'use client';
import * as React from 'react';
import React__default, { useState, useEffect, useMemo, useCallback, memo, Fragment as Fragment$2, useRef, forwardRef, Children, isValidElement, cloneElement, createContext, useContext } from 'react';
import { useExperimentType } from '@bucketplace/xpc-sdk';
import { jsx, jsxs, Fragment as Fragment$1 } from '@emotion/react/jsx-runtime';
import _styled from '@emotion/styled/base';
import { FONT_STYLE, ResizeImage, MEDIA_QUERY, pxToRem, useSnackbar, useResponsive, ScrapFilledIcon, TruckIcon, ChevronDownIcon as ChevronDownIcon$1, CallIcon, ChevronUpIcon, RESET_BUTTON, getImageUrl, HOVER as HOVER$1, DismissCircleIcon, FOCUS, useMedia, BREAK_POINT, ZINDEX as ZINDEX$1, useResize, hexToRgba, IntersectionObserver as IntersectionObserver$1, safeAreaInset, useIsInApp } from '@bucketplace/design-system';
import { keyframes, css, useTheme } from '@emotion/react';
import { Icon as Icon$1, Button as Button$4, DividerListItem, Modal, EmptyPage, ToggleButton, SquareBadge, OutlineButton, OutlineButtonWithIcon, Divider, Responsive, TextButton, OutlineSelectChip, Avatar as Avatar$1, SimpleFooter, NavigationTopBanner, Dropdown as Dropdown$1, TextButtonWithIcon, Toggle, Popper as Popper$1, OutlineAnchorButton, AnchorButton, Drawer, Container as Container$z, TabItem, Tab, CircleImage, Search, getWithIconOptions, IconNotification, NotificationType, SEARCH_TYPE as SEARCH_TYPE$1 } from '@bucketplace/design-system/bds';
import * as ReactDOM from 'react-dom';
import ReactDOM__default from 'react-dom';
import { useNodeHeight, useScrollDirection, Sticky, DEFAULT_STICKY_STATE, ResizeImage as ResizeImage$1 } from '@bucketplace/ui';

const USERABLE_TYPE = {
  normal: 'NormalUser',
  expert: 'ExpertUser',
  seller: 'SalesUser'
};

/** 브랜드 */

/** 뱃지 */

/** 쿠폰 뱃지 */

/** 카드 할인 혜택 뱃지 */

/** 가격 정보 */

/** 즉시할인 정보 */

const DELIVERY_PAYMENT = {
  /** 무료 */
  FREE: 'FREE',
  /** 조건부 무료 */
  CONDITIONAL_FREE: 'CONDITIONAL_FREE',
  /** 유료 */
  CHARGE: 'CHARGE'
};
const DELIVERY_SERVICE_CODE = {
  /** 일반 택배 */
  NORMAL: 'NORMAL',
  /** 판매자 직접 배송 */
  SELLER: 'SELLER',
  /** 화물택배 */
  CARGO: 'CARGO',
  /** 오늘의집 배송 */
  OHOUSE: 'OHOUSE',
  /** 빠른가전 배송 */
  THIRD_PARTY: 'THIRD_PARTY',
  /** 미노출 */
  NONE: 'NONE',
  /** 빠른가전배송 */
  THIRD_PARTY_APPLIANCE: 'THIRD_PARTY_APPLIANCE',
  /** 빠른가구배송 */
  THIRD_PARTY_FURNITURE: 'THIRD_PARTY_FURNITURE'
};

/** 배송비 유형 */

/** 배송 유형 */

/**
 * @type sm : name -> caption1, price -> caption1
 * @type md : name -> caption1, price -> subTitle2
 * @type lg : name -> subTitle2, price -> title3
 */

const STORE_ITEM_TYPE = {
  /** 상품 */
  GOODS: 'Goods',
  /** 모음전 */
  DEAL: 'Deal'
};

/** 'Goods' 와 'Deal' 에서 동일하게 사용하는 필드들입니다. */

/** type = 'Goods' 일때만 값을 가집니다. */

/** 굿스플로 상세 정보 */

/** 굿스플로 상세 정보 목록 */

/** 배송 조회 타입 - 배송중, 수거중, 재배송중 */
const DELIVERY_TARGET_TYPE = {
  ORDER: 'ORDER',
  PICKUP: 'PICKUP',
  REDELIVERY: 'REDELIVERY'
};
/** 배송  상태 */
const DELIVERY_TRACKING_STATUS = {
  READY: 'READY',
  SCHEDULED: 'SCHEDULED',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETE'
};
/** 배송방식 */
const SHIPMENT_TYPE = {
  NORMAL: 'NORMAL',
  SELLER: 'SELLER',
  CARGO: 'CARGO',
  OHOUSE: 'OHOUSE',
  THIRD_PARTY: 'THIRD_PARTY'
};

/**
 * 상품쿠폰으로 인한 할인금액 계산
 * @param price 상품가격
 * @param mold 상품쿠폰틀
 * @returns 할인금액
 * @example
 * ```
 * getDiscountPrice(10000, {
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * });
 * ```
 */
const getDiscountPrice = (price, mold) => {
  const {
    discountType,
    discountRate = 0
  } = mold;
  const discountAmount = Number.parseInt(mold.discountAmount ?? '0', 10);
  const maxDiscountAmount = Number.parseInt(mold.maxDiscountAmount ?? '0', 10);

  // 정률일경우
  if (discountType === 'FIXED_RATE') {
    return Math.min(price * discountRate, maxDiscountAmount);
  }

  // 정액일경우
  return Math.min(discountAmount, price);
};

/**
 * 할인금액이 가장 큰 쿠폰틀 계산
 * @param price 상품가격
 * @param molds 상품에 적용 가능한 쿠폰틀 리스트
 * @retuns 할인금액 가장 큰 쿠폰틀
 * @example
 * ```
 * getMaxDiscountCouponMold(1000, [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }]);
 * ```
 */

const getMaxDiscountCouponMold = (price, molds) => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevDiscountPrice = getDiscountPrice(price, prev);
    const currDiscountPrice = getDiscountPrice(price, curr);
    return prevDiscountPrice > currDiscountPrice ? prev : curr;
  });
};

/**
 * 최소주문금액이 가장 작은 쿠폰틀 계산
 * @param molds 쿠폰틀 리스트
 * @returns 최소주문금액이 가장 작은 쿠폰틀
 * @example
 * ```
 * getMinBaseAmountCouponMold([{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }, {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
const getMinBaseAmountCouponMold = molds => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevMinBaseAmount = Number.parseInt(prev.minBaseAmount, 10);
    const currMinBaseAmount = Number.parseInt(curr.minBaseAmount, 10);
    return prevMinBaseAmount > currMinBaseAmount ? curr : prev;
  });
};

/**
 * 상품카드에 노출되는 상품쿠폰
 * @param sellingPrice 판매가
 * @param goodsCouponMolds 상품쿠폰 리스트
 * @returns 상품카드에 노출되는 상품쿠폰
 * @example
 * ```
 * getCouponBadge('50', [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * },
 * {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
function getCouponBadge(sellingPrice, goodsCouponMolds) {
  if (!goodsCouponMolds.length) {
    return;
  }
  const price = Number.parseInt(sellingPrice, 10);

  // 최소주문금액이 가장 작은 쿠폰틀
  const minBaseAmountCouponMold = getMinBaseAmountCouponMold(goodsCouponMolds);
  const minBaseAmount = Number.parseInt(minBaseAmountCouponMold?.minBaseAmount ?? '0', 10);
  if (price > minBaseAmount) {
    // sellingPrice가 최소주문금액보다 클경우 할인금액이 가장 큰 쿠폰틀
    return getMaxDiscountCouponMold(price, goodsCouponMolds);
  } else {
    // sellingPrice가 최소주문금액보다 작을경우 최소주문금액이 가장 작은 쿠폰틀
    return minBaseAmountCouponMold;
  }
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}
function _createForOfIteratorHelper$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}
function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}
function _toPrimitive$2(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype['delete'] = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$1();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$1(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$1(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = (typeof global === "undefined" ? "undefined" : _typeof$2(global)) == 'object' && global && global.Object === Object && global;
var freeGlobal$1$1 = freeGlobal$2;

/** Detect free variable `self`. */
var freeSelf$1 = (typeof self === "undefined" ? "undefined" : _typeof$2(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$1$1 || freeSelf$1 || Function('return this')();
var root$1$1 = root$2;

/** Built-in value references. */
var _Symbol = root$1$1.Symbol;
var _Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1$1 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1$1),
    tag = value[symToStringTag$1$1];
  try {
    value[symToStringTag$1$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1$1] = tag;
    } else {
      delete value[symToStringTag$1$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
  undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1$1(value) {
  var type = _typeof$2(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$1(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$1$1['__core-js_shared__'];
var coreJsData$1$1 = coreJsData$2;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$1$1 && coreJsData$1$1.keys && coreJsData$1$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1$1 = Function.prototype,
  objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1$1 = funcProto$1$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' + funcToString$1$1.call(hasOwnProperty$d).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1$1(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$1(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$1(root$1$1, 'Map');
var Map$1$1 = Map$3;

/* Built-in method references that are verified to be native. */
var nativeCreate$2 = getNative$1(Object, 'create');
var nativeCreate$1$1 = nativeCreate$2;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$1$1 ? nativeCreate$1$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$1$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2$1 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$d$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b$1 = objectProto$d$1.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1$1 ? data[key] !== undefined : hasOwnProperty$b$1.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1$1 && value === undefined ? HASH_UNDEFINED$1$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype['delete'] = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1(),
    'map': new (Map$1$1 || ListCache$1)(),
    'string': new Hash$1()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = _typeof$2(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$1(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$1(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$1(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData$1(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype['delete'] = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear$1;
Stack$1.prototype['delete'] = stackDelete$1;
Stack$1.prototype.get = stackGet$1;
Stack$1.prototype.has = stackHas$1;
Stack$1.prototype.set = stackSet$1;

/** Built-in value references. */
var Uint8Array$3 = root$1$1.Uint8Array;
var Uint8Array$1$1 = Uint8Array$3;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol$1 ? _Symbol$1.prototype : undefined;
  symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1$1 = Array.isArray;
var isArray$2 = isArray$1$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$1() {
  return [];
}

/** Used for built-in method references. */
var objectProto$c$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1$1 = objectProto$c$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$1$1 ? stubArray$1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1$1(object), function (symbol) {
    return propertyIsEnumerable$1$1.call(object, symbol);
  });
};
var getSymbols$1$1 = getSymbols$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && _typeof$2(value) == 'object';
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$1(value) && baseGetTag$1(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$b$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a$1 = objectProto$b$1.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$b$1.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments$1(function () {
  return arguments;
}()) ? baseIsArguments$1 : function (value) {
  return isObjectLike$1(value) && hasOwnProperty$a$1.call(value, 'callee') && !propertyIsEnumerable$2.call(value, 'callee');
};
var isArguments$1$1 = isArguments$2;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse$1() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1$1 = moduleExports$2 ? root$1$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer$1 = Buffer$1$1 ? Buffer$1$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer$2 = nativeIsBuffer$1 || stubFalse$1;
var isBuffer$1$1 = isBuffer$2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = _typeof$2(value);
  length = length == null ? MAX_SAFE_INTEGER$1$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$1(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}

/** `Object#toString` result references. */
var argsTag$2$1 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$3 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$1$1 = '[object Function]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$3 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$2] = typedArrayTags$1[float64Tag$2] = typedArrayTags$1[int8Tag$2] = typedArrayTags$1[int16Tag$2] = typedArrayTags$1[int32Tag$2] = typedArrayTags$1[uint8Tag$2] = typedArrayTags$1[uint8ClampedTag$2] = typedArrayTags$1[uint16Tag$2] = typedArrayTags$1[uint32Tag$2] = true;
typedArrayTags$1[argsTag$2$1] = typedArrayTags$1[arrayTag$2] = typedArrayTags$1[arrayBufferTag$2] = typedArrayTags$1[boolTag$3] = typedArrayTags$1[dataViewTag$3] = typedArrayTags$1[dateTag$2] = typedArrayTags$1[errorTag$2] = typedArrayTags$1[funcTag$1$1] = typedArrayTags$1[mapTag$5] = typedArrayTags$1[numberTag$3] = typedArrayTags$1[objectTag$4] = typedArrayTags$1[regexpTag$2] = typedArrayTags$1[setTag$5] = typedArrayTags$1[stringTag$3] = typedArrayTags$1[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags$1[baseGetTag$1(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1$1 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1$1 = freeExports$1$1 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1$1 = freeModule$1$1 && freeModule$1$1.exports === freeExports$1$1;

/** Detect free variable `process` from Node.js. */
var freeProcess$1 = moduleExports$1$1 && freeGlobal$1$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil$2 = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1$1 && freeModule$1$1.require && freeModule$1$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess$1 && freeProcess$1.binding && freeProcess$1.binding('util');
  } catch (e) {}
}();
var nodeUtil$1$1 = nodeUtil$2;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1$1 && nodeUtil$1$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray$1 ? baseUnary$1(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray$1$1 = isTypedArray$2;

/** Used for built-in method references. */
var objectProto$a$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9$1 = objectProto$a$1.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$2(value),
    isArg = !isArr && isArguments$1$1(value),
    isBuff = !isArr && !isArg && isBuffer$1$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes$1(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9$1.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$9$1 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9$1;
  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$1(Object.keys, Object);
var nativeKeys$1$1 = nativeKeys$2;

/** Used for built-in method references. */
var objectProto$8$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8$1 = objectProto$8$1.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$1$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols$1$1);
}

/* Built-in method references that are verified to be native. */
var DataView$3 = getNative$1(root$1$1, 'DataView');
var DataView$1$1 = DataView$3;

/* Built-in method references that are verified to be native. */
var Promise$1$1 = getNative$1(root$1$1, 'Promise');
var Promise$2$1 = Promise$1$1;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$1$1, 'Set');
var Set$1$1 = Set$3;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$1(root$1$1, 'WeakMap');
var WeakMap$1$1 = WeakMap$3;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
  objectTag$3 = '[object Object]',
  promiseTag$1 = '[object Promise]',
  setTag$4 = '[object Set]',
  weakMapTag$1$1 = '[object WeakMap]';
var dataViewTag$2$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$1$1),
  mapCtorString$1 = toSource$1(Map$1$1),
  promiseCtorString$1 = toSource$1(Promise$2$1),
  setCtorString$1 = toSource$1(Set$1$1),
  weakMapCtorString$1 = toSource$1(WeakMap$1$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1$1 && getTag$2(new DataView$1$1(new ArrayBuffer(1))) != dataViewTag$2$1 || Map$1$1 && getTag$2(new Map$1$1()) != mapTag$4 || Promise$2$1 && getTag$2(Promise$2$1.resolve()) != promiseTag$1 || Set$1$1 && getTag$2(new Set$1$1()) != setTag$4 || WeakMap$1$1 && getTag$2(new WeakMap$1$1()) != weakMapTag$1$1) {
  getTag$2 = function getTag(value) {
    var result = baseGetTag$1(value),
      Ctor = result == objectTag$3 ? value.constructor : undefined,
      ctorString = Ctor ? toSource$1(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$2$1;
        case mapCtorString$1:
          return mapTag$4;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$4;
        case weakMapCtorString$1:
          return weakMapTag$1$1;
      }
    }
    return result;
  };
}
var getTag$1$1 = getTag$2;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return _typeof$2(value) == 'symbol' || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$2;
}

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = _typeof$2(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$4 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1$1.Cache || MapCache$1)();
  return memoized;
}

// Expose `MapCache`.
memoize$1$1.Cache = MapCache$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$1(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});
var stringToPath$1$1 = stringToPath$2;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1$1 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolToString$1 = symbolProto$1$1 ? symbolProto$1$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$2(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey$1(value, object) ? [value] : stringToPath$1$1(toString$2(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath$1(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$1(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) && (isArray$2(object) || isArguments$1$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}
var defineProperty$2 = function () {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1$1 = defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty$1$1) {
    defineProperty$1$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var queryString$2 = {};
var strictUriEncode$2 = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};
var token$2 = '%[a-f0-9]{2}';
var singleMatcher$2 = new RegExp('(' + token$2 + ')|([^%]+?)', 'gi');
var multiMatcher$2 = new RegExp('(' + token$2 + ')+', 'gi');
function decodeComponents$2(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$2(left), decodeComponents$2(right));
}
function decode$3(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher$2) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents$2(tokens, i).join('');
      tokens = input.match(singleMatcher$2) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$2(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher$2.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode$3(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$2.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent$2 = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + _typeof$2(encodedURI) + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$2(encodedURI);
  }
};
var splitOnFirst$2 = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  var separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};
var filterObj$1 = function filterObj(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};
(function (exports) {
  var strictUriEncode$1 = strictUriEncode$2;
  var decodeComponent = decodeUriComponent$2;
  var splitOnFirst$1 = splitOnFirst$2;
  var filterObject = filterObj$1;
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };
  var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', index, ']'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };
      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };
      case 'colon-list-separator':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list='].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list=', encode(value, options)].join('')]);
          };
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return function (key) {
            return function (result, value) {
              if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
                return result;
              }

              // Translate null to an empty string so that it doesn't serialize as 'null'
              value = value === null ? '' : value;
              if (result.length === 0) {
                return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
              }
              return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
            };
          };
        }
      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [encode(key, options)]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }
  function parserForArrayFormat(options) {
    var result;
    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return function (key, value, accumulator) {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return function (key, value, accumulator) {
          var isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          });
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (_typeof$2(input) === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }
    return input;
  }
  function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    var _iterator = _createForOfIteratorHelper$1(query.split('&')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;
        if (param === '') {
          continue;
        }
        var _splitOnFirst = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '='),
          _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
          _key = _splitOnFirst2[0],
          _value = _splitOnFirst2[1];

        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        _value = _value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i = 0, _Object$keys = Object.keys(ret); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var value = ret[key];
      if (_typeof$2(value) === 'object' && value !== null) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(value); _i2 < _Object$keys2.length; _i2++) {
          var k = _Object$keys2[_i2];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];
      if (Boolean(value) && _typeof$2(value) === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    for (var _i3 = 0, _Object$keys3 = Object.keys(object); _i3 < _Object$keys3.length; _i3++) {
      var key = _Object$keys3[_i3];
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(function (key) {
      var value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };
  exports.parseUrl = function (url, options) {
    options = Object.assign({
      decode: true
    }, options);
    var _splitOnFirst3 = splitOnFirst$1(url, '#'),
      _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
      url_ = _splitOnFirst4[0],
      hash = _splitOnFirst4[1];
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = function (object, options) {
    options = Object.assign(_defineProperty$2({
      encode: true,
      strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = "?".concat(queryString);
    }
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
  };
  exports.pick = function (input, filter, options) {
    options = Object.assign(_defineProperty$2({
      parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports$parseUrl = exports.parseUrl(input, options),
      url = _exports$parseUrl.url,
      query = _exports$parseUrl.query,
      fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
      url: url,
      query: filterObject(query, filter),
      fragmentIdentifier: fragmentIdentifier
    }, options);
  };
  exports.exclude = function (input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function (key) {
      return !filter.includes(key);
    } : function (key, value) {
      return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString$2);

/**
 * 웹 페이지가 모바일 앱 내의 웹뷰에서 실행되고 있는지 여부를 확인합니다.
 * 이 함수는 서버 사이드와 클라이언트 사이드 렌더링 환경 모두에서 사용 가능합니다.
 *
 * @param {Object} query - 서버 사이드 렌더링 시 사용할 쿼리 파라미터 객체입니다. (선택적)
 * @returns {boolean} 웹 페이지가 앱 내의 웹뷰에서 실행되고 있다면 true, 그렇지 않다면 false를 반환합니다.
 */
function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  var triggered = false;
  try {
    triggered = sessionStorage['webviewTriggered'] === 'yes';
  } catch (e) {
    console.error(e);
  }
  var search = queryString$2.parse(location.search);
  var isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (!isExpertCenterAndroid && (triggered || search['os_type'] != null && search['os_type'] !== '' || search['app'] != null)) {
    try {
      sessionStorage['webviewTriggered'] = 'yes';
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
}

// 모바일 장치를 포괄하는 정규 표현식
var MOBILE_USER_AGENT_REGEX = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|PlayBook/;
/**
 * 브라우저의 사용자 에이전트 또는 제공된 사용자 에이전트 문자열을 기반으로 현재 환경이 모바일 장치인지 여부를 확인합니다.
 *
 * @param {string} [userAgent=''] - (선택적) 확인할 사용자 에이전트입니다.
 * @returns {boolean} 모바일 장치면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * 브라우저 환경에서 사용할 경우:
 * isMobile();
 *
 * 사용자 에이전트 문자열을 제공할 경우:
 * isMobile("Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X)");
 */
function isMobileDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (userAgent !== '') {
    return MOBILE_USER_AGENT_REGEX.test(userAgent);
  }
  // 브라우저 환경에서 실행 중인지 확인
  if (typeof window !== 'undefined' && navigator) {
    var isMobileUA = MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
    // 터치 기능에 대한 추가 검사
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    // 모바일 장치를 나타내는 검사 중 하나라도 참이면 true 반환
    return isMobileUA || isTouchDevice;
  }
  return false;
}

/**
 * 주어진 값이 배열인지 여부를 확인합니다.
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 배열이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * // 배열인 경우
 * isArray([1, 2, 3]); // true
 *
 * @example
 * // 배열이 아닌 경우
 * isArray({ 'a': 1, 'b': 2, 'c': 3 }); // false
 *
 * @example
 * // null 값을 검사하는 경우
 * isArray(null); // false
 */
var isArray$3 = isArray$2;

/** Built-in value references. */
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);
var getPrototype$1$1 = getPrototype$2;

/** `Object#toString` result references. */
var objectTag$1$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
  objectProto$3$1 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3$1 = objectProto$3$1.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$3.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag$1$1) {
    return false;
  }
  var proto = getPrototype$1$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3$1.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString;
}

/** Used for built-in method references. */
var objectProto$2$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2$1 = objectProto$2$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2$1.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$1$1(object)) {
    return object;
  }
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1$1(objValue) ? objValue : isIndex$1(path[index + 1]) ? [] : {};
      }
    }
    assignValue$1(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet$1(object, path);
    if (predicate(value, path)) {
      baseSet$1(result, castPath$1(path, object), value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy$1(object, paths, function (value, path) {
    return hasIn$1(object, path);
  });
}

/** Built-in value references. */
var spreadableSymbol$1 = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$2(value) || isArguments$1$1(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable$1);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax$2(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$2(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply$1(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$2 = !defineProperty$1$1 ? identity$1 : function (func, string) {
  return defineProperty$1$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$1(string),
    'writable': true
  });
};
var baseSetToString$1$1 = baseSetToString$2;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT$1 = 800,
  HOT_SPAN$1 = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow$1 = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow$1(),
      remaining = HOT_SPAN$1 - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT$1) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut$1(baseSetToString$1$1);
var setToString$1$1 = setToString$2;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString$1$1(overRest$1(func, undefined, flatten$1), func + '');
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
flatRest$1(function (object, paths) {
  return object == null ? {} : basePick$1(object, paths);
});

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$1(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1$1 = objectProto$1$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$1$1(object)) {
    return nativeKeysIn$1(object);
  }
  var isProto = isPrototype$1(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

/** Detect free variable `exports`. */
var freeExports$3 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$3 = freeExports$3 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$3 = freeModule$3 && freeModule$3.exports === freeExports$3;

/** Built-in value references. */
var Buffer$2 = moduleExports$3 ? root$1$1.Buffer : undefined,
  allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1$1(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols$2 ? stubArray$1 : function (object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1$1(object));
    object = getPrototype$1$1(object);
  }
  return result;
};
var getSymbolsIn$1$1 = getSymbolsIn$2;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1$1(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$1, getSymbolsIn$1$1);
}

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$i.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$f.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1$1(result).set(new Uint8Array$1$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolValueOf$1 = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1$1 = '[object Boolean]',
  dateTag$1$1 = '[object Date]',
  mapTag$2$1 = '[object Map]',
  numberTag$1$1 = '[object Number]',
  regexpTag$1$1 = '[object RegExp]',
  setTag$2$1 = '[object Set]',
  stringTag$1$1 = '[object String]',
  symbolTag$1$1 = '[object Symbol]';
var arrayBufferTag$1$1 = '[object ArrayBuffer]',
  dataViewTag$1$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1$1:
      return cloneArrayBuffer(object);
    case boolTag$1$1:
    case dateTag$1$1:
      return new Ctor(+object);
    case dataViewTag$1$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2$1:
      return new Ctor();
    case numberTag$1$1:
    case stringTag$1$1:
      return new Ctor(object);
    case regexpTag$1$1:
      return cloneRegExp(object);
    case setTag$2$1:
      return new Ctor();
    case symbolTag$1$1:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$1$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate$1(getPrototype$1$1(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$1$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == mapTag$1$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1$1 && nodeUtil$1$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == setTag$1$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1$1 && nodeUtil$1$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
  arrayTag$3 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$3 = '[object Error]',
  funcTag$3 = '[object Function]',
  genTag$2 = '[object GeneratorFunction]',
  mapTag$6 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$5 = '[object Object]',
  regexpTag$3 = '[object RegExp]',
  setTag$6 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$3 = '[object Symbol]',
  weakMapTag$3 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$3 = '[object Float32Array]',
  float64Tag$3 = '[object Float64Array]',
  int8Tag$3 = '[object Int8Array]',
  int16Tag$3 = '[object Int16Array]',
  int32Tag$3 = '[object Int32Array]',
  uint8Tag$3 = '[object Uint8Array]',
  uint8ClampedTag$3 = '[object Uint8ClampedArray]',
  uint16Tag$3 = '[object Uint16Array]',
  uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$2] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$3] = cloneableTags[float64Tag$3] = cloneableTags[int8Tag$3] = cloneableTags[int16Tag$3] = cloneableTags[int32Tag$3] = cloneableTags[mapTag$6] = cloneableTags[numberTag$2] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$3] = cloneableTags[setTag$6] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$3] = cloneableTags[uint8ClampedTag$3] = cloneableTags[uint16Tag$3] = cloneableTags[uint32Tag$3] = true;
cloneableTags[errorTag$3] = cloneableTags[funcTag$3] = cloneableTags[weakMapTag$3] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1$1(value),
      isFunc = tag == funcTag$3 || tag == genTag$2;
    if (isBuffer$1$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$5 || tag == argsTag$4 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys$1 : isFlat ? keysIn$1 : keys$1;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$1(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet$1(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$1(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit$1 = flatRest$1(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$1(paths, function (path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn$1(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
var omit$2 = omit$1;

/**
 * 주어진 객체에서 선택된 키들에 해당하는 속성들을 제외한 나머지 속성들을 포함하는 새 객체를 반환합니다.
 * @param {Object} object - 원본 객체.
 * @param {string[]} paths - 제외할 속성의 키들을 나타내는 문자열 배열.
 * @returns {Object} 제외된 속성들을 제외한 나머지 속성들을 포함하는 새 객체.
 *
 * @example
 * // 객체에서 'b' 속성을 제외
 * omit({ 'a': 1, 'b': '2', 'c': 3 }, ['b']); // { 'a': 1, 'c': 3 }
 *
 * @example
 * // 객체에서 여러 속성을 제외
 * omit({ 'name': 'apple', 'color': 'red', 'weight': 100 }, ['color', 'weight']); // { 'name': 'apple' }
 */
var omit = omit$2;

/**
 * 숫자에 천자리 단위 (,)를 추가합니다.
 * @param x 천자리 단위 (,) 넣을 숫자
 * @returns 천자리 단위 (,) 포함된 숫자
 * @example
 * ```
 * formatComma(1000000);
 * 1,000,000
 * ```
 */
function formatComma(x) {
  if (x == null || Number.isNaN(Number(x))) {
    return '';
  }
  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
(',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
(',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');

/**
 * 주어진 숫자를 지정된 기준(base)를 기반으로 승수(step)를 구하고 정규화된 값을 반환합니다.
 *
 * 정규화된 값은 입력된 숫자를 해당 숫자를 나누는 기준(base)의 최고 차수로 나눈 결과입니다.
 * 단계는 입력된 숫자를 나누는 기준(base)의 최고 차수의 지수를 나타냅니다.
 *
 * @example calculateExponentStep(2312111, 1000) -> [2.3, 2]
 *
 * @param input 계산할 숫자
 * @param base 기준 값
 * @returns 정규화된 값과 단계를 포함하는 배열을 반환합니다.
 */
function calculateExponentStep(input, base) {
  if (input === 0) {
    return [0, 0];
  }
  var step = Math.floor(Math.log10(Math.abs(input)) / Math.log10(base));
  var divisor = Math.pow(base, step);
  return [input / divisor, step];
}

/**
 * 큰 수를 줄임 표기 형태로 변환합니다.
 *
 * @example 2312111 -> 2.3M
 * @example 126057 -> 126K
 *
 * @param number 변환할 숫자
 * @param base 기준값
 * @params markers 기준값에 따른 표기
 * @returns 변환된 문자열
 */
function formatLargeNumber(number) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var markers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', 'K', 'M', 'B'];
  var formatNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (n) {
    return String(Math.floor(n * 10) / 10);
  };
  var _calculateExponentSte = calculateExponentStep(number, base),
    _calculateExponentSte2 = _slicedToArray(_calculateExponentSte, 2),
    value = _calculateExponentSte2[0],
    step = _calculateExponentSte2[1];
  if (step >= markers.length) {
    var cappedStep = markers.length - 1;
    var accumulated = value * Math.pow(base, step - cappedStep);
    return "".concat(accumulated.toFixed(1)).concat(markers[cappedStep]);
  }
  return "".concat(formatNumber(value)).concat(markers[step]);
}

/**
 * text를 clipboard로 복사합니다.
 * @param text 복사할 text
 * @returns 성공 여부
 * @example
 * ```
 * copyTextToClipboard('오늘의집')
 * true or false
 * ```
 */
var copyTextToClipboard = function copyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '20em';
  textArea.style.height = '20em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;
  document.body.appendChild(textArea);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textArea.contentEditable = 'true';
    textArea.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(textArea);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 9999999);
  } else {
    textArea.select();
  }
  var successful = false;
  try {
    /** execCommand: deprecated된 메소드 입니다. */
    successful = document.execCommand('copy');
  } catch (err) {
    throw new Error('Unable to copy');
  } finally {
    window.document.body.removeChild(textArea);
  }
  return successful;
};

/**
 * url에서 쿼리 파라미터를 추출하여 객체 형태로 변환합니다.
 * @param {string} url url
 * @returns url 쿼리 객체
 * @example
 * ```
 * getQuery('https://ohou.se?a=1&b=2');
 * { a: 1, b: 2 }
 * ```
 */
var getQuery = memoize$1$1(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return queryString$2.parse(search.replace(/&amp;/g, '&'));
});

const THOUSAND_MATCH_REGX = /^((\d)[0]{3})$/;
const MILLION_MATCH_REGX = /(\d{1,})[0]{4}/;

/**
 * 상품카드 내 할인가격을 규칙에 맞게 노출합니다.
 * e.g) 100 -> 100원, 1000원 -> 1천원, 10000원 -> 1만원
 * @param number 할인가격
 * @returns 규칙이 적용된 할인가격
 * @example
 * ```
 * getShortenPrice(1000)
 * 1천원
 * ```
 */
const getShortenPrice = amount => {
  const strAmount = amount.toString();
  if (THOUSAND_MATCH_REGX.test(strAmount)) {
    return strAmount.replace('000', '천원');
  }
  if (MILLION_MATCH_REGX.test(strAmount)) {
    return `${formatComma(amount / 10000)}만원`;
  }
  return `${formatComma(amount)}원`;
};

/**
 * 상품카드에 노출되는 상품쿠폰 뱃지 텍스트
 * e.g) 할인쿠폰, 최대 10% 할인, 최대 10,000원 할인
 * @param goodsCouponMold 상품쿠폰틀
 * @param isLoggedIn 로그인 유무
 * @returns 상품쿠폰 뱃지 텍스트
 * @example
 * ```
 * getCouponBadgeTitle({
 *  title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *  discountType: 'FIXED_AMOUNT',
 *  couponType: 'GOODS',
 *  discountAmount: '5500',
 *  minBaseAmount: '100',
 *}, true);
 * ```
 */
const getCouponBadgeTitle = (goodsCouponMold, isLoggedIn) => {
  if (!isLoggedIn) {
    return '할인쿠폰';
  }
  if (goodsCouponMold.discountType === 'FIXED_RATE') {
    return `최대 ${Math.round((goodsCouponMold.discountRate ?? 0) * 100)}% 할인`;
  }
  const maxDiscountAmount = Number.parseInt(goodsCouponMold.maxDiscountAmount ?? '0', 10);
  const discountAmount = Number.parseInt(goodsCouponMold.discountAmount ?? '0', 10);
  const discountPrice = maxDiscountAmount > 0 ? Math.min(maxDiscountAmount, discountAmount) : discountAmount;
  const shortPrice = getShortenPrice(discountPrice);
  return `최대 ${shortPrice} 할인`;
};

/** 사용자에게 노출되는 메시지를 커스텀합니다. */
const CUSTOM_COUPON_PUBLISH_MESSAGE = {
  SUCCESS: '쿠폰이 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  PART_SUCCESS: '발급 불가 쿠폰을 제외하고 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  ERROR: '쿠폰 다운로드에 실패했습니다.',
  DONE: '이미 발급된 쿠폰입니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.'
};
const COUPON_PUBLISH_DONE_MESSAGE = '이미 발급된 쿠폰입니다.';
/**
 * publish_coupons의 결과값들을 상태별로 분류
 * @param coupons publish_coupons의 response
 * @returns publish_coupons 의 status (성공, 실패, 이미발급)
 */
const getPublishCartCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    const {
      success,
      message
    } = coupon;
    if (success) {
      return {
        ...acc,
        success: acc.success.concat(coupon)
      };
    }
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};
const getPublishProductCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    if ('response' in coupon) {
      const success = coupon.response?.map(coupon => coupon) ?? [];
      return {
        ...acc,
        success: acc.success.concat(success)
      };
    }
    const {
      message
    } = coupon;
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};

/**
 * 쿠폰팩 메시지 헨들링
 * @see {@link https://wiki.dailyhou.se/x/GP_0Bw}
 */
const getCouponsPublishMessage = (cartCoupons, productCoupons) => {
  const {
    success: cartSuccess,
    done: cartDone,
    errors: cartErrors
  } = getPublishCartCouponStatus(cartCoupons);
  const {
    success: productSuccess,
    done: productDone,
    errors: productErrors
  } = getPublishProductCouponStatus(productCoupons);
  const coupons = [...cartCoupons, ...productCoupons];
  const success = [...cartSuccess, ...productSuccess];
  const done = [...cartDone, ...productDone];
  const errors = [...cartErrors, ...productErrors];

  // 전부 이미 받음
  if (coupons.length === done.length) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.DONE;
  }
  // 발급 성공 & 발급 실패
  if (success.length > 0 && errors.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  }
  // 발급 성공
  if (success.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.SUCCESS;
  }
  // 전부 실패
  const hasSameError = errors.every(({
    message
  }) => message === errors[0]?.message);
  const errorMessage = hasSameError && errors[0]?.message ? errors[0].message : CUSTOM_COUPON_PUBLISH_MESSAGE.ERROR;
  return errorMessage;
};

const KAKAO_TEMPLATE_ID = {
  INVITE_FRIEND: 55328,
  PROJECT: 7230,
  CARD: 7231,
  ADVICE: 7281,
  SELLING_PRODUCT: 7282,
  NOT_SELLING_PRODUCT: 7286,
  /** 상품4개인 기획전 */
  EXHIBITION: 7289,
  /** 상품없는 기획전 */
  NO_PRODUCT_EXHIBITION: 96825,
  MY_HOME: 7325,
  QUESTION: 8237,
  CONTEST: 7331,
  SCRAP_BOOK: 9425,
  TODAY_PRODUCT: 12318,
  COMMON: 35477,
  COMMON_BUTTON_TEXT_CUSTOM: 77289
};

/**
 * 기획전 카카오 템플릿
 * @param exhibitionId 기획전 ID
 * @param title 기획전 제목
 * @param coverImageUrls 기획전 커버 이미지
 * @param products 상품 리스트
 * @returns 카카오 템플릿
 */
const getExhibitionKakaoTemplate = ({
  exhibitionId,
  title,
  coverImageUrls,
  products
}) => {
  const hasMoreThreeFormattedProducts = products && products.length > 3;
  const templateId = hasMoreThreeFormattedProducts ? KAKAO_TEMPLATE_ID.EXHIBITION : KAKAO_TEMPLATE_ID.NO_PRODUCT_EXHIBITION;
  if (hasMoreThreeFormattedProducts) {
    return {
      templateId,
      templateArgs: {
        exhibitionId,
        title,
        coverImgUrl: coverImageUrls[0],
        product0ImgUrl: products[0]?.originalImageUrl,
        product0Name: products[0]?.name,
        product0Id: products[0]?.id,
        product0CostInfo: products[0]?.sellingPrice,
        product1ImgUrl: products[1]?.originalImageUrl,
        product1Name: products[1]?.name,
        product1Id: products[1]?.id,
        product1CostInfo: products[1]?.sellingPrice,
        product2ImgUrl: products[2]?.originalImageUrl,
        product2Name: products[2]?.name,
        product2Id: products[2]?.id,
        product2CostInfo: products[2]?.sellingPrice,
        product3ImgUrl: products[3]?.originalImageUrl,
        product3Name: products[3]?.name,
        product3Id: products[3]?.id,
        product3CostInfo: products[3]?.sellingPrice
      }
    };
  }
  return {
    templateId,
    templateArgs: {
      exhibitionId,
      title,
      coverImgUrl: coverImageUrls[0]
    }
  };
};

/**
 * 카드 프로모션 중 가장 혜택 좋은 프로모션을 추출합니다. (내부에서만 사용)
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매가격
 * @returns 가장 혜택 좋은 카드 프로모션
 */
const getBestCardPromotion = (cardPromotions, sellingPrice) => {
  const bestPromotion = (cardPromotions ?? []).reduce((acc, promotion) => {
    const {
      discountType,
      discountRate,
      discountAmount,
      maximumDiscountAmount
    } = promotion;
    let bestPromotion = acc;
    if (!sellingPrice) {
      return promotion;
    }

    // 정률 혜택
    if (discountType === 'FIXED_RATE') {
      const discountAmount = Math.ceil(Number(sellingPrice) * ((discountRate ?? 1) / 100));
      bestPromotion = {
        ...promotion,
        bestPrice: Number(sellingPrice) - Math.min(Number(maximumDiscountAmount) ?? 1, discountAmount)
      };
    }
    if (discountType === 'FIXED_AMOUNT') {
      bestPromotion = {
        ...promotion,
        bestPrice: discountAmount ? Number(sellingPrice) - discountAmount : undefined
      };
    }
    if (acc.bestPrice && bestPromotion.bestPrice) {
      return acc.bestPrice < bestPromotion.bestPrice ? acc : bestPromotion;
    }
    return bestPromotion;
  }, {});
  return bestPromotion;
};

/**
 * 카드 프로모션 타이틀을 추출합니다. (내부에서만 사용)
 * @param cardPromotion 카드 프로모션
 * @returns 정액 / 정률 결제할인
 */
const getCardPromotionTitle = cardPromotion => {
  const {
    discountType,
    discountRate,
    discountAmount
  } = cardPromotion;
  if (discountType === 'FIXED_RATE') {
    return `최대 ${discountRate}% 결제할인`;
  }
  if (discountType === 'FIXED_AMOUNT') {
    return `최대 ${discountAmount}원 결제할인`;
  }
  return undefined;
};

/**
 * 카드 프로모션을 나타낼 badge를 추출합니다.
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매자
 * @returns 카드 프로모션 badge 리스트
 * @example
 * ```
 * getCardPromotionBadges([
 *   {
 *     cardName: '페이코',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 20,
 *     minimumApplyPrice: '1000',
 *     maximumDiscountAmount: '30000',
 *     promotionPaymentMethod: 'PAYCO',
 *   },
 *   {
 *     cardName: 'KB국민',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 10,
 *     minimumApplyPrice: '10',
 *     maximumDiscountAmount: '10000',
 *     promotionPaymentMethod: 'CREDIT_CARD',
 *   }),
 *   '24500'
 *  )
 * ```
 */
const getCardPromotionBadges = (cardPromotions, sellingPrice) => {
  const cardPromotion = getBestCardPromotion(cardPromotions, sellingPrice);
  const promotionTitle = getCardPromotionTitle(cardPromotion);
  return promotionTitle ? [{
    ozipTitle: '',
    image: 'https://image.ohou.se/i/bucketplace-v2-development/static/productions/card-promotion-v2.png',
    title: promotionTitle,
    discountRatio: cardPromotion.discountRate?.toString(),
    fixedDiscountAmount: cardPromotion.discountAmount?.toString()
  }] : undefined;
};

/**
 * @bucketplace/contents-ui의 Scrap 컴포넌트를 사용하기 위한 헬퍼 함수
 * refs
 *  - https://github.com/bucketplace/contents-web-common/blob/main/packages/ui/src/stories/Scrap/README.stories.mdx
 *  - https://www.notion.so/Scrap-16df6cb18a93435eb513d20b6b32d9f0
 *
 * @param {CreateProductScrapDataProps}
 * @returns {ScrapData}
 */
function createProductScrapData({
  product,
  active,
  count,
  userId,
  scrappedFrom,
  onScrap,
  onUnscrap,
  onCreateScrap,
  onDeleteScrap,
  onCreateCollectionBook,
  onMoveCollectionBookItemList,
  onClickScrapBook,
  onClickScrapBookTo,
  getCollectionBookList,
  redirectToLogin,
  onClickScrap
}) {
  const isLoggedIn = userId != null;
  // contents-ui 옮길 때 ScrapResponse 로 적용
  const handleScrap = async () => {
    const {
      success,
      collectionId,
      collectCount,
      message
    } = await onCreateScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        id: collectionId ?? -1,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 UnscrapResponse 로 적용
  const handleDeleteScrap = async () => {
    const {
      success,
      collectCount,
      message
    } = await onDeleteScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 CreateScrapBookResponse 로 적용
  const handleCreateScrapBook = async name => {
    const {
      success,
      id
    } = await onCreateCollectionBook({
      name
    });
    return {
      success,
      id
    };
  };
  const handleSelectScrapBook = async (scrapBookId, contentIds) => {
    // contents-ui 옮길 때 SelectScrapBookResponse 로 적용
    const {
      success
    } = await onMoveCollectionBookItemList({
      collectionBookId: scrapBookId,
      ids: contentIds // FIXME: remove Type assertion
    });
    return {
      success
    };
  };
  const handleGetScrapBookList = async () => {
    const {
      collectionBooks
    } = await getCollectionBookList();
    return collectionBooks ?? [];
  };
  return {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: active,
    initialCount: count,
    isLoggedIn,
    scrappedFrom,
    onScrap,
    onUnscrap,
    scrap: handleScrap,
    unscrap: handleDeleteScrap,
    createScrapBook: handleCreateScrapBook,
    selectScrapBook: handleSelectScrapBook,
    getScrapBooks: handleGetScrapBookList,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  };
}

/**
 * ThumbnailBadge를 Badge 타입으로 반환합니다.
 * @param thumbnailBadges 썸네일 뱃지
 * @returns 뱃지
 * @example
 * ```
 * convertThumbnailBadgeToBadge([{
 *  position: 2,
 *  imageUrl: 'https://bucketplace-v2-development.s3.amazonaws.com/uploads/admins/thumbnail_badges/162817329513046453.png',
 * }])
 * ```
 */
function convertThumbnailBadgeToBadge(thumbnailBadges) {
  return thumbnailBadges?.map(badge => ({
    id: Math.random() * 0x4FFFF | 0,
    thumbnailBadgeId: 0,
    position: badge.position,
    image: {
      url: badge.imageUrl,
      width: null,
      height: null
    }
  })) ?? [];
}

/**
 * convertGoodsToProduct, convertDealToProduct에서 default로 넣는 deprecated fields
 */
const DEPRECATED_FIELDS = {
  usedCardCount: 0,
  viewCount: 0,
  isDepartureTodayExp: 'A',
  isDiscounted: false,
  isRetailDelivery: false,
  isThirdPartyLogistic: false,
  status: 0,
  deliveryType: 0,
  userId: 0,
  isHidden: false,
  isDeliveryDateSpecified: false,
  isBuyable: true,
  isConsultable: false,
  isRemodel: false,
  weekRank: 0
};

/**
 * 상품 아이템을 Product 형태로 전환하는 함수
 * @param goods 상품 아이템
 * @param isScrap 스크랩 유무
 * @returns 상품
 */
const convertGoodsToProduct = ({
  goods,
  showCouponBadge,
  isLoggedIn
}) => {
  const goodsCouponMold = getCouponBadge(goods?.price?.sellingPrice ?? '0', goods?.additionalProperties?.goodsCouponMold ?? []);
  const isDepartureToday = goods?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED';
  const deadline = goods?.delivery?.policy?.releasePolicy?.orderDeadline ?? '';
  return {
    ...DEPRECATED_FIELDS,
    type: 'Production',
    id: Number.parseInt(goods?.id ?? '0', 10),
    name: goods?.name ?? '',
    reviewAvg: goods?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goods?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(goods?.price?.sellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(goods?.price?.originalPrice ?? '0', 10),
    originalImageUrl: goods?.imageUrl ?? '',
    brand: goods?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(goods?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: isDepartureToday && deadline ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [deadline]
      }
    } : undefined,
    deliveryServiceCode: goods?.delivery?.serviceCode ?? 'NONE',
    isDepartureToday,
    isSpecialPrice: goods?.price?.isSpecialPrice ?? false,
    isSelling: goods?.isSelling ?? true,
    isSoldOut: goods?.isSoldOut ?? false,
    isDiscontinued: goods?.isDiscontinued ?? false,
    isFreeDelivery: goods?.delivery?.isFree ?? false,
    isOverseasPurchase: goods?.isOverseasPurchase ?? false,
    couponBadge: goodsCouponMold && showCouponBadge ? {
      title: getCouponBadgeTitle(goodsCouponMold, isLoggedIn ?? false),
      image: 'https://image.ohou.se/i/bucketplace-v2-development/static/productions/goods-coupon-badge.png',
      discountRatio: goodsCouponMold.discountRate ? goodsCouponMold.discountRate.toString() : '',
      fixedDiscountAmount: goodsCouponMold.discountAmount
    } : undefined,
    benefitBadges: getCardPromotionBadges(goods?.additionalProperties?.cardPromotions, goods?.price?.sellingPrice),
    isScrap: goods?.isScrap ?? false,
    scrapCount: goods?.scrapCount ?? 0,
    price: goods?.price
  };
};

/**
 * 모음전 아이템을 Product 형태로 전환하는 함수
 * @param deal 모음전 아이템
 * @param isScrap 스크랩 유무
 * @returns 상품
 */
const convertDealToProduct = deal => {
  return {
    ...DEPRECATED_FIELDS,
    type: 'Deal',
    id: Number.parseInt(deal?.id ?? '0', 10),
    name: deal?.name ?? '',
    reviewAvg: deal?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: deal?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(deal?.price?.representativeSellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(deal?.price?.representativeOriginalPrice ?? '0', 10),
    originalImageUrl: deal?.imageUrl ?? '',
    brand: deal?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(deal?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: undefined,
    deliveryServiceCode: DELIVERY_SERVICE_CODE.NONE,
    isDepartureToday: deal?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED',
    isSpecialPrice: deal?.price?.isSpecialPrice ?? false,
    isSelling: deal?.isSelling ?? true,
    isSoldOut: deal?.isSoldOut ?? false,
    isDiscontinued: false,
    isFreeDelivery: deal?.isFreeDelivery ?? false,
    isOverseasPurchase: deal?.isOverseasPurchase ?? false,
    benefitBadges: getCardPromotionBadges(deal?.additionalProperties?.cardPromotions, deal?.price?.representativeSellingPrice),
    isScrap: deal?.isScrap ?? false,
    scrapCount: deal?.scrapCount ?? 0
  };
};

/**
 * Goods, Deal 둘중 하나의 형태를 지닌 StoreItem을 Product로 변환하는 함수
 * @param storeItem goods 또는 deal을 포함한 storeItem
 * @param showCouponBadge 쿠폰뱃지 노출 여부, 해당값이 true여야 쿠폰뱃지를 보여줌
 * @param isLoggedIn 로그인 여부, 로그인 상태가 아니면 상품쿠폰 뱃지의 타이틀을 할인쿠폰으로 보여줌
 * @returns 상품 Product
 * @example
 * ```
 * convertStoreItemToProduct({
 *   storeItem,
 *   showCouponBadge: true,
 *   isLoggedIn,
 * });
 * ```
 */
const convertStoreItemToProduct = ({
  storeItem,
  showCouponBadge = false,
  isLoggedIn = false
}) => {
  return storeItem.type === 'Goods' ? convertGoodsToProduct({
    goods: storeItem.goods,
    showCouponBadge,
    isLoggedIn
  }) : convertDealToProduct(storeItem.deal);
};

/**
 * store-mobile-bff 의 GoodsSummary 타입을
 * ProductCard 에서 사용하는 Product 타입으로 변환해주는 함수
 */
function convertGoodsSummaryToProduct({
  goodsSummary,
  type
}) {
  return {
    type,
    id: Number.parseInt(goodsSummary.id, 10),
    name: goodsSummary.name ?? '',
    reviewAvg: goodsSummary.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goodsSummary.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeSellingPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.sellingPrice ?? '0', 10),
    originalPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeOriginalPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.originalPrice ?? '0', 10),
    originalImageUrl: goodsSummary.imageUrl ?? '',
    brand: {
      id: Number.parseInt(goodsSummary.brand?.id ?? '0', 10),
      name: goodsSummary.brand?.name ?? ''
    },
    badges: goodsSummary.badgeProperties?.thumbnailBadges?.map(thumbnailBadge => ({
      id: 0,
      thumbnailBadgeId: 0,
      position: thumbnailBadge.position,
      image: {
        url: thumbnailBadge.imageUrl ?? '',
        width: null,
        height: null
      }
    })),
    benefitBadges: goodsSummary.badgeProperties?.cardPromotion != null ? [{
      image: goodsSummary.badgeProperties.cardPromotion.imageUrl,
      title: goodsSummary.badgeProperties.cardPromotion.displayText,
      ozipTitle: '',
      discountRatio: goodsSummary.badgeProperties.cardPromotion.discountRatio,
      fixedDiscountAmount: goodsSummary.badgeProperties.cardPromotion.fixedDiscountAmount
    }] : undefined,
    couponBadge: goodsSummary.badgeProperties?.couponBadge?.imageUrl != null && goodsSummary.badgeProperties?.couponBadge?.displayText != null ? {
      image: goodsSummary.badgeProperties.couponBadge.imageUrl,
      title: goodsSummary.badgeProperties?.couponBadge.displayText
    } : undefined,
    deliveryStartAt: goodsSummary.badgeProperties?.departureToday ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [goodsSummary.badgeProperties.departureToday.orderDeadline]
      }
    } : undefined,
    deliveryServiceCode: goodsSummary.badgeProperties?.deliveryServiceCode ?? 'NONE',
    scrapCount: goodsSummary.scrapInfo?.scrapCount ?? 0,
    isSpecialPrice: goodsSummary.badgeProperties?.isSpecialPrice ?? false,
    isSelling: goodsSummary.badgeProperties?.isSelling ?? true,
    isSoldOut: goodsSummary.isSoldOut ?? false,
    isScrap: goodsSummary.scrapInfo?.isScrap ?? false,
    isFreeDelivery: goodsSummary.badgeProperties?.isFreeDelivery ?? false,
    isDiscontinued: goodsSummary.badgeProperties?.isDiscontinued ?? false,
    isOverseasPurchase: goodsSummary.badgeProperties?.isOverseasPurchase ?? false,
    isDepartureToday: goodsSummary.badgeProperties?.departureToday !== undefined,
    ...DEPRECATED_FIELDS
  };
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$2 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$3 = formatDistance$2;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};
var formatRelative$3 = formatRelative$2;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$1 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey$1(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey$1(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale$1;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1초 미만',
    other: '{{count}}초 미만'
  },
  xSeconds: {
    one: '1초',
    other: '{{count}}초'
  },
  halfAMinute: '30초',
  lessThanXMinutes: {
    one: '1분 미만',
    other: '{{count}}분 미만'
  },
  xMinutes: {
    one: '1분',
    other: '{{count}}분'
  },
  aboutXHours: {
    one: '약 1시간',
    other: '약 {{count}}시간'
  },
  xHours: {
    one: '1시간',
    other: '{{count}}시간'
  },
  xDays: {
    one: '1일',
    other: '{{count}}일'
  },
  aboutXWeeks: {
    one: '약 1주',
    other: '약 {{count}}주'
  },
  xWeeks: {
    one: '1주',
    other: '{{count}}주'
  },
  aboutXMonths: {
    one: '약 1개월',
    other: '약 {{count}}개월'
  },
  xMonths: {
    one: '1개월',
    other: '{{count}}개월'
  },
  aboutXYears: {
    one: '약 1년',
    other: '약 {{count}}년'
  },
  xYears: {
    one: '1년',
    other: '{{count}}년'
  },
  overXYears: {
    one: '1년 이상',
    other: '{{count}}년 이상'
  },
  almostXYears: {
    one: '거의 1년',
    other: '거의 {{count}}년'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' 후';
    } else {
      return result + ' 전';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: 'y년 M월 d일 EEEE',
  long: 'y년 M월 d일',
  medium: 'y.MM.dd',
  short: 'y.MM.dd'
};
var timeFormats = {
  full: 'a H시 mm분 ss초 zzzz',
  long: 'a H:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['BC', 'AD'],
  abbreviated: ['BC', 'AD'],
  wide: ['기원전', '서기']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1분기', '2분기', '3분기', '4분기']
};
var monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
};
var dayValues = {
  narrow: ['일', '월', '화', '수', '목', '금', '토'],
  short: ['일', '월', '화', '수', '목', '금', '토'],
  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
};
var dayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = String(options === null || options === void 0 ? void 0 : options.unit);
  switch (unit) {
    case 'minute':
    case 'second':
      return String(number);
    case 'date':
      return number + '일';
    default:
      return number + '번째';
  }
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */
var locale = {
  code: 'ko',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var ko = locale;

const DATE_FORMAT = 'M/d (EE)';

/**
 * 배송의 타입, 상태에 따라 배송 추적 날짜 정보를 반환합니다.
 * ex)
 *  M/d (EE) 도착예정
 *  M/d (EE) 도착완료
 *  M/d (EE) 수거예정
 *  M/d (EE) 수거완료 예정 , ...
 * @param param
 */
const getDeliveryTackingNoticeFormat = param => {
  const {
    date,
    deliveryStatus,
    deliveryTargetType,
    isWithinDue
  } = param;
  if (deliveryTargetType === DELIVERY_TARGET_TYPE.PICKUP) {
    return getPickupDateFormat({
      date,
      deliveryStatus
    });
  } else {
    return getOrderDeliveryFormat({
      date,
      isWithinDue,
      isCompleted: deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE
    });
  }
};

/**
 * 배송/재배송시의 배송조회 예정 날짜 및 문구 포맷을 반환한다.
 * @param dayDiff 오늘과 배송예정 날짜의 차이
 * @param isCompleted 배송 완료 여부포맷
 * @param isWithinDue ~이내로 표시해야 하는지 여부 (해외배송, 판매자 직접 배송 등 배송일자가 밀릴 수 있는 경우)
 */
const getOrderDeliveryFormat = ({
  date,
  isCompleted,
  isWithinDue
}) => {
  const formatDate = format$1(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (isCompleted) {
    return {
      due: formatDate,
      status: '도착완료',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '배송지연중',
      isDelayed: true
    };
  }
  if (isWithinDue) {
    return {
      due: `${formatDate} 이내`,
      status: '도착예정',
      isDelayed: false
    };
  }
  let [monthAndDay, week] = formatDate.split(' ');
  if (dayDiff === 0) {
    monthAndDay = '오늘';
  } else if (dayDiff === 1) {
    monthAndDay = '내일';
  }
  return {
    due: `${monthAndDay} ${week}`,
    status: '도착예정',
    isDelayed: false
  };
};

/**
 * 수거관련 날짜 및 문구 포맷을 반환합니다.
 * @param deliveryStatus 배송상태
 * @param date 날짜
 */
const getPickupDateFormat = ({
  deliveryStatus,
  date
}) => {
  const formatDate = format$1(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE) {
    return {
      due: formatDate,
      status: '수거완료',
      isDelayed: false
    };
  }
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.SCHEDULED) {
    if (dayDiff <= -1) {
      return {
        due: '',
        status: '수거 지연중',
        isDelayed: true
      };
    }
    return {
      due: formatDate,
      status: '수거예정',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '수거완료 지연중',
      isDelayed: true
    };
  }
  return {
    due: formatDate,
    status: '수거완료 예정',
    isDelayed: false
  };
};

function formatPhoneNumber(value) {
  return value.replace(/\D/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace('--', '-');
}

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// Loads Kakao API on demand.
const KAKAO_API_SRC = '//developers.kakao.com/sdk/js/kakao.min.js';
const KAKAO_AUTH_TOKEN = '3019c756ec77dd7e0a24e56d9d784f77';
let kakaoAPILoading = null;
let initialized = false;
function getKakaoAPI() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.Kakao;
}
function loadKakaoAPI() {
  if (window.Kakao != null) {
    if (!initialized) {
      try {
        Kakao.init(KAKAO_AUTH_TOKEN);
      } catch (e) {
        //
      }
      initialized = true;
    }
    return Promise.resolve(window.Kakao);
  } else if (kakaoAPILoading != null) {
    return kakaoAPILoading;
  } else {
    kakaoAPILoading = new Promise(resolve => {
      // Load the script from daum...
      const script = document.createElement('script');
      script.addEventListener('load', () => {
        const Kakao = window.Kakao;
        Kakao.init(KAKAO_AUTH_TOKEN);
        initialized = true;
        resolve(Kakao);
      });
      script.src = KAKAO_API_SRC;
      document.body.appendChild(script);
    });
    return kakaoAPILoading;
  }
}
function useKakaoAPI(onUpdate) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!loaded) {
      loadKakaoAPI().then(() => {
        setLoaded(true);
        if (onUpdate != null) {
          onUpdate();
        }
      });
    }
  }, []);
  return getKakaoAPI();
}

const USP_BADGE_EXPERIMENT_KEY = 1005;
const useUspBadgeExperimentType = () => {
  const {
    experimentType = 'A',
    pending
  } = useExperimentType({
    type: 'AB',
    experimentKey: USP_BADGE_EXPERIMENT_KEY
  });
  return {
    experimentType: experimentType.toUpperCase(),
    pending
  };
};

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};
function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = React.useState(null);
  const callback = React.useRef();
  const [state, setState] = React.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  React.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = React.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

var E$1 = Object.create;
var h = Object.defineProperty;
var T$1 = Object.getOwnPropertyDescriptor;
var K = Object.getOwnPropertyNames;
var C$1 = Object.getPrototypeOf,
  F = Object.prototype.hasOwnProperty;
var V$1 = (e, o) => () => (o || e((o = {
  exports: {}
}).exports, o), o.exports);
var q = (e, o, n, s) => {
  if (o && typeof o == "object" || typeof o == "function") for (let i of K(o)) !F.call(e, i) && i !== n && h(e, i, {
    get: () => o[i],
    enumerable: !(s = T$1(o, i)) || s.enumerable
  });
  return e;
};
var A$1 = (e, o, n) => (n = e != null ? E$1(C$1(e)) : {}, q(o || !e || !e.__esModule ? h(n, "default", {
  value: e,
  enumerable: !0
}) : n, e));
var k = V$1((b, p) => {
  (function (e) {
    var o = function (t, r, a) {
        if (!I(r) || j(r) || O(r) || B(r) || P(r)) return r;
        var c,
          u = 0,
          y = 0;
        if (U(r)) for (c = [], y = r.length; u < y; u++) c.push(o(t, r[u], a));else {
          c = {};
          for (var w in r) Object.prototype.hasOwnProperty.call(r, w) && (c[t(w, a)] = o(t, r[w], a));
        }
        return c;
      },
      n = function (t, r) {
        r = r || {};
        var a = r.separator || "_",
          c = r.split || /(?=[A-Z])/;
        return t.split(c).join(a);
      },
      s = function (t) {
        return R(t) ? t : (t = t.replace(/[\-_\s]+(.)?/g, function (r, a) {
          return a ? a.toUpperCase() : "";
        }), t.substr(0, 1).toLowerCase() + t.substr(1));
      },
      i = function (t) {
        var r = s(t);
        return r.substr(0, 1).toUpperCase() + r.substr(1);
      },
      l = function (t, r) {
        return n(t, r).toLowerCase();
      },
      g = Object.prototype.toString,
      P = function (t) {
        return typeof t == "function";
      },
      I = function (t) {
        return t === Object(t);
      },
      U = function (t) {
        return g.call(t) == "[object Array]";
      },
      j = function (t) {
        return g.call(t) == "[object Date]";
      },
      O = function (t) {
        return g.call(t) == "[object RegExp]";
      },
      B = function (t) {
        return g.call(t) == "[object Boolean]";
      },
      R = function (t) {
        return t = t - 0, t === t;
      },
      m = function (t, r) {
        var a = r && "process" in r ? r.process : r;
        return typeof a != "function" ? t : function (c, u) {
          return a(c, t, u);
        };
      },
      d = {
        camelize: s,
        decamelize: l,
        pascalize: i,
        depascalize: l,
        camelizeKeys: function (t, r) {
          return o(m(s, r), t);
        },
        decamelizeKeys: function (t, r) {
          return o(m(l, r), t, r);
        },
        pascalizeKeys: function (t, r) {
          return o(m(i, r), t);
        },
        depascalizeKeys: function () {
          return this.decamelizeKeys.apply(this, arguments);
        }
      };
    typeof define == "function" && define.amd ? define(d) : typeof p < "u" && p.exports ? p.exports = d : e.humps = d;
  })(b);
});
var z = A$1(k());
function x$1(e, o) {
  let n = {};
  for (let s in e) Object.prototype.hasOwnProperty.call(e, s) && o(e[s], s) && (n[s] = e[s]);
  return n;
}
var f$1 = e => x$1({
    data: e.data,
    category: e.category,
    object_section: e.section,
    object_section_id: e.section_id,
    object_section_idx: e.section_idx,
    object_type: e.type && (0, z.decamelize)(e.type.toLowerCase()),
    object_id: e.id,
    object_idx: e.index,
    object_url: e.url,
    page_id: e.page_id,
    page_params: e.page_params
  }, o => o != null),
  L = e => {
    window.bucketLog = window.bucketLog || [], window.bucketLog.push(f$1(e));
  },
  M$1 = e => {
    let o = window.bucketLog;
    return o && o.get ? o.get(e) : null;
  };
function H(e) {
  L({
    category: "impression",
    data: [{
      ...f$1(e),
      time: Date.now()
    }]
  });
}
function ce({
  logData: e,
  threshold: o,
  disable: n
}) {
  let {
    ref: s,
    inView: i
  } = useInView({
    threshold: o,
    skip: n,
    triggerOnce: !0
  });
  return useEffect(() => {
    if (i && !n && e) {
      let {
        category: l,
        ...g
      } = e;
      H(g), L({
        category: "impression",
        data: [{
          ...f$1(g),
          time: Date.now()
        }]
      });
    }
  }, [i, n, e]), {
    ref: s
  };
}

/**
 * 뱃지 관련 로그 데이터 가공을 위한 hooks
 */
function useProductCardLogData({
  product,
  badgeMaxCount
}) {
  const {
    benefitBadges,
    couponBadge,
    deliveryServiceCode,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isSoldOut,
    isSelling,
    isDiscontinued,
    price
  } = product;
  const badgeLogData = useMemo(() => {
    const initialData = {
      isOverseasPurchase,
      isFreeDelivery,
      isSpecialPrice
    };
    if (isDiscontinued || !isSelling) {
      return {};
    }
    if (badgeMaxCount != null && Object.values(initialData).filter(val => !!val).length > badgeMaxCount) {
      return Object.keys(initialData).filter(val => !!val).slice(0, badgeMaxCount).reduce((acc, cur) => ({
        ...acc,
        [cur]: initialData[cur]
      }), {});
    }
    return initialData;
  }, [badgeMaxCount, isDiscontinued, isSelling, isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  const {
    regularPrice,
    sellingPrice,
    salePrice,
    discountPlans
  } = price ?? {};
  const hasInstantDiscount = discountPlans?.[0]?.planType === 'INSTANT_DISCOUNT';
  const instantDiscountPrice = Number(salePrice) - (hasInstantDiscount ? Number(discountPlans?.[0]?.discountAmount) : 0);
  const _detailLogData = {
    delivery_service_code: deliveryServiceCode,
    is_overseas_purchase: badgeLogData['isOverseasPurchase'] ?? false,
    is_free_delivery: badgeLogData['isFreeDelivery'] ?? false,
    is_special_price: badgeLogData['isSpecialPrice'] ?? false,
    is_soldout: isSoldOut,
    is_discontinued: isDiscontinued,
    is_selling: isSelling,
    coupon_badge: couponBadge != null ? {
      fixed_discount_amount: couponBadge?.fixedDiscountAmount,
      discount_ratio: Math.round(Number(couponBadge?.discountRatio ?? '0') * 100),
      display_text: couponBadge?.title
    } : undefined,
    card_promotion: benefitBadges?.[0] != null ? {
      fixed_discount_amount: benefitBadges?.[0]?.fixedDiscountAmount,
      discount_ratio: benefitBadges?.[0]?.discountRatio,
      display_text: benefitBadges?.[0]?.title,
      promotion_payment_method: benefitBadges?.[0]?.promotionPaymentMethod
    } : undefined,
    instant_discount_text_display: false,
    ...(hasInstantDiscount && {
      instant_discount_id: discountPlans?.[0]?.planId,
      instant_discount: {
        fixed_discount_amount: discountPlans?.[0]?.discountAmount ?? null,
        discount_ratio: null
      },
      instant_discount_price: instantDiscountPrice ?? null
    }),
    regular_price: regularPrice ?? null,
    sale_price: salePrice ?? null,
    selling_price: sellingPrice ?? null
  };
  const detailLogData = Object.fromEntries(Object.entries(_detailLogData).filter(([_, v]) => v != null));
  return {
    detailLogData
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (typeof arg !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs$1(classnamesExports);

function PlaceholderAnimation(props) {
  const {
    children,
    className
  } = props;
  return jsx(Container$y, {
    className: className,
    children: children
  });
}
const keyframesPlaceholderAnimation = keyframes`
  0% {
    transform: translate3d(-30%, 0, 0);
  }
  100% {
    transform: translate3d(30%, 0, 0);
  }
`;
const Container$y = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2uolej0"
} : {
  target: "e2uolej0",
  label: "Container"
})("position:relative;display:block;overflow:hidden;", ({
  theme
}) => /*#__PURE__*/css("color:", theme.content.base5, ";background-color:", theme.content.base5, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYWNlaG9sZGVyQW5pbWF0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQ3NCIiwiZmlsZSI6IlBsYWNlaG9sZGVyQW5pbWF0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCwgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUGxhY2Vob2xkZXJBbmltYXRpb25Qcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFBsYWNlaG9sZGVyQW5pbWF0aW9uKFxuICBwcm9wczogUGxhY2Vob2xkZXJBbmltYXRpb25Qcm9wcyxcbik6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGNsYXNzTmFtZSB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICB7IGNoaWxkcmVuIH1cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuY29uc3Qga2V5ZnJhbWVzUGxhY2Vob2xkZXJBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIDAlIHtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKC0zMCUsIDAsIDApO1xuICB9XG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoMzAlLCAwLCAwKTtcbiAgfVxuYDtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBibG9jaztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgJHsoeyB0aGVtZSB9KSA9PiBjc3NgXG4gICAgY29sb3I6ICR7dGhlbWUuY29udGVudC5iYXNlNX07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0aGVtZS5jb250ZW50LmJhc2U1fTtcbiAgYH1cbiAgJjphZnRlciB7XG4gICAgY29udGVudDogJ1xcXFwwMGEwJztcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICAgIHJpZ2h0OiAwO1xuICAgIGJvdHRvbTogMDtcbiAgICBsZWZ0OiA1MCU7XG4gICAgei1pbmRleDogMTtcbiAgICB3aWR0aDogNTAwJTtcbiAgICBtYXJnaW4tbGVmdDogLTI1MCU7XG4gICAgYW5pbWF0aW9uOiAke2tleWZyYW1lc1BsYWNlaG9sZGVyQW5pbWF0aW9ufSAwLjhzIGxpbmVhciBpbmZpbml0ZTtcbiAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsXG4gICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDApIDQ0JSxcbiAgICAgIHJnYmEoMjU1LCAyNTUsIDI1NSwgLjM1KSA1MCUsXG4gICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDApIDU2JSkgNTAlIDUwJTtcbiAgfVxuYDtcbiJdfQ== */"), " &:after{content:'\\00a0';position:absolute;top:0;right:0;bottom:0;left:50%;z-index:1;width:500%;margin-left:-250%;animation:", keyframesPlaceholderAnimation, " 0.8s linear infinite;background:linear-gradient(to right,\n      rgba(255, 255, 255, 0) 44%,\n      rgba(255, 255, 255, .35) 50%,\n      rgba(255, 255, 255, 0) 56%) 50% 50%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYWNlaG9sZGVyQW5pbWF0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2QjRCIiwiZmlsZSI6IlBsYWNlaG9sZGVyQW5pbWF0aW9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCwgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUGxhY2Vob2xkZXJBbmltYXRpb25Qcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFBsYWNlaG9sZGVyQW5pbWF0aW9uKFxuICBwcm9wczogUGxhY2Vob2xkZXJBbmltYXRpb25Qcm9wcyxcbik6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGNsYXNzTmFtZSB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICB7IGNoaWxkcmVuIH1cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuY29uc3Qga2V5ZnJhbWVzUGxhY2Vob2xkZXJBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIDAlIHtcbiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZTNkKC0zMCUsIDAsIDApO1xuICB9XG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlM2QoMzAlLCAwLCAwKTtcbiAgfVxuYDtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBibG9jaztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgJHsoeyB0aGVtZSB9KSA9PiBjc3NgXG4gICAgY29sb3I6ICR7dGhlbWUuY29udGVudC5iYXNlNX07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0aGVtZS5jb250ZW50LmJhc2U1fTtcbiAgYH1cbiAgJjphZnRlciB7XG4gICAgY29udGVudDogJ1xcXFwwMGEwJztcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICAgIHJpZ2h0OiAwO1xuICAgIGJvdHRvbTogMDtcbiAgICBsZWZ0OiA1MCU7XG4gICAgei1pbmRleDogMTtcbiAgICB3aWR0aDogNTAwJTtcbiAgICBtYXJnaW4tbGVmdDogLTI1MCU7XG4gICAgYW5pbWF0aW9uOiAke2tleWZyYW1lc1BsYWNlaG9sZGVyQW5pbWF0aW9ufSAwLjhzIGxpbmVhciBpbmZpbml0ZTtcbiAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsXG4gICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDApIDQ0JSxcbiAgICAgIHJnYmEoMjU1LCAyNTUsIDI1NSwgLjM1KSA1MCUsXG4gICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDApIDU2JSkgNTAlIDUwJTtcbiAgfVxuYDtcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$$() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Price(props) {
  const {
    originalPrice,
    sellingPrice,
    isDiscontinued,
    isSoldOut,
    variant = 'lg',
    renderSuffix,
    currency,
    priceToken
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const discountRate = Math.floor((originalPrice - sellingPrice) / originalPrice * 100);
  const isGlobal = !!currency;
  return jsxs(Container$x, {
    className: "price",
    children: [discountRate > 0 && originalPrice > 0 && jsxs(Rate, {
      disabled: disabled,
      variant: variant,
      children: [discountRate, jsx("span", {
        className: "percentage",
        children: '% '
      })]
    }), jsxs(Amount, {
      disabled: disabled,
      variant: variant,
      children: [formatComma(sellingPrice), renderSuffix != null && renderSuffix()]
    }), isGlobal && priceToken && jsx(EsportsToken, {
      children: priceToken
    })]
  });
}
function PricePlaceholder(props) {
  const {
    className
  } = props;
  return jsx(Placeholder$1, {
    className: className
  });
}
const Container$x = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e175igv94"
} : {
  target: "e175igv94",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "14q3hbk",
  styles: "display:flex;align-items:center;flex-wrap:wrap;margin-top:4px"
} : {
  name: "14q3hbk",
  styles: "display:flex;align-items:center;flex-wrap:wrap;margin-top:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
});
const getPriceFontStyle = variant => {
  switch (variant) {
    case 'sm':
      return FONT_STYLE.caption1;
    case 'md':
      return FONT_STYLE.subTitle2;
    default:
      return FONT_STYLE.title3;
  }
};
var _ref2$9 = process.env.NODE_ENV === "production" ? {
  name: "zw93mq",
  styles: "opacity:0.26"
} : {
  name: "nxe75c-Rate",
  styles: "opacity:0.26;label:Rate;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
};
const Rate = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv93"
} : {
  target: "e175igv93",
  label: "Rate"
})(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:bold;margin-right:2px;color:", ({
  theme
}) => theme.content.primary1.basic, ";", ({
  disabled
}) => disabled && _ref2$9, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var _ref$t = process.env.NODE_ENV === "production" ? {
  name: "5b2tzs",
  styles: "opacity:0.14"
} : {
  name: "ruk4nf-Amount",
  styles: "opacity:0.14;label:Amount;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaWNlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxR3FDIiwiZmlsZSI6IlByaWNlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCwgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgU2VyaWFsaXplZFN0eWxlcywgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBGT05UX1NUWUxFIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ3VycmVuY3kgfSBmcm9tICdAL3R5cGVzL2luZGV4JztcbmltcG9ydCB7IGZvcm1hdENvbW1hIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2xpYic7XG5cbmltcG9ydCBQbGFjZWhvbGRlckFuaW1hdGlvbiBmcm9tICdAL2NvbXBvbmVudHMvUGxhY2Vob2xkZXJBbmltYXRpb24nO1xuaW1wb3J0IHsgVmFyaWFudCB9IGZyb20gJ0AvY29tbWVyY2UvdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaWNlUHJvcHMge1xuICBvcmlnaW5hbFByaWNlOiBudW1iZXI7XG4gIHNlbGxpbmdQcmljZTogbnVtYmVyO1xuICBpc0Rpc2NvbnRpbnVlZD86IGJvb2xlYW47XG4gIGlzU29sZE91dD86IGJvb2xlYW47XG4gIHZhcmlhbnQ/OiBWYXJpYW50O1xuICByZW5kZXJTdWZmaXg/OiAoKSA9PiBSZWFjdE5vZGU7XG4gIGN1cnJlbmN5PzogQ3VycmVuY3k7XG4gIHByaWNlVG9rZW4/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBQcmljZShcbiAgcHJvcHM6IFByaWNlUHJvcHMsXG4pOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgb3JpZ2luYWxQcmljZSxcbiAgICBzZWxsaW5nUHJpY2UsXG4gICAgaXNEaXNjb250aW51ZWQsXG4gICAgaXNTb2xkT3V0LFxuICAgIHZhcmlhbnQgPSAnbGcnLFxuICAgIHJlbmRlclN1ZmZpeCxcbiAgICBjdXJyZW5jeSxcbiAgICBwcmljZVRva2VuLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGRpc2FibGVkID0gIWlzRGlzY29udGludWVkICYmIGlzU29sZE91dDtcbiAgY29uc3QgZGlzY291bnRSYXRlID0gTWF0aC5mbG9vcigoKG9yaWdpbmFsUHJpY2UgLSBzZWxsaW5nUHJpY2UpIC8gb3JpZ2luYWxQcmljZSkgKiAxMDApO1xuICBjb25zdCBpc0dsb2JhbCA9ICEhY3VycmVuY3k7XG5cbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIGNsYXNzTmFtZT1cInByaWNlXCI+XG4gICAgICB7IGRpc2NvdW50UmF0ZSA+IDAgJiYgb3JpZ2luYWxQcmljZSA+IDAgJiYgKFxuICAgICAgICA8UmF0ZSBkaXNhYmxlZD17ZGlzYWJsZWR9IHZhcmlhbnQ9e3ZhcmlhbnR9PlxuICAgICAgICAgIHsgZGlzY291bnRSYXRlIH1cbiAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJwZXJjZW50YWdlXCI+eyAnJSAnIH08L3NwYW4+XG4gICAgICAgIDwvUmF0ZT5cbiAgICAgICkgfVxuICAgICAgPEFtb3VudCBkaXNhYmxlZD17ZGlzYWJsZWR9IHZhcmlhbnQ9e3ZhcmlhbnR9PlxuICAgICAgICB7IGZvcm1hdENvbW1hKHNlbGxpbmdQcmljZSkgfVxuICAgICAgICB7IHJlbmRlclN1ZmZpeCAhPSBudWxsICYmIHJlbmRlclN1ZmZpeCgpIH1cbiAgICAgIDwvQW1vdW50PlxuICAgICAgeyBpc0dsb2JhbCAmJiBwcmljZVRva2VuICYmIDxFc3BvcnRzVG9rZW4+eyBwcmljZVRva2VuIH08L0VzcG9ydHNUb2tlbj4gfVxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIFByaWNlUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIFByaWNlUGxhY2Vob2xkZXIoXG4gIHByb3BzOiBQcmljZVBsYWNlaG9sZGVyUHJvcHMsXG4pOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7IGNsYXNzTmFtZSB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPFBsYWNlaG9sZGVyIGNsYXNzTmFtZT17Y2xhc3NOYW1lfSAvPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIG1hcmdpbi10b3A6IDRweDtcbmA7XG5cbmNvbnN0IGdldFByaWNlRm9udFN0eWxlID0gKHZhcmlhbnQ6IFZhcmlhbnQpOiBTZXJpYWxpemVkU3R5bGVzID0+IHtcbiAgc3dpdGNoICh2YXJpYW50KSB7XG4gICAgY2FzZSAnc20nOlxuICAgICAgcmV0dXJuIEZPTlRfU1RZTEUuY2FwdGlvbjE7XG4gICAgY2FzZSAnbWQnOlxuICAgICAgcmV0dXJuIEZPTlRfU1RZTEUuc3ViVGl0bGUyO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gRk9OVF9TVFlMRS50aXRsZTM7XG4gIH1cbn07XG5cbmNvbnN0IFJhdGUgPSBzdHlsZWQuc3Bhbjx7IHZhcmlhbnQ6IFZhcmlhbnQsIGRpc2FibGVkPzogYm9vbGVhbiB9PmBcbiAgJHsoeyB2YXJpYW50IH0pID0+IGdldFByaWNlRm9udFN0eWxlKHZhcmlhbnQpfTtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIG1hcmdpbi1yaWdodDogMnB4O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgJHsoeyBkaXNhYmxlZCB9KSA9PiBkaXNhYmxlZCAmJiBjc3NgXG4gICAgb3BhY2l0eTogMC4yNjtcbiAgYH1cbmA7XG5cbmNvbnN0IEFtb3VudCA9IHN0eWxlZC5zcGFuPHsgdmFyaWFudDogVmFyaWFudCwgZGlzYWJsZWQ/OiBib29sZWFuIH0+YFxuICAkeyh7IHZhcmlhbnQgfSkgPT4gZ2V0UHJpY2VGb250U3R5bGUodmFyaWFudCl9O1xuICBmb250LXdlaWdodDogNzAwO1xuICBjb2xvcjogIzJGMzQzODtcbiAgJHsoeyBkaXNhYmxlZCB9KSA9PiBkaXNhYmxlZCAmJiBjc3NgXG4gICAgb3BhY2l0eTogMC4xNDtcbiAgYH1cbmA7XG5cbmNvbnN0IFBsYWNlaG9sZGVyID0gc3R5bGVkKFBsYWNlaG9sZGVyQW5pbWF0aW9uKWBcbiAgZm9udC1zaXplOiAxN3B4O1xuICBsaW5lLWhlaWdodDogMjNweDtcbiAgJjpiZWZvcmUge1xuICAgIGNvbnRlbnQ6ICdcXFxcMDBhMCc7XG4gIH1cbmA7XG5cbmNvbnN0IEVzcG9ydHNUb2tlbiA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICBtYXJnaW4tbGVmdDogMnB4O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
};
const Amount = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv92"
} : {
  target: "e175igv92",
  label: "Amount"
})(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:700;color:#2F3438;", ({
  disabled
}) => disabled && _ref$t, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Placeholder$1 = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e175igv91"
} : {
  target: "e175igv91",
  label: "Placeholder"
})(process.env.NODE_ENV === "production" ? {
  name: "1l6via1",
  styles: "font-size:17px;line-height:23px;&:before{content:'\\00a0';}"
} : {
  name: "1l6via1",
  styles: "font-size:17px;line-height:23px;&:before{content:'\\00a0';}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
});
const EsportsToken = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv90"
} : {
  target: "e175igv90",
  label: "EsportsToken"
})(FONT_STYLE.caption1, " color:", ({
  theme
}) => theme.content.base2, ";margin-left:2px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaWNlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrSGdDIiwiZmlsZSI6IlByaWNlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCwgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgU2VyaWFsaXplZFN0eWxlcywgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBGT05UX1NUWUxFIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ3VycmVuY3kgfSBmcm9tICdAL3R5cGVzL2luZGV4JztcbmltcG9ydCB7IGZvcm1hdENvbW1hIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2xpYic7XG5cbmltcG9ydCBQbGFjZWhvbGRlckFuaW1hdGlvbiBmcm9tICdAL2NvbXBvbmVudHMvUGxhY2Vob2xkZXJBbmltYXRpb24nO1xuaW1wb3J0IHsgVmFyaWFudCB9IGZyb20gJ0AvY29tbWVyY2UvdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaWNlUHJvcHMge1xuICBvcmlnaW5hbFByaWNlOiBudW1iZXI7XG4gIHNlbGxpbmdQcmljZTogbnVtYmVyO1xuICBpc0Rpc2NvbnRpbnVlZD86IGJvb2xlYW47XG4gIGlzU29sZE91dD86IGJvb2xlYW47XG4gIHZhcmlhbnQ/OiBWYXJpYW50O1xuICByZW5kZXJTdWZmaXg/OiAoKSA9PiBSZWFjdE5vZGU7XG4gIGN1cnJlbmN5PzogQ3VycmVuY3k7XG4gIHByaWNlVG9rZW4/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBQcmljZShcbiAgcHJvcHM6IFByaWNlUHJvcHMsXG4pOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgb3JpZ2luYWxQcmljZSxcbiAgICBzZWxsaW5nUHJpY2UsXG4gICAgaXNEaXNjb250aW51ZWQsXG4gICAgaXNTb2xkT3V0LFxuICAgIHZhcmlhbnQgPSAnbGcnLFxuICAgIHJlbmRlclN1ZmZpeCxcbiAgICBjdXJyZW5jeSxcbiAgICBwcmljZVRva2VuLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGRpc2FibGVkID0gIWlzRGlzY29udGludWVkICYmIGlzU29sZE91dDtcbiAgY29uc3QgZGlzY291bnRSYXRlID0gTWF0aC5mbG9vcigoKG9yaWdpbmFsUHJpY2UgLSBzZWxsaW5nUHJpY2UpIC8gb3JpZ2luYWxQcmljZSkgKiAxMDApO1xuICBjb25zdCBpc0dsb2JhbCA9ICEhY3VycmVuY3k7XG5cbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIGNsYXNzTmFtZT1cInByaWNlXCI+XG4gICAgICB7IGRpc2NvdW50UmF0ZSA+IDAgJiYgb3JpZ2luYWxQcmljZSA+IDAgJiYgKFxuICAgICAgICA8UmF0ZSBkaXNhYmxlZD17ZGlzYWJsZWR9IHZhcmlhbnQ9e3ZhcmlhbnR9PlxuICAgICAgICAgIHsgZGlzY291bnRSYXRlIH1cbiAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJwZXJjZW50YWdlXCI+eyAnJSAnIH08L3NwYW4+XG4gICAgICAgIDwvUmF0ZT5cbiAgICAgICkgfVxuICAgICAgPEFtb3VudCBkaXNhYmxlZD17ZGlzYWJsZWR9IHZhcmlhbnQ9e3ZhcmlhbnR9PlxuICAgICAgICB7IGZvcm1hdENvbW1hKHNlbGxpbmdQcmljZSkgfVxuICAgICAgICB7IHJlbmRlclN1ZmZpeCAhPSBudWxsICYmIHJlbmRlclN1ZmZpeCgpIH1cbiAgICAgIDwvQW1vdW50PlxuICAgICAgeyBpc0dsb2JhbCAmJiBwcmljZVRva2VuICYmIDxFc3BvcnRzVG9rZW4+eyBwcmljZVRva2VuIH08L0VzcG9ydHNUb2tlbj4gfVxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIFByaWNlUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIFByaWNlUGxhY2Vob2xkZXIoXG4gIHByb3BzOiBQcmljZVBsYWNlaG9sZGVyUHJvcHMsXG4pOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7IGNsYXNzTmFtZSB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPFBsYWNlaG9sZGVyIGNsYXNzTmFtZT17Y2xhc3NOYW1lfSAvPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIG1hcmdpbi10b3A6IDRweDtcbmA7XG5cbmNvbnN0IGdldFByaWNlRm9udFN0eWxlID0gKHZhcmlhbnQ6IFZhcmlhbnQpOiBTZXJpYWxpemVkU3R5bGVzID0+IHtcbiAgc3dpdGNoICh2YXJpYW50KSB7XG4gICAgY2FzZSAnc20nOlxuICAgICAgcmV0dXJuIEZPTlRfU1RZTEUuY2FwdGlvbjE7XG4gICAgY2FzZSAnbWQnOlxuICAgICAgcmV0dXJuIEZPTlRfU1RZTEUuc3ViVGl0bGUyO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gRk9OVF9TVFlMRS50aXRsZTM7XG4gIH1cbn07XG5cbmNvbnN0IFJhdGUgPSBzdHlsZWQuc3Bhbjx7IHZhcmlhbnQ6IFZhcmlhbnQsIGRpc2FibGVkPzogYm9vbGVhbiB9PmBcbiAgJHsoeyB2YXJpYW50IH0pID0+IGdldFByaWNlRm9udFN0eWxlKHZhcmlhbnQpfTtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIG1hcmdpbi1yaWdodDogMnB4O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgJHsoeyBkaXNhYmxlZCB9KSA9PiBkaXNhYmxlZCAmJiBjc3NgXG4gICAgb3BhY2l0eTogMC4yNjtcbiAgYH1cbmA7XG5cbmNvbnN0IEFtb3VudCA9IHN0eWxlZC5zcGFuPHsgdmFyaWFudDogVmFyaWFudCwgZGlzYWJsZWQ/OiBib29sZWFuIH0+YFxuICAkeyh7IHZhcmlhbnQgfSkgPT4gZ2V0UHJpY2VGb250U3R5bGUodmFyaWFudCl9O1xuICBmb250LXdlaWdodDogNzAwO1xuICBjb2xvcjogIzJGMzQzODtcbiAgJHsoeyBkaXNhYmxlZCB9KSA9PiBkaXNhYmxlZCAmJiBjc3NgXG4gICAgb3BhY2l0eTogMC4xNDtcbiAgYH1cbmA7XG5cbmNvbnN0IFBsYWNlaG9sZGVyID0gc3R5bGVkKFBsYWNlaG9sZGVyQW5pbWF0aW9uKWBcbiAgZm9udC1zaXplOiAxN3B4O1xuICBsaW5lLWhlaWdodDogMjNweDtcbiAgJjpiZWZvcmUge1xuICAgIGNvbnRlbnQ6ICdcXFxcMDBhMCc7XG4gIH1cbmA7XG5cbmNvbnN0IEVzcG9ydHNUb2tlbiA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICBtYXJnaW4tbGVmdDogMnB4O1xuYDtcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATS_TYPES = {
  review(stats) {
    return jsxs(Fragment$1, {
      children: [jsx(Icon$1, {
        name: "star",
        className: "icon",
        size: 12
      }), jsx("strong", {
        className: "avg",
        children: stats.reviewAvg != null ? Math.round(stats.reviewAvg * 10) / 10 : 0
      }), jsx("span", {
        className: "count",
        children: `리뷰 ${formatComma(stats.reviewCount || 0)}`
      })]
    });
  },
  scrap(stats) {
    return `스크랩 ${formatComma(stats.scrapCount || 0)}`;
  }
};
function getStatsType({
  stats,
  isMdPick,
  hideReview
}) {
  if (stats.reviewCount != null && stats.reviewCount >= 1 && !hideReview) {
    return 'review';
  }
  if (stats.scrapCount != null && stats.scrapCount >= 1 && !isMdPick) {
    return 'scrap';
  }
  return null;
}
function Stats(props) {
  const {
    stats,
    isMdPick,
    hideReview,
    hideStats
  } = props;
  const {
    type = getStatsType({
      stats,
      isMdPick,
      hideReview
    })
  } = props;
  if (type == null || hideStats) {
    return null;
  }
  return jsx(Container$w, {
    className: type,
    children: STATS_TYPES[type](stats)
  });
}
function StatsPlaceholder(props) {
  const {
    className
  } = props;
  return jsx(Placeholder, {
    className: className
  });
}
const Container$w = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eib94ex1"
} : {
  target: "eib94ex1",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "tk8sp3",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px;&.review{>.icon{color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px;}>.avg{margin-right:4px;color:#2F3438;}>.count{font-size:12px;line-height:16px;font-weight:normal;color:#828C94;}}"
} : {
  name: "tk8sp3",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px;&.review{>.icon{color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px;}>.avg{margin-right:4px;color:#2F3438;}>.count{font-size:12px;line-height:16px;font-weight:normal;color:#828C94;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$_
});
const Placeholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eib94ex0"
} : {
  target: "eib94ex0",
  label: "Placeholder"
})(FONT_STYLE.caption1, ";&:before{content:'\\00a0';}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var OhouseDeliveryIcon = "data:image/png;base64,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";

var ThirdPartyApplianceIcon = "data:image/png;base64,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";

var ThirdPartyFurnitureIcon = "data:image/png;base64,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";

var DepartureTodayIcon = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$Z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function shouldShowDeliveryBadge(product) {
  const {
    deliveryServiceCode,
    isDepartureToday
  } = product;
  const showBadge = [DELIVERY_SERVICE_CODE.OHOUSE, DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE, DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE].some(code => code === deliveryServiceCode ?? DELIVERY_SERVICE_CODE.NONE);
  return Boolean(showBadge || isDepartureToday);
}
function DeliveryBadge({
  deliveryServiceCode = DELIVERY_SERVICE_CODE.NONE,
  isDepartureToday
}) {
  return jsxs(Container$v, {
    children: [deliveryServiceCode === DELIVERY_SERVICE_CODE.OHOUSE && jsx("img", {
      src: OhouseDeliveryIcon,
      className: "icon",
      alt: "\uC624\uB298\uC758\uC9D1\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE && jsx("img", {
      src: ThirdPartyApplianceIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uC804\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE && jsx("img", {
      src: ThirdPartyFurnitureIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uAD6C\uBC30\uC1A1\uBC43\uC9C0"
    }), isDepartureToday && jsx("img", {
      src: DepartureTodayIcon,
      className: "icon",
      alt: "\uC624\uB298\uCD9C\uBC1C\uBC43\uC9C0"
    })]
  });
}
const Container$v = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l7cet60"
} : {
  target: "e1l7cet60",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1vaw5w5",
  styles: "display:flex;margin-top:4px;>.icon{width:auto;height:15px;}"
} : {
  name: "1vaw5w5",
  styles: "display:flex;margin-top:4px;>.icon{width:auto;height:15px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
});

function DeliveryStartAt({
  deliveryStartAt
}) {
  const {
    template
  } = deliveryStartAt;
  const {
    text,
    values
  } = template;
  const startAt = text.replace('%s', values[0] ?? '');
  return jsx(Text$1, {
    children: startAt
  });
}
const Text$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "enkhhyt0"
} : {
  target: "enkhhyt0",
  label: "Text"
})("display:inline-block;margin-top:4px;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.primary4.basic, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRlbGl2ZXJ5U3RhcnRBdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0J3QiIsImZpbGUiOiJEZWxpdmVyeVN0YXJ0QXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUmVhY3RFbGVtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgRk9OVF9TVFlMRSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgRGVsaXZlcnlTdGFydEF0VHlwZSB9IGZyb20gJ0AvY29tbWVyY2UvdHlwZXMnO1xuXG5pbnRlcmZhY2UgRGVsaXZlcnlTdGFydEF0UHJvcHMge1xuICBkZWxpdmVyeVN0YXJ0QXQ6IERlbGl2ZXJ5U3RhcnRBdFR5cGU7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBEZWxpdmVyeVN0YXJ0QXQoe1xuICBkZWxpdmVyeVN0YXJ0QXQsXG59OiBEZWxpdmVyeVN0YXJ0QXRQcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHsgdGVtcGxhdGUgfSA9IGRlbGl2ZXJ5U3RhcnRBdDtcbiAgY29uc3QgeyB0ZXh0LCB2YWx1ZXMgfSA9IHRlbXBsYXRlO1xuICBjb25zdCBzdGFydEF0ID0gdGV4dC5yZXBsYWNlKCclcycsIHZhbHVlc1swXSA/PyAnJyk7XG5cbiAgcmV0dXJuIChcbiAgICA8VGV4dD5cbiAgICAgIHsgc3RhcnRBdCB9XG4gICAgPC9UZXh0PlxuICApO1xufVxuXG5jb25zdCBUZXh0ID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWFyZ2luLXRvcDogNHB4O1xuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnk0LmJhc2ljfTtcbmA7XG4iXX0= */"));

var _rect, _path$5;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgProductBadgeCheapestPrice = function SvgProductBadgeCheapestPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#F77",
    rx: 4
  })), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.83 7.93v-.97h-4.9v-.555h5.228v-.991H6.655v4.063h6.59v-.992H7.928V7.93zm-6.295 3.747v1.002h5.326v2.037h1.274v-3.04zm7.733-.588v-1.024H5.5v1.024zm9.642-1.307V8.725h-1.405V5H21.24v9.705h1.264V9.782h1.405zm-3.954-3.79h-4.53v1.056h3.147c-.174 1.938-1.623 3.975-3.736 4.945l.773.958c2.974-1.612 4.259-4.03 4.346-6.96z"
  })));
};

var _g$3;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgProductBadgeFreeDelivery = function SvgProductBadgeFreeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    d: "M12.73 5.38v3.96h-6.6V5.38zm-2.68 9.43H8.76v-3.25H5v-1.03h8.86v1.03h-3.81zm1.4-6.49V6.41H7.43v1.91h4.04zm11.08 2.7h-1.42v1.54h2.26v1.02h-8.86v-1.02h2.24v-1.53h-1.1V7.78h5.32V6.65H15.6V5.63h6.66V8.8h-5.33v1.18h5.61v1.04zm-4.53 0v1.54h1.87v-1.53H18zm14.37 3.78h-1.23V9.86h-.8v4.49h-1.2V5.18h1.2v3.66h.8V5h1.23zm-4.2-2.54h-3.9V6.01h1.27v2.26h1.36V6h1.28v6.26zm-1.27-1.01v-2h-1.36v2zm14.49 1.71c0 1.13-1.25 1.82-3.41 1.82s-3.42-.7-3.42-1.82 1.25-1.82 3.4-1.82c2.18 0 3.43.7 3.43 1.82m-3.41-6.05c-.5 1.13-2.1 1.9-3.51 2.1l-.54-1c1.64-.17 3.39-1.06 3.39-2.54V5.2h1.33v.28c0 1.48 1.99 2.47 3.4 2.53l-.55 1.01c-1.31-.18-3.03-.97-3.52-2.1zm4.42 3.78h-8.86V9.66h3.79V8.4h1.29v1.26h3.78zm-2.33 2.27c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8c0 .51.81.8 2.08.8s2.1-.29 2.1-.8"
  }))));
};

var _g$2;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgProductBadgeNonSelling = function SvgProductBadgeNonSelling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 20
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "#000",
    opacity: 0.07,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M12.66 14.8h-1.3V5h1.3zm-4.3-3.52V6.93H6.29v4.35h2.06zm1.3-5.38v6.4H5V5.9h4.65zm12.51 8.78H15.7v-3.94h1.29v.98h3.9v-.99h1.3v3.95zm-1.29-1.02v-.95h-3.9v.95zm1.28-3.43h-1.28V5h1.28v5.22zm-7.78-2.47c0-1.34 1.11-2.34 2.6-2.34 1.5 0 2.6.98 2.6 2.34 0 1.39-1.1 2.25-2.6 2.25-1.49 0-2.6-.86-2.6-2.25m1.3-.01c0 .76.57 1.2 1.3 1.2.71 0 1.3-.44 1.3-1.2 0-.81-.56-1.26-1.3-1.26s-1.3.48-1.3 1.26m16 6.93h-6.5v-3.62h6.5zm-7.76-8V5.63h5.17v1.05h-1.88a3.05 3.05 0 0 0 2.18 2.69l-.7 1a4.2 4.2 0 0 1-2.13-1.92 3.92 3.92 0 0 1-2.28 2.22l-.76-1.02c1.37-.5 2.3-1.54 2.37-2.97zm7.77 3.9h-1.3V8.4h-1.44V7.36h1.45V5h1.29v5.59zm-1.3 3.1v-1.63h-3.94v1.63h3.95z"
  }))));
};

var _g$1;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgProductBadgeDiscontinued = function SvgProductBadgeDiscontinued(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.38 8.8h-1.4v3.34h-1.3V5.07h1.3v2.67h1.4zm-1.16 5.78H5.7v-3.12H7v2.09h5.22zm-6.3-5.11c1.43 0 2.83-.08 3.84-.29.05.33.11.66.18.98-.92.22-2.53.34-4.33.34h-.96V5.87h4.37v1.01h-3.1zm15.77 3.57c0 1.14-1.25 1.83-3.41 1.83s-3.42-.7-3.42-1.83c0-1.1 1.25-1.8 3.4-1.8 2.18 0 3.43.7 3.43 1.8m.6-4.91-.56 1c-1.37-.11-2.9-.87-3.45-1.85-.49 1-1.92 1.75-3.47 1.87l-.53-1c1.49-.08 2.83-.74 3.22-1.7h-2.76v-1h7.1v1h-2.76c.43.97 1.94 1.63 3.2 1.68zm.41 2.67h-8.86V9.76h3.77V8.54h1.28v1.24h3.81v1.03zm-2.33 2.25c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8.81.8 2.08.8 2.1-.3 2.1-.8"
  }))));
};

var _g;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgProductBadgeOverseasPurchase = function SvgProductBadgeOverseasPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.349 14.801h-1.221V9.994h-.814v4.356h-1.199V5.176h1.199V8.96h.814V5h1.221zm-3.85-4.037c0 1.232-.869 2.035-2.145 2.035-1.265 0-2.145-.869-2.145-2.035 0-1.243.891-2.035 2.145-2.035 1.276 0 2.145.803 2.145 2.035M5 8.366V7.343h4.675v1.023zm3.344 2.398c0-.605-.418-1.023-.99-1.023-.561 0-.979.418-.979 1.023 0 .616.418 1.023.979 1.023.572 0 .99-.429.99-1.023M6.067 6.782V5.759h2.64v1.023zm14.861 5.797c-1.694.209-4.29.341-6.127.341a34 34 0 0 1-.187-1.034c.825 0 1.65 0 2.442-.022v-1.562c-1.177-.209-2.002-1.045-2.002-2.233 0-1.364 1.122-2.387 2.629-2.387s2.662 1.012 2.662 2.387c0 1.166-.825 1.991-1.991 2.222v1.518c.913-.055 1.76-.121 2.486-.22zM22.666 5v9.801h-1.298V5zm-3.597 3.069c0-.825-.638-1.309-1.386-1.309-.737 0-1.364.517-1.364 1.309 0 .759.638 1.221 1.364 1.221s1.386-.462 1.386-1.221m5.412-1.353V5.693h5.17v1.023H27.77c.099 1.408 1.1 2.343 2.2 2.695l-.715 1.012c-.748-.286-1.705-1.045-2.134-1.947-.275.957-1.32 1.87-2.277 2.2l-.759-1.001c1.386-.495 2.31-1.529 2.365-2.959zm1.034 4.477h6.644v3.619h-1.298v-2.607h-5.346zm6.633-.484h-1.287V5.011h1.287zm9.13-5.181c0 1.584-.099 3.058-.319 4.18h1.452v1.023h-3.806v4.07h-1.287v-4.07h-3.762V9.708h6.182c.176-.847.264-1.947.264-3.146h-5.357V5.528z"
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$Y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function BadgeList(props) {
  const {
    isDiscontinued,
    isSoldOut,
    isSelling,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isGlobal,
    badgeMaxCount
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const badgeList = useMemo(() => [isOverseasPurchase && jsx(SvgProductBadgeOverseasPurchase, {
    className: "icon",
    "aria-label": "\uD574\uC678\uC9C1\uAD6C"
  }, 0), isFreeDelivery && jsx(SvgProductBadgeFreeDelivery, {
    className: "icon",
    "aria-label": "\uBB34\uB8CC\uBC30\uC1A1"
  }, 1), isSpecialPrice && jsx(SvgProductBadgeCheapestPrice, {
    className: "icon",
    "aria-label": "\uD2B9\uAC00"
  }, 2)].filter(value => !!value), [isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  if (isDiscontinued || !isSelling && !isGlobal) {
    return jsxs(Container$u, {
      disabled: disabled,
      "data-testid": "badge-list-container",
      children: [!isSelling && !isGlobal && jsx(SvgProductBadgeNonSelling, {
        className: "icon",
        "aria-label": "\uBBF8\uC785\uC810"
      }), !(!isSelling && !isGlobal) && isDiscontinued && jsx(SvgProductBadgeDiscontinued, {
        className: "icon",
        "aria-label": "\uB2E8\uC885"
      })]
    });
  }
  return jsx(Container$u, {
    disabled: disabled,
    "data-testid": "badge-list-container",
    children: badgeMaxCount != null ? badgeList.slice(0, badgeMaxCount) : badgeList
  });
}
var _ref$s = process.env.NODE_ENV === "production" ? {
  name: "1s0bkzx",
  styles: "opacity:0.32"
} : {
  name: "15iych5-Container",
  styles: "opacity:0.32;label:Container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Y
};
const Container$u = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e132f8k40"
} : {
  target: "e132f8k40",
  label: "Container"
})("display:flex;flex-wrap:wrap;gap:4px;margin-top:8px;", ({
  disabled
}) => disabled && _ref$s, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$X() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function IconWithTextBadge({
  title,
  image
}) {
  return jsxs(Container$t, {
    children: [jsx(Icon, {
      src: image,
      alt: "icon-with-text-badge"
    }), jsx(Title$b, {
      children: title
    })]
  });
}
const Container$t = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etn6hd12"
} : {
  target: "etn6hd12",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1b1ga6k",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;margin-top:6px;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF"
} : {
  name: "1b1ga6k",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;margin-top:6px;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb25XaXRoVGV4dEJhZGdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjRCIiwiZmlsZSI6Ikljb25XaXRoVGV4dEJhZGdlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFJlc2l6ZUltYWdlIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5leHBvcnQgaW50ZXJmYWNlIEljb25XaXRoVGV4dEJhZGdlUHJvcHMge1xuICB0aXRsZTogc3RyaW5nO1xuICBpbWFnZTogc3RyaW5nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSWNvbldpdGhUZXh0QmFkZ2UoeyB0aXRsZSwgaW1hZ2UgfTogSWNvbldpdGhUZXh0QmFkZ2VQcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxJY29uIHNyYz17aW1hZ2V9IGFsdD1cImljb24td2l0aC10ZXh0LWJhZGdlXCIgLz5cbiAgICAgIDxUaXRsZT57IHRpdGxlIH08L1RpdGxlPlxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgbWFyZ2luLXRvcDogNnB4O1xuICBwYWRkaW5nOiAycHggNXB4O1xuICBmb250LXNpemU6IDEwcHg7XG4gIGxpbmUtaGVpZ2h0OiAxNHB4O1xuICBmb250LXdlaWdodDogNzAwO1xuICBsZXR0ZXItc3BhY2luZzogLTAuM3B4O1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGNvbG9yOiAjMkYzNDM4O1xuICBib3JkZXI6IDFweCBzb2xpZCAjRUFFREVGO1xuYDtcblxuY29uc3QgSWNvbiA9IHN0eWxlZChSZXNpemVJbWFnZSlgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogMTFweDtcbiAgbWFyZ2luLXJpZ2h0OiA1cHg7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5zcGFuYFxuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
});
const Icon = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "etn6hd11"
} : {
  target: "etn6hd11",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px"
} : {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb25XaXRoVGV4dEJhZGdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQ2dDIiwiZmlsZSI6Ikljb25XaXRoVGV4dEJhZGdlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFJlc2l6ZUltYWdlIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5leHBvcnQgaW50ZXJmYWNlIEljb25XaXRoVGV4dEJhZGdlUHJvcHMge1xuICB0aXRsZTogc3RyaW5nO1xuICBpbWFnZTogc3RyaW5nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSWNvbldpdGhUZXh0QmFkZ2UoeyB0aXRsZSwgaW1hZ2UgfTogSWNvbldpdGhUZXh0QmFkZ2VQcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxJY29uIHNyYz17aW1hZ2V9IGFsdD1cImljb24td2l0aC10ZXh0LWJhZGdlXCIgLz5cbiAgICAgIDxUaXRsZT57IHRpdGxlIH08L1RpdGxlPlxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgbWFyZ2luLXRvcDogNnB4O1xuICBwYWRkaW5nOiAycHggNXB4O1xuICBmb250LXNpemU6IDEwcHg7XG4gIGxpbmUtaGVpZ2h0OiAxNHB4O1xuICBmb250LXdlaWdodDogNzAwO1xuICBsZXR0ZXItc3BhY2luZzogLTAuM3B4O1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGNvbG9yOiAjMkYzNDM4O1xuICBib3JkZXI6IDFweCBzb2xpZCAjRUFFREVGO1xuYDtcblxuY29uc3QgSWNvbiA9IHN0eWxlZChSZXNpemVJbWFnZSlgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogMTFweDtcbiAgbWFyZ2luLXJpZ2h0OiA1cHg7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5zcGFuYFxuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
});
const Title$b = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "etn6hd10"
} : {
  target: "etn6hd10",
  label: "Title"
})(process.env.NODE_ENV === "production" ? {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
} : {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb25XaXRoVGV4dEJhZGdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3Q3lCIiwiZmlsZSI6Ikljb25XaXRoVGV4dEJhZGdlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFJlc2l6ZUltYWdlIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5leHBvcnQgaW50ZXJmYWNlIEljb25XaXRoVGV4dEJhZGdlUHJvcHMge1xuICB0aXRsZTogc3RyaW5nO1xuICBpbWFnZTogc3RyaW5nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSWNvbldpdGhUZXh0QmFkZ2UoeyB0aXRsZSwgaW1hZ2UgfTogSWNvbldpdGhUZXh0QmFkZ2VQcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxJY29uIHNyYz17aW1hZ2V9IGFsdD1cImljb24td2l0aC10ZXh0LWJhZGdlXCIgLz5cbiAgICAgIDxUaXRsZT57IHRpdGxlIH08L1RpdGxlPlxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgbWFyZ2luLXRvcDogNnB4O1xuICBwYWRkaW5nOiAycHggNXB4O1xuICBmb250LXNpemU6IDEwcHg7XG4gIGxpbmUtaGVpZ2h0OiAxNHB4O1xuICBmb250LXdlaWdodDogNzAwO1xuICBsZXR0ZXItc3BhY2luZzogLTAuM3B4O1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIGNvbG9yOiAjMkYzNDM4O1xuICBib3JkZXI6IDFweCBzb2xpZCAjRUFFREVGO1xuYDtcblxuY29uc3QgSWNvbiA9IHN0eWxlZChSZXNpemVJbWFnZSlgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogMTFweDtcbiAgbWFyZ2luLXJpZ2h0OiA1cHg7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5zcGFuYFxuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
});

function Badges({
  product,
  isMdPick,
  badgeMaxCount
}) {
  const {
    isSelling,
    isDiscontinued,
    deliveryServiceCode,
    isDepartureToday,
    deliveryStartAt,
    isSoldOut,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    currency,
    couponBadge,
    benefitBadges
  } = product;
  const showBadge = isSelling && !isDiscontinued;
  return jsxs(Fragment$1, {
    children: [showBadge && shouldShowDeliveryBadge(product) && jsx(DeliveryBadge, {
      deliveryServiceCode: deliveryServiceCode,
      isDepartureToday: isDepartureToday
    }), showBadge && deliveryStartAt && jsx(DeliveryStartAt, {
      deliveryStartAt: deliveryStartAt
    }), jsx(BadgeList, {
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      isSelling: isSelling,
      isOverseasPurchase: isOverseasPurchase,
      isFreeDelivery: isFreeDelivery,
      isSpecialPrice: isSpecialPrice,
      isGlobal: !!currency,
      badgeMaxCount: badgeMaxCount != null && isMdPick ? 2 : undefined
    }), showBadge && couponBadge != null && jsx(IconWithTextBadge, {
      title: couponBadge.title,
      image: couponBadge.image
    }), showBadge && benefitBadges?.map((badge, index) => jsx(IconWithTextBadge, {
      title: badge.title,
      image: badge.image
    }, `benefit-badge-${index + 1}`))]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$W() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Info$1({
  product,
  badgeMaxCount,
  isMdPick,
  flex,
  variant = 'lg',
  localeData = {},
  hideBadge,
  hideReview,
  hideStats,
  className,
  bottomArea
}) {
  const {
    name,
    isSelling,
    isDiscontinued,
    brand,
    originalPrice,
    sellingPrice,
    isSoldOut,
    type,
    reviewAvg,
    reviewCount,
    scrapCount,
    currency
  } = product;
  const isGlobal = !!currency;
  const showPrice = isGlobal || isSelling && !isDiscontinued;
  return jsxs(Container$s, {
    flex: flex,
    className: classNames('product-info', className),
    children: [jsxs(Header$6, {
      children: [jsx(Brand$1, {
        className: "product-brand",
        children: brand.name
      }), jsx(Name$1, {
        className: "product-name",
        variant: variant,
        children: name
      })]
    }), showPrice && jsx(Price, {
      originalPrice: originalPrice,
      sellingPrice: sellingPrice,
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      variant: variant,
      currency: currency,
      renderSuffix: () => jsx("span", {
        children: type === 'Deal' && ' 외'
      }),
      priceToken: localeData?.priceToken
    }), !isGlobal && jsx(Stats, {
      stats: {
        reviewAvg,
        reviewCount,
        scrapCount
      },
      isMdPick: isMdPick,
      hideReview: hideReview,
      hideStats: hideStats
    }), !hideBadge && jsx(Badges, {
      product: product,
      isMdPick: isMdPick,
      badgeMaxCount: badgeMaxCount
    }), bottomArea && bottomArea]
  });
}
function InfoPlaceholder() {
  return jsxs(Container$s, {
    children: [jsxs(Header$6, {
      children: [jsx(BrandPlaceholder, {}), jsx(NamePlaceholder, {})]
    }), jsx(StyledPricePlaceholder, {}), jsx(StyledStatsPlaceholer, {})]
  });
}
var _ref2$8 = process.env.NODE_ENV === "production" ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : {
  name: "oyt7z3-Container",
  styles: "margin-left:12px;label:Container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
};
const Container$s = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc47"
} : {
  target: "eo39oc47",
  label: "Container"
})("width:100%;", ({
  flex
}) => flex && _ref2$8, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Header$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc46"
} : {
  target: "eo39oc46",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : {
  name: "1r0yqr6",
  styles: "margin-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
});
const Brand$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc45"
} : {
  target: "eo39oc45",
  label: "Brand"
})(process.env.NODE_ENV === "production" ? {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94"
} : {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
});
const nameStyle$1 = process.env.NODE_ENV === "production" ? {
  name: "wwgkbi",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word"
} : {
  name: "kdxkly-nameStyle",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word;label:nameStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
};
var _ref$r = process.env.NODE_ENV === "production" ? {
  name: "xolxwr",
  styles: "font-size:12px;line-height:16px"
} : {
  name: "1qwpow5-Name",
  styles: "font-size:12px;line-height:16px;label:Name;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm8udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtLa0UiLCJmaWxlIjoiSW5mby50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY2xhc3NuYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEZPTlRfU1RZTEUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IFByb2R1Y3QsIFZhcmlhbnQgfSBmcm9tICdAL2NvbW1lcmNlL3R5cGVzJztcbmltcG9ydCBQbGFjZWhvbGRlckFuaW1hdGlvbiBmcm9tICdAL2NvbXBvbmVudHMvUGxhY2Vob2xkZXJBbmltYXRpb24nO1xuXG5pbXBvcnQgeyBQcmljZSwgUHJpY2VQbGFjZWhvbGRlciB9IGZyb20gJy4vUHJpY2UnO1xuaW1wb3J0IHsgU3RhdHMsIFN0YXRzUGxhY2Vob2xkZXIgfSBmcm9tICcuL1N0YXRzJztcbmltcG9ydCB7IEJhZGdlcyB9IGZyb20gJy4vQmFkZ2VzJztcblxuZXhwb3J0IGludGVyZmFjZSBMb2NhbGVEYXRhIHtcbiAgcHJpY2VUb2tlbj86IHN0cmluZztcbn1cblxuZXhwb3J0IGludGVyZmFjZSBJbmZvUHJvcHMge1xuICBwcm9kdWN0OiBQcm9kdWN0O1xuICBiYWRnZU1heENvdW50PzogbnVtYmVyO1xuICBpc01kUGljaz86IGJvb2xlYW47XG4gIGZsZXg/OiBib29sZWFuOyAvLyDrqqjrsJTsnbwg6rCA66Gc7ZiVIOyDge2SiOy5tOuTnOyXkOyEnCDsgqzsmqntlaAg6rK97JqwIO2VtOuLuSBwcm9wcyDstpTqsIAg7ZWE7JqUXG4gIHZhcmlhbnQ/OiBWYXJpYW50O1xuICBsb2NhbGVEYXRhPzogTG9jYWxlRGF0YTtcbiAgaGlkZUJhZGdlPzogYm9vbGVhbjtcbiAgaGlkZVJldmlldz86IGJvb2xlYW47XG4gIGhpZGVTdGF0cz86IGJvb2xlYW47XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgYm90dG9tQXJlYT86IFJlYWN0RWxlbWVudDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIEluZm8oe1xuICBwcm9kdWN0LFxuICBiYWRnZU1heENvdW50LFxuICBpc01kUGljayxcbiAgZmxleCxcbiAgdmFyaWFudCA9ICdsZycsXG4gIGxvY2FsZURhdGEgPSB7fSxcbiAgaGlkZUJhZGdlLFxuICBoaWRlUmV2aWV3LFxuICBoaWRlU3RhdHMsXG4gIGNsYXNzTmFtZSxcbiAgYm90dG9tQXJlYSxcbn06IEluZm9Qcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHtcbiAgICBuYW1lLFxuICAgIGlzU2VsbGluZyxcbiAgICBpc0Rpc2NvbnRpbnVlZCxcbiAgICBicmFuZCxcbiAgICBvcmlnaW5hbFByaWNlLFxuICAgIHNlbGxpbmdQcmljZSxcbiAgICBpc1NvbGRPdXQsXG4gICAgdHlwZSxcbiAgICByZXZpZXdBdmcsXG4gICAgcmV2aWV3Q291bnQsXG4gICAgc2NyYXBDb3VudCxcbiAgICBjdXJyZW5jeSxcbiAgfSA9IHByb2R1Y3Q7XG4gIGNvbnN0IGlzR2xvYmFsID0gISFjdXJyZW5jeTtcbiAgY29uc3Qgc2hvd1ByaWNlID0gaXNHbG9iYWwgfHwgKGlzU2VsbGluZyAmJiAhaXNEaXNjb250aW51ZWQpO1xuXG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBmbGV4PXtmbGV4fSBjbGFzc05hbWU9e2NsYXNzbmFtZXMoJ3Byb2R1Y3QtaW5mbycsIGNsYXNzTmFtZSl9PlxuICAgICAgPEhlYWRlcj5cbiAgICAgICAgPEJyYW5kIGNsYXNzTmFtZT1cInByb2R1Y3QtYnJhbmRcIj5cbiAgICAgICAgICB7IGJyYW5kLm5hbWUgfVxuICAgICAgICA8L0JyYW5kPlxuICAgICAgICA8TmFtZSBjbGFzc05hbWU9XCJwcm9kdWN0LW5hbWVcIiB2YXJpYW50PXt2YXJpYW50fT5cbiAgICAgICAgICB7IG5hbWUgfVxuICAgICAgICA8L05hbWU+XG4gICAgICA8L0hlYWRlcj5cbiAgICAgIHsgc2hvd1ByaWNlICYmIChcbiAgICAgICAgPFByaWNlXG4gICAgICAgICAgb3JpZ2luYWxQcmljZT17b3JpZ2luYWxQcmljZX1cbiAgICAgICAgICBzZWxsaW5nUHJpY2U9e3NlbGxpbmdQcmljZX1cbiAgICAgICAgICBpc0Rpc2NvbnRpbnVlZD17aXNEaXNjb250aW51ZWR9XG4gICAgICAgICAgaXNTb2xkT3V0PXtpc1NvbGRPdXR9XG4gICAgICAgICAgdmFyaWFudD17dmFyaWFudH1cbiAgICAgICAgICBjdXJyZW5jeT17Y3VycmVuY3l9XG4gICAgICAgICAgcmVuZGVyU3VmZml4PXsoKSA9PiAoXG4gICAgICAgICAgICA8c3Bhbj5cbiAgICAgICAgICAgICAgeyB0eXBlID09PSAnRGVhbCcgJiYgJyDsmbgnIH1cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICApfVxuICAgICAgICAgIHByaWNlVG9rZW49e2xvY2FsZURhdGE/LnByaWNlVG9rZW59XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICAgIHsgIWlzR2xvYmFsICYmIChcbiAgICAgICAgPFN0YXRzXG4gICAgICAgICAgc3RhdHM9e3tcbiAgICAgICAgICAgIHJldmlld0F2ZyxcbiAgICAgICAgICAgIHJldmlld0NvdW50LFxuICAgICAgICAgICAgc2NyYXBDb3VudCxcbiAgICAgICAgICB9fVxuICAgICAgICAgIGlzTWRQaWNrPXtpc01kUGlja31cbiAgICAgICAgICBoaWRlUmV2aWV3PXtoaWRlUmV2aWV3fVxuICAgICAgICAgIGhpZGVTdGF0cz17aGlkZVN0YXRzfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICB7ICFoaWRlQmFkZ2UgJiYgKFxuICAgICAgICA8QmFkZ2VzXG4gICAgICAgICAgcHJvZHVjdD17cHJvZHVjdH1cbiAgICAgICAgICBpc01kUGljaz17aXNNZFBpY2t9XG4gICAgICAgICAgYmFkZ2VNYXhDb3VudD17YmFkZ2VNYXhDb3VudH1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgICAgeyBib3R0b21BcmVhICYmIGJvdHRvbUFyZWEgfVxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSW5mb1BsYWNlaG9sZGVyKCk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxIZWFkZXI+XG4gICAgICAgIDxCcmFuZFBsYWNlaG9sZGVyIC8+XG4gICAgICAgIDxOYW1lUGxhY2Vob2xkZXIgLz5cbiAgICAgIDwvSGVhZGVyPlxuICAgICAgPFN0eWxlZFByaWNlUGxhY2Vob2xkZXIgLz5cbiAgICAgIDxTdHlsZWRTdGF0c1BsYWNlaG9sZXIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGZsZXg/OiBib29sZWFuIH0+YFxuICB3aWR0aDogMTAwJTtcbiAgJHsoeyBmbGV4IH0pID0+IGZsZXggJiYgY3NzYFxuICAgIG1hcmdpbi1sZWZ0OiAxMnB4O1xuICBgfVxuYDtcblxuY29uc3QgSGVhZGVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLXRvcDogMTBweDtcbmA7XG5cbmNvbnN0IEJyYW5kID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxMnB4O1xuICBsaW5lLWhlaWdodDogMTZweDtcbiAgZGlzcGxheTogYmxvY2s7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbiAgY29sb3I6ICM4MjhDOTQ7XG5gO1xuXG5jb25zdCBuYW1lU3R5bGUgPSBjc3NgXG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXgtaGVpZ2h0OiAzNnB4O1xuICBtYXJnaW4tdG9wOiA0cHg7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbiAgdHJhbnNpdGlvbjogLjFzIG9wYWNpdHk7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgLXdlYmtpdC1saW5lLWNsYW1wOiAyOyAvKiDrnbzsnbjsiJggKi9cbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgd29yZC13cmFwOiBicmVhay13b3JkO1xuYDtcblxuY29uc3QgTmFtZSA9IHN0eWxlZC5zcGFuPHsgdmFyaWFudDogVmFyaWFudCB9PmBcbiAgJHtuYW1lU3R5bGV9XG4gIGNvbG9yOiAjMkYzNDM4O1xuICAkeyh7IHZhcmlhbnQgfSkgPT4gKHZhcmlhbnQgPT09ICdzbScgfHwgdmFyaWFudCA9PT0gJ21kJykgJiYgY3NzYFxuICAgIGZvbnQtc2l6ZTogMTJweDtcbiAgICBsaW5lLWhlaWdodDogMTZweDtcbiAgYH1cbmA7XG5cbmNvbnN0IEJyYW5kUGxhY2Vob2xkZXIgPSBzdHlsZWQoUGxhY2Vob2xkZXJBbmltYXRpb24pYFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gICY6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnXFxcXDAwYTAnO1xuICB9XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG4gIHdpZHRoOiA4MHB4O1xuYDtcblxuY29uc3QgTmFtZVBsYWNlaG9sZGVyID0gc3R5bGVkKFBsYWNlaG9sZGVyQW5pbWF0aW9uKWBcbiAgJHtuYW1lU3R5bGV9XG4gICY6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnXFxcXDAwYTAnO1xuICB9XG5gO1xuXG5jb25zdCBTdHlsZWRQcmljZVBsYWNlaG9sZGVyID0gc3R5bGVkKFByaWNlUGxhY2Vob2xkZXIpYFxuICBtYXJnaW4tdG9wOiAzcHg7XG4gIGxpbmUtaGVpZ2h0OiAyMXB4O1xuICB3aWR0aDogMTIwcHg7XG5gO1xuXG5jb25zdCBTdHlsZWRTdGF0c1BsYWNlaG9sZXIgPSBzdHlsZWQoU3RhdHNQbGFjZWhvbGRlcilgXG4gIG1hcmdpbi10b3A6IDNweDtcbiAgd2lkdGg6IDEwMHB4O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
};
const Name$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eo39oc44"
} : {
  target: "eo39oc44",
  label: "Name"
})(nameStyle$1, " color:#2F3438;", ({
  variant
}) => (variant === 'sm' || variant === 'md') && _ref$r, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const BrandPlaceholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eo39oc43"
} : {
  target: "eo39oc43",
  label: "BrandPlaceholder"
})(FONT_STYLE.caption1, " &:before{content:'\\00a0';}display:block;word-break:break-all;width:80px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm8udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdLcUQiLCJmaWxlIjoiSW5mby50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY2xhc3NuYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEZPTlRfU1RZTEUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IFByb2R1Y3QsIFZhcmlhbnQgfSBmcm9tICdAL2NvbW1lcmNlL3R5cGVzJztcbmltcG9ydCBQbGFjZWhvbGRlckFuaW1hdGlvbiBmcm9tICdAL2NvbXBvbmVudHMvUGxhY2Vob2xkZXJBbmltYXRpb24nO1xuXG5pbXBvcnQgeyBQcmljZSwgUHJpY2VQbGFjZWhvbGRlciB9IGZyb20gJy4vUHJpY2UnO1xuaW1wb3J0IHsgU3RhdHMsIFN0YXRzUGxhY2Vob2xkZXIgfSBmcm9tICcuL1N0YXRzJztcbmltcG9ydCB7IEJhZGdlcyB9IGZyb20gJy4vQmFkZ2VzJztcblxuZXhwb3J0IGludGVyZmFjZSBMb2NhbGVEYXRhIHtcbiAgcHJpY2VUb2tlbj86IHN0cmluZztcbn1cblxuZXhwb3J0IGludGVyZmFjZSBJbmZvUHJvcHMge1xuICBwcm9kdWN0OiBQcm9kdWN0O1xuICBiYWRnZU1heENvdW50PzogbnVtYmVyO1xuICBpc01kUGljaz86IGJvb2xlYW47XG4gIGZsZXg/OiBib29sZWFuOyAvLyDrqqjrsJTsnbwg6rCA66Gc7ZiVIOyDge2SiOy5tOuTnOyXkOyEnCDsgqzsmqntlaAg6rK97JqwIO2VtOuLuSBwcm9wcyDstpTqsIAg7ZWE7JqUXG4gIHZhcmlhbnQ/OiBWYXJpYW50O1xuICBsb2NhbGVEYXRhPzogTG9jYWxlRGF0YTtcbiAgaGlkZUJhZGdlPzogYm9vbGVhbjtcbiAgaGlkZVJldmlldz86IGJvb2xlYW47XG4gIGhpZGVTdGF0cz86IGJvb2xlYW47XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgYm90dG9tQXJlYT86IFJlYWN0RWxlbWVudDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIEluZm8oe1xuICBwcm9kdWN0LFxuICBiYWRnZU1heENvdW50LFxuICBpc01kUGljayxcbiAgZmxleCxcbiAgdmFyaWFudCA9ICdsZycsXG4gIGxvY2FsZURhdGEgPSB7fSxcbiAgaGlkZUJhZGdlLFxuICBoaWRlUmV2aWV3LFxuICBoaWRlU3RhdHMsXG4gIGNsYXNzTmFtZSxcbiAgYm90dG9tQXJlYSxcbn06IEluZm9Qcm9wcyk6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHtcbiAgICBuYW1lLFxuICAgIGlzU2VsbGluZyxcbiAgICBpc0Rpc2NvbnRpbnVlZCxcbiAgICBicmFuZCxcbiAgICBvcmlnaW5hbFByaWNlLFxuICAgIHNlbGxpbmdQcmljZSxcbiAgICBpc1NvbGRPdXQsXG4gICAgdHlwZSxcbiAgICByZXZpZXdBdmcsXG4gICAgcmV2aWV3Q291bnQsXG4gICAgc2NyYXBDb3VudCxcbiAgICBjdXJyZW5jeSxcbiAgfSA9IHByb2R1Y3Q7XG4gIGNvbnN0IGlzR2xvYmFsID0gISFjdXJyZW5jeTtcbiAgY29uc3Qgc2hvd1ByaWNlID0gaXNHbG9iYWwgfHwgKGlzU2VsbGluZyAmJiAhaXNEaXNjb250aW51ZWQpO1xuXG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBmbGV4PXtmbGV4fSBjbGFzc05hbWU9e2NsYXNzbmFtZXMoJ3Byb2R1Y3QtaW5mbycsIGNsYXNzTmFtZSl9PlxuICAgICAgPEhlYWRlcj5cbiAgICAgICAgPEJyYW5kIGNsYXNzTmFtZT1cInByb2R1Y3QtYnJhbmRcIj5cbiAgICAgICAgICB7IGJyYW5kLm5hbWUgfVxuICAgICAgICA8L0JyYW5kPlxuICAgICAgICA8TmFtZSBjbGFzc05hbWU9XCJwcm9kdWN0LW5hbWVcIiB2YXJpYW50PXt2YXJpYW50fT5cbiAgICAgICAgICB7IG5hbWUgfVxuICAgICAgICA8L05hbWU+XG4gICAgICA8L0hlYWRlcj5cbiAgICAgIHsgc2hvd1ByaWNlICYmIChcbiAgICAgICAgPFByaWNlXG4gICAgICAgICAgb3JpZ2luYWxQcmljZT17b3JpZ2luYWxQcmljZX1cbiAgICAgICAgICBzZWxsaW5nUHJpY2U9e3NlbGxpbmdQcmljZX1cbiAgICAgICAgICBpc0Rpc2NvbnRpbnVlZD17aXNEaXNjb250aW51ZWR9XG4gICAgICAgICAgaXNTb2xkT3V0PXtpc1NvbGRPdXR9XG4gICAgICAgICAgdmFyaWFudD17dmFyaWFudH1cbiAgICAgICAgICBjdXJyZW5jeT17Y3VycmVuY3l9XG4gICAgICAgICAgcmVuZGVyU3VmZml4PXsoKSA9PiAoXG4gICAgICAgICAgICA8c3Bhbj5cbiAgICAgICAgICAgICAgeyB0eXBlID09PSAnRGVhbCcgJiYgJyDsmbgnIH1cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICApfVxuICAgICAgICAgIHByaWNlVG9rZW49e2xvY2FsZURhdGE/LnByaWNlVG9rZW59XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICAgIHsgIWlzR2xvYmFsICYmIChcbiAgICAgICAgPFN0YXRzXG4gICAgICAgICAgc3RhdHM9e3tcbiAgICAgICAgICAgIHJldmlld0F2ZyxcbiAgICAgICAgICAgIHJldmlld0NvdW50LFxuICAgICAgICAgICAgc2NyYXBDb3VudCxcbiAgICAgICAgICB9fVxuICAgICAgICAgIGlzTWRQaWNrPXtpc01kUGlja31cbiAgICAgICAgICBoaWRlUmV2aWV3PXtoaWRlUmV2aWV3fVxuICAgICAgICAgIGhpZGVTdGF0cz17aGlkZVN0YXRzfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICB7ICFoaWRlQmFkZ2UgJiYgKFxuICAgICAgICA8QmFkZ2VzXG4gICAgICAgICAgcHJvZHVjdD17cHJvZHVjdH1cbiAgICAgICAgICBpc01kUGljaz17aXNNZFBpY2t9XG4gICAgICAgICAgYmFkZ2VNYXhDb3VudD17YmFkZ2VNYXhDb3VudH1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgICAgeyBib3R0b21BcmVhICYmIGJvdHRvbUFyZWEgfVxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSW5mb1BsYWNlaG9sZGVyKCk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxIZWFkZXI+XG4gICAgICAgIDxCcmFuZFBsYWNlaG9sZGVyIC8+XG4gICAgICAgIDxOYW1lUGxhY2Vob2xkZXIgLz5cbiAgICAgIDwvSGVhZGVyPlxuICAgICAgPFN0eWxlZFByaWNlUGxhY2Vob2xkZXIgLz5cbiAgICAgIDxTdHlsZWRTdGF0c1BsYWNlaG9sZXIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGZsZXg/OiBib29sZWFuIH0+YFxuICB3aWR0aDogMTAwJTtcbiAgJHsoeyBmbGV4IH0pID0+IGZsZXggJiYgY3NzYFxuICAgIG1hcmdpbi1sZWZ0OiAxMnB4O1xuICBgfVxuYDtcblxuY29uc3QgSGVhZGVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLXRvcDogMTBweDtcbmA7XG5cbmNvbnN0IEJyYW5kID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxMnB4O1xuICBsaW5lLWhlaWdodDogMTZweDtcbiAgZGlzcGxheTogYmxvY2s7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbiAgY29sb3I6ICM4MjhDOTQ7XG5gO1xuXG5jb25zdCBuYW1lU3R5bGUgPSBjc3NgXG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbGluZS1oZWlnaHQ6IDE4cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXgtaGVpZ2h0OiAzNnB4O1xuICBtYXJnaW4tdG9wOiA0cHg7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbiAgdHJhbnNpdGlvbjogLjFzIG9wYWNpdHk7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgLXdlYmtpdC1saW5lLWNsYW1wOiAyOyAvKiDrnbzsnbjsiJggKi9cbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgd29yZC13cmFwOiBicmVhay13b3JkO1xuYDtcblxuY29uc3QgTmFtZSA9IHN0eWxlZC5zcGFuPHsgdmFyaWFudDogVmFyaWFudCB9PmBcbiAgJHtuYW1lU3R5bGV9XG4gIGNvbG9yOiAjMkYzNDM4O1xuICAkeyh7IHZhcmlhbnQgfSkgPT4gKHZhcmlhbnQgPT09ICdzbScgfHwgdmFyaWFudCA9PT0gJ21kJykgJiYgY3NzYFxuICAgIGZvbnQtc2l6ZTogMTJweDtcbiAgICBsaW5lLWhlaWdodDogMTZweDtcbiAgYH1cbmA7XG5cbmNvbnN0IEJyYW5kUGxhY2Vob2xkZXIgPSBzdHlsZWQoUGxhY2Vob2xkZXJBbmltYXRpb24pYFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gICY6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnXFxcXDAwYTAnO1xuICB9XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG4gIHdpZHRoOiA4MHB4O1xuYDtcblxuY29uc3QgTmFtZVBsYWNlaG9sZGVyID0gc3R5bGVkKFBsYWNlaG9sZGVyQW5pbWF0aW9uKWBcbiAgJHtuYW1lU3R5bGV9XG4gICY6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnXFxcXDAwYTAnO1xuICB9XG5gO1xuXG5jb25zdCBTdHlsZWRQcmljZVBsYWNlaG9sZGVyID0gc3R5bGVkKFByaWNlUGxhY2Vob2xkZXIpYFxuICBtYXJnaW4tdG9wOiAzcHg7XG4gIGxpbmUtaGVpZ2h0OiAyMXB4O1xuICB3aWR0aDogMTIwcHg7XG5gO1xuXG5jb25zdCBTdHlsZWRTdGF0c1BsYWNlaG9sZXIgPSBzdHlsZWQoU3RhdHNQbGFjZWhvbGRlcilgXG4gIG1hcmdpbi10b3A6IDNweDtcbiAgd2lkdGg6IDEwMHB4O1xuYDtcbiJdfQ== */"));
const NamePlaceholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eo39oc42"
} : {
  target: "eo39oc42",
  label: "NamePlaceholder"
})(nameStyle$1, " &:before{content:'\\00a0';}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledPricePlaceholder = /*#__PURE__*/_styled(PricePlaceholder, process.env.NODE_ENV === "production" ? {
  target: "eo39oc41"
} : {
  target: "eo39oc41",
  label: "StyledPricePlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px"
} : {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
});
const StyledStatsPlaceholer = /*#__PURE__*/_styled(StatsPlaceholder, process.env.NODE_ENV === "production" ? {
  target: "eo39oc40"
} : {
  target: "eo39oc40",
  label: "StyledStatsPlaceholer"
})(process.env.NODE_ENV === "production" ? {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px"
} : {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$V() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const badgeSizeLookup = {
  extraSmall: [29, 29],
  small: [29, 26],
  large: [23, 20]
};
const BASE_BADGE_SIZE = 100;
const SEGMENTS = 3;
const calculateColumn = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = Math.floor(position / SEGMENTS);
  return base * pos + (base - elementSize) / 2 * pos;
};
const calculateRow = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = position % SEGMENTS;
  return base * pos + (base - elementSize) / 2 * pos;
};
function ThumbnailBadge({
  badgeList,
  size
}) {
  const badgeSize = badgeSizeLookup[size ?? 'small'];
  const filteredBadgeList = badgeList.map(badge => ({
    ...badge,
    position: Math.max(1, Math.min(badge.position, 9))
  }));
  return jsx(Container$r, {
    children: filteredBadgeList.map((badge, index) => jsx(Content$5, {
      calculateColumn: calculateColumn,
      calculateRow: calculateRow,
      size: badgeSize,
      position: badge.position - 1,
      children: jsx(Image, {
        src: badge.image.url
      })
    }, `thumbnail-badge-${index + 1}`))
  });
}
const Container$r = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm2"
} : {
  target: "e3bgcpm2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none"
} : {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
});
const Content$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm1"
} : {
  target: "e3bgcpm1",
  label: "Content"
})("position:absolute;", ({
  calculateColumn,
  calculateRow,
  size,
  position
}) => `
    top: ${calculateColumn(size[0], position)}%;
    left: ${calculateRow(size[0], position)}%;
    width: ${size[0]}%;
    height: ${size[0]}%;
    ${MEDIA_QUERY.min('tablet', `
      top: ${calculateColumn(size[1], position)}%;
      left: ${calculateRow(size[1], position)}%;
      width: ${size[1]}%;
      height: ${size[1]}%;
    `)}
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Image = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm0"
} : {
  target: "e3bgcpm0",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}"
} : {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
});

var humps = {exports: {}};

(function (module) {
  (function (global) {
    var _processKeys = function (convert, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }
      var output,
        i = 0,
        l = 0;
      if (_isArray(obj)) {
        output = [];
        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert, obj[i], options));
        }
      } else {
        output = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert(key, options)] = _processKeys(convert, obj[key], options);
          }
        }
      }
      return output;
    };

    // String conversion methods

    var separateWords = function (string, options) {
      options = options || {};
      var separator = options.separator || '_';
      var split = options.split || /(?=[A-Z])/;
      return string.split(split).join(separator);
    };
    var camelize = function (string) {
      if (_isNumerical(string)) {
        return string;
      }
      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
      // Ensure 1st char is always lowercase
      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function (string) {
      var camelized = camelize(string);
      // Ensure 1st char is always uppercase
      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function (string, options) {
      return separateWords(string, options).toLowerCase();
    };

    // Utilities
    // Taken from Underscore.js

    var toString = Object.prototype.toString;
    var _isFunction = function (obj) {
      return typeof obj === 'function';
    };
    var _isObject = function (obj) {
      return obj === Object(obj);
    };
    var _isArray = function (obj) {
      return toString.call(obj) == '[object Array]';
    };
    var _isDate = function (obj) {
      return toString.call(obj) == '[object Date]';
    };
    var _isRegExp = function (obj) {
      return toString.call(obj) == '[object RegExp]';
    };
    var _isBoolean = function (obj) {
      return toString.call(obj) == '[object Boolean]';
    };

    // Performant way to determine if obj coerces to a number
    var _isNumerical = function (obj) {
      obj = obj - 0;
      return obj === obj;
    };

    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function (convert, options) {
      var callback = options && 'process' in options ? options.process : options;
      if (typeof callback !== 'function') {
        return convert;
      }
      return function (string, options) {
        return callback(string, convert, options);
      };
    };
    var humps = {
      camelize: camelize,
      decamelize: decamelize,
      pascalize: pascalize,
      depascalize: decamelize,
      camelizeKeys: function (object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function (object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function (object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function () {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    if (module.exports) {
      module.exports = humps;
    } else {
      global.humps = humps;
    }
  })(commonjsGlobal);
})(humps);
var humpsExports = humps.exports;

/**
 * 웹뷰에서 앱에게 braze custom log를 전송하라고 합니다.
 * braze custom log가 웹이 아니라 앱으로 찍을 때 사용합니다.
 * 사용하는 웹뷰에 ipc 설정이 되어 있을 때만 사용 가능합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터
 */
const logAppBraze = (name, properties) => {
  if (window.webkit?.messageHandlers?.ohouseBrazeInterface != null) {
    window.webkit.messageHandlers.ohouseBrazeInterface.postMessage({
      name,
      properties
    });
  } else if (window?.ohouseBrazeInterface != null) {
    window.ohouseBrazeInterface.sendLog(name, JSON.stringify(properties));
  }
};

var mapObj = {exports: {}};

const isObject$1 = value => typeof value === 'object' && value !== null;
const mapObjectSkip = Symbol('skip');

// Customized for this use-case
const isObjectCustom = value => isObject$1(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject = (object, mapper, options, isSeen = new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  const {
    target
  } = options;
  delete options.target;
  const mapArray = array => array.map(element => isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (const [key, value] of Object.entries(object)) {
    const mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip) {
      continue;
    }
    let [newKey, newValue, {
      shouldRecurse = true
    } = {}] = mapResult;

    // Drop `__proto__` keys.
    if (newKey === '__proto__') {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
mapObj.exports = (object, mapper, options) => {
  if (!isObject$1(object)) {
    throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
  }
  return mapObject(object, mapper, options);
};
mapObj.exports.mapObjectSkip = mapObjectSkip;
var mapObjExports = mapObj.exports;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign$1.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
  return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp,
    splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
    _b = options.stripRegexp,
    stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
    _c = options.transform,
    transform = _c === void 0 ? lowerCase : _c,
    _d = options.delimiter,
    delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  // Trim the delimiter from around the output string.
  while (result.charAt(start) === "\0") start++;
  while (result.charAt(end - 1) === "\0") end--;
  // Transform each token independently.
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}

function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign$1({
    delimiter: "."
  }, options));
}

function snakeCase$1(input, options) {
  if (options === void 0) {
    options = {};
  }
  return dotCase(input, __assign$1({
    delimiter: "_"
  }, options));
}

var dist_es2015 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  snakeCase: snakeCase$1
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(dist_es2015);

const map = mapObjExports;
const {
  snakeCase
} = require$$1;
var snakecaseKeys = function (obj, options) {
  options = Object.assign({
    deep: true,
    exclude: [],
    parsingOptions: {}
  }, options);
  return map(obj, function (key, val) {
    return [matches(options.exclude, key) ? key : snakeCase(key, options.parsingOptions), val];
  }, options);
};
function matches(patterns, value) {
  return patterns.some(function (pattern) {
    return typeof pattern === 'string' ? pattern === value : pattern.test(value);
  });
}
var snakecaseKeys$1 = /*@__PURE__*/getDefaultExportFromCjs$1(snakecaseKeys);

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 웹에서 braze custom log를 전송합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터이며 object 형태여야 로깅이 동작합니다.
 */
const logBraze = (eventName, properties) => {
  if (window.braze?.logCustomEvent != null) {
    window.braze.logCustomEvent(eventName, snakecaseKeys$1(properties));
  }
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const BRAZE_TOKEN = '5195e134-c2c9-4bdb-8431-ee5fca29b935';
const BRAZE_BASE_URL = 'sdk.iad-03.appboy.com';
let brazeInitialized = false;
let ohouseUserId = '';
/**
 * window.braze 에 Braze 를 세팅하고 초기화하기 위한 함수이며, logBraze 이전에 호출되어야 합니다.
 * 앱 내부일 경우 웹뷰에서 logAppBraze 를 사용할 경우 (ipc 세팅이 되어있을 경우) 호출하지 않아도 됩니다.
 * @param userId braze에 기록될 userId이며, 오늘의집 유저 id 를 주입하면 됩니다.
 * @param isDevelopment 개발환경이라면 debug log를 표시합니다.
 * @example
 * ```
 * <Script
 *   src="https://js.appboycdn.com/web-sdk/4.8/braze.min.js"
 *   onLoad={() => initBraze({ userId, isDevelopment })}
 * />
 * ```
 */
const initBraze = ({
  userId,
  isDevelopment = false
}) => {
  const isUserAlreadyInBraze = brazeInitialized && ohouseUserId === userId;
  if (isUserAlreadyInBraze || !window.braze) {
    return;
  }
  const Braze = window.braze;
  Braze.initialize(BRAZE_TOKEN, {
    baseUrl: BRAZE_BASE_URL,
    allowUserSuppliedJavascript: true,
    enableLogging: isDevelopment
  });
  Braze.openSession();
  Braze.changeUser(userId);
  ohouseUserId = userId;
  brazeInitialized = true;
};

const AIRBRIDGE_TOKEN = '2bd43efc5ef8401baece946c84ba155d';
/**
 * airbridge 전역 객체를 초기화합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * <Script
 *   src="/js/airbridge.js"
 *   onLoad={() => initAirbridge(user)}
 * />
 * ```
 */
const initAirbridge = user => {
  if (typeof window === 'undefined') {
    return;
  }
  const userConfig = user ? {
    user: {
      externalUserID: `${user.id}`,
      externalUserEmail: `${user.id}@bucketplace.net`
    }
  } : {};
  const config = {
    app: 'ohouse',
    webToken: AIRBRIDGE_TOKEN,
    cookieWindow: 1,
    userHash: false,
    urlQueryMapping: {
      channel: 'utm_source',
      campaign: 'utm_campaign',
      term: 'utm_term',
      ad_creative: 'utm_content',
      ad_group: 'bp_adset',
      content: 'bp_content',
      sub_id: 'bp_sub_id',
      sub_id_1: 'bp_sub_id_1',
      sub_id_2: 'bp_sub_id_2',
      sub_id_3: 'utm_medium'
    },
    ...userConfig
  };
  window.airbridge.init?.(config);
};

/**
 * airbridge 로그를 전송합니다.
 * @param {string} category event 카테고리
 * @param {EventOption} attritube event 옵션
 * @example
 * ```
 * logAirbridge('category', {
 *   label: 'label',
 *   action: 'action',
 *   value: 1,
 *   ...
 * });
 * ```
 */
const logAirbridge = ({
  category,
  attribute
}) => {
  if (!window?.airbridge) {
    return;
  }
  window.airbridge.events?.send(category, attribute);
};

/**
 * signout 시 airbridge 정보도 clear 합니다.
 * @example
 * ```
 * signoutAirbridge();
 * ```
 */
const signoutAirbridge = () => {
  logAirbridge({
    category: 'airbridge.user.signout'
  });
  window.airbridge?.clearUser();
};

const getAmplitude = () => {
  if (!window.amplitude) {
    return null;
  }
  return window.amplitude?.getInstance?.() || null;
};

/**
 * 앰플리튜드 로그를 남깁니다.
 * @param {string} type 이벤트 타입
 * @param {unknown} data 이벤트 데이터
 */
const logAmplitude$1 = (type, data) => {
  const amplitude = getAmplitude();
  if (!amplitude) {
    return;
  }
  amplitude.logEvent(type, data);
};

/**
 * 버킷 클릭 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketClickLog = data => {
  L({
    category: 'click',
    ...data
  });
};

/**
 * 버킷 임프레션 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketImpressionLog = data => {
  L({
    category: 'impression',
    data: [{
      ...f$1(data),
      time: Date.now()
    }]
  });
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$1(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$a;
  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Built-in value references. */
var Buffer$1 = moduleExports$1 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  mapTag$3 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$3 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$3] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$3] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$1(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString$1(overRest(func, undefined, flatten), func + '');
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root$1, 'DataView');
var DataView$2 = DataView$1;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$2 = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$2),
  mapCtorString = toSource(Map$2),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$2 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function (value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
    othIsArr = isArray$1(other),
    objTag = objIsArr ? arrayTag : getTag$1(object),
    othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get$3(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function () {
  return root$1.Date.now();
};
var now$2 = now$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time = now$2(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function (value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate), baseForOwn);
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$2(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  return function () {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function (prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function (value, path) {
    return predicate(value, path[0]);
  });
}

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick$1 = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick$2 = pick$1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

const GLOBAL_INFO = {
  /** 미국 */
  US: {
    currency: 'USD',
    locale: 'en'
  },
  /** 일본 */
  JP: {
    currency: 'JPY',
    locale: 'ja'
  },
  /** 인도네시아 */
  ID: {
    currency: 'IDR',
    locale: 'id'
  },
  /** 한국 */
  KR: {
    currency: 'KRW',
    locale: 'ko'
  }
};
const GLOBAL_DEFAULT_LOCALE = 'en';

/**
 * 국가별 통화에 맞게 가격을 formatting 합니다.
 */
const formatPriceByCurrency = (price, currency) => {
  if (!currency) {
    return price.toLocaleString();
  }
  const country = findKey(GLOBAL_INFO, global => global.currency === currency) ?? 'KR';
  const locale = GLOBAL_INFO[country].locale;
  const intl = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  });
  const originalFormattedPrice = intl.format(price);
  let formattedPrice = '';
  switch (currency) {
    /** 미국 */
    case 'USD':
      formattedPrice = originalFormattedPrice.replace('.00', '');
      break;
    /** 인도네시아 */
    case 'IDR':
      formattedPrice = originalFormattedPrice.replace(',00', '').replace(/\u00A0/, '');
      break;
    /** 일본 */
    case 'JPY':
    case 'KRW':
    default:
      formattedPrice = originalFormattedPrice;
      break;
  }
  return formattedPrice;
};

class HTTPError extends Error {
  constructor(status, body) {
    super(`HTTP ${status} occurred while sending fetch request.`);
    this.status = status;
    this.body = body;
    this.hasMessage = false;
  }
}

const globalLocales = ['en', 'ja', 'id'];
const locales = [...globalLocales, 'ko'];
const globalCountries = ['US', 'JP', 'ID'];
const countries = [...globalCountries, 'KR'];

const fetchSugar = async ({
  url,
  method,
  body = {},
  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  credentials = 'same-origin',
  ignoreError = false
}) => {
  const response = await fetch(url, {
    credentials,
    headers,
    method,
    ...(method === 'GET' ? {} : {
      body: JSON.stringify(body)
    })
  });
  if (!ignoreError && !response.ok) {
    const error = new HTTPError(response.status, {
      url: response.url,
      method,
      body
    });
    try {
      const json = await response.json();
      if (json.message) {
        error.message = json.message;
        error.hasMessage = true;
      }
    } catch (e) {
      // noop
    }
    throw error;
  }
  return response;
};
const fetchGet = async (url, options) => {
  return await fetchSugar({
    url,
    method: 'GET',
    ...options
  });
};
const fetchDelete = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'DELETE',
    body,
    ...options
  });
};
const fetchPut = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PUT',
    body,
    ...options
  });
};
const fetchPost = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'POST',
    body,
    ...options
  });
};
const fetchPatch = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PATCH',
    body,
    ...options
  });
};

const COMMERCE_PATTERN = /^\/productions|^\/store|^\/commerces|^\/exhibitions|^\/cart/;
const O2O_PATTERN = /^\/experts|^\/expert_users/;

/**
 * 현재 URL과 매칭되는 서비스 타입을 반환합니다.
 * @returns {string} 'hnc' | 'commerce | 'o2o'
 */
const getServiceType = (subdomain, pathname) => {
  switch (subdomain) {
    case 'store':
    case 'partner':
    case 'events':
      return 'commerce';
    case 'o2o':
    case 'expert':
      return 'o2o';
    case 'content':
      return 'hnc';
    case 'home':
      {
        if (COMMERCE_PATTERN.test(pathname)) {
          return 'commerce';
        }
        if (O2O_PATTERN.test(pathname)) {
          return 'o2o';
        }
        return 'hnc';
      }
    default:
      return 'hnc';
  }
};

/** 국외향 도메인 */
const GLOBAL_DOMAINS = {
  prod: {
    home: 'https://www.ohouse.com',
    content: 'https://content.ohouse.com',
    store: 'https://store.ohouse.com',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  qa: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  stage: {
    home: 'https://global.stage-web.dailyhou.se',
    content: 'https://content-global.stage-web.dailyhou.se',
    store: 'https://store-global.stage-web.dailyhou.se',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  dev: {
    home: 'https://global.dev-web.dailyhou.se',
    content: 'https://content-global.dev-web.dailyhou.se',
    store: 'https://store-global.dev-web.dailyhou.se',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  local: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  }
};

/** 국내향 도메인 */
const DOMAINS = {
  prod: {
    home: 'https://ohou.se',
    content: 'https://contents.ohou.se',
    store: 'https://store.ohou.se',
    o2o: 'https://o2o.ohou.se',
    events: 'https://events.ohou.se',
    partner: 'https://partners.ohou.se',
    expert: 'https://pro.ohou.se'
  },
  qa: {
    home: 'https://qa-web.dailyhou.se',
    content: 'https://contents.qa-web.dailyhou.se',
    store: 'https://store.qa-web.dailyhou.se',
    o2o: 'https://o2o.qa-web.dailyhou.se',
    events: 'https://events.qa-web.dailyhou.se',
    partner: 'https://partners.qa.dailyhou.se',
    expert: 'https://pro.qa-web.dailyhou.se'
  },
  stage: {
    home: 'https://stage-web.dailyhou.se',
    content: 'https://contents.stage-web.dailyhou.se',
    store: 'https://store.stage-web.dailyhou.se',
    o2o: 'https://o2o.stage-web.dailyhou.se',
    events: 'https://events.stage-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.stage-web.dailyhou.se'
  },
  dev: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.dev.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  },
  local: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  }
};
const API_AUTOCOMPLETE_HOST = {
  prod: 'https://autocomplete.datahou.se',
  qa: 'https://autocomplete.qa.datahou.se',
  stage: 'https://autocomplete.stage.datahou.se',
  dev: 'https://autocomplete.stage.datahou.se',
  local: 'https://autocomplete.stage.datahou.se'
};

/** 국외향 API GATEWAY */
const GLOBAL_API_GATEWAY = {
  prod: 'http://global-mbff.common',
  qa: 'http://global-mbff.common',
  stage: 'http://global-mbff.common',
  dev: 'http://global-mbff.common',
  local: 'https://mbff.qa-web.ohouse.in'
};

/** 국외향에서 사용하는 default metadata */
const GLOBAL_DEFAULT_METADATA = {
  ko: {
    title: '라이프스타일 슈퍼앱, 오늘의집',
    description: '감도높은 유저들의 일상 구경부터 제품 구매까지 한번에'
  },
  en: {
    title: 'Ohouse | Community driven interior design and inspiration',
    description: 'See how interior design enthusiasts decorate and furnish their home',
    siteName: 'Ohouse'
  },
  ja: {
    title: 'Ohouse(オーハウス)|部屋と家具のインテリア写真が見放題',
    description: '世界中の様々なテイストや間取りのインテリア写真が見放題！実際のユーザーの写真から欲しい家具や雑貨を見つけるインテリアコミュニティーサービス。',
    siteName: 'Ohouse'
  },
  id: {
    title: 'Ohouse | Komunitas no. 1 home styling di Indonesia',
    description: 'Intip ke dalam rumah-rumah estetik untuk mendapatkan inspirasi nge-bangun dan nge-dekor',
    siteName: 'Ohouse'
  }
};
const DEFAULT_OG_IMAGE = {
  global: 'https://image.ohouse.com/oh-image-ap-northeast-2/site/1_Ohouse_mark_horizontal_black_og.png',
  domestic: 'https://image.ohou.se/i/bucketplace-v2-development/uploads/default_images/open_graph_icon_2.png'
};

/**
 * 도메인에 따른 URL을 리턴합니다.
 * 이동하려는 URL과 현재 도메인이 다를 경우에만 full URL을 리턴합니다.
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @param {string} serviceType - 국내 또는 국외향 판단
 * @returns {string}
 */
const getURL = (subdomain, env, url, serviceType) => {
  const SERVICE_TYPE_DOMAINS = serviceType === 'OG' ? GLOBAL_DOMAINS : DOMAINS;
  const redirectURL = url.replace(SERVICE_TYPE_DOMAINS[env][subdomain] ?? '', '');
  return redirectURL === '' ? '/' : redirectURL;
};

/**
 * 로그인을 위한 리다이렉션
 */
const REDIRECTION_PATH_MAP = {
  home: undefined,
  content: '/contents-web',
  store: '/stores',
  o2o: '/o2o-web',
  events: '/events',
  partner: undefined,
  expert: undefined
};

/**
 * 유저 정보가 없을 경우, 로그인 URL을 리턴합니다.
 * 유저 정보가 있을 경우, 이동하려는 URL 그대로를 리턴합니다.
 * @param {Object|null} user - 유저 정보
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @returns {string}
 */
const getLoginURL = (user, subdomain, env, url, serviceType, locale) => {
  // Check if it is correct URL
  try {
    const isGlobal = serviceType === 'OG';
    const {
      pathname,
      search,
      hash
    } = new URL(url);
    if (user != null) {
      return url;
    }
    if (isGlobal) {
      const loginURL = `${GLOBAL_DOMAINS[env].home}/${locale}/sign-in?redirect-to=`;
      switch (subdomain) {
        case 'home':
          {
            const redirectURL = [pathname, search, hash].join('');
            return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
          }
        default:
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(url)}`, serviceType);
      }
    }
    const loginURL = `${DOMAINS[env].home}/users/sign_in?redirect_to=`;
    switch (subdomain) {
      case 'content':
      case 'store':
      case 'o2o':
      case 'events':
        {
          const redirectURL = [REDIRECTION_PATH_MAP[subdomain], pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
      default:
        {
          const redirectURL = [pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
    }
  } catch (error) {
    return '';
  }
};
const getCookieDomain = (env, subdomain, serviceType) => {
  try {
    const domain = serviceType === 'OG' ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home;
    const {
      host
    } = new URL(domain);
    if (typeof window !== 'undefined' && env === 'local' && subdomain === 'home') {
      return `${window.location.hostname}`;
    }
    // NOTE: 글로벌 환경은 www.ohouse.com 을 도메인으로 사용하지만 쿠키 도메인은 모든 서브도메인을 대응하기 위해서 .ohouse.com 으로 설정합니다.
    if (host === 'www.ohouse.com') {
      return `.ohouse.com`;
    }
    return `.${host}`;
  } catch (error) {
    return '.ohou.se';
  }
};
/**
 * 주어진 URL 배열을 '|'로 연결된 regex 로 반환하는 함수
 */
const convertUrlsToRegex = urlList => {
  const regexString = urlList.map(url => url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');

  // 문자열로부터 RegExp 객체 생성
  return new RegExp(regexString);
};

/**
 * 콘텐츠 서버에서 내려오는 landingUrl 을 각 host 에 맞게 변환해주는 함수
 * @param hostType 'content' | 'home' landingUrl 의 host 는 content, home 기반으로만 내려온다고 전달받았으므로, 해당 경우에는 각 MSA 도메인에서는 상대 경로로 이동하게 하기 위해 hostType을 받습니다.
 *   만약 content, home 기반이 아닌 다른 도메인 기반의 host를 가진 url이 내려온다면 그대로 반환합니다.
 * @param landingUrl 컨버팅할 url로 서버에서 내려오는 landingUrl 필드입니다.
 * @return 변환된 url을 반환합니다.
 */
const convertLandingUrlByHost = ({
  hostType,
  landingUrl,
  serviceType,
  env
}) => {
  const landingUrlHostMap = {
    content: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.content, DOMAINS.prod.content]),
      targetHost: serviceType === 'OG' ? GLOBAL_DOMAINS[env].content : DOMAINS[env].content
    },
    home: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.home, DOMAINS.prod.home]),
      targetHost: serviceType === 'OG' ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home
    }
  };
  switch (hostType) {
    case 'content':
      landingUrlHostMap.content.targetHost = '';
      break;
    case 'home':
      landingUrlHostMap.home.targetHost = '';
      break;
  }
  let convertedUrl = landingUrl;
  Object.values(landingUrlHostMap).forEach(({
    originalHost,
    targetHost
  }) => {
    convertedUrl = convertedUrl.replace(originalHost, targetHost);
  });
  return convertedUrl;
};

/**
 * url에서 protocol을 제거한 값을 리턴합니다.
 * @param url
 */
const getUrlWithoutProtocol = url => {
  if (url.startsWith('http://')) {
    return url.replace('http://', '');
  }
  if (url.startsWith('https://')) {
    return url.replace('https://', '');
  }
  return url;
};
/**
 * url에서 hostname을 리턴합니다.
 * @param url
 */
const getHostname = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const splittedUrl = urlWithoutProtocol.split('/');
  return splittedUrl[0] ?? '';
};

/**
 * 허용하는 locale인지 확인합니다.
 * @param locale string
 * @returns 허용하는 locale이라면 그대로 리턴합니다. 허용하지 않는 locale이라면 null을 리턴합니다.
 */
const checkAllowedLocale = locale => {
  if (!locale) {
    return null;
  }
  return globalLocales.find(allowedLocale => allowedLocale === locale) ?? null;
};

/**
 * 주어진 url에 포함된 locale 값을 리턴합니다. 값이 없거나 대응하지 않는 locale인 경우 null을 리턴합니다.
 * @param url
 */
const getLocaleFromUrl = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const pathname = urlWithoutProtocol.split('?')[0];
  const splittedPathname = pathname && pathname.split('/');
  const localeFromUrl = splittedPathname && splittedPathname[1];
  return checkAllowedLocale(localeFromUrl);
};

/**
 * 주어진 url에 서비스에서 대응하는 locale 값이 포함되어 있는지 확인합니다.
 * @param url
 */
const isUrlWithLocale = url => {
  return !!getLocaleFromUrl(url);
};

/**
 * locale을 포함한 root pathname(ex. /ja, /en/)인지 확인합니다.
 * @param relativeUrl relativeUrl(ex. /ja/goods/1234)
 * @param locale GlobalLocale
 */
const isRootPathnameWithLocale = relativeUrl => {
  const locale = getLocaleFromUrl(relativeUrl);
  const pathname = relativeUrl.split('?')[0];
  return pathname === `/${locale}` || pathname === `/${locale}/`;
};

/**
 * 주어진 url에 포함되어 있는 locale 값을 changeLocale로 변경하여 전달합니다.
 * 만약 locale이 없는 경우 추가하여 전달합니다.
 * @param url
 * @param changeLocale 변경하려는 Locale
 * @returns locale이 바뀐 Url
 */
const getUrlWithExchangeLocale = (url, changeLocale) => {
  const localeFromUrl = getLocaleFromUrl(url);
  const hostname = getHostname(url);
  if (localeFromUrl) {
    return url.replace(`${hostname}/${localeFromUrl}`, `${hostname}/${changeLocale}`);
  } else {
    return url.replace(`${hostname}`, `${hostname}/${changeLocale}`);
  }
};
const CONTENT_WEB_GLOBAL_APP_NAME = 'content-web-global';
const createGlobalDefaultUrl = ({
  env,
  locale,
  country,
  appName
}) => {
  let defaultPathname = null;
  switch (country) {
    case 'US':
      defaultPathname = '/projects';
      break;
    default:
      defaultPathname = '/topics/recommend';
  }
  if (appName === CONTENT_WEB_GLOBAL_APP_NAME) {
    return `/${locale}${defaultPathname}`;
  }
  return `${GLOBAL_DOMAINS[env]['content']}/${locale}${defaultPathname}`;
};

/**
 * NextJS 서버 요청 중 웹 페이지 요청인지를 판단합니다.
 * @param relativeUrl 요청 url
 * @returns 웹 페이지 요청인지
*/
const isNextJsPageRequest = relativeUrl => {
  const PUBLIC_FILE_REGEXP = /\.[^.]*$/;
  const pathname = relativeUrl.split('?')[0] ?? '';
  return !pathname.startsWith('/_next') && !pathname.startsWith('/api/') && !PUBLIC_FILE_REGEXP.test(pathname);
};

const getClientIp = req => {
  const ip = req.headers['x-forwarded-for']?.toString().split(',').shift();
  if (ip) {
    return ip;
  }
  return req.socket.remoteAddress;
};

/**
 * 검색 로봇 userAgent인지 판단합니다.
 * @param userAgent string
*/
const isSearchRobot = userAgent => {
  const googlebotRegex = /Googlebot/i;
  const yahooSlurpRegex = /Slurp/i;
  const microsoftBingbotRegex = /bingbot/i;
  const searchBotRegexs = [googlebotRegex, yahooSlurpRegex, microsoftBingbotRegex];
  return searchBotRegexs.some(robot => userAgent && robot.test(userAgent));
};

const logGtm = (event, data) => {
  if (!window) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data
  });
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const useScrapLogger = () => {
  const logScrap = useCallback(({
    contentType,
    contentId,
    bucketLogData = {},
    brazeLogData
  }) => {
    L({
      ...bucketLogData,
      category: 'scrap',
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    if (brazeLogData) {
      logBraze('add_scrap', {
        ...brazeLogData,
        type: contentType,
        productionId: contentId
      });
    }
    logAirbridge({
      category: 'add_to_wishlist',
      attribute: {
        action: 'type',
        label: contentType === 'Advice' && 'KNOWHOW' || contentType === 'CardCollection' && 'CARD_COLLECTION' || contentType === 'Card' && 'CARD' || contentType === 'Production' && 'PRODUCT' || contentType === 'Deal' && 'PRODUCT' || contentType === 'Exhibition' && 'EXHIBITION' || contentType === 'Project' && 'PROJECT' || '',
        customAttributes: {
          id: contentId
        }
      }
    });
  }, []);
  const logUnScrap = useCallback(({
    contentType,
    contentId,
    bucketLogData = {}
  }) => {
    L({
      ...bucketLogData,
      category: 'unscrap',
      type: contentType,
      id: contentId
    });
  }, []);
  const logScrapSuccess = useCallback(({
    contentType,
    contentId,
    count,
    amplitudeLogData
  }) => {
    logGtm('content_scrap', {
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    const amplitude = getAmplitude();
    if (amplitudeLogData && amplitude) {
      const identify = new amplitude.Identify();
      identify.set('Total Number of 스크랩 - 전체', count);
      if (['Production', 'Deal'].includes(contentType)) {
        identify.add('Total Number of 스크랩 - 상품', 1);
      }
      amplitude.identify(identify);
      const getAmplitudeLogEventType = () => {
        switch (contentType) {
          case 'Production':
          case 'Deal':
            return '상품 Added to Scrapbook Success';
          case 'Exhibition':
            return '프로모션 Added to Scrapbook Success';
          default:
            return '컨텐츠 Added to Scrapbook Success';
        }
      };
      logAmplitude$1(getAmplitudeLogEventType(), amplitudeLogData);
    }
  }, []);
  const logUnscrapSuccess = useCallback(({
    contentType,
    contentId
  }) => {
    logGtm('content_unscrap', {
      type: contentType,
      id: contentId
    });
  }, []);
  const logSelectScrapBook = useCallback(({
    scrapBookId,
    contentIds
  }) => {
    L({
      category: 'click',
      section: '스크랩 대량 편집',
      type: 'scrap_book',
      id: scrapBookId,
      data: contentIds
    });
  }, []);
  const logClickScrapBook = useCallback(() => {
    L({
      category: 'click',
      section: '스크랩 스낵바',
      type: 'scrap_book'
    });
  }, []);
  const logClickScrapBookTo = useCallback(() => {
    L({
      category: 'scrap',
      section: '폴더링 완료 스낵바',
      type: 'scrap_book'
    });
  }, []);
  return {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logSelectScrapBook,
    logClickScrapBook,
    logClickScrapBookTo
  };
};

function useToggle$1(options = {}) {
  const [open, setOpen] = useState(options.initialValue);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = useCallback(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open: open ?? false,
    isInitial: open == null,
    handleOpen,
    handleClose,
    handleToggle
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * webview 이벤트에 리스너를 연결합니다.
 * 컴포넌트가 언마운트 되면 연결해둔 리스너도 같이 제거됩니다.
 * **최적화를 위해 이벤트 리스너는 useCallback으로 memoize 하는 것을 권장합니다**
 * @param {WebviewEventType} type 웹뷰 이벤트 타입
 * @param {WebviewEventListener} listener 이벤트 리스너
 */
const useWebviewEventListener = (type, listener) => {
  // 특정한 event type인 경우만 리스너를 실행
  const callback = useCallback(event => {
    if (type !== event.type) {
      return;
    }
    listener(event);
  }, [type, listener]);
  useEffect(() => {
    const windowObj = window;

    // BucketUtils 전역객체 초기화
    if (!windowObj.BucketUtils) {
      windowObj.BucketUtils = {};
    }

    // BucketUtils.sendEvent,
    // BucketUtils.sendEvent.callback 초기화
    if (!windowObj.BucketUtils.sendEvent) {
      windowObj.BucketUtils.sendEvent = event => {
        (windowObj.BucketUtils.sendEvent.callbacks || []).forEach(callback => callback(event));
      };
      windowObj.BucketUtils.sendEvent.callbacks = [];
    }

    // 리스너 등록
    const {
      callbacks
    } = windowObj.BucketUtils.sendEvent;
    callbacks.push(callback);

    // 언마운트 시 리스너 제거
    return () => {
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  }, [callback]);
};

/**
 * 앱으로 이벤트를 전송하는 webview 이벤트 dispatcher를 반환합니다.
 * @return {function} 이벤트 dispatcher
 */
const useWebviewEventDispatcher = () => {
  const dispatchWebviewEvent = event => {
    try {
      const windowObj = window;
      windowObj.webkit?.messageHandlers?.ohouseEventInterface?.postMessage?.(event);
      windowObj.ohouseEventInterface?.sendEvent?.(JSON.stringify(event));
    } catch (e) {
      // noop
    }
  };
  return dispatchWebviewEvent;
};

const useIntersectionObserver = ({
  options,
  onIntersect
}) => {
  const {
    ref: target,
    inView
  } = useInView(options);
  useEffect(() => {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return target;
};

const useMergeRef = (...refs) => {
  return useCallback(node => refs.forEach(ref => {
    if (ref === null) {
      return;
    }
    if (typeof ref === 'function') {
      ref(node);
      return;
    }
    ref.current = node;
  }), [refs]);
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$U() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ScrapBookCreateForm = ({
  onSubmit
}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState('');
  if (!editing) {
    return jsx(Container$q, {
      size: "basic",
      variant: "thin",
      children: jsxs(CreateButton, {
        type: "button",
        onClick: () => setEditing(true),
        children: [jsx(IconBox, {
          blue: true,
          children: jsx(Icon$1, {
            name: "add_thick",
            size: 18
          })
        }), jsx(CreateButtonText, {
          children: "\uC0C8\uB85C\uC6B4 \uD3F4\uB354 \uCD94\uAC00\uD558\uAE30"
        })]
      })
    });
  }
  return jsxs(Container$q, {
    size: "basic",
    variant: "thin",
    children: [jsx(IconBox, {
      children: jsx(Icon$1, {
        name: "add_thick",
        size: 18
      })
    }), jsx(Input, {
      placeholder: "\uD3F4\uB354\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694",
      maxLength: 15,
      value: value,
      onChange: e => setValue(e.target.value)
    }), jsx(Button$4, {
      size: 32,
      type: "button",
      variant: "primary1",
      disabled: value.length === 0,
      onClick: () => onSubmit(value),
      children: "\uC644\uB8CC"
    })]
  });
};
const Container$q = /*#__PURE__*/_styled(DividerListItem, process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y4"
} : {
  target: "e1tlor0y4",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "vjnku4",
  styles: "display:flex;align-items:center;width:100%;box-sizing:border-box"
} : {
  name: "vjnku4",
  styles: "display:flex;align-items:center;width:100%;box-sizing:border-box",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$U
});
const CreateButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y3"
} : {
  target: "e1tlor0y3",
  label: "CreateButton"
})("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const CreateButtonText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y2"
} : {
  target: "e1tlor0y2",
  label: "CreateButtonText"
})("display:inline-block;margin-left:", pxToRem(10), ";font-size:", pxToRem(16), ";font-weight:700;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const IconBox = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y1"
} : {
  target: "e1tlor0y1",
  label: "IconBox"
})("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme,
  blue
}) => blue ? theme.content.primary1.basic : theme.content.base3, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Input = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y0"
} : {
  target: "e1tlor0y0",
  label: "Input"
})("flex:1 1 0%;min-width:0;margin:0 ", pxToRem(8), " 0 ", pxToRem(10), ";border:0;color:", ({
  theme
}) => theme.content.base1, ";caret-color:", ({
  theme
}) => theme.content.primary1.basic, ";background:none;font-size:", pxToRem(16), ";&::placeholder{color:", ({
  theme
}) => theme.content.base3, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const ScrapBookItem = /*#__PURE__*/memo(({
  id,
  name,
  lastImageUrl,
  onSelect
}) => {
  return jsx(DividerListItem, {
    size: "basic",
    variant: "thin",
    children: jsxs(Button$3, {
      type: "button",
      onClick: () => onSelect(id, name),
      children: [jsx(ImageBox, {
        children: lastImageUrl && jsx(ResizeImage, {
          src: lastImageUrl,
          intrinsicAspect: 1,
          intrinsicInitialWidth: 40,
          objectFit: "cover"
        })
      }), jsx(ButtonText, {
        children: name
      })]
    })
  });
});
const Button$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "etdzwz22"
} : {
  target: "etdzwz22",
  label: "Button"
})("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ImageBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etdzwz21"
} : {
  target: "etdzwz21",
  label: "ImageBox"
})("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme
}) => theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcmFwQm9va0l0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFEMkIiLCJmaWxlIjoiU2NyYXBCb29rSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBtZW1vIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBSZXNpemVJbWFnZSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IERpdmlkZXJMaXN0SXRlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7IFNjcmFwQm9vayB9IGZyb20gJ0Bjb21tZXJjZS90eXBlcyc7XG5cblxuaW50ZXJmYWNlIFNjcmFwQm9va0l0ZW1Qcm9wcyBleHRlbmRzIFNjcmFwQm9vayB7XG4gIG9uU2VsZWN0OiAoaWQ6IG51bWJlciwgbmFtZTogc3RyaW5nKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgY29uc3QgU2NyYXBCb29rSXRlbSA9IG1lbW8oKHtcbiAgaWQsXG4gIG5hbWUsXG4gIGxhc3RJbWFnZVVybCxcbiAgb25TZWxlY3QsXG59OiBTY3JhcEJvb2tJdGVtUHJvcHMpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8RGl2aWRlckxpc3RJdGVtIHNpemU9XCJiYXNpY1wiIHZhcmlhbnQ9XCJ0aGluXCI+XG4gICAgICA8QnV0dG9uXG4gICAgICAgIHR5cGU9XCJidXR0b25cIlxuICAgICAgICBvbkNsaWNrPXsoKSA9PiBvblNlbGVjdChpZCwgbmFtZSl9XG4gICAgICA+XG4gICAgICAgIDxJbWFnZUJveD5cbiAgICAgICAgICB7IGxhc3RJbWFnZVVybCAmJiAoXG4gICAgICAgICAgICA8UmVzaXplSW1hZ2VcbiAgICAgICAgICAgICAgc3JjPXtsYXN0SW1hZ2VVcmx9XG4gICAgICAgICAgICAgIGludHJpbnNpY0FzcGVjdD17MX1cbiAgICAgICAgICAgICAgaW50cmluc2ljSW5pdGlhbFdpZHRoPXs0MH1cbiAgICAgICAgICAgICAgb2JqZWN0Rml0PVwiY292ZXJcIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgPC9JbWFnZUJveD5cbiAgICAgICAgPEJ1dHRvblRleHQ+eyBuYW1lIH08L0J1dHRvblRleHQ+XG4gICAgICA8L0J1dHRvbj5cbiAgICA8L0RpdmlkZXJMaXN0SXRlbT5cbiAgKTtcbn0pO1xuXG5jb25zdCBCdXR0b24gPSBzdHlsZWQuYnV0dG9uYFxuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHdpZHRoOiAxMDAlO1xuICBwYWRkaW5nOiAwO1xuICBib3JkZXI6IDA7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICBiYWNrZ3JvdW5kOiBub25lO1xuYDtcblxuY29uc3QgSW1hZ2VCb3ggPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIHdpZHRoOiAke3B4VG9SZW0oNDApfTtcbiAgaGVpZ2h0OiAke3B4VG9SZW0oNDApfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC53aGl0ZX07XG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlNH07XG5gO1xuXG5jb25zdCBCdXR0b25UZXh0ID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWFyZ2luLWxlZnQ6ICR7cHhUb1JlbSgxMCl9O1xuICBmb250LXNpemU6ICR7cHhUb1JlbSgxNil9O1xuYDtcbiJdfQ== */"));
const ButtonText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "etdzwz20"
} : {
  target: "etdzwz20",
  label: "ButtonText"
})("display:inline-block;margin-left:", pxToRem(10), ";font-size:", pxToRem(16), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const ScrapBookSelectModal = ({
  contentIds,
  onClose,
  onClickTo,
  getList,
  create,
  select
}) => {
  const [scrapBooks, setScrapBooks] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedFolder, setSelectedFolder] = useState();
  const {
    open: openSnackbar
  } = useSnackbar();
  const {
    logSelectScrapBook,
    logClickScrapBookTo
  } = useScrapLogger();
  const handleConfirmClick = async () => {
    if (!selectedFolder) {
      return;
    }
    if (contentIds.length === 0) {
      openSnackbar({
        content: '이동할 수 있는 콘텐츠가 없습니다. 잠시 후 다시 시도해주세요.'
      });
      return;
    }
    const {
      id,
      name
    } = selectedFolder;
    try {
      const response = await select(id, contentIds);
      if (!response.success) {
        throw new Error();
      }
      openSnackbar({
        content: `'${name}'폴더로 이동했습니다.`,
        buttons: [{
          children: '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBookTo();
            onClickTo(id);
          }
        }]
      });
      logSelectScrapBook({
        scrapBookId: id,
        contentIds
      });
      onClose();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '잠시 후 다시 시도해주세요.'
      });
    }
  };
  const handleSelect = (id, name) => {
    setSelectedFolder({
      id,
      name
    });
  };
  const handleCreate = useCallback(async name => {
    try {
      const response = await create(name);
      if (!response.success) {
        openSnackbar({
          content: '올바른 폴더 이름을 입력해주세요.'
        });
        return;
      }
      handleSelect(response.id, name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '새로운 폴더를 생성하지 못했습니다.'
      });
    }
  }, [create, handleSelect]);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const scrapBooks = await getList();
        setScrapBooks(scrapBooks);
      } catch (error) {
        openSnackbar({
          content: '스크랩북 목록을 가져오지 못했습니다.'
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [getList]);
  return jsxs(Fragment$1, {
    children: [jsx(Modal, {
      width: 400,
      header: {
        title: '폴더 선택',
        onClose
      },
      onBlur: onClose,
      disableBackgroundScroll: true,
      children: jsxs(ModalBody, {
        children: [jsx(ScrapBookCreateForm, {
          onSubmit: handleCreate
        }), scrapBooks.length === 0 && !isLoading && jsx(EmptyMessage, {
          description: '이동할 폴더가 없습니다.\n새로운 폴더를 만들어보세요.'
        }), scrapBooks.length > 0 && scrapBooks.map(scrapBook => jsx(ScrapBookItem, {
          ...scrapBook,
          onSelect: handleSelect
        }, scrapBook.id))]
      })
    }), selectedFolder?.id && selectedFolder?.name && jsx(Modal, {
      width: 400,
      disableBackgroundScroll: true,
      footer: {
        action: {
          primary: {
            text: '확인',
            onClick: handleConfirmClick
          },
          secondary: {
            text: '취소',
            onClick: () => setSelectedFolder(undefined)
          }
        }
      },
      children: jsx(Content$4, {
        children: `선택한 컨텐츠를 '${selectedFolder.name}'으로 이동하시겠습니까?`
      })
    })]
  });
};
const ModalBody = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eetj5dr2"
} : {
  target: "eetj5dr2",
  label: "ModalBody"
})("overflow-y:auto;height:", pxToRem(446), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(466), ";padding:0 ", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ModalBody;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const EmptyMessage = /*#__PURE__*/_styled(EmptyPage, process.env.NODE_ENV === "production" ? {
  target: "eetj5dr1"
} : {
  target: "eetj5dr1",
  label: "EmptyMessage"
})("margin-top:", pxToRem(100), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("margin-top:", pxToRem(120), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:EmptyMessage;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Content$4 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eetj5dr0"
} : {
  target: "eetj5dr0",
  label: "Content"
})(FONT_STYLE.body1_1, ";color:", ({
  theme
}) => theme.content.base1, ";padding:16px 16px 10px 16px;text-align:center;word-break:keep-all;white-space:pre-line;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcmFwQm9va1NlbGVjdE1vZGFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyTXdCIiwiZmlsZSI6IlNjcmFwQm9va1NlbGVjdE1vZGFsLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIHJlYWN0LWhvb2tzL2V4aGF1c3RpdmUtZGVwcyAqL1xuaW1wb3J0IHsgdXNlQ2FsbGJhY2ssIHVzZUVmZmVjdCwgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7XG4gIEZPTlRfU1RZTEUsXG4gIE1FRElBX1FVRVJZLFxuICBweFRvUmVtLFxuICB1c2VTbmFja2Jhcixcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgRW1wdHlQYWdlLCBNb2RhbCB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7XG4gIENyZWF0ZVNjcmFwQm9va1Jlc3BvbnNlLFxuICBHZXRTY3JhcEJvb2tzUmVzcG9uc2UsXG4gIFNjcmFwQm9vayxcbiAgU2VsZWN0U2NyYXBCb29rUmVzcG9uc2UsXG59IGZyb20gJ0Bjb21tZXJjZS90eXBlcyc7XG5pbXBvcnQgeyB1c2VTY3JhcExvZ2dlciB9IGZyb20gJy4uL2hvb2tzJztcblxuaW1wb3J0IHsgU2NyYXBCb29rQ3JlYXRlRm9ybSB9IGZyb20gJy4vU2NyYXBCb29rQ3JlYXRlRm9ybSc7XG5pbXBvcnQgeyBTY3JhcEJvb2tJdGVtIH0gZnJvbSAnLi9TY3JhcEJvb2tJdGVtJztcblxuZXhwb3J0IGludGVyZmFjZSBTY3JhcEJvb2tTZWxlY3RNb2RhbFByb3BzIHtcbiAgY29udGVudElkczogKG51bWJlciB8IHN0cmluZylbXTtcbiAgb25DbG9zZTogKCkgPT4gdm9pZDtcbiAgb25DbGlja1RvOiAoc2NyYXBCb29rSWQ6IG51bWJlcikgPT4gdm9pZDtcbiAgZ2V0TGlzdDogKCkgPT4gUHJvbWlzZTxHZXRTY3JhcEJvb2tzUmVzcG9uc2U+O1xuICBjcmVhdGU6IChzY3JhcEJvb2tOYW1lOiBzdHJpbmcpID0+IFByb21pc2U8Q3JlYXRlU2NyYXBCb29rUmVzcG9uc2U+O1xuICBzZWxlY3Q6IChcbiAgICBzY3JhcEJvb2tJZDogbnVtYmVyLFxuICAgIGNvbnRlbnRJZHM6IChudW1iZXIgfCBzdHJpbmcpW10sXG4gICkgPT4gUHJvbWlzZTxTZWxlY3RTY3JhcEJvb2tSZXNwb25zZT47XG59XG5cbmV4cG9ydCBjb25zdCBTY3JhcEJvb2tTZWxlY3RNb2RhbCA9ICh7XG4gIGNvbnRlbnRJZHMsXG4gIG9uQ2xvc2UsXG4gIG9uQ2xpY2tUbyxcbiAgZ2V0TGlzdCxcbiAgY3JlYXRlLFxuICBzZWxlY3QsXG59OiBTY3JhcEJvb2tTZWxlY3RNb2RhbFByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgY29uc3QgW3NjcmFwQm9va3MsIHNldFNjcmFwQm9va3NdID0gdXNlU3RhdGU8U2NyYXBCb29rW10+KFtdKTtcbiAgY29uc3QgW2lzTG9hZGluZywgc2V0TG9hZGluZ10gPSB1c2VTdGF0ZSh0cnVlKTtcbiAgY29uc3QgW3NlbGVjdGVkRm9sZGVyLCBzZXRTZWxlY3RlZEZvbGRlcl0gPSB1c2VTdGF0ZTx7IGlkOiBudW1iZXIsIG5hbWU6IHN0cmluZyB9PigpO1xuICBjb25zdCB7IG9wZW46IG9wZW5TbmFja2JhciB9ID0gdXNlU25hY2tiYXIoKTtcbiAgY29uc3QgeyBsb2dTZWxlY3RTY3JhcEJvb2ssIGxvZ0NsaWNrU2NyYXBCb29rVG8gfSA9IHVzZVNjcmFwTG9nZ2VyKCk7XG5cbiAgY29uc3QgaGFuZGxlQ29uZmlybUNsaWNrID0gYXN5bmMgKCk6IFByb21pc2U8dm9pZD4gPT4ge1xuICAgIGlmICghc2VsZWN0ZWRGb2xkZXIpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBpZiAoY29udGVudElkcy5sZW5ndGggPT09IDApIHtcbiAgICAgIG9wZW5TbmFja2Jhcih7IGNvbnRlbnQ6ICfsnbTrj5ntlaAg7IiYIOyeiOuKlCDsvZjthZDsuKDqsIAg7JeG7Iq164uI64ukLiDsnqDsi5wg7ZuEIOuLpOyLnCDsi5zrj4TtlbTso7zshLjsmpQuJyB9KTtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBjb25zdCB7IGlkLCBuYW1lIH0gPSBzZWxlY3RlZEZvbGRlcjtcblxuICAgIHRyeSB7XG4gICAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IHNlbGVjdChpZCwgY29udGVudElkcyk7XG5cbiAgICAgIGlmICghcmVzcG9uc2Uuc3VjY2Vzcykge1xuICAgICAgICB0aHJvdyBuZXcgRXJyb3IoKTtcbiAgICAgIH1cblxuICAgICAgb3BlblNuYWNrYmFyKHtcbiAgICAgICAgY29udGVudDogYCcke25hbWV9J+2PtOuNlOuhnCDsnbTrj5ntlojsirXri4jri6QuYCxcbiAgICAgICAgYnV0dG9uczogW1xuICAgICAgICAgIHtcbiAgICAgICAgICAgIGNoaWxkcmVuOiAn7Iqk7YGs656p67aBIOuztOq4sCcsXG4gICAgICAgICAgICB0eXBlOiAnYnV0dG9uJyBhcyBjb25zdCxcbiAgICAgICAgICAgIG9uQ2xpY2s6ICgpID0+IHtcbiAgICAgICAgICAgICAgbG9nQ2xpY2tTY3JhcEJvb2tUbygpO1xuICAgICAgICAgICAgICBvbkNsaWNrVG8oaWQpO1xuICAgICAgICAgICAgfSxcbiAgICAgICAgICB9LFxuICAgICAgICBdLFxuICAgICAgfSk7XG5cbiAgICAgIGxvZ1NlbGVjdFNjcmFwQm9vayh7XG4gICAgICAgIHNjcmFwQm9va0lkOiBpZCxcbiAgICAgICAgY29udGVudElkcyxcbiAgICAgIH0pO1xuXG4gICAgICBvbkNsb3NlKCk7XG4gICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1leHBsaWNpdC1hbnlcbiAgICB9IGNhdGNoIChlcnJvcjogYW55KSB7XG4gICAgICBvcGVuU25hY2tiYXIoe1xuICAgICAgICBjb250ZW50OiBlcnJvci5tZXNzYWdlIHx8ICfsnqDsi5wg7ZuEIOuLpOyLnCDsi5zrj4TtlbTso7zshLjsmpQuJyxcbiAgICAgIH0pO1xuICAgIH1cbiAgfTtcblxuICBjb25zdCBoYW5kbGVTZWxlY3QgPSAoaWQ6IG51bWJlciwgbmFtZTogc3RyaW5nKTogdm9pZCA9PiB7XG4gICAgc2V0U2VsZWN0ZWRGb2xkZXIoe1xuICAgICAgaWQsXG4gICAgICBuYW1lLFxuICAgIH0pO1xuICB9O1xuXG4gIGNvbnN0IGhhbmRsZUNyZWF0ZSA9IHVzZUNhbGxiYWNrKGFzeW5jIChuYW1lOiBzdHJpbmcpID0+IHtcbiAgICB0cnkge1xuICAgICAgY29uc3QgcmVzcG9uc2UgPSBhd2FpdCBjcmVhdGUobmFtZSk7XG5cbiAgICAgIGlmICghcmVzcG9uc2Uuc3VjY2Vzcykge1xuICAgICAgICBvcGVuU25hY2tiYXIoeyBjb250ZW50OiAn7Jis67CU66W4IO2PtOuNlCDsnbTrpoTsnYQg7J6F66Cl7ZW07KO87IS47JqULicgfSk7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cblxuICAgICAgaGFuZGxlU2VsZWN0KHJlc3BvbnNlLmlkLCBuYW1lKTtcbiAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLWV4cGxpY2l0LWFueVxuICAgIH0gY2F0Y2ggKGVycm9yOiBhbnkpIHtcbiAgICAgIG9wZW5TbmFja2Jhcih7XG4gICAgICAgIGNvbnRlbnQ6IGVycm9yLm1lc3NhZ2UgfHwgJ+yDiOuhnOyatCDtj7TrjZTrpbwg7IOd7ISx7ZWY7KeAIOuqu+2WiOyKteuLiOuLpC4nLFxuICAgICAgfSk7XG4gICAgfVxuICB9LCBbY3JlYXRlLCBoYW5kbGVTZWxlY3RdKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIChhc3luYyAoKSA9PiB7XG4gICAgICB0cnkge1xuICAgICAgICBzZXRMb2FkaW5nKHRydWUpO1xuICAgICAgICBjb25zdCBzY3JhcEJvb2tzID0gYXdhaXQgZ2V0TGlzdCgpO1xuICAgICAgICBzZXRTY3JhcEJvb2tzKHNjcmFwQm9va3MpO1xuICAgICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgb3BlblNuYWNrYmFyKHsgY29udGVudDogJ+yKpO2BrOueqeu2gSDrqqnroZ3snYQg6rCA7KC47Jik7KeAIOuqu+2WiOyKteuLiOuLpC4nIH0pO1xuICAgICAgfSBmaW5hbGx5IHtcbiAgICAgICAgc2V0TG9hZGluZyhmYWxzZSk7XG4gICAgICB9XG4gICAgfSkoKTtcbiAgfSwgW2dldExpc3RdKTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICA8TW9kYWxcbiAgICAgICAgd2lkdGg9ezQwMH1cbiAgICAgICAgaGVhZGVyPXt7IHRpdGxlOiAn7Y+0642UIOyEoO2DnScsIG9uQ2xvc2UgfX1cbiAgICAgICAgb25CbHVyPXtvbkNsb3NlfVxuICAgICAgICBkaXNhYmxlQmFja2dyb3VuZFNjcm9sbFxuICAgICAgPlxuICAgICAgICA8TW9kYWxCb2R5PlxuICAgICAgICAgIDxTY3JhcEJvb2tDcmVhdGVGb3JtIG9uU3VibWl0PXtoYW5kbGVDcmVhdGV9IC8+XG5cbiAgICAgICAgICB7IChzY3JhcEJvb2tzLmxlbmd0aCA9PT0gMCAmJiAhaXNMb2FkaW5nKSAmJiAoXG4gICAgICAgICAgICA8RW1wdHlNZXNzYWdlXG4gICAgICAgICAgICAgIGRlc2NyaXB0aW9uPXsn7J2064+Z7ZWgIO2PtOuNlOqwgCDsl4bsirXri4jri6QuXFxu7IOI66Gc7Jq0IO2PtOuNlOulvCDrp4zrk6TslrTrs7TshLjsmpQuJ31cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG5cbiAgICAgICAgICB7IHNjcmFwQm9va3MubGVuZ3RoID4gMCAmJlxuICAgICAgICAgICAgc2NyYXBCb29rcy5tYXAoKHNjcmFwQm9vazogU2NyYXBCb29rKSA9PiAoXG4gICAgICAgICAgICAgIDxTY3JhcEJvb2tJdGVtXG4gICAgICAgICAgICAgICAga2V5PXtzY3JhcEJvb2suaWR9XG4gICAgICAgICAgICAgICAgey4uLnNjcmFwQm9va31cbiAgICAgICAgICAgICAgICBvblNlbGVjdD17aGFuZGxlU2VsZWN0fVxuICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgKSkgfVxuICAgICAgICA8L01vZGFsQm9keT5cbiAgICAgIDwvTW9kYWw+XG4gICAgICB7IHNlbGVjdGVkRm9sZGVyPy5pZCAmJiBzZWxlY3RlZEZvbGRlcj8ubmFtZSAmJiAoXG4gICAgICAgIDxNb2RhbFxuICAgICAgICAgIHdpZHRoPXs0MDB9XG4gICAgICAgICAgZGlzYWJsZUJhY2tncm91bmRTY3JvbGxcbiAgICAgICAgICBmb290ZXI9e3tcbiAgICAgICAgICAgIGFjdGlvbjoge1xuICAgICAgICAgICAgICBwcmltYXJ5OiB7XG4gICAgICAgICAgICAgICAgdGV4dDogJ+2ZleyduCcsXG4gICAgICAgICAgICAgICAgb25DbGljazogaGFuZGxlQ29uZmlybUNsaWNrLFxuICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICBzZWNvbmRhcnk6IHtcbiAgICAgICAgICAgICAgICB0ZXh0OiAn7Leo7IaMJyxcbiAgICAgICAgICAgICAgICBvbkNsaWNrOiAoKSA9PiBzZXRTZWxlY3RlZEZvbGRlcih1bmRlZmluZWQpLFxuICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICB9fVxuICAgICAgICA+XG4gICAgICAgICAgPENvbnRlbnQ+eyBg7ISg7YOd7ZWcIOy7qO2FkOy4oOulvCAnJHtzZWxlY3RlZEZvbGRlci5uYW1lfSfsnLzroZwg7J2064+Z7ZWY7Iuc6rKg7Iq164uI6rmMP2AgfTwvQ29udGVudD5cbiAgICAgICAgPC9Nb2RhbD5cbiAgICAgICkgfVxuICAgIDwvPlxuICApO1xufTtcblxuY29uc3QgTW9kYWxCb2R5ID0gc3R5bGVkLmRpdmBcbiAgb3ZlcmZsb3cteTogYXV0bztcbiAgaGVpZ2h0OiAke3B4VG9SZW0oNDQ2KX07XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oNDY2KX07XG4gICAgcGFkZGluZzogMCAke3B4VG9SZW0oMTIpfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBFbXB0eU1lc3NhZ2UgPSBzdHlsZWQoRW1wdHlQYWdlKWBcbiAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDEwMCl9O1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIG1hcmdpbi10b3A6ICR7cHhUb1JlbSgxMjApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBDb250ZW50ID0gc3R5bGVkLnBgXG4gICR7Rk9OVF9TVFlMRS5ib2R5MV8xfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMX07XG4gIHBhZGRpbmc6IDE2cHggMTZweCAxMHB4IDE2cHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgd29yZC1icmVhazoga2VlcC1hbGw7XG4gIHdoaXRlLXNwYWNlOiBwcmUtbGluZTtcbmA7XG4iXX0= */"));

/* eslint-disable react-hooks/exhaustive-deps */
const Scrap = ({
  contentType,
  contentId,
  initialActive = false,
  initialCount = 0,
  children,
  scrap,
  onScrap,
  unscrap,
  onUnscrap,
  isLoggedIn,
  redirectToLogin,
  onClickScrapBook,
  onClickScrapBookTo,
  getScrapBooks,
  createScrapBook,
  selectScrapBook,
  isGlobal,
  localeData
}) => {
  const [scrapItem, setScrapItem] = useState({
    active: initialActive,
    count: initialCount
  });
  const [pending, setPending] = useState(false);
  const [isScrapBookSelectModalOpen, setScrapBookSelectModalOpen] = useState(false);
  const {
    open: openSnackBar
  } = useSnackbar();
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logClickScrapBook
  } = useScrapLogger();
  useEffect(() => {
    setScrapItem(item => ({
      ...item,
      active: initialActive,
      count: initialCount
    }));
  }, [initialActive, initialCount]);
  const handleScrap = useCallback(async ({
    bucketLogData,
    brazeLogData,
    amplitudeLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logScrap({
      contentType,
      contentId,
      bucketLogData,
      brazeLogData
    });
    try {
      const response = await scrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        id: response.id,
        active: true,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successScrap ?? '스크랩했습니다.',
        buttons: [{
          children: localeData?.goToScrapBookPage ?? '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBook();
            onClickScrapBook();
          }
        }, isGlobal ? {} : {
          children: '폴더에 담기',
          type: 'button',
          onClick: () => setScrapBookSelectModalOpen(true)
        }]
      });
      dispatchWebviewEvent({
        type: 'scrap',
        contentType,
        contentId,
        performed: true,
        count: response.count
      });
      logScrapSuccess({
        contentType,
        contentId,
        count: response.count,
        amplitudeLogData
      });
      onScrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failScrap ?? '스크랩 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, scrap, onScrap, isLoggedIn, redirectToLogin]);
  const handleUnscrap = useCallback(async ({
    bucketLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logUnScrap({
      contentType,
      contentId,
      bucketLogData
    });
    try {
      const response = await unscrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        active: false,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successUnscrap ?? '스크랩북에서 삭제했습니다.'
      });
      dispatchWebviewEvent({
        type: 'scrap',
        contentType,
        contentId,
        performed: false,
        count: response.count
      });
      logUnscrapSuccess({
        contentType,
        contentId
      });
      onUnscrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failUnscrap ?? '스크랩북에서 삭제 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, unscrap, onUnscrap, isLoggedIn, redirectToLogin]);
  const handleToggle = useCallback(({
    scrap
  }) => {
    if (scrapItem.active) {
      return handleUnscrap(scrap);
    }
    return handleScrap(scrap);
  }, [scrapItem.active, handleScrap, handleUnscrap]);
  const handleWebviewScrap = useCallback(event => {
    if (event.contentId !== contentId) {
      return;
    }
    setScrapItem(item => ({
      ...item,
      count: event.count ?? (event.performed ? ++item.count : --item.count),
      active: event.performed,
      pending: false
    }));
  }, [contentId]);
  useWebviewEventListener('scrap', handleWebviewScrap);
  return jsxs(Fragment$1, {
    children: [children({
      active: scrapItem.active,
      count: scrapItem.count,
      scrap: handleScrap,
      unscrap: handleUnscrap,
      toggle: handleToggle
    }), isScrapBookSelectModalOpen && jsx(ScrapBookSelectModal, {
      contentIds: scrapItem.id ? [scrapItem.id] : [],
      onClose: () => setScrapBookSelectModalOpen(false),
      onClickTo: onClickScrapBookTo,
      getList: getScrapBooks,
      create: createScrapBook,
      select: selectScrapBook
    })]
  });
};

function HOVER(template, ...args) {
  return /*#__PURE__*/css("&.focus-visible:focus{", /*#__PURE__*/css(template, ...args), ";}@media(hover: hover) and (pointer: fine){&:hover,&:active{", /*#__PURE__*/css(template, ...args), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:HOVER;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1ZIiwiZmlsZSI6ImhvdmVyLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2VyaWFsaXplZFN0eWxlcywgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgZnVuY3Rpb24gSE9WRVIoXG4gIHRlbXBsYXRlOiBUZW1wbGF0ZVN0cmluZ3NBcnJheSxcbiAgLi4uYXJnczogUGFyYW1ldGVyczx0eXBlb2YgY3NzPltudW1iZXJdW11cbik6IFNlcmlhbGl6ZWRTdHlsZXMge1xuICByZXR1cm4gY3NzYFxuICAgICYuZm9jdXMtdmlzaWJsZTpmb2N1cyB7XG4gICAgICAke2Nzcyh0ZW1wbGF0ZSwgLi4uYXJncyl9XG4gICAgfVxuICAgIEBtZWRpYShob3ZlcjogaG92ZXIpIGFuZCAocG9pbnRlcjogZmluZSkge1xuICAgICAgJjpob3ZlciwgJjphY3RpdmUge1xuICAgICAgICAke2Nzcyh0ZW1wbGF0ZSwgLi4uYXJncyl9XG4gICAgICB9XG4gICAgfVxuICBgO1xufVxuIl19 */");
}

function ProductCardScrap({
  scrapData,
  product,
  logData
}) {
  const {
    initialActive,
    initialCount,
    isLoggedIn,
    userId,
    scrap,
    unscrap,
    onScrap,
    onUnscrap,
    createScrapBook,
    selectScrapBook,
    getScrapBooks,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  } = scrapData;
  const getScrapLogData = ({
    bucketLogData
  } = {}) => {
    return {
      bucketLogData,
      brazeLogData: {
        userId: userId || 0,
        productName: product.name
      }
    };
  };
  return jsx(Scrap, {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: initialActive,
    initialCount: initialCount,
    getScrapBooks: getScrapBooks,
    isLoggedIn: isLoggedIn,
    scrap: scrap,
    unscrap: unscrap,
    onScrap: onScrap,
    onUnscrap: onUnscrap,
    createScrapBook: createScrapBook,
    selectScrapBook: selectScrapBook,
    onClickScrapBook: onClickScrapBook,
    onClickScrapBookTo: onClickScrapBookTo,
    redirectToLogin: redirectToLogin,
    children: ({
      active,
      scrap,
      unscrap
    }) => jsx(ScrapButton$1, {
      name: "scrap",
      size: 24,
      active: active,
      initialActive: active,
      onActive: onClickScrap ?? (() => scrap({
        ...getScrapLogData({
          bucketLogData: logData
        })
      })),
      onInactive: () => unscrap({
        ...getScrapLogData({
          bucketLogData: logData
        })
      })
    })
  });
}
const ScrapButton$1 = /*#__PURE__*/_styled(ToggleButton, process.env.NODE_ENV === "production" ? {
  target: "ena0pzo0"
} : {
  target: "ena0pzo0",
  label: "ScrapButton"
})("position:absolute;bottom:4px;right:4px;z-index:10;", HOVER`
    opacity: 0.5;
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function SoldOutBanner() {
  return jsx(Container$p, {
    children: "\uD488\uC808"
  });
}
const Container$p = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e152w92t0"
} : {
  target: "e152w92t0",
  label: "Container"
})(FONT_STYLE.caption1, " position:absolute;left:0;right:0;bottom:0;padding:2px 0;text-align:center;font-weight:bold;", ({
  theme
}) => /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content.base3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNvbGRPdXRCYW5uZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNCc0IiLCJmaWxlIjoiU29sZE91dEJhbm5lci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBGT05UX1NUWUxFIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgUmVhY3RFbGVtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgZnVuY3Rpb24gU29sZE91dEJhbm5lcigpOiBSZWFjdEVsZW1lbnQge1xuICByZXR1cm4gKFxuICAgIDxDb250YWluZXI+XG4gICAgICDtkojsoIhcbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgJHtGT05UX1NUWUxFLmNhcHRpb24xfVxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuICBib3R0b206IDA7XG4gIHBhZGRpbmc6IDJweCAwO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAkeyh7IHRoZW1lIH0pID0+IGNzc2BcbiAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LndoaXRlfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RoZW1lLmNvbnRlbnQuYmFzZTN9O1xuICBgfVxuICBib3JkZXItcmFkaXVzOiAwIDAgNHB4IDRweDtcbiAgei1pbmRleDogMjtcbmA7XG4iXX0= */"), " border-radius:0 0 4px 4px;z-index:2;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNvbGRPdXRCYW5uZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWE0QiIsImZpbGUiOiJTb2xkT3V0QmFubmVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEZPTlRfU1RZTEUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBmdW5jdGlvbiBTb2xkT3V0QmFubmVyKCk6IFJlYWN0RWxlbWVudCB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIO2SiOygiFxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgcGFkZGluZzogMnB4IDA7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICR7KHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQud2hpdGV9O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dGhlbWUuY29udGVudC5iYXNlM307XG4gIGB9XG4gIGJvcmRlci1yYWRpdXM6IDAgMCA0cHggNHB4O1xuICB6LWluZGV4OiAyO1xuYDtcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Thumbnail$1({
  product,
  scrapData,
  flex,
  isMdPick,
  logData,
  className,
  children,
  renderOverlay
}) {
  const {
    badges,
    originalImageUrl,
    isSoldOut,
    isDiscontinued
  } = product;
  const isVisibleSoldoutBanner = isSoldOut && !isDiscontinued;
  return jsx(Wrapper$4, {
    flex: flex,
    className: classNames('product-thumbnail', className),
    children: jsxs(Container$o, {
      children: [renderOverlay?.(), scrapData != null && jsx(ProductCardScrap, {
        scrapData: scrapData,
        product: product,
        logData: logData
      }), jsxs(ImageWrapper, {
        children: [badges != null && badges.length > 0 && jsx(ThumbnailBadge, {
          badgeList: badges,
          size: isMdPick ? 'extraSmall' : 'small'
        }), jsx(StyledResizeImage, {
          src: originalImageUrl,
          quality: 50,
          intrinsicAspect: 1,
          className: "thumbnail-image",
          alt: "\uC0C1\uD488-\uC378\uB124\uC77C-\uC774\uBBF8\uC9C0"
        })]
      }), isVisibleSoldoutBanner && jsx(SoldOutBanner, {}), children]
    })
  });
}
function ThumbnailPlaceholder() {
  return jsx(ThumbnailPlaceholderAnimation, {});
}
const Wrapper$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc4"
} : {
  target: "e1bro5mc4",
  label: "Wrapper"
})(({
  flex
}) => flex && `
    flex: 1 0 48%;
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Container$o = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc3"
} : {
  target: "e1bro5mc3",
  label: "Container"
})("position:relative;padding-bottom:100%;background-color:", ({
  theme
}) => theme.content.base5, ";border-radius:4px;&:after{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(5, 3, 3, 0.02);border-radius:4px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ImageWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc2"
} : {
  target: "e1bro5mc2",
  label: "ImageWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden"
} : {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
});
const StyledResizeImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc1"
} : {
  target: "e1bro5mc1",
  label: "StyledResizeImage"
})(process.env.NODE_ENV === "production" ? {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform"
} : {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
});
const ThumbnailPlaceholderAnimation = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc0"
} : {
  target: "e1bro5mc0",
  label: "ThumbnailPlaceholderAnimation"
})(process.env.NODE_ENV === "production" ? {
  name: "vs1u20",
  styles: "padding-bottom:100%;border-radius:4px"
} : {
  name: "vs1u20",
  styles: "padding-bottom:100%;border-radius:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
});

function Timer({
  className,
  todayDeal
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile';
  const endAt = new Date(todayDeal.endAt).getTime();
  const [remaining, setRemaining] = useState(() => endAt - Date.now());
  const hasExpired = remaining <= 0;
  const text = remaining >= 86400000 ? `${Math.floor(remaining / 86400000)}일` : `${`00${Math.floor(remaining / 1000 / 3600) % 24}`.slice(-2)}:${`00${Math.floor(remaining / 1000 / 60) % 60}`.slice(-2)}:${`00${Math.floor(remaining / 1000) % 60}`.slice(-2)}`;
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(endAt - Date.now());
    }, 1000);
    return () => {
      window.clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(Badge, {
    size: isMobile ? 20 : 24,
    type: "fill",
    variant: "primary2",
    className: className,
    children: hasExpired ? '마감' : `${text} 남음`
  });
}
const Badge = /*#__PURE__*/_styled(SquareBadge, process.env.NODE_ENV === "production" ? {
  target: "edmzysc0"
} : {
  target: "edmzysc0",
  label: "Badge"
})("position:absolute;z-index:3;top:8px;left:8px;", MEDIA_QUERY.min('tablet', `
    top: 12px;
    left: 12px;
  `), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function ProductCard({
  product,
  href,
  badgeMaxCount,
  flex,
  isMdPick,
  logData,
  scrapData,
  localeData,
  hideBadge,
  hideReview,
  hideStats,
  className,
  renderOverlay,
  onClick,
  linkComponent,
  infoBottomArea,
  infoVariant
}) {
  const {
    detailLogData
  } = useProductCardLogData({
    product,
    badgeMaxCount
  });
  const bucketLogData = {
    ...logData,
    type: product.type?.toLowerCase() || 'production',
    id: product.id,
    data: {
      ...logData?.data,
      ...detailLogData
    }
  };
  const {
    ref
  } = ce({
    logData: bucketLogData
  });
  const LinkComponent = linkComponent;
  const handleClickProductLink = event => {
    if (logData) {
      L({
        category: 'click',
        ...bucketLogData
      });
    }
    onClick?.(event);
  };
  return jsxs(Container$n, {
    className: className,
    ref: ref,
    flex: flex,
    children: [LinkComponent != null && jsx(LinkComponent, {
      href: href,
      onClick: handleClickProductLink
    }), jsx(Thumbnail$1, {
      product: product,
      scrapData: scrapData,
      flex: flex,
      isMdPick: isMdPick,
      logData: bucketLogData,
      renderOverlay: renderOverlay
    }), jsx(Info$1, {
      product: product,
      badgeMaxCount: badgeMaxCount,
      flex: flex,
      isMdPick: isMdPick,
      localeData: localeData,
      hideBadge: hideBadge,
      hideReview: hideReview,
      hideStats: hideStats,
      bottomArea: infoBottomArea,
      variant: infoVariant
    })]
  });
}
function CardPlaceholder() {
  return jsxs(Container$n, {
    children: [jsx(ThumbnailPlaceholder, {}), jsx(InfoPlaceholder, {})]
  });
}
const Container$n = /*#__PURE__*/_styled("article", process.env.NODE_ENV === "production" ? {
  target: "etj6rb20"
} : {
  target: "etj6rb20",
  label: "Container"
})("display:block;position:relative;padding:16px 0;", ({
  flex
}) => flex && `
    display: flex;
    align-items: center;
  `, ">a{position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;", HOVER`
      & ~ .product-thumbnail .thumbnail-image {
        transform: translate(-50%, -50%) scale(1.1);
      }
      & ~ .product-info .product-name {
        opacity: 0.5;
      }
    `, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STAT_MAX_COUNT = 99999;
/**
 * 스크랩 실험용 Stats 컴포넌트
 *
 * B안에서 리뷰가 1000개 이상인 경우 스크랩이 있더라도 노출하지 않습니다.
 * 그 외에는 리뷰/스크랩 수 모두 최대 99999개로 표시합니다.
 */
function ScrapExperimentStats({
  experimentType,
  reviewAvg,
  reviewCount = 0,
  scrapCount = 0,
  isMdPick,
  hideReview,
  hideStats
}) {
  const hasReview = reviewCount > 0;
  const hasScrap = scrapCount > 0;
  const formattedReviewCount = reviewCount >= STAT_MAX_COUNT ? STAT_MAX_COUNT : reviewCount;
  const showScrap = hasScrap && !isMdPick && (experimentType === 'C' || (hasReview ? reviewCount < 1000 : true));
  const scrapMaxCount = experimentType === 'B' ? 9999 : 99999;
  if (hideStats) {
    return null;
  }
  return jsxs(Container$m, {
    children: [hasReview && !hideReview && jsxs(Fragment$1, {
      children: [jsx(StyledIcon, {
        name: "star",
        size: 12
      }), jsx(Average, {
        experimentType: experimentType,
        children: reviewAvg != null ? Math.round(reviewAvg * 10) / 10 : 0
      }), jsxs(InfoText, {
        children: [experimentType === 'B' && `리뷰 ${formatComma(reviewCount)}`, experimentType === 'C' && `(${formatComma(formattedReviewCount)})`]
      })]
    }), showScrap && jsxs(InfoText, {
      children: [jsx(ScrapFilledIcon, {
        size: 12,
        fill: theme => theme.colors.foregroundDisabled
      }), `${formatComma(scrapCount >= scrapMaxCount ? scrapMaxCount : scrapCount)}`]
    })]
  });
}
const Container$m = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evlaem23"
} : {
  target: "evlaem23",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "19imocq",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px"
} : {
  name: "19imocq",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
});
const StyledIcon = /*#__PURE__*/_styled(Icon$1, process.env.NODE_ENV === "production" ? {
  target: "evlaem22"
} : {
  target: "evlaem22",
  label: "StyledIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1ygk9k8",
  styles: "color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px"
} : {
  name: "1ygk9k8",
  styles: "color:#35C5F0;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
});
var _ref$q = process.env.NODE_ENV === "production" ? {
  name: "1wcfv52",
  styles: "margin-right:0"
} : {
  name: "1hupf1e-Average",
  styles: "margin-right:0;label:Average;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
const Average = /*#__PURE__*/_styled("strong", process.env.NODE_ENV === "production" ? {
  target: "evlaem21"
} : {
  target: "evlaem21",
  label: "Average"
})("margin-right:4px;color:#2F3438;", ({
  experimentType
}) => experimentType === 'C' && _ref$q, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const InfoText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "evlaem20"
} : {
  target: "evlaem20",
  label: "InfoText"
})(process.env.NODE_ENV === "production" ? {
  name: "1eewaai",
  styles: "display:flex;align-items:center;font-size:12px;line-height:16px;font-weight:normal;color:#828C94;margin-right:4px"
} : {
  name: "1eewaai",
  styles: "display:flex;align-items:center;font-size:12px;line-height:16px;font-weight:normal;color:#828C94;margin-right:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ScrapExperimentInfo({
  product,
  experimentType,
  badgeMaxCount,
  isMdPick,
  flex,
  variant = 'lg',
  localeData = {},
  hideBadge,
  hideReview,
  hideStats,
  className,
  bottomArea
}) {
  const {
    name,
    isSelling,
    isDiscontinued,
    brand,
    originalPrice,
    sellingPrice,
    isSoldOut,
    type,
    reviewAvg,
    reviewCount,
    scrapCount,
    currency
  } = product;
  const isGlobal = !!currency;
  const showPrice = isGlobal || isSelling && !isDiscontinued;
  return jsxs(Container$l, {
    flex: flex,
    className: classNames('product-info', className),
    children: [jsxs(Header$5, {
      children: [jsx(Brand, {
        className: "product-brand",
        children: brand.name
      }), jsx(Name, {
        className: "product-name",
        variant: variant,
        children: name
      })]
    }), showPrice && jsx(Price, {
      originalPrice: originalPrice,
      sellingPrice: sellingPrice,
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      variant: variant,
      currency: currency,
      renderSuffix: () => jsx("span", {
        children: type === 'Deal' && ' 외'
      }),
      priceToken: localeData?.priceToken
    }), !isGlobal && jsx(ScrapExperimentStats, {
      reviewAvg: reviewAvg,
      reviewCount: reviewCount,
      scrapCount: scrapCount,
      hideReview: hideReview,
      hideStats: hideStats,
      isMdPick: isMdPick,
      experimentType: experimentType
    }), !hideBadge && jsx(Badges, {
      product: product,
      isMdPick: isMdPick,
      badgeMaxCount: badgeMaxCount
    }), bottomArea && bottomArea]
  });
}
var _ref2$7 = process.env.NODE_ENV === "production" ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : {
  name: "oyt7z3-Container",
  styles: "margin-left:12px;label:Container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
const Container$l = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e524o2r7"
} : {
  target: "e524o2r7",
  label: "Container"
})("width:100%;", ({
  flex
}) => flex && _ref2$7, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Header$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e524o2r6"
} : {
  target: "e524o2r6",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : {
  name: "1r0yqr6",
  styles: "margin-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm8udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFJeUIiLCJmaWxlIjoiSW5mby50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY2xhc3NuYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEZPTlRfU1RZTEUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IFByb2R1Y3QsIFZhcmlhbnQgfSBmcm9tICdAL2NvbW1lcmNlL3R5cGVzJztcbmltcG9ydCBQbGFjZWhvbGRlckFuaW1hdGlvbiBmcm9tICdAL2NvbXBvbmVudHMvUGxhY2Vob2xkZXJBbmltYXRpb24nO1xuaW1wb3J0IHsgUHJpY2UsIFByaWNlUGxhY2Vob2xkZXIgfSBmcm9tICdAL2NvbXBvbmVudHMvcHJvZHVjdC1jYXJkL2NvbXBvbmVudHMvSW5mby9QcmljZSc7XG5pbXBvcnQgeyBTdGF0c1BsYWNlaG9sZGVyIH0gZnJvbSAnQC9jb21wb25lbnRzL3Byb2R1Y3QtY2FyZC9jb21wb25lbnRzL0luZm8vU3RhdHMnO1xuaW1wb3J0IHsgQmFkZ2VzIH0gZnJvbSAnQC9jb21wb25lbnRzL3Byb2R1Y3QtY2FyZC9jb21wb25lbnRzL0luZm8vQmFkZ2VzJztcblxuaW1wb3J0IHsgU2NyYXBFeHBlcmltZW50U3RhdHMgfSBmcm9tICcuL1N0YXRzJztcblxuZXhwb3J0IGludGVyZmFjZSBMb2NhbGVEYXRhIHtcbiAgcHJpY2VUb2tlbj86IHN0cmluZztcbn1cblxuZXhwb3J0IGludGVyZmFjZSBJbmZvUHJvcHMge1xuICBwcm9kdWN0OiBQcm9kdWN0O1xuICBleHBlcmltZW50VHlwZTogJ0InIHwgJ0MnO1xuICBiYWRnZU1heENvdW50PzogbnVtYmVyO1xuICBpc01kUGljaz86IGJvb2xlYW47XG4gIGZsZXg/OiBib29sZWFuOyAvLyDrqqjrsJTsnbwg6rCA66Gc7ZiVIOyDge2SiOy5tOuTnOyXkOyEnCDsgqzsmqntlaAg6rK97JqwIO2VtOuLuSBwcm9wcyDstpTqsIAg7ZWE7JqUXG4gIHZhcmlhbnQ/OiBWYXJpYW50O1xuICBsb2NhbGVEYXRhPzogTG9jYWxlRGF0YTtcbiAgaGlkZUJhZGdlPzogYm9vbGVhbjtcbiAgaGlkZVJldmlldz86IGJvb2xlYW47XG4gIGhpZGVTdGF0cz86IGJvb2xlYW47XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgYm90dG9tQXJlYT86IFJlYWN0RWxlbWVudDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIFNjcmFwRXhwZXJpbWVudEluZm8oe1xuICBwcm9kdWN0LFxuICBleHBlcmltZW50VHlwZSxcbiAgYmFkZ2VNYXhDb3VudCxcbiAgaXNNZFBpY2ssXG4gIGZsZXgsXG4gIHZhcmlhbnQgPSAnbGcnLFxuICBsb2NhbGVEYXRhID0ge30sXG4gIGhpZGVCYWRnZSxcbiAgaGlkZVJldmlldyxcbiAgaGlkZVN0YXRzLFxuICBjbGFzc05hbWUsXG4gIGJvdHRvbUFyZWEsXG59OiBJbmZvUHJvcHMpOiBSZWFjdEVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgbmFtZSxcbiAgICBpc1NlbGxpbmcsXG4gICAgaXNEaXNjb250aW51ZWQsXG4gICAgYnJhbmQsXG4gICAgb3JpZ2luYWxQcmljZSxcbiAgICBzZWxsaW5nUHJpY2UsXG4gICAgaXNTb2xkT3V0LFxuICAgIHR5cGUsXG4gICAgcmV2aWV3QXZnLFxuICAgIHJldmlld0NvdW50LFxuICAgIHNjcmFwQ291bnQsXG4gICAgY3VycmVuY3ksXG4gIH0gPSBwcm9kdWN0O1xuICBjb25zdCBpc0dsb2JhbCA9ICEhY3VycmVuY3k7XG4gIGNvbnN0IHNob3dQcmljZSA9IGlzR2xvYmFsIHx8IChpc1NlbGxpbmcgJiYgIWlzRGlzY29udGludWVkKTtcblxuICByZXR1cm4gKFxuICAgIDxDb250YWluZXIgZmxleD17ZmxleH0gY2xhc3NOYW1lPXtjbGFzc25hbWVzKCdwcm9kdWN0LWluZm8nLCBjbGFzc05hbWUpfT5cbiAgICAgIDxIZWFkZXI+XG4gICAgICAgIDxCcmFuZCBjbGFzc05hbWU9XCJwcm9kdWN0LWJyYW5kXCI+XG4gICAgICAgICAgeyBicmFuZC5uYW1lIH1cbiAgICAgICAgPC9CcmFuZD5cbiAgICAgICAgPE5hbWUgY2xhc3NOYW1lPVwicHJvZHVjdC1uYW1lXCIgdmFyaWFudD17dmFyaWFudH0+XG4gICAgICAgICAgeyBuYW1lIH1cbiAgICAgICAgPC9OYW1lPlxuICAgICAgPC9IZWFkZXI+XG4gICAgICB7IHNob3dQcmljZSAmJiAoXG4gICAgICAgIDxQcmljZVxuICAgICAgICAgIG9yaWdpbmFsUHJpY2U9e29yaWdpbmFsUHJpY2V9XG4gICAgICAgICAgc2VsbGluZ1ByaWNlPXtzZWxsaW5nUHJpY2V9XG4gICAgICAgICAgaXNEaXNjb250aW51ZWQ9e2lzRGlzY29udGludWVkfVxuICAgICAgICAgIGlzU29sZE91dD17aXNTb2xkT3V0fVxuICAgICAgICAgIHZhcmlhbnQ9e3ZhcmlhbnR9XG4gICAgICAgICAgY3VycmVuY3k9e2N1cnJlbmN5fVxuICAgICAgICAgIHJlbmRlclN1ZmZpeD17KCkgPT4gKFxuICAgICAgICAgICAgPHNwYW4+XG4gICAgICAgICAgICAgIHsgdHlwZSA9PT0gJ0RlYWwnICYmICcg7Jm4JyB9XG4gICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgKX1cbiAgICAgICAgICBwcmljZVRva2VuPXtsb2NhbGVEYXRhPy5wcmljZVRva2VufVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICB7ICFpc0dsb2JhbCAmJiAoXG4gICAgICAgIDxTY3JhcEV4cGVyaW1lbnRTdGF0c1xuICAgICAgICAgIHJldmlld0F2Zz17cmV2aWV3QXZnfVxuICAgICAgICAgIHJldmlld0NvdW50PXtyZXZpZXdDb3VudH1cbiAgICAgICAgICBzY3JhcENvdW50PXtzY3JhcENvdW50fVxuICAgICAgICAgIGhpZGVSZXZpZXc9e2hpZGVSZXZpZXd9XG4gICAgICAgICAgaGlkZVN0YXRzPXtoaWRlU3RhdHN9XG4gICAgICAgICAgaXNNZFBpY2s9e2lzTWRQaWNrfVxuICAgICAgICAgIGV4cGVyaW1lbnRUeXBlPXtleHBlcmltZW50VHlwZX1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgICAgeyAhaGlkZUJhZGdlICYmIChcbiAgICAgICAgPEJhZGdlc1xuICAgICAgICAgIHByb2R1Y3Q9e3Byb2R1Y3R9XG4gICAgICAgICAgaXNNZFBpY2s9e2lzTWRQaWNrfVxuICAgICAgICAgIGJhZGdlTWF4Q291bnQ9e2JhZGdlTWF4Q291bnR9XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICAgIHsgYm90dG9tQXJlYSAmJiBib3R0b21BcmVhIH1cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIEluZm9QbGFjZWhvbGRlcigpOiBSZWFjdEVsZW1lbnQge1xuICByZXR1cm4gKFxuICAgIDxDb250YWluZXI+XG4gICAgICA8SGVhZGVyPlxuICAgICAgICA8QnJhbmRQbGFjZWhvbGRlciAvPlxuICAgICAgICA8TmFtZVBsYWNlaG9sZGVyIC8+XG4gICAgICA8L0hlYWRlcj5cbiAgICAgIDxTdHlsZWRQcmljZVBsYWNlaG9sZGVyIC8+XG4gICAgICA8U3R5bGVkU3RhdHNQbGFjZWhvbGVyIC8+XG4gICAgPC9Db250YWluZXI+XG4gICk7XG59XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXY8eyBmbGV4PzogYm9vbGVhbiB9PmBcbiAgd2lkdGg6IDEwMCU7XG4gICR7KHsgZmxleCB9KSA9PiBmbGV4ICYmIGNzc2BcbiAgICBtYXJnaW4tbGVmdDogMTJweDtcbiAgYH1cbmA7XG5cbmNvbnN0IEhlYWRlciA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbi10b3A6IDEwcHg7XG5gO1xuXG5jb25zdCBCcmFuZCA9IHN0eWxlZC5kaXZgXG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgbGluZS1oZWlnaHQ6IDE2cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG4gIGNvbG9yOiAjODI4Qzk0O1xuYDtcblxuY29uc3QgbmFtZVN0eWxlID0gY3NzYFxuICBmb250LXNpemU6IDE0cHg7XG4gIGxpbmUtaGVpZ2h0OiAxOHB4O1xuICBkaXNwbGF5OiBibG9jaztcbiAgbWF4LWhlaWdodDogMzZweDtcbiAgbWFyZ2luLXRvcDogNHB4O1xuICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG4gIHRyYW5zaXRpb246IC4xcyBvcGFjaXR5O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gIC13ZWJraXQtbGluZS1jbGFtcDogMjsgLyog65287J247IiYICovXG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gIHdvcmQtd3JhcDogYnJlYWstd29yZDtcbmA7XG5cbmNvbnN0IE5hbWUgPSBzdHlsZWQuc3Bhbjx7IHZhcmlhbnQ6IFZhcmlhbnQgfT5gXG4gICR7bmFtZVN0eWxlfVxuICBjb2xvcjogIzJGMzQzODtcbiAgJHsoeyB2YXJpYW50IH0pID0+ICh2YXJpYW50ID09PSAnc20nIHx8IHZhcmlhbnQgPT09ICdtZCcpICYmIGNzc2BcbiAgICBmb250LXNpemU6IDEycHg7XG4gICAgbGluZS1oZWlnaHQ6IDE2cHg7XG4gIGB9XG5gO1xuXG5jb25zdCBCcmFuZFBsYWNlaG9sZGVyID0gc3R5bGVkKFBsYWNlaG9sZGVyQW5pbWF0aW9uKWBcbiAgJHtGT05UX1NUWUxFLmNhcHRpb24xfVxuICAmOmJlZm9yZSB7XG4gICAgY29udGVudDogJ1xcXFwwMGEwJztcbiAgfVxuICBkaXNwbGF5OiBibG9jaztcbiAgd29yZC1icmVhazogYnJlYWstYWxsO1xuICB3aWR0aDogODBweDtcbmA7XG5cbmNvbnN0IE5hbWVQbGFjZWhvbGRlciA9IHN0eWxlZChQbGFjZWhvbGRlckFuaW1hdGlvbilgXG4gICR7bmFtZVN0eWxlfVxuICAmOmJlZm9yZSB7XG4gICAgY29udGVudDogJ1xcXFwwMGEwJztcbiAgfVxuYDtcblxuY29uc3QgU3R5bGVkUHJpY2VQbGFjZWhvbGRlciA9IHN0eWxlZChQcmljZVBsYWNlaG9sZGVyKWBcbiAgbWFyZ2luLXRvcDogM3B4O1xuICBsaW5lLWhlaWdodDogMjFweDtcbiAgd2lkdGg6IDEyMHB4O1xuYDtcblxuY29uc3QgU3R5bGVkU3RhdHNQbGFjZWhvbGVyID0gc3R5bGVkKFN0YXRzUGxhY2Vob2xkZXIpYFxuICBtYXJnaW4tdG9wOiAzcHg7XG4gIHdpZHRoOiAxMDBweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});
const Brand = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e524o2r5"
} : {
  target: "e524o2r5",
  label: "Brand"
})(process.env.NODE_ENV === "production" ? {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94"
} : {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});
const nameStyle = process.env.NODE_ENV === "production" ? {
  name: "wwgkbi",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word"
} : {
  name: "kdxkly-nameStyle",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word;label:nameStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var _ref$p = process.env.NODE_ENV === "production" ? {
  name: "xolxwr",
  styles: "font-size:12px;line-height:16px"
} : {
  name: "1qwpow5-Name",
  styles: "font-size:12px;line-height:16px;label:Name;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
const Name = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e524o2r4"
} : {
  target: "e524o2r4",
  label: "Name"
})(nameStyle, " color:#2F3438;", ({
  variant
}) => (variant === 'sm' || variant === 'md') && _ref$p, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e524o2r3"
} : {
  target: "e524o2r3",
  label: "BrandPlaceholder"
})(FONT_STYLE.caption1, " &:before{content:'\\00a0';}display:block;word-break:break-all;width:80px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e524o2r2"
} : {
  target: "e524o2r2",
  label: "NamePlaceholder"
})(nameStyle, " &:before{content:'\\00a0';}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/*#__PURE__*/_styled(PricePlaceholder, process.env.NODE_ENV === "production" ? {
  target: "e524o2r1"
} : {
  target: "e524o2r1",
  label: "StyledPricePlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px"
} : {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});
/*#__PURE__*/_styled(StatsPlaceholder, process.env.NODE_ENV === "production" ? {
  target: "e524o2r0"
} : {
  target: "e524o2r0",
  label: "StyledStatsPlaceholer"
})(process.env.NODE_ENV === "production" ? {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px"
} : {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
});

function ScrapExperimentProductCard(props) {
  const {
    product,
    experimentType,
    href,
    badgeMaxCount,
    flex,
    isMdPick,
    logData,
    scrapData,
    localeData,
    hideBadge,
    hideReview,
    hideStats,
    className,
    renderOverlay,
    onClick,
    linkComponent,
    infoBottomArea,
    infoVariant
  } = props;
  const {
    detailLogData
  } = useProductCardLogData({
    product,
    badgeMaxCount
  });
  const bucketLogData = {
    ...logData,
    type: product.type?.toLowerCase() || 'production',
    id: product.id,
    data: {
      ...logData?.data,
      ...detailLogData
    }
  };
  const {
    ref
  } = ce({
    logData: bucketLogData
  });
  const LinkComponent = linkComponent;
  const handleClickProductLink = event => {
    if (logData) {
      L({
        category: 'click',
        ...bucketLogData
      });
    }
    onClick?.(event);
  };
  return jsxs(Container$n, {
    className: className,
    ref: ref,
    flex: flex,
    children: [LinkComponent != null && jsx(LinkComponent, {
      href: href,
      onClick: handleClickProductLink
    }), jsx(Thumbnail$1, {
      product: product,
      scrapData: scrapData,
      flex: flex,
      isMdPick: isMdPick,
      logData: bucketLogData,
      renderOverlay: renderOverlay
    }), jsx(ScrapExperimentInfo, {
      product: product,
      experimentType: experimentType,
      badgeMaxCount: badgeMaxCount,
      flex: flex,
      isMdPick: isMdPick,
      localeData: localeData,
      hideBadge: hideBadge,
      hideReview: hideReview,
      hideStats: hideStats,
      bottomArea: infoBottomArea,
      variant: infoVariant
    })]
  });
}

// TODO: 실험 종료 후 대응 필요
const CommerceProductCard = ({
  experimentType,
  scrapExperimentType,
  ...productCardProps
}) => {
  if (scrapExperimentType === 'B' || scrapExperimentType === 'C') {
    return jsx(ScrapExperimentProductCard, {
      experimentType: scrapExperimentType,
      ...productCardProps
    });
  }
  return jsx(ProductCard, {
    ...productCardProps
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliverySummary({
  logisticsName,
  invoiceNumber,
  deliveryStatus,
  deliveryTrackingNoticeDate,
  isOverseasPurchase,
  shipmentType,
  deliveryTargetType
}) {
  const theme = useTheme();
  const {
    open
  } = useSnackbar();
  const handleClickCopy = () => {
    copyTextToClipboard(invoiceNumber);
    open({
      content: '운송장 번호를 복사했습니다.'
    });
  };
  let dateFormat = null;
  if (deliveryTrackingNoticeDate) {
    dateFormat = getDeliveryTackingNoticeFormat({
      date: deliveryTrackingNoticeDate,
      isWithinDue: isOverseasPurchase || shipmentType === SHIPMENT_TYPE.SELLER,
      deliveryStatus,
      deliveryTargetType
    });
  }
  return jsxs(Wrapper$3, {
    children: [dateFormat && jsxs(ExpectedInfo, {
      children: [jsx("span", {
        className: "due",
        children: `${dateFormat.due} `
      }), jsx("span", {
        className: classNames('status', {
          delayed: dateFormat.status === '배송지연중'
        }),
        children: dateFormat.status
      })]
    }), jsxs(LogisticInfo, {
      children: [jsxs(LogisticName, {
        children: [jsx(TruckIcon, {
          className: "icon",
          size: 24,
          "data-testid": "truck-icon"
        }), `${logisticsName} ${invoiceNumber}`]
      }), jsx(OutlineButton, {
        css: /*#__PURE__*/css("background-color:", theme.content.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:DeliverySummary;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        size: 32,
        variant: "base1",
        onClick: handleClickCopy,
        children: "\uBCF5\uC0AC"
      })]
    })]
  });
}
const Wrapper$3 = /*#__PURE__*/_styled("section", process.env.NODE_ENV === "production" ? {
  target: "e185skhs3"
} : {
  target: "e185skhs3",
  label: "Wrapper"
})("margin-bottom:40px;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ExpectedInfo = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e185skhs2"
} : {
  target: "e185skhs2",
  label: "ExpectedInfo"
})(FONT_STYLE.title2, ";font-weight:700;text-align:center;margin-bottom:20px;.due{color:", ({
  theme
}) => theme.content.primary1.thick, ";}.status.delayed{color:", ({
  theme
}) => theme.content.base2, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const LogisticInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e185skhs1"
} : {
  target: "e185skhs1",
  label: "LogisticInfo"
})("display:flex;justify-content:space-between;align-items:center;padding:8px 12px;background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyRytCIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY2xhc3NOYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBUcnVja0ljb24sXG4gIHVzZVNuYWNrYmFyLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBPdXRsaW5lQnV0dG9uIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgRGVsaXZlcnlUYXJnZXRUeXBlLCBEZWxpdmVyeVRyYWNraW5nU3RhdHVzLCBTSElQTUVOVF9UWVBFLCBTaGlwbWVudFR5cGUgfSBmcm9tICdAY29tbWVyY2UvdHlwZXMnO1xuaW1wb3J0IHsgY29weVRleHRUb0NsaXBib2FyZCB9IGZyb20gJ0BidWNrZXRwbGFjZS9saWInO1xuaW1wb3J0IHsgZ2V0RGVsaXZlcnlUYWNraW5nTm90aWNlRm9ybWF0IH0gZnJvbSAnQGNvbW1lcmNlL3V0aWxzJztcblxuZXhwb3J0IGludGVyZmFjZSBEZWxpdmVyeVN1bW1hcnlQcm9wcyB7XG4gIC8qKiDtg53rsLDsgqwg66qFICovXG4gIGxvZ2lzdGljc05hbWU6IHN0cmluZztcbiAgLyoqIOyGoeyepeuyiO2YuCAqL1xuICBpbnZvaWNlTnVtYmVyOiBzdHJpbmc7XG4gIC8qKiDrsLDshqHsnZgg66qp7KCB7J20IOuQmOuKlCDtg4DsnoUgKOyjvOusuOuwsOyGoSwg6rWQ7ZmYL+yDge2SiCDsiJjqsbAsIOyjvOusuOyerOuwsOyGoSkgKi9cbiAgZGVsaXZlcnlUYXJnZXRUeXBlOiBEZWxpdmVyeVRhcmdldFR5cGU7XG4gIC8qKiDrsLDshqEg7KeE7ZaJIOyDge2DnCAqL1xuICBkZWxpdmVyeVN0YXR1czogRGVsaXZlcnlUcmFja2luZ1N0YXR1cztcbiAgLyoqXG4gICAqICDrsLDshqEg7KeE7ZaJIOyDge2DnOyXkCDsmIjsg4Eg67CPIOyZhOujjCDrgqDsp5xcbiAgICogIOuwsOyGoeykkSAtPiDrsLDshqHsmIjsoJXsnbwsXG4gICAqICDrsLDshqHsmYTro4wgLT4g67Cw7Iah7JmE66OM7J28XG4gICAqICDsiJjqsbDsmIjsoJUgLT4g7IiY6rGw7JiI7KCV7J28ICjrsLDshqHquLDsgqzqsIAg7IOB7ZKI7J2EIO2UveyXhe2VoCDsmIjsoJXsnbwpXG4gICAqICDsiJjqsbDspJEgLT4g7IiY6rGw7JmE66OM7JiI7KCV7J28ICjsiJjqsbDrkJwg7IOB7ZKI7J20IO2MkOunpOyekOyXkOqyjCDsoITri6zrkKAg7JiI7KCV7J28KVxuICAgKiAg7IiY6rGw7JmE66OMIC0+IOyImOqxsOyZhOujjOydvCAo7IiY6rGw65CcIOyDge2SiOydtCDtjJDrp6TsnpDsl5Dqsowg7Iuk7KCcIOyghOuLrOuQnCDsmIjsoJXsnbwpXG4gICAqICovXG4gIGRlbGl2ZXJ5VHJhY2tpbmdOb3RpY2VEYXRlOiBEYXRlIHwgbnVsbDtcbiAgc2hpcG1lbnRUeXBlPzogU2hpcG1lbnRUeXBlO1xuICBpc092ZXJzZWFzUHVyY2hhc2U/OiBib29sZWFuO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gRGVsaXZlcnlTdW1tYXJ5KHtcbiAgbG9naXN0aWNzTmFtZSxcbiAgaW52b2ljZU51bWJlcixcbiAgZGVsaXZlcnlTdGF0dXMsXG4gIGRlbGl2ZXJ5VHJhY2tpbmdOb3RpY2VEYXRlLFxuICBpc092ZXJzZWFzUHVyY2hhc2UsXG4gIHNoaXBtZW50VHlwZSxcbiAgZGVsaXZlcnlUYXJnZXRUeXBlLFxufTogRGVsaXZlcnlTdW1tYXJ5UHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IHsgb3BlbiB9ID0gdXNlU25hY2tiYXIoKTtcbiAgY29uc3QgaGFuZGxlQ2xpY2tDb3B5ID0gKCk6IHZvaWQgPT4ge1xuICAgIGNvcHlUZXh0VG9DbGlwYm9hcmQoaW52b2ljZU51bWJlcik7XG4gICAgb3Blbih7IGNvbnRlbnQ6ICfsmrTshqHsnqUg67KI7Zi466W8IOuzteyCrO2WiOyKteuLiOuLpC4nIH0pO1xuICB9O1xuXG4gIGxldCBkYXRlRm9ybWF0OiBSZXR1cm5UeXBlPHR5cGVvZiBnZXREZWxpdmVyeVRhY2tpbmdOb3RpY2VGb3JtYXQ+IHwgbnVsbCA9IG51bGw7XG4gIGlmIChkZWxpdmVyeVRyYWNraW5nTm90aWNlRGF0ZSkge1xuICAgIGRhdGVGb3JtYXQgPSBnZXREZWxpdmVyeVRhY2tpbmdOb3RpY2VGb3JtYXQoe1xuICAgICAgZGF0ZTogZGVsaXZlcnlUcmFja2luZ05vdGljZURhdGUsXG4gICAgICBpc1dpdGhpbkR1ZTogaXNPdmVyc2Vhc1B1cmNoYXNlIHx8IHNoaXBtZW50VHlwZSA9PT0gU0hJUE1FTlRfVFlQRS5TRUxMRVIsXG4gICAgICBkZWxpdmVyeVN0YXR1cyxcbiAgICAgIGRlbGl2ZXJ5VGFyZ2V0VHlwZSxcbiAgICB9KTtcbiAgfVxuXG4gIHJldHVybiAoXG4gICAgPFdyYXBwZXI+XG4gICAgICB7IGRhdGVGb3JtYXQgJiYgKFxuICAgICAgICA8RXhwZWN0ZWRJbmZvPlxuICAgICAgICAgIDxzcGFuIGNsYXNzTmFtZT1cImR1ZVwiPnsgYCR7ZGF0ZUZvcm1hdC5kdWV9IGAgfTwvc3Bhbj5cbiAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9e2NsYXNzTmFtZXMoJ3N0YXR1cycsIHsgZGVsYXllZDogZGF0ZUZvcm1hdC5zdGF0dXMgPT09ICfrsLDshqHsp4Dsl7DspJEnIH0pfT57IGRhdGVGb3JtYXQuc3RhdHVzIH08L3NwYW4+XG4gICAgICAgIDwvRXhwZWN0ZWRJbmZvPlxuICAgICAgKSB9XG4gICAgICA8TG9naXN0aWNJbmZvPlxuICAgICAgICA8TG9naXN0aWNOYW1lPlxuICAgICAgICAgIDxUcnVja0ljb24gY2xhc3NOYW1lPVwiaWNvblwiIHNpemU9ezI0fSBkYXRhLXRlc3RpZD1cInRydWNrLWljb25cIiAvPlxuICAgICAgICAgIHsgYCR7bG9naXN0aWNzTmFtZX0gJHtpbnZvaWNlTnVtYmVyfWAgfVxuICAgICAgICA8L0xvZ2lzdGljTmFtZT5cbiAgICAgICAgPE91dGxpbmVCdXR0b25cbiAgICAgICAgICBjc3M9e2Nzc2BiYWNrZ3JvdW5kLWNvbG9yOiAke3RoZW1lLmNvbnRlbnQud2hpdGV9O2B9XG4gICAgICAgICAgc2l6ZT17MzJ9XG4gICAgICAgICAgdmFyaWFudD1cImJhc2UxXCJcbiAgICAgICAgICBvbkNsaWNrPXtoYW5kbGVDbGlja0NvcHl9XG4gICAgICAgID5cbiAgICAgICAgICDrs7XsgqxcbiAgICAgICAgPC9PdXRsaW5lQnV0dG9uPlxuICAgICAgPC9Mb2dpc3RpY0luZm8+XG4gICAgPC9XcmFwcGVyPlxuICApO1xufVxuXG5jb25zdCBXcmFwcGVyID0gc3R5bGVkLnNlY3Rpb25gXG4gIG1hcmdpbi1ib3R0b206IDQwcHg7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuYDtcblxuY29uc3QgRXhwZWN0ZWRJbmZvID0gc3R5bGVkLmgxYFxuICAke0ZPTlRfU1RZTEUudGl0bGUyfTtcbiAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuICAuZHVlIHtcbiAgICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLnRoaWNrfTtcbiAgfVxuICAuc3RhdHVzLmRlbGF5ZWQge1xuICAgIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICB9XG5gO1xuXG5jb25zdCBMb2dpc3RpY0luZm8gPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDhweCAxMnB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYmFja2dyb3VuZC5ncm91cGVkQmFzZX07XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbmA7XG5cbmNvbnN0IExvZ2lzdGljTmFtZSA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAuaWNvbiB7XG4gICAgbWFyZ2luLXJpZ2h0OiAxMnB4O1xuICB9XG5gO1xuIl19 */"));
const LogisticName = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e185skhs0"
} : {
  target: "e185skhs0",
  label: "LogisticName"
})(process.env.NODE_ENV === "production" ? {
  name: "1ec23nz",
  styles: "display:flex;align-items:center;.icon{margin-right:12px;}"
} : {
  name: "1ec23nz",
  styles: "display:flex;align-items:center;.icon{margin-right:12px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
});

function DeliveryTimeLineStep({
  highLight,
  showArrow,
  fillPath,
  header,
  children,
  className
}) {
  return jsxs(Wrapper$2, {
    className: classNames(className, {
      highLight,
      fillPath
    }),
    "data-testid": "delivery-time-line-step",
    children: [showArrow && jsx(ArrowMark, {
      children: jsx(ChevronDownIcon$1, {
        size: 12,
        "data-testid": "arrow-down-icon"
      })
    }), header && jsx(Header$4, {
      children: header
    }), children]
  });
}
const Header$4 = /*#__PURE__*/_styled("h3", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca2"
} : {
  target: "e12hlzca2",
  label: "Header"
})(FONT_STYLE.subTitle1, ";color:", ({
  theme
}) => theme.content.base3, ";font-weight:700;display:flex;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ArrowMark = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca1"
} : {
  target: "e12hlzca1",
  label: "ArrowMark"
})("display:inline-flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";justify-content:center;position:absolute;left:-4px;top:-6px;width:36px;height:36px;border-radius:50%;background-color:", ({
  theme
}) => theme.content.white, ";border:2px solid ", ({
  theme
}) => theme.content.primary1.basic, ";box-sizing:border-box;z-index:5;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Wrapper$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca0"
} : {
  target: "e12hlzca0",
  label: "Wrapper"
})("padding-left:44px;position:relative;min-height:60px;padding-bottom:16px;&:last-of-type{min-height:0;}&::before{content:\"\";position:absolute;width:20px;display:inline-block;top:0;bottom:0;left:4px;background-color:", ({
  theme
}) => theme.content.base4, ";}&.fillPath::before{background-color:", ({
  theme
}) => theme.content.primary1.basic, ";}&:first-of-type::before{border-top-left-radius:20px;border-top-right-radius:20px;}&:last-of-type::before{border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:20px;}&::after{content:\"\";position:absolute;background-color:white;display:inline-block;width:8px;height:8px;left:10px;top:6px;z-index:3;border-radius:50%;}&.fillPath{", Header$4, "{color:", ({
  theme
}) => theme.content.base1, ";}}&.highLight{", Header$4, "{color:", ({
  theme
}) => theme.content.primary1.thick, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$o = process.env.NODE_ENV === "production" ? {
  name: "y1f223",
  styles: "margin:auto"
} : {
  name: "i5sq5b-DeliveryWayPoint",
  styles: "margin:auto;label:DeliveryWayPoint;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
function DeliveryWayPoint({
  currentLocation,
  className,
  empName,
  datetime,
  position,
  empPhone
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const formatDate = datetime && format$1(parseISO(datetime), 'M/d (EE) HH:mm', {
    locale: ko
  });
  return jsxs(Wrapper$1, {
    className: className,
    children: [jsx(Header$3, {
      className: classNames({
        highlight: currentLocation
      }),
      children: position
    }), jsxs(Info, {
      children: [`${formatDate} `, empName && jsxs(Fragment$1, {
        children: ["\xB7", ` ${empName} `]
      }), currentLocation && empPhone && (isMobile ? jsx(CallButton, {
        href: `tel:${empPhone}`,
        children: jsx(CallIcon, {
          size: 18,
          css: _ref$o
        })
      }) : empPhone)]
    })]
  });
}
const Wrapper$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo3"
} : {
  target: "e3nenqo3",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1u53ekv",
  styles: "padding-bottom:16px"
} : {
  name: "1u53ekv",
  styles: "padding-bottom:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
});
const Header$3 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo2"
} : {
  target: "e3nenqo2",
  label: "Header"
})(FONT_STYLE.subTitle2, ";&.highlight{font-weight:500;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Info = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo1"
} : {
  target: "e3nenqo1",
  label: "Info"
})(FONT_STYLE.body2_small, ";color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const CallButton = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo0"
} : {
  target: "e3nenqo0",
  label: "CallButton"
})("border:1px solid ", ({
  theme
}) => theme.content.base4, ";border-radius:50%;width:26px;height:26px;display:inline-flex;margin-left:4px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$n = process.env.NODE_ENV === "production" ? {
  name: "pbbd9q",
  styles: "padding-bottom:0px"
} : {
  name: "1quos74-DeliveryTimeLine",
  styles: "padding-bottom:0px;label:DeliveryTimeLine;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref2$6 = process.env.NODE_ENV === "production" ? {
  name: "18g08sj",
  styles: "padding-bottom:0"
} : {
  name: "84nixw-DeliveryTimeLine",
  styles: "padding-bottom:0;label:DeliveryTimeLine;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
function DeliveryTimeLine({
  details,
  status,
  isError,
  message,
  targetType
}) {
  const [isShowDetail, setIsShowDetail] = useState(false);
  if (isError) {
    return jsx(ErrorMessage, {
      children: breakLines(message)
    });
  }
  if (!details) {
    return null;
  }
  const detailsLength = details.length;
  const isExistWayPoint = detailsLength > 0;
  const recentWayPoint = isExistWayPoint && details[detailsLength - 1];
  const passedWayPoints = isExistWayPoint ? details.slice(0, detailsLength - 1) : undefined;
  const canShowPassedWayPoints = passedWayPoints && passedWayPoints?.length > 0;
  const targetTypeKorean = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거' : '배송';
  return jsxs(Fragment$1, {
    children: [jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 준비중`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS, DELIVERY_TRACKING_STATUS.SCHEDULED].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.READY,
      showArrow: status === DELIVERY_TRACKING_STATUS.READY
    }), targetType === DELIVERY_TARGET_TYPE.PICKUP && jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 예정`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.SCHEDULED,
      showArrow: status === DELIVERY_TRACKING_STATUS.SCHEDULED
    }), jsx(DeliveryTimeLineStep, {
      header: [`${targetTypeKorean}중`, canShowPassedWayPoints && jsx(ShowDetailButton, {
        isShowDetail: isShowDetail,
        onClick: () => setIsShowDetail(!isShowDetail)
      }, 1)],
      css: canShowPassedWayPoints && status === DELIVERY_TRACKING_STATUS.INPROGRESS && _ref2$6,
      highLight: status === DELIVERY_TRACKING_STATUS.INPROGRESS
      // 배송이 완료된 상태이거나 배송중이면서 하나 이상의 경유지를 방문하였을 경우
      ,
      fillPath: status === DELIVERY_TRACKING_STATUS.COMPLETE || status === DELIVERY_TRACKING_STATUS.INPROGRESS && isExistWayPoint
      // 배송중이지만 경유지 정보가 주어지지 않았을 경우
      ,
      showArrow: status === DELIVERY_TRACKING_STATUS.INPROGRESS && !isExistWayPoint,
      children: isShowDetail && jsx(PassedPointList, {
        children: passedWayPoints?.map((item, index) => jsx(DeliveryWayPoint, {
          ...item
        }, index))
      })
    }), recentWayPoint && status === DELIVERY_TRACKING_STATUS.INPROGRESS && jsx(DeliveryTimeLineStep, {
      highLight: true,
      showArrow: true,
      fillPath: false,
      children: jsx(DeliveryWayPoint, {
        ...recentWayPoint,
        currentLocation: true
      })
    }), jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean}완료`,
      highLight: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      showArrow: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      fillPath: false,
      children: status === DELIVERY_TRACKING_STATUS.COMPLETE && recentWayPoint && jsx(DeliveryWayPoint, {
        css: _ref$n,
        ...recentWayPoint,
        position: "",
        currentLocation: true
      })
    })]
  });
}
function ShowDetailButton({
  isShowDetail,
  onClick
}) {
  const text = isShowDetail ? '접기' : '자세히보기';
  return jsxs(WayPointDetailButton, {
    onClick: onClick,
    children: [text, isShowDetail ? jsx(ChevronUpIcon, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-up-icon"
    }) : jsx(ChevronDownIcon$1, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-down-icon"
    })]
  });
}

// dot(.)을 기준으로 라인을 나누어 렌더링
function breakLines(message) {
  return message.split('.').map((line, index) => jsxs(Fragment$2, {
    children: [line, jsx("br", {})]
  }, index));
}
const WayPointDetailButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz2"
} : {
  target: "e1k86jnz2",
  label: "WayPointDetailButton"
})(RESET_BUTTON, ";", FONT_STYLE.subTitle2, ";font-weight:400;margin-left:8px;margin-right:2px;color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;.icon{margin-left:2px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ErrorMessage = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz1"
} : {
  target: "e1k86jnz1",
  label: "ErrorMessage"
})(FONT_STYLE.body2, ";color:", ({
  theme
}) => theme.content.base2, ";text-align:center;padding:24px 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const PassedPointList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz0"
} : {
  target: "e1k86jnz0",
  label: "PassedPointList"
})(process.env.NODE_ENV === "production" ? {
  name: "de9hf",
  styles: "padding-top:16px"
} : {
  name: "de9hf",
  styles: "padding-top:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function PhoneButton({
  phoneNumber,
  name
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile' || breakpoint === 'tablet';
  const theme = useTheme();

  // FIXME 디자인시스템의 OutlineButtonWithIcon컴포넌트에서 anchoring을 정상 지원할 경우
  //  컴포넌트에서 처리
  //  관련 이슈 https://github.com/bucketplace/design-system/issues/238
  const handlePhoneCall = () => {
    const a = document.createElement('a');
    a.href = `tel:${phoneNumber}`;
    a.click();
  };
  return isMobile ? jsx(PhoneMobileButton, {
    text: name,
    icon: "call_outline",
    color: theme.content.base2,
    size: 40,
    full: true,
    variant: "base1",
    onClick: handlePhoneCall
  }) : jsxs(PhoneInfo, {
    children: [jsx("span", {
      className: "label",
      children: name
    }), jsx("span", {
      className: "phone-number",
      children: phoneNumber
    })]
  });
}
const PhoneMobileButton = /*#__PURE__*/_styled(OutlineButtonWithIcon, process.env.NODE_ENV === "production" ? {
  target: "eoi3ru91"
} : {
  target: "eoi3ru91",
  label: "PhoneMobileButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1ti5vbu",
  styles: "letter-spacing:-0.4px"
} : {
  name: "1ti5vbu",
  styles: "letter-spacing:-0.4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
});
const PhoneInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eoi3ru90"
} : {
  target: "eoi3ru90",
  label: "PhoneInfo"
})(FONT_STYLE.caption1, ";background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;height:40px;display:flex;padding:0 20px;align-items:center;justify-content:center;flex:1 1 0;min-width:0;.label{color:", ({
  theme
}) => theme.content.base2, ";margin-right:4px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}.phone-number{white-space:nowrap;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliveryOrderInfo({
  productName,
  destinationAddress,
  optionName,
  receiverName,
  productImageUrl,
  sellerPhone,
  sellerName,
  quantity,
  onClickProduct,
  targetType
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const title = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거정보' : '배송지정보';
  return jsxs(Wrapper, {
    children: [jsx(Header$2, {
      children: title
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uC8FC\uC18C"
      }), destinationAddress]
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uBC1B\uB294 \uC0AC\uB78C"
      }), receiverName]
    }), jsxs(Content$3, {
      onClick: onClickProduct,
      children: [jsx(ProductImage, {
        alt: `${productName}`,
        src: productImageUrl ?? ''
      }), jsxs(ProductExplanation, {
        children: [jsx(ProductName, {
          children: productName
        }), jsx(OptionName, {
          children: `${optionName} • ${quantity}개`
        })]
      })]
    }), jsxs(PhoneNumbersWrapper, {
      children: [sellerPhone && jsx(PhoneButton, {
        phoneNumber: formatPhoneNumber(sellerPhone),
        name: isMobile ? '판매자 전화문의' : sellerName ?? ''
      }), jsx(PhoneButton, {
        phoneNumber: "1670-0876",
        name: "\uC624\uB298\uC758\uC9D1 \uACE0\uAC1D\uC13C\uD130"
      })]
    })]
  });
}
const Wrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx9"
} : {
  target: "e1yc6enx9",
  label: "Wrapper"
})("color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Header$2 = /*#__PURE__*/_styled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx8"
} : {
  target: "e1yc6enx8",
  label: "Header"
})(FONT_STYLE.subTitle1, ";font-weight:bold;margin-bottom:20px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const InfoRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx7"
} : {
  target: "e1yc6enx7",
  label: "InfoRow"
})("display:flex;", FONT_STYLE.body1_small, ";margin-bottom:6px;&:nth-of-type(2){margin-bottom:20px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const InfoLabel = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx6"
} : {
  target: "e1yc6enx6",
  label: "InfoLabel"
})("display:inherit;min-width:68px;color:", ({
  theme
}) => theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxRzZCIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1vdXNlRXZlbnQsIFJlYWN0RWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7XG4gIEZPTlRfU1RZTEUsXG4gIFJlc2l6ZUltYWdlLFxuICB1c2VSZXNwb25zaXZlLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IERFTElWRVJZX1RBUkdFVF9UWVBFLCBEZWxpdmVyeVRhcmdldFR5cGUgfSBmcm9tICdAY29tbWVyY2UvdHlwZXMnO1xuaW1wb3J0IHsgZm9ybWF0UGhvbmVOdW1iZXIgfSBmcm9tICdAY29tbWVyY2UvdXRpbHMnO1xuXG5pbXBvcnQgeyBQaG9uZUJ1dHRvbiB9IGZyb20gJy4vUGhvbmVCdXR0b24nO1xuXG5leHBvcnQgaW50ZXJmYWNlIERlbGl2ZXJ5T3JkZXJJbmZvUHJvcHMge1xuICAvKiog67Cw7IahIOycoO2YlSAqL1xuICB0YXJnZXRUeXBlOiBEZWxpdmVyeVRhcmdldFR5cGU7XG4gIC8qKiDsg4HtkojrqoUgKi9cbiAgcHJvZHVjdE5hbWU6IHN0cmluZztcbiAgLyoqIOyDge2SiCDsnbTrr7jsp4AgKi9cbiAgcHJvZHVjdEltYWdlVXJsPzogc3RyaW5nO1xuICAvKiog7Ji17IWY66qFICovXG4gIG9wdGlvbk5hbWU6IHN0cmluZztcbiAgLyoqIOuwsOyGoeyngCDso7zshowgKi9cbiAgZGVzdGluYXRpb25BZGRyZXNzOiBzdHJpbmc7XG4gIC8qKiDsiJjroLnsnbgg7J2066aEICovXG4gIHJlY2VpdmVyTmFtZTogc3RyaW5nO1xuICAvKiog7YyQ66ek7J6QIOydtOumhCAqL1xuICBzZWxsZXJOYW1lOiBzdHJpbmc7XG4gIC8qKiDtjJDrp6TsnpAg7KCE7ZmU67KI7Zi4ICovXG4gIHNlbGxlclBob25lPzogc3RyaW5nO1xuICAvKiog7IiY65+JICovXG4gIHF1YW50aXR5OiBudW1iZXI7XG4gIC8qKiovXG4gIG9uQ2xpY2tQcm9kdWN0OiAoZTogTW91c2VFdmVudDxIVE1MSW1hZ2VFbGVtZW50PikgPT4gdm9pZDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIERlbGl2ZXJ5T3JkZXJJbmZvKHtcbiAgcHJvZHVjdE5hbWUsXG4gIGRlc3RpbmF0aW9uQWRkcmVzcyxcbiAgb3B0aW9uTmFtZSxcbiAgcmVjZWl2ZXJOYW1lLFxuICBwcm9kdWN0SW1hZ2VVcmwsXG4gIHNlbGxlclBob25lLFxuICBzZWxsZXJOYW1lLFxuICBxdWFudGl0eSxcbiAgb25DbGlja1Byb2R1Y3QsXG4gIHRhcmdldFR5cGUsXG59OiBEZWxpdmVyeU9yZGVySW5mb1Byb3BzKTogUmVhY3RFbGVtZW50IHtcbiAgY29uc3QgeyBicmVha3BvaW50IH0gPSB1c2VSZXNwb25zaXZlKHt9KTtcbiAgY29uc3QgaXNNb2JpbGUgPSBbJ21vYmlsZScsICd0YWJsZXQnXS5pbmNsdWRlcyhicmVha3BvaW50ID8/ICcnKTtcblxuICBjb25zdCB0aXRsZSA9IHRhcmdldFR5cGUgPT09IERFTElWRVJZX1RBUkdFVF9UWVBFLlBJQ0tVUCA/ICfsiJjqsbDsoJXrs7QnIDogJ+uwsOyGoeyngOygleuztCc7XG5cbiAgcmV0dXJuIChcbiAgICA8V3JhcHBlcj5cbiAgICAgIDxIZWFkZXI+eyB0aXRsZSB9PC9IZWFkZXI+XG4gICAgICA8SW5mb1Jvdz5cbiAgICAgICAgPEluZm9MYWJlbD7so7zshow8L0luZm9MYWJlbD5cbiAgICAgICAgeyBkZXN0aW5hdGlvbkFkZHJlc3MgfVxuICAgICAgPC9JbmZvUm93PlxuICAgICAgPEluZm9Sb3c+XG4gICAgICAgIDxJbmZvTGFiZWw+67Cb64qUIOyCrOuejDwvSW5mb0xhYmVsPlxuICAgICAgICB7IHJlY2VpdmVyTmFtZSB9XG4gICAgICA8L0luZm9Sb3c+XG4gICAgICA8Q29udGVudCBvbkNsaWNrPXtvbkNsaWNrUHJvZHVjdH0+XG4gICAgICAgIDxQcm9kdWN0SW1hZ2UgYWx0PXtgJHtwcm9kdWN0TmFtZX1gfSBzcmM9e3Byb2R1Y3RJbWFnZVVybCA/PyAnJ30gLz5cbiAgICAgICAgPFByb2R1Y3RFeHBsYW5hdGlvbj5cbiAgICAgICAgICA8UHJvZHVjdE5hbWU+eyBwcm9kdWN0TmFtZSB9PC9Qcm9kdWN0TmFtZT5cbiAgICAgICAgICA8T3B0aW9uTmFtZT5cbiAgICAgICAgICAgIHsgYCR7b3B0aW9uTmFtZX0g4oCiICR7cXVhbnRpdHl96rCcYCB9XG4gICAgICAgICAgPC9PcHRpb25OYW1lPlxuICAgICAgICA8L1Byb2R1Y3RFeHBsYW5hdGlvbj5cbiAgICAgIDwvQ29udGVudD5cbiAgICAgIDxQaG9uZU51bWJlcnNXcmFwcGVyPlxuICAgICAgICB7IHNlbGxlclBob25lICYmIDxQaG9uZUJ1dHRvbiBwaG9uZU51bWJlcj17Zm9ybWF0UGhvbmVOdW1iZXIoc2VsbGVyUGhvbmUpfSBuYW1lPXtpc01vYmlsZSA/ICftjJDrp6TsnpAg7KCE7ZmU66y47J2YJyA6IHNlbGxlck5hbWUgPz8gJyd9IC8+IH1cbiAgICAgICAgPFBob25lQnV0dG9uIHBob25lTnVtYmVyPVwiMTY3MC0wODc2XCIgbmFtZT1cIuyYpOuKmOydmOynkSDqs6DqsJ3shLzthLBcIiAvPlxuICAgICAgPC9QaG9uZU51bWJlcnNXcmFwcGVyPlxuICAgIDwvV3JhcHBlcj5cbiAgKTtcbn1cblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuYDtcblxuY29uc3QgSGVhZGVyID0gc3R5bGVkLmgyYFxuICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUxfTtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIG1hcmdpbi1ib3R0b206IDIwcHg7XG5gO1xuXG5jb25zdCBJbmZvUm93ID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgJHtGT05UX1NUWUxFLmJvZHkxX3NtYWxsfTtcbiAgbWFyZ2luLWJvdHRvbTogNnB4O1xuXG4gICY6bnRoLW9mLXR5cGUoMikge1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gIH1cbmA7XG5cbmNvbnN0IEluZm9MYWJlbCA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBpbmhlcml0O1xuICBtaW4td2lkdGg6IDY4cHg7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuYDtcblxuY29uc3QgUHJvZHVjdEltYWdlID0gc3R5bGVkKFJlc2l6ZUltYWdlKWBcbiAgZmxleC1zaHJpbms6IDA7XG4gIHdpZHRoOiA1NHB4O1xuICBoZWlnaHQ6IDU0cHg7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xuYDtcblxuY29uc3QgUGhvbmVOdW1iZXJzV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGNvbHVtbi1nYXA6IDEycHg7XG5gO1xuXG5jb25zdCBDb250ZW50ID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgcGFkZGluZy1ib3R0b206IDIwcHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbmA7XG5cbmNvbnN0IFByb2R1Y3RFeHBsYW5hdGlvbiA9IHN0eWxlZC5kaXZgXG4gICR7Rk9OVF9TVFlMRS5ib2R5Mn1cbmA7XG5cbmNvbnN0IFByb2R1Y3ROYW1lID0gc3R5bGVkLnBgXG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuYDtcblxuY29uc3QgT3B0aW9uTmFtZSA9IHN0eWxlZC5wYFxuICBmb250LXdlaWdodDogNDAwO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbmA7XG4iXX0= */"));
const ProductImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx5"
} : {
  target: "e1yc6enx5",
  label: "ProductImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1vc19v7",
  styles: "flex-shrink:0;width:54px;height:54px;border-radius:4px;margin-right:10px"
} : {
  name: "1vc19v7",
  styles: "flex-shrink:0;width:54px;height:54px;border-radius:4px;margin-right:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
});
const PhoneNumbersWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx4"
} : {
  target: "e1yc6enx4",
  label: "PhoneNumbersWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "mapv73",
  styles: "display:flex;column-gap:12px"
} : {
  name: "mapv73",
  styles: "display:flex;column-gap:12px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
});
const Content$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx3"
} : {
  target: "e1yc6enx3",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "oyqoge",
  styles: "display:flex;padding-bottom:20px;cursor:pointer"
} : {
  name: "oyqoge",
  styles: "display:flex;padding-bottom:20px;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
});
const ProductExplanation = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx2"
} : {
  target: "e1yc6enx2",
  label: "ProductExplanation"
})(FONT_STYLE.body2, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ProductName = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx1"
} : {
  target: "e1yc6enx1",
  label: "ProductName"
})("font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const OptionName = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx0"
} : {
  target: "e1yc6enx0",
  label: "OptionName"
})("font-weight:400;color:", ({
  theme
}) => theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DeliveryTrackingLoadFail = ({
  handleButtonClick,
  title
}) => {
  return jsxs(Fragment$1, {
    children: [!isInApp() && title && jsx(WebViewTitle, {
      children: title
    }), jsxs(LoadingWrapper, {
      children: [jsx(Title$a, {
        children: "\uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694."
      }), jsxs(Text, {
        children: ["\uC5F0\uB3D9 \uC815\uBCF4 \uC870\uD68C \uC911 \uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.", jsx("br", {}), "\uC0C8\uB85C\uACE0\uCE68\uC744 \uD074\uB9AD\uD574\uC8FC\uC138\uC694."]
      }), jsx(RefreshButton, {
        size: 44,
        variant: "primary1",
        onClick: handleButtonClick,
        children: "\uC0C8\uB85C\uACE0\uCE68"
      })]
    })]
  });
};
const LoadingWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty4"
} : {
  target: "e1ewtnty4",
  label: "LoadingWrapper"
})("width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 80px);", MEDIA_QUERY.max('tablet', process.env.NODE_ENV === "production" ? {
  name: "lohfg0",
  styles: "height:calc(100vh - 50px)"
} : {
  name: "1kegrpo-LoadingWrapper",
  styles: "height:calc(100vh - 50px);label:LoadingWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WebViewTitle = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty3"
} : {
  target: "e1ewtnty3",
  label: "WebViewTitle"
})(FONT_STYLE.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Title$a = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty2"
} : {
  target: "e1ewtnty2",
  label: "Title"
})(FONT_STYLE.title2, ";font-weight:600;", MEDIA_QUERY.max('tablet', process.env.NODE_ENV === "production" ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : {
  name: "7uheje-Title",
  styles: "font-weight:400;label:Title;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Text = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty1"
} : {
  target: "e1ewtnty1",
  label: "Text"
})(FONT_STYLE.body1_1, ";margin-top:8px;text-align:center;color:", ({
  theme
}) => theme.content.base2, ";", MEDIA_QUERY.max('tablet', /*#__PURE__*/css(FONT_STYLE.body2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Text;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const RefreshButton = /*#__PURE__*/_styled(Button$4, process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty0"
} : {
  target: "e1ewtnty0",
  label: "RefreshButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : {
  name: "1r0yqr6",
  styles: "margin-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DELIVERY_TARGET_TYPE_NAME = {
  ORDER: '배송',
  PICKUP: '수거',
  REDELIVERY: '재배송'
};
function DeliveryTrackingTemplate({
  deliveryTargetType,
  summaryElement,
  timelineElement,
  orderInfoElement
}) {
  const targetTypeKorean = DELIVERY_TARGET_TYPE_NAME[deliveryTargetType];
  const title = `${targetTypeKorean}조회`;
  return jsx(BackgroundLayout, {
    children: jsxs(ContentWrapper, {
      children: [!isInApp() && jsx(Title$9, {
        children: title
      }), jsxs(Content$2, {
        children: [summaryElement, timelineElement]
      }), jsx(Divider, {
        variant: "thick"
      }), jsx(Content$2, {
        children: orderInfoElement
      })]
    })
  });
}
const BackgroundLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq3"
} : {
  target: "e1v1izdq3",
  label: "BackgroundLayout"
})("background-color:", ({
  theme
}) => theme.background.groupedBase, ";height:auto;min-height:100vh;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ContentWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq2"
} : {
  target: "e1v1izdq2",
  label: "ContentWrapper"
})("max-width:500px;height:auto;min-height:100vh;background-color:", ({
  theme
}) => theme.background.base, ";margin-left:auto;margin-right:auto;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Content$2 = /*#__PURE__*/_styled("section", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq1"
} : {
  target: "e1v1izdq1",
  label: "Content"
})("padding:24px 20px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "9zbbnr",
  styles: "padding:24px 16px"
} : {
  name: "ik3grn-Content",
  styles: "padding:24px 16px;label:Content;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Title$9 = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq0"
} : {
  target: "e1v1izdq0",
  label: "Title"
})(FONT_STYLE.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var qrcodegen;
(qrcodegen2 => {
  const _QrCode = class {
    constructor(version, errorCorrectionLevel, dataCodewords, msk) {
      this.version = version;
      this.errorCorrectionLevel = errorCorrectionLevel;
      this.modules = [];
      this.isFunction = [];
      if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
      if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
      this.size = version * 4 + 17;
      let row = [];
      for (let i = 0; i < this.size; i++) row.push(false);
      for (let i = 0; i < this.size; i++) {
        this.modules.push(row.slice());
        this.isFunction.push(row.slice());
      }
      this.drawFunctionPatterns();
      const allCodewords = this.addEccAndInterleave(dataCodewords);
      this.drawCodewords(allCodewords);
      if (msk == -1) {
        let minPenalty = 1e9;
        for (let i = 0; i < 8; i++) {
          this.applyMask(i);
          this.drawFormatBits(i);
          const penalty = this.getPenaltyScore();
          if (penalty < minPenalty) {
            msk = i;
            minPenalty = penalty;
          }
          this.applyMask(i);
        }
      }
      assert(0 <= msk && msk <= 7);
      this.mask = msk;
      this.applyMask(msk);
      this.drawFormatBits(msk);
      this.isFunction = [];
    }
    static encodeText(text, ecl) {
      const segs = qrcodegen2.QrSegment.makeSegments(text);
      return _QrCode.encodeSegments(segs, ecl);
    }
    static encodeBinary(data, ecl) {
      const seg = qrcodegen2.QrSegment.makeBytes(data);
      return _QrCode.encodeSegments([seg], ecl);
    }
    static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
      if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
      let version;
      let dataUsedBits;
      for (version = minVersion;; version++) {
        const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
        const usedBits = QrSegment.getTotalBits(segs, version);
        if (usedBits <= dataCapacityBits2) {
          dataUsedBits = usedBits;
          break;
        }
        if (version >= maxVersion) throw new RangeError("Data too long");
      }
      for (const newEcl of [_QrCode.Ecc.MEDIUM, _QrCode.Ecc.QUARTILE, _QrCode.Ecc.HIGH]) {
        if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
      }
      let bb = [];
      for (const seg of segs) {
        appendBits(seg.mode.modeBits, 4, bb);
        appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
        for (const b of seg.getData()) bb.push(b);
      }
      assert(bb.length == dataUsedBits);
      const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
      assert(bb.length <= dataCapacityBits);
      appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
      appendBits(0, (8 - bb.length % 8) % 8, bb);
      assert(bb.length % 8 == 0);
      for (let padByte = 236; bb.length < dataCapacityBits; padByte ^= 236 ^ 17) appendBits(padByte, 8, bb);
      let dataCodewords = [];
      while (dataCodewords.length * 8 < bb.length) dataCodewords.push(0);
      bb.forEach((b, i) => dataCodewords[i >>> 3] |= b << 7 - (i & 7));
      return new _QrCode(version, ecl, dataCodewords, mask);
    }
    getModule(x, y) {
      return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
    }
    getModules() {
      return this.modules;
    }
    drawFunctionPatterns() {
      for (let i = 0; i < this.size; i++) {
        this.setFunctionModule(6, i, i % 2 == 0);
        this.setFunctionModule(i, 6, i % 2 == 0);
      }
      this.drawFinderPattern(3, 3);
      this.drawFinderPattern(this.size - 4, 3);
      this.drawFinderPattern(3, this.size - 4);
      const alignPatPos = this.getAlignmentPatternPositions();
      const numAlign = alignPatPos.length;
      for (let i = 0; i < numAlign; i++) {
        for (let j = 0; j < numAlign; j++) {
          if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
        }
      }
      this.drawFormatBits(0);
      this.drawVersion();
    }
    drawFormatBits(mask) {
      const data = this.errorCorrectionLevel.formatBits << 3 | mask;
      let rem = data;
      for (let i = 0; i < 10; i++) rem = rem << 1 ^ (rem >>> 9) * 1335;
      const bits = (data << 10 | rem) ^ 21522;
      assert(bits >>> 15 == 0);
      for (let i = 0; i <= 5; i++) this.setFunctionModule(8, i, getBit(bits, i));
      this.setFunctionModule(8, 7, getBit(bits, 6));
      this.setFunctionModule(8, 8, getBit(bits, 7));
      this.setFunctionModule(7, 8, getBit(bits, 8));
      for (let i = 9; i < 15; i++) this.setFunctionModule(14 - i, 8, getBit(bits, i));
      for (let i = 0; i < 8; i++) this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
      for (let i = 8; i < 15; i++) this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
      this.setFunctionModule(8, this.size - 8, true);
    }
    drawVersion() {
      if (this.version < 7) return;
      let rem = this.version;
      for (let i = 0; i < 12; i++) rem = rem << 1 ^ (rem >>> 11) * 7973;
      const bits = this.version << 12 | rem;
      assert(bits >>> 18 == 0);
      for (let i = 0; i < 18; i++) {
        const color = getBit(bits, i);
        const a = this.size - 11 + i % 3;
        const b = Math.floor(i / 3);
        this.setFunctionModule(a, b, color);
        this.setFunctionModule(b, a, color);
      }
    }
    drawFinderPattern(x, y) {
      for (let dy = -4; dy <= 4; dy++) {
        for (let dx = -4; dx <= 4; dx++) {
          const dist = Math.max(Math.abs(dx), Math.abs(dy));
          const xx = x + dx;
          const yy = y + dy;
          if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
        }
      }
    }
    drawAlignmentPattern(x, y) {
      for (let dy = -2; dy <= 2; dy++) {
        for (let dx = -2; dx <= 2; dx++) this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
      }
    }
    setFunctionModule(x, y, isDark) {
      this.modules[y][x] = isDark;
      this.isFunction[y][x] = true;
    }
    addEccAndInterleave(data) {
      const ver = this.version;
      const ecl = this.errorCorrectionLevel;
      if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
      const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
      const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
      const numShortBlocks = numBlocks - rawCodewords % numBlocks;
      const shortBlockLen = Math.floor(rawCodewords / numBlocks);
      let blocks = [];
      const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
      for (let i = 0, k = 0; i < numBlocks; i++) {
        let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
        k += dat.length;
        const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
        if (i < numShortBlocks) dat.push(0);
        blocks.push(dat.concat(ecc));
      }
      let result = [];
      for (let i = 0; i < blocks[0].length; i++) {
        blocks.forEach((block, j) => {
          if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
        });
      }
      assert(result.length == rawCodewords);
      return result;
    }
    drawCodewords(data) {
      if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
      let i = 0;
      for (let right = this.size - 1; right >= 1; right -= 2) {
        if (right == 6) right = 5;
        for (let vert = 0; vert < this.size; vert++) {
          for (let j = 0; j < 2; j++) {
            const x = right - j;
            const upward = (right + 1 & 2) == 0;
            const y = upward ? this.size - 1 - vert : vert;
            if (!this.isFunction[y][x] && i < data.length * 8) {
              this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
              i++;
            }
          }
        }
      }
      assert(i == data.length * 8);
    }
    applyMask(mask) {
      if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          let invert;
          switch (mask) {
            case 0:
              invert = (x + y) % 2 == 0;
              break;
            case 1:
              invert = y % 2 == 0;
              break;
            case 2:
              invert = x % 3 == 0;
              break;
            case 3:
              invert = (x + y) % 3 == 0;
              break;
            case 4:
              invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
              break;
            case 5:
              invert = x * y % 2 + x * y % 3 == 0;
              break;
            case 6:
              invert = (x * y % 2 + x * y % 3) % 2 == 0;
              break;
            case 7:
              invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
        }
      }
    }
    getPenaltyScore() {
      let result = 0;
      for (let y = 0; y < this.size; y++) {
        let runColor = false;
        let runX = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++) {
          if (this.modules[y][x] == runColor) {
            runX++;
            if (runX == 5) result += _QrCode.PENALTY_N1;else if (runX > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runX, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runX = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let x = 0; x < this.size; x++) {
        let runColor = false;
        let runY = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let y = 0; y < this.size; y++) {
          if (this.modules[y][x] == runColor) {
            runY++;
            if (runY == 5) result += _QrCode.PENALTY_N1;else if (runY > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runY, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runY = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let y = 0; y < this.size - 1; y++) {
        for (let x = 0; x < this.size - 1; x++) {
          const color = this.modules[y][x];
          if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
        }
      }
      let dark = 0;
      for (const row of this.modules) dark = row.reduce((sum, color) => sum + (color ? 1 : 0), dark);
      const total = this.size * this.size;
      const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      assert(0 <= k && k <= 9);
      result += k * _QrCode.PENALTY_N4;
      assert(0 <= result && result <= 2568888);
      return result;
    }
    getAlignmentPatternPositions() {
      if (this.version == 1) return [];else {
        const numAlign = Math.floor(this.version / 7) + 2;
        const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
        let result = [6];
        for (let pos = this.size - 7; result.length < numAlign; pos -= step) result.splice(1, 0, pos);
        return result;
      }
    }
    static getNumRawDataModules(ver) {
      if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
      let result = (16 * ver + 128) * ver + 64;
      if (ver >= 2) {
        const numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7) result -= 36;
      }
      assert(208 <= result && result <= 29648);
      return result;
    }
    static getNumDataCodewords(ver, ecl) {
      return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
    }
    static reedSolomonComputeDivisor(degree) {
      if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
      let result = [];
      for (let i = 0; i < degree - 1; i++) result.push(0);
      result.push(1);
      let root = 1;
      for (let i = 0; i < degree; i++) {
        for (let j = 0; j < result.length; j++) {
          result[j] = _QrCode.reedSolomonMultiply(result[j], root);
          if (j + 1 < result.length) result[j] ^= result[j + 1];
        }
        root = _QrCode.reedSolomonMultiply(root, 2);
      }
      return result;
    }
    static reedSolomonComputeRemainder(data, divisor) {
      let result = divisor.map(_ => 0);
      for (const b of data) {
        const factor = b ^ result.shift();
        result.push(0);
        divisor.forEach((coef, i) => result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
      }
      return result;
    }
    static reedSolomonMultiply(x, y) {
      if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
      let z = 0;
      for (let i = 7; i >= 0; i--) {
        z = z << 1 ^ (z >>> 7) * 285;
        z ^= (y >>> i & 1) * x;
      }
      assert(z >>> 8 == 0);
      return z;
    }
    finderPenaltyCountPatterns(runHistory) {
      const n = runHistory[1];
      assert(n <= this.size * 3);
      const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
      return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }
    finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
      if (currentRunColor) {
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        currentRunLength = 0;
      }
      currentRunLength += this.size;
      this.finderPenaltyAddHistory(currentRunLength, runHistory);
      return this.finderPenaltyCountPatterns(runHistory);
    }
    finderPenaltyAddHistory(currentRunLength, runHistory) {
      if (runHistory[0] == 0) currentRunLength += this.size;
      runHistory.pop();
      runHistory.unshift(currentRunLength);
    }
  };
  let QrCode = _QrCode;
  QrCode.MIN_VERSION = 1;
  QrCode.MAX_VERSION = 40;
  QrCode.PENALTY_N1 = 3;
  QrCode.PENALTY_N2 = 3;
  QrCode.PENALTY_N3 = 40;
  QrCode.PENALTY_N4 = 10;
  QrCode.ECC_CODEWORDS_PER_BLOCK = [[-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28], [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]];
  QrCode.NUM_ERROR_CORRECTION_BLOCKS = [[-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25], [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49], [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68], [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]];
  qrcodegen2.QrCode = QrCode;
  function appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
    for (let i = len - 1; i >= 0; i--) bb.push(val >>> i & 1);
  }
  function getBit(x, i) {
    return (x >>> i & 1) != 0;
  }
  function assert(cond) {
    if (!cond) throw new Error("Assertion error");
  }
  const _QrSegment = class {
    constructor(mode, numChars, bitData) {
      this.mode = mode;
      this.numChars = numChars;
      this.bitData = bitData;
      if (numChars < 0) throw new RangeError("Invalid argument");
      this.bitData = bitData.slice();
    }
    static makeBytes(data) {
      let bb = [];
      for (const b of data) appendBits(b, 8, bb);
      return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
    }
    static makeNumeric(digits) {
      if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
      let bb = [];
      for (let i = 0; i < digits.length;) {
        const n = Math.min(digits.length - i, 3);
        appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
        i += n;
      }
      return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
    }
    static makeAlphanumeric(text) {
      if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let bb = [];
      let i;
      for (i = 0; i + 2 <= text.length; i += 2) {
        let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        appendBits(temp, 11, bb);
      }
      if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
      return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
    }
    static makeSegments(text) {
      if (text == "") return [];else if (_QrSegment.isNumeric(text)) return [_QrSegment.makeNumeric(text)];else if (_QrSegment.isAlphanumeric(text)) return [_QrSegment.makeAlphanumeric(text)];else return [_QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))];
    }
    static makeEci(assignVal) {
      let bb = [];
      if (assignVal < 0) throw new RangeError("ECI assignment value out of range");else if (assignVal < 1 << 7) appendBits(assignVal, 8, bb);else if (assignVal < 1 << 14) {
        appendBits(2, 2, bb);
        appendBits(assignVal, 14, bb);
      } else if (assignVal < 1e6) {
        appendBits(6, 3, bb);
        appendBits(assignVal, 21, bb);
      } else throw new RangeError("ECI assignment value out of range");
      return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
    }
    static isNumeric(text) {
      return _QrSegment.NUMERIC_REGEX.test(text);
    }
    static isAlphanumeric(text) {
      return _QrSegment.ALPHANUMERIC_REGEX.test(text);
    }
    getData() {
      return this.bitData.slice();
    }
    static getTotalBits(segs, version) {
      let result = 0;
      for (const seg of segs) {
        const ccbits = seg.mode.numCharCountBits(version);
        if (seg.numChars >= 1 << ccbits) return Infinity;
        result += 4 + ccbits + seg.bitData.length;
      }
      return result;
    }
    static toUtf8ByteArray(str) {
      str = encodeURI(str);
      let result = [];
      for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) != "%") result.push(str.charCodeAt(i));else {
          result.push(parseInt(str.substr(i + 1, 2), 16));
          i += 2;
        }
      }
      return result;
    }
  };
  let QrSegment = _QrSegment;
  QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
  QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
  QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrCode2 => {
    const _Ecc = class {
      constructor(ordinal, formatBits) {
        this.ordinal = ordinal;
        this.formatBits = formatBits;
      }
    };
    let Ecc = _Ecc;
    Ecc.LOW = new _Ecc(0, 1);
    Ecc.MEDIUM = new _Ecc(1, 0);
    Ecc.QUARTILE = new _Ecc(2, 3);
    Ecc.HIGH = new _Ecc(3, 2);
    QrCode2.Ecc = Ecc;
  })(qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrSegment2 => {
    const _Mode = class {
      constructor(modeBits, numBitsCharCount) {
        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
      }
      numCharCountBits(ver) {
        return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
      }
    };
    let Mode = _Mode;
    Mode.NUMERIC = new _Mode(1, [10, 12, 14]);
    Mode.ALPHANUMERIC = new _Mode(2, [9, 11, 13]);
    Mode.BYTE = new _Mode(4, [8, 16, 16]);
    Mode.KANJI = new _Mode(8, [8, 10, 12]);
    Mode.ECI = new _Mode(7, [0, 0, 0]);
    QrSegment2.Mode = Mode;
  })(qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;

// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var ERROR_LEVEL_MAP = {
  L: qrcodegen_default.QrCode.Ecc.LOW,
  M: qrcodegen_default.QrCode.Ecc.MEDIUM,
  Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
  H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE$1 = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
  const ops = [];
  modules.forEach(function (row, y) {
    let start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
        start = null;
        return;
      }
      if (x === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
        } else {
          ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
        }
        return;
      }
      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join("");
}
function excavateModules(modules, excavation) {
  return modules.slice().map((row, y) => {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }
    return row.map((cell, x) => {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }
      return false;
    });
  });
}
function getImageSettings(cells, size, includeMargin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  const scale = numCells / size;
  const w = (imageSettings.width || defaultSize) * scale;
  const h = (imageSettings.height || defaultSize) * scale;
  const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  let excavation = null;
  if (imageSettings.excavate) {
    let floorX = Math.floor(x);
    let floorY = Math.floor(y);
    let ceilW = Math.ceil(w + x - floorX);
    let ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }
  return {
    x,
    y,
    h,
    w,
    excavation
  };
}
var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }
  return true;
}();
function QRCodeCanvas(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      style,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "style", "imageSettings"]);
  const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
  const _canvas = useRef(null);
  const _image = useRef(null);
  const [isImgLoaded, setIsImageLoaded] = useState(false);
  useEffect(() => {
    if (_canvas.current != null) {
      const canvas = _canvas.current;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }
      let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
      const margin = includeMargin ? MARGIN_SIZE : 0;
      const numCells = cells.length + margin * 2;
      const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
      const image = _image.current;
      const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }
      const pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      const scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;
      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  useEffect(() => {
    setIsImageLoaded(false);
  }, [imgSrc]);
  const canvasStyle = __spreadValues({
    height: size,
    width: size
  }, style);
  let img = null;
  if (imgSrc != null) {
    img = /* @__PURE__ */React__default.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: {
        display: "none"
      },
      onLoad: () => {
        setIsImageLoaded(true);
      },
      ref: _image
    });
  }
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("canvas", __spreadValues({
    style: canvasStyle,
    height: size,
    width: size,
    ref: _canvas
  }, otherProps)), img);
}
function QRCodeSVG(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]);
  let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
  let image = null;
  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cells = excavateModules(cells, calculatedImageSettings.excavation);
    }
    image = /* @__PURE__ */React__default.createElement("image", {
      xlinkHref: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none"
    });
  }
  const fgPath = generatePath(cells, margin);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues({
    height: size,
    width: size,
    viewBox: `0 0 ${numCells} ${numCells}`
  }, otherProps), /* @__PURE__ */React__default.createElement("path", {
    fill: bgColor,
    d: `M0,0 h${numCells}v${numCells}H0z`,
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */React__default.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
}
var QRCode = props => {
  const _a = props,
    {
      renderAs
    } = _a,
    otherProps = __objRest(_a, ["renderAs"]);
  if (renderAs === "svg") {
    return /* @__PURE__ */React__default.createElement(QRCodeSVG, __spreadValues({}, otherProps));
  }
  return /* @__PURE__ */React__default.createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};

const LogoIcon$1 = props => jsx("svg", {
  className: "icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  preserveAspectRatio: "xMidYMid meet",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      fill: "#35C5F0",
      d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
    }), jsx("path", {
      fill: "#FFF",
      d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34 0-.74.6-1.34 1.33-1.34s1.32.6 1.32 1.34c0 .74-.59 1.34-1.32 1.34zm-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3.01 3.01 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
    })]
  })
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const AppDownloadPopupWithQR = ({
  deeplink,
  isOpen,
  isMobileDevice,
  onClose,
  actionType,
  localeData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleDownloadApp = () => {
    L({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'button',
      id: 'app',
      data: {
        object_group: '팝업 액션',
        object_group_id: actionType
      }
    });
    window.location.href = deeplink;
  };
  const action = isMobileDevice ? {
    primary: {
      text: localeData.popupWebToAppBtn02,
      onClick: handleDownloadApp
    }
  } : undefined;
  const handleBlur = () => {
    L({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'grey_zone',
      id: 'close'
    });
    onClose();
  };
  useEffect(() => {
    if (isOpen) {
      L({
        category: 'impression',
        url: window.location.href,
        type: '앱 QR 모달',
        id: 'MODAL_APP_QR',
        data: [{
          object_group: '팝업 액션',
          object_group_id: actionType
        }]
      });
      logAmplitude$1('Pop-up', {
        action_name: actionType
      });
    }
  }, [isOpen, actionType]);
  if (!isOpen) {
    return null;
  }
  return jsx(Modal, {
    width: 400,
    footer: {
      action
    },
    disableBackgroundScroll: isOpen,
    onBlur: handleBlur,
    role: "dialog",
    children: jsxs(Container$k, {
      children: [isMobileDevice ? jsx(Logo$1, {
        "data-testid": "logo"
      }) : jsxs(Fragment$1, {
        children: [jsx(Title$8, {
          children: localeData.popupWebToAppTitleScan
        }), jsx(QRCode, {
          "data-testid": "qr",
          value: deeplink,
          size: isMobile ? 64 : 80
        })]
      }), jsx(Description$1, {
        children: localeData.popupWebToAppTitle
      })]
    })
  });
};
const Container$k = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f63"
} : {
  target: "e2lc0f63",
  label: "Container"
})("padding:30px 16px 10px 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "1b5azyf",
  styles: "padding:20px 16px 0 16px"
} : {
  name: "168ylpe-Container",
  styles: "padding:20px 16px 0 16px;label:Container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Title$8 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f62"
} : {
  target: "e2lc0f62",
  label: "Title"
})(FONT_STYLE.title3, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Description$1 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f61"
} : {
  target: "e2lc0f61",
  label: "Description"
})(FONT_STYLE.body1_small, ";font-weight:500;white-space:pre-wrap;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Logo$1 = /*#__PURE__*/_styled(LogoIcon$1, process.env.NODE_ENV === "production" ? {
  target: "e2lc0f60"
} : {
  target: "e2lc0f60",
  label: "Logo"
})("width:64px;height:64px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "1e9n0ny",
  styles: "width:80px;height:80px"
} : {
  name: "a91dqi-Logo",
  styles: "width:80px;height:80px;label:Logo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function BlockedPage({
  className,
  title,
  description,
  exit
}) {
  return jsxs(Container$j, {
    className: className,
    children: [jsx(Title$7, {
      children: title
    }), jsx(Description, {
      children: description
    }), exit && jsx(Responsive, {
      mobile: jsx(ExitButton, {
        size: 32,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      }),
      tablet: jsx(ExitButton, {
        size: 30,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      })
    })]
  });
}
const Container$j = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi3"
} : {
  target: "eqn4bhi3",
  label: "Container"
})("width:100%;max-width:", pxToRem(300), ";margin:", pxToRem(140), " auto;padding:0 ", pxToRem(40), ";box-sizing:border-box;text-align:center;word-break:keep-all;word-wrap:break-word;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("max-width:", pxToRem(500), ";margin-top:", pxToRem(200), ";margin-bottom:", pxToRem(200), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Title$7 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi2"
} : {
  target: "eqn4bhi2",
  label: "Title"
})("margin-bottom:", pxToRem(8), ";", FONT_STYLE.subTitle1, ";font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.title3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Title;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Description = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi1"
} : {
  target: "eqn4bhi1",
  label: "Description"
})("margin:", pxToRem(8), " 0 ", pxToRem(13), ";", FONT_STYLE.body2, ";color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.body1_1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Description;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ExitButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi0"
} : {
  target: "eqn4bhi0",
  label: "ExitButton"
})("margin:", pxToRem(7), " 0 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChipListModule = ({
  chipListInfo,
  onClick,
  ...rest
}) => {
  const {
    label,
    chipList
  } = chipListInfo;
  return jsxs(Container$i, {
    ...rest,
    children: [label && jsx(Label$2, {
      children: label
    }), jsx(ChipList, {
      children: chipList.map(({
        chipId,
        chipLabel,
        selected
      }) => {
        return jsx(ChipItem, {
          children: jsx(OutlineSelectChip, {
            size: 32,
            variant: "primary1",
            checked: selected,
            onCheck: () => onClick(chipId),
            children: chipLabel
          })
        }, chipId);
      })
    })]
  });
};
const Container$i = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy3"
} : {
  target: "e1t6ufvy3",
  label: "Container"
})("margin-bottom:", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Label$2 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy2"
} : {
  target: "e1t6ufvy2",
  label: "Label"
})(FONT_STYLE.subTitle2, " font-weight:700;margin-bottom:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ChipList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy1"
} : {
  target: "e1t6ufvy1",
  label: "ChipList"
})(process.env.NODE_ENV === "production" ? {
  name: "1mzohwv",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;text-align:center;align-items:center"
} : {
  name: "1mzohwv",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;text-align:center;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
});
const ChipItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy0"
} : {
  target: "e1t6ufvy0",
  label: "ChipItem"
})("margin-right:", pxToRem(4), ";margin-bottom:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemThumbnail = ({
  src,
  isZoomed,
  dim,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  aspect = 3 / 2,
  alt = '',
  quality,
  lazy
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleCornerClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return jsxs(Container$h, {
    aspect: aspect,
    children: [jsx(Thumbnail, {
      alt: alt,
      src: src,
      intrinsicAspect: aspect,
      objectFit: "cover",
      style: isZoomed && !isMobile ? {
        transform: 'scale(1.05)'
      } : undefined,
      quality: quality,
      lazy: lazy
    }), topLeft && jsx(Corner, {
      position: "top-left",
      onClick: handleCornerClick,
      children: topLeft
    }), topRight && jsx(Corner, {
      position: "top-right",
      onClick: handleCornerClick,
      children: topRight
    }), bottomLeft && jsx(Corner, {
      position: "bottom-left",
      onClick: handleCornerClick,
      children: bottomLeft
    }), bottomRight && jsx(Corner, {
      position: "bottom-right",
      onClick: handleCornerClick,
      children: bottomRight
    }), dim && jsx(Dim, {
      children: dim
    })]
  });
};
const Container$h = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm3"
} : {
  target: "e8i2tqm3",
  label: "Container"
})("overflow:hidden;position:relative;border-radius:", pxToRem(4), ";&:before{content:\"\";display:block;", ({
  aspect
}) => /*#__PURE__*/css("padding-top:", 100 / aspect, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Thumbnail = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm2"
} : {
  target: "e8i2tqm2",
  label: "Thumbnail"
})(process.env.NODE_ENV === "production" ? {
  name: "161a5fa",
  styles: "position:absolute;top:0;left:0;transition:transform .2s"
} : {
  name: "161a5fa",
  styles: "position:absolute;top:0;left:0;transition:transform .2s",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
});
const Corner = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm1"
} : {
  target: "e8i2tqm1",
  label: "Corner"
})("position:absolute;padding:", pxToRem(6), ";font-size:0;z-index:1;", ({
  position
}) => {
  switch (position) {
    case 'top-left':
      return /*#__PURE__*/css("top:", pxToRem(6), ";left:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
    case 'top-right':
      return /*#__PURE__*/css("top:", pxToRem(6), ";right:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
    case 'bottom-left':
      return /*#__PURE__*/css("left:", pxToRem(6), ";bottom:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
    case 'bottom-right':
      return /*#__PURE__*/css("right:", pxToRem(6), ";bottom:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlZWRJdGVtVGh1bWJuYWlsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5SWtCIiwiZmlsZSI6IkZlZWRJdGVtVGh1bWJuYWlsLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1vdXNlRXZlbnQsIHVzZUNhbGxiYWNrIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBSZXNpemVJbWFnZSxcbiAgUmVzaXplSW1hZ2VQcm9wcyxcbiAgcHhUb1JlbSxcbiAgdXNlUmVzcG9uc2l2ZSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5leHBvcnQgaW50ZXJmYWNlIEZlZWRJdGVtVGh1bWJuYWlsUHJvcHMge1xuICBzcmM6IHN0cmluZztcbiAgaXNab29tZWQ/OiBib29sZWFuO1xuICBkaW0/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIHRvcExlZnQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIHRvcFJpZ2h0PzogUmVhY3QuUmVhY3ROb2RlO1xuICBib3R0b21MZWZ0PzogUmVhY3QuUmVhY3ROb2RlO1xuICBib3R0b21SaWdodD86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgYXNwZWN0PzogbnVtYmVyO1xuICBhbHQ/OiBzdHJpbmc7XG4gIHF1YWxpdHk/OiBSZXNpemVJbWFnZVByb3BzWydxdWFsaXR5J107XG4gIGxhenk/OiBSZXNpemVJbWFnZVByb3BzWydsYXp5J107XG59XG5cbmV4cG9ydCBjb25zdCBGZWVkSXRlbVRodW1ibmFpbCA9ICh7XG4gIHNyYyxcbiAgaXNab29tZWQsXG4gIGRpbSxcbiAgdG9wTGVmdCxcbiAgdG9wUmlnaHQsXG4gIGJvdHRvbUxlZnQsXG4gIGJvdHRvbVJpZ2h0LFxuICBhc3BlY3QgPSAzIC8gMixcbiAgYWx0ID0gJycsXG4gIHF1YWxpdHksXG4gIGxhenksXG59OiBGZWVkSXRlbVRodW1ibmFpbFByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgY29uc3QgaXNNb2JpbGUgPSB1c2VSZXNwb25zaXZlKCkuYnJlYWtwb2ludCA9PT0gJ21vYmlsZSc7XG4gIGNvbnN0IGhhbmRsZUNvcm5lckNsaWNrID0gdXNlQ2FsbGJhY2soKGU6IE1vdXNlRXZlbnQpID0+IHtcbiAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgZS5zdG9wUHJvcGFnYXRpb24oKTtcbiAgfSwgW10pO1xuXG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBhc3BlY3Q9e2FzcGVjdH0+XG4gICAgICA8VGh1bWJuYWlsXG4gICAgICAgIGFsdD17YWx0fVxuICAgICAgICBzcmM9e3NyY31cbiAgICAgICAgaW50cmluc2ljQXNwZWN0PXthc3BlY3R9XG4gICAgICAgIG9iamVjdEZpdD1cImNvdmVyXCJcbiAgICAgICAgc3R5bGU9e2lzWm9vbWVkICYmICFpc01vYmlsZSA/IHsgdHJhbnNmb3JtOiAnc2NhbGUoMS4wNSknIH0gOiB1bmRlZmluZWR9XG4gICAgICAgIHF1YWxpdHk9e3F1YWxpdHl9XG4gICAgICAgIGxhenk9e2xhenl9XG4gICAgICAvPlxuICAgICAgeyB0b3BMZWZ0ICYmIChcbiAgICAgICAgPENvcm5lclxuICAgICAgICAgIHBvc2l0aW9uPVwidG9wLWxlZnRcIlxuICAgICAgICAgIG9uQ2xpY2s9e2hhbmRsZUNvcm5lckNsaWNrfVxuICAgICAgICA+XG4gICAgICAgICAgeyB0b3BMZWZ0IH1cbiAgICAgICAgPC9Db3JuZXI+XG4gICAgICApIH1cbiAgICAgIHsgdG9wUmlnaHQgJiYgKFxuICAgICAgICA8Q29ybmVyXG4gICAgICAgICAgcG9zaXRpb249XCJ0b3AtcmlnaHRcIlxuICAgICAgICAgIG9uQ2xpY2s9e2hhbmRsZUNvcm5lckNsaWNrfVxuICAgICAgICA+XG4gICAgICAgICAgeyB0b3BSaWdodCB9XG4gICAgICAgIDwvQ29ybmVyPlxuICAgICAgKSB9XG4gICAgICB7IGJvdHRvbUxlZnQgJiYgKFxuICAgICAgICA8Q29ybmVyXG4gICAgICAgICAgcG9zaXRpb249XCJib3R0b20tbGVmdFwiXG4gICAgICAgICAgb25DbGljaz17aGFuZGxlQ29ybmVyQ2xpY2t9XG4gICAgICAgID5cbiAgICAgICAgICB7IGJvdHRvbUxlZnQgfVxuICAgICAgICA8L0Nvcm5lcj5cbiAgICAgICkgfVxuICAgICAgeyBib3R0b21SaWdodCAmJiAoXG4gICAgICAgIDxDb3JuZXJcbiAgICAgICAgICBwb3NpdGlvbj1cImJvdHRvbS1yaWdodFwiXG4gICAgICAgICAgb25DbGljaz17aGFuZGxlQ29ybmVyQ2xpY2t9XG4gICAgICAgID5cbiAgICAgICAgICB7IGJvdHRvbVJpZ2h0IH1cbiAgICAgICAgPC9Db3JuZXI+XG4gICAgICApIH1cbiAgICAgIHsgZGltICYmIDxEaW0+eyBkaW0gfTwvRGltPiB9XG4gICAgPC9Db250YWluZXI+XG4gICk7XG59O1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2PHsgYXNwZWN0OiBudW1iZXIgfT5gXG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgJjpiZWZvcmUge1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgJHsoeyBhc3BlY3QgfSkgPT4gY3NzYFxuICAgICAgcGFkZGluZy10b3A6ICR7MTAwIC8gYXNwZWN0fSU7XG4gICAgYH1cbiAgfVxuYDtcblxuY29uc3QgVGh1bWJuYWlsID0gc3R5bGVkKFJlc2l6ZUltYWdlKWBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHRyYW5zaXRpb246IHRyYW5zZm9ybSAuMnM7XG5gO1xuXG5jb25zdCBDb3JuZXIgPSBzdHlsZWQuZGl2PHtcbiAgcG9zaXRpb246ICd0b3AtbGVmdCcgfCAndG9wLXJpZ2h0JyB8ICdib3R0b20tbGVmdCcgfCAnYm90dG9tLXJpZ2h0Jyxcbn0+YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHBhZGRpbmc6ICR7cHhUb1JlbSg2KX07XG4gIGZvbnQtc2l6ZTogMDtcbiAgei1pbmRleDogMTtcbiAgJHsoeyBwb3NpdGlvbiB9KSA9PiB7XG4gICAgc3dpdGNoIChwb3NpdGlvbikge1xuICAgICAgY2FzZSAndG9wLWxlZnQnOlxuICAgICAgICByZXR1cm4gY3NzYFxuICAgICAgICAgIHRvcDogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgICBsZWZ0OiAke3B4VG9SZW0oNil9O1xuICAgICAgICBgO1xuICAgICAgY2FzZSAndG9wLXJpZ2h0JzpcbiAgICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgICB0b3A6ICR7cHhUb1JlbSg2KX07XG4gICAgICAgICAgcmlnaHQ6ICR7cHhUb1JlbSg2KX07XG4gICAgICAgIGA7XG4gICAgICBjYXNlICdib3R0b20tbGVmdCc6XG4gICAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICAgbGVmdDogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgICBib3R0b206ICR7cHhUb1JlbSg2KX07XG4gICAgICAgIGA7XG4gICAgICBjYXNlICdib3R0b20tcmlnaHQnOlxuICAgICAgICByZXR1cm4gY3NzYFxuICAgICAgICAgIHJpZ2h0OiAke3B4VG9SZW0oNil9O1xuICAgICAgICAgIGJvdHRvbTogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgYDtcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIHJldHVybiAnJztcbiAgICB9XG4gIH19XG5gO1xuXG5jb25zdCBEaW0gPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTZ9O1xuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmRpbS5iYXNpY307XG5gO1xuXG4iXX0= */");
    default:
      return '';
  }
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlZWRJdGVtVGh1bWJuYWlsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrSEUiLCJmaWxlIjoiRmVlZEl0ZW1UaHVtYm5haWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTW91c2VFdmVudCwgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7XG4gIFJlc2l6ZUltYWdlLFxuICBSZXNpemVJbWFnZVByb3BzLFxuICBweFRvUmVtLFxuICB1c2VSZXNwb25zaXZlLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgRmVlZEl0ZW1UaHVtYm5haWxQcm9wcyB7XG4gIHNyYzogc3RyaW5nO1xuICBpc1pvb21lZD86IGJvb2xlYW47XG4gIGRpbT86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgdG9wTGVmdD86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgdG9wUmlnaHQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIGJvdHRvbUxlZnQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIGJvdHRvbVJpZ2h0PzogUmVhY3QuUmVhY3ROb2RlO1xuICBhc3BlY3Q/OiBudW1iZXI7XG4gIGFsdD86IHN0cmluZztcbiAgcXVhbGl0eT86IFJlc2l6ZUltYWdlUHJvcHNbJ3F1YWxpdHknXTtcbiAgbGF6eT86IFJlc2l6ZUltYWdlUHJvcHNbJ2xhenknXTtcbn1cblxuZXhwb3J0IGNvbnN0IEZlZWRJdGVtVGh1bWJuYWlsID0gKHtcbiAgc3JjLFxuICBpc1pvb21lZCxcbiAgZGltLFxuICB0b3BMZWZ0LFxuICB0b3BSaWdodCxcbiAgYm90dG9tTGVmdCxcbiAgYm90dG9tUmlnaHQsXG4gIGFzcGVjdCA9IDMgLyAyLFxuICBhbHQgPSAnJyxcbiAgcXVhbGl0eSxcbiAgbGF6eSxcbn06IEZlZWRJdGVtVGh1bWJuYWlsUHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICBjb25zdCBpc01vYmlsZSA9IHVzZVJlc3BvbnNpdmUoKS5icmVha3BvaW50ID09PSAnbW9iaWxlJztcbiAgY29uc3QgaGFuZGxlQ29ybmVyQ2xpY2sgPSB1c2VDYWxsYmFjaygoZTogTW91c2VFdmVudCkgPT4ge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICBlLnN0b3BQcm9wYWdhdGlvbigpO1xuICB9LCBbXSk7XG5cbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIGFzcGVjdD17YXNwZWN0fT5cbiAgICAgIDxUaHVtYm5haWxcbiAgICAgICAgYWx0PXthbHR9XG4gICAgICAgIHNyYz17c3JjfVxuICAgICAgICBpbnRyaW5zaWNBc3BlY3Q9e2FzcGVjdH1cbiAgICAgICAgb2JqZWN0Rml0PVwiY292ZXJcIlxuICAgICAgICBzdHlsZT17aXNab29tZWQgJiYgIWlzTW9iaWxlID8geyB0cmFuc2Zvcm06ICdzY2FsZSgxLjA1KScgfSA6IHVuZGVmaW5lZH1cbiAgICAgICAgcXVhbGl0eT17cXVhbGl0eX1cbiAgICAgICAgbGF6eT17bGF6eX1cbiAgICAgIC8+XG4gICAgICB7IHRvcExlZnQgJiYgKFxuICAgICAgICA8Q29ybmVyXG4gICAgICAgICAgcG9zaXRpb249XCJ0b3AtbGVmdFwiXG4gICAgICAgICAgb25DbGljaz17aGFuZGxlQ29ybmVyQ2xpY2t9XG4gICAgICAgID5cbiAgICAgICAgICB7IHRvcExlZnQgfVxuICAgICAgICA8L0Nvcm5lcj5cbiAgICAgICkgfVxuICAgICAgeyB0b3BSaWdodCAmJiAoXG4gICAgICAgIDxDb3JuZXJcbiAgICAgICAgICBwb3NpdGlvbj1cInRvcC1yaWdodFwiXG4gICAgICAgICAgb25DbGljaz17aGFuZGxlQ29ybmVyQ2xpY2t9XG4gICAgICAgID5cbiAgICAgICAgICB7IHRvcFJpZ2h0IH1cbiAgICAgICAgPC9Db3JuZXI+XG4gICAgICApIH1cbiAgICAgIHsgYm90dG9tTGVmdCAmJiAoXG4gICAgICAgIDxDb3JuZXJcbiAgICAgICAgICBwb3NpdGlvbj1cImJvdHRvbS1sZWZ0XCJcbiAgICAgICAgICBvbkNsaWNrPXtoYW5kbGVDb3JuZXJDbGlja31cbiAgICAgICAgPlxuICAgICAgICAgIHsgYm90dG9tTGVmdCB9XG4gICAgICAgIDwvQ29ybmVyPlxuICAgICAgKSB9XG4gICAgICB7IGJvdHRvbVJpZ2h0ICYmIChcbiAgICAgICAgPENvcm5lclxuICAgICAgICAgIHBvc2l0aW9uPVwiYm90dG9tLXJpZ2h0XCJcbiAgICAgICAgICBvbkNsaWNrPXtoYW5kbGVDb3JuZXJDbGlja31cbiAgICAgICAgPlxuICAgICAgICAgIHsgYm90dG9tUmlnaHQgfVxuICAgICAgICA8L0Nvcm5lcj5cbiAgICAgICkgfVxuICAgICAgeyBkaW0gJiYgPERpbT57IGRpbSB9PC9EaW0+IH1cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn07XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXY8eyBhc3BlY3Q6IG51bWJlciB9PmBcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oNCl9O1xuICAmOmJlZm9yZSB7XG4gICAgY29udGVudDogXCJcIjtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICAkeyh7IGFzcGVjdCB9KSA9PiBjc3NgXG4gICAgICBwYWRkaW5nLXRvcDogJHsxMDAgLyBhc3BlY3R9JTtcbiAgICBgfVxuICB9XG5gO1xuXG5jb25zdCBUaHVtYm5haWwgPSBzdHlsZWQoUmVzaXplSW1hZ2UpYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgdHJhbnNpdGlvbjogdHJhbnNmb3JtIC4ycztcbmA7XG5cbmNvbnN0IENvcm5lciA9IHN0eWxlZC5kaXY8e1xuICBwb3NpdGlvbjogJ3RvcC1sZWZ0JyB8ICd0b3AtcmlnaHQnIHwgJ2JvdHRvbS1sZWZ0JyB8ICdib3R0b20tcmlnaHQnLFxufT5gXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgcGFkZGluZzogJHtweFRvUmVtKDYpfTtcbiAgZm9udC1zaXplOiAwO1xuICB6LWluZGV4OiAxO1xuICAkeyh7IHBvc2l0aW9uIH0pID0+IHtcbiAgICBzd2l0Y2ggKHBvc2l0aW9uKSB7XG4gICAgICBjYXNlICd0b3AtbGVmdCc6XG4gICAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICAgdG9wOiAke3B4VG9SZW0oNil9O1xuICAgICAgICAgIGxlZnQ6ICR7cHhUb1JlbSg2KX07XG4gICAgICAgIGA7XG4gICAgICBjYXNlICd0b3AtcmlnaHQnOlxuICAgICAgICByZXR1cm4gY3NzYFxuICAgICAgICAgIHRvcDogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgICByaWdodDogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgYDtcbiAgICAgIGNhc2UgJ2JvdHRvbS1sZWZ0JzpcbiAgICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgICBsZWZ0OiAke3B4VG9SZW0oNil9O1xuICAgICAgICAgIGJvdHRvbTogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgYDtcbiAgICAgIGNhc2UgJ2JvdHRvbS1yaWdodCc6XG4gICAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICAgcmlnaHQ6ICR7cHhUb1JlbSg2KX07XG4gICAgICAgICAgYm90dG9tOiAke3B4VG9SZW0oNil9O1xuICAgICAgICBgO1xuICAgICAgZGVmYXVsdDpcbiAgICAgICAgcmV0dXJuICcnO1xuICAgIH1cbiAgfX1cbmA7XG5cbmNvbnN0IERpbSA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlNn07XG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuZGltLmJhc2ljfTtcbmA7XG5cbiJdfQ== */"));
const Dim = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm0"
} : {
  target: "e8i2tqm0",
  label: "Dim"
})("position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;color:", ({
  theme
}) => theme.content.base6, ";background:", ({
  theme
}) => theme.dim.basic, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const HorizontalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$g, {
    "data-testid": "horizontal-feed-item",
    className: className,
    children: [jsx(FeedItemThumbnail, {
      aspect: 3 / 2,
      ...thumbnail
    }), title && jsx(Title$6, {
      children: title
    }), writer && jsxs(Writer, {
      onClick: e => {
        writer.onClick?.(e);
        e.preventDefault();
        e.stopPropagation();
      },
      children: [writer.avatar && jsx(Avatar, {
        children: jsx(ResizeImage, {
          src: writer.avatar,
          intrinsicInitialWidth: 18,
          intrinsicAspect: 1,
          objectFit: "cover"
        })
      }), jsx(Nickname$2, {
        children: writer.nickname
      }), jsx(RightNickname, {
        children: writer.rightNickName
      })]
    }), counts && jsx(Counts$1, {
      children: counts.map((count, i) => jsx(Count$1, {
        children: `${count.label} ${count.number.toLocaleString()}`
      }, i))
    })]
  });
};
const Container$g = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u7"
} : {
  target: "e1yd5r1u7",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1azakc",
  styles: "text-align:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhvcml6b250YWxGZWVkSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0U0QiIsImZpbGUiOiJIb3Jpem9udGFsRmVlZEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBSZXNpemVJbWFnZSxcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbXBvcnQgeyBGZWVkSXRlbUJhc2VQcm9wcyB9IGZyb20gJy4vRmVlZEl0ZW0nO1xuaW1wb3J0IHsgRmVlZEl0ZW1UaHVtYm5haWwgfSBmcm9tICcuLi9mZWVkLWl0ZW0tdGh1bWJuYWlsJztcblxuZXhwb3J0IGNvbnN0IEhvcml6b250YWxGZWVkSXRlbSA9ICh7XG4gIGNsYXNzTmFtZSxcbiAgdGh1bWJuYWlsLFxuICB0aXRsZSxcbiAgd3JpdGVyLFxuICBjb3VudHMsXG59OiBGZWVkSXRlbUJhc2VQcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBkYXRhLXRlc3RpZD1cImhvcml6b250YWwtZmVlZC1pdGVtXCIgY2xhc3NOYW1lPXtjbGFzc05hbWV9PlxuICAgICAgPEZlZWRJdGVtVGh1bWJuYWlsXG4gICAgICAgIGFzcGVjdD17MyAvIDJ9XG4gICAgICAgIHsuLi50aHVtYm5haWx9XG4gICAgICAvPlxuICAgICAgeyB0aXRsZSAmJiA8VGl0bGU+eyB0aXRsZSB9PC9UaXRsZT4gfVxuICAgICAgeyB3cml0ZXIgJiYgKFxuICAgICAgICA8V3JpdGVyXG4gICAgICAgICAgb25DbGljaz17KGUpID0+IHtcbiAgICAgICAgICAgIHdyaXRlci5vbkNsaWNrPy4oZSk7XG4gICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgICAgICAgICBlLnN0b3BQcm9wYWdhdGlvbigpO1xuICAgICAgICAgIH19XG4gICAgICAgID5cbiAgICAgICAgICB7IHdyaXRlci5hdmF0YXIgJiYgKFxuICAgICAgICAgICAgPEF2YXRhcj5cbiAgICAgICAgICAgICAgPFJlc2l6ZUltYWdlXG4gICAgICAgICAgICAgICAgc3JjPXt3cml0ZXIuYXZhdGFyfVxuICAgICAgICAgICAgICAgIGludHJpbnNpY0luaXRpYWxXaWR0aD17MTh9XG4gICAgICAgICAgICAgICAgaW50cmluc2ljQXNwZWN0PXsxfVxuICAgICAgICAgICAgICAgIG9iamVjdEZpdD1cImNvdmVyXCJcbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvQXZhdGFyPlxuICAgICAgICAgICkgfVxuICAgICAgICAgIDxOaWNrbmFtZT5cbiAgICAgICAgICAgIHsgd3JpdGVyLm5pY2tuYW1lIH1cbiAgICAgICAgICA8L05pY2tuYW1lPlxuICAgICAgICAgIDxSaWdodE5pY2tuYW1lPlxuICAgICAgICAgICAgeyB3cml0ZXIucmlnaHROaWNrTmFtZSB9XG4gICAgICAgICAgPC9SaWdodE5pY2tuYW1lPlxuICAgICAgICA8L1dyaXRlcj5cbiAgICAgICkgfVxuICAgICAgeyBjb3VudHMgJiYgKFxuICAgICAgICA8Q291bnRzPlxuICAgICAgICAgIHsgY291bnRzLm1hcCgoY291bnQsIGkpID0+IChcbiAgICAgICAgICAgIDxDb3VudCBrZXk9e2l9PlxuICAgICAgICAgICAgICB7IGAke2NvdW50LmxhYmVsfSAke2NvdW50Lm51bWJlci50b0xvY2FsZVN0cmluZygpfWAgfVxuICAgICAgICAgICAgPC9Db3VudD5cbiAgICAgICAgICApKSB9XG4gICAgICAgIDwvQ291bnRzPlxuICAgICAgKSB9XG4gICAgPC9Db250YWluZXI+XG4gICk7XG59O1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5wYFxuICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUxfVxuICBvdmVyZmxvdzogaGlkZGVuO1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDE0KX07XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICBmb250LXdlaWdodDogNzAwO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd29yZC13cmFwOiBicmVhay13b3JkO1xuICAtd2Via2l0LWxpbmUtY2xhbXA6IDI7XG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG5gO1xuXG5jb25zdCBXcml0ZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDgpfTtcbiAgJHtGT05UX1NUWUxFLnN1YlRpdGxlMn1cbiAgZm9udC13ZWlnaHQ6IDUwMDtcbmA7XG5cbmNvbnN0IEF2YXRhciA9IHN0eWxlZC5kaXZgXG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgd2lkdGg6ICR7cHhUb1JlbSgxOCl9O1xuICBoZWlnaHQ6ICR7cHhUb1JlbSgxOCl9O1xuICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSg2KX07XG4gIGZsZXg6IG5vbmU7XG5gO1xuXG5jb25zdCBOaWNrbmFtZSA9IHN0eWxlZC5zcGFuYFxuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICAtd2Via2l0LWxpbmUtY2xhbXA6IDE7XG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbmA7XG5cbmNvbnN0IFJpZ2h0Tmlja25hbWUgPSBzdHlsZWQuc3BhbmBcbiAgZmxleDogbm9uZTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbmA7XG5cbmNvbnN0IENvdW50cyA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG1hcmdpbi10b3A6ICR7cHhUb1JlbSg4KX07XG5gO1xuXG5jb25zdCBDb3VudCA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUyfVxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSg4KX07XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICAmOmJlZm9yZSB7XG4gICAgY29udGVudDogXCJcIjtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICAgIGxlZnQ6ICR7cHhUb1JlbSgtNCl9O1xuICAgIGJvdHRvbTogMDtcbiAgICB3aWR0aDogJHtweFRvUmVtKDIpfTtcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSgyKX07XG4gICAgbWFyZ2luOiBhdXRvO1xuICAgIGJvcmRlci1yYWRpdXM6IDEwMCU7XG4gICAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgfVxuICAmOmZpcnN0LW9mLXR5cGU6YmVmb3JlIHtcbiAgICBjb250ZW50OiBub25lO1xuICB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
});
const Title$6 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u6"
} : {
  target: "e1yd5r1u6",
  label: "Title"
})(FONT_STYLE.subTitle1, " overflow:hidden;display:-webkit-box;margin-top:", pxToRem(14), ";color:", ({
  theme
}) => theme.content.base1, ";font-weight:700;text-overflow:ellipsis;word-wrap:break-word;-webkit-line-clamp:2;-webkit-box-orient:vertical;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Writer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u5"
} : {
  target: "e1yd5r1u5",
  label: "Writer"
})("display:flex;align-items:center;justify-content:center;margin-top:", pxToRem(8), ";", FONT_STYLE.subTitle2, " font-weight:500;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Avatar = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u4"
} : {
  target: "e1yd5r1u4",
  label: "Avatar"
})("overflow:hidden;position:relative;width:", pxToRem(18), ";height:", pxToRem(18), ";border-radius:100%;margin-right:", pxToRem(6), ";flex:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Nickname$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u3"
} : {
  target: "e1yd5r1u3",
  label: "Nickname"
})("color:", ({
  theme
}) => theme.content.base1, ";display:flex;align-items:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const RightNickname = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u2"
} : {
  target: "e1yd5r1u2",
  label: "RightNickname"
})(process.env.NODE_ENV === "production" ? {
  name: "1iiyiwh",
  styles: "flex:none;display:flex;align-items:center"
} : {
  name: "1iiyiwh",
  styles: "flex:none;display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
});
const Counts$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u1"
} : {
  target: "e1yd5r1u1",
  label: "Counts"
})("display:flex;flex-wrap:wrap;align-items:center;justify-content:center;margin-top:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Count$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u0"
} : {
  target: "e1yd5r1u0",
  label: "Count"
})(FONT_STYLE.subTitle2, " position:relative;flex-shrink:0;margin-right:", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", pxToRem(-4), ";bottom:0;width:", pxToRem(2), ";height:", pxToRem(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type:before{content:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const VerticalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$f, {
    "data-testid": "vertical-feed-item",
    className: className,
    children: [jsx(Column, {
      children: jsx(FeedItemThumbnail, {
        aspect: 8 / 5,
        ...thumbnail
      })
    }), jsxs(Column, {
      children: [jsx(Row$1, {
        children: title && jsx(Title$5, {
          children: title
        })
      }), writer && jsxs(Nickname$1, {
        onClick: writer.onClick,
        children: [writer.nickname, writer.rightNickName]
      }), counts && jsx(Counts, {
        children: counts.map((count, i) => jsx(Count, {
          children: `${count.label} ${count.number.toLocaleString()}`
        }, i))
      })]
    })]
  });
};
const Container$f = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m6"
} : {
  target: "emnxm2m6",
  label: "Container"
})("overflow:hidden;display:flex;align-items:top;width:100%;padding:0 ", pxToRem(16), ";box-sizing:border-box;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Column = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m5"
} : {
  target: "emnxm2m5",
  label: "Column"
})("flex:1 0 0%;margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlZlcnRpY2FsRmVlZEl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVEeUIiLCJmaWxlIjoiVmVydGljYWxGZWVkSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IEZPTlRfU1RZTEUsIHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IEZlZWRJdGVtQmFzZVByb3BzIH0gZnJvbSAnLi9GZWVkSXRlbSc7XG5pbXBvcnQgeyBGZWVkSXRlbVRodW1ibmFpbCB9IGZyb20gJy4uL2ZlZWQtaXRlbS10aHVtYm5haWwnO1xuXG5leHBvcnQgY29uc3QgVmVydGljYWxGZWVkSXRlbSA9ICh7XG4gIGNsYXNzTmFtZSxcbiAgdGh1bWJuYWlsLFxuICB0aXRsZSxcbiAgd3JpdGVyLFxuICBjb3VudHMsXG59OiBGZWVkSXRlbUJhc2VQcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBkYXRhLXRlc3RpZD1cInZlcnRpY2FsLWZlZWQtaXRlbVwiIGNsYXNzTmFtZT17Y2xhc3NOYW1lfT5cbiAgICAgIDxDb2x1bW4+XG4gICAgICAgIDxGZWVkSXRlbVRodW1ibmFpbFxuICAgICAgICAgIGFzcGVjdD17OCAvIDV9XG4gICAgICAgICAgey4uLnRodW1ibmFpbH1cbiAgICAgICAgLz5cbiAgICAgIDwvQ29sdW1uPlxuICAgICAgPENvbHVtbj5cbiAgICAgICAgPFJvdz5cbiAgICAgICAgICB7IHRpdGxlICYmIDxUaXRsZT57IHRpdGxlIH08L1RpdGxlPiB9XG4gICAgICAgIDwvUm93PlxuICAgICAgICB7IHdyaXRlciAmJiAoXG4gICAgICAgICAgPE5pY2tuYW1lIG9uQ2xpY2s9e3dyaXRlci5vbkNsaWNrfT5cbiAgICAgICAgICAgIHsgd3JpdGVyLm5pY2tuYW1lIH1cbiAgICAgICAgICAgIHsgd3JpdGVyLnJpZ2h0Tmlja05hbWUgfVxuICAgICAgICAgIDwvTmlja25hbWU+XG4gICAgICAgICkgfVxuICAgICAgICB7IGNvdW50cyAmJiAoXG4gICAgICAgICAgPENvdW50cz5cbiAgICAgICAgICAgIHsgY291bnRzLm1hcCgoY291bnQsIGkpID0+IChcbiAgICAgICAgICAgICAgPENvdW50IGtleT17aX0+XG4gICAgICAgICAgICAgICAgeyBgJHtjb3VudC5sYWJlbH0gJHtjb3VudC5udW1iZXIudG9Mb2NhbGVTdHJpbmcoKX1gIH1cbiAgICAgICAgICAgICAgPC9Db3VudD5cbiAgICAgICAgICAgICkpIH1cbiAgICAgICAgICA8L0NvdW50cz5cbiAgICAgICAgKSB9XG4gICAgICA8L0NvbHVtbj5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn07XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiB0b3A7XG4gIHdpZHRoOiAxMDAlO1xuICBwYWRkaW5nOiAwICR7cHhUb1JlbSgxNil9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuYDtcblxuY29uc3QgQ29sdW1uID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAwIDAlO1xuICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDEyKX07XG4gICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbmA7XG5cbmNvbnN0IFJvdyA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5wYFxuICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUxfVxuICBvdmVyZmxvdzogaGlkZGVuO1xuICBmbGV4OiAxIDAgMCU7XG4gIGRpc3BsYXk6IC13ZWJraXQtYm94O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfTtcbiAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIHdvcmQtd3JhcDogYnJlYWstd29yZDtcbiAgLXdlYmtpdC1saW5lLWNsYW1wOiAzO1xuICAtd2Via2l0LWJveC1vcmllbnQ6IHZlcnRpY2FsO1xuYDtcblxuY29uc3QgTmlja25hbWUgPSBzdHlsZWQuc3BhbmBcbiAgJHtGT05UX1NUWUxFLmJvZHkzfVxuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDgpfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMn07XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5gO1xuXG5jb25zdCBDb3VudHMgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIG1hcmdpbi10b3A6ICR7cHhUb1JlbSgyKX07XG5gO1xuXG5jb25zdCBDb3VudCA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuYm9keTN9XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1hcmdpbjogMCAke3B4VG9SZW0oOCl9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgJjpiZWZvcmUge1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogMDtcbiAgICBsZWZ0OiAke3B4VG9SZW0oLTQpfTtcbiAgICBib3R0b206IDA7XG4gICAgd2lkdGg6ICR7cHhUb1JlbSgyKX07XG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oMil9O1xuICAgIG1hcmdpbjogYXV0bztcbiAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMn07XG4gIH1cbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBtYXJnaW4tbGVmdDogMDtcbiAgICAmOmJlZm9yZSB7XG4gICAgICBjb250ZW50OiBub25lO1xuICAgIH1cbiAgfVxuYDtcbiJdfQ== */"));
const Row$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m4"
} : {
  target: "emnxm2m4",
  label: "Row"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
});
const Title$5 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m3"
} : {
  target: "emnxm2m3",
  label: "Title"
})(FONT_STYLE.subTitle1, " overflow:hidden;flex:1 0 0%;display:-webkit-box;color:", ({
  theme
}) => theme.content.base1, ";font-weight:500;text-overflow:ellipsis;word-wrap:break-word;-webkit-line-clamp:3;-webkit-box-orient:vertical;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Nickname$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m2"
} : {
  target: "emnxm2m2",
  label: "Nickname"
})(FONT_STYLE.body3, " display:block;margin-top:", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";font-weight:500;display:flex;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Counts = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m1"
} : {
  target: "emnxm2m1",
  label: "Counts"
})("display:flex;flex-wrap:wrap;align-items:center;margin-top:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlZlcnRpY2FsRmVlZEl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBGeUIiLCJmaWxlIjoiVmVydGljYWxGZWVkSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IEZPTlRfU1RZTEUsIHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IEZlZWRJdGVtQmFzZVByb3BzIH0gZnJvbSAnLi9GZWVkSXRlbSc7XG5pbXBvcnQgeyBGZWVkSXRlbVRodW1ibmFpbCB9IGZyb20gJy4uL2ZlZWQtaXRlbS10aHVtYm5haWwnO1xuXG5leHBvcnQgY29uc3QgVmVydGljYWxGZWVkSXRlbSA9ICh7XG4gIGNsYXNzTmFtZSxcbiAgdGh1bWJuYWlsLFxuICB0aXRsZSxcbiAgd3JpdGVyLFxuICBjb3VudHMsXG59OiBGZWVkSXRlbUJhc2VQcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBkYXRhLXRlc3RpZD1cInZlcnRpY2FsLWZlZWQtaXRlbVwiIGNsYXNzTmFtZT17Y2xhc3NOYW1lfT5cbiAgICAgIDxDb2x1bW4+XG4gICAgICAgIDxGZWVkSXRlbVRodW1ibmFpbFxuICAgICAgICAgIGFzcGVjdD17OCAvIDV9XG4gICAgICAgICAgey4uLnRodW1ibmFpbH1cbiAgICAgICAgLz5cbiAgICAgIDwvQ29sdW1uPlxuICAgICAgPENvbHVtbj5cbiAgICAgICAgPFJvdz5cbiAgICAgICAgICB7IHRpdGxlICYmIDxUaXRsZT57IHRpdGxlIH08L1RpdGxlPiB9XG4gICAgICAgIDwvUm93PlxuICAgICAgICB7IHdyaXRlciAmJiAoXG4gICAgICAgICAgPE5pY2tuYW1lIG9uQ2xpY2s9e3dyaXRlci5vbkNsaWNrfT5cbiAgICAgICAgICAgIHsgd3JpdGVyLm5pY2tuYW1lIH1cbiAgICAgICAgICAgIHsgd3JpdGVyLnJpZ2h0Tmlja05hbWUgfVxuICAgICAgICAgIDwvTmlja25hbWU+XG4gICAgICAgICkgfVxuICAgICAgICB7IGNvdW50cyAmJiAoXG4gICAgICAgICAgPENvdW50cz5cbiAgICAgICAgICAgIHsgY291bnRzLm1hcCgoY291bnQsIGkpID0+IChcbiAgICAgICAgICAgICAgPENvdW50IGtleT17aX0+XG4gICAgICAgICAgICAgICAgeyBgJHtjb3VudC5sYWJlbH0gJHtjb3VudC5udW1iZXIudG9Mb2NhbGVTdHJpbmcoKX1gIH1cbiAgICAgICAgICAgICAgPC9Db3VudD5cbiAgICAgICAgICAgICkpIH1cbiAgICAgICAgICA8L0NvdW50cz5cbiAgICAgICAgKSB9XG4gICAgICA8L0NvbHVtbj5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn07XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiB0b3A7XG4gIHdpZHRoOiAxMDAlO1xuICBwYWRkaW5nOiAwICR7cHhUb1JlbSgxNil9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuYDtcblxuY29uc3QgQ29sdW1uID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAwIDAlO1xuICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDEyKX07XG4gICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgbWFyZ2luLWxlZnQ6IDA7XG4gIH1cbmA7XG5cbmNvbnN0IFJvdyA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5wYFxuICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUxfVxuICBvdmVyZmxvdzogaGlkZGVuO1xuICBmbGV4OiAxIDAgMCU7XG4gIGRpc3BsYXk6IC13ZWJraXQtYm94O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfTtcbiAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIHdvcmQtd3JhcDogYnJlYWstd29yZDtcbiAgLXdlYmtpdC1saW5lLWNsYW1wOiAzO1xuICAtd2Via2l0LWJveC1vcmllbnQ6IHZlcnRpY2FsO1xuYDtcblxuY29uc3QgTmlja25hbWUgPSBzdHlsZWQuc3BhbmBcbiAgJHtGT05UX1NUWUxFLmJvZHkzfVxuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDgpfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMn07XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5gO1xuXG5jb25zdCBDb3VudHMgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIG1hcmdpbi10b3A6ICR7cHhUb1JlbSgyKX07XG5gO1xuXG5jb25zdCBDb3VudCA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuYm9keTN9XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1hcmdpbjogMCAke3B4VG9SZW0oOCl9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgJjpiZWZvcmUge1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogMDtcbiAgICBsZWZ0OiAke3B4VG9SZW0oLTQpfTtcbiAgICBib3R0b206IDA7XG4gICAgd2lkdGg6ICR7cHhUb1JlbSgyKX07XG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oMil9O1xuICAgIG1hcmdpbjogYXV0bztcbiAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMn07XG4gIH1cbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBtYXJnaW4tbGVmdDogMDtcbiAgICAmOmJlZm9yZSB7XG4gICAgICBjb250ZW50OiBub25lO1xuICAgIH1cbiAgfVxuYDtcbiJdfQ== */"));
const Count = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m0"
} : {
  target: "emnxm2m0",
  label: "Count"
})(FONT_STYLE.body3, " flex-shrink:0;position:relative;margin:0 ", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", pxToRem(-4), ";bottom:0;width:", pxToRem(2), ";height:", pxToRem(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type{margin-left:0;&:before{content:none;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItem = /*#__PURE__*/React__default.memo(({
  flow = 'horizontal',
  link,
  onClick,
  onImpression = () => {/* noop */},
  ...props
}) => {
  const [isHovered, setHovered] = useState(false);
  const intersectionObserverTarget = useIntersectionObserver({
    options: {
      triggerOnce: true
    },
    onIntersect: onImpression
  });
  const feedItem = jsxs(Container$e, {
    ref: intersectionObserverTarget,
    clickable: !!onClick,
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    children: [flow === 'horizontal' && jsx(HorizontalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    }), flow === 'vertical' && jsx(VerticalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    })]
  });
  if (link) {
    const Link = link.component;
    return jsx(Link, {
      href: link.href,
      children: feedItem
    });
  } else {
    return feedItem;
  }
});
var _ref$m = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "daeijt-Container",
  styles: "cursor:pointer;label:Container;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};
const Container$e = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etxueos0"
} : {
  target: "etxueos0",
  label: "Container"
})("position:relative;", ({
  clickable
}) => clickable && _ref$m, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

/**
 * @internal
 */
const SkeletonThemeContext = React__default.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = React__default.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (React__default.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(React__default.createElement(React__default.Fragment, { key: i },
                skeletonSpan,
                React__default.createElement("br", null)));
        }
    }
    return (React__default.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => React__default.createElement(Wrapper, { key: i }, el))
        : elements));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemPlaceholder = /*#__PURE__*/React__default.memo(({
  flow = 'horizontal'
}) => {
  if (flow === 'vertical') {
    return jsxs(VerticalContainer, {
      "data-testid": "vertical-container",
      children: [jsx(VerticalContainerColumn, {
        children: jsx(ImageSkeletonWrapper, {
          children: jsx(ImageSkeleton$3, {})
        })
      }), jsxs(VerticalContainerColumn, {
        children: [jsx(TextSkeleton$2, {}), jsx(TextSkeleton$2, {
          width: "50%",
          marginTop: 8
        })]
      })]
    });
  }
  return jsxs(HorizontalContainer, {
    "data-testid": "horizontal-container",
    children: [jsx(ImageSkeletonWrapper, {
      children: jsx(ImageSkeleton$3, {})
    }), jsx(TextSkeleton$2, {
      marginTop: 14
    }), jsx(TextSkeleton$2, {
      width: "50%",
      marginTop: 8
    })]
  });
});
const HorizontalContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh5"
} : {
  target: "e1adnbeh5",
  label: "HorizontalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1xe63ku",
  styles: "line-height:1"
} : {
  name: "1xe63ku",
  styles: "line-height:1",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
});
const VerticalContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh4"
} : {
  target: "e1adnbeh4",
  label: "VerticalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : {
  name: "7whenc",
  styles: "display:flex;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
});
const VerticalContainerColumn = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh3"
} : {
  target: "e1adnbeh3",
  label: "VerticalContainerColumn"
})("flex:1;margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ImageSkeletonWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh2"
} : {
  target: "e1adnbeh2",
  label: "ImageSkeletonWrapper"
})("position:relative;&:before{content:\"\";display:block;padding-top:", 2 / 3 * 100, "%;}br{display:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ImageSkeleton$3 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh1"
} : {
  target: "e1adnbeh1",
  label: "ImageSkeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1at77vf",
  styles: "position:absolute;top:0;left:0;min-height:100%"
} : {
  name: "1at77vf",
  styles: "position:absolute;top:0;left:0;min-height:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
});
const TextSkeleton$2 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh0"
} : {
  target: "e1adnbeh0",
  label: "TextSkeleton"
})("margin-top:", ({
  marginTop
}) => marginTop ? pxToRem(marginTop) : 0, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const canPlayHls = videoElem => {
  return !!videoElem.canPlayType('application/vnd.apple.mpegurl');
};
const Video = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    src,
    autoPlay,
    useHlsJs = true,
    hlsConfig,
    quality = 'auto',
    ...restProps
  } = props;
  const videoRef = useRef(null);
  const mergedRef = useMergeRef(ref ?? null, videoRef);
  useEffect(() => {
    const videoElem = videoRef.current;
    if (!videoElem || !src) {
      return;
    }
    let unmounted = false;
    let playPromise;
    Promise.resolve().then(function () { return hls; }).then(({
      default: HlsJs
    }) => {
      if (unmounted) {
        return;
      }
      if (!src) {
        return;
      }
      if (!useHlsJs) {
        videoElem.src = src;
      } else if (HlsJs.isSupported()) {
        const hls = new HlsJs(hlsConfig ?? {});
        hls.attachMedia(videoElem);
        hls.loadSource(src);
        if (quality === 'low') {
          hls.autoLevelCapping = 0;
        }
        if (quality === 'auto') {
          hls.capLevelToPlayerSize = true;
        }
      } else if (canPlayHls(videoElem)) {
        videoElem.src = src;
      }
      videoElem.load();
      // Because Safari
      if (autoPlay) {
        playPromise = videoElem.play();
      }
    });
    return () => {
      unmounted = true;
      if (playPromise !== undefined) {
        playPromise.then(() => {
          videoElem.removeAttribute('src');
          videoElem.load();
        }).catch(() => {
          /**
           * Uncaught (in promise) DOMException: The play() request was interrupted because the media was removed from the document.
           * catch above error
           * */
        });
      }
    };
  }, [src, useHlsJs, autoPlay, hlsConfig, quality]);
  return jsx("video", {
    ...restProps,
    "data-testid": "video",
    src: src,
    autoPlay: autoPlay,
    ref: mergedRef
  });
});

const FeedItemVideoThumbnail = ({
  src,
  aspect = 3 / 2,
  canPlay,
  poster
}) => {
  return jsx(VideoContainer, {
    aspect: aspect,
    children: canPlay && jsx(StyledVideoPlayer, {
      src: src,
      quality: "auto",
      loop: true,
      autoPlay: true,
      muted: true,
      playsInline: true,
      poster: poster
    })
  });
};
const StyledVideoPlayer = /*#__PURE__*/_styled(Video, process.env.NODE_ENV === "production" ? {
  target: "efg1py01"
} : {
  target: "efg1py01",
  label: "StyledVideoPlayer"
})("width:100%;height:100%;object-fit:cover;border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlZWRJdGVtVmlkZW9UaHVtYm5haWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1DdUMiLCJmaWxlIjoiRmVlZEl0ZW1WaWRlb1RodW1ibmFpbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgVmlkZW8gfSBmcm9tICdAY29udGVudC9jb21wb25lbnRzL3ZpZGVvJztcblxuZXhwb3J0IGludGVyZmFjZSBGZWVkSXRlbVZpZGVvVGh1bWJuYWlsUHJvcHMge1xuICBzcmM6IHN0cmluZztcbiAgYXNwZWN0PzogbnVtYmVyO1xuICBjYW5QbGF5OiBib29sZWFuO1xuICBwb3N0ZXI/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjb25zdCBGZWVkSXRlbVZpZGVvVGh1bWJuYWlsID0gKHtcbiAgc3JjLFxuICBhc3BlY3QgPSAzIC8gMixcbiAgY2FuUGxheSxcbiAgcG9zdGVyLFxufTogRmVlZEl0ZW1WaWRlb1RodW1ibmFpbFByb3BzKTogUmVhY3RFbGVtZW50ID0+IHtcbiAgcmV0dXJuIChcbiAgICA8VmlkZW9Db250YWluZXIgYXNwZWN0PXthc3BlY3R9PlxuICAgICAgeyBjYW5QbGF5ICYmIChcbiAgICAgICAgPFN0eWxlZFZpZGVvUGxheWVyXG4gICAgICAgICAgc3JjPXtzcmN9XG4gICAgICAgICAgcXVhbGl0eT1cImF1dG9cIlxuICAgICAgICAgIGxvb3BcbiAgICAgICAgICBhdXRvUGxheVxuICAgICAgICAgIG11dGVkXG4gICAgICAgICAgcGxheXNJbmxpbmVcbiAgICAgICAgICBwb3N0ZXI9e3Bvc3Rlcn1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgIDwvVmlkZW9Db250YWluZXI+XG4gICk7XG59O1xuXG5jb25zdCBTdHlsZWRWaWRlb1BsYXllciA9IHN0eWxlZChWaWRlbylgXG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG9iamVjdC1maXQ6IGNvdmVyO1xuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oNCl9O1xuYDtcblxuY29uc3QgVmlkZW9Db250YWluZXIgPSBzdHlsZWQuZGl2PHsgYXNwZWN0OiBudW1iZXIgfT5gXG4gIGFzcGVjdC1yYXRpbzogJHsocHJvcHMpID0+IHByb3BzLmFzcGVjdH07XG5gO1xuIl19 */"));
const VideoContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efg1py00"
} : {
  target: "efg1py00",
  label: "VideoContainer"
})("aspect-ratio:", props => props.aspect, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlZWRJdGVtVmlkZW9UaHVtYm5haWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBDcUQiLCJmaWxlIjoiRmVlZEl0ZW1WaWRlb1RodW1ibmFpbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZWFjdEVsZW1lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgVmlkZW8gfSBmcm9tICdAY29udGVudC9jb21wb25lbnRzL3ZpZGVvJztcblxuZXhwb3J0IGludGVyZmFjZSBGZWVkSXRlbVZpZGVvVGh1bWJuYWlsUHJvcHMge1xuICBzcmM6IHN0cmluZztcbiAgYXNwZWN0PzogbnVtYmVyO1xuICBjYW5QbGF5OiBib29sZWFuO1xuICBwb3N0ZXI/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjb25zdCBGZWVkSXRlbVZpZGVvVGh1bWJuYWlsID0gKHtcbiAgc3JjLFxuICBhc3BlY3QgPSAzIC8gMixcbiAgY2FuUGxheSxcbiAgcG9zdGVyLFxufTogRmVlZEl0ZW1WaWRlb1RodW1ibmFpbFByb3BzKTogUmVhY3RFbGVtZW50ID0+IHtcbiAgcmV0dXJuIChcbiAgICA8VmlkZW9Db250YWluZXIgYXNwZWN0PXthc3BlY3R9PlxuICAgICAgeyBjYW5QbGF5ICYmIChcbiAgICAgICAgPFN0eWxlZFZpZGVvUGxheWVyXG4gICAgICAgICAgc3JjPXtzcmN9XG4gICAgICAgICAgcXVhbGl0eT1cImF1dG9cIlxuICAgICAgICAgIGxvb3BcbiAgICAgICAgICBhdXRvUGxheVxuICAgICAgICAgIG11dGVkXG4gICAgICAgICAgcGxheXNJbmxpbmVcbiAgICAgICAgICBwb3N0ZXI9e3Bvc3Rlcn1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgIDwvVmlkZW9Db250YWluZXI+XG4gICk7XG59O1xuXG5jb25zdCBTdHlsZWRWaWRlb1BsYXllciA9IHN0eWxlZChWaWRlbylgXG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG9iamVjdC1maXQ6IGNvdmVyO1xuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oNCl9O1xuYDtcblxuY29uc3QgVmlkZW9Db250YWluZXIgPSBzdHlsZWQuZGl2PHsgYXNwZWN0OiBudW1iZXIgfT5gXG4gIGFzcGVjdC1yYXRpbzogJHsocHJvcHMpID0+IHByb3BzLmFzcGVjdH07XG5gO1xuIl19 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItem = ({
  writer,
  thumbnail,
  videoThumbnail,
  actions,
  title,
  link
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const Link = link.component;
  const countFormatter = new Intl.NumberFormat('en', {
    notation: 'compact'
  });
  return jsxs("div", {
    children: [writer && jsxs(WriterContainer$1, {
      children: [jsxs(WriterMainContainer, {
        children: [jsxs(WriterLink, {
          as: Link,
          href: writer.href,
          onClick: writer.onClick,
          children: [jsx(WriterNickname, {
            children: writer.nickname
          }), jsx(WriterAvatar, {
            children: jsx(ResizeImage, {
              src: writer.avatarSrc,
              intrinsicInitialWidth: 72,
              intrinsicAspect: 1,
              objectFit: "cover",
              alt: ""
            })
          })]
        }), writer.action && jsxs(Fragment$1, {
          children: [jsx(WriterNickname, {
            children: "\xB7"
          }), jsx(WriterAction, {
            onClick: writer.action.onClick,
            children: writer.action.label
          })]
        })]
      }), writer.description && jsx(WriterDescription, {
        children: writer.description
      })]
    }), jsxs(Container$d, {
      children: [jsxs(Link, {
        href: link.href,
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        children: [jsxs(ThumbnailContainer$1, {
          children: [jsx(FeedItemThumbnail, {
            ...thumbnail,
            aspect: 1,
            isZoomed: isHovered
          }), videoThumbnail && jsx(VideoThumbnailContainer$1, {
            ref: targetRef,
            children: jsx(FeedItemVideoThumbnail, {
              src: videoThumbnail.src,
              aspect: 1,
              canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice()
            })
          })]
        }), actions && jsx(ActionsPlaceholder, {}), jsx(Title$4, {
          isHovered: isHovered,
          children: title
        })]
      }), actions && jsx(Actions, {
        children: actions.map(action => jsxs(ActionButton, {
          type: "button",
          onClick: action.onClick,
          children: [jsx(Icon$1, {
            name: action.iconName,
            size: 24,
            fill: theme => action.iconColor?.(theme) ?? theme.content.base1
          }), jsx(ActionCount, {
            children: countFormatter.format(action.count)
          })]
        }, action.iconName))
      })]
    })]
  });
};
const WriterContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr14"
} : {
  target: "e12sucbr14",
  label: "WriterContainer"
})("display:flex;flex-direction:column;gap:", pxToRem(2), ";position:relative;min-height:", pxToRem(40), ";padding-left:", pxToRem(48), ";margin-bottom:", pxToRem(16), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WriterMainContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr13"
} : {
  target: "e12sucbr13",
  label: "WriterMainContainer"
})("margin:auto 0;display:flex;align-items:center;gap:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WriterLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr12"
} : {
  target: "e12sucbr12",
  label: "WriterLink"
})(process.env.NODE_ENV === "production" ? {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}"
} : {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const WriterAvatar = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr11"
} : {
  target: "e12sucbr11",
  label: "WriterAvatar"
})("position:absolute;left:0;top:0;overflow:hidden;width:", pxToRem(36), ";height:", pxToRem(36), ";border-radius:100%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WriterNickname = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr10"
} : {
  target: "e12sucbr10",
  label: "WriterNickname"
})(FONT_STYLE.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WriterAction = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr9"
} : {
  target: "e12sucbr9",
  label: "WriterAction"
})(RESET_BUTTON, " ", FONT_STYLE.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.primary1.basic, ";white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const WriterDescription = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr8"
} : {
  target: "e12sucbr8",
  label: "WriterDescription"
})(FONT_STYLE.caption1, " color:", ({
  theme
}) => theme.content.base2, ";font-weight:400;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Container$d = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr7"
} : {
  target: "e12sucbr7",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const ThumbnailContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr6"
} : {
  target: "e12sucbr6",
  label: "ThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const VideoThumbnailContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr5"
} : {
  target: "e12sucbr5",
  label: "VideoThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : {
  name: "b98nv4",
  styles: "position:absolute;inset:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const ActionsPlaceholder = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr4"
} : {
  target: "e12sucbr4",
  label: "ActionsPlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "1k18kha",
  styles: "height:40px"
} : {
  name: "1k18kha",
  styles: "height:40px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const Actions = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr3"
} : {
  target: "e12sucbr3",
  label: "Actions"
})(process.env.NODE_ENV === "production" ? {
  name: "9h583h",
  styles: "position:absolute;top:0;width:100%;margin-top:100%;height:40px;display:flex;justify-content:space-between"
} : {
  name: "9h583h",
  styles: "position:absolute;top:0;width:100%;margin-top:100%;height:40px;display:flex;justify-content:space-between",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
const ActionButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr2"
} : {
  target: "e12sucbr2",
  label: "ActionButton"
})(RESET_BUTTON, " flex:1 0 0;padding:", pxToRem(12), " 0 ", pxToRem(4), " 0;display:flex;justify-content:center;align-items:center;&:hover{opacity:0.5;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ActionCount = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr1"
} : {
  target: "e12sucbr1",
  label: "ActionCount"
})(FONT_STYLE.body3, " color:", ({
  theme
}) => theme.content.base1, ";margin-left:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRGZWVkSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOFArQiIsImZpbGUiOiJDYXJkRmVlZEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyB1c2VJblZpZXcgfSBmcm9tICdyZWFjdC1pbnRlcnNlY3Rpb24tb2JzZXJ2ZXInO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgVGhlbWUsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgRk9OVF9TVFlMRSxcbiAgUkVTRVRfQlVUVE9OLFxuICBSZXNpemVJbWFnZSxcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgSWNvbiwgSWNvbk5hbWUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuaW1wb3J0IHsgaXNNb2JpbGVEZXZpY2UgfSBmcm9tICdAYnVja2V0cGxhY2UvbGliJztcblxuaW1wb3J0IHsgRmVlZEl0ZW1UaHVtYm5haWwsIEZlZWRJdGVtVGh1bWJuYWlsUHJvcHMgfSBmcm9tICcuLi9mZWVkLWl0ZW0tdGh1bWJuYWlsJztcbmltcG9ydCB7IEZlZWRJdGVtVmlkZW9UaHVtYm5haWwsIEZlZWRJdGVtVmlkZW9UaHVtYm5haWxQcm9wcyB9IGZyb20gJy4uL2ZlZWQtaXRlbS12aWRlby10aHVtYm5haWwnO1xuXG5pbnRlcmZhY2UgV3JpdGVyIHtcbiAgYXZhdGFyU3JjOiBzdHJpbmc7XG4gIG5pY2tuYW1lOiBzdHJpbmc7XG4gIGRlc2NyaXB0aW9uPzogc3RyaW5nO1xuICBocmVmOiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgYWN0aW9uPzoge1xuICAgIGxhYmVsOiBzdHJpbmcsXG4gICAgb25DbGljazogUmVhY3QuTW91c2VFdmVudEhhbmRsZXIsXG4gIH07XG59XG5cbmludGVyZmFjZSBBY3Rpb24ge1xuICBpY29uTmFtZTogSWNvbk5hbWU7XG4gIGljb25Db2xvcj86ICh0aGVtZTogVGhlbWUpID0+IHN0cmluZztcbiAgY291bnQ6IG51bWJlcjtcbiAgb25DbGljazogUmVhY3QuTW91c2VFdmVudEhhbmRsZXI7XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ2FyZEZlZWRJdGVtUHJvcHMge1xuICB3cml0ZXI/OiBXcml0ZXI7XG4gIHRodW1ibmFpbDogRmVlZEl0ZW1UaHVtYm5haWxQcm9wcztcbiAgdmlkZW9UaHVtYm5haWw/OiBQaWNrPEZlZWRJdGVtVmlkZW9UaHVtYm5haWxQcm9wcywgJ3NyYycgfCAncG9zdGVyJz47XG4gIGFjdGlvbnM/OiBBY3Rpb25bXTtcbiAgdGl0bGU6IHN0cmluZztcbiAgbGluazoge1xuICAgIGhyZWY6IHN0cmluZyxcbiAgICBjb21wb25lbnQ6IFJlYWN0LkVsZW1lbnRUeXBlPFJlYWN0LkFuY2hvckhUTUxBdHRyaWJ1dGVzPEhUTUxBbmNob3JFbGVtZW50Pj4sXG4gIH07XG59XG5cbmV4cG9ydCBjb25zdCBDYXJkRmVlZEl0ZW0gPSAoe1xuICB3cml0ZXIsXG4gIHRodW1ibmFpbCxcbiAgdmlkZW9UaHVtYm5haWwsXG4gIGFjdGlvbnMsXG4gIHRpdGxlLFxuICBsaW5rLFxufTogQ2FyZEZlZWRJdGVtUHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICBjb25zdCBbaXNIb3ZlcmVkLCBzZXRJc0hvdmVyZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuICBjb25zdCB7IHJlZjogdGFyZ2V0UmVmLCBpblZpZXcgfSA9IHVzZUluVmlldyh7XG4gICAgdGhyZXNob2xkOiAxLFxuICAgIHNraXA6ICFpc01vYmlsZURldmljZSgpLFxuICB9KTtcblxuICBjb25zdCBMaW5rID0gbGluay5jb21wb25lbnQ7XG4gIGNvbnN0IGNvdW50Rm9ybWF0dGVyID0gbmV3IEludGwuTnVtYmVyRm9ybWF0KCdlbicsIHsgbm90YXRpb246ICdjb21wYWN0JyB9KTtcblxuICByZXR1cm4gKFxuICAgIDxkaXY+XG4gICAgICB7IHdyaXRlciAmJiAoXG4gICAgICAgIDxXcml0ZXJDb250YWluZXI+XG4gICAgICAgICAgPFdyaXRlck1haW5Db250YWluZXI+XG4gICAgICAgICAgICA8V3JpdGVyTGlua1xuICAgICAgICAgICAgICBhcz17TGlua31cbiAgICAgICAgICAgICAgaHJlZj17d3JpdGVyLmhyZWZ9XG4gICAgICAgICAgICAgIG9uQ2xpY2s9e3dyaXRlci5vbkNsaWNrfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICA8V3JpdGVyTmlja25hbWU+XG4gICAgICAgICAgICAgICAgeyB3cml0ZXIubmlja25hbWUgfVxuICAgICAgICAgICAgICA8L1dyaXRlck5pY2tuYW1lPlxuICAgICAgICAgICAgICA8V3JpdGVyQXZhdGFyPlxuICAgICAgICAgICAgICAgIDxSZXNpemVJbWFnZVxuICAgICAgICAgICAgICAgICAgc3JjPXt3cml0ZXIuYXZhdGFyU3JjfVxuICAgICAgICAgICAgICAgICAgaW50cmluc2ljSW5pdGlhbFdpZHRoPXs3Mn1cbiAgICAgICAgICAgICAgICAgIGludHJpbnNpY0FzcGVjdD17MX1cbiAgICAgICAgICAgICAgICAgIG9iamVjdEZpdD1cImNvdmVyXCJcbiAgICAgICAgICAgICAgICAgIGFsdD1cIlwiXG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgPC9Xcml0ZXJBdmF0YXI+XG4gICAgICAgICAgICA8L1dyaXRlckxpbms+XG4gICAgICAgICAgICB7IHdyaXRlci5hY3Rpb24gJiYgKFxuICAgICAgICAgICAgICA8PlxuICAgICAgICAgICAgICAgIDxXcml0ZXJOaWNrbmFtZT7CtzwvV3JpdGVyTmlja25hbWU+XG4gICAgICAgICAgICAgICAgPFdyaXRlckFjdGlvbiBvbkNsaWNrPXt3cml0ZXIuYWN0aW9uLm9uQ2xpY2t9Pnsgd3JpdGVyLmFjdGlvbi5sYWJlbCB9PC9Xcml0ZXJBY3Rpb24+XG4gICAgICAgICAgICAgIDwvPlxuICAgICAgICAgICAgKSB9XG4gICAgICAgICAgPC9Xcml0ZXJNYWluQ29udGFpbmVyPlxuICAgICAgICAgIHsgd3JpdGVyLmRlc2NyaXB0aW9uICYmIDxXcml0ZXJEZXNjcmlwdGlvbj57IHdyaXRlci5kZXNjcmlwdGlvbiB9PC9Xcml0ZXJEZXNjcmlwdGlvbj4gfVxuICAgICAgICA8L1dyaXRlckNvbnRhaW5lcj5cbiAgICAgICkgfVxuICAgICAgPENvbnRhaW5lcj5cbiAgICAgICAgPExpbmtcbiAgICAgICAgICBocmVmPXtsaW5rLmhyZWZ9XG4gICAgICAgICAgb25Nb3VzZUVudGVyPXsoKSA9PiBzZXRJc0hvdmVyZWQodHJ1ZSl9XG4gICAgICAgICAgb25Nb3VzZUxlYXZlPXsoKSA9PiBzZXRJc0hvdmVyZWQoZmFsc2UpfVxuICAgICAgICA+XG4gICAgICAgICAgPFRodW1ibmFpbENvbnRhaW5lcj5cbiAgICAgICAgICAgIDxGZWVkSXRlbVRodW1ibmFpbFxuICAgICAgICAgICAgICB7Li4udGh1bWJuYWlsfVxuICAgICAgICAgICAgICBhc3BlY3Q9ezF9XG4gICAgICAgICAgICAgIGlzWm9vbWVkPXtpc0hvdmVyZWR9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgeyB2aWRlb1RodW1ibmFpbCAmJiAoXG4gICAgICAgICAgICAgIDxWaWRlb1RodW1ibmFpbENvbnRhaW5lciByZWY9e3RhcmdldFJlZn0+XG4gICAgICAgICAgICAgICAgPEZlZWRJdGVtVmlkZW9UaHVtYm5haWxcbiAgICAgICAgICAgICAgICAgIHNyYz17dmlkZW9UaHVtYm5haWwuc3JjfVxuICAgICAgICAgICAgICAgICAgYXNwZWN0PXsxfVxuICAgICAgICAgICAgICAgICAgY2FuUGxheT17KGlzSG92ZXJlZCAmJiAhaXNNb2JpbGVEZXZpY2UoKSkgfHwgKGluVmlldyAmJiBpc01vYmlsZURldmljZSgpKX1cbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICA8L1ZpZGVvVGh1bWJuYWlsQ29udGFpbmVyPlxuICAgICAgICAgICAgKSB9XG4gICAgICAgICAgPC9UaHVtYm5haWxDb250YWluZXI+XG4gICAgICAgICAgeyBhY3Rpb25zICYmIDxBY3Rpb25zUGxhY2Vob2xkZXIgLz4gfVxuICAgICAgICAgIDxUaXRsZSBpc0hvdmVyZWQ9e2lzSG92ZXJlZH0+XG4gICAgICAgICAgICB7IHRpdGxlIH1cbiAgICAgICAgICA8L1RpdGxlPlxuICAgICAgICA8L0xpbms+XG4gICAgICAgIHsgYWN0aW9ucyAmJiAoXG4gICAgICAgICAgPEFjdGlvbnM+XG4gICAgICAgICAgICB7IGFjdGlvbnMubWFwKChhY3Rpb24pID0+IChcbiAgICAgICAgICAgICAgPEFjdGlvbkJ1dHRvblxuICAgICAgICAgICAgICAgIGtleT17YWN0aW9uLmljb25OYW1lfVxuICAgICAgICAgICAgICAgIHR5cGU9XCJidXR0b25cIlxuICAgICAgICAgICAgICAgIG9uQ2xpY2s9e2FjdGlvbi5vbkNsaWNrfVxuICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgPEljb25cbiAgICAgICAgICAgICAgICAgIG5hbWU9e2FjdGlvbi5pY29uTmFtZX1cbiAgICAgICAgICAgICAgICAgIHNpemU9ezI0fVxuICAgICAgICAgICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiBhY3Rpb24uaWNvbkNvbG9yPy4odGhlbWUpID8/IHRoZW1lLmNvbnRlbnQuYmFzZTF9XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICA8QWN0aW9uQ291bnQ+eyBjb3VudEZvcm1hdHRlci5mb3JtYXQoYWN0aW9uLmNvdW50KSB9PC9BY3Rpb25Db3VudD5cbiAgICAgICAgICAgICAgPC9BY3Rpb25CdXR0b24+XG4gICAgICAgICAgICApKSB9XG4gICAgICAgICAgPC9BY3Rpb25zPlxuICAgICAgICApIH1cbiAgICAgIDwvQ29udGFpbmVyPlxuICAgIDwvZGl2PlxuICApO1xufTtcblxuY29uc3QgV3JpdGVyQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiAke3B4VG9SZW0oMil9O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1pbi1oZWlnaHQ6ICR7cHhUb1JlbSg0MCl9O1xuICBwYWRkaW5nLWxlZnQ6ICR7cHhUb1JlbSg0OCl9O1xuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTYpfTtcbmA7XG5cblxuY29uc3QgV3JpdGVyTWFpbkNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbjogYXV0byAwO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6ICR7cHhUb1JlbSg0KX07XG5gO1xuXG5jb25zdCBXcml0ZXJMaW5rID0gc3R5bGVkLmFgXG4gICY6aG92ZXIge1xuICAgIG9wYWNpdHk6IDAuNTtcbiAgfVxuYDtcblxuY29uc3QgV3JpdGVyQXZhdGFyID0gc3R5bGVkLnNwYW5gXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbGVmdDogMDtcbiAgdG9wOiAwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB3aWR0aDogJHtweFRvUmVtKDM2KX07XG4gIGhlaWdodDogJHtweFRvUmVtKDM2KX07XG4gIGJvcmRlci1yYWRpdXM6IDEwMCU7XG5gO1xuXG5jb25zdCBXcml0ZXJOaWNrbmFtZSA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuYm9keTFfc21hbGx9XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIC13ZWJraXQtbGluZS1jbGFtcDogMTtcbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgd29yZC1icmVhazogYnJlYWstYWxsO1xuYDtcblxuY29uc3QgV3JpdGVyQWN0aW9uID0gc3R5bGVkLmJ1dHRvbmBcbiAgJHtSRVNFVF9CVVRUT059XG4gICR7Rk9OVF9TVFlMRS5ib2R5MV9zbWFsbH1cbiAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5wcmltYXJ5MS5iYXNpY307XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG5gO1xuXG5jb25zdCBXcml0ZXJEZXNjcmlwdGlvbiA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICBmb250LXdlaWdodDogNDAwO1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIC13ZWJraXQtbGluZS1jbGFtcDogMTtcbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgd29yZC1icmVhazogYnJlYWstYWxsO1xuYDtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuYDtcblxuY29uc3QgVGh1bWJuYWlsQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuYDtcblxuY29uc3QgVmlkZW9UaHVtYm5haWxDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGluc2V0OiAwO1xuYDtcblxuY29uc3QgQWN0aW9uc1BsYWNlaG9sZGVyID0gc3R5bGVkLmRpdmBcbiAgaGVpZ2h0OiA0MHB4O1xuYDtcblxuY29uc3QgQWN0aW9ucyA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICB3aWR0aDogMTAwJTtcbiAgbWFyZ2luLXRvcDogMTAwJTtcbiAgaGVpZ2h0OiA0MHB4O1xuXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbmA7XG5cbmNvbnN0IEFjdGlvbkJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gICR7UkVTRVRfQlVUVE9OfVxuICBmbGV4OiAxIDAgMDtcbiAgcGFkZGluZzogJHtweFRvUmVtKDEyKX0gMCAke3B4VG9SZW0oNCl9IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAmOmhvdmVyIHtcbiAgICBvcGFjaXR5OiAwLjU7XG4gIH1cbmA7XG5cbmNvbnN0IEFjdGlvbkNvdW50ID0gc3R5bGVkLnNwYW5gXG4gICR7Rk9OVF9TVFlMRS5ib2R5M31cbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMX07XG4gIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oNil9O1xuYDtcblxuY29uc3QgVGl0bGUgPSBzdHlsZWQuZGl2PHsgaXNIb3ZlcmVkPzogYm9vbGVhbiB9PmBcbiAgbWFyZ2luLXRvcDogMTJweDsgXG4gICR7Rk9OVF9TVFlMRS5ib2R5MV9zbWFsbH1cbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC5iYXNlMX07XG4gIHdoaXRlLXNwYWNlOiBwcmUtbGluZTtcbiAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICAtd2Via2l0LWxpbmUtY2xhbXA6IDI7XG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcbiAgJHsoeyBpc0hvdmVyZWQgfSkgPT4gaXNIb3ZlcmVkICYmIGNzc2BcbiAgICBvcGFjaXR5OiAwLjU7XG4gIGB9XG5gO1xuIl19 */"));
var _ref$l = process.env.NODE_ENV === "production" ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : {
  name: "tg2egp-Title",
  styles: "opacity:0.5;label:Title;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
};
const Title$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr0"
} : {
  target: "e12sucbr0",
  label: "Title"
})("margin-top:12px;", FONT_STYLE.body1_small, " color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-all;", ({
  isHovered
}) => isHovered && _ref$l, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItemPlaceholder = ({
  writer,
  actions
}) => {
  return jsxs("div", {
    style: {
      width: '100%'
    },
    children: [writer && jsxs(WriterContainer, {
      children: [jsx(AvatarPlaceholder, {
        height: "auto",
        borderRadius: "50%"
      }), jsx(NicknameContainer, {
        children: jsx(Skeleton, {
          height: "auto"
        })
      })]
    }), jsx(ImageSkeleton$2, {
      height: "auto"
    }), actions && jsx(ActionsContainer, {
      children: Array.from({
        length: 3
      }).map((_, index) => jsx(ActionIconContainer, {
        children: jsx(ActionIconPlaceholder, {
          height: "auto"
        })
      }, index))
    }), jsx(TitlePlaceholder, {})]
  });
};
const WriterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi7"
} : {
  target: "eknv2pi7",
  label: "WriterContainer"
})("display:flex;gap:", pxToRem(12), ";min-height:", pxToRem(40), ";margin-bottom:", pxToRem(16), ";align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const AvatarPlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi6"
} : {
  target: "eknv2pi6",
  label: "AvatarPlaceholder"
})("width:", pxToRem(40), ";aspect-ratio:1;border-radius:50%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const NicknameContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi5"
} : {
  target: "eknv2pi5",
  label: "NicknameContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "82a6rk",
  styles: "flex:1",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
});
const ImageSkeleton$2 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi4"
} : {
  target: "eknv2pi4",
  label: "ImageSkeleton"
})("aspect-ratio:1;width:100%;height:auto;border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ActionsContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi3"
} : {
  target: "eknv2pi3",
  label: "ActionsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "8w8w4j",
  styles: "height:40px;display:flex;justify-content:space-between"
} : {
  name: "8w8w4j",
  styles: "height:40px;display:flex;justify-content:space-between",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnRW1DIiwiZmlsZSI6IkNhcmRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBTa2VsZXRvbiBmcm9tICdyZWFjdC1sb2FkaW5nLXNrZWxldG9uJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuZXhwb3J0IGludGVyZmFjZSBDYXJkRmVlZEl0ZW1QbGFjZWhvbGRlclByb3BzIHtcbiAgd3JpdGVyPzogYm9vbGVhbjtcbiAgYWN0aW9ucz86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBjb25zdCBDYXJkRmVlZEl0ZW1QbGFjZWhvbGRlciA9ICh7XG4gIHdyaXRlcixcbiAgYWN0aW9ucyxcbn06IENhcmRGZWVkSXRlbVBsYWNlaG9sZGVyUHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICByZXR1cm4gKFxuICAgIDxkaXYgc3R5bGU9e3sgd2lkdGg6ICcxMDAlJyB9fT5cbiAgICAgIHsgd3JpdGVyICYmIChcbiAgICAgICAgPFdyaXRlckNvbnRhaW5lcj5cbiAgICAgICAgICA8QXZhdGFyUGxhY2Vob2xkZXIgaGVpZ2h0PVwiYXV0b1wiIGJvcmRlclJhZGl1cz1cIjUwJVwiIC8+XG4gICAgICAgICAgPE5pY2tuYW1lQ29udGFpbmVyPlxuICAgICAgICAgICAgPFNrZWxldG9uIGhlaWdodD1cImF1dG9cIiAvPlxuICAgICAgICAgIDwvTmlja25hbWVDb250YWluZXI+XG4gICAgICAgIDwvV3JpdGVyQ29udGFpbmVyPlxuICAgICAgKSB9XG4gICAgICA8SW1hZ2VTa2VsZXRvbiBoZWlnaHQ9XCJhdXRvXCIgLz5cbiAgICAgIHsgYWN0aW9ucyAmJiAoXG4gICAgICAgIDxBY3Rpb25zQ29udGFpbmVyPlxuICAgICAgICAgIHsgQXJyYXkuZnJvbSh7IGxlbmd0aDogMyB9KS5tYXAoKF8sIGluZGV4KSA9PiAoXG4gICAgICAgICAgICA8QWN0aW9uSWNvbkNvbnRhaW5lciBrZXk9e2luZGV4fT5cbiAgICAgICAgICAgICAgPEFjdGlvbkljb25QbGFjZWhvbGRlciBoZWlnaHQ9XCJhdXRvXCIgLz5cbiAgICAgICAgICAgIDwvQWN0aW9uSWNvbkNvbnRhaW5lcj5cbiAgICAgICAgICApKSB9XG4gICAgICAgIDwvQWN0aW9uc0NvbnRhaW5lcj5cbiAgICAgICkgfVxuICAgICAgPFRpdGxlUGxhY2Vob2xkZXIgLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbmNvbnN0IFdyaXRlckNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGdhcDogJHtweFRvUmVtKDEyKX07XG4gIG1pbi1oZWlnaHQ6ICR7cHhUb1JlbSg0MCl9O1xuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTYpfTtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbmA7XG5cbmNvbnN0IEF2YXRhclBsYWNlaG9sZGVyID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgd2lkdGg6ICR7cHhUb1JlbSg0MCl9O1xuICBhc3BlY3QtcmF0aW86IDE7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbmA7XG5cbmNvbnN0IE5pY2tuYW1lQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMTtcbmA7XG5cbmNvbnN0IEltYWdlU2tlbGV0b24gPSBzdHlsZWQoU2tlbGV0b24pYFxuICBhc3BlY3QtcmF0aW86IDE7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IGF1dG87XG4gIGJvcmRlci1yYWRpdXM6ICR7cHhUb1JlbSg0KX07XG5gO1xuXG5jb25zdCBBY3Rpb25zQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgaGVpZ2h0OiA0MHB4O1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG5gO1xuXG5jb25zdCBBY3Rpb25JY29uQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAwIDA7XG4gIHBhZGRpbmc6ICR7cHhUb1JlbSgxMil9IDAgJHtweFRvUmVtKDQpfSAwO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbmA7XG5cbmNvbnN0IEFjdGlvbkljb25QbGFjZWhvbGRlciA9IHN0eWxlZChTa2VsZXRvbilgXG4gIHdpZHRoOiAke3B4VG9SZW0oMjQpfTtcbiAgYXNwZWN0LXJhdGlvOiAxO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG5gO1xuXG5jb25zdCBUaXRsZVBsYWNlaG9sZGVyID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgbWFyZ2luLXRvcDogMTJweDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
});
const ActionIconContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi2"
} : {
  target: "eknv2pi2",
  label: "ActionIconContainer"
})("flex:1 0 0;padding:", pxToRem(12), " 0 ", pxToRem(4), " 0;display:flex;justify-content:center;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ActionIconPlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi1"
} : {
  target: "eknv2pi1",
  label: "ActionIconPlaceholder"
})("width:", pxToRem(24), ";aspect-ratio:1;border-radius:50%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const TitlePlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi0"
} : {
  target: "eknv2pi0",
  label: "TitlePlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "xda5ep",
  styles: "margin-top:12px"
} : {
  name: "xda5ep",
  styles: "margin-top:12px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FEED_ITEM_MOBILE_ASPECT_RATIO = 3 / 4;
const FEED_ITEM_DESKTOP_ASPECT_RATIO = 1;
const ContentFeedItem = ({
  href,
  onClick,
  label,
  title,
  writer,
  thumbnail,
  videoThumbnail,
  className,
  linkComponent,
  like,
  scrap,
  badge
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const isMobile = useResponsive().breakpoint === 'mobile';
  const Link = linkComponent ?? 'a';
  return jsxs(Container$c, {
    ref: targetRef,
    className: className,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [jsxs(Link, {
      href: href,
      onClick: onClick,
      children: [jsxs(ThumbnailContainer, {
        children: [jsx(FeedItemThumbnail, {
          ...thumbnail,
          aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
        }), videoThumbnail && jsx(VideoThumbnailContainer, {
          children: jsx(FeedItemVideoThumbnail, {
            src: videoThumbnail.src,
            canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice(),
            aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
          })
        })]
      }), jsxs(Title$3, {
        children: [label && jsx(Label$1, {
          children: `${label} `
        }), title]
      })]
    }), badge && jsx(BadgeContainer, {
      children: badge
    }), scrap && jsx(ScrapButton, {
      name: "scrap",
      "aria-label": scrap.label ?? '스크랩',
      size: 24,
      active: scrap.active,
      initialActive: scrap.initialActive,
      onActive: () => scrap.onClick(true),
      onInactive: () => scrap.onClick(false)
    }), jsxs(UserContainer, {
      children: [jsxs(Link, {
        href: writer.href,
        onClick: writer.onClick,
        children: [jsx(StyledAvatar, {
          size: 18,
          alt: "",
          src: getImageUrl({
            src: writer.avatar,
            width: 72,
            height: 72,
            quality: 60
          })
        }), jsx(Nickname, {
          children: writer.nickname
        })]
      }), like && jsxs(LikeButton, {
        type: "button",
        "aria-label": like.label ?? '좋아요',
        onClick: () => like.onClick(like.active),
        children: [jsx(Icon$1, {
          size: 16,
          name: like.active ? 'heart' : 'heart_outline',
          fill: theme => like.active ? theme.content.primary1.basic : theme.interactive.base1
        }), jsx(LikeCountText, {
          children: like.count > 0 && formatLargeNumber(like.count)
        })]
      })]
    })]
  });
};
const Container$c = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj11"
} : {
  target: "e1e7vpgj11",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnRGZWVkSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEo0QiIsImZpbGUiOiJDb250ZW50RmVlZEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFJlYWN0RWxlbWVudCwgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyB1c2VJblZpZXcgfSBmcm9tICdyZWFjdC1pbnRlcnNlY3Rpb24tb2JzZXJ2ZXInO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHtcbiAgRk9OVF9TVFlMRSxcbiAgTUVESUFfUVVFUlksXG4gIGdldEltYWdlVXJsLFxuICBweFRvUmVtLFxuICB1c2VSZXNwb25zaXZlLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBBdmF0YXIsIEljb24sIFRvZ2dsZUJ1dHRvbiB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5pbXBvcnQgeyBmb3JtYXRMYXJnZU51bWJlciwgaXNNb2JpbGVEZXZpY2UgfSBmcm9tICdAYnVja2V0cGxhY2UvbGliJztcbmltcG9ydCB7IEZlZWRJdGVtVmlkZW9UaHVtYm5haWwsIEZlZWRJdGVtVmlkZW9UaHVtYm5haWxQcm9wcyB9IGZyb20gJy4uL2ZlZWQtaXRlbS12aWRlby10aHVtYm5haWwnO1xuaW1wb3J0IHsgRmVlZEl0ZW1UaHVtYm5haWwsIEZlZWRJdGVtVGh1bWJuYWlsUHJvcHMgfSBmcm9tICcuLi9mZWVkLWl0ZW0tdGh1bWJuYWlsJztcblxuZXhwb3J0IGNvbnN0IEZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPID0gMyAvIDQ7XG5leHBvcnQgY29uc3QgRkVFRF9JVEVNX0RFU0tUT1BfQVNQRUNUX1JBVElPID0gMTtcblxuZXhwb3J0IGludGVyZmFjZSBDb250ZW50RmVlZEl0ZW1Qcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgaHJlZjogc3RyaW5nO1xuICBvbkNsaWNrPzogKCkgPT4gdm9pZDtcbiAgdGh1bWJuYWlsOiBQaWNrPEZlZWRJdGVtVGh1bWJuYWlsUHJvcHMsICdzcmMnIHwgJ3F1YWxpdHknIHwgJ2xhenknPjtcbiAgdmlkZW9UaHVtYm5haWw/OiBQaWNrPEZlZWRJdGVtVmlkZW9UaHVtYm5haWxQcm9wcywgJ3NyYyc+O1xuICBsYWJlbD86IHN0cmluZztcbiAgdGl0bGU/OiBzdHJpbmc7XG4gIHdyaXRlcjoge1xuICAgIGhyZWY6IHN0cmluZyxcbiAgICBhdmF0YXI6IHN0cmluZyxcbiAgICBuaWNrbmFtZTogc3RyaW5nLFxuICAgIG9uQ2xpY2s/OiAoKSA9PiB2b2lkLFxuICB9O1xuICBzY3JhcD86IHtcbiAgICBsYWJlbD86IHN0cmluZyxcbiAgICBpbml0aWFsQWN0aXZlPzogYm9vbGVhbixcbiAgICBhY3RpdmU/OiBib29sZWFuLFxuICAgIG9uQ2xpY2s6IChhY3RpdmU6IGJvb2xlYW4pID0+IHZvaWQsXG4gIH07XG4gIGxpa2U/OiB7XG4gICAgbGFiZWw/OiBzdHJpbmcsXG4gICAgYWN0aXZlOiBib29sZWFuLFxuICAgIGNvdW50OiBudW1iZXIsXG4gICAgb25DbGljazogKGFjdGl2ZTogYm9vbGVhbikgPT4gdm9pZCxcbiAgfTtcbiAgYmFkZ2U/OiBSZWFjdEVsZW1lbnQ7XG4gIGxpbmtDb21wb25lbnQ/OiBSZWFjdC5FbGVtZW50VHlwZTxSZWFjdC5BbmNob3JIVE1MQXR0cmlidXRlczxIVE1MQW5jaG9yRWxlbWVudD4gJiB7IGhyZWY6IHN0cmluZyB9Pjtcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRlbnRGZWVkSXRlbSA9ICh7XG4gIGhyZWYsXG4gIG9uQ2xpY2ssXG4gIGxhYmVsLFxuICB0aXRsZSxcbiAgd3JpdGVyLFxuICB0aHVtYm5haWwsXG4gIHZpZGVvVGh1bWJuYWlsLFxuICBjbGFzc05hbWUsXG4gIGxpbmtDb21wb25lbnQsXG4gIGxpa2UsXG4gIHNjcmFwLFxuICBiYWRnZSxcbn06IENvbnRlbnRGZWVkSXRlbVByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgY29uc3QgW2lzSG92ZXJlZCwgc2V0SXNIb3ZlcmVkXSA9IHVzZVN0YXRlKGZhbHNlKTtcbiAgY29uc3QgeyByZWY6IHRhcmdldFJlZiwgaW5WaWV3IH0gPSB1c2VJblZpZXcoe1xuICAgIHRocmVzaG9sZDogMSxcbiAgICBza2lwOiAhaXNNb2JpbGVEZXZpY2UoKSxcbiAgfSk7XG5cbiAgY29uc3QgaXNNb2JpbGUgPSB1c2VSZXNwb25zaXZlKCkuYnJlYWtwb2ludCA9PT0gJ21vYmlsZSc7XG4gIGNvbnN0IExpbmsgPSBsaW5rQ29tcG9uZW50ID8/ICdhJztcblxuICByZXR1cm4gKFxuICAgIDxDb250YWluZXJcbiAgICAgIHJlZj17dGFyZ2V0UmVmfVxuICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICBvbk1vdXNlRW50ZXI9eygpID0+IHNldElzSG92ZXJlZCh0cnVlKX1cbiAgICAgIG9uTW91c2VMZWF2ZT17KCkgPT4gc2V0SXNIb3ZlcmVkKGZhbHNlKX1cbiAgICA+XG4gICAgICA8TGluayBocmVmPXtocmVmfSBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICAgICAgPFRodW1ibmFpbENvbnRhaW5lcj5cbiAgICAgICAgICA8RmVlZEl0ZW1UaHVtYm5haWxcbiAgICAgICAgICAgIHsuLi50aHVtYm5haWx9XG4gICAgICAgICAgICBhc3BlY3Q9e2lzTW9iaWxlID8gRkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU8gOiBGRUVEX0lURU1fREVTS1RPUF9BU1BFQ1RfUkFUSU99XG4gICAgICAgICAgLz5cbiAgICAgICAgICB7IHZpZGVvVGh1bWJuYWlsICYmIChcbiAgICAgICAgICAgIDxWaWRlb1RodW1ibmFpbENvbnRhaW5lcj5cbiAgICAgICAgICAgICAgPEZlZWRJdGVtVmlkZW9UaHVtYm5haWxcbiAgICAgICAgICAgICAgICBzcmM9e3ZpZGVvVGh1bWJuYWlsLnNyY31cbiAgICAgICAgICAgICAgICBjYW5QbGF5PXsoaXNIb3ZlcmVkICYmICFpc01vYmlsZURldmljZSgpKSB8fCAoaW5WaWV3ICYmIGlzTW9iaWxlRGV2aWNlKCkpfVxuICAgICAgICAgICAgICAgIGFzcGVjdD17aXNNb2JpbGUgPyBGRUVEX0lURU1fTU9CSUxFX0FTUEVDVF9SQVRJTyA6IEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJT31cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvVmlkZW9UaHVtYm5haWxDb250YWluZXI+XG4gICAgICAgICAgKSB9XG4gICAgICAgIDwvVGh1bWJuYWlsQ29udGFpbmVyPlxuICAgICAgICA8VGl0bGU+XG4gICAgICAgICAgeyBsYWJlbCAmJiA8TGFiZWw+eyBgJHtsYWJlbH0gYCB9PC9MYWJlbD4gfVxuICAgICAgICAgIHsgdGl0bGUgfVxuICAgICAgICA8L1RpdGxlPlxuICAgICAgPC9MaW5rPlxuICAgICAgeyBiYWRnZSAmJiA8QmFkZ2VDb250YWluZXI+eyBiYWRnZSB9PC9CYWRnZUNvbnRhaW5lcj4gfVxuICAgICAgeyBzY3JhcCAmJiAoXG4gICAgICAgIDxTY3JhcEJ1dHRvblxuICAgICAgICAgIG5hbWU9XCJzY3JhcFwiXG4gICAgICAgICAgYXJpYS1sYWJlbD17c2NyYXAubGFiZWwgPz8gJ+yKpO2BrOueqSd9XG4gICAgICAgICAgc2l6ZT17MjR9XG4gICAgICAgICAgYWN0aXZlPXtzY3JhcC5hY3RpdmV9XG4gICAgICAgICAgaW5pdGlhbEFjdGl2ZT17c2NyYXAuaW5pdGlhbEFjdGl2ZX1cbiAgICAgICAgICBvbkFjdGl2ZT17KCkgPT4gc2NyYXAub25DbGljayh0cnVlKX1cbiAgICAgICAgICBvbkluYWN0aXZlPXsoKSA9PiBzY3JhcC5vbkNsaWNrKGZhbHNlKX1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgICAgPFVzZXJDb250YWluZXI+XG4gICAgICAgIDxMaW5rXG4gICAgICAgICAgaHJlZj17d3JpdGVyLmhyZWZ9XG4gICAgICAgICAgb25DbGljaz17d3JpdGVyLm9uQ2xpY2t9XG4gICAgICAgID5cbiAgICAgICAgICA8U3R5bGVkQXZhdGFyXG4gICAgICAgICAgICBzaXplPXsxOH1cbiAgICAgICAgICAgIGFsdD1cIlwiXG4gICAgICAgICAgICBzcmM9e2dldEltYWdlVXJsKHtcbiAgICAgICAgICAgICAgc3JjOiB3cml0ZXIuYXZhdGFyLFxuICAgICAgICAgICAgICB3aWR0aDogNzIsXG4gICAgICAgICAgICAgIGhlaWdodDogNzIsXG4gICAgICAgICAgICAgIHF1YWxpdHk6IDYwLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8Tmlja25hbWU+eyB3cml0ZXIubmlja25hbWUgfTwvTmlja25hbWU+XG4gICAgICAgIDwvTGluaz5cbiAgICAgICAgeyBsaWtlICYmIChcbiAgICAgICAgICA8TGlrZUJ1dHRvblxuICAgICAgICAgICAgdHlwZT1cImJ1dHRvblwiXG4gICAgICAgICAgICBhcmlhLWxhYmVsPXtsaWtlLmxhYmVsID8/ICfsoovslYTsmpQnfVxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbGlrZS5vbkNsaWNrKGxpa2UuYWN0aXZlKX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgICBzaXplPXsxNn1cbiAgICAgICAgICAgICAgbmFtZT17bGlrZS5hY3RpdmUgPyAnaGVhcnQnIDogJ2hlYXJ0X291dGxpbmUnfVxuICAgICAgICAgICAgICBmaWxsPXsodGhlbWUpID0+IChsaWtlLmFjdGl2ZVxuICAgICAgICAgICAgICAgID8gdGhlbWUuY29udGVudC5wcmltYXJ5MS5iYXNpY1xuICAgICAgICAgICAgICAgIDogdGhlbWUuaW50ZXJhY3RpdmUuYmFzZTFcbiAgICAgICAgICAgICAgKX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8TGlrZUNvdW50VGV4dD5cbiAgICAgICAgICAgICAgeyBsaWtlLmNvdW50ID4gMCAmJiBmb3JtYXRMYXJnZU51bWJlcihsaWtlLmNvdW50KSB9XG4gICAgICAgICAgICA8L0xpa2VDb3VudFRleHQ+XG4gICAgICAgICAgPC9MaWtlQnV0dG9uPlxuICAgICAgICApIH1cbiAgICAgIDwvVXNlckNvbnRhaW5lcj5cbiAgICA8L0NvbnRhaW5lcj5cblxuICApO1xufTtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuYDtcblxuY29uc3QgVGh1bWJuYWlsQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBhc3BlY3QtcmF0aW86ICR7RkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU99O1xuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oOCl9O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oNCl9O1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGFzcGVjdC1yYXRpbzogJHtGRUVEX0lURU1fREVTS1RPUF9BU1BFQ1RfUkFUSU99O1xuICAgIG1hcmdpbi1ib3R0b206ICR7cHhUb1JlbSgxMCl9O1xuICBgKX1cbmA7XG5cbmNvbnN0IFZpZGVvVGh1bWJuYWlsQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBpbnNldDogMDtcbmA7XG5cbmNvbnN0IExhYmVsID0gc3R5bGVkLnNwYW5gXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQucHJpbWFyeTIudGhpY2t9O1xuICBmb250LXdlaWdodDogNzAwO1xuYDtcblxuY29uc3QgVGl0bGUgPSBzdHlsZWQuZGl2YFxuICAke0ZPTlRfU1RZTEUuYm9keTJfc21hbGx9XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2hpdGUtc3BhY2U6IHByZS1saW5lO1xuICBkaXNwbGF5OiAtd2Via2l0LWJveDtcbiAgLXdlYmtpdC1saW5lLWNsYW1wOiAyO1xuICAtd2Via2l0LWJveC1vcmllbnQ6IHZlcnRpY2FsO1xuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oNil9O1xuICAmOmhvdmVyIHtcbiAgICBvcGFjaXR5OiAwLjU7XG4gIH1cbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICAke0ZPTlRfU1RZTEUuYm9keTFfMX1cbiAgICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBTY3JhcEJ1dHRvbiA9IHN0eWxlZChUb2dnbGVCdXR0b24pYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogJHtweFRvUmVtKC0xMCl9O1xuICByaWdodDogJHtweFRvUmVtKDgpfTtcbiAgbWFyZ2luLXRvcDogJHsoMSAvIEZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPKSAqIDEwMH0lO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTEwMCUpO1xuICBAbWVkaWEoaG92ZXI6IGhvdmVyKSB7XG4gICAgJjpob3ZlciB7XG4gICAgICBvcGFjaXR5OiAwLjU7XG4gICAgfVxuICB9XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgbWFyZ2luLXRvcDogJHsoMSAvIEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJTykgKiAxMDB9JTtcbiAgYCl9XG5gO1xuXG5jb25zdCBCYWRnZUNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAke3B4VG9SZW0oOCl9O1xuICByaWdodDogJHtweFRvUmVtKDgpfTtcbmA7XG5cbmNvbnN0IFVzZXJDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBtYXJnaW4tdG9wOiAke3B4VG9SZW0oOCl9O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICYgYSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBnYXA6ICR7cHhUb1JlbSg2KX07XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgJjpob3ZlciB7XG4gICAgICAgIG9wYWNpdHk6IDAuNTtcbiAgICB9XG4gIH1cbmA7XG5cbmNvbnN0IE5pY2tuYW1lID0gc3R5bGVkLmRpdmBcbiAgJHtGT05UX1NUWUxFLmNhcHRpb24xX3NtYWxsfVxuICBmb250LXdlaWdodDogNTAwO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgYCl9XG5gO1xuXG5jb25zdCBTdHlsZWRBdmF0YXIgPSBzdHlsZWQoQXZhdGFyKWBcbiAgZmxleC1zaHJpbms6IDA7XG5gO1xuXG5jb25zdCBMaWtlQnV0dG9uID0gc3R5bGVkLmJ1dHRvbmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiAke3B4VG9SZW0oNCl9O1xuICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDQpfTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuYDtcblxuY29uc3QgTGlrZUNvdW50VGV4dCA9IHN0eWxlZC5zcGFuYFxuICAke0ZPTlRfU1RZTEUuYm9keTN9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfTtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
const ThumbnailContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj10"
} : {
  target: "e1e7vpgj10",
  label: "ThumbnailContainer"
})("position:relative;aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", pxToRem(8), ";overflow:hidden;border-radius:", pxToRem(4), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ThumbnailContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const VideoThumbnailContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj9"
} : {
  target: "e1e7vpgj9",
  label: "VideoThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : {
  name: "b98nv4",
  styles: "position:absolute;inset:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
const Label$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj8"
} : {
  target: "e1e7vpgj8",
  label: "Label"
})("color:", ({
  theme
}) => theme.content.primary2.thick, ";font-weight:700;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Title$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj7"
} : {
  target: "e1e7vpgj7",
  label: "Title"
})(FONT_STYLE.body2_small, " color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;text-overflow:ellipsis;white-space:pre-line;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;margin-bottom:", pxToRem(6), ";&:hover{opacity:0.5;}", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.body1_1, " margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Title;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ScrapButton = /*#__PURE__*/_styled(ToggleButton, process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj6"
} : {
  target: "e1e7vpgj6",
  label: "ScrapButton"
})("position:absolute;top:", pxToRem(-10), ";right:", pxToRem(8), ";margin-top:", 1 / FEED_ITEM_MOBILE_ASPECT_RATIO * 100, "%;transform:translateY(-100%);@media(hover: hover){&:hover{opacity:0.5;}}", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("margin-top:", 1 / FEED_ITEM_DESKTOP_ASPECT_RATIO * 100, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:ScrapButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const BadgeContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj5"
} : {
  target: "e1e7vpgj5",
  label: "BadgeContainer"
})("position:absolute;top:", pxToRem(8), ";right:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const UserContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj4"
} : {
  target: "e1e7vpgj4",
  label: "UserContainer"
})("display:flex;margin-top:", pxToRem(8), ";justify-content:space-between;align-items:center;& a{display:flex;gap:", pxToRem(6), ";align-items:center;width:fit-content;max-width:100%;overflow:hidden;&:hover{opacity:0.5;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Nickname = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj3"
} : {
  target: "e1e7vpgj3",
  label: "Nickname"
})(FONT_STYLE.caption1_small, " font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : {
  name: "13gc3a7-Nickname",
  styles: "font-weight:600;label:Nickname;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledAvatar = /*#__PURE__*/_styled(Avatar$1, process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj2"
} : {
  target: "e1e7vpgj2",
  label: "StyledAvatar"
})(process.env.NODE_ENV === "production" ? {
  name: "ozd7xs",
  styles: "flex-shrink:0"
} : {
  name: "ozd7xs",
  styles: "flex-shrink:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
const LikeButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj1"
} : {
  target: "e1e7vpgj1",
  label: "LikeButton"
})("display:flex;justify-content:flex-end;align-items:center;gap:", pxToRem(4), ";margin-left:", pxToRem(4), ";text-align:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const LikeCountText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj0"
} : {
  target: "e1e7vpgj0",
  label: "LikeCountText"
})(FONT_STYLE.body3, ";color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ContentFeedItemPlaceholder = /*#__PURE__*/React__default.memo(({
  className
}) => {
  return jsxs(Container$b, {
    className: className,
    children: [jsx(ImageSkeleton$1, {
      height: "auto",
      style: {
        display: 'block'
      }
    }), jsx(TextSkeleton$1, {}), jsx(TextSkeleton$1, {
      width: "50%"
    }), jsx(TextSkeleton$1, {
      width: "50%"
    })]
  });
});
const Container$b = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g2"
} : {
  target: "e1l3as7g2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1amee4m",
  styles: "line-height:0"
} : {
  name: "1amee4m",
  styles: "line-height:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QjRCIiwiZmlsZSI6IkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJTywgRkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU8gfSBmcm9tICcuL0NvbnRlbnRGZWVkSXRlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29udGVudEZlZWRJdGVtUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyID0gUmVhY3QubWVtbygoe1xuICBjbGFzc05hbWUsXG59OiBDb250ZW50RmVlZEl0ZW1QbGFjZWhvbGRlclByb3BzKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICA8SW1hZ2VTa2VsZXRvbiBoZWlnaHQ9XCJhdXRvXCIgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSAvPlxuICAgICAgPFRleHRTa2VsZXRvbiAvPlxuICAgICAgPFRleHRTa2VsZXRvbiB3aWR0aD1cIjUwJVwiIC8+XG4gICAgICA8VGV4dFNrZWxldG9uIHdpZHRoPVwiNTAlXCIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn0pO1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICAgbGluZS1oZWlnaHQ6IDA7XG5gO1xuXG5jb25zdCBJbWFnZVNrZWxldG9uID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgYXNwZWN0LXJhdGlvOiAke0ZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPfTtcbiAgbWFyZ2luLWJvdHRvbTogJHtweFRvUmVtKDgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBhc3BlY3QtcmF0aW86ICR7RkVFRF9JVEVNX0RFU0tUT1BfQVNQRUNUX1JBVElPfTtcbiAgICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBUZXh0U2tlbGV0b24gPSBzdHlsZWQoU2tlbGV0b24pYFxuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oNil9O1xuYDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
});
const ImageSkeleton$1 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g1"
} : {
  target: "e1l3as7g1",
  label: "ImageSkeleton"
})("aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", pxToRem(8), ";border-radius:", pxToRem(4), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ImageSkeleton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQ2lDIiwiZmlsZSI6IkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJTywgRkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU8gfSBmcm9tICcuL0NvbnRlbnRGZWVkSXRlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29udGVudEZlZWRJdGVtUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyID0gUmVhY3QubWVtbygoe1xuICBjbGFzc05hbWUsXG59OiBDb250ZW50RmVlZEl0ZW1QbGFjZWhvbGRlclByb3BzKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICA8SW1hZ2VTa2VsZXRvbiBoZWlnaHQ9XCJhdXRvXCIgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSAvPlxuICAgICAgPFRleHRTa2VsZXRvbiAvPlxuICAgICAgPFRleHRTa2VsZXRvbiB3aWR0aD1cIjUwJVwiIC8+XG4gICAgICA8VGV4dFNrZWxldG9uIHdpZHRoPVwiNTAlXCIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn0pO1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICAgbGluZS1oZWlnaHQ6IDA7XG5gO1xuXG5jb25zdCBJbWFnZVNrZWxldG9uID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgYXNwZWN0LXJhdGlvOiAke0ZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPfTtcbiAgbWFyZ2luLWJvdHRvbTogJHtweFRvUmVtKDgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBhc3BlY3QtcmF0aW86ICR7RkVFRF9JVEVNX0RFU0tUT1BfQVNQRUNUX1JBVElPfTtcbiAgICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBUZXh0U2tlbGV0b24gPSBzdHlsZWQoU2tlbGV0b24pYFxuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oNil9O1xuYDtcbiJdfQ== */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QnNDIiwiZmlsZSI6IkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJTywgRkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU8gfSBmcm9tICcuL0NvbnRlbnRGZWVkSXRlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29udGVudEZlZWRJdGVtUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyID0gUmVhY3QubWVtbygoe1xuICBjbGFzc05hbWUsXG59OiBDb250ZW50RmVlZEl0ZW1QbGFjZWhvbGRlclByb3BzKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICA8SW1hZ2VTa2VsZXRvbiBoZWlnaHQ9XCJhdXRvXCIgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSAvPlxuICAgICAgPFRleHRTa2VsZXRvbiAvPlxuICAgICAgPFRleHRTa2VsZXRvbiB3aWR0aD1cIjUwJVwiIC8+XG4gICAgICA8VGV4dFNrZWxldG9uIHdpZHRoPVwiNTAlXCIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn0pO1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICAgbGluZS1oZWlnaHQ6IDA7XG5gO1xuXG5jb25zdCBJbWFnZVNrZWxldG9uID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgYXNwZWN0LXJhdGlvOiAke0ZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPfTtcbiAgbWFyZ2luLWJvdHRvbTogJHtweFRvUmVtKDgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBhc3BlY3QtcmF0aW86ICR7RkVFRF9JVEVNX0RFU0tUT1BfQVNQRUNUX1JBVElPfTtcbiAgICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBUZXh0U2tlbGV0b24gPSBzdHlsZWQoU2tlbGV0b24pYFxuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oNil9O1xuYDtcbiJdfQ== */"));
const TextSkeleton$1 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g0"
} : {
  target: "e1l3as7g0",
  label: "TextSkeleton"
})("margin-bottom:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQ3FDIiwiZmlsZSI6IkNvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEZFRURfSVRFTV9ERVNLVE9QX0FTUEVDVF9SQVRJTywgRkVFRF9JVEVNX01PQklMRV9BU1BFQ1RfUkFUSU8gfSBmcm9tICcuL0NvbnRlbnRGZWVkSXRlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29udGVudEZlZWRJdGVtUGxhY2Vob2xkZXJQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRlbnRGZWVkSXRlbVBsYWNlaG9sZGVyID0gUmVhY3QubWVtbygoe1xuICBjbGFzc05hbWUsXG59OiBDb250ZW50RmVlZEl0ZW1QbGFjZWhvbGRlclByb3BzKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICA8SW1hZ2VTa2VsZXRvbiBoZWlnaHQ9XCJhdXRvXCIgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSAvPlxuICAgICAgPFRleHRTa2VsZXRvbiAvPlxuICAgICAgPFRleHRTa2VsZXRvbiB3aWR0aD1cIjUwJVwiIC8+XG4gICAgICA8VGV4dFNrZWxldG9uIHdpZHRoPVwiNTAlXCIgLz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn0pO1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICAgbGluZS1oZWlnaHQ6IDA7XG5gO1xuXG5jb25zdCBJbWFnZVNrZWxldG9uID0gc3R5bGVkKFNrZWxldG9uKWBcbiAgYXNwZWN0LXJhdGlvOiAke0ZFRURfSVRFTV9NT0JJTEVfQVNQRUNUX1JBVElPfTtcbiAgbWFyZ2luLWJvdHRvbTogJHtweFRvUmVtKDgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBhc3BlY3QtcmF0aW86ICR7RkVFRF9JVEVNX0RFU0tUT1BfQVNQRUNUX1JBVElPfTtcbiAgICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oMTApfTtcbiAgYCl9XG5gO1xuXG5jb25zdCBUZXh0U2tlbGV0b24gPSBzdHlsZWQoU2tlbGV0b24pYFxuICBtYXJnaW4tYm90dG9tOiAke3B4VG9SZW0oNil9O1xuYDtcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedPlaceholder = ({
  className,
  loadingText
}) => {
  return jsxs(ContentContainer, {
    className: className,
    children: [jsxs(PlaceholderContainer, {
      children: [jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      }), jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      })]
    }), jsx(PlaceholderText, {
      children: loadingText ?? '맞춤 피드를 불러오고 있어요'
    })]
  });
};
const ContentContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf5"
} : {
  target: "e989kf5",
  label: "ContentContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "i4idzn",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin:auto"
} : {
  name: "i4idzn",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin:auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
const PlaceholderContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf4"
} : {
  target: "e989kf4",
  label: "PlaceholderContainer"
})("width:", pxToRem(95), ";display:flex;justify-content:space-around;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const PlaceholderModule = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf3"
} : {
  target: "e989kf3",
  label: "PlaceholderModule"
})("width:", pxToRem(44), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ImageSkeleton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf2"
} : {
  target: "e989kf2",
  label: "ImageSkeleton"
})("width:100%;height:", pxToRem(58), ";margin-bottom:", pxToRem(4), ";border-radius:", pxToRem(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const TextSkeleton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf1"
} : {
  target: "e989kf1",
  label: "TextSkeleton"
})("height:", pxToRem(6), ";margin-bottom:", pxToRem(3), ";border-radius:", pxToRem(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const PlaceholderText = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf0"
} : {
  target: "e989kf0",
  label: "PlaceholderText"
})("margin-top:", pxToRem(16), ";color:", ({
  theme
}) => theme.content.base2, ";", FONT_STYLE.subTitle2, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

/** 국외향 웹에서 사용하는 푸터 */
const GlobalFooter = ({
  locale,
  country,
  env,
  subdomain,
  serviceType,
  localeData
}) => {
  const isVisibleJPOnlyTab = country === 'JP' && locale === 'ja';
  const aboutLinks = {
    en: 'https://www.bucketplace.com/en/',
    ja: 'https://www.bucketplace.com/ja/',
    id: 'https://www.bucketplace.com/en/',
    ko: 'https://www.bucketplace.com/en/'
  };
  const defaultCompanyLinks = [{
    text: localeData.footerMenuAbout,
    href: aboutLinks[locale]
  }, {
    text: localeData.footerMenuTerms,
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/terms`, serviceType)
  }, {
    text: localeData.footerMenuPrivacyPolicy,
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/privacy`, serviceType)
  }, {
    text: localeData.footerMenuContact,
    href: `mailto:${encodeURIComponent('contact@ohouse.com')}`
  }];
  const electronicAnnouncementLink = {
    text: '電子公告',
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/electronic-announcement`, serviceType)
  };
  const commerceLawLink = {
    text: '特定商取引法に基づく表記',
    href: getURL(subdomain, env, `${GLOBAL_DOMAINS[env]['home']}/${locale}/commerce-law`, serviceType)
  };
  const companyLinks = isVisibleJPOnlyTab ? [...defaultCompanyLinks.slice(0, 3), electronicAnnouncementLink, commerceLawLink, ...defaultCompanyLinks.slice(3)] : defaultCompanyLinks;
  const socialLinkData = {
    en: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohousetoday/'
    }, {
      type: 'TikTok',
      href: 'https://www.tiktok.com/@ohousetoday'
    }],
    ja: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohousejp/'
    }, {
      type: 'Pinterest',
      href: 'https://www.pinterest.jp/ohouse_japan/'
    }],
    id: [{
      type: 'Instagram',
      href: 'https://www.instagram.com/ohouseidn/'
    }, {
      type: 'Pinterest',
      href: 'https://www.pinterest.com/ohouseidn/'
    }, {
      type: 'TikTok',
      href: 'https://www.tiktok.com/@ohouseidn'
    }]
  };
  return jsx(SimpleFooter, {
    companyLinks: companyLinks,
    socialLinks: socialLinkData[locale]
  });
};

const GlobalBanner = ({
  linkComponent,
  getDeepLink,
  location,
  banner = {
    pcContentList: [],
    mobileImageSrc: ''
  },
  user,
  onClose,
  localeData
}) => {
  const handleLog = useCallback((type, data) => {
    switch (type) {
      case 'banner.top.pc.click':
        L({
          category: 'click',
          section: '네비 배너',
          index: data.index
        });
        break;
      case 'banner.top.mobile.click':
        L({
          category: 'click',
          section: '네비 배너'
        });
        break;
      case 'banner.top.pc.close':
      case 'banner.top.mobile.close':
        L({
          category: 'click',
          section: '네비 배너 닫기'
        });
        break;
      case 'banner.bottom.mobile.click':
        L({
          category: 'click',
          section: '앱 다운로드'
        });
        break;
      case 'banner.bottom.mobile.close':
        L({
          category: 'click',
          section: '앱 다운로드 닫기'
        });
        break;
    }
  }, []);
  const handleAppOpen = useCallback(type => {
    window.location.href = getDeepLink({
      sub_id_1: type === 'banner.top.mobile.click' ? 'web_top_bnr' : 'web_bottom_bnr'
    });
  }, [getDeepLink]);
  return jsx(NavigationTopBanner, {
    location: location,
    pcContentList: banner.pcContentList,
    mobileImageSrc: banner.mobileImageSrc,
    linkComponent: linkComponent,
    onLog: handleLog,
    onAppOpen: handleAppOpen,
    isUserLoggedIn: !!user,
    onClosePCTopBanner: onClose?.pcTopBanner,
    onCloseMobileTopBanner: onClose?.mobileTopBanner,
    onCloseAppDownloadPopup: onClose?.appDownloadPopup,
    localeData: localeData
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const LOCALE_ITEMS = [{
  locale: 'en',
  text: 'English'
}, {
  locale: 'ja',
  text: '日本語'
}, {
  locale: 'id',
  text: 'Bahasa Indonesia'
}];
const DROPDOWN_LOCALE_ITEMS = LOCALE_ITEMS.map((item, index) => {
  return {
    id: index,
    value: item.text
  };
});
const ChangeLanguageButton = () => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const [currentLocale, setCurrentLocale] = useState(null);
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const redirectToNewUrlWithLocale = locale => {
    location.href = getUrlWithExchangeLocale(location.href, locale);
  };
  const getLocaleByDropdownItemIndex = index => {
    return LOCALE_ITEMS[index]?.locale;
  };
  const handleClickLocaleButton = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };
  const handleClickDropdownItem = index => {
    setIsDropdownOpen(false);
    if (selectedItemIndex === index) {
      return;
    }
    const locale = getLocaleByDropdownItemIndex(index);
    if (locale) {
      redirectToNewUrlWithLocale(locale);
    }
  };
  useEffect(() => {
    if (currentLocale) {
      setSelectedItemIndex(LOCALE_ITEMS.findIndex(item => item.locale === currentLocale));
    }
  }, [currentLocale]);
  useEffect(() => {
    if (location) {
      setCurrentLocale(getLocaleFromUrl(location.href));
    }
  }, []);
  return jsxs(LocaleContainer, {
    children: [jsx(StyledTextButtonWithIcon, {
      size: isMobile ? 32 : 30,
      icon: isMobile ? 'chevron_thick_down' : 'chevron_down',
      iconSize: isMobile ? 12 : 18,
      variant: "base1",
      text: (isMobile ? LOCALE_ITEMS[selectedItemIndex]?.locale.toUpperCase() : LOCALE_ITEMS[selectedItemIndex]?.text) ?? '',
      isTrailing: true,
      onClick: handleClickLocaleButton
    }), isDropdownOpen && jsx(DropdownWrapper, {
      "data-testid": "language-dropdown",
      children: jsx(Dropdown$1, {
        title: "",
        dropdownRef: dropdownRef,
        items: DROPDOWN_LOCALE_ITEMS,
        onCloseDropdown: handleCloseDropdown,
        onClose: () => setIsDropdownOpen(false),
        onClick: handleClickDropdownItem,
        selectedItemId: selectedItemIndex
      })
    })]
  });
};
const LocaleContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etdtywj2"
} : {
  target: "etdtywj2",
  label: "LocaleContainer"
})(FONT_STYLE.caption1, " display:flex;position:relative;flex-wrap:wrap;align-items:center;color:", ({
  theme
}) => theme.content.base1, ";", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "gleosg",
  styles: "gap:20px"
} : {
  name: "do7gyl-LocaleContainer",
  styles: "gap:20px;label:LocaleContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const DropdownWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etdtywj1"
} : {
  target: "etdtywj1",
  label: "DropdownWrapper"
})("position:absolute;top:calc(100% + 16px);left:0px;min-width:296px;padding:8px;background-color:", ({
  theme
}) => theme.background.base, ";border-radius:8px;box-shadow:0px 2px 10px 0px ", ({
  theme
}) => theme.shadow.darken, ";&>div>div{border:0px;}", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "52b1oc",
  styles: "padding:0px"
} : {
  name: "11qpsuu-DropdownWrapper",
  styles: "padding:0px;label:DropdownWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledTextButtonWithIcon = /*#__PURE__*/_styled(TextButtonWithIcon, process.env.NODE_ENV === "production" ? {
  target: "etdtywj0"
} : {
  target: "etdtywj0",
  label: "StyledTextButtonWithIcon"
})("&>span:first-of-type{", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "14hpr0l",
  styles: "display:inline-block;max-width:42px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : {
  name: "egzzk8-StyledTextButtonWithIcon",
  styles: "display:inline-block;max-width:42px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;label:StyledTextButtonWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
}), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$2 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$2[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs$1(reactFastCompare);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (isEqual$1(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs$1(propTypesExports);

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = /*#__PURE__*/React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;
  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$2() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
      _this$props.classNames;
      var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /*#__PURE__*/React__default.createElement(Transition$1, _extends$6({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$6({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && /*#__PURE__*/isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (! /*#__PURE__*/isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = /*#__PURE__*/isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && /*#__PURE__*/isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$6({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (/*#__PURE__*/React__default.isValidElement(oldChildren) && /*#__PURE__*/React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return /*#__PURE__*/React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, /*#__PURE__*/React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return /*#__PURE__*/React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, /*#__PURE__*/React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [/*#__PURE__*/React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, /*#__PURE__*/React__default.cloneElement(children, {
        in: true
      }));
    })
  }), /*#__PURE__*/React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: /*#__PURE__*/React__default.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(React__default.Component);
SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var SwitchTransition$1 = SwitchTransition;

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_ARROW = {
  width: 14,
  height: 10,
  color: theme => theme.background.base
};
const InfoTip = ({
  children,
  renderOpener,
  onOpenChange,
  openOnHover,
  offsetTop = 4,
  arrow: arrowProps = {},
  forceOpen,
  forceClose,
  contentStyle
}) => {
  const buttonRef = useRef(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [ref, setRef] = useState(null);
  const [isOpenState, setIsOpenState] = useState(false);
  const arrow = useMemo(() => ({
    ...DEFAULT_ARROW,
    ...arrowProps
  }), [arrowProps]);
  const {
    styles,
    attributes,
    state
  } = usePopper(buttonRef.current, ref, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, offsetTop + arrow.height]
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowRef
      }
    }]
  });
  const handleOpen = useCallback(() => {
    setIsOpenState(true);
    onOpenChange?.(true);
  }, [onOpenChange]);
  const handleClose = useCallback(() => {
    setIsOpenState(false);
    onOpenChange?.(false);
  }, [onOpenChange]);
  const handleToggle = useCallback(() => {
    if (isOpenState) {
      handleClose();
      return;
    }
    handleOpen();
  }, [isOpenState, handleOpen, handleClose]);
  const handleMouseEnter = useCallback(() => {
    if (openOnHover) {
      handleOpen();
    }
  }, [openOnHover, handleOpen]);
  const handleMouseLeave = useCallback(() => {
    if (openOnHover) {
      handleClose();
    }
  }, [openOnHover, handleClose]);
  const isOpen = Boolean((isOpenState || forceOpen) && !forceClose);
  return jsxs(Fragment$1, {
    children: [jsx(ButtonWrapper, {
      ref: buttonRef,
      children: renderOpener({
        isOpen,
        onToggle: handleToggle,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    }), isOpen && jsx(CSSTransition$1, {
      in: ref !== null && isOpen,
      timeout: 200,
      classNames: {
        enterActive: 'open',
        enterDone: 'open open-active',
        appearDone: 'open',
        exit: 'exiting'
      },
      children: jsxs(Content$1, {
        ref: setRef,
        style: {
          ...styles['popper'],
          ...contentStyle
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        offset: offsetTop + arrow.height,
        className: state?.placement ?? 'auto',
        ...attributes['popper'],
        children: [jsx(Arrow$1, {
          ref: setArrowRef,
          style: styles['arrow'],
          placement: state?.placement ?? 'auto',
          arrow: arrow,
          "data-popper-arrow": true,
          className: state?.placement
        }), jsx(ChildrenWrapper, {
          style: styles['offset'],
          children: children
        })]
      })
    })]
  });
};
const ButtonWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au3"
} : {
  target: "et5x4au3",
  label: "ButtonWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1kx8xpu",
  styles: "line-height:0;display:inline-block"
} : {
  name: "1kx8xpu",
  styles: "line-height:0;display:inline-block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
});

// 화살표 팁과 Content 영역 사이에 마우스가 위치해도 열림 상태를 유지하기 위한 레이어
const cssBackLayer = process.env.NODE_ENV === "production" ? {
  name: "zw5q4a",
  styles: "content:'';width:100%;height:100%;position:absolute;left:0"
} : {
  name: "1jdkgnu-cssBackLayer",
  styles: "content:'';width:100%;height:100%;position:absolute;left:0;label:cssBackLayer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};
const Content$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au2"
} : {
  target: "et5x4au2",
  label: "Content"
})("z-index:1;&[data-popper-placement^='bottom']{&:before{", cssBackLayer, " top:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='top']{&:before{", cssBackLayer, " bottom:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='right']{&:before{", cssBackLayer, " left:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='left']{&:before{", cssBackLayer, " right:", ({
  offset
}) => pxToRem(-offset), ";}}visibility:hidden;opacity:0;pointer-events:none;&.open{visibility:visible;opacity:1;transform:none;transition:0.2s opacity,0.2s transform;}&.open-active{pointer-events:auto;}&.exiting{transition:visibility 0.2s,0.2s opacity,0.2s transform;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ChildrenWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au1"
} : {
  target: "et5x4au1",
  label: "ChildrenWrapper"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const generateArrow = (placement, arrow, theme) => {
  if (placement.startsWith('bottom')) {
    return /*#__PURE__*/css("border-bottom:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  }
  if (placement.startsWith('top')) {
    return /*#__PURE__*/css("border-top:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  }
  if (placement.startsWith('right')) {
    return /*#__PURE__*/css("border-right:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-bottom:", pxToRem(arrow.width / 2), " solid transparent;border-top:", pxToRem(arrow.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9UaXAudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBRYyIsImZpbGUiOiJJbmZvVGlwLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VDYWxsYmFjaywgdXNlTWVtbywgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFBvcHBlclByb3BzLCB1c2VQb3BwZXIgfSBmcm9tICdyZWFjdC1wb3BwZXInO1xuaW1wb3J0IHsgQ1NTVHJhbnNpdGlvbiB9IGZyb20gJ3JlYWN0LXRyYW5zaXRpb24tZ3JvdXAnO1xuaW1wb3J0IHsgU2VyaWFsaXplZFN0eWxlcywgVGhlbWUsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxudHlwZSBQbGFjZW1lbnQgPSBOb25OdWxsYWJsZTxQb3BwZXJQcm9wczx1bmtub3duPlsncGxhY2VtZW50J10+O1xuXG5leHBvcnQgaW50ZXJmYWNlIE9wZW5lclByb3BzIHtcbiAgaXNPcGVuOiBib29sZWFuO1xuICBvblRvZ2dsZTogKCkgPT4gdm9pZDtcbiAgb25Nb3VzZUVudGVyOiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgb25Nb3VzZUxlYXZlOiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbn1cblxuZXhwb3J0IGludGVyZmFjZSBBcnJvd1Byb3BzIHtcbiAgd2lkdGg6IG51bWJlcjtcbiAgaGVpZ2h0OiBudW1iZXI7XG4gIGNvbG9yOiAodGhlbWU6IFRoZW1lKSA9PiBzdHJpbmc7XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgSW5mb1RpcFByb3BzIHtcbiAgY2hpbGRyZW46IFJlYWN0LlJlYWN0Tm9kZTtcbiAgcmVuZGVyT3BlbmVyOiAocHJvcHM6IE9wZW5lclByb3BzKSA9PiBSZWFjdC5SZWFjdE5vZGU7XG4gIG9uT3BlbkNoYW5nZT86IChpc09wZW46IGJvb2xlYW4pID0+IHZvaWQ7XG4gIC8qKlxuICAgKiBob3ZlciDtlojsnYQg65WMIOyXtOumvCDsg4Htg5zqsIAg67CU64CM64qU7KeAXG4gICAqL1xuICBvcGVuT25Ib3Zlcj86IGJvb2xlYW47XG4gIC8qKlxuICAgKiByZW5kZXJPcGVuZXIg64SY6rKo7KSAIOyalOyGjOyZgCDsvZjthZDsuKDsnZgg7ZmU7IK07ZGcIOyCrOydtOydmCDqsITqsqlcbiAgICogZGVmYXVsdDogNHB4XG4gICAqL1xuICBvZmZzZXRUb3A/OiBudW1iZXI7XG4gIC8qKlxuICAgKiBkZWZhdWx0OlxuICAgKiAtIHdpZHRoOiAxNHB4XG4gICAqIC0gaGVpZ2h0OiAxMHB4XG4gICAqIC0gY29sb3I6ICNmZmZmZmZcbiAgICovXG4gIGFycm93PzogUGFydGlhbDxBcnJvd1Byb3BzPjtcbiAgLyoqXG4gICAqIGNsaWNrLCBob3ZlciDslaHshZjsl4bsnbQg7Je066as6rKMIO2VoCDsiJgg7J6I7J2MXG4gICAqIGUuZykg7IOB7ZKIIOyKpO2BrOuhpOufrOyXkOyEnCDsg4HtkoggSG92ZXIg7ZaI7J2EIOuVjCDtg5zqt7jqsIAg7Je066a0IOuVjCB0cnVl66GcIOuEmOqyqOykhCDsiJgg7J6I7J2MXG4gICAqL1xuICBmb3JjZU9wZW4/OiBib29sZWFuO1xuICAvKipcbiAgICogY2xpY2ssIGhvdmVyIOyVoeyFmOyXhuydtCDri6vtnojqsowg7ZWgIOyImCDsnojsnYxcbiAgICogZS5nKSDtlYTthLDsl5DshJwg7Ji17IWYIOyEoO2DnSDsi5wgZHJvcGRvd27snYQgY2xvc2XtlaAg65WMIHRydWXroZwg64SY6rKo7KSEIOyImCDsnojsnYxcbiAgICovXG4gIGZvcmNlQ2xvc2U/OiBib29sZWFuO1xuICBjb250ZW50U3R5bGU/OiBSZWFjdC5DU1NQcm9wZXJ0aWVzO1xufVxuXG5jb25zdCBERUZBVUxUX0FSUk9XOiBBcnJvd1Byb3BzID0ge1xuICB3aWR0aDogMTQsXG4gIGhlaWdodDogMTAsXG4gIGNvbG9yOiAodGhlbWU6IFRoZW1lKSA9PiB0aGVtZS5iYWNrZ3JvdW5kLmJhc2UsXG59O1xuXG5leHBvcnQgY29uc3QgSW5mb1RpcCA9ICh7XG4gIGNoaWxkcmVuLFxuICByZW5kZXJPcGVuZXIsXG4gIG9uT3BlbkNoYW5nZSxcbiAgb3Blbk9uSG92ZXIsXG4gIG9mZnNldFRvcCA9IDQsXG4gIGFycm93OiBhcnJvd1Byb3BzID0ge30sXG4gIGZvcmNlT3BlbixcbiAgZm9yY2VDbG9zZSxcbiAgY29udGVudFN0eWxlLFxufTogSW5mb1RpcFByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgY29uc3QgYnV0dG9uUmVmID0gdXNlUmVmKG51bGwpO1xuICBjb25zdCBbYXJyb3dSZWYsIHNldEFycm93UmVmXSA9IHVzZVN0YXRlPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IFtyZWYsIHNldFJlZl0gPSB1c2VTdGF0ZTxIVE1MRGl2RWxlbWVudCB8IG51bGw+KG51bGwpO1xuICBjb25zdCBbaXNPcGVuU3RhdGUsIHNldElzT3BlblN0YXRlXSA9IHVzZVN0YXRlKGZhbHNlKTtcblxuICBjb25zdCBhcnJvdyA9IHVzZU1lbW8oXG4gICAgKCkgPT4gKHtcbiAgICAgIC4uLkRFRkFVTFRfQVJST1csXG4gICAgICAuLi5hcnJvd1Byb3BzLFxuICAgIH0pLFxuICAgIFthcnJvd1Byb3BzXSxcbiAgKTtcblxuICBjb25zdCB7IHN0eWxlcywgYXR0cmlidXRlcywgc3RhdGUgfSA9IHVzZVBvcHBlcihidXR0b25SZWYuY3VycmVudCwgcmVmLCB7XG4gICAgcGxhY2VtZW50OiAnYm90dG9tJyxcbiAgICBtb2RpZmllcnM6IFtcbiAgICAgIHtcbiAgICAgICAgbmFtZTogJ29mZnNldCcsXG4gICAgICAgIGVuYWJsZWQ6IHRydWUsXG4gICAgICAgIG9wdGlvbnM6IHtcbiAgICAgICAgICBvZmZzZXQ6IFswLCBvZmZzZXRUb3AgKyBhcnJvdy5oZWlnaHRdLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIHtcbiAgICAgICAgbmFtZTogJ2Fycm93JyxcbiAgICAgICAgZW5hYmxlZDogdHJ1ZSxcbiAgICAgICAgb3B0aW9uczoge1xuICAgICAgICAgIGVsZW1lbnQ6IGFycm93UmVmLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICBdLFxuICB9KTtcblxuICBjb25zdCBoYW5kbGVPcGVuID0gdXNlQ2FsbGJhY2soKCk6IHZvaWQgPT4ge1xuICAgIHNldElzT3BlblN0YXRlKHRydWUpO1xuICAgIG9uT3BlbkNoYW5nZT8uKHRydWUpO1xuICB9LCBbb25PcGVuQ2hhbmdlXSk7XG5cbiAgY29uc3QgaGFuZGxlQ2xvc2UgPSB1c2VDYWxsYmFjaygoKTogdm9pZCA9PiB7XG4gICAgc2V0SXNPcGVuU3RhdGUoZmFsc2UpO1xuICAgIG9uT3BlbkNoYW5nZT8uKGZhbHNlKTtcbiAgfSwgW29uT3BlbkNoYW5nZV0pO1xuXG4gIGNvbnN0IGhhbmRsZVRvZ2dsZSA9IHVzZUNhbGxiYWNrKCgpOiB2b2lkID0+IHtcbiAgICBpZiAoaXNPcGVuU3RhdGUpIHtcbiAgICAgIGhhbmRsZUNsb3NlKCk7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGhhbmRsZU9wZW4oKTtcbiAgfSwgW2lzT3BlblN0YXRlLCBoYW5kbGVPcGVuLCBoYW5kbGVDbG9zZV0pO1xuXG4gIGNvbnN0IGhhbmRsZU1vdXNlRW50ZXIgPSB1c2VDYWxsYmFjaygoKTogdm9pZCA9PiB7XG4gICAgaWYgKG9wZW5PbkhvdmVyKSB7XG4gICAgICBoYW5kbGVPcGVuKCk7XG4gICAgfVxuICB9LCBbb3Blbk9uSG92ZXIsIGhhbmRsZU9wZW5dKTtcblxuICBjb25zdCBoYW5kbGVNb3VzZUxlYXZlID0gdXNlQ2FsbGJhY2soKCk6IHZvaWQgPT4ge1xuICAgIGlmIChvcGVuT25Ib3Zlcikge1xuICAgICAgaGFuZGxlQ2xvc2UoKTtcbiAgICB9XG4gIH0sIFtvcGVuT25Ib3ZlciwgaGFuZGxlQ2xvc2VdKTtcblxuICBjb25zdCBpc09wZW4gPSBCb29sZWFuKChpc09wZW5TdGF0ZSB8fCBmb3JjZU9wZW4pICYmICFmb3JjZUNsb3NlKTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICA8QnV0dG9uV3JhcHBlciByZWY9e2J1dHRvblJlZn0+XG4gICAgICAgIHsgcmVuZGVyT3BlbmVyKHtcbiAgICAgICAgICBpc09wZW4sXG4gICAgICAgICAgb25Ub2dnbGU6IGhhbmRsZVRvZ2dsZSxcbiAgICAgICAgICBvbk1vdXNlRW50ZXI6IGhhbmRsZU1vdXNlRW50ZXIsXG4gICAgICAgICAgb25Nb3VzZUxlYXZlOiBoYW5kbGVNb3VzZUxlYXZlLFxuICAgICAgICB9KSB9XG4gICAgICA8L0J1dHRvbldyYXBwZXI+XG4gICAgICB7IGlzT3BlbiAmJiAoXG4gICAgICAgIDxDU1NUcmFuc2l0aW9uXG4gICAgICAgICAgaW49e3JlZiAhPT0gbnVsbCAmJiBpc09wZW59XG4gICAgICAgICAgdGltZW91dD17MjAwfVxuICAgICAgICAgIGNsYXNzTmFtZXM9e3tcbiAgICAgICAgICAgIGVudGVyQWN0aXZlOiAnb3BlbicsXG4gICAgICAgICAgICBlbnRlckRvbmU6ICdvcGVuIG9wZW4tYWN0aXZlJyxcbiAgICAgICAgICAgIGFwcGVhckRvbmU6ICdvcGVuJyxcbiAgICAgICAgICAgIGV4aXQ6ICdleGl0aW5nJyxcbiAgICAgICAgICB9fVxuICAgICAgICA+XG4gICAgICAgICAgPENvbnRlbnRcbiAgICAgICAgICAgIHJlZj17c2V0UmVmfVxuICAgICAgICAgICAgc3R5bGU9e3tcbiAgICAgICAgICAgICAgLi4uc3R5bGVzWydwb3BwZXInXSxcbiAgICAgICAgICAgICAgLi4uY29udGVudFN0eWxlLFxuICAgICAgICAgICAgfX1cbiAgICAgICAgICAgIG9uTW91c2VFbnRlcj17aGFuZGxlTW91c2VFbnRlcn1cbiAgICAgICAgICAgIG9uTW91c2VMZWF2ZT17aGFuZGxlTW91c2VMZWF2ZX1cbiAgICAgICAgICAgIG9mZnNldD17b2Zmc2V0VG9wICsgYXJyb3cuaGVpZ2h0fVxuICAgICAgICAgICAgY2xhc3NOYW1lPXtzdGF0ZT8ucGxhY2VtZW50ID8/ICdhdXRvJ31cbiAgICAgICAgICAgIHsuLi5hdHRyaWJ1dGVzWydwb3BwZXInXX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICA8QXJyb3dcbiAgICAgICAgICAgICAgcmVmPXtzZXRBcnJvd1JlZn1cbiAgICAgICAgICAgICAgc3R5bGU9e3N0eWxlc1snYXJyb3cnXX1cbiAgICAgICAgICAgICAgcGxhY2VtZW50PXtzdGF0ZT8ucGxhY2VtZW50ID8/ICdhdXRvJ31cbiAgICAgICAgICAgICAgYXJyb3c9e2Fycm93fVxuICAgICAgICAgICAgICBkYXRhLXBvcHBlci1hcnJvd1xuICAgICAgICAgICAgICBjbGFzc05hbWU9e3N0YXRlPy5wbGFjZW1lbnR9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPENoaWxkcmVuV3JhcHBlciBzdHlsZT17c3R5bGVzWydvZmZzZXQnXX0+eyBjaGlsZHJlbiB9PC9DaGlsZHJlbldyYXBwZXI+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICA8L0NTU1RyYW5zaXRpb24+XG4gICAgICApIH1cbiAgICA8Lz5cbiAgKTtcbn07XG5cbmNvbnN0IEJ1dHRvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBsaW5lLWhlaWdodDogMDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuYDtcblxuLy8g7ZmU7IK07ZGcIO2MgeqzvCBDb250ZW50IOyYgeyXrSDsgqzsnbTsl5Ag66eI7Jqw7Iqk6rCAIOychOy5mO2VtOuPhCDsl7Trprwg7IOB7YOc66W8IOycoOyngO2VmOq4sCDsnITtlZwg66CI7J207Ja0XG5jb25zdCBjc3NCYWNrTGF5ZXIgPSBjc3NgXG4gIGNvbnRlbnQ6ICcnO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDA7XG5gO1xuXG5jb25zdCBDb250ZW50ID0gc3R5bGVkLmRpdjx7IG9mZnNldDogbnVtYmVyLCBwbGFjZW1lbnQ/OiBQbGFjZW1lbnQgfT5gXG4gIHotaW5kZXg6IDE7XG4gICZbZGF0YS1wb3BwZXItcGxhY2VtZW50Xj0nYm90dG9tJ10ge1xuICAgICY6YmVmb3JlIHtcbiAgICAgICR7Y3NzQmFja0xheWVyfVxuICAgICAgdG9wOiAkeyh7IG9mZnNldCB9KSA9PiBweFRvUmVtKC1vZmZzZXQpfTtcbiAgICB9XG4gIH1cbiAgJltkYXRhLXBvcHBlci1wbGFjZW1lbnRePSd0b3AnXSB7XG4gICAgJjpiZWZvcmUge1xuICAgICAgJHtjc3NCYWNrTGF5ZXJ9XG4gICAgICBib3R0b206ICR7KHsgb2Zmc2V0IH0pID0+IHB4VG9SZW0oLW9mZnNldCl9O1xuICAgIH1cbiAgfVxuICAmW2RhdGEtcG9wcGVyLXBsYWNlbWVudF49J3JpZ2h0J10ge1xuICAgICY6YmVmb3JlIHtcbiAgICAgICR7Y3NzQmFja0xheWVyfVxuICAgICAgbGVmdDogJHsoeyBvZmZzZXQgfSkgPT4gcHhUb1JlbSgtb2Zmc2V0KX07XG4gICAgfVxuICB9XG4gICZbZGF0YS1wb3BwZXItcGxhY2VtZW50Xj0nbGVmdCddIHtcbiAgICAmOmJlZm9yZSB7XG4gICAgICAke2Nzc0JhY2tMYXllcn1cbiAgICAgIHJpZ2h0OiAkeyh7IG9mZnNldCB9KSA9PiBweFRvUmVtKC1vZmZzZXQpfTtcbiAgICB9XG4gIH1cbiAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICBvcGFjaXR5OiAwO1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgJi5vcGVuIHtcbiAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgIG9wYWNpdHk6IDE7XG4gICAgdHJhbnNmb3JtOiBub25lO1xuICAgIHRyYW5zaXRpb246IDAuMnMgb3BhY2l0eSwgMC4ycyB0cmFuc2Zvcm07XG4gIH1cbiAgJi5vcGVuLWFjdGl2ZSB7XG4gICAgcG9pbnRlci1ldmVudHM6IGF1dG87XG4gIH1cbiAgJi5leGl0aW5nIHtcbiAgICB0cmFuc2l0aW9uOiB2aXNpYmlsaXR5IDAuMnMsIDAuMnMgb3BhY2l0eSwgMC4ycyB0cmFuc2Zvcm07XG4gIH1cbmA7XG5cbmNvbnN0IENoaWxkcmVuV3JhcHBlciA9IHN0eWxlZC5kaXZgYDtcblxuY29uc3QgZ2VuZXJhdGVBcnJvdyA9IChcbiAgcGxhY2VtZW50OiBQbGFjZW1lbnQsXG4gIGFycm93OiBBcnJvd1Byb3BzLFxuICB0aGVtZTogVGhlbWUsXG4pOiBTZXJpYWxpemVkU3R5bGVzID0+IHtcbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCdib3R0b20nKSkge1xuICAgIHJldHVybiBjc3NgXG4gICAgICBib3JkZXItYm90dG9tOiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX0gc29saWQgJHthcnJvdy5jb2xvcih0aGVtZSl9O1xuICAgICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGA7XG4gIH1cbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCd0b3AnKSkge1xuICAgIHJldHVybiBjc3NgXG4gICAgICBib3JkZXItdG9wOiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX0gc29saWQgJHthcnJvdy5jb2xvcih0aGVtZSl9O1xuICAgICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGA7XG4gIH1cbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCdyaWdodCcpKSB7XG4gICAgcmV0dXJuIGNzc2BcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LmhlaWdodCl9IHNvbGlkICR7YXJyb3cuY29sb3IodGhlbWUpfTtcbiAgICAgIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci10b3A6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICBgO1xuICB9XG4gIHJldHVybiBjc3NgXG4gICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy5oZWlnaHQpfSBzb2xpZCAke2Fycm93LmNvbG9yKHRoZW1lKX07XG4gICAgYm9yZGVyLXRvcDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgYDtcbn07XG5cbmNvbnN0IEFycm93ID0gc3R5bGVkLmRpdjx7IHBsYWNlbWVudDogUGxhY2VtZW50LCBhcnJvdzogQXJyb3dQcm9wcyB9PmBcbiAgJHsoeyBhcnJvdyB9KSA9PiBhcnJvdyAmJlxuICAgIGBcbiAgICB3aWR0aDogJHtweFRvUmVtKGFycm93LndpZHRoKX07XG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX07YH1cbiAgJHsoeyBhcnJvdyB9KSA9PiBgXG4gICAgJltjbGFzc149XCJib3R0b21cIl0ge1xuICAgICAgdG9wOiAke3B4VG9SZW0oLWFycm93LmhlaWdodCl9O1xuICAgIH1cbiAgICAmW2NsYXNzXj1cInRvcFwiXSB7XG4gICAgICBib3R0b206ICR7cHhUb1JlbSgtYXJyb3cuaGVpZ2h0KX07XG4gICAgfVxuICAgICZbY2xhc3NePVwicmlnaHRcIl0ge1xuICAgICAgbGVmdDogJHtweFRvUmVtKC1hcnJvdy5oZWlnaHQpfTtcbiAgICB9XG4gICAgJltjbGFzc149XCJsZWZ0XCJdIHtcbiAgICAgIHJpZ2h0OiAke3B4VG9SZW0oLWFycm93LmhlaWdodCl9O1xuICAgIH1cbiAgYH1cbiAgJjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAwO1xuICAgIGhlaWdodDogMDtcbiAgICBsZWZ0OiAwO1xuICAgICR7KHsgcGxhY2VtZW50LCBhcnJvdywgdGhlbWUgfSkgPT4gcGxhY2VtZW50ICYmIGdlbmVyYXRlQXJyb3cocGxhY2VtZW50LCBhcnJvdywgdGhlbWUpfVxuICB9XG5gO1xuIl19 */");
  }
  return /*#__PURE__*/css("border-left:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-top:", pxToRem(arrow.width / 2), " solid transparent;border-bottom:", pxToRem(arrow.width / 2), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9UaXAudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdSWSIsImZpbGUiOiJJbmZvVGlwLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VDYWxsYmFjaywgdXNlTWVtbywgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFBvcHBlclByb3BzLCB1c2VQb3BwZXIgfSBmcm9tICdyZWFjdC1wb3BwZXInO1xuaW1wb3J0IHsgQ1NTVHJhbnNpdGlvbiB9IGZyb20gJ3JlYWN0LXRyYW5zaXRpb24tZ3JvdXAnO1xuaW1wb3J0IHsgU2VyaWFsaXplZFN0eWxlcywgVGhlbWUsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxudHlwZSBQbGFjZW1lbnQgPSBOb25OdWxsYWJsZTxQb3BwZXJQcm9wczx1bmtub3duPlsncGxhY2VtZW50J10+O1xuXG5leHBvcnQgaW50ZXJmYWNlIE9wZW5lclByb3BzIHtcbiAgaXNPcGVuOiBib29sZWFuO1xuICBvblRvZ2dsZTogKCkgPT4gdm9pZDtcbiAgb25Nb3VzZUVudGVyOiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgb25Nb3VzZUxlYXZlOiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbn1cblxuZXhwb3J0IGludGVyZmFjZSBBcnJvd1Byb3BzIHtcbiAgd2lkdGg6IG51bWJlcjtcbiAgaGVpZ2h0OiBudW1iZXI7XG4gIGNvbG9yOiAodGhlbWU6IFRoZW1lKSA9PiBzdHJpbmc7XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgSW5mb1RpcFByb3BzIHtcbiAgY2hpbGRyZW46IFJlYWN0LlJlYWN0Tm9kZTtcbiAgcmVuZGVyT3BlbmVyOiAocHJvcHM6IE9wZW5lclByb3BzKSA9PiBSZWFjdC5SZWFjdE5vZGU7XG4gIG9uT3BlbkNoYW5nZT86IChpc09wZW46IGJvb2xlYW4pID0+IHZvaWQ7XG4gIC8qKlxuICAgKiBob3ZlciDtlojsnYQg65WMIOyXtOumvCDsg4Htg5zqsIAg67CU64CM64qU7KeAXG4gICAqL1xuICBvcGVuT25Ib3Zlcj86IGJvb2xlYW47XG4gIC8qKlxuICAgKiByZW5kZXJPcGVuZXIg64SY6rKo7KSAIOyalOyGjOyZgCDsvZjthZDsuKDsnZgg7ZmU7IK07ZGcIOyCrOydtOydmCDqsITqsqlcbiAgICogZGVmYXVsdDogNHB4XG4gICAqL1xuICBvZmZzZXRUb3A/OiBudW1iZXI7XG4gIC8qKlxuICAgKiBkZWZhdWx0OlxuICAgKiAtIHdpZHRoOiAxNHB4XG4gICAqIC0gaGVpZ2h0OiAxMHB4XG4gICAqIC0gY29sb3I6ICNmZmZmZmZcbiAgICovXG4gIGFycm93PzogUGFydGlhbDxBcnJvd1Byb3BzPjtcbiAgLyoqXG4gICAqIGNsaWNrLCBob3ZlciDslaHshZjsl4bsnbQg7Je066as6rKMIO2VoCDsiJgg7J6I7J2MXG4gICAqIGUuZykg7IOB7ZKIIOyKpO2BrOuhpOufrOyXkOyEnCDsg4HtkoggSG92ZXIg7ZaI7J2EIOuVjCDtg5zqt7jqsIAg7Je066a0IOuVjCB0cnVl66GcIOuEmOqyqOykhCDsiJgg7J6I7J2MXG4gICAqL1xuICBmb3JjZU9wZW4/OiBib29sZWFuO1xuICAvKipcbiAgICogY2xpY2ssIGhvdmVyIOyVoeyFmOyXhuydtCDri6vtnojqsowg7ZWgIOyImCDsnojsnYxcbiAgICogZS5nKSDtlYTthLDsl5DshJwg7Ji17IWYIOyEoO2DnSDsi5wgZHJvcGRvd27snYQgY2xvc2XtlaAg65WMIHRydWXroZwg64SY6rKo7KSEIOyImCDsnojsnYxcbiAgICovXG4gIGZvcmNlQ2xvc2U/OiBib29sZWFuO1xuICBjb250ZW50U3R5bGU/OiBSZWFjdC5DU1NQcm9wZXJ0aWVzO1xufVxuXG5jb25zdCBERUZBVUxUX0FSUk9XOiBBcnJvd1Byb3BzID0ge1xuICB3aWR0aDogMTQsXG4gIGhlaWdodDogMTAsXG4gIGNvbG9yOiAodGhlbWU6IFRoZW1lKSA9PiB0aGVtZS5iYWNrZ3JvdW5kLmJhc2UsXG59O1xuXG5leHBvcnQgY29uc3QgSW5mb1RpcCA9ICh7XG4gIGNoaWxkcmVuLFxuICByZW5kZXJPcGVuZXIsXG4gIG9uT3BlbkNoYW5nZSxcbiAgb3Blbk9uSG92ZXIsXG4gIG9mZnNldFRvcCA9IDQsXG4gIGFycm93OiBhcnJvd1Byb3BzID0ge30sXG4gIGZvcmNlT3BlbixcbiAgZm9yY2VDbG9zZSxcbiAgY29udGVudFN0eWxlLFxufTogSW5mb1RpcFByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgY29uc3QgYnV0dG9uUmVmID0gdXNlUmVmKG51bGwpO1xuICBjb25zdCBbYXJyb3dSZWYsIHNldEFycm93UmVmXSA9IHVzZVN0YXRlPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IFtyZWYsIHNldFJlZl0gPSB1c2VTdGF0ZTxIVE1MRGl2RWxlbWVudCB8IG51bGw+KG51bGwpO1xuICBjb25zdCBbaXNPcGVuU3RhdGUsIHNldElzT3BlblN0YXRlXSA9IHVzZVN0YXRlKGZhbHNlKTtcblxuICBjb25zdCBhcnJvdyA9IHVzZU1lbW8oXG4gICAgKCkgPT4gKHtcbiAgICAgIC4uLkRFRkFVTFRfQVJST1csXG4gICAgICAuLi5hcnJvd1Byb3BzLFxuICAgIH0pLFxuICAgIFthcnJvd1Byb3BzXSxcbiAgKTtcblxuICBjb25zdCB7IHN0eWxlcywgYXR0cmlidXRlcywgc3RhdGUgfSA9IHVzZVBvcHBlcihidXR0b25SZWYuY3VycmVudCwgcmVmLCB7XG4gICAgcGxhY2VtZW50OiAnYm90dG9tJyxcbiAgICBtb2RpZmllcnM6IFtcbiAgICAgIHtcbiAgICAgICAgbmFtZTogJ29mZnNldCcsXG4gICAgICAgIGVuYWJsZWQ6IHRydWUsXG4gICAgICAgIG9wdGlvbnM6IHtcbiAgICAgICAgICBvZmZzZXQ6IFswLCBvZmZzZXRUb3AgKyBhcnJvdy5oZWlnaHRdLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIHtcbiAgICAgICAgbmFtZTogJ2Fycm93JyxcbiAgICAgICAgZW5hYmxlZDogdHJ1ZSxcbiAgICAgICAgb3B0aW9uczoge1xuICAgICAgICAgIGVsZW1lbnQ6IGFycm93UmVmLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICBdLFxuICB9KTtcblxuICBjb25zdCBoYW5kbGVPcGVuID0gdXNlQ2FsbGJhY2soKCk6IHZvaWQgPT4ge1xuICAgIHNldElzT3BlblN0YXRlKHRydWUpO1xuICAgIG9uT3BlbkNoYW5nZT8uKHRydWUpO1xuICB9LCBbb25PcGVuQ2hhbmdlXSk7XG5cbiAgY29uc3QgaGFuZGxlQ2xvc2UgPSB1c2VDYWxsYmFjaygoKTogdm9pZCA9PiB7XG4gICAgc2V0SXNPcGVuU3RhdGUoZmFsc2UpO1xuICAgIG9uT3BlbkNoYW5nZT8uKGZhbHNlKTtcbiAgfSwgW29uT3BlbkNoYW5nZV0pO1xuXG4gIGNvbnN0IGhhbmRsZVRvZ2dsZSA9IHVzZUNhbGxiYWNrKCgpOiB2b2lkID0+IHtcbiAgICBpZiAoaXNPcGVuU3RhdGUpIHtcbiAgICAgIGhhbmRsZUNsb3NlKCk7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGhhbmRsZU9wZW4oKTtcbiAgfSwgW2lzT3BlblN0YXRlLCBoYW5kbGVPcGVuLCBoYW5kbGVDbG9zZV0pO1xuXG4gIGNvbnN0IGhhbmRsZU1vdXNlRW50ZXIgPSB1c2VDYWxsYmFjaygoKTogdm9pZCA9PiB7XG4gICAgaWYgKG9wZW5PbkhvdmVyKSB7XG4gICAgICBoYW5kbGVPcGVuKCk7XG4gICAgfVxuICB9LCBbb3Blbk9uSG92ZXIsIGhhbmRsZU9wZW5dKTtcblxuICBjb25zdCBoYW5kbGVNb3VzZUxlYXZlID0gdXNlQ2FsbGJhY2soKCk6IHZvaWQgPT4ge1xuICAgIGlmIChvcGVuT25Ib3Zlcikge1xuICAgICAgaGFuZGxlQ2xvc2UoKTtcbiAgICB9XG4gIH0sIFtvcGVuT25Ib3ZlciwgaGFuZGxlQ2xvc2VdKTtcblxuICBjb25zdCBpc09wZW4gPSBCb29sZWFuKChpc09wZW5TdGF0ZSB8fCBmb3JjZU9wZW4pICYmICFmb3JjZUNsb3NlKTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICA8QnV0dG9uV3JhcHBlciByZWY9e2J1dHRvblJlZn0+XG4gICAgICAgIHsgcmVuZGVyT3BlbmVyKHtcbiAgICAgICAgICBpc09wZW4sXG4gICAgICAgICAgb25Ub2dnbGU6IGhhbmRsZVRvZ2dsZSxcbiAgICAgICAgICBvbk1vdXNlRW50ZXI6IGhhbmRsZU1vdXNlRW50ZXIsXG4gICAgICAgICAgb25Nb3VzZUxlYXZlOiBoYW5kbGVNb3VzZUxlYXZlLFxuICAgICAgICB9KSB9XG4gICAgICA8L0J1dHRvbldyYXBwZXI+XG4gICAgICB7IGlzT3BlbiAmJiAoXG4gICAgICAgIDxDU1NUcmFuc2l0aW9uXG4gICAgICAgICAgaW49e3JlZiAhPT0gbnVsbCAmJiBpc09wZW59XG4gICAgICAgICAgdGltZW91dD17MjAwfVxuICAgICAgICAgIGNsYXNzTmFtZXM9e3tcbiAgICAgICAgICAgIGVudGVyQWN0aXZlOiAnb3BlbicsXG4gICAgICAgICAgICBlbnRlckRvbmU6ICdvcGVuIG9wZW4tYWN0aXZlJyxcbiAgICAgICAgICAgIGFwcGVhckRvbmU6ICdvcGVuJyxcbiAgICAgICAgICAgIGV4aXQ6ICdleGl0aW5nJyxcbiAgICAgICAgICB9fVxuICAgICAgICA+XG4gICAgICAgICAgPENvbnRlbnRcbiAgICAgICAgICAgIHJlZj17c2V0UmVmfVxuICAgICAgICAgICAgc3R5bGU9e3tcbiAgICAgICAgICAgICAgLi4uc3R5bGVzWydwb3BwZXInXSxcbiAgICAgICAgICAgICAgLi4uY29udGVudFN0eWxlLFxuICAgICAgICAgICAgfX1cbiAgICAgICAgICAgIG9uTW91c2VFbnRlcj17aGFuZGxlTW91c2VFbnRlcn1cbiAgICAgICAgICAgIG9uTW91c2VMZWF2ZT17aGFuZGxlTW91c2VMZWF2ZX1cbiAgICAgICAgICAgIG9mZnNldD17b2Zmc2V0VG9wICsgYXJyb3cuaGVpZ2h0fVxuICAgICAgICAgICAgY2xhc3NOYW1lPXtzdGF0ZT8ucGxhY2VtZW50ID8/ICdhdXRvJ31cbiAgICAgICAgICAgIHsuLi5hdHRyaWJ1dGVzWydwb3BwZXInXX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICA8QXJyb3dcbiAgICAgICAgICAgICAgcmVmPXtzZXRBcnJvd1JlZn1cbiAgICAgICAgICAgICAgc3R5bGU9e3N0eWxlc1snYXJyb3cnXX1cbiAgICAgICAgICAgICAgcGxhY2VtZW50PXtzdGF0ZT8ucGxhY2VtZW50ID8/ICdhdXRvJ31cbiAgICAgICAgICAgICAgYXJyb3c9e2Fycm93fVxuICAgICAgICAgICAgICBkYXRhLXBvcHBlci1hcnJvd1xuICAgICAgICAgICAgICBjbGFzc05hbWU9e3N0YXRlPy5wbGFjZW1lbnR9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPENoaWxkcmVuV3JhcHBlciBzdHlsZT17c3R5bGVzWydvZmZzZXQnXX0+eyBjaGlsZHJlbiB9PC9DaGlsZHJlbldyYXBwZXI+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICA8L0NTU1RyYW5zaXRpb24+XG4gICAgICApIH1cbiAgICA8Lz5cbiAgKTtcbn07XG5cbmNvbnN0IEJ1dHRvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBsaW5lLWhlaWdodDogMDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuYDtcblxuLy8g7ZmU7IK07ZGcIO2MgeqzvCBDb250ZW50IOyYgeyXrSDsgqzsnbTsl5Ag66eI7Jqw7Iqk6rCAIOychOy5mO2VtOuPhCDsl7Trprwg7IOB7YOc66W8IOycoOyngO2VmOq4sCDsnITtlZwg66CI7J207Ja0XG5jb25zdCBjc3NCYWNrTGF5ZXIgPSBjc3NgXG4gIGNvbnRlbnQ6ICcnO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDA7XG5gO1xuXG5jb25zdCBDb250ZW50ID0gc3R5bGVkLmRpdjx7IG9mZnNldDogbnVtYmVyLCBwbGFjZW1lbnQ/OiBQbGFjZW1lbnQgfT5gXG4gIHotaW5kZXg6IDE7XG4gICZbZGF0YS1wb3BwZXItcGxhY2VtZW50Xj0nYm90dG9tJ10ge1xuICAgICY6YmVmb3JlIHtcbiAgICAgICR7Y3NzQmFja0xheWVyfVxuICAgICAgdG9wOiAkeyh7IG9mZnNldCB9KSA9PiBweFRvUmVtKC1vZmZzZXQpfTtcbiAgICB9XG4gIH1cbiAgJltkYXRhLXBvcHBlci1wbGFjZW1lbnRePSd0b3AnXSB7XG4gICAgJjpiZWZvcmUge1xuICAgICAgJHtjc3NCYWNrTGF5ZXJ9XG4gICAgICBib3R0b206ICR7KHsgb2Zmc2V0IH0pID0+IHB4VG9SZW0oLW9mZnNldCl9O1xuICAgIH1cbiAgfVxuICAmW2RhdGEtcG9wcGVyLXBsYWNlbWVudF49J3JpZ2h0J10ge1xuICAgICY6YmVmb3JlIHtcbiAgICAgICR7Y3NzQmFja0xheWVyfVxuICAgICAgbGVmdDogJHsoeyBvZmZzZXQgfSkgPT4gcHhUb1JlbSgtb2Zmc2V0KX07XG4gICAgfVxuICB9XG4gICZbZGF0YS1wb3BwZXItcGxhY2VtZW50Xj0nbGVmdCddIHtcbiAgICAmOmJlZm9yZSB7XG4gICAgICAke2Nzc0JhY2tMYXllcn1cbiAgICAgIHJpZ2h0OiAkeyh7IG9mZnNldCB9KSA9PiBweFRvUmVtKC1vZmZzZXQpfTtcbiAgICB9XG4gIH1cbiAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICBvcGFjaXR5OiAwO1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgJi5vcGVuIHtcbiAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgIG9wYWNpdHk6IDE7XG4gICAgdHJhbnNmb3JtOiBub25lO1xuICAgIHRyYW5zaXRpb246IDAuMnMgb3BhY2l0eSwgMC4ycyB0cmFuc2Zvcm07XG4gIH1cbiAgJi5vcGVuLWFjdGl2ZSB7XG4gICAgcG9pbnRlci1ldmVudHM6IGF1dG87XG4gIH1cbiAgJi5leGl0aW5nIHtcbiAgICB0cmFuc2l0aW9uOiB2aXNpYmlsaXR5IDAuMnMsIDAuMnMgb3BhY2l0eSwgMC4ycyB0cmFuc2Zvcm07XG4gIH1cbmA7XG5cbmNvbnN0IENoaWxkcmVuV3JhcHBlciA9IHN0eWxlZC5kaXZgYDtcblxuY29uc3QgZ2VuZXJhdGVBcnJvdyA9IChcbiAgcGxhY2VtZW50OiBQbGFjZW1lbnQsXG4gIGFycm93OiBBcnJvd1Byb3BzLFxuICB0aGVtZTogVGhlbWUsXG4pOiBTZXJpYWxpemVkU3R5bGVzID0+IHtcbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCdib3R0b20nKSkge1xuICAgIHJldHVybiBjc3NgXG4gICAgICBib3JkZXItYm90dG9tOiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX0gc29saWQgJHthcnJvdy5jb2xvcih0aGVtZSl9O1xuICAgICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGA7XG4gIH1cbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCd0b3AnKSkge1xuICAgIHJldHVybiBjc3NgXG4gICAgICBib3JkZXItdG9wOiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX0gc29saWQgJHthcnJvdy5jb2xvcih0aGVtZSl9O1xuICAgICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGA7XG4gIH1cbiAgaWYgKHBsYWNlbWVudC5zdGFydHNXaXRoKCdyaWdodCcpKSB7XG4gICAgcmV0dXJuIGNzc2BcbiAgICAgIGJvcmRlci1yaWdodDogJHtweFRvUmVtKGFycm93LmhlaWdodCl9IHNvbGlkICR7YXJyb3cuY29sb3IodGhlbWUpfTtcbiAgICAgIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICAgIGJvcmRlci10b3A6ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgICBgO1xuICB9XG4gIHJldHVybiBjc3NgXG4gICAgYm9yZGVyLWxlZnQ6ICR7cHhUb1JlbShhcnJvdy5oZWlnaHQpfSBzb2xpZCAke2Fycm93LmNvbG9yKHRoZW1lKX07XG4gICAgYm9yZGVyLXRvcDogJHtweFRvUmVtKGFycm93LndpZHRoIC8gMil9IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbShhcnJvdy53aWR0aCAvIDIpfSBzb2xpZCB0cmFuc3BhcmVudDtcbiAgYDtcbn07XG5cbmNvbnN0IEFycm93ID0gc3R5bGVkLmRpdjx7IHBsYWNlbWVudDogUGxhY2VtZW50LCBhcnJvdzogQXJyb3dQcm9wcyB9PmBcbiAgJHsoeyBhcnJvdyB9KSA9PiBhcnJvdyAmJlxuICAgIGBcbiAgICB3aWR0aDogJHtweFRvUmVtKGFycm93LndpZHRoKX07XG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oYXJyb3cuaGVpZ2h0KX07YH1cbiAgJHsoeyBhcnJvdyB9KSA9PiBgXG4gICAgJltjbGFzc149XCJib3R0b21cIl0ge1xuICAgICAgdG9wOiAke3B4VG9SZW0oLWFycm93LmhlaWdodCl9O1xuICAgIH1cbiAgICAmW2NsYXNzXj1cInRvcFwiXSB7XG4gICAgICBib3R0b206ICR7cHhUb1JlbSgtYXJyb3cuaGVpZ2h0KX07XG4gICAgfVxuICAgICZbY2xhc3NePVwicmlnaHRcIl0ge1xuICAgICAgbGVmdDogJHtweFRvUmVtKC1hcnJvdy5oZWlnaHQpfTtcbiAgICB9XG4gICAgJltjbGFzc149XCJsZWZ0XCJdIHtcbiAgICAgIHJpZ2h0OiAke3B4VG9SZW0oLWFycm93LmhlaWdodCl9O1xuICAgIH1cbiAgYH1cbiAgJjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAwO1xuICAgIGhlaWdodDogMDtcbiAgICBsZWZ0OiAwO1xuICAgICR7KHsgcGxhY2VtZW50LCBhcnJvdywgdGhlbWUgfSkgPT4gcGxhY2VtZW50ICYmIGdlbmVyYXRlQXJyb3cocGxhY2VtZW50LCBhcnJvdywgdGhlbWUpfVxuICB9XG5gO1xuIl19 */");
};
const Arrow$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au0"
} : {
  target: "et5x4au0",
  label: "Arrow"
})(({
  arrow
}) => arrow && `
    width: ${pxToRem(arrow.width)};
    height: ${pxToRem(arrow.height)};`, " ", ({
  arrow
}) => `
    &[class^="bottom"] {
      top: ${pxToRem(-arrow.height)};
    }
    &[class^="top"] {
      bottom: ${pxToRem(-arrow.height)};
    }
    &[class^="right"] {
      left: ${pxToRem(-arrow.height)};
    }
    &[class^="left"] {
      right: ${pxToRem(-arrow.height)};
    }
  `, " &:after{content:'';position:absolute;width:0;height:0;left:0;", ({
  placement,
  arrow,
  theme
}) => placement && generateArrow(placement, arrow, theme), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const useFilterTags = ({
  schema,
  query,
  onChangeQuery
}) => {
  const [tags, setTags] = useState([]);
  const serializeTags = useCallback(tags => schema.map(schemaEntry => schemaEntry.serializer.serialize).reduce((prev, serialize) => ({
    ...prev,
    ...serialize(tags)
  }), {}), [schema]);
  const deserializeTags = useCallback(() => schema.map(schemaEntry => schemaEntry.serializer.deserialize).reduce((prev, deserialize) => [...prev, ...deserialize(query)], []), [schema, query]);
  const handleChangeTags = useCallback(tags => {
    const queryParams = serializeTags(tags);
    onChangeQuery({
      ...omitBy(queryParams, value => value == null)
    });
    setTags(tags);
  }, [serializeTags, onChangeQuery]);
  useEffect(() => {
    setTags(deserializeTags());
  }, [query, deserializeTags]);
  return {
    handleChangeTags,
    tags
  };
};

const useFilterListModal = ({
  schema,
  tags,
  handleChangeTags
}) => {
  const [selectedEntryId, setSelectedEntryId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedEntryId(null);
  }, []);
  const activeEntry = schema.find(entry => entry.id === selectedEntryId);
  const isSelectedByQuery = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const showResetButton = activeEntry ? isSelectedByQuery(activeEntry) && activeEntry.config?.showResetButtonOnSelected?.mobile : schema.some(entry => isSelectedByQuery(entry) && entry.config?.showResetButtonOnSelected?.mobile);
  const reset = showResetButton ? () => {
    if (!activeEntry) {
      handleChangeTags([]);
    } else {
      handleChangeTags(tags.filter(tag => tag.id !== activeEntry.id));
    }
  } : undefined;
  return {
    reset,
    selectedEntryId,
    selectEntry: setSelectedEntryId,
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal
  };
};

const defaultLocaleData = {
  filter: '필터',
  reset: '초기화',
  apply: '확인',
  showAllFilter: '전체 필터 보기'
};
const LocaleDataContext = /*#__PURE__*/createContext(defaultLocaleData);
function LocaleDataProvider({
  children,
  data
}) {
  return jsx(LocaleDataContext.Provider, {
    value: data,
    children: children
  });
}
function useLocaleData() {
  return useContext(LocaleDataContext);
}

const FilterKey = {
  /** 다중 선택 리스트 필터 ex)스타일 필터 */
  MULTI_SELECT_LIST: 'multiSelectList',
  /** 단일 선택 리스트 필터 ex)정렬 필터 */
  SINGLE_SELECT_LIST: 'singleSelectList',
  /** 범위 선택 리스트 필터 ex)예산 필터 */
  RANGE: 'range',
  /** 중첩 필터 ex)지역 필터 */
  NESTED: 'nested',
  /** 여러 필터를 그룹으로 묶어서 선택할 수 있는 필터  */
  /** 동시에 여러 필터를 선택할 수 있는 그룹 필터 ex) 컬러 필터의 벽/바닥 컬러 필터 */
  MULTI_SELECT_GROUP: 'multiSelectGroup',
  /** 그룹 필터 중 한개의 필터만 선택할 수 있는 그룹 필터 ex)컬러 필터 */
  SINGLE_SELECT_GROUP: 'singleSelectGroup',
  /** 다중 색상 선택 필터 */
  MULTI_SELECT_COLOR: 'multiSelectColor',
  /** 단일 색상 선택 필터 */
  SINGLE_SELECT_COLOR: 'singleSelectColor'
};

const ListPanelDropdownItem = ({
  buttonText,
  caption,
  onClick,
  isActive
}) => {
  return jsxs(ItemButton$1, {
    type: "button",
    onClick: onClick,
    children: [jsx(Title$2, {
      isActive: isActive,
      children: buttonText
    }), jsx(Caption$1, {
      children: caption
    })]
  });
};
const ItemButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu2"
} : {
  target: "e1599rzu2",
  label: "ItemButton"
})("width:100%;max-width:", pxToRem(375), ";min-width:", pxToRem(200), ";display:block;padding:", pxToRem(13), " ", pxToRem(15), ";color:inherit;text-align:left;cursor:pointer;", ({
  theme
}) => HOVER$1`
    background: ${theme.interactive.primary1.transparent};
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RQYW5lbERyb3Bkb3duSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNkJnQyIsImZpbGUiOiJMaXN0UGFuZWxEcm9wZG93bkl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbnRlcmZhY2UgTGlzdFBhbmVsRHJvcGRvd25JdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIGNhcHRpb24/OiBzdHJpbmc7XG4gIG9uQ2xpY2s6ICgpID0+IHZvaWQ7XG4gIGlzQWN0aXZlOiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgTGlzdFBhbmVsRHJvcGRvd25JdGVtID0gKHtcbiAgYnV0dG9uVGV4dCxcbiAgY2FwdGlvbixcbiAgb25DbGljayxcbiAgaXNBY3RpdmUsXG59OiBMaXN0UGFuZWxEcm9wZG93bkl0ZW1Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPEl0ZW1CdXR0b24gdHlwZT1cImJ1dHRvblwiIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgICAgPFRpdGxlIGlzQWN0aXZlPXtpc0FjdGl2ZX0+eyBidXR0b25UZXh0IH08L1RpdGxlPlxuICAgICAgPENhcHRpb24+eyBjYXB0aW9uIH08L0NhcHRpb24+XG4gICAgPC9JdGVtQnV0dG9uPlxuICApO1xufTtcblxuY29uc3QgSXRlbUJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6ICR7cHhUb1JlbSgzNzUpfTtcbiAgbWluLXdpZHRoOiAke3B4VG9SZW0oMjAwKX07XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMTMpfSAke3B4VG9SZW0oMTUpfTtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgJHsoeyB0aGVtZSB9KSA9PiBIT1ZFUmBcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmludGVyYWN0aXZlLnByaW1hcnkxLnRyYW5zcGFyZW50fTtcbiAgYH1cbmA7XG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLnNwYW48eyBpc0FjdGl2ZT86IGJvb2xlYW4gfT5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuYm9keTFfc21hbGx9O1xuICBjb2xvcjogJHsoeyBpc0FjdGl2ZSwgdGhlbWUgfSkgPT4gaXNBY3RpdmUgPyB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljIDogJ2luaGVyaXQnfTtcbiAgZm9udC13ZWlnaHQ6ICR7KHsgaXNBY3RpdmUgfSkgPT4gKGlzQWN0aXZlID8gNzAwIDogNDAwKX07XG5gO1xuXG5jb25zdCBDYXB0aW9uID0gc3R5bGVkLnNwYW5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgbWFyZ2luOiAke3B4VG9SZW0oNSl9IDA7XG5gO1xuIl19 */"));
const Title$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu1"
} : {
  target: "e1599rzu1",
  label: "Title"
})("width:100%;", FONT_STYLE.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RQYW5lbERyb3Bkb3duSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkNpRCIsImZpbGUiOiJMaXN0UGFuZWxEcm9wZG93bkl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbnRlcmZhY2UgTGlzdFBhbmVsRHJvcGRvd25JdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIGNhcHRpb24/OiBzdHJpbmc7XG4gIG9uQ2xpY2s6ICgpID0+IHZvaWQ7XG4gIGlzQWN0aXZlOiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgTGlzdFBhbmVsRHJvcGRvd25JdGVtID0gKHtcbiAgYnV0dG9uVGV4dCxcbiAgY2FwdGlvbixcbiAgb25DbGljayxcbiAgaXNBY3RpdmUsXG59OiBMaXN0UGFuZWxEcm9wZG93bkl0ZW1Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPEl0ZW1CdXR0b24gdHlwZT1cImJ1dHRvblwiIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgICAgPFRpdGxlIGlzQWN0aXZlPXtpc0FjdGl2ZX0+eyBidXR0b25UZXh0IH08L1RpdGxlPlxuICAgICAgPENhcHRpb24+eyBjYXB0aW9uIH08L0NhcHRpb24+XG4gICAgPC9JdGVtQnV0dG9uPlxuICApO1xufTtcblxuY29uc3QgSXRlbUJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6ICR7cHhUb1JlbSgzNzUpfTtcbiAgbWluLXdpZHRoOiAke3B4VG9SZW0oMjAwKX07XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMTMpfSAke3B4VG9SZW0oMTUpfTtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgJHsoeyB0aGVtZSB9KSA9PiBIT1ZFUmBcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmludGVyYWN0aXZlLnByaW1hcnkxLnRyYW5zcGFyZW50fTtcbiAgYH1cbmA7XG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLnNwYW48eyBpc0FjdGl2ZT86IGJvb2xlYW4gfT5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuYm9keTFfc21hbGx9O1xuICBjb2xvcjogJHsoeyBpc0FjdGl2ZSwgdGhlbWUgfSkgPT4gaXNBY3RpdmUgPyB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljIDogJ2luaGVyaXQnfTtcbiAgZm9udC13ZWlnaHQ6ICR7KHsgaXNBY3RpdmUgfSkgPT4gKGlzQWN0aXZlID8gNzAwIDogNDAwKX07XG5gO1xuXG5jb25zdCBDYXB0aW9uID0gc3R5bGVkLnNwYW5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgbWFyZ2luOiAke3B4VG9SZW0oNSl9IDA7XG5gO1xuIl19 */"));
const Caption$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu0"
} : {
  target: "e1599rzu0",
  label: "Caption"
})("width:100%;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";margin:", pxToRem(5), " 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RQYW5lbERyb3Bkb3duSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0QyQiIsImZpbGUiOiJMaXN0UGFuZWxEcm9wZG93bkl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbnRlcmZhY2UgTGlzdFBhbmVsRHJvcGRvd25JdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIGNhcHRpb24/OiBzdHJpbmc7XG4gIG9uQ2xpY2s6ICgpID0+IHZvaWQ7XG4gIGlzQWN0aXZlOiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgTGlzdFBhbmVsRHJvcGRvd25JdGVtID0gKHtcbiAgYnV0dG9uVGV4dCxcbiAgY2FwdGlvbixcbiAgb25DbGljayxcbiAgaXNBY3RpdmUsXG59OiBMaXN0UGFuZWxEcm9wZG93bkl0ZW1Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPEl0ZW1CdXR0b24gdHlwZT1cImJ1dHRvblwiIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgICAgPFRpdGxlIGlzQWN0aXZlPXtpc0FjdGl2ZX0+eyBidXR0b25UZXh0IH08L1RpdGxlPlxuICAgICAgPENhcHRpb24+eyBjYXB0aW9uIH08L0NhcHRpb24+XG4gICAgPC9JdGVtQnV0dG9uPlxuICApO1xufTtcblxuY29uc3QgSXRlbUJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIHdpZHRoOiAxMDAlO1xuICBtYXgtd2lkdGg6ICR7cHhUb1JlbSgzNzUpfTtcbiAgbWluLXdpZHRoOiAke3B4VG9SZW0oMjAwKX07XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMTMpfSAke3B4VG9SZW0oMTUpfTtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgJHsoeyB0aGVtZSB9KSA9PiBIT1ZFUmBcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmludGVyYWN0aXZlLnByaW1hcnkxLnRyYW5zcGFyZW50fTtcbiAgYH1cbmA7XG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLnNwYW48eyBpc0FjdGl2ZT86IGJvb2xlYW4gfT5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuYm9keTFfc21hbGx9O1xuICBjb2xvcjogJHsoeyBpc0FjdGl2ZSwgdGhlbWUgfSkgPT4gaXNBY3RpdmUgPyB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljIDogJ2luaGVyaXQnfTtcbiAgZm9udC13ZWlnaHQ6ICR7KHsgaXNBY3RpdmUgfSkgPT4gKGlzQWN0aXZlID8gNzAwIDogNDAwKX07XG5gO1xuXG5jb25zdCBDYXB0aW9uID0gc3R5bGVkLnNwYW5gXG4gIHdpZHRoOiAxMDAlO1xuICAke0ZPTlRfU1RZTEUuY2FwdGlvbjF9O1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LmJhc2UyfTtcbiAgbWFyZ2luOiAke3B4VG9SZW0oNSl9IDA7XG5gO1xuIl19 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListPanelModalItem = ({
  buttonText,
  caption,
  isActive,
  onClick,
  icon
}) => {
  return jsxs(ItemButton, {
    type: "button",
    onClick: onClick,
    isActive: isActive,
    children: [jsxs(Right$2, {
      children: [jsx(Title$1, {
        isActive: isActive,
        children: buttonText
      }), caption && jsx(Caption, {
        children: caption
      })]
    }), jsx(IconWrapper$1, {
      children: icon
    })]
  });
};
const ItemButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc4"
} : {
  target: "e1tzdgxc4",
  label: "ItemButton"
})("width:100%;display:flex;justify-content:space-between;align-items:center;padding:", pxToRem(10), " ", pxToRem(13), ";background:", ({
  theme,
  isActive
}) => isActive ? theme.interactive.primary1.transparent : 'none', ";color:inherit;text-align:left;border-bottom:", pxToRem(1), " solid ", ({
  theme
}) => theme.border, ";", ({
  theme
}) => HOVER$1`
    background: ${theme.interactive.primary1.transparent};
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Right$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc3"
} : {
  target: "e1tzdgxc3",
  label: "Right"
})(process.env.NODE_ENV === "production" ? {
  name: "b936mu",
  styles: "flex-basis:max-content;flex-shrink:0"
} : {
  name: "b936mu",
  styles: "flex-basis:max-content;flex-shrink:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RQYW5lbE1vZGFsSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUR5QiIsImZpbGUiOiJMaXN0UGFuZWxNb2RhbEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbnRlcmZhY2UgTGlzdFBhbmVsTW9kYWxJdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xuICBjYXB0aW9uPzogc3RyaW5nO1xuICBpc0FjdGl2ZT86IGJvb2xlYW47XG4gIGljb24/OiBSZWFjdC5SZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBjb25zdCBMaXN0UGFuZWxNb2RhbEl0ZW0gPSAoe1xuICBidXR0b25UZXh0LFxuICBjYXB0aW9uLFxuICBpc0FjdGl2ZSxcbiAgb25DbGljayxcbiAgaWNvbixcbn06IExpc3RQYW5lbE1vZGFsSXRlbVByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgcmV0dXJuIChcbiAgICA8SXRlbUJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgb25DbGljaz17b25DbGlja30gaXNBY3RpdmU9e2lzQWN0aXZlfT5cbiAgICAgIDxSaWdodD5cbiAgICAgICAgPFRpdGxlIGlzQWN0aXZlPXtpc0FjdGl2ZX0+eyBidXR0b25UZXh0IH08L1RpdGxlPlxuICAgICAgICB7IGNhcHRpb24gJiYgPENhcHRpb24+eyBjYXB0aW9uIH08L0NhcHRpb24+IH1cbiAgICAgIDwvUmlnaHQ+XG4gICAgICA8SWNvbldyYXBwZXI+XG4gICAgICAgIHsgaWNvbiB9XG4gICAgICA8L0ljb25XcmFwcGVyPlxuICAgIDwvSXRlbUJ1dHRvbj5cbiAgKTtcbn07XG5cbmNvbnN0IEl0ZW1CdXR0b24gPSBzdHlsZWQuYnV0dG9uPHsgaXNBY3RpdmU/OiBib29sZWFuIH0+YFxuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMTApfSAke3B4VG9SZW0oMTMpfTtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSwgaXNBY3RpdmUgfSkgPT4gaXNBY3RpdmUgPyB0aGVtZS5pbnRlcmFjdGl2ZS5wcmltYXJ5MS50cmFuc3BhcmVudCA6ICdub25lJ307XG4gIGNvbG9yOiBpbmhlcml0O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBib3JkZXItYm90dG9tOiAke3B4VG9SZW0oMSl9IHNvbGlkICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYm9yZGVyfTtcbiAgJHsoeyB0aGVtZSB9KSA9PiBIT1ZFUmBcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmludGVyYWN0aXZlLnByaW1hcnkxLnRyYW5zcGFyZW50fTtcbiAgYH1cbmA7XG5cbmNvbnN0IFJpZ2h0ID0gc3R5bGVkLnNwYW5gXG4gIGZsZXgtYmFzaXM6IG1heC1jb250ZW50O1xuICBmbGV4LXNocmluazogMDtcbmA7XG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLnNwYW48eyBpc0FjdGl2ZT86IGJvb2xlYW4gfT5gXG4gICR7Rk9OVF9TVFlMRS5ib2R5MV9zbWFsbH07XG4gIGNvbG9yOiAkeyh7IGlzQWN0aXZlLCB0aGVtZSB9KSA9PiBpc0FjdGl2ZSA/IHRoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWMgOiAnaW5oZXJpdCd9O1xuICBmb250LXdlaWdodDogJHsoeyBpc0FjdGl2ZSB9KSA9PiAoaXNBY3RpdmUgPyA3MDAgOiA0MDApfTtcbmA7XG5cbmNvbnN0IENhcHRpb24gPSBzdHlsZWQuc3BhbmBcbiAgbWFyZ2luOiAke3B4VG9SZW0oNSl9IDA7XG4gICR7Rk9OVF9TVFlMRS5jYXB0aW9uMX07XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuYDtcblxuY29uc3QgSWNvbldyYXBwZXIgPSBzdHlsZWQuc3BhbmBcbiAgZmxleDogMTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
});
const Title$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc2"
} : {
  target: "e1tzdgxc2",
  label: "Title"
})(FONT_STYLE.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Caption = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc1"
} : {
  target: "e1tzdgxc1",
  label: "Caption"
})("margin:", pxToRem(5), " 0;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const IconWrapper$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc0"
} : {
  target: "e1tzdgxc0",
  label: "IconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "pezd64",
  styles: "flex:1;display:flex;justify-content:flex-end"
} : {
  name: "pezd64",
  styles: "flex:1;display:flex;justify-content:flex-end",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
});

const ListPanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleClickItem = value => {
    const newTag = {
      type: 'list',
      id: entry.id,
      value
    };
    const alreadySelectedTagIndex = tags.findIndex(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (alreadySelectedTagIndex !== -1) {
      onChangeTags(tags.filter((_, index) => alreadySelectedTagIndex !== index));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_LIST) {
      onChangeTags([...tags, newTag]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== newTag.id), newTag]);
  };

  /**
   * 쿼리 파라미터로 선택된 태그(tags)이거나 기본값으로 설정된 값인 경우 true를 반환
   */
  const isActiveItem = value => {
    const isSelected = tags.some(tag => tag.id === entry.id);
    if (!isSelected) {
      return entry.config?.defaultValue === value;
    }
    return tags.some(tag => tag.id === entry.id && tag.value === value);
  };
  const ListItem = isMobile ? ListPanelModalItem : ListPanelDropdownItem;
  return jsx(Fragment$1, {
    children: entry.options.map(option => jsx(ListItem, {
      buttonText: option.label,
      caption: option.caption,
      isActive: isActiveItem(option.value),
      onClick: () => handleClickItem(option.value)
    }, option.label))
  });
};

/**
 * 뉴턴-랩슨 방법을 사용하여 주어진 함수 `transform`이 목표 y 값 `yTarget`과 같아지도록 하는 x 값을 근사합니다.
 *
 * @param {function(number): number} transform - 근을 찾기 위한 함수.
 * @param {number} yTarget - 목표 y 값, 이 값에 해당하는 x 값을 찾고자 함.
 * @param {number} xStart - 초기 x 값 추정치.
 * @param {number} [iterations=30] - 최대 반복 횟수.
 * @param {number} [epsilon=1e-14] - 기울기의 허용 오차 (기울기가 이 값보다 작으면 반복을 중단).
 * @param {number} [tolerance=1e-7] - x 값 변화의 허용 오차 (변화가 이 값보다 작으면 반복을 중단).
 * @param {number} [derivateStep=1e-5] - 수치 미분을 위한 스텝 크기.
 * @returns {number} 근사된 x 값.
 */
function findApproximateValue(transform, yTarget, xStart, iterations = 30, epsilon = 1e-14, tolerance = 1e-7, derivateStep = 1e-5) {
  let xValue = xStart;
  for (let i = 0; i < iterations; ++i) {
    const yValue = transform(xValue) - yTarget;
    const ySlope = (transform(xValue + derivateStep) - transform(xValue)) / derivateStep;
    // 기울기가 너무 작아 계산할 수 없음.
    if (Math.abs(ySlope) < epsilon) {
      break;
    }
    const newXValue = xValue - yValue / ySlope;
    // 값이 범위 내에 있음; 반복을 종료.
    if (Math.abs(newXValue - xValue) <= tolerance * Math.abs(newXValue)) {
      break;
    }
    xValue = newXValue;
  }
  return xValue;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const RangeSliderInput = ({
  className,
  value,
  onChange,
  dual,
  min,
  max,
  left,
  right,
  projection = x => x,
  quantize = x => x,
  step = 1,
  'aria-label': ariaLabel = ''
}) => {
  const ref = useRef(null);
  const leftThumbRef = useRef(null);
  const rightThumbRef = useRef(null);
  const otherValueRef = useRef(null);
  const dualValueRef = useRef(dual ? value : null);
  const preventClickUntilRef = useRef(null);
  useEffect(() => {
    dualValueRef.current = dual ? value : null;
  }, [dual, value]);
  const projectValue = (value, fallback = 0) => {
    const leftmost = projection(min);
    const rightmost = projection(max);
    if (value == null) {
      return fallback;
    }
    return (projection(value) - leftmost) / (rightmost - leftmost);
  };
  const leftPos = dual ? projectValue(value && value.min, 0) : 0;
  const rightPos = dual ? projectValue(value && value.max, 1) : projectValue(value, 0.5);
  const leftValue = dual ? value && value.min : 0;
  const rightValue = dual ? value && value.max : value;
  const getNode = clientX => {
    if (ref.current == null) {
      return null;
    }
    if (!dual) {
      return rightThumbRef.current;
    }
    const bounds = ref.current.getBoundingClientRect();
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    if (actualPos > valueCenter) {
      return rightThumbRef.current;
    }
    return leftThumbRef.current;
  };
  const setPos = clientX => {
    if (ref.current == null) {
      return;
    }
    const bounds = ref.current.getBoundingClientRect();
    // Convert position to value using inverse function...
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;
    if (!dual) {
      const newValue = findApproximateValue(projection, actualPos, min);
      let recordedValue = newValue;
      if (quantize != null) {
        recordedValue = quantize(newValue);
      }
      if (Number.isNaN(recordedValue)) {
        return;
      }
      onChange(Math.min(Math.max(recordedValue, min), max));
      return;
    }

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    const newValue = findApproximateValue(projection, actualPos, min);
    let recordedValue = newValue;
    if (quantize != null) {
      recordedValue = quantize(newValue);
    }
    if (Number.isNaN(recordedValue)) {
      return;
    }
    if (otherValueRef.current == null) {
      otherValueRef.current = actualPos > valueCenter ? valueMin : valueMax;
    }
    onChange({
      min: Math.max(Math.min(otherValueRef.current, recordedValue), min),
      max: Math.min(Math.max(otherValueRef.current, recordedValue), max)
    });
  };
  const handleMouseDown = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null) {
        focusNode.focus();
      }
    }
    setPos(clientX);
    ['mousemove', 'touchmove'].forEach(type => window.addEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.addEventListener(type, handleMouseUp));
  };
  const handleMouseMove = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null && document.activeElement !== focusNode) {
        focusNode.focus();
      }
    }
    setPos(clientX);
  };
  const handleMouseUp = e => {
    if ('clientX' in e) {
      e.preventDefault();
    }
    otherValueRef.current = null;
    ['mousemove', 'touchmove'].forEach(type => window.removeEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.removeEventListener(type, handleMouseUp));
    preventClickUntilRef.current = Date.now() + 50;
    window.addEventListener('click', handleClickCapture, true);
  };
  const handleClickCapture = e => {
    if (preventClickUntilRef.current && Date.now() < preventClickUntilRef.current) {
      e.stopPropagation();
    }
    window.removeEventListener('click', handleClickCapture, true);
  };
  const handleKeyDown = (isMin, e) => {
    let currentValue;
    let edited = false;
    if (dual) {
      if (value == null) {
        currentValue = isMin ? min : max;
      } else {
        currentValue = value[isMin ? 'min' : 'max'];
      }
    } else {
      currentValue = value;
    }
    switch (e.code) {
      case 'ArrowDown':
      case 'ArrowLeft':
        {
          // Decrease
          e.preventDefault();
          currentValue -= step;
          edited = true;
          break;
        }
      case 'ArrowUp':
      case 'ArrowRight':
        {
          // Increase
          e.preventDefault();
          currentValue += step;
          edited = true;
          break;
        }
      case 'PageUp':
        {
          // Decrease many times
          e.preventDefault();
          currentValue -= step * 10;
          edited = true;
          break;
        }
      case 'PageDown':
        {
          // Increase many times
          e.preventDefault();
          currentValue += step * 10;
          edited = true;
          break;
        }
      case 'Home':
        {
          // Set to min
          e.preventDefault();
          currentValue = min;
          edited = true;
          break;
        }
      case 'End':
        {
          // Set to max
          e.preventDefault();
          currentValue = max;
          edited = true;
          break;
        }
    }
    if (edited) {
      currentValue = Math.min(Math.max(quantize(currentValue), min), max);
      if (dual) {
        if (isMin) {
          onChange({
            max: value?.max,
            min: Math.min(currentValue, value?.max)
          });
        } else {
          onChange({
            min: value?.min,
            max: Math.max(currentValue, value?.min)
          });
        }
      } else {
        onChange(currentValue);
      }
    }
  };
  return jsxs("div", {
    className: className,
    children: [jsxs(Container$a, {
      onMouseDown: e => handleMouseDown(e.nativeEvent),
      onTouchStart: e => handleMouseDown(e.nativeEvent),
      children: [jsx(Background, {}), jsxs(BarContainer, {
        ref: ref,
        children: [jsx(Bar, {
          dual: dual,
          style: {
            left: `${leftPos * 100}%`,
            width: `${(rightPos - leftPos) * 100}%`
          }
        }), dual && jsx(Thumb, {
          style: {
            left: `${leftPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": leftValue ?? min,
          "aria-label": `${ariaLabel} 최소`,
          ref: leftThumbRef,
          onKeyDown: e => handleKeyDown(true, e)
        }), jsx(Thumb, {
          style: {
            left: `${rightPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": rightValue ?? max,
          "aria-label": ariaLabel + (dual ? ' 최대' : ''),
          ref: rightThumbRef,
          onKeyDown: e => handleKeyDown(false, e)
        })]
      })]
    }), jsxs(Footer, {
      children: [jsx(FooterItem, {
        children: left
      }), jsx(FooterItem, {
        children: right
      })]
    })]
  });
};
const Container$a = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv6"
} : {
  target: "evasvfv6",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1ltp2go",
  styles: "position:relative;padding:7px 0;height:10px"
} : {
  name: "1ltp2go",
  styles: "position:relative;padding:7px 0;height:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const Background = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv5"
} : {
  target: "evasvfv5",
  label: "Background"
})(process.env.NODE_ENV === "production" ? {
  name: "cg6g99",
  styles: "position:absolute;top:7px;left:0;right:0;height:10px;border-radius:10px;background-color:#f5f5f5"
} : {
  name: "cg6g99",
  styles: "position:absolute;top:7px;left:0;right:0;height:10px;border-radius:10px;background-color:#f5f5f5",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const BarContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv4"
} : {
  target: "evasvfv4",
  label: "BarContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "xf71sx",
  styles: "position:absolute;top:7px;left:12px;right:12px;height:10px"
} : {
  name: "xf71sx",
  styles: "position:absolute;top:7px;left:12px;right:12px;height:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const Bar = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv3"
} : {
  target: "evasvfv3",
  label: "Bar"
})("position:absolute;height:10px;border-radius:10px;margin-left:", props => props.dual ? 0 : -12, "px;background-color:#c7effb;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Thumb = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv2"
} : {
  target: "evasvfv2",
  label: "Thumb"
})(process.env.NODE_ENV === "production" ? {
  name: "vvjryx",
  styles: "position:absolute;top:50%;margin:-12px 0 0 -12px;width:24px;height:24px;border-radius:100%;background-color:#35c5f0;transform:translateZ(0px);@media (hover: none){-webkit-tap-highlight-color:rgba(0, 0, 0, 0);&:active{background-color:#09addb;}}@media (hover: hover){&:hover,&:focus{background-color:#09addb;}}&:focus{outline:none;box-shadow:0 0 0 3px #6cd5f4;}"
} : {
  name: "vvjryx",
  styles: "position:absolute;top:50%;margin:-12px 0 0 -12px;width:24px;height:24px;border-radius:100%;background-color:#35c5f0;transform:translateZ(0px);@media (hover: none){-webkit-tap-highlight-color:rgba(0, 0, 0, 0);&:active{background-color:#09addb;}}@media (hover: hover){&:hover,&:focus{background-color:#09addb;}}&:focus{outline:none;box-shadow:0 0 0 3px #6cd5f4;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const Footer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv1"
} : {
  target: "evasvfv1",
  label: "Footer"
})(process.env.NODE_ENV === "production" ? {
  name: "rtxflr",
  styles: "display:flex;justify-content:space-between;margin-top:10px"
} : {
  name: "rtxflr",
  styles: "display:flex;justify-content:space-between;margin-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const FooterItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv0"
} : {
  target: "evasvfv0",
  label: "FooterItem"
})(process.env.NODE_ENV === "production" ? {
  name: "15buy4s",
  styles: "font-size:13px;color:#9e9e9e;line-height:16px"
} : {
  name: "15buy4s",
  styles: "font-size:13px;color:#9e9e9e;line-height:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});

const MULTIPLE_VALUE_SEPERATOR$1 = '^';
const createListTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR$1)
  };
};
const createListTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR$1) ?? [];
  return values.map(value => ({
    id,
    value,
    type: 'list'
  }));
};
const formatList = ({
  options,
  tag
}) => {
  const option = options.find(option => option.value === tag.value);
  if (option == null) {
    return '';
  }
  return option.label;
};
const createListSchema = ({
  type,
  label,
  id,
  options,
  config
}) => {
  const defaultTag = config?.defaultValue ? {
    id,
    value: config.defaultValue,
    type: 'list'
  } : null;
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: false,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createListTagSerializer(id),
      deserialize: createListTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.value !== config?.defaultValue,
    renderTag: tag => {
      if (tag.type !== 'list' || tag.id !== id || config?.defaultValue === tag.value) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    },
    renderSummary: (tag = defaultTag) => {
      if (!tag || tag.type !== 'list' || tag.id !== id) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    }
  };
};

const formatRange = ({
  range,
  unselectedText,
  unit
}) => {
  if (!range) {
    return unselectedText;
  }
  if (range.max == null && range.min == null) {
    return unselectedText;
  }
  if (range.max != null && range.min != null) {
    return `${range.min} - ${range.max}${unit}`;
  }
  if (range.min) {
    return `${range.min}${unit} 이상`;
  }
  return `${range.max}${unit} 이하`;
};

/**
 * targetRange가 range에 포함되었는지 여부를 반환합니다.
 */
const isInclude = ({
  range,
  targetRange
}) => {
  if (!range) {
    return false;
  }
  return (range.min == null || range.min <= targetRange.min) && (range.max == null || range.max >= targetRange.max);
};

/**
 * 기존 범위에 새로운 범위를 추가한 범위를 반환합니다.
 */
const addRange = ({
  range,
  newRange
}) => {
  if (range == null) {
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  return omitBy({
    min: range.min == null ? null : Math.min(newRange?.min, range.min),
    max: range.max == null ? null : Math.max(newRange?.max, range.max)
  }, v => v == null);
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 다음 옵션을 반환합니다.
 */
const findNextOption = (options, target) => {
  return options.find(option => option.value.min >= target.max)?.value;
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 이전 옵션을 반환합니다.
 */
const findPreviousOption = (options, target) => {
  return [...options].reverse().find(option => option.value.max <= target.min)?.value;
};

/**
 * 규칙
 * - 기존에 선택한 범위가 없을 때
 *   - 선택한 범위를 추가합니다.
 * - 기존에 선택한 범위가 있을 때
 *   - 기존 범위의 양쪽 끝 범위를 선택한 경우, 선택한 범위를 제외합니다.
 *   - 양쪽 끝이 아닌 범위를 선택한 경우, 선택한 범위만을 반환합니다(나머지 범위는 제거)
 * - 기존 범위 밖에 범위를 선택했을 때
 *   - 해당 범위까지 추가해줍니다.
 */
const getRange = ({
  currentRange,
  newRange,
  entry
}) => {
  const defaultMin = entry.config.range.min;
  const defaultMax = entry.config.range.max;
  const currentMin = currentRange == null || currentRange.min == null ? defaultMin : currentRange.min;
  const currentMax = currentRange == null || currentRange.max == null ? defaultMax : currentRange.max;
  if (currentRange != null && isInclude({
    range: currentRange,
    targetRange: newRange
  })) {
    const isSelectCurrentRange = currentMin === newRange.min && currentMax === newRange.max;
    if (isSelectCurrentRange) {
      return {
        min: defaultMin,
        max: defaultMax
      };
    }
    const result = {
      min: currentMin,
      max: currentMax
    };
    const isSelectFirstMin = currentMin === newRange.min;
    if (isSelectFirstMin) {
      const nextOption = findNextOption(entry.options, newRange);
      if (nextOption != null) {
        result.min = nextOption.min;
      } else {
        result.min = newRange.max ?? entry.config.range.max;
      }
      return result;
    }
    const isSelectLastMax = currentMax === newRange.max;
    if (isSelectLastMax) {
      result.max = newRange.min;
      const target = findPreviousOption(entry.options, newRange);
      if (target != null) {
        result.max = target.max;
      } else {
        result.max = newRange.min;
      }
      return result;
    }
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  const addedRange = addRange({
    range: currentRange,
    newRange
  });
  if (addedRange.min == null || addedRange.max == null) {
    if (addedRange.min === entry.config.range.min) {
      return {
        min: addedRange.min,
        max: entry.config.range.max
      };
    }
    if (addedRange.max === entry.config.range.max) {
      return {
        min: entry.config.range.min,
        max: addedRange.max
      };
    }
  }
  return addedRange;
};

const createRangeTagSerializer = id => tags => {
  const value = tags.find(v => v.id === id);
  if (value == null || value.type !== 'range') {
    return {};
  }
  const queryParams = {
    [`${id}_min`]: value.value.min != null ? String(value.value.min) : null,
    [`${id}_max`]: value.value.max != null ? String(value.value.max) : null
  };
  return omitBy(queryParams, isNil);
};
const createRangeTagDeserializer = id => query => {
  const minValue = parseFloat(query[`${id}_min`] ?? '');
  const maxValue = parseFloat(query[`${id}_max`] ?? '');
  if (isNaN(minValue) && isNaN(maxValue)) {
    return [];
  }
  return [{
    type: 'range',
    id,
    value: omitBy({
      min: minValue || null,
      max: maxValue || null
    }, isNil)
  }];
};
const createRangeSchema = ({
  type,
  label,
  id,
  config,
  options
}) => {
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: true,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createRangeTagSerializer(id),
      deserialize: createRangeTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.type === 'range' && !isEqual$2(tag.value, config.range),
    renderTag: tag => {
      if (tag.type !== 'range' || tag.id !== id) {
        return null;
      }
      return formatRange({
        range: isEqual$2(tag.value, config.range) ? null : tag.value,
        unselectedText: config.unselectedText,
        unit: config.unit
      });
    },
    renderSummary(tag) {
      if (!tag) {
        return null;
      }
      return this.renderTag(tag);
    }
  };
};

const createSerialize = converters => tags => {
  return converters.reduce((acc, converter) => ({
    ...acc,
    ...converter(tags)
  }), {});
};
const createDeserialize = converters => query => {
  return converters.map(converter => converter(query)).reduce((acc, tag) => [...acc, ...tag], []);
};
const createGroupSchema = ({
  id,
  schema,
  ...rest
}) => {
  return {
    id,
    schema,
    ...rest,
    serializer: {
      serialize: createSerialize(schema.map(entry => entry.serializer.serialize)),
      deserialize: createDeserialize(schema.map(entry => entry.serializer.deserialize))
    },
    hasTag: tag => schema.some(entry => entry.hasTag(tag)),
    renderTag: tag => schema.map(entry => entry.renderTag(tag)),
    renderSummary: tag => schema.map(entry => entry.renderSummary(tag))
  };
};

const DEFAULT_SIZE = 16;
const ColorIcon = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e66elua0"
} : {
  target: "e66elua0",
  label: "ColorIcon"
})("display:inline-flex;justify-content:center;align-items:center;width:", ({
  size
}) => pxToRem(size ?? DEFAULT_SIZE), ";height:", ({
  size
}) => pxToRem(size ?? DEFAULT_SIZE), ";background:", ({
  color
}) => color, ";box-sizing:border-box;border:", ({
  hasBorder,
  theme
}) => hasBorder ? `${pxToRem(1)} solid ${theme.border}` : 'none', ";border-radius:50%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbG9ySWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTJGIiwiZmlsZSI6IkNvbG9ySWNvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmNvbnN0IERFRkFVTFRfU0laRSA9IDE2O1xuXG5leHBvcnQgY29uc3QgQ29sb3JJY29uID0gc3R5bGVkLnNwYW48eyBjb2xvcjogc3RyaW5nLCBzaXplPzogbnVtYmVyLCBoYXNCb3JkZXI/OiBib29sZWFuIH0+YFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHdpZHRoOiAkeyh7IHNpemUgfSkgPT4gcHhUb1JlbShzaXplID8/IERFRkFVTFRfU0laRSl9O1xuICBoZWlnaHQ6ICR7KHsgc2l6ZSB9KSA9PiBweFRvUmVtKHNpemUgPz8gREVGQVVMVF9TSVpFKX07XG4gIGJhY2tncm91bmQ6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBib3JkZXI6ICR7KHsgaGFzQm9yZGVyLCB0aGVtZSB9KSA9PiBoYXNCb3JkZXIgPyBgJHtweFRvUmVtKDEpfSBzb2xpZCAke3RoZW1lLmJvcmRlcn1gIDogJ25vbmUnfTtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuYDtcbiJdfQ== */"));

const MULTIPLE_VALUE_SEPERATOR = '^';
const createColorTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR)
  };
};
const createColorTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR) ?? [];
  return values.map(value => ({
    id,
    value: Number(value),
    type: 'color'
  }));
};
const createColorSchema = ({
  id,
  config,
  options,
  type,
  label,
  ...rest
}) => {
  return {
    ...rest,
    type,
    id,
    label,
    options,
    serializer: {
      serialize: createColorTagSerializer(id),
      deserialize: createColorTagDeserializer(id)
    },
    hasTag: tag => tag.id === id,
    renderTag: tag => {
      if (tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 16,
        color: option.value.code,
        hasBorder: option.value.border
      });
    },
    renderSummary: tag => {
      if (!tag || tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 24,
        color: option.value.code,
        hasBorder: option.value.border
      });
    }
  };
};
const ColorIconContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1azwwbb0"
} : {
  target: "e1azwwbb0",
  label: "ColorIconContainer"
})("display:flex;align-items:center;gap:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const ButtonControl = ({
  entry,
  onChangeTags,
  tags
}) => {
  const currentRange = tags.find(tag => tag.id === entry.id);
  const handleClick = newRange => {
    if (currentRange && currentRange.type !== 'range') {
      return;
    }
    const range = getRange({
      currentRange: currentRange?.value,
      newRange,
      entry
    });
    onChangeTags(range);
  };
  return jsx(ButtonList, {
    children: entry.options.map(option => jsx(Button$2, {
      type: "button",
      isActive: isInclude({
        range: currentRange?.type === 'range' ? currentRange?.value : undefined,
        targetRange: option.value
      }),
      onClick: () => handleClick(option.value),
      children: option.label
    }, option.label))
  });
};
const ButtonList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ectpx291"
} : {
  target: "ectpx291",
  label: "ButtonList"
})("display:grid;grid-template-columns:repeat(4, 1fr);column-gap:", pxToRem(4), ";row-gap:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Button$2 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ectpx290"
} : {
  target: "ectpx290",
  label: "Button"
})("height:", pxToRem(40), ";", FONT_STYLE.body2_small, ";border-radius:", pxToRem(4), ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.white : theme.content.base1, ";background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : theme.content.base5, ";", ({
  theme,
  isActive
}) => HOVER$1`
    background: ${isActive ? '#09addb' : theme.interactive.base5};
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * max, min값이 default 값일 때 필드를 제거합니다.
 */
const convertRange = (range, defaultRange) => {
  const result = {
    min: range.min === defaultRange.min ? null : range.min,
    max: range.max === defaultRange.max ? null : range.max
  };
  if (result.min == null && result.max == null) {
    return null;
  }
  return omitBy(result, v => v == null);
};
const RangePanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const [sliderRange, setSliderRange] = useState(null);
  const {
    reset
  } = useLocaleData();
  const handleChangeTags = useCallback(value => {
    const newValue = convertRange(value, entry.config.range);
    if (newValue == null) {
      onChangeTags([...tags.filter(tag => tag.id !== entry.id)]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== entry.id), {
      id: entry.id,
      type: 'range',
      value: newValue
    }]);
  }, [entry, onChangeTags, tags]);
  const debouncedOnChange = useMemo(() => debounce$1(handleChangeTags, 500), [handleChangeTags]);
  const handleButtonClick = useCallback(handleChangeTags, [handleChangeTags]);
  const handleSliderClick = useCallback(({
    min,
    max
  }) => {
    const value = omitBy({
      min,
      max
    }, v => v == null);
    debouncedOnChange(value);
    if (entry.config.hasSliderInput) {
      setSliderRange(value);
    }
  }, [debouncedOnChange, entry]);
  const getRange = useCallback(() => {
    const tag = tags.find(tag => tag.id === entry.id);
    if (tag && tag.type !== 'range') {
      return null;
    }
    return tag?.value == null ? null : tag.value;
  }, [tags, entry]);
  useEffect(() => {
    const range = getRange();
    if (range == null) {
      setSliderRange(null);
    }
  }, [getRange]);
  const handleReset = () => {
    onChangeTags(tags.filter(tag => tag.id !== entry.id));
  };
  const currentStateText = () => {
    const range = entry.config.hasSliderInput && sliderRange ? sliderRange : getRange();
    return formatRange({
      range: range ? convertRange(range, entry.config.range) : null,
      unselectedText: entry.config.unselectedText,
      unit: entry.config.unit
    });
  };
  const isSelected = !!tags.find(tag => tag.id === entry.id);
  const isMobile = useResponsive().breakpoint === 'mobile';
  const range = sliderRange ?? getRange();
  return jsxs(Container$9, {
    children: [jsxs(Header$1, {
      children: [jsx(CurrentState, {
        children: currentStateText()
      }), isSelected && !isMobile && entry.config.showResetButtonOnSelected?.pc && jsx(ResetButton$3, {
        type: "button",
        onClick: handleReset,
        children: reset
      })]
    }), entry.config.hasSliderInput && jsx(StyledRangeSliderInput, {
      min: entry.config.range.min,
      max: entry.config.range.max,
      dual: true,
      value: {
        min: range?.min,
        max: range?.max
      },
      projection: v => v,
      quantize: v => Math.round(v),
      left: entry.config.rangeStartText,
      right: entry.config.rangeEndText,
      onChange: handleSliderClick
    }), jsx(ButtonControl, {
      entry: entry,
      onChangeTags: handleButtonClick,
      tags: tags
    })]
  });
};
const Container$9 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n4"
} : {
  target: "ek7ao1n4",
  label: "Container"
})("width:100%;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("width:", pxToRem(375), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " padding:", pxToRem(20), " ", pxToRem(15), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Header$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n3"
} : {
  target: "ek7ao1n3",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1066lcq",
  styles: "display:flex;justify-content:space-between;align-items:center"
} : {
  name: "1066lcq",
  styles: "display:flex;justify-content:space-between;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const ResetButton$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n2"
} : {
  target: "ek7ao1n2",
  label: "ResetButton"
})(FONT_STYLE.body1_small, ";color:", ({
  theme
}) => theme.content.primary1.basic, ";", HOVER$1`
    opacity: 0.5;
  `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const CurrentState = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n1"
} : {
  target: "ek7ao1n1",
  label: "CurrentState"
})("font-weight:700;", FONT_STYLE.title2, ";text-align:left;padding:", pxToRem(14), " 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledRangeSliderInput = /*#__PURE__*/_styled(RangeSliderInput, process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n0"
} : {
  target: "ek7ao1n0",
  label: "StyledRangeSliderInput"
})("margin-bottom:", pxToRem(38), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$k = process.env.NODE_ENV === "production" ? {
  name: "3lrvfj",
  styles: "vertical-align:bottom"
} : {
  name: "t1w8fb-ColorButton",
  styles: "vertical-align:bottom;label:ColorButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbG9yQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQmMiLCJmaWxlIjoiQ29sb3JCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgSWNvbiB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7IENvbG9ySWNvbiB9IGZyb20gJy4uLy4uLy4uL0NvbG9ySWNvbic7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29sb3JCdXR0b25Qcm9wc1xuICBleHRlbmRzIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxCdXR0b25FbGVtZW50PiB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgaXNDaGVja2VkOiBib29sZWFuO1xuICBiYWNrZ3JvdW5kOiB7XG4gICAgY29sb3I6IHN0cmluZyxcbiAgICBpc1doaXRpc2g6IGJvb2xlYW4sXG4gIH07XG59XG5cbmV4cG9ydCBjb25zdCBDb2xvckJ1dHRvbiA9ICh7XG4gIGlzQ2hlY2tlZCxcbiAgYmFja2dyb3VuZCxcbiAgLi4ucmVzdFxufTogQ29sb3JCdXR0b25Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbG9ySWNvblxuICAgICAgY29sb3I9e2JhY2tncm91bmQuY29sb3J9XG4gICAgICBoYXNCb3JkZXI9e2JhY2tncm91bmQuaXNXaGl0aXNofVxuICAgICAgYXM9XCJidXR0b25cIlxuICAgICAgc2l6ZT17MjR9XG4gICAgICBjc3M9e2Nzc2BcbiAgICAgICAgdmVydGljYWwtYWxpZ246IGJvdHRvbTtcbiAgICAgIGB9XG4gICAgICB7Li4ucmVzdH1cbiAgICA+XG4gICAgICB7IGlzQ2hlY2tlZCAmJiAoXG4gICAgICAgIDxJY29uXG4gICAgICAgICAgbmFtZT1cImNoZWNrX3RoaWNrXCJcbiAgICAgICAgICBzaXplPXsxNn1cbiAgICAgICAgICBmaWxsPXsodGhlbWUpID0+IGJhY2tncm91bmQuaXNXaGl0aXNoID8gdGhlbWUuY29udGVudC5iYXNlMSA6IHRoZW1lLmNvbnRlbnQud2hpdGV9XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICA8L0NvbG9ySWNvbj5cbiAgKTtcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};
const ColorButton = ({
  isChecked,
  background,
  ...rest
}) => {
  return jsx(ColorIcon, {
    color: background.color,
    hasBorder: background.isWhitish,
    as: "button",
    size: 24,
    css: _ref$k,
    ...rest,
    children: isChecked && jsx(Icon$1, {
      name: "check_thick",
      size: 16,
      fill: theme => background.isWhitish ? theme.content.base1 : theme.content.white
    })
  });
};

const ColorPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const handleClick = optionValue => {
    const newTag = {
      id: entry.id,
      type: 'color',
      value: optionValue.search
    };
    const isAlreadySelected = tags.some(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (isAlreadySelected) {
      onChangeTags(tags.filter(tag => !(tag.id === newTag.id && tag.value === newTag.value)));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_COLOR) {
      onChangeTags([newTag, ...tags]);
      return;
    }
    onChangeTags([newTag, ...tags.filter(tag => tag.id !== newTag.id)]);
  };
  return jsxs(Fragment$1, {
    children: [entry.label && jsx(Label, {
      children: entry.label
    }), jsx(List, {
      children: entry.options.map(option => jsx(StyledColorButton, {
        background: {
          color: option.value.code,
          isWhitish: !!option.value.border
        },
        isChecked: !!tags.find(tag => {
          return tag.id === entry.id && tag.value === option.value.search;
        }),
        onClick: () => {
          handleClick(option.value);
        }
      }, option.label))
    })]
  });
};
const List = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqyadn62"
} : {
  target: "eqyadn62",
  label: "List"
})("min-height:", pxToRem(50), ";padding:", pxToRem(5), " ", pxToRem(10), ";box-sizing:content-box;white-space:nowrap;overflow-x:auto;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledColorButton = /*#__PURE__*/_styled(ColorButton, process.env.NODE_ENV === "production" ? {
  target: "eqyadn61"
} : {
  target: "eqyadn61",
  label: "StyledColorButton"
})("margin:", pxToRem(5), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Label = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eqyadn60"
} : {
  target: "eqyadn60",
  label: "Label"
})("padding:", pxToRem(5), " ", pxToRem(15), ";", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const renderSinglePanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_LIST:
    case FilterKey.SINGLE_SELECT_LIST:
      return jsx(ListPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.RANGE:
      return jsx(RangePanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.MULTI_SELECT_COLOR:
    case FilterKey.SINGLE_SELECT_COLOR:
      return jsx(ColorPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return null;
  }
};
const SinglePanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Fragment$1, {
    children: renderSinglePanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

const getIdsInGroup = entry => {
  if (entry.type !== FilterKey.SINGLE_SELECT_GROUP && entry.type !== FilterKey.MULTI_SELECT_GROUP) {
    return [entry.id];
  }
  return entry.schema.map(entry => getIdsInGroup(entry)).reduce((acc, ids) => [...acc, ...ids], []);
};
const GroupPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const [activeGroupId, setActiveGroupId] = useState(null);
  const idListInGroup = getIdsInGroup(entry);
  const selectedGroupId = tags.find(tag => idListInGroup.includes(tag.id))?.id;
  const resetAllGroupTags = () => {
    if (!selectedGroupId) {
      return;
    }
    onChangeTags(tags.filter(tag => !idListInGroup.includes(tag.id)));
  };
  const isActiveGroup = entry => {
    if (activeGroupId) {
      return entry.id === activeGroupId;
    }
    return !!(selectedGroupId && getIdsInGroup(entry).includes(selectedGroupId));
  };
  if (entry.type === FilterKey.SINGLE_SELECT_GROUP) {
    return jsx(Fragment$1, {
      children: entry.schema.map(subEntry => jsxs(React__default.Fragment, {
        children: [jsxs(ExpanderController, {
          children: [jsx("span", {
            children: subEntry.label
          }), jsx(Toggle, {
            checked: isActiveGroup(subEntry),
            onCheck: checked => {
              setActiveGroupId(checked ? subEntry.id : null);
              resetAllGroupTags();
            }
          })]
        }), jsx(Expander, {
          isExpanded: isActiveGroup(subEntry),
          children: jsx(SinglePanel, {
            entry: {
              ...subEntry,
              label: subEntry.type === FilterKey.SINGLE_SELECT_GROUP || subEntry.type === FilterKey.MULTI_SELECT_GROUP ? subEntry.label : ''
            },
            onChangeTags: onChangeTags,
            tags: tags
          })
        })]
      }, subEntry.id))
    });
  }
  return jsx(Fragment$1, {
    children: entry.schema.map(entry => jsx(SinglePanel, {
      entry: entry,
      onChangeTags: onChangeTags,
      tags: tags
    }, entry.id))
  });
};
const ExpanderController = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekqfg9x1"
} : {
  target: "ekqfg9x1",
  label: "ExpanderController"
})(FONT_STYLE.body1_small, ";display:flex;justify-content:space-between;align-items:center;padding:", pxToRem(10.5), " ", pxToRem(15), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Expander = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekqfg9x0"
} : {
  target: "ekqfg9x0",
  label: "Expander"
})("height:", ({
  isExpanded
}) => isExpanded ? 'fit-content' : 0, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const renderPanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_GROUP:
    case FilterKey.SINGLE_SELECT_GROUP:
      return jsx(GroupPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return jsx(SinglePanel, {
        ...props
      });
  }
};
const Panel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Container$8, {
    children: renderPanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

// TODO
// InfoTip backlayer 수정 후 스타일 제거
const Container$8 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gi3ci50"
} : {
  target: "e1gi3ci50",
  label: "Container"
})("position:relative;z-index:1;text-align:start;max-height:", pxToRem(425), ";overflow:auto;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQzRCIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgRmlsdGVyS2V5LCBTY2hlbWFFbnRyeSwgVGFnIH0gZnJvbSAnLi4vdHlwZSc7XG5pbXBvcnQgeyBHcm91cFBhbmVsIH0gZnJvbSAnLi9Hcm91cFBhbmVsJztcbmltcG9ydCB7IFNpbmdsZVBhbmVsIH0gZnJvbSAnLi9TaW5nbGVQYW5lbCc7XG5cbmludGVyZmFjZSBSZW5kZXJQYW5lbFByb3BzIHtcbiAgZW50cnk6IFNjaGVtYUVudHJ5O1xuICBvbkNoYW5nZVRhZ3M6ICh0YWdzOiBUYWdbXSkgPT4gdm9pZDtcbiAgdGFnczogVGFnW107XG59XG5cbmNvbnN0IHJlbmRlclBhbmVsID0gKHByb3BzOiBSZW5kZXJQYW5lbFByb3BzKTogUmVhY3QuUmVhY3RFbGVtZW50IHwgbnVsbCA9PiB7XG4gIHN3aXRjaCAocHJvcHMuZW50cnkudHlwZSkge1xuICAgIGNhc2UgRmlsdGVyS2V5Lk1VTFRJX1NFTEVDVF9HUk9VUDpcbiAgICBjYXNlIEZpbHRlcktleS5TSU5HTEVfU0VMRUNUX0dST1VQOlxuICAgICAgcmV0dXJuIDxHcm91cFBhbmVsIHsuLi5wcm9wc30gZW50cnk9e3Byb3BzLmVudHJ5fSB0YWdzPXtwcm9wcy50YWdzfSAvPjtcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIDxTaW5nbGVQYW5lbCB7Li4ucHJvcHN9IC8+O1xuICB9XG59O1xuXG5leHBvcnQgY29uc3QgUGFuZWwgPSAoe1xuICBlbnRyeSxcbiAgb25DaGFuZ2VUYWdzLFxuICB0YWdzLFxufTogUmVuZGVyUGFuZWxQcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiA8Q29udGFpbmVyPnsgcmVuZGVyUGFuZWwoeyBlbnRyeSwgb25DaGFuZ2VUYWdzLCB0YWdzIH0pIH08L0NvbnRhaW5lcj47XG59O1xuXG4vLyBUT0RPXG4vLyBJbmZvVGlwIGJhY2tsYXllciDsiJjsoJUg7ZuEIOyKpO2DgOydvCDsoJzqsbBcbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgei1pbmRleDogMTtcbiAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gIG1heC1oZWlnaHQ6ICR7cHhUb1JlbSg0MjUpfTtcbiAgb3ZlcmZsb3c6IGF1dG87XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQuYmFzZTF9O1xuYDtcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const homeTransitionStyles = {
  entering: {
    opacity: 1,
    transition: 'opacity 0.2s'
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0,
    transition: 'opacity 0.2s'
  },
  exited: {
    opacity: 0
  }
};
const pageTransitionStyles = {
  entering: {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  entered: {
    opacity: 1,
    transform: 'translateX(0)'
  },
  exiting: {
    opacity: 0,
    transform: 'translateX(50px)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  exited: {
    opacity: 0,
    transform: 'translateX(50px)'
  }
};
const PageWithFadeTransition = ({
  children,
  isHome,
  show
}) => {
  const transitionStyles = isHome ? homeTransitionStyles : pageTransitionStyles;
  const ref = useRef(null);
  return jsx(Transition$1, {
    in: show,
    timeout: 200,
    unmountOnExit: true,
    nodeRef: ref,
    children: state => {
      return jsx(Content, {
        ref: ref,
        style: transitionStyles[state],
        children: children
      });
    }
  });
};
const Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eq9zchc0"
} : {
  target: "eq9zchc0",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%"
} : {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BaseModal = ({
  actionLeft,
  title,
  actionRight,
  onClose,
  isStartToClose,
  children,
  ...rest
}) => {
  return jsx(StyledModal$1, {
    ...rest,
    width: 400,
    height: "440px",
    hasInteraction: true,
    disableBackgroundScroll: true,
    isStartToClose: isStartToClose,
    onBlur: onClose,
    children: jsxs(Container$7, {
      children: [jsxs(Header, {
        children: [jsx(HeaderLeft, {
          children: actionLeft
        }), title, jsx(HeaderRight, {
          children: actionRight
        })]
      }), jsx(Body, {
        children: children
      })]
    })
  });
};
const slideUp = keyframes`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
`;
const StyledModal$1 = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => prop !== 'isStartToClose',
  target: "e14xlalu5"
} : {
  shouldForwardProp: prop => prop !== 'isStartToClose',
  target: "e14xlalu5",
  label: "StyledModal"
})("opacity:", ({
  isStartToClose
}) => isStartToClose ? '0' : '1', ";transition:all .25s ease-out;>div{transform:", ({
  isStartToClose
}) => isStartToClose ? 'translateY(100px)' : 'none', ";transition:all .25s ease-out;animation:", slideUp, " .25s ease-out;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Container$7 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu4"
} : {
  target: "e14xlalu4",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1lghw08",
  styles: "position:relative;width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column"
} : {
  name: "1lghw08",
  styles: "position:relative;width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
const Body = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu3"
} : {
  target: "e14xlalu3",
  label: "Body"
})("flex:1;position:relative;overflow-x:hidden;overflow-y:scroll;margin-bottom:", pxToRem(-1), ";margin-top:", pxToRem(1), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Header = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu2"
} : {
  target: "e14xlalu2",
  label: "Header"
})("position:relative;", FONT_STYLE.title4, ";font-weight:700;padding:", pxToRem(10), " 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const HeaderLeft = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu1"
} : {
  target: "e14xlalu1",
  label: "HeaderLeft"
})("position:absolute;top:0;left:0;padding-left:", pxToRem(20.5), ";height:100%;display:flex;align-items:center;font-weight:400;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const HeaderRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu0"
} : {
  target: "e14xlalu0",
  label: "HeaderRight"
})("position:absolute;top:0;right:0;height:100%;padding-right:", pxToRem(15.5), ";display:flex;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MenuModal = ({
  menu,
  home,
  currentMenuKey,
  onChangeMenuKey,
  onClose,
  actions,
  ...rest
}) => {
  const showHome = currentMenuKey == null;
  const currentMenuItem = menu.find(item => item.key === currentMenuKey) ?? home;
  const handleBack = !showHome ? () => onChangeMenuKey?.(null) : undefined;
  return jsxs(BaseModal, {
    ...rest,
    actionLeft: handleBack && jsx(BackButton, {
      type: "button",
      onClick: handleBack,
      children: jsx(Icon$1, {
        name: "arrow_left",
        size: 24
      })
    }),
    actionRight: actions,
    title: currentMenuItem.label,
    onClose: onClose,
    children: [jsx(PageWithFadeTransition, {
      isHome: true,
      show: showHome,
      children: home.content
    }), menu.map(item => jsx(PageWithFadeTransition, {
      show: item.key === currentMenuKey,
      children: item.content
    }, item.key))]
  });
};
const BackButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1yjndi0"
} : {
  target: "e1yjndi0",
  label: "BackButton"
})(process.env.NODE_ENV === "production" ? {
  name: "opde7s",
  styles: "color:inherit"
} : {
  name: "opde7s",
  styles: "color:inherit",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});

const FilterTag = ({
  onClick,
  showDeleteIcon = true,
  children
}) => {
  return jsxs(TagButton, {
    onClick: onClick,
    children: [children, showDeleteIcon && jsx(DeleteIcon, {
      size: 16
    })]
  });
};
const TagButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e6u93a41"
} : {
  target: "e6u93a41",
  label: "TagButton"
})("display:flex;align-items:center;height:", pxToRem(24), ";padding:", pxToRem(1), " ", pxToRem(8), " ", pxToRem(3), ";background-color:", ({
  theme
}) => theme.content.primary1.basic, ";color:", ({
  theme
}) => theme.content.white, ";font-size:", pxToRem(15), ";font-weight:700;line-height:", pxToRem(18), ";border-radius:", pxToRem(26), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlclRhZy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0IrQiIsImZpbGUiOiJGaWx0ZXJUYWcudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBEaXNtaXNzQ2lyY2xlSWNvbiwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgRmlsdGVyVGFnUHJvcHMge1xuICBvbkNsaWNrOiAoKSA9PiB2b2lkO1xuICBzaG93RGVsZXRlSWNvbj86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBjb25zdCBGaWx0ZXJUYWcgPSAoe1xuICBvbkNsaWNrLFxuICBzaG93RGVsZXRlSWNvbiA9IHRydWUsXG4gIGNoaWxkcmVuLFxufTogUHJvcHNXaXRoQ2hpbGRyZW48RmlsdGVyVGFnUHJvcHM+KTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgcmV0dXJuIChcbiAgICA8VGFnQnV0dG9uIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgICAgeyBjaGlsZHJlbiB9XG4gICAgICB7IHNob3dEZWxldGVJY29uICYmIDxEZWxldGVJY29uIHNpemU9ezE2fSAvPiB9XG4gICAgPC9UYWdCdXR0b24+XG4gICk7XG59O1xuXG5jb25zdCBUYWdCdXR0b24gPSBzdHlsZWQuYnV0dG9uYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSgyNCl9O1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMSl9ICR7cHhUb1JlbSg4KX0gJHtweFRvUmVtKDMpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC53aGl0ZX07XG4gIGZvbnQtc2l6ZTogJHtweFRvUmVtKDE1KX07XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGxpbmUtaGVpZ2h0OiAke3B4VG9SZW0oMTgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDI2KX07XG5gO1xuXG5jb25zdCBEZWxldGVJY29uID0gc3R5bGVkKERpc21pc3NDaXJjbGVJY29uKWBcbiAgbWFyZ2luOiAwICR7cHhUb1JlbSgtNCl9IDAgJHtweFRvUmVtKDcpfTtcbiAgdmVydGljYWwtYWxpZ246ICR7cHhUb1JlbSgtMSl9O1xuYDtcbiJdfQ== */"));
const DeleteIcon = /*#__PURE__*/_styled(DismissCircleIcon, process.env.NODE_ENV === "production" ? {
  target: "e6u93a40"
} : {
  target: "e6u93a40",
  label: "DeleteIcon"
})("margin:0 ", pxToRem(-4), " 0 ", pxToRem(7), ";vertical-align:", pxToRem(-1), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlclRhZy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUM0QyIsImZpbGUiOiJGaWx0ZXJUYWcudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBEaXNtaXNzQ2lyY2xlSWNvbiwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgRmlsdGVyVGFnUHJvcHMge1xuICBvbkNsaWNrOiAoKSA9PiB2b2lkO1xuICBzaG93RGVsZXRlSWNvbj86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBjb25zdCBGaWx0ZXJUYWcgPSAoe1xuICBvbkNsaWNrLFxuICBzaG93RGVsZXRlSWNvbiA9IHRydWUsXG4gIGNoaWxkcmVuLFxufTogUHJvcHNXaXRoQ2hpbGRyZW48RmlsdGVyVGFnUHJvcHM+KTogUmVhY3QuUmVhY3RFbGVtZW50ID0+IHtcbiAgcmV0dXJuIChcbiAgICA8VGFnQnV0dG9uIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgICAgeyBjaGlsZHJlbiB9XG4gICAgICB7IHNob3dEZWxldGVJY29uICYmIDxEZWxldGVJY29uIHNpemU9ezE2fSAvPiB9XG4gICAgPC9UYWdCdXR0b24+XG4gICk7XG59O1xuXG5jb25zdCBUYWdCdXR0b24gPSBzdHlsZWQuYnV0dG9uYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSgyNCl9O1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMSl9ICR7cHhUb1JlbSg4KX0gJHtweFRvUmVtKDMpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29udGVudC53aGl0ZX07XG4gIGZvbnQtc2l6ZTogJHtweFRvUmVtKDE1KX07XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGxpbmUtaGVpZ2h0OiAke3B4VG9SZW0oMTgpfTtcbiAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDI2KX07XG5gO1xuXG5jb25zdCBEZWxldGVJY29uID0gc3R5bGVkKERpc21pc3NDaXJjbGVJY29uKWBcbiAgbWFyZ2luOiAwICR7cHhUb1JlbSgtNCl9IDAgJHtweFRvUmVtKDcpfTtcbiAgdmVydGljYWwtYWxpZ246ICR7cHhUb1JlbSgtMSl9O1xuYDtcbiJdfQ== */"));

const findTagLabel = (schema, tag) => {
  return schema.reduce((result, entry) => {
    if (result) {
      return result;
    }
    if (entry.type === 'multiSelectGroup' || entry.type === 'singleSelectGroup') {
      return findTagLabel(entry.schema, tag);
    }
    return entry.renderTag(tag);
  }, null);
};
const FilterTagList = ({
  className,
  handleChangeTags,
  tags,
  schema: schemaList
}) => {
  const {
    reset
  } = useLocaleData();
  const isMobile = useResponsive().breakpoint === 'mobile';
  const hideResetButton = useMemo(() => {
    return tags.length <= 1 && tags.some(tag => {
      return schemaList.some(schema => {
        if (schema.type === 'multiSelectList' || schema.type === 'singleSelectList') {
          return schema.config?.defaultValue === tag.value;
        }
        return false;
      });
    });
  }, [schemaList, tags]);
  return jsxs(ListContainer, {
    className: className,
    children: [tags.map((tag, index) => findTagLabel(schemaList, tag) == null ? null : jsx(FilterTagListItem, {
      children: jsx(FilterTag, {
        onClick: () => handleChangeTags(tags.filter((_, i) => i !== index)),
        children: findTagLabel(schemaList, tag)
      })
    }, `${tag.id}-${JSON.stringify(tag.value)}`)), !isMobile && !hideResetButton && jsx(FilterTagListItem, {
      children: jsx(ResetButton$2, {
        type: "button",
        onClick: () => handleChangeTags([]),
        children: reset
      })
    })]
  });
};
const ListContainer = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz2"
} : {
  target: "e1pjrndz2",
  label: "ListContainer"
})("display:flex;flex-wrap:wrap;gap:", pxToRem(4), ";list-style:none;padding:", pxToRem(5), " 0;white-space:nowrap;overflow:auto;", MEDIA_QUERY.max('tablet', /*#__PURE__*/css("margin:0 ", pxToRem(-15), ";padding:", pxToRem(5), " ", pxToRem(15), ";flex-wrap:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:ListContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const FilterTagListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz1"
} : {
  target: "e1pjrndz1",
  label: "FilterTagListItem"
})("padding:", pxToRem(2), " 0;&>button{border:", pxToRem(1), " solid transparent;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlclRhZ0xpc3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlGbUMiLCJmaWxlIjoiRmlsdGVyVGFnTGlzdC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHtcbiAgTUVESUFfUVVFUlksXG4gIHB4VG9SZW0sXG4gIHVzZVJlc3BvbnNpdmUsXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgU2NoZW1hRW50cnksIFRhZyB9IGZyb20gJy4vdHlwZSc7XG5pbXBvcnQgeyBGaWx0ZXJUYWcgfSBmcm9tICcuL0ZpbHRlclRhZyc7XG5pbXBvcnQgeyB1c2VMb2NhbGVEYXRhIH0gZnJvbSAnLi9jb250ZXh0JztcblxuaW50ZXJmYWNlIEZpbHRlclRhZ0xpc3RQcm9wcyB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbiAgaGFuZGxlQ2hhbmdlVGFnczogKHRhZ3M6IFRhZ1tdKSA9PiB2b2lkO1xuICB0YWdzOiBUYWdbXTtcbiAgc2NoZW1hOiBTY2hlbWFFbnRyeVtdO1xufVxuXG5jb25zdCBmaW5kVGFnTGFiZWwgPSAoc2NoZW1hOiBTY2hlbWFFbnRyeVtdLCB0YWc6IFRhZyk6IFJlYWN0LlJlYWN0Tm9kZSA9PiB7XG4gIHJldHVybiBzY2hlbWEucmVkdWNlKChyZXN1bHQ6IFJlYWN0LlJlYWN0Tm9kZSwgZW50cnk6IFNjaGVtYUVudHJ5KSA9PiB7XG4gICAgaWYgKHJlc3VsdCkgeyByZXR1cm4gcmVzdWx0OyB9XG4gICAgaWYgKGVudHJ5LnR5cGUgPT09ICdtdWx0aVNlbGVjdEdyb3VwJyB8fCBlbnRyeS50eXBlID09PSAnc2luZ2xlU2VsZWN0R3JvdXAnKSB7IHJldHVybiBmaW5kVGFnTGFiZWwoZW50cnkuc2NoZW1hLCB0YWcpOyB9XG4gICAgcmV0dXJuIGVudHJ5LnJlbmRlclRhZyh0YWcpO1xuICB9LCBudWxsKTtcbn07XG5cbmV4cG9ydCBjb25zdCBGaWx0ZXJUYWdMaXN0ID0gKHtcbiAgY2xhc3NOYW1lLFxuICBoYW5kbGVDaGFuZ2VUYWdzLFxuICB0YWdzLFxuICBzY2hlbWE6IHNjaGVtYUxpc3QsXG59OiBGaWx0ZXJUYWdMaXN0UHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgfCBudWxsID0+IHtcbiAgY29uc3QgeyByZXNldCB9ID0gdXNlTG9jYWxlRGF0YSgpO1xuICBjb25zdCBpc01vYmlsZSA9IHVzZVJlc3BvbnNpdmUoKS5icmVha3BvaW50ID09PSAnbW9iaWxlJztcbiAgY29uc3QgaGlkZVJlc2V0QnV0dG9uID0gdXNlTWVtbygoKSA9PiB7XG4gICAgcmV0dXJuIHRhZ3MubGVuZ3RoIDw9IDEgJiYgdGFncy5zb21lKCh0YWcpID0+IHtcbiAgICAgIHJldHVybiBzY2hlbWFMaXN0LnNvbWUoKHNjaGVtYSkgPT4ge1xuICAgICAgICBpZiAoc2NoZW1hLnR5cGUgPT09ICdtdWx0aVNlbGVjdExpc3QnIHx8IHNjaGVtYS50eXBlID09PSAnc2luZ2xlU2VsZWN0TGlzdCcpIHtcbiAgICAgICAgICByZXR1cm4gc2NoZW1hLmNvbmZpZz8uZGVmYXVsdFZhbHVlID09PSB0YWcudmFsdWU7XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgfSk7XG4gICAgfSk7XG4gIH0sIFtzY2hlbWFMaXN0LCB0YWdzXSk7XG5cbiAgcmV0dXJuIChcbiAgICA8TGlzdENvbnRhaW5lciBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAgICB7XG4gICAgICAgIHRhZ3MubWFwKCh0YWcsIGluZGV4KSA9PiAoZmluZFRhZ0xhYmVsKHNjaGVtYUxpc3QsIHRhZykgPT0gbnVsbFxuICAgICAgICAgID8gbnVsbFxuICAgICAgICAgIDogKFxuICAgICAgICAgICAgPEZpbHRlclRhZ0xpc3RJdGVtIGtleT17YCR7dGFnLmlkfS0ke0pTT04uc3RyaW5naWZ5KHRhZy52YWx1ZSl9YH0+XG4gICAgICAgICAgICAgIDxGaWx0ZXJUYWcgb25DbGljaz17KCkgPT4gaGFuZGxlQ2hhbmdlVGFncyh0YWdzLmZpbHRlcigoXywgaSkgPT4gaSAhPT0gaW5kZXgpKX0+XG4gICAgICAgICAgICAgICAgeyBmaW5kVGFnTGFiZWwoc2NoZW1hTGlzdCwgdGFnKSB9XG4gICAgICAgICAgICAgIDwvRmlsdGVyVGFnPlxuICAgICAgICAgICAgPC9GaWx0ZXJUYWdMaXN0SXRlbT5cbiAgICAgICAgICApKSlcbiAgICAgIH1cbiAgICAgIHtcbiAgICAgICAgIWlzTW9iaWxlICYmICFoaWRlUmVzZXRCdXR0b24gJiYgKFxuICAgICAgICAgIDxGaWx0ZXJUYWdMaXN0SXRlbT5cbiAgICAgICAgICAgIDxSZXNldEJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgb25DbGljaz17KCkgPT4gaGFuZGxlQ2hhbmdlVGFncyhbXSl9PlxuICAgICAgICAgICAgICB7IHJlc2V0IH1cbiAgICAgICAgICAgIDwvUmVzZXRCdXR0b24+XG4gICAgICAgICAgPC9GaWx0ZXJUYWdMaXN0SXRlbT5cbiAgICAgICAgKVxuICAgICAgfVxuICAgIDwvTGlzdENvbnRhaW5lcj5cbiAgKTtcbn07XG5cbmNvbnN0IExpc3RDb250YWluZXIgPSBzdHlsZWQudWxgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgZ2FwOiAke3B4VG9SZW0oNCl9O1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBwYWRkaW5nOiAke3B4VG9SZW0oNSl9IDA7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBhdXRvO1xuICAke01FRElBX1FVRVJZLm1heCgndGFibGV0JywgY3NzYFxuICAgIG1hcmdpbjogMCAke3B4VG9SZW0oLTE1KX07XG4gICAgcGFkZGluZzogJHtweFRvUmVtKDUpfSAke3B4VG9SZW0oMTUpfTtcbiAgICBmbGV4LXdyYXA6IG5vd3JhcDtcbiAgYCl9XG5gO1xuXG5jb25zdCBGaWx0ZXJUYWdMaXN0SXRlbSA9IHN0eWxlZC5saWBcbiAgcGFkZGluZzogJHtweFRvUmVtKDIpfSAwO1xuICAmPmJ1dHRvbiB7XG4gICAgYm9yZGVyOiAke3B4VG9SZW0oMSl9IHNvbGlkIHRyYW5zcGFyZW50O1xuICB9XG5gO1xuXG5jb25zdCBSZXNldEJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICBwYWRkaW5nOiAke3B4VG9SZW0oMil9ICR7cHhUb1JlbSgxMCl9O1xuICBib3JkZXI6IG5vbmU7XG4gIGJhY2tncm91bmQ6IG5vbmU7XG4gIGZvbnQtc2l6ZTogJHtweFRvUmVtKDE1KX07XG4gIGxpbmUtaGVpZ2h0OiAke3B4VG9SZW0oMTgpfTtcbiAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuYDtcbiJdfQ== */"));
const ResetButton$2 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz0"
} : {
  target: "e1pjrndz0",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";padding:", pxToRem(2), " ", pxToRem(10), ";border:none;background:none;font-size:", pxToRem(15), ";line-height:", pxToRem(18), ";font-weight:700;text-align:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const ZINDEX = 3;
const Dropdown = ({
  children,
  content,
  isOpen,
  onChangeOpen
}) => {
  return jsx(InfoTip, {
    renderOpener: ({
      onMouseEnter,
      onMouseLeave
    }) => /*#__PURE__*/React__default.cloneElement(children, {
      onMouseEnter,
      onMouseLeave
    }),
    onOpenChange: onChangeOpen,
    openOnHover: true,
    offsetTop: 8,
    forceClose: !isOpen,
    contentStyle: {
      zIndex: ZINDEX
    },
    children: jsx(Container$6, {
      children: content
    })
  });
};
const Container$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ejm8vx70"
} : {
  target: "ejm8vx70",
  label: "Container"
})("border-radius:", pxToRem(10), ";overflow:hidden;background:", ({
  theme
}) => theme.content.white, ";box-shadow:0 ", pxToRem(-1), " ", pxToRem(16), " rgba(0, 0, 0, 0.2);" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyb3Bkb3duLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1QzRCIiwiZmlsZSI6IkRyb3Bkb3duLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBJbmZvVGlwIH0gZnJvbSAnLi4vaW5mby10aXAnO1xuXG5jb25zdCBaSU5ERVggPSAzO1xuXG5pbnRlcmZhY2UgRHJvcGRvd25Qcm9wcyB7XG4gIGNoaWxkcmVuOiBSZWFjdC5SZWFjdEVsZW1lbnQ7XG4gIGNvbnRlbnQ/OiBSZWFjdC5SZWFjdEVsZW1lbnQ7XG4gIGlzT3Blbj86IGJvb2xlYW47XG4gIG9uQ2hhbmdlT3Blbj86IChpc09wZW46IGJvb2xlYW4pID0+IHZvaWQ7XG59XG5cbmV4cG9ydCBjb25zdCBEcm9wZG93biA9ICh7XG4gIGNoaWxkcmVuLFxuICBjb250ZW50LFxuICBpc09wZW4sXG4gIG9uQ2hhbmdlT3Blbixcbn06IERyb3Bkb3duUHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICByZXR1cm4gKFxuICAgIDxJbmZvVGlwXG4gICAgICByZW5kZXJPcGVuZXI9eyh7IG9uTW91c2VFbnRlciwgb25Nb3VzZUxlYXZlIH0pID0+IFJlYWN0LmNsb25lRWxlbWVudChjaGlsZHJlbiwgeyBvbk1vdXNlRW50ZXIsIG9uTW91c2VMZWF2ZSB9KX1cbiAgICAgIG9uT3BlbkNoYW5nZT17b25DaGFuZ2VPcGVufVxuICAgICAgb3Blbk9uSG92ZXJcbiAgICAgIG9mZnNldFRvcD17OH1cbiAgICAgIGZvcmNlQ2xvc2U9eyFpc09wZW59XG4gICAgICBjb250ZW50U3R5bGU9e3tcbiAgICAgICAgekluZGV4OiBaSU5ERVgsXG4gICAgICB9fVxuICAgID5cbiAgICAgIDxDb250YWluZXI+XG4gICAgICAgIHsgY29udGVudCB9XG4gICAgICA8L0NvbnRhaW5lcj5cbiAgICA8L0luZm9UaXA+XG4gICk7XG59O1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oMTApfTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LndoaXRlfTtcbiAgYm94LXNoYWRvdzogMCAke3B4VG9SZW0oLTEpfSAke3B4VG9SZW0oMTYpfSByZ2JhKDAsIDAsIDAsIDAuMik7XG5gO1xuIl19 */"));

const FilterButton = ({
  icon,
  children,
  ...rest
}) => {
  return jsxs(Button$1, {
    type: "button",
    ...rest,
    children: [children, icon]
  });
};
const Button$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ebq8vr70"
} : {
  target: "ebq8vr70",
  label: "Button"
})("width:max-content;background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thin : theme.content.base5, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thick : theme.content.base2, ";border-radius:", pxToRem(4), ";", FONT_STYLE.body1_small, ";font-size:", pxToRem(15), ";font-weight:700;height:", pxToRem(34), ";padding:0 ", pxToRem(8), ";display:flex;align-items:center;gap:", pxToRem(5), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlckJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JvRCIsImZpbGUiOiJGaWx0ZXJCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBGT05UX1NUWUxFLCBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbnRlcmZhY2UgRmlsdGVyQnV0dG9uUHJvcHMgZXh0ZW5kcyBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MQnV0dG9uRWxlbWVudD4ge1xuICBpY29uPzogUmVhY3QuUmVhY3RFbGVtZW50O1xuICBpc0FjdGl2ZT86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBjb25zdCBGaWx0ZXJCdXR0b24gPSAoe1xuICBpY29uLFxuICBjaGlsZHJlbixcbiAgLi4ucmVzdFxufTogRmlsdGVyQnV0dG9uUHJvcHMpOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4ge1xuICByZXR1cm4gKFxuICAgIDxCdXR0b24gdHlwZT1cImJ1dHRvblwiIHsuLi5yZXN0fT5cbiAgICAgIHsgY2hpbGRyZW4gfVxuICAgICAgeyBpY29uIH1cbiAgICA8L0J1dHRvbj5cbiAgKTtcbn07XG5cbmNvbnN0IEJ1dHRvbiA9IHN0eWxlZC5idXR0b248eyBpc0FjdGl2ZT86IGJvb2xlYW4gfT5gXG4gIHdpZHRoOiBtYXgtY29udGVudDtcbiAgYmFja2dyb3VuZDogJHsoeyBpc0FjdGl2ZSwgdGhlbWUgfSkgPT4gaXNBY3RpdmUgPyB0aGVtZS5jb250ZW50LnByaW1hcnkxLnRoaW4gOiB0aGVtZS5jb250ZW50LmJhc2U1fTtcbiAgY29sb3I6ICR7KHsgaXNBY3RpdmUsIHRoZW1lIH0pID0+IGlzQWN0aXZlID8gdGhlbWUuY29udGVudC5wcmltYXJ5MS50aGljayA6IHRoZW1lLmNvbnRlbnQuYmFzZTJ9O1xuICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oNCl9O1xuICAke0ZPTlRfU1RZTEUuYm9keTFfc21hbGx9O1xuICBmb250LXNpemU6ICR7cHhUb1JlbSgxNSl9O1xuICBmb250LXdlaWdodDogNzAwO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSgzNCl9O1xuICBwYWRkaW5nOiAwICR7cHhUb1JlbSg4KX07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogJHtweFRvUmVtKDUpfTtcbmA7XG4iXX0= */"));

const FilterSelectButton = ({
  icon,
  ...rest
}) => {
  return jsx(FilterButton, {
    icon: icon || jsx(Icon$1, {
      name: "chevron_thick_down",
      size: 12
    }),
    ...rest
  });
};

const FilterController = ({
  entry,
  isActive,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isOptionStartToClose, setIsOptionStartToClose] = useState(false);
  const {
    reset,
    apply
  } = useLocaleData();
  const closeOption = () => {
    setIsOptionStartToClose(true);
  };
  const handleClose = useCallback(() => {
    closeOption();
    setIsClicked(false);
  }, []);
  const handleChangeTags = useCallback(tags => {
    onChangeTags(tags);
    // 단일 선택 리스트일 때만 옵션 선택 시 선택 창이 닫힘
    // 그 외 타입은 모달의 확인 버튼 클릭하거나 dropdown 영역을 벗어났을 때 닫힘
    if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
      handleClose();
    }
  }, [entry, onChangeTags, handleClose]);
  const handleChangeOpen = useCallback(isOpen => {
    setIsClicked(isOpen);
    setIsOptionOpen(isOpen);
  }, []);
  const showResetButton = isActive && entry.config?.showResetButtonOnSelected?.mobile;
  const showCloseButton = isActive && entry.config?.showCloseButtonOnSelected?.mobile;
  return jsxs(Fragment$1, {
    children: [jsx(Dropdown, {
      content: jsx(Panel, {
        entry: entry,
        onChangeTags: tags => {
          handleChangeTags(tags);
          if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
            closeOption();
            setIsClicked(false);
          }
        },
        tags: tags
      }),
      onChangeOpen: !isMobile ? handleChangeOpen : undefined,
      isOpen: !isMobile && isOptionOpen,
      children: jsx(FilterSelectButton, {
        isActive: isActive,
        onClick: () => {
          if (!isMobile) {
            setIsClicked(prev => !prev);
          }
          setIsOptionOpen(prev => isMobile ? !prev : isClicked);
        },
        children: entry.label
      })
    }, entry.id), isMobile && isOptionOpen && jsx(BaseModal, {
      title: entry?.label,
      onClose: handleClose,
      isStartToClose: isOptionStartToClose,
      onTransitionEnd: () => {
        if (isOptionStartToClose) {
          setIsOptionOpen(false);
          setIsOptionStartToClose(false);
        }
      },
      actionRight: showResetButton && jsx(ResetButton$1, {
        type: "button",
        onClick: () => {
          onChangeTags(tags.filter(tag => tag.id !== entry?.id));
        },
        children: reset
      }),
      footer: showCloseButton ? {
        action: {
          primary: {
            text: apply,
            onClick: handleClose
          }
        }
      } : undefined,
      children: entry && jsx(Panel, {
        entry: entry,
        tags: tags,
        onChangeTags: onChangeTags
      })
    })]
  });
};
const ResetButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e2ma4e60"
} : {
  target: "e2ma4e60",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const FilterListModalItem = ({
  buttonText,
  onClick,
  label
}) => {
  return jsx(ListPanelModalItem, {
    buttonText: buttonText,
    onClick: onClick,
    icon: jsxs(IconWrapper, {
      children: [jsx(SelectedValue, {
        children: label
      }), jsx(Icon$1, {
        name: "chevron_right",
        size: 18
      })]
    })
  });
};
const IconWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eecmxa11"
} : {
  target: "eecmxa11",
  label: "IconWrapper"
})("display:flex;gap:", pxToRem(4), ";font-weight:700;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlckxpc3RNb2RhbEl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9DOEIiLCJmaWxlIjoiRmlsdGVyTGlzdE1vZGFsSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcbmltcG9ydCB7IExpc3RQYW5lbE1vZGFsSXRlbSB9IGZyb20gJy4vUGFuZWwvU2luZ2xlUGFuZWwvTGlzdFBhbmVsL0xpc3RQYW5lbE1vZGFsSXRlbSc7XG5cbmludGVyZmFjZSBGaWx0ZXJMaXN0TW9kYWxJdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xuICBsYWJlbD86IFJlYWN0LlJlYWN0Tm9kZTtcbn1cblxuZXhwb3J0IGNvbnN0IEZpbHRlckxpc3RNb2RhbEl0ZW0gPSAoe1xuICBidXR0b25UZXh0LFxuICBvbkNsaWNrLFxuICBsYWJlbCxcbn06IEZpbHRlckxpc3RNb2RhbEl0ZW1Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPExpc3RQYW5lbE1vZGFsSXRlbVxuICAgICAgYnV0dG9uVGV4dD17YnV0dG9uVGV4dH1cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICBpY29uPXsoXG4gICAgICAgIDxJY29uV3JhcHBlcj5cbiAgICAgICAgICA8U2VsZWN0ZWRWYWx1ZT5cbiAgICAgICAgICAgIHsgbGFiZWwgfVxuICAgICAgICAgIDwvU2VsZWN0ZWRWYWx1ZT5cbiAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgc2l6ZT17MTh9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9JY29uV3JhcHBlcj5cbiAgICAgICl9XG4gICAgLz5cbiAgKTtcbn07XG5cbmNvbnN0IEljb25XcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiAke3B4VG9SZW0oNCl9O1xuICBmb250LXdlaWdodDogNzAwO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuYDtcblxuY29uc3QgU2VsZWN0ZWRWYWx1ZSA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbmA7XG4iXX0= */"));
const SelectedValue = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eecmxa10"
} : {
  target: "eecmxa10",
  label: "SelectedValue"
})("display:flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbHRlckxpc3RNb2RhbEl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJDaUMiLCJmaWxlIjoiRmlsdGVyTGlzdE1vZGFsSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcbmltcG9ydCB7IExpc3RQYW5lbE1vZGFsSXRlbSB9IGZyb20gJy4vUGFuZWwvU2luZ2xlUGFuZWwvTGlzdFBhbmVsL0xpc3RQYW5lbE1vZGFsSXRlbSc7XG5cbmludGVyZmFjZSBGaWx0ZXJMaXN0TW9kYWxJdGVtUHJvcHMge1xuICBidXR0b25UZXh0OiBzdHJpbmc7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xuICBsYWJlbD86IFJlYWN0LlJlYWN0Tm9kZTtcbn1cblxuZXhwb3J0IGNvbnN0IEZpbHRlckxpc3RNb2RhbEl0ZW0gPSAoe1xuICBidXR0b25UZXh0LFxuICBvbkNsaWNrLFxuICBsYWJlbCxcbn06IEZpbHRlckxpc3RNb2RhbEl0ZW1Qcm9wcyk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gIHJldHVybiAoXG4gICAgPExpc3RQYW5lbE1vZGFsSXRlbVxuICAgICAgYnV0dG9uVGV4dD17YnV0dG9uVGV4dH1cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICBpY29uPXsoXG4gICAgICAgIDxJY29uV3JhcHBlcj5cbiAgICAgICAgICA8U2VsZWN0ZWRWYWx1ZT5cbiAgICAgICAgICAgIHsgbGFiZWwgfVxuICAgICAgICAgIDwvU2VsZWN0ZWRWYWx1ZT5cbiAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgc2l6ZT17MTh9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9JY29uV3JhcHBlcj5cbiAgICAgICl9XG4gICAgLz5cbiAgKTtcbn07XG5cbmNvbnN0IEljb25XcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiAke3B4VG9SZW0oNCl9O1xuICBmb250LXdlaWdodDogNzAwO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuYDtcblxuY29uc3QgU2VsZWN0ZWRWYWx1ZSA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbmA7XG4iXX0= */"));

const RouteFilter = ({
  className,
  schema,
  query,
  onChangeQuery,
  localeData = defaultLocaleData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const {
    handleChangeTags,
    tags
  } = useFilterTags({
    schema,
    query,
    onChangeQuery
  });
  const {
    reset,
    selectedEntryId,
    selectEntry,
    isModalOpen,
    openModal,
    closeModal
  } = useFilterListModal({
    schema,
    tags,
    handleChangeTags
  });
  const [isStartToClose, setIsStartToClose] = useState(false);
  const isSelected = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const renderSummary = entry => {
    const activeTags = tags.filter(tag => entry.hasTag(tag));
    return activeTags.length === 0 ? entry.renderSummary() : activeTags.map(tag => entry.renderSummary(tag));
  };
  return jsxs(LocaleDataProvider, {
    data: localeData,
    children: [jsxs(Container$5, {
      className: className,
      "data-testid": "router-filter",
      children: [jsxs(FilterControllerList, {
        children: [isMobile && jsxs(AllFilterButton, {
          type: "button",
          onClick: openModal,
          children: [jsx(Icon$1, {
            name: "filter",
            size: 18,
            fill: theme => theme.content.base3
          }), jsx(HiddenText, {
            children: localeData.showAllFilter
          })]
        }), schema.map(entry => jsx(FilterController, {
          entry: entry,
          isActive: isSelected(entry),
          tags: tags,
          onChangeTags: handleChangeTags
        }, entry.id))]
      }), tags.length > 0 && jsx(StyledFilterTagList, {
        tags: tags,
        handleChangeTags: handleChangeTags,
        schema: schema
      })]
    }), isModalOpen && jsx(MenuModal, {
      isStartToClose: isStartToClose,
      onTransitionEnd: () => {
        if (isStartToClose) {
          closeModal();
          setIsStartToClose(false);
        }
      },
      actions: reset && jsx(ResetButton, {
        type: "button",
        onClick: reset,
        children: localeData.reset
      }),
      footer: {
        action: {
          primary: {
            text: localeData.apply,
            onClick: () => setIsStartToClose(true)
          }
        }
      },
      onClose: () => setIsStartToClose(true),
      onChangeMenuKey: selectEntry,
      menu: schema.map(entry => ({
        key: entry.id,
        label: entry.label,
        content: jsx(Panel, {
          entry: entry,
          tags: tags,
          onChangeTags: handleChangeTags
        })
      })),
      home: {
        label: localeData.filter,
        content: jsx(Fragment$1, {
          children: schema.map(entry => jsx(FilterListModalItem, {
            buttonText: entry.label,
            onClick: () => selectEntry(entry.id),
            label: jsx(TagLabelContainer, {
              children: renderSummary(entry)
            })
          }, entry.id))
        })
      },
      currentMenuKey: selectedEntryId
    })]
  });
};
const Container$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn46"
} : {
  target: "e1kmhkn46",
  label: "Container"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const FilterControllerList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn45"
} : {
  target: "e1kmhkn45",
  label: "FilterControllerList"
})("display:flex;align-items:center;gap:", pxToRem(4), ";padding:", pxToRem(5), " 0;width:100%;overflow-x:auto;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledFilterTagList = /*#__PURE__*/_styled(FilterTagList, process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn44"
} : {
  target: "e1kmhkn44",
  label: "StyledFilterTagList"
})("margin:", pxToRem(10), " 0 ", pxToRem(5), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const ResetButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn43"
} : {
  target: "e1kmhkn43",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const TagLabelContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn42"
} : {
  target: "e1kmhkn42",
  label: "TagLabelContainer"
})("display:flex;gap:", pxToRem(4), ";flex-wrap:wrap;justify-content:flex-end;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const AllFilterButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn41"
} : {
  target: "e1kmhkn41",
  label: "AllFilterButton"
})("padding-right:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const HiddenText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn40"
} : {
  target: "e1kmhkn40",
  label: "HiddenText"
})("border:0;clip:rect(0 0 0 0);width:", pxToRem(1), ";height:", pxToRem(1), ";overflow:hidden;padding:0;position:absolute;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var ne=Object.defineProperty;var E=(e,t,o)=>t in e?ne(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o;(e=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(e,{get:(t,o)=>(typeof require!="undefined"?require:t)[o]}):e)(function(e){if(typeof require!="undefined")return require.apply(this,arguments);throw Error('Dynamic require of "'+e+'" is not supported')});var f=(e,t,o)=>E(e,typeof t!="symbol"?t+"":t,o);var u={OFF:0,ERROR:10,WARN:20,INFO:30,DEBUG:40};var V=class{constructor(t){f(this,"id");f(this,"level");this.id=t.id,this.level=t.level;}getLevel(){return this.level}setLevel(t){this.level=t;}error(t,o){this.level<u.ERROR||console.error("[ERROR]",this.createLogSchema(u.ERROR,t,o));}warn(t,o){this.level<u.WARN||console.warn("[WARN]",this.createLogSchema(u.WARN,t,o));}info(t,o){this.level<u.INFO||console.info("[INFO]",this.createLogSchema(u.INFO,t,o));}debug(t,o){this.level<u.DEBUG||console.debug("[DEBUG]",this.createLogSchema(u.DEBUG,t,o));}createLogSchema(t,o,r){return JSON.stringify({id:this.id,level:t,message:o,data:r,timestamp:Date.now()})}};var P="bp-m-ver",T="bp-cid",A="bp-sid",w="bp-aid",v="bp-p-type",I="bp-p-ver",R="bp-a-name",x="bp-a-ver",C="bp-s-country",U="bp-locale",j="bp-tz",N="b_visitor_id",y=[P,T,A,w,v,I,R,x,C,U,j,N];function a(e=3456e7){return Date.now()+e}function d(){return {"bp-m-ver":"","bp-cid":"","bp-sid":"","bp-aid":"","bp-p-type":"","bp-p-ver":"","bp-a-name":"","bp-a-ver":"","bp-s-country":"","bp-locale":"","bp-tz":"",b_visitor_id:""}}function _(e){return e.split(";").reduce((t,o)=>{var m,i;let r=o.trim().split("="),c=(m=r[0])!=null?m:"",p=(i=r[1])!=null?i:"";return !c||!p||!y.includes(c)?t:Object.assign(t,{[c]:p})},d())}function M(e){let t=U,o=e.value?e.value:"";return {name:t,value:o,cookie:()=>{let r=a();return `${t}=${o}; path=/; domain=${e.domain}; expires=${new Date(r).toUTCString()}`}}}new V({id:"metadata",level:u.OFF});

var n=new V({id:"metadata:server",level:u.OFF});function me({metadata:t,req:e,res:r,value:a}){var s;if(typeof window!="undefined"){n.warn("\uC11C\uBC84 \uD658\uACBD\uC774 \uC544\uB2D9\uB2C8\uB2E4.");return}let i=t.set("bp-locale",M({domain:t.config.cookieDomain,value:a})),c=(s=r.getHeader("set-cookie"))!=null?s:[],o=`${i.name}=${i.value}`;r.setHeader("set-cookie",[...c,i.cookie()]),e.headers.cookie=e.headers.cookie?`${e.headers.cookie}; ${o}`:o;}

/**
 * @see {@link https://mbff.qa-web.ohouse.in/webjars/swagger-ui/index.html#/meta/intro}
 */
const getMetaIntroData = async (req, env) => {
  const META_INTRO_API_URL = `${GLOBAL_API_GATEWAY[env]}/config/meta/intro`;
  const res = await fetch(META_INTRO_API_URL, {
    headers: {
      'true-client-ip': getClientIp(req) ?? ''
    }
  });
  const data = await res.json();
  return data;
};
const getBpLocale = req => req.metadata?.data?.get(U)?.value;

/**
 * locale 없는 url의 redirect에 사용할 locale을 return 합니다.
 */
const getDefaultLocale = async (req, env) => {
  const localeFromMetadata = getBpLocale(req)?.split('-')[0];
  const allowedLocale = checkAllowedLocale(localeFromMetadata);
  if (allowedLocale) {
    return allowedLocale;
  }
  const data = await getMetaIntroData(req, env);
  return checkAllowedLocale(data?.lang) ?? GLOBAL_DEFAULT_LOCALE;
};

const createCookieDomain = env => {
  const host = GLOBAL_DOMAINS[env]['home'];
  return /https?:\/\/([^/]+)/.exec(host)[1];
};
const updateSetHeader = (res, locale, env) => {
  const ONE_DAY = 24 * 3600 * 1000;
  const expireDate = new Date(Date.now() + ONE_DAY).toUTCString();
  const setCookie = res.getHeader('set-cookie');
  const cookies = isArray$3(setCookie) ? setCookie : [];
  const newBpSCountry = findKey(GLOBAL_INFO, info => info.locale === locale);
  const cookieDomain = `.${createCookieDomain(env)}`;
  res.setHeader('set-cookie', [...cookies, `bp-s-country=${newBpSCountry}; path=/; domain=${cookieDomain}; expires=${expireDate}`]);
};
const globalMiddleware = {
  express: ({
    env
  }) => async (req, res, next) => {
    const relativeUrl = req.url;
    if (isNextJsPageRequest(relativeUrl) && req.metadata) {
      const locale = getLocaleFromUrl(relativeUrl);
      const appName = req.metadata.data?.get(R)?.value;
      const country = req.metadata.data?.get(C)?.value;
      if (!locale) {
        const defaultLocale = await getDefaultLocale(req, env);
        const currentUrlWithLocale = `/${defaultLocale}${relativeUrl}`;
        const defaultUrl = createGlobalDefaultUrl({
          env,
          locale: defaultLocale,
          country,
          appName
        });
        const redirectUrl = isRootPathnameWithLocale(currentUrlWithLocale) ? defaultUrl : currentUrlWithLocale;
        res.redirect(302, redirectUrl);
        return;
      }
      if (isRootPathnameWithLocale(relativeUrl)) {
        const defaultUrl = createGlobalDefaultUrl({
          env,
          locale,
          country,
          appName
        });
        res.redirect(302, defaultUrl);
        return;
      }
      const userAgent = req.headers['user-agent'];
      if (userAgent && isSearchRobot(userAgent)) {
        updateSetHeader(res, locale, env);
      }
      me({
        metadata: req.metadata,
        req,
        res,
        value: locale
      });
    }
    next();
  }
};

var _path$4;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.186 15v-3.93h.037L6.994 15h1.027V9H6.834v3.909h-.033L4.035 9H3v6zM12.794 13.96H10.11v-1.513h2.533v-.965H10.11v-1.447h2.684V9H8.87v6h3.924zM17.096 10.9h.037l1.125 4.1h1.17L21 9h-1.285l-.936 4.345h-.033L17.638 9H16.59l-1.108 4.345h-.033L14.518 9h-1.285l1.568 6h1.17z"
  })));
};
var NewIcon$1 = SvgNew;

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATUS_MARKER_ICONS_MAPPING = {
  new: () => jsx(NewIconWrapper, {
    children: jsx(NewIcon$1, {})
  }),
  higher: () => jsx(IconFlipper, {
    children: jsx(IconColorizer, {
      className: "higher",
      children: jsx(Icon$1, {
        size: 24,
        name: "dropdown"
      })
    })
  }),
  lower: () => jsx(IconColorizer, {
    className: "lower",
    children: jsx(Icon$1, {
      size: 24,
      name: "dropdown"
    })
  }),
  constant: () => jsx(IconColorizer, {
    className: "constant",
    children: jsx(Icon$1, {
      size: 24,
      name: "unconverted"
    })
  })
};
function TrendingKeywordsEntry(props) {
  const {
    className,
    rank,
    status,
    title
  } = props;
  const marker = STATUS_MARKER_ICONS_MAPPING[status];
  return jsxs(Container$4, {
    className: className,
    children: [jsx(RankNumberGutter, {
      children: rank
    }), jsx(StatusMarker, {
      children: /*#__PURE__*/React__default.createElement(marker ?? STATUS_MARKER_ICONS_MAPPING['constant'])
    }), jsx(Title, {
      children: title
    })]
  });
}
const Container$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj6"
} : {
  target: "e1p2u4vj6",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
const RankNumberGutter = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj5"
} : {
  target: "e1p2u4vj5",
  label: "RankNumberGutter"
})("display:inline-block;", FONT_STYLE.subTitle1, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";text-align:center;margin-right:2px;min-width:20px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StatusMarker = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj4"
} : {
  target: "e1p2u4vj4",
  label: "StatusMarker"
})(process.env.NODE_ENV === "production" ? {
  name: "ckw133",
  styles: "margin-right:6px;display:flex;align-items:center"
} : {
  name: "ckw133",
  styles: "margin-right:6px;display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
const Title = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj3"
} : {
  target: "e1p2u4vj3",
  label: "Title"
})("display:inline-block;", FONT_STYLE.subTitle1, ";flex:1 0 auto;font-style:normal;font-weight:400;color:", ({
  theme
}) => theme.content.base1, ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:104px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const IconFlipper = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj2"
} : {
  target: "e1p2u4vj2",
  label: "IconFlipper"
})(process.env.NODE_ENV === "production" ? {
  name: "1mnpgkl",
  styles: "display:block;transform:rotate(180deg)"
} : {
  name: "1mnpgkl",
  styles: "display:block;transform:rotate(180deg)",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
const IconColorizer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj1"
} : {
  target: "e1p2u4vj1",
  label: "IconColorizer"
})("display:block;>span{display:block;}&.higher{color:", ({
  theme
}) => theme.content.primary2.thick, ";}&.lower{color:", ({
  theme
}) => theme.content.primary1.thick, ";}&.constant{color:", ({
  theme
}) => theme.content.base3, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const NewIconWrapper = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj0"
} : {
  target: "e1p2u4vj0",
  label: "NewIconWrapper"
})("display:block;width:24px;height:24px;>svg{display:block;width:100%;height:auto;color:", ({
  theme
}) => theme.content.primary2.thick, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

// FIXME: Use exports from @bucketplace/bucket-log instead;
// Leaving this as there's unresolved module resolution issue with bucket-log.
function sendImpressionLog(logData) {
  L({
    category: 'impression',
    data: [{
      ...f$1(logData),
      time: Date.now()
    }]
  });
}
function serializePathToString(path) {
  if (typeof path === 'string') {
    return path;
  }
  return `${path.pathname ?? ''}${path.search ?? ''}${path.hash ?? ''}`;
}

/**
 * 연결된 `ref` 요소가 화면에 보이기 시작하면 `logData`를 가지고 impression 로그를 전송합니다.
 */
function useImpressionLog({
  logData,
  threshold,
  disable
}) {
  const {
    ref,
    inView
  } = useInView({
    threshold,
    skip: disable,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView && !disable && !!logData) {
      sendImpressionLog(logData);
    }
  }, [inView, disable, logData]);
  return {
    ref
  };
}

/**
 * 감싸진 `children`이 화면에 보이기 시작하면 `logData`를 가지고 impression
 * 로그를 전송합니다.
 *
 * `children`이 html element(styled components)이거나, forwardRef로 감싸진
 * 컴포넌트인 경우에만 사용 가능합니다.
 *
 * 더 많은 컨트롤이 필요하다면 useImpressionLog() hook을 사용하세요.
 */
function ImpressionTracker(props) {
  const {
    threshold = 0.5,
    logData,
    disable,
    children
  } = props;
  const handleChange = useCallback(inView => {
    if (inView && !disable && logData != null) {
      L({
        category: 'impression',
        data: [{
          ...f$1(logData),
          time: Date.now()
        }]
      });
    }
  }, [disable, logData]);
  if (logData == null) {
    return children;
  }
  return jsx(InView, {
    threshold: threshold,
    skip: disable,
    onChange: handleChange,
    triggerOnce: true,
    children: ({
      ref: inViewRef
    }) => React__default.Children.map(children, child => {
      const ref = node => {
        if (child.props.ref != null) {
          if (typeof child.props.ref === 'function') {
            child.props.ref(node);
          } else {
            child.props.ref.current = node;
          }
        }
        if (inViewRef != null) {
          if (typeof inViewRef === 'function') {
            inViewRef(node);
          } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            inViewRef.current = node;
          }
        }
      };
      return /*#__PURE__*/React__default.cloneElement(child, {
        ref
      });
    })
  });
}

/**
 * Checks whether we're in a browser environment
 *
 * @returns Answer to given question
 */
function isBrowserEnv() {
  return typeof window === 'object' && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
/**
 * Fixes browser edge case where Prototype.js injects Array.prototype.toJSON and breaks the built-in JSON.stringify()
 *
 * @returns true if Array.prototype.toJSON was deleted, false if not
 */
var prototypeJsFix = function () {
  var _a;
  if (isBrowserEnv()) {
    var augmentedWindow = window;
    var augmentedArray = Array;
    if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
      delete augmentedArray.prototype.toJSON;
      return true;
    }
  }
  return false;
};

var md5$1 = {exports: {}};

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
(function (module) {
  (function ($) {

    /**
     * Add integers, wrapping at 2^32.
     * This uses 16-bit operations internally to work around bugs in interpreters.
     *
     * @param {number} x First integer
     * @param {number} y Second integer
     * @returns {number} Sum
     */
    function safeAdd(x, y) {
      var lsw = (x & 0xffff) + (y & 0xffff);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return msw << 16 | lsw & 0xffff;
    }

    /**
     * Bitwise rotate a 32-bit number to the left.
     *
     * @param {number} num 32-bit number
     * @param {number} cnt Rotation count
     * @returns {number} Rotated number
     */
    function bitRotateLeft(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }

    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} q q
     * @param {number} a a
     * @param {number} b b
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5cmn(q, a, b, x, s, t) {
      return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ff(a, b, c, d, x, s, t) {
      return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5gg(a, b, c, d, x, s, t) {
      return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5hh(a, b, c, d, x, s, t) {
      return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ii(a, b, c, d, x, s, t) {
      return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    /**
     * Calculate the MD5 of an array of little-endian words, and a bit length.
     *
     * @param {Array} x Array of little-endian words
     * @param {number} len Bit length
     * @returns {Array<number>} MD5 Array
     */
    function binlMD5(x, len) {
      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;
      var i;
      var olda;
      var oldb;
      var oldc;
      var oldd;
      var a = 1732584193;
      var b = -271733879;
      var c = -1732584194;
      var d = 271733878;
      for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
      }
      return [a, b, c, d];
    }

    /**
     * Convert an array of little-endian words to a string
     *
     * @param {Array<number>} input MD5 Array
     * @returns {string} MD5 string
     */
    function binl2rstr(input) {
      var i;
      var output = '';
      var length32 = input.length * 32;
      for (i = 0; i < length32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
      }
      return output;
    }

    /**
     * Convert a raw string to an array of little-endian words
     * Characters >255 have their high-byte silently ignored.
     *
     * @param {string} input Raw input string
     * @returns {Array<number>} Array of little-endian words
     */
    function rstr2binl(input) {
      var i;
      var output = [];
      output[(input.length >> 2) - 1] = undefined;
      for (i = 0; i < output.length; i += 1) {
        output[i] = 0;
      }
      var length8 = input.length * 8;
      for (i = 0; i < length8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
      }
      return output;
    }

    /**
     * Calculate the MD5 of a raw string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rstrMD5(s) {
      return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }

    /**
     * Calculates the HMAC-MD5 of a key and some data (raw strings)
     *
     * @param {string} key HMAC key
     * @param {string} data Raw input string
     * @returns {string} Raw MD5 string
     */
    function rstrHMACMD5(key, data) {
      var i;
      var bkey = rstr2binl(key);
      var ipad = [];
      var opad = [];
      var hash;
      ipad[15] = opad[15] = undefined;
      if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
      }
      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }
      hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
    }

    /**
     * Convert a raw string to a hex string
     *
     * @param {string} input Raw input string
     * @returns {string} Hex encoded string
     */
    function rstr2hex(input) {
      var hexTab = '0123456789abcdef';
      var output = '';
      var x;
      var i;
      for (i = 0; i < input.length; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
      }
      return output;
    }

    /**
     * Encode a string as UTF-8
     *
     * @param {string} input Input string
     * @returns {string} UTF8 string
     */
    function str2rstrUTF8(input) {
      return unescape(encodeURIComponent(input));
    }

    /**
     * Encodes input string as raw MD5 string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rawMD5(s) {
      return rstrMD5(str2rstrUTF8(s));
    }
    /**
     * Encodes input string as Hex encoded string
     *
     * @param {string} s Input string
     * @returns {string} Hex encoded string
     */
    function hexMD5(s) {
      return rstr2hex(rawMD5(s));
    }
    /**
     * Calculates the raw HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function rawHMACMD5(k, d) {
      return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
     * Calculates the Hex encoded HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function hexHMACMD5(k, d) {
      return rstr2hex(rawHMACMD5(k, d));
    }

    /**
     * Calculates MD5 value for a given string.
     * If a key is provided, calculates the HMAC-MD5 value.
     * Returns a Hex encoded string unless the raw argument is given.
     *
     * @param {string} string Input string
     * @param {string} [key] HMAC key
     * @param {boolean} [raw] Raw output switch
     * @returns {string} MD5 output
     */
    function md5(string, key, raw) {
      if (!key) {
        if (!raw) {
          return hexMD5(string);
        }
        return rawMD5(string);
      }
      if (!raw) {
        return hexHMACMD5(key, string);
      }
      return rawHMACMD5(key, string);
    }
    if (module.exports) {
      module.exports = md5;
    } else {
      $.md5 = md5;
    }
  })(commonjsGlobal);
})(md5$1);
var md5Exports = md5$1.exports;
var md5 = /*@__PURE__*/getDefaultExportFromCjs$1(md5Exports);

const token$1 = '%[a-f0-9]{2}';
const singleMatcher$1 = new RegExp('(' + token$1 + ')|([^%]+?)', 'gi');
const multiMatcher$1 = new RegExp('(' + token$1 + ')+', 'gi');
function decodeComponents$1(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  const left = components.slice(0, split);
  const right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$1(left), decodeComponents$1(right));
}
function decode$2(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher$1) || [];
    for (let i = 1; i < tokens.length; i++) {
      input = decodeComponents$1(tokens, i).join('');
      tokens = input.match(singleMatcher$1) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$1(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  const replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  let match = multiMatcher$1.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$2(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$1.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  const entries = Object.keys(replaceMap);
  for (const key of entries) {
    // Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent$1(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$1(encodedURI);
  }
}

function splitOnFirst$1(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (string === '' || separator === '') {
    return [];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
}

function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor?.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        if (predicate(key, value, object)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}

const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode$1 = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case 'index':
      {
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      }
    case 'bracket':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      }
    case 'colon-list-separator':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      }
    case 'comma':
    case 'separator':
    case 'bracket-separator':
      {
        const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }

          // Translate null to an empty string so that it doesn't serialize as 'null'
          value = value === null ? '' : value;
          if (result.length === 0) {
            return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
          }
          return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
        };
      }
    default:
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
      }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case 'index':
      {
        return (key, value, accumulator) => {
          result = /\[(\d*)]$/.exec(key);
          key = key.replace(/\[\d*]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      }
    case 'bracket':
      {
        return (key, value, accumulator) => {
          result = /(\[])$/.exec(key);
          key = key.replace(/\[]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'colon-list-separator':
      {
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'comma':
    case 'separator':
      {
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode$1(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode$1(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode$1(item, options)) : value === null ? value : decode$1(value, options);
          accumulator[key] = newValue;
        };
      }
    case 'bracket-separator':
      {
        return (key, value, accumulator) => {
          const isArray = /(\[])$/.test(key);
          key = key.replace(/\[]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode$1(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode$1(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [...accumulator[key], ...arrayValue];
        };
      }
    default:
      {
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [...[accumulator[key]].flat(), value];
        };
      }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== 'string' || value.length !== 1) {
    throw new TypeError('arrayFormatSeparator must be single character string');
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
  }
  return value;
}
function decode$1(value, options) {
  if (options.decode) {
    return decodeUriComponent$1(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf('#');
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url) {
  let hash = '';
  const hashStart = url.indexOf('#');
  if (hashStart !== -1) {
    hash = url.slice(hashStart);
  }
  return hash;
}
function parseValue(value, options) {
  if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
    value = Number(value);
  } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
    value = value.toLowerCase() === 'true';
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf('?');
  if (queryStart === -1) {
    return '';
  }
  return input.slice(queryStart + 1);
}
function parse(query, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    parseNumbers: false,
    parseBooleans: false,
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);

  // Create an object with no prototype
  const returnValue = Object.create(null);
  if (typeof query !== 'string') {
    return returnValue;
  }
  query = query.trim().replace(/^[?#&]/, '');
  if (!query) {
    return returnValue;
  }
  for (const parameter of query.split('&')) {
    if (parameter === '') {
      continue;
    }
    const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;
    let [key, value] = splitOnFirst$1(parameter_, '=');
    if (key === undefined) {
      key = parameter_;
    }

    // Missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode$1(value, options);
    formatter(decode$1(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === 'object' && value !== null) {
      for (const [key2, value2] of Object.entries(value)) {
        value[key2] = parseValue(value2, options);
      }
    } else {
      returnValue[key] = parseValue(value, options);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }

  // TODO: Remove the use of `reduce`.
  // eslint-disable-next-line unicorn/no-array-reduce
  return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
      // Sort object keys, not values
      result[key] = keysSorter(value);
    } else {
      result[key] = value;
    }
    return result;
  }, Object.create(null));
}
function stringify(object, options) {
  if (!object) {
    return '';
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys.sort(options.sort);
  }
  return keys.map(key => {
    const value = object[key];
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return encode(key, options);
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
        return encode(key, options) + '[]';
      }
      return value.reduce(formatter(key), []).join('&');
    }
    return encode(key, options) + '=' + encode(value, options);
  }).filter(x => x.length > 0).join('&');
}
function parseUrl(url, options) {
  options = {
    decode: true,
    ...options
  };
  let [url_, hash] = splitOnFirst$1(url, '#');
  if (url_ === undefined) {
    url_ = url;
  }
  return {
    url: url_?.split('?')?.[0] ?? '',
    query: parse(extract(url), options),
    ...(options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode$1(hash, options)
    } : {})
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options
  };
  const url = removeHash(object.url).split('?')[0] || '';
  const queryFromUrl = extract(object.url);
  const query = {
    ...parse(queryFromUrl, {
      sort: false
    }),
    ...object.query
  };
  let queryString = stringify(query, options);
  if (queryString) {
    queryString = `?${queryString}`;
  }
  let hash = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
    hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString}${hash}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options
  };
  const {
    url,
    query,
    fragmentIdentifier
  } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
  return pick(input, exclusionFilter, options);
}

var queryString$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  exclude: exclude,
  extract: extract,
  parse: parse,
  parseUrl: parseUrl,
  pick: pick,
  stringify: stringify,
  stringifyUrl: stringifyUrl
});

var uaParser = {exports: {}};

(function (module, exports) {
  /////////////////////////////////////////////////////////////////////////////////
  /* UAParser.js v0.7.33
     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     MIT License */ /*
                    Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
                    Supports browser & node.js environment.
                    Demo   : https://faisalman.github.io/ua-parser-js
                    Source : https://github.com/faisalman/ua-parser-js */
  /////////////////////////////////////////////////////////////////////////////////

  (function (window, undefined$1) {

    //////////////
    // Constants
    /////////////
    var LIBVERSION = "0.7.33",
      EMPTY = "",
      UNKNOWN = "?",
      FUNC_TYPE = "function",
      UNDEF_TYPE = "undefined",
      OBJ_TYPE = "object",
      STR_TYPE = "string",
      MAJOR = "major",
      MODEL = "model",
      NAME = "name",
      TYPE = "type",
      VENDOR = "vendor",
      VERSION = "version",
      ARCHITECTURE = "architecture",
      CONSOLE = "console",
      MOBILE = "mobile",
      TABLET = "tablet",
      SMARTTV = "smarttv",
      WEARABLE = "wearable",
      EMBEDDED = "embedded",
      UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon",
      APPLE = "Apple",
      ASUS = "ASUS",
      BLACKBERRY = "BlackBerry",
      BROWSER = "Browser",
      CHROME = "Chrome",
      EDGE = "Edge",
      FIREFOX = "Firefox",
      GOOGLE = "Google",
      HUAWEI = "Huawei",
      LG = "LG",
      MICROSOFT = "Microsoft",
      MOTOROLA = "Motorola",
      OPERA = "Opera",
      SAMSUNG = "Samsung",
      SHARP = "Sharp",
      SONY = "Sony",
      XIAOMI = "Xiaomi",
      ZEBRA = "Zebra",
      FACEBOOK = "Facebook";

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }
        return mergedRegexes;
      },
      enumerize = function (arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      },
      has = function (str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      },
      lowerize = function (str) {
        return str.toLowerCase();
      },
      majorize = function (version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      },
      trim = function (str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {
        var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;

        // loop through all regexes maps
        while (i < arrays.length && !matches) {
          var regex = arrays[i],
            // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
          j = k = 0;

          // try matching uastring with regexes
          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                // check if given property is actually array
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      strMapper = function (str, map) {
        for (var i in map) {
          // check if current value is array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      },
      windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2000: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      };

    //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, "Edge"]], [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, OPERA + " Mini"]], [/\bopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, OPERA]], [
      // Mixed
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
      // Baidu Browser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer

      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i], [VERSION, [NAME, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
      ], [VERSION, [NAME, "IE"]], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, "MIUI " + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
      ], [[NAME, "360 " + BROWSER]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 " + BROWSER], VERSION], [
      // Oculus/Samsung/Sailfish/Huawei Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, " "], VERSION], [/(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i,
      // SouGouBrowser
      /(lbbrowser)/i,
      // LieBao Browser
      /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
      ], [NAME], [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
      ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
      ], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
      ], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
      ], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
      // Gecko based
      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
      ], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla

      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i // Links
      ], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i // Cobalt
      ], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
      ], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, "armhf"]], [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, lowerize]]],
      device: [[
      //////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////

      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
      // Apple
      /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/(ipad\d+,\d+)/i // iPad model
      ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
      // Xiaomi
      /\b(poco[\w ]+)(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [
      // OPPO
      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [
      // Vivo
      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [
      // Realme
      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
      // Lenovo
      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [
      // Google
      /(pixel c)\b/i // Google Pixel C
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [
      // Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i,
      // Kindle Fire without Silk
      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
      ], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
      // HTC
      /(nexus 9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC

      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [
      // Meizu
      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(nook)[\w ]+build\/(\w+)/i,
      // Nook
      /(dell) (strea[kpr\d ]*[\dko])/i,
      // Dell Streak
      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
      // Le Pan Tablets
      /(trinity)[- ]*(t\d{3}) bui/i,
      // Trinity Tablets
      /(gigaset)[- ]+(q\w{1,9}) bui/i,
      // Gigaset Tablets
      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
      ], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
      ], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
      ], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
      ], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
      ], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
      ], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
      ], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
      ], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
      ], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
      ], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
      ], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
      ], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
      ], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
      ///////////////////
      // CONSOLES
      ///////////////////

      /(ouya)/i,
      // Ouya
      /(nintendo) ([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
      ///////////////////
      // SMARTTVS
      ///////////////////

      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
      ], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i // Sharp
      ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i // Sony
      ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i // Xiaomi
      ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [
      ///////////////////
      // WEARABLES
      ///////////////////

      /((pebble))app/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
      ///////////////////
      // EMBEDDED
      ///////////////////

      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////

      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
      ], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[
      // Windows
      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i,
      // Windows RT
      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
      // Windows Phone
      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, strMapper, windowsVersionMap]], [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
      ], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
      ], [VERSION, NAME], [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
      ], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, "webOS"]], [
      // Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
      ], [[NAME, "Chromium OS"], VERSION], [
      // Console
      /(nintendo|playstation) ([wids345portablevuch]+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)

      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i // Haiku
      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
      ], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
      /(unix) ?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }
      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser.major = majorize(_browser.version);
        return _browser;
      };
      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        return _device;
      };
      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        return _os;
      };
      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function () {
        return _ua;
      };
      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA();
      };
      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
var UAParser = /*@__PURE__*/getDefaultExportFromCjs$1(uaParserExports);

var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage$1(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage$1 = function () {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function (obj1, obj2) {
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
    var p = primitive_1[_i];
    if (p === typeA) {
      return obj1 === obj2;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = __assign({}, this.identity.userProperties);
    var actingIdentity = __assign(__assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var actingProperties = actingIdentity.userProperties || {};
        for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
          var _b = _a[_i],
            action = _b[0],
            properties = _b[1];
          switch (action) {
            case ID_OP_SET:
              for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                var _e = _d[_c],
                  key = _e[0],
                  value = _e[1];
                actingProperties[key] = value;
              }
              break;
            case ID_OP_UNSET:
              for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                var key = _g[_f];
                delete actingProperties[key];
              }
              break;
            case ID_OP_CLEAR_ALL:
              actingProperties = {};
              break;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return __assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = __assign({}, this.identity);
    this.identity = __assign({}, identity);
    if (!isEqual(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var Constants = {
  DEFAULT_INSTANCE: '$default_instance',
  API_VERSION: 2,
  MAX_STRING_LENGTH: 4096,
  MAX_PROPERTY_KEYS: 1000,
  IDENTIFY_EVENT: '$identify',
  GROUP_IDENTIFY_EVENT: '$groupidentify',
  EVENT_LOG_URL: 'api.amplitude.com',
  EVENT_LOG_EU_URL: 'api.eu.amplitude.com',
  DYNAMIC_CONFIG_URL: 'regionconfig.amplitude.com',
  DYNAMIC_CONFIG_EU_URL: 'regionconfig.eu.amplitude.com',
  // localStorageKeys
  LAST_EVENT_ID: 'amplitude_lastEventId',
  LAST_EVENT_TIME: 'amplitude_lastEventTime',
  LAST_IDENTIFY_ID: 'amplitude_lastIdentifyId',
  LAST_SEQUENCE_NUMBER: 'amplitude_lastSequenceNumber',
  SESSION_ID: 'amplitude_sessionId',
  // Used in cookie as well
  DEVICE_ID: 'amplitude_deviceId',
  OPT_OUT: 'amplitude_optOut',
  USER_ID: 'amplitude_userId',
  // indexes of properties in cookie v2 storage format
  DEVICE_ID_INDEX: 0,
  USER_ID_INDEX: 1,
  OPT_OUT_INDEX: 2,
  SESSION_ID_INDEX: 3,
  LAST_EVENT_TIME_INDEX: 4,
  EVENT_ID_INDEX: 5,
  IDENTIFY_ID_INDEX: 6,
  SEQUENCE_NUMBER_INDEX: 7,
  COOKIE_TEST_PREFIX: 'amp_cookie_test',
  COOKIE_PREFIX: 'amp',
  // Storage options
  STORAGE_DEFAULT: '',
  STORAGE_COOKIES: 'cookies',
  STORAGE_NONE: 'none',
  STORAGE_LOCAL: 'localStorage',
  STORAGE_SESSION: 'sessionStorage',
  // revenue keys
  REVENUE_EVENT: 'revenue_amount',
  REVENUE_PRODUCT_ID: '$productId',
  REVENUE_QUANTITY: '$quantity',
  REVENUE_PRICE: '$price',
  REVENUE_REVENUE_TYPE: '$revenueType',
  AMP_DEVICE_ID_PARAM: 'amp_device_id',
  // url param
  AMP_REFERRER_PARAM: 'amp_referrer',
  // url param for overwriting the document.refer

  REFERRER: 'referrer',
  REFERRING_DOMAIN: 'referring_domain',
  // UTM Params
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_TERM: 'utm_term',
  UTM_CONTENT: 'utm_content',
  ATTRIBUTION_EVENT: '[Amplitude] Attribution Captured',
  TRANSPORT_HTTP: 'http',
  TRANSPORT_BEACON: 'beacon'
};

/*
 * UTF-8 encoder/decoder
 * http://www.webtoolkit.info/
 */
var UTF8 = {
  encode: function encode(s) {
    var utftext = '';
    for (var n = 0; n < s.length; n++) {
      var c = s.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  decode: function decode(utftext) {
    var s = '';
    var i = 0;
    var c = 0,
      c1 = 0,
      c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        s += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c1 = utftext.charCodeAt(i + 1);
        s += String.fromCharCode((c & 31) << 6 | c1 & 63);
        i += 2;
      } else {
        c1 = utftext.charCodeAt(i + 1);
        c2 = utftext.charCodeAt(i + 2);
        s += String.fromCharCode((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
        i += 3;
      }
    }
    return s;
  }
};

/* global globalThis */
var GlobalScope = function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
}();

/*
 * Base64 encoder/decoder
 * http://www.webtoolkit.info/
 */
var Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function encode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return GlobalScope.btoa(unescape(encodeURIComponent(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._encode(input);
  },
  _encode: function _encode(input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = UTF8.encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) + Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
    }
    return output;
  },
  decode: function decode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return decodeURIComponent(escape(GlobalScope.atob(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._decode(input);
  },
  _decode: function _decode(input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (i < input.length) {
      enc1 = Base64._keyStr.indexOf(input.charAt(i++));
      enc2 = Base64._keyStr.indexOf(input.charAt(i++));
      enc3 = Base64._keyStr.indexOf(input.charAt(i++));
      enc4 = Base64._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = UTF8.decode(output);
    return output;
  }
};

/**
 * toString ref.
 * @private
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 * @private
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

function type(val) {
  switch (toString.call(val)) {
    case '[object Date]':
      return 'date';
    case '[object RegExp]':
      return 'regexp';
    case '[object Arguments]':
      return 'arguments';
    case '[object Array]':
      return 'array';
    case '[object Error]':
      return 'error';
  }
  if (val === null) {
    return 'null';
  }
  if (val === undefined) {
    return 'undefined';
  }
  if (val !== val) {
    return 'nan';
  }
  if (val && val.nodeType === 1) {
    return 'element';
  }
  if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(val)) {
    return 'buffer';
  }
  val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
  return _typeof(val);
}
var logLevels = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3
};
var logLevel = logLevels.WARN;
var setLogLevel = function setLogLevel(logLevelName) {
  if (Object.prototype.hasOwnProperty.call(logLevels, logLevelName)) {
    logLevel = logLevels[logLevelName];
  }
};
var getLogLevel = function getLogLevel() {
  return logLevel;
};
var log = {
  error: function error(s) {
    if (logLevel >= logLevels.ERROR) {
      _log(s);
    }
  },
  warn: function warn(s) {
    if (logLevel >= logLevels.WARN) {
      _log(s);
    }
  },
  info: function info(s) {
    if (logLevel >= logLevels.INFO) {
      _log(s);
    }
  }
};
var _log = function _log(s) {
  try {
    console.log('[Amplitude] ' + s);
  } catch (e) {
    // console logging not available
  }
};
var isEmptyString = function isEmptyString(str) {
  return !str || str.length === 0;
};
var sessionStorageEnabled = function sessionStorageEnabled() {
  try {
    if (GlobalScope.sessionStorage) {
      return true;
    }
  } catch (e) {
    // sessionStorage disabled
  }
  return false;
};

// truncate string values in event and user properties so that request size does not get too large
var truncate$1 = function truncate(value) {
  if (type(value) === 'array') {
    for (var i = 0; i < value.length; i++) {
      value[i] = truncate(value[i]);
    }
  } else if (type(value) === 'object') {
    for (var key in value) {
      if (key in value) {
        value[key] = truncate(value[key]);
      }
    }
  } else {
    value = _truncateValue(value);
  }
  return value;
};
var _truncateValue = function _truncateValue(value) {
  if (type(value) === 'string') {
    return value.length > Constants.MAX_STRING_LENGTH ? value.substring(0, Constants.MAX_STRING_LENGTH) : value;
  }
  return value;
};
var validateInput = function validateInput(input, name, expectedType) {
  if (type(input) !== expectedType) {
    log.error('Invalid ' + name + ' input type. Expected ' + expectedType + ' but received ' + type(input));
    return false;
  }
  return true;
};
var validateDeviceId = function validateDeviceId(deviceId) {
  if (!validateInput(deviceId, 'deviceId', 'string')) {
    return false;
  }
  if (deviceId.indexOf('.') >= 0) {
    log.error("Device IDs may not contain '.' characters. Value will be ignored: \"".concat(deviceId, "\""));
    return false;
  }
  return true;
};
var validateTransport = function validateTransport(transport) {
  if (!validateInput(transport, 'transport', 'string')) {
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && transport !== Constants.TRANSPORT_BEACON) {
    log.error("transport value must be one of '".concat(Constants.TRANSPORT_BEACON, "' or '").concat(Constants.TRANSPORT_HTTP, "'"));
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && typeof navigator !== 'undefined' && !navigator.sendBeacon) {
    log.error("browser does not support sendBeacon, so transport must be HTTP");
    return false;
  }
  return true;
};

// do some basic sanitization and type checking, also catch property dicts with more than 1000 key/value pairs
var validateProperties = function validateProperties(properties) {
  var propsType = type(properties);
  if (propsType !== 'object') {
    log.error('Error: invalid properties format. Expecting Javascript object, received ' + propsType + ', ignoring');
    return {};
  }
  if (Object.keys(properties).length > Constants.MAX_PROPERTY_KEYS) {
    log.error('Error: too many properties (more than 1000), ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var property in properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, property)) {
      continue;
    }

    // validate key
    var key = property;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string property key, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validatePropertyValue(key, properties[property]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var invalidValueTypes = ['nan', 'function', 'arguments', 'regexp', 'element'];
var validatePropertyValue = function validatePropertyValue(key, value) {
  var valueType = type(value);
  if (invalidValueTypes.indexOf(valueType) !== -1) {
    log.warn('WARNING: Property key "' + key + '" with invalid value type ' + valueType + ', ignoring');
    value = null;
  } else if (valueType === 'undefined') {
    value = null;
  } else if (valueType === 'error') {
    value = String(value);
    log.warn('WARNING: Property key "' + key + '" with value type error, coercing to ' + value);
  } else if (valueType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < value.length; i++) {
      var element = value[i];
      var elemType = type(element);
      if (elemType === 'array') {
        log.warn('WARNING: Cannot have ' + elemType + ' nested in an array property value, skipping');
        continue;
      } else if (elemType === 'object') {
        arrayCopy.push(validateProperties(element));
      } else {
        arrayCopy.push(validatePropertyValue(key, element));
      }
    }
    value = arrayCopy;
  } else if (valueType === 'object') {
    value = validateProperties(value);
  }
  return value;
};
var validateGroups = function validateGroups(groups) {
  var groupsType = type(groups);
  if (groupsType !== 'object') {
    log.error('Error: invalid groups format. Expecting Javascript object, received ' + groupsType + ', ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var group in groups) {
    if (!Object.prototype.hasOwnProperty.call(groups, group)) {
      continue;
    }

    // validate key
    var key = group;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string groupType, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validateGroupName(key, groups[group]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var validateGroupName = function validateGroupName(key, groupName) {
  var groupNameType = type(groupName);
  if (groupNameType === 'string') {
    return groupName;
  }
  if (groupNameType === 'date' || groupNameType === 'number' || groupNameType === 'boolean') {
    groupName = String(groupName);
    log.warn('WARNING: Non-string groupName, received type ' + groupNameType + ', coercing to string "' + groupName + '"');
    return groupName;
  }
  if (groupNameType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < groupName.length; i++) {
      var element = groupName[i];
      var elemType = type(element);
      if (elemType === 'array' || elemType === 'object') {
        log.warn('WARNING: Skipping nested ' + elemType + ' in array groupName');
        continue;
      } else if (elemType === 'string') {
        arrayCopy.push(element);
      } else if (elemType === 'date' || elemType === 'number' || elemType === 'boolean') {
        element = String(element);
        log.warn('WARNING: Non-string groupName, received type ' + elemType + ', coercing to string "' + element + '"');
        arrayCopy.push(element);
      }
    }
    return arrayCopy;
  }
  log.warn('WARNING: Non-string groupName, received type ' + groupNameType + '. Please use strings or array of strings for groupName');
};

// parses the value of a url param (for example ?gclid=1234&...)
var getQueryParam = function getQueryParam(name, query) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var isWebWorkerEnvironment = function isWebWorkerEnvironment() {
  return typeof WorkerGlobalScope !== 'undefined';
};
var validateSessionId = function validateSessionId(sessionId) {
  if (validateInput(sessionId, 'sessionId', 'number') && new Date(sessionId).getTime() > 0) {
    return true;
  }
  log.error("sessionId value must in milliseconds since epoch (Unix Timestamp)");
  return false;
};
var getLocation = function getLocation() {
  return GlobalScope.location;
};
var getHost = function getHost(url) {
  var defaultHostname = GlobalScope.location ? GlobalScope.location.hostname : '';
  if (url) {
    if (typeof document !== 'undefined') {
      var a = document.createElement('a');
      a.href = url;
      return a.hostname || defaultHostname;
    }
    if (typeof URL === 'function') {
      var u = new URL(url);
      return u.hostname || defaultHostname;
    }
  }
  return defaultHostname;
};
var utils = {
  setLogLevel: setLogLevel,
  getLogLevel: getLogLevel,
  logLevels: logLevels,
  log: log,
  isEmptyString: isEmptyString,
  isWebWorkerEnvironment: isWebWorkerEnvironment,
  getQueryParam: getQueryParam,
  sessionStorageEnabled: sessionStorageEnabled,
  truncate: truncate$1,
  validateGroups: validateGroups,
  validateInput: validateInput,
  validateProperties: validateProperties,
  validateDeviceId: validateDeviceId,
  validateTransport: validateTransport,
  validateSessionId: validateSessionId,
  getLocation: getLocation,
  getHost: getHost
};
var get$1 = function get(name) {
  try {
    var ca = document.cookie.split(';');
    var value = null;
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(name) === 0) {
        value = c.substring(name.length, c.length);
        break;
      }
    }
    return value;
  } catch (e) {
    return null;
  }
};
var getAll = function getAll(name) {
  try {
    var cookieArray = document.cookie.split(';').map(function (c) {
      return c.trimStart();
    });
    var values = [];
    var _iterator = _createForOfIteratorHelper(cookieArray),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookie = _step.value;
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          values.push(cookie.substring(name.length));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return values;
  } catch (e) {
    return [];
  }
};
var set$1 = function set(name, value, opts) {
  var expires = value !== null ? opts.expirationDays : -1;
  if (expires) {
    var date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    expires = date;
  }
  var str = name + '=' + value;
  if (expires) {
    str += '; expires=' + expires.toUTCString();
  }
  str += '; path=/';
  if (opts.domain) {
    str += '; domain=' + opts.domain;
  }
  if (opts.secure) {
    str += '; Secure';
  }
  if (opts.sameSite) {
    str += '; SameSite=' + opts.sameSite;
  }
  document.cookie = str;
};
var getLastEventTime = function getLastEventTime() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var strValue = cookie.split('.')[Constants.LAST_EVENT_TIME_INDEX];
  var parsedValue;
  if (strValue) {
    parsedValue = parseInt(strValue, 32);
  }
  if (parsedValue) {
    return parsedValue;
  } else {
    utils.log.warn("unable to parse malformed cookie: ".concat(cookie));
    return 0;
  }
};
var sortByEventTime = function sortByEventTime(cookies) {
  return _toConsumableArray(cookies).sort(function (c1, c2) {
    var t1 = getLastEventTime(c1);
    var t2 = getLastEventTime(c2);
    // sort c1 first if its last event time is more recent
    // i.e its event time integer is larger that c2's
    return t2 - t1;
  });
};

// test that cookies are enabled - navigator.cookiesEnabled yields false positives in IE, need to test directly
var areCookiesEnabled = function areCookiesEnabled() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cookieName = Constants.COOKIE_TEST_PREFIX;
  if (typeof document === 'undefined') {
    return false;
  }
  var _areCookiesEnabled = false;
  try {
    var uid = String(Date.now());
    set$1(cookieName, uid, opts);
    utils.log.info("Testing if cookies available");
    _areCookiesEnabled = get$1(cookieName + '=') === uid;
  } catch (e) {
    utils.log.warn("Error thrown when checking for cookies. Reason: \"".concat(e, "\""));
  } finally {
    utils.log.info("Cleaning up cookies availability test");
    set$1(cookieName, null, opts);
  }
  return _areCookiesEnabled;
};
var baseCookie = {
  set: set$1,
  get: get$1,
  getAll: getAll,
  getLastEventTime: getLastEventTime,
  sortByEventTime: sortByEventTime,
  areCookiesEnabled: areCookiesEnabled
};

// A URL safe variation on the the list of Base64 characters
var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
var base64Id = function base64Id() {
  var str = '';
  for (var i = 0; i < 22; ++i) {
    str += base64Chars.charAt(Math.floor(Math.random() * 64));
  }
  return str;
};

// Utility that finds top level domain to write to
var topDomain = function topDomain(url) {
  var host = utils.getHost(url);
  var parts = host.split('.');
  var levels = [];
  var cname = '_tldtest_' + base64Id();
  if (utils.isWebWorkerEnvironment()) return '';
  for (var i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }
  for (var _i = 0; _i < levels.length; ++_i) {
    var domain = levels[_i];
    var opts = {
      domain: '.' + domain
    };
    baseCookie.set(cname, 1, opts);
    if (baseCookie.get(cname)) {
      baseCookie.set(cname, null, opts);
      return domain;
    }
  }
  return '';
};

/*
 * Cookie data
 */
var _options = {
  expirationDays: undefined,
  domain: undefined
};
var reset = function reset() {
  _options = {
    expirationDays: undefined,
    domain: undefined
  };
};
var options = function options(opts) {
  if (arguments.length === 0) {
    return _options;
  }
  opts = opts || {};
  _options.expirationDays = opts.expirationDays;
  _options.secure = opts.secure;
  _options.sameSite = opts.sameSite;
  var domain = !utils.isEmptyString(opts.domain) ? opts.domain : '.' + topDomain(utils.getLocation().href);
  var token = Math.random();
  _options.domain = domain;
  set$2('amplitude_test', token);
  var stored = get$2('amplitude_test');
  if (!stored || stored !== token) {
    domain = null;
  }
  remove('amplitude_test');
  _options.domain = domain;
  return _options;
};
var _domainSpecific = function _domainSpecific(name) {
  // differentiate between cookies on different domains
  var suffix = '';
  if (_options.domain) {
    suffix = _options.domain.charAt(0) === '.' ? _options.domain.substring(1) : _options.domain;
  }
  return name + suffix;
};
var get$2 = function get(name) {
  var nameEq = _domainSpecific(name) + '=';
  var value = baseCookie.get(nameEq);
  try {
    if (value) {
      return JSON.parse(Base64.decode(value));
    }
  } catch (e) {
    return null;
  }
  return null;
};
var set$2 = function set(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), Base64.encode(JSON.stringify(value)), _options);
    return true;
  } catch (e) {
    return false;
  }
};
var setRaw = function setRaw(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), value, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var getRaw = function getRaw(name) {
  var nameEq = _domainSpecific(name) + '=';
  return baseCookie.get(nameEq);
};
var remove = function remove(name) {
  try {
    baseCookie.set(_domainSpecific(name), null, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var Cookie = {
  reset: reset,
  options: options,
  get: get$2,
  set: set$2,
  remove: remove,
  setRaw: setRaw,
  getRaw: getRaw
};
var WorkerStorage = /*#__PURE__*/function () {
  function WorkerStorage() {
    _classCallCheck(this, WorkerStorage);
    this.map = new Map();
    this.length = 0;
  }
  _createClass(WorkerStorage, [{
    key: "key",
    value: function key(index) {
      var keys = Array.from(this.map.keys());
      var key = keys[index];
      return this.map.get(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!this.map.has(key)) {
        this.length += 1;
      }
      this.map.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.map.has(key)) {
        this.length -= 1;
        this.map["delete"](key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
      this.length = 0;
    }
  }]);
  return WorkerStorage;
}();

/*
 * Implement localStorage to support Firefox 2-3 and IE 5-7
 */
var localStorage$1;
{
  // test that Window.localStorage is available and works
  var windowLocalStorageAvailable = function windowLocalStorageAvailable() {
    var uid = new Date();
    var result;
    try {
      GlobalScope.localStorage.setItem(uid, uid);
      result = GlobalScope.localStorage.getItem(uid) === String(uid);
      GlobalScope.localStorage.removeItem(uid);
      return result;
    } catch (e) {
      // localStorage not available
    }
    return false;
  };
  if (windowLocalStorageAvailable()) {
    localStorage$1 = GlobalScope.localStorage;
  } else if (typeof GlobalScope !== 'undefined' && GlobalScope.globalStorage) {
    // Firefox 2-3 use globalStorage
    // See https://developer.mozilla.org/en/dom/storage#globalStorage
    try {
      localStorage$1 = GlobalScope.globalStorage[GlobalScope.location.hostname];
    } catch (e) {
      // Something bad happened...
    }
  } else if (typeof document !== 'undefined') {
    // IE 5-7 use userData
    // See http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    var div = document.createElement('div'),
      attrKey = 'localStorage';
    div.style.display = 'none';
    document.getElementsByTagName('head')[0].appendChild(div);
    if (div.addBehavior) {
      div.addBehavior('#default#userdata');
      localStorage$1 = {
        length: 0,
        setItem: function setItem(k, v) {
          div.load(attrKey);
          if (!div.getAttribute(k)) {
            this.length++;
          }
          div.setAttribute(k, v);
          div.save(attrKey);
        },
        getItem: function getItem(k) {
          div.load(attrKey);
          return div.getAttribute(k);
        },
        removeItem: function removeItem(k) {
          div.load(attrKey);
          if (div.getAttribute(k)) {
            this.length--;
          }
          div.removeAttribute(k);
          div.save(attrKey);
        },
        clear: function clear() {
          div.load(attrKey);
          var i = 0;
          var attr;
          while (attr = div.XMLDocument.documentElement.attributes[i++]) {
            div.removeAttribute(attr.name);
          }
          div.save(attrKey);
          this.length = 0;
        },
        key: function key(k) {
          div.load(attrKey);
          return div.XMLDocument.documentElement.attributes[k];
        }
      };
      div.load(attrKey);
      localStorage$1.length = div.XMLDocument.documentElement.attributes.length;
    }
  } else if (utils.isWebWorkerEnvironment()) {
    // Web worker
    localStorage$1 = new WorkerStorage();
  }
  if (!localStorage$1) {
    /* eslint-disable no-unused-vars */
    localStorage$1 = {
      length: 0,
      setItem: function setItem(k, v) {},
      getItem: function getItem(k) {},
      removeItem: function removeItem(k) {},
      clear: function clear() {},
      key: function key(k) {}
    };
    /* eslint-enable no-unused-vars */
  }
}
var localStorage$1$1 = localStorage$1;

/*
 * Abstraction layer for cookie storage.
 * Uses cookie if available, otherwise fallback to localstorage.
 */
var cookieStorage = function cookieStorage() {
  this.storage = null;
};
cookieStorage.prototype.getStorage = function (disableCookies) {
  if (this.storage !== null) {
    return this.storage;
  }
  if (!disableCookies && baseCookie.areCookiesEnabled()) {
    this.storage = Cookie;
  } else {
    // if cookies disabled, fallback to localstorage
    // note: localstorage does not persist across subdomains
    var keyPrefix = 'amp_cookiestore_';
    this.storage = {
      _options: {
        expirationDays: undefined,
        domain: undefined,
        secure: false
      },
      reset: function reset() {
        this._options = {
          expirationDays: undefined,
          domain: undefined,
          secure: false
        };
      },
      options: function options(opts) {
        if (arguments.length === 0) {
          return this._options;
        }
        opts = opts || {};
        this._options.expirationDays = opts.expirationDays || this._options.expirationDays;
        // localStorage is specific to subdomains
        this._options.domain = opts.domain || this._options.domain || GlobalScope && GlobalScope.location && GlobalScope.location.hostname;
        return this._options.secure = opts.secure || false;
      },
      get: function get(name) {
        try {
          return JSON.parse(localStorage$1$1.getItem(keyPrefix + name));
        } catch (e) {} /* eslint-disable-line no-empty */
        return null;
      },
      set: function set(name, value) {
        try {
          localStorage$1$1.setItem(keyPrefix + name, JSON.stringify(value));
          return true;
        } catch (e) {} /* eslint-disable-line no-empty */
        return false;
      },
      remove: function remove(name) {
        try {
          localStorage$1$1.removeItem(keyPrefix + name);
        } catch (e) {
          return false;
        }
      }
    };
  }
  return this.storage;
};
var _storageOptionExists;
var storageOptionExists = (_storageOptionExists = {}, _defineProperty$1(_storageOptionExists, Constants.STORAGE_COOKIES, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_NONE, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_LOCAL, true), _defineProperty$1(_storageOptionExists, Constants.STORAGE_SESSION, true), _storageOptionExists);

/**
 * MetadataStorage involves SDK data persistance
 * storage priority: cookies -> localStorage -> in memory
 * This priority can be overriden by setting the storage options.
 * if in localStorage, unable track users between subdomains
 * if in memory, then memory can't be shared between different tabs
 */
var MetadataStorage = /*#__PURE__*/function () {
  function MetadataStorage(_ref) {
    var storageKey = _ref.storageKey,
      disableCookies = _ref.disableCookies,
      domain = _ref.domain,
      secure = _ref.secure,
      sameSite = _ref.sameSite,
      expirationDays = _ref.expirationDays,
      storage = _ref.storage;
    _classCallCheck(this, MetadataStorage);
    this.storageKey = storageKey;
    this.domain = domain;
    this.secure = secure;
    this.sameSite = sameSite;
    this.expirationDays = expirationDays;
    this.cookieDomain = '';
    var loc = utils.getLocation() ? utils.getLocation().href : undefined;
    var writableTopDomain = !disableCookies ? topDomain(loc) : '';
    this.cookieDomain = domain || (writableTopDomain ? '.' + writableTopDomain : null);
    if (storageOptionExists[storage]) {
      this.storage = storage;
    } else {
      var disableCookieStorage = disableCookies || !baseCookie.areCookiesEnabled({
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
      if (disableCookieStorage) {
        this.storage = Constants.STORAGE_LOCAL;
      } else {
        this.storage = Constants.STORAGE_COOKIES;
      }
    }
  }
  _createClass(MetadataStorage, [{
    key: "getCookieStorageKey",
    value: function getCookieStorageKey() {
      if (!this.domain) {
        return this.storageKey;
      }
      var suffix = this.domain.charAt(0) === '.' ? this.domain.substring(1) : this.domain;
      return "".concat(this.storageKey).concat(suffix ? "_".concat(suffix) : '');
    }

    /*
     * Data is saved as delimited values rather than JSO to minimize cookie space
     * Should not change order of the items
     */
  }, {
    key: "save",
    value: function save(_ref2) {
      var deviceId = _ref2.deviceId,
        userId = _ref2.userId,
        optOut = _ref2.optOut,
        sessionId = _ref2.sessionId,
        lastEventTime = _ref2.lastEventTime,
        eventId = _ref2.eventId,
        identifyId = _ref2.identifyId,
        sequenceNumber = _ref2.sequenceNumber;
      if (this.storage === Constants.STORAGE_NONE) {
        return;
      }
      var value = [deviceId, Base64.encode(userId || ''),
      // used to convert not unicode to alphanumeric since cookies only use alphanumeric
      optOut ? '1' : '', sessionId ? sessionId.toString(32) : '0',
      // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
      lastEventTime ? lastEventTime.toString(32) : '0',
      // last time an event was set
      eventId ? eventId.toString(32) : '0', identifyId ? identifyId.toString(32) : '0', sequenceNumber ? sequenceNumber.toString(32) : '0'].join('.');
      switch (this.storage) {
        case Constants.STORAGE_SESSION:
          if (GlobalScope.sessionStorage) {
            GlobalScope.sessionStorage.setItem(this.storageKey, value);
          }
          break;
        case Constants.STORAGE_LOCAL:
          localStorage$1$1.setItem(this.storageKey, value);
          break;
        case Constants.STORAGE_COOKIES:
          this.saveCookie(value);
          break;
      }
    }
  }, {
    key: "saveCookie",
    value: function saveCookie(value) {
      baseCookie.set(this.getCookieStorageKey(), value, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        var cookieKey = this.getCookieStorageKey() + '=';
        var allCookies = baseCookie.getAll(cookieKey);
        if (allCookies.length === 0 || allCookies.length === 1) {
          str = allCookies[0];
        } else {
          // dedup cookies by deleting them all and restoring
          // the one with the most recent event time
          var latestCookie = baseCookie.sortByEventTime(allCookies)[0];
          allCookies.forEach(function () {
            return baseCookie.set(_this.getCookieStorageKey(), null, {});
          });
          this.saveCookie(latestCookie);
          str = baseCookie.get(cookieKey);
        }
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      if (!str) {
        return null;
      }
      var values = str.split('.');
      var userId = null;
      if (values[Constants.USER_ID_INDEX]) {
        try {
          userId = Base64.decode(values[Constants.USER_ID_INDEX]);
        } catch (e) {
          userId = null;
        }
      }
      return {
        deviceId: values[Constants.DEVICE_ID_INDEX],
        userId: userId,
        optOut: values[Constants.OPT_OUT_INDEX] === '1',
        sessionId: parseInt(values[Constants.SESSION_ID_INDEX], 32),
        lastEventTime: parseInt(values[Constants.LAST_EVENT_TIME_INDEX], 32),
        eventId: parseInt(values[Constants.EVENT_ID_INDEX], 32),
        identifyId: parseInt(values[Constants.IDENTIFY_ID_INDEX], 32),
        sequenceNumber: parseInt(values[Constants.SEQUENCE_NUMBER_INDEX], 32)
      };
    }

    /**
     * Clears any saved metadata storage
     * @constructor AmplitudeClient
     * @public
     * @return {boolean} True if metadata was cleared, false if none existed
     */
  }, {
    key: "clear",
    value: function clear() {
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        str = baseCookie.get(this.getCookieStorageKey() + '=');
        baseCookie.set(this.getCookieStorageKey(), null, {
          domain: this.cookieDomain,
          secure: this.secure,
          sameSite: this.sameSite,
          expirationDays: 0
        });
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
        localStorage$1$1.clear();
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
          GlobalScope.sessionStorage.clear();
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      return !!str;
    }
  }]);
  return MetadataStorage;
}();
var getUtmData$1 = function getUtmData(rawCookie, query) {
  // Translate the utmz cookie format into url query string format.
  var cookie = rawCookie ? '?' + rawCookie.split('.').slice(-1)[0].replace(/\|/g, '&') : '';
  var fetchParam = function fetchParam(queryName, query, cookieName, cookie) {
    return utils.getQueryParam(queryName, query) || utils.getQueryParam(cookieName, cookie);
  };
  var utmSource = fetchParam(Constants.UTM_SOURCE, query, 'utmcsr', cookie);
  var utmMedium = fetchParam(Constants.UTM_MEDIUM, query, 'utmcmd', cookie);
  var utmCampaign = fetchParam(Constants.UTM_CAMPAIGN, query, 'utmccn', cookie);
  var utmTerm = fetchParam(Constants.UTM_TERM, query, 'utmctr', cookie);
  var utmContent = fetchParam(Constants.UTM_CONTENT, query, 'utmcct', cookie);
  var utmData = {};
  var addIfNotNull = function addIfNotNull(key, value) {
    if (!utils.isEmptyString(value)) {
      utmData[key] = value;
    }
  };
  addIfNotNull(Constants.UTM_SOURCE, utmSource);
  addIfNotNull(Constants.UTM_MEDIUM, utmMedium);
  addIfNotNull(Constants.UTM_CAMPAIGN, utmCampaign);
  addIfNotNull(Constants.UTM_TERM, utmTerm);
  addIfNotNull(Constants.UTM_CONTENT, utmContent);
  return utmData;
};

/*
 * Wrapper for a user properties JSON object that supports operations.
 * Note: if a user property is used in multiple operations on the same Identify object,
 * only the first operation will be saved, and the rest will be ignored.
 */

var AMP_OP_ADD = '$add';
var AMP_OP_APPEND = '$append';
var AMP_OP_CLEAR_ALL = '$clearAll';
var AMP_OP_PREPEND = '$prepend';
var AMP_OP_SET = '$set';
var AMP_OP_SET_ONCE = '$setOnce';
var AMP_OP_UNSET = '$unset';
var AMP_OP_PREINSERT = '$preInsert';
var AMP_OP_POSTINSERT = '$postInsert';
var AMP_OP_REMOVE = '$remove';

/**
 * Identify API - instance constructor. Identify objects are a wrapper for user property operations.
 * Each method adds a user property operation to the Identify object, and returns the same Identify object,
 * allowing you to chain multiple method calls together.
 * Note: if the same user property is used in multiple operations on a single Identify object,
 * only the first operation on that property will be saved, and the rest will be ignored.
 * @constructor Identify
 * @public
 * @example var identify = new amplitude.Identify();
 */
var Identify = function Identify() {
  this.userPropertiesOperations = {};
  this.properties = []; // keep track of keys that have been added
};

/**
 * Increment a user property by a given value (can also be negative to decrement).
 * If the user property does not have a value set yet, it will be initialized to 0 before being incremented.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string} value - The amount by which to increment the user property. Allows numbers as strings (ex: '123').
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().add('karma', 1).add('friends', 1);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.add = function (property, value) {
  if (type(value) === 'number' || type(value) === 'string') {
    this._addOperation(AMP_OP_ADD, property, value);
  } else {
    utils.log.error('Unsupported type for value: ' + type(value) + ', expecting number or string');
  }
  return this;
};

/**
 * Append a value or values to a user property.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are appended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values appended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to append.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().append('ab-tests', 'new-user-tests');
 * identify.append('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.append = function (property, value) {
  this._addOperation(AMP_OP_APPEND, property, value);
  return this;
};

/**
 * Clear all user properties for the current user.
 * SDK user should instead call amplitude.clearUserProperties() instead of using this.
 * $clearAll needs to be sent on its own Identify object. If there are already other operations, then don't add $clearAll.
 * If $clearAll already in an Identify object, don't allow other operations to be added.
 * @private
 */
Identify.prototype.clearAll = function () {
  if (Object.keys(this.userPropertiesOperations).length > 0) {
    if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
      utils.log.error('Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll');
    }
    return this;
  }
  this.userPropertiesOperations[AMP_OP_CLEAR_ALL] = '-';
  return this;
};

/**
 * Prepend a value or values to a user property.
 * Prepend means inserting the value or values at the front of a list.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are prepended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values prepended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to prepend.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().prepend('ab-tests', 'new-user-tests');
 * identify.prepend('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.prepend = function (property, value) {
  this._addOperation(AMP_OP_PREPEND, property, value);
  return this;
};

/**
 * Sets the value of a given user property. If a value already exists, it will be overwriten with the new value.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().set('user_type', 'beta');
 * identify.set('name', {'first': 'John', 'last': 'Doe'}); // dict is flattened and becomes name.first: John, name.last: Doe
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.set = function (property, value) {
  this._addOperation(AMP_OP_SET, property, value);
  return this;
};

/**
 * Sets the value of a given user property only once. Subsequent setOnce operations on that user property will be ignored;
 * however, that user property can still be modified through any of the other operations.
 * Useful for capturing properties such as 'initial_signup_date', 'initial_referrer', etc.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set once.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().setOnce('sign_up_date', '2016-04-01');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.setOnce = function (property, value) {
  this._addOperation(AMP_OP_SET_ONCE, property, value);
  return this;
};

/**
 * Unset and remove a user property. This user property will no longer show up in a user's profile.
 * @public
 * @param {string} property - The user property key.
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().unset('user_type').unset('age');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.unset = function (property) {
  this._addOperation(AMP_OP_UNSET, property, '-');
  return this;
};

/**
 * Preinsert a value or values to a user property, if it does not exist in the user property already.
 * Preinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.preInsert = function (property, value) {
  this._addOperation(AMP_OP_PREINSERT, property, value);
  return this;
};

/**
 * Postinsert a value or values to a user property, if it does not exist in the user property already.
 * Postinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.postInsert = function (property, value) {
  this._addOperation(AMP_OP_POSTINSERT, property, value);
  return this;
};

/**
 * Remove a value or values to a user property, if it does exist in the user property.
 * If the item does not exist in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to remove.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.remove = function (property, value) {
  this._addOperation(AMP_OP_REMOVE, property, value);
  return this;
};

/**
 * Helper function that adds operation to the Identify's object
 * Handle's filtering of duplicate user property keys, and filtering for clearAll.
 * @private
 */
Identify.prototype._addOperation = function (operation, property, value) {
  // check that the identify doesn't already contain a clearAll
  if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
    utils.log.error('This identify already contains a $clearAll operation, skipping operation ' + operation);
    return;
  }

  // check that property wasn't already used in this Identify
  if (this.properties.indexOf(property) !== -1) {
    utils.log.error('User property "' + property + '" already used in this identify, skipping operation ' + operation);
    return;
  }
  if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, operation)) {
    this.userPropertiesOperations[operation] = {};
  }
  this.userPropertiesOperations[operation][property] = value;
  this.properties.push(property);
};

/*
 * Simple AJAX request object
 */
var Request$1 = function Request(url, data, headers) {
  this.url = url;
  this.data = data || {};
  this.headers = headers;
};
var CORS_HEADER = 'Cross-Origin-Resource-Policy';
function setHeaders(xhr, headers) {
  for (var header in headers) {
    if (header === CORS_HEADER && !headers[header]) {
      continue;
    }
    xhr.setRequestHeader(header, headers[header]);
  }
}
Request$1.prototype.send = function (callback) {
  var isIE = GlobalScope.XDomainRequest ? true : false;
  if (isIE) {
    var xdr = new GlobalScope.XDomainRequest();
    xdr.open('POST', this.url, true);
    xdr.onload = function () {
      callback(200, xdr.responseText);
    };
    xdr.onerror = function () {
      // status code not available from xdr, try string matching on responseText
      if (xdr.responseText === 'Request Entity Too Large') {
        callback(413, xdr.responseText);
      } else {
        callback(500, xdr.responseText);
      }
    };
    xdr.ontimeout = function () {};
    xdr.onprogress = function () {};
    xdr.send(queryString$1.stringify(this.data));
  } else if (typeof XMLHttpRequest !== 'undefined') {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback(xhr.status, xhr.responseText);
      }
    };
    setHeaders(xhr, this.headers);
    xhr.send(queryString$1.stringify(this.data));
  } else {
    var responseStatus = undefined;
    fetch(this.url, {
      method: 'POST',
      headers: this.headers,
      body: queryString$1.stringify(this.data)
    }).then(function (response) {
      responseStatus = response.status;
      return response.text();
    }).then(function (responseText) {
      callback(responseStatus, responseText);
    });
  }
  //log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));
};

/**
 * Revenue API - instance constructor. Wrapper for logging Revenue data. Revenue objects get passed to amplitude.logRevenueV2 to send to Amplitude servers.
 * Each method updates a revenue property in the Revenue object, and returns the same Revenue object,
 * allowing you to chain multiple method calls together.
 *
 * Note: price is a required field to log revenue events.
 * If quantity is not specified then defaults to 1.
 * @constructor Revenue
 * @public
 * @example var revenue = new amplitude.Revenue();
 */
var Revenue = function Revenue() {
  // required fields
  this._price = null;

  // optional fields
  this._productId = null;
  this._quantity = 1;
  this._revenueType = null;
  this._properties = null;
};

/**
 * Set a value for the product identifer.
 * @public
 * @param {string} productId - The value for the product identifier. Empty and invalid strings are ignored.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setProductId = function setProductId(productId) {
  if (type(productId) !== 'string') {
    utils.log.error('Unsupported type for productId: ' + type(productId) + ', expecting string');
  } else if (utils.isEmptyString(productId)) {
    utils.log.error('Invalid empty productId');
  } else {
    this._productId = productId;
  }
  return this;
};

/**
 * Set a value for the quantity. Note revenue amount is calculated as price * quantity.
 * @public
 * @param {number} quantity - Integer value for the quantity. If not set, quantity defaults to 1.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setQuantity(5);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setQuantity = function setQuantity(quantity) {
  if (type(quantity) !== 'number') {
    utils.log.error('Unsupported type for quantity: ' + type(quantity) + ', expecting number');
  } else {
    this._quantity = parseInt(quantity);
  }
  return this;
};

/**
 * Set a value for the price. This field is required for all revenue being logged.
 *
 * Note: revenue amount is calculated as price * quantity.
 * @public
 * @param {number} price - Double value for the quantity.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setPrice = function setPrice(price) {
  if (type(price) !== 'number') {
    utils.log.error('Unsupported type for price: ' + type(price) + ', expecting number');
  } else {
    this._price = price;
  }
  return this;
};

/**
 * Set a value for the revenueType (for example purchase, cost, tax, refund, etc).
 * @public
 * @param {string} revenueType - RevenueType to designate.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setRevenueType('purchase');
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setRevenueType = function setRevenueType(revenueType) {
  if (type(revenueType) !== 'string') {
    utils.log.error('Unsupported type for revenueType: ' + type(revenueType) + ', expecting string');
  } else {
    this._revenueType = revenueType;
  }
  return this;
};

/**
 * Set event properties for the revenue event.
 * @public
 * @param {object} eventProperties - Revenue event properties to set.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var event_properties = {'city': 'San Francisco'};
 * var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setEventProperties(event_properties);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setEventProperties = function setEventProperties(eventProperties) {
  if (type(eventProperties) !== 'object') {
    utils.log.error('Unsupported type for eventProperties: ' + type(eventProperties) + ', expecting object');
  } else {
    this._properties = utils.validateProperties(eventProperties);
  }
  return this;
};

/**
 * @private
 */
Revenue.prototype._isValidRevenue = function _isValidRevenue() {
  if (type(this._price) !== 'number') {
    utils.log.error('Invalid revenue, need to set price field');
    return false;
  }
  return true;
};

/**
 * @private
 */
Revenue.prototype._toJSONObject = function _toJSONObject() {
  var obj = type(this._properties) === 'object' ? this._properties : {};
  if (this._productId !== null) {
    obj[Constants.REVENUE_PRODUCT_ID] = this._productId;
  }
  if (this._quantity !== null) {
    obj[Constants.REVENUE_QUANTITY] = this._quantity;
  }
  if (this._price !== null) {
    obj[Constants.REVENUE_PRICE] = this._price;
  }
  if (this._revenueType !== null) {
    obj[Constants.REVENUE_REVENUE_TYPE] = this._revenueType;
  }
  return obj;
};

/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var uuid$1 = function uuid(a) {
  return a // if the placeholder was passed, return
  ?
  // a random number from 0 to 15
  (a ^
  // unless b is 8,
  Math.random() *
  // in which case
  16 >>
  // a random number from
  a / 4
  // 8 to 11
  ).toString(16) // in hexadecimal
  :
  // or otherwise a concatenated string:
  ([1e7] +
  // 10000000 +
  -1e3 +
  // -1000 +
  -4e3 +
  // -4000 +
  -8e3 +
  // -80000000 +
  -1e11
  // -100000000000,
  ).replace(
  // replacing
  /[018]/g,
  // zeroes, ones, and eights with
  uuid // random hex digits
  );
};
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || '';
};
var language = {
  getLanguage: getLanguage
};

/**
 * AmplitudeServerZone is for Data Residency and handling server zone related properties.
 * The server zones now are US and EU.
 *
 * For usage like sending data to Amplitude's EU servers, you need to configure the serverZone during nitializing.
 */
var AmplitudeServerZone = {
  US: 'US',
  EU: 'EU'
};
var getEventLogApi = function getEventLogApi(serverZone) {
  var eventLogUrl = Constants.EVENT_LOG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      eventLogUrl = Constants.EVENT_LOG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      eventLogUrl = Constants.EVENT_LOG_URL;
      break;
  }
  return eventLogUrl;
};
var getDynamicConfigApi = function getDynamicConfigApi(serverZone) {
  var dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
      break;
  }
  return dynamicConfigUrl;
};
var version = "8.21.9";

/**
 * Options used when initializing Amplitude
 * @typedef {Object} Options
 * @property {string} [apiEndpoint=`api.amplitude.com`] - Endpoint to send amplitude event requests to.
 * @property {boolean} [batchEvents=`false`] -  If `true`, then events are batched together and uploaded only when the number of unsent events is greater than or equal to eventUploadThreshold or after eventUploadPeriodMillis milliseconds have passed since the first unsent event was logged.
 * @property {number} [cookieExpiration=`365`] - The number of days after which the Amplitude cookie will expire. 12 months is for GDPR compliance.
 * @property {string} [cookieName=`amplitude_id`] - *DEPRECATED*
 * @property {string} [sameSiteCookie='None'] -  Sets the SameSite flag on the amplitude cookie. Decides cookie privacy policy.
 * @property {boolean} [cookieForceUpgrade=`false`] - Forces pre-v6.0.0 instances to adopt post-v6.0.0 compat cookie formats.
 * @property {boolean} [deferInitialization=`null`] -  If `true`, disables the core functionality of the sdk, including saving a cookie and all logging, until explicitly enabled. To enable tracking, please call `amplitude.getInstance().enableTracking()` *Note: This will not affect users who already have an amplitude cookie. The decision to track events is determined by whether or not a user has an amplitude analytics cookie. If the `cookieExpiration</code> is manually defined to be a short lifespan, you may need to run `amplitude.getInstance().enableTracking()` upon the cookie expiring or upon logging in.*
 * @property {boolean} [disableCookies=`false`] -  Disable Ampllitude cookies altogether.
 * @property {string} [deviceId=A randomly generated UUID.] -  The custom Device ID to set. *Note: This is not recommended unless you know what you are doing (e.g. you have your own system for tracking user devices).*
 * @property {boolean} [deviceIdFromUrlParam=`false`] -  If `true`, then the SDK will parse Device ID values from the URL parameter amp_device_id if available. Device IDs defined in the configuration options during init will take priority over Device IDs from URL parameters.
 * @property {string} [domain=The top domain of the current page's URL. ('https://amplitude.com')] -  Set a custom domain for the Amplitude cookie. To include subdomains, add a preceding period, eg: `.amplitude.com`.
 * @property {number} [eventUploadPeriodMillis=`30000` (30 sec)] -  Amount of time in milliseconds that the SDK waits before uploading events if batchEvents is true.
 * @property {number} [eventUploadThreshold=`30`] -  Minimum number of events to batch together per request if batchEvents is true.
 * @property {boolean} [forceHttps=`true`] -  If `true`, the events will always be uploaded to HTTPS endpoint. Otherwise, it will use the embedding site's protocol.
 * @property {boolean} [includeFbclid=`false`] -  If `true`, captures the fbclid URL parameter as well as the user's initial_fbclid via a setOnce operation.
 * @property {boolean} [includeGclid=`false`] -  If `true`, captures the gclid URL parameter as well as the user's initial_gclid via a setOnce operation.
 * @property {boolean} [includeReferrer=`false`] -  If `true`, captures the referrer and referring_domain for each session, as well as the user's initial_referrer and initial_referring_domain via a setOnce operation.
 * @property {boolean} [includeUtm=`false`] -  If `true`, finds UTM parameters in the query string or the _utmz cookie, parses, and includes them as user properties on all events uploaded. This also captures initial UTM parameters for each session via a setOnce operation.
 * @property {Object} [ingestionMetadata] Ingestion metadata
 * @property {string} [ingestionMetadata.sourceName] source name in ingestion metadata, e.g. "ampli"
 * @property {string} [ingestionMetadata.sourceVersion] source version in ingestion metadata, e.g. "1.0.0"
 * @property {string} [language=The language determined by the browser] -  Custom language to set.
 * @property {Object} [library=`{ name: 'amplitude-js', version: packageJsonVersion }`] -  Values for the library version
 * @property {string} [logLevel=`WARN`] -  Level of logs to be printed in the developer console. Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'. To learn more about the different options, see below.
 * @property {boolean} [logAttributionCapturedEvent=`false`] - If `true`, the SDK will log an Amplitude event anytime new attribution values are captured from the user. **Note: These events count towards your event volume.** Event name being logged: [Amplitude] Attribution Captured. Event Properties that can be logged: `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, `utm_content`, `referrer`, `referring_domain`, `gclid`, `fbclid`. For UTM properties to be logged, `includeUtm` must be set to `true`. For the `referrer` and `referring_domain` properties to be logged, `includeReferrer` must be set to `true`. For the `gclid` property to be logged, `includeGclid` must be set to `true`. For the `fbclid` property to be logged, `includeFbclid` must be set to `true`.
 * @property {boolean} [optOut=`false`] -  Whether or not to disable tracking for the current user.
 * @property {function} [onError=`() => {}`] - Function to call on error.
 * @property {function} [onExitPage=`() => {}`] - Function called when the user exits the browser. Useful logging on page exit.
 * @property {Object} [plan] Tracking plan properties
 * @property {string} [plan.branch] The tracking plan branch name e.g. "main"
 * @property {string} [plan.source] The tracking plan source e.g. "web"
 * @property {string} [plan.version] The tracking plan version e.g. "1", "15"
 * @property {string} [plan.versionId] The tracking plan version Id e.g. "9ec23ba0-275f-468f-80d1-66b88bff9529"
 * @property {string} [platform=`Web`] -  Platform device is running on. Defaults to `Web` (browser, including mobile browsers).
 * @property {number} [savedMaxCount=`1000`] -  Maximum number of events to save in localStorage. If more events are logged while offline, then old events are removed.
 * @property {boolean} [saveEvents=`true`] -  If `true`, saves events to localStorage and removes them upon successful upload. *Note: Without saving events, events may be lost if the user navigates to another page before the events are uploaded.*
 * @property {boolean} [saveParamsReferrerOncePerSession=`true`] -  If `true`, then includeGclid, includeFbclid, includeReferrer, and includeUtm will only track their respective properties once per session. New values that come in during the middle of the user's session will be ignored. Set to false to always capture new values.
 * @property {boolean} [secureCookie=`false`] -  If `true`, the amplitude cookie will be set with the Secure flag.
 * @property {number} [sessionTimeout=`30*60*1000` (30 min)] -  The time between logged events before a new session starts in milliseconds.
 * @property {string[]} [storage=`''`] - Sets storage strategy.  Options are 'cookies', 'localStorage', 'sessionStorage', or `none`. Will override `disableCookies` option
 * @property {Object} [trackingOptions=`{ city: true, country: true, carrier: true, device_manufacturer: true, device_model: true, dma: true, ip_address: true, language: true, os_name: true, os_version: true, platform: true, region: true, version_name: true}`] - Type of data associated with a user.
 * @property {string} [transport=`http`] - Network transport mechanism used to send events. Options are 'http' and 'beacon'.
 * @property {boolean} [unsetParamsReferrerOnNewSession=`false`] -  If `false`, the existing `referrer` and `utm_parameter` values will be carried through each new session. If set to `true`, the `referrer` and `utm_parameter` user properties, which include `referrer`, `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, and `utm_content`, will be set to `null` upon instantiating a new session. Note: This only works if `includeReferrer` or `includeUtm` is set to `true`.
 * @property {string} [unsentKey=`amplitude_unsent`] - localStorage key that stores unsent events.
 * @property {string} [unsentIdentifyKey=`amplitude_unsent_identify`] - localStorage key that stores unsent identifies.
 * @property {number} [uploadBatchSize=`100`] -  The maximum number of events to send to the server per request.
 * @property {Object} [headers=`{ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }`] - Headers attached to an event(s) upload network request. Custom header properties are merged with this object.
 * @property {string} [serverZone] - For server zone related configuration, used for server api endpoint and dynamic configuration.
 * @property {boolean} [useDynamicConfig] - Enable dynamic configuration to find best server url for user.
 * @property {boolean} [serverZoneBasedApi] - To update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @property {number} [sessionId=`null`] - The custom Session ID for the current session. *Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * @property {string} [partnerId=`null`] - The partner id value
 */
var DEFAULT_OPTIONS = {
  apiEndpoint: Constants.EVENT_LOG_URL,
  batchEvents: false,
  cookieExpiration: 365,
  // 12 months is for GDPR compliance
  cookieName: 'amplitude_id',
  // this is a deprecated option
  sameSiteCookie: 'Lax',
  // cookie privacy policy
  cookieForceUpgrade: false,
  deferInitialization: false,
  disableCookies: false,
  // this is a deprecated option
  deviceIdFromUrlParam: false,
  domain: '',
  eventUploadPeriodMillis: 30 * 1000,
  // 30s
  eventUploadThreshold: 30,
  forceHttps: true,
  includeFbclid: false,
  includeGclid: false,
  includeReferrer: false,
  includeUtm: false,
  ingestionMetadata: {
    sourceName: '',
    sourceVersion: ''
  },
  language: language.getLanguage(),
  library: {
    name: 'amplitude-js',
    version: version
  },
  logLevel: 'WARN',
  logAttributionCapturedEvent: false,
  optOut: false,
  onError: function onError() {},
  onExitPage: function onExitPage() {},
  onNewSessionStart: function onNewSessionStart() {},
  plan: {
    branch: '',
    source: '',
    version: '',
    versionId: ''
  },
  platform: 'Web',
  savedMaxCount: 1000,
  saveEvents: true,
  saveParamsReferrerOncePerSession: true,
  secureCookie: false,
  sessionTimeout: 30 * 60 * 1000,
  storage: Constants.STORAGE_DEFAULT,
  trackingOptions: {
    city: true,
    country: true,
    carrier: true,
    device_manufacturer: true,
    device_model: true,
    dma: true,
    ip_address: true,
    language: true,
    os_name: true,
    os_version: true,
    platform: true,
    region: true,
    version_name: true
  },
  transport: Constants.TRANSPORT_HTTP,
  unsetParamsReferrerOnNewSession: false,
  unsentKey: 'amplitude_unsent',
  unsentIdentifyKey: 'amplitude_unsent_identify',
  uploadBatchSize: 100,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cross-Origin-Resource-Policy': 'cross-origin'
  },
  serverZone: AmplitudeServerZone.US,
  useDynamicConfig: false,
  serverZoneBasedApi: false,
  sessionId: null,
  partnerId: ''
};

/**
 * Dynamic Configuration
 * Find the best server url automatically based on app users' geo location.
 */
var ConfigManager = /*#__PURE__*/function () {
  function ConfigManager() {
    _classCallCheck(this, ConfigManager);
    if (!ConfigManager.instance) {
      this.ingestionEndpoint = Constants.EVENT_LOG_URL;
      ConfigManager.instance = this;
    }
    return ConfigManager.instance;
  }
  _createClass(ConfigManager, [{
    key: "refresh",
    value: function refresh(serverZone, forceHttps, callback) {
      var protocol = 'https';
      if (!forceHttps && 'https:' !== GlobalScope.location.protocol) {
        protocol = 'http';
      }
      var dynamicConfigUrl = protocol + '://' + getDynamicConfigApi(serverZone);
      var self = this;
      var isIE = GlobalScope.XDomainRequest ? true : false;
      if (isIE) {
        var xdr = new GlobalScope.XDomainRequest();
        xdr.open('GET', dynamicConfigUrl, true);
        xdr.onload = function () {
          var response = JSON.parse(xdr.responseText);
          self.ingestionEndpoint = response['ingestionEndpoint'];
          if (callback) {
            callback();
          }
        };
        xdr.onerror = function () {};
        xdr.ontimeout = function () {};
        xdr.onprogress = function () {};
        xdr.send();
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', dynamicConfigUrl, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            self.ingestionEndpoint = response['ingestionEndpoint'];
            if (callback) {
              callback();
            }
          }
        };
        xhr.send();
      }
    }
  }]);
  return ConfigManager;
}();
var instance$1 = new ConfigManager();

/**
 * AmplitudeClient SDK API - instance constructor.
 * The Amplitude class handles creation of client instances, all you need to do is call amplitude.getInstance()
 * @constructor AmplitudeClient
 * @public
 * @example var amplitudeClient = new AmplitudeClient();
 */
var AmplitudeClient = function AmplitudeClient(instanceName) {
  if (!isBrowserEnv() && !utils.isWebWorkerEnvironment()) {
    utils.log.warn('amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node');
  }
  this._instanceName = utils.isEmptyString(instanceName) ? Constants.DEFAULT_INSTANCE : instanceName.toLowerCase();
  this._unsentEvents = [];
  this._unsentIdentifys = [];
  this.options = _objectSpread2$1(_objectSpread2$1({}, DEFAULT_OPTIONS), {}, {
    headers: _objectSpread2$1({}, DEFAULT_OPTIONS.headers),
    ingestionMetadata: _objectSpread2$1({}, DEFAULT_OPTIONS.ingestionMetadata),
    library: _objectSpread2$1({}, DEFAULT_OPTIONS.library),
    plan: _objectSpread2$1({}, DEFAULT_OPTIONS.plan),
    trackingOptions: _objectSpread2$1({}, DEFAULT_OPTIONS.trackingOptions)
  });
  this._q = []; // queue for proxied functions before script load
  this._sending = false;
  this._updateScheduled = false;
  this._onInitCallbacks = [];
  this._onNewSessionStartCallbacks = [];

  // event meta data
  this._eventId = 0;
  this._identifyId = 0;
  this._lastEventTime = null;
  this._newSession = false;
  // sequence used for by frontend for prioritizing event send retries
  this._sequenceNumber = 0;
  this._sessionId = null;
  this._isInitialized = false;

  // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
  this._connector = null;
  this._userAgent = typeof navigator !== 'undefined' && navigator && navigator.userAgent || null;
  this._ua = new UAParser(this._userAgent).getResult();
};
AmplitudeClient.prototype.Identify = Identify;
AmplitudeClient.prototype.Revenue = Revenue;

/**
 * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
 * This is required before any other methods can be called.
 * @public
 * @param {string} apiKey - The API key for your app.
 * @param {string} opt_userId - (optional) An identifier for this user.
 * @param {object} opt_config - (optional) Configuration options.
 * See [options.js](https://amplitude.github.io/Amplitude-JavaScript/Options) for a list of options and default values.
 * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
 * @example amplitudeClient.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
 */
AmplitudeClient.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
  var _this = this;
  if (type(apiKey) !== 'string' || utils.isEmptyString(apiKey)) {
    utils.log.error('Invalid apiKey. Please re-initialize with a valid apiKey');
    return;
  }
  try {
    // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
    this._connector = AnalyticsConnector.getInstance(this._instanceName);
    _parseConfig(this.options, opt_config);
    if ((isBrowserEnv() || utils.isWebWorkerEnvironment()) && GlobalScope.Prototype !== undefined && Array.prototype.toJSON) {
      prototypeJsFix();
      utils.log.warn('Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify');
    }
    if (this.options.cookieName !== DEFAULT_OPTIONS.cookieName) {
      utils.log.warn('The cookieName option is deprecated. We will be ignoring it for newer cookies');
    }
    if (this.options.serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
    this._refreshDynamicConfig();
    this.options.apiKey = apiKey;
    this._storageSuffix = '_' + apiKey + (this._instanceName === Constants.DEFAULT_INSTANCE ? '' : '_' + this._instanceName);
    this._storageSuffixV5 = apiKey.slice(0, 6);
    this._oldCookiename = this.options.cookieName + this._storageSuffix;
    this._unsentKey = this.options.unsentKey + this._storageSuffix;
    this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix;
    this._cookieName = Constants.COOKIE_PREFIX + '_' + this._storageSuffixV5;
    this.cookieStorage = new cookieStorage().getStorage(this.options.disableCookies);
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie
    });
    this._metadataStorage = new MetadataStorage({
      storageKey: this._cookieName,
      disableCookies: this.options.disableCookies,
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie,
      storage: this.options.storage
    });
    var hasOldCookie = !!this.cookieStorage.get(this._oldCookiename);
    var hasNewCookie = !!this._metadataStorage.load();
    this._useOldCookie = !hasNewCookie && hasOldCookie && !this.options.cookieForceUpgrade;
    var hasCookie = hasNewCookie || hasOldCookie;
    if (this.options.deferInitialization && !hasCookie) {
      this._deferInitialization(apiKey, opt_userId, opt_config, opt_callback);
      return;
    }
    this.options.domain = this.cookieStorage.options().domain;
    if (type(this.options.logLevel) === 'string') {
      utils.setLogLevel(this.options.logLevel);
    }
    var trackingOptions = _generateApiPropertiesTrackingConfig(this);
    this._apiPropertiesTrackingOptions = Object.keys(trackingOptions).length > 0 ? {
      tracking_options: trackingOptions
    } : {};
    if (this.options.cookieForceUpgrade && hasOldCookie) {
      if (!hasNewCookie) {
        _upgradeCookieData(this);
      }
      this.cookieStorage.remove(this._oldCookiename);
    }
    _loadCookieData(this);
    this._pendingReadStorage = true;
    var initFromStorage = function initFromStorage(storedDeviceId) {
      if (opt_config && opt_config.deviceId && !utils.validateDeviceId(opt_config.deviceId)) {
        utils.log.error("Invalid device ID rejected. Randomly generated UUID will be used instead of \"".concat(opt_config.deviceId, "\""));
        delete opt_config.deviceId;
      }
      _this.options.deviceId = _this._getInitialDeviceId(opt_config && opt_config.deviceId, storedDeviceId);
      _this.options.userId = type(opt_userId) === 'string' && !utils.isEmptyString(opt_userId) && opt_userId || type(opt_userId) === 'number' && opt_userId.toString() || _this.options.userId || null;
      var now = new Date().getTime();
      var startNewSession = !_this._sessionId || !_this._lastEventTime || now - _this._lastEventTime > _this.options.sessionTimeout || _this.options.sessionId;
      if (startNewSession) {
        if (_this.options.unsetParamsReferrerOnNewSession) {
          _this._unsetUTMParams();
        }
        _this._newSession = true;
        _this._sessionId = _this.options.sessionId || now;
        // reset this.options.sessionId to avoid re-usage
        // use instance.getSessionId() to get session id
        _this.options.sessionId = undefined;

        // only capture UTM params and referrer if new session
        if (_this.options.saveParamsReferrerOncePerSession) {
          _this._trackParamsAndReferrer();
        }
      }
      if (!_this.options.saveParamsReferrerOncePerSession) {
        _this._trackParamsAndReferrer();
      }

      // load unsent events and identifies before any attempt to log new ones
      if (_this.options.saveEvents) {
        _validateUnsentEventQueue(_this._unsentEvents);
        _validateUnsentEventQueue(_this._unsentIdentifys);
      }
      _this._lastEventTime = now;
      _saveCookieData(_this);
      _this._pendingReadStorage = false;
      _this._sendEventsIfReady(); // try sending unsent events

      for (var i = 0; i < _this._onInitCallbacks.length; i++) {
        _this._onInitCallbacks[i](_this);
      }
      _this._onInitCallbacks = [];
      _this._isInitialized = true;
      if (startNewSession) {
        _this._runNewSessionStartCallbacks();
      }
    };
    if (this.options.saveEvents) {
      this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentEvents);
      this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentIdentifys);
    }
    if (opt_config && opt_config.onNewSessionStart) {
      this.onNewSessionStart(this.options.onNewSessionStart);
    }
    initFromStorage();
    this.runQueuedFunctions();
    if (type(opt_callback) === 'function') {
      opt_callback(this);
    }
    var onExitPage = this.options.onExitPage;
    if (type(onExitPage) === 'function' && GlobalScope.addEventListener) {
      if (!this.pageHandlersAdded) {
        this.pageHandlersAdded = true;
        var handleVisibilityChange = function handleVisibilityChange() {
          var prevTransport = _this.options.transport;
          _this.setTransport(Constants.TRANSPORT_BEACON);
          onExitPage();
          _this.setTransport(prevTransport);
        };

        // Monitoring just page exits because that is the most requested feature for now
        // "If you're specifically trying to detect page unload events, the pagehide event is the best option."
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
        GlobalScope.addEventListener('pagehide', function () {
          handleVisibilityChange();
        }, false);
      }
    }

    // Sets an event receiver to receive and forward exposure events from the experiment SDK.
    this._connector.eventBridge.setEventReceiver(function (event) {
      _this._logEvent(event.eventType, event.eventProperties, event.userProperties);
    });

    // Set the user ID and device ID in the core identity store to enable fetching variants.
    var editor = this._connector.identityStore.editIdentity();
    if (this.options.deviceId) {
      editor.setDeviceId(this.options.deviceId);
    }
    if (this.options.userId) {
      editor.setUserId(this.options.userId);
    }
    editor.commit();
  } catch (err) {
    utils.log.error(err);
    if (opt_config && type(opt_config.onError) === 'function') {
      opt_config.onError(err);
    }
  }
};
AmplitudeClient.prototype._runNewSessionStartCallbacks = function () {
  for (var i = 0; i < this._onNewSessionStartCallbacks.length; i++) {
    this._onNewSessionStartCallbacks[i](this);
  }
};
AmplitudeClient.prototype.deleteLowerLevelDomainCookies = function () {
  var host = utils.getHost();
  var cookieHost = this.options.domain && this.options.domain[0] === '.' ? this.options.domain.slice(1) : this.options.domain;
  if (!cookieHost || !utils.isWebWorkerEnvironment()) {
    return;
  }
  if (host !== cookieHost) {
    if (new RegExp(cookieHost + '$').test(host)) {
      var hostParts = host.split('.');
      var cookieHostParts = cookieHost.split('.');
      for (var i = hostParts.length; i > cookieHostParts.length; --i) {
        var deleteDomain = hostParts.slice(hostParts.length - i).join('.');
        baseCookie.set(this._cookieName, null, {
          domain: '.' + deleteDomain
        });
      }
      baseCookie.set(this._cookieName, null, {});
    }
  }
};
AmplitudeClient.prototype._getInitialDeviceId = function (configDeviceId, storedDeviceId) {
  if (configDeviceId) {
    return configDeviceId;
  }
  if (this.options.deviceIdFromUrlParam) {
    var deviceIdFromUrlParam = this._getDeviceIdFromUrlParam(this._getUrlParams());
    if (deviceIdFromUrlParam) {
      return deviceIdFromUrlParam;
    }
  }
  if (this.options.deviceId) {
    return this.options.deviceId;
  }
  if (storedDeviceId) {
    return storedDeviceId;
  }
  return base64Id();
};

// validate properties for unsent events
var _validateUnsentEventQueue = function _validateUnsentEventQueue(queue) {
  for (var i = 0; i < queue.length; i++) {
    var userProperties = queue[i].event.user_properties;
    var eventProperties = queue[i].event.event_properties;
    var groups = queue[i].event.groups;
    queue[i].event.user_properties = utils.validateProperties(userProperties);
    queue[i].event.event_properties = utils.validateProperties(eventProperties);
    queue[i].event.groups = utils.validateGroups(groups);
  }
};

/**
 * @private
 */
AmplitudeClient.prototype._trackParamsAndReferrer = function _trackParamsAndReferrer() {
  var utmProperties;
  var referrerProperties;
  var gclidProperties;
  var fbclidProperties;
  if (this.options.includeUtm) {
    utmProperties = this._initUtmData();
  }
  if (this.options.includeReferrer) {
    referrerProperties = this._saveReferrer(this._getReferrer());
  }
  if (this.options.includeGclid) {
    gclidProperties = this._saveGclid(this._getUrlParams());
  }
  if (this.options.includeFbclid) {
    fbclidProperties = this._saveFbclid(this._getUrlParams());
  }
  if (this.options.logAttributionCapturedEvent) {
    var attributionProperties = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, utmProperties), referrerProperties), gclidProperties), fbclidProperties);
    if (Object.keys(attributionProperties).length > 0) {
      this.logEvent(Constants.ATTRIBUTION_EVENT, attributionProperties);
    }
  }
};

/**
 * Parse and validate user specified config values and overwrite existing option value
 * DEFAULT_OPTIONS provides list of all config keys that are modifiable, as well as expected types for values
 * @private
 */
var _parseConfig = function _parseConfig(options, config) {
  if (type(config) !== 'object') {
    return;
  }

  // Add exception in headers
  var freeFormObjectKeys = new Set(['headers']);
  var zeroAllowedKeys = new Set(['eventUploadPeriodMillis']);

  // validates config value is defined, is the correct type, and some additional value sanity checks
  var parseValidateAndLoad = function parseValidateAndLoad(key) {
    if (!Object.prototype.hasOwnProperty.call(options, key)) {
      return; // skip bogus config values
    }
    var inputValue = config[key];
    var expectedType = type(options[key]);
    if (key === 'transport' && !utils.validateTransport(inputValue)) {
      return;
    } else if (key === 'sessionId' && inputValue !== null) {
      options[key] = utils.validateSessionId(inputValue) ? inputValue : null;
      return;
    } else if (!utils.validateInput(inputValue, key + ' option', expectedType)) {
      return;
    }
    if (expectedType === 'boolean') {
      options[key] = !!inputValue;
    } else if (expectedType === 'string' && !utils.isEmptyString(inputValue) || expectedType === 'number' && (inputValue > 0 || inputValue === 0 && zeroAllowedKeys.has(key)) || expectedType === 'function') {
      options[key] = inputValue;
    } else if (expectedType === 'object') {
      _parseConfig(options[key], inputValue);
    }
  };
  for (var key in config) {
    if (freeFormObjectKeys.has(key)) {
      options[key] = _objectSpread2$1(_objectSpread2$1({}, options[key]), config[key]);
    } else if (Object.prototype.hasOwnProperty.call(config, key)) {
      parseValidateAndLoad(key);
    }
  }
};

/**
 * Run functions queued up by proxy loading snippet
 * @private
 */
AmplitudeClient.prototype.runQueuedFunctions = function () {
  var queue = this._q;
  this._q = [];
  for (var i = 0; i < queue.length; i++) {
    var fn = this[queue[i][0]];
    if (type(fn) === 'function') {
      fn.apply(this, queue[i].slice(1));
    }
  }
};

/**
 * Check that the apiKey is set before calling a function. Logs a warning message if not set.
 * @private
 */
AmplitudeClient.prototype._apiKeySet = function _apiKeySet(methodName) {
  if (utils.isEmptyString(this.options.apiKey)) {
    utils.log.error('Invalid apiKey. Please set a valid apiKey with init() before calling ' + methodName);
    return false;
  }
  return true;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._loadSavedUnsentEvents = function _loadSavedUnsentEvents(unsentKey) {
  var savedUnsentEventsString = this._getFromStorage(localStorage$1$1, unsentKey);
  var unsentEvents = this._parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey);
  this._setInStorage(localStorage$1$1, unsentKey, JSON.stringify(unsentEvents));
  return unsentEvents;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._parseSavedUnsentEventsString = function _parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey) {
  if (utils.isEmptyString(savedUnsentEventsString)) {
    return []; // new app, does not have any saved events
  }
  if (type(savedUnsentEventsString) === 'string') {
    try {
      var events = JSON.parse(savedUnsentEventsString);
      if (type(events) === 'array') {
        // handle case where JSON dumping of unsent events is corrupted
        return events;
      }
    } catch (e) {} /* eslint-disable-line no-empty */
  }
  utils.log.error('Unable to load ' + unsentKey + ' events. Restart with a new empty queue.');
  return [];
};

/**
 * Returns true if a new session was created during initialization, otherwise false.
 * @public
 * @return {boolean} Whether a new session was created during initialization.
 */
AmplitudeClient.prototype.isNewSession = function isNewSession() {
  return this._newSession;
};

/**
 * Add callbacks to call after init. Useful for users who load Amplitude through a snippet.
 * @public
 */
AmplitudeClient.prototype.onInit = function onInit(callback) {
  if (this._isInitialized) {
    callback(this);
  } else {
    this._onInitCallbacks.push(callback);
  }
};

/**
 * Add callbacks to call after new session start.
 * @public
 */
AmplitudeClient.prototype.onNewSessionStart = function onNewSessionStart(callback) {
  this._onNewSessionStartCallbacks.push(callback);
};

/**
 * Returns the id of the current session.
 * @public
 * @return {number} Id of the current session.
 */
AmplitudeClient.prototype.getSessionId = function getSessionId() {
  return this._sessionId;
};

/**
 * Increments the eventId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextEventId = function nextEventId() {
  this._eventId++;
  return this._eventId;
};

/**
 * Increments the identifyId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextIdentifyId = function nextIdentifyId() {
  this._identifyId++;
  return this._identifyId;
};

/**
 * Increments the sequenceNumber and returns it.
 * @private
 */
AmplitudeClient.prototype.nextSequenceNumber = function nextSequenceNumber() {
  this._sequenceNumber++;
  return this._sequenceNumber;
};

/**
 * Returns the total count of unsent events and identifys
 * @private
 */
AmplitudeClient.prototype._unsentCount = function _unsentCount() {
  return this._unsentEvents.length + this._unsentIdentifys.length;
};

/**
 * Send events if ready. Returns true if events are sent.
 * @private
 */
AmplitudeClient.prototype._sendEventsIfReady = function _sendEventsIfReady() {
  if (this._unsentCount() === 0) {
    return false;
  }

  // if batching disabled, send any unsent events immediately
  if (!this.options.batchEvents) {
    this.sendEvents();
    return true;
  }

  // if batching enabled, check if min threshold met for batch size
  if (this._unsentCount() >= this.options.eventUploadThreshold) {
    this.sendEvents();
    return true;
  }

  // if beacon transport is activated, send events immediately
  // because there is no way to retry them later
  if (this.options.transport === Constants.TRANSPORT_BEACON) {
    this.sendEvents();
    return true;
  }

  // otherwise schedule an upload after 30s
  if (!this._updateScheduled) {
    // make sure we only schedule 1 upload
    this._updateScheduled = true;
    setTimeout(function () {
      this._updateScheduled = false;
      this.sendEvents();
    }.bind(this), this.options.eventUploadPeriodMillis);
  }
  return false; // an upload was scheduled, no events were uploaded
};

/**
 * Clears any stored events and metadata. Storage is then re-created on next event sending.
 * @public
 * @return {boolean} True if metadata was cleared, false if none existed
 */
AmplitudeClient.prototype.clearStorage = function clearStorage() {
  return this._metadataStorage.clear();
};

/**
 * Helper function to fetch values from storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._getFromStorage = function _getFromStorage(storage, key) {
  return storage.getItem(key + this._storageSuffix);
};

/**
 * Helper function to set values in storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._setInStorage = function _setInStorage(storage, key, value) {
  storage.setItem(key + this._storageSuffix, value);
};

/**
 * Fetches deviceId, userId, event meta data from amplitude cookie
 * @private
 */
var _loadCookieData = function _loadCookieData(scope) {
  if (!scope._useOldCookie) {
    var props = scope._metadataStorage.load();
    if (type(props) === 'object') {
      _loadCookieDataProps(scope, props);
    }
    return;
  }
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    return;
  }
};
var _upgradeCookieData = function _upgradeCookieData(scope) {
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    _saveCookieData(scope);
  }
};
var _loadCookieDataProps = function _loadCookieDataProps(scope, cookieData) {
  if (cookieData.deviceId) {
    scope.options.deviceId = cookieData.deviceId;
  }
  if (cookieData.userId) {
    scope.options.userId = cookieData.userId;
  }
  if (cookieData.optOut !== null && cookieData.optOut !== undefined) {
    // Do not clobber config opt out value if cookieData has optOut as false
    if (cookieData.optOut !== false) {
      scope.options.optOut = cookieData.optOut;
    }
  }
  if (cookieData.sessionId) {
    scope._sessionId = parseInt(cookieData.sessionId, 10);
  }
  if (cookieData.lastEventTime) {
    scope._lastEventTime = parseInt(cookieData.lastEventTime, 10);
  }
  if (cookieData.eventId) {
    scope._eventId = parseInt(cookieData.eventId, 10);
  }
  if (cookieData.identifyId) {
    scope._identifyId = parseInt(cookieData.identifyId, 10);
  }
  if (cookieData.sequenceNumber) {
    scope._sequenceNumber = parseInt(cookieData.sequenceNumber, 10);
  }
};

/**
 * Saves deviceId, userId, event meta data to amplitude cookie
 * @private
 */
var _saveCookieData = function _saveCookieData(scope) {
  var cookieData = {
    deviceId: scope.options.deviceId,
    userId: scope.options.userId,
    optOut: scope.options.optOut,
    sessionId: scope._sessionId,
    lastEventTime: scope._lastEventTime,
    eventId: scope._eventId,
    identifyId: scope._identifyId,
    sequenceNumber: scope._sequenceNumber
  };
  if (scope._useOldCookie) {
    scope.cookieStorage.set(scope.options.cookieName + scope._storageSuffix, cookieData);
  } else {
    scope._metadataStorage.save(cookieData);
  }
};

/**
 * Parse the utm properties out of cookies and query for adding to user properties.
 * @private
 */
AmplitudeClient.prototype._initUtmData = function _initUtmData(queryParams, cookieParams) {
  queryParams = queryParams || this._getUrlParams();
  cookieParams = cookieParams || this.cookieStorage.get('__utmz');
  var utmProperties = getUtmData$1(cookieParams, queryParams);
  _sendParamsReferrerUserProperties(this, utmProperties);
  return utmProperties;
};

/**
 * Unset the utm params from the Amplitude instance and update the identify.
 * @private
 */
AmplitudeClient.prototype._unsetUTMParams = function _unsetUTMParams() {
  var identify = new Identify();
  identify.unset(Constants.REFERRER);
  identify.unset(Constants.REFERRING_DOMAIN);
  identify.unset(Constants.UTM_SOURCE);
  identify.unset(Constants.UTM_MEDIUM);
  identify.unset(Constants.UTM_CAMPAIGN);
  identify.unset(Constants.UTM_TERM);
  identify.unset(Constants.UTM_CONTENT);
  this.identify(identify);
};

/**
 * The calling function should determine when it is appropriate to send these user properties. This function
 * will no longer contain any session storage checking logic.
 * @private
 */
var _sendParamsReferrerUserProperties = function _sendParamsReferrerUserProperties(scope, userProperties) {
  if (type(userProperties) !== 'object' || Object.keys(userProperties).length === 0) {
    return;
  }

  // setOnce the initial user properties
  var identify = new Identify();
  for (var key in userProperties) {
    if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
      identify.setOnce('initial_' + key, userProperties[key]);
      identify.set(key, userProperties[key]);
    }
  }
  scope.identify(identify);
};

/**
 * @private
 */
AmplitudeClient.prototype._getReferrer = function _getReferrer() {
  var urlRefer = this._getReferrerFromUrlParam(this._getUrlParams());
  if (urlRefer) return urlRefer;else return typeof document !== 'undefined' ? document.referrer : '';
};

/**
 * @private
 */
AmplitudeClient.prototype._getUrlParams = function _getUrlParams() {
  return GlobalScope.location.search;
};

/**
 * Try to fetch Google Gclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveGclid = function _saveGclid(urlParams) {
  var gclid = utils.getQueryParam('gclid', urlParams);
  if (utils.isEmptyString(gclid)) {
    return;
  }
  var gclidProperties = {
    gclid: gclid
  };
  _sendParamsReferrerUserProperties(this, gclidProperties);
  return gclidProperties;
};

/**
 * Try to fetch Facebook Fbclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveFbclid = function _saveFbclid(urlParams) {
  var fbclid = utils.getQueryParam('fbclid', urlParams);
  if (utils.isEmptyString(fbclid)) {
    return;
  }
  var fbclidProperties = {
    fbclid: fbclid
  };
  _sendParamsReferrerUserProperties(this, fbclidProperties);
  return fbclidProperties;
};

/**
 * Try to fetch Amplitude device id from url params.
 * @private
 */
AmplitudeClient.prototype._getDeviceIdFromUrlParam = function _getDeviceIdFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_DEVICE_ID_PARAM, urlParams);
};

/**
 * Try to fetch referrer from url params.
 * @private
 */
AmplitudeClient.prototype._getReferrerFromUrlParam = function _getReferrerFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_REFERRER_PARAM, urlParams);
};

/**
 * Parse the domain from referrer info
 * @private
 */
AmplitudeClient.prototype._getReferringDomain = function _getReferringDomain(referrer) {
  if (utils.isEmptyString(referrer)) {
    return null;
  }
  var parts = referrer.split('/');
  if (parts.length >= 3) {
    return parts[2];
  }
  return null;
};

/**
 * Fetch the referrer information, parse the domain and send.
 * Since user properties are propagated on the server, only send once per session, don't need to send with every event
 * @private
 */
AmplitudeClient.prototype._saveReferrer = function _saveReferrer(referrer) {
  if (utils.isEmptyString(referrer)) {
    return;
  }
  var referrerInfo = {
    referrer: referrer,
    referring_domain: this._getReferringDomain(referrer)
  };
  _sendParamsReferrerUserProperties(this, referrerInfo);
  return referrerInfo;
};

/**
 * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
 * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
 * @private
 */
AmplitudeClient.prototype.saveEvents = function saveEvents() {
  try {
    var serializedUnsentEvents = JSON.stringify(this._unsentEvents.map(function (_ref) {
      var event = _ref.event;
      return event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentKey, serializedUnsentEvents);
  } catch (e) {} /* eslint-disable-line no-empty */

  try {
    var serializedIdentifys = JSON.stringify(this._unsentIdentifys.map(function (unsentIdentify) {
      return unsentIdentify.event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentIdentifyKey, serializedIdentifys);
  } catch (e) {} /* eslint-disable-line no-empty */
};

/**
 * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
 * @public
 * @param {string} domain to set.
 * @example amplitudeClient.setDomain('.amplitude.com');
 */
AmplitudeClient.prototype.setDomain = function setDomain(domain) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDomain'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(domain, 'domain', 'string')) {
    return;
  }
  try {
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      secure: this.options.secureCookie,
      domain: domain,
      sameSite: this.options.sameSiteCookie
    });
    this.options.domain = this.cookieStorage.options().domain;
    _loadCookieData(this);
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets an identifier for the current user.
 * @public
 * @param {string} userId - identifier to set. Can be null.
 * @param {boolean} startNewSession - (optional) if start a new session or not
 * @example amplitudeClient.setUserId('joe@gmail.com');
 */
AmplitudeClient.prototype.setUserId = function setUserId(userId) {
  var startNewSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!utils.validateInput(startNewSession, 'startNewSession', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.userId = userId !== undefined && userId !== null && '' + userId || null;
    if (startNewSession) {
      if (this.options.unsetParamsReferrerOnNewSession) {
        this._unsetUTMParams();
      }
      this._newSession = true;
      this._sessionId = new Date().getTime();
      this._runNewSessionStartCallbacks();

      // only capture UTM params and referrer if new session
      if (this.options.saveParamsReferrerOncePerSession) {
        this._trackParamsAndReferrer();
      }
    }
    _saveCookieData(this);

    // Update core identity store to propagate new user info
    // to experiment SDK and trigger a fetch if the ID has changed.
    if (this._connector) {
      this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Add user to a group or groups. You need to specify a groupType and groupName(s).
 *
 * For example you can group people by their organization.
 * In that case, groupType is "orgId" and groupName would be the actual ID(s).
 * groupName can be a string or an array of strings to indicate a user in multiple gruups.
 * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
 *
 * Note: this will also set groupType: groupName as a user property.
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
 * @public
 * @param {string} groupType - the group type (ex: orgId)
 * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
 * @example amplitudeClient.setGroup('orgId', 15); // this adds the current user to orgId 15.
 */
AmplitudeClient.prototype.setGroup = function (groupType, groupName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setGroup'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setGroup()') || !utils.validateInput(groupType, 'groupType', 'string') || utils.isEmptyString(groupType)) {
    return;
  }
  var groups = {};
  groups[groupType] = groupName;
  var identify = new Identify().set(groupType, groupName);
  this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify.userPropertiesOperations, groups, null, null, null);
};

/**
 * Sets whether to opt current user out of tracking.
 * @public
 * @param {boolean} enable - if true then no events will be logged or sent.
 * @example: amplitude.setOptOut(true);
 */
AmplitudeClient.prototype.setOptOut = function setOptOut(enable) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setOptOut'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(enable, 'enable', 'boolean')) {
    return;
  }
  try {
    this.options.optOut = enable;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Set a custom Session ID for the current session.
 * Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * The Session ID to set for the current session must be in milliseconds since epoch (Unix Timestamp).
 * @public
 * @param {int} sessionId to set.
 * @example amplitudeClient.setSessionId(1622158968000);
 */
AmplitudeClient.prototype.setSessionId = function setSessionId(sessionId) {
  if (!utils.validateInput(sessionId, 'sessionId', 'number')) {
    return;
  }
  try {
    this._sessionId = sessionId;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the current Unix timestamp as the new Session ID for the instance.
 * @public
 * @example amplitudeClient.resetSessionId();
 */
AmplitudeClient.prototype.resetSessionId = function resetSessionId() {
  this.setSessionId(new Date().getTime());
};

/**
 * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
 * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
 * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
 * This uses src/uuid.js to regenerate the deviceId.
 * @public
 */
AmplitudeClient.prototype.regenerateDeviceId = function regenerateDeviceId() {
  if (this._shouldDeferCall()) {
    return this._q.push(['regenerateDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  this.setDeviceId(base64Id());
};

/**
 * Sets a custom deviceId for current user. **Values may not have `.` inside them**
 * Note: this is not recommended unless you know what you are doing (like if you have your own system for managing deviceIds).
 * Make sure the deviceId you set is sufficiently unique
 * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
 * @public
 * @param {string} deviceId - custom deviceId for current user.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */
AmplitudeClient.prototype.setDeviceId = function setDeviceId(deviceId) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateDeviceId(deviceId)) {
    return;
  }
  try {
    if (!utils.isEmptyString(deviceId)) {
      this.options.deviceId = '' + deviceId;
      _saveCookieData(this);

      // Update core identity store to propagate new user info
      // to experiment SDK and trigger a fetch if the ID has changed.
      if (this._connector) {
        this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit();
      }
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the network transport type for events. Typically used to set to 'beacon'
 * on an end-of-lifecycle event handler such as `onpagehide` or `onvisibilitychange`
 * @public
 * @param {string} transport - transport mechanism to use for events. Must be one of `http` or `beacon`.
 * @example amplitudeClient.setTransport('beacon');
 */
AmplitudeClient.prototype.setTransport = function setTransport(transport) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setTransport'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateTransport(transport)) {
    return;
  }
  this.options.transport = transport;
};

/**
 * Sets user properties for the current user.
 * @public
 * @param {object} - object with string keys and values for the user properties to set.
 * @param {boolean} - DEPRECATED opt_replace: in earlier versions of the JS SDK the user properties object was kept in
 * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
 * @example amplitudeClient.setUserProperties({'gender': 'female', 'sign_up_complete': true})
 */
AmplitudeClient.prototype.setUserProperties = function setUserProperties(userProperties) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setUserProperties()') || !utils.validateInput(userProperties, 'userProperties', 'object')) {
    return;
  }
  // sanitize the userProperties dict before converting into identify
  var sanitized = utils.truncate(utils.validateProperties(userProperties));
  if (Object.keys(sanitized).length === 0) {
    return;
  }

  // convert userProperties into an identify call
  var identify = new Identify();
  for (var property in sanitized) {
    if (Object.prototype.hasOwnProperty.call(sanitized, property)) {
      identify.set(property, sanitized[property]);
    }
  }
  this.identify(identify);
};

/**
 * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
 * @public
 * @example amplitudeClient.clearUserProperties();
 */
AmplitudeClient.prototype.clearUserProperties = function clearUserProperties() {
  if (this._shouldDeferCall()) {
    return this._q.push(['clearUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('clearUserProperties()')) {
    return;
  }
  var identify = new Identify();
  identify.clearAll();
  this.identify(identify);
};

/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 * @private
 */
var _convertProxyObjectToRealObject = function _convertProxyObjectToRealObject(instance, proxy) {
  for (var i = 0; i < proxy._q.length; i++) {
    var fn = instance[proxy._q[i][0]];
    if (type(fn) === 'function') {
      fn.apply(instance, proxy._q[i].slice(1));
    }
  }
  return instance;
};

/**
 * Send an identify call containing user property operations to Amplitude servers.
 * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
 * reference page for more information on the Identify API and user property operations.
 * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
 * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
 * Note: the server response code and response body from the identify event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example
 * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
 * amplitude.identify(identify);
 */
AmplitudeClient.prototype.identify = function (identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['identify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('identify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify_obj.userPropertiesOperations, null, null, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No user property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};
AmplitudeClient.prototype.groupIdentify = function (group_type, group_name, identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['groupIdentify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('groupIdentify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }
  if (!utils.validateInput(group_type, 'group_type', 'string') || utils.isEmptyString(group_type)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group type'
    });
    return;
  }
  if (group_name === null || group_name === undefined) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group name'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.GROUP_IDENTIFY_EVENT, null, null, null, _defineProperty$1({}, group_type, group_name), identify_obj.userPropertiesOperations, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No group property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};

/**
 * Set a versionName for your application.
 * @public
 * @param {string} versionName - The version to set for your application.
 * @example amplitudeClient.setVersionName('1.12.3');
 */
AmplitudeClient.prototype.setVersionName = function setVersionName(versionName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setVersionName'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(versionName, 'versionName', 'string')) {
    return;
  }
  this.options.versionName = versionName;
};

/**
 * Private logEvent method. Keeps apiProperties from being publicly exposed.
 * @private
 */
AmplitudeClient.prototype._logEvent = function _logEvent(eventType, eventProperties, apiProperties, userProperties, groups, groupProperties, timestamp, callback, errorCallback, outOfSession) {
  _loadCookieData(this); // reload cookie before each log event to sync event meta-data between windows and tabs

  if (!eventType) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return;
  }
  if (this.options.optOut) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'optOut is set to true'
    });
    return;
  }
  try {
    var eventId;
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      eventId = this.nextIdentifyId();
    } else {
      eventId = this.nextEventId();
    }
    var sequenceNumber = this.nextSequenceNumber();
    var eventTime = type(timestamp) === 'number' ? timestamp : new Date().getTime();
    if (outOfSession) {
      this._sessionId = -1;
    } else if (!this._sessionId || !this._lastEventTime || eventTime - this._lastEventTime > this.options.sessionTimeout) {
      this._sessionId = eventTime;
      this._runNewSessionStartCallbacks();
    }
    this._lastEventTime = eventTime;
    _saveCookieData(this);
    var osName = this._ua.browser.name;
    var osVersion = this._ua.browser.major;
    var deviceModel = this._ua.device.model || this._ua.os.name;
    var deviceVendor = this._ua.device.vendor;
    userProperties = userProperties || {};
    var trackingOptions = _objectSpread2$1({}, this._apiPropertiesTrackingOptions);
    apiProperties = _objectSpread2$1(_objectSpread2$1({}, apiProperties || {}), trackingOptions);
    eventProperties = eventProperties || {};
    groups = groups || {};
    groupProperties = groupProperties || {};
    var event = {
      device_id: this.options.deviceId,
      user_id: this.options.userId,
      timestamp: eventTime,
      event_id: eventId,
      session_id: this._sessionId || -1,
      event_type: eventType,
      version_name: this.options.versionName || null,
      platform: _shouldTrackField(this, 'platform') ? this.options.platform : null,
      os_name: _shouldTrackField(this, 'os_name') ? osName || null : null,
      os_version: _shouldTrackField(this, 'os_version') ? osVersion || null : null,
      device_model: _shouldTrackField(this, 'device_model') ? deviceModel || null : null,
      device_manufacturer: _shouldTrackField(this, 'device_manufacturer') ? deviceVendor || null : null,
      language: _shouldTrackField(this, 'language') ? this.options.language : null,
      api_properties: apiProperties,
      event_properties: utils.truncate(utils.validateProperties(eventProperties)),
      user_properties: utils.truncate(utils.validateProperties(userProperties)),
      uuid: uuid$1(),
      library: this.options.library,
      sequence_number: sequenceNumber,
      // for ordering events and identifys
      groups: utils.truncate(utils.validateGroups(groups)),
      group_properties: utils.truncate(utils.validateProperties(groupProperties)),
      user_agent: this._userAgent,
      partner_id: this.options.partnerId || null
    };
    if (_isObservePlanSet(this)) {
      event.plan = {
        branch: this.options.plan.branch || undefined,
        source: this.options.plan.source || undefined,
        version: this.options.plan.version || undefined,
        versionId: this.options.plan.versionId || undefined
      };
    }
    if (_isIngestionMetadataSet(this)) {
      event.ingestion_metadata = {
        source_name: this.options.ingestionMetadata.sourceName || undefined,
        source_version: this.options.ingestionMetadata.sourceVersion || undefined
      };
    }
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      this._unsentIdentifys.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentIdentifys);
    } else {
      this._unsentEvents.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentEvents);
    }
    if (this.options.saveEvents) {
      this.saveEvents();
    }
    this._sendEventsIfReady();

    // In the case of an identify event, update the core user store so the experiment SDK can fetch new variants and
    // utilize user properties in real time.
    if (eventType === Constants.IDENTIFY_EVENT && this._connector) {
      this._connector.identityStore.editIdentity().updateUserProperties(utils.truncate(utils.validateProperties(userProperties))).commit();
    }
    return eventId;
  } catch (e) {
    utils.log.error(e);
  }
};
var _isObservePlanSet = function _isObservePlanSet(scope) {
  return scope.options.plan && (scope.options.plan.source || scope.options.plan.branch || scope.options.plan.version || scope.options.plan.versionId);
};
var _isIngestionMetadataSet = function _isIngestionMetadataSet(scope) {
  return scope.options.ingestionMetadata && (scope.options.ingestionMetadata.sourceName || scope.options.ingestionMetadata.sourceVersion);
};
var _shouldTrackField = function _shouldTrackField(scope, field) {
  return !!scope.options.trackingOptions[field];
};
var _generateApiPropertiesTrackingConfig = function _generateApiPropertiesTrackingConfig(scope) {
  // to limit size of config payload, only send fields that have been disabled
  var fields = ['city', 'country', 'dma', 'ip_address', 'region'];
  var config = {};
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    if (!_shouldTrackField(scope, field)) {
      config[field] = false;
    }
  }
  return config;
};

/**
 * Remove old events from the beginning of the array if too many have accumulated. Default limit is 1000 events.
 * @private
 */
AmplitudeClient.prototype._limitEventsQueued = function _limitEventsQueued(queue) {
  if (queue.length > this.options.savedMaxCount) {
    var deletedEvents = queue.splice(0, queue.length - this.options.savedMaxCount);
    deletedEvents.forEach(function (event) {
      _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
        reason: 'Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker'
      });
    });
  }
};

/**
 * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
 * and the server response code and response body from the upload request are passed to the callback function.
 * @callback Amplitude~eventCallback
 * @param {number} responseCode - Server response code for the event / identify upload request.
 * @param {string} responseBody - Server response body for the event / identify upload request.
 * @param {object} details - (optional) Additional information associated with sending event.
 */

/**
 * Log an event with eventType and eventProperties
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if this event is out of session or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */
AmplitudeClient.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEvent'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  return this.logEventWithTimestamp(eventType, eventProperties, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType and eventProperties and a custom timestamp
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {number} timestamp - (optional) the custom timestamp as milliseconds since epoch.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if out of the sessioin or not
 * @example amplitudeClient.logEventWithTimestamp('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15}, Date.now());
 */
AmplitudeClient.prototype.logEventWithTimestamp = function logEvent(eventType, eventProperties, timestamp, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithTimestamp'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEvent()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (utils.isEmptyString(eventType)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, null, null, timestamp, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
 * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
 * (unless you explicitly set it with setGroup).
 *
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
 * about groups and Count by Distinct on the Amplitude platform.
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
 * groupName can be a string or an array of strings.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example amplitudeClient.logEventWithGroups('Clicked Button', null, {'orgId': 24});
 */
AmplitudeClient.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithGroups'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEventWithGroups()')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, groups, null, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Test that n is a number or a numeric value.
 * @private
 */
var _isNumber = function _isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 * Handles errors that are sent to both callbacks
 * @private
 */
var _logErrorsWithCallbacks = function _logErrorsWithCallbacks(opt_callback, opt_error_callback, status, response, details) {
  if (type(opt_callback) === 'function') {
    opt_callback(status, response, details);
  }
  if (type(opt_error_callback) === 'function') {
    opt_error_callback(status, response, details);
  }
};

/**
 * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
 * revenueType and event properties.
 *
 * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
 * reference page for more information on the Revenue interface and logging revenue.
 * @public
 * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
AmplitudeClient.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
  if (this._shouldDeferCall()) {
    return this._q.push(['logRevenueV2'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logRevenueV2()')) {
    return;
  }

  // if revenue input is a proxied object created by the async loading snippet, convert it into an revenue object
  if (type(revenue_obj) === 'object' && Object.prototype.hasOwnProperty.call(revenue_obj, '_q')) {
    revenue_obj = _convertProxyObjectToRealObject(new Revenue(), revenue_obj);
  }
  if (revenue_obj instanceof Revenue) {
    // only send if revenue is valid
    if (revenue_obj && revenue_obj._isValidRevenue()) {
      return this.logEvent(Constants.REVENUE_EVENT, revenue_obj._toJSONObject());
    }
  } else {
    utils.log.error('Invalid revenue input type. Expected Revenue object but saw ' + type(revenue_obj));
  }
};
{
  /**
   * Log revenue event with a price, quantity, and product identifier. DEPRECATED - use logRevenueV2
   * @public
   * @deprecated
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @example amplitudeClient.logRevenue(3.99, 1, 'product_1234');
   */
  AmplitudeClient.prototype.logRevenue = function logRevenue(price, quantity, product) {
    if (this._shouldDeferCall()) {
      return this._q.push(['logRevenue'].concat(Array.prototype.slice.call(arguments, 0)));
    }

    // Test that the parameters are of the right type.
    if (!this._apiKeySet('logRevenue()') || !_isNumber(price) || quantity !== undefined && !_isNumber(quantity)) {
      // utils.log('Price and quantity arguments to logRevenue must be numbers');
      return -1;
    }
    return this._logEvent(Constants.REVENUE_EVENT, {}, {
      productId: product,
      special: 'revenue_amount',
      quantity: quantity || 1,
      price: price
    }, null, null, null, null, null);
  };
}

/**
 * Calls error callback on unsent events
 * @private
 */
AmplitudeClient.prototype._logErrorsOnEvents = function _logErrorsOnEvents(maxEventId, maxIdentifyId, status, response) {
  var queues = ['_unsentEvents', '_unsentIdentifys'];
  for (var j = 0; j < queues.length; j++) {
    var queue = queues[j];
    var maxId = queue === '_unsentEvents' ? maxEventId : maxIdentifyId;
    for (var i = 0; i < this[queue].length || 0; i++) {
      var unsentEvent = this[queue][i];
      if (unsentEvent.event.event_id <= maxId) {
        if (unsentEvent.errorCallback) {
          unsentEvent.errorCallback(status, response);
        }
      }
    }
  }
};

/**
 * Remove events in storage with event ids up to and including maxEventId.
 * @private
 */
AmplitudeClient.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId, status, response) {
  _removeEvents(this, '_unsentEvents', maxEventId, status, response);
  _removeEvents(this, '_unsentIdentifys', maxIdentifyId, status, response);
};

/**
 * Helper function to remove events up to maxId from a single queue.
 * Does a true filter in case events get out of order or old events are removed.
 * @private
 */
var _removeEvents = function _removeEvents(scope, eventQueue, maxId, status, response) {
  if (maxId < 0) {
    return;
  }
  var filteredEvents = [];
  for (var i = 0; i < scope[eventQueue].length || 0; i++) {
    var unsentEvent = scope[eventQueue][i];
    if (unsentEvent.event.event_id > maxId) {
      filteredEvents.push(unsentEvent);
    } else {
      if (unsentEvent.callback) {
        unsentEvent.callback(status, response);
      }
    }
  }
  scope[eventQueue] = filteredEvents;
};

/**
 * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
 * If batchEvents is true, then events are only sent when batch criterias are met.
 * @private
 */
AmplitudeClient.prototype.sendEvents = function sendEvents() {
  if (!this._apiKeySet('sendEvents()')) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return;
  }
  if (this.options.optOut) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'Opt out is set to true'
    });
    return;
  }

  // How is it possible to get into this state?
  if (this._unsentCount() === 0) {
    return;
  }

  // We only make one request at a time. sendEvents will be invoked again once
  // the last request completes.
  // beacon data is sent synchronously, so don't pause for it
  if (this.options.transport !== Constants.TRANSPORT_BEACON) {
    if (this._sending) {
      return;
    }
    this._sending = true;
  }
  var protocol = this.options.forceHttps ? 'https' : 'https:' === GlobalScope.location.protocol ? 'https' : 'http';
  var url = protocol + '://' + this.options.apiEndpoint;

  // fetch events to send
  var numEvents = Math.min(this._unsentCount(), this.options.uploadBatchSize);
  var mergedEvents = this._mergeEventsAndIdentifys(numEvents);
  var maxEventId = mergedEvents.maxEventId;
  var maxIdentifyId = mergedEvents.maxIdentifyId;
  var events = JSON.stringify(mergedEvents.eventsToSend.map(function (_ref2) {
    var event = _ref2.event;
    return event;
  }));
  var uploadTime = new Date().getTime();
  var data = {
    client: this.options.apiKey,
    e: events,
    v: Constants.API_VERSION,
    upload_time: uploadTime,
    checksum: md5(Constants.API_VERSION + this.options.apiKey + events + uploadTime)
  };
  if (this.options.transport === Constants.TRANSPORT_BEACON && typeof navigator !== 'undefined') {
    var success = navigator.sendBeacon(url, new URLSearchParams(data));
    if (success) {
      this.removeEvents(maxEventId, maxIdentifyId, 200, 'success');
      if (this.options.saveEvents) {
        this.saveEvents();
      }
    } else {
      this._logErrorsOnEvents(maxEventId, maxIdentifyId, 0, '');
    }
    return;
  }
  var scope = this;
  try {
    new Request$1(url, data, this.options.headers).send(function (status, response) {
      scope._sending = false;
      try {
        if (status === 200) {
          scope.removeEvents(maxEventId, maxIdentifyId, status, response);

          // Update the event cache after the removal of sent events.
          if (scope.options.saveEvents) {
            scope.saveEvents();
          }

          // Send more events if any queued during previous send.
          scope._sendEventsIfReady();

          // handle payload too large
        } else {
          scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
          if (status === 413) {
            // utils.log('request too large');
            // Can't even get this one massive event through. Drop it, even if it is an identify.
            if (scope.options.uploadBatchSize === 1) {
              scope.removeEvents(maxEventId, maxIdentifyId, status, response);
            }

            // The server complained about the length of the request. Backoff and try again.
            scope.options.uploadBatchSize = Math.ceil(numEvents / 2);
            scope.sendEvents();
          }
        }
        // else {
        //  all the events are still queued, and will be retried when the next
        //  event is sent In the interest of debugging, it would be nice to have
        //  something like an event emitter for a better debugging experince
        //  here.
        // }
      } catch (e) {
        // utils.log.error('failed upload');
      }
    });
  } catch (e) {
    var status = 0,
      response = 'Request failed to send';
    utils.log.error(response);
    scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
    scope.removeEvents(maxEventId, maxIdentifyId, status, response, {
      reason: e.message
    });
  }
};

/**
 * Merge unsent events and identifys together in sequential order based on their sequence number, for uploading.
 * Identifys given higher priority than Events. Also earlier sequence given priority
 * @private
 */
AmplitudeClient.prototype._mergeEventsAndIdentifys = function _mergeEventsAndIdentifys(numEvents) {
  // coalesce events from both queues
  var eventsToSend = [];
  var eventIndex = 0;
  var maxEventId = -1;
  var identifyIndex = 0;
  var maxIdentifyId = -1;
  while (eventsToSend.length < numEvents) {
    var unsentEvent = void 0;
    var noIdentifys = identifyIndex >= this._unsentIdentifys.length;
    var noEvents = eventIndex >= this._unsentEvents.length;

    // case 0: no events or identifys left
    // note this should not happen, this means we have less events and identifys than expected
    if (noEvents && noIdentifys) {
      utils.log.error('Merging Events and Identifys, less events and identifys than expected');
      break;
    }

    // case 1: no identifys - grab from events
    else if (noIdentifys) {
      unsentEvent = this._unsentEvents[eventIndex++];
      maxEventId = unsentEvent.event.event_id;

      // case 2: no events - grab from identifys
    } else if (noEvents) {
      unsentEvent = this._unsentIdentifys[identifyIndex++];
      maxIdentifyId = unsentEvent.event.event_id;

      // case 3: need to compare sequence numbers
    } else {
      // events logged before v2.5.0 won't have a sequence number, put those first
      if (!('sequence_number' in this._unsentEvents[eventIndex].event) || this._unsentEvents[eventIndex].event.sequence_number < this._unsentIdentifys[identifyIndex].event.sequence_number) {
        unsentEvent = this._unsentEvents[eventIndex++];
        maxEventId = unsentEvent.event.event_id;
      } else {
        unsentEvent = this._unsentIdentifys[identifyIndex++];
        maxIdentifyId = unsentEvent.event.event_id;
      }
    }
    eventsToSend.push(unsentEvent);
  }
  return {
    eventsToSend: eventsToSend,
    maxEventId: maxEventId,
    maxIdentifyId: maxIdentifyId
  };
};
{
  /**
   * Set global user properties. Note this is deprecated, and we recommend using setUserProperties
   * @public
   * @deprecated
   */
  AmplitudeClient.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
AmplitudeClient.prototype.__VERSION__ = function getVersion() {
  return this.options.library.version;
};

/**
 * Sets the library name and version. Default is `amplitude-js` and the version defined in package.json. Used if you're building another library on top of amplitude-js and want a custom data source value
 * @public
 * @param {string} name - Custom library name
 * @param {string} version - Custom library version
 */
AmplitudeClient.prototype.setLibrary = function setLibrary(name, version) {
  if (name !== null && typeof name !== 'undefined') {
    this.options.library.name = name;
  }
  if (version !== null && typeof version !== 'undefined') {
    this.options.library.version = version;
  }
};

/**
 * Determines whether or not to push call to this._q or invoke it
 * @private
 */
AmplitudeClient.prototype._shouldDeferCall = function _shouldDeferCall() {
  return this._pendingReadStorage || this._initializationDeferred;
};

/**
 * Defers Initialization by putting all functions into storage until users
 * have accepted terms for tracking
 * @private
 */
AmplitudeClient.prototype._deferInitialization = function _deferInitialization() {
  this._initializationDeferred = true;
  this._q.push(['init'].concat(Array.prototype.slice.call(arguments, 0)));
};

/**
 * Enable tracking via logging events and dropping a cookie
 * Intended to be used with the deferInitialization configuration flag
 * This will drop a cookie and reset initialization deferred
 * @public
 */
AmplitudeClient.prototype.enableTracking = function enableTracking() {
  // This will call init (which drops the cookie) and will run any pending tasks
  this._initializationDeferred = false;
  _saveCookieData(this);
  this.runQueuedFunctions();
};

/**
 * Find best server url if choose to enable dynamic configuration.
 */
AmplitudeClient.prototype._refreshDynamicConfig = function _refreshDynamicConfig() {
  if (this.options.useDynamicConfig) {
    instance$1.refresh(this.options.serverZone, this.options.forceHttps, function () {
      this.options.apiEndpoint = instance$1.ingestionEndpoint;
    }.bind(this));
  }
};

/**
 * Returns the deviceId value.
 * @public
 * @return {string} Id of current device.
 */
AmplitudeClient.prototype.getDeviceId = function getDeviceId() {
  return this.options.deviceId;
};

/**
 * Returns the userId.
 * @public
 * @return {string} Id of current user.
 */
AmplitudeClient.prototype.getUserId = function getUserId() {
  return this.options.userId;
};

/**
 * Set a custom session expiration time.
 * @public
 * @param {number} timeInMillis - session expireation time in milliseconds.
 */
AmplitudeClient.prototype.setMinTimeBetweenSessionsMillis = function setMinTimeBetweenSessionsMillis(timeInMillis) {
  if (!utils.validateInput(timeInMillis, 'timeInMillis', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setMinTimeBetweenSessionsMillis'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.sessionTimeout = timeInMillis;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets minimum number of events to batch together per request if batchEvents is true.
 * @public
 * @param {number} eventUploadThreshold - The number of the event upload threshold. Default value is 30.
 * @example amplitudeClient.setEventUploadThreshold(10);
 */
AmplitudeClient.prototype.setEventUploadThreshold = function setEventUploadThreshold(eventUploadThreshold) {
  if (!utils.validateInput(eventUploadThreshold, 'eventUploadThreshold', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setEventUploadThreshold'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.eventUploadThreshold = eventUploadThreshold;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Dynamically adjust server URL
 * @public
 * @param {bool} useDynamicConfig - if enable dynamic config or not.
 * @example amplitudeClient.setUseDynamicConfig(true);
 */
AmplitudeClient.prototype.setUseDynamicConfig = function setUseDynamicConfig(useDynamicConfig) {
  if (!utils.validateInput(useDynamicConfig, 'useDynamicConfig', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUseDynamicConfig'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.useDynamicConfig = useDynamicConfig;
    this._refreshDynamicConfig();
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server zone, used for server api endpoint and dynamic configuration.
 * @public
 * @param {string} serverZone - the server zone value. AmplitudeServerZone.US or AmplitudeServerZone.EU.
 * @param {bool} serverZoneBasedApi - (optional) update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @example amplitudeClient.setServerZone(AmplitudeServerZone.EU, true);
 */
AmplitudeClient.prototype.setServerZone = function setServerZone(serverZone) {
  var serverZoneBasedApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (serverZone !== AmplitudeServerZone.EU && serverZone !== AmplitudeServerZone.US || !utils.validateInput(serverZoneBasedApi, 'serverZoneBasedApi', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerZone'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.serverZone = serverZone;
    this.options.serverZoneBasedApi = serverZoneBasedApi;
    if (serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server URL for the request.
 * @public
 * @param {string} serverUrl - The value of the server URL.
 * @example amplitudeClient.setServerUrl('api.amplitude.com');
 */
AmplitudeClient.prototype.setServerUrl = function setServerUrl(serverUrl) {
  if (!utils.validateInput(serverUrl, 'serverUrl', 'string')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerUrl'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.apiEndpoint = serverUrl;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Deprecated legacy API of the Amplitude JS SDK - instance manager.
 *
 * Wraps around the current [AmplitudeClient](https://amplitude.github.io/Amplitude-JavaScript/) which provides more features
 * Function calls directly on amplitude have been deprecated. Please call methods on the default shared instance: amplitude.getInstance() instead.
 *
 * See the [3.0.0 changelog](https://github.com/amplitude/Amplitude-JavaScript/blob/ed405afb5f06d5cf5b72539a5d09179abcf7e1fe/README.md#300-update-and-logging-events-to-multiple-amplitude-apps) for more information about this change.
 * @constructor Amplitude
 * @public
 * @deprecated
 * @example var amplitude = new Amplitude();
 */
var Amplitude = function Amplitude() {
  this.options = _objectSpread2$1({}, DEFAULT_OPTIONS);
  this._q = [];
  this._instances = {}; // mapping of instance names to instances
};
Amplitude.prototype.Identify = Identify;
Amplitude.prototype.Revenue = Revenue;
Amplitude.prototype.getInstance = function getInstance(instance) {
  instance = utils.isEmptyString(instance) ? Constants.DEFAULT_INSTANCE : instance.toLowerCase();
  var client = this._instances[instance];
  if (client === undefined) {
    client = new AmplitudeClient(instance);
    this._instances[instance] = client;
  }
  return client;
};
{
  /**
   * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
   * This is required before any other methods can be called.
   * @public
   * @param {string} apiKey - The API key for your app.
   * @param {string} opt_userId - (optional) An identifier for this user.
   * @param {object} opt_config - (optional) Configuration options.
   * See [options.js](https://github.com/amplitude/Amplitude-JavaScript/blob/master/src/options.js#L14) for list of options and default values.
   * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
   * @deprecated Please use amplitude.getInstance().init(apiKey, opt_userId, opt_config, opt_callback);
   * @example amplitude.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
   */
  Amplitude.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    this.getInstance().init(apiKey, opt_userId, opt_config, function (instance) {
      // make options such as deviceId available for callback functions
      this.options = instance.options;
      if (type(opt_callback) === 'function') {
        opt_callback(instance);
      }
    }.bind(this));
  };

  /**
   * Returns true if a new session was created during initialization, otherwise false.
   * @public
   * @return {boolean} Whether a new session was created during initialization.
   * @deprecated Please use amplitude.getInstance().isNewSession();
   */
  Amplitude.prototype.isNewSession = function isNewSession() {
    return this.getInstance().isNewSession();
  };

  /**
   * Returns the id of the current session.
   * @public
   * @return {number} Id of the current session.
   * @deprecated Please use amplitude.getInstance().getSessionId();
   */
  Amplitude.prototype.getSessionId = function getSessionId() {
    return this.getInstance().getSessionId();
  };

  /**
   * Increments the eventId and returns it.
   * @private
   */
  Amplitude.prototype.nextEventId = function nextEventId() {
    return this.getInstance().nextEventId();
  };

  /**
   * Increments the identifyId and returns it.
   * @private
   */
  Amplitude.prototype.nextIdentifyId = function nextIdentifyId() {
    return this.getInstance().nextIdentifyId();
  };

  /**
   * Increments the sequenceNumber and returns it.
   * @private
   */
  Amplitude.prototype.nextSequenceNumber = function nextSequenceNumber() {
    return this.getInstance().nextSequenceNumber();
  };

  /**
   * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
   * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
   * @private
   */
  Amplitude.prototype.saveEvents = function saveEvents() {
    this.getInstance().saveEvents();
  };

  /**
   * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
   * @public
   * @param {string} domain to set.
   * @deprecated Please use amplitude.getInstance().setDomain(domain);
   * @example amplitude.setDomain('.amplitude.com');
   */
  Amplitude.prototype.setDomain = function setDomain(domain) {
    this.getInstance().setDomain(domain);
  };

  /**
   * Sets an identifier for the current user.
   * @public
   * @param {string} userId - identifier to set. Can be null.
   * @deprecated Please use amplitude.getInstance().setUserId(userId);
   * @example amplitude.setUserId('joe@gmail.com');
   */
  Amplitude.prototype.setUserId = function setUserId(userId) {
    this.getInstance().setUserId(userId);
  };

  /**
   * Add user to a group or groups. You need to specify a groupType and groupName(s).
   * For example you can group people by their organization.
   * In that case groupType is "orgId" and groupName would be the actual ID(s).
   * groupName can be a string or an array of strings to indicate a user in multiple gruups.
   * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
   * Note: this will also set groupType: groupName as a user property.
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
   * @public
   * @param {string} groupType - the group type (ex: orgId)
   * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
   * @deprecated Please use amplitude.getInstance().setGroup(groupType, groupName);
   * @example amplitude.setGroup('orgId', 15); // this adds the current user to orgId 15.
   */
  Amplitude.prototype.setGroup = function (groupType, groupName) {
    this.getInstance().setGroup(groupType, groupName);
  };

  /**
   * Sets whether to opt current user out of tracking.
   * @public
   * @param {boolean} enable - if true then no events will be logged or sent.
   * @deprecated Please use amplitude.getInstance().setOptOut(enable);
   * @example: amplitude.setOptOut(true);
   */
  Amplitude.prototype.setOptOut = function setOptOut(enable) {
    this.getInstance().setOptOut(enable);
  };

  /**
   * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
   * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
   * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
   * This uses src/uuid.js to regenerate the deviceId.
   * @public
   * @deprecated Please use amplitude.getInstance().regenerateDeviceId();
   */
  Amplitude.prototype.regenerateDeviceId = function regenerateDeviceId() {
    this.getInstance().regenerateDeviceId();
  };

  /**
   * Sets a custom deviceId for current user. Note: this is not recommended unless you know what you are doing
   * (like if you have your own system for managing deviceIds).
   *
   * Make sure the deviceId you set is sufficiently unique
   * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
   * @public
   * @param {string} deviceId - custom deviceId for current user.
   * @deprecated Please use amplitude.getInstance().setDeviceId(deviceId);
   * @example amplitude.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
   */
  Amplitude.prototype.setDeviceId = function setDeviceId(deviceId) {
    this.getInstance().setDeviceId(deviceId);
  };

  /**
   * Sets user properties for the current user.
   * @public
   * @param {object} userProperties - object with string keys and values for the user properties to set.
   * @param {boolean} opt_replace - Deprecated. In earlier versions of the JS SDK the user properties object was kept in
   * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
   * @deprecated Please use amplitude.getInstance().setUserProperties(userProperties);
   * @example amplitude.setUserProperties({'gender': 'female', 'sign_up_complete': true})
   */
  Amplitude.prototype.setUserProperties = function setUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };

  /**
   * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
   * @public
   * @deprecated Please use amplitude.getInstance().clearUserProperties();
   * @example amplitude.clearUserProperties();
   */
  Amplitude.prototype.clearUserProperties = function clearUserProperties() {
    this.getInstance().clearUserProperties();
  };

  /**
   * Send an identify call containing user property operations to Amplitude servers.
   * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
   * reference page for more information on the Identify API and user property operations.
   * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
   * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
   * Note: the server response code and response body from the identify event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().identify(identify);
   * @example
   * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
   * amplitude.identify(identify);
   */
  Amplitude.prototype.identify = function (identify_obj, opt_callback) {
    this.getInstance().identify(identify_obj, opt_callback);
  };

  /**
   * Set a versionName for your application.
   * @public
   * @param {string} versionName - The version to set for your application.
   * @deprecated Please use amplitude.getInstance().setVersionName(versionName);
   * @example amplitude.setVersionName('1.12.3');
   */
  Amplitude.prototype.setVersionName = function setVersionName(versionName) {
    this.getInstance().setVersionName(versionName);
  };

  /**
   * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
   * and the server response code and response body from the upload request are passed to the callback function.
   * @callback Amplitude~eventCallback
   * @param {number} responseCode - Server response code for the event / identify upload request.
   * @param {string} responseBody - Server response body for the event / identify upload request.
   */

  /**
   * Log an event with eventType and eventProperties
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEvent(eventType, eventProperties, opt_callback);
   * @example amplitude.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
   */
  Amplitude.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback) {
    return this.getInstance().logEvent(eventType, eventProperties, opt_callback);
  };

  /**
   * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
   *
   * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
   * (unless you explicitly set it with setGroup).
   *
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
   * about groups and Count by Distinct on the Amplitude platform.
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
   * groupName can be a string or an array of strings.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
   * @example amplitude.logEventWithGroups('Clicked Button', null, {'orgId': 24});
   */
  Amplitude.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback) {
    return this.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
  };

  /**
   * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
   * revenueType and event properties.
   *
   * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
   * reference page for more information on the Revenue interface and logging revenue.
   * @public
   * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
   * amplitude.logRevenueV2(revenue);
   */
  Amplitude.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    return this.getInstance().logRevenueV2(revenue_obj);
  };

  /**
   * Log revenue event with a price, quantity, and product identifier.
   * @public
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example amplitude.logRevenue(3.99, 1, 'product_1234');
   */
  Amplitude.prototype.logRevenue = function logRevenue(price, quantity, product) {
    return this.getInstance().logRevenue(price, quantity, product);
  };

  /**
   * Remove events in storage with event ids up to and including maxEventId.
   * @private
   */
  Amplitude.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId) {
    this.getInstance().removeEvents(maxEventId, maxIdentifyId);
  };

  /**
   * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
   * If batchEvents is true, then events are only sent when batch criterias are met.
   * @private
   * @param {Amplitude~eventCallback} callback - (optional) callback to run after events are sent.
   * Note the server response code and response body are passed to the callback as input arguments.
   */
  Amplitude.prototype.sendEvents = function sendEvents(callback) {
    this.getInstance().sendEvents(callback);
  };

  /**
   * Set global user properties.
   * @public
   * @deprecated Please use amplitudeClient.setUserProperties
   */
  Amplitude.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
Amplitude.prototype.__VERSION__ = version;

// Entry point
var old = typeof GlobalScope !== 'undefined' && GlobalScope.amplitude || {};
var newInstance = new Amplitude();
newInstance._q = old._q || [];

/**
 * Instantiates Amplitude object and runs all queued function logged by stubbed methods provided by snippets
 * Event queue allows async loading of SDK to not blocking client's app
 */
for (var instance in old._iq) {
  // migrate each instance's queue
  if (Object.prototype.hasOwnProperty.call(old._iq, instance)) {
    newInstance.getInstance(instance)._q = old._iq[instance]._q || [];
  }
}

/**
 * Amplitude 로그를 남깁니다.
 *
 * @param type 이벤트 타입
 * @param data 이벤트 데이터
 */
function logAmplitude(type, data) {
  newInstance.getInstance().logEvent(type, data);
}

function _LogLink(props, ref) {
  const {
    logData,
    amplitudeType,
    amplitudeData = {},
    href,
    to,
    as: LinkComponent = 'a',
    onClick,
    ...linkProps
  } = props;
  const interopHref = href ?? to; // Supports both Next.js and React Router.
  const normalizedHref = interopHref != null ? serializePathToString(interopHref) : interopHref;
  return jsx(LinkComponent, {
    ref: ref,
    onClick: e => {
      if (logData != null) {
        L({
          category: 'click',
          ...logData
        });
      }
      if (amplitudeType != null) {
        logAmplitude(amplitudeType, amplitudeData);
      }
      onClick?.(e);
    },
    href: normalizedHref,
    to: normalizedHref,
    ...linkProps
  });
}

/**
 * A generic logging link component that supports any routing library.
 */
const LogLink = /*#__PURE__*/React.forwardRef(_LogLink);

const STATUS_MAPPING = {
  1: 'higher',
  0: 'constant',
  [-1]: 'lower'
};
function mapTrendingKeywordStatus(keyword) {
  if (keyword.isNew) {
    return 'new';
  }
  return STATUS_MAPPING[Math.sign(keyword.diffRank)] ?? 'constant';
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsList(props) {
  const {
    className,
    entries,
    historyStorage,
    mode,
    linkComponent,
    baseUrl,
    onEntryClick
  } = props;
  const logDataFragment = {
    section: '인기 검색어 펼침',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  return jsx(Container$3, {
    className: className,
    children: jsx(ImpressionTracker, {
      logData: logDataFragment,
      children: jsx(KeywordEntryList, {
        mode: mode ?? 'grid',
        children: entries.map((keyword, index) => jsx(LinkStyled$1, {
          as: linkComponent,
          href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(keyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
          onClick: () => {
            historyStorage.append(keyword.displayKeyword);
            onEntryClick?.(keyword, index);
          },
          logData: {
            ...logDataFragment,
            id: keyword.displayKeyword,
            index
          },
          children: jsx(KeywordEntry, {
            rank: keyword.rank,
            status: mapTrendingKeywordStatus(keyword),
            title: keyword.displayKeyword
          })
        }, keyword.key))
      })
    })
  });
}
const Container$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekcs1el3"
} : {
  target: "ekcs1el3",
  label: "Container"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const LinkStyled$1 = /*#__PURE__*/_styled(LogLink, process.env.NODE_ENV === "production" ? {
  target: "ekcs1el2"
} : {
  target: "ekcs1el2",
  label: "LinkStyled"
})("display:block;", ({
  theme
}) => /*#__PURE__*/css(HOVER$1`
      background-color: ${theme.background.groupedBase};
    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:LinkStyled;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var _ref$j = process.env.NODE_ENV === "production" ? {
  name: "1ety6b1",
  styles: "margin:0 4px;grid-template-columns:repeat(2, 1fr);& * div{margin:8px 12px;}"
} : {
  name: "1kesqm5-KeywordEntryList",
  styles: "margin:0 4px;grid-template-columns:repeat(2, 1fr);& * div{margin:8px 12px;};label:KeywordEntryList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
};
const KeywordEntryList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekcs1el1"
} : {
  target: "ekcs1el1",
  label: "KeywordEntryList"
})("display:grid;", ({
  mode
}) => mode === 'grid' && _ref$j, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const KeywordEntry = /*#__PURE__*/_styled(TrendingKeywordsEntry, process.env.NODE_ENV === "production" ? {
  target: "ekcs1el0"
} : {
  target: "ekcs1el0",
  label: "KeywordEntry"
})(process.env.NODE_ENV === "production" ? {
  name: "uhy4xz",
  styles: "margin:8px 16px"
} : {
  name: "uhy4xz",
  styles: "margin:8px 16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TRANSITION_DURATION = 400;
const ROLLING_INTERVAL = 1500 + TRANSITION_DURATION;
function _TrendingKeywordsRolling(props, ref) {
  const {
    className,
    entries,
    historyStorage,
    paused,
    linkComponent,
    baseUrl,
    onOpen,
    onMouseEnter,
    onMouseLeave
  } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (paused) {
      return;
    }
    const handle = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % entries.length);
    }, ROLLING_INTERVAL);
    return () => {
      clearInterval(handle);
    };
  }, [entries, paused]);
  useEffect(() => {
    setCurrentIndex(0);
  }, [entries]);
  const logDataFragment = {
    section: '인기 검색어',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  const currentKeyword = entries[currentIndex];
  const currentElement = currentKeyword != null ? jsx(LinkStyled, {
    as: linkComponent,
    href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(currentKeyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
    onClick: () => historyStorage.append(currentKeyword.displayKeyword),
    logData: {
      ...logDataFragment,
      id: currentKeyword.displayKeyword,
      index: currentIndex
    },
    children: jsx(TrendingKeywordsEntry, {
      rank: currentKeyword.rank,
      status: mapTrendingKeywordStatus(currentKeyword),
      title: currentKeyword.displayKeyword
    })
  }) : null;
  return jsx(ImpressionTracker, {
    logData: logDataFragment,
    children: jsxs(Container$2, {
      className: className,
      ref: ref,
      children: [jsxs(RollingContainer, {
        children: [jsx(InvisibleSpacingMachine, {
          children: currentElement
        }), jsx(TransitionGroup$1, {
          children: jsx(CSSTransition$1, {
            timeout: TRANSITION_DURATION,
            classNames: "item",
            children: jsx(TransitionContainer, {
              children: currentElement
            })
          }, currentKeyword?.key)
        })]
      }), jsx(MenuToggleButton$1, {
        type: "button",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: () => onOpen(),
        children: jsx(Icon$1, {
          size: 18,
          name: "chevron_down"
        })
      })]
    })
  });
}
const TrendingKeywordsRolling = /*#__PURE__*/React__default.forwardRef(_TrendingKeywordsRolling);
const Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji5"
} : {
  target: "e1nb0uji5",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "ga3b11",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%"
} : {
  name: "ga3b11",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const RollingContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji4"
} : {
  target: "e1nb0uji4",
  label: "RollingContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "s0wc5p",
  styles: "position:relative;margin-right:6px;overflow:hidden"
} : {
  name: "s0wc5p",
  styles: "position:relative;margin-right:6px;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const MenuToggleButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji3"
} : {
  target: "e1nb0uji3",
  label: "MenuToggleButton"
})(RESET_BUTTON, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const InvisibleSpacingMachine = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji2"
} : {
  target: "e1nb0uji2",
  label: "InvisibleSpacingMachine"
})(process.env.NODE_ENV === "production" ? {
  name: "6dhm9o",
  styles: "visibility:hidden"
} : {
  name: "6dhm9o",
  styles: "visibility:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const TransitionContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji1"
} : {
  target: "e1nb0uji1",
  label: "TransitionContainer"
})("position:absolute;top:0;left:0;&.item-enter{transform:translateY(24px);opacity:0;}&.item-enter-active{opacity:1;transform:translateY(0);transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}&.item-exit{transform:translateY(0);opacity:1;}&.item-exit-active{transform:translateY(-24px);opacity:0;transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const LinkStyled = /*#__PURE__*/_styled(LogLink, process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji0"
} : {
  target: "e1nb0uji0",
  label: "LinkStyled"
})(process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "4zleql",
  styles: "display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});

function useToggle(options = {}) {
  const [open, setOpen] = useState(options.open ?? false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = useCallback(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open,
    handleOpen,
    handleClose,
    handleToggle
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsDropdown(props) {
  const {
    className,
    entries,
    historyStorage,
    linkComponent,
    baseUrl
  } = props;
  const {
    open: dropdownOpened,
    handleOpen,
    handleClose
  } = useToggle({
    open: false
  });
  return jsx(Container$1, {
    className: className,
    children: jsx(DropdownPopper, {
      placement: "bottom-end",
      isForceClosed: !dropdownOpened,
      renderButton: ({
        onClick
      }) => jsx(TrendingKeywordsRolling, {
        entries: entries,
        paused: dropdownOpened,
        historyStorage: historyStorage,
        linkComponent: linkComponent,
        baseUrl: baseUrl,
        onOpen: () => {
          onClick();
          handleOpen();
        }
      }),
      children: jsxs(DropdownListPanel, {
        children: [jsxs(DropdownListHeader, {
          children: [jsx(DropdownListHeaderTitle, {
            children: "\uC778\uAE30 \uAC80\uC0C9\uC5B4"
          }), jsx(MenuToggleButton, {
            type: "button",
            onClick: () => {
              L({
                category: 'click',
                section: '인기 검색어 닫힘'
              });
              handleClose();
            },
            children: jsx(Icon$1, {
              size: 18,
              name: "chevron_down"
            })
          })]
        }), jsx(TrendingKeywordsList, {
          mode: "list",
          entries: entries,
          historyStorage: historyStorage,
          baseUrl: baseUrl,
          onEntryClick: handleClose
        })]
      })
    })
  });
}
const Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw5"
} : {
  target: "eft3pbw5",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});
const DropdownPopper = /*#__PURE__*/_styled(Popper$1, process.env.NODE_ENV === "production" ? {
  target: "eft3pbw4"
} : {
  target: "eft3pbw4",
  label: "DropdownPopper"
})(process.env.NODE_ENV === "production" ? {
  name: "1iqaq9l",
  styles: "z-index:10000;&&>.popper-item{transform:translate3d(24px, -70px, 0);}"
} : {
  name: "1iqaq9l",
  styles: "z-index:10000;&&>.popper-item{transform:translate3d(24px, -70px, 0);}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});
const DropdownListPanel = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw3"
} : {
  target: "eft3pbw3",
  label: "DropdownListPanel"
})("width:268px;background:", ({
  theme
}) => theme.background.base, ";padding:20px 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const DropdownListHeader = /*#__PURE__*/_styled("header", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw2"
} : {
  target: "eft3pbw2",
  label: "DropdownListHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "mnvjsq",
  styles: "display:flex;align-items:center;justify-content:space-between;margin:0 16px 8px"
} : {
  name: "mnvjsq",
  styles: "display:flex;align-items:center;justify-content:space-between;margin:0 16px 8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});
const DropdownListHeaderTitle = /*#__PURE__*/_styled("h2", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw1"
} : {
  target: "eft3pbw1",
  label: "DropdownListHeaderTitle"
})(FONT_STYLE.title3, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const MenuToggleButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw0"
} : {
  target: "eft3pbw0",
  label: "MenuToggleButton"
})(RESET_BUTTON, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";transform:rotate(180deg);}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const useFollow = ({
  id,
  userId,
  isInitialFollowing = false,
  initialFollowCount = 0,
  onRedirectToSignIn,
  requestFollow,
  requestUnfollow,
  onFollow,
  onUnfollow,
  snackbarPlacement = 'basic',
  logData = {}
}) => {
  const snackbar = useSnackbar();
  const [pending, setPending] = useState(false);
  const [isFollowing, setIsFollowing] = useState(isInitialFollowing);
  const [count, setCount] = useState(initialFollowCount);
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const logFollow = () => {
    L({
      category: 'follow',
      type: 'user',
      id,
      ...logData
    });
  };
  const logUnfollow = () => {
    L({
      category: 'unfollow',
      type: 'user',
      id,
      ...logData
    });
  };
  const sendEventToWebview = eventType => {
    if (eventType === 'follow') {
      dispatchWebviewEvent({
        type: 'follow',
        contentType: 'User',
        contentId: id,
        performed: true,
        count: count + 1
      });
      return;
    }
    dispatchWebviewEvent({
      type: 'follow',
      contentType: 'User',
      contentId: id,
      performed: false,
      count: count - 1
    });
  };
  const handleFollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestFollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(true);
        setCount(count => count + 1);
        logFollow();
        sendEventToWebview('follow');
        onFollow?.();
      } else {
        snackbar.open({
          content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleUnfollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestUnfollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(false);
        setCount(count => count - 1);
        logUnfollow();
        sendEventToWebview('unfollow');
        onUnfollow?.();
      } else {
        snackbar.open({
          content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleToggleFollow = () => {
    if (isFollowing) {
      handleUnfollow();
      return;
    }
    handleFollow();
  };
  useWebviewEventListener('follow', event => {
    if (event.contentId !== id) {
      return;
    }
    setIsFollowing(event.performed);
    setCount(event.count);
    setPending(false);
  });
  return {
    follow: handleFollow,
    unfollow: handleUnfollow,
    toggle: handleToggleFollow,
    isFollowing,
    count,
    pending,
    isMe: id === userId
  };
};

const Follow = ({
  children,
  ...followProps
}) => {
  const followData = useFollow(followProps);
  return jsx(Fragment$1, {
    children: children(followData)
  });
};

const LinkContext = /*#__PURE__*/createContext('a');
const useLinkContext = () => useContext(LinkContext);
function LinkProvider({
  children,
  linkComponent
}) {
  return jsx(LinkContext.Provider, {
    value: linkComponent,
    children: children
  });
}

const LogContext = /*#__PURE__*/createContext(() => {/* noop */});
const useLogContext = () => useContext(LogContext);
function LogProvider({
  children,
  onLog
}) {
  return jsx(LogContext.Provider, {
    value: onLog,
    children: children
  });
}

const GNBDataContext = /*#__PURE__*/createContext(null);
function GNBDataProvider({
  children,
  value
}) {
  return jsx(GNBDataContext.Provider, {
    value: value,
    children: children
  });
}
function useGNBData() {
  const value = useContext(GNBDataContext);
  if (value === null) {
    throw new Error('The useLocaleData must be used within a LocaleDataContext');
  }
  return value;
}

var _path$3, _path2$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};
var NewIcon = SvgIcNew18;

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$i = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "l717kj-NavigationDrawerMenuAccordion",
  styles: "overflow:hidden;label:NavigationDrawerMenuAccordion;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
};
function NavigationDrawerMenuAccordion({
  children,
  isExpanded,
  onTransitionStart,
  onTransitionEnd
}) {
  const container = useRef(null);
  const content = useRef(null);
  const isExpanding = useRef(false);
  const isCollapsing = useRef(false);
  const expand = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = `${content.current.clientHeight}px`;
    onTransitionStart();
  }, [onTransitionStart]);
  const collapse = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isCollapsing.current = true;
    container.current.style.height = `${content.current.clientHeight}px`;
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  const handleTransitionEnd = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  useEffect(() => {
    if (!container.current) {
      return;
    }
    if (!container.current.style.transition) {
      return;
    }
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  useEffect(() => {
    if (!container.current) {
      return;
    }
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("div", {
    ref: container,
    css: _ref$i,
    onTransitionEnd: handleTransitionEnd,
    children: jsx("div", {
      ref: content,
      children: children
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref3$2 = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "ighj9o-NavigationDrawerMenu",
  styles: "padding:0;label:NavigationDrawerMenu;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
function NavigationDrawerMenu({
  items,
  indents,
  fontStyles,
  onClose
}) {
  const [expandedIndex, setExpandedIndex] = useState(() => items.findIndex(item => item.active));
  return jsx("ul", {
    css: _ref3$2,
    children: items.map((item, index) => jsx(NavigationDrawerMenuItem, {
      title: item.title,
      icon: item.icon,
      bullet: item.bullet,
      href: item.href,
      isActive: item.active,
      items: item.entries,
      renderChild: item.renderDrawerChild,
      indents: indents,
      fontStyles: fontStyles,
      isExpanded: index === expandedIndex,
      onExpand: () => setExpandedIndex(index),
      onCollapse: () => setExpandedIndex(-1),
      onClick: () => {
        item.onClick?.({
          item,
          index
        });
        if (!item.entries) {
          onClose?.();
        }
      },
      onClose: onClose
    }, index))
  });
}
var _ref$h = process.env.NODE_ENV === "production" ? {
  name: "1r7xtnv",
  styles: "margin-left:1.5px"
} : {
  name: "z60fnh-renderTitle",
  styles: "margin-left:1.5px;label:renderTitle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
var _ref2$5 = process.env.NODE_ENV === "production" ? {
  name: "6103ef",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1"
} : {
  name: "1bx3wbx-renderTitle",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1;label:renderTitle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
function NavigationDrawerMenuItem({
  title,
  icon,
  href,
  bullet,
  items,
  indents = [],
  fontStyles = [],
  isActive,
  isExpanded,
  onExpand,
  onCollapse,
  renderChild,
  onClick,
  onClose
}) {
  const theme = useTheme();
  const Link = useLinkContext();
  const isAccordionTransitioning = useRef(false);
  const handleAccordionTransitionStart = useCallback(() => {
    isAccordionTransitioning.current = true;
  }, []);
  const handleAccordionTransitionEnd = useCallback(() => {
    isAccordionTransitioning.current = false;
  }, []);
  const handleAccordionToggle = useCallback(() => {
    if (isAccordionTransitioning.current) {
      return;
    }
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  const renderTitle = () => {
    return jsxs("div", {
      css: _ref2$5,
      children: [icon && jsx("span", {
        css: /*#__PURE__*/css("display:inline-block;margin-right:", pxToRem(8), ";border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:renderTitle;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: icon
      }), title, bullet === 'new' && jsx(NewIcon, {
        css: _ref$h
      })]
    });
  };
  const [indent] = indents;
  const [fontStyle = {}] = fontStyles;
  return jsx("li", {
    css: /*#__PURE__*/css("margin:", pxToRem(4), " 0 0;padding:0;font-size:", pxToRem(fontStyle.size || 14), ";font-weight:", isActive ? 'bold' : fontStyle.weight || 'normal', ";color:", fontStyle.color || theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    children: items && items.length || renderChild ? jsxs(Fragment$1, {
      children: [jsxs("button", {
        type: "button",
        onClick: () => {
          handleAccordionToggle();
          onClick?.();
        },
        css: /*#__PURE__*/css(RESET_BUTTON, " overflow:hidden;position:relative;display:block;width:100%;height:", pxToRem(40), ";margin:0;padding:0 ", pxToRem(40), " 0 ", pxToRem(indent || 14), ";color:inherit;text-align:left;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER$1`
                      background-color: ${theme.content.base5};
                    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") : HOVER$1`
                    background-color: ${theme.content.base5};
                  `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: [renderTitle(), jsx(Icon$1, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/css("position:absolute;top:", pxToRem(14), ";right:", pxToRem(14), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
        })]
      }), jsx(NavigationDrawerMenuAccordion, {
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd,
        children: items && jsx(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      })]
    }) : jsx(Link, {
      href: href,
      onClick: onClick,
      css: /*#__PURE__*/css("overflow:hidden;display:block;width:100%;height:", pxToRem(40), ";padding:0 ", pxToRem(14), " 0 ", pxToRem(indent || 14), ";color:inherit;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER$1`
                  background-color: ${theme.content.base5};
                `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") : HOVER$1`
                background-color: ${theme.content.base5};
              `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: renderTitle()
    })
  });
}

var _path$2, _path2$2, _path3, _path4, _path5;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 28,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19.711 7.307h10.226c.759 0 1.374-.606 1.374-1.355s-.615-1.356-1.374-1.356h-8.852v-3.24C21.085.607 20.47 0 19.71 0c-.759 0-1.374.607-1.374 1.356v4.596c0 .749.615 1.355 1.374 1.355Z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.804 8.877c0 4.711-2.261 7.638-5.9 7.638s-5.901-2.927-5.901-7.638V8.54c0-4.711 2.26-7.638 5.9-7.638s5.9 2.927 5.9 7.638zm-5.9-5.264c-1.178 0-3.153.64-3.153 4.927v.337c0 4.287 1.975 4.927 3.152 4.927s3.153-.64 3.153-4.927V8.54c0-4.287-1.975-4.927-3.153-4.927Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.278 23.496h4.655c.76 0 1.374.607 1.374 1.356 0 .748-.615 1.355-1.374 1.355H1.873A1.365 1.365 0 0 1 .5 24.852c0-.75.615-1.356 1.374-1.356H6.53v-4.173c0-.748.615-1.355 1.374-1.355.758 0 1.374.607 1.374 1.355zm22.79-13.84H17.343c-.759 0-1.373.607-1.373 1.355 0 .75.614 1.356 1.373 1.356h14.725c.76 0 1.374-.607 1.374-1.356 0-.748-.615-1.355-1.374-1.355M21.009 24.362c.654.499 2.897 1.475 9.59-.24a1.376 1.376 0 0 1 1.675.97 1.354 1.354 0 0 1-.984 1.653c-2.745.704-5.095 1.055-7.035 1.056-2.15 0-3.797-.432-4.927-1.294-1.103-.843-1.686-2.063-1.686-3.532v-2.163c0-.748.614-1.356 1.373-1.356h9.703v-2.03h-9.703a1.365 1.365 0 0 1-1.373-1.355c0-.749.614-1.356 1.373-1.356h11.077c.759 0 1.373.607 1.373 1.356v4.741c0 .749-.614 1.356-1.373 1.356h-9.703v.807c0 .632.191 1.06.62 1.387M68.135 0a1.41 1.41 0 0 0-1.419 1.4v11.2c0 .773.636 1.4 1.42 1.4a1.41 1.41 0 0 0 1.418-1.4V1.4c0-.773-.635-1.4-1.419-1.4m-6.624 12.39a1.374 1.374 0 0 0 1.759.808 1.35 1.35 0 0 0 .823-1.737c-.045-.12-.944-2.5-3.191-4.195l3.49-3.83c.362-.398.454-.97.233-1.458a1.38 1.38 0 0 0-1.255-.804h-8.56c-.759 0-1.374.607-1.374 1.356 0 .748.615 1.355 1.374 1.355h5.477l-6.499 7.132a1.34 1.34 0 0 0 .103 1.914c.263.233.591.348.919.348.376 0 .75-.152 1.022-.45l3.224-3.538c1.706 1.19 2.437 3.054 2.454 3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M67.072 17.362c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v6.627c0 1.914-1.579 3.471-3.519 3.471h-6.634c-1.94 0-3.519-1.557-3.519-3.471v-6.627c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v2.095h8.176zm-7.405 7.387h6.634c.425 0 .771-.34.771-.76v-1.821h-8.176v1.82c0 .42.346.761.771.761m-18.999-8.935c1.664 0 3.052-.87 3.91-2.452.678-1.252 1.037-2.982 1.037-5.004s-.359-3.752-1.038-5.004C43.72 1.772 42.332.902 40.668.902s-3.052.87-3.91 2.452c-.678 1.252-1.037 2.982-1.037 5.004s.359 3.752 1.038 5.004c.857 1.581 2.245 2.452 3.909 2.452m0-12.201c2.093 0 2.2 3.952 2.2 4.745 0 .792-.107 4.745-2.2 4.745s-2.2-3.953-2.2-4.745.106-4.745 2.2-4.745",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M47.746 1.81c0-.748.615-1.355 1.374-1.355s1.374.607 1.374 1.356V25.73c0 .749-.615 1.355-1.374 1.355a1.365 1.365 0 0 1-1.374-1.355v-4.514c-2.992.733-7.314.95-9.812.95h-2.091a1.365 1.365 0 0 1-1.374-1.355c0-.749.615-1.356 1.374-1.356h2.091c4.378 0 7.991-.493 9.812-1.052z"
  })));
};
var LogoIcon = SvgLogo;

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$g = process.env.NODE_ENV === "production" ? {
  name: "40f4ru",
  styles: "vertical-align:top"
} : {
  name: "1w6io5f-Logo",
  styles: "vertical-align:top;label:Logo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1EMEIiLCJmaWxlIjoiTG9nby50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBIVE1MUHJvcHMsIFJlYWN0Tm9kZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7XG4gIEZPQ1VTLFxuICBSRVNFVF9CVVRUT04sXG4gIHB4VG9SZW0sXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuaW1wb3J0IHsgTmF2aWdhdGlvbkxvZ28gfSBmcm9tICcuLi90eXBlcyc7XG5cbmltcG9ydCBMb2dvSWNvbiBmcm9tICcuL2xvZ28uc3ZnJztcblxuZXhwb3J0IGludGVyZmFjZSBMb2dvUHJvcHMgZXh0ZW5kcyBIVE1MUHJvcHM8SFRNTEFuY2hvckVsZW1lbnQ+IHtcbiAgbG9nbz86IE5hdmlnYXRpb25Mb2dvO1xuICBjaGlsZHJlbj86IFJlYWN0Tm9kZTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIExvZ28oe1xuICBsb2dvLFxuICBjaGlsZHJlbixcbiAgLi4ucmVzdFxufTogTG9nb1Byb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IExpbmsgPSB1c2VMaW5rQ29udGV4dCgpO1xuXG4gIHJldHVybiAoXG4gICAgPExpbmtcbiAgICAgIHsuLi5yZXN0fVxuICAgICAgaHJlZj17bG9nbz8uaHJlZiB8fCAnaHR0cHM6Ly9vaG91LnNlJ31cbiAgICAgIGFyaWEtbGFiZWw9XCLsmKTripjsnZjsp5Eg66Gc6rOgXCJcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3NgXG4gICAgICAgICAgJHtSRVNFVF9CVVRUT059XG4gICAgICAgICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBtYXJnaW46ICR7cHhUb1JlbSgtNCl9O1xuICAgICAgICAgIHBhZGRpbmc6ICR7cHhUb1JlbSg0KX07XG4gICAgICAgICAgZm9udC1zaXplOiAwO1xuICAgICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmludGVyYWN0aXZlLmJhc2UxfTtcbiAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICBgLFxuICAgICAgICBGT0NVU2BcbiAgICAgICAgICBib3gtc2hhZG93OiAwIDAgMCAke3B4VG9SZW0oMyl9ICR7dGhlbWUuaW50ZXJhY3RpdmUucHJpbWFyeTEudGhpbn07XG4gICAgICAgICAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDMpfTtcbiAgICAgICAgYCxcbiAgICAgIF19XG4gICAgPlxuICAgICAgeyBjaGlsZHJlbiB8fCBsb2dvPy5pdGVtIHx8IChcbiAgICAgICAgPExvZ29JY29uIGNzcz17Y3NzYFxuICAgICAgICAgIHZlcnRpY2FsLWFsaWduOiB0b3A7XG4gICAgICAgIGB9XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICA8L0xpbms+XG4gICk7XG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
};
function Logo({
  logo,
  children,
  ...rest
}) {
  const theme = useTheme();
  const Link = useLinkContext();
  return jsx(Link, {
    ...rest,
    href: logo?.href || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/css(RESET_BUTTON, " display:inline-flex;align-items:center;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";font-size:0;line-height:0;color:", theme.interactive.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:Logo;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlDVyIsImZpbGUiOiJMb2dvLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEhUTUxQcm9wcywgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIFJFU0VUX0JVVFRPTixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyBOYXZpZ2F0aW9uTG9nbyB9IGZyb20gJy4uL3R5cGVzJztcblxuaW1wb3J0IExvZ29JY29uIGZyb20gJy4vbG9nby5zdmcnO1xuXG5leHBvcnQgaW50ZXJmYWNlIExvZ29Qcm9wcyBleHRlbmRzIEhUTUxQcm9wczxIVE1MQW5jaG9yRWxlbWVudD4ge1xuICBsb2dvPzogTmF2aWdhdGlvbkxvZ287XG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTG9nbyh7XG4gIGxvZ28sXG4gIGNoaWxkcmVuLFxuICAuLi5yZXN0XG59OiBMb2dvUHJvcHMpOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgY29uc3QgTGluayA9IHVzZUxpbmtDb250ZXh0KCk7XG5cbiAgcmV0dXJuIChcbiAgICA8TGlua1xuICAgICAgey4uLnJlc3R9XG4gICAgICBocmVmPXtsb2dvPy5ocmVmIHx8ICdodHRwczovL29ob3Uuc2UnfVxuICAgICAgYXJpYS1sYWJlbD1cIuyYpOuKmOydmOynkSDroZzqs6BcIlxuICAgICAgY3NzPXtbXG4gICAgICAgIGNzc2BcbiAgICAgICAgICAke1JFU0VUX0JVVFRPTn1cbiAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgIG1hcmdpbjogJHtweFRvUmVtKC00KX07XG4gICAgICAgICAgcGFkZGluZzogJHtweFRvUmVtKDQpfTtcbiAgICAgICAgICBmb250LXNpemU6IDA7XG4gICAgICAgICAgbGluZS1oZWlnaHQ6IDA7XG4gICAgICAgICAgY29sb3I6ICR7dGhlbWUuaW50ZXJhY3RpdmUuYmFzZTF9O1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIGAsXG4gICAgICAgIEZPQ1VTYFxuICAgICAgICAgIGJveC1zaGFkb3c6IDAgMCAwICR7cHhUb1JlbSgzKX0gJHt0aGVtZS5pbnRlcmFjdGl2ZS5wcmltYXJ5MS50aGlufTtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oMyl9O1xuICAgICAgICBgLFxuICAgICAgXX1cbiAgICA+XG4gICAgICB7IGNoaWxkcmVuIHx8IGxvZ28/Lml0ZW0gfHwgKFxuICAgICAgICA8TG9nb0ljb24gY3NzPXtjc3NgXG4gICAgICAgICAgdmVydGljYWwtYWxpZ246IHRvcDtcbiAgICAgICAgYH1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgIDwvTGluaz5cbiAgKTtcbn1cbiJdfQ== */"), FOCUS`
          box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
          border-radius: ${pxToRem(3)};
        `, process.env.NODE_ENV === "production" ? "" : ";label:Logo;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDTSIsImZpbGUiOiJMb2dvLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEhUTUxQcm9wcywgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIFJFU0VUX0JVVFRPTixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyBOYXZpZ2F0aW9uTG9nbyB9IGZyb20gJy4uL3R5cGVzJztcblxuaW1wb3J0IExvZ29JY29uIGZyb20gJy4vbG9nby5zdmcnO1xuXG5leHBvcnQgaW50ZXJmYWNlIExvZ29Qcm9wcyBleHRlbmRzIEhUTUxQcm9wczxIVE1MQW5jaG9yRWxlbWVudD4ge1xuICBsb2dvPzogTmF2aWdhdGlvbkxvZ287XG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTG9nbyh7XG4gIGxvZ28sXG4gIGNoaWxkcmVuLFxuICAuLi5yZXN0XG59OiBMb2dvUHJvcHMpOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgY29uc3QgTGluayA9IHVzZUxpbmtDb250ZXh0KCk7XG5cbiAgcmV0dXJuIChcbiAgICA8TGlua1xuICAgICAgey4uLnJlc3R9XG4gICAgICBocmVmPXtsb2dvPy5ocmVmIHx8ICdodHRwczovL29ob3Uuc2UnfVxuICAgICAgYXJpYS1sYWJlbD1cIuyYpOuKmOydmOynkSDroZzqs6BcIlxuICAgICAgY3NzPXtbXG4gICAgICAgIGNzc2BcbiAgICAgICAgICAke1JFU0VUX0JVVFRPTn1cbiAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgIG1hcmdpbjogJHtweFRvUmVtKC00KX07XG4gICAgICAgICAgcGFkZGluZzogJHtweFRvUmVtKDQpfTtcbiAgICAgICAgICBmb250LXNpemU6IDA7XG4gICAgICAgICAgbGluZS1oZWlnaHQ6IDA7XG4gICAgICAgICAgY29sb3I6ICR7dGhlbWUuaW50ZXJhY3RpdmUuYmFzZTF9O1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIGAsXG4gICAgICAgIEZPQ1VTYFxuICAgICAgICAgIGJveC1zaGFkb3c6IDAgMCAwICR7cHhUb1JlbSgzKX0gJHt0aGVtZS5pbnRlcmFjdGl2ZS5wcmltYXJ5MS50aGlufTtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oMyl9O1xuICAgICAgICBgLFxuICAgICAgXX1cbiAgICA+XG4gICAgICB7IGNoaWxkcmVuIHx8IGxvZ28/Lml0ZW0gfHwgKFxuICAgICAgICA8TG9nb0ljb24gY3NzPXtjc3NgXG4gICAgICAgICAgdmVydGljYWwtYWxpZ246IHRvcDtcbiAgICAgICAgYH1cbiAgICAgICAgLz5cbiAgICAgICkgfVxuICAgIDwvTGluaz5cbiAgKTtcbn1cbiJdfQ== */"],
    children: children || logo?.item || jsx(LogoIcon, {
      css: _ref$g
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$f = process.env.NODE_ENV === "production" ? {
  name: "1200b05",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none"
} : {
  name: "10rqdyz-NavigationDrawerHeader",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none;label:NavigationDrawerHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
};
function NavigationDrawerHeader({
  logo,
  action,
  supplementary
}) {
  const log = useLogContext();
  const {
    userProfile,
    signup,
    signin
  } = supplementary;
  return jsxs(Fragment$1, {
    children: [jsxs("div", {
      css: /*#__PURE__*/css("position:relative;font-size:", pxToRem(14), ";line-height:", pxToRem(18), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [jsx(Logo, {
        ...logo,
        onClick: () => log({
          key: 'drawer.logo',
          category: 'click'
        })
      }), action && (({
        text,
        ...rest
      }) => jsxs(TextButton, {
        ...rest,
        size: 32,
        variant: "primary1",
        css: _ref$f,
        children: [text, jsx(Icon$1, {
          name: "chevron_right",
          size: 12,
          fill: theme => theme.content.primary1.basic,
          css: /*#__PURE__*/css("margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
        })]
      }))(action)]
    }), userProfile == null ? jsxs("div", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;width:100%;margin:", pxToRem(20), " 0 ", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [signin && jsx(OutlineAnchorButton, {
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signIn page
        },
        css: /*#__PURE__*/css("font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;height:", pxToRem(42), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEZzQiIsImZpbGUiOiJIZWFkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgbXVsdGlsaW5lLXRlcm5hcnkgKi9cbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgSHRtbEJ1dHRvblByb3BzLCBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHtcbiAgQW5jaG9yQnV0dG9uLFxuICBBdmF0YXIsXG4gIEljb24sXG4gIE91dGxpbmVBbmNob3JCdXR0b24sXG4gIFRleHRCdXR0b24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7IExvZ28sIExvZ29Qcm9wcyB9IGZyb20gJy4uL2xvZ28vTG9nbyc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25EcmF3ZXJIZWFkZXJQcm9wcyB7XG4gIGxvZ28/OiBMb2dvUHJvcHM7XG4gIGFjdGlvbj86IEh0bWxCdXR0b25Qcm9wcyAmIHtcbiAgICB0ZXh0OiBzdHJpbmcsXG4gIH07XG4gIHN1cHBsZW1lbnRhcnk6IFN1cHBsZW1lbnRhcnk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uRHJhd2VySGVhZGVyKHtcbiAgbG9nbyxcbiAgYWN0aW9uLFxuICBzdXBwbGVtZW50YXJ5LFxufTogTmF2aWdhdGlvbkRyYXdlckhlYWRlclByb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCBsb2cgPSB1c2VMb2dDb250ZXh0KCk7XG4gIGNvbnN0IHsgdXNlclByb2ZpbGUsIHNpZ251cCwgc2lnbmluIH0gPSBzdXBwbGVtZW50YXJ5O1xuXG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxkaXYgY3NzPXtjc3NgXG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTQpfTtcbiAgICAgICAgbGluZS1oZWlnaHQ6ICR7cHhUb1JlbSgxOCl9O1xuICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgPExvZ29cbiAgICAgICAgICB7Li4ubG9nb31cbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAnZHJhd2VyLmxvZ28nLFxuICAgICAgICAgICAgY2F0ZWdvcnk6ICdjbGljaycsXG4gICAgICAgICAgfSl9XG4gICAgICAgIC8+XG4gICAgICAgIHsgYWN0aW9uICYmICgoeyB0ZXh0LCAuLi5yZXN0IH0pID0+IChcbiAgICAgICAgICA8VGV4dEJ1dHRvblxuICAgICAgICAgICAgey4uLnJlc3R9XG4gICAgICAgICAgICBzaXplPXszMn1cbiAgICAgICAgICAgIHZhcmlhbnQ9XCJwcmltYXJ5MVwiXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgYH1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IHRleHQgfVxuICAgICAgICAgICAgPEljb25cbiAgICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDQpfTtcbiAgICAgICAgICAgICAgYH1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9UZXh0QnV0dG9uPlxuICAgICAgICApKShhY3Rpb24pIH1cbiAgICAgIDwvZGl2PlxuICAgICAgeyB1c2VyUHJvZmlsZSA9PSBudWxsID8gKFxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIG1hcmdpbjogJHtweFRvUmVtKDIwKX0gMCAke3B4VG9SZW0oMTApfTtcbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIHsgc2lnbmluICYmIChcbiAgICAgICAgICAgIDxPdXRsaW5lQW5jaG9yQnV0dG9uXG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBzaXplPXs0NH1cbiAgICAgICAgICAgICAgdmFyaWFudD1cInByaW1hcnkxXCJcbiAgICAgICAgICAgICAgb25DbGljaz17KCkgPT4ge1xuICAgICAgICAgICAgICAvLyB0byBzaWduSW4gcGFnZVxuICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgICAgZmxleDogMTtcbiAgICAgICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICAgIGhlaWdodDogJHtweFRvUmVtKDQyKX07XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHsgc2lnbmluLnRpdGxlIH1cbiAgICAgICAgICAgIDwvT3V0bGluZUFuY2hvckJ1dHRvbj5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8QW5jaG9yQnV0dG9uXG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBzaXplPXs0NH1cbiAgICAgICAgICAgICAgdmFyaWFudD1cInByaW1hcnkxXCJcbiAgICAgICAgICAgICAgb25DbGljaz17KCkgPT4ge1xuICAgICAgICAgICAgICAvLyB0byBzaWduVXAgcGFnZVxuICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDgpfTtcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgICAgZmxleDogMTtcbiAgICAgICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICBgfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IHNpZ251cC50aXRsZSB9XG4gICAgICAgICAgICA8L0FuY2hvckJ1dHRvbj5cbiAgICAgICAgICApIH1cbiAgICAgICAgPC9kaXY+XG4gICAgICApIDogKFxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBtYXJnaW46ICR7cHhUb1JlbSgyNCl9IDAgJHtweFRvUmVtKDIwKX07XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8QXZhdGFyXG4gICAgICAgICAgICBhcmlhLWxhYmVsPVwiZHJhd2VyIOycoOyggCDtlITroZztlYQg7J2066+47KeAXCJcbiAgICAgICAgICAgIHNpemU9ezIwfVxuICAgICAgICAgICAgc3JjPXt1c2VyUHJvZmlsZS5pbWFnZVVybH1cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxwIGNzcz17Y3NzYFxuICAgICAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTQpfTtcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAke3B4VG9SZW0oMjApfTtcbiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oNCl9O1xuICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgeyB1c2VyUHJvZmlsZS5uaWNrbmFtZSB9XG4gICAgICAgICAgPC9wPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICkgfVxuICAgIDwvPlxuICApO1xufVxuIl19 */"),
        children: signin.title
      }), signup && jsx(AnchorButton, {
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signUp page
        },
        css: /*#__PURE__*/css("margin-left:", pxToRem(8), ";font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: signup.title
      })]
    }) : jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;margin:", pxToRem(24), " 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [jsx(Avatar$1, {
        "aria-label": "drawer \uC720\uC800 \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0",
        size: 20,
        src: userProfile.imageUrl
      }), jsx("p", {
        css: /*#__PURE__*/css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUlxQiIsImZpbGUiOiJIZWFkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgbXVsdGlsaW5lLXRlcm5hcnkgKi9cbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgSHRtbEJ1dHRvblByb3BzLCBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHtcbiAgQW5jaG9yQnV0dG9uLFxuICBBdmF0YXIsXG4gIEljb24sXG4gIE91dGxpbmVBbmNob3JCdXR0b24sXG4gIFRleHRCdXR0b24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7IExvZ28sIExvZ29Qcm9wcyB9IGZyb20gJy4uL2xvZ28vTG9nbyc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25EcmF3ZXJIZWFkZXJQcm9wcyB7XG4gIGxvZ28/OiBMb2dvUHJvcHM7XG4gIGFjdGlvbj86IEh0bWxCdXR0b25Qcm9wcyAmIHtcbiAgICB0ZXh0OiBzdHJpbmcsXG4gIH07XG4gIHN1cHBsZW1lbnRhcnk6IFN1cHBsZW1lbnRhcnk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uRHJhd2VySGVhZGVyKHtcbiAgbG9nbyxcbiAgYWN0aW9uLFxuICBzdXBwbGVtZW50YXJ5LFxufTogTmF2aWdhdGlvbkRyYXdlckhlYWRlclByb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCBsb2cgPSB1c2VMb2dDb250ZXh0KCk7XG4gIGNvbnN0IHsgdXNlclByb2ZpbGUsIHNpZ251cCwgc2lnbmluIH0gPSBzdXBwbGVtZW50YXJ5O1xuXG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxkaXYgY3NzPXtjc3NgXG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTQpfTtcbiAgICAgICAgbGluZS1oZWlnaHQ6ICR7cHhUb1JlbSgxOCl9O1xuICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgPExvZ29cbiAgICAgICAgICB7Li4ubG9nb31cbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAnZHJhd2VyLmxvZ28nLFxuICAgICAgICAgICAgY2F0ZWdvcnk6ICdjbGljaycsXG4gICAgICAgICAgfSl9XG4gICAgICAgIC8+XG4gICAgICAgIHsgYWN0aW9uICYmICgoeyB0ZXh0LCAuLi5yZXN0IH0pID0+IChcbiAgICAgICAgICA8VGV4dEJ1dHRvblxuICAgICAgICAgICAgey4uLnJlc3R9XG4gICAgICAgICAgICBzaXplPXszMn1cbiAgICAgICAgICAgIHZhcmlhbnQ9XCJwcmltYXJ5MVwiXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgYH1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IHRleHQgfVxuICAgICAgICAgICAgPEljb25cbiAgICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiB0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDQpfTtcbiAgICAgICAgICAgICAgYH1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9UZXh0QnV0dG9uPlxuICAgICAgICApKShhY3Rpb24pIH1cbiAgICAgIDwvZGl2PlxuICAgICAgeyB1c2VyUHJvZmlsZSA9PSBudWxsID8gKFxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIG1hcmdpbjogJHtweFRvUmVtKDIwKX0gMCAke3B4VG9SZW0oMTApfTtcbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIHsgc2lnbmluICYmIChcbiAgICAgICAgICAgIDxPdXRsaW5lQW5jaG9yQnV0dG9uXG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBzaXplPXs0NH1cbiAgICAgICAgICAgICAgdmFyaWFudD1cInByaW1hcnkxXCJcbiAgICAgICAgICAgICAgb25DbGljaz17KCkgPT4ge1xuICAgICAgICAgICAgICAvLyB0byBzaWduSW4gcGFnZVxuICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgICAgZmxleDogMTtcbiAgICAgICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICAgIGhlaWdodDogJHtweFRvUmVtKDQyKX07XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHsgc2lnbmluLnRpdGxlIH1cbiAgICAgICAgICAgIDwvT3V0bGluZUFuY2hvckJ1dHRvbj5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8QW5jaG9yQnV0dG9uXG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBzaXplPXs0NH1cbiAgICAgICAgICAgICAgdmFyaWFudD1cInByaW1hcnkxXCJcbiAgICAgICAgICAgICAgb25DbGljaz17KCkgPT4ge1xuICAgICAgICAgICAgICAvLyB0byBzaWduVXAgcGFnZVxuICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDgpfTtcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICAgICAgZmxleDogMTtcbiAgICAgICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgICBgfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IHNpZ251cC50aXRsZSB9XG4gICAgICAgICAgICA8L0FuY2hvckJ1dHRvbj5cbiAgICAgICAgICApIH1cbiAgICAgICAgPC9kaXY+XG4gICAgICApIDogKFxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBtYXJnaW46ICR7cHhUb1JlbSgyNCl9IDAgJHtweFRvUmVtKDIwKX07XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8QXZhdGFyXG4gICAgICAgICAgICBhcmlhLWxhYmVsPVwiZHJhd2VyIOycoOyggCDtlITroZztlYQg7J2066+47KeAXCJcbiAgICAgICAgICAgIHNpemU9ezIwfVxuICAgICAgICAgICAgc3JjPXt1c2VyUHJvZmlsZS5pbWFnZVVybH1cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxwIGNzcz17Y3NzYFxuICAgICAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTQpfTtcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAke3B4VG9SZW0oMjApfTtcbiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oNCl9O1xuICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgeyB1c2VyUHJvZmlsZS5uaWNrbmFtZSB9XG4gICAgICAgICAgPC9wPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICkgfVxuICAgIDwvPlxuICApO1xufVxuIl19 */"),
        children: userProfile.nickname
      })]
    })]
  });
}

function NavigationDrawerFooterListItem({
  title,
  href,
  onClick,
  onClose
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  return jsx("li", {
    css: [/*#__PURE__*/css("display:inline-block;padding:", pxToRem(6), ";border-radius:", pxToRem(4), ";margin:0 0 0 ", pxToRem(7), ";line-height:", pxToRem(18), ";&:first-of-type{margin:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvb3Rlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkJTIiwiZmlsZSI6IkZvb3Rlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQge1xuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgUkVTRVRfQlVUVE9OLFxuICBweFRvUmVtLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IHVzZUxpbmtDb250ZXh0IH0gZnJvbSAnLi4vbGluay1jb250ZXh0JztcblxuaW1wb3J0IHsgVXNlck1lbnVTY2hlbWFFbnRyeSB9IGZyb20gJy4uL3R5cGVzJztcblxuaW50ZXJmYWNlIE5hdmlnYXRpb25EcmF3ZXJGb290ZXJMaXN0SXRlbVByb3BzIGV4dGVuZHMgVXNlck1lbnVTY2hlbWFFbnRyeSB7XG4gIG9uQ2xvc2U/OiAoKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTmF2aWdhdGlvbkRyYXdlckZvb3Rlckxpc3RJdGVtKHtcbiAgdGl0bGUsXG4gIGhyZWYsXG4gIG9uQ2xpY2ssXG4gIG9uQ2xvc2UsXG59OiBOYXZpZ2F0aW9uRHJhd2VyRm9vdGVyTGlzdEl0ZW1Qcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCBMaW5rQ29tcG9uZW50ID0gdXNlTGlua0NvbnRleHQoKTtcbiAgcmV0dXJuIChcbiAgICA8bGkgY3NzPXtbXG4gICAgICBjc3NgXG4gICAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgICAgcGFkZGluZzogJHtweFRvUmVtKDYpfTtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDQpfTtcbiAgICAgICAgbWFyZ2luOiAwIDAgMCAke3B4VG9SZW0oNyl9O1xuICAgICAgICBsaW5lLWhlaWdodDogJHtweFRvUmVtKDE4KX07XG4gICAgICAgICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICB9XG4gICAgICBgLFxuICAgICAgSE9WRVJgXG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7dGhlbWUuYmFja2dyb3VuZC5ncm91cGVkQmFzZX07XG4gICAgICBgLFxuICAgIF19XG4gICAgPlxuICAgICAgeyBocmVmICE9IG51bGxcbiAgICAgICAgPyAoXG4gICAgICAgICAgPExpbmtDb21wb25lbnRcbiAgICAgICAgICAgIGhyZWY9e2hyZWZ9XG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICR7Rk9OVF9TVFlMRS5zdWJUaXRsZTJ9XG4gICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgICAgICAgYH1cbiAgICAgICAgICAgIG9uQ2xpY2s9e29uQ2xvc2V9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgeyB0aXRsZSB9XG4gICAgICAgICAgPC9MaW5rQ29tcG9uZW50PlxuICAgICAgICApXG4gICAgICAgIDogKFxuICAgICAgICAgIDxidXR0b25cbiAgICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgJHtSRVNFVF9CVVRUT059XG4gICAgICAgICAgICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUyfVxuICAgICAgICAgICAgY29sb3I6ICR7dGhlbWUuY29udGVudC5iYXNlMX07XG4gICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgICAgICAgYH1cbiAgICAgICAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IHRpdGxlIH1cbiAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgKSB9XG4gICAgPC9saT5cbiAgKTtcbn1cblxuZXhwb3J0IGludGVyZmFjZSBOYXZpZ2F0aW9uRHJhd2VyRm9vdGVyUHJvcHMge1xuICBpdGVtczogVXNlck1lbnVTY2hlbWFFbnRyeVtdO1xuICBvbkNsb3NlPzogKCkgPT4gdm9pZDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIE5hdmlnYXRpb25EcmF3ZXJGb290ZXIoe1xuICBpdGVtcyxcbiAgb25DbG9zZSxcbn06IE5hdmlnYXRpb25EcmF3ZXJGb290ZXJQcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgcmV0dXJuIChcbiAgICA8dWwgY3NzPXtjc3NgXG4gICAgICBwYWRkaW5nOiAwO1xuICAgICAgbWFyZ2luLXRvcDogJHtweFRvUmVtKDE0KX07XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgID4gYnV0dG9uIHtcbiAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTQpfTtcbiAgICAgICAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcbiAgICAgIH1cbiAgICBgfVxuICAgID5cbiAgICAgIHsgaXRlbXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICA8TmF2aWdhdGlvbkRyYXdlckZvb3Rlckxpc3RJdGVtXG4gICAgICAgICAga2V5PXtpbmRleH1cbiAgICAgICAgICBvbkNsb3NlPXtvbkNsb3NlfVxuICAgICAgICAgIHsuLi5pdGVtfVxuICAgICAgICAvPlxuICAgICAgKSkgfVxuICAgIDwvdWw+XG4gICk7XG59XG4iXX0= */"), HOVER$1`
        background-color: ${theme.background.groupedBase};
      `, process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    children: href != null ? jsx(LinkComponent, {
      href: href,
      css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " outline:none;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      onClick: onClose,
      children: title
    }) : jsx("button", {
      css: /*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.subTitle2, " color:", theme.content.base1, ";outline:none;cursor:pointer;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      onClick: onClick,
      type: "button",
      children: title
    })
  });
}
function NavigationDrawerFooter({
  items,
  onClose
}) {
  return jsx("ul", {
    css: /*#__PURE__*/css("padding:0;margin-top:", pxToRem(14), ";display:flex;align-items:center;>button{font-size:", pxToRem(14), ";font-weight:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooter;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    children: items.map((item, index) => jsx(NavigationDrawerFooterListItem, {
      onClose: onClose,
      ...item
    }, index))
  });
}

function NavigationDrawer({
  open,
  logo,
  menuSchema,
  supplementary,
  onClose,
  onAppDownload,
  ...rest
}) {
  const {
    userMenu,
    showAppDownloadButton = true
  } = supplementary;
  const log = useLogContext();
  const {
    localeData
  } = useGNBData();
  const drawerMenu = useMemo(() => menuSchema.map(mainMenu => ({
    ...mainMenu,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.main.item',
        category: 'click',
        params: {
          index
        }
      });
    },
    entries: mainMenu.entries?.map(subMenu => ({
      ...subMenu,
      onClick: ({
        item: {
          href
        },
        index
      }) => {
        log({
          key: 'drawer.sub.item',
          category: 'click',
          params: {
            index,
            href
          }
        });
      }
    }))
  })), [menuSchema, log]);
  const drawerUserMenu = useMemo(() => userMenu.filter(menu => menu.showOn?.includes('drawer')).map(({
    title,
    href,
    bullet
  }) => ({
    title,
    href,
    bullet,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.user.item',
        category: 'click',
        params: {
          index
        }
      });
    }
  })), [userMenu, log]);
  const drawerFooterMenu = useMemo(() => userMenu.filter(menu => menu.type === 'bottom'), [userMenu]);
  return jsxs(Drawer, {
    open: open,
    width: 270,
    onClose: onClose,
    ...rest,
    children: [jsx(NavigationDrawerHeader, {
      logo: {
        logo,
        onClick: () => window.open(logo?.href || 'https://ohou.se')
      },
      action: showAppDownloadButton ? {
        text: localeData?.appDownload ?? '앱다운로드',
        onClick: () => {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload?.();
        }
      } : undefined,
      supplementary: supplementary
    }), jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  });
}
const NavigationDrawerDivider = /*#__PURE__*/_styled(Divider, process.env.NODE_ENV === "production" ? {
  target: "e1thtjjz0"
} : {
  target: "e1thtjjz0",
  label: "NavigationDrawerDivider"
})("margin:", pxToRem(20), " 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    const index = fallbackMenuSchema.findIndex(item => item.active);
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (let i = 0; i < menuSchema.length; i += 1) {
    const child = menuSchema[i];
    const childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return [i, ...childActiveIds];
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (let i = 0; i < entry.entries.length; i += 1) {
      const child = entry.entries[i];
      const childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return [i, ...childActiveIds];
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

function useHover(onHover) {
  const onHoverRef = useRef(onHover);
  onHoverRef.current = onHover;
  const timeoutRef = useRef(null);
  const handleMouseTimeout = useCallback(() => {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  const handleMouseMove = useCallback(() => {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  const handleMouseEnter = useCallback(() => {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  const handleMouseLeave = useCallback(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

function NavigationBarPrimaryTabItem(props) {
  const {
    component = 'button',
    index,
    isActive,
    isOpen,
    children,
    onSelect,
    forwardedRef,
    onClick,
    ...rest
  } = props;
  const theme = useTheme();
  const log = useLogContext();
  const handleClick = useCallback(e => {
    if (onClick) {
      onClick(e);
    }
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index
      }
    });
  }, [log, onClick, index]);
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const Component = component;
  return jsx(Component, {
    "data-testid": "navigation-primary-tab-item",
    css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;display:inline-block;margin:0 ", pxToRem(10), ";padding:", pxToRem(21), " ", pxToRem(5), " ", pxToRem(15), ";font-size:", pxToRem(18), ";line-height:1;font-weight:bold;color:", theme.content.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), isActive && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), isOpen && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
          color: ${theme.content.primary1.basic};
        `, FOCUS`
          color: ${theme.content.primary1.basic};
          & > span {
            box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
          }
        `, process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnlUYWJJdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3RE0iLCJmaWxlIjoiUHJpbWFyeVRhYkl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IE1vdXNlRXZlbnQsIHVzZUNhbGxiYWNrIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIEhPVkVSLFxuICBSRVNFVF9CVVRUT04sXG4gIHB4VG9SZW0sXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcblxuaW1wb3J0IHsgdXNlTG9nQ29udGV4dCB9IGZyb20gJy4uL2xvZy1jb250ZXh0JztcbmltcG9ydCB7IHVzZUhvdmVyIH0gZnJvbSAnLi91c2VIb3Zlcic7XG5cbmV4cG9ydCB0eXBlIE5hdmlnYXRpb25CYXJQcmltYXJ5VGFiSXRlbVByb3BzXG48VCBleHRlbmRzIFJlYWN0LkVsZW1lbnRUeXBlID0gJ2J1dHRvbic+ID0ge1xuICBjb21wb25lbnQ/OiBULFxuICBpbmRleDogbnVtYmVyLFxuICBpc0FjdGl2ZT86IGJvb2xlYW4sXG4gIGlzT3Blbj86IGJvb2xlYW4sXG4gIG9uU2VsZWN0OiAoKSA9PiB2b2lkLFxuICBmb3J3YXJkZWRSZWY/OiBSZWFjdC5Db21wb25lbnRSZWY8VD4sXG4gIG9uQ2xpY2s/OiAoZT86IFJlYWN0Lk1vdXNlRXZlbnQpID0+IHZvaWQsXG59ICYgUmVhY3QuQ29tcG9uZW50UHJvcHM8VD47XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW1cbjxUIGV4dGVuZHMgUmVhY3QuRWxlbWVudFR5cGUgPSAnYnV0dG9uJz4oXG4gIHByb3BzOiBOYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW1Qcm9wczxUPixcbik6IFJlYWN0LlJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHtcbiAgICBjb21wb25lbnQgPSAnYnV0dG9uJyxcbiAgICBpbmRleCxcbiAgICBpc0FjdGl2ZSxcbiAgICBpc09wZW4sXG4gICAgY2hpbGRyZW4sXG4gICAgb25TZWxlY3QsXG4gICAgZm9yd2FyZGVkUmVmLFxuICAgIG9uQ2xpY2ssXG4gICAgLi4ucmVzdFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcblxuICBjb25zdCBsb2cgPSB1c2VMb2dDb250ZXh0KCk7XG4gIGNvbnN0IGhhbmRsZUNsaWNrID0gdXNlQ2FsbGJhY2soKGU6IE1vdXNlRXZlbnQpID0+IHtcbiAgICBpZiAob25DbGljaykgeyBvbkNsaWNrKGUpOyB9XG4gICAgbG9nKHtcbiAgICAgIGtleTogJ3ByaW1hcnkuaXRlbScsXG4gICAgICBjYXRlZ29yeTogJ2NsaWNrJyxcbiAgICAgIHBhcmFtczogeyBpbmRleCB9LFxuICAgIH0pO1xuICB9LCBbbG9nLCBvbkNsaWNrLCBpbmRleF0pO1xuXG4gIGNvbnN0IFtoYW5kbGVNb3VzZUVudGVyLCBoYW5kbGVNb3VzZUxlYXZlXSA9IHVzZUhvdmVyKG9uU2VsZWN0KTtcbiAgY29uc3QgQ29tcG9uZW50ID0gY29tcG9uZW50O1xuICByZXR1cm4gKFxuICAgIDxDb21wb25lbnRcbiAgICAgIGRhdGEtdGVzdGlkPVwibmF2aWdhdGlvbi1wcmltYXJ5LXRhYi1pdGVtXCJcbiAgICAgIGNzcz17W1xuICAgICAgICBjc3NgXG4gICAgICAgICAgJHtSRVNFVF9CVVRUT059XG4gICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgICAgICBtYXJnaW46IDAgJHtweFRvUmVtKDEwKX07XG4gICAgICAgICAgcGFkZGluZzogJHtweFRvUmVtKDIxKX0gJHtweFRvUmVtKDUpfSAke3B4VG9SZW0oMTUpfTtcbiAgICAgICAgICBmb250LXNpemU6ICR7cHhUb1JlbSgxOCl9O1xuICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxO1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgIGAsXG4gICAgICAgIGlzQWN0aXZlICYmIGNzc2BcbiAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICAgICAgYCxcbiAgICAgICAgaXNPcGVuICYmIGNzc2BcbiAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICAgICAgYCxcbiAgICAgICAgSE9WRVJgXG4gICAgICAgICAgY29sb3I6ICR7dGhlbWUuY29udGVudC5wcmltYXJ5MS5iYXNpY307XG4gICAgICAgIGAsXG4gICAgICAgIEZPQ1VTYFxuICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICYgPiBzcGFuIHtcbiAgICAgICAgICAgIGJveC1zaGFkb3c6IDAgMCAwICR7cHhUb1JlbSgzKX0gJHt0aGVtZS5pbnRlcmFjdGl2ZS5wcmltYXJ5MS50aGlufTtcbiAgICAgICAgICB9XG4gICAgICAgIGAsXG4gICAgICBdfVxuICAgICAgcmVmPXtmb3J3YXJkZWRSZWZ9XG4gICAgICBvbkNsaWNrPXtoYW5kbGVDbGlja31cbiAgICAgIG9uTW91c2VFbnRlcj17aGFuZGxlTW91c2VFbnRlcn1cbiAgICAgIG9uTW91c2VMZWF2ZT17aGFuZGxlTW91c2VMZWF2ZX1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIDxzcGFuIGNzcz17Y3NzYFxuICAgICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgICAgIG1hcmdpbjogJHtweFRvUmVtKC00KX07XG4gICAgICAgIHBhZGRpbmc6ICR7cHhUb1JlbSg0KX07XG4gICAgICAgIGJvcmRlci1yYWRpdXM6ICR7cHhUb1JlbSgzKX07XG4gICAgICBgfVxuICAgICAgPlxuICAgICAgICB7IGNoaWxkcmVuIH1cbiAgICAgIDwvc3Bhbj5cbiAgICA8L0NvbXBvbmVudD5cbiAgKTtcbn1cbiJdfQ== */"],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ...rest,
    children: jsx("span", {
      css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: children
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  const {
    leftmost,
    left,
    right,
    menuEntries,
    activeId,
    selectedId,
    onMouseEnter,
    onMouseLeave,
    onSelect
  } = props;
  const LinkComponent = useLinkContext();
  const childRef = useRef(null);
  const isPc = useMedia(`(min-width: ${BREAK_POINT.tablet}px)`, true);
  const nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT$1);
  const scrollDir = useScrollDirection();
  return jsx(StyledSticky$1, {
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX$1.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef,
    children: jsxs(StyledContainer$1, {
      children: [jsx(LeftMost, {
        children: leftmost
      }), jsx(Left, {
        children: left
      }), jsx(NavigationBarPrimaryTabList, {
        children: menuEntries.map((item, index) => jsx(NavigationBarPrimaryTabItem, {
          index: index,
          component: LinkComponent,
          href: item.href,
          isActive: activeId === index,
          isOpen: selectedId === index,
          onSelect: () => onSelect(item, index),
          children: item.title
        }, index))
      }), jsx(Right$1, {
        children: right
      })]
    })
  });
}
const StyledSticky$1 = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e1uull345"
} : {
  target: "e1uull345",
  label: "StyledSticky"
})("background:", ({
  theme
}) => theme.background.base, ";border-bottom:", pxToRem(1), " solid ", ({
  theme
}) => theme.divider, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStGbUMiLCJmaWxlIjoiUHJpbWFyeS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHtcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIEJSRUFLX1BPSU5ULFxuICBNRURJQV9RVUVSWSxcbiAgWklOREVYLFxuICBweFRvUmVtLFxuICB1c2VNZWRpYSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuXG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0gfSBmcm9tICcuL1ByaW1hcnlUYWJJdGVtJztcbmltcG9ydCB7IE1lbnVTY2hlbWFFbnRyeSB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3QgSU5JVElBTF9OT0RFX0hFSUdIVCA9IDgxO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25CYXJQcmltYXJ5UHJvcHMge1xuICBsZWZ0bW9zdDogUmVhY3QuUmVhY3ROb2RlO1xuICBsZWZ0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIHJpZ2h0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHNlbGVjdGVkSWQ6IG51bWJlciB8IG51bGw7XG4gIG9uTW91c2VFbnRlcj86IFJlYWN0Lk1vdXNlRXZlbnRIYW5kbGVyO1xuICBvbk1vdXNlTGVhdmU/OiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTmF2aWdhdGlvbkJhclByaW1hcnkoXG4gIHByb3BzOiBOYXZpZ2F0aW9uQmFyUHJpbWFyeVByb3BzLFxuKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgbGVmdG1vc3QsXG4gICAgbGVmdCxcbiAgICByaWdodCxcbiAgICBtZW51RW50cmllcyxcbiAgICBhY3RpdmVJZCxcbiAgICBzZWxlY3RlZElkLFxuICAgIG9uTW91c2VFbnRlcixcbiAgICBvbk1vdXNlTGVhdmUsXG4gICAgb25TZWxlY3QsXG4gIH0gPSBwcm9wcztcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IGlzUGMgPSB1c2VNZWRpYShgKG1pbi13aWR0aDogJHtCUkVBS19QT0lOVC50YWJsZXR9cHgpYCwgdHJ1ZSk7XG4gIGNvbnN0IG5vZGVIZWlnaHQgPSB1c2VOb2RlSGVpZ2h0KGNoaWxkUmVmLCBJTklUSUFMX05PREVfSEVJR0hUKTtcbiAgY29uc3Qgc2Nyb2xsRGlyID0gdXNlU2Nyb2xsRGlyZWN0aW9uKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8U3R5bGVkU3RpY2t5XG4gICAgICBkaXJlY3Rpb249XCJ0b3BcIlxuICAgICAgb2Zmc2V0PXshaXNQYyAmJiBzY3JvbGxEaXIgPT09ICdkb3duJyA/IC1ub2RlSGVpZ2h0IDogMH1cbiAgICAgIG9mZnNldFJhbmdlPXtpc1BjID8gWzAsIDBdIDogWy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIHpJbmRleD17WklOREVYLmFwcEJhciArIDJ9XG4gICAgICB0cmFuc2l0aW9uPXswLjF9XG4gICAgICBvbk1vdXNlRW50ZXI9e29uTW91c2VFbnRlcn1cbiAgICAgIG9uTW91c2VMZWF2ZT17b25Nb3VzZUxlYXZlfVxuICAgICAgZm9yd2FyZFJlZj17Y2hpbGRSZWZ9XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lcj5cbiAgICAgICAgPExlZnRNb3N0PnsgbGVmdG1vc3QgfTwvTGVmdE1vc3Q+XG4gICAgICAgIDxMZWZ0PnsgbGVmdCB9PC9MZWZ0PlxuICAgICAgICA8TmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0PlxuICAgICAgICAgIHsgbWVudUVudHJpZXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJQcmltYXJ5VGFiSXRlbVxuICAgICAgICAgICAgICBrZXk9e2luZGV4fVxuICAgICAgICAgICAgICBpbmRleD17aW5kZXh9XG4gICAgICAgICAgICAgIGNvbXBvbmVudD17TGlua0NvbXBvbmVudH1cbiAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICBpc0FjdGl2ZT17YWN0aXZlSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBpc09wZW49e3NlbGVjdGVkSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IGl0ZW0udGl0bGUgfVxuICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0+XG4gICAgICAgICAgKSkgfVxuICAgICAgICA8L05hdmlnYXRpb25CYXJQcmltYXJ5VGFiTGlzdD5cbiAgICAgICAgPFJpZ2h0PnsgcmlnaHQgfTwvUmlnaHQ+XG4gICAgICA8L1N0eWxlZENvbnRhaW5lcj5cbiAgICA8L1N0eWxlZFN0aWNreT5cbiAgKTtcbn1cblxuY29uc3QgU3R5bGVkU3RpY2t5ID0gc3R5bGVkKFN0aWNreSlgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYmFja2dyb3VuZC5iYXNlfTtcbiAgYm9yZGVyLWJvdHRvbTogJHtweFRvUmVtKDEpfSBzb2xpZCAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmRpdmlkZXJ9O1xuYDtcblxuY29uc3QgU3R5bGVkQ29udGFpbmVyID0gc3R5bGVkKENvbnRhaW5lcilgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSg1MCl9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBsaW5lLWhlaWdodDogMDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSg4MCl9O1xuICAgIHBhZGRpbmctdG9wOiAke3B4VG9SZW0oMTApfTtcbiAgICBwYWRkaW5nLWJvdHRvbTogJHtweFRvUmVtKDEwKX07XG4gIGApfVxuYDtcblxuY29uc3QgTGVmdE1vc3QgPSBzdHlsZWQuZGl2YFxuICBmbGV4OiAwIDAgYXV0bztcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oLTcpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogbm9uZTtcbiAgYCl9XG4gIGA7XG5cbmNvbnN0IExlZnQgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICBsZWZ0OiA1MCU7XG4gIHRvcDogNTAlO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5pbnRlcmFjdGl2ZS5iYXNlMX07XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIHBvc2l0aW9uOiBzdGF0aWM7XG4gICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oMjApfTtcbiAgICBsZWZ0OiBub25lO1xuICAgIHRvcDogbm9uZTtcbiAgICB0cmFuc2Zvcm06IG5vbmU7XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignbGFwdG9wJywgY3NzYFxuICAgIG1hcmdpbi1yaWdodDogJHtweFRvUmVtKDM1KX07XG4gIGApfVxuYDtcblxuY29uc3QgTmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAxIDBweDtcbiAgZGlzcGxheTogbm9uZTtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogYmxvY2s7XG4gIGApfVxuICBgO1xuXG5jb25zdCBSaWdodCA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDAgMCBhdXRvO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGZsZXg6IDAgMSAke3B4VG9SZW0oNDc2KX07XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGNzc2BcbiAgICBmbGV4OiAwIDEgJHtweFRvUmVtKDY1MCl9O1xuICBgKX1cbiAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGNzc2BcbiAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgtNyl9O1xuICBgKX1cbmA7XG4iXX0= */"));
const StyledContainer$1 = /*#__PURE__*/_styled(Container$z, process.env.NODE_ENV === "production" ? {
  target: "e1uull344"
} : {
  target: "e1uull344",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;height:", pxToRem(50), ";box-sizing:border-box;line-height:0;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(80), ";padding-top:", pxToRem(10), ";padding-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const LeftMost = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uull343"
} : {
  target: "e1uull343",
  label: "LeftMost"
})("flex:0 0 auto;display:block;margin-left:", pxToRem(-7), ";", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "jk5cn7-LeftMost",
  styles: "display:none;label:LeftMost;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVIaUMiLCJmaWxlIjoiUHJpbWFyeS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHtcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIEJSRUFLX1BPSU5ULFxuICBNRURJQV9RVUVSWSxcbiAgWklOREVYLFxuICBweFRvUmVtLFxuICB1c2VNZWRpYSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuXG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0gfSBmcm9tICcuL1ByaW1hcnlUYWJJdGVtJztcbmltcG9ydCB7IE1lbnVTY2hlbWFFbnRyeSB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3QgSU5JVElBTF9OT0RFX0hFSUdIVCA9IDgxO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25CYXJQcmltYXJ5UHJvcHMge1xuICBsZWZ0bW9zdDogUmVhY3QuUmVhY3ROb2RlO1xuICBsZWZ0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIHJpZ2h0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHNlbGVjdGVkSWQ6IG51bWJlciB8IG51bGw7XG4gIG9uTW91c2VFbnRlcj86IFJlYWN0Lk1vdXNlRXZlbnRIYW5kbGVyO1xuICBvbk1vdXNlTGVhdmU/OiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTmF2aWdhdGlvbkJhclByaW1hcnkoXG4gIHByb3BzOiBOYXZpZ2F0aW9uQmFyUHJpbWFyeVByb3BzLFxuKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgbGVmdG1vc3QsXG4gICAgbGVmdCxcbiAgICByaWdodCxcbiAgICBtZW51RW50cmllcyxcbiAgICBhY3RpdmVJZCxcbiAgICBzZWxlY3RlZElkLFxuICAgIG9uTW91c2VFbnRlcixcbiAgICBvbk1vdXNlTGVhdmUsXG4gICAgb25TZWxlY3QsXG4gIH0gPSBwcm9wcztcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IGlzUGMgPSB1c2VNZWRpYShgKG1pbi13aWR0aDogJHtCUkVBS19QT0lOVC50YWJsZXR9cHgpYCwgdHJ1ZSk7XG4gIGNvbnN0IG5vZGVIZWlnaHQgPSB1c2VOb2RlSGVpZ2h0KGNoaWxkUmVmLCBJTklUSUFMX05PREVfSEVJR0hUKTtcbiAgY29uc3Qgc2Nyb2xsRGlyID0gdXNlU2Nyb2xsRGlyZWN0aW9uKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8U3R5bGVkU3RpY2t5XG4gICAgICBkaXJlY3Rpb249XCJ0b3BcIlxuICAgICAgb2Zmc2V0PXshaXNQYyAmJiBzY3JvbGxEaXIgPT09ICdkb3duJyA/IC1ub2RlSGVpZ2h0IDogMH1cbiAgICAgIG9mZnNldFJhbmdlPXtpc1BjID8gWzAsIDBdIDogWy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIHpJbmRleD17WklOREVYLmFwcEJhciArIDJ9XG4gICAgICB0cmFuc2l0aW9uPXswLjF9XG4gICAgICBvbk1vdXNlRW50ZXI9e29uTW91c2VFbnRlcn1cbiAgICAgIG9uTW91c2VMZWF2ZT17b25Nb3VzZUxlYXZlfVxuICAgICAgZm9yd2FyZFJlZj17Y2hpbGRSZWZ9XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lcj5cbiAgICAgICAgPExlZnRNb3N0PnsgbGVmdG1vc3QgfTwvTGVmdE1vc3Q+XG4gICAgICAgIDxMZWZ0PnsgbGVmdCB9PC9MZWZ0PlxuICAgICAgICA8TmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0PlxuICAgICAgICAgIHsgbWVudUVudHJpZXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJQcmltYXJ5VGFiSXRlbVxuICAgICAgICAgICAgICBrZXk9e2luZGV4fVxuICAgICAgICAgICAgICBpbmRleD17aW5kZXh9XG4gICAgICAgICAgICAgIGNvbXBvbmVudD17TGlua0NvbXBvbmVudH1cbiAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICBpc0FjdGl2ZT17YWN0aXZlSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBpc09wZW49e3NlbGVjdGVkSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IGl0ZW0udGl0bGUgfVxuICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0+XG4gICAgICAgICAgKSkgfVxuICAgICAgICA8L05hdmlnYXRpb25CYXJQcmltYXJ5VGFiTGlzdD5cbiAgICAgICAgPFJpZ2h0PnsgcmlnaHQgfTwvUmlnaHQ+XG4gICAgICA8L1N0eWxlZENvbnRhaW5lcj5cbiAgICA8L1N0eWxlZFN0aWNreT5cbiAgKTtcbn1cblxuY29uc3QgU3R5bGVkU3RpY2t5ID0gc3R5bGVkKFN0aWNreSlgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYmFja2dyb3VuZC5iYXNlfTtcbiAgYm9yZGVyLWJvdHRvbTogJHtweFRvUmVtKDEpfSBzb2xpZCAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmRpdmlkZXJ9O1xuYDtcblxuY29uc3QgU3R5bGVkQ29udGFpbmVyID0gc3R5bGVkKENvbnRhaW5lcilgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSg1MCl9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBsaW5lLWhlaWdodDogMDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSg4MCl9O1xuICAgIHBhZGRpbmctdG9wOiAke3B4VG9SZW0oMTApfTtcbiAgICBwYWRkaW5nLWJvdHRvbTogJHtweFRvUmVtKDEwKX07XG4gIGApfVxuYDtcblxuY29uc3QgTGVmdE1vc3QgPSBzdHlsZWQuZGl2YFxuICBmbGV4OiAwIDAgYXV0bztcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oLTcpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogbm9uZTtcbiAgYCl9XG4gIGA7XG5cbmNvbnN0IExlZnQgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICBsZWZ0OiA1MCU7XG4gIHRvcDogNTAlO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5pbnRlcmFjdGl2ZS5iYXNlMX07XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIHBvc2l0aW9uOiBzdGF0aWM7XG4gICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oMjApfTtcbiAgICBsZWZ0OiBub25lO1xuICAgIHRvcDogbm9uZTtcbiAgICB0cmFuc2Zvcm06IG5vbmU7XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignbGFwdG9wJywgY3NzYFxuICAgIG1hcmdpbi1yaWdodDogJHtweFRvUmVtKDM1KX07XG4gIGApfVxuYDtcblxuY29uc3QgTmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAxIDBweDtcbiAgZGlzcGxheTogbm9uZTtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogYmxvY2s7XG4gIGApfVxuICBgO1xuXG5jb25zdCBSaWdodCA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDAgMCBhdXRvO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGZsZXg6IDAgMSAke3B4VG9SZW0oNDc2KX07XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGNzc2BcbiAgICBmbGV4OiAwIDEgJHtweFRvUmVtKDY1MCl9O1xuICBgKX1cbiAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGNzc2BcbiAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgtNyl9O1xuICBgKX1cbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Left = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uull342"
} : {
  target: "e1uull342",
  label: "Left"
})("position:absolute;flex:0 0 auto;left:50%;top:50%;color:", ({
  theme
}) => theme.interactive.base1, ";transform:translate(-50%, -50%);", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("position:static;margin-right:", pxToRem(20), ";left:none;top:none;transform:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:Left;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/css("margin-right:", pxToRem(35), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Left;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRIdUIiLCJmaWxlIjoiUHJpbWFyeS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHtcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIEJSRUFLX1BPSU5ULFxuICBNRURJQV9RVUVSWSxcbiAgWklOREVYLFxuICBweFRvUmVtLFxuICB1c2VNZWRpYSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuXG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0gfSBmcm9tICcuL1ByaW1hcnlUYWJJdGVtJztcbmltcG9ydCB7IE1lbnVTY2hlbWFFbnRyeSB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3QgSU5JVElBTF9OT0RFX0hFSUdIVCA9IDgxO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25CYXJQcmltYXJ5UHJvcHMge1xuICBsZWZ0bW9zdDogUmVhY3QuUmVhY3ROb2RlO1xuICBsZWZ0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIHJpZ2h0OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHNlbGVjdGVkSWQ6IG51bWJlciB8IG51bGw7XG4gIG9uTW91c2VFbnRlcj86IFJlYWN0Lk1vdXNlRXZlbnRIYW5kbGVyO1xuICBvbk1vdXNlTGVhdmU/OiBSZWFjdC5Nb3VzZUV2ZW50SGFuZGxlcjtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gTmF2aWdhdGlvbkJhclByaW1hcnkoXG4gIHByb3BzOiBOYXZpZ2F0aW9uQmFyUHJpbWFyeVByb3BzLFxuKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB7XG4gICAgbGVmdG1vc3QsXG4gICAgbGVmdCxcbiAgICByaWdodCxcbiAgICBtZW51RW50cmllcyxcbiAgICBhY3RpdmVJZCxcbiAgICBzZWxlY3RlZElkLFxuICAgIG9uTW91c2VFbnRlcixcbiAgICBvbk1vdXNlTGVhdmUsXG4gICAgb25TZWxlY3QsXG4gIH0gPSBwcm9wcztcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IGlzUGMgPSB1c2VNZWRpYShgKG1pbi13aWR0aDogJHtCUkVBS19QT0lOVC50YWJsZXR9cHgpYCwgdHJ1ZSk7XG4gIGNvbnN0IG5vZGVIZWlnaHQgPSB1c2VOb2RlSGVpZ2h0KGNoaWxkUmVmLCBJTklUSUFMX05PREVfSEVJR0hUKTtcbiAgY29uc3Qgc2Nyb2xsRGlyID0gdXNlU2Nyb2xsRGlyZWN0aW9uKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8U3R5bGVkU3RpY2t5XG4gICAgICBkaXJlY3Rpb249XCJ0b3BcIlxuICAgICAgb2Zmc2V0PXshaXNQYyAmJiBzY3JvbGxEaXIgPT09ICdkb3duJyA/IC1ub2RlSGVpZ2h0IDogMH1cbiAgICAgIG9mZnNldFJhbmdlPXtpc1BjID8gWzAsIDBdIDogWy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIHpJbmRleD17WklOREVYLmFwcEJhciArIDJ9XG4gICAgICB0cmFuc2l0aW9uPXswLjF9XG4gICAgICBvbk1vdXNlRW50ZXI9e29uTW91c2VFbnRlcn1cbiAgICAgIG9uTW91c2VMZWF2ZT17b25Nb3VzZUxlYXZlfVxuICAgICAgZm9yd2FyZFJlZj17Y2hpbGRSZWZ9XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lcj5cbiAgICAgICAgPExlZnRNb3N0PnsgbGVmdG1vc3QgfTwvTGVmdE1vc3Q+XG4gICAgICAgIDxMZWZ0PnsgbGVmdCB9PC9MZWZ0PlxuICAgICAgICA8TmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0PlxuICAgICAgICAgIHsgbWVudUVudHJpZXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJQcmltYXJ5VGFiSXRlbVxuICAgICAgICAgICAgICBrZXk9e2luZGV4fVxuICAgICAgICAgICAgICBpbmRleD17aW5kZXh9XG4gICAgICAgICAgICAgIGNvbXBvbmVudD17TGlua0NvbXBvbmVudH1cbiAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICBpc0FjdGl2ZT17YWN0aXZlSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBpc09wZW49e3NlbGVjdGVkSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IGl0ZW0udGl0bGUgfVxuICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyUHJpbWFyeVRhYkl0ZW0+XG4gICAgICAgICAgKSkgfVxuICAgICAgICA8L05hdmlnYXRpb25CYXJQcmltYXJ5VGFiTGlzdD5cbiAgICAgICAgPFJpZ2h0PnsgcmlnaHQgfTwvUmlnaHQ+XG4gICAgICA8L1N0eWxlZENvbnRhaW5lcj5cbiAgICA8L1N0eWxlZFN0aWNreT5cbiAgKTtcbn1cblxuY29uc3QgU3R5bGVkU3RpY2t5ID0gc3R5bGVkKFN0aWNreSlgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYmFja2dyb3VuZC5iYXNlfTtcbiAgYm9yZGVyLWJvdHRvbTogJHtweFRvUmVtKDEpfSBzb2xpZCAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmRpdmlkZXJ9O1xuYDtcblxuY29uc3QgU3R5bGVkQ29udGFpbmVyID0gc3R5bGVkKENvbnRhaW5lcilgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBoZWlnaHQ6ICR7cHhUb1JlbSg1MCl9O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBsaW5lLWhlaWdodDogMDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSg4MCl9O1xuICAgIHBhZGRpbmctdG9wOiAke3B4VG9SZW0oMTApfTtcbiAgICBwYWRkaW5nLWJvdHRvbTogJHtweFRvUmVtKDEwKX07XG4gIGApfVxuYDtcblxuY29uc3QgTGVmdE1vc3QgPSBzdHlsZWQuZGl2YFxuICBmbGV4OiAwIDAgYXV0bztcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1hcmdpbi1sZWZ0OiAke3B4VG9SZW0oLTcpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogbm9uZTtcbiAgYCl9XG4gIGA7XG5cbmNvbnN0IExlZnQgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGZsZXg6IDAgMCBhdXRvO1xuICBsZWZ0OiA1MCU7XG4gIHRvcDogNTAlO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5pbnRlcmFjdGl2ZS5iYXNlMX07XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIHBvc2l0aW9uOiBzdGF0aWM7XG4gICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oMjApfTtcbiAgICBsZWZ0OiBub25lO1xuICAgIHRvcDogbm9uZTtcbiAgICB0cmFuc2Zvcm06IG5vbmU7XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignbGFwdG9wJywgY3NzYFxuICAgIG1hcmdpbi1yaWdodDogJHtweFRvUmVtKDM1KX07XG4gIGApfVxuYDtcblxuY29uc3QgTmF2aWdhdGlvbkJhclByaW1hcnlUYWJMaXN0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMSAxIDBweDtcbiAgZGlzcGxheTogbm9uZTtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgZGlzcGxheTogYmxvY2s7XG4gIGApfVxuICBgO1xuXG5jb25zdCBSaWdodCA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDAgMCBhdXRvO1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGZsZXg6IDAgMSAke3B4VG9SZW0oNDc2KX07XG4gIGApfVxuICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGNzc2BcbiAgICBmbGV4OiAwIDEgJHtweFRvUmVtKDY1MCl9O1xuICBgKX1cbiAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGNzc2BcbiAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgtNyl9O1xuICBgKX1cbmA7XG4iXX0= */"));
const NavigationBarPrimaryTabList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uull341"
} : {
  target: "e1uull341",
  label: "NavigationBarPrimaryTabList"
})("flex:1 1 0px;display:none;white-space:nowrap;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "17kma8h-NavigationBarPrimaryTabList",
  styles: "display:block;label:NavigationBarPrimaryTabList;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Right$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1uull340"
} : {
  target: "e1uull340",
  label: "Right"
})("flex:0 0 auto;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("flex:0 1 ", pxToRem(476), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " ", MEDIA_QUERY.min('desktop', /*#__PURE__*/css("flex:0 1 ", pxToRem(650), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " ", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("margin-right:", pxToRem(-7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Right;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

/* eslint-disable camelcase */

/** 글로벌에서만 찍는 로그를 한시적으로 적용합니다. 추후 국내와 국외 로그 스펙이 같거나 비슷해져서 통합 가능해졌을 때 Context형태로 통합하는 것을 권장합니다. */

const globalLog = {
  logClickTab: ({
    section_id,
    section_idx
  }) => {
    L({
      category: 'click',
      section_id,
      section_idx,
      type: 'TAB'
    });
  },
  logClickAutocompleteKeyword: ({
    id,
    index
  }) => {
    L({
      category: 'click',
      section_id: 'AUTOCOMPLETE',
      type: 'KEYWORD',
      id,
      index
    });
  },
  logClickSearchInput: () => {
    L({
      category: 'click',
      section_id: 'TOPBAR',
      type: 'INPUT',
      id: 'SEARCH'
    });
  }
};

const useNavigationLog = () => {
  const log = useLogContext();
  const logTabImpression = useCallback((menu, index) => {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  const logTabClick = useCallback((menu, index, isHncTopicTab) => {
    const defaultParams = {
      index,
      section: '서브 메뉴',
      type: 'tab',
      id: menu.logId ?? menu.title
    };
    const params = isHncTopicTab ? {
      ...defaultParams,
      type: 'topic',
      section_id: 'LNB'
    } : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params
    });
  }, [log]);
  const logMoreButtonClick = useCallback(() => {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
const useMoreMenus = ({
  menus,
  scrollableEntries,
  activeId,
  primaryId
}) => {
  const menusWithIndex = useMemo(() => menus.map((menu, index) => ({
    ...menu,
    index
  })), [menus]);
  const [moreMenus, setMoreMenus] = useState(menusWithIndex);
  /** moreButton + popper의 visible 여부 */
  const [isVisible, setIsVisible] = useState(false);
  const [isGradientVisible, setIsGradientVisible] = useState(true);
  /** popper를 강제로 닫을지 여부 */
  const [isForcePopperClosed, setIsForcePopperClosed] = useState(false);
  /** popper의 open 여부 */
  const [isPopperOpened, setIsPopperOpened] = useState(false);

  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  const [bottomSheetHeight, setBottomSheetHeight] = useState('auto');
  const [hasClosingInteraction, setHasClosingInteraction] = useState(false);
  const containerRef = useRef(null);
  const currentClientY = useRef(0);
  const isMobile = useResponsive().breakpoint === 'mobile';
  const theme = useTheme();
  const Link = useLinkContext();
  const {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = useCallback((menu, index) => {
    if (!isHncSecondaryTabItem || !menu.logId) {
      return;
    }
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  const handleClick = useCallback((menu, index) => {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  const activeIdInMoreMenus = useMemo(() => {
    if (activeId == null) {
      return null;
    }
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  const handleOpenBottomSheet = () => {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  const handleCloseBottomSheet = () => {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  const handleTouchMove = useCallback(event => {
    if (event.changedTouches[0]?.clientY) {
      const scrollDown = currentClientY.current < event.changedTouches[0].clientY;
      if (scrollDown) {
        handleCloseBottomSheet();
      }
    }
  }, []);
  const handleChangeVisibleMenu = useCallback((changedMenu, changedMenuIndex, visibleRatio) => {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) {
      return;
    }
    if (visibleRatio < 1) {
      setMoreMenus(menus => menus.map(menu => menu.index).includes(changedMenuIndex) ? menus : [...menus, {
        ...changedMenu,
        index: changedMenuIndex
      }].sort((a, b) => a.index - b.index));
    } else {
      setMoreMenus(menus => menus.filter(menu => changedMenuIndex !== menu.index));
    }
  }, [isMobile, menusWithIndex]);
  const handleChangeVisibleGradient = node => {
    const scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - node?.getBoundingClientRect().width;
    setIsGradientVisible(scrollRight > 5);
  };
  const handleResize = () => {
    if (!containerRef.current) {
      return;
    }
    const scrollWidth = containerRef.current.scrollWidth;
    const elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    const overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  useResize(containerRef, handleResize);
  useEffect(() => {
    setMoreMenus([]);
  }, [scrollableEntries]);
  useEffect(() => {
    if (isMobile) {
      return;
    }
    const handleScroll = () => {
      const isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    const throttleScroll = throttle$1(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return () => {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  const MoreMenus = useMemo(() => {
    return jsx(MoreMenusContainer, {
      children: moreMenus.map((menu, index) => jsx(StyledIntersectionObserver, {
        onIntersect: () => handleIntersect(menu, menu.index),
        children: jsx(Link, {
          href: menu.href,
          onClick: () => {
            handleClick(menu, menu.index);
            setIsForcePopperClosed(true);
          },
          css: [cssLink, /*#__PURE__*/css("@media(hover: hover){&:hover{color:", theme.content.primary1.basic, ";}}", activeIdInMoreMenus === index && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), FOCUS`
                  color: ${theme.content.primary1.basic};
                `, process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
          children: menu.title
        })
      }, menu.title))
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef,
    isPopperOpened,
    moreMenusComponent: isVisible ? jsx(Popper$1, {
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: ({
        onClick,
        isOpen
      }) => jsxs(Fragment$1, {
        children: [jsx(MoreButton, {
          isGradientVisible: isGradientVisible,
          type: "button",
          onClick: () => {
            handleOpenBottomSheet();
            onClick();
            logMoreButtonClick();
          },
          children: jsx(ChevronDownIcon, {
            size: 12,
            name: "chevron_down",
            fill: theme => theme.content.base1
          })
        }), isMobile && isOpen && jsx(StyledModal, {
          width: 400,
          hasInteraction: true,
          hasGrabber: true,
          height: bottomSheetHeight,
          hasClosingInteraction: hasClosingInteraction,
          onBlur: handleCloseBottomSheet,
          onTouchStart: event => {
            if (event.changedTouches[0]?.clientY) {
              currentClientY.current = event.changedTouches[0]?.clientY;
            }
          },
          onTouchMove: handleTouchMove,
          disableBackgroundScroll: true,
          header: {
            title: '탭 선택하기',
            onClose: handleCloseBottomSheet
          },
          onTransitionEnd: () => {
            if (hasClosingInteraction) {
              onClick();
            }
          },
          children: jsx(SwitchTransition$1, {
            children: jsx(Transition$1, {
              timeout: 200,
              children: MoreMenus
            })
          })
        })]
      }),
      children: !isMobile && MoreMenus
    }) : null
  };
};
const cssLink = /*#__PURE__*/css(FONT_STYLE.body1_small, " display:block;padding:", pxToRem(10), " 0 ", pxToRem(10), " ", pxToRem(26), ";text-align:start;font-weight:700;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.subTitle1, ";padding:0 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVzZU1vcmVNZW51cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ1RpQyIsImZpbGUiOiJ1c2VNb3JlTWVudXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7XG4gIE11dGFibGVSZWZPYmplY3QsXG4gIFRvdWNoRXZlbnQsXG4gIHVzZUNhbGxiYWNrLFxuICB1c2VFZmZlY3QsXG4gIHVzZU1lbW8sXG4gIHVzZVJlZixcbiAgdXNlU3RhdGUsXG59IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBTd2l0Y2hUcmFuc2l0aW9uLCBUcmFuc2l0aW9uIH0gZnJvbSAncmVhY3QtdHJhbnNpdGlvbi1ncm91cCc7XG5pbXBvcnQgdGhyb3R0bGUgZnJvbSAnbG9kYXNoLWVzL3Rocm90dGxlJztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIEZPTlRfU1RZTEUsXG4gIEludGVyc2VjdGlvbk9ic2VydmVyLFxuICBNRURJQV9RVUVSWSxcbiAgUkVTRVRfQlVUVE9OLFxuICBoZXhUb1JnYmEsXG4gIHB4VG9SZW0sXG4gIHVzZVJlc2l6ZSxcbiAgdXNlUmVzcG9uc2l2ZSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHtcbiAgSWNvbixcbiAgTW9kYWwsXG4gIFBvcHBlcixcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuaW1wb3J0IHsgdXNlTmF2aWdhdGlvbkxvZyB9IGZyb20gJy4vdXNlTmF2aWdhdGlvbkxvZyc7XG5cbmludGVyZmFjZSB1c2VyTW9yZU1lbnVzUGFyYW1zIHtcbiAgbWVudXM6IE1lbnVTY2hlbWFFbnRyeVtdO1xuICBzY3JvbGxhYmxlRW50cmllczogYm9vbGVhbjtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbDtcbn1cblxuaW50ZXJmYWNlIFVzZU1vcmVNZW51c1JldHVybnMge1xuICBvbkNoYW5nZVZpc2libGVNZW51OiAoY2hhbmdlZE1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgY2hhbmdlZE1lbnVJbmRleDogbnVtYmVyLCB2aXNpYmxlUmF0aW8/OiBudW1iZXIpID0+IHZvaWQ7XG4gIC8qKlxuICAgKiDsl6zrsLHsnYQg7Y+s7ZWo7ZWcIOuplOuJtOydmCDsoITssrTrpbwg7LCo7KeA7ZWY64qUIOyXmOumrOuovO2KuCBSZWZcbiAgICovXG4gIGNvbnRhaW5lclJlZjogTXV0YWJsZVJlZk9iamVjdDxIVE1MRGl2RWxlbWVudCB8IG51bGw+O1xuICBtb3JlTWVudXNDb21wb25lbnQ6IFJlYWN0LlJlYWN0RWxlbWVudCB8IG51bGw7XG4gIGlzUG9wcGVyT3BlbmVkOiBib29sZWFuO1xuICBvbkNoYW5nZVZpc2libGVHcmFkaWVudDogKG5vZGU6IEhUTUxFbGVtZW50KSA9PiB2b2lkO1xufVxuXG5pbnRlcmZhY2UgTWVudVNjaGVtYUVudHJ5V2l0aEluZGV4IGV4dGVuZHMgTWVudVNjaGVtYUVudHJ5IHtcbiAgaW5kZXg6IG51bWJlcjtcbn1cblxuZXhwb3J0IGNvbnN0IEJVVFRPTl9XSURUSCA9IDEwMDtcbi8qKlxuICogc2NyYW9sbGFibGVFbnRyaWVz6rCAIGZhbHNl7J28IOqyveyasFxuICog66mU64m0IGVudHJpZXMgVUnrpbwg64uk66W4IFVJ66GcIOuztOyXrOyjvOuKlCDroZzsp4Hrk6TsnYQg7Y+s7ZWo7ZWp64uI64ukLlxuICovXG5leHBvcnQgY29uc3QgdXNlTW9yZU1lbnVzID0gKHtcbiAgbWVudXMsXG4gIHNjcm9sbGFibGVFbnRyaWVzLFxuICBhY3RpdmVJZCxcbiAgcHJpbWFyeUlkLFxufTogdXNlck1vcmVNZW51c1BhcmFtcyk6IFVzZU1vcmVNZW51c1JldHVybnMgPT4ge1xuICBjb25zdCBtZW51c1dpdGhJbmRleCA9IHVzZU1lbW8oKCkgPT4gbWVudXMubWFwKChtZW51LCBpbmRleCkgPT4gKHsgLi4ubWVudSwgaW5kZXggfSkpLCBbbWVudXNdKTtcbiAgY29uc3QgW21vcmVNZW51cywgc2V0TW9yZU1lbnVzXSA9IHVzZVN0YXRlPE1lbnVTY2hlbWFFbnRyeVdpdGhJbmRleFtdPihtZW51c1dpdGhJbmRleCk7XG4gIC8qKiBtb3JlQnV0dG9uICsgcG9wcGVy7J2YIHZpc2libGUg7Jes67aAICovXG4gIGNvbnN0IFtpc1Zpc2libGUsIHNldElzVmlzaWJsZV0gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IFtpc0dyYWRpZW50VmlzaWJsZSwgc2V0SXNHcmFkaWVudFZpc2libGVdID0gdXNlU3RhdGUodHJ1ZSk7XG4gIC8qKiBwb3BwZXLrpbwg6rCV7KCc66GcIOuLq+ydhOyngCDsl6zrtoAgKi9cbiAgY29uc3QgW2lzRm9yY2VQb3BwZXJDbG9zZWQsIHNldElzRm9yY2VQb3BwZXJDbG9zZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuICAvKiogcG9wcGVy7J2YIG9wZW4g7Jes67aAICovXG4gIGNvbnN0IFtpc1BvcHBlck9wZW5lZCwgc2V0SXNQb3BwZXJPcGVuZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuXG4gIC8vIFRPRE86IGJvdHRvbVNoZWV0IOq0gOugqCDqs7XthrUg7J247YSw656Z7IWYIOqzte2Gte2ZlFxuICBjb25zdCBbYm90dG9tU2hlZXRIZWlnaHQsIHNldEJvdHRvbVNoZWV0SGVpZ2h0XSA9IHVzZVN0YXRlKCdhdXRvJyk7XG4gIGNvbnN0IFtoYXNDbG9zaW5nSW50ZXJhY3Rpb24sIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbl0gPSB1c2VTdGF0ZShmYWxzZSk7XG5cbiAgY29uc3QgY29udGFpbmVyUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IGN1cnJlbnRDbGllbnRZID0gdXNlUmVmKDApO1xuXG4gIGNvbnN0IGlzTW9iaWxlID0gdXNlUmVzcG9uc2l2ZSgpLmJyZWFrcG9pbnQgPT09ICdtb2JpbGUnO1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IExpbmsgPSB1c2VMaW5rQ29udGV4dCgpO1xuICBjb25zdCB7IGxvZ1RhYkNsaWNrLCBsb2dUYWJJbXByZXNzaW9uLCBsb2dNb3JlQnV0dG9uQ2xpY2sgfSA9IHVzZU5hdmlnYXRpb25Mb2coKTtcbiAgY29uc3QgaXNIbmNTZWNvbmRhcnlUYWJJdGVtID0gcHJpbWFyeUlkID09PSAwO1xuXG4gIGNvbnN0IGhhbmRsZUludGVyc2VjdCA9IHVzZUNhbGxiYWNrKChtZW51OiBNZW51U2NoZW1hRW50cnksIGluZGV4OiBudW1iZXIpID0+IHtcbiAgICBpZiAoIWlzSG5jU2Vjb25kYXJ5VGFiSXRlbSB8fCAhbWVudS5sb2dJZCkgeyByZXR1cm47IH1cbiAgICBsb2dUYWJJbXByZXNzaW9uKG1lbnUsIGluZGV4KTtcbiAgfSwgW2xvZ1RhYkltcHJlc3Npb24sIGlzSG5jU2Vjb25kYXJ5VGFiSXRlbV0pO1xuXG4gIGNvbnN0IGhhbmRsZUNsaWNrID0gdXNlQ2FsbGJhY2soKG1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgaW5kZXg6IG51bWJlcikgPT4ge1xuICAgIGxvZ1RhYkNsaWNrKG1lbnUsIGluZGV4LCAhIShpc0huY1NlY29uZGFyeVRhYkl0ZW0gJiYgbWVudS5sb2dJZCkpO1xuICB9LCBbbG9nVGFiQ2xpY2ssIGlzSG5jU2Vjb25kYXJ5VGFiSXRlbV0pO1xuXG4gIGNvbnN0IGFjdGl2ZUlkSW5Nb3JlTWVudXMgPSB1c2VNZW1vKCgpID0+IHtcbiAgICBpZiAoYWN0aXZlSWQgPT0gbnVsbCkgeyByZXR1cm4gbnVsbDsgfVxuICAgIHJldHVybiAoXG4gICAgICBhY3RpdmVJZCAtIChtZW51cy5sZW5ndGggLSBtb3JlTWVudXMubGVuZ3RoKVxuICAgICk7XG4gIH0sIFthY3RpdmVJZCwgbWVudXMubGVuZ3RoLCBtb3JlTWVudXMubGVuZ3RoXSk7XG5cbiAgY29uc3QgaGFuZGxlT3BlbkJvdHRvbVNoZWV0ID0gKCk6IHZvaWQgPT4ge1xuICAgIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbihmYWxzZSk7XG4gICAgc2V0Qm90dG9tU2hlZXRIZWlnaHQoJ2F1dG8nKTtcbiAgICBzZXRJc0ZvcmNlUG9wcGVyQ2xvc2VkKGZhbHNlKTtcbiAgfTtcblxuICBjb25zdCBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0ID0gKCk6IHZvaWQgPT4ge1xuICAgIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbih0cnVlKTtcbiAgICBzZXRCb3R0b21TaGVldEhlaWdodCgnMCUnKTtcbiAgfTtcblxuICBjb25zdCBoYW5kbGVUb3VjaE1vdmUgPSB1c2VDYWxsYmFjaygoZXZlbnQ6IFRvdWNoRXZlbnQ8SFRNTERpdkVsZW1lbnQ+KSA9PiB7XG4gICAgaWYgKGV2ZW50LmNoYW5nZWRUb3VjaGVzWzBdPy5jbGllbnRZKSB7XG4gICAgICBjb25zdCBzY3JvbGxEb3duID0gY3VycmVudENsaWVudFkuY3VycmVudCA8IGV2ZW50LmNoYW5nZWRUb3VjaGVzWzBdLmNsaWVudFk7XG4gICAgICBpZiAoc2Nyb2xsRG93bikge1xuICAgICAgICBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0KCk7XG4gICAgICB9XG4gICAgfVxuICB9LCBbXSk7XG5cbiAgY29uc3QgaGFuZGxlQ2hhbmdlVmlzaWJsZU1lbnUgPSB1c2VDYWxsYmFjaygoXG4gICAgY2hhbmdlZE1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgY2hhbmdlZE1lbnVJbmRleDogbnVtYmVyLCB2aXNpYmxlUmF0aW8/OiBudW1iZXIsXG4gICkgPT4ge1xuICAgIGlmIChpc01vYmlsZSkge1xuICAgICAgc2V0TW9yZU1lbnVzKG1lbnVzV2l0aEluZGV4KTtcbiAgICAgIHJldHVybjtcbiAgICB9XG4gICAgaWYgKHZpc2libGVSYXRpbyA9PSBudWxsKSB7IHJldHVybjsgfVxuICAgIGlmICh2aXNpYmxlUmF0aW8gPCAxKSB7XG4gICAgICBzZXRNb3JlTWVudXMoKG1lbnVzKSA9PiBtZW51cy5tYXAoKG1lbnUpID0+IG1lbnUuaW5kZXgpLmluY2x1ZGVzKGNoYW5nZWRNZW51SW5kZXgpXG4gICAgICAgID8gbWVudXNcbiAgICAgICAgOiBbLi4ubWVudXMsIHsgLi4uY2hhbmdlZE1lbnUsIGluZGV4OiBjaGFuZ2VkTWVudUluZGV4IH1dXG4gICAgICAgICAgLnNvcnQoKGEsIGIpID0+IGEuaW5kZXggLSBiLmluZGV4KSxcbiAgICAgICk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHNldE1vcmVNZW51cygobWVudXMpID0+IG1lbnVzLmZpbHRlcigobWVudSkgPT4gY2hhbmdlZE1lbnVJbmRleCAhPT0gbWVudS5pbmRleCksXG4gICAgICApO1xuICAgIH1cbiAgfSwgW2lzTW9iaWxlLCBtZW51c1dpdGhJbmRleF0pO1xuXG4gIGNvbnN0IGhhbmRsZUNoYW5nZVZpc2libGVHcmFkaWVudCA9IChub2RlOiBIVE1MRWxlbWVudCk6IHZvaWQgPT4ge1xuICAgIGNvbnN0IHNjcm9sbFJpZ2h0ID0gbm9kZS5zY3JvbGxXaWR0aCAtXG4gICAgICBNYXRoLmNlaWwobm9kZS5zY3JvbGxMZWZ0KSAtXG4gICAgICBub2RlPy5nZXRCb3VuZGluZ0NsaWVudFJlY3QoKS53aWR0aDtcblxuICAgIHNldElzR3JhZGllbnRWaXNpYmxlKHNjcm9sbFJpZ2h0ID4gNSk7XG4gIH07XG5cbiAgY29uc3QgaGFuZGxlUmVzaXplID0gKCk6IHZvaWQgPT4ge1xuICAgIGlmICghY29udGFpbmVyUmVmLmN1cnJlbnQpIHsgcmV0dXJuOyB9XG5cbiAgICBjb25zdCBzY3JvbGxXaWR0aCA9IGNvbnRhaW5lclJlZi5jdXJyZW50LnNjcm9sbFdpZHRoO1xuICAgIGNvbnN0IGVsZW1lbnRXaWR0aCA9IE1hdGguY2VpbChjb250YWluZXJSZWYuY3VycmVudC5nZXRCb3VuZGluZ0NsaWVudFJlY3QoKS53aWR0aCk7XG4gICAgY29uc3Qgb3ZlcmZsb3dXaWR0aCA9IE1hdGgubWF4KHNjcm9sbFdpZHRoIC0gZWxlbWVudFdpZHRoLCAwKTtcblxuICAgIHNldElzVmlzaWJsZShvdmVyZmxvd1dpZHRoID4gMCk7XG4gIH07XG5cbiAgdXNlUmVzaXplKGNvbnRhaW5lclJlZiwgaGFuZGxlUmVzaXplKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIHNldE1vcmVNZW51cyhbXSk7XG4gIH0sIFtzY3JvbGxhYmxlRW50cmllc10pO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKGlzTW9iaWxlKSB7IHJldHVybjsgfVxuXG4gICAgY29uc3QgaGFuZGxlU2Nyb2xsID0gKCk6IHZvaWQgPT4ge1xuICAgICAgY29uc3QgaXNTY3JvbGxEb3duID0gY3VycmVudENsaWVudFkuY3VycmVudCA8IHdpbmRvdy5zY3JvbGxZO1xuICAgICAgc2V0SXNGb3JjZVBvcHBlckNsb3NlZChpc1Njcm9sbERvd24pO1xuXG4gICAgICBjdXJyZW50Q2xpZW50WS5jdXJyZW50ID0gd2luZG93LnNjcm9sbFk7XG4gICAgfTtcbiAgICBjb25zdCB0aHJvdHRsZVNjcm9sbCA9IHRocm90dGxlKGhhbmRsZVNjcm9sbCwgMTAwMCk7XG5cbiAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcignc2Nyb2xsJywgdGhyb3R0bGVTY3JvbGwpO1xuICAgIHJldHVybiAoKSA9PiB7XG4gICAgICB3aW5kb3cucmVtb3ZlRXZlbnRMaXN0ZW5lcignc2Nyb2xsJywgdGhyb3R0bGVTY3JvbGwpO1xuICAgIH07XG4gIH0sIFtpc01vYmlsZV0pO1xuXG4gIGNvbnN0IE1vcmVNZW51cyA9IHVzZU1lbW8oKCk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxNb3JlTWVudXNDb250YWluZXI+XG4gICAgICAgIHsgbW9yZU1lbnVzLm1hcCgobWVudSwgaW5kZXgpID0+IChcbiAgICAgICAgICA8U3R5bGVkSW50ZXJzZWN0aW9uT2JzZXJ2ZXJcbiAgICAgICAgICAgIGtleT17bWVudS50aXRsZX1cbiAgICAgICAgICAgIG9uSW50ZXJzZWN0PXsoKSA9PiBoYW5kbGVJbnRlcnNlY3QobWVudSwgbWVudS5pbmRleCl9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPExpbmtcbiAgICAgICAgICAgICAgaHJlZj17bWVudS5ocmVmfVxuICAgICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgICAgICAgICAgaGFuZGxlQ2xpY2sobWVudSwgbWVudS5pbmRleCk7XG4gICAgICAgICAgICAgICAgc2V0SXNGb3JjZVBvcHBlckNsb3NlZCh0cnVlKTtcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgY3NzPXtbXG4gICAgICAgICAgICAgICAgY3NzTGluayxcbiAgICAgICAgICAgICAgICBjc3NgXG4gICAgICAgICAgICAgICAgQG1lZGlhKGhvdmVyOiBob3Zlcikge1xuICAgICAgICAgICAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAke2FjdGl2ZUlkSW5Nb3JlTWVudXMgPT09IGluZGV4ICYmIGNzc2BcbiAgICAgICAgICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAgIGAsXG4gICAgICAgICAgICAgICAgRk9DVVNgXG4gICAgICAgICAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICAgICAgICAgICAgICBgLFxuICAgICAgICAgICAgICBdfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IG1lbnUudGl0bGUgfVxuICAgICAgICAgICAgPC9MaW5rPlxuICAgICAgICAgIDwvU3R5bGVkSW50ZXJzZWN0aW9uT2JzZXJ2ZXI+XG4gICAgICAgICkpIH1cbiAgICAgIDwvTW9yZU1lbnVzQ29udGFpbmVyPlxuICAgICk7XG4gIH0sIFt0aGVtZSwgbW9yZU1lbnVzLCBMaW5rLCBhY3RpdmVJZEluTW9yZU1lbnVzLCBoYW5kbGVJbnRlcnNlY3QsIGhhbmRsZUNsaWNrXSk7XG5cbiAgcmV0dXJuIHtcbiAgICBvbkNoYW5nZVZpc2libGVNZW51OiBoYW5kbGVDaGFuZ2VWaXNpYmxlTWVudSxcbiAgICBvbkNoYW5nZVZpc2libGVHcmFkaWVudDogaGFuZGxlQ2hhbmdlVmlzaWJsZUdyYWRpZW50LFxuICAgIGNvbnRhaW5lclJlZixcbiAgICBpc1BvcHBlck9wZW5lZCxcbiAgICBtb3JlTWVudXNDb21wb25lbnQ6IGlzVmlzaWJsZVxuICAgICAgPyAoXG4gICAgICAgIDxQb3BwZXJcbiAgICAgICAgICBpc0ZvcmNlQ2xvc2VkPXtpc0ZvcmNlUG9wcGVyQ2xvc2VkfVxuICAgICAgICAgIHVzZVBvcnRhbD17ZmFsc2V9XG4gICAgICAgICAgc3R5bGU9e2lzTW9iaWxlID8geyB2aXNpYmlsaXR5OiAnaGlkZGVuJyB9IDogdW5kZWZpbmVkfVxuICAgICAgICAgIG9uQ2hhbmdlPXtzZXRJc1BvcHBlck9wZW5lZH1cbiAgICAgICAgICByZW5kZXJCdXR0b249eyh7IG9uQ2xpY2ssIGlzT3BlbiB9KSA9PiAoXG4gICAgICAgICAgICA8PlxuICAgICAgICAgICAgICA8TW9yZUJ1dHRvblxuICAgICAgICAgICAgICAgIGlzR3JhZGllbnRWaXNpYmxlPXtpc0dyYWRpZW50VmlzaWJsZX1cbiAgICAgICAgICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgICAgICAgICAgICBoYW5kbGVPcGVuQm90dG9tU2hlZXQoKTtcbiAgICAgICAgICAgICAgICAgIG9uQ2xpY2soKTtcbiAgICAgICAgICAgICAgICAgIGxvZ01vcmVCdXR0b25DbGljaygpO1xuICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8Q2hldnJvbkRvd25JY29uXG4gICAgICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgICAgIG5hbWU9XCJjaGV2cm9uX2Rvd25cIlxuICAgICAgICAgICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfVxuICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgIDwvTW9yZUJ1dHRvbj5cbiAgICAgICAgICAgICAgeyBpc01vYmlsZSAmJiBpc09wZW4gJiYgKFxuICAgICAgICAgICAgICAgIDxTdHlsZWRNb2RhbFxuICAgICAgICAgICAgICAgICAgd2lkdGg9ezQwMH1cbiAgICAgICAgICAgICAgICAgIGhhc0ludGVyYWN0aW9uXG4gICAgICAgICAgICAgICAgICBoYXNHcmFiYmVyXG4gICAgICAgICAgICAgICAgICBoZWlnaHQ9e2JvdHRvbVNoZWV0SGVpZ2h0fVxuICAgICAgICAgICAgICAgICAgaGFzQ2xvc2luZ0ludGVyYWN0aW9uPXtoYXNDbG9zaW5nSW50ZXJhY3Rpb259XG4gICAgICAgICAgICAgICAgICBvbkJsdXI9e2hhbmRsZUNsb3NlQm90dG9tU2hlZXR9XG4gICAgICAgICAgICAgICAgICBvblRvdWNoU3RhcnQ9eyhldmVudCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICBpZiAoZXZlbnQuY2hhbmdlZFRvdWNoZXNbMF0/LmNsaWVudFkpIHtcbiAgICAgICAgICAgICAgICAgICAgICBjdXJyZW50Q2xpZW50WS5jdXJyZW50ID0gZXZlbnQuY2hhbmdlZFRvdWNoZXNbMF0/LmNsaWVudFk7XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgICAgICBvblRvdWNoTW92ZT17aGFuZGxlVG91Y2hNb3ZlfVxuICAgICAgICAgICAgICAgICAgZGlzYWJsZUJhY2tncm91bmRTY3JvbGxcbiAgICAgICAgICAgICAgICAgIGhlYWRlcj17e1xuICAgICAgICAgICAgICAgICAgICB0aXRsZTogJ+2DrSDshKDtg53tlZjquLAnLFxuICAgICAgICAgICAgICAgICAgICBvbkNsb3NlOiBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0LFxuICAgICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgICAgIG9uVHJhbnNpdGlvbkVuZD17KCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICBpZiAoaGFzQ2xvc2luZ0ludGVyYWN0aW9uKSB7XG4gICAgICAgICAgICAgICAgICAgICAgb25DbGljaygpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIDxTd2l0Y2hUcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgICAgICA8VHJhbnNpdGlvbiB0aW1lb3V0PXsyMDB9PlxuICAgICAgICAgICAgICAgICAgICAgIHsgTW9yZU1lbnVzIH1cbiAgICAgICAgICAgICAgICAgICAgPC9UcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgICAgPC9Td2l0Y2hUcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgIDwvU3R5bGVkTW9kYWw+XG4gICAgICAgICAgICAgICkgfVxuICAgICAgICAgICAgPC8+XG4gICAgICAgICAgKX1cbiAgICAgICAgPlxuICAgICAgICAgIHsgIWlzTW9iaWxlICYmIE1vcmVNZW51cyB9XG4gICAgICAgIDwvUG9wcGVyPlxuICAgICAgKVxuICAgICAgOiBudWxsLFxuICB9O1xufTtcblxuY29uc3QgY3NzTGluayA9IGNzc2BcbiAgJHtGT05UX1NUWUxFLmJvZHkxX3NtYWxsfVxuICBkaXNwbGF5OiBibG9jaztcbiAgcGFkZGluZzogJHtweFRvUmVtKDEwKX0gMCAke3B4VG9SZW0oMTApfSAke3B4VG9SZW0oMjYpfTtcbiAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgJHtGT05UX1NUWUxFLnN1YlRpdGxlMX07XG4gICAgcGFkZGluZzogMCAwICR7cHhUb1JlbSgyMCl9O1xuICBgKX1cbmA7XG5cbmNvbnN0IE1vcmVCdXR0b24gPSBzdHlsZWQuYnV0dG9uPHsgaXNHcmFkaWVudFZpc2libGU6IGJvb2xlYW4gfT5gXG4gICR7UkVTRVRfQlVUVE9OfVxuICBwYWRkaW5nOiAwICR7cHhUb1JlbSg2KX07XG4gIGhlaWdodDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTEwMCUpO1xuICAkeyh7IGlzR3JhZGllbnRWaXNpYmxlLCB0aGVtZSB9KSA9PiBpc0dyYWRpZW50VmlzaWJsZSAmJiBjc3NgXG4gICAgJjphZnRlciB7XG4gICAgICBjb250ZW50OiAnJztcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHJpZ2h0OiAwO1xuICAgICAgd2lkdGg6ICR7cHhUb1JlbShCVVRUT05fV0lEVEgpfTtcbiAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCg5MGRlZywgJHtoZXhUb1JnYmEodGhlbWUuYmFja2dyb3VuZC5iYXNlLCAwKX0gMCUsICR7dGhlbWUuYmFja2dyb3VuZC5iYXNlfSA1MCUpO1xuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IE1vcmVNZW51c0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgcGFkZGluZy10b3A6ICR7cHhUb1JlbSgzMCl9O1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIG1pbi13aWR0aDogJHtweFRvUmVtKDI1MCl9O1xuICAgIHBhZGRpbmc6ICR7cHhUb1JlbSgyMCl9ICR7cHhUb1JlbSgyMil9IDA7XG4gIGApfVxuYDtcblxuY29uc3QgQ2hldnJvbkRvd25JY29uID0gc3R5bGVkKEljb24pYFxuICB6LWluZGV4OiAyO1xuYDtcblxuY29uc3QgU3R5bGVkTW9kYWwgPSBzdHlsZWQoTW9kYWwpPHsgaGFzQ2xvc2luZ0ludGVyYWN0aW9uOiBib29sZWFuIH0+YFxuICAkeyh7IGhhc0Nsb3NpbmdJbnRlcmFjdGlvbiB9KSA9PiBoYXNDbG9zaW5nSW50ZXJhY3Rpb24gJiYgY3NzYFxuICAgIG9wYWNpdHk6IDA7XG4gICAgdHJhbnNpdGlvbjogb3BhY2l0eSAwLjNzIGVhc2UtaW47XG4gIGB9XG5gO1xuXG5jb25zdCBTdHlsZWRJbnRlcnNlY3Rpb25PYnNlcnZlciA9IHN0eWxlZChJbnRlcnNlY3Rpb25PYnNlcnZlcilgXG4gIGZsZXgtYmFzaXM6IDUwJTtcbmA7XG4iXX0= */")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const MoreButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ehl2p6i4"
} : {
  target: "ehl2p6i4",
  label: "MoreButton"
})(RESET_BUTTON, " padding:0 ", pxToRem(6), ";height:100%;display:flex;align-items:center;position:absolute;transform:translateX(-100%);", ({
  isGradientVisible,
  theme
}) => isGradientVisible && /*#__PURE__*/css("&:after{content:'';position:absolute;right:0;width:", pxToRem(BUTTON_WIDTH), ";height:100%;background:linear-gradient(90deg, ", hexToRgba(theme.background.base, 0), " 0%, ", theme.background.base, " 50%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const MoreMenusContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehl2p6i3"
} : {
  target: "ehl2p6i3",
  label: "MoreMenusContainer"
})("display:flex;flex-wrap:wrap;padding-top:", pxToRem(30), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("display:block;min-width:", pxToRem(250), ";padding:", pxToRem(20), " ", pxToRem(22), " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenusContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVzZU1vcmVNZW51cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMFVxQyIsImZpbGUiOiJ1c2VNb3JlTWVudXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7XG4gIE11dGFibGVSZWZPYmplY3QsXG4gIFRvdWNoRXZlbnQsXG4gIHVzZUNhbGxiYWNrLFxuICB1c2VFZmZlY3QsXG4gIHVzZU1lbW8sXG4gIHVzZVJlZixcbiAgdXNlU3RhdGUsXG59IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBTd2l0Y2hUcmFuc2l0aW9uLCBUcmFuc2l0aW9uIH0gZnJvbSAncmVhY3QtdHJhbnNpdGlvbi1ncm91cCc7XG5pbXBvcnQgdGhyb3R0bGUgZnJvbSAnbG9kYXNoLWVzL3Rocm90dGxlJztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIEZPTlRfU1RZTEUsXG4gIEludGVyc2VjdGlvbk9ic2VydmVyLFxuICBNRURJQV9RVUVSWSxcbiAgUkVTRVRfQlVUVE9OLFxuICBoZXhUb1JnYmEsXG4gIHB4VG9SZW0sXG4gIHVzZVJlc2l6ZSxcbiAgdXNlUmVzcG9uc2l2ZSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHtcbiAgSWNvbixcbiAgTW9kYWwsXG4gIFBvcHBlcixcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgdXNlTGlua0NvbnRleHQgfSBmcm9tICcuLi9saW5rLWNvbnRleHQnO1xuaW1wb3J0IHsgdXNlTmF2aWdhdGlvbkxvZyB9IGZyb20gJy4vdXNlTmF2aWdhdGlvbkxvZyc7XG5cbmludGVyZmFjZSB1c2VyTW9yZU1lbnVzUGFyYW1zIHtcbiAgbWVudXM6IE1lbnVTY2hlbWFFbnRyeVtdO1xuICBzY3JvbGxhYmxlRW50cmllczogYm9vbGVhbjtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbDtcbn1cblxuaW50ZXJmYWNlIFVzZU1vcmVNZW51c1JldHVybnMge1xuICBvbkNoYW5nZVZpc2libGVNZW51OiAoY2hhbmdlZE1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgY2hhbmdlZE1lbnVJbmRleDogbnVtYmVyLCB2aXNpYmxlUmF0aW8/OiBudW1iZXIpID0+IHZvaWQ7XG4gIC8qKlxuICAgKiDsl6zrsLHsnYQg7Y+s7ZWo7ZWcIOuplOuJtOydmCDsoITssrTrpbwg7LCo7KeA7ZWY64qUIOyXmOumrOuovO2KuCBSZWZcbiAgICovXG4gIGNvbnRhaW5lclJlZjogTXV0YWJsZVJlZk9iamVjdDxIVE1MRGl2RWxlbWVudCB8IG51bGw+O1xuICBtb3JlTWVudXNDb21wb25lbnQ6IFJlYWN0LlJlYWN0RWxlbWVudCB8IG51bGw7XG4gIGlzUG9wcGVyT3BlbmVkOiBib29sZWFuO1xuICBvbkNoYW5nZVZpc2libGVHcmFkaWVudDogKG5vZGU6IEhUTUxFbGVtZW50KSA9PiB2b2lkO1xufVxuXG5pbnRlcmZhY2UgTWVudVNjaGVtYUVudHJ5V2l0aEluZGV4IGV4dGVuZHMgTWVudVNjaGVtYUVudHJ5IHtcbiAgaW5kZXg6IG51bWJlcjtcbn1cblxuZXhwb3J0IGNvbnN0IEJVVFRPTl9XSURUSCA9IDEwMDtcbi8qKlxuICogc2NyYW9sbGFibGVFbnRyaWVz6rCAIGZhbHNl7J28IOqyveyasFxuICog66mU64m0IGVudHJpZXMgVUnrpbwg64uk66W4IFVJ66GcIOuztOyXrOyjvOuKlCDroZzsp4Hrk6TsnYQg7Y+s7ZWo7ZWp64uI64ukLlxuICovXG5leHBvcnQgY29uc3QgdXNlTW9yZU1lbnVzID0gKHtcbiAgbWVudXMsXG4gIHNjcm9sbGFibGVFbnRyaWVzLFxuICBhY3RpdmVJZCxcbiAgcHJpbWFyeUlkLFxufTogdXNlck1vcmVNZW51c1BhcmFtcyk6IFVzZU1vcmVNZW51c1JldHVybnMgPT4ge1xuICBjb25zdCBtZW51c1dpdGhJbmRleCA9IHVzZU1lbW8oKCkgPT4gbWVudXMubWFwKChtZW51LCBpbmRleCkgPT4gKHsgLi4ubWVudSwgaW5kZXggfSkpLCBbbWVudXNdKTtcbiAgY29uc3QgW21vcmVNZW51cywgc2V0TW9yZU1lbnVzXSA9IHVzZVN0YXRlPE1lbnVTY2hlbWFFbnRyeVdpdGhJbmRleFtdPihtZW51c1dpdGhJbmRleCk7XG4gIC8qKiBtb3JlQnV0dG9uICsgcG9wcGVy7J2YIHZpc2libGUg7Jes67aAICovXG4gIGNvbnN0IFtpc1Zpc2libGUsIHNldElzVmlzaWJsZV0gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IFtpc0dyYWRpZW50VmlzaWJsZSwgc2V0SXNHcmFkaWVudFZpc2libGVdID0gdXNlU3RhdGUodHJ1ZSk7XG4gIC8qKiBwb3BwZXLrpbwg6rCV7KCc66GcIOuLq+ydhOyngCDsl6zrtoAgKi9cbiAgY29uc3QgW2lzRm9yY2VQb3BwZXJDbG9zZWQsIHNldElzRm9yY2VQb3BwZXJDbG9zZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuICAvKiogcG9wcGVy7J2YIG9wZW4g7Jes67aAICovXG4gIGNvbnN0IFtpc1BvcHBlck9wZW5lZCwgc2V0SXNQb3BwZXJPcGVuZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuXG4gIC8vIFRPRE86IGJvdHRvbVNoZWV0IOq0gOugqCDqs7XthrUg7J247YSw656Z7IWYIOqzte2Gte2ZlFxuICBjb25zdCBbYm90dG9tU2hlZXRIZWlnaHQsIHNldEJvdHRvbVNoZWV0SGVpZ2h0XSA9IHVzZVN0YXRlKCdhdXRvJyk7XG4gIGNvbnN0IFtoYXNDbG9zaW5nSW50ZXJhY3Rpb24sIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbl0gPSB1c2VTdGF0ZShmYWxzZSk7XG5cbiAgY29uc3QgY29udGFpbmVyUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG4gIGNvbnN0IGN1cnJlbnRDbGllbnRZID0gdXNlUmVmKDApO1xuXG4gIGNvbnN0IGlzTW9iaWxlID0gdXNlUmVzcG9uc2l2ZSgpLmJyZWFrcG9pbnQgPT09ICdtb2JpbGUnO1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IExpbmsgPSB1c2VMaW5rQ29udGV4dCgpO1xuICBjb25zdCB7IGxvZ1RhYkNsaWNrLCBsb2dUYWJJbXByZXNzaW9uLCBsb2dNb3JlQnV0dG9uQ2xpY2sgfSA9IHVzZU5hdmlnYXRpb25Mb2coKTtcbiAgY29uc3QgaXNIbmNTZWNvbmRhcnlUYWJJdGVtID0gcHJpbWFyeUlkID09PSAwO1xuXG4gIGNvbnN0IGhhbmRsZUludGVyc2VjdCA9IHVzZUNhbGxiYWNrKChtZW51OiBNZW51U2NoZW1hRW50cnksIGluZGV4OiBudW1iZXIpID0+IHtcbiAgICBpZiAoIWlzSG5jU2Vjb25kYXJ5VGFiSXRlbSB8fCAhbWVudS5sb2dJZCkgeyByZXR1cm47IH1cbiAgICBsb2dUYWJJbXByZXNzaW9uKG1lbnUsIGluZGV4KTtcbiAgfSwgW2xvZ1RhYkltcHJlc3Npb24sIGlzSG5jU2Vjb25kYXJ5VGFiSXRlbV0pO1xuXG4gIGNvbnN0IGhhbmRsZUNsaWNrID0gdXNlQ2FsbGJhY2soKG1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgaW5kZXg6IG51bWJlcikgPT4ge1xuICAgIGxvZ1RhYkNsaWNrKG1lbnUsIGluZGV4LCAhIShpc0huY1NlY29uZGFyeVRhYkl0ZW0gJiYgbWVudS5sb2dJZCkpO1xuICB9LCBbbG9nVGFiQ2xpY2ssIGlzSG5jU2Vjb25kYXJ5VGFiSXRlbV0pO1xuXG4gIGNvbnN0IGFjdGl2ZUlkSW5Nb3JlTWVudXMgPSB1c2VNZW1vKCgpID0+IHtcbiAgICBpZiAoYWN0aXZlSWQgPT0gbnVsbCkgeyByZXR1cm4gbnVsbDsgfVxuICAgIHJldHVybiAoXG4gICAgICBhY3RpdmVJZCAtIChtZW51cy5sZW5ndGggLSBtb3JlTWVudXMubGVuZ3RoKVxuICAgICk7XG4gIH0sIFthY3RpdmVJZCwgbWVudXMubGVuZ3RoLCBtb3JlTWVudXMubGVuZ3RoXSk7XG5cbiAgY29uc3QgaGFuZGxlT3BlbkJvdHRvbVNoZWV0ID0gKCk6IHZvaWQgPT4ge1xuICAgIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbihmYWxzZSk7XG4gICAgc2V0Qm90dG9tU2hlZXRIZWlnaHQoJ2F1dG8nKTtcbiAgICBzZXRJc0ZvcmNlUG9wcGVyQ2xvc2VkKGZhbHNlKTtcbiAgfTtcblxuICBjb25zdCBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0ID0gKCk6IHZvaWQgPT4ge1xuICAgIHNldEhhc0Nsb3NpbmdJbnRlcmFjdGlvbih0cnVlKTtcbiAgICBzZXRCb3R0b21TaGVldEhlaWdodCgnMCUnKTtcbiAgfTtcblxuICBjb25zdCBoYW5kbGVUb3VjaE1vdmUgPSB1c2VDYWxsYmFjaygoZXZlbnQ6IFRvdWNoRXZlbnQ8SFRNTERpdkVsZW1lbnQ+KSA9PiB7XG4gICAgaWYgKGV2ZW50LmNoYW5nZWRUb3VjaGVzWzBdPy5jbGllbnRZKSB7XG4gICAgICBjb25zdCBzY3JvbGxEb3duID0gY3VycmVudENsaWVudFkuY3VycmVudCA8IGV2ZW50LmNoYW5nZWRUb3VjaGVzWzBdLmNsaWVudFk7XG4gICAgICBpZiAoc2Nyb2xsRG93bikge1xuICAgICAgICBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0KCk7XG4gICAgICB9XG4gICAgfVxuICB9LCBbXSk7XG5cbiAgY29uc3QgaGFuZGxlQ2hhbmdlVmlzaWJsZU1lbnUgPSB1c2VDYWxsYmFjaygoXG4gICAgY2hhbmdlZE1lbnU6IE1lbnVTY2hlbWFFbnRyeSwgY2hhbmdlZE1lbnVJbmRleDogbnVtYmVyLCB2aXNpYmxlUmF0aW8/OiBudW1iZXIsXG4gICkgPT4ge1xuICAgIGlmIChpc01vYmlsZSkge1xuICAgICAgc2V0TW9yZU1lbnVzKG1lbnVzV2l0aEluZGV4KTtcbiAgICAgIHJldHVybjtcbiAgICB9XG4gICAgaWYgKHZpc2libGVSYXRpbyA9PSBudWxsKSB7IHJldHVybjsgfVxuICAgIGlmICh2aXNpYmxlUmF0aW8gPCAxKSB7XG4gICAgICBzZXRNb3JlTWVudXMoKG1lbnVzKSA9PiBtZW51cy5tYXAoKG1lbnUpID0+IG1lbnUuaW5kZXgpLmluY2x1ZGVzKGNoYW5nZWRNZW51SW5kZXgpXG4gICAgICAgID8gbWVudXNcbiAgICAgICAgOiBbLi4ubWVudXMsIHsgLi4uY2hhbmdlZE1lbnUsIGluZGV4OiBjaGFuZ2VkTWVudUluZGV4IH1dXG4gICAgICAgICAgLnNvcnQoKGEsIGIpID0+IGEuaW5kZXggLSBiLmluZGV4KSxcbiAgICAgICk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHNldE1vcmVNZW51cygobWVudXMpID0+IG1lbnVzLmZpbHRlcigobWVudSkgPT4gY2hhbmdlZE1lbnVJbmRleCAhPT0gbWVudS5pbmRleCksXG4gICAgICApO1xuICAgIH1cbiAgfSwgW2lzTW9iaWxlLCBtZW51c1dpdGhJbmRleF0pO1xuXG4gIGNvbnN0IGhhbmRsZUNoYW5nZVZpc2libGVHcmFkaWVudCA9IChub2RlOiBIVE1MRWxlbWVudCk6IHZvaWQgPT4ge1xuICAgIGNvbnN0IHNjcm9sbFJpZ2h0ID0gbm9kZS5zY3JvbGxXaWR0aCAtXG4gICAgICBNYXRoLmNlaWwobm9kZS5zY3JvbGxMZWZ0KSAtXG4gICAgICBub2RlPy5nZXRCb3VuZGluZ0NsaWVudFJlY3QoKS53aWR0aDtcblxuICAgIHNldElzR3JhZGllbnRWaXNpYmxlKHNjcm9sbFJpZ2h0ID4gNSk7XG4gIH07XG5cbiAgY29uc3QgaGFuZGxlUmVzaXplID0gKCk6IHZvaWQgPT4ge1xuICAgIGlmICghY29udGFpbmVyUmVmLmN1cnJlbnQpIHsgcmV0dXJuOyB9XG5cbiAgICBjb25zdCBzY3JvbGxXaWR0aCA9IGNvbnRhaW5lclJlZi5jdXJyZW50LnNjcm9sbFdpZHRoO1xuICAgIGNvbnN0IGVsZW1lbnRXaWR0aCA9IE1hdGguY2VpbChjb250YWluZXJSZWYuY3VycmVudC5nZXRCb3VuZGluZ0NsaWVudFJlY3QoKS53aWR0aCk7XG4gICAgY29uc3Qgb3ZlcmZsb3dXaWR0aCA9IE1hdGgubWF4KHNjcm9sbFdpZHRoIC0gZWxlbWVudFdpZHRoLCAwKTtcblxuICAgIHNldElzVmlzaWJsZShvdmVyZmxvd1dpZHRoID4gMCk7XG4gIH07XG5cbiAgdXNlUmVzaXplKGNvbnRhaW5lclJlZiwgaGFuZGxlUmVzaXplKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIHNldE1vcmVNZW51cyhbXSk7XG4gIH0sIFtzY3JvbGxhYmxlRW50cmllc10pO1xuXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKGlzTW9iaWxlKSB7IHJldHVybjsgfVxuXG4gICAgY29uc3QgaGFuZGxlU2Nyb2xsID0gKCk6IHZvaWQgPT4ge1xuICAgICAgY29uc3QgaXNTY3JvbGxEb3duID0gY3VycmVudENsaWVudFkuY3VycmVudCA8IHdpbmRvdy5zY3JvbGxZO1xuICAgICAgc2V0SXNGb3JjZVBvcHBlckNsb3NlZChpc1Njcm9sbERvd24pO1xuXG4gICAgICBjdXJyZW50Q2xpZW50WS5jdXJyZW50ID0gd2luZG93LnNjcm9sbFk7XG4gICAgfTtcbiAgICBjb25zdCB0aHJvdHRsZVNjcm9sbCA9IHRocm90dGxlKGhhbmRsZVNjcm9sbCwgMTAwMCk7XG5cbiAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcignc2Nyb2xsJywgdGhyb3R0bGVTY3JvbGwpO1xuICAgIHJldHVybiAoKSA9PiB7XG4gICAgICB3aW5kb3cucmVtb3ZlRXZlbnRMaXN0ZW5lcignc2Nyb2xsJywgdGhyb3R0bGVTY3JvbGwpO1xuICAgIH07XG4gIH0sIFtpc01vYmlsZV0pO1xuXG4gIGNvbnN0IE1vcmVNZW51cyA9IHVzZU1lbW8oKCk6IFJlYWN0LlJlYWN0RWxlbWVudCA9PiB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxNb3JlTWVudXNDb250YWluZXI+XG4gICAgICAgIHsgbW9yZU1lbnVzLm1hcCgobWVudSwgaW5kZXgpID0+IChcbiAgICAgICAgICA8U3R5bGVkSW50ZXJzZWN0aW9uT2JzZXJ2ZXJcbiAgICAgICAgICAgIGtleT17bWVudS50aXRsZX1cbiAgICAgICAgICAgIG9uSW50ZXJzZWN0PXsoKSA9PiBoYW5kbGVJbnRlcnNlY3QobWVudSwgbWVudS5pbmRleCl9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPExpbmtcbiAgICAgICAgICAgICAgaHJlZj17bWVudS5ocmVmfVxuICAgICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgICAgICAgICAgaGFuZGxlQ2xpY2sobWVudSwgbWVudS5pbmRleCk7XG4gICAgICAgICAgICAgICAgc2V0SXNGb3JjZVBvcHBlckNsb3NlZCh0cnVlKTtcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgY3NzPXtbXG4gICAgICAgICAgICAgICAgY3NzTGluayxcbiAgICAgICAgICAgICAgICBjc3NgXG4gICAgICAgICAgICAgICAgQG1lZGlhKGhvdmVyOiBob3Zlcikge1xuICAgICAgICAgICAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAke2FjdGl2ZUlkSW5Nb3JlTWVudXMgPT09IGluZGV4ICYmIGNzc2BcbiAgICAgICAgICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAgIGAsXG4gICAgICAgICAgICAgICAgRk9DVVNgXG4gICAgICAgICAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICAgICAgICAgICAgICBgLFxuICAgICAgICAgICAgICBdfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7IG1lbnUudGl0bGUgfVxuICAgICAgICAgICAgPC9MaW5rPlxuICAgICAgICAgIDwvU3R5bGVkSW50ZXJzZWN0aW9uT2JzZXJ2ZXI+XG4gICAgICAgICkpIH1cbiAgICAgIDwvTW9yZU1lbnVzQ29udGFpbmVyPlxuICAgICk7XG4gIH0sIFt0aGVtZSwgbW9yZU1lbnVzLCBMaW5rLCBhY3RpdmVJZEluTW9yZU1lbnVzLCBoYW5kbGVJbnRlcnNlY3QsIGhhbmRsZUNsaWNrXSk7XG5cbiAgcmV0dXJuIHtcbiAgICBvbkNoYW5nZVZpc2libGVNZW51OiBoYW5kbGVDaGFuZ2VWaXNpYmxlTWVudSxcbiAgICBvbkNoYW5nZVZpc2libGVHcmFkaWVudDogaGFuZGxlQ2hhbmdlVmlzaWJsZUdyYWRpZW50LFxuICAgIGNvbnRhaW5lclJlZixcbiAgICBpc1BvcHBlck9wZW5lZCxcbiAgICBtb3JlTWVudXNDb21wb25lbnQ6IGlzVmlzaWJsZVxuICAgICAgPyAoXG4gICAgICAgIDxQb3BwZXJcbiAgICAgICAgICBpc0ZvcmNlQ2xvc2VkPXtpc0ZvcmNlUG9wcGVyQ2xvc2VkfVxuICAgICAgICAgIHVzZVBvcnRhbD17ZmFsc2V9XG4gICAgICAgICAgc3R5bGU9e2lzTW9iaWxlID8geyB2aXNpYmlsaXR5OiAnaGlkZGVuJyB9IDogdW5kZWZpbmVkfVxuICAgICAgICAgIG9uQ2hhbmdlPXtzZXRJc1BvcHBlck9wZW5lZH1cbiAgICAgICAgICByZW5kZXJCdXR0b249eyh7IG9uQ2xpY2ssIGlzT3BlbiB9KSA9PiAoXG4gICAgICAgICAgICA8PlxuICAgICAgICAgICAgICA8TW9yZUJ1dHRvblxuICAgICAgICAgICAgICAgIGlzR3JhZGllbnRWaXNpYmxlPXtpc0dyYWRpZW50VmlzaWJsZX1cbiAgICAgICAgICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgICAgICAgICAgICBoYW5kbGVPcGVuQm90dG9tU2hlZXQoKTtcbiAgICAgICAgICAgICAgICAgIG9uQ2xpY2soKTtcbiAgICAgICAgICAgICAgICAgIGxvZ01vcmVCdXR0b25DbGljaygpO1xuICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICA8Q2hldnJvbkRvd25JY29uXG4gICAgICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgICAgIG5hbWU9XCJjaGV2cm9uX2Rvd25cIlxuICAgICAgICAgICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiB0aGVtZS5jb250ZW50LmJhc2UxfVxuICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgIDwvTW9yZUJ1dHRvbj5cbiAgICAgICAgICAgICAgeyBpc01vYmlsZSAmJiBpc09wZW4gJiYgKFxuICAgICAgICAgICAgICAgIDxTdHlsZWRNb2RhbFxuICAgICAgICAgICAgICAgICAgd2lkdGg9ezQwMH1cbiAgICAgICAgICAgICAgICAgIGhhc0ludGVyYWN0aW9uXG4gICAgICAgICAgICAgICAgICBoYXNHcmFiYmVyXG4gICAgICAgICAgICAgICAgICBoZWlnaHQ9e2JvdHRvbVNoZWV0SGVpZ2h0fVxuICAgICAgICAgICAgICAgICAgaGFzQ2xvc2luZ0ludGVyYWN0aW9uPXtoYXNDbG9zaW5nSW50ZXJhY3Rpb259XG4gICAgICAgICAgICAgICAgICBvbkJsdXI9e2hhbmRsZUNsb3NlQm90dG9tU2hlZXR9XG4gICAgICAgICAgICAgICAgICBvblRvdWNoU3RhcnQ9eyhldmVudCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICBpZiAoZXZlbnQuY2hhbmdlZFRvdWNoZXNbMF0/LmNsaWVudFkpIHtcbiAgICAgICAgICAgICAgICAgICAgICBjdXJyZW50Q2xpZW50WS5jdXJyZW50ID0gZXZlbnQuY2hhbmdlZFRvdWNoZXNbMF0/LmNsaWVudFk7XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgICAgICBvblRvdWNoTW92ZT17aGFuZGxlVG91Y2hNb3ZlfVxuICAgICAgICAgICAgICAgICAgZGlzYWJsZUJhY2tncm91bmRTY3JvbGxcbiAgICAgICAgICAgICAgICAgIGhlYWRlcj17e1xuICAgICAgICAgICAgICAgICAgICB0aXRsZTogJ+2DrSDshKDtg53tlZjquLAnLFxuICAgICAgICAgICAgICAgICAgICBvbkNsb3NlOiBoYW5kbGVDbG9zZUJvdHRvbVNoZWV0LFxuICAgICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgICAgIG9uVHJhbnNpdGlvbkVuZD17KCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICBpZiAoaGFzQ2xvc2luZ0ludGVyYWN0aW9uKSB7XG4gICAgICAgICAgICAgICAgICAgICAgb25DbGljaygpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIDxTd2l0Y2hUcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgICAgICA8VHJhbnNpdGlvbiB0aW1lb3V0PXsyMDB9PlxuICAgICAgICAgICAgICAgICAgICAgIHsgTW9yZU1lbnVzIH1cbiAgICAgICAgICAgICAgICAgICAgPC9UcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgICAgPC9Td2l0Y2hUcmFuc2l0aW9uPlxuICAgICAgICAgICAgICAgIDwvU3R5bGVkTW9kYWw+XG4gICAgICAgICAgICAgICkgfVxuICAgICAgICAgICAgPC8+XG4gICAgICAgICAgKX1cbiAgICAgICAgPlxuICAgICAgICAgIHsgIWlzTW9iaWxlICYmIE1vcmVNZW51cyB9XG4gICAgICAgIDwvUG9wcGVyPlxuICAgICAgKVxuICAgICAgOiBudWxsLFxuICB9O1xufTtcblxuY29uc3QgY3NzTGluayA9IGNzc2BcbiAgJHtGT05UX1NUWUxFLmJvZHkxX3NtYWxsfVxuICBkaXNwbGF5OiBibG9jaztcbiAgcGFkZGluZzogJHtweFRvUmVtKDEwKX0gMCAke3B4VG9SZW0oMTApfSAke3B4VG9SZW0oMjYpfTtcbiAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgJHtGT05UX1NUWUxFLnN1YlRpdGxlMX07XG4gICAgcGFkZGluZzogMCAwICR7cHhUb1JlbSgyMCl9O1xuICBgKX1cbmA7XG5cbmNvbnN0IE1vcmVCdXR0b24gPSBzdHlsZWQuYnV0dG9uPHsgaXNHcmFkaWVudFZpc2libGU6IGJvb2xlYW4gfT5gXG4gICR7UkVTRVRfQlVUVE9OfVxuICBwYWRkaW5nOiAwICR7cHhUb1JlbSg2KX07XG4gIGhlaWdodDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTEwMCUpO1xuICAkeyh7IGlzR3JhZGllbnRWaXNpYmxlLCB0aGVtZSB9KSA9PiBpc0dyYWRpZW50VmlzaWJsZSAmJiBjc3NgXG4gICAgJjphZnRlciB7XG4gICAgICBjb250ZW50OiAnJztcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHJpZ2h0OiAwO1xuICAgICAgd2lkdGg6ICR7cHhUb1JlbShCVVRUT05fV0lEVEgpfTtcbiAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCg5MGRlZywgJHtoZXhUb1JnYmEodGhlbWUuYmFja2dyb3VuZC5iYXNlLCAwKX0gMCUsICR7dGhlbWUuYmFja2dyb3VuZC5iYXNlfSA1MCUpO1xuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IE1vcmVNZW51c0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgcGFkZGluZy10b3A6ICR7cHhUb1JlbSgzMCl9O1xuICAke01FRElBX1FVRVJZLm1pbigndGFibGV0JywgY3NzYFxuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIG1pbi13aWR0aDogJHtweFRvUmVtKDI1MCl9O1xuICAgIHBhZGRpbmc6ICR7cHhUb1JlbSgyMCl9ICR7cHhUb1JlbSgyMil9IDA7XG4gIGApfVxuYDtcblxuY29uc3QgQ2hldnJvbkRvd25JY29uID0gc3R5bGVkKEljb24pYFxuICB6LWluZGV4OiAyO1xuYDtcblxuY29uc3QgU3R5bGVkTW9kYWwgPSBzdHlsZWQoTW9kYWwpPHsgaGFzQ2xvc2luZ0ludGVyYWN0aW9uOiBib29sZWFuIH0+YFxuICAkeyh7IGhhc0Nsb3NpbmdJbnRlcmFjdGlvbiB9KSA9PiBoYXNDbG9zaW5nSW50ZXJhY3Rpb24gJiYgY3NzYFxuICAgIG9wYWNpdHk6IDA7XG4gICAgdHJhbnNpdGlvbjogb3BhY2l0eSAwLjNzIGVhc2UtaW47XG4gIGB9XG5gO1xuXG5jb25zdCBTdHlsZWRJbnRlcnNlY3Rpb25PYnNlcnZlciA9IHN0eWxlZChJbnRlcnNlY3Rpb25PYnNlcnZlcilgXG4gIGZsZXgtYmFzaXM6IDUwJTtcbmA7XG4iXX0= */"));
const ChevronDownIcon = /*#__PURE__*/_styled(Icon$1, process.env.NODE_ENV === "production" ? {
  target: "ehl2p6i2"
} : {
  target: "ehl2p6i2",
  label: "ChevronDownIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1dk0v5d",
  styles: "z-index:2"
} : {
  name: "1dk0v5d",
  styles: "z-index:2",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
var _ref$e = process.env.NODE_ENV === "production" ? {
  name: "1yoibbp",
  styles: "opacity:0;transition:opacity 0.3s ease-in"
} : {
  name: "1pkytaj-StyledModal",
  styles: "opacity:0;transition:opacity 0.3s ease-in;label:StyledModal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
};
const StyledModal = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "ehl2p6i1"
} : {
  target: "ehl2p6i1",
  label: "StyledModal"
})(({
  hasClosingInteraction
}) => hasClosingInteraction && _ref$e, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const StyledIntersectionObserver = /*#__PURE__*/_styled(IntersectionObserver$1, process.env.NODE_ENV === "production" ? {
  target: "ehl2p6i0"
} : {
  target: "ehl2p6i0",
  label: "StyledIntersectionObserver"
})(process.env.NODE_ENV === "production" ? {
  name: "1dlyed8",
  styles: "flex-basis:50%"
} : {
  name: "1dlyed8",
  styles: "flex-basis:50%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$d = process.env.NODE_ENV === "production" ? {
  name: "gth0vq",
  styles: "height:inherit"
} : {
  name: "1p5tzyk-NavigationBarSecondaryTabItem",
  styles: "height:inherit;label:NavigationBarSecondaryTabItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};
function NavigationBarSecondaryTabItem(props) {
  const {
    onSelect,
    index,
    item,
    onChangeVisibleMenu,
    containerRef,
    primaryId,
    ...rest
  } = props;
  const {
    isGlobal
  } = useGNBData();
  const LinkComponent = useLinkContext();
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const {
    ref,
    entry
  } = useInView({
    root: containerRef.current,
    rootMargin: `0px -${BUTTON_WIDTH}px 0px 0px`,
    initialInView: true,
    threshold: [0, 1]
  });
  const {
    logTabClick,
    logTabImpression
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = useCallback(() => {
    if (!isHncSecondaryTabItem || !item.logId) {
      return;
    }
    logTabImpression?.(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  const handleTabClick = useCallback(() => {
    if (isGlobal) {
      globalLog.logClickTab({
        section_idx: index,
        section_id: item.logId
      });
    } else {
      logTabClick?.(item, index, !!(isHncSecondaryTabItem && item.logId));
    }
  }, [index, isGlobal, isHncSecondaryTabItem, item, logTabClick]);
  useEffect(() => {
    onChangeVisibleMenu(item, index, entry?.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return jsx(IntersectionObserver$1, {
    onIntersect: handleIntersect,
    children: jsx("div", {
      ref: ref,
      css: _ref$d,
      children: jsx(StyledTabItem, {
        ...rest,
        component: LinkComponent,
        onClick: handleTabClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    })
  });
}
const StyledTabItem = /*#__PURE__*/_styled(TabItem, process.env.NODE_ENV === "production" ? {
  target: "e1sy26r80"
} : {
  target: "e1sy26r80",
  label: "StyledTabItem"
})("height:inherit;outline:none;&>div>p{font-weight:700;}", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("padding:", pxToRem(11), " ", pxToRem(5), ";>div>p{", FONT_STYLE.subTitle2, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " ", ({
  theme
}) => /*#__PURE__*/css(HOVER$1`
      color: ${theme.content.primary1.basic};
    `, " ", FOCUS`
      * {
        color: ${theme.content.primary1.basic};
      }
      & > div {
        box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
        border-radius: ${pxToRem(3)};
      }
    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeVRhYkl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStGc0IiLCJmaWxlIjoiU2Vjb25kYXJ5VGFiSXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlQ2FsbGJhY2ssIHVzZUVmZmVjdCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHVzZUluVmlldyB9IGZyb20gJ3JlYWN0LWludGVyc2VjdGlvbi1vYnNlcnZlcic7XG5cbmltcG9ydCB7XG4gIEZPQ1VTLFxuICBGT05UX1NUWUxFLFxuICBIT1ZFUixcbiAgSW50ZXJzZWN0aW9uT2JzZXJ2ZXIsXG4gIE1FRElBX1FVRVJZLFxuICBweFRvUmVtLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBUYWJJdGVtLCBUYWJJdGVtUHJvcHMgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyB1c2VHTkJEYXRhIH0gZnJvbSAnQC9jb21wb25lbnRzL2duYi9jb250ZXh0cyc7XG5pbXBvcnQgeyBnbG9iYWxMb2cgfSBmcm9tICdAL2NvbXBvbmVudHMvbG9nZ2luZy9nbG9iYWxMb2cnO1xuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgQlVUVE9OX1dJRFRIIH0gZnJvbSAnLi91c2VNb3JlTWVudXMnO1xuaW1wb3J0IHsgTGlua0NvbXBvbmVudFR5cGUsIHVzZUxpbmtDb250ZXh0IH0gZnJvbSAnLi4vbGluay1jb250ZXh0JztcbmltcG9ydCB7IHVzZUhvdmVyIH0gZnJvbSAnLi91c2VIb3Zlcic7XG5pbXBvcnQgeyB1c2VOYXZpZ2F0aW9uTG9nIH0gZnJvbSAnLi91c2VOYXZpZ2F0aW9uTG9nJztcblxuZXhwb3J0IHR5cGUgTmF2aWdhdGlvbkJhclNlY29uZGFyeVRhYkl0ZW1Qcm9wcyA9IFRhYkl0ZW1Qcm9wczxMaW5rQ29tcG9uZW50VHlwZT4gJiB7XG4gIGluZGV4OiBudW1iZXIsXG4gIGl0ZW06IE1lbnVTY2hlbWFFbnRyeSxcbiAgb25TZWxlY3Q6ICgpID0+IHZvaWQsXG4gIG9uQ2hhbmdlVmlzaWJsZU1lbnU6IChtZW51OiBNZW51U2NoZW1hRW50cnksIGluZGV4OiBudW1iZXIsIHZpc2libGVSYXRpbz86IG51bWJlcikgPT4gdm9pZCxcbiAgY29udGFpbmVyUmVmOiBSZWFjdC5NdXRhYmxlUmVmT2JqZWN0PEhUTUxEaXZFbGVtZW50IHwgbnVsbD4sXG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbCxcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5VGFiSXRlbShcbiAgcHJvcHM6IE5hdmlnYXRpb25CYXJTZWNvbmRhcnlUYWJJdGVtUHJvcHMsXG4pOiBSZWFjdC5SZWFjdEVsZW1lbnQge1xuICBjb25zdCB7IG9uU2VsZWN0LCBpbmRleCwgaXRlbSwgb25DaGFuZ2VWaXNpYmxlTWVudSwgY29udGFpbmVyUmVmLCBwcmltYXJ5SWQsIC4uLnJlc3QgfSA9IHByb3BzO1xuXG4gIGNvbnN0IHsgaXNHbG9iYWwgfSA9IHVzZUdOQkRhdGEoKTtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IFtoYW5kbGVNb3VzZUVudGVyLCBoYW5kbGVNb3VzZUxlYXZlXSA9IHVzZUhvdmVyKG9uU2VsZWN0KTtcbiAgY29uc3QgeyByZWYsIGVudHJ5IH0gPSB1c2VJblZpZXcoe1xuICAgIHJvb3Q6IGNvbnRhaW5lclJlZi5jdXJyZW50LFxuICAgIHJvb3RNYXJnaW46IGAwcHggLSR7QlVUVE9OX1dJRFRIfXB4IDBweCAwcHhgLFxuICAgIGluaXRpYWxJblZpZXc6IHRydWUsXG4gICAgdGhyZXNob2xkOiBbMCwgMV0sXG4gIH0pO1xuICBjb25zdCB7IGxvZ1RhYkNsaWNrLCBsb2dUYWJJbXByZXNzaW9uIH0gPSB1c2VOYXZpZ2F0aW9uTG9nKCk7XG4gIGNvbnN0IGlzSG5jU2Vjb25kYXJ5VGFiSXRlbSA9IHByaW1hcnlJZCA9PT0gMDtcblxuICBjb25zdCBoYW5kbGVJbnRlcnNlY3QgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgaWYgKCFpc0huY1NlY29uZGFyeVRhYkl0ZW0gfHwgIWl0ZW0ubG9nSWQpIHsgcmV0dXJuOyB9XG4gICAgbG9nVGFiSW1wcmVzc2lvbj8uKGl0ZW0sIGluZGV4KTtcbiAgfSwgW2xvZ1RhYkltcHJlc3Npb24sIGl0ZW0sIGluZGV4LCBpc0huY1NlY29uZGFyeVRhYkl0ZW1dKTtcblxuICBjb25zdCBoYW5kbGVUYWJDbGljayA9IHVzZUNhbGxiYWNrKCgpID0+IHtcbiAgICBpZiAoaXNHbG9iYWwpIHtcbiAgICAgIGdsb2JhbExvZy5sb2dDbGlja1RhYih7XG4gICAgICAgIHNlY3Rpb25faWR4OiBpbmRleCxcbiAgICAgICAgc2VjdGlvbl9pZDogaXRlbS5sb2dJZCxcbiAgICAgIH0pO1xuICAgIH0gZWxzZSB7XG4gICAgICBsb2dUYWJDbGljaz8uKGl0ZW0sIGluZGV4LCAhIShpc0huY1NlY29uZGFyeVRhYkl0ZW0gJiYgaXRlbS5sb2dJZCkpO1xuICAgIH1cbiAgfSwgW2luZGV4LCBpc0dsb2JhbCwgaXNIbmNTZWNvbmRhcnlUYWJJdGVtLCBpdGVtLCBsb2dUYWJDbGlja10pO1xuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIG9uQ2hhbmdlVmlzaWJsZU1lbnUoaXRlbSwgaW5kZXgsIGVudHJ5Py5pbnRlcnNlY3Rpb25SYXRpbyk7XG4gIH0sIFtlbnRyeSwgaXRlbSwgaW5kZXgsIG9uQ2hhbmdlVmlzaWJsZU1lbnVdKTtcblxuICByZXR1cm4gKFxuICAgIDxJbnRlcnNlY3Rpb25PYnNlcnZlciBvbkludGVyc2VjdD17aGFuZGxlSW50ZXJzZWN0fT5cbiAgICAgIDxkaXYgcmVmPXtyZWZ9IGNzcz17Y3NzYGhlaWdodDogaW5oZXJpdDtgfT5cbiAgICAgICAgPFN0eWxlZFRhYkl0ZW1cbiAgICAgICAgICB7Li4ucmVzdH1cbiAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgb25DbGljaz17aGFuZGxlVGFiQ2xpY2t9XG4gICAgICAgICAgb25Nb3VzZUVudGVyPXtoYW5kbGVNb3VzZUVudGVyfVxuICAgICAgICAgIG9uTW91c2VMZWF2ZT17aGFuZGxlTW91c2VMZWF2ZX1cbiAgICAgICAgLz5cbiAgICAgIDwvZGl2PlxuICAgIDwvSW50ZXJzZWN0aW9uT2JzZXJ2ZXI+XG4gICk7XG59XG5cbmNvbnN0IFN0eWxlZFRhYkl0ZW0gPSBzdHlsZWQoVGFiSXRlbSlgXG4gIGhlaWdodDogaW5oZXJpdDtcbiAgb3V0bGluZTogbm9uZTtcbiAgJiA+IGRpdiA+IHAge1xuICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIH1cbiAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGNzc2BcbiAgICBwYWRkaW5nOiAke3B4VG9SZW0oMTEpfSAke3B4VG9SZW0oNSl9O1xuICAgID4gZGl2ID4gcCB7XG4gICAgICAke0ZPTlRfU1RZTEUuc3ViVGl0bGUyfVxuICAgIH1cbiAgYCl9XG4gICR7KHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgICR7SE9WRVJgXG4gICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICBgfVxuICAgICR7Rk9DVVNgXG4gICAgICAqIHtcbiAgICAgICAgY29sb3I6ICR7dGhlbWUuY29udGVudC5wcmltYXJ5MS5iYXNpY307XG4gICAgICB9XG4gICAgICAmID4gZGl2IHtcbiAgICAgICAgYm94LXNoYWRvdzogMCAwIDAgJHtweFRvUmVtKDMpfSAke3RoZW1lLmludGVyYWN0aXZlLnByaW1hcnkxLnRoaW59O1xuICAgICAgICBib3JkZXItcmFkaXVzOiAke3B4VG9SZW0oMyl9O1xuICAgICAgfVxuICAgIGB9XG4gIGB9XG5gO1xuIl19 */"), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  const {
    hasItems,
    isForceOpened,
    isFallback,
    right,
    menuEntries,
    activeId,
    onMouseEnter,
    onMouseLeave,
    onSelect,
    primaryId,
    scrollableEntries = true
  } = props;
  const childRef = useRef(null);
  const theme = useTheme();
  const isMobile = useResponsive().breakpoint === 'mobile';
  const nodeHeight = useNodeHeight(childRef, INITIAL_NODE_HEIGHT);
  const scrollDir = useScrollDirection();
  const shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  const {
    onChangeVisibleMenu,
    onChangeVisibleGradient,
    containerRef,
    moreMenusComponent,
    isPopperOpened
  } = useMoreMenus({
    menus: menuEntries,
    scrollableEntries,
    activeId,
    primaryId
  });

  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  useEffect(() => {
    if (isPopperOpened) {
      return;
    }
    onMouseLeave?.();
  }, [isPopperOpened, onMouseLeave]);
  if (menuEntries.length === 0) {
    return null;
  }

  // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.
  return jsx(StyledSticky, {
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/css(isFallback && /*#__PURE__*/css("background:", theme.background.groupedBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarSecondary;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEdrQyIsImZpbGUiOiJTZWNvbmRhcnkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBpc1Byb3BWYWxpZCBmcm9tICdAZW1vdGlvbi9pcy1wcm9wLXZhbGlkJztcbmltcG9ydCB0aHJvdHRsZSBmcm9tICdsb2Rhc2gtZXMvdGhyb3R0bGUnO1xuXG5pbXBvcnQge1xuICBERUZBVUxUX1NUSUNLWV9TVEFURSxcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIE1FRElBX1FVRVJZLFxuICBaSU5ERVgsXG4gIHB4VG9SZW0sXG4gIHVzZVJlc3BvbnNpdmUsXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IENvbnRhaW5lciwgVGFiIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgTmF2aWdhdGlvbkJhclNlY29uZGFyeVRhYkl0ZW0gfSBmcm9tICcuL1NlY29uZGFyeVRhYkl0ZW0nO1xuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgdXNlTW9yZU1lbnVzIH0gZnJvbSAnLi91c2VNb3JlTWVudXMnO1xuXG5jb25zdCBJTklUSUFMX05PREVfSEVJR0hUID0gNTE7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzIHtcbiAgLyoqXG4gICAqIFNlY29uZGFyeeyXkCDslYTsnbTthZzsnbQg7KG07J6s7ZW07IScIFNlY29uZGFyeSDrqZTribTqsIAg67O07Jes7KeIIOyImCDsnojsnYzsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7J20IOqwkuydtCBmYWxzZeudvOuptCwgU2Vjb25kYXJ564qUIO2RnOyLnOuQmOyngCDslYrsirXri4jri6QgKFByaW1hcnkg65Kk7JeQIO2VreyDgSDsiKjslrTsnojsirXri4jri6QpXG4gICAqIOycoOyggOqwgCBQcmltYXJ57JeQ7IScIOuLpOuluCDrqZTribTrpbwg7ISg7YOd7ZW07IScLCDslYTsnbTthZzsnbQg67O07Jes7KeA6riwIOyLnOyeke2VtOuPhCDsnbQg6rCS7J2AIGZhbHNl66GcXG4gICAqIOq3uOuMgOuhnCDrgqjslYTsnojslrTslbwg7ZWp64uI64ukLiAo6re466CH7KeAIOyViuycvOuptCBTZWNvbmRhcnkg7KCE7LK06rCAIOusuOyEnCDsoITssrTrpbwg67CR7Jy866GcIOuCtOumtCDsiJhcbiAgICog7J6I6riwIOuVjOusuOyeheuLiOuLpC4pXG4gICAqL1xuICBoYXNJdGVtczogYm9vbGVhbjtcbiAgLyoqXG4gICAqIOycoOyggOqwgCBQcmltYXJ5LCBTZWNvbmRhcnnsl5Ag66eI7Jqw7Iqk66W8IOyYrOugpOyEnCBTZWNvbmRhcnnqsIAg7Iqk7YGs66GkIOyDge2DnOyXkCDqtIDqs4Qg7JeG7J20XG4gICAqIOuztOyXrOyguOyVvCDtlajsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7Jyg7KCA6rCAIOuniOyasOyKpOulvCDsmKzroLjslrTrj4QsIOuztOyXrOykhCDqsJLsnbQg7JeG64uk66m0IGlzRm9yY2VPcGVuZWTripQgZmFsc2Xsl6zslbwg7ZWp64uI64ukLlxuICAgKiDrqqjrsJTsnbwg7YGs6riw7JeQ7ISc64qUIOydtCDqsJLsl5Ag6rSA6rOEIOyXhuydtCDtla3sg4Eg67O07Jes7KeR64uI64ukLlxuICAgKi9cbiAgaXNGb3JjZU9wZW5lZDogYm9vbGVhbjtcbiAgaXNGYWxsYmFjazogYm9vbGVhbjtcbiAgcmlnaHQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbDtcbiAgb25Nb3VzZUVudGVyPzogKCkgPT4gdm9pZDtcbiAgb25Nb3VzZUxlYXZlPzogKCkgPT4gdm9pZDtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xuICAvKipcbiAgICogbmF2aWdhdGlvbiBiYXLqsIAgb3ZlcmZsb3cg65CQ7J2EIOuVjCDsspjrpqxcbiAgICogdHJ1ZShkZWZhdWx0KTogc2Nyb2xsZXJcbiAgICogZmFsc2U6IHBjOiBwb3BwZXIsIG1vYmlsZTogYm90dG9tIHNoZWV0KG1vZGFsIOy7tO2PrOuEjO2KuCDsgqzsmqkpXG4gICAqL1xuICBzY3JvbGxhYmxlRW50cmllcz86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5KFxuICBwcm9wczogTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzLFxuKTogUmVhY3QuUmVhY3RFbGVtZW50IHwgbnVsbCB7XG4gIGNvbnN0IHtcbiAgICBoYXNJdGVtcyxcbiAgICBpc0ZvcmNlT3BlbmVkLFxuICAgIGlzRmFsbGJhY2ssXG4gICAgcmlnaHQsXG4gICAgbWVudUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgb25Nb3VzZUVudGVyLFxuICAgIG9uTW91c2VMZWF2ZSxcbiAgICBvblNlbGVjdCxcbiAgICBwcmltYXJ5SWQsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMgPSB0cnVlLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG5cbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCBpc01vYmlsZSA9IHVzZVJlc3BvbnNpdmUoKS5icmVha3BvaW50ID09PSAnbW9iaWxlJztcbiAgY29uc3Qgbm9kZUhlaWdodCA9IHVzZU5vZGVIZWlnaHQoY2hpbGRSZWYsIElOSVRJQUxfTk9ERV9IRUlHSFQpO1xuICBjb25zdCBzY3JvbGxEaXIgPSB1c2VTY3JvbGxEaXJlY3Rpb24oKTtcbiAgY29uc3Qgc2hvdWxkT3BlbiA9IChoYXNJdGVtcyAmJiBzY3JvbGxEaXIgIT09ICdkb3duJykgfHwgaXNGb3JjZU9wZW5lZDtcblxuICBjb25zdCB7XG4gICAgb25DaGFuZ2VWaXNpYmxlTWVudSxcbiAgICBvbkNoYW5nZVZpc2libGVHcmFkaWVudCxcbiAgICBjb250YWluZXJSZWYsXG4gICAgbW9yZU1lbnVzQ29tcG9uZW50LFxuICAgIGlzUG9wcGVyT3BlbmVkLFxuICB9ID0gdXNlTW9yZU1lbnVzKHtcbiAgICBtZW51czogbWVudUVudHJpZXMsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgcHJpbWFyeUlkLFxuICB9KTtcblxuICAvKiogSG92ZXLrkJwgU2Vjb25kYXJ5IOuplOuJtCDrgrQgUG9wcGVy6rCAIOuLq+2eiOuptCwgU2Vjb25kYXJ57J2YIEhvdmVy7IOB7YOc64+EIOyXhuyVoOq4sCDsnITtlbQg7Iuk7ZaJ7ZWp64uI64ukLiAqL1xuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICBvbk1vdXNlTGVhdmU/LigpO1xuICB9LCBbaXNQb3BwZXJPcGVuZWQsIG9uTW91c2VMZWF2ZV0pO1xuXG4gIGlmIChtZW51RW50cmllcy5sZW5ndGggPT09IDApIHsgcmV0dXJuIG51bGw7IH1cblxuICAvLyBOT1RFOiBTZWNvbmRhcnnsnZgg66qo67CU7J28L1BDIOuPmeyekeydgCDsmYTsoITtnogg64+Z7J287ZWp64uI64ukLlxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRTdGlja3lcbiAgICAgIGNsYXNzTmFtZT1cImxheW91dC1uYXZpZ2F0aW9uLXNlY29uZGFyeVwiXG4gICAgICBjc3M9e2Nzc2Ake2lzRmFsbGJhY2sgJiYgY3NzYGJhY2tncm91bmQ6ICR7dGhlbWUuYmFja2dyb3VuZC5ncm91cGVkQmFzZX07YH1gfVxuICAgICAgY29udGFpbmVyU3R5bGU9eyFoYXNJdGVtc1xuICAgICAgICA/IHtcbiAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgICB0b3A6IGlzRm9yY2VPcGVuZWQgPyAnMCcgOiBweFRvUmVtKC1ub2RlSGVpZ2h0KSxcbiAgICAgICAgICBoZWlnaHQ6ICcwcHgnLFxuICAgICAgICAgIHRyYW5zaXRpb246ICcuMXMgdG9wJyxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIGRpcmVjdGlvbj1cInRvcFwiXG4gICAgICBvZmZzZXQ9e3Nob3VsZE9wZW4gPyAwIDogLW5vZGVIZWlnaHR9XG4gICAgICBvZmZzZXRSYW5nZT17Wy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIGRpc2FibGVIZWlnaHQ9eyFoYXNJdGVtc31cbiAgICAgIGZvcndhcmRSZWY9e2NoaWxkUmVmfVxuICAgICAgekluZGV4PXtaSU5ERVguYXBwQmFyICsgMX1cbiAgICAgIHRyYW5zaXRpb249ezAuMX1cbiAgICAgIGluaXRpYWxTdGF0ZT17IWhhc0l0ZW1zXG4gICAgICAgID8ge1xuICAgICAgICAgIC4uLkRFRkFVTFRfU1RJQ0tZX1NUQVRFLFxuICAgICAgICAgIGRpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBlbXVsYXRlZERpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBvZmZzZXQ6IC1ub2RlSGVpZ2h0LFxuICAgICAgICAgIGVtdWxhdGVkT2Zmc2V0OiAtbm9kZUhlaWdodCxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIG9uTW91c2VFbnRlcj17b25Nb3VzZUVudGVyfVxuICAgICAgb25Nb3VzZUxlYXZlPXsoKSA9PiB7XG4gICAgICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICAgICAgb25Nb3VzZUxlYXZlPy4oKTtcbiAgICAgIH19XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lciBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc30+XG4gICAgICAgIDxUYWJDb250YWluZXJcbiAgICAgICAgICByZWY9e2NvbnRhaW5lclJlZn1cbiAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgPlxuICAgICAgICAgIDxTdHlsZWRUYWJcbiAgICAgICAgICAgIHJlZj17KG5vZGUpID0+IHtcbiAgICAgICAgICAgICAgaWYgKCFub2RlKSB7IHJldHVybjsgfVxuICAgICAgICAgICAgICBjb25zdCB0aHJvdHRsZVNjcm9sbCA9IHRocm90dGxlKCgpID0+IG9uQ2hhbmdlVmlzaWJsZUdyYWRpZW50KG5vZGUpLCAxMDApO1xuICAgICAgICAgICAgICBub2RlLmFkZEV2ZW50TGlzdGVuZXIoJ3Njcm9sbCcsIHRocm90dGxlU2Nyb2xsKTtcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgICAgIGlzTW9iaWxlPXtpc01vYmlsZX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IG1lbnVFbnRyaWVzLm1hcCgoaXRlbSwgaW5kZXgpID0+IChcbiAgICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJTZWNvbmRhcnlUYWJJdGVtXG4gICAgICAgICAgICAgICAgY29udGFpbmVyUmVmPXtjb250YWluZXJSZWZ9XG4gICAgICAgICAgICAgICAga2V5PXtpdGVtLnRpdGxlfVxuICAgICAgICAgICAgICAgIGluZGV4PXtpbmRleH1cbiAgICAgICAgICAgICAgICBvbkNoYW5nZVZpc2libGVNZW51PXtvbkNoYW5nZVZpc2libGVNZW51fVxuICAgICAgICAgICAgICAgIGl0ZW09e2l0ZW19XG4gICAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICAgIGJ1bGxldD17aXRlbS5idWxsZXR9XG4gICAgICAgICAgICAgICAgYmFkZ2U9e2l0ZW0uYmFkZ2V9XG4gICAgICAgICAgICAgICAgaXNBY3RpdmU9e2FjdGl2ZUlkID09PSBpbmRleH1cbiAgICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgICAgIHByaW1hcnlJZD17cHJpbWFyeUlkfVxuICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgeyBpdGVtLnRpdGxlIH1cbiAgICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5VGFiSXRlbT5cbiAgICAgICAgICAgICkpIH1cbiAgICAgICAgICA8L1N0eWxlZFRhYj5cbiAgICAgICAgICB7ICFzY3JvbGxhYmxlRW50cmllcyAmJiBtb3JlTWVudXNDb21wb25lbnQgfVxuICAgICAgICA8L1RhYkNvbnRhaW5lcj5cbiAgICAgICAgeyByaWdodCAmJiA8UmlnaHQ+eyByaWdodCB9PC9SaWdodD4gfVxuICAgICAgPC9TdHlsZWRDb250YWluZXI+XG4gICAgPC9TdHlsZWRTdGlja3k+XG4gICk7XG59XG5cbmNvbnN0IFN0eWxlZFN0aWNreSA9IHN0eWxlZChTdGlja3kpYFxuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJhY2tncm91bmQuYmFzZX07XG4gIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbSgxKX0gc29saWQgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5kaXZpZGVyfTtcbmA7XG5cbmNvbnN0IFN0eWxlZENvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiB9PmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIG92ZXJmbG93OiBhdXRvO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIG92ZXJmbG93OiBpbml0aWFsO1xuICAgIHBhZGRpbmctbGVmdDogMDtcbiAgYH1cbmA7XG5cbmNvbnN0IFN0eWxlZFRhYiA9IHN0eWxlZChUYWIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiwgaXNNb2JpbGU6IGJvb2xlYW4gfT5gXG4gIGhlaWdodDogJHtweFRvUmVtKDUxKX07XG4gICR7TUVESUFfUVVFUlkubWF4KCdtb2JpbGUnLCBjc3NgXG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oNDApfTtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBtYXJnaW46IDAgJHtweFRvUmVtKC0yKX07XG4gICAgJiYgPiAqIHtcbiAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMil9O1xuICAgIH1cbiAgYCl9XG4gICR7KHsgc2Nyb2xsYWJsZSwgaXNNb2JpbGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgICYge1xuICAgICAgJHtpc01vYmlsZVxuICAgID8gY3NzYFxuICAgICAgICBwYWRkaW5nOiAwICR7cHhUb1JlbSgzMil9IDAgJHtweFRvUmVtKDE2KX07XG4gICAgICAgIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gICAgICBgXG4gICAgOiBjc3Ngb3ZlcmZsb3c6IGhpZGRlbjtgfVxuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IFJpZ2h0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMCAwIGF1dG87XG4gIGRpc3BsYXk6IG5vbmU7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gIGApfVxuYDtcblxuY29uc3QgVGFiQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IHNjcm9sbGFibGU6IGJvb2xlYW4gfT5gXG4gIGZsZXg6IDEgMCAwO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIGB9XG5gO1xuIl19 */"), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarSecondary;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX$1.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? {
      ...DEFAULT_STICKY_STATE,
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    } : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: () => {
      if (isPopperOpened) {
        return;
      }
      onMouseLeave?.();
    },
    children: jsxs(StyledContainer, {
      scrollable: scrollableEntries,
      children: [jsxs(TabContainer, {
        ref: containerRef,
        scrollable: scrollableEntries,
        children: [jsx(StyledTab, {
          ref: node => {
            if (!node) {
              return;
            }
            const throttleScroll = throttle$1(() => onChangeVisibleGradient(node), 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile,
          children: menuEntries.map((item, index) => jsx(NavigationBarSecondaryTabItem, {
            containerRef: containerRef,
            index: index,
            onChangeVisibleMenu: onChangeVisibleMenu,
            item: item,
            href: item.href,
            bullet: item.bullet,
            badge: item.badge,
            isActive: activeId === index,
            onSelect: () => onSelect(item, index),
            primaryId: primaryId,
            children: item.title
          }, item.title))
        }), !scrollableEntries && moreMenusComponent]
      }), right && jsx(Right, {
        children: right
      })]
    })
  });
}
const StyledSticky = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "e2301rp4"
} : {
  target: "e2301rp4",
  label: "StyledSticky"
})("background:", ({
  theme
}) => theme.background.base, ";border-bottom:", pxToRem(1), " solid ", ({
  theme
}) => theme.divider, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var _ref3$1 = process.env.NODE_ENV === "production" ? {
  name: "1ahtu5h",
  styles: "overflow:initial;padding-left:0"
} : {
  name: "167amg9-StyledContainer",
  styles: "overflow:initial;padding-left:0;label:StyledContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
const StyledContainer = /*#__PURE__*/_styled(Container$z, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp3"
} : {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp3",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;overflow:auto;", ({
  scrollable
}) => !scrollable && _ref3$1, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNkwyQiIsImZpbGUiOiJTZWNvbmRhcnkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBpc1Byb3BWYWxpZCBmcm9tICdAZW1vdGlvbi9pcy1wcm9wLXZhbGlkJztcbmltcG9ydCB0aHJvdHRsZSBmcm9tICdsb2Rhc2gtZXMvdGhyb3R0bGUnO1xuXG5pbXBvcnQge1xuICBERUZBVUxUX1NUSUNLWV9TVEFURSxcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIE1FRElBX1FVRVJZLFxuICBaSU5ERVgsXG4gIHB4VG9SZW0sXG4gIHVzZVJlc3BvbnNpdmUsXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IENvbnRhaW5lciwgVGFiIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgTmF2aWdhdGlvbkJhclNlY29uZGFyeVRhYkl0ZW0gfSBmcm9tICcuL1NlY29uZGFyeVRhYkl0ZW0nO1xuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgdXNlTW9yZU1lbnVzIH0gZnJvbSAnLi91c2VNb3JlTWVudXMnO1xuXG5jb25zdCBJTklUSUFMX05PREVfSEVJR0hUID0gNTE7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzIHtcbiAgLyoqXG4gICAqIFNlY29uZGFyeeyXkCDslYTsnbTthZzsnbQg7KG07J6s7ZW07IScIFNlY29uZGFyeSDrqZTribTqsIAg67O07Jes7KeIIOyImCDsnojsnYzsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7J20IOqwkuydtCBmYWxzZeudvOuptCwgU2Vjb25kYXJ564qUIO2RnOyLnOuQmOyngCDslYrsirXri4jri6QgKFByaW1hcnkg65Kk7JeQIO2VreyDgSDsiKjslrTsnojsirXri4jri6QpXG4gICAqIOycoOyggOqwgCBQcmltYXJ57JeQ7IScIOuLpOuluCDrqZTribTrpbwg7ISg7YOd7ZW07IScLCDslYTsnbTthZzsnbQg67O07Jes7KeA6riwIOyLnOyeke2VtOuPhCDsnbQg6rCS7J2AIGZhbHNl66GcXG4gICAqIOq3uOuMgOuhnCDrgqjslYTsnojslrTslbwg7ZWp64uI64ukLiAo6re466CH7KeAIOyViuycvOuptCBTZWNvbmRhcnkg7KCE7LK06rCAIOusuOyEnCDsoITssrTrpbwg67CR7Jy866GcIOuCtOumtCDsiJhcbiAgICog7J6I6riwIOuVjOusuOyeheuLiOuLpC4pXG4gICAqL1xuICBoYXNJdGVtczogYm9vbGVhbjtcbiAgLyoqXG4gICAqIOycoOyggOqwgCBQcmltYXJ5LCBTZWNvbmRhcnnsl5Ag66eI7Jqw7Iqk66W8IOyYrOugpOyEnCBTZWNvbmRhcnnqsIAg7Iqk7YGs66GkIOyDge2DnOyXkCDqtIDqs4Qg7JeG7J20XG4gICAqIOuztOyXrOyguOyVvCDtlajsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7Jyg7KCA6rCAIOuniOyasOyKpOulvCDsmKzroLjslrTrj4QsIOuztOyXrOykhCDqsJLsnbQg7JeG64uk66m0IGlzRm9yY2VPcGVuZWTripQgZmFsc2Xsl6zslbwg7ZWp64uI64ukLlxuICAgKiDrqqjrsJTsnbwg7YGs6riw7JeQ7ISc64qUIOydtCDqsJLsl5Ag6rSA6rOEIOyXhuydtCDtla3sg4Eg67O07Jes7KeR64uI64ukLlxuICAgKi9cbiAgaXNGb3JjZU9wZW5lZDogYm9vbGVhbjtcbiAgaXNGYWxsYmFjazogYm9vbGVhbjtcbiAgcmlnaHQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbDtcbiAgb25Nb3VzZUVudGVyPzogKCkgPT4gdm9pZDtcbiAgb25Nb3VzZUxlYXZlPzogKCkgPT4gdm9pZDtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xuICAvKipcbiAgICogbmF2aWdhdGlvbiBiYXLqsIAgb3ZlcmZsb3cg65CQ7J2EIOuVjCDsspjrpqxcbiAgICogdHJ1ZShkZWZhdWx0KTogc2Nyb2xsZXJcbiAgICogZmFsc2U6IHBjOiBwb3BwZXIsIG1vYmlsZTogYm90dG9tIHNoZWV0KG1vZGFsIOy7tO2PrOuEjO2KuCDsgqzsmqkpXG4gICAqL1xuICBzY3JvbGxhYmxlRW50cmllcz86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5KFxuICBwcm9wczogTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzLFxuKTogUmVhY3QuUmVhY3RFbGVtZW50IHwgbnVsbCB7XG4gIGNvbnN0IHtcbiAgICBoYXNJdGVtcyxcbiAgICBpc0ZvcmNlT3BlbmVkLFxuICAgIGlzRmFsbGJhY2ssXG4gICAgcmlnaHQsXG4gICAgbWVudUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgb25Nb3VzZUVudGVyLFxuICAgIG9uTW91c2VMZWF2ZSxcbiAgICBvblNlbGVjdCxcbiAgICBwcmltYXJ5SWQsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMgPSB0cnVlLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG5cbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCBpc01vYmlsZSA9IHVzZVJlc3BvbnNpdmUoKS5icmVha3BvaW50ID09PSAnbW9iaWxlJztcbiAgY29uc3Qgbm9kZUhlaWdodCA9IHVzZU5vZGVIZWlnaHQoY2hpbGRSZWYsIElOSVRJQUxfTk9ERV9IRUlHSFQpO1xuICBjb25zdCBzY3JvbGxEaXIgPSB1c2VTY3JvbGxEaXJlY3Rpb24oKTtcbiAgY29uc3Qgc2hvdWxkT3BlbiA9IChoYXNJdGVtcyAmJiBzY3JvbGxEaXIgIT09ICdkb3duJykgfHwgaXNGb3JjZU9wZW5lZDtcblxuICBjb25zdCB7XG4gICAgb25DaGFuZ2VWaXNpYmxlTWVudSxcbiAgICBvbkNoYW5nZVZpc2libGVHcmFkaWVudCxcbiAgICBjb250YWluZXJSZWYsXG4gICAgbW9yZU1lbnVzQ29tcG9uZW50LFxuICAgIGlzUG9wcGVyT3BlbmVkLFxuICB9ID0gdXNlTW9yZU1lbnVzKHtcbiAgICBtZW51czogbWVudUVudHJpZXMsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgcHJpbWFyeUlkLFxuICB9KTtcblxuICAvKiogSG92ZXLrkJwgU2Vjb25kYXJ5IOuplOuJtCDrgrQgUG9wcGVy6rCAIOuLq+2eiOuptCwgU2Vjb25kYXJ57J2YIEhvdmVy7IOB7YOc64+EIOyXhuyVoOq4sCDsnITtlbQg7Iuk7ZaJ7ZWp64uI64ukLiAqL1xuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICBvbk1vdXNlTGVhdmU/LigpO1xuICB9LCBbaXNQb3BwZXJPcGVuZWQsIG9uTW91c2VMZWF2ZV0pO1xuXG4gIGlmIChtZW51RW50cmllcy5sZW5ndGggPT09IDApIHsgcmV0dXJuIG51bGw7IH1cblxuICAvLyBOT1RFOiBTZWNvbmRhcnnsnZgg66qo67CU7J28L1BDIOuPmeyekeydgCDsmYTsoITtnogg64+Z7J287ZWp64uI64ukLlxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRTdGlja3lcbiAgICAgIGNsYXNzTmFtZT1cImxheW91dC1uYXZpZ2F0aW9uLXNlY29uZGFyeVwiXG4gICAgICBjc3M9e2Nzc2Ake2lzRmFsbGJhY2sgJiYgY3NzYGJhY2tncm91bmQ6ICR7dGhlbWUuYmFja2dyb3VuZC5ncm91cGVkQmFzZX07YH1gfVxuICAgICAgY29udGFpbmVyU3R5bGU9eyFoYXNJdGVtc1xuICAgICAgICA/IHtcbiAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgICB0b3A6IGlzRm9yY2VPcGVuZWQgPyAnMCcgOiBweFRvUmVtKC1ub2RlSGVpZ2h0KSxcbiAgICAgICAgICBoZWlnaHQ6ICcwcHgnLFxuICAgICAgICAgIHRyYW5zaXRpb246ICcuMXMgdG9wJyxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIGRpcmVjdGlvbj1cInRvcFwiXG4gICAgICBvZmZzZXQ9e3Nob3VsZE9wZW4gPyAwIDogLW5vZGVIZWlnaHR9XG4gICAgICBvZmZzZXRSYW5nZT17Wy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIGRpc2FibGVIZWlnaHQ9eyFoYXNJdGVtc31cbiAgICAgIGZvcndhcmRSZWY9e2NoaWxkUmVmfVxuICAgICAgekluZGV4PXtaSU5ERVguYXBwQmFyICsgMX1cbiAgICAgIHRyYW5zaXRpb249ezAuMX1cbiAgICAgIGluaXRpYWxTdGF0ZT17IWhhc0l0ZW1zXG4gICAgICAgID8ge1xuICAgICAgICAgIC4uLkRFRkFVTFRfU1RJQ0tZX1NUQVRFLFxuICAgICAgICAgIGRpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBlbXVsYXRlZERpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBvZmZzZXQ6IC1ub2RlSGVpZ2h0LFxuICAgICAgICAgIGVtdWxhdGVkT2Zmc2V0OiAtbm9kZUhlaWdodCxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIG9uTW91c2VFbnRlcj17b25Nb3VzZUVudGVyfVxuICAgICAgb25Nb3VzZUxlYXZlPXsoKSA9PiB7XG4gICAgICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICAgICAgb25Nb3VzZUxlYXZlPy4oKTtcbiAgICAgIH19XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lciBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc30+XG4gICAgICAgIDxUYWJDb250YWluZXJcbiAgICAgICAgICByZWY9e2NvbnRhaW5lclJlZn1cbiAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgPlxuICAgICAgICAgIDxTdHlsZWRUYWJcbiAgICAgICAgICAgIHJlZj17KG5vZGUpID0+IHtcbiAgICAgICAgICAgICAgaWYgKCFub2RlKSB7IHJldHVybjsgfVxuICAgICAgICAgICAgICBjb25zdCB0aHJvdHRsZVNjcm9sbCA9IHRocm90dGxlKCgpID0+IG9uQ2hhbmdlVmlzaWJsZUdyYWRpZW50KG5vZGUpLCAxMDApO1xuICAgICAgICAgICAgICBub2RlLmFkZEV2ZW50TGlzdGVuZXIoJ3Njcm9sbCcsIHRocm90dGxlU2Nyb2xsKTtcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgICAgIGlzTW9iaWxlPXtpc01vYmlsZX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IG1lbnVFbnRyaWVzLm1hcCgoaXRlbSwgaW5kZXgpID0+IChcbiAgICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJTZWNvbmRhcnlUYWJJdGVtXG4gICAgICAgICAgICAgICAgY29udGFpbmVyUmVmPXtjb250YWluZXJSZWZ9XG4gICAgICAgICAgICAgICAga2V5PXtpdGVtLnRpdGxlfVxuICAgICAgICAgICAgICAgIGluZGV4PXtpbmRleH1cbiAgICAgICAgICAgICAgICBvbkNoYW5nZVZpc2libGVNZW51PXtvbkNoYW5nZVZpc2libGVNZW51fVxuICAgICAgICAgICAgICAgIGl0ZW09e2l0ZW19XG4gICAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICAgIGJ1bGxldD17aXRlbS5idWxsZXR9XG4gICAgICAgICAgICAgICAgYmFkZ2U9e2l0ZW0uYmFkZ2V9XG4gICAgICAgICAgICAgICAgaXNBY3RpdmU9e2FjdGl2ZUlkID09PSBpbmRleH1cbiAgICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgICAgIHByaW1hcnlJZD17cHJpbWFyeUlkfVxuICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgeyBpdGVtLnRpdGxlIH1cbiAgICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5VGFiSXRlbT5cbiAgICAgICAgICAgICkpIH1cbiAgICAgICAgICA8L1N0eWxlZFRhYj5cbiAgICAgICAgICB7ICFzY3JvbGxhYmxlRW50cmllcyAmJiBtb3JlTWVudXNDb21wb25lbnQgfVxuICAgICAgICA8L1RhYkNvbnRhaW5lcj5cbiAgICAgICAgeyByaWdodCAmJiA8UmlnaHQ+eyByaWdodCB9PC9SaWdodD4gfVxuICAgICAgPC9TdHlsZWRDb250YWluZXI+XG4gICAgPC9TdHlsZWRTdGlja3k+XG4gICk7XG59XG5cbmNvbnN0IFN0eWxlZFN0aWNreSA9IHN0eWxlZChTdGlja3kpYFxuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJhY2tncm91bmQuYmFzZX07XG4gIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbSgxKX0gc29saWQgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5kaXZpZGVyfTtcbmA7XG5cbmNvbnN0IFN0eWxlZENvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiB9PmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIG92ZXJmbG93OiBhdXRvO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIG92ZXJmbG93OiBpbml0aWFsO1xuICAgIHBhZGRpbmctbGVmdDogMDtcbiAgYH1cbmA7XG5cbmNvbnN0IFN0eWxlZFRhYiA9IHN0eWxlZChUYWIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiwgaXNNb2JpbGU6IGJvb2xlYW4gfT5gXG4gIGhlaWdodDogJHtweFRvUmVtKDUxKX07XG4gICR7TUVESUFfUVVFUlkubWF4KCdtb2JpbGUnLCBjc3NgXG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oNDApfTtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBtYXJnaW46IDAgJHtweFRvUmVtKC0yKX07XG4gICAgJiYgPiAqIHtcbiAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMil9O1xuICAgIH1cbiAgYCl9XG4gICR7KHsgc2Nyb2xsYWJsZSwgaXNNb2JpbGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgICYge1xuICAgICAgJHtpc01vYmlsZVxuICAgID8gY3NzYFxuICAgICAgICBwYWRkaW5nOiAwICR7cHhUb1JlbSgzMil9IDAgJHtweFRvUmVtKDE2KX07XG4gICAgICAgIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gICAgICBgXG4gICAgOiBjc3Ngb3ZlcmZsb3c6IGhpZGRlbjtgfVxuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IFJpZ2h0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMCAwIGF1dG87XG4gIGRpc3BsYXk6IG5vbmU7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gIGApfVxuYDtcblxuY29uc3QgVGFiQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IHNjcm9sbGFibGU6IGJvb2xlYW4gfT5gXG4gIGZsZXg6IDEgMCAwO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIGB9XG5gO1xuIl19 */"));
var _ref2$4 = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "xx69bi-StyledTab",
  styles: "overflow:hidden;label:StyledTab;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
const StyledTab = /*#__PURE__*/_styled(Tab, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp2"
} : {
  shouldForwardProp: prop => isPropValid(prop),
  target: "e2301rp2",
  label: "StyledTab"
})("height:", pxToRem(51), ";", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("height:", pxToRem(40), ";justify-content:center;margin:0 ", pxToRem(-2), ";&&>*{margin:0 ", pxToRem(2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), " ", ({
  scrollable,
  isMobile
}) => !scrollable && /*#__PURE__*/css("&{", isMobile ? /*#__PURE__*/css("padding:0 ", pxToRem(32), " 0 ", pxToRem(16), ";justify-content:start;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeU5TIiwiZmlsZSI6IlNlY29uZGFyeS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlRWZmZWN0LCB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IGlzUHJvcFZhbGlkIGZyb20gJ0BlbW90aW9uL2lzLXByb3AtdmFsaWQnO1xuaW1wb3J0IHRocm90dGxlIGZyb20gJ2xvZGFzaC1lcy90aHJvdHRsZSc7XG5cbmltcG9ydCB7XG4gIERFRkFVTFRfU1RJQ0tZX1NUQVRFLFxuICBTdGlja3ksXG4gIHVzZU5vZGVIZWlnaHQsXG4gIHVzZVNjcm9sbERpcmVjdGlvbixcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL3VpJztcblxuaW1wb3J0IHtcbiAgTUVESUFfUVVFUlksXG4gIFpJTkRFWCxcbiAgcHhUb1JlbSxcbiAgdXNlUmVzcG9uc2l2ZSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ29udGFpbmVyLCBUYWIgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5VGFiSXRlbSB9IGZyb20gJy4vU2Vjb25kYXJ5VGFiSXRlbSc7XG5pbXBvcnQgeyBNZW51U2NoZW1hRW50cnkgfSBmcm9tICcuLi90eXBlcyc7XG5pbXBvcnQgeyB1c2VNb3JlTWVudXMgfSBmcm9tICcuL3VzZU1vcmVNZW51cyc7XG5cbmNvbnN0IElOSVRJQUxfTk9ERV9IRUlHSFQgPSA1MTtcblxuZXhwb3J0IGludGVyZmFjZSBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5UHJvcHMge1xuICAvKipcbiAgICogU2Vjb25kYXJ57JeQIOyVhOydtO2FnOydtCDsobTsnqztlbTshJwgU2Vjb25kYXJ5IOuplOuJtOqwgCDrs7Tsl6zsp4gg7IiYIOyeiOydjOydhCDsnZjrr7jtlanri4jri6QuXG4gICAqIOunjOyVvSDsnbQg6rCS7J20IGZhbHNl652866m0LCBTZWNvbmRhcnnripQg7ZGc7Iuc65CY7KeAIOyViuyKteuLiOuLpCAoUHJpbWFyeSDrkqTsl5Ag7ZWt7IOBIOyIqOyWtOyeiOyKteuLiOuLpClcbiAgICog7Jyg7KCA6rCAIFByaW1hcnnsl5DshJwg64uk66W4IOuplOuJtOulvCDshKDtg53tlbTshJwsIOyVhOydtO2FnOydtCDrs7Tsl6zsp4DquLAg7Iuc7J6R7ZW064+EIOydtCDqsJLsnYAgZmFsc2XroZxcbiAgICog6re464yA66GcIOuCqOyVhOyeiOyWtOyVvCDtlanri4jri6QuICjqt7jroIfsp4Ag7JWK7Jy866m0IFNlY29uZGFyeSDsoITssrTqsIAg66y47IScIOyghOyytOulvCDrsJHsnLzroZwg64K066a0IOyImFxuICAgKiDsnojquLAg65WM66y47J6F64uI64ukLilcbiAgICovXG4gIGhhc0l0ZW1zOiBib29sZWFuO1xuICAvKipcbiAgICog7Jyg7KCA6rCAIFByaW1hcnksIFNlY29uZGFyeeyXkCDrp4jsmrDsiqTrpbwg7Jis66Ck7IScIFNlY29uZGFyeeqwgCDsiqTtgazroaQg7IOB7YOc7JeQIOq0gOqzhCDsl4bsnbRcbiAgICog67O07Jes7KC47JW8IO2VqOydhCDsnZjrr7jtlanri4jri6QuXG4gICAqIOunjOyVvSDsnKDsoIDqsIAg66eI7Jqw7Iqk66W8IOyYrOuguOyWtOuPhCwg67O07Jes7KSEIOqwkuydtCDsl4bri6TrqbQgaXNGb3JjZU9wZW5lZOuKlCBmYWxzZeyXrOyVvCDtlanri4jri6QuXG4gICAqIOuqqOuwlOydvCDtgazquLDsl5DshJzripQg7J20IOqwkuyXkCDqtIDqs4Qg7JeG7J20IO2VreyDgSDrs7Tsl6zsp5Hri4jri6QuXG4gICAqL1xuICBpc0ZvcmNlT3BlbmVkOiBib29sZWFuO1xuICBpc0ZhbGxiYWNrOiBib29sZWFuO1xuICByaWdodD86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgbWVudUVudHJpZXM6IE1lbnVTY2hlbWFFbnRyeVtdO1xuICBhY3RpdmVJZDogbnVtYmVyIHwgbnVsbDtcbiAgcHJpbWFyeUlkOiBudW1iZXIgfCBudWxsO1xuICBvbk1vdXNlRW50ZXI/OiAoKSA9PiB2b2lkO1xuICBvbk1vdXNlTGVhdmU/OiAoKSA9PiB2b2lkO1xuICBvblNlbGVjdDogKGVudHJ5OiBNZW51U2NoZW1hRW50cnksIGluZGV4OiBudW1iZXIpID0+IHZvaWQ7XG4gIC8qKlxuICAgKiBuYXZpZ2F0aW9uIGJhcuqwgCBvdmVyZmxvdyDrkJDsnYQg65WMIOyymOumrFxuICAgKiB0cnVlKGRlZmF1bHQpOiBzY3JvbGxlclxuICAgKiBmYWxzZTogcGM6IHBvcHBlciwgbW9iaWxlOiBib3R0b20gc2hlZXQobW9kYWwg7Lu07Y+s64SM7Yq4IOyCrOyaqSlcbiAgICovXG4gIHNjcm9sbGFibGVFbnRyaWVzPzogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIE5hdmlnYXRpb25CYXJTZWNvbmRhcnkoXG4gIHByb3BzOiBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5UHJvcHMsXG4pOiBSZWFjdC5SZWFjdEVsZW1lbnQgfCBudWxsIHtcbiAgY29uc3Qge1xuICAgIGhhc0l0ZW1zLFxuICAgIGlzRm9yY2VPcGVuZWQsXG4gICAgaXNGYWxsYmFjayxcbiAgICByaWdodCxcbiAgICBtZW51RW50cmllcyxcbiAgICBhY3RpdmVJZCxcbiAgICBvbk1vdXNlRW50ZXIsXG4gICAgb25Nb3VzZUxlYXZlLFxuICAgIG9uU2VsZWN0LFxuICAgIHByaW1hcnlJZCxcbiAgICBzY3JvbGxhYmxlRW50cmllcyA9IHRydWUsXG4gIH0gPSBwcm9wcztcbiAgY29uc3QgY2hpbGRSZWYgPSB1c2VSZWY8SFRNTERpdkVsZW1lbnQgfCBudWxsPihudWxsKTtcblxuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IGlzTW9iaWxlID0gdXNlUmVzcG9uc2l2ZSgpLmJyZWFrcG9pbnQgPT09ICdtb2JpbGUnO1xuICBjb25zdCBub2RlSGVpZ2h0ID0gdXNlTm9kZUhlaWdodChjaGlsZFJlZiwgSU5JVElBTF9OT0RFX0hFSUdIVCk7XG4gIGNvbnN0IHNjcm9sbERpciA9IHVzZVNjcm9sbERpcmVjdGlvbigpO1xuICBjb25zdCBzaG91bGRPcGVuID0gKGhhc0l0ZW1zICYmIHNjcm9sbERpciAhPT0gJ2Rvd24nKSB8fCBpc0ZvcmNlT3BlbmVkO1xuXG4gIGNvbnN0IHtcbiAgICBvbkNoYW5nZVZpc2libGVNZW51LFxuICAgIG9uQ2hhbmdlVmlzaWJsZUdyYWRpZW50LFxuICAgIGNvbnRhaW5lclJlZixcbiAgICBtb3JlTWVudXNDb21wb25lbnQsXG4gICAgaXNQb3BwZXJPcGVuZWQsXG4gIH0gPSB1c2VNb3JlTWVudXMoe1xuICAgIG1lbnVzOiBtZW51RW50cmllcyxcbiAgICBzY3JvbGxhYmxlRW50cmllcyxcbiAgICBhY3RpdmVJZCxcbiAgICBwcmltYXJ5SWQsXG4gIH0pO1xuXG4gIC8qKiBIb3ZlcuuQnCBTZWNvbmRhcnkg66mU64m0IOuCtCBQb3BwZXLqsIAg64ur7Z6I66m0LCBTZWNvbmRhcnnsnZggSG92ZXLsg4Htg5zrj4Qg7JeG7JWg6riwIOychO2VtCDsi6Ttlontlanri4jri6QuICovXG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKGlzUG9wcGVyT3BlbmVkKSB7IHJldHVybjsgfVxuICAgIG9uTW91c2VMZWF2ZT8uKCk7XG4gIH0sIFtpc1BvcHBlck9wZW5lZCwgb25Nb3VzZUxlYXZlXSk7XG5cbiAgaWYgKG1lbnVFbnRyaWVzLmxlbmd0aCA9PT0gMCkgeyByZXR1cm4gbnVsbDsgfVxuXG4gIC8vIE5PVEU6IFNlY29uZGFyeeydmCDrqqjrsJTsnbwvUEMg64+Z7J6R7J2AIOyZhOyghO2eiCDrj5nsnbztlanri4jri6QuXG4gIHJldHVybiAoXG4gICAgPFN0eWxlZFN0aWNreVxuICAgICAgY2xhc3NOYW1lPVwibGF5b3V0LW5hdmlnYXRpb24tc2Vjb25kYXJ5XCJcbiAgICAgIGNzcz17Y3NzYCR7aXNGYWxsYmFjayAmJiBjc3NgYmFja2dyb3VuZDogJHt0aGVtZS5iYWNrZ3JvdW5kLmdyb3VwZWRCYXNlfTtgfWB9XG4gICAgICBjb250YWluZXJTdHlsZT17IWhhc0l0ZW1zXG4gICAgICAgID8ge1xuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRvcDogaXNGb3JjZU9wZW5lZCA/ICcwJyA6IHB4VG9SZW0oLW5vZGVIZWlnaHQpLFxuICAgICAgICAgIGhlaWdodDogJzBweCcsXG4gICAgICAgICAgdHJhbnNpdGlvbjogJy4xcyB0b3AnLFxuICAgICAgICB9XG4gICAgICAgIDogdW5kZWZpbmVkfVxuICAgICAgZGlyZWN0aW9uPVwidG9wXCJcbiAgICAgIG9mZnNldD17c2hvdWxkT3BlbiA/IDAgOiAtbm9kZUhlaWdodH1cbiAgICAgIG9mZnNldFJhbmdlPXtbLW5vZGVIZWlnaHQsIDBdfVxuICAgICAgdHlwZT1cIm5hdmlnYXRpb25cIlxuICAgICAgZGlzYWJsZU5hdGl2ZVN0aWNreVxuICAgICAgZGlzYWJsZUJvdHRvbVxuICAgICAgZGlzYWJsZUhlaWdodD17IWhhc0l0ZW1zfVxuICAgICAgZm9yd2FyZFJlZj17Y2hpbGRSZWZ9XG4gICAgICB6SW5kZXg9e1pJTkRFWC5hcHBCYXIgKyAxfVxuICAgICAgdHJhbnNpdGlvbj17MC4xfVxuICAgICAgaW5pdGlhbFN0YXRlPXshaGFzSXRlbXNcbiAgICAgICAgPyB7XG4gICAgICAgICAgLi4uREVGQVVMVF9TVElDS1lfU1RBVEUsXG4gICAgICAgICAgZGlzYWJsZWQ6IGZhbHNlLFxuICAgICAgICAgIGVtdWxhdGVkRGlzYWJsZWQ6IGZhbHNlLFxuICAgICAgICAgIG9mZnNldDogLW5vZGVIZWlnaHQsXG4gICAgICAgICAgZW11bGF0ZWRPZmZzZXQ6IC1ub2RlSGVpZ2h0LFxuICAgICAgICB9XG4gICAgICAgIDogdW5kZWZpbmVkfVxuICAgICAgb25Nb3VzZUVudGVyPXtvbk1vdXNlRW50ZXJ9XG4gICAgICBvbk1vdXNlTGVhdmU9eygpID0+IHtcbiAgICAgICAgaWYgKGlzUG9wcGVyT3BlbmVkKSB7IHJldHVybjsgfVxuICAgICAgICBvbk1vdXNlTGVhdmU/LigpO1xuICAgICAgfX1cbiAgICA+XG4gICAgICA8U3R5bGVkQ29udGFpbmVyIHNjcm9sbGFibGU9e3Njcm9sbGFibGVFbnRyaWVzfT5cbiAgICAgICAgPFRhYkNvbnRhaW5lclxuICAgICAgICAgIHJlZj17Y29udGFpbmVyUmVmfVxuICAgICAgICAgIHNjcm9sbGFibGU9e3Njcm9sbGFibGVFbnRyaWVzfVxuICAgICAgICA+XG4gICAgICAgICAgPFN0eWxlZFRhYlxuICAgICAgICAgICAgcmVmPXsobm9kZSkgPT4ge1xuICAgICAgICAgICAgICBpZiAoIW5vZGUpIHsgcmV0dXJuOyB9XG4gICAgICAgICAgICAgIGNvbnN0IHRocm90dGxlU2Nyb2xsID0gdGhyb3R0bGUoKCkgPT4gb25DaGFuZ2VWaXNpYmxlR3JhZGllbnQobm9kZSksIDEwMCk7XG4gICAgICAgICAgICAgIG5vZGUuYWRkRXZlbnRMaXN0ZW5lcignc2Nyb2xsJywgdGhyb3R0bGVTY3JvbGwpO1xuICAgICAgICAgICAgfX1cbiAgICAgICAgICAgIHNjcm9sbGFibGU9e3Njcm9sbGFibGVFbnRyaWVzfVxuICAgICAgICAgICAgaXNNb2JpbGU9e2lzTW9iaWxlfVxuICAgICAgICAgID5cbiAgICAgICAgICAgIHsgbWVudUVudHJpZXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICAgICAgICA8TmF2aWdhdGlvbkJhclNlY29uZGFyeVRhYkl0ZW1cbiAgICAgICAgICAgICAgICBjb250YWluZXJSZWY9e2NvbnRhaW5lclJlZn1cbiAgICAgICAgICAgICAgICBrZXk9e2l0ZW0udGl0bGV9XG4gICAgICAgICAgICAgICAgaW5kZXg9e2luZGV4fVxuICAgICAgICAgICAgICAgIG9uQ2hhbmdlVmlzaWJsZU1lbnU9e29uQ2hhbmdlVmlzaWJsZU1lbnV9XG4gICAgICAgICAgICAgICAgaXRlbT17aXRlbX1cbiAgICAgICAgICAgICAgICBocmVmPXtpdGVtLmhyZWZ9XG4gICAgICAgICAgICAgICAgYnVsbGV0PXtpdGVtLmJ1bGxldH1cbiAgICAgICAgICAgICAgICBiYWRnZT17aXRlbS5iYWRnZX1cbiAgICAgICAgICAgICAgICBpc0FjdGl2ZT17YWN0aXZlSWQgPT09IGluZGV4fVxuICAgICAgICAgICAgICAgIG9uU2VsZWN0PXsoKSA9PiBvblNlbGVjdChpdGVtLCBpbmRleCl9XG4gICAgICAgICAgICAgICAgcHJpbWFyeUlkPXtwcmltYXJ5SWR9XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICB7IGl0ZW0udGl0bGUgfVxuICAgICAgICAgICAgICA8L05hdmlnYXRpb25CYXJTZWNvbmRhcnlUYWJJdGVtPlxuICAgICAgICAgICAgKSkgfVxuICAgICAgICAgIDwvU3R5bGVkVGFiPlxuICAgICAgICAgIHsgIXNjcm9sbGFibGVFbnRyaWVzICYmIG1vcmVNZW51c0NvbXBvbmVudCB9XG4gICAgICAgIDwvVGFiQ29udGFpbmVyPlxuICAgICAgICB7IHJpZ2h0ICYmIDxSaWdodD57IHJpZ2h0IH08L1JpZ2h0PiB9XG4gICAgICA8L1N0eWxlZENvbnRhaW5lcj5cbiAgICA8L1N0eWxlZFN0aWNreT5cbiAgKTtcbn1cblxuY29uc3QgU3R5bGVkU3RpY2t5ID0gc3R5bGVkKFN0aWNreSlgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYmFja2dyb3VuZC5iYXNlfTtcbiAgYm9yZGVyLWJvdHRvbTogJHtweFRvUmVtKDEpfSBzb2xpZCAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmRpdmlkZXJ9O1xuYDtcblxuY29uc3QgU3R5bGVkQ29udGFpbmVyID0gc3R5bGVkKENvbnRhaW5lciwge1xuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+IGlzUHJvcFZhbGlkKHByb3ApLFxufSk8eyBzY3JvbGxhYmxlOiBib29sZWFuIH0+YFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgb3ZlcmZsb3c6IGF1dG87XG4gICR7KHsgc2Nyb2xsYWJsZSB9KSA9PiAhc2Nyb2xsYWJsZSAmJiBjc3NgXG4gICAgb3ZlcmZsb3c6IGluaXRpYWw7XG4gICAgcGFkZGluZy1sZWZ0OiAwO1xuICBgfVxuYDtcblxuY29uc3QgU3R5bGVkVGFiID0gc3R5bGVkKFRhYiwge1xuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+IGlzUHJvcFZhbGlkKHByb3ApLFxufSk8eyBzY3JvbGxhYmxlOiBib29sZWFuLCBpc01vYmlsZTogYm9vbGVhbiB9PmBcbiAgaGVpZ2h0OiAke3B4VG9SZW0oNTEpfTtcbiAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGNzc2BcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSg0MCl9O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIG1hcmdpbjogMCAke3B4VG9SZW0oLTIpfTtcbiAgICAmJiA+ICoge1xuICAgICAgbWFyZ2luOiAwICR7cHhUb1JlbSgyKX07XG4gICAgfVxuICBgKX1cbiAgJHsoeyBzY3JvbGxhYmxlLCBpc01vYmlsZSB9KSA9PiAhc2Nyb2xsYWJsZSAmJiBjc3NgXG4gICAgJiB7XG4gICAgICAke2lzTW9iaWxlXG4gICAgPyBjc3NgXG4gICAgICAgIHBhZGRpbmc6IDAgJHtweFRvUmVtKDMyKX0gMCAke3B4VG9SZW0oMTYpfTtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBzdGFydDtcbiAgICAgIGBcbiAgICA6IGNzc2BvdmVyZmxvdzogaGlkZGVuO2B9XG4gICAgfVxuICBgfVxuYDtcblxuY29uc3QgUmlnaHQgPSBzdHlsZWQuZGl2YFxuICBmbGV4OiAwIDAgYXV0bztcbiAgZGlzcGxheTogbm9uZTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICBtYXJnaW4tbGVmdDogMTBweDtcbiAgYCl9XG5gO1xuXG5jb25zdCBUYWJDb250YWluZXIgPSBzdHlsZWQuZGl2PHsgc2Nyb2xsYWJsZTogYm9vbGVhbiB9PmBcbiAgZmxleDogMSAwIDA7XG4gICR7KHsgc2Nyb2xsYWJsZSB9KSA9PiAhc2Nyb2xsYWJsZSAmJiBjc3NgXG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgYH1cbmA7XG4iXX0= */") : _ref2$4, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Right = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2301rp1"
} : {
  target: "e2301rp1",
  label: "Right"
})("flex:0 0 auto;display:none;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "17kpjmp",
  styles: "display:block;margin-left:10px"
} : {
  name: "a5adt4-Right",
  styles: "display:block;margin-left:10px;label:Right;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var _ref$c = process.env.NODE_ENV === "production" ? {
  name: "t1y265",
  styles: "display:flex;justify-content:space-between;overflow:hidden"
} : {
  name: "1sit2m7-TabContainer",
  styles: "display:flex;justify-content:space-between;overflow:hidden;label:TabContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNk8wQyIsImZpbGUiOiJTZWNvbmRhcnkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBpc1Byb3BWYWxpZCBmcm9tICdAZW1vdGlvbi9pcy1wcm9wLXZhbGlkJztcbmltcG9ydCB0aHJvdHRsZSBmcm9tICdsb2Rhc2gtZXMvdGhyb3R0bGUnO1xuXG5pbXBvcnQge1xuICBERUZBVUxUX1NUSUNLWV9TVEFURSxcbiAgU3RpY2t5LFxuICB1c2VOb2RlSGVpZ2h0LFxuICB1c2VTY3JvbGxEaXJlY3Rpb24sXG59IGZyb20gJ0BidWNrZXRwbGFjZS91aSc7XG5cbmltcG9ydCB7XG4gIE1FRElBX1FVRVJZLFxuICBaSU5ERVgsXG4gIHB4VG9SZW0sXG4gIHVzZVJlc3BvbnNpdmUsXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IENvbnRhaW5lciwgVGFiIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgTmF2aWdhdGlvbkJhclNlY29uZGFyeVRhYkl0ZW0gfSBmcm9tICcuL1NlY29uZGFyeVRhYkl0ZW0nO1xuaW1wb3J0IHsgTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgdXNlTW9yZU1lbnVzIH0gZnJvbSAnLi91c2VNb3JlTWVudXMnO1xuXG5jb25zdCBJTklUSUFMX05PREVfSEVJR0hUID0gNTE7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzIHtcbiAgLyoqXG4gICAqIFNlY29uZGFyeeyXkCDslYTsnbTthZzsnbQg7KG07J6s7ZW07IScIFNlY29uZGFyeSDrqZTribTqsIAg67O07Jes7KeIIOyImCDsnojsnYzsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7J20IOqwkuydtCBmYWxzZeudvOuptCwgU2Vjb25kYXJ564qUIO2RnOyLnOuQmOyngCDslYrsirXri4jri6QgKFByaW1hcnkg65Kk7JeQIO2VreyDgSDsiKjslrTsnojsirXri4jri6QpXG4gICAqIOycoOyggOqwgCBQcmltYXJ57JeQ7IScIOuLpOuluCDrqZTribTrpbwg7ISg7YOd7ZW07IScLCDslYTsnbTthZzsnbQg67O07Jes7KeA6riwIOyLnOyeke2VtOuPhCDsnbQg6rCS7J2AIGZhbHNl66GcXG4gICAqIOq3uOuMgOuhnCDrgqjslYTsnojslrTslbwg7ZWp64uI64ukLiAo6re466CH7KeAIOyViuycvOuptCBTZWNvbmRhcnkg7KCE7LK06rCAIOusuOyEnCDsoITssrTrpbwg67CR7Jy866GcIOuCtOumtCDsiJhcbiAgICog7J6I6riwIOuVjOusuOyeheuLiOuLpC4pXG4gICAqL1xuICBoYXNJdGVtczogYm9vbGVhbjtcbiAgLyoqXG4gICAqIOycoOyggOqwgCBQcmltYXJ5LCBTZWNvbmRhcnnsl5Ag66eI7Jqw7Iqk66W8IOyYrOugpOyEnCBTZWNvbmRhcnnqsIAg7Iqk7YGs66GkIOyDge2DnOyXkCDqtIDqs4Qg7JeG7J20XG4gICAqIOuztOyXrOyguOyVvCDtlajsnYQg7J2Y66+47ZWp64uI64ukLlxuICAgKiDrp4zslb0g7Jyg7KCA6rCAIOuniOyasOyKpOulvCDsmKzroLjslrTrj4QsIOuztOyXrOykhCDqsJLsnbQg7JeG64uk66m0IGlzRm9yY2VPcGVuZWTripQgZmFsc2Xsl6zslbwg7ZWp64uI64ukLlxuICAgKiDrqqjrsJTsnbwg7YGs6riw7JeQ7ISc64qUIOydtCDqsJLsl5Ag6rSA6rOEIOyXhuydtCDtla3sg4Eg67O07Jes7KeR64uI64ukLlxuICAgKi9cbiAgaXNGb3JjZU9wZW5lZDogYm9vbGVhbjtcbiAgaXNGYWxsYmFjazogYm9vbGVhbjtcbiAgcmlnaHQ/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIG1lbnVFbnRyaWVzOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgYWN0aXZlSWQ6IG51bWJlciB8IG51bGw7XG4gIHByaW1hcnlJZDogbnVtYmVyIHwgbnVsbDtcbiAgb25Nb3VzZUVudGVyPzogKCkgPT4gdm9pZDtcbiAgb25Nb3VzZUxlYXZlPzogKCkgPT4gdm9pZDtcbiAgb25TZWxlY3Q6IChlbnRyeTogTWVudVNjaGVtYUVudHJ5LCBpbmRleDogbnVtYmVyKSA9PiB2b2lkO1xuICAvKipcbiAgICogbmF2aWdhdGlvbiBiYXLqsIAgb3ZlcmZsb3cg65CQ7J2EIOuVjCDsspjrpqxcbiAgICogdHJ1ZShkZWZhdWx0KTogc2Nyb2xsZXJcbiAgICogZmFsc2U6IHBjOiBwb3BwZXIsIG1vYmlsZTogYm90dG9tIHNoZWV0KG1vZGFsIOy7tO2PrOuEjO2KuCDsgqzsmqkpXG4gICAqL1xuICBzY3JvbGxhYmxlRW50cmllcz86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5KFxuICBwcm9wczogTmF2aWdhdGlvbkJhclNlY29uZGFyeVByb3BzLFxuKTogUmVhY3QuUmVhY3RFbGVtZW50IHwgbnVsbCB7XG4gIGNvbnN0IHtcbiAgICBoYXNJdGVtcyxcbiAgICBpc0ZvcmNlT3BlbmVkLFxuICAgIGlzRmFsbGJhY2ssXG4gICAgcmlnaHQsXG4gICAgbWVudUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgb25Nb3VzZUVudGVyLFxuICAgIG9uTW91c2VMZWF2ZSxcbiAgICBvblNlbGVjdCxcbiAgICBwcmltYXJ5SWQsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMgPSB0cnVlLFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IGNoaWxkUmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50IHwgbnVsbD4obnVsbCk7XG5cbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCBpc01vYmlsZSA9IHVzZVJlc3BvbnNpdmUoKS5icmVha3BvaW50ID09PSAnbW9iaWxlJztcbiAgY29uc3Qgbm9kZUhlaWdodCA9IHVzZU5vZGVIZWlnaHQoY2hpbGRSZWYsIElOSVRJQUxfTk9ERV9IRUlHSFQpO1xuICBjb25zdCBzY3JvbGxEaXIgPSB1c2VTY3JvbGxEaXJlY3Rpb24oKTtcbiAgY29uc3Qgc2hvdWxkT3BlbiA9IChoYXNJdGVtcyAmJiBzY3JvbGxEaXIgIT09ICdkb3duJykgfHwgaXNGb3JjZU9wZW5lZDtcblxuICBjb25zdCB7XG4gICAgb25DaGFuZ2VWaXNpYmxlTWVudSxcbiAgICBvbkNoYW5nZVZpc2libGVHcmFkaWVudCxcbiAgICBjb250YWluZXJSZWYsXG4gICAgbW9yZU1lbnVzQ29tcG9uZW50LFxuICAgIGlzUG9wcGVyT3BlbmVkLFxuICB9ID0gdXNlTW9yZU1lbnVzKHtcbiAgICBtZW51czogbWVudUVudHJpZXMsXG4gICAgc2Nyb2xsYWJsZUVudHJpZXMsXG4gICAgYWN0aXZlSWQsXG4gICAgcHJpbWFyeUlkLFxuICB9KTtcblxuICAvKiogSG92ZXLrkJwgU2Vjb25kYXJ5IOuplOuJtCDrgrQgUG9wcGVy6rCAIOuLq+2eiOuptCwgU2Vjb25kYXJ57J2YIEhvdmVy7IOB7YOc64+EIOyXhuyVoOq4sCDsnITtlbQg7Iuk7ZaJ7ZWp64uI64ukLiAqL1xuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICBvbk1vdXNlTGVhdmU/LigpO1xuICB9LCBbaXNQb3BwZXJPcGVuZWQsIG9uTW91c2VMZWF2ZV0pO1xuXG4gIGlmIChtZW51RW50cmllcy5sZW5ndGggPT09IDApIHsgcmV0dXJuIG51bGw7IH1cblxuICAvLyBOT1RFOiBTZWNvbmRhcnnsnZgg66qo67CU7J28L1BDIOuPmeyekeydgCDsmYTsoITtnogg64+Z7J287ZWp64uI64ukLlxuICByZXR1cm4gKFxuICAgIDxTdHlsZWRTdGlja3lcbiAgICAgIGNsYXNzTmFtZT1cImxheW91dC1uYXZpZ2F0aW9uLXNlY29uZGFyeVwiXG4gICAgICBjc3M9e2Nzc2Ake2lzRmFsbGJhY2sgJiYgY3NzYGJhY2tncm91bmQ6ICR7dGhlbWUuYmFja2dyb3VuZC5ncm91cGVkQmFzZX07YH1gfVxuICAgICAgY29udGFpbmVyU3R5bGU9eyFoYXNJdGVtc1xuICAgICAgICA/IHtcbiAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgICB0b3A6IGlzRm9yY2VPcGVuZWQgPyAnMCcgOiBweFRvUmVtKC1ub2RlSGVpZ2h0KSxcbiAgICAgICAgICBoZWlnaHQ6ICcwcHgnLFxuICAgICAgICAgIHRyYW5zaXRpb246ICcuMXMgdG9wJyxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIGRpcmVjdGlvbj1cInRvcFwiXG4gICAgICBvZmZzZXQ9e3Nob3VsZE9wZW4gPyAwIDogLW5vZGVIZWlnaHR9XG4gICAgICBvZmZzZXRSYW5nZT17Wy1ub2RlSGVpZ2h0LCAwXX1cbiAgICAgIHR5cGU9XCJuYXZpZ2F0aW9uXCJcbiAgICAgIGRpc2FibGVOYXRpdmVTdGlja3lcbiAgICAgIGRpc2FibGVCb3R0b21cbiAgICAgIGRpc2FibGVIZWlnaHQ9eyFoYXNJdGVtc31cbiAgICAgIGZvcndhcmRSZWY9e2NoaWxkUmVmfVxuICAgICAgekluZGV4PXtaSU5ERVguYXBwQmFyICsgMX1cbiAgICAgIHRyYW5zaXRpb249ezAuMX1cbiAgICAgIGluaXRpYWxTdGF0ZT17IWhhc0l0ZW1zXG4gICAgICAgID8ge1xuICAgICAgICAgIC4uLkRFRkFVTFRfU1RJQ0tZX1NUQVRFLFxuICAgICAgICAgIGRpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBlbXVsYXRlZERpc2FibGVkOiBmYWxzZSxcbiAgICAgICAgICBvZmZzZXQ6IC1ub2RlSGVpZ2h0LFxuICAgICAgICAgIGVtdWxhdGVkT2Zmc2V0OiAtbm9kZUhlaWdodCxcbiAgICAgICAgfVxuICAgICAgICA6IHVuZGVmaW5lZH1cbiAgICAgIG9uTW91c2VFbnRlcj17b25Nb3VzZUVudGVyfVxuICAgICAgb25Nb3VzZUxlYXZlPXsoKSA9PiB7XG4gICAgICAgIGlmIChpc1BvcHBlck9wZW5lZCkgeyByZXR1cm47IH1cbiAgICAgICAgb25Nb3VzZUxlYXZlPy4oKTtcbiAgICAgIH19XG4gICAgPlxuICAgICAgPFN0eWxlZENvbnRhaW5lciBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc30+XG4gICAgICAgIDxUYWJDb250YWluZXJcbiAgICAgICAgICByZWY9e2NvbnRhaW5lclJlZn1cbiAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgPlxuICAgICAgICAgIDxTdHlsZWRUYWJcbiAgICAgICAgICAgIHJlZj17KG5vZGUpID0+IHtcbiAgICAgICAgICAgICAgaWYgKCFub2RlKSB7IHJldHVybjsgfVxuICAgICAgICAgICAgICBjb25zdCB0aHJvdHRsZVNjcm9sbCA9IHRocm90dGxlKCgpID0+IG9uQ2hhbmdlVmlzaWJsZUdyYWRpZW50KG5vZGUpLCAxMDApO1xuICAgICAgICAgICAgICBub2RlLmFkZEV2ZW50TGlzdGVuZXIoJ3Njcm9sbCcsIHRocm90dGxlU2Nyb2xsKTtcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgICBzY3JvbGxhYmxlPXtzY3JvbGxhYmxlRW50cmllc31cbiAgICAgICAgICAgIGlzTW9iaWxlPXtpc01vYmlsZX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7IG1lbnVFbnRyaWVzLm1hcCgoaXRlbSwgaW5kZXgpID0+IChcbiAgICAgICAgICAgICAgPE5hdmlnYXRpb25CYXJTZWNvbmRhcnlUYWJJdGVtXG4gICAgICAgICAgICAgICAgY29udGFpbmVyUmVmPXtjb250YWluZXJSZWZ9XG4gICAgICAgICAgICAgICAga2V5PXtpdGVtLnRpdGxlfVxuICAgICAgICAgICAgICAgIGluZGV4PXtpbmRleH1cbiAgICAgICAgICAgICAgICBvbkNoYW5nZVZpc2libGVNZW51PXtvbkNoYW5nZVZpc2libGVNZW51fVxuICAgICAgICAgICAgICAgIGl0ZW09e2l0ZW19XG4gICAgICAgICAgICAgICAgaHJlZj17aXRlbS5ocmVmfVxuICAgICAgICAgICAgICAgIGJ1bGxldD17aXRlbS5idWxsZXR9XG4gICAgICAgICAgICAgICAgYmFkZ2U9e2l0ZW0uYmFkZ2V9XG4gICAgICAgICAgICAgICAgaXNBY3RpdmU9e2FjdGl2ZUlkID09PSBpbmRleH1cbiAgICAgICAgICAgICAgICBvblNlbGVjdD17KCkgPT4gb25TZWxlY3QoaXRlbSwgaW5kZXgpfVxuICAgICAgICAgICAgICAgIHByaW1hcnlJZD17cHJpbWFyeUlkfVxuICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgeyBpdGVtLnRpdGxlIH1cbiAgICAgICAgICAgICAgPC9OYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5VGFiSXRlbT5cbiAgICAgICAgICAgICkpIH1cbiAgICAgICAgICA8L1N0eWxlZFRhYj5cbiAgICAgICAgICB7ICFzY3JvbGxhYmxlRW50cmllcyAmJiBtb3JlTWVudXNDb21wb25lbnQgfVxuICAgICAgICA8L1RhYkNvbnRhaW5lcj5cbiAgICAgICAgeyByaWdodCAmJiA8UmlnaHQ+eyByaWdodCB9PC9SaWdodD4gfVxuICAgICAgPC9TdHlsZWRDb250YWluZXI+XG4gICAgPC9TdHlsZWRTdGlja3k+XG4gICk7XG59XG5cbmNvbnN0IFN0eWxlZFN0aWNreSA9IHN0eWxlZChTdGlja3kpYFxuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmJhY2tncm91bmQuYmFzZX07XG4gIGJvcmRlci1ib3R0b206ICR7cHhUb1JlbSgxKX0gc29saWQgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5kaXZpZGVyfTtcbmA7XG5cbmNvbnN0IFN0eWxlZENvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiB9PmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIG92ZXJmbG93OiBhdXRvO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIG92ZXJmbG93OiBpbml0aWFsO1xuICAgIHBhZGRpbmctbGVmdDogMDtcbiAgYH1cbmA7XG5cbmNvbnN0IFN0eWxlZFRhYiA9IHN0eWxlZChUYWIsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiBpc1Byb3BWYWxpZChwcm9wKSxcbn0pPHsgc2Nyb2xsYWJsZTogYm9vbGVhbiwgaXNNb2JpbGU6IGJvb2xlYW4gfT5gXG4gIGhlaWdodDogJHtweFRvUmVtKDUxKX07XG4gICR7TUVESUFfUVVFUlkubWF4KCdtb2JpbGUnLCBjc3NgXG4gICAgaGVpZ2h0OiAke3B4VG9SZW0oNDApfTtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBtYXJnaW46IDAgJHtweFRvUmVtKC0yKX07XG4gICAgJiYgPiAqIHtcbiAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMil9O1xuICAgIH1cbiAgYCl9XG4gICR7KHsgc2Nyb2xsYWJsZSwgaXNNb2JpbGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgICYge1xuICAgICAgJHtpc01vYmlsZVxuICAgID8gY3NzYFxuICAgICAgICBwYWRkaW5nOiAwICR7cHhUb1JlbSgzMil9IDAgJHtweFRvUmVtKDE2KX07XG4gICAgICAgIGp1c3RpZnktY29udGVudDogc3RhcnQ7XG4gICAgICBgXG4gICAgOiBjc3Ngb3ZlcmZsb3c6IGhpZGRlbjtgfVxuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IFJpZ2h0ID0gc3R5bGVkLmRpdmBcbiAgZmxleDogMCAwIGF1dG87XG4gIGRpc3BsYXk6IG5vbmU7XG4gICR7TUVESUFfUVVFUlkubWluKCd0YWJsZXQnLCBjc3NgXG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gIGApfVxuYDtcblxuY29uc3QgVGFiQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IHNjcm9sbGFibGU6IGJvb2xlYW4gfT5gXG4gIGZsZXg6IDEgMCAwO1xuICAkeyh7IHNjcm9sbGFibGUgfSkgPT4gIXNjcm9sbGFibGUgJiYgY3NzYFxuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIGB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};
const TabContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2301rp0"
} : {
  target: "e2301rp0",
  label: "TabContainer"
})("flex:1 0 0;", ({
  scrollable
}) => !scrollable && _ref$c, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function NavigationBarTertiary({
  item,
  isOpen,
  onMouseEnter,
  onMouseLeave
}) {
  const itemRef = useRef(item);
  if (item != null) {
    itemRef.current = item;
  }
  const currentItem = itemRef.current;
  const nodeRef = useRef(null);
  const [top, setTop] = useState(null);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    let timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(() => {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  const show = useMemo(() => Boolean(isOpen && item?.renderBarChild), [isOpen, item]);
  if (top == null) {
    return null;
  }
  return jsx(CSSTransition$1, {
    timeout: 200,
    in: show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    },
    children: jsx("div", {
      css: /*#__PURE__*/css("position:fixed;top:", top, "px;left:0;right:0;background-color:#ffffff;border-bottom:1px solid #ededed;z-index:500;opacity:0;transform:translateY(-100%);&.opening{transition:.2s opacity,.2s transform;}&.exiting{transition:.2s opacity,.2s transform;}&.open{opacity:1;transform:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarTertiary;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: currentItem?.renderBarChild?.()
    })
  });
}

const HistoryStorageContext = /*#__PURE__*/createContext({});
const useHistoryStorage = () => useContext(HistoryStorageContext);
function HistoryStorageProvider({
  children,
  ...props
}) {
  return jsx(HistoryStorageContext.Provider, {
    value: props,
    children: children
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText({
  item,
  query
}) {
  const {
    highlightedDisplay
  } = item.value;
  if (!query) {
    return jsx(Fragment$1, {
      children: item.query
    });
  }
  const parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp(`(${query})`, 'gi'));
  return jsx(Fragment$1, {
    children: parts.map((part, index) => jsx(Fragment$2, {
      children: index % 2 === 1 ? jsx("strong", {
        children: part
      }) : part
    }, index))
  });
}
var _ref$b = process.env.NODE_ENV === "production" ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : {
  name: "1tzo240-KeywordItem",
  styles: "display:flex;align-items:center;white-space:nowrap;label:KeywordItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
};
function KeywordItem(props) {
  return jsxs("div", {
    css: _ref$b,
    children: [jsx(Icon$1, {
      name: "search",
      size: 18,
      fill: theme => theme.content.base1,
      css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', `
            width: ${pxToRem(24)};
            height: ${pxToRem(24)};
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:KeywordItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    }), jsx("div", {
      css: /*#__PURE__*/css("flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:KeywordItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: jsx(HighlightedText, {
        ...props
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$a = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "ick9f2-CategoryItem",
  styles: "display:flex;align-items:center;overflow:hidden;label:CategoryItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
};
var _ref2$3 = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "1msaz0g-CategoryItem",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:CategoryItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
};
function CategoryItem(props) {
  const theme = useTheme();
  return jsxs("div", {
    css: _ref2$3,
    children: [jsxs("div", {
      css: _ref$a,
      children: [jsx(Icon$1, {
        css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', `
              width: ${pxToRem(24)};
              height: ${pxToRem(24)};
              min-width: ${pxToRem(24)};
            `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        name: "search",
        size: 18,
        fill: theme => theme.content.base1
      }), jsx("div", {
        css: /*#__PURE__*/css("text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: jsx(HighlightedText, {
          ...props
        })
      }), jsx("span", {
        css: /*#__PURE__*/css("width:", pxToRem(1), ";height:", pxToRem(10), ";background:", theme.content.base4, ";margin:0 ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
      }), jsx("span", {
        css: /*#__PURE__*/css(FONT_STYLE.caption1, " margin-right:", pxToRem(14), ";color:", theme.content.base2, ";", MEDIA_QUERY.min('laptop', `
            ${FONT_STYLE.caption2}
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: "\uCE74\uD14C\uACE0\uB9AC"
      })]
    }), jsx(Icon$1, {
      name: "chevron_right",
      size: 18,
      fill: theme => theme.content.base3
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MAX_DEPTH = 2;
var _ref$9 = process.env.NODE_ENV === "production" ? {
  name: "n0fp6c",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%"
} : {
  name: "dnavbd-CategoryHierarchy",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%;label:CategoryHierarchy;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhdGVnb3J5SGllcmFyY2h5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjaUIiLCJmaWxlIjoiQ2F0ZWdvcnlIaWVyYXJjaHkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRnJhZ21lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgSWNvbiB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmNvbnN0IE1BWF9ERVBUSCA9IDI7XG5leHBvcnQgZnVuY3Rpb24gQ2F0ZWdvcnlIaWVyYXJjaHkoe1xuICBoaWVyYXJjaHksXG59OiB7IGhpZXJhcmNoeTogc3RyaW5nW10gfSk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgdHJhaWxpbmdzID0gaGllcmFyY2h5LnNsaWNlKC1NQVhfREVQVEgpO1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZmxvdzogcm93IHdyYXA7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgYH1cbiAgICA+XG4gICAgICB7IHRyYWlsaW5ncy5tYXAoKGRlcHRoLCBpbmRleCkgPT4gKFxuICAgICAgICA8RnJhZ21lbnQga2V5PXtpbmRleH0+XG4gICAgICAgICAgPHNwYW4gY3NzPXtjc3NgXG4gICAgICAgICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgICAgICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAxLjQ7XG4gICAgICAgICAgICAmOmxhc3Qtb2YtdHlwZSB7XG4gICAgICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEudGhpY2t9O1xuICAgICAgICAgICAgfVxuICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgeyBkZXB0aCB9XG4gICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgIHsgaW5kZXggPCB0cmFpbGluZ3MubGVuZ3RoIC0gMSAmJiAoXG4gICAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgICBuYW1lPVwiY2hldnJvbl9yaWdodFwiXG4gICAgICAgICAgICAgIHNpemU9ezEyfVxuICAgICAgICAgICAgICBjc3M9e2Nzc2BtYXJnaW46IDAgJHtweFRvUmVtKDYpfTtgfVxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgPC9GcmFnbWVudD5cbiAgICAgICkpIH1cbiAgICA8L2Rpdj5cbiAgKTtcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
};
function CategoryHierarchy({
  hierarchy
}) {
  const trailings = hierarchy.slice(-MAX_DEPTH);
  const theme = useTheme();
  return jsx("div", {
    css: _ref$9,
    children: trailings.map((depth, index) => jsxs(Fragment$2, {
      children: [jsx("span", {
        css: /*#__PURE__*/css("display:inline-block;font-weight:bold;line-height:1.4;&:last-of-type{color:", theme.content.primary1.thick, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryHierarchy;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhdGVnb3J5SGllcmFyY2h5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1QndCIiwiZmlsZSI6IkNhdGVnb3J5SGllcmFyY2h5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEZyYWdtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb24gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5jb25zdCBNQVhfREVQVEggPSAyO1xuZXhwb3J0IGZ1bmN0aW9uIENhdGVnb3J5SGllcmFyY2h5KHtcbiAgaGllcmFyY2h5LFxufTogeyBoaWVyYXJjaHk6IHN0cmluZ1tdIH0pOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHRyYWlsaW5ncyA9IGhpZXJhcmNoeS5zbGljZSgtTUFYX0RFUFRIKTtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWZsb3c6IHJvdyB3cmFwO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIGB9XG4gICAgPlxuICAgICAgeyB0cmFpbGluZ3MubWFwKChkZXB0aCwgaW5kZXgpID0+IChcbiAgICAgICAgPEZyYWdtZW50IGtleT17aW5kZXh9PlxuICAgICAgICAgIDxzcGFuIGNzcz17Y3NzYFxuICAgICAgICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMS40O1xuICAgICAgICAgICAgJjpsYXN0LW9mLXR5cGUge1xuICAgICAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLnRoaWNrfTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICBgfVxuICAgICAgICAgID5cbiAgICAgICAgICAgIHsgZGVwdGggfVxuICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICB7IGluZGV4IDwgdHJhaWxpbmdzLmxlbmd0aCAtIDEgJiYgKFxuICAgICAgICAgICAgPEljb25cbiAgICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgY3NzPXtjc3NgbWFyZ2luOiAwICR7cHhUb1JlbSg2KX07YH1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgIDwvRnJhZ21lbnQ+XG4gICAgICApKSB9XG4gICAgPC9kaXY+XG4gICk7XG59XG4iXX0= */"),
        children: depth
      }), index < trailings.length - 1 && jsx(Icon$1, {
        name: "chevron_right",
        size: 12,
        css: /*#__PURE__*/css("margin:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryHierarchy;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhdGVnb3J5SGllcmFyY2h5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQ3NCIiwiZmlsZSI6IkNhdGVnb3J5SGllcmFyY2h5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEZyYWdtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb24gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5jb25zdCBNQVhfREVQVEggPSAyO1xuZXhwb3J0IGZ1bmN0aW9uIENhdGVnb3J5SGllcmFyY2h5KHtcbiAgaGllcmFyY2h5LFxufTogeyBoaWVyYXJjaHk6IHN0cmluZ1tdIH0pOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHRyYWlsaW5ncyA9IGhpZXJhcmNoeS5zbGljZSgtTUFYX0RFUFRIKTtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWZsb3c6IHJvdyB3cmFwO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIGB9XG4gICAgPlxuICAgICAgeyB0cmFpbGluZ3MubWFwKChkZXB0aCwgaW5kZXgpID0+IChcbiAgICAgICAgPEZyYWdtZW50IGtleT17aW5kZXh9PlxuICAgICAgICAgIDxzcGFuIGNzcz17Y3NzYFxuICAgICAgICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMS40O1xuICAgICAgICAgICAgJjpsYXN0LW9mLXR5cGUge1xuICAgICAgICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLnRoaWNrfTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgICBgfVxuICAgICAgICAgID5cbiAgICAgICAgICAgIHsgZGVwdGggfVxuICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICB7IGluZGV4IDwgdHJhaWxpbmdzLmxlbmd0aCAtIDEgJiYgKFxuICAgICAgICAgICAgPEljb25cbiAgICAgICAgICAgICAgbmFtZT1cImNoZXZyb25fcmlnaHRcIlxuICAgICAgICAgICAgICBzaXplPXsxMn1cbiAgICAgICAgICAgICAgY3NzPXtjc3NgbWFyZ2luOiAwICR7cHhUb1JlbSg2KX07YH1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgIDwvRnJhZ21lbnQ+XG4gICAgICApKSB9XG4gICAgPC9kaXY+XG4gICk7XG59XG4iXX0= */")
      })]
    }, index))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$8 = process.env.NODE_ENV === "production" ? {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden"
} : {
  name: "18t4iq0-renderItem",
  styles: "text-overflow:ellipsis;overflow:hidden;label:renderItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};
function HistoryItem({
  item,
  hovered
}) {
  const theme = useTheme();
  const {
    query,
    value
  } = item;
  const historyStorage = useHistoryStorage();
  const handleDeleteClick = e => {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  const renderItem = () => {
    let elem = query;
    if (typeof value === 'object' && value.type === 'category') {
      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      const orgDisplay = value.value.orgDisplay ?? '';
      elem = jsx(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(value => value.trim())
      });
    }
    return jsx("span", {
      css: _ref$8,
      children: elem
    });
  };
  return jsxs("div", {
    css: /*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", pxToRem(4), " 0;box-sizing:border-box;", MEDIA_QUERY.min('laptop', /*#__PURE__*/css("padding:", pxToRem(4), " ", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    children: [renderItem(), jsx("button", {
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/css(RESET_BUTTON, " margin-right:", pxToRem(-6), ";padding:", pxToRem(6), ";transition:.1s opacity;font-size:0;line-height:0;border-radius:", pxToRem(2), ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
            opacity: .4;
          `, FOCUS`
            box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
          `, process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhpc3RvcnlJdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1RVEiLCJmaWxlIjoiSGlzdG9yeUl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTW91c2VFdmVudCwgUmVhY3RFbGVtZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIEhPVkVSLFxuICBNRURJQV9RVUVSWSxcbiAgUkVTRVRfQlVUVE9OLFxuICBweFRvUmVtLFxufSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHsgdXNlSGlzdG9yeVN0b3JhZ2UgfSBmcm9tICcuLi9IaXN0b3J5Q29udGV4dCc7XG5pbXBvcnQgeyBTZWFyY2hJdGVtIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5pbXBvcnQgeyBDYXRlZ29yeUhpZXJhcmNoeSB9IGZyb20gJy4vQ2F0ZWdvcnlIaWVyYXJjaHknO1xuXG5pbnRlcmZhY2UgSGlzdG9yeUl0ZW1Qcm9wcyB7XG4gIGl0ZW06IEV4dHJhY3Q8U2VhcmNoSXRlbSwgeyB0eXBlOiAnaGlzdG9yeScgfT47XG4gIGhvdmVyZWQ6IGJvb2xlYW47XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBIaXN0b3J5SXRlbSh7XG4gIGl0ZW0sIGhvdmVyZWQsXG59OiBIaXN0b3J5SXRlbVByb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IHsgcXVlcnksIHZhbHVlIH0gPSBpdGVtO1xuICBjb25zdCBoaXN0b3J5U3RvcmFnZSA9IHVzZUhpc3RvcnlTdG9yYWdlKCk7XG5cbiAgY29uc3QgaGFuZGxlRGVsZXRlQ2xpY2sgPSAoZTogTW91c2VFdmVudCk6IHZvaWQgPT4ge1xuICAgIGUuc3RvcFByb3BhZ2F0aW9uKCk7XG4gICAgaGlzdG9yeVN0b3JhZ2UucmVtb3ZlKHZhbHVlKTtcbiAgfTtcblxuICBjb25zdCByZW5kZXJJdGVtID0gKCk6IFJlYWN0RWxlbWVudCA9PiB7XG4gICAgbGV0IGVsZW06IFJlYWN0LlJlYWN0Tm9kZSA9IHF1ZXJ5O1xuICAgIGlmICh0eXBlb2YgdmFsdWUgPT09ICdvYmplY3QnICYmIHZhbHVlLnR5cGUgPT09ICdjYXRlZ29yeScpIHtcbiAgICAgIC8vIOq4sOyhtCBIaXN0b3J5IOuNsOydtO2EsOqwgCB1bmRlZmluZWQg7J24IOqyveyasOqwgCDsnojslrQsIOyYteyFlOuEkCDqsJIg7LaU6rCAXG4gICAgICBjb25zdCBvcmdEaXNwbGF5ID0gdmFsdWUudmFsdWUub3JnRGlzcGxheSA/PyAnJztcbiAgICAgIGVsZW0gPSA8Q2F0ZWdvcnlIaWVyYXJjaHkgaGllcmFyY2h5PXtvcmdEaXNwbGF5LnNwbGl0KCc+JykubWFwKCh2YWx1ZSkgPT4gdmFsdWUudHJpbSgpKX0gLz47XG4gICAgfVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxzcGFuXG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICAgICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgIGB9XG4gICAgICA+XG4gICAgICAgIHsgZWxlbSB9XG4gICAgICA8L3NwYW4+XG4gICAgKTtcbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDxkaXYgY3NzPXtjc3NgXG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgcGFkZGluZzogJHtweFRvUmVtKDQpfSAwO1xuICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBjc3NgXG4gICAgICAgIHBhZGRpbmc6ICR7cHhUb1JlbSg0KX0gJHtweFRvUmVtKDQpfTtcbiAgICAgIGApfVxuICAgIGB9XG4gICAgPlxuICAgICAgeyByZW5kZXJJdGVtKCkgfVxuICAgICAgPGJ1dHRvblxuICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgb25DbGljaz17aGFuZGxlRGVsZXRlQ2xpY2t9XG4gICAgICAgIGNzcz17W1xuICAgICAgICAgIGNzc2BcbiAgICAgICAgICAgICR7UkVTRVRfQlVUVE9OfVxuICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oLTYpfTtcbiAgICAgICAgICAgIHBhZGRpbmc6ICR7cHhUb1JlbSg2KX07XG4gICAgICAgICAgICB0cmFuc2l0aW9uOiAuMXMgb3BhY2l0eTtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMDtcbiAgICAgICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogJHtweFRvUmVtKDIpfTtcbiAgICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgICAgYCxcbiAgICAgICAgICBIT1ZFUmBcbiAgICAgICAgICAgIG9wYWNpdHk6IC40O1xuICAgICAgICAgIGAsXG4gICAgICAgICAgRk9DVVNgXG4gICAgICAgICAgICBib3gtc2hhZG93OiAwIDAgMCAke3B4VG9SZW0oMyl9ICR7dGhlbWUuaW50ZXJhY3RpdmUucHJpbWFyeTEudGhpbn07XG4gICAgICAgICAgYCxcbiAgICAgICAgXX1cbiAgICAgID5cbiAgICAgICAgPEljb25cbiAgICAgICAgICBuYW1lPVwiZGlzbWlzc1wiXG4gICAgICAgICAgc2l6ZT17MTJ9XG4gICAgICAgICAgZmlsbD17KHRoZW1lKSA9PiAoaG92ZXJlZCA/IHRoZW1lLmNvbnRlbnQuYmFzZTIgOiB0aGVtZS5jb250ZW50LmJhc2UzKX1cbiAgICAgICAgLz5cbiAgICAgIDwvYnV0dG9uPlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */"],
      children: jsx(Icon$1, {
        name: "dismiss",
        size: 12,
        fill: theme => hovered ? theme.content.base2 : theme.content.base3
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$7 = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "wghtr2-ConsultingItem",
  styles: "display:flex;align-items:center;overflow:hidden;label:ConsultingItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "dgqyf2-ConsultingItem",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:ConsultingItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
};
function ConsultingItem(props) {
  const {
    item: {
      value
    }
  } = props;
  const theme = useTheme();
  const cta = ` ${value.info.cta}`;
  return jsxs("div", {
    css: _ref2$2,
    children: [jsxs("div", {
      css: _ref$7,
      children: [jsx("div", {
        css: /*#__PURE__*/css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', `
              width: ${pxToRem(24)};
              height: ${pxToRem(24)};
            `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: value.info.iconFileUrl ? jsx(CircleImage, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/css("width:100%;border:", pxToRem(0.5), " solid ", theme.outline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnN1bHRpbmdJdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxRHdCIiwiZmlsZSI6IkNvbnN1bHRpbmdJdGVtLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7IE1FRElBX1FVRVJZLCBweFRvUmVtIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgQ2lyY2xlSW1hZ2UsIEljb24gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBTZWFyY2hJdGVtIH0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgSGlnaGxpZ2h0ZWRUZXh0IH0gZnJvbSAnLi9LZXl3b3JkSXRlbSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29uc3VsdGluZ0l0ZW1Qcm9wcyB7XG4gIGl0ZW06IEV4dHJhY3Q8U2VhcmNoSXRlbSwgeyB0eXBlOiAnY29uc3VsdGluZycgfT47XG4gIHF1ZXJ5Pzogc3RyaW5nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gQ29uc3VsdGluZ0l0ZW0ocHJvcHM6IENvbnN1bHRpbmdJdGVtUHJvcHMpOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHsgaXRlbTogeyB2YWx1ZSB9IH0gPSBwcm9wcztcblxuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG5cbiAgY29uc3QgY3RhID0gYCAke3ZhbHVlLmluZm8uY3RhfWA7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e2Nzc2BcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgYH1cbiAgICA+XG4gICAgICA8ZGl2XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICBgfVxuICAgICAgPlxuICAgICAgICA8ZGl2XG4gICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICB3aWR0aDogJHtweFRvUmVtKDMyKX07XG4gICAgICAgICAgICBoZWlnaHQ6ICR7cHhUb1JlbSgzMil9O1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBgXG4gICAgICAgICAgICAgIHdpZHRoOiAke3B4VG9SZW0oMjQpfTtcbiAgICAgICAgICAgICAgaGVpZ2h0OiAke3B4VG9SZW0oMjQpfTtcbiAgICAgICAgICAgIGApfVxuICAgICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICB7IHZhbHVlLmluZm8uaWNvbkZpbGVVcmxcbiAgICAgICAgICAgID8gKFxuICAgICAgICAgICAgICA8Q2lyY2xlSW1hZ2VcbiAgICAgICAgICAgICAgICBzcmM9e3ZhbHVlLmluZm8uaWNvbkZpbGVVcmx9XG4gICAgICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgICAgICAgIGJvcmRlcjogJHtweFRvUmVtKDAuNSl9IHNvbGlkICR7dGhlbWUub3V0bGluZX07XG4gICAgICAgICAgICAgICAgYH1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIClcbiAgICAgICAgICAgIDogKFxuICAgICAgICAgICAgICA8SWNvblxuICAgICAgICAgICAgICAgIG5hbWU9XCJzZWFyY2hcIlxuICAgICAgICAgICAgICAgIHNpemU9ezE4fVxuICAgICAgICAgICAgICAgIGZpbGw9eyh0aGVtZSkgPT4gdGhlbWUuY29udGVudC5iYXNlMX1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICkgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgZmxleDogMTtcbiAgICAgICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgICAgICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICAgICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgICAgICBtYXJnaW4tbGVmdDogJHtweFRvUmVtKDgpfTtcbiAgICAgICAgICBgfVxuICAgICAgICA+XG4gICAgICAgICAgPEhpZ2hsaWdodGVkVGV4dCB7Li4ucHJvcHN9IC8+XG4gICAgICAgICAgeyBjdGEgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgICAgPEljb24gbmFtZT1cImNoZXZyb25fcmlnaHRcIiBzaXplPXsxOH0gZmlsbD17KHRoZW1lKSA9PiB0aGVtZS5jb250ZW50LmJhc2UzfSAvPlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */")
        }) : jsx(Icon$1, {
          name: "search",
          size: 18,
          fill: theme => theme.content.base1
        })
      }), jsxs("div", {
        css: /*#__PURE__*/css("flex:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: [jsx(HighlightedText, {
          ...props
        }), cta]
      })]
    }), jsx(Icon$1, {
      name: "chevron_right",
      size: 18,
      fill: theme => theme.content.base3
    })]
  });
}

function ListBoxItem({
  item,
  hovered,
  query,
  showDivider = false,
  onHover,
  ...props
}) {
  const theme = useTheme();
  const ref = useRef(null);
  const renderItem = () => {
    switch (item.type) {
      case 'query':
        return jsx(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return jsx(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return jsx(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        return jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });
      default:
        return null;
    }
  };
  useEffect(() => {
    if (!hovered || !ref.current) {
      return;
    }
    onHover(ref.current);
  }, [hovered, onHover]);
  return jsxs(Fragment$1, {
    children: [jsx("li", {
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/css(FONT_STYLE.subTitle1, " position:relative;margin:0;padding:", pxToRem(8), " ", pxToRem(16), ";color:", theme.content.base1, ";line-height:", pxToRem(21), ";cursor:pointer;border-radius:", pxToRem(2), ";outline:none;strong{color:", theme.content.primary1.thick, ";font-weight:400;}", hovered && `background: ${theme.background.groupedBase};`, " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/css(FONT_STYLE.subTitle2, " padding:", pxToRem(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), FOCUS`
          background: ${theme.background.groupedBase};
        `, process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      tabIndex: 0,
      ...props,
      children: renderItem()
    }), showDivider && jsx(Divider, {
      css: /*#__PURE__*/css("margin:", pxToRem(8), " 0;", MEDIA_QUERY.min('laptop', `
              margin: ${pxToRem(10)} 0;
            `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      variant: "thin"
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function filterOnlyHistoryKeyword(items) {
  return items.filter(item => item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query');
}
var _ref$6 = process.env.NODE_ENV === "production" ? {
  name: "1xclg2i",
  styles: "margin:0;padding:0"
} : {
  name: "6ca3jb-ListBox",
  styles: "margin:0;padding:0;label:ListBox;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
function ListBox({
  items,
  query,
  hoveredIndex,
  isHistoryList,
  onItemClick,
  onItemMouseEnter
}) {
  const theme = useTheme();
  const container = useRef(null);
  const {
    localeData
  } = useGNBData();
  const log = useLogContext();
  const handleIntersect = useCallback(() => {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  const isShowDivider = useCallback((item, index) => {
    return index < items.length - 1 && items[index + 1]?.type !== item.type;
  }, [items]);
  const handleItemHover = useCallback(item => {
    if (!container.current) {
      return;
    }
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  const handleItemClick = useCallback((item, index) => () => onItemClick(item, index), [onItemClick]);
  const handleItemMouseEnter = useCallback((item, index) => () => onItemMouseEnter(item, index), [onItemMouseEnter]);
  return jsx(IntersectionObserver$1, {
    onIntersect: handleIntersect,
    children: jsxs("div", {
      ref: container,
      css: /*#__PURE__*/css("overflow-y:auto;position:relative;width:100%;padding:", pxToRem(10), " 0;border:", pxToRem(1), " solid ", theme.divider, ";border-radius:", pxToRem(4), ";background:", theme.background.base, ";box-shadow:0 ", pxToRem(4), " ", pxToRem(6), " 0 ", theme.shadow.basic, ";box-sizing:border-box;", MEDIA_QUERY.min('laptop', `
          position: absolute;
          top: calc(100% + ${pxToRem(4)});
          left: 0;
          max-height: ${pxToRem(400)};
        `), " ", MEDIA_QUERY.only('tablet', `
          top: ${pxToRem(4)};
          height: 100%;
        `), " ", MEDIA_QUERY.only('mobile', `
          height: 100%;
          padding: ${pxToRem(8)} 0;
          border: 0;
          box-shadow: none;
        `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBox;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [!isHistoryList && jsx(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0,
        localeData: localeData
      }), items.length > 0 ? jsx("ul", {
        css: _ref$6,
        children: items.map((item, index) => jsx(ListBoxItem, {
          item: item,
          query: query,
          hovered: hoveredIndex === index,
          showDivider: isShowDivider(item, index),
          onHover: handleItemHover,
          onClick: handleItemClick(item, index),
          onMouseEnter: handleItemMouseEnter(item, index)
        }, `${item.query}${index}`))
      }) : jsx("p", {
        css: /*#__PURE__*/css("margin:0;padding:", pxToRem(10), " ", pxToRem(16), ";color:", theme.content.base3, ";font-size:", pxToRem(15), ";line-height:1.4;" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBox;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: localeData?.search?.historyEmpty ?? '최근 검색한 내역이 없습니다.'
      })]
    })
  });
}
function HistoryListBoxHeader({
  hasDeleteButton,
  localeData
}) {
  const theme = useTheme();
  const historyStorage = useHistoryStorage();
  return jsxs("div", {
    css: /*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;padding:", pxToRem(7), " ", pxToRem(8), " ", pxToRem(10), ";font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    children: [jsx("span", {
      css: /*#__PURE__*/css("font-size:", pxToRem(13), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: localeData?.search?.historyLabel ?? '최근 검색어'
    }), hasDeleteButton && jsx("button", {
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/css(RESET_BUTTON, " margin:", pxToRem(-2), ";padding:", pxToRem(2), ";font-size:", pxToRem(12), ";color:", theme.content.base2, ";border-radius:", pxToRem(2), ";outline:none;transition:.1s opacity;" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
              opacity: .4;
            `, FOCUS`
              box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
            `, process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      children: localeData?.search?.deleteHistory ?? '전체 삭제'
    })]
  });
}

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

function NavigationSearch({
  searchType,
  initialQuery,
  onFetch,
  onSubmit,
  onSubmitItem,
  onInputFocus,
  historyStorage,
  placeholder,
  ...props
}) {
  const [pageKey, setPageKey] = useState(null);
  const [manuallyTypedInputValue, setManuallyTypedInputValue] = useState(initialQuery);
  const {
    isGlobal
  } = useGNBData();
  const fetchListFromSearchHistory = useCallback(() => {
    const history = historyStorage.get();
    return history.map(value => ({
      type: 'history',
      value,
      query: typeof value === 'string' ? value : value.query
    }));
  }, [historyStorage]);
  const fetchList = useCallback(async query => {
    if (!manuallyTypedInputValue) {
      return fetchListFromSearchHistory();
    }
    return onFetch(query);
  }, [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  const handleHistoryUpdate = useCallback(() => {
    setPageKey({
      ...window.location,
      timestamp: new Date().getTime()
    });
  }, []);
  const handleSubmit = useCallback(value => {
    historyStorage.append(value);
    if (onSubmit) {
      onSubmit(value);
    }
  }, [historyStorage, onSubmit]);
  const log = useLogContext();
  const logAutocompleteKeyword = useCallback((item, index) => {
    const params = {
      type: item.type,
      index,
      id: item.query
    };
    if (isGlobal) {
      globalLog.logClickAutocompleteKeyword({
        id: item.query,
        index
      });
      return;
    }
    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: {
          ...params,
          type: item.value.type
        }
      });
    }
    if (item.type === 'category' || item.type === 'query') {
      log({
        key: `primary.right.search.autocomplete.${item.type}`,
        category: 'click',
        params
      });
    }
  }, [log, isGlobal]);
  const handleSubmitItem = useCallback((item, index) => {
    const value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) {
      onSubmitItem(item);
    }
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  const handleInputFocus = useCallback(e => {
    if (onInputFocus) {
      onInputFocus(e);
    }
    if (isGlobal) {
      globalLog.logClickSearchInput();
    } else {
      log({
        key: 'primary.right.search.input',
        category: 'click',
        params: {
          search_type: searchType
        }
      });
    }
  }, [onInputFocus, log, searchType, isGlobal]);
  return jsx(HistoryStorageProvider, {
    get: historyStorage.get,
    set: histories => {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: history => {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: history => {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: () => {
      historyStorage.removeAll();
      handleHistoryUpdate();
    },
    children: jsx(Search, {
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder ?? getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: item => item.query,
      renderListBox: props => jsx(ListBox, {
        ...props,
        isHistoryList: !!manuallyTypedInputValue
      }),
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue,
      ...props
    })
  });
}

const slideIn = keyframes`
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(0);
  }
`;
function SearchDrawer({
  className,
  onSubmit,
  onSubmitItem,
  ...searchProps
}) {
  const theme = useTheme();
  const {
    localeData
  } = useGNBData();
  const [open, setOpen] = useState(false);
  const drawerAnimation = {
    drawer: slideIn
  };
  const handleDrawerOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setOpen(false);
  }, []);
  const handleSubmit = useCallback(value => {
    setOpen(false);
    onSubmit?.(value);
  }, [onSubmit]);
  const handleSubmitItem = useCallback(item => {
    setOpen(false);
    onSubmitItem?.(item);
  }, [onSubmitItem]);
  return jsxs("div", {
    css: className,
    children: [jsx("button", {
      type: "button",
      css: [/*#__PURE__*/css(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
            color: ${theme.content.primary1.basic};
          `, FOCUS`
            color: ${theme.content.primary1.basic};
          `, process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      onClick: handleDrawerOpen,
      children: jsx(Icon$1, {
        name: "search",
        size: 24
      })
    }), jsx(Drawer, {
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(safeAreaInset('bottom', 'padding-bottom'), " ", MEDIA_QUERY.min('tablet', `
            min-width: ${pxToRem(256)};
            max-width: ${pxToRem(326)};
            padding: ${pxToRem(30)};
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: jsx(NavigationSearch, {
        ...searchProps,
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: () => jsx("button", {
          type: "button",
          onClick: handleDrawerClose,
          css: [/*#__PURE__*/css(RESET_BUTTON, " flex-shrink:0;margin-left:", pxToRem(15), ";padding:", pxToRem(9), " ", pxToRem(5), " ", pxToRem(10), ";color:", theme.content.base1, ";font-size:", pxToRem(15), ";line-height:1;font-weight:700;outline:none;", MEDIA_QUERY.min('tablet', `
                    display: none;
                  `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), FOCUS`
                  & > span {
                    box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
                  }
                `, process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
          children: jsx("span", {
            css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
            children: localeData?.search?.closeDrawer ?? '취소'
          })
        })
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$5 = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1a8gq24-UploadDropdownContentItem",
  styles: "position:relative;label:UploadDropdownContentItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};
function UploadDropdownContentItem({
  href,
  icon,
  title,
  subtitle,
  logId
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  return jsxs(LinkComponent, {
    role: "link",
    href: href,
    css: [/*#__PURE__*/css("display:flex;align-items:center;padding:", pxToRem(15), ";background-color:", theme.background.base, ";border-radius:", pxToRem(2), ";transition:.1s background-color;word-break:keep-all;white-space:nowrap;font-size:", pxToRem(15), ";line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
          background-color: ${theme.background.groupedBase};
        `, FOCUS`
          background-color: ${theme.background.groupedBase};
        `, process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    onClick: () => {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    },
    children: [jsx("div", {
      css: _ref$5,
      children: icon
    }), jsxs("div", {
      css: /*#__PURE__*/css("margin-left:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [jsx("div", {
        css: /*#__PURE__*/css("font-size:", pxToRem(15), ";font-weight:bold;line-height:", pxToRem(21), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: title
      }), jsx("div", {
        css: /*#__PURE__*/css("margin:", pxToRem(4), " 0 0;font-size:", pxToRem(12), ";line-height:", pxToRem(16), ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: subtitle
      })]
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_SIZE = 40;
var _ref$4 = process.env.NODE_ENV === "production" ? {
  name: "12whrtl",
  styles: "outline:none;overflow:hidden"
} : {
  name: "pun5pg-UploadDropdownContentButton",
  styles: "outline:none;overflow:hidden;label:UploadDropdownContentButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};
function UploadDropdownContentButton({
  uploadMenuLinks
}) {
  const theme = useTheme();
  const log = useLogContext();
  const {
    gap,
    iconSize
  } = getWithIconOptions(BUTTON_SIZE);
  return jsx(Popper$1, {
    usePortal: false,
    renderButton: ({
      onClick
    }) => jsxs(Button$4, {
      role: "button",
      variant: "primary1",
      size: BUTTON_SIZE,
      type: "button",
      css: [_ref$4, FOCUS`
              box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
            `, process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      onClick: () => {
        onClick();
        log({
          key: 'primary.right.upload',
          category: 'click'
        });
      },
      children: [jsx("span", {
        css: /*#__PURE__*/css("vertical-align:middle;white-space:nowrap;", MEDIA_QUERY.min('laptop', `
                margin-right: ${pxToRem(gap)};
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: "\uAE00\uC4F0\uAE30"
      }), jsx(Icon$1, {
        css: /*#__PURE__*/css("vertical-align:middle;display:none;", MEDIA_QUERY.min('laptop', `
                display: inline-block;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        name: "chevron_down",
        size: iconSize
      })]
    }),
    children: uploadMenuLinks && uploadMenuLinks.map(item => jsx(UploadDropdownContentItem, {
      ...item
    }, item.title))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$3 = process.env.NODE_ENV === "production" ? {
  name: "1dnrp50",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0"
} : {
  name: "1nd5n5m-UserDropdownContentItem",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0;label:UserDropdownContentItem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJEcm9wZG93bkNvbnRlbnRJdGVtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErRWtCIiwiZmlsZSI6IlVzZXJEcm9wZG93bkNvbnRlbnRJdGVtLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0RWxlbWVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7XG4gIEZPQ1VTLFxuICBIT1ZFUixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbXBvcnQgTmV3SWNvbiBmcm9tICcuLi9pYy1uZXctMTguc3ZnJztcbmltcG9ydCB7IHVzZUxpbmtDb250ZXh0IH0gZnJvbSAnLi4vbGluay1jb250ZXh0JztcbmltcG9ydCB7IHVzZUxvZ0NvbnRleHQgfSBmcm9tICcuLi9sb2ctY29udGV4dCc7XG5cbmltcG9ydCB7IFVzZXJNZW51U2NoZW1hRW50cnkgfSBmcm9tICcuLi90eXBlcyc7XG5cbmV4cG9ydCBmdW5jdGlvbiBVc2VyRHJvcGRvd25Db250ZW50SXRlbSh7XG4gIGJ1bGxldCxcbiAgdGl0bGUsXG4gIGhyZWYsXG4gIG9uQ2xpY2ssXG4gIGxvZ0lkLFxufTogVXNlck1lbnVTY2hlbWFFbnRyeSk6IFJlYWN0RWxlbWVudCB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCBDb21wb25lbnQgPSBocmVmID8gTGlua0NvbXBvbmVudCA6ICdidXR0b24nO1xuXG4gIHJldHVybiAoXG4gICAgPENvbXBvbmVudFxuICAgICAgey4uLihDb21wb25lbnQgPT09IExpbmtDb21wb25lbnQgPyB7IGhyZWYgfSA6IHsgdHlwZTogJ2J1dHRvbicgfSl9XG4gICAgICBjc3M9e1tcbiAgICAgICAgY3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgcGFkZGluZzogJHtweFRvUmVtKDEwKX0gJHtweFRvUmVtKDE0KX0gJHtweFRvUmVtKDExKX07XG4gICAgICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgICAgICBib3JkZXI6IG5vbmU7XG4gICAgICAgICAgYmFja2dyb3VuZDogJHt0aGVtZS5iYWNrZ3JvdW5kLmJhc2V9O1xuICAgICAgICAgIGNvbG9yOiAke3RoZW1lLmNvbnRlbnQuYmFzZTF9O1xuICAgICAgICAgIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICAgICAgICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gICAgICAgICAgZm9udC1zaXplOiAke3B4VG9SZW0oMTUpfTtcbiAgICAgICAgICBsaW5lLWhlaWdodDogJHtweFRvUmVtKDIxKX07XG4gICAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgICAgICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICAgIGJvcmRlci1yYWRpdXM6ICR7cHhUb1JlbSgyKX07XG4gICAgICAgICAgb3V0bGluZTogbm9uZTtcbiAgICAgICAgYCxcbiAgICAgICAgSE9WRVJgXG4gICAgICAgICAgYmFja2dyb3VuZDogJHt0aGVtZS5iYWNrZ3JvdW5kLmdyb3VwZWRCYXNlfTtcbiAgICAgICAgYCxcbiAgICAgICAgRk9DVVNgXG4gICAgICAgICAgYmFja2dyb3VuZDogJHt0aGVtZS5iYWNrZ3JvdW5kLmdyb3VwZWRCYXNlfTtcbiAgICAgICAgYCxcbiAgICAgIF19XG4gICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgIGlmIChsb2dJZCkge1xuICAgICAgICAgIGxvZyh7XG4gICAgICAgICAgICBrZXk6ICdwcmltYXJ5LnJpZ2h0LnVzZXIuZHJvcGRvd24nLFxuICAgICAgICAgICAgY2F0ZWdvcnk6ICdjbGljaycsXG4gICAgICAgICAgICBwYXJhbXM6IHtcbiAgICAgICAgICAgICAgaWQ6IGxvZ0lkLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICB9KTtcbiAgICAgICAgfVxuXG4gICAgICAgIGlmIChvbkNsaWNrKSB7XG4gICAgICAgICAgb25DbGljaygpO1xuICAgICAgICB9XG4gICAgICB9fVxuICAgID5cbiAgICAgIHsgdGl0bGUgfVxuICAgICAgeyBidWxsZXQgPT09ICduZXcnICYmIChcbiAgICAgICAgPE5ld0ljb25cbiAgICAgICAgICBkYXRhLXRlc3RpZD1cIm5ldy1pY29uXCJcbiAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgICAgICAgICBtYXJnaW46IDAgMS41cHggMS41cHggMDtcbiAgICAgICAgICBgfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgPC9Db21wb25lbnQ+XG4gICk7XG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
function UserDropdownContentItem({
  bullet,
  title,
  href,
  onClick,
  logId
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const Component = href ? LinkComponent : 'button';
  return jsxs(Component, {
    ...(Component === LinkComponent ? {
      href
    } : {
      type: 'button'
    }),
    css: [/*#__PURE__*/css("display:block;position:relative;width:100%;margin:0;padding:", pxToRem(10), " ", pxToRem(14), " ", pxToRem(11), ";box-sizing:border-box;border:none;background:", theme.background.base, ";color:", theme.content.base1, ";font-family:inherit;font-weight:normal;font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";text-decoration:none;text-align:left;cursor:pointer;border-radius:", pxToRem(2), ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), HOVER$1`
          background: ${theme.background.groupedBase};
        `, FOCUS`
          background: ${theme.background.groupedBase};
        `, process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    onClick: () => {
      if (logId) {
        log({
          key: 'primary.right.user.dropdown',
          category: 'click',
          params: {
            id: logId
          }
        });
      }
      if (onClick) {
        onClick();
      }
    },
    children: [title, bullet === 'new' && jsx(NewIcon, {
      "data-testid": "new-icon",
      css: _ref$3
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_PROFILE_URL = 'https://image.ohou.se/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "xnm8en",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover"
} : {
  name: "1hoed2d-UserDropdownContentButton",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover;label:UserDropdownContentButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtGb0IiLCJmaWxlIjoiVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VNZW1vIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IFJlc2l6ZUltYWdlIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL3VpJztcblxuaW1wb3J0IHtcbiAgRk9DVVMsXG4gIEhPVkVSLFxuICBSRVNFVF9CVVRUT04sXG4gIHB4VG9SZW0sXG59IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IFBvcHBlciB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmltcG9ydCB7XG4gIFVzZXJEcm9wZG93bkNvbnRlbnRJdGVtLFxufSBmcm9tICcuL1VzZXJEcm9wZG93bkNvbnRlbnRJdGVtJztcblxuaW1wb3J0IHsgVXNlck1lbnVTY2hlbWFFbnRyeSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IERFRkFVTFRfUFJPRklMRV9VUkwgPSAnaHR0cHM6Ly9pbWFnZS5vaG91LnNlL2kvYnVja2V0cGxhY2UtdjItZGV2ZWxvcG1lbnQvdXBsb2Fkcy91c2Vycy9wcm9maWxlX2ltYWdlczE1NDI5ODczMDdfTGtjbUkuanBlZyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvblByb3BzIHtcbiAgcHJvZmlsZVVybD86IHN0cmluZztcbiAgdXNlck1lbnU6IFVzZXJNZW51U2NoZW1hRW50cnlbXTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b24oe1xuICBwcm9maWxlVXJsLFxuICB1c2VyTWVudSxcbn06IFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b25Qcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCBpdGVtcyA9IHVzZU1lbW8oXG4gICAgKCkgPT4gdXNlck1lbnUuZmlsdGVyKChtZW51KSA9PiBtZW51LnNob3dPbj8uaW5jbHVkZXMoJ2JhcicpKSxcbiAgICBbdXNlck1lbnVdLFxuICApO1xuXG4gIHJldHVybiAoXG4gICAgPFBvcHBlclxuICAgICAgdXNlUG9ydGFsPXtmYWxzZX1cbiAgICAgIHJlbmRlckJ1dHRvbj17KHsgb25DbGljayB9KSA9PiAoXG4gICAgICAgIDxidXR0b25cbiAgICAgICAgICBjc3M9e1tcbiAgICAgICAgICAgIGNzc2BcbiAgICAgICAgICAgICAgJHtSRVNFVF9CVVRUT059XG4gICAgICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgICAgICAgICAgd2lkdGg6ICR7cHhUb1JlbSg0MCl9O1xuICAgICAgICAgICAgICBoZWlnaHQ6ICR7cHhUb1JlbSg0MCl9O1xuICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgICAgICAgICAgICBvdXRsaW5lOiBub25lO1xuICAgICAgICAgICAgICAmOmFmdGVyIHtcbiAgICAgICAgICAgICAgICBjb250ZW50OiAnJztcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgICAgICAgbGVmdDogMDtcbiAgICAgICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogMTAwJTtcbiAgICAgICAgICAgICAgICBib3JkZXI6ICR7cHhUb1JlbSgyKX0gc29saWQgJHt0aGVtZS5jb250ZW50LnByaW1hcnkxLmJhc2ljfTtcbiAgICAgICAgICAgICAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICBgLFxuICAgICAgICAgICAgSE9WRVJgXG4gICAgICAgICAgICAgICY6YWZ0ZXIge1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICBgLFxuICAgICAgICAgICAgRk9DVVNgXG4gICAgICAgICAgICAgICY6YWZ0ZXIge1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICBgLFxuICAgICAgICAgIF19XG4gICAgICAgICAgdHlwZT1cImJ1dHRvblwiXG4gICAgICAgICAgb25DbGljaz17b25DbGlja31cbiAgICAgICAgICBhcmlhLWxhYmVsPVwi7ZSE66Gc7ZWEIOuplOuJtFwiXG4gICAgICAgID5cbiAgICAgICAgICA8UmVzaXplSW1hZ2VcbiAgICAgICAgICAgIHdpZHRoPXs0MH1cbiAgICAgICAgICAgIGFzcGVjdD17MX1cbiAgICAgICAgICAgIHNyYz17cHJvZmlsZVVybCB8fCBERUZBVUxUX1BST0ZJTEVfVVJMfVxuICAgICAgICAgICAgYWx0PVwi7ZSE66Gc7ZWEIOyCrOynhFwiXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICAgICAgb2JqZWN0LWZpdDogY292ZXI7XG4gICAgICAgICAgICBgfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvYnV0dG9uPlxuICAgICAgKX1cbiAgICA+XG4gICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIHdpZHRoOiAke3B4VG9SZW0oMTg0KX07XG4gICAgICAgIGB9XG4gICAgICA+XG4gICAgICAgIHsgaXRlbXMubWFwKChpdGVtLCBpbmRleCkgPT4gKFxuICAgICAgICAgIDxVc2VyRHJvcGRvd25Db250ZW50SXRlbVxuICAgICAgICAgICAga2V5PXtpbmRleH1cbiAgICAgICAgICAgIHsuLi5pdGVtfVxuICAgICAgICAgIC8+XG4gICAgICAgICkpIH1cbiAgICAgIDwvZGl2PlxuICAgIDwvUG9wcGVyPlxuICApO1xufVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
function UserDropdownContentButton({
  profileUrl,
  userMenu
}) {
  const theme = useTheme();
  const items = useMemo(() => userMenu.filter(menu => menu.showOn?.includes('bar')), [userMenu]);
  return jsx(Popper$1, {
    usePortal: false,
    renderButton: ({
      onClick
    }) => jsx("button", {
      css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;overflow:hidden;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:100%;outline:none;&:after{content:'';display:none;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:100%;border:", pxToRem(2), " solid ", theme.content.primary1.basic, ";box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlDZSIsImZpbGUiOiJVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgUmVzaXplSW1hZ2UgfSBmcm9tICdAYnVja2V0cGxhY2UvdWknO1xuXG5pbXBvcnQge1xuICBGT0NVUyxcbiAgSE9WRVIsXG4gIFJFU0VUX0JVVFRPTixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgUG9wcGVyIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHtcbiAgVXNlckRyb3Bkb3duQ29udGVudEl0ZW0sXG59IGZyb20gJy4vVXNlckRyb3Bkb3duQ29udGVudEl0ZW0nO1xuXG5pbXBvcnQgeyBVc2VyTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgREVGQVVMVF9QUk9GSUxFX1VSTCA9ICdodHRwczovL2ltYWdlLm9ob3Uuc2UvaS9idWNrZXRwbGFjZS12Mi1kZXZlbG9wbWVudC91cGxvYWRzL3VzZXJzL3Byb2ZpbGVfaW1hZ2VzMTU0Mjk4NzMwN19Ma2NtSS5qcGVnJztcblxuZXhwb3J0IGludGVyZmFjZSBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uUHJvcHMge1xuICBwcm9maWxlVXJsPzogc3RyaW5nO1xuICB1c2VyTWVudTogVXNlck1lbnVTY2hlbWFFbnRyeVtdO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbih7XG4gIHByb2ZpbGVVcmwsXG4gIHVzZXJNZW51LFxufTogVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvblByb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IGl0ZW1zID0gdXNlTWVtbyhcbiAgICAoKSA9PiB1c2VyTWVudS5maWx0ZXIoKG1lbnUpID0+IG1lbnUuc2hvd09uPy5pbmNsdWRlcygnYmFyJykpLFxuICAgIFt1c2VyTWVudV0sXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8UG9wcGVyXG4gICAgICB1c2VQb3J0YWw9e2ZhbHNlfVxuICAgICAgcmVuZGVyQnV0dG9uPXsoeyBvbkNsaWNrIH0pID0+IChcbiAgICAgICAgPGJ1dHRvblxuICAgICAgICAgIGNzcz17W1xuICAgICAgICAgICAgY3NzYFxuICAgICAgICAgICAgICAke1JFU0VUX0JVVFRPTn1cbiAgICAgICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICAgICAgICB3aWR0aDogJHtweFRvUmVtKDQwKX07XG4gICAgICAgICAgICAgIGhlaWdodDogJHtweFRvUmVtKDQwKX07XG4gICAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDEwMCU7XG4gICAgICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgICAgICAgICY6YWZ0ZXIge1xuICAgICAgICAgICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICAgIHRvcDogMDtcbiAgICAgICAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgICAgICAgICAgICAgIGJvcmRlcjogJHtweFRvUmVtKDIpfSBzb2xpZCAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgICBIT1ZFUmBcbiAgICAgICAgICAgICAgJjphZnRlciB7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgICBGT0NVU2BcbiAgICAgICAgICAgICAgJjphZnRlciB7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgXX1cbiAgICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgICAgIGFyaWEtbGFiZWw9XCLtlITroZztlYQg66mU64m0XCJcbiAgICAgICAgPlxuICAgICAgICAgIDxSZXNpemVJbWFnZVxuICAgICAgICAgICAgd2lkdGg9ezQwfVxuICAgICAgICAgICAgYXNwZWN0PXsxfVxuICAgICAgICAgICAgc3JjPXtwcm9maWxlVXJsIHx8IERFRkFVTFRfUFJPRklMRV9VUkx9XG4gICAgICAgICAgICBhbHQ9XCLtlITroZztlYQg7IKs7KeEXCJcbiAgICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICAgICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9idXR0b24+XG4gICAgICApfVxuICAgID5cbiAgICAgIDxkaXYgY3NzPXtjc3NgXG4gICAgICAgICAgd2lkdGg6ICR7cHhUb1JlbSgxODQpfTtcbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBpdGVtcy5tYXAoKGl0ZW0sIGluZGV4KSA9PiAoXG4gICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRJdGVtXG4gICAgICAgICAgICBrZXk9e2luZGV4fVxuICAgICAgICAgICAgey4uLml0ZW19XG4gICAgICAgICAgLz5cbiAgICAgICAgKSkgfVxuICAgICAgPC9kaXY+XG4gICAgPC9Qb3BwZXI+XG4gICk7XG59XG4iXX0= */"), HOVER$1`
              &:after {
                display: block;
              }
            `, FOCUS`
              &:after {
                display: block;
              }
            `, process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdDVSIsImZpbGUiOiJVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgUmVzaXplSW1hZ2UgfSBmcm9tICdAYnVja2V0cGxhY2UvdWknO1xuXG5pbXBvcnQge1xuICBGT0NVUyxcbiAgSE9WRVIsXG4gIFJFU0VUX0JVVFRPTixcbiAgcHhUb1JlbSxcbn0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgUG9wcGVyIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0vYmRzJztcblxuaW1wb3J0IHtcbiAgVXNlckRyb3Bkb3duQ29udGVudEl0ZW0sXG59IGZyb20gJy4vVXNlckRyb3Bkb3duQ29udGVudEl0ZW0nO1xuXG5pbXBvcnQgeyBVc2VyTWVudVNjaGVtYUVudHJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgREVGQVVMVF9QUk9GSUxFX1VSTCA9ICdodHRwczovL2ltYWdlLm9ob3Uuc2UvaS9idWNrZXRwbGFjZS12Mi1kZXZlbG9wbWVudC91cGxvYWRzL3VzZXJzL3Byb2ZpbGVfaW1hZ2VzMTU0Mjk4NzMwN19Ma2NtSS5qcGVnJztcblxuZXhwb3J0IGludGVyZmFjZSBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uUHJvcHMge1xuICBwcm9maWxlVXJsPzogc3RyaW5nO1xuICB1c2VyTWVudTogVXNlck1lbnVTY2hlbWFFbnRyeVtdO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbih7XG4gIHByb2ZpbGVVcmwsXG4gIHVzZXJNZW51LFxufTogVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvblByb3BzKTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IGl0ZW1zID0gdXNlTWVtbyhcbiAgICAoKSA9PiB1c2VyTWVudS5maWx0ZXIoKG1lbnUpID0+IG1lbnUuc2hvd09uPy5pbmNsdWRlcygnYmFyJykpLFxuICAgIFt1c2VyTWVudV0sXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8UG9wcGVyXG4gICAgICB1c2VQb3J0YWw9e2ZhbHNlfVxuICAgICAgcmVuZGVyQnV0dG9uPXsoeyBvbkNsaWNrIH0pID0+IChcbiAgICAgICAgPGJ1dHRvblxuICAgICAgICAgIGNzcz17W1xuICAgICAgICAgICAgY3NzYFxuICAgICAgICAgICAgICAke1JFU0VUX0JVVFRPTn1cbiAgICAgICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICAgICAgICB3aWR0aDogJHtweFRvUmVtKDQwKX07XG4gICAgICAgICAgICAgIGhlaWdodDogJHtweFRvUmVtKDQwKX07XG4gICAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDEwMCU7XG4gICAgICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgICAgICAgICY6YWZ0ZXIge1xuICAgICAgICAgICAgICAgIGNvbnRlbnQ6ICcnO1xuICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICAgICAgICAgIHRvcDogMDtcbiAgICAgICAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgICAgICAgICAgICAgIGJvcmRlcjogJHtweFRvUmVtKDIpfSBzb2xpZCAke3RoZW1lLmNvbnRlbnQucHJpbWFyeTEuYmFzaWN9O1xuICAgICAgICAgICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgICBIT1ZFUmBcbiAgICAgICAgICAgICAgJjphZnRlciB7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgICBGT0NVU2BcbiAgICAgICAgICAgICAgJjphZnRlciB7XG4gICAgICAgICAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIGAsXG4gICAgICAgICAgXX1cbiAgICAgICAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICAgICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgICAgIGFyaWEtbGFiZWw9XCLtlITroZztlYQg66mU64m0XCJcbiAgICAgICAgPlxuICAgICAgICAgIDxSZXNpemVJbWFnZVxuICAgICAgICAgICAgd2lkdGg9ezQwfVxuICAgICAgICAgICAgYXNwZWN0PXsxfVxuICAgICAgICAgICAgc3JjPXtwcm9maWxlVXJsIHx8IERFRkFVTFRfUFJPRklMRV9VUkx9XG4gICAgICAgICAgICBhbHQ9XCLtlITroZztlYQg7IKs7KeEXCJcbiAgICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICAgICAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9idXR0b24+XG4gICAgICApfVxuICAgID5cbiAgICAgIDxkaXYgY3NzPXtjc3NgXG4gICAgICAgICAgd2lkdGg6ICR7cHhUb1JlbSgxODQpfTtcbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBpdGVtcy5tYXAoKGl0ZW0sIGluZGV4KSA9PiAoXG4gICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRJdGVtXG4gICAgICAgICAgICBrZXk9e2luZGV4fVxuICAgICAgICAgICAgey4uLml0ZW19XG4gICAgICAgICAgLz5cbiAgICAgICAgKSkgfVxuICAgICAgPC9kaXY+XG4gICAgPC9Qb3BwZXI+XG4gICk7XG59XG4iXX0= */"],
      type: "button",
      onClick: onClick,
      "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274",
      children: jsx(ResizeImage$1, {
        width: 40,
        aspect: 1,
        src: profileUrl || DEFAULT_PROFILE_URL,
        alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
        css: _ref$2
      })
    }),
    children: jsx("div", {
      css: /*#__PURE__*/css("width:", pxToRem(184), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentButton;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: items.map((item, index) => jsx(UserDropdownContentItem, {
        ...item
      }, index))
    })
  });
}

function NoLoginMenuItem({
  component = 'a',
  label,
  href,
  logKey,
  ...rest
}) {
  const theme = useTheme();
  const Component = component;
  const log = useLogContext();
  return jsx(Component, {
    ...rest,
    href: href,
    css: /*#__PURE__*/css(FONT_STYLE.subTitle2, ";color:", theme.content.base1, ";padding:0 10px;border-left:1px solid ", theme.content.base4, ";&:first-of-type{border-left:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NoLoginMenuItem;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5vTG9naW5NZW51SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJjIiwiZmlsZSI6Ik5vTG9naW5NZW51SXRlbS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRQcm9wcywgRWxlbWVudFR5cGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MsIHVzZVRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBGT05UX1NUWUxFIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuXG5pbXBvcnQgeyBMb2dLZXkgfSBmcm9tICcuLi9uYXZpZ2F0aW9uTG9nJztcbmltcG9ydCB7IHVzZUxvZ0NvbnRleHQgfSBmcm9tICcuLi9sb2ctY29udGV4dCc7XG5cbmV4cG9ydCB0eXBlIE5vTG9naW5NZW51UHJvcHM8VCBleHRlbmRzIEVsZW1lbnRUeXBlID0gJ2EnPiA9IHtcbiAgY29tcG9uZW50PzogVCxcbiAgbGFiZWw6IHN0cmluZyxcbiAgaHJlZjogc3RyaW5nLFxuICBsb2dLZXk6IExvZ0tleSxcbn0gJiBDb21wb25lbnRQcm9wczxUPjtcblxuZXhwb3J0IGZ1bmN0aW9uIE5vTG9naW5NZW51SXRlbTxUIGV4dGVuZHMgRWxlbWVudFR5cGUgPSAnYSc+KHtcbiAgY29tcG9uZW50ID0gJ2EnLFxuICBsYWJlbCxcbiAgaHJlZixcbiAgbG9nS2V5LFxuICAuLi5yZXN0XG59OiBOb0xvZ2luTWVudVByb3BzPFQ+KTogSlNYLkVsZW1lbnQge1xuICBjb25zdCB0aGVtZSA9IHVzZVRoZW1lKCk7XG4gIGNvbnN0IENvbXBvbmVudCA9IGNvbXBvbmVudDtcbiAgY29uc3QgbG9nID0gdXNlTG9nQ29udGV4dCgpO1xuXG4gIHJldHVybiAoXG4gICAgPENvbXBvbmVudFxuICAgICAgey4uLnJlc3R9XG4gICAgICBocmVmPXtocmVmfVxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgICR7Rk9OVF9TVFlMRS5zdWJUaXRsZTJ9O1xuICAgICAgICBjb2xvcjogJHt0aGVtZS5jb250ZW50LmJhc2UxfTtcbiAgICAgICAgcGFkZGluZzogMCAxMHB4O1xuICAgICAgICBib3JkZXItbGVmdDogMXB4IHNvbGlkICR7dGhlbWUuY29udGVudC5iYXNlNH07XG4gICAgICAgICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgICAgICAgYm9yZGVyLWxlZnQ6IG5vbmU7XG4gICAgICAgIH1cbiAgICAgIGB9XG4gICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICBrZXk6IGxvZ0tleSxcbiAgICAgICAgY2F0ZWdvcnk6ICdjbGljaycsXG4gICAgICB9KX1cbiAgICA+XG4gICAgICB7IGxhYmVsIH1cbiAgICA8L0NvbXBvbmVudD5cbiAgKTtcbn1cbiJdfQ== */"),
    onClick: () => log({
      key: logKey,
      category: 'click'
    }),
    children: label
  });
}

const SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/memo(({
  userableType,
  ...rest
}) => {
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return jsx(OutlineAnchorButton, {
    css: /*#__PURE__*/css("display:none;margin-left:8px;", MEDIA_QUERY.min('laptop', `
          display: flex;
          align-items: center;
        `), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlbGxlckJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JjIiwiZmlsZSI6IlNlbGxlckJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBtZW1vIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBIdG1sQW5jaG9yUHJvcHMsIE1FRElBX1FVRVJZIH0gZnJvbSAnQGJ1Y2tldHBsYWNlL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHsgT3V0bGluZUFuY2hvckJ1dHRvbiB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtL2Jkcyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU2VsbGVyQnV0dG9uUHJvcHMgZXh0ZW5kcyBIdG1sQW5jaG9yUHJvcHMge1xuICB1c2VyYWJsZVR5cGU/OiBzdHJpbmc7XG59XG5cbmNvbnN0IFNFTExFUl9VU0VSQUJMRV9UWVBFID0gJ1NhbGVzVXNlcic7XG5cbmV4cG9ydCBkZWZhdWx0IG1lbW8oKHtcbiAgdXNlcmFibGVUeXBlLFxuICAuLi5yZXN0XG59OiBTZWxsZXJCdXR0b25Qcm9wcyk6IEpTWC5FbGVtZW50IHwgbnVsbCA9PiB7XG4gIGlmICh1c2VyYWJsZVR5cGUgIT09IFNFTExFUl9VU0VSQUJMRV9UWVBFKSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxPdXRsaW5lQW5jaG9yQnV0dG9uXG4gICAgICBjc3M9e2Nzc2BcbiAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDhweDtcbiAgICAgICAgJHtNRURJQV9RVUVSWS5taW4oJ2xhcHRvcCcsIGBcbiAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGApfVxuICAgICAgYH1cbiAgICAgIHZhcmlhbnQ9XCJiYXNlMVwiXG4gICAgICBzaXplPXs0MH1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIO2MkOunpOyekCDsoITsmqnshJzruYTsiqRcbiAgICA8L091dGxpbmVBbmNob3JCdXR0b24+XG4gICk7XG59KTtcbiJdfQ== */")),
    variant: "base1",
    size: 40,
    ...rest,
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  });
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "1kpxvh4",
  styles: "display:flex;margin:0 10px 0 8px"
} : {
  name: "jq04iw-PrimaryRight",
  styles: "display:flex;margin:0 10px 0 8px;label:PrimaryRight;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "10vibjk",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0"
} : {
  name: "1c3mnkg-PrimaryRight",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0;label:PrimaryRight;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
function PrimaryRight({
  searchProps,
  userProfile,
  userMenu,
  scrap,
  cart,
  notification,
  signin,
  signup,
  cs,
  seller,
  uploadMenuLinks,
  showChangeLanguageButton = false
}) {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const {
    userId,
    imageUrl
  } = userProfile || {};
  const loggedIn = userId != null;
  return jsxs("div", {
    css: _ref2$1,
    children: [searchProps && jsxs(Fragment$1, {
      children: [jsx(NavigationSearch, {
        css: /*#__PURE__*/css("flex:1 1 0px;min-width:0;margin-right:", pxToRem(9), ";", MEDIA_QUERY.min('desktop', `
                margin-right: ${pxToRem(14)};
              `), " ", MEDIA_QUERY.max('tablet', `
                display: none;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnlSaWdodC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkRvQiIsImZpbGUiOiJQcmltYXJ5UmlnaHQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb25Ob3RpZmljYXRpb24sIE5vdGlmaWNhdGlvblR5cGUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBDaGFuZ2VMYW5ndWFnZUJ1dHRvbiB9IGZyb20gJ0Bjb250ZW50L2NvbXBvbmVudHMnO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuaW1wb3J0IHsgU2VhcmNoRHJhd2VyIH0gZnJvbSAnLi9TZWFyY2hEcmF3ZXInO1xuaW1wb3J0IHsgTmF2aWdhdGlvblNlYXJjaCwgTmF2aWdhdGlvblNlYXJjaFByb3BzIH0gZnJvbSAnLi4vc2VhcmNoL1NlYXJjaCc7XG5pbXBvcnQge1xuICBVcGxvYWREcm9wZG93bkNvbnRlbnRCdXR0b24sXG59IGZyb20gJy4uL3VwbG9hZC1kcm9wZG93bi1jb250ZW50L1VwbG9hZERyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5pbXBvcnQge1xuICBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLFxufSBmcm9tICcuLi91c2VyLWRyb3Bkb3duLWNvbnRlbnQvVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5cbmltcG9ydCB7IE5vTG9naW5NZW51SXRlbSB9IGZyb20gJy4vTm9Mb2dpbk1lbnVJdGVtJztcbmltcG9ydCBTZWxsZXJCdXR0b24gZnJvbSAnLi9TZWxsZXJCdXR0b24nO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaW1hcnlSaWdodFByb3BzIGV4dGVuZHMgU3VwcGxlbWVudGFyeSB7XG4gIHNlYXJjaFByb3BzPzogTmF2aWdhdGlvblNlYXJjaFByb3BzO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gUHJpbWFyeVJpZ2h0KHtcbiAgc2VhcmNoUHJvcHMsXG4gIHVzZXJQcm9maWxlLFxuICB1c2VyTWVudSxcbiAgc2NyYXAsXG4gIGNhcnQsXG4gIG5vdGlmaWNhdGlvbixcbiAgc2lnbmluLFxuICBzaWdudXAsXG4gIGNzLFxuICBzZWxsZXIsXG4gIHVwbG9hZE1lbnVMaW5rcyxcbiAgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uID0gZmFsc2UsXG59OiBQcmltYXJ5UmlnaHRQcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCB7IHVzZXJJZCwgaW1hZ2VVcmwgfSA9IHVzZXJQcm9maWxlIHx8IHt9O1xuICBjb25zdCBsb2dnZWRJbiA9IHVzZXJJZCAhPSBudWxsO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgYH1cbiAgICA+XG4gICAgICB7IHNlYXJjaFByb3BzICYmIChcbiAgICAgICAgPD5cbiAgICAgICAgICA8TmF2aWdhdGlvblNlYXJjaFxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIGZsZXg6IDEgMSAwcHg7XG4gICAgICAgICAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oOSl9O1xuICAgICAgICAgICAgICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGBcbiAgICAgICAgICAgICAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgxNCl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ3RhYmxldCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8U2VhcmNoRHJhd2VyXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5taW4oJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC8+XG4gICAgICApIH1cbiAgICAgIHsgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uICYmIDxDaGFuZ2VMYW5ndWFnZUJ1dHRvbiAvPiB9XG4gICAgICB7IHNjcmFwICYmIChcbiAgICAgICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIDxJY29uTm90aWZpY2F0aW9uXG4gICAgICAgICAgICBpY29uTmFtZT1cInNjcmFwX291dGxpbmVcIlxuICAgICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5Ob25lfVxuICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgYXJpYS1sYWJlbD1cIuyKpO2BrOueqeu2gSDtjpjsnbTsp4Ag66eB7YGsIOuyhO2KvFwiXG4gICAgICAgICAgICBocmVmPXtzY3JhcC5ocmVmfVxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5zY3JhcCcsXG4gICAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgICApIH1cbiAgICAgIHsgbm90aWZpY2F0aW9uICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGBcbiAgICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICAgIGApfVxuICAgICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgICAgaWNvbk5hbWU9XCJub3RpZmljYXRpb25fb3V0bGluZVwiXG4gICAgICAgICAgICB0eXBlPXtOb3RpZmljYXRpb25UeXBlLk51bWJlcn1cbiAgICAgICAgICAgIGNvdW50PXtub3RpZmljYXRpb24uY291bnR9XG4gICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICBocmVmPXtub3RpZmljYXRpb24uaHJlZn1cbiAgICAgICAgICAgIGFyaWEtbGFiZWw9XCLrgrTshozsi50g7Y6Y7J207KeAIOunge2BrCDrsoTtirxcIlxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5ub3RpZmljYXRpb24nLFxuICAgICAgICAgICAgICBjYXRlZ29yeTogJ2NsaWNrJyxcbiAgICAgICAgICAgIH0pfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKSB9XG4gICAgICB7IGNhcnQgJiYgKFxuICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgIGljb25OYW1lPVwiY2FydFwiXG4gICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5OdW1iZXJ9XG4gICAgICAgICAgY291bnQ9e2NhcnQuY291bnR9XG4gICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgIGhyZWY9e2NhcnQuaHJlZn1cbiAgICAgICAgICBhcmlhLWxhYmVsPVwi7J6l67CU6rWs64uIIO2OmOydtOyngCDrp4Htgawg67KE7Yq8XCJcbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5jYXJ0JyxcbiAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgIH0pfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICA8ZGl2XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBsb2dnZWRJbiAmJiAoXG4gICAgICAgICAgPGRpdlxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMTIpfSAwICR7cHhUb1JlbSg1KX07XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBgXG4gICAgICAgICAgICAgICAgbWFyZ2luOiAwICR7cHhUb1JlbSgxNil9IDAgJHtweFRvUmVtKDkpfTtcbiAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdkZXNrdG9wJywgYFxuICAgICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMjApfSAwICR7cHhUb1JlbSgxMyl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b25cbiAgICAgICAgICAgICAgcHJvZmlsZVVybD17aW1hZ2VVcmx9XG4gICAgICAgICAgICAgIHVzZXJNZW51PXt1c2VyTWVudX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICkgfVxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgbWFyZ2luOiAwIDEwcHggMCA4cHg7XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICB7IHNpZ25pbiAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWduaW4udGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQubG9naW5cIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWdudXAudGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQuc2lnbnVwXCJcbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgICAgeyBjcyAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtjcy50aXRsZX1cbiAgICAgICAgICAgICAgaHJlZj17Y3MuaHJlZn1cbiAgICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgICBsb2dLZXk9XCJwcmltYXJ5LnJpZ2h0LmNzXCJcbiAgICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICkgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgeyB1cGxvYWRNZW51TGlua3MgJiYgdXBsb2FkTWVudUxpbmtzLmxlbmd0aCA+IDAgJiZcbiAgICAgICAgICA8VXBsb2FkRHJvcGRvd25Db250ZW50QnV0dG9uIHVwbG9hZE1lbnVMaW5rcz17dXBsb2FkTWVudUxpbmtzfSAvPiB9XG4gICAgICAgIHsgc2VsbGVyICYmIDxTZWxsZXJCdXR0b24gaHJlZj17c2VsbGVyLmhyZWZ9IC8+IH1cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */"),
        ...searchProps
      }), jsx(SearchDrawer, {
        css: /*#__PURE__*/css(MEDIA_QUERY.min('laptop', `
                display: none;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnlSaWdodC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUVvQiIsImZpbGUiOiJQcmltYXJ5UmlnaHQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb25Ob3RpZmljYXRpb24sIE5vdGlmaWNhdGlvblR5cGUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBDaGFuZ2VMYW5ndWFnZUJ1dHRvbiB9IGZyb20gJ0Bjb250ZW50L2NvbXBvbmVudHMnO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuaW1wb3J0IHsgU2VhcmNoRHJhd2VyIH0gZnJvbSAnLi9TZWFyY2hEcmF3ZXInO1xuaW1wb3J0IHsgTmF2aWdhdGlvblNlYXJjaCwgTmF2aWdhdGlvblNlYXJjaFByb3BzIH0gZnJvbSAnLi4vc2VhcmNoL1NlYXJjaCc7XG5pbXBvcnQge1xuICBVcGxvYWREcm9wZG93bkNvbnRlbnRCdXR0b24sXG59IGZyb20gJy4uL3VwbG9hZC1kcm9wZG93bi1jb250ZW50L1VwbG9hZERyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5pbXBvcnQge1xuICBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLFxufSBmcm9tICcuLi91c2VyLWRyb3Bkb3duLWNvbnRlbnQvVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5cbmltcG9ydCB7IE5vTG9naW5NZW51SXRlbSB9IGZyb20gJy4vTm9Mb2dpbk1lbnVJdGVtJztcbmltcG9ydCBTZWxsZXJCdXR0b24gZnJvbSAnLi9TZWxsZXJCdXR0b24nO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaW1hcnlSaWdodFByb3BzIGV4dGVuZHMgU3VwcGxlbWVudGFyeSB7XG4gIHNlYXJjaFByb3BzPzogTmF2aWdhdGlvblNlYXJjaFByb3BzO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gUHJpbWFyeVJpZ2h0KHtcbiAgc2VhcmNoUHJvcHMsXG4gIHVzZXJQcm9maWxlLFxuICB1c2VyTWVudSxcbiAgc2NyYXAsXG4gIGNhcnQsXG4gIG5vdGlmaWNhdGlvbixcbiAgc2lnbmluLFxuICBzaWdudXAsXG4gIGNzLFxuICBzZWxsZXIsXG4gIHVwbG9hZE1lbnVMaW5rcyxcbiAgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uID0gZmFsc2UsXG59OiBQcmltYXJ5UmlnaHRQcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCB7IHVzZXJJZCwgaW1hZ2VVcmwgfSA9IHVzZXJQcm9maWxlIHx8IHt9O1xuICBjb25zdCBsb2dnZWRJbiA9IHVzZXJJZCAhPSBudWxsO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgYH1cbiAgICA+XG4gICAgICB7IHNlYXJjaFByb3BzICYmIChcbiAgICAgICAgPD5cbiAgICAgICAgICA8TmF2aWdhdGlvblNlYXJjaFxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIGZsZXg6IDEgMSAwcHg7XG4gICAgICAgICAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oOSl9O1xuICAgICAgICAgICAgICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGBcbiAgICAgICAgICAgICAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgxNCl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ3RhYmxldCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8U2VhcmNoRHJhd2VyXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5taW4oJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC8+XG4gICAgICApIH1cbiAgICAgIHsgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uICYmIDxDaGFuZ2VMYW5ndWFnZUJ1dHRvbiAvPiB9XG4gICAgICB7IHNjcmFwICYmIChcbiAgICAgICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIDxJY29uTm90aWZpY2F0aW9uXG4gICAgICAgICAgICBpY29uTmFtZT1cInNjcmFwX291dGxpbmVcIlxuICAgICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5Ob25lfVxuICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgYXJpYS1sYWJlbD1cIuyKpO2BrOueqeu2gSDtjpjsnbTsp4Ag66eB7YGsIOuyhO2KvFwiXG4gICAgICAgICAgICBocmVmPXtzY3JhcC5ocmVmfVxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5zY3JhcCcsXG4gICAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgICApIH1cbiAgICAgIHsgbm90aWZpY2F0aW9uICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGBcbiAgICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICAgIGApfVxuICAgICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgICAgaWNvbk5hbWU9XCJub3RpZmljYXRpb25fb3V0bGluZVwiXG4gICAgICAgICAgICB0eXBlPXtOb3RpZmljYXRpb25UeXBlLk51bWJlcn1cbiAgICAgICAgICAgIGNvdW50PXtub3RpZmljYXRpb24uY291bnR9XG4gICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICBocmVmPXtub3RpZmljYXRpb24uaHJlZn1cbiAgICAgICAgICAgIGFyaWEtbGFiZWw9XCLrgrTshozsi50g7Y6Y7J207KeAIOunge2BrCDrsoTtirxcIlxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5ub3RpZmljYXRpb24nLFxuICAgICAgICAgICAgICBjYXRlZ29yeTogJ2NsaWNrJyxcbiAgICAgICAgICAgIH0pfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKSB9XG4gICAgICB7IGNhcnQgJiYgKFxuICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgIGljb25OYW1lPVwiY2FydFwiXG4gICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5OdW1iZXJ9XG4gICAgICAgICAgY291bnQ9e2NhcnQuY291bnR9XG4gICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgIGhyZWY9e2NhcnQuaHJlZn1cbiAgICAgICAgICBhcmlhLWxhYmVsPVwi7J6l67CU6rWs64uIIO2OmOydtOyngCDrp4Htgawg67KE7Yq8XCJcbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5jYXJ0JyxcbiAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgIH0pfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICA8ZGl2XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBsb2dnZWRJbiAmJiAoXG4gICAgICAgICAgPGRpdlxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMTIpfSAwICR7cHhUb1JlbSg1KX07XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBgXG4gICAgICAgICAgICAgICAgbWFyZ2luOiAwICR7cHhUb1JlbSgxNil9IDAgJHtweFRvUmVtKDkpfTtcbiAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdkZXNrdG9wJywgYFxuICAgICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMjApfSAwICR7cHhUb1JlbSgxMyl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b25cbiAgICAgICAgICAgICAgcHJvZmlsZVVybD17aW1hZ2VVcmx9XG4gICAgICAgICAgICAgIHVzZXJNZW51PXt1c2VyTWVudX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICkgfVxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgbWFyZ2luOiAwIDEwcHggMCA4cHg7XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICB7IHNpZ25pbiAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWduaW4udGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQubG9naW5cIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWdudXAudGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQuc2lnbnVwXCJcbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgICAgeyBjcyAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtjcy50aXRsZX1cbiAgICAgICAgICAgICAgaHJlZj17Y3MuaHJlZn1cbiAgICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgICBsb2dLZXk9XCJwcmltYXJ5LnJpZ2h0LmNzXCJcbiAgICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICkgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgeyB1cGxvYWRNZW51TGlua3MgJiYgdXBsb2FkTWVudUxpbmtzLmxlbmd0aCA+IDAgJiZcbiAgICAgICAgICA8VXBsb2FkRHJvcGRvd25Db250ZW50QnV0dG9uIHVwbG9hZE1lbnVMaW5rcz17dXBsb2FkTWVudUxpbmtzfSAvPiB9XG4gICAgICAgIHsgc2VsbGVyICYmIDxTZWxsZXJCdXR0b24gaHJlZj17c2VsbGVyLmhyZWZ9IC8+IH1cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */"),
        ...searchProps
      })]
    }), showChangeLanguageButton && jsx(ChangeLanguageButton, {}), scrap && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', `
            display: none;
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnlSaWdodC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0ZxQiIsImZpbGUiOiJQcmltYXJ5UmlnaHQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb25Ob3RpZmljYXRpb24sIE5vdGlmaWNhdGlvblR5cGUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBDaGFuZ2VMYW5ndWFnZUJ1dHRvbiB9IGZyb20gJ0Bjb250ZW50L2NvbXBvbmVudHMnO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuaW1wb3J0IHsgU2VhcmNoRHJhd2VyIH0gZnJvbSAnLi9TZWFyY2hEcmF3ZXInO1xuaW1wb3J0IHsgTmF2aWdhdGlvblNlYXJjaCwgTmF2aWdhdGlvblNlYXJjaFByb3BzIH0gZnJvbSAnLi4vc2VhcmNoL1NlYXJjaCc7XG5pbXBvcnQge1xuICBVcGxvYWREcm9wZG93bkNvbnRlbnRCdXR0b24sXG59IGZyb20gJy4uL3VwbG9hZC1kcm9wZG93bi1jb250ZW50L1VwbG9hZERyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5pbXBvcnQge1xuICBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLFxufSBmcm9tICcuLi91c2VyLWRyb3Bkb3duLWNvbnRlbnQvVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5cbmltcG9ydCB7IE5vTG9naW5NZW51SXRlbSB9IGZyb20gJy4vTm9Mb2dpbk1lbnVJdGVtJztcbmltcG9ydCBTZWxsZXJCdXR0b24gZnJvbSAnLi9TZWxsZXJCdXR0b24nO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaW1hcnlSaWdodFByb3BzIGV4dGVuZHMgU3VwcGxlbWVudGFyeSB7XG4gIHNlYXJjaFByb3BzPzogTmF2aWdhdGlvblNlYXJjaFByb3BzO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gUHJpbWFyeVJpZ2h0KHtcbiAgc2VhcmNoUHJvcHMsXG4gIHVzZXJQcm9maWxlLFxuICB1c2VyTWVudSxcbiAgc2NyYXAsXG4gIGNhcnQsXG4gIG5vdGlmaWNhdGlvbixcbiAgc2lnbmluLFxuICBzaWdudXAsXG4gIGNzLFxuICBzZWxsZXIsXG4gIHVwbG9hZE1lbnVMaW5rcyxcbiAgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uID0gZmFsc2UsXG59OiBQcmltYXJ5UmlnaHRQcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCB7IHVzZXJJZCwgaW1hZ2VVcmwgfSA9IHVzZXJQcm9maWxlIHx8IHt9O1xuICBjb25zdCBsb2dnZWRJbiA9IHVzZXJJZCAhPSBudWxsO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgYH1cbiAgICA+XG4gICAgICB7IHNlYXJjaFByb3BzICYmIChcbiAgICAgICAgPD5cbiAgICAgICAgICA8TmF2aWdhdGlvblNlYXJjaFxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIGZsZXg6IDEgMSAwcHg7XG4gICAgICAgICAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oOSl9O1xuICAgICAgICAgICAgICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGBcbiAgICAgICAgICAgICAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgxNCl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ3RhYmxldCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8U2VhcmNoRHJhd2VyXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5taW4oJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC8+XG4gICAgICApIH1cbiAgICAgIHsgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uICYmIDxDaGFuZ2VMYW5ndWFnZUJ1dHRvbiAvPiB9XG4gICAgICB7IHNjcmFwICYmIChcbiAgICAgICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIDxJY29uTm90aWZpY2F0aW9uXG4gICAgICAgICAgICBpY29uTmFtZT1cInNjcmFwX291dGxpbmVcIlxuICAgICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5Ob25lfVxuICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgYXJpYS1sYWJlbD1cIuyKpO2BrOueqeu2gSDtjpjsnbTsp4Ag66eB7YGsIOuyhO2KvFwiXG4gICAgICAgICAgICBocmVmPXtzY3JhcC5ocmVmfVxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5zY3JhcCcsXG4gICAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgICApIH1cbiAgICAgIHsgbm90aWZpY2F0aW9uICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGBcbiAgICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICAgIGApfVxuICAgICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgICAgaWNvbk5hbWU9XCJub3RpZmljYXRpb25fb3V0bGluZVwiXG4gICAgICAgICAgICB0eXBlPXtOb3RpZmljYXRpb25UeXBlLk51bWJlcn1cbiAgICAgICAgICAgIGNvdW50PXtub3RpZmljYXRpb24uY291bnR9XG4gICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICBocmVmPXtub3RpZmljYXRpb24uaHJlZn1cbiAgICAgICAgICAgIGFyaWEtbGFiZWw9XCLrgrTshozsi50g7Y6Y7J207KeAIOunge2BrCDrsoTtirxcIlxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5ub3RpZmljYXRpb24nLFxuICAgICAgICAgICAgICBjYXRlZ29yeTogJ2NsaWNrJyxcbiAgICAgICAgICAgIH0pfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKSB9XG4gICAgICB7IGNhcnQgJiYgKFxuICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgIGljb25OYW1lPVwiY2FydFwiXG4gICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5OdW1iZXJ9XG4gICAgICAgICAgY291bnQ9e2NhcnQuY291bnR9XG4gICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgIGhyZWY9e2NhcnQuaHJlZn1cbiAgICAgICAgICBhcmlhLWxhYmVsPVwi7J6l67CU6rWs64uIIO2OmOydtOyngCDrp4Htgawg67KE7Yq8XCJcbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5jYXJ0JyxcbiAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgIH0pfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICA8ZGl2XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBsb2dnZWRJbiAmJiAoXG4gICAgICAgICAgPGRpdlxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMTIpfSAwICR7cHhUb1JlbSg1KX07XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBgXG4gICAgICAgICAgICAgICAgbWFyZ2luOiAwICR7cHhUb1JlbSgxNil9IDAgJHtweFRvUmVtKDkpfTtcbiAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdkZXNrdG9wJywgYFxuICAgICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMjApfSAwICR7cHhUb1JlbSgxMyl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b25cbiAgICAgICAgICAgICAgcHJvZmlsZVVybD17aW1hZ2VVcmx9XG4gICAgICAgICAgICAgIHVzZXJNZW51PXt1c2VyTWVudX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICkgfVxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgbWFyZ2luOiAwIDEwcHggMCA4cHg7XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICB7IHNpZ25pbiAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWduaW4udGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQubG9naW5cIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWdudXAudGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQuc2lnbnVwXCJcbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgICAgeyBjcyAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtjcy50aXRsZX1cbiAgICAgICAgICAgICAgaHJlZj17Y3MuaHJlZn1cbiAgICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgICBsb2dLZXk9XCJwcmltYXJ5LnJpZ2h0LmNzXCJcbiAgICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICkgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgeyB1cGxvYWRNZW51TGlua3MgJiYgdXBsb2FkTWVudUxpbmtzLmxlbmd0aCA+IDAgJiZcbiAgICAgICAgICA8VXBsb2FkRHJvcGRvd25Db250ZW50QnV0dG9uIHVwbG9hZE1lbnVMaW5rcz17dXBsb2FkTWVudUxpbmtzfSAvPiB9XG4gICAgICAgIHsgc2VsbGVyICYmIDxTZWxsZXJCdXR0b24gaHJlZj17c2VsbGVyLmhyZWZ9IC8+IH1cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */"),
      children: jsx(IconNotification, {
        iconName: "scrap_outline",
        type: NotificationType.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: () => log({
          key: 'primary.right.scrap',
          category: 'click'
        })
      })
    }), notification && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', `
              display: none;
            `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByaW1hcnlSaWdodC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUdrQiIsImZpbGUiOiJQcmltYXJ5UmlnaHQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBNRURJQV9RVUVSWSwgcHhUb1JlbSB9IGZyb20gJ0BidWNrZXRwbGFjZS9kZXNpZ24tc3lzdGVtJztcbmltcG9ydCB7IEljb25Ob3RpZmljYXRpb24sIE5vdGlmaWNhdGlvblR5cGUgfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbS9iZHMnO1xuXG5pbXBvcnQgeyBDaGFuZ2VMYW5ndWFnZUJ1dHRvbiB9IGZyb20gJ0Bjb250ZW50L2NvbXBvbmVudHMnO1xuXG5pbXBvcnQgeyB1c2VMaW5rQ29udGV4dCB9IGZyb20gJy4uL2xpbmstY29udGV4dCc7XG5pbXBvcnQgeyB1c2VMb2dDb250ZXh0IH0gZnJvbSAnLi4vbG9nLWNvbnRleHQnO1xuaW1wb3J0IHsgU2VhcmNoRHJhd2VyIH0gZnJvbSAnLi9TZWFyY2hEcmF3ZXInO1xuaW1wb3J0IHsgTmF2aWdhdGlvblNlYXJjaCwgTmF2aWdhdGlvblNlYXJjaFByb3BzIH0gZnJvbSAnLi4vc2VhcmNoL1NlYXJjaCc7XG5pbXBvcnQge1xuICBVcGxvYWREcm9wZG93bkNvbnRlbnRCdXR0b24sXG59IGZyb20gJy4uL3VwbG9hZC1kcm9wZG93bi1jb250ZW50L1VwbG9hZERyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5pbXBvcnQge1xuICBVc2VyRHJvcGRvd25Db250ZW50QnV0dG9uLFxufSBmcm9tICcuLi91c2VyLWRyb3Bkb3duLWNvbnRlbnQvVXNlckRyb3Bkb3duQ29udGVudEJ1dHRvbic7XG5cbmltcG9ydCB7IE5vTG9naW5NZW51SXRlbSB9IGZyb20gJy4vTm9Mb2dpbk1lbnVJdGVtJztcbmltcG9ydCBTZWxsZXJCdXR0b24gZnJvbSAnLi9TZWxsZXJCdXR0b24nO1xuXG5pbXBvcnQgeyBTdXBwbGVtZW50YXJ5IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFByaW1hcnlSaWdodFByb3BzIGV4dGVuZHMgU3VwcGxlbWVudGFyeSB7XG4gIHNlYXJjaFByb3BzPzogTmF2aWdhdGlvblNlYXJjaFByb3BzO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gUHJpbWFyeVJpZ2h0KHtcbiAgc2VhcmNoUHJvcHMsXG4gIHVzZXJQcm9maWxlLFxuICB1c2VyTWVudSxcbiAgc2NyYXAsXG4gIGNhcnQsXG4gIG5vdGlmaWNhdGlvbixcbiAgc2lnbmluLFxuICBzaWdudXAsXG4gIGNzLFxuICBzZWxsZXIsXG4gIHVwbG9hZE1lbnVMaW5rcyxcbiAgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uID0gZmFsc2UsXG59OiBQcmltYXJ5UmlnaHRQcm9wcyk6IEpTWC5FbGVtZW50IHtcbiAgY29uc3QgTGlua0NvbXBvbmVudCA9IHVzZUxpbmtDb250ZXh0KCk7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCB7IHVzZXJJZCwgaW1hZ2VVcmwgfSA9IHVzZXJQcm9maWxlIHx8IHt9O1xuICBjb25zdCBsb2dnZWRJbiA9IHVzZXJJZCAhPSBudWxsO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAwO1xuICAgICAgYH1cbiAgICA+XG4gICAgICB7IHNlYXJjaFByb3BzICYmIChcbiAgICAgICAgPD5cbiAgICAgICAgICA8TmF2aWdhdGlvblNlYXJjaFxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIGZsZXg6IDEgMSAwcHg7XG4gICAgICAgICAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiAke3B4VG9SZW0oOSl9O1xuICAgICAgICAgICAgICAke01FRElBX1FVRVJZLm1pbignZGVza3RvcCcsIGBcbiAgICAgICAgICAgICAgICBtYXJnaW4tcmlnaHQ6ICR7cHhUb1JlbSgxNCl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ3RhYmxldCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8U2VhcmNoRHJhd2VyXG4gICAgICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5taW4oJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgICB7Li4uc2VhcmNoUHJvcHN9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC8+XG4gICAgICApIH1cbiAgICAgIHsgc2hvd0NoYW5nZUxhbmd1YWdlQnV0dG9uICYmIDxDaGFuZ2VMYW5ndWFnZUJ1dHRvbiAvPiB9XG4gICAgICB7IHNjcmFwICYmIChcbiAgICAgICAgPGRpdiBjc3M9e2Nzc2BcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgICAgPlxuICAgICAgICAgIDxJY29uTm90aWZpY2F0aW9uXG4gICAgICAgICAgICBpY29uTmFtZT1cInNjcmFwX291dGxpbmVcIlxuICAgICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5Ob25lfVxuICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgYXJpYS1sYWJlbD1cIuyKpO2BrOueqeu2gSDtjpjsnbTsp4Ag66eB7YGsIOuyhO2KvFwiXG4gICAgICAgICAgICBocmVmPXtzY3JhcC5ocmVmfVxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5zY3JhcCcsXG4gICAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgICApIH1cbiAgICAgIHsgbm90aWZpY2F0aW9uICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ21vYmlsZScsIGBcbiAgICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICAgIGApfVxuICAgICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgICAgaWNvbk5hbWU9XCJub3RpZmljYXRpb25fb3V0bGluZVwiXG4gICAgICAgICAgICB0eXBlPXtOb3RpZmljYXRpb25UeXBlLk51bWJlcn1cbiAgICAgICAgICAgIGNvdW50PXtub3RpZmljYXRpb24uY291bnR9XG4gICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICBocmVmPXtub3RpZmljYXRpb24uaHJlZn1cbiAgICAgICAgICAgIGFyaWEtbGFiZWw9XCLrgrTshozsi50g7Y6Y7J207KeAIOunge2BrCDrsoTtirxcIlxuICAgICAgICAgICAgb25DbGljaz17KCkgPT4gbG9nKHtcbiAgICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5ub3RpZmljYXRpb24nLFxuICAgICAgICAgICAgICBjYXRlZ29yeTogJ2NsaWNrJyxcbiAgICAgICAgICAgIH0pfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKSB9XG4gICAgICB7IGNhcnQgJiYgKFxuICAgICAgICA8SWNvbk5vdGlmaWNhdGlvblxuICAgICAgICAgIGljb25OYW1lPVwiY2FydFwiXG4gICAgICAgICAgdHlwZT17Tm90aWZpY2F0aW9uVHlwZS5OdW1iZXJ9XG4gICAgICAgICAgY291bnQ9e2NhcnQuY291bnR9XG4gICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgIGhyZWY9e2NhcnQuaHJlZn1cbiAgICAgICAgICBhcmlhLWxhYmVsPVwi7J6l67CU6rWs64uIIO2OmOydtOyngCDrp4Htgawg67KE7Yq8XCJcbiAgICAgICAgICBvbkNsaWNrPXsoKSA9PiBsb2coe1xuICAgICAgICAgICAga2V5OiAncHJpbWFyeS5yaWdodC5jYXJ0JyxcbiAgICAgICAgICAgIGNhdGVnb3J5OiAnY2xpY2snLFxuICAgICAgICAgIH0pfVxuICAgICAgICAvPlxuICAgICAgKSB9XG4gICAgICA8ZGl2XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICAke01FRElBX1FVRVJZLm1heCgnbW9iaWxlJywgYFxuICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICBgKX1cbiAgICAgICAgYH1cbiAgICAgID5cbiAgICAgICAgeyBsb2dnZWRJbiAmJiAoXG4gICAgICAgICAgPGRpdlxuICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMTIpfSAwICR7cHhUb1JlbSg1KX07XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdsYXB0b3AnLCBgXG4gICAgICAgICAgICAgICAgbWFyZ2luOiAwICR7cHhUb1JlbSgxNil9IDAgJHtweFRvUmVtKDkpfTtcbiAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgICR7TUVESUFfUVVFUlkubWluKCdkZXNrdG9wJywgYFxuICAgICAgICAgICAgICAgIG1hcmdpbjogMCAke3B4VG9SZW0oMjApfSAwICR7cHhUb1JlbSgxMyl9O1xuICAgICAgICAgICAgICBgKX1cbiAgICAgICAgICAgIGB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPFVzZXJEcm9wZG93bkNvbnRlbnRCdXR0b25cbiAgICAgICAgICAgICAgcHJvZmlsZVVybD17aW1hZ2VVcmx9XG4gICAgICAgICAgICAgIHVzZXJNZW51PXt1c2VyTWVudX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICkgfVxuICAgICAgICA8ZGl2IGNzcz17Y3NzYFxuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgbWFyZ2luOiAwIDEwcHggMCA4cHg7XG4gICAgICAgIGB9XG4gICAgICAgID5cbiAgICAgICAgICB7IHNpZ25pbiAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWduaW4udGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ25pbi5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQubG9naW5cIlxuICAgICAgICAgICAgLz5cbiAgICAgICAgICApIH1cbiAgICAgICAgICB7IHNpZ251cCAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtzaWdudXAudGl0bGV9XG4gICAgICAgICAgICAgIGhyZWY9e3NpZ251cC5ocmVmfVxuICAgICAgICAgICAgICBjb21wb25lbnQ9e0xpbmtDb21wb25lbnR9XG4gICAgICAgICAgICAgIGxvZ0tleT1cInByaW1hcnkucmlnaHQuc2lnbnVwXCJcbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSB9XG4gICAgICAgICAgeyBjcyAmJiAoXG4gICAgICAgICAgICA8Tm9Mb2dpbk1lbnVJdGVtXG4gICAgICAgICAgICAgIGxhYmVsPXtjcy50aXRsZX1cbiAgICAgICAgICAgICAgaHJlZj17Y3MuaHJlZn1cbiAgICAgICAgICAgICAgY29tcG9uZW50PXtMaW5rQ29tcG9uZW50fVxuICAgICAgICAgICAgICBsb2dLZXk9XCJwcmltYXJ5LnJpZ2h0LmNzXCJcbiAgICAgICAgICAgICAgY3NzPXtjc3NgXG4gICAgICAgICAgICAgICAgJHtNRURJQV9RVUVSWS5tYXgoJ2xhcHRvcCcsIGBcbiAgICAgICAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICAgICAgICAgICAgYCl9XG4gICAgICAgICAgICAgIGB9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICkgfVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgeyB1cGxvYWRNZW51TGlua3MgJiYgdXBsb2FkTWVudUxpbmtzLmxlbmd0aCA+IDAgJiZcbiAgICAgICAgICA8VXBsb2FkRHJvcGRvd25Db250ZW50QnV0dG9uIHVwbG9hZE1lbnVMaW5rcz17dXBsb2FkTWVudUxpbmtzfSAvPiB9XG4gICAgICAgIHsgc2VsbGVyICYmIDxTZWxsZXJCdXR0b24gaHJlZj17c2VsbGVyLmhyZWZ9IC8+IH1cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufVxuIl19 */"),
      children: jsx(IconNotification, {
        iconName: "notification_outline",
        type: NotificationType.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: () => log({
          key: 'primary.right.notification',
          category: 'click'
        })
      })
    }), cart && jsx(IconNotification, {
      iconName: "cart",
      type: NotificationType.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: () => log({
        key: 'primary.right.cart',
        category: 'click'
      })
    }), jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;", MEDIA_QUERY.max('mobile', `
            display: none;
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: [loggedIn && jsx("div", {
        css: /*#__PURE__*/css("margin:0 ", pxToRem(12), " 0 ", pxToRem(5), ";", MEDIA_QUERY.min('laptop', `
                margin: 0 ${pxToRem(16)} 0 ${pxToRem(9)};
              `), " ", MEDIA_QUERY.min('desktop', `
                margin: 0 ${pxToRem(20)} 0 ${pxToRem(13)};
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: jsx(UserDropdownContentButton, {
          profileUrl: imageUrl,
          userMenu: userMenu
        })
      }), jsxs("div", {
        css: _ref$1,
        children: [signin && jsx(NoLoginMenuItem, {
          label: signin.title,
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && jsx(NoLoginMenuItem, {
          label: signup.title,
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && jsx(NoLoginMenuItem, {
          label: cs.title,
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/css(MEDIA_QUERY.max('laptop', `
                  display: none;
                `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
        })]
      }), uploadMenuLinks && uploadMenuLinks.length > 0 && jsx(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && jsx(SellerButton, {
        href: seller.href
      })]
    })]
  });
}

function useFocusedLatch(onChange) {
  const focusRef = useRef(null);
  const handleFocusIn = useCallback(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  const handleFocusOut = useCallback(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(() => onChange(false));
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function NavigationBar(props) {
  const log = useLogContext();
  const {
    logo,
    primaryLeftmost,
    menuSchema,
    fallbackMenuSchema,
    searchOptions,
    supplementary
  } = props;
  const [{
    isHovered,
    selectedIds
  }, setState] = useState({
    isHovered: false,
    selectedIds: null
  });
  const setHovered = useCallback(value => {
    setState(prevState => ({
      ...prevState,
      isHovered: value,
      selectedIds: !value ? null : prevState.selectedIds
    }));
  }, []);
  const [onMouseEnter, onMouseLeave] = useFocusedLatch(setHovered);
  const activeIds = useMemo(() => getActiveIds(menuSchema, fallbackMenuSchema), [menuSchema, fallbackMenuSchema]);
  const currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  const primaryEntries = menuSchema;
  const activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  const primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  const secondaryEntries = getSecondaryEntries({
    primary: primaryItem ?? null,
    activeIds,
    fallbackMenuSchema
  });
  const secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  const hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  const handlePrimarySelect = useCallback((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [index]
    }));
  }, []);
  const handleSecondarySelect = useCallback((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [currentSelectedIds[0] ?? null, index]
    }));
  }, [currentSelectedIds]);
  const CustomPrimaryRight = supplementary.primaryRight ?? null;
  const showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  const secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/React__default.createElement(supplementary.secondaryRight) : null;
  const hasItemInActivedPrimaryItem = activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : false;
  const hasItemInHoveredPrimaryItem = primaryItem != null && primaryItem.entries != null ? primaryItem.entries.length > 0 : false;
  return jsxs("header", {
    children: [jsx(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: jsx(StyledLogo, {
        logo: logo,
        onClick: () => {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? jsx(CustomPrimaryRightContainer, {
        children: jsx(CustomPrimaryRight, {})
      }) : jsx(PrimaryRight, {
        searchProps: searchOptions,
        ...supplementary
      }),
      menuEntries: primaryEntries,
      activeId: activeIds[0] ?? null,
      selectedId: currentSelectedIds[0] ?? null,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handlePrimarySelect
    }), jsx(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivedPrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] || activeIds[1] ? activeIds[1] ?? null : null,
      primaryId: currentSelectedIds[0] ?? null,
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onSelect: handleSecondarySelect,
      scrollableEntries: primaryItem?.scrollableEntries
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
}
const StyledLogo = /*#__PURE__*/_styled(Logo, process.env.NODE_ENV === "production" ? {
  target: "e1d4t2q81"
} : {
  target: "e1d4t2q81",
  label: "StyledLogo"
})("height:", pxToRem(26), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(30), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledLogo;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const CustomPrimaryRightContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1d4t2q80"
} : {
  target: "e1d4t2q80",
  label: "CustomPrimaryRightContainer"
})(MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "ffpekn-CustomPrimaryRightContainer",
  styles: "display:none;label:CustomPrimaryRightContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEs4QyIsImZpbGUiOiJCYXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUNhbGxiYWNrLCB1c2VNZW1vLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgTUVESUFfUVVFUlksIHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmltcG9ydCB7IE1lbnVTY2hlbWFFbnRyeSwgTmF2aWdhdGlvbkxvZ28sIFN1cHBsZW1lbnRhcnkgfSBmcm9tICcuLi90eXBlcyc7XG5pbXBvcnQgeyBnZXRBY3RpdmVJZHMgfSBmcm9tICcuLi91dGlscy9nZXRBY3RpdmVJZHMnO1xuXG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyUHJpbWFyeSB9IGZyb20gJy4vUHJpbWFyeSc7XG5pbXBvcnQgeyBOYXZpZ2F0aW9uQmFyU2Vjb25kYXJ5IH0gZnJvbSAnLi9TZWNvbmRhcnknO1xuaW1wb3J0IHsgTmF2aWdhdGlvbkJhclRlcnRpYXJ5IH0gZnJvbSAnLi9UZXJ0aWFyeSc7XG5pbXBvcnQgeyBQcmltYXJ5UmlnaHQgfSBmcm9tICcuLi9wcmltYXJ5LXJpZ2h0L1ByaW1hcnlSaWdodCc7XG5pbXBvcnQgeyBOYXZpZ2F0aW9uU2VhcmNoUHJvcHMgfSBmcm9tICcuLi9zZWFyY2gvU2VhcmNoJztcbmltcG9ydCB7IExvZ28gfSBmcm9tICcuLi9sb2dvL0xvZ28nO1xuaW1wb3J0IHsgdXNlRm9jdXNlZExhdGNoIH0gZnJvbSAnLi91c2VGb2N1c2VkTGF0Y2gnO1xuaW1wb3J0IHsgdXNlTG9nQ29udGV4dCB9IGZyb20gJy4uL2xvZy1jb250ZXh0JztcblxuZXhwb3J0IGludGVyZmFjZSBOYXZpZ2F0aW9uQmFyUHJvcHMge1xuICBsb2dvPzogTmF2aWdhdGlvbkxvZ287XG4gIHByaW1hcnlMZWZ0bW9zdDogUmVhY3QuUmVhY3ROb2RlO1xuICBtZW51U2NoZW1hOiBNZW51U2NoZW1hRW50cnlbXTtcbiAgZmFsbGJhY2tNZW51U2NoZW1hPzogTWVudVNjaGVtYUVudHJ5W107XG4gIHNlYXJjaE9wdGlvbnM/OiBOYXZpZ2F0aW9uU2VhcmNoUHJvcHM7XG4gIHN1cHBsZW1lbnRhcnk6IFN1cHBsZW1lbnRhcnk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBOYXZpZ2F0aW9uQmFyKHByb3BzOiBOYXZpZ2F0aW9uQmFyUHJvcHMpOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IGxvZyA9IHVzZUxvZ0NvbnRleHQoKTtcblxuICBjb25zdCB7XG4gICAgbG9nbyxcbiAgICBwcmltYXJ5TGVmdG1vc3QsXG4gICAgbWVudVNjaGVtYSxcbiAgICBmYWxsYmFja01lbnVTY2hlbWEsXG4gICAgc2VhcmNoT3B0aW9ucyxcbiAgICBzdXBwbGVtZW50YXJ5LFxuICB9ID0gcHJvcHM7XG4gIGNvbnN0IFt7IGlzSG92ZXJlZCwgc2VsZWN0ZWRJZHMgfSwgc2V0U3RhdGVdID0gdXNlU3RhdGU8e1xuICAgIGlzSG92ZXJlZDogYm9vbGVhbixcbiAgICBzZWxlY3RlZElkczogKG51bWJlciB8IG51bGwpW10gfCBudWxsLFxuICB9Pih7XG4gICAgICAgIGlzSG92ZXJlZDogZmFsc2UsXG4gICAgICAgIHNlbGVjdGVkSWRzOiBudWxsLFxuICAgICAgfSk7XG4gIGNvbnN0IHNldEhvdmVyZWQgPSB1c2VDYWxsYmFjaygodmFsdWU6IGJvb2xlYW4pID0+IHtcbiAgICBzZXRTdGF0ZSgocHJldlN0YXRlKSA9PiAoe1xuICAgICAgLi4ucHJldlN0YXRlLFxuICAgICAgaXNIb3ZlcmVkOiB2YWx1ZSxcbiAgICAgIHNlbGVjdGVkSWRzOiAhdmFsdWUgPyBudWxsIDogcHJldlN0YXRlLnNlbGVjdGVkSWRzLFxuICAgIH0pKTtcbiAgfSwgW10pO1xuICBjb25zdCBbb25Nb3VzZUVudGVyLCBvbk1vdXNlTGVhdmVdID0gdXNlRm9jdXNlZExhdGNoKHNldEhvdmVyZWQpO1xuICBjb25zdCBhY3RpdmVJZHM6IChudW1iZXIgfCBudWxsKVtdID0gdXNlTWVtbyhcbiAgICAoKSA9PiBnZXRBY3RpdmVJZHMobWVudVNjaGVtYSwgZmFsbGJhY2tNZW51U2NoZW1hKSxcbiAgICBbbWVudVNjaGVtYSwgZmFsbGJhY2tNZW51U2NoZW1hXSxcbiAgKTtcbiAgY29uc3QgY3VycmVudFNlbGVjdGVkSWRzID0gc2VsZWN0ZWRJZHMgPT0gbnVsbCA/IGFjdGl2ZUlkcyA6IHNlbGVjdGVkSWRzO1xuICBjb25zdCBwcmltYXJ5RW50cmllcyA9IG1lbnVTY2hlbWE7XG4gIGNvbnN0IGFjdGl2ZVByaW1hcnlJdGVtID0gYWN0aXZlSWRzWzBdICE9IG51bGxcbiAgICA/IHByaW1hcnlFbnRyaWVzW2FjdGl2ZUlkc1swXV1cbiAgICA6IG51bGw7XG4gIGNvbnN0IHByaW1hcnlJdGVtID0gY3VycmVudFNlbGVjdGVkSWRzWzBdICE9IG51bGxcbiAgICA/IHByaW1hcnlFbnRyaWVzW2N1cnJlbnRTZWxlY3RlZElkc1swXV1cbiAgICA6IG51bGw7XG4gIGNvbnN0IHNlY29uZGFyeUVudHJpZXMgPSBnZXRTZWNvbmRhcnlFbnRyaWVzKHsgcHJpbWFyeTogcHJpbWFyeUl0ZW0gPz8gbnVsbCwgYWN0aXZlSWRzLCBmYWxsYmFja01lbnVTY2hlbWEgfSk7XG4gIGNvbnN0IHNlY29uZGFyeUl0ZW0gPSBjdXJyZW50U2VsZWN0ZWRJZHNbMV0gIT0gbnVsbFxuICAgID8gc2Vjb25kYXJ5RW50cmllc1tjdXJyZW50U2VsZWN0ZWRJZHNbMV1dXG4gICAgOiBudWxsO1xuICBjb25zdCBoYXNGYWxsYmFja01lbnVTY2hlbWEgPVxuICAgIGZhbGxiYWNrTWVudVNjaGVtYSAhPSBudWxsICYmXG4gICAgZmFsbGJhY2tNZW51U2NoZW1hLmxlbmd0aCA+IDA7XG4gIGNvbnN0IGhhbmRsZVByaW1hcnlTZWxlY3QgPSB1c2VDYWxsYmFjaygoXG4gICAgXzogTWVudVNjaGVtYUVudHJ5LFxuICAgIGluZGV4OiBudW1iZXIsXG4gICkgPT4ge1xuICAgIHNldFN0YXRlKChwcmV2U3RhdGUpID0+ICh7IC4uLnByZXZTdGF0ZSwgc2VsZWN0ZWRJZHM6IFtpbmRleF0gfSkpO1xuICB9LCBbXSk7XG4gIGNvbnN0IGhhbmRsZVNlY29uZGFyeVNlbGVjdCA9IHVzZUNhbGxiYWNrKChcbiAgICBfOiBNZW51U2NoZW1hRW50cnksXG4gICAgaW5kZXg6IG51bWJlcixcbiAgKSA9PiB7XG4gICAgc2V0U3RhdGUoKHByZXZTdGF0ZSkgPT4gKHtcbiAgICAgIC4uLnByZXZTdGF0ZSxcbiAgICAgIHNlbGVjdGVkSWRzOiBbY3VycmVudFNlbGVjdGVkSWRzWzBdID8/IG51bGwsIGluZGV4XSxcbiAgICB9KSk7XG4gIH0sIFtjdXJyZW50U2VsZWN0ZWRJZHNdKTtcblxuICBjb25zdCBDdXN0b21QcmltYXJ5UmlnaHQgPSBzdXBwbGVtZW50YXJ5LnByaW1hcnlSaWdodCA/PyBudWxsO1xuICBjb25zdCBzaG93VGVydGlhcnkgPSBzZWxlY3RlZElkcyAhPSBudWxsICYmIHNlbGVjdGVkSWRzWzFdICE9IG51bGwgJiZcbiAgICBzZWNvbmRhcnlJdGVtICE9IG51bGwgJiYgc2Vjb25kYXJ5SXRlbS5yZW5kZXJCYXJDaGlsZCAhPSBudWxsO1xuICBjb25zdCBzZWNvbmRhcnlSaWdodEVsZW1lbnQgPSBzdXBwbGVtZW50YXJ5LnNlY29uZGFyeVJpZ2h0ICE9IG51bGxcbiAgICA/IFJlYWN0LmNyZWF0ZUVsZW1lbnQoc3VwcGxlbWVudGFyeS5zZWNvbmRhcnlSaWdodClcbiAgICA6IG51bGw7XG5cbiAgY29uc3QgaGFzSXRlbUluQWN0aXZlZFByaW1hcnlJdGVtID0gYWN0aXZlUHJpbWFyeUl0ZW0gIT0gbnVsbCAmJiBhY3RpdmVQcmltYXJ5SXRlbS5lbnRyaWVzICE9IG51bGxcbiAgICA/IGFjdGl2ZVByaW1hcnlJdGVtLmVudHJpZXMubGVuZ3RoID4gMFxuICAgIDogZmFsc2U7XG4gIGNvbnN0IGhhc0l0ZW1JbkhvdmVyZWRQcmltYXJ5SXRlbSA9IHByaW1hcnlJdGVtICE9IG51bGwgJiYgcHJpbWFyeUl0ZW0uZW50cmllcyAhPSBudWxsXG4gICAgPyBwcmltYXJ5SXRlbS5lbnRyaWVzLmxlbmd0aCA+IDBcbiAgICA6IGZhbHNlO1xuXG4gIHJldHVybiAoXG4gICAgPGhlYWRlcj5cbiAgICAgIDxOYXZpZ2F0aW9uQmFyUHJpbWFyeVxuICAgICAgICBsZWZ0bW9zdD17cHJpbWFyeUxlZnRtb3N0fVxuICAgICAgICBsZWZ0PXsoXG4gICAgICAgICAgPFN0eWxlZExvZ29cbiAgICAgICAgICAgIGxvZ289e2xvZ299XG4gICAgICAgICAgICBvbkNsaWNrPXsoKSA9PiB7XG4gICAgICAgICAgICAgIGxvZyh7XG4gICAgICAgICAgICAgICAga2V5OiAnbG9nbycsXG4gICAgICAgICAgICAgICAgY2F0ZWdvcnk6ICdjbGljaycsXG4gICAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgfX1cbiAgICAgICAgICAvPlxuICAgICAgICApfVxuICAgICAgICByaWdodD17KFxuICAgICAgICAgIEN1c3RvbVByaW1hcnlSaWdodFxuICAgICAgICAgICAgPyAoXG4gICAgICAgICAgICAgIDxDdXN0b21QcmltYXJ5UmlnaHRDb250YWluZXI+XG4gICAgICAgICAgICAgICAgPEN1c3RvbVByaW1hcnlSaWdodCAvPlxuICAgICAgICAgICAgICA8L0N1c3RvbVByaW1hcnlSaWdodENvbnRhaW5lcj5cbiAgICAgICAgICAgIClcbiAgICAgICAgICAgIDogKFxuICAgICAgICAgICAgICA8UHJpbWFyeVJpZ2h0XG4gICAgICAgICAgICAgICAgc2VhcmNoUHJvcHM9e3NlYXJjaE9wdGlvbnN9XG4gICAgICAgICAgICAgICAgey4uLnN1cHBsZW1lbnRhcnl9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICApXG4gICAgICAgICl9XG4gICAgICAgIG1lbnVFbnRyaWVzPXtwcmltYXJ5RW50cmllc31cbiAgICAgICAgYWN0aXZlSWQ9e2FjdGl2ZUlkc1swXSA/PyBudWxsfVxuICAgICAgICBzZWxlY3RlZElkPXtjdXJyZW50U2VsZWN0ZWRJZHNbMF0gPz8gbnVsbH1cbiAgICAgICAgb25Nb3VzZUVudGVyPXtvbk1vdXNlRW50ZXJ9XG4gICAgICAgIG9uTW91c2VMZWF2ZT17b25Nb3VzZUxlYXZlfVxuICAgICAgICBvblNlbGVjdD17aGFuZGxlUHJpbWFyeVNlbGVjdH1cbiAgICAgIC8+XG4gICAgICA8TmF2aWdhdGlvbkJhclNlY29uZGFyeVxuICAgICAgICByaWdodD17c2Vjb25kYXJ5UmlnaHRFbGVtZW50fVxuICAgICAgICBtZW51RW50cmllcz17c2Vjb25kYXJ5RW50cmllc31cbiAgICAgICAgaGFzSXRlbXM9e2hhc0l0ZW1JbkFjdGl2ZWRQcmltYXJ5SXRlbSB8fCBoYXNJdGVtSW5Ib3ZlcmVkUHJpbWFyeUl0ZW0gfHwgaGFzRmFsbGJhY2tNZW51U2NoZW1hfVxuICAgICAgICBhY3RpdmVJZD17Y3VycmVudFNlbGVjdGVkSWRzWzBdID09PSBhY3RpdmVJZHNbMF0gfHwgYWN0aXZlSWRzWzFdXG4gICAgICAgICAgPyBhY3RpdmVJZHNbMV0gPz8gbnVsbFxuICAgICAgICAgIDogbnVsbH1cbiAgICAgICAgcHJpbWFyeUlkPXtjdXJyZW50U2VsZWN0ZWRJZHNbMF0gPz8gbnVsbH1cbiAgICAgICAgaXNGb3JjZU9wZW5lZD17aXNIb3ZlcmVkICYmIHNlY29uZGFyeUVudHJpZXMubGVuZ3RoID4gMH1cbiAgICAgICAgaXNGYWxsYmFjaz17Y3VycmVudFNlbGVjdGVkSWRzWzBdID09IG51bGwgJiYgaGFzRmFsbGJhY2tNZW51U2NoZW1hfVxuICAgICAgICBvbk1vdXNlRW50ZXI9e29uTW91c2VFbnRlcn1cbiAgICAgICAgb25Nb3VzZUxlYXZlPXtvbk1vdXNlTGVhdmV9XG4gICAgICAgIG9uU2VsZWN0PXtoYW5kbGVTZWNvbmRhcnlTZWxlY3R9XG4gICAgICAgIHNjcm9sbGFibGVFbnRyaWVzPXtwcmltYXJ5SXRlbT8uc2Nyb2xsYWJsZUVudHJpZXN9XG4gICAgICAvPlxuICAgICAgeyBzaG93VGVydGlhcnkgJiYgKFxuICAgICAgICA8TmF2aWdhdGlvbkJhclRlcnRpYXJ5XG4gICAgICAgICAgaXRlbT17c2hvd1RlcnRpYXJ5ID8gc2Vjb25kYXJ5SXRlbSA6IG51bGx9XG4gICAgICAgICAgaXNPcGVuPXtzaG93VGVydGlhcnl9XG4gICAgICAgICAgb25Nb3VzZUVudGVyPXtvbk1vdXNlRW50ZXJ9XG4gICAgICAgICAgb25Nb3VzZUxlYXZlPXtvbk1vdXNlTGVhdmV9XG4gICAgICAgIC8+XG4gICAgICApIH1cbiAgICA8L2hlYWRlcj5cbiAgKTtcbn1cblxuY29uc3QgU3R5bGVkTG9nbyA9IHN0eWxlZChMb2dvKWBcbiAgaGVpZ2h0OiAke3B4VG9SZW0oMjYpfTtcbiAgJHtNRURJQV9RVUVSWS5taW4oJ3RhYmxldCcsIGNzc2BcbiAgICBoZWlnaHQ6ICR7cHhUb1JlbSgzMCl9O1xuICBgKX1cbmA7XG5cbmNvbnN0IEN1c3RvbVByaW1hcnlSaWdodENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gICR7TUVESUFfUVVFUlkubWF4KCdtb2JpbGUnLCBjc3NgXG4gICAgZGlzcGxheTogbm9uZTtcbiAgYCl9XG5gO1xuXG4vKiogU2Vjb25kYXJ5IOuplOuJtCDsiqTtgqTrp4jrpbwg66as7YS07ZWp64uI64ukICovXG5mdW5jdGlvbiBnZXRTZWNvbmRhcnlFbnRyaWVzKHtcbiAgcHJpbWFyeSxcbiAgYWN0aXZlSWRzLFxuICBmYWxsYmFja01lbnVTY2hlbWEsXG59OiB7XG4gIHByaW1hcnk6IE1lbnVTY2hlbWFFbnRyeSB8IG51bGwsXG4gIGFjdGl2ZUlkczogKG51bWJlciB8IG51bGwpW10sXG4gIGZhbGxiYWNrTWVudVNjaGVtYT86IE1lbnVTY2hlbWFFbnRyeVtdLFxufSk6IE1lbnVTY2hlbWFFbnRyeVtdIHtcbiAgaWYgKHByaW1hcnkgIT0gbnVsbCkge1xuICAgIHJldHVybiBwcmltYXJ5LmVudHJpZXMgPz8gW107XG4gIH1cblxuICBpZiAoYWN0aXZlSWRzWzFdICE9IG51bGwpIHtcbiAgICByZXR1cm4gZmFsbGJhY2tNZW51U2NoZW1hID8/IFtdO1xuICB9XG5cbiAgcmV0dXJuIFtdO1xufVxuIl19 */"));

/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries({
  primary,
  activeIds,
  fallbackMenuSchema
}) {
  if (primary != null) {
    return primary.entries ?? [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema ?? [];
  }
  return [];
}

function Navigation(props) {
  const {
    logo,
    menuSchema,
    searchOptions,
    supplementary,
    fallbackMenuSchema,
    linkComponent,
    onLog,
    onAppDownload,
    location
  } = props;
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen(v => !v);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);
  const isInApp = useIsInApp(location);
  if (isInApp) {
    return null;
  }
  return jsx(LinkProvider, {
    linkComponent: linkComponent,
    children: jsx(LogProvider, {
      onLog: onLog,
      children: jsxs(Fragment$1, {
        children: [jsx(NavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: jsx(Button, {
            type: "button",
            onClick: () => {
              onLog({
                key: 'drawer.button',
                category: 'click'
              });
              handleDrawerToggle();
            },
            children: jsx(Icon$1, {
              size: 24,
              name: "menu"
            })
          }),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(NavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    })
  });
}
const Button = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e7erebj0"
} : {
  target: "e7erebj0",
  label: "Button"
})(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", ({
  theme
}) => theme.content.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "10qs83r",
  styles: "display:block;margin:20px -10px 0;line-height:1"
} : {
  name: "18k148p-StoreCategory",
  styles: "display:block;margin:20px -10px 0;line-height:1;label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "d0zu4q",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;}"
} : {
  name: "12i7lqh-StoreCategory",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;};label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "dg5hsf",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center"
} : {
  name: "1gto5p3-StoreCategory",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center;label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "laomuu",
  styles: "padding-right:60px"
} : {
  name: "1gjziyx-StoreCategory",
  styles: "padding-right:60px;label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "v61o11",
  styles: "max-width:1276px;padding:10px 0 10px 60px"
} : {
  name: "1wmzh4t-StoreCategory",
  styles: "max-width:1276px;padding:10px 0 10px 60px;label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref6 = process.env.NODE_ENV === "production" ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : {
  name: "164muiv-StoreCategory",
  styles: "overflow:auto;label:StoreCategory;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function StoreCategory({
  categories
}) {
  const Link = useLinkContext();
  const log = useLogContext();
  const theme = useTheme();
  return jsx("div", {
    css: _ref6,
    children: jsx("ul", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;margin:0 auto;padding:10px 0 10px 40px;box-sizing:border-box;", MEDIA_QUERY.min('laptop', _ref5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StoreCategory;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: categories.map((category, index) => jsx("li", {
        css: /*#__PURE__*/css("flex:0 0 auto;margin:0;padding:0 0 0 10px;color:", category.active ? theme.content.primary1.basic : theme.content.base1, ";&:last-of-type{padding-right:40px;", MEDIA_QUERY.min('laptop', _ref4), ";}&:hover{color:", theme.content.primary1.basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StoreCategory;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: jsxs(Link, {
          "data-testid": `category-${category.title}-link`,
          href: category.href,
          onClick: () => {
            log({
              key: 'tertiary.store.category.item',
              category: 'click',
              params: {
                id: category.logId,
                index
              }
            });
          },
          css: _ref3,
          children: [jsx("span", {
            css: _ref2,
            children: category.icon
          }), jsx("span", {
            css: _ref,
            children: category.title
          })]
        })
      }, category.title))
    })
  });
}

/* eslint-disable camelcase */

const TYPE_MAP = {
  'logo': () => ({
    click: {
      bucket: {
        section: '로고'
      }
    }
  }),
  // primary
  'primary.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index
      }
    }
  }),
  'primary.right.search.input': ({
    search_type
  }) => ({
    click: {
      bucket: {
        section: '검색'
      },
      amplitude: {
        type: '검색 필드 Clicked',
        search_type
      }
    }
  }),
  'primary.right.search.autocomplete.query': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '자동완성',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.autocomplete.category': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '추천 카테고리',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.history': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '최근 검색어',
        id,
        type,
        index
      }
    },
    impression: {
      bucket: {
        section: '최근 검색어',
        type
      }
    }
  }),
  'primary.right.scrap': () => ({
    click: {
      bucket: {
        section: '스크랩북'
      },
      amplitude: {
        type: '스크랩북 Viewed',
        data: {
          source: {
            page: {
              tab: {
                main: '스크랩북'
              }
            },
            referrer: {
              type: '바로가기'
            }
          }
        }
      }
    }
  }),
  'primary.right.cart': () => ({
    click: {
      bucket: {
        section: '장바구니'
      }
    }
  }),
  'primary.right.notification': () => ({
    click: {
      bucket: {
        section: '알림'
      },
      amplitude: {
        type: '알림 리스트 Viewed'
      }
    }
  }),
  'primary.right.login': () => ({
    click: {
      bucket: {
        section: '로그인'
      }
    }
  }),
  'primary.right.signup': () => ({
    click: {
      bucket: {
        section: '회원가입'
      }
    }
  }),
  'primary.right.cs': () => ({
    click: {
      bucket: {
        section: '고객센터'
      }
    }
  }),
  'primary.right.user.dropdown': ({
    id
  }) => ({
    click: {
      bucket: {
        section: 'user_menu',
        section_id: id
      }
    }
  }),
  'primary.right.mypage': () => ({
    click: {
      amplitude: {
        type: '계정 Viewed'
      }
    }
  }),
  'primary.right.logout': () => ({
    click: {
      amplitude: {
        type: '계정 Logout'
      }
    }
  }),
  'primary.right.upload': () => ({
    click: {
      bucket: {
        section: '글쓰기'
      }
    }
  }),
  'primary.right.upload.photo': () => ({
    click: {
      bucket: {
        section: '사진 올리기'
      }
    }
  }),
  // secondary
  'secondary.item': ({
    index,
    href,
    ...rest
  }) => ({
    click: {
      bucket: {
        index,
        url: typeof href === 'string' ? href : '/',
        ...rest
      }
    },
    impression: {
      bucket: {
        index,
        ...rest
      }
    }
  }),
  'secondary.interior': () => ({
    click: {
      bucket: {
        section: '3D인테리어'
      }
    }
  }),
  'secondary.more.button': () => ({
    click: {
      bucket: {
        section: '토픽',
        section_id: 'TOPIC',
        type: 'button',
        id: 'more_button'
      }
    }
  }),
  // tertiary
  'tertiary.store.category.item': ({
    id,
    index
  }) => ({
    click: {
      bucket: {
        section: '카테고리 메뉴',
        type: 'category',
        id,
        index
      }
    }
  }),
  // drawer
  'drawer.logo': () => ({
    click: {
      bucket: {
        section: 'drawer 로고'
      }
    }
  }),
  'drawer.button': () => ({
    click: {
      bucket: {
        section: '햄버거 메뉴'
      }
    }
  }),
  'drawer.main.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index
      }
    }
  }),
  'drawer.sub.item': ({
    index,
    href
  }) => ({
    click: {
      bucket: {
        section: '서브 메뉴',
        index,
        url: typeof href === 'string' ? href : '/'
      }
    }
  }),
  'drawer.user.item': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '유저 메뉴',
        index
      }
    }
  }),
  'drawer.user.profile': () => ({
    click: {
      bucket: {
        section: '유저 프로필'
      },
      amplitude: {
        type: '계정 Viewed'
      }
    }
  })
};

const SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

const getSearchPathname = searchType => {
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return 'commerce';
    case SEARCH_TYPE.EXPERT:
      return 'expert';
    case SEARCH_TYPE.TOTAL:
    default:
      return 'integrated';
  }
};
const SEARCH_ITEM_TYPE = ['query', 'category', 'consulting', 'history'];
const getDomesticAutoCompleteKeywords = async ({
  env,
  searchType,
  query
}) => {
  const searchPathname = getSearchPathname(searchType);

  /** @see {https://www.notion.so/ohouse/integrated-4a4eeee9b22340faa3dbb3b4e7c83f25?pvs=4} */
  const response = await fetchGet(`${API_AUTOCOMPLETE_HOST[env]}/${searchPathname}?query=${query}&v=v2`, {
    headers: {}
  });
  const data = await response.json();
  return data;
};
const formatAutoCompleteKeywords = data => {
  const autoCompleteKeywords = humpsExports.camelizeKeys(data.results);
  return autoCompleteKeywords.map(item => ({
    type: item.dataType,
    value: item,
    query: item.orgDisplay
  })).filter(item => SEARCH_ITEM_TYPE.includes(item.type));
};

const defaultSignOut = async ({
  user,
  env
}) => {
  const isPro = user?.userableType === 'ExpertUser';
  const res = await fetchDelete(`${DOMAINS[env].home}/users/sign_out.json`, {
    data: {
      is_pro: isPro
    }
  }, {
    headers: {},
    credentials: 'include'
  });
  return res.json();
};

const filterHistory = (history, query) => {
  return typeof history === 'string' ? history !== query : history.query !== query;
};

/** 최근 검색어 데이터들을 다루는 storage를 생성합니다. */
const createSearchHistoryStorage = ({
  env,
  subdomain,
  serviceType
}) => {
  const SearchHistoryStorage = {
    get: () => {
      const matches = document.cookie.match(
      // eslint-disable-next-line prefer-regex-literals
      new RegExp('(?:^|; )searchHistory=([^;]*)'));
      if (matches) {
        try {
          return JSON.parse(decodeURIComponent(matches[1] ?? ''));
        } catch {
          return [];
        }
      }
      return [];
    },
    set: histories => {
      const value = encodeURIComponent(JSON.stringify(histories.slice(0, 5)));
      const cookieDomain = getCookieDomain(env, subdomain, serviceType);
      document.cookie = `searchHistory=${value}; domain=${cookieDomain}; max-age=2147483647; path=/`;
    },
    append: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set([history, ...SearchHistoryStorage.get().filter(history => filterHistory(history, query))]);
    },
    remove: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set(SearchHistoryStorage.get().filter(history => filterHistory(history, query)));
    },
    removeAll: () => {
      SearchHistoryStorage.set([]);
    }
  };
  return SearchHistoryStorage;
};

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher) || [];
    }
    return input;
  }
}
function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  var match = multiMatcher.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent = function (encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = (string, separator) => {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var filterObj = function (obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};

(function (exports) {

  const strictUriEncode$1 = strictUriEncode;
  const decodeComponent = decodeUriComponent;
  const splitOnFirst$1 = splitOnFirst;
  const filterObject = filterObj;
  const isNullOrUndefined = value => value === null || value === undefined;
  const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      case 'bracket':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      case 'colon-list-separator':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return key => (result, value) => {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            // Translate null to an empty string so that it doesn't serialize as 'null'
            value = value === null ? '' : value;
            if (result.length === 0) {
              return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
            }
            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        }
      default:
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
    }
  }
  function parserForArrayFormat(options) {
    let result;
    switch (options.arrayFormat) {
      case 'index':
        return (key, value, accumulator) => {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return (key, value, accumulator) => {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return (key, value, accumulator) => {
          const isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
    }
    return input;
  }
  function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    for (const param of query.split('&')) {
      if (param === '') {
        continue;
      }
      let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

      // Missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
      formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)) {
      const value = ret[key];
      if (typeof value === 'object' && value !== null) {
        for (const k of Object.keys(value)) {
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
      const value = ret[key];
      if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = (object, options) => {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object)) {
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(key => {
      const value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(x => x.length > 0).join('&');
  };
  exports.parseUrl = (url, options) => {
    options = Object.assign({
      decode: true
    }, options);
    const [url_, hash] = splitOnFirst$1(url, '#');
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = (object, options) => {
    options = Object.assign({
      encode: true,
      strict: true,
      [encodeFragmentIdentifier]: true
    }, options);
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = `?${queryString}`;
    }
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
  };
  exports.pick = (input, filter, options) => {
    options = Object.assign({
      parseFragmentIdentifier: true,
      [encodeFragmentIdentifier]: false
    }, options);
    const {
      url,
      query,
      fragmentIdentifier
    } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
      url,
      query: filterObject(query, filter),
      fragmentIdentifier
    }, options);
  };
  exports.exclude = (input, filter, options) => {
    const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString);

/**
 *  SEARCH_TYPE에 따라 다른 이동할 검색 페이지의 URL을 return합니다
 */
const getSearchURL = ({
  searchType,
  env,
  params,
  serviceType,
  locale
}) => {
  const queryParams = queryString.stringify(params);
  switch (serviceType) {
    case 'OG':
      return getGlobalSearchURL({
        env,
        queryParams,
        locale
      });
    case 'OK':
    default:
      return getDomesticSearchURL({
        searchType,
        env,
        queryParams
      });
  }
};
const getDomesticSearchURL = ({
  searchType,
  env,
  queryParams
}) => {
  const domain = DOMAINS[env].home;
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return `${domain}/productions/feed?${queryParams}`;
    case SEARCH_TYPE.EXPERT:
      return `${domain}/expert_users?${queryParams}`;
    case SEARCH_TYPE.TOTAL:
    default:
      return `${domain}/search/index?${queryParams}`;
  }
};
const getGlobalSearchURL = ({
  env,
  locale,
  queryParams
}) => {
  const domain = GLOBAL_DOMAINS[env].home;
  return `${domain}/${locale}/search?${queryParams}`;
};

/**
 * '최근 검색어', '추천 검색어'를 통해 검색 후 이동할 페이지의 URL을 return합니다
 * @param {object} GetSearchTargetURLParams.item 검색할 아이템. 인터페이스는 디자인시스템 `SearchItem` 인터페이스 참고
 * @param {string} env 서비스 환경
 * @return {string} 검색 후 이동할 페이지 URL
 * */
const getSearchTargetURL = ({
  searchType,
  item,
  env,
  serviceType,
  locale
}) => {
  const searchItem = item.type === 'history' ? item.value : item;
  const params = {
    search_affect_type: item.type === 'history' ? 'History' : 'Autocomplete'
  };
  if (typeof searchItem === 'string') {
    return getSearchURL({
      searchType,
      env,
      params: {
        ...params,
        query: searchItem
      },
      serviceType,
      locale
    });
  }
  switch (searchItem.type) {
    case 'query':
      {
        return getSearchURL({
          searchType,
          env,
          params: {
            ...params,
            query: searchItem.query
          },
          serviceType,
          locale
        });
      }
    case 'category':
      {
        return `${DOMAINS[env].home}/store/category?${queryString.stringify({
          category_id: searchItem.value.info.displayCategoryId,
          affect_type: 'StoreSearch',
          affect_id: 0,
          ...params
        })}`;
      }
    case 'consulting':
      {
        const [url, search] = searchItem.value.info.contentUrl.split('?');
        const query = search ? `${search}&${queryString.stringify(params)}` : queryString.stringify(params);
        return `${url}?${query}`;
      }
    default:
      {
        return `${DOMAINS[env].home}/search/index?${queryString.stringify({
          query: searchItem.query,
          ...params
        })}`;
      }
  }
};

const getSearchType = ({
  subdomain,
  pathname
}) => {
  const serviceType = getServiceType(subdomain, pathname);
  switch (serviceType) {
    case 'commerce':
      return SEARCH_TYPE$1.STORE;
    case 'o2o':
      return SEARCH_TYPE$1.EXPERT;
    default:
      return SEARCH_TYPE$1.TOTAL;
  }
};

const useGNBSearch = ({
  location,
  env,
  subdomain,
  hiddenSearchBar,
  serviceType = 'OK',
  autoComplete
}) => {
  const {
    locale
  } = location;
  const urlSearchParams = new URLSearchParams(location.search);
  const initialQuery = urlSearchParams.get('query');
  const {
    localeData
  } = useGNBData();
  const searchType = useMemo(() => getSearchType({
    subdomain,
    pathname: location.pathname
  }), [location.pathname, subdomain]);
  const historyStorage = useMemo(() => createSearchHistoryStorage({
    env,
    subdomain,
    serviceType
  }), [env, subdomain, serviceType]);
  const isGlobal = serviceType === 'OG';

  /**
   * 유저가 검색시 api요청으로 응답받은 추천 자동완성 키워드 리스트를 return하는 함수
   */
  const handleFetch = useCallback(async query => {
    try {
      const response = await autoComplete({
        env,
        searchType,
        query
      });
      return formatAutoCompleteKeywords(response);
    } catch (error) {
      return [];
    }
  }, [env, searchType, autoComplete]);

  /**
   * 유저가 직접 입력하여 검색하는 경우 실행하는 함수
   */
  const handleSubmit = useCallback(searchValue => {
    if (!searchValue) {
      return;
    }
    const url = getSearchURL({
      searchType,
      env,
      params: {
        query: searchValue,
        search_affect_type: 'Typing'
      },
      serviceType,
      locale
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [env, searchType, serviceType, subdomain, locale]);

  /**
   * 유저가 '최근 검색어', '추천 검색어'를 클릭하는 경우 실행하는 함수
   */
  const handleSubmitItem = useCallback(item => {
    const url = getSearchTargetURL({
      searchType,
      item,
      env,
      serviceType,
      locale
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [searchType, env, subdomain, serviceType, locale]);
  return hiddenSearchBar ? undefined : {
    searchType,
    initialQuery: typeof initialQuery === 'string' ? initialQuery : undefined,
    historyStorage,
    onFetch: handleFetch,
    onSubmit: handleSubmit,
    onSubmitItem: handleSubmitItem,
    placeholder: isGlobal ? localeData?.search?.inputPlaceholder : undefined
  };
};

const GnbUploadMenuAdviceIcon = props => jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      d: "M0 0h36v36H0z"
    }), jsx("path", {
      fill: "#EDEDED",
      d: "M17 10h2v22h-2z"
    }), jsx("path", {
      fill: "#FFF",
      d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0v21c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
    }), jsx("path", {
      fill: "#EDEDED",
      d: "M16.5 15h3v16c-.66.8-1.16 1.2-1.5 1.2-.34 0-.84-.4-1.5-1.2V15z"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0h0v1.97h0V31.2c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
    }), jsxs("g", {
      transform: "translate(11 3)",
      children: [jsx("path", {
        fill: "#FFDB92",
        stroke: "#000",
        d: "M7 0a7 7 0 013 13.33V17H4v-3.67A7 7 0 017 0z"
      }), jsx("path", {
        stroke: "#000",
        strokeLinecap: "square",
        d: "M7 15.68V8.5"
      }), jsx("circle", {
        cx: "7",
        cy: "7.5",
        r: "1.5",
        fill: "#000"
      }), jsx("path", {
        fill: "#FFF",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16h8v7H3z"
      }), jsx("path", {
        stroke: "#000",
        strokeLinecap: "square",
        d: "M3 18.5h8m-8 2h8"
      })]
    })]
  })
});
const GnbUploadMenuPhotosIcon = props => jsxs("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  width: "36",
  height: "36",
  ...props,
  children: [jsx("rect", {
    x: "6.54",
    y: "3.59",
    width: "27",
    height: "29",
    rx: "2.5",
    transform: "rotate(4 6.54 3.6)",
    fill: "#DBDBDB",
    stroke: "#000",
    strokeLinejoin: "round"
  }), jsx("rect", {
    x: "2.5",
    y: "1.5",
    width: "27",
    height: "29",
    rx: "2.5",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round"
  }), jsx("rect", {
    x: "5",
    y: "4",
    width: "22",
    height: "22",
    rx: "1",
    fill: "#FFE2C7"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7l5 .45v3.5l-5-.45V7zm0 4.5V15l5 .45v-3.5l-5-.45zm6 .55v3.5l5 .45v-3.5l-5-.45zm5-.55V8l-5-.45v3.5l5 .45z",
    fill: "#fff"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19l22 2v7L5 26v-7z",
    fill: "#E6A87C"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.45h5v16l-5 4v-20z",
    fill: "#F1C8A3"
  })]
});
const GnbUploadMenuProReviewIcon = props => jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      d: "M0 0h36v36H0z"
    }), jsx("path", {
      fill: "#FFDB92",
      d: "M13.75 3.52h1.9a8.1 8.1 0 018.1 8.1v1.9H5.65v-1.9a8.1 8.1 0 018.1-8.1z"
    }), jsx("path", {
      fill: "#FFDB92",
      d: "M12 3h5v2h-5z"
    }), jsx("path", {
      fill: "#FFF",
      d: "M12.2 23.92h5.4a7.2 7.2 0 017.2 7.2v2.8H5v-2.8a7.2 7.2 0 017.2-7.2z"
    }), jsx("path", {
      fill: "#EDEDED",
      fillOpacity: ".14",
      d: "M17.6 23.92c1.2 0 2.33.3 3.32.8a10.84 10.84 0 01-6.19 1.78c-2.28 0-4.38-.57-6.04-1.67a7.15 7.15 0 013.51-.91h5.4z"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M5 33.59V30.9a6.59 6.59 0 015.47-6.37"
    }), jsx("path", {
      d: "M10.64 24.6v3.19",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("path", {
      fill: "#B1C0CB",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.9 33.92l.98-6H21.9l.98 6"
    }), jsx("path", {
      fill: "#FFF6E6",
      fillRule: "nonzero",
      d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
    }), jsx("path", {
      fill: "#EDE2CD",
      fillRule: "nonzero",
      d: "M22.04 14.29c.16.48.29 1.09.37 1.71H7.06c.08-.62.2-1.23.37-1.71h14.6z"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.29 20.9c-.23.46-.84.79-1.56.79-.72 0-1.33-.33-1.56-.78"
    }), jsx("path", {
      d: "M12 17.55V17m5.46.55V17",
      fillRule: "nonzero",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3"
    }), jsx("path", {
      fill: "#EFC570",
      d: "M9.5 5l2.88 4.72v-5.9zM19.94 5l-2.89 4.72v-5.9z"
    }), jsxs("g", {
      stroke: "#000",
      strokeLinecap: "round",
      children: [jsx("path", {
        strokeLinejoin: "round",
        d: "M5.75 11.76c0-4.08 2.9-7.45 6.63-7.94v-.3c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v.3c3.74.5 6.63 3.86 6.63 7.94"
      }), jsx("path", {
        d: "M12.38 5.52v-2c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v2"
      }), jsx("path", {
        fill: "#F5F5F5",
        fillRule: "nonzero",
        d: "M4.2 14.02h20.7"
      })]
    }), jsxs("g", {
      children: [jsx("path", {
        fill: "#35C5F0",
        d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
      }), jsx("path", {
        fill: "#9AE2F7",
        d: "M27.15 19.18a1 1 0 01.26.26l2.22 3.24c.06.09.13.16.21.23l-8.58 8.58.05-1.98a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.39-.26z"
      }), jsx("path", {
        stroke: "#000",
        d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
      })]
    })]
  })
});
const GnbUploadMenuProductReviewIcon = props => jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      d: "M0 0h36v36H0z"
    }), jsxs("g", {
      strokeLinejoin: "round",
      transform: "translate(2 3)",
      children: [jsx("rect", {
        width: "4",
        height: "8",
        x: "3",
        y: "21",
        fill: "#FFB787",
        stroke: "#000",
        rx: "2"
      }), jsx("rect", {
        fill: "#FFE2C7",
        width: "24",
        height: "25",
        rx: "3"
      }), jsx("rect", {
        fill: "#ffe2c7",
        width: "24",
        height: "25",
        rx: "3"
      }), jsx("rect", {
        stroke: "#000",
        width: "24",
        height: "25",
        rx: "3",
        strokeWidth: "1.2"
      }), jsx("rect", {
        width: "6",
        height: "3",
        x: "9",
        y: "5",
        fill: "#DB9F77",
        stroke: "#FFF",
        rx: "1.5"
      }), jsx("rect", {
        width: "6",
        height: "3",
        x: "9",
        y: "17",
        fill: "#DB9F77",
        stroke: "#FFF",
        rx: "1.5"
      }), jsx("path", {
        fill: "#FFDB92",
        stroke: "#EDC29B",
        d: "M1.5 12.5h21"
      })]
    }), jsx("path", {
      fill: "#35C5F0",
      d: "M26.25 31.53l-3.7 1.32a1 1 0 01-1.34-.97l.1-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.55.4l3.77 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.11 3.93a1 1 0 01-1.33.97l-3.71-1.32a1 1 0 00-.67 0z"
    }), jsx("path", {
      fill: "#9AE2F7",
      d: "M27.15 17.61a1 1 0 01.26.26l2.22 3.25c.06.09.13.16.22.23l-8.59 8.58.06-1.98a.99.99 0 00-.21-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.39-.26z"
    }), jsx("path", {
      stroke: "#000",
      d: "M26.29 30.85l-3.31 1.17a.9.9 0 01-1.2-.86l.1-3.51c0-.2-.06-.4-.18-.57l-2.14-2.78a.9.9 0 01.45-1.4l3.37-.99a.9.9 0 00.48-.35l1.99-2.9a.9.9 0 011.47 0l1.99 2.9c.11.17.28.3.48.35l3.37 1a.9.9 0 01.45 1.4l-2.14 2.77a.89.89 0 00-.18.57l.1 3.5a.9.9 0 01-1.2.87l-3.3-1.17a.9.9 0 00-.6 0z",
      strokeWidth: "1.2"
    })]
  })
});
const GnbUploadMenuProjectIcon = props => jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      d: "M0 0h36v36H0z"
    }), jsx("path", {
      fill: "#FFF6E6",
      d: "M27.2 29.31H4.8V14.38h22.4"
    }), jsx("path", {
      fill: "#EDE2CD",
      d: "M27.2 17.18H4.8v-2.8h22.4"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.8 29.31V14.38h22.4v14.93H4.8z"
    }), jsx("path", {
      fill: "#FFF",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), jsx("path", {
      fill: "#fff",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), jsx("path", {
      stroke: "#000",
      d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
    }), jsx("path", {
      fill: "#FBDEC1",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5l3.25 6.6a.9.9 0 01-.8 1.3H2.93z"
    }), jsx("path", {
      fill: "#E9C39D",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l.74-1.5h26.26l.74 1.5a.9.9 0 01-.8 1.3H2.92z"
    }), jsx("path", {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5h0l3.25 6.6a.9.9 0 01-.8 1.3h0H2.93z"
    }), jsxs("g", {
      transform: "translate(26 9)",
      children: [jsx("path", {
        fill: "#fff",
        d: "M0 5h8.07v12H0z"
      }), jsx("path", {
        fill: "#ffdb92",
        d: "M0 0h8v4H0z"
      }), jsx("path", {
        d: "M8.5 17.43H-.52 8.5L4 23.8l-4.52-6.37H8.5",
        fill: "#fff6e6"
      }), jsx("path", {
        d: "M8.5 1v0A1.49 1.49 0 007-.5H1v0A1.5 1.5 0 00-.5 1l-.02 16.43L4 23.8l4.5-6.37z",
        stroke: "#000"
      }), jsx("path", {
        fill: "#000",
        d: "M4 23l2-2H2z"
      }), jsx("rect", {
        width: "6",
        height: "2",
        x: "-14",
        y: "3",
        stroke: "#000",
        rx: "1",
        transform: "rotate(-90)",
        ry: "1"
      }), jsx("rect", {
        width: "5",
        height: "1",
        x: "-13.5",
        y: "3.5",
        fill: "#ffdb92",
        rx: ".5",
        transform: "rotate(-90)",
        ry: ".5"
      }), jsx("path", {
        fill: "#000",
        d: "M0 4h8v1H0z",
        opacity: ".9"
      }), jsx("path", {
        d: "M-.52 17.43H8.5",
        stroke: "#000"
      })]
    }), jsx("path", {
      fill: "#000",
      d: "M30 32l2-2h-4z"
    })]
  })
});

const GNBIcon = ({
  size = 24,
  name,
  ...props
}) => {
  return jsx(Icon$1, {
    ...props,
    size: size,
    name: name
  });
};
const GNBImage = ({
  width = 80,
  height = 80,
  alt = '',
  url
}) => {
  return jsx("img", {
    src: url,
    width: width,
    height: height,
    alt: alt
  });
};
const GNBSVG = ({
  name
}) => {
  switch (name) {
    case 'photo':
      return jsx(GnbUploadMenuPhotosIcon, {});
    case 'project':
      return jsx(GnbUploadMenuProjectIcon, {});
    case 'advice':
      return jsx(GnbUploadMenuAdviceIcon, {});
    case 'production':
      return jsx(GnbUploadMenuProductReviewIcon, {});
    case 'remodeling':
      return jsx(GnbUploadMenuProReviewIcon, {});
    default:
      return null;
  }
};

/**
 * type에 따라 디자인 시스템 Icon | SVG Icon | 이미지를 생성합니다.
 * @param media
 * @returns 디자인 시스템 Icon | SVG Icon | 이미지
 */
const createMedia = media => {
  switch (media.type) {
    case 'icon':
      {
        return jsx(GNBIcon, {
          ...media
        });
      }
    case 'image':
      {
        return jsx(GNBImage, {
          ...media
        });
      }
    case 'svg':
      {
        return jsx(GNBSVG, {
          ...media
        });
      }
    default:
      return null;
  }
};

/**
 * GNB의 메뉴 스키마를 생성합니다. level1 ~ level3까지 모든 메뉴를 생성합니다.
 * design-system Navigation을 warpping한 구조입니다.
 */
const createMenuSchema = ({
  menus,
  location
}) => {
  const createMenu = menu => {
    if (!menu) {
      return null;
    }
    const {
      title,
      href,
      matches,
      media,
      items,
      log,
      custom
    } = menu;
    const localePath = location.locale ? `/${location.locale}` : '';
    const currentURL = location.origin + localePath + location.pathname + location.search + location.hash;
    const active = matches.map(match => new RegExp(match)).some(regExp => regExp.test(currentURL));
    const entries = items?.map(item => createMenu(item)).filter(Boolean);
    const scrollableProps = custom === 'noScrollableEntries' ? {
      scrollableEntries: false
    } : {};
    return {
      title,
      href,
      icon: media && createMedia(media),
      entries: custom === 'store' ? entries.map(entry => ({
        ...entry,
        icon: null
      })) : entries,
      active,
      logId: log?.id,
      renderBarChild: custom === 'store' ? () => jsx(StoreCategory, {
        categories: entries
      }) : undefined,
      ...scrollableProps
    };
  };
  return menus.map(menu => createMenu(menu)).filter(Boolean);
};

/**
 * store: 쇼핑 > 카테고리 메뉴 하위로 tertinary menus를 보여줍니다.
 * noScrollableEntries: menu의 entries를 scroll UI가 아닌 별도의 UI로 보여줍니다.
 */

const SHORTCUT_TYPE = {
  cart: 'cart',
  cs: 'cs',
  notification: 'notification',
  scrap: 'scrap',
  seller: 'seller',
  signin: 'signin',
  signup: 'signup'
};

/**
 * 신규 /api/navigation API에 추가 정의된 response 타입
 * @see {@link https://docs.google.com/document/d/1LE9v_LcjKgnxiVOGjxXiG_q75dFpb_6pKnEJR2_yryI#heading=h.qofnrodkae26 웹 네비게이션 모듈화 BFF API }
 */

/** 유저 프로필 클릭 시 나오는 유저 메뉴를 create합니다. */
const createUserMenus = ({
  userMenus,
  onSignout
}) => {
  return userMenus.map(({
    title,
    href,
    position,
    showOn,
    action,
    bullet,
    log
  }) => {
    return {
      type: position,
      showOn,
      title,
      href,
      bullet,
      onClick: action === 'signout' ? onSignout : undefined,
      logId: log?.id
    };
  });
};
/** 검색과 유저 프로필 사이에 있는 아이콘 메뉴를 create합니다. */
const createShortcuts = ({
  supplementary,
  user,
  subdomain,
  env,
  location,
  serviceType
}) => {
  const localePath = location.locale ? `/${location.locale}` : '';
  const url = [location.origin, localePath, location.pathname, location.search, location.hash].join('');
  const shortcuts = Object.entries(supplementary).reduce((prev, [key, value]) => {
    if (!Object.keys(SHORTCUT_TYPE).includes(key)) {
      return prev;
    }
    return {
      ...prev,
      [key]: {
        title: value?.title,
        count: value?.count,
        href: value?.action === 'signin' ? getLoginURL(user, subdomain, env, url, serviceType, location.locale) : value?.href
      }
    };
  }, {});
  return shortcuts;
};
/** 글쓰기 버튼 클릭시 나오는 업로드 메뉴를 create합니다. */
const createUploadMenuLinks = uploadLinks => {
  return uploadLinks.map(({
    title,
    subtitle,
    href,
    media,
    log
  }) => {
    return {
      title,
      subtitle,
      href,
      icon: createMedia(media),
      logId: log?.id
    };
  });
};

/** 로그인 유저의 정보를 통해 유저 프로필 data를 create합니다. */
const createUserProfile = user => {
  if (!user) {
    return undefined;
  }
  return {
    userId: user.id,
    imageUrl: user.profileImageUrl,
    nickname: user.nickname,
    userableType: user.userableType
  };
};
const createSupplementary = ({
  user,
  supplementary,
  subdomain,
  env,
  location,
  serviceType,
  onSignout,
  secondaryRight
}) => {
  const userProfile = createUserProfile(user);
  const userMenus = createUserMenus({
    userMenus: supplementary.userMenus,
    onSignout
  });
  const uploadMenuLinks = createUploadMenuLinks(supplementary.uploads);
  const shortcuts = createShortcuts({
    supplementary,
    user,
    subdomain,
    env,
    location,
    serviceType
  });
  const showChangeLanguageButton = serviceType === 'OG';
  return {
    ...shortcuts,
    userProfile,
    userMenu: userMenus,
    uploadMenuLinks,
    secondaryRight,
    showChangeLanguageButton
  };
};

/**
 * 원하는 도메인에 대하여 fallback 메뉴를 생성합니다.
 */
const createFallbackMenuSchema = ({
  subdomain,
  searchMenus,
  location
}) => {
  const currentURLSearchParams = new URLSearchParams(location.search);
  const newURLSearchParams = new URLSearchParams();
  const queryParam = currentURLSearchParams.get('query');
  if (queryParam) {
    newURLSearchParams.set('query', queryParam);
  }
  const searchAffectTypeParam = currentURLSearchParams.get('search_affect_type');
  if (searchAffectTypeParam) {
    newURLSearchParams.set('search_affect_type', searchAffectTypeParam);
  }
  const suggestParam = currentURLSearchParams.get('suggest');
  if (suggestParam) {
    newURLSearchParams.set('suggest', suggestParam);
  }
  const search = newURLSearchParams.size === 0 ? '' : `?${newURLSearchParams.toString()}`;
  const searchMenuSchema = createMenuSchema({
    menus: searchMenus,
    location
  }).map(menu => {
    return {
      ...menu,
      active: !!queryParam && menu.active,
      href: `${menu.href}${search}`
    };
  });
  const getFallbackMenuSchema = () => {
    switch (subdomain) {
      case 'home':
        return searchMenuSchema;
      default:
        return [];
    }
  };
  return getFallbackMenuSchema();
};

const GNBInner = ({
  linkComponent,
  location,
  getDeepLink,
  env,
  logo,
  menus = [],
  supplementary = {
    userMenus: [],
    uploads: []
  },
  searchMenus = [],
  user,
  subdomain,
  secondaryRight,
  trendingKeywords,
  hiddenSearchBar = false,
  serviceType = 'OK',
  localeData,
  signOut = defaultSignOut,
  autoComplete = getDomesticAutoCompleteKeywords
}) => {
  const isGlobal = serviceType === 'OG';
  const {
    open
  } = useSnackbar();
  const handleSignout = useCallback(async () => {
    try {
      const data = await signOut({
        user,
        env
      });
      if (data.success) {
        signoutAirbridge();
        logAmplitude$1('계정 Logout');
        const url = isGlobal ? `${GLOBAL_DOMAINS[env].home}/${location.locale}` : DOMAINS[env].home;
        window.location.href = getURL(subdomain, env, url, serviceType);
      }
    } catch (e) {
      open({
        content: localeData?.failSignout ?? '로그아웃에 실패했습니다. 잠시 후 다시 시도해 주세요.'
      });
    }
  }, [signOut, user, env, isGlobal, subdomain, serviceType, open, localeData?.failSignout, location.locale]);
  const searchOptions = useGNBSearch({
    location,
    env,
    subdomain,
    hiddenSearchBar,
    serviceType,
    autoComplete
  });
  const menuSchema = useMemo(() => createMenuSchema({
    menus,
    location
  }), [menus, location]);
  const fallbackMenuSchema = useMemo(() => createFallbackMenuSchema({
    subdomain,
    searchMenus,
    location
  }), [subdomain, searchMenus, location]);
  const supplementarySchema = createSupplementary({
    user,
    supplementary,
    subdomain,
    env,
    location,
    serviceType,
    secondaryRight: secondaryRight ?? (() => {
      if (searchOptions == null) {
        return null;
      }
      if (trendingKeywords == null || trendingKeywords.length < 1) {
        return null;
      }
      return jsx(TrendingKeywordsDropdown, {
        entries: trendingKeywords,
        historyStorage: searchOptions.historyStorage,
        linkComponent: linkComponent,
        baseUrl: DOMAINS[env].home
      });
    }),
    onSignout: handleSignout
  });
  const handleLog = useCallback(({
    key,
    category,
    params
  }) => {
    const logData = TYPE_MAP[key](params || {})[category];
    const {
      bucket,
      amplitude
    } = logData || {};
    if (bucket) {
      switch (category) {
        case 'impression':
          {
            bucketImpressionLog(bucket);
            break;
          }
        case 'click':
        default:
          {
            bucketClickLog(bucket);
            break;
          }
      }
    }
    if (amplitude) {
      const {
        type,
        data
      } = amplitude;
      logAmplitude$1(`${type}`, data);
    }
  }, []);
  const handleAppDownload = useCallback(() => {
    window.location.href = getDeepLink({
      sub_id_1: 'web_left_bnr'
    });
  }, [getDeepLink]);
  const defaultLogo = useMemo(() => ({
    href: getURL(subdomain, env, DOMAINS[env].home, serviceType)
  }), [env, subdomain, serviceType]);
  return jsx(Navigation, {
    menuSchema: menuSchema,
    searchOptions: searchOptions,
    supplementary: supplementarySchema,
    linkComponent: linkComponent,
    fallbackMenuSchema: fallbackMenuSchema,
    onLog: handleLog,
    onAppDownload: handleAppDownload,
    location: location,
    logo: logo ?? defaultLogo
  });
};
const GNB = ({
  ...params
}) => {
  return jsx(GNBDataProvider, {
    value: {
      isGlobal: params.serviceType === 'OG',
      location: params.location,
      localeData: params.localeData
    },
    children: jsx(GNBInner, {
      ...params
    })
  });
};

const ShareButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1ftxrf30"
} : {
  target: "e1ftxrf30",
  label: "ShareButton"
})(RESET_BUTTON, ";width:", pxToRem(40), ";height:", pxToRem(40), ";margin:0 ", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNoYXJlQnV0dG9uQmFzZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJd0MiLCJmaWxlIjoiU2hhcmVCdXR0b25CYXNlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBSRVNFVF9CVVRUT04sIHB4VG9SZW0gfSBmcm9tICdAYnVja2V0cGxhY2UvZGVzaWduLXN5c3RlbSc7XG5cbmV4cG9ydCBjb25zdCBTaGFyZUJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gICR7UkVTRVRfQlVUVE9OfTtcbiAgd2lkdGg6ICR7cHhUb1JlbSg0MCl9O1xuICBoZWlnaHQ6ICR7cHhUb1JlbSg0MCl9O1xuICBtYXJnaW46IDAgJHtweFRvUmVtKDYpfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBTaGFyZUFuY2hvciA9IFNoYXJlQnV0dG9uLndpdGhDb21wb25lbnQoJ2EnKTtcbiJdfQ== */"));
ShareButton.withComponent('a', process.env.NODE_ENV === "production" ? {
  target: "e1ftxrf31"
} : {
  target: "e1ftxrf31",
  label: "ShareAnchor"
});

var _circle$1, _path$1, _path2$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgIcShareUrl = function SvgIcShareUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAEDEF"
  })), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25 20.65H15v-1.3h10z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.35 20A4.65 4.65 0 0 1 15 15.35h3v1.3h-3a3.35 3.35 0 1 0 0 6.7h3v1.3h-3A4.65 4.65 0 0 1 10.35 20M29.65 20A4.65 4.65 0 0 0 25 15.35h-3v1.3h3a3.35 3.35 0 1 1 0 6.7h-3v1.3h3A4.65 4.65 0 0 0 29.65 20"
  })));
};
var UrlIcon = SvgIcShareUrl;

const ShareHandlerContext = /*#__PURE__*/createContext(undefined);
function ShareHandlerProvider({
  children,
  value
}) {
  return jsx(ShareHandlerContext.Provider, {
    value: value,
    children: children
  });
}
function useShareHandler() {
  return useContext(ShareHandlerContext);
}

const isAndroid13OrAbove = cookie => {
  const parsedCookie = _(cookie);
  const bpPType = parsedCookie['bp-p-type'];
  const bpPVersion = parsedCookie['bp-p-ver'];
  if (bpPType === 'mWebAndroid') {
    const version = bpPVersion.split(', ').find(item => item.includes('Android'))?.split(' ')?.[1];
    return version != null && parseInt(version, 10) >= 13;
  }
  return bpPType === 'Android' && parseInt(bpPVersion, 10) >= 13;
};
function UrlCopyButton(props) {
  const {
    url,
    onShare,
    onError,
    localeData
  } = props;
  const snackbar = useSnackbar();
  const shareHandler = useShareHandler();
  const handleClick = useCallback(async () => {
    try {
      if (!url) {
        return onError?.(new Error('No URL provided to copy'));
      }
      await copyTextToClipboard(url);
      onShare?.();
      shareHandler?.();
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardSuccess ?? '클립보드에 복사되었습니다.'
      });
    } catch (err) {
      console.error(err);
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardFail ?? '클립보드 복사에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [url, onShare, shareHandler, snackbar, localeData?.clipboardSuccess, localeData?.clipboardFail, onError]);
  return jsx(ShareButton, {
    type: "button",
    onClick: handleClick,
    children: jsx(UrlIcon, {
      "aria-label": "\uC8FC\uC18C \uBCF5\uC0AC"
    })
  });
}

var _circle, _path, _path2;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgIcShareKakaotalk = function SvgIcShareKakaotalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F9E000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#371C1D",
    d: "m17.095 18.06.75 2.13h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#371C1D",
    fillRule: "evenodd",
    d: "M6.842 19.253C6.842 13.591 12.664 9 19.846 9s13.003 4.59 13.003 10.253-5.821 10.253-13.003 10.253q-1.184-.001-2.31-.161c-.75.529-5.086 3.574-5.495 3.63 0 0-.168.066-.31-.018-.143-.084-.117-.304-.117-.304.043-.294 1.124-4.026 1.323-4.713-3.661-1.814-6.095-5.026-6.095-8.687m5.064 2.863c0 .395.336.716.75.716s.75-.321.75-.716v-4.457h1.17c.407 0 .737-.33.737-.735a.736.736 0 0 0-.736-.734h-3.842a.736.736 0 0 0-.736.734c0 .405.33.735.736.735h1.17zm6.704.375c.072.204.312.332.625.332.164 0 .327-.036.476-.104.207-.095.406-.358.178-1.067l-1.794-4.721c-.127-.36-.51-.73-1-.741-.49.01-.873.381-1 .74l-1.794 4.724c-.228.707-.03.97.177 1.065.15.068.313.104.477.104.313 0 .552-.127.624-.331l.372-.974h2.288zm1.767-.456c0 .38.323.688.719.688h2.407c.396 0 .719-.309.719-.688s-.323-.688-.719-.688h-1.594V16.94a.76.76 0 0 0-.766-.75.76.76 0 0 0-.766.75zm4.137.037a.751.751 0 0 0 1.5 0v-1.637l.26-.26 1.76 2.33a.75.75 0 0 0 .6.3.74.74 0 0 0 .646-.37.75.75 0 0 0 .08-.57.7.7 0 0 0-.128-.263l-1.847-2.446 1.71-1.71a.58.58 0 0 0 .165-.457.74.74 0 0 0-.22-.475.74.74 0 0 0-.517-.222c-.16 0-.308.06-.416.167l-2.093 2.093V16.94a.751.751 0 0 0-1.5 0z",
    clipRule: "evenodd"
  })));
};
var KakaoTalkIcon = SvgIcShareKakaotalk;

function KakaoTalkButton(props) {
  const {
    kakaoApi,
    templateId,
    templateArgs,
    onShare,
    onError
  } = props;
  const snackbar = useSnackbar();
  const shareHandler = useShareHandler();
  const handleClick = useCallback(() => {
    // Use optimistic handler, ignoring an action when not ready.
    if (kakaoApi == null) {
      return;
    }
    try {
      kakaoApi?.Share.sendCustom({
        templateId,
        templateArgs: templateArgs ?? {},
        installTalk: true
      });
      onShare?.();
      shareHandler?.();
    } catch (err) {
      console.error(err);
      snackbar.open({
        content: '카카오톡 공유에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [kakaoApi, templateId, templateArgs, onShare, shareHandler, snackbar, onError]);
  return jsx(ShareButton, {
    role: "button",
    type: "button",
    onClick: handleClick,
    children: jsx(KakaoTalkIcon, {
      "aria-label": "\uCE74\uCE74\uC624\uD1A1 \uACF5\uC720"
    })
  });
}

function SharePopper(props) {
  const {
    targetElement,
    isOpen,
    onClose,
    onShare,
    children,
    className
  } = props;
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const {
    styles,
    attributes
  } = usePopper(targetElement, popperElement, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 8
      }
    }]
  });
  useEffect(() => {
    const handleClickWindow = ({
      target
    }) => {
      // eslint-disable-next-line react/prop-types
      if (targetElement?.contains(target)) {
        return;
      }
      onClose?.();
    };
    const handleClose = () => onClose?.();
    window.addEventListener('scroll', handleClose);
    window.addEventListener('click', handleClickWindow);
    return () => {
      window.removeEventListener('scroll', handleClose);
      window.removeEventListener('click', handleClickWindow);
    };
  }, [targetElement, onClose]);
  return jsx(CSSTransition$1, {
    in: isOpen,
    timeout: 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open'
    },
    children: jsxs(Popper, {
      ref: setPopperElement,
      style: styles['popper'],
      ...attributes['popper'],
      children: [jsx(Arrow, {
        ref: setArrowElement,
        style: styles['arrow']
      }), jsx(Container, {
        className: className,
        children: jsx(ShareHandlerProvider, {
          value: onShare,
          children: children
        })
      })]
    })
  });
}
SharePopper.UrlCopyButton = UrlCopyButton;
SharePopper.KakaoTalkButton = KakaoTalkButton;
const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f2"
} : {
  target: "e5zrl1f2",
  label: "Container"
})("display:flex;align-items:center;margin:0 ", pxToRem(-6), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Arrow = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f1"
} : {
  target: "e5zrl1f1",
  label: "Arrow"
})("border:", pxToRem(7), " solid transparent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Popper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f0"
} : {
  target: "e5zrl1f0",
  label: "Popper"
})("position:relative;padding:", pxToRem(16), ";white-space:nowrap;border-radius:", pxToRem(8), ";background:", ({
  theme
}) => theme.content.base6, ";box-shadow:rgb(0 0 0 / 12%) 0 ", pxToRem(2), " ", pxToRem(16), ";opacity:0;transition:.2s opacity,.2s margin;pointer-events:none;&[data-popper-placement^='bottom']{margin-top:-10px;", Arrow, "{bottom:100%;border-bottom-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='top']{margin-top:10px;", Arrow, "{top:100%;border-top-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='right']{margin-left:10px;", Arrow, "{right:100%;border-right-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='left']{margin-left:-10px;", Arrow, "{left:100%;border-left-color:", ({
  theme
}) => theme.content.base6, ";}}&.open{margin:0;opacity:1;pointer-events:auto;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

const CRITEO_ACCOUNT = 50838;

/**
 * criteo 전역 객체를 초기화합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * initCriteo(loginUser);
 * ```
 */
const initCriteo = user => {
  if (typeof window === 'undefined') {
    return;
  }
  const _window = window;
  const ua = navigator.userAgent.toLowerCase();
  const mobile = {
    isAndroid: ua.indexOf('android') > -1,
    isIos: ua.match(/(ipad|iphone|ipod)/g)
  };
  const type = mobile.isAndroid || mobile.isIos ? 'm' : 'd';
  _window.criteo_q = _window.criteo_q || [];
  _window.criteo_q.push({
    event: 'setAccount',
    account: CRITEO_ACCOUNT
  }, {
    event: 'setEmail',
    email: user ? `${user.id}@bucketplace.net` : ''
  }, {
    event: 'setSiteType',
    type
  });
};

const PIXEL_ID = '937204509645248';

/**
 * Facebook pixel script를 로드합니다.
 * @returns {string} facebook pixel load script
 * @example
 * ```
 * <Script
 *   id="load-facebook-pixel"
 *   strategy="beforeInteractive"
 *   dangerouslySetInnerHTML={{ __html: getFacebookPixelScript() }}
 * />
 * <noscript>
 *   <img
 *     width="1"
 *     height="1"
 *     style={{ display: 'none' }}
 *     src="https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
 *   />
 * </noscript>
 * ```
 */
const getFacebookPixelScript = () => {
  return `
    !(function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded =!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);})(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('set', 'autoConfig', 'false', '${PIXEL_ID}');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `;
};

/**
 * Facebook pixel log를 전송합니다.
 * @see {@link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking}
 * @param eventName 이벤트 이름
 * @param properties 로깅할 데이터
 * @example
 * ```
 * logFacebookPixel('AddToCart', {
 *   content_name: 'name',
 *   content_type: 'product',
 *   contents: [],
 *   currentcy: 'KRW',
 * });
 * ```
 */
const logFacebookPixel = (eventName, properties) => {
  if (!window.fbq) {
    return;
  }
  window.fbq('track', eventName, properties);
};

const KAKAO_ID = '7919701595446099671';
/**
 * kakao pixel 전역 객체를 초기화합니다.
 * @example
 * ```
 * <Script
 *   src="https://t1.daumcdn.net/adfit/static/kp.js"
 *   onLoad={() => initKakaoPixel()}
 * />
 * ```
 */
const initKakaoPixel = () => {
  if (!window.kakaoPixel) {
    return;
  }
  window.kakaoPixel(KAKAO_ID).pageView();
};

const NAVER_ID = 's_2e85116be219';
const OHOUSE_URL = 'ohou.se';
/**
 * naver analytics 전역 객체를 생성합니다.
 * @example
 * ```
 * <Script
 *   src="https://wcs.naver.net/wcslog.js"
 *   onLoad={() => initNaverAnalytics()}
 *   async
 * />
 * ```
 */
const initNaverAnalycis = () => {
  if (!window || window.wcs == null) {
    return;
  }
  if (!window.wcs_add) {
    window.wcs_add = {};
  }
  window.wcs_add['wa'] = NAVER_ID;
  if (!window._nasa) {
    window._nasa = {};
  }
  window.wcs.inflow(OHOUSE_URL);
  if (window.wcs_do) {
    window.wcs_do(window._nasa);
  }
};

const DEEP_LINK_HOST = 'https://link.ohou.se/@ohouse';
const GLOBAL_DEEP_LINK_HOST = 'https://link.ohouse.com/@globalohouse';

/**
 * query 에서 제외해야하는 blacklist
 */
const QUERY_BLACKLIST = ['airbridge_referrer', 'fallback_ios', 'fallback_android', 'short_id', 'https_deeplink', 'campaign', 'ad_group', 'ad_creative', 'term', 'deeplink_url', 'fallback_desktop', 'n_media', 'n_query', 'n_rank', 'n_ad_group', 'n_ad', 'n_keyword_id', 'n_keyword', 'n_campaign_type', 'n_ad_group_type', 'NaPm', 'routing_short_id', 'content', 'sub_id_1', 'sub_id_2', 'sub_id_3', 'campaign_id', 'ad_group_id', 'ad_creative_id', 'term_id'];

/** 사용하는 utm tags */
const UTM_TAGS = ['source', 'utm_source', 'utm_campaign', 'utm_content', 'utm_media', 'utm_term', 'utm_medium', 'bp_adset', 'bp_content', 'bp_sub_id', 'bp_sub_id_1', 'bp_sub_id_2'];

/**
 * 객체의 값에서 `/{}`, `_{}`, `{}`로 감싸진 문자열을 제거합니다.
 * 제거된 결과가 빈 문자열인 경우, 리턴되는 객체에서 해당 키를 삭제합니다.
 * @param query escape 처리할 객체
 * @return escape 처리된 객체
 * @example
 * escapeBracesInQuery({ test: 'foo_{bar}' })
 * escapeBracesInQuery({ test: 'foo/{bar}' })
 * escapeBracesInQuery({ test: 'foo{bar}' })
 * { test: 'foo' }
 * escapeBracesInQuery({ test: '{foo}' })
 * {}
 * ```
 */
const escapeBracesInQuery = query => {
  const trimmed = Object.fromEntries(Object.entries(query).map(([key, value]) => {
    return [key, value?.replace?.(/([/\\_]?{[^}]+})+/g, '')];
  }));
  return pickBy(trimmed, Boolean);
};

/**
 * sesisonStorage에서 ohsUtmData를 가져옵니다.
 * @returns UTM_TAGS가 포함된 object
 */
const getUtmData = () => {
  try {
    return JSON.parse(sessionStorage['ohsUtmData'] || '{}');
  } catch (e) {
    //
    return {};
  }
};

/**
 * NOTE This relies on document / window object. Therefore, SSR is not possible
 * with this - it's recommend to use location.href = getDeepLink() or
 * equivalent to defer retriving UTM data.
 * query에서 블랙리스트를 제외하고 utm tags 기반으로 deeplink를 생성
 * @param additionalParams 추가로 더 포함할 params
 * @param pathname pathname
 * @param query query
 * @param host 각 호스트 store.ohou.se, contents.ohou.se, o2o.ohou.se
 * @param fallbackDesktopUrl fallback url
 * @param isOwap owap 유무
 * @param isGlobal global 유무
 */
function getDeepLink({
  additionalParams,
  pathname,
  query,
  host,
  fallbackDesktopUrl,
  isOwap,
  isGlobal
} = {}) {
  const queryObj = getQuery(query ?? location.search);
  const essentialQuery = pickBy({
    ...omit(queryObj, [...UTM_TAGS, ...QUERY_BLACKLIST])
  }, value => value != null);
  const escapedQuery = escapeBracesInQuery(essentialQuery);
  const searchString = queryString.stringify(escapedQuery);
  const deepLinkPath = pathname ?? location.pathname;
  const path = `${deepLinkPath}?${searchString}`;
  const utmData = getUtmData();
  const owapDeepLink = `ohouseapp://owap?url=https://${host}${path}&webviewType=page`;
  const deepLinkHost = isGlobal ? GLOBAL_DEEP_LINK_HOST : DEEP_LINK_HOST;
  const result = `${deepLinkHost}/${utmData['utm_source'] || 'web_organic'}?${queryString.stringify({
    deeplink_url: isOwap ? owapDeepLink : `${isGlobal ? 'ohouseglobalapp' : 'ohouseapp'}://${host}${path}`,
    // fallback_desktop을 공통으로 사용하려면 window.location.href 가 필요하지 않을까?
    fallback_desktop: fallbackDesktopUrl ?? window.location.href,
    campaign: queryObj['campaign'] || utmData['utm_campaign'],
    term: queryObj['term'] || utmData['utm_term'],
    client_id: M$1('visitor_id'),
    sub_id: queryObj['sub_id'] || utmData['bp_sub_id'],
    sub_id_1: 'ohouseWeb',
    sub_id_2: queryObj['sub_id_2'] || utmData['bp_sub_id_2'],
    sub_id_3: queryObj['sub_id_3'] || utmData['utm_medium'],
    ad_creative: queryObj['ad_creative'] || utmData['utm_content'],
    ad_group: queryObj['ad_group'] || utmData['bp_adset'],
    content: queryObj['content'] || utmData['bp_content'],
    ...(additionalParams ?? {})
  })}`;
  return result;
}

/**
 * 기존 있던 url에 query들을 연결시켜 주는 함수
 * @param url 기존 url
 * @param query 새로 붙일 query
 * @returns 연결된 url
 * @example
 * ```
 * joinLinkQuery('ohou.se/store?a=1&b=2', 'c=3&d=4')
 * ohou.se/store?a=1&b=2&c=3&d=4
 * ```
 */
const joinLinkQuery = (url, query) => {
  const pattern = /^([^?#]+)(\?[^?#]+)?(#.+?)?$/.exec(url);
  if (pattern == null) {
    return url;
  }
  const [, pathname, urlQuery, urlHash] = pattern;
  return pathname + (urlQuery ?? '') + (urlQuery != null ? '&' : '?') + query + (urlHash ?? '');
};

/**
 * 쿼리 문자열에서 utm 파라미터 객체를 추출합니다.
 * @param queryString utmData를 추출하고픈 target 쿼리 문자열
 * @return object 추출된 utm 파라미터 객체
 */
const getUtmDataFromUrl = queryString => {
  const query = getQuery(queryString ?? location.search);
  const utmQuery = pick$2(query, UTM_TAGS);
  return escapeBracesInQuery(utmQuery);
};

/**
 * 현재 url의 utmData를 추출하여 sessionStorage에 저장합니다.
 */
const setUtmData = () => {
  const urlData = getUtmDataFromUrl();
  if (isEmpty(urlData)) {
    return;
  }
  try {
    sessionStorage.setItem('ohsUtmData', JSON.stringify(urlData));
  } catch (e) {
    //
  }
};

const WP_TRACKING_ID = '47350';
const WP_TRACKING_TAG_TYPE = 'Home';
/**
 * wider planet script를 로드합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * <div id="wp_tg_cts" style={{ display: 'none' }} />
 * <Script id="init-wp">
 *   { `${initWiderPlanet(navigation.loginUser)}` }
 * </Script>
 * <Script src="https://cdn-aitg.widerplanet.com/js/wp_astg_4.0.js" async />
 * ```
 */
const initWiderPlanet = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  window.wptg_tagscript_vars.push(() => {
    return {
      wp_hcuid: user?.id ?? '',
      ti: WP_TRACKING_ID,
      ty: WP_TRACKING_TAG_TYPE,
      device: navigator.userAgent.match(/ios|iphone|ipad|android/i) ? 'mobile' : 'web'
    };
  });
};

/**
 * 버킷로그 전역 객체를 초기화합니다.
 * 유저 정보가 있으면 버킷로그 데이터 큐에 유저 아이디를 넣습니다.
 * @param {User} user 로그인 유저 데이터
 * @example
 * ```
 * initBucketLog(user)
 * ```
 */
const initBucketLog = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.bucketLog = window.bucketLog || [];
  if (user) {
    window.bucketLog.push({
      user_id: user.id
    });
  }
};

/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
  log: 'log',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error'
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
  originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
  debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
  log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
  info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
  warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
  error: originalConsoleMethods.error.bind(globalConsole, PREFIX)
};
var DOCS_ORIGIN = 'https://docs.datadoghq.com';

function catchUserErrors(fn, errorMsg) {
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      return fn.apply(void 0, args);
    } catch (err) {
      display.error(errorMsg, err);
    }
  };
}

/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
  return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
  return +num.toFixed(decimals);
}
function isPercentage(value) {
  return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
  return typeof value === 'number';
}

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
  return {
    relative: relative,
    timeStamp: getCorrectedTimeStamp(relative)
  };
}
function timeStampToClocks(timeStamp) {
  return {
    relative: getRelativeTime(timeStamp),
    timeStamp: timeStamp
  };
}
function getCorrectedTimeStamp(relativeTime) {
  var correctedOrigin = dateNow() - performance.now();
  // apply correction only for positive drift
  if (correctedOrigin > getNavigationStart()) {
    return Math.round(addDuration(correctedOrigin, relativeTime));
  }
  return getTimeStamp$1(relativeTime);
}
function currentDrift() {
  return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
  if (!isNumber(duration)) {
    return duration;
  }
  return round(duration * 1e6, 0);
}
function dateNow() {
  // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
  // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
  // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
  // case ourselves.
  // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
  return new Date().getTime();
}
function timeStampNow() {
  return dateNow();
}
function relativeNow() {
  return performance.now();
}
function clocksNow() {
  return {
    relative: relativeNow(),
    timeStamp: timeStampNow()
  };
}
function clocksOrigin() {
  return {
    relative: 0,
    timeStamp: getNavigationStart()
  };
}
function elapsed(start, end) {
  return end - start;
}
function addDuration(a, b) {
  return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
  return timestamp - getNavigationStart();
}
function getTimeStamp$1(relativeTime) {
  return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
  return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
  if (navigationStart === undefined) {
    navigationStart = performance.timing.navigationStart;
  }
  return navigationStart;
}

var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
  // Accurate bytes count computations can degrade performances when there is a lot of events to process
  if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
    return candidate.length;
  }
  if (window.TextEncoder !== undefined) {
    return new TextEncoder().encode(candidate).length;
  }
  return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
  var length = buffers.reduce(function (total, buffer) {
    return total + buffer.length;
  }, 0);
  var result = new Uint8Array(length);
  var offset = 0;
  for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
    var buffer = buffers_1[_i];
    result.set(buffer, offset);
    offset += buffer.length;
  }
  return result;
}

function includes(candidate, search) {
  return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
  if (Array.from) {
    return Array.from(arrayLike);
  }
  var array = [];
  if (arrayLike instanceof Set) {
    arrayLike.forEach(function (item) {
      return array.push(item);
    });
  } else {
    for (var i = 0; i < arrayLike.length; i++) {
      array.push(arrayLike[i]);
    }
  }
  return array;
}
function find(array, predicate) {
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];
    if (predicate(item, i)) {
      return item;
    }
  }
  return undefined;
}
function findLast(array, predicate) {
  for (var i = array.length - 1; i >= 0; i -= 1) {
    var item = array[i];
    if (predicate(item, i, array)) {
      return item;
    }
  }
  return undefined;
}
function forEach(list, callback) {
  Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
}
function objectEntries(object) {
  return Object.keys(object).map(function (key) {
    return [key, object[key]];
  });
}
function startsWith$1(candidate, search) {
  return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
  return candidate.slice(-search.length) === search;
}
function assign(target) {
  var toAssign = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    toAssign[_i - 1] = arguments[_i];
  }
  toAssign.forEach(function (source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function shallowClone(object) {
  return assign({}, object);
}
function objectHasValue(object, value) {
  return Object.keys(object).some(function (key) {
    return object[key] === value;
  });
}
function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
  var newObject = {};
  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var key = _a[_i];
    newObject[key] = fn(object[key]);
  }
  return newObject;
}

/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
  if (typeof globalThis === 'object') {
    return globalThis;
  }
  Object.defineProperty(Object.prototype, '_dd_temp_', {
    get: function () {
      return this;
    },
    configurable: true
  });
  // @ts-ignore _dd_temp is defined using defineProperty
  var globalObject = _dd_temp_;
  // @ts-ignore _dd_temp is defined using defineProperty
  delete Object.prototype._dd_temp_;
  if (typeof globalObject !== 'object') {
    // on safari _dd_temp_ is available on window but not globally
    // fallback on other browser globals check
    if (typeof self === 'object') {
      globalObject = self;
    } else if (typeof window === 'object') {
      globalObject = window;
    } else {
      globalObject = {};
    }
  }
  return globalObject;
}

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
  var browserWindow = getGlobalObject();
  var original;
  if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
    original = target[browserWindow.Zone.__symbol__(name)];
  }
  if (!original) {
    original = target[name];
  }
  return original;
}

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
  onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
  debugMode = newDebugMode;
}
function monitor(fn) {
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return callMonitored(fn, this, arguments);
  }; // consider output type has input type
}
function callMonitored(fn, context, args) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return fn.apply(context, args);
  } catch (e) {
    displayIfDebugEnabled(e);
    if (onMonitorErrorCollected) {
      try {
        onMonitorErrorCollected(e);
      } catch (e) {
        displayIfDebugEnabled(e);
      }
    }
  }
}
function displayIfDebugEnabled() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  if (debugMode) {
    display.error.apply(display, __spreadArray(['[MONITOR]'], args, false));
  }
}

function setTimeout$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setTimeout')(monitor(callback), delay);
}
function clearTimeout$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearTimeout')(timeoutId);
}
function setInterval$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setInterval')(monitor(callback), delay);
}
function clearInterval$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearInterval')(timeoutId);
}

var Observable = /** @class */function () {
  function Observable(onFirstSubscribe) {
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }
  Observable.prototype.subscribe = function (f) {
    var _this = this;
    this.observers.push(f);
    if (this.observers.length === 1 && this.onFirstSubscribe) {
      this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
    }
    return {
      unsubscribe: function () {
        _this.observers = _this.observers.filter(function (other) {
          return f !== other;
        });
        if (!_this.observers.length && _this.onLastUnsubscribe) {
          _this.onLastUnsubscribe();
        }
      }
    };
  };
  Observable.prototype.notify = function (data) {
    this.observers.forEach(function (observer) {
      return observer(data);
    });
  };
  return Observable;
}();
function mergeObservables() {
  var observables = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    observables[_i] = arguments[_i];
  }
  return new Observable(function (globalObservable) {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
}

// use lodash API
function throttle(fn, wait, options) {
  var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
  var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
  var inWaitPeriod = false;
  var pendingExecutionWithParameters;
  var pendingTimeoutId;
  return {
    throttled: function () {
      var parameters = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        parameters[_i] = arguments[_i];
      }
      if (inWaitPeriod) {
        pendingExecutionWithParameters = parameters;
        return;
      }
      if (needLeadingExecution) {
        fn.apply(void 0, parameters);
      } else {
        pendingExecutionWithParameters = parameters;
      }
      inWaitPeriod = true;
      pendingTimeoutId = setTimeout$1(function () {
        if (needTrailingExecution && pendingExecutionWithParameters) {
          fn.apply(void 0, pendingExecutionWithParameters);
        }
        inWaitPeriod = false;
        pendingExecutionWithParameters = undefined;
      }, wait);
    },
    cancel: function () {
      clearTimeout$1(pendingTimeoutId);
      inWaitPeriod = false;
      pendingExecutionWithParameters = undefined;
    }
  };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop$1() {}

/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
  return placeholder ?
  // eslint-disable-next-line  no-bitwise
  (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      if (match[1] === name) {
        return match[2];
      }
    } else {
      break;
    }
  }
}
function findCommaSeparatedValues(rawString) {
  var result = new Map();
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      result.set(match[1], match[2]);
    } else {
      break;
    }
  }
  return result;
}
function safeTruncate(candidate, length, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }
  var lastChar = candidate.charCodeAt(length - 1);
  var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
  var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
  if (candidate.length <= correctedLength) {
    return candidate;
  }
  return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

function isIE() {
  return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
  return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
  return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
  return browserCache !== null && browserCache !== void 0 ? browserCache : browserCache = detectBrowser();
}
// Exported only for tests
function detectBrowser(browserWindow) {
  var _a;
  if (browserWindow === void 0) {
    browserWindow = window;
  }
  var userAgent = browserWindow.navigator.userAgent;
  if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
    return 1 /* Browser.CHROMIUM */;
  }
  if (
  // navigator.vendor is deprecated, but it is the most resilient way we found to detect
  // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
  // useragent test as a semi-working fallback.
  ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) {
    return 2 /* Browser.SAFARI */;
  }
  if (browserWindow.document.documentMode) {
    return 0 /* Browser.IE */;
  }
  return 3 /* Browser.OTHER */;
}

function setCookie(name, value, expireDelay, options) {
  var date = new Date();
  date.setTime(date.getTime() + expireDelay);
  var expires = "expires=".concat(date.toUTCString());
  var sameSite = options && options.crossSite ? 'none' : 'strict';
  var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
  var secure = options && options.secure ? ';secure' : '';
  var partitioned = options && options.partitioned ? ';partitioned' : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function getCookie(name) {
  return findCommaSeparatedValue(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
  if (!initCookieParsed) {
    initCookieParsed = findCommaSeparatedValues(document.cookie);
  }
  return initCookieParsed.get(name);
}
function deleteCookie(name, options) {
  setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
  if (document.cookie === undefined || document.cookie === null) {
    return false;
  }
  try {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_cookie_test_".concat(generateUUID());
    var testCookieValue = 'test';
    setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
    var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
    deleteCookie(testCookieName, options);
    return isCookieCorrectlySet;
  } catch (error) {
    display.error(error);
    return false;
  }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
  if (getCurrentSiteCache === undefined) {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_site_test_".concat(generateUUID());
    var testCookieValue = 'test';
    var domainLevels = window.location.hostname.split('.');
    var candidateDomain = domainLevels.pop();
    while (domainLevels.length && !getCookie(testCookieName)) {
      candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
      setCookie(testCookieName, testCookieValue, ONE_SECOND, {
        domain: candidateDomain
      });
    }
    deleteCookie(testCookieName, {
      domain: candidateDomain
    });
    getCurrentSiteCache = candidateDomain;
  }
  return getCurrentSiteCache;
}

var SESSION_STORE_KEY = '_dd_s';

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;

var SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var EXPIRED = '1';
function getExpiredSessionState() {
  return {
    isExpired: EXPIRED
  };
}
function isSessionInNotStartedState(session) {
  return isEmptyObject(session);
}
function isSessionStarted(session) {
  return !isSessionInNotStartedState(session);
}
function isSessionInExpiredState(session) {
  return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
  // created and expire can be undefined for versions which was not storing them
  // these checks could be removed when older versions will not be available/live anymore
  return (sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) && (sessionState.expire === undefined || dateNow() < Number(sessionState.expire));
}
function expandSessionState(session) {
  session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
function toSessionString(session) {
  return objectEntries(session).map(function (_a) {
    var key = _a[0],
      value = _a[1];
    return "".concat(key, "=").concat(value);
  }).join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
  var session = {};
  if (isValidSessionString(sessionString)) {
    sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
      var matches = SESSION_ENTRY_REGEXP.exec(entry);
      if (matches !== null) {
        var key = matches[1],
          value = matches[2];
        session[key] = value;
      }
    });
  }
  return session;
}
function isValidSessionString(sessionString) {
  return !!sessionString && (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString));
}

var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY$1 = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
  var sessionString = getInitCookie(SESSION_STORE_KEY);
  if (!sessionString) {
    var oldSessionId = getInitCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getInitCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getInitCookie(OLD_LOGS_COOKIE_NAME);
    var session = {};
    if (oldSessionId) {
      session.id = oldSessionId;
    }
    if (oldLogsType && /^[01]$/.test(oldLogsType)) {
      session[LOGS_SESSION_KEY] = oldLogsType;
    }
    if (oldRumType && /^[012]$/.test(oldRumType)) {
      session[RUM_SESSION_KEY$1] = oldRumType;
    }
    if (isSessionStarted(session)) {
      expandSessionState(session);
      cookieStoreStrategy.persistSession(session);
    }
  }
}

function selectCookieStrategy(initConfiguration) {
  var cookieOptions = buildCookieOptions(initConfiguration);
  return areCookiesAuthorized(cookieOptions) ? {
    type: 'Cookie',
    cookieOptions: cookieOptions
  } : undefined;
}
function initCookieStrategy(cookieOptions) {
  var cookieStore = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: isChromium(),
    persistSession: persistSessionCookie(cookieOptions),
    retrieveSession: retrieveSessionCookie,
    expireSession: function () {
      return expireSessionCookie(cookieOptions);
    }
  };
  tryOldCookiesMigration(cookieStore);
  return cookieStore;
}
function persistSessionCookie(options) {
  return function (session) {
    setCookie(SESSION_STORE_KEY, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
  };
}
function expireSessionCookie(options) {
  setCookie(SESSION_STORE_KEY, toSessionString(getExpiredSessionState()), SESSION_TIME_OUT_DELAY, options);
}
function retrieveSessionCookie() {
  var sessionString = getCookie(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function buildCookieOptions(initConfiguration) {
  var cookieOptions = {};
  cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
  if (initConfiguration.trackSessionAcrossSubdomains) {
    cookieOptions.domain = getCurrentSite();
  }
  return cookieOptions;
}

var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
  try {
    var id = generateUUID();
    var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
    localStorage.setItem(testKey, id);
    var retrievedId = localStorage.getItem(testKey);
    localStorage.removeItem(testKey);
    return id === retrievedId ? {
      type: 'LocalStorage'
    } : undefined;
  } catch (e) {
    return undefined;
  }
}
function initLocalStorageStrategy() {
  return {
    isLockEnabled: false,
    persistSession: persistInLocalStorage,
    retrieveSession: retrieveSessionFromLocalStorage,
    expireSession: expireSessionFromLocalStorage
  };
}
function persistInLocalStorage(sessionState) {
  localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
  var sessionString = localStorage.getItem(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function expireSessionFromLocalStorage() {
  persistInLocalStorage(getExpiredSessionState());
}

var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
  var _a;
  if (numberOfRetries === void 0) {
    numberOfRetries = 0;
  }
  var isLockEnabled = sessionStoreStrategy.isLockEnabled,
    persistSession = sessionStoreStrategy.persistSession,
    expireSession = sessionStoreStrategy.expireSession;
  var persistWithLock = function (session) {
    return persistSession(assign({}, session, {
      lock: currentLock
    }));
  };
  var retrieveStore = function () {
    var session = sessionStoreStrategy.retrieveSession();
    var lock = session.lock;
    if (session.lock) {
      delete session.lock;
    }
    return {
      session: session,
      lock: lock
    };
  };
  if (!ongoingOperations) {
    ongoingOperations = operations;
  }
  if (operations !== ongoingOperations) {
    bufferedOperations.push(operations);
    return;
  }
  if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
    next(sessionStoreStrategy);
    return;
  }
  var currentLock;
  var currentStore = retrieveStore();
  if (isLockEnabled) {
    // if someone has lock, retry later
    if (currentStore.lock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
    // acquire lock
    currentLock = generateUUID();
    persistWithLock(currentStore.session);
    // if lock is not acquired, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  var processedSession = operations.process(currentStore.session);
  if (isLockEnabled) {
    // if lock corrupted after process, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  if (processedSession) {
    if (isSessionInExpiredState(processedSession)) {
      expireSession();
    } else {
      expandSessionState(processedSession);
      isLockEnabled ? persistWithLock(processedSession) : persistSession(processedSession);
    }
  }
  if (isLockEnabled) {
    // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    if (!(processedSession && isSessionInExpiredState(processedSession))) {
      // if lock corrupted after persist, retry later
      currentStore = retrieveStore();
      if (currentStore.lock !== currentLock) {
        retryLater(operations, sessionStoreStrategy, numberOfRetries);
        return;
      }
      persistSession(currentStore.session);
      processedSession = currentStore.session;
    }
  }
  // call after even if session is not persisted in order to perform operations on
  // up-to-date session state value => the value could have been modified by another tab
  (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
  next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
  setTimeout$1(function () {
    processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
  }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
  ongoingOperations = undefined;
  var nextOperations = bufferedOperations.shift();
  if (nextOperations) {
    processSessionStoreOperations(nextOperations, sessionStore);
  }
}

/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
  var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
  if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
    sessionStoreStrategyType = selectLocalStorageStrategy();
  }
  return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  var sessionStateUpdateObservable = new Observable();
  var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie' ? initCookieStrategy(sessionStoreStrategyType.cookieOptions) : initLocalStorageStrategy();
  var expireSession = sessionStoreStrategy.expireSession;
  var watchSessionTimeoutId = setInterval$1(watchSession, STORAGE_POLL_DELAY);
  var sessionCache;
  startSession();
  var _a = throttle(function () {
      processSessionStoreOperations({
        process: function (sessionState) {
          if (isSessionInNotStartedState(sessionState)) {
            return;
          }
          var synchronizedSession = synchronizeSession(sessionState);
          expandOrRenewSessionState(synchronizedSession);
          return synchronizedSession;
        },
        after: function (sessionState) {
          if (isSessionStarted(sessionState) && !hasSessionInCache()) {
            renewSessionInCache(sessionState);
          }
          sessionCache = sessionState;
        }
      }, sessionStoreStrategy);
    }, STORAGE_POLL_DELAY),
    throttledExpandOrRenewSession = _a.throttled,
    cancelExpandOrRenewSession = _a.cancel;
  function expandSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
      }
    }, sessionStoreStrategy);
  }
  /**
   * allows two behaviors:
   * - if the session is active, synchronize the session cache without updating the session store
   * - if the session is not active, clear the session store and expire the session cache
   */
  function watchSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return isSessionInExpiredState(sessionState) ? getExpiredSessionState() : undefined;
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  function synchronizeSession(sessionState) {
    if (isSessionInExpiredState(sessionState)) {
      sessionState = getExpiredSessionState();
    }
    if (hasSessionInCache()) {
      if (isSessionInCacheOutdated(sessionState)) {
        expireSessionInCache();
      } else {
        sessionStateUpdateObservable.notify({
          previousState: sessionCache,
          newState: sessionState
        });
        sessionCache = sessionState;
      }
    }
    return sessionState;
  }
  function startSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        if (isSessionInNotStartedState(sessionState)) {
          return getExpiredSessionState();
        }
      },
      after: function (sessionState) {
        sessionCache = sessionState;
      }
    }, sessionStoreStrategy);
  }
  function expandOrRenewSessionState(sessionState) {
    if (isSessionInNotStartedState(sessionState)) {
      return false;
    }
    var _a = computeSessionState(sessionState[productKey]),
      trackingType = _a.trackingType,
      isTracked = _a.isTracked;
    sessionState[productKey] = trackingType;
    delete sessionState.isExpired;
    if (isTracked && !sessionState.id) {
      sessionState.id = generateUUID();
      sessionState.created = String(dateNow());
    }
  }
  function hasSessionInCache() {
    return sessionCache[productKey] !== undefined;
  }
  function isSessionInCacheOutdated(sessionState) {
    return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
  }
  function expireSessionInCache() {
    sessionCache = getExpiredSessionState();
    expireObservable.notify();
  }
  function renewSessionInCache(sessionState) {
    sessionCache = sessionState;
    renewObservable.notify();
  }
  function updateSessionState(partialSessionState) {
    processSessionStoreOperations({
      process: function (sessionState) {
        return assign({}, sessionState, partialSessionState);
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  return {
    expandOrRenewSession: throttledExpandOrRenewSession,
    expandSession: expandSession,
    getSession: function () {
      return sessionCache;
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStateUpdateObservable,
    restartSession: startSession,
    expire: function () {
      cancelExpandOrRenewSession();
      expireSession();
      synchronizeSession(getExpiredSessionState());
    },
    stop: function () {
      clearInterval$1(watchSessionTimeoutId);
    },
    updateSessionState: updateSessionState
  };
}

var TrackingConsent = {
  GRANTED: 'granted',
  NOT_GRANTED: 'not-granted'
};
function createTrackingConsentState(currentConsent) {
  var observable = new Observable();
  return {
    tryToInit: function (trackingConsent) {
      if (!currentConsent) {
        currentConsent = trackingConsent;
      }
    },
    update: function (trackingConsent) {
      currentConsent = trackingConsent;
      observable.notify();
    },
    isGranted: function () {
      return currentConsent === TrackingConsent.GRANTED;
    },
    observable: observable
  };
}

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
  if (typeof value !== 'object' || value === null) {
    return JSON.stringify(value);
  }
  // Note: The order matter here. We need to detach toJSON methods on parent classes before their
  // subclasses.
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
  var restoreValueToJson = detachToJsonMethod(value);
  try {
    return JSON.stringify(value, replacer, space);
  } catch (_a) {
    return '<error: unable to serialize object>';
  } finally {
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    restoreValuePrototypeToJson();
    restoreValueToJson();
  }
}
function detachToJsonMethod(value) {
  var object = value;
  var objectToJson = object.toJSON;
  if (objectToJson) {
    delete object.toJSON;
    return function () {
      object.toJSON = objectToJson;
    };
  }
  return noop$1;
}

function normalizeUrl(url) {
  return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
  try {
    return !!buildUrl(url);
  } catch (_a) {
    return false;
  }
}
function getPathName(url) {
  var pathname = buildUrl(url).pathname;
  return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
  var supportedURL = getSupportedUrl();
  if (supportedURL) {
    try {
      return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
      throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify({
        url: url,
        base: base
      })));
    }
  }
  if (base === undefined && !/:/.test(url)) {
    throw new Error("Invalid URL: '".concat(url, "'"));
  }
  var doc = document;
  var anchorElement = doc.createElement('a');
  if (base !== undefined) {
    doc = document.implementation.createHTMLDocument('');
    var baseElement = doc.createElement('base');
    baseElement.href = base;
    doc.head.appendChild(baseElement);
    doc.body.appendChild(anchorElement);
  }
  anchorElement.href = url;
  return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
  if (isURLSupported === undefined) {
    try {
      var url = new originalURL('http://test/path');
      isURLSupported = url.href === 'http://test/path';
    } catch (_a) {
      isURLSupported = false;
    }
  }
  return isURLSupported ? originalURL : undefined;
}

var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
var PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';

function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
  var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
  return {
    build: function (api, payload) {
      var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
      return buildUrlWithParameters(parameters);
    },
    urlPrefix: buildUrlWithParameters(''),
    trackType: trackType
  };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
  var path = "/api/v2/".concat(trackType);
  var proxy = initConfiguration.proxy;
  if (typeof proxy === 'string') {
    var normalizedProxyUrl_1 = normalizeUrl(proxy);
    return function (parameters) {
      return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
    };
  }
  if (typeof proxy === 'function') {
    return function (parameters) {
      return proxy({
        path: path,
        parameters: parameters
      });
    };
  }
  var host = buildEndpointHost(trackType, initConfiguration);
  return function (parameters) {
    return "https://".concat(host).concat(path, "?").concat(parameters);
  };
}
function buildEndpointHost(trackType, initConfiguration) {
  var _a = initConfiguration.site,
    site = _a === void 0 ? INTAKE_SITE_US1 : _a,
    internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
  if (trackType === 'logs' && initConfiguration.usePciIntake && site === INTAKE_SITE_US1) {
    return PCI_INTAKE_HOST_US1;
  }
  if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
    return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
  }
  if (site === INTAKE_SITE_FED_STAGING) {
    return "http-intake.logs.".concat(site);
  }
  var domainParts = site.split('.');
  var extension = domainParts.pop();
  return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
  var clientToken = _a.clientToken,
    internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
  var retry = _b.retry,
    encoding = _b.encoding;
  var tags = ["sdk_version:".concat("5.23.0"), "api:".concat(api)].concat(configurationTags);
  if (retry) {
    tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
  }
  var parameters = ['ddsource=browser', "ddtags=".concat(encodeURIComponent(tags.join(','))), "dd-api-key=".concat(clientToken), "dd-evp-origin-version=".concat(encodeURIComponent("5.23.0")), 'dd-evp-origin=browser', "dd-request-id=".concat(generateUUID())];
  if (encoding) {
    parameters.push("dd-evp-encoding=".concat(encoding));
  }
  if (trackType === 'rum') {
    parameters.push("batch_time=".concat(timeStampNow()));
  }
  if (internalAnalyticsSubdomain) {
    parameters.reverse();
  }
  return parameters.join('&');
}

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
  var env = configuration.env,
    service = configuration.service,
    version = configuration.version,
    datacenter = configuration.datacenter;
  var tags = [];
  if (env) {
    tags.push(buildTag('env', env));
  }
  if (service) {
    tags.push(buildTag('service', service));
  }
  if (version) {
    tags.push(buildTag('version', version));
  }
  if (datacenter) {
    tags.push(buildTag('datacenter', datacenter));
  }
  return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
  // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
  // that the backend may not follow the exact same rules, so we only want to display an informal
  // warning.
  var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
  if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
    display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. More details: ").concat(DOCS_ORIGIN, "/getting_started/tagging/#defining-tags"));
  }
  // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
  // by forging a value containing commas.
  var sanitizedValue = rawValue.replace(/,/g, '_');
  return "".concat(key, ":").concat(sanitizedValue);
}

function computeTransportConfiguration(initConfiguration) {
  var site = initConfiguration.site || INTAKE_SITE_US1;
  var tags = buildTags(initConfiguration);
  var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
  var intakeUrlPrefixes = computeIntakeUrlPrefixes(endpointBuilders, site);
  var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
  return assign({
    isIntakeUrl: function (url) {
      return intakeUrlPrefixes.some(function (intakeEndpoint) {
        return url.indexOf(intakeEndpoint) === 0;
      });
    },
    replica: replicaConfiguration,
    site: site
  }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
  return {
    logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
    sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags)
  };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
  if (!initConfiguration.replica) {
    return;
  }
  var replicaConfiguration = assign({}, initConfiguration, {
    site: INTAKE_SITE_US1,
    clientToken: initConfiguration.replica.clientToken
  });
  var replicaEndpointBuilders = {
    logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags)
  };
  intakeUrlPrefixes.push.apply(intakeUrlPrefixes, objectValues(replicaEndpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  }));
  return assign({
    applicationId: initConfiguration.replica.applicationId
  }, replicaEndpointBuilders);
}
function computeIntakeUrlPrefixes(endpointBuilders, site) {
  var intakeUrlPrefixes = objectValues(endpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  });
  if (site === INTAKE_SITE_US1) {
    intakeUrlPrefixes.push("https://".concat(PCI_INTAKE_HOST_US1, "/"));
  }
  return intakeUrlPrefixes;
}

var DefaultPrivacyLevel = {
  ALLOW: 'allow',
  MASK: 'mask',
  MASK_USER_INPUT: 'mask-user-input'
};
var TraceContextInjection = {
  ALL: 'all',
  SAMPLED: 'sampled'
};
function checkIfString(tag, tagName) {
  if (tag !== undefined && tag !== null && typeof tag !== 'string') {
    display.error("".concat(tagName, " must be defined as a string"));
    return false;
  }
  return true;
}
function isDatadogSite(site) {
  return /(datadog|ddog|datad0g|dd0g)/.test(site);
}
function validateAndBuildConfiguration(initConfiguration) {
  var _a, _b, _c, _d, _e;
  if (!initConfiguration || !initConfiguration.clientToken) {
    display.error('Client Token is not configured, we will not send any data.');
    return;
  }
  if (initConfiguration.sessionSampleRate !== undefined && !isPercentage(initConfiguration.sessionSampleRate)) {
    display.error('Session Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
    display.error('Telemetry Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryConfigurationSampleRate !== undefined && !isPercentage(initConfiguration.telemetryConfigurationSampleRate)) {
    display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryUsageSampleRate !== undefined && !isPercentage(initConfiguration.telemetryUsageSampleRate)) {
    display.error('Telemetry Usage Sample Rate should be a number between 0 and 100');
    return;
  }
  if (!checkIfString(initConfiguration.version, 'Version')) {
    return;
  }
  if (!checkIfString(initConfiguration.env, 'Env')) {
    return;
  }
  if (!checkIfString(initConfiguration.service, 'Service')) {
    return;
  }
  if (initConfiguration.trackingConsent !== undefined && !objectHasValue(TrackingConsent, initConfiguration.trackingConsent)) {
    display.error('Tracking Consent should be either "granted" or "not-granted"');
    return;
  }
  if (initConfiguration.site && !isDatadogSite(initConfiguration.site)) {
    display.error("Site should be a valid Datadog site. Learn more here: ".concat(DOCS_ORIGIN, "/getting_started/site/."));
    return;
  }
  return assign({
    beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
    sessionStoreStrategyType: selectSessionStoreStrategyType(initConfiguration),
    sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
    telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
    telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
    telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
    service: initConfiguration.service || undefined,
    silentMultipleInit: !!initConfiguration.silentMultipleInit,
    allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
    trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : TrackingConsent.GRANTED,
    storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * ONE_KIBI_BYTE,
    eventRateLimiterThreshold: 3000,
    maxTelemetryEventsPerPage: 15,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * ONE_SECOND,
    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * ONE_KIBI_BYTE
  }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
  return {
    session_sample_rate: initConfiguration.sessionSampleRate,
    telemetry_sample_rate: initConfiguration.telemetrySampleRate,
    telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
    use_before_send: !!initConfiguration.beforeSend,
    use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
    use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
    use_proxy: !!initConfiguration.proxy,
    silent_multiple_init: initConfiguration.silentMultipleInit,
    track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
    allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
    tracking_consent: initConfiguration.trackingConsent
  };
}

/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
  ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
  ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
  ExperimentalFeature["TOLERANT_RESOURCE_TIMINGS"] = "tolerant_resource_timings";
  ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
  ExperimentalFeature["UPDATE_VIEW_NAME"] = "update_view_name";
  ExperimentalFeature["PLUGINS"] = "plugins";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function initFeatureFlags(enableExperimentalFeatures) {
  if (Array.isArray(enableExperimentalFeatures)) {
    addExperimentalFeatures(enableExperimentalFeatures.filter(function (flag) {
      return objectHasValue(ExperimentalFeature, flag);
    }));
  }
}
function addExperimentalFeatures(enabledFeatures) {
  enabledFeatures.forEach(function (flag) {
    enabledExperimentalFeatures.add(flag);
  });
}
function isExperimentalFeatureEnabled(featureName) {
  return enabledExperimentalFeatures.has(featureName);
}
function getExperimentalFeatures() {
  return enabledExperimentalFeatures;
}

/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */
var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
  var stack = [];
  var stackProperty = tryToGetString(ex, 'stack');
  var exString = String(ex);
  if (stackProperty && startsWith$1(stackProperty, exString)) {
    stackProperty = stackProperty.slice(exString.length);
  }
  if (stackProperty) {
    stackProperty.split('\n').forEach(function (line) {
      var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
      if (stackFrame) {
        if (!stackFrame.func && stackFrame.line) {
          stackFrame.func = UNKNOWN_FUNCTION;
        }
        stack.push(stackFrame);
      }
    });
  }
  return {
    message: tryToGetString(ex, 'message'),
    name: tryToGetString(ex, 'name'),
    stack: stack
  };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
  var parts = CHROME_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
  var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
  var submatch = CHROME_EVAL_RE.exec(parts[2]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line/column number
    parts[2] = submatch[1]; // url
    parts[3] = submatch[2]; // line
    parts[4] = submatch[3]; // column
  }
  return {
    args: isNative ? [parts[2]] : [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[3] ? +parts[3] : undefined,
    url: !isNative ? parts[2] : undefined
  };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
  var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[3] ? +parts[3] : undefined,
    func: UNKNOWN_FUNCTION,
    line: parts[2] ? +parts[2] : undefined,
    url: parts[1]
  };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
  var parts = WINJS_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: +parts[3],
    url: parts[2]
  };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
  var parts = GECKO_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
  var submatch = GECKO_EVAL_RE.exec(parts[3]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line number
    parts[3] = submatch[1];
    parts[4] = submatch[2];
    parts[5] = undefined; // no column when eval
  }
  return {
    args: parts[2] ? parts[2].split(',') : [],
    column: parts[5] ? +parts[5] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[4] ? +parts[4] : undefined,
    url: parts[3]
  };
}
function tryToGetString(candidate, property) {
  if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
    return undefined;
  }
  var value = candidate[property];
  return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
  var stack = [{
    url: url,
    column: column,
    line: line
  }];
  var _a = tryToParseMessage(messageObj),
    name = _a.name,
    message = _a.message;
  return {
    name: name,
    message: message,
    stack: stack
  };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
  var _a;
  var name;
  var message;
  if ({}.toString.call(messageObj) === '[object String]') {
    _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
  }
  return {
    name: name,
    message: message
  };
}

/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
  /**
   * Skip the two internal frames:
   * - SDK API (console.error, ...)
   * - this function
   * in order to keep only the user calls
   */
  var internalFramesToSkip = 2;
  var error = new Error();
  var formattedStack;
  // IE needs to throw the error to fill in the stack trace
  if (!error.stack) {
    try {
      throw error;
    } catch (e) {
    }
  }
  callMonitored(function () {
    var stackTrace = computeStackTrace(error);
    stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
    formattedStack = toStackTraceString(stackTrace);
  });
  return formattedStack;
}
function toStackTraceString(stack) {
  var result = formatErrorMessage(stack);
  stack.stack.forEach(function (frame) {
    var func = frame.func === '?' ? '<anonymous>' : frame.func;
    var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
    var line = frame.line ? ":".concat(frame.line) : '';
    var column = frame.line && frame.column ? ":".concat(frame.column) : '';
    result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
  });
  return result;
}
function formatErrorMessage(stack) {
  return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}

/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall, _a) {
  var _b = _a === void 0 ? {} : _a,
    computeHandlingStack = _b.computeHandlingStack;
  var original = targetPrototype[method];
  if (typeof original !== 'function') {
    if (startsWith$1(method, 'on')) {
      original = noop$1;
    } else {
      return {
        stop: noop$1
      };
    }
  }
  var stopped = false;
  var instrumentation = function () {
    if (stopped) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return original.apply(this, arguments);
    }
    var parameters = arrayFrom(arguments);
    var postCallCallback;
    callMonitored(onPreCall, null, [{
      target: this,
      parameters: parameters,
      onPostCall: function (callback) {
        postCallCallback = callback;
      },
      handlingStack: computeHandlingStack ? createHandlingStack() : undefined
    }]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    var result = original.apply(this, parameters);
    if (postCallCallback) {
      callMonitored(postCallCallback, null, [result]);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  };
  targetPrototype[method] = instrumentation;
  return {
    stop: function () {
      stopped = true;
      // If the instrumentation has been removed by a third party, keep the last one
      if (targetPrototype[method] === instrumentation) {
        targetPrototype[method] = original;
      }
    }
  };
}
function instrumentSetter(targetPrototype, property, after) {
  var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
  if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
    return {
      stop: noop$1
    };
  }
  var stoppedInstrumentation = noop$1;
  var instrumentation = function (target, value) {
    // put hooked setter into event loop to avoid of set latency
    setTimeout$1(function () {
      if (instrumentation !== stoppedInstrumentation) {
        after(target, value);
      }
    }, 0);
  };
  var instrumentationWrapper = function (value) {
    originalDescriptor.set.call(this, value);
    instrumentation(this, value);
  };
  Object.defineProperty(targetPrototype, property, {
    set: instrumentationWrapper
  });
  return {
    stop: function () {
      var _a;
      if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
        Object.defineProperty(targetPrototype, property, originalDescriptor);
      }
      instrumentation = stoppedInstrumentation;
    }
  };
}

// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
  var _a;
  if (maxCharacterCount === void 0) {
    maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
  }
  // Unbind any toJSON function we may have on [] or {} prototypes
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
  var containerQueue = [];
  var visitedObjectsWithPath = new WeakMap();
  var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
  var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
  if (accumulatedCharacterCount > maxCharacterCount) {
    warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
    return undefined;
  }
  while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
    var containerToProcess = containerQueue.shift();
    var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
    // Arrays and Objects have to be handled distinctly to ensure
    // we do not pick up non-numerical properties from Arrays
    if (Array.isArray(containerToProcess.source)) {
      for (var key = 0; key < containerToProcess.source.length; key++) {
        var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
        if (targetData !== undefined) {
          accumulatedCharacterCount += JSON.stringify(targetData).length;
        } else {
          // When an element of an Array (targetData) is undefined, it is serialized as null:
          // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
          accumulatedCharacterCount += 4;
        }
        accumulatedCharacterCount += separatorLength;
        separatorLength = 1;
        if (accumulatedCharacterCount > maxCharacterCount) {
          warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
          break;
        }
        containerToProcess.target[key] = targetData;
      }
    } else {
      for (var key in containerToProcess.source) {
        if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
          var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
          // When a property of an object has an undefined value, it will be dropped during serialization:
          // JSON.stringify({a:undefined}) => '{}'
          if (targetData !== undefined) {
            accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
            separatorLength = 1;
          }
          if (accumulatedCharacterCount > maxCharacterCount) {
            warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
            break;
          }
          containerToProcess.target[key] = targetData;
        }
      }
    }
  }
  // Rebind detached toJSON functions
  restoreObjectPrototypeToJson();
  restoreArrayPrototypeToJson();
  return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
  // Start by handling toJSON, as we want to sanitize its output
  var sourceToSanitize = tryToApplyToJSON(source);
  if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
    return sanitizePrimitivesAndFunctions(sourceToSanitize);
  }
  var sanitizedSource = sanitizeObjects(sourceToSanitize);
  if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
    return sanitizedSource;
  }
  // Handle potential cyclic references
  // We need to use source as sourceToSanitize could be a reference to a new object
  // At this stage, we know the source is an object type
  var sourceAsObject = source;
  if (visitedObjectsWithPath.has(sourceAsObject)) {
    return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
  }
  // Add processed source to queue
  var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
  var target = Array.isArray(sourceToSanitize) ? [] : {};
  visitedObjectsWithPath.set(sourceAsObject, currentPath);
  queue.push({
    source: sourceToSanitize,
    target: target,
    path: currentPath
  });
  return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
  // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
  if (typeof value === 'bigint') {
    return "[BigInt] ".concat(value.toString());
  }
  // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
  // so it won't prevent stringify from serializing later
  if (typeof value === 'function') {
    return "[Function] ".concat(value.name || 'unknown');
  }
  // JSON.stringify() does not serialize symbols.
  if (typeof value === 'symbol') {
    return "[Symbol] ".concat(value.description || value.toString());
  }
  return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
  try {
    // Handle events - Keep a simple implementation to avoid breaking changes
    if (value instanceof Event) {
      return {
        isTrusted: value.isTrusted
      };
    }
    // Handle all remaining object types in a generic way
    var result = Object.prototype.toString.call(value);
    var match = result.match(/\[object (.*)\]/);
    if (match && match[1]) {
      return "[".concat(match[1], "]");
    }
  } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
  }
  return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
  var object = value;
  if (object && typeof object.toJSON === 'function') {
    try {
      return object.toJSON();
    } catch (_a) {
      // If toJSON fails, we continue by trying to serialize the value manually
    }
  }
  return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
  display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}

var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
  var stackTrace = _a.stackTrace,
    originalError = _a.originalError,
    handlingStack = _a.handlingStack,
    startClocks = _a.startClocks,
    nonErrorPrefix = _a.nonErrorPrefix,
    source = _a.source,
    handling = _a.handling;
  var isErrorInstance = originalError instanceof Error;
  var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
  var stack = hasUsableStack(isErrorInstance, stackTrace) ? toStackTraceString(stackTrace) : NO_ERROR_STACK_PRESENT_MESSAGE;
  var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
  var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
  var fingerprint = tryToGetFingerprint(originalError);
  return {
    startClocks: startClocks,
    source: source,
    handling: handling,
    handlingStack: handlingStack,
    originalError: originalError,
    type: type,
    message: message,
    stack: stack,
    causes: causes,
    fingerprint: fingerprint
  };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
  // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
  // TODO rework tracekit integration to avoid scattering error building logic
  return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError))) : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
  if (stackTrace === undefined) {
    return false;
  }
  if (isErrorInstance) {
    return true;
  }
  // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
  // TODO rework tracekit integration to avoid generating those unusable stack
  return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
  return originalError instanceof Error && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function flattenErrorCauses(error, parentSource) {
  var currentError = error;
  var causes = [];
  while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
    var stackTrace = computeStackTrace(currentError.cause);
    causes.push({
      message: currentError.cause.message,
      source: parentSource,
      type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
      stack: stackTrace && toStackTraceString(stackTrace)
    });
    currentError = currentError.cause;
  }
  return causes.length ? causes : undefined;
}

var ErrorSource = {
  AGENT: 'agent',
  CONSOLE: 'console',
  CUSTOM: 'custom',
  LOGGER: 'logger',
  NETWORK: 'network',
  SOURCE: 'source',
  REPORT: 'report'
};

function trackRuntimeError(errorObservable) {
  var handleRuntimeError = function (stackTrace, originalError) {
    var rawError = computeRawError({
      stackTrace: stackTrace,
      originalError: originalError,
      startClocks: clocksNow(),
      nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
      source: ErrorSource.SOURCE,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */
    });
    errorObservable.notify(rawError);
  };
  var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
  var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
  return {
    stop: function () {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    }
  };
}
function instrumentOnError(callback) {
  return instrumentMethod(window, 'onerror', function (_a) {
    var _b = _a.parameters,
      messageObj = _b[0],
      url = _b[1],
      line = _b[2],
      column = _b[3],
      errorObj = _b[4];
    var stackTrace;
    if (errorObj instanceof Error) {
      stackTrace = computeStackTrace(errorObj);
    } else {
      stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
    }
    callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
  });
}
function instrumentUnhandledRejection(callback) {
  return instrumentMethod(window, 'onunhandledrejection', function (_a) {
    var e = _a.parameters[0];
    var reason = e.reason || 'Empty reason';
    var stack = computeStackTrace(reason);
    callback(stack, reason);
  });
}

function makePublicApi(stub) {
  var publicApi = assign({
    version: "5.23.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function (callback) {
      callback();
    }
  }, stub);
  // Add a "hidden" property to set debug mode. We define it that way to hide it
  // as much as possible but of course it's not a real protection.
  Object.defineProperty(publicApi, '_setDebug', {
    get: function () {
      return setDebugMode;
    },
    enumerable: false
  });
  return publicApi;
}
function defineGlobal(global, name, api) {
  var existingGlobalVariable = global[name];
  if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
    display.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
  }
  global[name] = api;
  if (existingGlobalVariable && existingGlobalVariable.q) {
    existingGlobalVariable.q.forEach(function (fn) {
      return catchUserErrors(fn, 'onReady callback threw an error:')();
    });
  }
}

function displayAlreadyInitializedError(sdkName, initConfiguration) {
  if (!initConfiguration.silentMultipleInit) {
    display.error("".concat(sdkName, " is already initialized."));
  }
}

// We want to use a real enum (i.e. not a const enum) here, to be able to iterate over it to automatically add _ddIsTrusted in e2e tests
// eslint-disable-next-line no-restricted-syntax
var DOM_EVENT;
(function (DOM_EVENT) {
  DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
  DOM_EVENT["CLICK"] = "click";
  DOM_EVENT["DBL_CLICK"] = "dblclick";
  DOM_EVENT["KEY_DOWN"] = "keydown";
  DOM_EVENT["LOAD"] = "load";
  DOM_EVENT["POP_STATE"] = "popstate";
  DOM_EVENT["SCROLL"] = "scroll";
  DOM_EVENT["TOUCH_START"] = "touchstart";
  DOM_EVENT["TOUCH_END"] = "touchend";
  DOM_EVENT["TOUCH_MOVE"] = "touchmove";
  DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
  DOM_EVENT["PAGE_SHOW"] = "pageshow";
  DOM_EVENT["FREEZE"] = "freeze";
  DOM_EVENT["RESUME"] = "resume";
  DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
  DOM_EVENT["POINTER_DOWN"] = "pointerdown";
  DOM_EVENT["POINTER_UP"] = "pointerup";
  DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
  DOM_EVENT["HASH_CHANGE"] = "hashchange";
  DOM_EVENT["PAGE_HIDE"] = "pagehide";
  DOM_EVENT["MOUSE_DOWN"] = "mousedown";
  DOM_EVENT["MOUSE_UP"] = "mouseup";
  DOM_EVENT["MOUSE_MOVE"] = "mousemove";
  DOM_EVENT["FOCUS"] = "focus";
  DOM_EVENT["BLUR"] = "blur";
  DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
  DOM_EVENT["RESIZE"] = "resize";
  DOM_EVENT["CHANGE"] = "change";
  DOM_EVENT["INPUT"] = "input";
  DOM_EVENT["PLAY"] = "play";
  DOM_EVENT["PAUSE"] = "pause";
  DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
  DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
  DOM_EVENT["STORAGE"] = "storage";
})(DOM_EVENT || (DOM_EVENT = {}));
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
  return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
  var _b = _a === void 0 ? {} : _a,
    once = _b.once,
    capture = _b.capture,
    passive = _b.passive;
  var listenerWithMonitor = monitor(function (event) {
    if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
      return;
    }
    if (once) {
      stop();
    }
    listener(event);
  });
  var options = passive ? {
    capture: capture,
    passive: passive
  } : capture;
  var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
  eventNames.forEach(function (eventName) {
    return add.call(eventTarget, eventName, listenerWithMonitor, options);
  });
  function stop() {
    var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
    eventNames.forEach(function (eventName) {
      return remove.call(eventTarget, eventName, listenerWithMonitor, options);
    });
  }
  return {
    stop: stop
  };
}

var RawReportType = {
  intervention: 'intervention',
  deprecation: 'deprecation',
  cspViolation: 'csp_violation'
};
function initReportObservable(configuration, apis) {
  var observables = [];
  if (includes(apis, RawReportType.cspViolation)) {
    observables.push(createCspViolationReportObservable(configuration));
  }
  var reportTypes = apis.filter(function (api) {
    return api !== RawReportType.cspViolation;
  });
  if (reportTypes.length) {
    observables.push(createReportObservable(reportTypes));
  }
  return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
  return new Observable(function (observable) {
    if (!window.ReportingObserver) {
      return;
    }
    var handleReports = monitor(function (reports, _) {
      return reports.forEach(function (report) {
        observable.notify(buildRawReportFromReport(report));
      });
    });
    var observer = new window.ReportingObserver(handleReports, {
      types: reportTypes,
      buffered: true
    });
    observer.observe();
    return function () {
      observer.disconnect();
    };
  });
}
function createCspViolationReportObservable(configuration) {
  return new Observable(function (observable) {
    var stop = addEventListener(configuration, document, DOM_EVENT.SECURITY_POLICY_VIOLATION, function (event) {
      observable.notify(buildRawReportFromCspViolation(event));
    }).stop;
    return stop;
  });
}
function buildRawReportFromReport(report) {
  var type = report.type,
    body = report.body;
  return {
    type: type,
    subtype: body.id,
    message: "".concat(type, ": ").concat(body.message),
    originalReport: report,
    stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
  };
}
function buildRawReportFromCspViolation(event) {
  var type = RawReportType.cspViolation;
  var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
  return {
    type: RawReportType.cspViolation,
    subtype: event.effectiveDirective,
    message: "".concat(type, ": ").concat(message),
    stack: buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\"") : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    originalReport: event
  };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
  return sourceFile ? toStackTraceString({
    name: name,
    message: message,
    stack: [{
      func: '?',
      url: sourceFile,
      line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
      column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
    }]
  }) : undefined;
}

function sendToExtension(type, payload) {
  var callback = window.__ddBrowserSdkExtensionCallback;
  if (callback) {
    callback({
      type: type,
      payload: payload
    });
  }
}

/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
  if (value === null) {
    return 'null';
  }
  if (Array.isArray(value)) {
    return 'array';
  }
  return typeof value;
}

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
  if (circularReferenceChecker === void 0) {
    circularReferenceChecker = createCircularReferenceChecker();
  }
  // ignore the source if it is undefined
  if (source === undefined) {
    return destination;
  }
  if (typeof source !== 'object' || source === null) {
    // primitive values - just return source
    return source;
  } else if (source instanceof Date) {
    return new Date(source.getTime());
  } else if (source instanceof RegExp) {
    var flags = source.flags ||
    // old browsers compatibility
    [source.global ? 'g' : '', source.ignoreCase ? 'i' : '', source.multiline ? 'm' : '', source.sticky ? 'y' : '', source.unicode ? 'u' : ''].join('');
    return new RegExp(source.source, flags);
  }
  if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
    // remove circular references
    return undefined;
  } else if (Array.isArray(source)) {
    var merged_1 = Array.isArray(destination) ? destination : [];
    for (var i = 0; i < source.length; ++i) {
      merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
    }
    return merged_1;
  }
  var merged = getType(destination) === 'object' ? destination : {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
    }
  }
  return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
  return mergeInto(undefined, value);
}
function combine() {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  var destination;
  for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
    var source = sources_1[_a];
    // Ignore any undefined or null sources.
    if (source === undefined || source === null) {
      continue;
    }
    destination = mergeInto(destination, source);
  }
  return destination;
}
function createCircularReferenceChecker() {
  if (typeof WeakSet !== 'undefined') {
    var set_1 = new WeakSet();
    return {
      hasAlreadyBeenSeen: function (value) {
        var has = set_1.has(value);
        if (!has) {
          set_1.add(value);
        }
        return has;
      }
    };
  }
  var array = [];
  return {
    hasAlreadyBeenSeen: function (value) {
      var has = array.indexOf(value) >= 0;
      if (!has) {
        array.push(value);
      }
      return has;
    }
  };
}

function getConnectivity() {
  var _a;
  var navigator = window.navigator;
  return {
    status: navigator.onLine ? 'connected' : 'not_connected',
    interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
    effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
  };
}

function removeItem(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */function () {
  function BoundedBuffer() {
    this.buffer = [];
  }
  BoundedBuffer.prototype.add = function (callback) {
    var length = this.buffer.push(callback);
    if (length > BUFFER_LIMIT) {
      this.buffer.splice(0, 1);
    }
  };
  BoundedBuffer.prototype.remove = function (callback) {
    removeItem(this.buffer, callback);
  };
  BoundedBuffer.prototype.drain = function (arg) {
    this.buffer.forEach(function (callback) {
      return callback(arg);
    });
    this.buffer.length = 0;
  };
  return BoundedBuffer;
}();

var TelemetryType = {
  log: 'log',
  configuration: 'configuration',
  usage: 'usage'
};

var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var preStartTelemetryBuffer = new BoundedBuffer();
var onRawTelemetryEventCollected = function (event) {
  preStartTelemetryBuffer.add(function () {
    return onRawTelemetryEventCollected(event);
  });
};
function startTelemetry(telemetryService, configuration) {
  var _a;
  var contextProvider;
  var observable = new Observable();
  var alreadySentEvents = new Set();
  var telemetryEnabled = !includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = (_a = {}, _a[TelemetryType.log] = telemetryEnabled, _a[TelemetryType.configuration] = telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate), _a[TelemetryType.usage] = telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate), _a);
  var runtimeEnvInfo = getRuntimeEnvInfo();
  onRawTelemetryEventCollected = function (rawEvent) {
    var stringifiedEvent = jsonStringify(rawEvent);
    if (telemetryEnabledPerType[rawEvent.type] && alreadySentEvents.size < configuration.maxTelemetryEventsPerPage && !alreadySentEvents.has(stringifiedEvent)) {
      var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
      observable.notify(event_1);
      sendToExtension('telemetry', event_1);
      alreadySentEvents.add(stringifiedEvent);
    }
  };
  startMonitorErrorCollection(addTelemetryError);
  function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
    return combine({
      type: 'telemetry',
      date: timeStampNow(),
      service: telemetryService,
      version: "5.23.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(event, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity()
      }),
      experimental_features: arrayFrom(getExperimentalFeatures())
    }, contextProvider !== undefined ? contextProvider() : {});
  }
  return {
    setContextProvider: function (provider) {
      contextProvider = provider;
    },
    observable: observable,
    enabled: telemetryEnabled
  };
}
function getRuntimeEnvInfo() {
  return {
    is_local_file: window.location.protocol === 'file:',
    is_worker: 'WorkerGlobalScope' in self
  };
}
// need to be called after telemetry context is provided and observers are registered
function drainPreStartTelemetry() {
  preStartTelemetryBuffer.drain();
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    message: message,
    status: "debug" /* StatusType.debug */
  }, context));
}
function addTelemetryError(e, context) {
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    status: "error" /* StatusType.error */
  }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
  onRawTelemetryEventCollected({
    type: TelemetryType.configuration,
    configuration: configuration
  });
}
function addTelemetryUsage(usage) {
  onRawTelemetryEventCollected({
    type: TelemetryType.usage,
    usage: usage
  });
}
function formatError(e) {
  if (e instanceof Error) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }
  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify(e))
  };
}
function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return startsWith$1(frame.url, allowedFrameUrl);
    });
  });
  return stackTrace;
}

var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */function () {
  function ValueHistory(expireDelay, maxEntries) {
    var _this = this;
    this.expireDelay = expireDelay;
    this.maxEntries = maxEntries;
    this.entries = [];
    this.clearOldValuesInterval = setInterval$1(function () {
      return _this.clearOldValues();
    }, CLEAR_OLD_VALUES_INTERVAL);
  }
  /**
   * Add a value to the history associated with a start time. Returns a reference to this newly
   * added entry that can be removed or closed.
   */
  ValueHistory.prototype.add = function (value, startTime) {
    var _this = this;
    var entry = {
      value: value,
      startTime: startTime,
      endTime: END_OF_TIMES,
      remove: function () {
        removeItem(_this.entries, entry);
      },
      close: function (endTime) {
        entry.endTime = endTime;
      }
    };
    if (this.maxEntries && this.entries.length >= this.maxEntries) {
      this.entries.pop();
    }
    this.entries.unshift(entry);
    return entry;
  };
  /**
   * Return the latest value that was active during `startTime`, or the currently active value
   * if no `startTime` is provided. This method assumes that entries are not overlapping.
   *
   * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
   */
  ValueHistory.prototype.find = function (startTime, options) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (options === void 0) {
      options = {
        returnInactive: false
      };
    }
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.startTime <= startTime) {
        if (options.returnInactive || startTime <= entry.endTime) {
          return entry.value;
        }
        break;
      }
    }
  };
  /**
   * Helper function to close the currently active value, if any. This method assumes that entries
   * are not overlapping.
   */
  ValueHistory.prototype.closeActive = function (endTime) {
    var latestEntry = this.entries[0];
    if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
      latestEntry.close(endTime);
    }
  };
  /**
   * Return all values with an active period overlapping with the duration,
   * or all values that were active during `startTime` if no duration is provided,
   * or all currently active values if no `startTime` is provided.
   */
  ValueHistory.prototype.findAll = function (startTime, duration) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (duration === void 0) {
      duration = 0;
    }
    var endTime = addDuration(startTime, duration);
    return this.entries.filter(function (entry) {
      return entry.startTime <= endTime && startTime <= entry.endTime;
    }).map(function (entry) {
      return entry.value;
    });
  };
  /**
   * Remove all entries from this collection.
   */
  ValueHistory.prototype.reset = function () {
    this.entries = [];
  };
  /**
   * Stop internal garbage collection of past entries.
   */
  ValueHistory.prototype.stop = function () {
    clearInterval$1(this.clearOldValuesInterval);
  };
  ValueHistory.prototype.clearOldValues = function () {
    var oldTimeThreshold = relativeNow() - this.expireDelay;
    while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
      this.entries.pop();
    }
  };
  return ValueHistory;
}();

var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
function startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  // TODO - Improve configuration type and remove assertion
  var sessionStore = startSessionStore(configuration.sessionStoreStrategyType, productKey, computeSessionState);
  var sessionContextHistory = new ValueHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
  sessionStore.renewObservable.subscribe(function () {
    sessionContextHistory.add(buildSessionContext(), relativeNow());
    renewObservable.notify();
  });
  sessionStore.expireObservable.subscribe(function () {
    expireObservable.notify();
    sessionContextHistory.closeActive(relativeNow());
  });
  // We expand/renew session unconditionally as tracking consent is always granted when the session
  // manager is started.
  sessionStore.expandOrRenewSession();
  sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
  trackingConsentState.observable.subscribe(function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    } else {
      sessionStore.expire();
    }
  });
  trackActivity(configuration, function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    }
  });
  trackVisibility(configuration, function () {
    return sessionStore.expandSession();
  });
  trackResume(configuration, function () {
    return sessionStore.restartSession();
  });
  function buildSessionContext() {
    return {
      id: sessionStore.getSession().id,
      trackingType: sessionStore.getSession()[productKey],
      isReplayForced: !!sessionStore.getSession().forcedReplay
    };
  }
  return {
    findSession: function (startTime, options) {
      return sessionContextHistory.find(startTime, options);
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
    expire: sessionStore.expire,
    updateSessionState: sessionStore.updateSessionState
  };
}
function trackActivity(configuration, expandOrRenewSession) {
  addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.TOUCH_START, DOM_EVENT.KEY_DOWN, DOM_EVENT.SCROLL], expandOrRenewSession, {
    capture: true,
    passive: true
  }).stop;
}
function trackVisibility(configuration, expandSession) {
  var expandSessionWhenVisible = function () {
    if (document.visibilityState === 'visible') {
      expandSession();
    }
  };
  addEventListener(configuration, document, DOM_EVENT.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
  setInterval$1(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
}
function trackResume(configuration, cb) {
  addEventListener(configuration, window, DOM_EVENT.RESUME, cb, {
    capture: true
  }).stop;
}

function isServerError(status) {
  return status >= 500;
}
function tryToClone(response) {
  try {
    return response.clone();
  } catch (e) {
    // clone can throw if the response has already been used by another instrumentation or is disturbed
    return;
  }
}

var MAX_ONGOING_BYTES_COUNT = 80 * ONE_KIBI_BYTE;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * ONE_MEBI_BYTE;
var MAX_BACKOFF_TIME = ONE_MINUTE;
var INITIAL_BACKOFF_TIME = ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
  if (state.transportStatus === 0 /* TransportStatus.UP */ && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) {
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.queuedPayloads.enqueue(payload);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  } else {
    state.queuedPayloads.enqueue(payload);
  }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
  if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
    return;
  }
  setTimeout$1(function () {
    var payload = state.queuedPayloads.first();
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        state.queuedPayloads.dequeue();
        state.currentBackoffTime = INITIAL_BACKOFF_TIME;
        retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
  var onSuccess = _a.onSuccess,
    onFailure = _a.onFailure;
  state.bandwidthMonitor.add(payload);
  sendStrategy(payload, function (response) {
    state.bandwidthMonitor.remove(payload);
    if (!shouldRetryRequest(response)) {
      state.transportStatus = 0 /* TransportStatus.UP */;
      onSuccess();
    } else {
      // do not consider transport down if another ongoing request could succeed
      state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
      payload.retry = {
        count: payload.retry ? payload.retry.count + 1 : 1,
        lastFailureStatus: response.status
      };
      onFailure();
    }
  });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
  if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
    reportError({
      message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / ONE_MEBI_BYTE, "MiB"),
      source: ErrorSource.AGENT,
      startClocks: clocksNow()
    });
    state.queueFullReported = true;
  }
  var previousQueue = state.queuedPayloads;
  state.queuedPayloads = newPayloadQueue();
  while (previousQueue.size() > 0) {
    sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
  }
}
function shouldRetryRequest(response) {
  return response.type !== 'opaque' && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || isServerError(response.status));
}
function newRetryState() {
  return {
    transportStatus: 0 /* TransportStatus.UP */,
    currentBackoffTime: INITIAL_BACKOFF_TIME,
    bandwidthMonitor: newBandwidthMonitor(),
    queuedPayloads: newPayloadQueue(),
    queueFullReported: false
  };
}
function newPayloadQueue() {
  var queue = [];
  return {
    bytesCount: 0,
    enqueue: function (payload) {
      if (this.isFull()) {
        return;
      }
      queue.push(payload);
      this.bytesCount += payload.bytesCount;
    },
    first: function () {
      return queue[0];
    },
    dequeue: function () {
      var payload = queue.shift();
      if (payload) {
        this.bytesCount -= payload.bytesCount;
      }
      return payload;
    },
    size: function () {
      return queue.length;
    },
    isFull: function () {
      return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
    }
  };
}
function newBandwidthMonitor() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function (payload) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT && this.ongoingRequestCount < MAX_ONGOING_REQUESTS;
    },
    add: function (payload) {
      this.ongoingRequestCount += 1;
      this.ongoingByteCount += payload.bytesCount;
    },
    remove: function (payload) {
      this.ongoingRequestCount -= 1;
      this.ongoingByteCount -= payload.bytesCount;
    }
  };
}

function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
  var retryState = newRetryState();
  var sendStrategyForRetry = function (payload, onResponse) {
    return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
  };
  return {
    send: function (payload) {
      sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function (payload) {
      sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
    }
  };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
  var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
  if (canUseBeacon) {
    try {
      var beaconUrl = endpointBuilder.build('beacon', payload);
      var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
      if (isQueued) {
        return;
      }
    } catch (e) {
      reportBeaconError(e);
    }
  }
  var xhrUrl = endpointBuilder.build('xhr', payload);
  sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    addTelemetryError(e);
  }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
  var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
  if (canUseKeepAlive) {
    var fetchUrl = endpointBuilder.build('fetch', payload);
    fetch(fetchUrl, {
      method: 'POST',
      body: payload.data,
      keepalive: true,
      mode: 'cors'
    }).then(monitor(function (response) {
      return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
        status: response.status,
        type: response.type
      });
    }), monitor(function () {
      var xhrUrl = endpointBuilder.build('xhr', payload);
      // failed to queue the request
      sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }));
  } else {
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data, onResponse);
  }
}
function isKeepAliveSupported() {
  // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
  try {
    return window.Request && 'keepalive' in new Request('http://a');
  } catch (_a) {
    return false;
  }
}
function sendXHR(configuration, url, data, onResponse) {
  var request = new XMLHttpRequest();
  request.open('POST', url, true);
  if (data instanceof Blob) {
    // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader('Content-Type', data.type);
  }
  addEventListener(configuration, request, 'loadend', function () {
    onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: request.status
    });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: true
  });
  request.send(data);
}

function getEventBridge() {
  var eventBridgeGlobal = getEventBridgeGlobal();
  if (!eventBridgeGlobal) {
    return;
  }
  return {
    getCapabilities: function () {
      var _a;
      return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
    },
    getPrivacyLevel: function () {
      var _a;
      return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
    },
    getAllowedWebViewHosts: function () {
      return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
    },
    send: function (eventType, event, viewId) {
      var view = viewId ? {
        id: viewId
      } : undefined;
      eventBridgeGlobal.send(JSON.stringify({
        eventType: eventType,
        event: event,
        view: view
      }));
    }
  };
}
function bridgeSupports(capability) {
  var bridge = getEventBridge();
  return !!bridge && includes(bridge.getCapabilities(), capability);
}
function canUseEventBridge(currentHost) {
  var _a;
  if (currentHost === void 0) {
    currentHost = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname;
  }
  var bridge = getEventBridge();
  return !!bridge && bridge.getAllowedWebViewHosts().some(function (allowedHost) {
    return currentHost === allowedHost || endsWith(currentHost, ".".concat(allowedHost));
  });
}
function getEventBridgeGlobal() {
  return getGlobalObject().DatadogEventBridge;
}

var PageExitReason = {
  HIDDEN: 'visibility_hidden',
  UNLOADING: 'before_unload',
  PAGEHIDE: 'page_hide',
  FROZEN: 'page_frozen'
};
function createPageExitObservable(configuration) {
  return new Observable(function (observable) {
    var stopListeners = addEventListeners(configuration, window, [DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.FREEZE], function (event) {
      if (event.type === DOM_EVENT.VISIBILITY_CHANGE && document.visibilityState === 'hidden') {
        /**
         * Only event that guarantee to fire on mobile devices when the page transitions to background state
         * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
         */
        observable.notify({
          reason: PageExitReason.HIDDEN
        });
      } else if (event.type === DOM_EVENT.FREEZE) {
        /**
         * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
         * Allow to collect events happening between hidden and frozen state.
         */
        observable.notify({
          reason: PageExitReason.FROZEN
        });
      }
    }, {
      capture: true
    }).stop;
    var stopBeforeUnloadListener = addEventListener(configuration, window, DOM_EVENT.BEFORE_UNLOAD, function () {
      observable.notify({
        reason: PageExitReason.UNLOADING
      });
    }).stop;
    return function () {
      stopListeners();
      stopBeforeUnloadListener();
    };
  });
}
function isPageExitReason(reason) {
  return includes(objectValues(PageExitReason), reason);
}

var Batch = /** @class */function () {
  function Batch(encoder, request, flushController, messageBytesLimit) {
    var _this = this;
    this.encoder = encoder;
    this.request = request;
    this.flushController = flushController;
    this.messageBytesLimit = messageBytesLimit;
    this.upsertBuffer = {};
    this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) {
      return _this.flush(event);
    });
  }
  Batch.prototype.add = function (message) {
    this.addOrUpdate(message);
  };
  Batch.prototype.upsert = function (message, key) {
    this.addOrUpdate(message, key);
  };
  Batch.prototype.stop = function () {
    this.flushSubscription.unsubscribe();
  };
  Batch.prototype.flush = function (event) {
    var upsertMessages = objectValues(this.upsertBuffer).join('\n');
    this.upsertBuffer = {};
    var isPageExit = isPageExitReason(event.reason);
    var send = isPageExit ? this.request.sendOnExit : this.request.send;
    if (isPageExit &&
    // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
    // if the encoder is async we need to send two requests in some cases (one for encoded data
    // and the other for non-encoded data). But if it's not async, we don't have to worry about
    // it and always send a single request.
    this.encoder.isAsync) {
      var encoderResult = this.encoder.finishSync();
      // Send encoded messages
      if (encoderResult.outputBytesCount) {
        send(formatPayloadFromEncoder(encoderResult));
      }
      // Send messages that are not yet encoded at this point
      var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
      if (pendingMessages) {
        send({
          data: pendingMessages,
          bytesCount: computeBytesCount(pendingMessages)
        });
      }
    } else {
      if (upsertMessages) {
        this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
      }
      this.encoder.finish(function (encoderResult) {
        send(formatPayloadFromEncoder(encoderResult));
      });
    }
  };
  Batch.prototype.addOrUpdate = function (message, key) {
    var serializedMessage = jsonStringify(message);
    var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
    if (estimatedMessageBytesCount >= this.messageBytesLimit) {
      display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#technical-limitations"));
      return;
    }
    if (this.hasMessageFor(key)) {
      this.remove(key);
    }
    this.push(serializedMessage, estimatedMessageBytesCount, key);
  };
  Batch.prototype.push = function (serializedMessage, estimatedMessageBytesCount, key) {
    var _this = this;
    this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
    if (key !== undefined) {
      this.upsertBuffer[key] = serializedMessage;
      this.flushController.notifyAfterAddMessage();
    } else {
      this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
        _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
      });
    }
  };
  Batch.prototype.remove = function (key) {
    var removedMessage = this.upsertBuffer[key];
    delete this.upsertBuffer[key];
    var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
    this.flushController.notifyAfterRemoveMessage(messageBytesCount);
  };
  Batch.prototype.hasMessageFor = function (key) {
    return key !== undefined && this.upsertBuffer[key] !== undefined;
  };
  return Batch;
}();
function formatPayloadFromEncoder(encoderResult) {
  var data;
  if (typeof encoderResult.output === 'string') {
    data = encoderResult.output;
  } else {
    data = new Blob([encoderResult.output], {
      // This will set the 'Content-Type: text/plain' header. Reasoning:
      // * The intake rejects the request if there is no content type.
      // * The browser will issue CORS preflight requests if we set it to 'application/json', which
      // could induce higher intake load (and maybe has other impacts).
      // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
      // new lines.
      type: 'text/plain'
    });
  }
  return {
    data: data,
    bytesCount: encoderResult.outputBytesCount,
    encoding: encoderResult.encoding
  };
}

/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
  var messagesLimit = _a.messagesLimit,
    bytesLimit = _a.bytesLimit,
    durationLimit = _a.durationLimit,
    pageExitObservable = _a.pageExitObservable,
    sessionExpireObservable = _a.sessionExpireObservable;
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    return flush(event.reason);
  });
  var sessionExpireSubscription = sessionExpireObservable.subscribe(function () {
    return flush('session_expire');
  });
  var flushObservable = new Observable(function () {
    return function () {
      pageExitSubscription.unsubscribe();
      sessionExpireSubscription.unsubscribe();
    };
  });
  var currentBytesCount = 0;
  var currentMessagesCount = 0;
  function flush(flushReason) {
    if (currentMessagesCount === 0) {
      return;
    }
    var messagesCount = currentMessagesCount;
    var bytesCount = currentBytesCount;
    currentMessagesCount = 0;
    currentBytesCount = 0;
    cancelDurationLimitTimeout();
    flushObservable.notify({
      reason: flushReason,
      messagesCount: messagesCount,
      bytesCount: bytesCount
    });
  }
  var durationLimitTimeoutId;
  function scheduleDurationLimitTimeout() {
    if (durationLimitTimeoutId === undefined) {
      durationLimitTimeoutId = setTimeout$1(function () {
        flush('duration_limit');
      }, durationLimit);
    }
  }
  function cancelDurationLimitTimeout() {
    clearTimeout$1(durationLimitTimeoutId);
    durationLimitTimeoutId = undefined;
  }
  return {
    flushObservable: flushObservable,
    get messagesCount() {
      return currentMessagesCount;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
      if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
      // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
      // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
      // to notify when a flush is needed (for example on page exit).
      currentMessagesCount += 1;
      currentBytesCount += estimatedMessageBytesCount;
      scheduleDurationLimitTimeout();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage: function (messageBytesCountDiff) {
      if (messageBytesCountDiff === void 0) {
        messageBytesCountDiff = 0;
      }
      currentBytesCount += messageBytesCountDiff;
      if (currentMessagesCount >= messagesLimit) {
        flush('messages_limit');
      } else if (currentBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage: function (messageBytesCount) {
      currentBytesCount -= messageBytesCount;
      currentMessagesCount -= 1;
      if (currentMessagesCount === 0) {
        cancelDurationLimitTimeout();
      }
    }
  };
}

function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
  var primaryBatch = createBatch(configuration, primary);
  var replicaBatch = replica && createBatch(configuration, replica);
  function createBatch(configuration, _a) {
    var endpoint = _a.endpoint,
      encoder = _a.encoder;
    return new Batch(encoder, createHttpRequest(configuration, endpoint, configuration.batchBytesLimit, reportError), createFlushController({
      messagesLimit: configuration.batchMessagesLimit,
      bytesLimit: configuration.batchBytesLimit,
      durationLimit: configuration.flushTimeout,
      pageExitObservable: pageExitObservable,
      sessionExpireObservable: sessionExpireObservable
    }), configuration.messageBytesLimit);
  }
  return {
    flushObservable: primaryBatch.flushController.flushObservable,
    add: function (message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }
      primaryBatch.add(message);
      if (replicaBatch && replicated) {
        replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
      }
    },
    upsert: function (message, key) {
      primaryBatch.upsert(message, key);
      if (replicaBatch) {
        replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
      }
    },
    stop: function () {
      primaryBatch.stop();
      replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
    }
  };
}

function createIdentityEncoder() {
  var output = '';
  var outputBytesCount = 0;
  return {
    isAsync: false,
    get isEmpty() {
      return !output;
    },
    write: function (data, callback) {
      var additionalEncodedBytesCount = computeBytesCount(data);
      outputBytesCount += additionalEncodedBytesCount;
      output += data;
      if (callback) {
        callback(additionalEncodedBytesCount);
      }
    },
    finish: function (callback) {
      callback(this.finishSync());
    },
    finishSync: function () {
      var result = {
        output: output,
        outputBytesCount: outputBytesCount,
        rawBytesCount: outputBytesCount,
        pendingData: ''
      };
      output = '';
      outputBytesCount = 0;
      return result;
    },
    estimateEncodedBytesCount: function (data) {
      return data.length;
    }
  };
}

var AbstractLifeCycle = /** @class */function () {
  function AbstractLifeCycle() {
    this.callbacks = {};
  }
  AbstractLifeCycle.prototype.notify = function (eventType, data) {
    var eventCallbacks = this.callbacks[eventType];
    if (eventCallbacks) {
      eventCallbacks.forEach(function (callback) {
        return callback(data);
      });
    }
  };
  AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
    var _this = this;
    if (!this.callbacks[eventType]) {
      this.callbacks[eventType] = [];
    }
    this.callbacks[eventType].push(callback);
    return {
      unsubscribe: function () {
        _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) {
          return callback !== other;
        });
      }
    };
  };
  return AbstractLifeCycle;
}();

function createEventRateLimiter(eventType, limit, onLimitReached) {
  var eventCount = 0;
  var allowNextEvent = false;
  return {
    isLimitReached: function () {
      if (eventCount === 0) {
        setTimeout$1(function () {
          eventCount = 0;
        }, ONE_MINUTE);
      }
      eventCount += 1;
      if (eventCount <= limit || allowNextEvent) {
        allowNextEvent = false;
        return false;
      }
      if (eventCount === limit + 1) {
        allowNextEvent = true;
        try {
          onLimitReached({
            message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
            source: ErrorSource.AGENT,
            startClocks: clocksNow()
          });
        } finally {
          allowNextEvent = false;
        }
      }
      return true;
    }
  };
}

function runOnReadyState(configuration, expectedReadyState, callback) {
  if (document.readyState === expectedReadyState || document.readyState === 'complete') {
    callback();
  } else {
    var eventName = expectedReadyState === 'complete' ? DOM_EVENT.LOAD : DOM_EVENT.DOM_CONTENT_LOADED;
    addEventListener(configuration, window, eventName, callback, {
      once: true
    });
  }
}

var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable(configuration);
  }
  return xhrObservable;
}
function createXhrObservable(configuration) {
  return new Observable(function (observable) {
    var stopInstrumentingStart = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr).stop;
    var stopInstrumentingSend = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
      sendXhr(call, configuration, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    var stopInstrumentingAbort = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr).stop;
    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
}
function openXhr(_a) {
  var xhr = _a.target,
    _b = _a.parameters,
    method = _b[0],
    url = _b[1];
  xhrContexts.set(xhr, {
    state: 'open',
    method: String(method).toUpperCase(),
    url: normalizeUrl(String(url))
  });
}
function sendXhr(_a, configuration, observable) {
  var xhr = _a.target,
    handlingStack = _a.handlingStack;
  var context = xhrContexts.get(xhr);
  if (!context) {
    return;
  }
  var startContext = context;
  startContext.state = 'start';
  startContext.startClocks = clocksNow();
  startContext.isAborted = false;
  startContext.xhr = xhr;
  startContext.handlingStack = handlingStack;
  var hasBeenReported = false;
  var stopInstrumentingOnReadyStateChange = instrumentMethod(xhr, 'onreadystatechange', function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      // Try to report the XHR as soon as possible, because the XHR may be mutated by the
      // application during a future event. For example, Angular is calling .abort() on
      // completed requests during an onreadystatechange event, so the status becomes '0'
      // before the request is collected.
      onEnd();
    }
  }).stop;
  var onEnd = function () {
    unsubscribeLoadEndListener();
    stopInstrumentingOnReadyStateChange();
    if (hasBeenReported) {
      return;
    }
    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
    completeContext.status = xhr.status;
    observable.notify(shallowClone(completeContext));
  };
  var unsubscribeLoadEndListener = addEventListener(configuration, xhr, 'loadend', onEnd).stop;
  observable.notify(startContext);
}
function abortXhr(_a) {
  var xhr = _a.target;
  var context = xhrContexts.get(xhr);
  if (context) {
    context.isAborted = true;
  }
}

var fetchObservable;
function initFetchObservable() {
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }
  return fetchObservable;
}
function createFetchObservable() {
  return new Observable(function (observable) {
    if (!window.fetch) {
      return;
    }
    var stop = instrumentMethod(window, 'fetch', function (call) {
      return beforeSend(call, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    return stop;
  });
}
function beforeSend(_a, observable) {
  var parameters = _a.parameters,
    onPostCall = _a.onPostCall,
    handlingStack = _a.handlingStack;
  var input = parameters[0],
    init = parameters[1];
  var methodFromParams = init && init.method;
  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }
  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack
  };
  observable.notify(context);
  // Those properties can be changed by observable subscribers
  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    return afterSend(observable, responsePromise, context);
  });
}
function afterSend(observable, responsePromise, startContext) {
  var reportFetch = function (response) {
    var context = startContext;
    context.state = 'resolve';
    if ('stack' in response || response instanceof Error) {
      context.status = 0;
      context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
      context.error = response;
    } else if ('status' in response) {
      context.response = response;
      context.responseType = response.type;
      context.status = response.status;
      context.isAborted = false;
    }
    observable.notify(context);
  };
  responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}

var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
  var consoleObservables = apis.map(function (api) {
    if (!consoleObservablesByApi[api]) {
      consoleObservablesByApi[api] = createConsoleObservable(api);
    }
    return consoleObservablesByApi[api];
  });
  return mergeObservables.apply(void 0, consoleObservables);
}
function createConsoleObservable(api) {
  return new Observable(function (observable) {
    var originalConsoleApi = globalConsole[api];
    globalConsole[api] = function () {
      var params = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
      }
      originalConsoleApi.apply(console, params);
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        observable.notify(buildConsoleLog(params, api, handlingStack));
      });
    };
    return function () {
      globalConsole[api] = originalConsoleApi;
    };
  });
}
function buildConsoleLog(params, api, handlingStack) {
  var message = params.map(function (param) {
    return formatConsoleParameters(param);
  }).join(' ');
  var stack;
  var fingerprint;
  var causes;
  if (api === ConsoleApiName.error) {
    var firstErrorParam = find(params, function (param) {
      return param instanceof Error;
    });
    stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
    fingerprint = tryToGetFingerprint(firstErrorParam);
    causes = firstErrorParam ? flattenErrorCauses(firstErrorParam, 'console') : undefined;
  }
  return {
    api: api,
    message: message,
    stack: stack,
    handlingStack: handlingStack,
    fingerprint: fingerprint,
    causes: causes
  };
}
function formatConsoleParameters(param) {
  if (typeof param === 'string') {
    return sanitize(param);
  }
  if (param instanceof Error) {
    return formatErrorMessage(computeStackTrace(param));
  }
  return jsonStringify(sanitize(param), undefined, 2);
}

function createContextManager(customerDataTracker) {
  var context = {};
  var changeObservable = new Observable();
  var contextManager = {
    getContext: function () {
      return deepClone(context);
    },
    setContext: function (newContext) {
      if (getType(newContext) === 'object') {
        context = sanitize(newContext);
        customerDataTracker.updateCustomerData(context);
      } else {
        contextManager.clearContext();
      }
      changeObservable.notify();
    },
    setContextProperty: function (key, property) {
      context[key] = sanitize(property);
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    removeContextProperty: function (key) {
      delete context[key];
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    clearContext: function () {
      context = {};
      customerDataTracker.resetCustomerData();
      changeObservable.notify();
    },
    changeObservable: changeObservable
  };
  return contextManager;
}

var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
  var storageKey = buildStorageKey(productKey, customerDataType);
  storageListeners.push(addEventListener(configuration, window, DOM_EVENT.STORAGE, function (_a) {
    var key = _a.key;
    if (storageKey === key) {
      synchronizeWithStorage();
    }
  }));
  contextManager.changeObservable.subscribe(dumpToStorage);
  contextManager.setContext(combine(getFromStorage(), contextManager.getContext()));
  function synchronizeWithStorage() {
    contextManager.setContext(getFromStorage());
  }
  function dumpToStorage() {
    localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
  }
  function getFromStorage() {
    var rawContext = localStorage.getItem(storageKey);
    return rawContext !== null ? JSON.parse(rawContext) : {};
  }
}
function buildStorageKey(productKey, customerDataType) {
  return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}

// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * ONE_KIBI_BYTE;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * ONE_KIBI_BYTE;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createCustomerDataTrackerManager(compressionStatus) {
  if (compressionStatus === void 0) {
    compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */;
  }
  var customerDataTrackers = new Map();
  var alreadyWarned = false;
  function checkCustomerDataLimit(initialBytesCount) {
    if (initialBytesCount === void 0) {
      initialBytesCount = 0;
    }
    if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
      return;
    }
    var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */ ? CUSTOMER_DATA_BYTES_LIMIT : CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
    var bytesCount = initialBytesCount;
    customerDataTrackers.forEach(function (tracker) {
      bytesCount += tracker.getBytesCount();
    });
    if (bytesCount > bytesCountLimit) {
      displayCustomerDataLimitReachedWarning(bytesCountLimit);
      alreadyWarned = true;
    }
  }
  return {
    /**
     * Creates a detached tracker. The manager will not store a reference to that tracker, and the
     * bytes count will be counted independently from other detached trackers.
     *
     * This is particularly useful when we don't know when the tracker will be unused, so we don't
     * leak memory (ex: when used in Logger instances).
     */
    createDetachedTracker: function () {
      var tracker = createCustomerDataTracker(function () {
        return checkCustomerDataLimit(tracker.getBytesCount());
      });
      return tracker;
    },
    /**
     * Creates a tracker if it doesn't exist, and returns it.
     */
    getOrCreateTracker: function (type) {
      if (!customerDataTrackers.has(type)) {
        customerDataTrackers.set(type, createCustomerDataTracker(checkCustomerDataLimit));
      }
      return customerDataTrackers.get(type);
    },
    setCompressionStatus: function (newCompressionStatus) {
      if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
        compressionStatus = newCompressionStatus;
        checkCustomerDataLimit();
      }
    },
    getCompressionStatus: function () {
      return compressionStatus;
    },
    stop: function () {
      customerDataTrackers.forEach(function (tracker) {
        return tracker.stop();
      });
      customerDataTrackers.clear();
    }
  };
}
function createCustomerDataTracker(checkCustomerDataLimit) {
  var bytesCountCache = 0;
  // Throttle the bytes computation to minimize the impact on performance.
  // Especially useful if the user call context APIs synchronously multiple times in a row
  var _a = throttle(function (context) {
      bytesCountCache = computeBytesCount(jsonStringify(context));
      checkCustomerDataLimit();
    }, BYTES_COMPUTATION_THROTTLING_DELAY),
    computeBytesCountThrottled = _a.throttled,
    cancelComputeBytesCount = _a.cancel;
  var resetBytesCount = function () {
    cancelComputeBytesCount();
    bytesCountCache = 0;
  };
  return {
    updateCustomerData: function (context) {
      if (isEmptyObject(context)) {
        resetBytesCount();
      } else {
        computeBytesCountThrottled(context);
      }
    },
    resetCustomerData: resetBytesCount,
    getBytesCount: function () {
      return bytesCountCache;
    },
    stop: function () {
      cancelComputeBytesCount();
    }
  };
}
function displayCustomerDataLimitReachedWarning(bytesCountLimit) {
  display.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / ONE_KIBI_BYTE, "KiB threshold. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}

/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
  var reader = stream.getReader();
  var chunks = [];
  var readBytesCount = 0;
  readMore();
  function readMore() {
    reader.read().then(monitor(function (result) {
      if (result.done) {
        onDone();
        return;
      }
      if (options.collectStreamBody) {
        chunks.push(result.value);
      }
      readBytesCount += result.value.length;
      if (readBytesCount > options.bytesLimit) {
        onDone();
      } else {
        readMore();
      }
    }), monitor(function (error) {
      return callback(error);
    }));
  }
  function onDone() {
    reader.cancel().catch(
    // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    noop$1);
    var bytes;
    var limitExceeded;
    if (options.collectStreamBody) {
      var completeBuffer_1;
      if (chunks.length === 1) {
        // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
        // use it directly.
        completeBuffer_1 = chunks[0];
      } else {
        // else, we need to copy buffers into a larger buffer to concatenate them.
        completeBuffer_1 = new Uint8Array(readBytesCount);
        var offset_1 = 0;
        chunks.forEach(function (chunk) {
          completeBuffer_1.set(chunk, offset_1);
          offset_1 += chunk.length;
        });
      }
      bytes = completeBuffer_1.slice(0, options.bytesLimit);
      limitExceeded = completeBuffer_1.length > options.bytesLimit;
    }
    callback(undefined, bytes, limitExceeded);
  }
}

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
  return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
  var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
  var value = window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}

/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
  // We shallow clone only to prevent mutation of user data.
  var user = assign({}, newUser);
  var keys = ['id', 'name', 'email'];
  keys.forEach(function (key) {
    if (key in user) {
      user[key] = String(user[key]);
    }
  });
  return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
  var isValid = getType(newUser) === 'object';
  if (!isValid) {
    display.error('Unsupported user:', newUser);
  }
  return isValid;
}

function isMatchOption(item) {
  var itemType = getType(item);
  return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
  if (useStartsWith === void 0) {
    useStartsWith = false;
  }
  return list.some(function (item) {
    try {
      if (typeof item === 'function') {
        return item(value);
      } else if (item instanceof RegExp) {
        return item.test(value);
      } else if (typeof item === 'string') {
        return useStartsWith ? startsWith$1(value, item) : item === value;
      }
    } catch (e) {
      display.error(e);
    }
    return false;
  });
}

function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
  return {
    context: globalContextManager.getContext(),
    user: userContextManager.getContext(),
    hasReplay: recorderApi.isRecording() ? true : undefined
  };
}

function isTracingOption(item) {
  var expectedItem = item;
  return getType(expectedItem) === 'object' && isMatchOption(expectedItem.match) && Array.isArray(expectedItem.propagatorTypes);
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
  if (context.status === 0 && !context.isAborted) {
    context.traceId = undefined;
    context.spanId = undefined;
    context.traceSampled = undefined;
  }
}
function startTracer(configuration, sessionManager) {
  return {
    clearTracingIfNeeded: clearTracingIfNeeded,
    traceFetch: function (context) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        var _a;
        if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
          context.input = new Request(context.input);
          Object.keys(tracingHeaders).forEach(function (key) {
            context.input.headers.append(key, tracingHeaders[key]);
          });
        } else {
          context.init = shallowClone(context.init);
          var headers_1 = [];
          if (context.init.headers instanceof Headers) {
            context.init.headers.forEach(function (value, key) {
              headers_1.push([key, value]);
            });
          } else if (Array.isArray(context.init.headers)) {
            context.init.headers.forEach(function (header) {
              headers_1.push(header);
            });
          } else if (context.init.headers) {
            Object.keys(context.init.headers).forEach(function (key) {
              headers_1.push([key, context.init.headers[key]]);
            });
          }
          context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
        }
      });
    },
    traceXhr: function (context, xhr) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        Object.keys(tracingHeaders).forEach(function (name) {
          xhr.setRequestHeader(name, tracingHeaders[name]);
        });
      });
    }
  };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
  if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
    return;
  }
  var tracingOption = find(configuration.allowedTracingUrls, function (tracingOption) {
    return matchList([tracingOption.match], context.url, true);
  });
  if (!tracingOption) {
    return;
  }
  context.traceSampled = !isNumber(configuration.traceSampleRate) || performDraw(configuration.traceSampleRate);
  if (!context.traceSampled && configuration.traceContextInjection !== TraceContextInjection.ALL) {
    return;
  }
  context.traceId = new TraceIdentifier();
  context.spanId = new TraceIdentifier();
  inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
  return getCrypto() !== undefined;
}
function getCrypto() {
  return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
  var tracingHeaders = {};
  propagatorTypes.forEach(function (propagatorType) {
    switch (propagatorType) {
      case 'datadog':
        {
          assign(tracingHeaders, {
            'x-datadog-origin': 'rum',
            'x-datadog-parent-id': spanId.toDecimalString(),
            'x-datadog-sampling-priority': traceSampled ? '1' : '0',
            'x-datadog-trace-id': traceId.toDecimalString()
          });
          break;
        }
      // https://www.w3.org/TR/trace-context/
      case 'tracecontext':
        {
          assign(tracingHeaders, {
            traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      // https://github.com/openzipkin/b3-propagation
      case 'b3':
        {
          assign(tracingHeaders, {
            b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      case 'b3multi':
        {
          assign(tracingHeaders, {
            'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
            'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
            'X-B3-Sampled': traceSampled ? '1' : '0'
          });
          break;
        }
    }
  });
  return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */function () {
  function TraceIdentifier() {
    this.buffer = new Uint8Array(8);
    getCrypto().getRandomValues(this.buffer);
    this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
  }
  TraceIdentifier.prototype.toString = function (radix) {
    var high = this.readInt32(0);
    var low = this.readInt32(4);
    var str = '';
    do {
      var mod = high % radix * 4294967296 + low;
      high = Math.floor(high / radix);
      low = Math.floor(mod / radix);
      str = (mod % radix).toString(radix) + str;
    } while (high || low);
    return str;
  };
  /**
   * Format used everywhere except the trace intake
   */
  TraceIdentifier.prototype.toDecimalString = function () {
    return this.toString(10);
  };
  /**
   * Format used by OTel headers
   */
  TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
    var traceId = this.toString(16);
    return Array(17 - traceId.length).join('0') + traceId;
  };
  TraceIdentifier.prototype.readInt32 = function (offset) {
    return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
  };
  return TraceIdentifier;
}();
/* eslint-enable no-bitwise */

var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
  var _a, _b;
  if (!initConfiguration.applicationId) {
    display.error('Application ID is not configured, no RUM data will be collected.');
    return;
  }
  if (initConfiguration.sessionReplaySampleRate !== undefined && !isPercentage(initConfiguration.sessionReplaySampleRate)) {
    display.error('Session Replay Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.traceSampleRate !== undefined && !isPercentage(initConfiguration.traceSampleRate)) {
    display.error('Trace Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
    display.error('Excluded Activity Urls should be an array');
    return;
  }
  var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
  if (!allowedTracingUrls) {
    return;
  }
  var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
  if (!baseConfiguration) {
    return;
  }
  return assign({
    applicationId: initConfiguration.applicationId,
    version: initConfiguration.version || undefined,
    actionNameAttribute: initConfiguration.actionNameAttribute,
    sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
    startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
    traceSampleRate: initConfiguration.traceSampleRate,
    allowedTracingUrls: allowedTracingUrls,
    excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
    workerUrl: initConfiguration.workerUrl,
    compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
    trackUserInteractions: !!initConfiguration.trackUserInteractions,
    trackViewsManually: !!initConfiguration.trackViewsManually,
    trackResources: !!initConfiguration.trackResources,
    trackLongTasks: !!initConfiguration.trackLongTasks,
    subdomain: initConfiguration.subdomain,
    defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : DefaultPrivacyLevel.MASK,
    enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
    customerDataTelemetrySampleRate: 1,
    traceContextInjection: objectHasValue(TraceContextInjection, initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : TraceContextInjection.ALL,
    plugins: isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS) && initConfiguration.plugins || []
  }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
  if (initConfiguration.allowedTracingUrls !== undefined) {
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
      display.error('Allowed Tracing URLs should be an array');
      return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
      display.error('Service needs to be configured when tracing is enabled');
      return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    var tracingOptions_1 = [];
    initConfiguration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        tracingOptions_1.push({
          match: option,
          propagatorTypes: DEFAULT_PROPAGATOR_TYPES
        });
      } else if (isTracingOption(option)) {
        tracingOptions_1.push(option);
      } else {
        display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
      }
    });
    return tracingOptions_1;
  }
  return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
  var usedTracingPropagators = new Set();
  if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
    configuration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      } else if (getType(option) === 'object' && Array.isArray(option.propagatorTypes)) {
        // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
        option.propagatorTypes.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      }
    });
  }
  return arrayFrom(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
  var _a;
  var baseSerializedConfiguration = serializeConfiguration(configuration);
  return assign({
    session_replay_sample_rate: configuration.sessionReplaySampleRate,
    start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
    trace_sample_rate: configuration.traceSampleRate,
    trace_context_injection: configuration.traceContextInjection,
    action_name_attribute: configuration.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
    selected_tracing_propagators: getSelectedTracingPropagators(configuration),
    default_privacy_level: configuration.defaultPrivacyLevel,
    enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
    use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
    use_worker_url: !!configuration.workerUrl,
    compress_intake_requests: configuration.compressIntakeRequests,
    track_views_manually: configuration.trackViewsManually,
    track_user_interactions: configuration.trackUserInteractions,
    track_resources: configuration.trackResources,
    track_long_task: configuration.trackLongTasks,
    plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map(function (plugin) {
      var _a;
      return assign({
        name: plugin.name
      }, (_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin));
    })
  }, baseSerializedConfiguration);
}

var REMOTE_CONFIGURATION_URL = 'https://d3uc069fcn7uxw.cloudfront.net/configuration';
function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
  fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
    callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
  });
}
function applyRemoteConfiguration(initConfiguration, remoteInitConfiguration) {
  return assign({}, initConfiguration, remoteInitConfiguration);
}
function fetchRemoteConfiguration(configuration, callback) {
  var xhr = new XMLHttpRequest();
  addEventListener(configuration, xhr, 'load', function () {
    if (xhr.status === 200) {
      callback(JSON.parse(xhr.responseText));
    } else {
      displayRemoteConfigurationFetchingError();
    }
  });
  addEventListener(configuration, xhr, 'error', function () {
    displayRemoteConfigurationFetchingError();
  });
  xhr.open('GET', "".concat(REMOTE_CONFIGURATION_URL, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json"));
  xhr.send();
}
function displayRemoteConfigurationFetchingError() {
  display.error('Error fetching the remote configuration.');
}

function startVitalCollection(lifeCycle, pageStateHistory) {
  function isValid(vital) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, vital.startClocks.relative, vital.duration);
  }
  function addDurationVital(vital) {
    if (isValid(vital)) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital, true));
    }
  }
  return {
    addDurationVital: addDurationVital,
    startDurationVital: function (startVital) {
      return createVitalInstance(function (vital) {
        addDurationVital(vital);
      }, startVital);
    }
  };
}
function createVitalInstance(stopCallback, vitalStart) {
  var startClocks = clocksNow();
  var stopClocks;
  return {
    stop: function (vitalStop) {
      if (stopClocks) {
        return;
      }
      stopClocks = clocksNow();
      stopCallback(buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks));
    }
  };
}
function buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks) {
  var _a;
  if (vitalStop === void 0) {
    vitalStop = {};
  }
  return {
    name: vitalStart.name,
    type: "duration" /* VitalType.DURATION */,
    startClocks: startClocks,
    duration: elapsed(startClocks.timeStamp, stopClocks.timeStamp),
    context: combine(vitalStart.context, vitalStop.context),
    details: (_a = vitalStop.details) !== null && _a !== void 0 ? _a : vitalStart.details
  };
}
function processVital(vital, valueComputedBySdk) {
  var rawRumEvent = {
    date: vital.startClocks.timeStamp,
    vital: {
      id: generateUUID(),
      type: vital.type,
      name: vital.name,
      duration: toServerDuration(vital.duration),
      details: vital.details
    },
    type: "vital" /* RumEventType.VITAL */
  };
  if (valueComputedBySdk) {
    rawRumEvent._dd = {
      vital: {
        computed_value: true
      }
    };
  }
  return {
    rawRumEvent: rawRumEvent,
    startTime: vital.startClocks.relative,
    customerContext: vital.context,
    domainContext: {}
  };
}

function callPluginsMethod(plugins, methodName, parameter) {
  if (!plugins) {
    return;
  }
  for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
    var plugin = plugins_1[_i];
    var method = plugin[methodName];
    if (method) {
      method(parameter);
    }
  }
}

function createPreStartStrategy(_a, getCommonContext, trackingConsentState, doStartRum) {
  var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum,
    startDeflateWorker = _a.startDeflateWorker;
  var bufferApiCalls = new BoundedBuffer();
  var firstStartViewCall;
  var deflateWorker;
  var cachedInitConfiguration;
  var cachedConfiguration;
  var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
  function tryStartRum() {
    if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
      return;
    }
    trackingConsentStateSubscription.unsubscribe();
    var initialViewOptions;
    if (cachedConfiguration.trackViewsManually) {
      if (!firstStartViewCall) {
        return;
      }
      // An initial view is always created when starting RUM.
      // When tracking views automatically, any startView call before RUM start creates an extra
      // view.
      // When tracking views manually, we use the ViewOptions from the first startView call as the
      // initial view options, and we remove the actual startView call so we don't create an extra
      // view.
      bufferApiCalls.remove(firstStartViewCall.callback);
      initialViewOptions = firstStartViewCall.options;
    }
    var startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
    bufferApiCalls.drain(startRumResult);
  }
  function doInit(initConfiguration) {
    var eventBridgeAvailable = canUseEventBridge();
    if (eventBridgeAvailable) {
      initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
    }
    // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
    cachedInitConfiguration = initConfiguration;
    addTelemetryConfiguration(serializeRumConfiguration(initConfiguration));
    if (cachedConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
      return;
    }
    var configuration = validateAndBuildRumConfiguration(initConfiguration);
    if (!configuration) {
      return;
    }
    if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
      display.warn('No storage available for session. We will not send any data.');
      return;
    }
    if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
      deflateWorker = startDeflateWorker(configuration, 'Datadog RUM',
      // Worker initialization can fail asynchronously, especially in Firefox where even CSP
      // issues are reported asynchronously. For now, the SDK will continue its execution even if
      // data won't be sent to Datadog. We could improve this behavior in the future.
      noop$1);
      if (!deflateWorker) {
        // `startDeflateWorker` should have logged an error message explaining the issue
        return;
      }
    }
    cachedConfiguration = configuration;
    // Instrumuent fetch to track network requests
    // This is needed in case the consent is not granted and some cutsomer
    // library (Apollo Client) is storing uninstrumented fetch to be used later
    // The subscrption is needed so that the instrumentation process is completed
    initFetchObservable().subscribe(noop$1);
    trackingConsentState.tryToInit(configuration.trackingConsent);
    tryStartRum();
  }
  var addDurationVital = function (vital) {
    bufferApiCalls.add(function (startRumResult) {
      return startRumResult.addDurationVital(vital);
    });
  };
  return {
    init: function (initConfiguration, publicApi) {
      if (!initConfiguration) {
        display.error('Missing configuration');
        return;
      }
      // Set the experimental feature flags as early as possible, so we can use them in most places
      initFeatureFlags(initConfiguration.enableExperimentalFeatures);
      // Expose the initial configuration regardless of initialization success.
      cachedInitConfiguration = initConfiguration;
      // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
      // to completely discard the customer application RUM instance by ignoring their init() call.
      // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
      // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
      if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
        return;
      }
      if (isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS)) {
        callPluginsMethod(initConfiguration.plugins, 'onInit', {
          initConfiguration: initConfiguration,
          publicApi: publicApi
        });
      }
      if (initConfiguration.remoteConfigurationId && isExperimentalFeatureEnabled(ExperimentalFeature.REMOTE_CONFIGURATION)) {
        fetchAndApplyRemoteConfiguration(initConfiguration, doInit);
      } else {
        doInit(initConfiguration);
      }
    },
    get initConfiguration() {
      return cachedInitConfiguration;
    },
    getInternalContext: noop$1,
    stopSession: noop$1,
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addTiming(name, time);
      });
    },
    startView: function (options, startClocks) {
      if (startClocks === void 0) {
        startClocks = clocksNow();
      }
      var callback = function (startRumResult) {
        startRumResult.startView(options, startClocks);
      };
      bufferApiCalls.add(callback);
      if (!firstStartViewCall) {
        firstStartViewCall = {
          options: options,
          callback: callback
        };
        tryStartRum();
      }
    },
    updateViewName: function (name) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.updateViewName(name);
      });
    },
    addAction: function (action, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addAction(action, commonContext);
      });
    },
    addError: function (providedError, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addError(providedError, commonContext);
      });
    },
    addFeatureFlagEvaluation: function (key, value) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addFeatureFlagEvaluation(key, value);
      });
    },
    startDurationVital: function (vitalStart) {
      return createVitalInstance(function (vital) {
        return addDurationVital(vital);
      }, vitalStart);
    },
    addDurationVital: addDurationVital
  };
}
function overrideInitConfigurationForBridge(initConfiguration) {
  var _a, _b;
  return assign({}, initConfiguration, {
    applicationId: '00000000-aaaa-0000-aaaa-000000000000',
    clientToken: 'empty',
    sessionSampleRate: 100,
    defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = getEventBridge()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
  });
}

var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, options) {
  if (options === void 0) {
    options = {};
  }
  var customerDataTrackerManager = createCustomerDataTrackerManager(0 /* CustomerDataCompressionStatus.Unknown */);
  var globalContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
  var userContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
  var trackingConsentState = createTrackingConsentState();
  function getCommonContext() {
    return buildCommonContext(globalContextManager, userContextManager, recorderApi);
  }
  var strategy = createPreStartStrategy(options, getCommonContext, trackingConsentState, function (configuration, deflateWorker, initialViewOptions) {
    if (isExperimentalFeatureEnabled(ExperimentalFeature.CUSTOM_VITALS)) {
      rumPublicApi.startDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'start-duration-vital'
        });
        return strategy.startDurationVital({
          name: sanitize(name),
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.addDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'add-duration-vital'
        });
        strategy.addDurationVital({
          name: sanitize(name),
          type: "duration" /* VitalType.DURATION */,
          startClocks: timeStampToClocks(options.startTime),
          duration: options.duration,
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.stopDurationVital = noop$1;
    }
    if (isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
      rumPublicApi.updateViewName = monitor(function (name) {
        strategy.updateViewName(name);
      });
    }
    if (configuration.storeContextsAcrossPages) {
      storeContextManager(configuration, globalContextManager, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
      storeContextManager(configuration, userContextManager, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
    }
    customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */ : 2 /* CustomerDataCompressionStatus.Disabled */);
    var startRumResult = startRumImpl(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder ? function (streamId) {
      return options.createDeflateEncoder(configuration, deflateWorker, streamId);
    } : createIdentityEncoder, trackingConsentState);
    recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
    strategy = createPostStartStrategy(strategy, startRumResult);
    return startRumResult;
  });
  var startView = monitor(function (options) {
    var sanitizedOptions = typeof options === 'object' ? options : {
      name: options
    };
    strategy.startView(sanitizedOptions);
    addTelemetryUsage({
      feature: 'start-view'
    });
  });
  var rumPublicApi = makePublicApi({
    init: monitor(function (initConfiguration) {
      return strategy.init(initConfiguration, rumPublicApi);
    }),
    setTrackingConsent: monitor(function (trackingConsent) {
      trackingConsentState.update(trackingConsent);
      addTelemetryUsage({
        feature: 'set-tracking-consent',
        tracking_consent: trackingConsent
      });
    }),
    setGlobalContext: monitor(function (context) {
      globalContextManager.setContext(context);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    getGlobalContext: monitor(function () {
      return globalContextManager.getContext();
    }),
    setGlobalContextProperty: monitor(function (key, value) {
      globalContextManager.setContextProperty(key, value);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    removeGlobalContextProperty: monitor(function (key) {
      return globalContextManager.removeContextProperty(key);
    }),
    clearGlobalContext: monitor(function () {
      return globalContextManager.clearContext();
    }),
    getInternalContext: monitor(function (startTime) {
      return strategy.getInternalContext(startTime);
    }),
    getInitConfiguration: monitor(function () {
      return deepClone(strategy.initConfiguration);
    }),
    addAction: function (name, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addAction({
          name: sanitize(name),
          context: sanitize(context),
          startClocks: clocksNow(),
          type: "custom" /* ActionType.CUSTOM */,
          handlingStack: handlingStack
        });
        addTelemetryUsage({
          feature: 'add-action'
        });
      });
    },
    addError: function (error, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addError({
          error: error,
          // Do not sanitize error here, it is needed unserialized by computeRawError()
          handlingStack: handlingStack,
          context: sanitize(context),
          startClocks: clocksNow()
        });
        addTelemetryUsage({
          feature: 'add-error'
        });
      });
    },
    addTiming: monitor(function (name, time) {
      // TODO: next major decide to drop relative time support or update its behaviour
      strategy.addTiming(sanitize(name), time);
    }),
    setUser: monitor(function (newUser) {
      if (checkUser(newUser)) {
        userContextManager.setContext(sanitizeUser(newUser));
      }
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    getUser: monitor(function () {
      return userContextManager.getContext();
    }),
    setUserProperty: monitor(function (key, property) {
      var _a;
      var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
      userContextManager.setContextProperty(key, sanitizedProperty);
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    removeUserProperty: monitor(function (key) {
      return userContextManager.removeContextProperty(key);
    }),
    clearUser: monitor(function () {
      return userContextManager.clearContext();
    }),
    startView: startView,
    stopSession: monitor(function () {
      strategy.stopSession();
      addTelemetryUsage({
        feature: 'stop-session'
      });
    }),
    addFeatureFlagEvaluation: monitor(function (key, value) {
      strategy.addFeatureFlagEvaluation(sanitize(key), sanitize(value));
      addTelemetryUsage({
        feature: 'add-feature-flag-evaluation'
      });
    }),
    getSessionReplayLink: monitor(function () {
      return recorderApi.getSessionReplayLink();
    }),
    startSessionReplayRecording: monitor(function (options) {
      recorderApi.start(options);
      addTelemetryUsage({
        feature: 'start-session-replay-recording',
        force: options === null || options === void 0 ? void 0 : options.force
      });
    }),
    stopSessionReplayRecording: monitor(function () {
      return recorderApi.stop();
    })
  });
  return rumPublicApi;
}
function createPostStartStrategy(preStartStrategy, startRumResult) {
  return assign({
    init: function (initConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
    },
    initConfiguration: preStartStrategy.initConfiguration
  }, startRumResult);
}

function createDOMMutationObservable() {
  var MutationObserver = getMutationObserverConstructor();
  return new Observable(function (observable) {
    if (!MutationObserver) {
      return;
    }
    var observer = new MutationObserver(monitor(function () {
      return observable.notify();
    }));
    observer.observe(document, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
}
function getMutationObserverConstructor() {
  var constructor;
  var browserWindow = window;
  // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
  // global MutationObserver constructor with a patched version to support the context propagation.
  // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
  // component: on some occasions, the callback is being called in an infinite loop, causing the
  // page to freeze (even if the callback is completely empty).
  //
  // To work around this issue, we try to get the original MutationObserver constructor stored by
  // Zone.js.
  //
  // [1] https://github.com/angular/angular/issues/26948
  // [2] https://github.com/angular/angular/issues/31712
  if (browserWindow.Zone) {
    // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
    //
    // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
    constructor = getZoneJsOriginalValue(browserWindow, 'MutationObserver');
    if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
      // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
      // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
      // instance in its properties[4]. Let's get the original MutationObserver constructor from
      // there.
      //
      // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
      var patchedInstance = new browserWindow.MutationObserver(noop$1);
      var originalInstance = getZoneJsOriginalValue(patchedInstance, 'originalInstance');
      constructor = originalInstance && originalInstance.constructor;
    }
  }
  if (!constructor) {
    constructor = browserWindow.MutationObserver;
  }
  return constructor;
}

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [["document" /* ResourceType.DOCUMENT */, function (initiatorType) {
  return FAKE_INITIAL_DOCUMENT === initiatorType;
}], ["xhr" /* ResourceType.XHR */, function (initiatorType) {
  return 'xmlhttprequest' === initiatorType;
}], ["fetch" /* ResourceType.FETCH */, function (initiatorType) {
  return 'fetch' === initiatorType;
}], ["beacon" /* ResourceType.BEACON */, function (initiatorType) {
  return 'beacon' === initiatorType;
}], ["css" /* ResourceType.CSS */, function (_, path) {
  return /\.css$/i.test(path);
}], ["js" /* ResourceType.JS */, function (_, path) {
  return /\.js$/i.test(path);
}], ["image" /* ResourceType.IMAGE */, function (initiatorType, path) {
  return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
}], ["font" /* ResourceType.FONT */, function (_, path) {
  return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
}], ["media" /* ResourceType.MEDIA */, function (initiatorType, path) {
  return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
}]];
function computeResourceKind(timing) {
  var url = timing.name;
  if (!isValidUrl(url)) {
    addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
    return "other" /* ResourceType.OTHER */;
  }
  var path = getPathName(url);
  for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
    var _a = RESOURCE_TYPES_1[_i],
      type = _a[0],
      isType = _a[1];
    if (isType(timing.initiatorType, path)) {
      return type;
    }
  }
  return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
  var numbers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    numbers[_i] = arguments[_i];
  }
  for (var i = 1; i < numbers.length; i += 1) {
    if (numbers[i - 1] > numbers[i]) {
      return false;
    }
  }
  return true;
}
function isRequestKind(timing) {
  return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
  var duration = entry.duration,
    startTime = entry.startTime,
    responseEnd = entry.responseEnd;
  // Safari duration is always 0 on timings blocked by cross origin policies.
  if (duration === 0 && startTime < responseEnd) {
    return toServerDuration(elapsed(startTime, responseEnd));
  }
  return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
  if (!isValidEntry(entry)) {
    return undefined;
  }
  var startTime = entry.startTime,
    fetchStart = entry.fetchStart,
    redirectStart = entry.redirectStart,
    redirectEnd = entry.redirectEnd,
    domainLookupStart = entry.domainLookupStart,
    domainLookupEnd = entry.domainLookupEnd,
    connectStart = entry.connectStart,
    secureConnectionStart = entry.secureConnectionStart,
    connectEnd = entry.connectEnd,
    requestStart = entry.requestStart,
    responseStart = entry.responseStart,
    responseEnd = entry.responseEnd;
  var details = {
    download: formatTiming(startTime, responseStart, responseEnd),
    first_byte: formatTiming(startTime, requestStart, responseStart)
  };
  // Make sure a connection occurred
  if (fetchStart < connectEnd) {
    details.connect = formatTiming(startTime, connectStart, connectEnd);
    // Make sure a secure connection occurred
    if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
      details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
    }
  }
  // Make sure a domain lookup occurred
  if (fetchStart < domainLookupEnd) {
    details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
  }
  // Make sure a redirection occurred
  if (startTime < redirectEnd) {
    details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
  }
  return details;
}
function isValidEntry(entry) {
  if (isExperimentalFeatureEnabled(ExperimentalFeature.TOLERANT_RESOURCE_TIMINGS)) {
    return true;
  }
  // Ensure timings are in the right order. On top of filtering out potential invalid
  // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
  // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
  // it.
  var areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
  var areRedirectionTimingsInOrder = hasRedirection(entry) ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
  return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
  return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
  if (origin <= start && start <= end) {
    return {
      duration: toServerDuration(elapsed(start, end)),
      start: toServerDuration(elapsed(origin, start))
    };
  }
}
function computeSize(entry) {
  // Make sure a request actually occurred
  if (entry.startTime < entry.responseStart) {
    var encodedBodySize = entry.encodedBodySize,
      decodedBodySize = entry.decodedBodySize,
      transferSize = entry.transferSize;
    return {
      size: decodedBodySize,
      encoded_body_size: encodedBodySize,
      decoded_body_size: decodedBodySize,
      transfer_size: transferSize
    };
  }
  return {
    size: undefined,
    encoded_body_size: undefined,
    decoded_body_size: undefined,
    transfer_size: undefined
  };
}
function isAllowedRequestUrl(configuration, url) {
  return url && !configuration.isIntakeUrl(url);
}
var DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 24000;
function isLongDataUrl(url) {
  if (url.length <= MAX_ATTRIBUTE_VALUE_CHAR_LENGTH) {
    return false;
  } else if (url.substring(0, 5) === 'data:') {
    // Avoid String.match RangeError: Maximum call stack size exceeded
    url = url.substring(0, MAX_ATTRIBUTE_VALUE_CHAR_LENGTH);
    return true;
  }
  return false;
}
function sanitizeDataUrl(url) {
  return "".concat(url.match(DATA_URL_REGEX)[0], "[...]");
}
function computeRelativePerformanceTiming() {
  var result = {};
  var timing = performance.timing;
  for (var key in timing) {
    if (isNumber(timing[key])) {
      var numberKey = key;
      var timingElement = timing[numberKey];
      result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
    }
  }
  return result;
}

// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
  RumPerformanceEntryType["EVENT"] = "event";
  RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
  RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
  RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
  RumPerformanceEntryType["LONG_TASK"] = "longtask";
  RumPerformanceEntryType["NAVIGATION"] = "navigation";
  RumPerformanceEntryType["PAINT"] = "paint";
  RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function createPerformanceObservable(configuration, options) {
  return new Observable(function (observable) {
    var observer;
    var timeoutId;
    if (window.PerformanceObserver) {
      var isObserverInitializing_1 = true;
      var handlePerformanceEntries_1 = function (entries) {
        var rumPerformanceEntries = filterRumPerformanceEntries(configuration, entries);
        if (rumPerformanceEntries.length > 0) {
          observable.notify(rumPerformanceEntries);
        }
      };
      observer = new PerformanceObserver(monitor(function (entries) {
        // In Safari the performance observer callback is synchronous.
        // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
        if (isObserverInitializing_1) {
          timeoutId = setTimeout$1(function () {
            return handlePerformanceEntries_1(entries.getEntries());
          });
        } else {
          handlePerformanceEntries_1(entries.getEntries());
        }
      }));
      try {
        observer.observe(options);
      } catch (_a) {
        // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
        // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
        // TODO: remove this fallback in the next major version
        var fallbackSupportedEntryTypes = [RumPerformanceEntryType.RESOURCE, RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
        if (includes(fallbackSupportedEntryTypes, options.type)) {
          if (options.buffered) {
            timeoutId = setTimeout$1(function () {
              return handlePerformanceEntries_1(performance.getEntriesByType(options.type));
            });
          }
          observer.observe({
            entryTypes: [options.type]
          });
        }
      }
      isObserverInitializing_1 = false;
    }
    manageResourceTimingBufferFull(configuration);
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
      if (timeoutId) {
        clearTimeout$1(timeoutId);
      }
    };
  });
}
var resourceTimingBufferFullListener;
function manageResourceTimingBufferFull(configuration) {
  if (!resourceTimingBufferFullListener && supportPerformanceObject$1() && 'addEventListener' in performance) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    resourceTimingBufferFullListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
      performance.clearResourceTimings();
    });
  }
  return function () {
    resourceTimingBufferFullListener === null || resourceTimingBufferFullListener === void 0 ? void 0 : resourceTimingBufferFullListener.stop();
  };
}
function supportPerformanceObject$1() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function filterRumPerformanceEntries(configuration, entries) {
  return entries.filter(function (entry) {
    return isAllowedResource(configuration, entry);
  });
}
function isAllowedResource(configuration, entry) {
  return entry.entryType === RumPerformanceEntryType.RESOURCE && isAllowedRequestUrl(configuration, entry.name);
}

function supportPerformanceObject() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function startPerformanceCollection(lifeCycle, configuration) {
  var cleanupTasks = [];
  if (supportPerformanceObject()) {
    var performanceEntries_1 = performance.getEntries();
    // Because the performance entry list can be quite large
    // delay the computation to prevent the SDK from blocking the main thread on init
    setTimeout$1(function () {
      return handleRumPerformanceEntries(lifeCycle, performanceEntries_1);
    });
  }
  if (window.PerformanceObserver) {
    var handlePerformanceEntryList_1 = monitor(function (entries) {
      return handleRumPerformanceEntries(lifeCycle, entries.getEntries());
    });
    var mainEntries = [RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
    var experimentalEntries = [RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT, RumPerformanceEntryType.FIRST_INPUT, RumPerformanceEntryType.LAYOUT_SHIFT, RumPerformanceEntryType.EVENT];
    try {
      // Experimental entries are not retrieved by performance.getEntries()
      // use a single PerformanceObserver with buffered flag by type
      // to get values that could happen before SDK init
      experimentalEntries.forEach(function (type) {
        var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
        observer.observe({
          type: type,
          buffered: true,
          // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
          // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
          durationThreshold: 40
        });
        cleanupTasks.push(function () {
          return observer.disconnect();
        });
      });
    } catch (e) {
      // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
      // In these cases, fallback to PerformanceObserver with entryTypes
      mainEntries.push.apply(mainEntries, experimentalEntries);
    }
    var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
    mainObserver_1.observe({
      entryTypes: mainEntries
    });
    cleanupTasks.push(function () {
      return mainObserver_1.disconnect();
    });
    if (supportPerformanceObject() && 'addEventListener' in performance) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
      var removePerformanceListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
        performance.clearResourceTimings();
      }).stop;
      cleanupTasks.push(removePerformanceListener);
    }
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
    retrieveNavigationTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    });
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
    var stopFirstInputTiming = retrieveFirstInputTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    }).stop;
    cleanupTasks.push(stopFirstInputTiming);
  }
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function retrieveNavigationTiming(configuration, callback) {
  function sendFakeTiming() {
    callback(assign(computeRelativePerformanceTiming(), {
      entryType: RumPerformanceEntryType.NAVIGATION
    }));
  }
  runOnReadyState(configuration, 'complete', function () {
    // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
    setTimeout$1(sendFakeTiming);
  });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
  var startTimeStamp = dateNow();
  var timingSent = false;
  var removeEventListeners = addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.MOUSE_DOWN, DOM_EVENT.KEY_DOWN, DOM_EVENT.TOUCH_START, DOM_EVENT.POINTER_DOWN], function (evt) {
    // Only count cancelable events, which should trigger behavior important to the user.
    if (!evt.cancelable) {
      return;
    }
    // This timing will be used to compute the "first Input delay", which is the delta between
    // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
    // (e.g. performance.now()).
    var timing = {
      entryType: RumPerformanceEntryType.FIRST_INPUT,
      processingStart: relativeNow(),
      processingEnd: relativeNow(),
      startTime: evt.timeStamp,
      duration: 0,
      // arbitrary value to avoid nullable duration and simplify INP logic
      name: ''
    };
    if (evt.type === DOM_EVENT.POINTER_DOWN) {
      sendTimingIfPointerIsNotCancelled(configuration, timing);
    } else {
      sendTiming(timing);
    }
  }, {
    passive: true,
    capture: true
  }).stop;
  return {
    stop: removeEventListeners
  };
  /**
   * Pointer events are a special case, because they can trigger main or compositor thread behavior.
   * We differentiate these cases based on whether or not we see a pointercancel event, which are
   * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
   * scrolling and pinch/zooming.
   */
  function sendTimingIfPointerIsNotCancelled(configuration, timing) {
    addEventListeners(configuration, window, [DOM_EVENT.POINTER_UP, DOM_EVENT.POINTER_CANCEL], function (event) {
      if (event.type === DOM_EVENT.POINTER_UP) {
        sendTiming(timing);
      }
    }, {
      once: true
    });
  }
  function sendTiming(timing) {
    if (!timingSent) {
      timingSent = true;
      removeEventListeners();
      // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
      // the time between now and when the page was loaded.
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
      var delay = timing.processingStart - timing.startTime;
      if (delay >= 0 && delay < dateNow() - startTimeStamp) {
        callback(timing);
      }
    }
  }
}
function handleRumPerformanceEntries(lifeCycle, entries) {
  var rumPerformanceEntries = entries.filter(function (entry) {
    return objectHasValue(RumPerformanceEntryType, entry.entryType);
  });
  var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) {
    return !isIncompleteNavigation(entry);
  });
  if (rumAllowedPerformanceEntries.length) {
    lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
  }
}
function isIncompleteNavigation(entry) {
  return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}

function getSyntheticsContext() {
  var testId = getSyntheticsTestId();
  var resultId = getSyntheticsResultId();
  if (testId && resultId) {
    return {
      test_id: testId,
      result_id: resultId,
      injected: willSyntheticsInjectRum()
    };
  }
}

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
  var clone = deepClone(object);
  var result = modifier(clone);
  objectEntries(modifiableFieldPaths).forEach(function (_a) {
    var fieldPath = _a[0],
      fieldType = _a[1];
    var newValue = get(clone, fieldPath);
    var newType = getType(newValue);
    if (newType === fieldType) {
      set(object, fieldPath, sanitize(newValue));
    } else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
      set(object, fieldPath, {});
    }
  });
  return result;
}
function get(object, path) {
  var current = object;
  for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
    var field = _a[_i];
    if (!isValidObjectContaining(current, field)) {
      return;
    }
    current = current[field];
  }
  return current;
}
function set(object, path, value) {
  var current = object;
  var fields = path.split('.');
  for (var i = 0; i < fields.length; i += 1) {
    var field = fields[i];
    if (!isValidObject(current)) {
      return;
    }
    if (i !== fields.length - 1) {
      current = current[field];
    } else {
      current[field] = value;
    }
  }
}
function isValidObject(object) {
  return getType(object) === 'object';
}
function isValidObjectContaining(object, field) {
  return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}

var VIEW_MODIFIABLE_FIELD_PATHS = {
  'view.name': 'string',
  'view.url': 'string',
  'view.referrer': 'string'
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
  context: 'object'
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
  service: 'string',
  version: 'string'
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
  var _a, _b;
  modifiableFieldPathsByEvent = (_a = {}, _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS, _a["error" /* RumEventType.ERROR */] = assign({
    'error.message': 'string',
    'error.stack': 'string',
    'error.resource.url': 'string',
    'error.fingerprint': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["resource" /* RumEventType.RESOURCE */] = assign({
    'resource.url': 'string'
  }, isExperimentalFeatureEnabled(ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL) ? {
    'resource.graphql': 'object'
  } : {}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["action" /* RumEventType.ACTION */] = assign({
    'action.target.name': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["long_task" /* RumEventType.LONG_TASK */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a["vital" /* RumEventType.VITAL */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a);
  var eventRateLimiters = (_b = {}, _b["error" /* RumEventType.ERROR */] = createEventRateLimiter("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError), _b["action" /* RumEventType.ACTION */] = createEventRateLimiter("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError), _b["vital" /* RumEventType.VITAL */] = createEventRateLimiter("vital" /* RumEventType.VITAL */, configuration.eventRateLimiterThreshold, reportError), _b);
  var syntheticsContext = getSyntheticsContext();
  lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
    var startTime = _a.startTime,
      rawRumEvent = _a.rawRumEvent,
      domainContext = _a.domainContext,
      savedCommonContext = _a.savedCommonContext,
      customerContext = _a.customerContext;
    var viewContext = viewContexts.findView(startTime);
    var urlContext = urlContexts.findUrl(startTime);
    var session = sessionManager.findTrackedSession(startTime);
    if (session && viewContext && urlContext) {
      var commonContext = savedCommonContext || getCommonContext();
      var actionId = actionContexts.findActionId(startTime);
      var rumContext = {
        _dd: {
          format_version: 2,
          drift: currentDrift(),
          configuration: {
            session_sample_rate: round(configuration.sessionSampleRate, 3),
            session_replay_sample_rate: round(configuration.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: canUseEventBridge() ? "5.23.0" : undefined
        },
        application: {
          id: configuration.applicationId
        },
        date: timeStampNow(),
        service: viewContext.service || configuration.service,
        version: viewContext.version || configuration.version,
        source: 'browser',
        session: {
          id: session.id,
          type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciVisibilityContext.get() ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */
        },
        view: {
          id: viewContext.id,
          name: viewContext.name,
          url: urlContext.url,
          referrer: urlContext.referrer
        },
        action: needToAssembleWithAction(rawRumEvent) && actionId ? {
          id: actionId
        } : undefined,
        synthetics: syntheticsContext,
        ci_test: ciVisibilityContext.get(),
        display: displayContext.get(),
        connectivity: getConnectivity()
      };
      var serverRumEvent = combine(rumContext, rawRumEvent);
      serverRumEvent.context = combine(commonContext.context, customerContext);
      if (!('has_replay' in serverRumEvent.session)) {
        serverRumEvent.session.has_replay = commonContext.hasReplay;
      }
      if (serverRumEvent.type === 'view') {
        serverRumEvent.session.sampled_for_replay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */;
      }
      if (!isEmptyObject(commonContext.user)) {
        serverRumEvent.usr = commonContext.user;
      }
      if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
        if (isEmptyObject(serverRumEvent.context)) {
          delete serverRumEvent.context;
        }
        lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
      }
    }
  });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;
  if (beforeSend) {
    var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
      return beforeSend(event, domainContext);
    });
    if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
      return false;
    }
    if (result === false) {
      display.warn("Can't dismiss view events using beforeSend!");
    }
  }
  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}
function needToAssembleWithAction(event) {
  return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
  return {
    get: function (startTime) {
      var viewContext = viewContexts.findView(startTime);
      var urlContext = urlContexts.findUrl(startTime);
      var session = sessionManager.findTrackedSession(startTime);
      if (session && viewContext && urlContext) {
        var actionId = actionContexts.findActionId(startTime);
        return {
          application_id: applicationId,
          session_id: session.id,
          user_action: actionId ? {
            id: actionId
          } : undefined,
          view: {
            id: viewContext.id,
            name: viewContext.name,
            referrer: urlContext.referrer,
            url: urlContext.url
          }
        };
      }
    }
  };
}

var LifeCycle = AbstractLifeCycle;

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
  var viewContextHistory = new ValueHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
    viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    viewContextHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (viewUpdate) {
    var currentView = viewContextHistory.find(viewUpdate.startClocks.relative);
    if (currentView && viewUpdate.name) {
      currentView.name = viewUpdate.name;
    }
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    viewContextHistory.reset();
  });
  function buildViewContext(view) {
    return {
      service: view.service,
      version: view.version,
      id: view.id,
      name: view.name,
      startClocks: view.startClocks
    };
  }
  return {
    findView: function (startTime) {
      return viewContextHistory.find(startTime);
    },
    stop: function () {
      viewContextHistory.stop();
    }
  };
}

var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
  var tracer = startTracer(configuration, sessionManager);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = initXhrObservable(configuration).subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: "xhr" /* RequestType.XHR */,
          url: context.url,
          xhr: context.xhr,
          isAborted: context.isAborted,
          handlingStack: context.handlingStack
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = initFetchObservable().subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'resolve':
        waitForResponseToComplete(context, function (duration) {
          tracer.clearTracingIfNeeded(context);
          lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
            duration: duration,
            method: context.method,
            requestIndex: context.requestIndex,
            responseType: context.responseType,
            spanId: context.spanId,
            startClocks: context.startClocks,
            status: context.status,
            traceId: context.traceId,
            traceSampled: context.traceSampled,
            type: "fetch" /* RequestType.FETCH */,
            url: context.url,
            response: context.response,
            init: context.init,
            input: context.input,
            isAborted: context.isAborted,
            handlingStack: context.handlingStack
          });
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}
function waitForResponseToComplete(context, callback) {
  var clonedResponse = context.response && tryToClone(context.response);
  if (!clonedResponse || !clonedResponse.body) {
    // do not try to wait for the response if the clone failed, fetch error or null body
    callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
  } else {
    readBytesFromStream(clonedResponse.body, function () {
      callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
    }, {
      bytesLimit: Number.POSITIVE_INFINITY,
      collectStreamBody: false
    });
  }
}

function discardNegativeDuration(duration) {
  return isNumber(duration) && duration < 0 ? undefined : duration;
}

function trackEventCounts(_a) {
  var lifeCycle = _a.lifeCycle,
    isChildEvent = _a.isChildEvent,
    _b = _a.onChange,
    callback = _b === void 0 ? noop$1 : _b;
  var eventCounts = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  };
  var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    var _a;
    if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
      return;
    }
    switch (event.type) {
      case "error" /* RumEventType.ERROR */:
        eventCounts.errorCount += 1;
        callback();
        break;
      case "action" /* RumEventType.ACTION */:
        eventCounts.actionCount += 1;
        if (event.action.frustration) {
          eventCounts.frustrationCount += event.action.frustration.type.length;
        }
        callback();
        break;
      case "long_task" /* RumEventType.LONG_TASK */:
        eventCounts.longTaskCount += 1;
        callback();
        break;
      case "resource" /* RumEventType.RESOURCE */:
        if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
          eventCounts.resourceCount += 1;
          callback();
        }
        break;
    }
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    },
    eventCounts: eventCounts
  };
}

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
  var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
  return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
  var pageActivityEndTimeoutId;
  var hasCompleted = false;
  var validationTimeoutId = setTimeout$1(monitor(function () {
    return complete({
      hadActivity: false
    });
  }), PAGE_ACTIVITY_VALIDATION_DELAY);
  var maxDurationTimeoutId = maxDuration !== undefined ? setTimeout$1(monitor(function () {
    return complete({
      hadActivity: true,
      end: timeStampNow()
    });
  }), maxDuration) : undefined;
  var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
    var isBusy = _a.isBusy;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    var lastChangeTime = timeStampNow();
    if (!isBusy) {
      pageActivityEndTimeoutId = setTimeout$1(monitor(function () {
        return complete({
          hadActivity: true,
          end: lastChangeTime
        });
      }), PAGE_ACTIVITY_END_DELAY);
    }
  });
  var stop = function () {
    hasCompleted = true;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    clearTimeout$1(maxDurationTimeoutId);
    pageActivitySubscription.unsubscribe();
  };
  function complete(event) {
    if (hasCompleted) {
      return;
    }
    stop();
    pageActivityEndCallback(event);
  }
  return {
    stop: stop
  };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
  return new Observable(function (observable) {
    var subscriptions = [];
    var firstRequestIndex;
    var pendingRequestsCount = 0;
    subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), createPerformanceObservable(configuration, {
      type: RumPerformanceEntryType.RESOURCE
    }).subscribe(function (entries) {
      if (entries.some(function (entry) {
        return !isExcludedUrl(configuration, entry.name);
      })) {
        notifyPageActivity();
      }
    }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
      if (isExcludedUrl(configuration, startEvent.url)) {
        return;
      }
      if (firstRequestIndex === undefined) {
        firstRequestIndex = startEvent.requestIndex;
      }
      pendingRequestsCount += 1;
      notifyPageActivity();
    }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
      if (isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined ||
      // If the request started before the tracking start, ignore it
      request.requestIndex < firstRequestIndex) {
        return;
      }
      pendingRequestsCount -= 1;
      notifyPageActivity();
    }));
    var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
    return function () {
      stopTrackingWindowOpen();
      subscriptions.forEach(function (s) {
        return s.unsubscribe();
      });
    };
    function notifyPageActivity() {
      observable.notify({
        isBusy: pendingRequestsCount > 0
      });
    }
  });
}
function isExcludedUrl(configuration, requestUrl) {
  return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
  return instrumentMethod(window, 'open', callback);
}

// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
  if (window.CSS && window.CSS.escape) {
    return window.CSS.escape(str);
  }
  // eslint-disable-next-line no-control-regex
  return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
    if (asCodePoint) {
      // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
      if (ch === '\0') {
        return '\uFFFD';
      }
      // Control characters and (dependent upon position) numbers get escaped as code points
      return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
    }
    // Other potentially-special ASCII characters get backslash-escaped
    return "\\".concat(ch);
  });
}
function elementMatches(element, selector) {
  if (element.matches) {
    return element.matches(selector);
  }
  // IE11 support
  if (element.msMatchesSelector) {
    return element.msMatchesSelector(selector);
  }
  return false;
}
/**
 * Return the parentElement of an node
 *
 * In cases where parentElement is not supported, such as in IE11 for SVG nodes, we fallback to parentNode
 */
function getParentElement(node) {
  if (node.parentElement) {
    return node.parentElement;
  }
  while (node.parentNode) {
    if (node.parentNode.nodeType === Node.ELEMENT_NODE) {
      return node.parentNode;
    }
    node = node.parentNode;
  }
  return null;
}
/**
 * Return the classList of an element or an array of classes if classList is not supported
 *
 * In cases where classList is not supported, such as in IE11 for SVG and MathML elements,
 * we fallback to using element.getAttribute('class').
 * We opt for element.getAttribute('class') over element.className because className returns an SVGAnimatedString for SVG elements.
 */
function getClassList(element) {
  var _a;
  if (element.classList) {
    return element.classList;
  }
  var classes = (_a = element.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.trim();
  return classes ? classes.split(/\s+/) : [];
}
// ie11 supports WeakMap but not WeakSet
var PLACEHOLDER = 1;
var WeakSet$1 = /** @class */function () {
  function WeakSet(initialValues) {
    var _this = this;
    this.map = new WeakMap();
    if (initialValues) {
      initialValues.forEach(function (value) {
        return _this.map.set(value, PLACEHOLDER);
      });
    }
  }
  WeakSet.prototype.add = function (value) {
    this.map.set(value, PLACEHOLDER);
    return this;
  };
  WeakSet.prototype.delete = function (value) {
    return this.map.delete(value);
  };
  WeakSet.prototype.has = function (value) {
    return this.map.has(value);
  };
  return WeakSet;
}();

function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
  return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
  return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
  var shadowRoot = node;
  return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
  return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
  var child = node.firstChild;
  while (child) {
    callback(child);
    child = child.nextSibling;
  }
  if (isNodeShadowHost(node)) {
    callback(node.shadowRoot);
  }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
  return isNodeShadowRoot(node) ? node.host : node.parentNode;
}

var NodePrivacyLevel = {
  IGNORE: 'ignore',
  HIDDEN: 'hidden',
  ALLOW: DefaultPrivacyLevel.ALLOW,
  MASK: DefaultPrivacyLevel.MASK,
  MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
  INPUT: true,
  OUTPUT: true,
  TEXTAREA: true,
  SELECT: true,
  OPTION: true,
  DATALIST: true,
  OPTGROUP: true
};
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
  if (cache && cache.has(node)) {
    return cache.get(node);
  }
  var parentNode = getParentNode(node);
  var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
  var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
  var nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
  if (cache) {
    cache.set(node, nodePrivacyLevel);
  }
  return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
  switch (parentNodePrivacyLevel) {
    // These values cannot be overridden
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return parentNodePrivacyLevel;
  }
  switch (childPrivacyLevel) {
    case NodePrivacyLevel.ALLOW:
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.MASK_USER_INPUT:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return childPrivacyLevel;
    default:
      return parentNodePrivacyLevel;
  }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
  // Only Element types can have a privacy level set
  if (!isElementNode(node)) {
    return;
  }
  // Overrules for replay purpose
  if (node.tagName === 'BASE') {
    return NodePrivacyLevel.ALLOW;
  }
  // Overrules to enforce end-user protection
  if (node.tagName === 'INPUT') {
    var inputElement = node;
    if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
      return NodePrivacyLevel.MASK;
    }
    if (inputElement.type === 'hidden') {
      return NodePrivacyLevel.MASK;
    }
    var autocomplete = inputElement.getAttribute('autocomplete');
    // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
    if (autocomplete && autocomplete.indexOf('cc-') === 0) {
      return NodePrivacyLevel.MASK;
    }
  }
  // Check HTML privacy attributes and classes
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.HIDDEN))) {
    return NodePrivacyLevel.HIDDEN;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK))) {
    return NodePrivacyLevel.MASK;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) {
    return NodePrivacyLevel.MASK_USER_INPUT;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.ALLOW))) {
    return NodePrivacyLevel.ALLOW;
  }
  if (shouldIgnoreElement(node)) {
    return NodePrivacyLevel.IGNORE;
  }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
  switch (privacyLevel) {
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return true;
    case NodePrivacyLevel.MASK_USER_INPUT:
      return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
    default:
      return false;
  }
}
function isFormElement(node) {
  if (!node || node.nodeType !== node.ELEMENT_NODE) {
    return false;
  }
  var element = node;
  if (element.tagName === 'INPUT') {
    switch (element.type) {
      case 'button':
      case 'color':
      case 'reset':
      case 'submit':
        return false;
    }
  }
  return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) {
  return text.replace(/\S/g, TEXT_MASKING_CHAR);
};
function getTextContent$1(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
  var _a;
  // The parent node may not be a html element which has a tagName attribute.
  // So just let it be undefined which is ok in this use case.
  var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
  var textContent = textNode.textContent || '';
  if (ignoreWhiteSpace && !textContent.trim()) {
    return;
  }
  var nodePrivacyLevel = parentNodePrivacyLevel;
  var isScript = parentTagName === 'SCRIPT';
  if (isScript) {
    // For perf reasons, we don't record script (heuristic)
    textContent = CENSORED_STRING_MARK;
  } else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = CENSORED_STRING_MARK;
  } else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
    if (
    // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
    parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
      if (!textContent.trim()) {
        return;
      }
    } else if (parentTagName === 'OPTION') {
      // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
      textContent = CENSORED_STRING_MARK;
    } else {
      textContent = censorText(textContent);
    }
  }
  return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
  if (element.nodeName === 'SCRIPT') {
    return true;
  }
  if (element.nodeName === 'LINK') {
    var relAttribute = getLowerCaseAttribute('rel');
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script' ||
      // Favicons
      relAttribute === 'shortcut icon' || relAttribute === 'icon'
    );
  }
  if (element.nodeName === 'META') {
    var nameAttribute = getLowerCaseAttribute('name');
    var relAttribute = getLowerCaseAttribute('rel');
    var propertyAttribute = getLowerCaseAttribute('property');
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' ||
      // Description
      nameAttribute === 'keywords' || nameAttribute === 'description' ||
      // Social
      /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' ||
      // Robots
      nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' ||
      // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      element.hasAttribute('http-equiv') ||
      // Authorship
      nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) ||
      // Verification
      nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token'
    );
  }
  function getLowerCaseAttribute(name) {
    return (element.getAttribute(name) || '').toLowerCase();
  }
  return false;
}
function getPrivacySelector(privacyLevel) {
  return "[".concat(PRIVACY_ATTR_NAME, "=\"").concat(privacyLevel, "\"], .").concat(PRIVACY_CLASS_PREFIX).concat(privacyLevel);
}

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
var ACTION_NAME_PLACEHOLDER = 'Masked Element';
function getActionNameFromElement(element, _a, nodePrivacyLevel) {
  var enablePrivacyForActionName = _a.enablePrivacyForActionName,
    userProgrammaticAttribute = _a.actionNameAttribute;
  // Proceed to get the action name in two steps:
  // * first, get the name programmatically, explicitly defined by the user.
  // * then, use strategies that are known to return good results. Those strategies will be used on
  //   the element and a few parents, but it's likely that they won't succeed at all.
  // * if no name is found this way, use strategies returning less accurate names as a fallback.
  //   Those are much likely to succeed.
  var defaultActionName = getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) || userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
    return defaultActionName || ACTION_NAME_PLACEHOLDER;
  }
  return defaultActionName || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies, enablePrivacyForActionName) || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies, enablePrivacyForActionName) || '';
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
  var elementWithAttribute;
  // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
  // without limit. It is up to the user to declare a relevant naming strategy.
  // If available, use element.closest() to match get the attribute from the element or any of its
  // parent.  Else fallback to a more traditional implementation.
  if (supportsElementClosest()) {
    elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
  } else {
    var element = targetElement;
    while (element) {
      if (element.hasAttribute(programmaticAttribute)) {
        elementWithAttribute = element;
        break;
      }
      element = getParentElement(element);
    }
  }
  if (!elementWithAttribute) {
    return;
  }
  var name = elementWithAttribute.getAttribute(programmaticAttribute);
  return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
// associated LABEL text
function (element, userProgrammaticAttribute, privacy) {
  // IE does not support element.labels, so we fallback to a CSS selector based on the element id
  // instead
  if (supportsLabelProperty()) {
    if ('labels' in element && element.labels && element.labels.length > 0) {
      return getTextualContent(element.labels[0], userProgrammaticAttribute);
    }
  } else if (element.id) {
    var label = element.ownerDocument && find(element.ownerDocument.querySelectorAll('label'), function (label) {
      return label.htmlFor === element.id;
    });
    return label && getTextualContent(label, userProgrammaticAttribute, privacy);
  }
},
// INPUT button (and associated) value
function (element) {
  if (element.nodeName === 'INPUT') {
    var input = element;
    var type = input.getAttribute('type');
    if (type === 'button' || type === 'submit' || type === 'reset') {
      return input.value;
    }
  }
},
// BUTTON, LABEL or button-like element text
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
    return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
  }
}, function (element) {
  return element.getAttribute('aria-label');
},
// associated element text designated by the aria-labelledby attribute
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  var labelledByAttribute = element.getAttribute('aria-labelledby');
  if (labelledByAttribute) {
    return labelledByAttribute.split(/\s+/).map(function (id) {
      return getElementById(element, id);
    }).filter(function (label) {
      return Boolean(label);
    }).map(function (element) {
      return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    }).join(' ');
  }
}, function (element) {
  return element.getAttribute('alt');
}, function (element) {
  return element.getAttribute('name');
}, function (element) {
  return element.getAttribute('title');
}, function (element) {
  return element.getAttribute('placeholder');
},
// SELECT first OPTION text
function (element, userProgrammaticAttribute) {
  if ('options' in element && element.options.length > 0) {
    return getTextualContent(element.options[0], userProgrammaticAttribute);
  }
}];
var fallbackStrategies = [function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
}];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies, privacyEnabledActionName) {
  var element = targetElement;
  var recursionCounter = 0;
  while (recursionCounter <= MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD') {
    for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
      var strategy = strategies_1[_i];
      var name_1 = strategy(element, userProgrammaticAttribute, privacyEnabledActionName);
      if (typeof name_1 === 'string') {
        var trimmedName = name_1.trim();
        if (trimmedName) {
          return truncate(normalizeWhitespace(trimmedName));
        }
      }
    }
    // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
    // be reconsidered in the future.
    if (element.nodeName === 'FORM') {
      break;
    }
    element = getParentElement(element);
    recursionCounter += 1;
  }
}
function normalizeWhitespace(s) {
  return s.replace(/\s+/g, ' ');
}
function truncate(s) {
  return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
  // Use the element ownerDocument here, because tests are executed in an iframe, so
  // document.getElementById won't work.
  return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.isContentEditable) {
    return;
  }
  if ('innerText' in element) {
    var text_1 = element.innerText;
    var removeTextFromElements = function (query) {
      var list = element.querySelectorAll(query);
      for (var index = 0; index < list.length; index += 1) {
        var element_1 = list[index];
        if ('innerText' in element_1) {
          var textToReplace = element_1.innerText;
          if (textToReplace && textToReplace.trim().length > 0) {
            text_1 = text_1.replace(textToReplace, '');
          }
        }
      }
    };
    if (!supportsInnerTextScriptAndStyleRemoval()) {
      // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
      // be relatively fast and work in most cases.
      removeTextFromElements('script, style');
    }
    // remove the text of elements with programmatic attribute value
    removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
    if (userProgrammaticAttribute) {
      removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
    }
    if (privacyEnabledActionName) {
      // remove the text of elements with privacy override
      removeTextFromElements("".concat(getPrivacySelector(NodePrivacyLevel.HIDDEN), ", ").concat(getPrivacySelector(NodePrivacyLevel.MASK)));
    }
    return text_1;
  }
  return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
  return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
  if (supportsLabelPropertyResult === undefined) {
    supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
  }
  return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
  if (supportsElementClosestResult === undefined) {
    supportsElementClosestResult = 'closest' in HTMLElement.prototype;
  }
  return supportsElementClosestResult;
}

/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
// Common test attributes (list provided by google recorder)
'data-testid', 'data-test', 'data-qa', 'data-cy', 'data-test-id', 'data-qa-id', 'data-testing',
// FullStory decorator attributes:
'data-component', 'data-element', 'data-source-file'];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [getStableAttributeSelector, getClassSelector, getTagNameSelector];
function getSelectorFromElement(targetElement, actionNameAttribute) {
  if (!isConnected(targetElement)) {
    // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
  }
  var targetElementSelector;
  var currentElement = targetElement;
  while (currentElement && currentElement.nodeName !== 'HTML') {
    var globallyUniqueSelector = findSelector(currentElement, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
    if (globallyUniqueSelector) {
      return globallyUniqueSelector;
    }
    var uniqueSelectorAmongChildren = findSelector(currentElement, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
    targetElementSelector = uniqueSelectorAmongChildren || combineSelector(getPositionSelector(currentElement), targetElementSelector);
    currentElement = getParentElement(currentElement);
  }
  return targetElementSelector;
}
function isGeneratedValue(value) {
  // To compute the "URL path group", the backend replaces every URL path parts as a question mark
  // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
  // present.
  //
  // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
  // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
  // CSS selectors so it should be fine most of the time.
  return /[0-9]/.test(value);
}
function getIDSelector(element) {
  if (element.id && !isGeneratedValue(element.id)) {
    return "#".concat(cssEscape(element.id));
  }
}
function getClassSelector(element) {
  if (element.tagName === 'BODY') {
    return;
  }
  var classList = getClassList(element);
  for (var i = 0; i < classList.length; i += 1) {
    var className = classList[i];
    if (isGeneratedValue(className)) {
      continue;
    }
    return "".concat(cssEscape(element.tagName), ".").concat(cssEscape(className));
  }
}
function getTagNameSelector(element) {
  return cssEscape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
  if (actionNameAttribute) {
    var selector = getAttributeSelector(actionNameAttribute);
    if (selector) {
      return selector;
    }
  }
  for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
    var attributeName = STABLE_ATTRIBUTES_1[_i];
    var selector = getAttributeSelector(attributeName);
    if (selector) {
      return selector;
    }
  }
  function getAttributeSelector(attributeName) {
    if (element.hasAttribute(attributeName)) {
      return "".concat(cssEscape(element.tagName), "[").concat(attributeName, "=\"").concat(cssEscape(element.getAttribute(attributeName)), "\"]");
    }
  }
}
function getPositionSelector(element) {
  var sibling = getParentElement(element).firstElementChild;
  var elementIndex = 1;
  while (sibling && sibling !== element) {
    if (sibling.tagName === element.tagName) {
      elementIndex += 1;
    }
    sibling = sibling.nextElementSibling;
  }
  return "".concat(cssEscape(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
  for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
    var selectorGetter = selectorGetters_1[_i];
    var elementSelector = selectorGetter(element, actionNameAttribute);
    if (!elementSelector) {
      continue;
    }
    if (predicate(element, elementSelector, childSelector)) {
      return combineSelector(elementSelector, childSelector);
    }
  }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, elementSelector, childSelector) {
  return element.ownerDocument.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
 *
 * @param {Element} currentElement - the element being considered while iterating over the target
 * element ancestors.
 *
 * @param {string} currentElementSelector - a selector that matches the current element. That
 * selector is not a composed selector (i.e. it might be a single tag name, class name...).
 *
 * @param {string|undefined} childSelector - child selector is a selector that targets a descendant
 * of the current element. When undefined, the current element is the target element.
 *
 * # Scope selector usage
 *
 * When composed together, the final selector will be joined with `>` operators to make sure we
 * target direct descendants at each level. In this function, we'll use `querySelector` to check if
 * a selector matches descendants of the current element. But by default, the query selector match
 * elements at any level. Example:
 *
 * ```html
 * <main>
 *   <div>
 *     <span></span>
 *   </div>
 *   <marquee>
 *     <div>
 *       <span></span>
 *     </div>
 *   </marquee>
 * </main>
 * ```
 *
 * `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
 * selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
 * operator (`MAIN > DIV > SPAN`).
 *
 * To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
 * sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT CHILD_SELECTOR" returns a single element), regardless of whether the selector is
 * a direct descendant of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 *
 * [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
 *
 * # Performance considerations
 *
 * We compute selectors in performance-critical operations (ex: during a click), so we need to make
 * sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
 * check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
 *
 * Because we are iterating the DOM upward and we use that function at every level, we know the
 * child selector is already unique among the current element children, so we don't need to check
 * for the current element subtree.
 *
 * Instead, we can focus on the current element siblings. If we find a single element matching the
 * selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
 * (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
 */
function isSelectorUniqueAmongSiblings(currentElement, currentElementSelector, childSelector) {
  var isSiblingMatching;
  if (childSelector === undefined) {
    // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = function (sibling) {
      return elementMatches(sibling, currentElementSelector);
    };
  } else {
    var scopedSelector_1 = supportScopeSelector() ? combineSelector("".concat(currentElementSelector, ":scope"), childSelector) : combineSelector(currentElementSelector, childSelector);
    isSiblingMatching = function (sibling) {
      return sibling.querySelector(scopedSelector_1) !== null;
    };
  }
  var parent = getParentElement(currentElement);
  var sibling = parent.firstElementChild;
  while (sibling) {
    if (sibling !== currentElement && isSiblingMatching(sibling)) {
      return false;
    }
    sibling = sibling.nextElementSibling;
  }
  return true;
}
function combineSelector(parent, child) {
  return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
  if (supportScopeSelectorCache === undefined) {
    try {
      document.querySelector(':scope');
      supportScopeSelectorCache = true;
    } catch (_a) {
      supportScopeSelectorCache = false;
    }
  }
  return supportScopeSelectorCache;
}
/**
 * Polyfill-utility for the `isConnected` property not supported in IE11
 */
function isConnected(element) {
  if ('isConnected' in
  // cast is to make sure `element` is not inferred as `never` after the check
  element) {
    return element.isConnected;
  }
  return element.ownerDocument.documentElement.contains(element);
}

var MAX_DURATION_BETWEEN_CLICKS = ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
  var bufferedClicks = [];
  var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
  var maxDurationBetweenClicksTimeoutId;
  appendClick(firstClick);
  function appendClick(click) {
    click.stopObservable.subscribe(tryFinalize);
    bufferedClicks.push(click);
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    maxDurationBetweenClicksTimeoutId = setTimeout$1(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
  }
  function tryFinalize() {
    if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) {
      return click.isStopped();
    })) {
      status = 2 /* ClickChainStatus.Finalized */;
      onFinalize(bufferedClicks);
    }
  }
  function dontAcceptMoreClick() {
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
      status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
      tryFinalize();
    }
  }
  return {
    tryAppend: function (click) {
      if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
        return false;
      }
      if (bufferedClicks.length > 0 && !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
        dontAcceptMoreClick();
        return false;
      }
      appendClick(click);
      return true;
    },
    stop: function () {
      dontAcceptMoreClick();
    }
  };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
  return first.target === second.target && mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS && first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS;
}
function mouseEventDistance(origin, other) {
  return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

function listenActionEvents(configuration, _a) {
  var onPointerDown = _a.onPointerDown,
    onPointerUp = _a.onPointerUp;
  var selectionEmptyAtPointerDown;
  var userActivity = {
    selection: false,
    input: false,
    scroll: false
  };
  var clickContext;
  var listeners = [addEventListener(configuration, window, DOM_EVENT.POINTER_DOWN, function (event) {
    if (isValidPointerEvent(event)) {
      selectionEmptyAtPointerDown = isSelectionEmpty();
      userActivity = {
        selection: false,
        input: false,
        scroll: false
      };
      clickContext = onPointerDown(event);
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SELECTION_CHANGE, function () {
    if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
      userActivity.selection = true;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SCROLL, function () {
    userActivity.scroll = true;
  }, {
    capture: true,
    passive: true
  }), addEventListener(configuration, window, DOM_EVENT.POINTER_UP, function (event) {
    if (isValidPointerEvent(event) && clickContext) {
      // Use a scoped variable to make sure the value is not changed by other clicks
      var localUserActivity_1 = userActivity;
      onPointerUp(clickContext, event, function () {
        return localUserActivity_1;
      });
      clickContext = undefined;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.INPUT, function () {
    userActivity.input = true;
  }, {
    capture: true
  })];
  return {
    stop: function () {
      listeners.forEach(function (listener) {
        return listener.stop();
      });
    }
  };
}
function isSelectionEmpty() {
  var selection = window.getSelection();
  return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
  return event.target instanceof Element &&
  // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  event.isPrimary !== false;
}

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
  if (isRage(clicks)) {
    rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
    if (clicks.some(isDead)) {
      rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
    if (rageClick.hasError) {
      rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    return {
      isRage: true
    };
  }
  var hasSelectionChanged = clicks.some(function (click) {
    return click.getUserActivity().selection;
  });
  clicks.forEach(function (click) {
    if (click.hasError) {
      click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    if (isDead(click) &&
    // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !hasSelectionChanged) {
      click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
  });
  return {
    isRage: false
  };
}
function isRage(clicks) {
  if (clicks.some(function (click) {
    return click.getUserActivity().selection || click.getUserActivity().scroll;
  })) {
    return false;
  }
  for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
    if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= ONE_SECOND) {
      return true;
    }
  }
  return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR =
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' + 'textarea,' + 'select,' +
// contenteditable and their descendants don't always trigger meaningful changes when manipulated
'[contenteditable],' + '[contenteditable] *,' +
// canvas, as there is no good way to detect activity occurring on them
'canvas,' +
// links that are interactive (have an href attribute) or any of their descendants, as they can
// open a new tab or navigate to a hash without triggering a meaningful event
'a[href],' + 'a[href] *';
function isDead(click) {
  if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) {
    return false;
  }
  return !elementMatches(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}

// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
  var history = new ValueHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
  var stopObservable = new Observable();
  var currentClickChain;
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    history.reset();
  });
  lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
  var stopActionEventsListener = listenActionEvents(configuration, {
    onPointerDown: function (pointerDownEvent) {
      return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
    },
    onPointerUp: function (_a, startEvent, getUserActivity) {
      var clickActionBase = _a.clickActionBase,
        hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
      startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
    }
  }).stop;
  var actionContexts = {
    findActionId: function (startTime) {
      return history.findAll(startTime);
    }
  };
  return {
    stop: function () {
      stopClickChain();
      stopObservable.notify();
      stopActionEventsListener();
    },
    actionContexts: actionContexts
  };
  function appendClickToClickChain(click) {
    if (!currentClickChain || !currentClickChain.tryAppend(click)) {
      var rageClick_1 = click.clone();
      currentClickChain = createClickChain(click, function (clicks) {
        finalizeClicks(clicks, rageClick_1);
      });
    }
  }
  function stopClickChain() {
    if (currentClickChain) {
      currentClickChain.stop();
    }
  }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
  var nodePrivacyLevel = configuration.enablePrivacyForActionName ? getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel) : NodePrivacyLevel.ALLOW;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return undefined;
  }
  var clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
  var hadActivityOnPointerDown = false;
  waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
  },
  // We don't care about the activity duration, we just want to know whether an activity did happen
  // within the "validation delay" or not. Limit the duration so the callback is called sooner.
  PAGE_ACTIVITY_VALIDATION_DELAY);
  return {
    clickActionBase: clickActionBase,
    hadActivityOnPointerDown: function () {
      return hadActivityOnPointerDown;
    }
  };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
  var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
  appendClickToClickChain(click);
  var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
      // If the clock is looking weird, just discard the click
      click.discard();
    } else {
      if (pageActivityEndEvent.hadActivity) {
        click.stop(pageActivityEndEvent.end);
      } else if (hadActivityOnPointerDown()) {
        click.stop(
        // using the click start as activity end, so the click will have some activity but its
        // duration will be 0 (as the activity started before the click start)
        click.startClocks.timeStamp);
      } else {
        click.stop();
      }
    }
  }, CLICK_ACTION_MAX_DURATION).stop;
  var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    click.stop(endClocks.timeStamp);
  });
  var stopSubscription = stopObservable.subscribe(function () {
    click.stop();
  });
  click.stopObservable.subscribe(function () {
    viewEndedSubscription.unsubscribe();
    stopWaitPageActivityEnd();
    stopSubscription.unsubscribe();
  });
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
  var rect = event.target.getBoundingClientRect();
  return {
    type: "click" /* ActionType.CLICK */,
    target: {
      width: Math.round(rect.width),
      height: Math.round(rect.height),
      selector: getSelectorFromElement(event.target, configuration.actionNameAttribute)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(event.clientX - rect.left),
      y: Math.round(event.clientY - rect.top)
    },
    name: getActionNameFromElement(event.target, configuration, nodePrivacyLevel)
  };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
  var id = generateUUID();
  var startClocks = clocksNow();
  var historyEntry = history.add(id, startClocks.relative);
  var eventCountsSubscription = trackEventCounts({
    lifeCycle: lifeCycle,
    isChildEvent: function (event) {
      return event.action !== undefined && (Array.isArray(event.action.id) ? includes(event.action.id, id) : event.action.id === id);
    }
  });
  var status = 0 /* ClickStatus.ONGOING */;
  var activityEndTime;
  var frustrationTypes = [];
  var stopObservable = new Observable();
  function stop(newActivityEndTime) {
    if (status !== 0 /* ClickStatus.ONGOING */) {
      return;
    }
    activityEndTime = newActivityEndTime;
    status = 1 /* ClickStatus.STOPPED */;
    if (activityEndTime) {
      historyEntry.close(getRelativeTime(activityEndTime));
    } else {
      historyEntry.remove();
    }
    eventCountsSubscription.stop();
    stopObservable.notify();
  }
  return {
    event: startEvent,
    stop: stop,
    stopObservable: stopObservable,
    get hasError() {
      return eventCountsSubscription.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return activityEndTime !== undefined;
    },
    getUserActivity: getUserActivity,
    addFrustration: function (frustrationType) {
      frustrationTypes.push(frustrationType);
    },
    startClocks: startClocks,
    isStopped: function () {
      return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */;
    },
    clone: function () {
      return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    },
    validate: function (domEvents) {
      stop();
      if (status !== 1 /* ClickStatus.STOPPED */) {
        return;
      }
      var _a = eventCountsSubscription.eventCounts,
        resourceCount = _a.resourceCount,
        errorCount = _a.errorCount,
        longTaskCount = _a.longTaskCount;
      var clickAction = assign({
        type: "click" /* ActionType.CLICK */,
        duration: activityEndTime && elapsed(startClocks.timeStamp, activityEndTime),
        startClocks: startClocks,
        id: id,
        frustrationTypes: frustrationTypes,
        counts: {
          resourceCount: resourceCount,
          errorCount: errorCount,
          longTaskCount: longTaskCount
        },
        events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
        event: startEvent
      }, clickActionBase);
      lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
      status = 2 /* ClickStatus.FINALIZED */;
    },
    discard: function () {
      stop();
      status = 2 /* ClickStatus.FINALIZED */;
    }
  };
}
function finalizeClicks(clicks, rageClick) {
  var isRage = computeFrustration(clicks, rageClick).isRage;
  if (isRage) {
    clicks.forEach(function (click) {
      return click.discard();
    });
    rageClick.stop(timeStampNow());
    rageClick.validate(clicks.map(function (click) {
      return click.event;
    }));
  } else {
    rageClick.discard();
    clicks.forEach(function (click) {
      return click.validate();
    });
  }
}

function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
  lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
  });
  var actionContexts = {
    findActionId: noop$1
  };
  if (configuration.trackUserInteractions) {
    actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
  }
  return {
    addAction: function (action, savedCommonContext) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
        savedCommonContext: savedCommonContext
      }, processAction(action, pageStateHistory)));
    },
    actionContexts: actionContexts
  };
}
function processAction(action, pageStateHistory) {
  var autoActionProperties = isAutoAction(action) ? {
    action: {
      id: action.id,
      loading_time: discardNegativeDuration(toServerDuration(action.duration)),
      frustration: {
        type: action.frustrationTypes
      },
      error: {
        count: action.counts.errorCount
      },
      long_task: {
        count: action.counts.longTaskCount
      },
      resource: {
        count: action.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: action.target,
        position: action.position
      }
    }
  } : undefined;
  var customerContext = !isAutoAction(action) ? action.context : undefined;
  var actionEvent = combine({
    action: {
      id: generateUUID(),
      target: {
        name: action.name
      },
      type: action.type
    },
    date: action.startClocks.timeStamp,
    type: "action" /* RumEventType.ACTION */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, action.startClocks.relative)
    }
  }, autoActionProperties);
  var domainContext = isAutoAction(action) ? {
    events: action.events
  } : {};
  if (!isAutoAction(action) && action.handlingStack) {
    domainContext.handlingStack = action.handlingStack;
  }
  return {
    customerContext: customerContext,
    rawRumEvent: actionEvent,
    startTime: action.startClocks.relative,
    domainContext: domainContext
  };
}
function isAutoAction(action) {
  return action.type !== "custom" /* ActionType.CUSTOM */;
}

function trackConsoleError(errorObservable) {
  var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
    return errorObservable.notify({
      startClocks: clocksNow(),
      message: consoleError.message,
      stack: consoleError.stack,
      fingerprint: consoleError.fingerprint,
      source: ErrorSource.CONSOLE,
      handling: "handled" /* ErrorHandling.HANDLED */,
      handlingStack: consoleError.handlingStack
    });
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function trackReportError(configuration, errorObservable) {
  var subscription = initReportObservable(configuration, [RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
    var rawError = {
      startClocks: clocksNow(),
      message: reportError.message,
      stack: reportError.stack,
      type: reportError.subtype,
      source: ErrorSource.REPORT,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */,
      originalError: reportError.originalReport
    };
    if (reportError.originalReport.type === 'securitypolicyviolation') {
      rawError.csp = {
        disposition: reportError.originalReport.disposition
      };
    }
    return errorObservable.notify(rawError);
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
  var errorObservable = new Observable();
  trackConsoleError(errorObservable);
  trackRuntimeError(errorObservable);
  trackReportError(configuration, errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
  lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
    var error = _a.error,
      customerContext = _a.customerContext,
      savedCommonContext = _a.savedCommonContext;
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
      customerContext: customerContext,
      savedCommonContext: savedCommonContext
    }, processError(error, pageStateHistory, featureFlagContexts)));
  });
  return {
    addError: function (_a, savedCommonContext) {
      var error = _a.error,
        handlingStack = _a.handlingStack,
        startClocks = _a.startClocks,
        customerContext = _a.context;
      var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
      var rawError = computeRawError({
        stackTrace: stackTrace,
        originalError: error,
        handlingStack: handlingStack,
        startClocks: startClocks,
        nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
        source: ErrorSource.CUSTOM,
        handling: "handled" /* ErrorHandling.HANDLED */
      });
      lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
        customerContext: customerContext,
        savedCommonContext: savedCommonContext,
        error: rawError
      });
    }
  };
}
function processError(error, pageStateHistory, featureFlagContexts) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: generateUUID(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser',
      fingerprint: error.fingerprint,
      csp: error.csp
    },
    type: "error" /* RumEventType.ERROR */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, error.startClocks.relative)
    }
  };
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
  if (featureFlagContext && !isEmptyObject(featureFlagContext)) {
    rawRumEvent.feature_flags = featureFlagContext;
  }
  var domainContext = {
    error: error.originalError,
    handlingStack: error.handlingStack
  };
  return {
    rawRumEvent: rawRumEvent,
    startTime: error.startClocks.relative,
    domainContext: domainContext
  };
}

function startLongTaskCollection(lifeCycle, configuration) {
  lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
        break;
      }
      if (!configuration.trackLongTasks) {
        break;
      }
      var startClocks = relativeToClocks(entry.startTime);
      var rawRumEvent = {
        date: startClocks.timeStamp,
        long_task: {
          id: generateUUID(),
          duration: toServerDuration(entry.duration)
        },
        type: "long_task" /* RumEventType.LONG_TASK */,
        _dd: {
          discarded: false
        }
      };
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
        rawRumEvent: rawRumEvent,
        startTime: startClocks.relative,
        domainContext: {
          performanceEntry: entry
        }
      });
    }
  });
}

var alreadyMatchedEntries = new WeakSet$1();
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - filter out timing that were already matched to a request
 * - then, if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
  if (!performance || !('getEntriesByName' in performance)) {
    return;
  }
  var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
  if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
    return;
  }
  var candidates = sameNameEntries.filter(function (entry) {
    return !alreadyMatchedEntries.has(entry);
  }).filter(function (entry) {
    return isValidEntry(entry);
  }).filter(function (entry) {
    return isBetween(entry, request.startClocks.relative, endTime({
      startTime: request.startClocks.relative,
      duration: request.duration
    }));
  });
  if (candidates.length === 1) {
    alreadyMatchedEntries.add(candidates[0]);
    return candidates[0].toJSON();
  }
  return;
}
function endTime(timing) {
  return addDuration(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
  var errorMargin = 1;
  return timing.startTime >= start - errorMargin && endTime(timing) <= addDuration(end, errorMargin);
}

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
  var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
  if (!data || data.traceTime <= dateNow() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
    return undefined;
  }
  return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
  var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
  var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
  return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
  var comment = findTraceComment(document);
  if (!comment) {
    return undefined;
  }
  return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
  var traceTime = rawTraceTime && Number(rawTraceTime);
  if (!traceId || !traceTime) {
    return undefined;
  }
  return {
    traceId: traceId,
    traceTime: traceTime
  };
}
function findTraceComment(document) {
  // 1. Try to find the comment as a direct child of the document
  // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
  // value is not an array or string (here, a NodeList).
  for (var i = 0; i < document.childNodes.length; i += 1) {
    var comment = getTraceCommentFromNode(document.childNodes[i]);
    if (comment) {
      return comment;
    }
  }
  // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
  // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
  // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
  // reverse order, stopping if we come across a non-text node.
  if (document.body) {
    for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
      var node = document.body.childNodes[i];
      var comment = getTraceCommentFromNode(node);
      if (comment) {
        return comment;
      }
      if (!isTextNode(node)) {
        break;
      }
    }
  }
}
function getTraceCommentFromNode(node) {
  if (node && isCommentNode(node)) {
    var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
    if (match) {
      return match[1];
    }
  }
}

function retrieveInitialDocumentResourceTiming(configuration, callback) {
  runOnReadyState(configuration, 'interactive', function () {
    var timing;
    var forcedAttributes = {
      entryType: RumPerformanceEntryType.RESOURCE,
      initiatorType: FAKE_INITIAL_DOCUMENT,
      traceId: getDocumentTraceId(document),
      toJSON: function () {
        return assign({}, timing, {
          toJSON: undefined
        });
      }
    };
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) && performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
      var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
      timing = assign(navigationEntry.toJSON(), forcedAttributes);
    } else {
      var relativePerformanceTiming = computeRelativePerformanceTiming();
      timing = assign(relativePerformanceTiming, {
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        renderBlockingStatus: 'non-blocking',
        duration: relativePerformanceTiming.responseEnd,
        name: window.location.href,
        startTime: 0
      }, forcedAttributes);
    }
    callback(timing);
  });
}

function startResourceCollection(lifeCycle, configuration, pageStateHistory) {
  lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
    var rawEvent = processRequest(request, configuration, pageStateHistory);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  var performanceResourceSubscription = createPerformanceObservable(configuration, {
    type: RumPerformanceEntryType.RESOURCE,
    buffered: true
  }).subscribe(function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (!isRequestKind(entry)) {
        var rawEvent = processResourceEntry(entry, configuration);
        if (rawEvent) {
          lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
      }
    }
  });
  retrieveInitialDocumentResourceTiming(configuration, function (timing) {
    var rawEvent = processResourceEntry(timing, configuration);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  return {
    stop: function () {
      performanceResourceSubscription.unsubscribe();
    }
  };
}
function processRequest(request, configuration, pageStateHistory) {
  var matchingTiming = matchRequestTiming(request);
  var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
  var tracingInfo = computeRequestTracingInfo(request, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
  var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
  var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      duration: duration,
      method: request.method,
      status_code: request.status,
      url: isLongDataUrl(request.url) ? sanitizeDataUrl(request.url) : request.url
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, correspondingTimingOverrides);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: matchingTiming,
      xhr: request.xhr,
      response: request.response,
      requestInput: request.input,
      requestInit: request.init,
      error: request.error,
      isAborted: request.isAborted,
      handlingStack: request.handlingStack
    }
  };
}
function processResourceEntry(entry, configuration) {
  var startClocks = relativeToClocks(entry.startTime);
  var tracingInfo = computeEntryTracingInfo(entry, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = computeResourceKind(entry);
  var entryMetrics = computePerformanceEntryMetrics(entry);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      url: entry.name,
      status_code: discardZeroStatus(entry.responseStatus)
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, entryMetrics);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: entry
    }
  };
}
function computePerformanceEntryMetrics(timing) {
  var renderBlockingStatus = timing.renderBlockingStatus;
  return {
    resource: assign({
      duration: computePerformanceResourceDuration(timing),
      render_blocking_status: renderBlockingStatus
    }, computeSize(timing), computePerformanceResourceDetails(timing))
  };
}
function computeRequestTracingInfo(request, configuration) {
  var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      span_id: request.spanId.toDecimalString(),
      trace_id: request.traceId.toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
function computeEntryTracingInfo(entry, configuration) {
  var hasBeenTraced = entry.traceId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      trace_id: entry.traceId,
      span_id: new TraceIdentifier().toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
  return isNumber(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
  return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, startClocks.relative, duration) ? toServerDuration(duration) : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
  return statusCode === 0 ? undefined : statusCode;
}

function trackViewEventCounts(lifeCycle, viewId, onChange) {
  var _a = trackEventCounts({
      lifeCycle: lifeCycle,
      isChildEvent: function (event) {
        return event.view.id === viewId;
      },
      onChange: onChange
    }),
    stop = _a.stop,
    eventCounts = _a.eventCounts;
  return {
    stop: stop,
    eventCounts: eventCounts
  };
}

// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var fcpEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.PAINT && entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < FCP_MAXIMUM_DELAY;
    });
    if (fcpEntry) {
      callback(fcpEntry.startTime);
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var firstInputEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
    });
    if (firstInputEntry) {
      var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
      var firstInputTargetSelector = void 0;
      if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
        firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
      }
      callback({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: firstInputDelay >= 0 ? firstInputDelay : 0,
        time: firstInputEntry.startTime,
        targetSelector: firstInputTargetSelector
      });
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

function trackNavigationTimings(lifeCycle, callback) {
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
        callback({
          domComplete: entry.domComplete,
          domContentLoaded: entry.domContentLoadedEventEnd,
          domInteractive: entry.domInteractive,
          loadEvent: entry.loadEventEnd,
          // In some cases the value reported is negative or is larger
          // than the current page time. Ignore these cases:
          // https://github.com/GoogleChrome/web-vitals/issues/137
          // https://github.com/GoogleChrome/web-vitals/issues/162
          firstByte: entry.responseStart >= 0 && entry.responseStart <= relativeNow() ? entry.responseStart : undefined
        });
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
  // Ignore entries that come after the first user interaction. According to the documentation, the
  // browser should not send largest-contentful-paint entries after a user interact with the page,
  // but the web-vitals reference implementation uses this as a safeguard.
  var firstInteractionTimestamp = Infinity;
  var stopEventListener = addEventListeners(configuration, eventTarget, [DOM_EVENT.POINTER_DOWN, DOM_EVENT.KEY_DOWN], function (event) {
    firstInteractionTimestamp = event.timeStamp;
  }, {
    capture: true,
    once: true
  }).stop;
  var biggestLcpSize = 0;
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var lcpEntry = findLast(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < LCP_MAXIMUM_DELAY &&
      // Ensure to get the LCP entry with the biggest size, see
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
      entry.size > biggestLcpSize;
    });
    if (lcpEntry) {
      var lcpTargetSelector = void 0;
      if (lcpEntry.element) {
        lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
      }
      callback({
        value: lcpEntry.startTime,
        targetSelector: lcpTargetSelector
      });
      biggestLcpSize = lcpEntry.size;
    }
  }).unsubscribe;
  return {
    stop: function () {
      stopEventListener();
      unsubscribeLifeCycle();
    }
  };
}

function trackFirstHidden(configuration, eventTarget) {
  if (eventTarget === void 0) {
    eventTarget = window;
  }
  var timeStamp;
  var stopListeners;
  if (document.visibilityState === 'hidden') {
    timeStamp = 0;
  } else {
    timeStamp = Infinity;
    stopListeners = addEventListeners(configuration, eventTarget, [DOM_EVENT.PAGE_HIDE, DOM_EVENT.VISIBILITY_CHANGE], function (event) {
      if (event.type === DOM_EVENT.PAGE_HIDE || document.visibilityState === 'hidden') {
        timeStamp = event.timeStamp;
        stopListeners();
      }
    }, {
      capture: true
    }).stop;
  }
  return {
    get timeStamp() {
      return timeStamp;
    },
    stop: function () {
      stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
    }
  };
}

function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
  var initialViewMetrics = {};
  var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
    setLoadEvent(navigationTimings.loadEvent);
    initialViewMetrics.navigationTimings = navigationTimings;
    scheduleViewUpdate();
  }).stop;
  var firstHidden = trackFirstHidden(configuration);
  var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
    initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
    initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
    initialViewMetrics.firstInput = firstInput;
    scheduleViewUpdate();
  }).stop;
  function stop() {
    stopNavigationTracking();
    stopFCPTracking();
    stopLCPTracking();
    stopFIDTracking();
    firstHidden.stop();
  }
  return {
    stop: stop,
    initialViewMetrics: initialViewMetrics
  };
}

/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, viewStart, callback) {
  if (!isLayoutShiftSupported()) {
    return {
      stop: noop$1
    };
  }
  var maxClsValue = 0;
  // WeakRef is not supported in IE11 and Safari mobile, but so is the layout shift API, so this code won't be executed in these browsers
  var maxClsTarget;
  var maxClsStartTime;
  // if no layout shift happen the value should be reported as 0
  callback({
    value: 0
  });
  var window = slidingSessionWindow();
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
        var _a = window.update(entry),
          cumulatedValue = _a.cumulatedValue,
          isMaxValue = _a.isMaxValue;
        if (isMaxValue) {
          var target = getTargetFromSource(entry.sources);
          maxClsTarget = target ? new WeakRef(target) : undefined;
          maxClsStartTime = elapsed(viewStart, entry.startTime);
        }
        if (cumulatedValue > maxClsValue) {
          maxClsValue = cumulatedValue;
          var target = maxClsTarget === null || maxClsTarget === void 0 ? void 0 : maxClsTarget.deref();
          callback({
            value: round(maxClsValue, 4),
            targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
            time: maxClsStartTime
          });
        }
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}
function getTargetFromSource(sources) {
  var _a;
  if (!sources) {
    return;
  }
  return (_a = find(sources, function (source) {
    return !!source.node && isElementNode(source.node);
  })) === null || _a === void 0 ? void 0 : _a.node;
}
var MAX_WINDOW_DURATION = 5 * ONE_SECOND;
var MAX_UPDATE_GAP = ONE_SECOND;
function slidingSessionWindow() {
  var cumulatedValue = 0;
  var startTime;
  var endTime;
  var maxValue = 0;
  return {
    update: function (entry) {
      var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= MAX_UPDATE_GAP || entry.startTime - startTime >= MAX_WINDOW_DURATION;
      var isMaxValue;
      if (shouldCreateNewWindow) {
        startTime = endTime = entry.startTime;
        maxValue = cumulatedValue = entry.value;
        isMaxValue = true;
      } else {
        cumulatedValue += entry.value;
        endTime = entry.startTime;
        isMaxValue = entry.value > maxValue;
        if (isMaxValue) {
          maxValue = entry.value;
        }
      }
      return {
        cumulatedValue: cumulatedValue,
        isMaxValue: isMaxValue
      };
    }
  };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}

/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */
var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
  if ('interactionCount' in performance || observer) {
    return;
  }
  observer = new window.PerformanceObserver(monitor(function (entries) {
    entries.getEntries().forEach(function (e) {
      var entry = e;
      if (entry.interactionId) {
        minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
        maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
        interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
      }
    });
  }));
  observer.observe({
    type: 'event',
    buffered: true,
    durationThreshold: 0
  });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
  return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};

// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = 1 * ONE_MINUTE;
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
  if (!isInteractionToNextPaintSupported()) {
    return {
      getInteractionToNextPaint: function () {
        return undefined;
      },
      setViewEnd: noop$1,
      stop: noop$1
    };
  }
  var _a = trackViewInteractionCount(viewLoadingType),
    getViewInteractionCount = _a.getViewInteractionCount,
    stopViewInteractionCount = _a.stopViewInteractionCount;
  var viewEnd = Infinity;
  var longestInteractions = trackLongestInteractions(getViewInteractionCount);
  var interactionToNextPaint = -1;
  var interactionToNextPaintTargetSelector;
  var interactionToNextPaintStartTime;
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if ((entry.entryType === RumPerformanceEntryType.EVENT || entry.entryType === RumPerformanceEntryType.FIRST_INPUT) && entry.interactionId &&
      // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      entry.startTime >= viewStart && entry.startTime <= viewEnd) {
        longestInteractions.process(entry);
      }
    }
    var newInteraction = longestInteractions.estimateP98Interaction();
    if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
      interactionToNextPaint = newInteraction.duration;
      interactionToNextPaintStartTime = elapsed(viewStart, newInteraction.startTime);
      if (newInteraction.target && isElementNode(newInteraction.target)) {
        interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
      } else {
        interactionToNextPaintTargetSelector = undefined;
      }
    }
  }).unsubscribe;
  return {
    getInteractionToNextPaint: function () {
      // If no INP duration where captured because of the performanceObserver 40ms threshold
      // but the view interaction count > 0 then report 0
      if (interactionToNextPaint >= 0) {
        return {
          value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
          targetSelector: interactionToNextPaintTargetSelector,
          time: interactionToNextPaintStartTime
        };
      } else if (getViewInteractionCount()) {
        return {
          value: 0
        };
      }
    },
    setViewEnd: function (viewEndTime) {
      viewEnd = viewEndTime;
      stopViewInteractionCount();
    },
    stop: stop
  };
}
function trackLongestInteractions(getViewInteractionCount) {
  var longestInteractions = [];
  function sortAndTrimLongestInteractions() {
    longestInteractions.sort(function (a, b) {
      return b.duration - a.duration;
    }).splice(MAX_INTERACTION_ENTRIES);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function (entry) {
      var interactionIndex = longestInteractions.findIndex(function (interaction) {
        return entry.interactionId === interaction.interactionId;
      });
      var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
      if (interactionIndex !== -1) {
        if (entry.duration > longestInteractions[interactionIndex].duration) {
          longestInteractions[interactionIndex] = entry;
          sortAndTrimLongestInteractions();
        }
      } else if (longestInteractions.length < MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
        longestInteractions.push(entry);
        sortAndTrimLongestInteractions();
      }
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function () {
      var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
      return longestInteractions[interactionIndex];
    }
  };
}
function trackViewInteractionCount(viewLoadingType) {
  initInteractionCountPolyfill();
  var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
  var state = {
    stopped: false
  };
  function computeViewInteractionCount() {
    return getInteractionCount() - previousInteractionCount;
  }
  return {
    getViewInteractionCount: function () {
      if (state.stopped) {
        return state.interactionCount;
      }
      return computeViewInteractionCount();
    },
    stopViewInteractionCount: function () {
      state = {
        stopped: true,
        interactionCount: computeViewInteractionCount()
      };
    }
  };
}
function isInteractionToNextPaintSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) && window.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype;
}

function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
  var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
  var isWaitingForActivityLoadingTime = true;
  var loadingTimeCandidates = [];
  function invokeCallbackIfAllCandidatesAreReceived() {
    if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
      callback(Math.max.apply(Math, loadingTimeCandidates));
    }
  }
  var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
    if (isWaitingForActivityLoadingTime) {
      isWaitingForActivityLoadingTime = false;
      if (event.hadActivity) {
        loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
      }
      invokeCallbackIfAllCandidatesAreReceived();
    }
  }).stop;
  return {
    stop: stop,
    setLoadEvent: function (loadEvent) {
      if (isWaitingForLoadEvent) {
        isWaitingForLoadEvent = false;
        loadingTimeCandidates.push(loadEvent);
        invokeCallbackIfAllCandidatesAreReceived();
      }
    }
  };
}

function getScrollX() {
  var scrollX;
  var visual = window.visualViewport;
  if (visual) {
    scrollX = visual.pageLeft - visual.offsetLeft;
  } else if (window.scrollX !== undefined) {
    scrollX = window.scrollX;
  } else {
    scrollX = window.pageXOffset || 0;
  }
  return Math.round(scrollX);
}
function getScrollY() {
  var scrollY;
  var visual = window.visualViewport;
  if (visual) {
    scrollY = visual.pageTop - visual.offsetTop;
  } else if (window.scrollY !== undefined) {
    scrollY = window.scrollY;
  } else {
    scrollY = window.pageYOffset || 0;
  }
  return Math.round(scrollY);
}

var viewportObservable;
function initViewportObservable(configuration) {
  if (!viewportObservable) {
    viewportObservable = createViewportObservable(configuration);
  }
  return viewportObservable;
}
function createViewportObservable(configuration) {
  return new Observable(function (observable) {
    var updateDimension = throttle(function () {
      observable.notify(getViewportDimension());
    }, 200).throttled;
    return addEventListener(configuration, window, DOM_EVENT.RESIZE, updateDimension, {
      capture: true,
      passive: true
    }).stop;
  });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
  var visual = window.visualViewport;
  if (visual) {
    return {
      width: Number(visual.width * visual.scale),
      height: Number(visual.height * visual.scale)
    };
  }
  return {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}

/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = ONE_SECOND;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
  if (scrollValues === void 0) {
    scrollValues = createScrollValuesObservable(configuration);
  }
  var maxScrollDepth = 0;
  var maxScrollHeight = 0;
  var maxScrollHeightTime = 0;
  var subscription = scrollValues.subscribe(function (_a) {
    var scrollDepth = _a.scrollDepth,
      scrollTop = _a.scrollTop,
      scrollHeight = _a.scrollHeight;
    var shouldUpdate = false;
    if (scrollDepth > maxScrollDepth) {
      maxScrollDepth = scrollDepth;
      shouldUpdate = true;
    }
    if (scrollHeight > maxScrollHeight) {
      maxScrollHeight = scrollHeight;
      var now = relativeNow();
      maxScrollHeightTime = elapsed(viewStart.relative, now);
      shouldUpdate = true;
    }
    if (shouldUpdate) {
      callback({
        maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
        maxDepthScrollTop: scrollTop,
        maxScrollHeight: maxScrollHeight,
        maxScrollHeightTime: maxScrollHeightTime
      });
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function computeScrollValues() {
  var scrollTop = getScrollY();
  var height = getViewportDimension().height;
  var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
  var scrollDepth = Math.round(height + scrollTop);
  return {
    scrollHeight: scrollHeight,
    scrollDepth: scrollDepth,
    scrollTop: scrollTop
  };
}
function createScrollValuesObservable(configuration, throttleDuration) {
  if (throttleDuration === void 0) {
    throttleDuration = THROTTLE_SCROLL_DURATION;
  }
  return new Observable(function (observable) {
    function notify() {
      observable.notify(computeScrollValues());
    }
    if (window.ResizeObserver) {
      var throttledNotify_1 = throttle(notify, throttleDuration, {
        leading: false,
        trailing: true
      });
      var observerTarget_1 = document.scrollingElement || document.documentElement;
      var resizeObserver_1 = new ResizeObserver(monitor(throttledNotify_1.throttled));
      resizeObserver_1.observe(observerTarget_1);
      var eventListener_1 = addEventListener(configuration, window, DOM_EVENT.SCROLL, throttledNotify_1.throttled, {
        passive: true
      });
      return function () {
        throttledNotify_1.cancel();
        resizeObserver_1.unobserve(observerTarget_1);
        eventListener_1.stop();
      };
    }
  });
}

function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
  var commonViewMetrics = {};
  var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
      commonViewMetrics.loadingTime = newLoadingTime;
      scheduleViewUpdate();
    }),
    stopLoadingTimeTracking = _a.stop,
    setLoadEvent = _a.setLoadEvent;
  var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
    commonViewMetrics.scroll = newScrollMetrics;
  }).stop;
  var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, viewStart.relative, function (cumulativeLayoutShift) {
    commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
    scheduleViewUpdate();
  }).stop;
  var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle),
    stopINPTracking = _b.stop,
    getInteractionToNextPaint = _b.getInteractionToNextPaint,
    setViewEnd = _b.setViewEnd;
  return {
    stop: function () {
      stopLoadingTimeTracking();
      stopCLSTracking();
      stopScrollMetricsTracking();
    },
    stopINPTracking: stopINPTracking,
    setLoadEvent: setLoadEvent,
    setViewEnd: setViewEnd,
    getCommonViewMetrics: function () {
      commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
      return commonViewMetrics;
    }
  };
}

var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
  var activeViews = new Set();
  var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, clocksOrigin(), initialViewOptions);
  startViewLifeCycle();
  var locationChangeSubscription;
  if (areViewsTrackedAutomatically) {
    locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
  }
  function startNewView(loadingType, startClocks, viewOptions) {
    var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
    activeViews.add(newlyCreatedView);
    newlyCreatedView.stopObservable.subscribe(function () {
      activeViews.delete(newlyCreatedView);
    });
    return newlyCreatedView;
  }
  function startViewLifeCycle() {
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
      // Renew view on session renewal
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
        name: currentView.name,
        service: currentView.service,
        version: currentView.version
      });
    });
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
      currentView.end({
        sessionIsActive: false
      });
    });
    // End the current view on page unload
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
      if (pageExitEvent.reason === PageExitReason.UNLOADING) {
        currentView.end();
      }
    });
  }
  function renewViewOnLocationChange(locationChangeObservable) {
    return locationChangeObservable.subscribe(function (_a) {
      var oldLocation = _a.oldLocation,
        newLocation = _a.newLocation;
      if (areDifferentLocation(oldLocation, newLocation)) {
        currentView.end();
        currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
      }
    });
  }
  return {
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      currentView.addTiming(name, time);
    },
    startView: function (options, startClocks) {
      currentView.end({
        endClocks: startClocks
      });
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
    },
    updateViewName: function (name) {
      currentView.updateViewName(name);
    },
    stop: function () {
      locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
      currentView.end();
      activeViews.forEach(function (view) {
        return view.stop();
      });
    }
  };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
  if (startClocks === void 0) {
    startClocks = clocksNow();
  }
  // Setup initial values
  var id = generateUUID();
  var stopObservable = new Observable();
  var customTimings = {};
  var documentVersion = 0;
  var endClocks;
  var location = shallowClone(initialLocation);
  var sessionIsActive = true;
  var name;
  var service;
  var version;
  if (viewOptions) {
    name = viewOptions.name;
    service = viewOptions.service || undefined;
    version = viewOptions.version || undefined;
  }
  var viewCreatedEvent = {
    id: id,
    name: name,
    startClocks: startClocks,
    service: service,
    version: version
  };
  lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
  lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
  // Update the view every time the measures are changing
  var _a = throttle(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
      leading: false
    }),
    scheduleViewUpdate = _a.throttled,
    cancelScheduleViewUpdate = _a.cancel;
  var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks),
    setLoadEvent = _b.setLoadEvent,
    setViewEnd = _b.setViewEnd,
    stopCommonViewMetricsTracking = _b.stop,
    stopINPTracking = _b.stopINPTracking,
    getCommonViewMetrics = _b.getCommonViewMetrics;
  var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) : {
      stop: noop$1,
      initialViewMetrics: {}
    },
    stopInitialViewMetricsTracking = _c.stop,
    initialViewMetrics = _c.initialViewMetrics;
  var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate),
    stopEventCountsTracking = _d.stop,
    eventCounts = _d.eventCounts;
  // Session keep alive
  var keepAliveIntervalId = setInterval$1(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
  // Initial view update
  triggerViewUpdate();
  function triggerViewUpdate() {
    cancelScheduleViewUpdate();
    documentVersion += 1;
    var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
    lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
      customTimings: customTimings,
      documentVersion: documentVersion,
      id: id,
      name: name,
      service: service,
      version: version,
      loadingType: loadingType,
      location: location,
      startClocks: startClocks,
      commonViewMetrics: getCommonViewMetrics(),
      initialViewMetrics: initialViewMetrics,
      duration: elapsed(startClocks.timeStamp, currentEnd),
      isActive: endClocks === undefined,
      sessionIsActive: sessionIsActive,
      eventCounts: eventCounts
    });
  }
  return {
    get name() {
      return name;
    },
    service: service,
    version: version,
    stopObservable: stopObservable,
    end: function (options) {
      var _this = this;
      var _a, _b;
      if (options === void 0) {
        options = {};
      }
      if (endClocks) {
        // view already ended
        return;
      }
      endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : clocksNow();
      sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
      lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, {
        endClocks: endClocks
      });
      lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, {
        endClocks: endClocks
      });
      clearInterval$1(keepAliveIntervalId);
      setViewEnd(endClocks.relative);
      stopCommonViewMetricsTracking();
      triggerViewUpdate();
      setTimeout$1(function () {
        _this.stop();
      }, KEEP_TRACKING_AFTER_VIEW_DELAY);
    },
    stop: function () {
      stopInitialViewMetricsTracking();
      stopEventCountsTracking();
      stopINPTracking();
      stopObservable.notify();
    },
    addTiming: function (name, time) {
      if (endClocks) {
        return;
      }
      var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
      customTimings[sanitizeTiming(name)] = relativeTime;
      scheduleViewUpdate();
    },
    updateViewName: function (updatedName) {
      if (!isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
        return;
      }
      name = updatedName;
      triggerViewUpdate();
    }
  };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
  var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
  if (sanitized !== name) {
    display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
  }
  return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
  return currentLocation.pathname !== otherLocation.pathname || !isHashAnAnchor(otherLocation.hash) && getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash);
}
function isHashAnAnchor(hash) {
  var correspondingId = hash.substring(1);
  // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
  return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
  var index = hash.indexOf('?');
  return index < 0 ? hash : hash.slice(0, index);
}

function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
  });
  return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  var replayStats = recorderApi.getReplayStats(view.id);
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
  var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
  var viewEvent = {
    _dd: {
      document_version: view.documentVersion,
      replay_stats: replayStats,
      page_states: pageStates,
      configuration: {
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
      }
    },
    date: view.startClocks.timeStamp,
    type: "view" /* RumEventType.VIEW */,
    view: {
      action: {
        count: view.eventCounts.actionCount
      },
      frustration: {
        count: view.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
      cumulative_layout_shift_time: toServerDuration((_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.time),
      cumulative_layout_shift_target_selector: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.targetSelector,
      first_byte: toServerDuration((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.firstByte),
      dom_complete: toServerDuration((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domComplete),
      dom_content_loaded: toServerDuration((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domContentLoaded),
      dom_interactive: toServerDuration((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domInteractive),
      error: {
        count: view.eventCounts.errorCount
      },
      first_contentful_paint: toServerDuration(view.initialViewMetrics.firstContentfulPaint),
      first_input_delay: toServerDuration((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.delay),
      first_input_time: toServerDuration((_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.time),
      first_input_target_selector: (_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.targetSelector,
      interaction_to_next_paint: toServerDuration((_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.value),
      interaction_to_next_paint_time: toServerDuration((_m = view.commonViewMetrics.interactionToNextPaint) === null || _m === void 0 ? void 0 : _m.time),
      interaction_to_next_paint_target_selector: (_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
      is_active: view.isActive,
      name: view.name,
      largest_contentful_paint: toServerDuration((_p = view.initialViewMetrics.largestContentfulPaint) === null || _p === void 0 ? void 0 : _p.value),
      largest_contentful_paint_target_selector: (_q = view.initialViewMetrics.largestContentfulPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
      load_event: toServerDuration((_r = view.initialViewMetrics.navigationTimings) === null || _r === void 0 ? void 0 : _r.loadEvent),
      loading_time: discardNegativeDuration(toServerDuration(view.commonViewMetrics.loadingTime)),
      loading_type: view.loadingType,
      long_task: {
        count: view.eventCounts.longTaskCount
      },
      resource: {
        count: view.eventCounts.resourceCount
      },
      time_spent: toServerDuration(view.duration)
    },
    feature_flags: featureFlagContext && !isEmptyObject(featureFlagContext) ? featureFlagContext : undefined,
    display: view.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: view.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: toServerDuration(view.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : undefined,
    session: {
      has_replay: replayStats ? true : undefined,
      is_active: view.sessionIsActive ? undefined : false
    },
    privacy: {
      replay_level: configuration.defaultPrivacyLevel
    }
  };
  if (!isEmptyObject(view.customTimings)) {
    viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
  }
  return {
    rawRumEvent: viewEvent,
    startTime: view.startClocks.relative,
    domainContext: {
      location: view.location
    }
  };
}

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
  var sessionManager = startSessionManager(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
    return computeSessionState(configuration, rawTrackingType);
  }, trackingConsentState);
  sessionManager.expireObservable.subscribe(function () {
    lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
  });
  sessionManager.renewObservable.subscribe(function () {
    lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
  });
  sessionManager.sessionStateUpdateObservable.subscribe(function (_a) {
    var previousState = _a.previousState,
      newState = _a.newState;
    if (!previousState.forcedReplay && newState.forcedReplay) {
      var sessionEntity = sessionManager.findSession();
      if (sessionEntity) {
        sessionEntity.isReplayForced = true;
      }
    }
  });
  return {
    findTrackedSession: function (startTime) {
      var session = sessionManager.findSession(startTime);
      if (!session || !isTypeTracked(session.trackingType)) {
        return;
      }
      return {
        id: session.id,
        sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ? 1 /* SessionReplayState.SAMPLED */ : session.isReplayForced ? 2 /* SessionReplayState.FORCED */ : 0 /* SessionReplayState.OFF */
      };
    },
    expire: sessionManager.expire,
    expireObservable: sessionManager.expireObservable,
    setForcedReplay: function () {
      return sessionManager.updateSessionState({
        forcedReplay: '1'
      });
    }
  };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
  var session = {
    id: '00000000-aaaa-0000-aaaa-000000000000',
    sessionReplay: bridgeSupports("records" /* BridgeCapability.RECORDS */) ? 1 /* SessionReplayState.SAMPLED */ : 0 /* SessionReplayState.OFF */
  };
  return {
    findTrackedSession: function () {
      return session;
    },
    expire: noop$1,
    expireObservable: new Observable(),
    setForcedReplay: noop$1
  };
}
function computeSessionState(configuration, rawTrackingType) {
  var trackingType;
  if (hasValidRumSession(rawTrackingType)) {
    trackingType = rawTrackingType;
  } else if (!performDraw(configuration.sessionSampleRate)) {
    trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
  } else if (!performDraw(configuration.sessionReplaySampleRate)) {
    trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
  } else {
    trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
  }
  return {
    trackingType: trackingType,
    isTracked: isTypeTracked(trackingType)
  };
}
function hasValidRumSession(trackingType) {
  return trackingType === "0" /* RumTrackingType.NOT_TRACKED */ || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
}
function isTypeTracked(rumSessionType) {
  return rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ || rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
}

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
  var replica = configuration.replica;
  var batch = startBatchWithReplica(configuration, {
    endpoint: configuration.rumEndpointBuilder,
    encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */)
  }, replica && {
    endpoint: replica.rumEndpointBuilder,
    transformMessage: function (message) {
      return combine(message, {
        application: {
          id: replica.applicationId
        }
      });
    },
    encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */)
  }, reportError, pageExitObservable, sessionExpireObservable);
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
      batch.upsert(serverRumEvent, serverRumEvent.view.id);
    } else {
      batch.add(serverRumEvent);
    }
  });
  telemetryEventObservable.subscribe(function (event) {
    return batch.add(event, isTelemetryReplicationAllowed(configuration));
  });
  return batch;
}

function startRumEventBridge(lifeCycle) {
  var bridge = getEventBridge();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    bridge.send('rum', serverRumEvent);
  });
}

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
  var urlContextHistory = new ValueHistory(URL_CONTEXT_TIME_OUT_DELAY);
  var previousViewUrl;
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    var viewUrl = location.href;
    urlContextHistory.add(buildUrlContext({
      url: viewUrl,
      referrer: !previousViewUrl ? document.referrer : previousViewUrl
    }), startClocks.relative);
    previousViewUrl = viewUrl;
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    urlContextHistory.closeActive(endClocks.relative);
  });
  var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
    var newLocation = _a.newLocation;
    var current = urlContextHistory.find();
    if (current) {
      var changeTime = relativeNow();
      urlContextHistory.closeActive(changeTime);
      urlContextHistory.add(buildUrlContext({
        url: newLocation.href,
        referrer: current.referrer
      }), changeTime);
    }
  });
  function buildUrlContext(_a) {
    var url = _a.url,
      referrer = _a.referrer;
    return {
      url: url,
      referrer: referrer
    };
  }
  return {
    findUrl: function (startTime) {
      return urlContextHistory.find(startTime);
    },
    stop: function () {
      locationChangeSubscription.unsubscribe();
      urlContextHistory.stop();
    }
  };
}

function createLocationChangeObservable(configuration, location) {
  var currentLocation = shallowClone(location);
  return new Observable(function (observable) {
    var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
    var stopHashTracking = trackHash(configuration, onLocationChange).stop;
    function onLocationChange() {
      if (currentLocation.href === location.href) {
        return;
      }
      var newLocation = shallowClone(location);
      observable.notify({
        newLocation: newLocation,
        oldLocation: currentLocation
      });
      currentLocation = newLocation;
    }
    return function () {
      stopHistoryTracking();
      stopHashTracking();
    };
  });
}
function trackHistory(configuration, onHistoryChange) {
  var stopInstrumentingPushState = instrumentMethod(history, 'pushState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var stopInstrumentingReplaceState = instrumentMethod(history, 'replaceState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var removeListener = addEventListener(configuration, window, DOM_EVENT.POP_STATE, onHistoryChange).stop;
  return {
    stop: function () {
      stopInstrumentingPushState();
      stopInstrumentingReplaceState();
      removeListener();
    }
  };
}
function trackHash(configuration, onHashChange) {
  return addEventListener(configuration, window, DOM_EVENT.HASH_CHANGE, onHashChange);
}

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, customerDataTracker) {
  var featureFlagContexts = new ValueHistory(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    featureFlagContexts.add({}, startClocks.relative);
    customerDataTracker.resetCustomerData();
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    featureFlagContexts.closeActive(endClocks.relative);
  });
  return {
    findFeatureFlagEvaluations: function (startTime) {
      return featureFlagContexts.find(startTime);
    },
    addFeatureFlagEvaluation: function (key, value) {
      var currentContext = featureFlagContexts.find();
      if (currentContext) {
        currentContext[key] = value;
        customerDataTracker.updateCustomerData(currentContext);
      }
    },
    stop: function () {
      return customerDataTracker.stop();
    }
  };
}

var MEASURES_PERIOD_DURATION = 10 * ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
  var customerDataTelemetryEnabled = telemetry.enabled && performDraw(configuration.customerDataTelemetrySampleRate);
  if (!customerDataTelemetryEnabled) {
    return;
  }
  initCurrentPeriodMeasures();
  initCurrentBatchMeasures();
  // We measure the data of every view updates even if there could only be one per batch due to the upsert
  // It means that contexts bytes count sums can be higher than it really is
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    batchHasRumEvent = true;
    updateMeasure(currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */).getBytesCount());
    updateMeasure(currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */).getBytesCount());
    updateMeasure(currentBatchMeasures.featureFlagBytes, includes(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */).getBytesCount() : 0);
  });
  batchFlushObservable.subscribe(function (_a) {
    var bytesCount = _a.bytesCount,
      messagesCount = _a.messagesCount;
    // Don't measure batch that only contains telemetry events to avoid batch sending loop
    // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
    if (!batchHasRumEvent) {
      return;
    }
    currentPeriodMeasures.batchCount += 1;
    updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
    updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
    mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
    mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
    mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
    initCurrentBatchMeasures();
  });
  setInterval$1(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
  if (currentPeriodMeasures.batchCount === 0) {
    return;
  }
  addTelemetryDebug('Customer data measures', currentPeriodMeasures);
  initCurrentPeriodMeasures();
}
function createMeasure() {
  return {
    min: Infinity,
    max: 0,
    sum: 0
  };
}
function updateMeasure(measure, value) {
  measure.sum += value;
  measure.min = Math.min(measure.min, value);
  measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
  target.sum += source.sum;
  target.min = Math.min(target.min, source.min);
  target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
  currentPeriodMeasures = {
    batchCount: 0,
    batchBytesCount: createMeasure(),
    batchMessagesCount: createMeasure(),
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}
function initCurrentBatchMeasures() {
  batchHasRumEvent = false;
  currentBatchMeasures = {
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
  if (maxPageStateEntriesSelectable === void 0) {
    maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE;
  }
  var pageStateEntryHistory = new ValueHistory(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
  var currentPageState;
  addPageState(getPageState(), relativeNow());
  var stopEventListeners = addEventListeners(configuration, window, [DOM_EVENT.PAGE_SHOW, DOM_EVENT.FOCUS, DOM_EVENT.BLUR, DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.RESUME, DOM_EVENT.FREEZE, DOM_EVENT.PAGE_HIDE], function (event) {
    addPageState(computePageState(event), event.timeStamp);
  }, {
    capture: true
  }).stop;
  function addPageState(nextPageState, startTime) {
    if (startTime === void 0) {
      startTime = relativeNow();
    }
    if (nextPageState === currentPageState) {
      return;
    }
    currentPageState = nextPageState;
    pageStateEntryHistory.closeActive(startTime);
    pageStateEntryHistory.add({
      state: currentPageState,
      startTime: startTime
    }, startTime);
  }
  var pageStateHistory = {
    findAll: function (eventStartTime, duration) {
      var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
      if (pageStateEntries.length === 0) {
        return;
      }
      var pageStateServerEntries = [];
      // limit the number of entries to return
      var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
      // loop page state entries backward to return the selected ones in desc order
      for (var index = pageStateEntries.length - 1; index >= limit; index--) {
        var pageState = pageStateEntries[index];
        // compute the start time relative to the event start time (ex: to be relative to the view start time)
        var relativeStartTime = elapsed(eventStartTime, pageState.startTime);
        pageStateServerEntries.push({
          state: pageState.state,
          start: toServerDuration(relativeStartTime)
        });
      }
      return pageStateServerEntries;
    },
    wasInPageStateAt: function (state, startTime) {
      return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
    },
    wasInPageStateDuringPeriod: function (state, startTime, duration) {
      return pageStateEntryHistory.findAll(startTime, duration).some(function (pageState) {
        return pageState.state === state;
      });
    },
    addPageState: addPageState,
    stop: function () {
      stopEventListeners();
      pageStateEntryHistory.stop();
    }
  };
  return pageStateHistory;
}
function computePageState(event) {
  if (event.type === DOM_EVENT.FREEZE) {
    return "frozen" /* PageState.FROZEN */;
  } else if (event.type === DOM_EVENT.PAGE_HIDE) {
    return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
  }
  return getPageState();
}
function getPageState() {
  if (document.visibilityState === 'hidden') {
    return "hidden" /* PageState.HIDDEN */;
  }
  if (document.hasFocus()) {
    return "active" /* PageState.ACTIVE */;
  }
  return "passive" /* PageState.PASSIVE */;
}

function startDisplayContext(configuration) {
  var viewport = getViewportDimension();
  var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
    viewport = viewportDimension;
  }).unsubscribe;
  return {
    get: function () {
      return {
        viewport: viewport
      };
    },
    stop: unsubscribeViewport
  };
}

function createCookieObservable(configuration, cookieName) {
  var detectCookieChangeStrategy = window.cookieStore ? listenToCookieStoreChange(configuration) : watchCookieFallback;
  return new Observable(function (observable) {
    return detectCookieChangeStrategy(cookieName, function (event) {
      return observable.notify(event);
    });
  });
}
function listenToCookieStoreChange(configuration) {
  return function (cookieName, callback) {
    var listener = addEventListener(configuration, window.cookieStore, DOM_EVENT.CHANGE, function (event) {
      // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
      // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
      var changeEvent = find(event.changed, function (event) {
        return event.name === cookieName;
      }) || find(event.deleted, function (event) {
        return event.name === cookieName;
      });
      if (changeEvent) {
        callback(changeEvent.value);
      }
    });
    return listener.stop;
  };
}
var WATCH_COOKIE_INTERVAL_DELAY = ONE_SECOND;
function watchCookieFallback(cookieName, callback) {
  var previousCookieValue = findCommaSeparatedValue(document.cookie, cookieName);
  var watchCookieIntervalId = setInterval$1(function () {
    var cookieValue = findCommaSeparatedValue(document.cookie, cookieName);
    if (cookieValue !== previousCookieValue) {
      callback(cookieValue);
    }
  }, WATCH_COOKIE_INTERVAL_DELAY);
  return function () {
    clearInterval$1(watchCookieIntervalId);
  };
}

var CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
function startCiVisibilityContext(configuration, cookieObservable) {
  var _a;
  if (cookieObservable === void 0) {
    cookieObservable = createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME);
  }
  var testExecutionId = getInitCookie(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
  var cookieObservableSubscription = cookieObservable.subscribe(function (value) {
    testExecutionId = value;
  });
  return {
    get: function () {
      if (typeof testExecutionId === 'string') {
        return {
          test_execution_id: testExecutionId
        };
      }
    },
    stop: function () {
      return cookieObservableSubscription.unsubscribe();
    }
  };
}

function startRum(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder,
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
  var cleanupTasks = [];
  var lifeCycle = new LifeCycle();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    return sendToExtension('rum', event);
  });
  var telemetry = startRumTelemetry(configuration);
  telemetry.setContextProvider(function () {
    var _a, _b;
    return {
      application: {
        id: configuration.applicationId
      },
      session: {
        id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
      },
      view: {
        id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id
      },
      action: {
        id: actionContexts.findActionId()
      }
    };
  });
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var featureFlagContexts = startFeatureFlagContexts(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */));
  var pageExitObservable = createPageExitObservable(configuration);
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */, event);
  });
  cleanupTasks.push(function () {
    return pageExitSubscription.unsubscribe();
  });
  var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle, trackingConsentState) : startRumSessionManagerStub();
  if (!canUseEventBridge()) {
    var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
    cleanupTasks.push(function () {
      return batch_1.stop();
    });
    startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
  } else {
    startRumEventBridge(lifeCycle);
  }
  var domMutationObservable = createDOMMutationObservable();
  var locationChangeObservable = createLocationChangeObservable(configuration, location);
  var pageStateHistory = startPageStateHistory(configuration);
  var _a = startRumEventCollection(lifeCycle, configuration, location, session, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError),
    viewContexts = _a.viewContexts,
    urlContexts = _a.urlContexts,
    actionContexts = _a.actionContexts,
    addAction = _a.addAction,
    stopRumEventCollection = _a.stop;
  cleanupTasks.push(stopRumEventCollection);
  drainPreStartTelemetry();
  var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions),
    addTiming = _b.addTiming,
    startView = _b.startView,
    updateViewName = _b.updateViewName,
    stopViewCollection = _b.stop;
  cleanupTasks.push(stopViewCollection);
  var stopResourceCollection = startResourceCollection(lifeCycle, configuration, pageStateHistory).stop;
  cleanupTasks.push(stopResourceCollection);
  startLongTaskCollection(lifeCycle, configuration);
  var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
  startRequestCollection(lifeCycle, configuration, session);
  var stopPerformanceCollection = startPerformanceCollection(lifeCycle, configuration).stop;
  cleanupTasks.push(stopPerformanceCollection);
  var vitalCollection = startVitalCollection(lifeCycle, pageStateHistory);
  var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
  return {
    addAction: addAction,
    addError: addError,
    addTiming: addTiming,
    addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
    startView: startView,
    updateViewName: updateViewName,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts,
    session: session,
    stopSession: function () {
      return session.expire();
    },
    getInternalContext: internalContext.get,
    startDurationVital: vitalCollection.startDurationVital,
    addDurationVital: vitalCollection.addDurationVital,
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function startRumTelemetry(configuration) {
  var telemetry = startTelemetry("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
  if (canUseEventBridge()) {
    var bridge_1 = getEventBridge();
    telemetry.observable.subscribe(function (event) {
      return bridge_1.send('internal_telemetry', event);
    });
  }
  return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
  var viewContexts = startViewContexts(lifeCycle);
  var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
  var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory),
    addAction = _a.addAction,
    actionContexts = _a.actionContexts;
  var displayContext = startDisplayContext(configuration);
  var ciVisibilityContext = startCiVisibilityContext(configuration);
  startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
  return {
    viewContexts: viewContexts,
    pageStateHistory: pageStateHistory,
    urlContexts: urlContexts,
    addAction: addAction,
    actionContexts: actionContexts,
    stop: function () {
      ciVisibilityContext.stop();
      displayContext.stop();
      pageStateHistory.stop();
      urlContexts.stop();
      viewContexts.stop();
      pageStateHistory.stop();
    }
  };
}

function getSessionReplayUrl(configuration, _a) {
  var session = _a.session,
    viewContext = _a.viewContext,
    errorType = _a.errorType;
  var sessionId = session ? session.id : 'no-session-id';
  var parameters = [];
  if (errorType !== undefined) {
    parameters.push("error-type=".concat(errorType));
  }
  if (viewContext) {
    parameters.push("seed=".concat(viewContext.id));
    parameters.push("from=".concat(viewContext.startClocks.timeStamp));
  }
  var origin = getDatadogSiteUrl(configuration);
  var path = "/rum/replay/sessions/".concat(sessionId);
  return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
  var site = rumConfiguration.site;
  var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
  return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
  switch (configuration.site) {
    case INTAKE_SITE_US1:
    case INTAKE_SITE_EU1:
      return 'app';
    case INTAKE_SITE_STAGING:
      return 'dd';
    default:
      return undefined;
  }
}

var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
  return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
  getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
  getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
  getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
  return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function getOrCreateReplayStats(viewId) {
  if (!statsPerView) {
    statsPerView = new Map();
  }
  var replayStats;
  if (statsPerView.has(viewId)) {
    replayStats = statsPerView.get(viewId);
  } else {
    replayStats = {
      records_count: 0,
      segments_count: 0,
      segments_total_raw_size: 0
    };
    statsPerView.set(viewId, replayStats);
    if (statsPerView.size > MAX_STATS_HISTORY) {
      deleteOldestStats();
    }
  }
  return replayStats;
}
function deleteOldestStats() {
  if (!statsPerView) {
    return;
  }
  if (statsPerView.keys) {
    statsPerView.delete(statsPerView.keys().next().value);
  } else {
    // IE11 doesn't support map.keys
    var isFirst_1 = true;
    statsPerView.forEach(function (_value, key) {
      if (isFirst_1) {
        statsPerView.delete(key);
        isFirst_1 = false;
      }
    });
  }
}

var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
  return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
  var current = node;
  while (current) {
    if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
      return false;
    }
    current = getParentNode(current);
  }
  return true;
}
function getSerializedNodeId(node) {
  return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
  serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
  /*
   BROWSER SPEC NOTE: <input>, <select>
   For some <input> elements, the `value` is an exceptional property/attribute that has the
   value synced between el.value and el.getAttribute()
   input[type=button,checkbox,hidden,image,radio,reset,submit]
   */
  var tagName = element.tagName;
  var value = element.value;
  if (shouldMaskNode(element, nodePrivacyLevel)) {
    var type = element.type;
    if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
      // Overrule `MASK` privacy level for button-like element values, as they are used during replay
      // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
      return value;
    } else if (!value || tagName === 'OPTION') {
      // <Option> value provides no benefit
      return;
    }
    return CENSORED_STRING_MARK;
  }
  if (tagName === 'OPTION' || tagName === 'SELECT') {
    return element.value;
  }
  if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
    return;
  }
  return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
  return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
    var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
    if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
      return matchingSubstring;
    }
    var quote = singleQuote || doubleQuote || '';
    return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
  });
}
function makeUrlAbsolute(url, baseUrl) {
  try {
    return buildUrl(url, baseUrl).href;
  } catch (_) {
    return url;
  }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
  var processedTagName = tagName.toLowerCase().trim();
  if (TAG_NAME_REGEX.test(processedTagName)) {
    // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return 'div';
  }
  return processedTagName;
}
function censoredImageForSize(width, height) {
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}

var RecordType = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
};
var NodeType = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
};
var IncrementalSource = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
};
var MouseInteractionType = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
};
var MediaInteractionType = {
  Play: 0,
  Pause: 1
};

function serializeStyleSheets(cssStyleSheets) {
  if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
    return undefined;
  }
  return cssStyleSheets.map(function (cssStyleSheet) {
    var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
    var cssRules = Array.from(rules, function (cssRule) {
      return cssRule.cssText;
    });
    var styleSheet = {
      cssRules: cssRules,
      disabled: cssStyleSheet.disabled || undefined,
      media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
    };
    return styleSheet;
  });
}

function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // dup condition for direct access case
    return null;
  }
  var attributeValue = element.getAttribute(attributeName);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK && attributeName !== PRIVACY_ATTR_NAME && !STABLE_ATTRIBUTES.includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
    var tagName = element.tagName;
    switch (attributeName) {
      // Mask Attribute text content
      case 'title':
      case 'alt':
      case 'placeholder':
        return CENSORED_STRING_MARK;
    }
    // mask image URLs
    if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
      // generate image with similar dimension than the original to have the same rendering behaviour
      var image = element;
      if (image.naturalWidth > 0) {
        return censoredImageForSize(image.naturalWidth, image.naturalHeight);
      }
      var _a = element.getBoundingClientRect(),
        width = _a.width,
        height = _a.height;
      if (width > 0 || height > 0) {
        return censoredImageForSize(width, height);
      }
      // if we can't get the image size, fallback to the censored image
      return CENSORED_IMG_MARK;
    }
    // mask source URLs
    if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
      return CENSORED_IMG_MARK;
    }
    // mask <a> URLs
    if (tagName === 'A' && attributeName === 'href') {
      return CENSORED_STRING_MARK;
    }
    // mask data-* attributes
    if (attributeValue && startsWith$1(attributeName, 'data-')) {
      // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
      return CENSORED_STRING_MARK;
    }
    // mask iframe srcdoc
    if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
      return CENSORED_STRING_MARK;
    }
  }
  if (!attributeValue || typeof attributeValue !== 'string') {
    return attributeValue;
  }
  // Minimum Fix for customer.
  if (isLongDataUrl(attributeValue)) {
    return sanitizeDataUrl(attributeValue);
  }
  return attributeValue;
}

function serializeAttributes(element, nodePrivacyLevel, options) {
  var _a;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return {};
  }
  var safeAttrs = {};
  var tagName = getValidTagName(element.tagName);
  var doc = element.ownerDocument;
  for (var i = 0; i < element.attributes.length; i += 1) {
    var attribute = element.attributes.item(i);
    var attributeName = attribute.name;
    var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
    if (attributeValue !== null) {
      safeAttrs[attributeName] = attributeValue;
    }
  }
  if (element.value && (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
    var formValue = getElementInputValue(element, nodePrivacyLevel);
    if (formValue !== undefined) {
      safeAttrs.value = formValue;
    }
  }
  /**
   * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
   */
  if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
    // For privacy=`MASK`, all the values would be the same, so skip.
    var optionElement = element;
    if (optionElement.selected) {
      safeAttrs.selected = optionElement.selected;
    }
  }
  // remote css
  if (tagName === 'link') {
    var stylesheet = Array.from(doc.styleSheets).find(function (s) {
      return s.href === element.href;
    });
    var cssText = getCssRulesString(stylesheet);
    if (cssText && stylesheet) {
      safeAttrs._cssText = cssText;
    }
  }
  // dynamic stylesheet
  if (tagName === 'style' && element.sheet) {
    var cssText = getCssRulesString(element.sheet);
    if (cssText) {
      safeAttrs._cssText = cssText;
    }
  }
  /**
   * Forms: input[type=checkbox,radio]
   * The `checked` property for <input> is a little bit special:
   * 1. el.checked is a setter that returns if truthy.
   * 2. getAttribute returns the string value
   * getAttribute('checked') does not sync with `Element.checked`, so use JS property
   * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
   */
  var inputElement = element;
  if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
    if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
      safeAttrs.checked = !!inputElement.checked;
    } else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
      delete safeAttrs.checked;
    }
  }
  /**
   * Serialize the media playback state
   */
  if (tagName === 'audio' || tagName === 'video') {
    var mediaElement = element;
    safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
  }
  /**
   * Serialize the scroll state for each element only for full snapshot
   */
  var scrollTop;
  var scrollLeft;
  var serializationContext = options.serializationContext;
  switch (serializationContext.status) {
    case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
      scrollTop = Math.round(element.scrollTop);
      scrollLeft = Math.round(element.scrollLeft);
      if (scrollTop || scrollLeft) {
        serializationContext.elementsScrollPositions.set(element, {
          scrollTop: scrollTop,
          scrollLeft: scrollLeft
        });
      }
      break;
    case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
      if (serializationContext.elementsScrollPositions.has(element)) {
        _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
      }
      break;
  }
  if (scrollLeft) {
    safeAttrs.rr_scrollLeft = scrollLeft;
  }
  if (scrollTop) {
    safeAttrs.rr_scrollTop = scrollTop;
  }
  return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
  if (!cssStyleSheet) {
    return null;
  }
  var rules;
  try {
    rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
  } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
  }
  if (!rules) {
    return null;
  }
  var styleSheetCssText = Array.from(rules, isSafari() ? getCssRuleStringForSafari : getCssRuleString).join('');
  return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
  // Safari does not escape attribute selectors containing : properly
  // https://bugs.webkit.org/show_bug.cgi?id=184604
  if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
    // This regex replaces [foo:bar] by [foo\\:bar]
    var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return rule.cssText.replace(escapeColon, '$1\\$2');
  }
  return getCssRuleString(rule);
}
function getCssRuleString(rule) {
  // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
  // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
  // to the @import rule CSS text.
  return isCSSImportRule(rule) && getCssRulesString(rule.styleSheet) || rule.cssText;
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}

function serializeNodeWithId(node, options) {
  var serializedNode = serializeNode(node, options);
  if (!serializedNode) {
    return null;
  }
  // Try to reuse the previous id
  var id = getSerializedNodeId(node) || generateNextId();
  var serializedNodeWithId = serializedNode;
  serializedNodeWithId.id = id;
  setSerializedNodeId(node, id);
  if (options.serializedNodeIds) {
    options.serializedNodeIds.add(id);
  }
  return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
  return _nextId++;
}
function serializeChildNodes(node, options) {
  var result = [];
  forEachChildNodes(node, function (childNode) {
    var serializedChildNode = serializeNodeWithId(childNode, options);
    if (serializedChildNode) {
      result.push(serializedChildNode);
    }
  });
  return result;
}
function serializeNode(node, options) {
  switch (node.nodeType) {
    case node.DOCUMENT_NODE:
      return serializeDocumentNode(node, options);
    case node.DOCUMENT_FRAGMENT_NODE:
      return serializeDocumentFragmentNode(node, options);
    case node.DOCUMENT_TYPE_NODE:
      return serializeDocumentTypeNode(node);
    case node.ELEMENT_NODE:
      return serializeElementNode(node, options);
    case node.TEXT_NODE:
      return serializeTextNode(node, options);
    case node.CDATA_SECTION_NODE:
      return serializeCDataNode();
  }
}
function serializeDocumentNode(document, options) {
  return {
    type: NodeType.Document,
    childNodes: serializeChildNodes(document, options),
    adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets)
  };
}
function serializeDocumentFragmentNode(element, options) {
  var isShadowRoot = isNodeShadowRoot(element);
  if (isShadowRoot) {
    options.serializationContext.shadowRootsController.addShadowRoot(element);
  }
  return {
    type: NodeType.DocumentFragment,
    childNodes: serializeChildNodes(element, options),
    isShadowRoot: isShadowRoot,
    adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined
  };
}
function serializeDocumentTypeNode(documentType) {
  return {
    type: NodeType.DocumentType,
    name: documentType.name,
    publicId: documentType.publicId,
    systemId: documentType.systemId
  };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
  var _a;
  var tagName = getValidTagName(element.tagName);
  var isSVG = isSVGElement(element) || undefined;
  // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
  // parentNodePrivacyLevel option to avoid iterating over all parents
  var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    var _b = element.getBoundingClientRect(),
      width = _b.width,
      height = _b.height;
    return {
      type: NodeType.Element,
      tagName: tagName,
      attributes: (_a = {
        rr_width: "".concat(width, "px"),
        rr_height: "".concat(height, "px")
      }, _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN, _a),
      childNodes: [],
      isSVG: isSVG
    };
  }
  // Ignore Elements like Script and some Link, Metas
  if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
    return;
  }
  var attributes = serializeAttributes(element, nodePrivacyLevel, options);
  var childNodes = [];
  if (hasChildNodes(element) &&
  // Do not serialize style children as the css rules are already in the _cssText attribute
  tagName !== 'style') {
    // OBJECT POOLING OPTIMIZATION:
    // We should not create a new object systematically as it could impact performances. Try to reuse
    // the same object as much as possible, and clone it only if we need to.
    var childNodesSerializationOptions = void 0;
    if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
      childNodesSerializationOptions = options;
    } else {
      childNodesSerializationOptions = assign({}, options, {
        parentNodePrivacyLevel: nodePrivacyLevel,
        ignoreWhiteSpace: tagName === 'head'
      });
    }
    childNodes = serializeChildNodes(element, childNodesSerializationOptions);
  }
  return {
    type: NodeType.Element,
    tagName: tagName,
    attributes: attributes,
    childNodes: childNodes,
    isSVG: isSVG
  };
}
function isSVGElement(el) {
  return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
  var textContent = getTextContent$1(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
  if (textContent === undefined) {
    return;
  }
  return {
    type: NodeType.Text,
    textContent: textContent
  };
}
function serializeCDataNode() {
  return {
    type: NodeType.CDATA,
    textContent: ''
  };
}

function serializeDocument(document, configuration, serializationContext) {
  // We are sure that Documents are never ignored, so this function never returns null
  return serializeNodeWithId(document, {
    serializationContext: serializationContext,
    parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
    configuration: configuration
  });
}

function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function getEventTarget(event) {
  if (event.composed === true && isNodeShadowHost(event.target)) {
    return event.composedPath()[0];
  }
  return event.target;
}

/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
  return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE;
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
  var visualViewport = window.visualViewport;
  var normalized = {
    layoutViewportX: clientX,
    layoutViewportY: clientY,
    visualViewportX: clientX,
    visualViewportY: clientY
  };
  if (!visualViewport) {
    // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
  } else if (isVisualViewportFactoredIn(visualViewport)) {
    // Typically Mobile Devices
    normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
    normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
  } else {
    // Typically Desktop Devices
    normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
    normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
  }
  return normalized;
};
var getVisualViewport = function (visualViewport) {
  return {
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width
  };
};

function assembleIncrementalSnapshot(source, data) {
  return {
    data: assign({
      source: source
    }, data),
    type: RecordType.IncrementalSnapshot,
    timestamp: timeStampNow()
  };
}

var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function trackMove(configuration, moveCb) {
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (hasSerializedNode(target)) {
        var coordinates = tryToComputeCoordinates(event);
        if (!coordinates) {
          return;
        }
        var position = {
          id: getSerializedNodeId(target),
          timeOffset: 0,
          x: coordinates.x,
          y: coordinates.y
        };
        moveCb(assembleIncrementalSnapshot(isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove, {
          positions: [position]
        }));
      }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
      trailing: false
    }),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListeners(configuration, document, [DOM_EVENT.MOUSE_MOVE, DOM_EVENT.TOUCH_MOVE], updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}
function tryToComputeCoordinates(event) {
  var _a = isTouchEvent(event) ? event.changedTouches[0] : event,
    x = _a.clientX,
    y = _a.clientY;
  if (window.visualViewport) {
    var _b = convertMouseEventToLayoutCoordinates(x, y),
      visualViewportX = _b.visualViewportX,
      visualViewportY = _b.visualViewportY;
    x = visualViewportX;
    y = visualViewportY;
  }
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    if (event.isTrusted) {
      addTelemetryDebug('mouse/touch event without x/y');
    }
    return undefined;
  }
  return {
    x: x,
    y: y
  };
}

var _a;
var eventTypeToMouseInteraction = (_a = {},
// Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
_a[DOM_EVENT.POINTER_UP] = MouseInteractionType.MouseUp, _a[DOM_EVENT.MOUSE_DOWN] = MouseInteractionType.MouseDown, _a[DOM_EVENT.CLICK] = MouseInteractionType.Click, _a[DOM_EVENT.CONTEXT_MENU] = MouseInteractionType.ContextMenu, _a[DOM_EVENT.DBL_CLICK] = MouseInteractionType.DblClick, _a[DOM_EVENT.FOCUS] = MouseInteractionType.Focus, _a[DOM_EVENT.BLUR] = MouseInteractionType.Blur, _a[DOM_EVENT.TOUCH_START] = MouseInteractionType.TouchStart, _a[DOM_EVENT.TOUCH_END] = MouseInteractionType.TouchEnd, _a);
function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
  var handler = function (event) {
    var target = getEventTarget(event);
    if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    var id = getSerializedNodeId(target);
    var type = eventTypeToMouseInteraction[event.type];
    var interaction;
    if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
      var coordinates = tryToComputeCoordinates(event);
      if (!coordinates) {
        return;
      }
      interaction = {
        id: id,
        type: type,
        x: coordinates.x,
        y: coordinates.y
      };
    } else {
      interaction = {
        id: id,
        type: type
      };
    }
    var record = assign({
      id: recordIds.getIdForEvent(event)
    }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
    mouseInteractionCb(record);
  };
  return addEventListeners(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
    capture: true,
    passive: true
  });
}

var SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scrollCb, elementsScrollPositions, target) {
  if (target === void 0) {
    target = document;
  }
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
        return;
      }
      var id = getSerializedNodeId(target);
      var scrollPositions = target === document ? {
        scrollTop: getScrollY(),
        scrollLeft: getScrollX()
      } : {
        scrollTop: Math.round(target.scrollTop),
        scrollLeft: Math.round(target.scrollLeft)
      };
      elementsScrollPositions.set(target, scrollPositions);
      scrollCb(assembleIncrementalSnapshot(IncrementalSource.Scroll, {
        id: id,
        x: scrollPositions.scrollLeft,
        y: scrollPositions.scrollTop
      }));
    }, SCROLL_OBSERVER_THRESHOLD),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListener(configuration, target, DOM_EVENT.SCROLL, updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}

function trackViewportResize(configuration, viewportResizeCb) {
  var viewportResizeSubscription = initViewportObservable(configuration).subscribe(function (data) {
    viewportResizeCb(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, data));
  });
  return {
    stop: function () {
      viewportResizeSubscription.unsubscribe();
    }
  };
}

function trackMediaInteraction(configuration, mediaInteractionCb) {
  return addEventListeners(configuration, document, [DOM_EVENT.PLAY, DOM_EVENT.PAUSE], function (event) {
    var target = getEventTarget(event);
    if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    mediaInteractionCb(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, {
      id: getSerializedNodeId(target),
      type: event.type === DOM_EVENT.PLAY ? MediaInteractionType.Play : MediaInteractionType.Pause
    }));
  }, {
    capture: true,
    passive: true
  });
}

function trackStyleSheet(styleSheetCb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
      callback(getSerializedNodeId(styleSheet.ownerNode));
    }
  }
  var instrumentationStoppers = [instrumentMethod(CSSStyleSheet.prototype, 'insertRule', function (_a) {
    var styleSheet = _a.target,
      _b = _a.parameters,
      rule = _b[0],
      index = _b[1];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        adds: [{
          rule: rule,
          index: index
        }]
      }));
    });
  }), instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', function (_a) {
    var styleSheet = _a.target,
      index = _a.parameters[0];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        removes: [{
          index: index
        }]
      }));
    });
  })];
  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }
  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push(instrumentMethod(cls.prototype, 'insertRule', function (_a) {
      var styleSheet = _a.target,
        _b = _a.parameters,
        rule = _b[0],
        index = _b[1];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index || 0);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            adds: [{
              rule: rule,
              index: path
            }]
          }));
        }
      });
    }), instrumentMethod(cls.prototype, 'deleteRule', function (_a) {
      var styleSheet = _a.target,
        index = _a.parameters[0];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            removes: [{
              index: path
            }]
          }));
        }
      });
    }));
  }
  return {
    stop: function () {
      instrumentationStoppers.forEach(function (stopper) {
        return stopper.stop();
      });
    }
  };
}
function getPathToNestedCSSRule(rule) {
  var path = [];
  var currentRule = rule;
  while (currentRule.parentRule) {
    var rules_1 = Array.from(currentRule.parentRule.cssRules);
    var index_1 = rules_1.indexOf(currentRule);
    path.unshift(index_1);
    currentRule = currentRule.parentRule;
  }
  // A rule may not be attached to a stylesheet
  if (!currentRule.parentStyleSheet) {
    return;
  }
  var rules = Array.from(currentRule.parentStyleSheet.cssRules);
  var index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}

function trackFocus(configuration, focusCb) {
  return addEventListeners(configuration, window, [DOM_EVENT.FOCUS, DOM_EVENT.BLUR], function () {
    focusCb({
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timeStampNow()
    });
  });
}

function trackFrustration(lifeCycle, frustrationCb, recordIds) {
  var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
    var _a, _b, _c;
    if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ && data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && 'events' in data.domainContext && ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
      frustrationCb({
        timestamp: data.rawRumEvent.date,
        type: RecordType.FrustrationRecord,
        data: {
          frustrationTypes: data.rawRumEvent.action.frustration.type,
          recordIds: data.domainContext.events.map(function (e) {
            return recordIds.getIdForEvent(e);
          })
        }
      });
    }
  });
  return {
    stop: function () {
      frustrationSubscription.unsubscribe();
    }
  };
}

function trackViewEnd(lifeCycle, viewEndCb) {
  var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function () {
    viewEndCb({
      timestamp: timeStampNow(),
      type: RecordType.ViewEnd
    });
  });
  return {
    stop: function () {
      viewEndSubscription.unsubscribe();
    }
  };
}

function trackInput(configuration, inputCb, target) {
  if (target === void 0) {
    target = document;
  }
  var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
  var lastInputStateMap = new WeakMap();
  var isShadowRoot = target !== document;
  var stopEventListeners = addEventListeners(configuration, target,
  // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
  // roots since it will be handled by the event listener that we did add to the document. Only
  // the 'change' event is blocked and needs to be handled on shadow roots.
  isShadowRoot ? [DOM_EVENT.CHANGE] : [DOM_EVENT.INPUT, DOM_EVENT.CHANGE], function (event) {
    var target = getEventTarget(event);
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      onElementChange(target);
    }
  }, {
    capture: true,
    passive: true
  }).stop;
  var stopPropertySetterInstrumentation;
  if (!isShadowRoot) {
    var instrumentationStoppers_1 = [instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange), instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange), instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange)];
    stopPropertySetterInstrumentation = function () {
      instrumentationStoppers_1.forEach(function (stopper) {
        return stopper.stop();
      });
    };
  } else {
    stopPropertySetterInstrumentation = noop$1;
  }
  return {
    stop: function () {
      stopPropertySetterInstrumentation();
      stopEventListeners();
    }
  };
  function onElementChange(target) {
    var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
      return;
    }
    var type = target.type;
    var inputState;
    if (type === 'radio' || type === 'checkbox') {
      if (shouldMaskNode(target, nodePrivacyLevel)) {
        return;
      }
      inputState = {
        isChecked: target.checked
      };
    } else {
      var value = getElementInputValue(target, nodePrivacyLevel);
      if (value === undefined) {
        return;
      }
      inputState = {
        text: value
      };
    }
    // Can be multiple changes on the same node within the same batched mutation observation.
    cbWithDedup(target, inputState);
    // If a radio was checked, other radios with the same name attribute will be unchecked.
    var name = target.name;
    if (type === 'radio' && name && target.checked) {
      forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(cssEscape(name), "\"]")), function (el) {
        if (el !== target) {
          // TODO: Consider the privacy implications for various differing input privacy levels
          cbWithDedup(el, {
            isChecked: false
          });
        }
      });
    }
  }
  /**
   * There can be multiple changes on the same node within the same batched mutation observation.
   */
  function cbWithDedup(target, inputState) {
    if (!hasSerializedNode(target)) {
      return;
    }
    var lastInputState = lastInputStateMap.get(target);
    if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
      lastInputStateMap.set(target, inputState);
      inputCb(assembleIncrementalSnapshot(IncrementalSource.Input, assign({
        id: getSerializedNodeId(target)
      }, inputState)));
    }
  }
}

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
/**
 * Minimum duration to wait before processing mutations. This is used to batch mutations together
 * and be able to deduplicate them to save processing time and bandwidth.
 * 16ms is the duration of a frame at 60fps that ensure fluid UI.
 */
var MUTATION_PROCESS_MIN_DELAY = 16;
function createMutationBatch(processMutationBatch) {
  var cancelScheduledFlush = noop$1;
  var pendingMutations = [];
  function flush() {
    cancelScheduledFlush();
    processMutationBatch(pendingMutations);
    pendingMutations = [];
  }
  var _a = throttle(flush, MUTATION_PROCESS_MIN_DELAY, {
      leading: false
    }),
    throttledFlush = _a.throttled,
    cancelThrottle = _a.cancel;
  return {
    addMutations: function (mutations) {
      if (pendingMutations.length === 0) {
        cancelScheduledFlush = requestIdleCallback(throttledFlush, {
          timeout: MUTATION_PROCESS_MAX_DELAY
        });
      }
      pendingMutations.push.apply(pendingMutations, mutations);
    },
    flush: flush,
    stop: function () {
      cancelScheduledFlush();
      cancelThrottle();
    }
  };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var id_1 = window.requestIdleCallback(monitor(callback), opts);
    return function () {
      return window.cancelIdleCallback(id_1);
    };
  }
  var id = window.requestAnimationFrame(monitor(callback));
  return function () {
    return window.cancelAnimationFrame(id);
  };
}

/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function trackMutation(mutationCallback, configuration, shadowRootsController, target) {
  var MutationObserver = getMutationObserverConstructor();
  if (!MutationObserver) {
    return {
      stop: noop$1,
      flush: noop$1
    };
  }
  var mutationBatch = createMutationBatch(function (mutations) {
    processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
  });
  var observer = new MutationObserver(monitor(mutationBatch.addMutations));
  observer.observe(target, {
    attributeOldValue: true,
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return {
    stop: function () {
      observer.disconnect();
      mutationBatch.stop();
    },
    flush: function () {
      mutationBatch.flush();
    }
  };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
  var nodePrivacyLevelCache = new Map();
  mutations.filter(function (mutation) {
    return mutation.type === 'childList';
  }).forEach(function (mutation) {
    mutation.removedNodes.forEach(function (removedNode) {
      traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
    });
  });
  // Discard any mutation with a 'target' node that:
  // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
  // part of a mutation occurring in a parent Node
  // * should be hidden or ignored
  var filteredMutations = mutations.filter(function (mutation) {
    return mutation.target.isConnected && nodeAndAncestorsHaveSerializedNode(mutation.target) && getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== NodePrivacyLevel.HIDDEN;
  });
  var _a = processChildListMutations(filteredMutations.filter(function (mutation) {
      return mutation.type === 'childList';
    }), configuration, shadowRootsController, nodePrivacyLevelCache),
    adds = _a.adds,
    removes = _a.removes,
    hasBeenSerialized = _a.hasBeenSerialized;
  var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  if (!texts.length && !attributes.length && !removes.length && !adds.length) {
    return;
  }
  mutationCallback(assembleIncrementalSnapshot(IncrementalSource.Mutation, {
    adds: adds,
    removes: removes,
    texts: texts,
    attributes: attributes
  }));
}
function processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
  // First, we iterate over mutations to collect:
  //
  // * nodes that have been added in the document and not removed by a subsequent mutation
  // * nodes that have been removed from the document but were not added in a previous mutation
  //
  // For this second category, we also collect their previous parent (mutation.target) because we'll
  // need it to emit a 'remove' mutation.
  //
  // Those two categories may overlap: if a node moved from a position to another, it is reported as
  // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
  // the node will be in both sets.
  var addedAndMovedNodes = new Set();
  var removedNodes = new Map();
  var _loop_1 = function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      addedAndMovedNodes.add(node);
    });
    mutation.removedNodes.forEach(function (node) {
      if (!addedAndMovedNodes.has(node)) {
        removedNodes.set(node, mutation.target);
      }
      addedAndMovedNodes.delete(node);
    });
  };
  for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
    var mutation = mutations_1[_i];
    _loop_1(mutation);
  }
  // Then, we sort nodes that are still in the document by topological order, for two reasons:
  //
  // * We will serialize each added nodes with their descendants. We don't want to serialize a node
  // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
  // a precedent node.
  //
  // * To emit "add" mutations, we need references to the parent and potential next sibling of each
  // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
  // siblings, we want to iterate from last to first. This will ensure that any "next" node is
  // already serialized and have an id.
  var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
  sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
  // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
  // node ids in a set to be able to skip subsequent related mutations.
  var serializedNodeIds = new Set();
  var addedNodeMutations = [];
  for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
    var node = sortedAddedAndMovedNodes_1[_a];
    if (hasBeenSerialized(node)) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    var serializedNode = serializeNodeWithId(node, {
      serializedNodeIds: serializedNodeIds,
      parentNodePrivacyLevel: parentNodePrivacyLevel,
      serializationContext: {
        status: 2 /* SerializationContextStatus.MUTATION */,
        shadowRootsController: shadowRootsController
      },
      configuration: configuration
    });
    if (!serializedNode) {
      continue;
    }
    var parentNode = getParentNode(node);
    addedNodeMutations.push({
      nextId: getNextSibling(node),
      parentId: getSerializedNodeId(parentNode),
      node: serializedNode
    });
  }
  // Finally, we emit remove mutations.
  var removedNodeMutations = [];
  removedNodes.forEach(function (parent, node) {
    if (hasSerializedNode(node)) {
      removedNodeMutations.push({
        parentId: getSerializedNodeId(parent),
        id: getSerializedNodeId(node)
      });
    }
  });
  return {
    adds: addedNodeMutations,
    removes: removedNodeMutations,
    hasBeenSerialized: hasBeenSerialized
  };
  function hasBeenSerialized(node) {
    return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
  }
  function getNextSibling(node) {
    var nextSibling = node.nextSibling;
    while (nextSibling) {
      if (hasSerializedNode(nextSibling)) {
        return getSerializedNodeId(nextSibling);
      }
      nextSibling = nextSibling.nextSibling;
    }
    return null;
  }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
  var _a;
  var textMutations = [];
  // Deduplicate mutations based on their target node
  var handledNodes = new Set();
  var filteredMutations = mutations.filter(function (mutation) {
    if (handledNodes.has(mutation.target)) {
      return false;
    }
    handledNodes.add(mutation.target);
    return true;
  });
  // Emit mutations
  for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
    var mutation = filteredMutations_1[_i];
    var value = mutation.target.textContent;
    if (value === mutation.oldValue) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    textMutations.push({
      id: getSerializedNodeId(mutation.target),
      // TODO: pass a valid "ignoreWhiteSpace" argument
      value: (_a = getTextContent$1(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
    });
  }
  return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
  var attributeMutations = [];
  // Deduplicate mutations based on their target node and changed attribute
  var handledElements = new Map();
  var filteredMutations = mutations.filter(function (mutation) {
    var handledAttributes = handledElements.get(mutation.target);
    if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
      return false;
    }
    if (!handledAttributes) {
      handledElements.set(mutation.target, new Set([mutation.attributeName]));
    } else {
      handledAttributes.add(mutation.attributeName);
    }
    return true;
  });
  // Emit mutations
  var emittedMutations = new Map();
  for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
    var mutation = filteredMutations_2[_i];
    var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
    if (uncensoredValue === mutation.oldValue) {
      continue;
    }
    var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
    var transformedValue = void 0;
    if (mutation.attributeName === 'value') {
      var inputValue = getElementInputValue(mutation.target, privacyLevel);
      if (inputValue === undefined) {
        continue;
      }
      transformedValue = inputValue;
    } else if (typeof attributeValue === 'string') {
      transformedValue = attributeValue;
    } else {
      transformedValue = null;
    }
    var emittedMutation = emittedMutations.get(mutation.target);
    if (!emittedMutation) {
      emittedMutation = {
        id: getSerializedNodeId(mutation.target),
        attributes: {}
      };
      attributeMutations.push(emittedMutation);
      emittedMutations.set(mutation.target, emittedMutation);
    }
    emittedMutation.attributes[mutation.attributeName] = transformedValue;
  }
  return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
  nodes.sort(function (a, b) {
    var position = a.compareDocumentPosition(b);
    /* eslint-disable no-bitwise */
    if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    } else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      return -1;
    }
    /* eslint-enable no-bitwise */
    return 0;
  });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
  if (isNodeShadowHost(removedNode)) {
    shadowDomRemovedCallback(removedNode.shadowRoot);
  }
  forEachChildNodes(removedNode, function (childNode) {
    return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback);
  });
}

function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  return {
    set: function (element, scrollPositions) {
      if (element === document && !document.scrollingElement) {
        // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
        // in some cases scrolling elements can not be defined, we don't support those for now
        return;
      }
      scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
    },
    get: function (element) {
      return scrollPositionsByElement.get(element);
    },
    has: function (element) {
      return scrollPositionsByElement.has(element);
    }
  };
}

var initShadowRootsController = function (configuration, callback, elementsScrollPositions) {
  var controllerByShadowRoot = new Map();
  var shadowRootsController = {
    addShadowRoot: function (shadowRoot) {
      if (controllerByShadowRoot.has(shadowRoot)) {
        return;
      }
      var mutationTracker = trackMutation(callback, configuration, shadowRootsController, shadowRoot);
      // The change event does not bubble up across the shadow root, we have to listen on the shadow root
      var inputTracker = trackInput(configuration, callback, shadowRoot);
      // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
      var scrollTracker = trackScroll(configuration, callback, elementsScrollPositions, shadowRoot);
      controllerByShadowRoot.set(shadowRoot, {
        flush: function () {
          return mutationTracker.flush();
        },
        stop: function () {
          mutationTracker.stop();
          inputTracker.stop();
          scrollTracker.stop();
        }
      });
    },
    removeShadowRoot: function (shadowRoot) {
      var entry = controllerByShadowRoot.get(shadowRoot);
      if (!entry) {
        // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
        return;
      }
      entry.stop();
      controllerByShadowRoot.delete(shadowRoot);
    },
    stop: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var stop = _a.stop;
        return stop();
      });
    },
    flush: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var flush = _a.flush;
        return flush();
      });
    }
  };
  return shadowRootsController;
};

function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
  var takeFullSnapshot = function (timestamp, serializationContext) {
    if (timestamp === void 0) {
      timestamp = timeStampNow();
    }
    if (serializationContext === void 0) {
      serializationContext = {
        status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
        elementsScrollPositions: elementsScrollPositions,
        shadowRootsController: shadowRootsController
      };
    }
    var _a = getViewportDimension(),
      width = _a.width,
      height = _a.height;
    var records = [{
      data: {
        height: height,
        href: window.location.href,
        width: width
      },
      type: RecordType.Meta,
      timestamp: timestamp
    }, {
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timestamp
    }, {
      data: {
        node: serializeDocument(document, configuration, serializationContext),
        initialOffset: {
          left: getScrollX(),
          top: getScrollY()
        }
      },
      type: RecordType.FullSnapshot,
      timestamp: timestamp
    }];
    if (window.visualViewport) {
      records.push({
        data: getVisualViewport(window.visualViewport),
        type: RecordType.VisualViewport,
        timestamp: timestamp
      });
    }
    return records;
  };
  fullSnapshotCallback(takeFullSnapshot());
  var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
    flushMutations();
    fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
      shadowRootsController: shadowRootsController,
      status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
      elementsScrollPositions: elementsScrollPositions
    }));
  }).unsubscribe;
  return {
    stop: unsubscribe
  };
}

function initRecordIds() {
  var recordIds = new WeakMap();
  var nextId = 1;
  return {
    getIdForEvent: function (event) {
      if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
      }
      return recordIds.get(event);
    }
  };
}

function record(options) {
  var emit = options.emit,
    configuration = options.configuration,
    lifeCycle = options.lifeCycle;
  // runtime checks for user options
  if (!emit) {
    throw new Error('emit function is required');
  }
  var emitAndComputeStats = function (record) {
    emit(record);
    sendToExtension('record', {
      record: record
    });
    var view = options.viewContexts.findView();
    addRecord(view.id);
  };
  var elementsScrollPositions = createElementsScrollPositions();
  var shadowRootsController = initShadowRootsController(configuration, emitAndComputeStats, elementsScrollPositions);
  var stopFullSnapshots = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function (records) {
    return records.forEach(function (record) {
      return emitAndComputeStats(record);
    });
  }).stop;
  function flushMutations() {
    shadowRootsController.flush();
    mutationTracker.flush();
  }
  var recordIds = initRecordIds();
  var mutationTracker = trackMutation(emitAndComputeStats, configuration, shadowRootsController, document);
  var trackers = [mutationTracker, trackMove(configuration, emitAndComputeStats), trackMouseInteraction(configuration, emitAndComputeStats, recordIds), trackScroll(configuration, emitAndComputeStats, elementsScrollPositions, document), trackViewportResize(configuration, emitAndComputeStats), trackInput(configuration, emitAndComputeStats), trackMediaInteraction(configuration, emitAndComputeStats), trackStyleSheet(emitAndComputeStats), trackFocus(configuration, emitAndComputeStats), trackViewportResize(configuration, emitAndComputeStats), trackFrustration(lifeCycle, emitAndComputeStats, recordIds), trackViewEnd(lifeCycle, function (viewEndRecord) {
    flushMutations();
    emitAndComputeStats(viewEndRecord);
  })];
  return {
    stop: function () {
      shadowRootsController.stop();
      trackers.forEach(function (tracker) {
        return tracker.stop();
      });
      stopFullSnapshots();
    },
    flushMutations: flushMutations,
    shadowRootsController: shadowRootsController
  };
}

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
  var formData = new FormData();
  formData.append('segment', new Blob([data], {
    type: 'application/octet-stream'
  }), "".concat(metadata.session.id, "-").concat(metadata.start));
  var metadataAndSegmentSizes = assign({
    raw_segment_size: rawSegmentBytesCount,
    compressed_segment_size: data.byteLength
  }, metadata);
  var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
  formData.append('event', new Blob([serializedMetadataAndSegmentSizes], {
    type: 'application/json'
  }));
  return {
    data: formData,
    bytesCount: data.byteLength
  };
}

var Segment = /** @class */function () {
  function Segment(encoder, context, creationReason) {
    this.encoder = encoder;
    this.encodedBytesCount = 0;
    var viewId = context.view.id;
    this.metadata = assign({
      start: Infinity,
      end: -Infinity,
      creation_reason: creationReason,
      records_count: 0,
      has_full_snapshot: false,
      index_in_view: getSegmentsCount(viewId),
      source: 'browser'
    }, context);
    addSegment(viewId);
  }
  Segment.prototype.addRecord = function (record, callback) {
    var _this = this;
    var _a;
    this.metadata.start = Math.min(this.metadata.start, record.timestamp);
    this.metadata.end = Math.max(this.metadata.end, record.timestamp);
    this.metadata.records_count += 1;
    (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
    var prefix = this.encoder.isEmpty ? '{"records":[' : ',';
    this.encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
      _this.encodedBytesCount += additionalEncodedBytesCount;
      callback(_this.encodedBytesCount);
    });
  };
  Segment.prototype.flush = function (callback) {
    var _this = this;
    if (this.encoder.isEmpty) {
      throw new Error('Empty segment flushed');
    }
    this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
    this.encoder.finish(function (encoderResult) {
      addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
      callback(_this.metadata, encoderResult);
    });
  };
  return Segment;
}();

var SEGMENT_DURATION_LIMIT = 30 * ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
  return doStartSegmentCollection(lifeCycle, function () {
    return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts);
  }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
  var state = {
    status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
    nextSegmentCreationReason: 'init'
  };
  var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function () {
    flushSegment('view_change');
  }).unsubscribe;
  var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
    flushSegment(pageExitEvent.reason);
  }).unsubscribe;
  function flushSegment(flushReason) {
    if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
      state.segment.flush(function (metadata, encoderResult) {
        var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
        if (isPageExitReason(flushReason)) {
          httpRequest.sendOnExit(payload);
        } else {
          httpRequest.send(payload);
        }
      });
      clearTimeout$1(state.expirationTimeoutId);
    }
    if (flushReason !== 'stop') {
      state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: flushReason
      };
    } else {
      state = {
        status: 2 /* SegmentCollectionStatus.Stopped */
      };
    }
  }
  return {
    addRecord: function (record) {
      if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
        return;
      }
      if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
        var context = getSegmentContext();
        if (!context) {
          return;
        }
        state = {
          status: 1 /* SegmentCollectionStatus.SegmentPending */,
          segment: new Segment(encoder, context, state.nextSegmentCreationReason),
          expirationTimeoutId: setTimeout$1(function () {
            flushSegment('segment_duration_limit');
          }, SEGMENT_DURATION_LIMIT)
        };
      }
      state.segment.addRecord(record, function (encodedBytesCount) {
        if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
          flushSegment('segment_bytes_limit');
        }
      });
    },
    stop: function () {
      flushSegment('stop');
      unsubscribeViewCreated();
      unsubscribePageExited();
    }
  };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
  var session = sessionManager.findTrackedSession();
  var viewContext = viewContexts.findView();
  if (!session || !viewContext) {
    return undefined;
  }
  return {
    application: {
      id: applicationId
    },
    session: {
      id: session.id
    },
    view: {
      id: viewContext.id
    }
  };
}

function startRecordBridge(viewContexts) {
  var bridge = getEventBridge();
  return {
    addRecord: function (record) {
      // Get the current active view, not at the time of the record, aligning with the segment logic.
      // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
      // However the risk is minimal. We could address the issue when potential negative impact are identified.
      var view = viewContexts.findView();
      bridge.send('record', record, view.id);
    }
  };
}

function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
  var cleanupTasks = [];
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var replayRequest = httpRequest || createHttpRequest(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
  var addRecord;
  if (!canUseEventBridge()) {
    var segmentCollection = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder);
    addRecord = segmentCollection.addRecord;
    cleanupTasks.push(segmentCollection.stop);
  } else {
    addRecord = startRecordBridge(viewContexts).addRecord;
  }
  var stopRecording = record({
    emit: addRecord,
    configuration: configuration,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts
  }).stop;
  cleanupTasks.push(stopRecording);
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}

/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && typeof URL.createObjectURL === 'function' && 'forEach' in NodeList.prototype
  );
}

function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
  var session = sessionManager.findTrackedSession();
  var errorType = getErrorType(session, isRecordingStarted);
  var viewContext = viewContexts.findView();
  return getSessionReplayUrl(configuration, {
    viewContext: viewContext,
    errorType: errorType,
    session: session
  });
}
function getErrorType(session, isRecordingStarted) {
  if (!isBrowserSupported()) {
    return 'browser-not-supported';
  }
  if (!session) {
    // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return 'rum-not-tracked';
  }
  if (session.sessionReplay === 0 /* SessionReplayState.OFF */) {
    // possibilities
    // - replay sampled out
    return 'incorrect-session-plan';
  }
  if (!isRecordingStarted) {
    return 'replay-not-started';
  }
}

function createDeflateEncoder(configuration, worker, streamId) {
  var rawBytesCount = 0;
  var compressedData = [];
  var compressedDataTrailer;
  var nextWriteActionId = 0;
  var pendingWriteActions = [];
  var removeMessageListener = addEventListener(configuration, worker, 'message', function (_a) {
    var workerResponse = _a.data;
    if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
      return;
    }
    rawBytesCount += workerResponse.additionalBytesCount;
    compressedData.push(workerResponse.result);
    compressedDataTrailer = workerResponse.trailer;
    var nextPendingAction = pendingWriteActions.shift();
    if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
      if (nextPendingAction.writeCallback) {
        nextPendingAction.writeCallback(workerResponse.result.byteLength);
      } else if (nextPendingAction.finishCallback) {
        nextPendingAction.finishCallback();
      }
    } else {
      removeMessageListener();
      addTelemetryDebug('Worker responses received out of order.');
    }
  }).stop;
  function consumeResult() {
    var output = compressedData.length === 0 ? new Uint8Array(0) : concatBuffers(compressedData.concat(compressedDataTrailer));
    var result = {
      rawBytesCount: rawBytesCount,
      output: output,
      outputBytesCount: output.byteLength,
      encoding: 'deflate'
    };
    rawBytesCount = 0;
    compressedData = [];
    return result;
  }
  function sendResetIfNeeded() {
    if (nextWriteActionId > 0) {
      worker.postMessage({
        action: 'reset',
        streamId: streamId
      });
      nextWriteActionId = 0;
    }
  }
  return {
    isAsync: true,
    get isEmpty() {
      return nextWriteActionId === 0;
    },
    write: function (data, callback) {
      worker.postMessage({
        action: 'write',
        id: nextWriteActionId,
        data: data,
        streamId: streamId
      });
      pendingWriteActions.push({
        id: nextWriteActionId,
        writeCallback: callback,
        data: data
      });
      nextWriteActionId += 1;
    },
    finish: function (callback) {
      sendResetIfNeeded();
      if (!pendingWriteActions.length) {
        callback(consumeResult());
      } else {
        // Make sure we do not call any write callback
        pendingWriteActions.forEach(function (pendingWriteAction) {
          delete pendingWriteAction.writeCallback;
        });
        // Wait for the last action to finish before calling the finish callback
        pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () {
          return callback(consumeResult());
        };
      }
    },
    finishSync: function () {
      sendResetIfNeeded();
      var pendingData = pendingWriteActions.map(function (pendingWriteAction) {
        // Make sure we do not call any write or finish callback
        delete pendingWriteAction.writeCallback;
        delete pendingWriteAction.finishCallback;
        return pendingWriteAction.data;
      }).join('');
      return assign(consumeResult(), {
        pendingData: pendingData
      });
    },
    estimateEncodedBytesCount: function (data) {
      // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
      // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
      // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
      // requests of the expected size.
      return data.length / 8;
    },
    stop: function () {
      removeMessageListener();
    }
  };
}

var INITIALIZATION_TIME_OUT_DELAY = 10 * ONE_SECOND;
function createDeflateWorker(configuration) {
  return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.23.0\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = {
  status: 0 /* DeflateWorkerStatus.Nil */
};
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
    // doStartDeflateWorker updates the state to "loading" or "error"
    doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
  }
  switch (state.status) {
    case 1 /* DeflateWorkerStatus.Loading */:
      state.initializationFailureCallbacks.push(onInitializationFailure);
      return state.worker;
    case 3 /* DeflateWorkerStatus.Initialized */:
      return state.worker;
  }
}
function getDeflateWorkerStatus() {
  return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  try {
    var worker = createDeflateWorkerImpl(configuration);
    var removeErrorListener_1 = addEventListener(configuration, worker, 'error', function (error) {
      onError(configuration, source, error);
    }).stop;
    var removeMessageListener_1 = addEventListener(configuration, worker, 'message', function (_a) {
      var data = _a.data;
      if (data.type === 'errored') {
        onError(configuration, source, data.error, data.streamId);
      } else if (data.type === 'initialized') {
        onInitialized(data.version);
      }
    }).stop;
    worker.postMessage({
      action: 'init'
    });
    setTimeout$1(function () {
      return onTimeout(source);
    }, INITIALIZATION_TIME_OUT_DELAY);
    var stop_1 = function () {
      removeErrorListener_1();
      removeMessageListener_1();
    };
    state = {
      status: 1 /* DeflateWorkerStatus.Loading */,
      worker: worker,
      stop: stop_1,
      initializationFailureCallbacks: []
    };
  } catch (error) {
    onError(configuration, source, error);
  }
}
function onTimeout(source) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    display.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
    state.initializationFailureCallbacks.forEach(function (callback) {
      return callback();
    });
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  }
}
function onInitialized(version) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    state = {
      status: 3 /* DeflateWorkerStatus.Initialized */,
      worker: state.worker,
      stop: state.stop,
      version: version
    };
  }
}
function onError(configuration, source, error, streamId) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
    display.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
    if (error instanceof Event || error instanceof Error && isMessageCspRelated(error.message)) {
      var baseMessage = void 0;
      if (configuration.workerUrl) {
        baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
      } else {
        baseMessage = 'Please make sure CSP is correctly configured.';
      }
      display.error("".concat(baseMessage, " See documentation at ").concat(DOCS_ORIGIN, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else {
      addTelemetryError(error);
    }
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
      state.initializationFailureCallbacks.forEach(function (callback) {
        return callback();
      });
    }
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  } else {
    addTelemetryError(error, {
      worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
      stream_id: streamId
    });
  }
}
function isMessageCspRelated(message) {
  return includes(message, 'Content Security Policy') ||
  // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  includes(message, "requires 'TrustedScriptURL'");
}

function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
  if (canUseEventBridge() && !bridgeSupports("records" /* BridgeCapability.RECORDS */) || !isBrowserSupported()) {
    return {
      start: noop$1,
      stop: noop$1,
      getReplayStats: function () {
        return undefined;
      },
      onRumStart: noop$1,
      isRecording: function () {
        return false;
      },
      getSessionReplayLink: function () {
        return undefined;
      }
    };
  }
  var state = {
    status: 1 /* RecorderStatus.IntentToStart */
  };
  var startStrategy = function () {
    state = {
      status: 1 /* RecorderStatus.IntentToStart */
    };
  };
  var stopStrategy = function () {
    state = {
      status: 0 /* RecorderStatus.Stopped */
    };
  };
  var getSessionReplayLinkStrategy = noop$1;
  return {
    start: function (options) {
      return startStrategy(options);
    },
    stop: function () {
      return stopStrategy();
    },
    getSessionReplayLink: function () {
      return getSessionReplayLinkStrategy();
    },
    onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
      if (configuration.startSessionReplayRecordingManually) {
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      }
      lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          stopStrategy();
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
        }
      });
      // Stop the recorder on page unload to avoid sending records after the page is ended.
      lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        if (pageExitEvent.reason === PageExitReason.UNLOADING) {
          stopStrategy();
        }
      });
      lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        if (state.status === 1 /* RecorderStatus.IntentToStart */) {
          startStrategy();
        }
      });
      var cachedDeflateEncoder;
      function getOrCreateDeflateEncoder() {
        if (!cachedDeflateEncoder) {
          if (!worker) {
            worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
              stopStrategy();
            }, createDeflateWorkerImpl);
          }
          if (worker) {
            cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
          }
        }
        return cachedDeflateEncoder;
      }
      startStrategy = function (options) {
        var session = sessionManager.findTrackedSession();
        if (!session || session.sessionReplay === 0 /* SessionReplayState.OFF */ && !(options === null || options === void 0 ? void 0 : options.force)) {
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
          return;
        }
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          return;
        }
        state = {
          status: 2 /* RecorderStatus.Starting */
        };
        runOnReadyState(configuration, 'interactive', function () {
          if (state.status !== 2 /* RecorderStatus.Starting */) {
            return;
          }
          var deflateEncoder = getOrCreateDeflateEncoder();
          if (!deflateEncoder) {
            state = {
              status: 0 /* RecorderStatus.Stopped */
            };
            return;
          }
          var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
          state = {
            status: 3 /* RecorderStatus.Started */,
            stopRecording: stopRecording
          };
        });
        if ((options === null || options === void 0 ? void 0 : options.force) && session.sessionReplay === 0 /* SessionReplayState.OFF */) {
          sessionManager.setForcedReplay();
        }
      };
      stopStrategy = function () {
        if (state.status === 0 /* RecorderStatus.Stopped */) {
          return;
        }
        if (state.status === 3 /* RecorderStatus.Started */) {
          state.stopRecording();
        }
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      };
      getSessionReplayLinkStrategy = function () {
        return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
      };
      if (state.status === 1 /* RecorderStatus.IntentToStart */) {
        startStrategy();
      }
    },
    isRecording: function () {
      // The worker is started optimistically, meaning we could have started to record but its
      // initialization fails a bit later. This could happen when:
      // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
      // throw an exception when instantiating the worker, and IE doesn't care about CSP)
      // * the browser fails to load the worker in case the workerUrl is used
      // * an unexpected error occurs in the Worker before initialization, ex:
      //   * a runtime exception collected by monitor()
      //   * a syntax error notified by the browser via an error event
      // * the worker is unresponsive for some reason and timeouts
      //
      // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
      // an important part of the Datadog App:
      // * If we have a false positive (we set has_replay: true even if no replay data is present),
      // we might display broken links to the Session Replay player.
      // * If we have a false negative (we don't set has_replay: true even if replay data is
      // available), it is less noticeable because no link will be displayed.
      //
      // Thus, it is better to have false negative, so let's make sure the worker is correctly
      // initialized before advertizing that we are recording.
      //
      // In the future, when the compression worker will also be used for RUM data, this will be
      // less important since no RUM event will be sent when the worker fails to initialize.
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
    },
    getReplayStats: function (viewId) {
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
    }
  };
}

// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, {
  startDeflateWorker: startDeflateWorker,
  createDeflateEncoder: createDeflateEncoder
});
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);

/**
 * datadogRum 초기화
 * @see {@link https://docs.datadoghq.com/real_user_monitoring/browser/}
 * @param {InitDatadogRumParam} datadogRumConfig
 * @example
 * ```
 * initDatadogRum({
 *   applicationId: '66451c75-004a-4a0a-ae4c-02d685d69a6c',
 *   clientToken: 'pub016ce1bb00dd9537751b302853449132',
 *   env: 'dev' | 'qa' | 'prod'
 *   service: 'store-web',
 *   sessionSampleRate: 5,
 *   sessionReplaySampleRate: 5,
 * });
 * ```
 */
const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  env,
  version = '',
  sessionSampleRate,
  sessionReplaySampleRate
}) => {
  if (typeof window === 'undefined' || !['qa', 'prod'].includes(env ?? '')) {
    return;
  }
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  if (sessionReplaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var urlToolkit = {exports: {}};

(function (module, exports) {
	// see https://tools.ietf.org/html/rfc1808

	(function (root) {
	  var URL_REGEX =
	    /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
	  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;

	  var URLToolkit = {
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function (baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(
	          basePartsForNormalise.path
	        );
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment,
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath =
	              baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) +
	              relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize
	          ? URLToolkit.normalizePath(relativeParts.path)
	          : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function (url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || '',
	      };
	    },
	    normalizePath: function (path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (
	        path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length
	      ) {}
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function (parts) {
	      return (
	        parts.scheme +
	        parts.netLoc +
	        parts.path +
	        parts.params +
	        parts.query +
	        parts.fragment
	      );
	    },
	  };

	  module.exports = URLToolkit;
	})(); 
} (urlToolkit));

var urlToolkitExports = urlToolkit.exports;

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const isFiniteNumber = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const isSafeInteger = Number.isSafeInteger || function (value) {
  return typeof value === 'number' && Math.abs(value) <= MAX_SAFE_INTEGER;
};
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

let Events = /*#__PURE__*/function (Events) {
  Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
  Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
  Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
  Events["MEDIA_DETACHED"] = "hlsMediaDetached";
  Events["BUFFER_RESET"] = "hlsBufferReset";
  Events["BUFFER_CODECS"] = "hlsBufferCodecs";
  Events["BUFFER_CREATED"] = "hlsBufferCreated";
  Events["BUFFER_APPENDING"] = "hlsBufferAppending";
  Events["BUFFER_APPENDED"] = "hlsBufferAppended";
  Events["BUFFER_EOS"] = "hlsBufferEos";
  Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
  Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
  Events["MANIFEST_LOADING"] = "hlsManifestLoading";
  Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
  Events["MANIFEST_PARSED"] = "hlsManifestParsed";
  Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
  Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
  Events["LEVEL_LOADING"] = "hlsLevelLoading";
  Events["LEVEL_LOADED"] = "hlsLevelLoaded";
  Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
  Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
  Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
  Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
  Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
  Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
  Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
  Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
  Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
  Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
  Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
  Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
  Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
  Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
  Events["CUES_PARSED"] = "hlsCuesParsed";
  Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
  Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
  Events["FRAG_LOADING"] = "hlsFragLoading";
  Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
  Events["FRAG_LOADED"] = "hlsFragLoaded";
  Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
  Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
  Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
  Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
  Events["FRAG_PARSED"] = "hlsFragParsed";
  Events["FRAG_BUFFERED"] = "hlsFragBuffered";
  Events["FRAG_CHANGED"] = "hlsFragChanged";
  Events["FPS_DROP"] = "hlsFpsDrop";
  Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
  Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
  Events["ERROR"] = "hlsError";
  Events["DESTROYING"] = "hlsDestroying";
  Events["KEY_LOADING"] = "hlsKeyLoading";
  Events["KEY_LOADED"] = "hlsKeyLoaded";
  Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
  Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
  Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
  return Events;
}({});

/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */

let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["NETWORK_ERROR"] = "networkError";
  ErrorTypes["MEDIA_ERROR"] = "mediaError";
  ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
  ErrorTypes["MUX_ERROR"] = "muxError";
  ErrorTypes["OTHER_ERROR"] = "otherError";
  return ErrorTypes;
}({});
let ErrorDetails = /*#__PURE__*/function (ErrorDetails) {
  ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
  ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
  ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
  ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
  ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
  ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
  ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
  ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
  ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
  ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
  ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
  ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
  ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
  ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
  ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
  ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
  ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
  ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
  ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
  ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
  ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
  ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
  ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
  ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
  ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
  ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
  ErrorDetails["FRAG_GAP"] = "fragGap";
  ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
  ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
  ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
  ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
  ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
  ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
  ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
  ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
  ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
  ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
  ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
  ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
  ErrorDetails["INTERNAL_ABORTED"] = "aborted";
  ErrorDetails["UNKNOWN"] = "unknown";
  return ErrorDetails;
}({});

const noop = function noop() {};
const fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};
let exportedLogger = fakeLogger;

// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function consolePrintFn(type) {
  const func = self.console[type];
  if (func) {
    return func.bind(self.console, `[${type}] >`);
  }
  return noop;
}
function exportLoggerFunctions(debugConfig, ...functions) {
  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}
function enableLogs(debugConfig, id) {
  // check that console is available
  if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    // 'trace',
    'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log(`Debug logs enabled for "${id}" in hls.js version ${"1.5.14"}`);
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
}
const logger = exportedLogger;

const DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class AttrList {
  constructor(attrs) {
    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs);
    }
    _extends(this, attrs);
  }
  get clientAttrs() {
    return Object.keys(this).filter(attr => attr.substring(0, 2) === 'X-');
  }
  decimalInteger(attrName) {
    const intValue = parseInt(this[attrName], 10);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  hexadecimalInteger(attrName) {
    if (this[attrName]) {
      let stringValue = (this[attrName] || '0x').slice(2);
      stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
      const value = new Uint8Array(stringValue.length / 2);
      for (let i = 0; i < stringValue.length / 2; i++) {
        value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
      }
      return value;
    } else {
      return null;
    }
  }
  hexadecimalIntegerAsNumber(attrName) {
    const intValue = parseInt(this[attrName], 16);
    if (intValue > Number.MAX_SAFE_INTEGER) {
      return Infinity;
    }
    return intValue;
  }
  decimalFloatingPoint(attrName) {
    return parseFloat(this[attrName]);
  }
  optionalFloat(attrName, defaultValue) {
    const value = this[attrName];
    return value ? parseFloat(value) : defaultValue;
  }
  enumeratedString(attrName) {
    return this[attrName];
  }
  bool(attrName) {
    return this[attrName] === 'YES';
  }
  decimalResolution(attrName) {
    const res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
    if (res === null) {
      return undefined;
    }
    return {
      width: parseInt(res[1], 10),
      height: parseInt(res[2], 10)
    };
  }
  static parseAttrList(input) {
    let match;
    const attrs = {};
    const quote = '"';
    ATTR_LIST_REGEX.lastIndex = 0;
    while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
      let value = match[2];
      if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
        value = value.slice(1, -1);
      }
      const name = match[1].trim();
      attrs[name] = value;
    }
    return attrs;
  }
}

// Avoid exporting const enum so that these values can be inlined

function isDateRangeCueAttribute(attrName) {
  return attrName !== "ID" && attrName !== "CLASS" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function isSCTE35Attribute(attrName) {
  return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN";
}
class DateRange {
  constructor(dateRangeAttr, dateRangeWithSameId) {
    this.attr = void 0;
    this._startDate = void 0;
    this._endDate = void 0;
    this._badValueForSameId = void 0;
    if (dateRangeWithSameId) {
      const previousAttr = dateRangeWithSameId.attr;
      for (const key in previousAttr) {
        if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
          logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
          this._badValueForSameId = key;
          break;
        }
      }
      // Merge DateRange tags with the same ID
      dateRangeAttr = _extends(new AttrList({}), previousAttr, dateRangeAttr);
    }
    this.attr = dateRangeAttr;
    this._startDate = new Date(dateRangeAttr["START-DATE"]);
    if ("END-DATE" in this.attr) {
      const endDate = new Date(this.attr["END-DATE"]);
      if (isFiniteNumber(endDate.getTime())) {
        this._endDate = endDate;
      }
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate) {
      return this._endDate;
    }
    const duration = this.duration;
    if (duration !== null) {
      return new Date(this._startDate.getTime() + duration * 1000);
    }
    return null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const duration = this.attr.decimalFloatingPoint("DURATION");
      if (isFiniteNumber(duration)) {
        return duration;
      }
    } else if (this._endDate) {
      return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
    }
    return null;
  }
  get plannedDuration() {
    if ("PLANNED-DURATION" in this.attr) {
      return this.attr.decimalFloatingPoint("PLANNED-DURATION");
    }
    return null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}

class LoadStats {
  constructor() {
    this.aborted = false;
    this.loaded = 0;
    this.retry = 0;
    this.total = 0;
    this.chunkCount = 0;
    this.bwEstimate = 0;
    this.loading = {
      start: 0,
      first: 0,
      end: 0
    };
    this.parsing = {
      start: 0,
      end: 0
    };
    this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}

var ElementaryStreamTypes = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class BaseSegment {
  constructor(baseurl) {
    this._byteRange = null;
    this._url = null;
    // baseurl is the URL to the playlist
    this.baseurl = void 0;
    // relurl is the portion of the URL that comes from inside the playlist.
    this.relurl = void 0;
    // Holds the types of data this fragment supports
    this.elementaryStreams = {
      [ElementaryStreamTypes.AUDIO]: null,
      [ElementaryStreamTypes.VIDEO]: null,
      [ElementaryStreamTypes.AUDIOVIDEO]: null
    };
    this.baseurl = baseurl;
  }

  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(value, previous) {
    const params = value.split('@', 2);
    let start;
    if (params.length === 1) {
      start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
    } else {
      start = parseInt(params[1]);
    }
    this._byteRange = [start, parseInt(params[0]) + start];
  }
  get byteRange() {
    if (!this._byteRange) {
      return [];
    }
    return this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    if (!this._url && this.baseurl && this.relurl) {
      this._url = urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
        alwaysNormalize: true
      });
    }
    return this._url || '';
  }
  set url(value) {
    this._url = value;
  }
}

/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */
class Fragment extends BaseSegment {
  constructor(type, baseurl) {
    super(baseurl);
    this._decryptdata = null;
    this.rawProgramDateTime = null;
    this.programDateTime = null;
    this.tagList = [];
    // EXTINF has to be present for a m3u8 to be considered valid
    this.duration = 0;
    // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
    this.sn = 0;
    // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
    // core difference from the private field _decryptdata is the lack of the initialized IV
    // _decryptdata will set the IV for this segment based on the segment number in the fragment
    this.levelkeys = void 0;
    // A string representing the fragment type
    this.type = void 0;
    // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
    this.loader = null;
    // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
    this.keyLoader = null;
    // The level/track index to which the fragment belongs
    this.level = -1;
    // The continuity counter of the fragment
    this.cc = 0;
    // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.startPTS = void 0;
    // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
    this.endPTS = void 0;
    // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.startDTS = void 0;
    // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
    this.endDTS = void 0;
    // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
    this.start = 0;
    // Set by `updateFragPTSDTS` in level-helper
    this.deltaPTS = void 0;
    // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.maxStartPTS = void 0;
    // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
    this.minEndPTS = void 0;
    // Load/parse timing information
    this.stats = new LoadStats();
    // Init Segment bytes (unset for media segments)
    this.data = void 0;
    // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
    this.bitrateTest = false;
    // #EXTINF  segment title
    this.title = null;
    // The Media Initialization Section for this segment
    this.initSegment = null;
    // Fragment is the last fragment in the media playlist
    this.endList = void 0;
    // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
    this.gap = void 0;
    // Deprecated
    this.urlId = 0;
    this.type = type;
  }
  get decryptdata() {
    const {
      levelkeys
    } = this;
    if (!levelkeys && !this._decryptdata) {
      return null;
    }
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const key = this.levelkeys.identity;
      if (key) {
        this._decryptdata = key.getDecryptData(this.sn);
      } else {
        const keyFormats = Object.keys(this.levelkeys);
        if (keyFormats.length === 1) {
          return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
        }
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null) {
      return null;
    }
    if (!isFiniteNumber(this.programDateTime)) {
      return null;
    }
    const duration = !isFiniteNumber(this.duration) ? 0 : this.duration;
    return this.programDateTime + duration * 1000;
  }
  get encrypted() {
    var _this$_decryptdata;
    // At the m3u8-parser level we need to add support for manifest signalled keyformats
    // when we want the fragment to start reporting that it is encrypted.
    // Currently, keyFormat will only be set for identity keys
    if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) {
      return true;
    } else if (this.levelkeys) {
      const keyFormats = Object.keys(this.levelkeys);
      const len = keyFormats.length;
      if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) {
        return true;
      }
    }
    return false;
  }
  setKeyFormat(keyFormat) {
    if (this.levelkeys) {
      const key = this.levelkeys[keyFormat];
      if (key && !this._decryptdata) {
        this._decryptdata = key.getDecryptData(this.sn);
      }
    }
  }
  abortRequests() {
    var _this$loader, _this$keyLoader;
    (_this$loader = this.loader) == null ? void 0 : _this$loader.abort();
    (_this$keyLoader = this.keyLoader) == null ? void 0 : _this$keyLoader.abort();
  }
  setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
    const {
      elementaryStreams
    } = this;
    const info = elementaryStreams[type];
    if (!info) {
      elementaryStreams[type] = {
        startPTS,
        endPTS,
        startDTS,
        endDTS,
        partial
      };
      return;
    }
    info.startPTS = Math.min(info.startPTS, startPTS);
    info.endPTS = Math.max(info.endPTS, endPTS);
    info.startDTS = Math.min(info.startDTS, startDTS);
    info.endDTS = Math.max(info.endDTS, endDTS);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams
    } = this;
    elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
    elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
    elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
  }
}

/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */
class Part extends BaseSegment {
  constructor(partAttrs, frag, baseurl, index, previous) {
    super(baseurl);
    this.fragOffset = 0;
    this.duration = 0;
    this.gap = false;
    this.independent = false;
    this.relurl = void 0;
    this.fragment = void 0;
    this.index = void 0;
    this.stats = new LoadStats();
    this.duration = partAttrs.decimalFloatingPoint('DURATION');
    this.gap = partAttrs.bool('GAP');
    this.independent = partAttrs.bool('INDEPENDENT');
    this.relurl = partAttrs.enumeratedString('URI');
    this.fragment = frag;
    this.index = index;
    const byteRange = partAttrs.enumeratedString('BYTERANGE');
    if (byteRange) {
      this.setByteRange(byteRange, previous);
    }
    if (previous) {
      this.fragOffset = previous.fragOffset + previous.duration;
    }
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams
    } = this;
    return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
  }
}

const DEFAULT_TARGET_DURATION = 10;

/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */
class LevelDetails {
  constructor(baseUrl) {
    this.PTSKnown = false;
    this.alignedSliding = false;
    this.averagetargetduration = void 0;
    this.endCC = 0;
    this.endSN = 0;
    this.fragments = void 0;
    this.fragmentHint = void 0;
    this.partList = null;
    this.dateRanges = void 0;
    this.live = true;
    this.ageHeader = 0;
    this.advancedDateTime = void 0;
    this.updated = true;
    this.advanced = true;
    this.availabilityDelay = void 0;
    // Manifest reload synchronization
    this.misses = 0;
    this.startCC = 0;
    this.startSN = 0;
    this.startTimeOffset = null;
    this.targetduration = 0;
    this.totalduration = 0;
    this.type = null;
    this.url = void 0;
    this.m3u8 = '';
    this.version = null;
    this.canBlockReload = false;
    this.canSkipUntil = 0;
    this.canSkipDateRanges = false;
    this.skippedSegments = 0;
    this.recentlyRemovedDateranges = void 0;
    this.partHoldBack = 0;
    this.holdBack = 0;
    this.partTarget = 0;
    this.preloadHint = void 0;
    this.renditionReports = void 0;
    this.tuneInGoal = 0;
    this.deltaUpdateFailed = void 0;
    this.driftStartTime = 0;
    this.driftEndTime = 0;
    this.driftStart = 0;
    this.driftEnd = 0;
    this.encryptedFragments = void 0;
    this.playlistParsingError = null;
    this.variableList = null;
    this.hasVariableRefs = false;
    this.fragments = [];
    this.encryptedFragments = [];
    this.dateRanges = {};
    this.url = baseUrl;
  }
  reloaded(previous) {
    if (!previous) {
      this.advanced = true;
      this.updated = true;
      return;
    }
    const partSnDiff = this.lastPartSn - previous.lastPartSn;
    const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
    this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
    this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
    if (this.updated || this.advanced) {
      this.misses = Math.floor(previous.misses * 0.6);
    } else {
      this.misses = previous.misses + 1;
    }
    this.availabilityDelay = previous.availabilityDelay;
  }
  get hasProgramDateTime() {
    if (this.fragments.length) {
      return isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
    }
    return false;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || DEFAULT_TARGET_DURATION;
  }
  get drift() {
    const runTime = this.driftEndTime - this.driftStartTime;
    if (runTime > 0) {
      const runDuration = this.driftEnd - this.driftStart;
      return runDuration * 1000 / runTime;
    }
    return 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var _this$partList;
    if ((_this$partList = this.partList) != null && _this$partList.length) {
      return this.partList[this.partList.length - 1].end;
    }
    return this.fragmentEnd;
  }
  get fragmentEnd() {
    var _this$fragments;
    if ((_this$fragments = this.fragments) != null && _this$fragments.length) {
      return this.fragments[this.fragments.length - 1].end;
    }
    return 0;
  }
  get age() {
    if (this.advancedDateTime) {
      return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
    }
    return 0;
  }
  get lastPartIndex() {
    var _this$partList2;
    if ((_this$partList2 = this.partList) != null && _this$partList2.length) {
      return this.partList[this.partList.length - 1].index;
    }
    return -1;
  }
  get lastPartSn() {
    var _this$partList3;
    if ((_this$partList3 = this.partList) != null && _this$partList3.length) {
      return this.partList[this.partList.length - 1].fragment.sn;
    }
    return this.endSN;
  }
}

function base64Decode(base64encodedStr) {
  return Uint8Array.from(atob(base64encodedStr), c => c.charCodeAt(0));
}

function getKeyIdBytes(str) {
  const keyIdbytes = strToUtf8array(str).subarray(0, 16);
  const paddedkeyIdbytes = new Uint8Array(16);
  paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
  return paddedkeyIdbytes;
}
function changeEndianness(keyId) {
  const swap = function swap(array, from, to) {
    const cur = array[from];
    array[from] = array[to];
    array[to] = cur;
  };
  swap(keyId, 0, 3);
  swap(keyId, 1, 2);
  swap(keyId, 4, 5);
  swap(keyId, 6, 7);
}
function convertDataUriToArrayBytes(uri) {
  // data:[<media type][;attribute=value][;base64],<data>
  const colonsplit = uri.split(':');
  let keydata = null;
  if (colonsplit[0] === 'data' && colonsplit.length === 2) {
    const semicolonsplit = colonsplit[1].split(';');
    const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
    if (commasplit.length === 2) {
      const isbase64 = commasplit[0] === 'base64';
      const data = commasplit[1];
      if (isbase64) {
        semicolonsplit.splice(-1, 1); // remove from processing
        keydata = base64Decode(data);
      } else {
        keydata = getKeyIdBytes(data);
      }
    }
  }
  return keydata;
}
function strToUtf8array(str) {
  return Uint8Array.from(unescape(encodeURIComponent(str)), c => c.charCodeAt(0));
}

/** returns `undefined` is `self` is missing, e.g. in node */
const optionalSelf = typeof self !== 'undefined' ? self : undefined;

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */
var KeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
};

// Playlist #EXT-X-KEY KEYFORMAT values
var KeySystemFormats = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function keySystemFormatToKeySystemDomain(format) {
  switch (format) {
    case KeySystemFormats.FAIRPLAY:
      return KeySystems.FAIRPLAY;
    case KeySystemFormats.PLAYREADY:
      return KeySystems.PLAYREADY;
    case KeySystemFormats.WIDEVINE:
      return KeySystems.WIDEVINE;
    case KeySystemFormats.CLEARKEY:
      return KeySystems.CLEARKEY;
  }
}

// System IDs for which we can extract a key ID from "encrypted" event PSSH
var KeySystemIds = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function keySystemIdToKeySystemDomain(systemId) {
  if (systemId === KeySystemIds.WIDEVINE) {
    return KeySystems.WIDEVINE;
    // } else if (systemId === KeySystemIds.PLAYREADY) {
    //   return KeySystems.PLAYREADY;
    // } else if (systemId === KeySystemIds.CENC || systemId === KeySystemIds.CLEARKEY) {
    //   return KeySystems.CLEARKEY;
  }
}
function keySystemDomainToKeySystemFormat(keySystem) {
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      return KeySystemFormats.FAIRPLAY;
    case KeySystems.PLAYREADY:
      return KeySystemFormats.PLAYREADY;
    case KeySystems.WIDEVINE:
      return KeySystemFormats.WIDEVINE;
    case KeySystems.CLEARKEY:
      return KeySystemFormats.CLEARKEY;
  }
}
function getKeySystemsForConfig(config) {
  const {
    drmSystems,
    widevineLicenseUrl
  } = config;
  const keySystemsToAttempt = drmSystems ? [KeySystems.FAIRPLAY, KeySystems.WIDEVINE, KeySystems.PLAYREADY, KeySystems.CLEARKEY].filter(keySystem => !!drmSystems[keySystem]) : [];
  if (!keySystemsToAttempt[KeySystems.WIDEVINE] && widevineLicenseUrl) {
    keySystemsToAttempt.push(KeySystems.WIDEVINE);
  }
  return keySystemsToAttempt;
}
const requestMediaKeySystemAccess = function (_optionalSelf$navigat) {
  if (optionalSelf != null && (_optionalSelf$navigat = optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) {
    return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
  } else {
    return null;
  }
}();

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */
function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
  let initDataTypes;
  switch (keySystem) {
    case KeySystems.FAIRPLAY:
      initDataTypes = ['cenc', 'sinf'];
      break;
    case KeySystems.WIDEVINE:
    case KeySystems.PLAYREADY:
      initDataTypes = ['cenc'];
      break;
    case KeySystems.CLEARKEY:
      initDataTypes = ['cenc', 'keyids'];
      break;
    default:
      throw new Error(`Unknown key-system: ${keySystem}`);
  }
  return createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
  const baseConfig = {
    initDataTypes: initDataTypes,
    persistentState: drmSystemOptions.persistentState || 'optional',
    distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
    sessionTypes: drmSystemOptions.sessionTypes || [drmSystemOptions.sessionType || 'temporary'],
    audioCapabilities: audioCodecs.map(codec => ({
      contentType: `audio/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.audioRobustness || '',
      encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
    })),
    videoCapabilities: videoCodecs.map(codec => ({
      contentType: `video/mp4; codecs="${codec}"`,
      robustness: drmSystemOptions.videoRobustness || '',
      encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
    }))
  };
  return [baseConfig];
}

function sliceUint8(array, start, end) {
  // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
  // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
  return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
}

// breaking up those two types in order to clarify what is happening in the decoding path.

/**
 * Returns true if an ID3 header can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isHeader$2 = (data, offset) => {
  /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */
  if (offset + 10 <= data.length) {
    // look for 'ID3' identifier
    if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns true if an ID3 footer can be found at offset in data
 * @param data - The data to search
 * @param offset - The offset at which to start searching
 */
const isFooter = (data, offset) => {
  /*
   * The footer is a copy of the header, but with a different identifier
   */
  if (offset + 10 <= data.length) {
    // look for '3DI' identifier
    if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
      // check version is within range
      if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
        // check size is within range
        if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
          return true;
        }
      }
    }
  }
  return false;
};

/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 * @returns the block of data containing any ID3 tags found
 * or *undefined* if no header is found at the starting offset
 */
const getID3Data = (data, offset) => {
  const front = offset;
  let length = 0;
  while (isHeader$2(data, offset)) {
    // ID3 header is 10 bytes
    length += 10;
    const size = readSize(data, offset + 6);
    length += size;
    if (isFooter(data, offset + 10)) {
      // ID3 footer is 10 bytes
      length += 10;
    }
    offset += length;
  }
  if (length > 0) {
    return data.subarray(front, front + length);
  }
  return undefined;
};
const readSize = (data, offset) => {
  let size = 0;
  size = (data[offset] & 0x7f) << 21;
  size |= (data[offset + 1] & 0x7f) << 14;
  size |= (data[offset + 2] & 0x7f) << 7;
  size |= data[offset + 3] & 0x7f;
  return size;
};
const canParse$2 = (data, offset) => {
  return isHeader$2(data, offset) && readSize(data, offset + 6) + 10 <= data.length - offset;
};

/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 * @param data - Block of data containing one or more ID3 tags
 */
const getTimeStamp = data => {
  const frames = getID3Frames(data);
  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    if (isTimeStampFrame(frame)) {
      return readTimeStamp(frame);
    }
  }
  return undefined;
};

/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 */
const isTimeStampFrame = frame => {
  return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
};
const getFrameData = data => {
  /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */
  const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
  const size = readSize(data, 4);

  // skip frame id, size, and flags
  const offset = 10;
  return {
    type,
    size,
    data: data.subarray(offset, offset + size)
  };
};

/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 * @param id3Data - The ID3 data containing one or more ID3 tags
 */
const getID3Frames = id3Data => {
  let offset = 0;
  const frames = [];
  while (isHeader$2(id3Data, offset)) {
    const size = readSize(id3Data, offset + 6);
    // skip past ID3 header
    offset += 10;
    const end = offset + size;
    // loop through frames in the ID3 tag
    while (offset + 8 < end) {
      const frameData = getFrameData(id3Data.subarray(offset));
      const frame = decodeFrame(frameData);
      if (frame) {
        frames.push(frame);
      }

      // skip frame header and frame data
      offset += frameData.size + 10;
    }
    if (isFooter(id3Data, offset)) {
      offset += 10;
    }
  }
  return frames;
};
const decodeFrame = frame => {
  if (frame.type === 'PRIV') {
    return decodePrivFrame(frame);
  } else if (frame.type[0] === 'W') {
    return decodeURLFrame(frame);
  }
  return decodeTextFrame(frame);
};
const decodePrivFrame = frame => {
  /*
  Format: <text string>\0<binary data>
  */
  if (frame.size < 2) {
    return undefined;
  }
  const owner = utf8ArrayToStr(frame.data, true);
  const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
  return {
    key: frame.type,
    info: owner,
    data: privateData.buffer
  };
};
const decodeTextFrame = frame => {
  if (frame.size < 2) {
    return undefined;
  }
  if (frame.type === 'TXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */
  const text = utf8ArrayToStr(frame.data.subarray(1));
  return {
    key: frame.type,
    data: text
  };
};
const decodeURLFrame = frame => {
  if (frame.type === 'WXXX') {
    /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */
    if (frame.size < 2) {
      return undefined;
    }
    let index = 1;
    const description = utf8ArrayToStr(frame.data.subarray(index), true);
    index += description.length + 1;
    const value = utf8ArrayToStr(frame.data.subarray(index));
    return {
      key: frame.type,
      info: description,
      data: value
    };
  }
  /*
  Format:
  [0-?] = {URL}
  */
  const url = utf8ArrayToStr(frame.data);
  return {
    key: frame.type,
    data: url
  };
};
const readTimeStamp = timeStampFrame => {
  if (timeStampFrame.data.byteLength === 8) {
    const data = new Uint8Array(timeStampFrame.data);
    // timestamp is 33 bit expressed as a big-endian eight-octet number,
    // with the upper 31 bits set to zero.
    const pts33Bit = data[3] & 0x1;
    let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
    timestamp /= 45;
    if (pts33Bit) {
      timestamp += 47721858.84;
    } // 2^32 / 90

    return Math.round(timestamp);
  }
  return undefined;
};

// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */
const utf8ArrayToStr = (array, exitOnNull = false) => {
  const decoder = getTextDecoder();
  if (decoder) {
    const decoded = decoder.decode(array);
    if (exitOnNull) {
      // grab up to the first null
      const idx = decoded.indexOf('\0');
      return idx !== -1 ? decoded.substring(0, idx) : decoded;
    }

    // remove any null characters
    return decoded.replace(/\0/g, '');
  }
  const len = array.length;
  let c;
  let char2;
  let char3;
  let out = '';
  let i = 0;
  while (i < len) {
    c = array[i++];
    if (c === 0x00 && exitOnNull) {
      return out;
    } else if (c === 0x00 || c === 0x03) {
      // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
      continue;
    }
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
        break;
    }
  }
  return out;
};
let decoder;
function getTextDecoder() {
  // On Play Station 4, TextDecoder is defined but partially implemented.
  // Manual decoding option is preferable
  if (navigator.userAgent.includes('PlayStation 4')) {
    return;
  }
  if (!decoder && typeof self.TextDecoder !== 'undefined') {
    decoder = new self.TextDecoder('utf-8');
  }
  return decoder;
}

/**
 *  hex dump helper class
 */

const Hex = {
  hexDump: function (array) {
    let str = '';
    for (let i = 0; i < array.length; i++) {
      let h = array[i].toString(16);
      if (h.length < 2) {
        h = '0' + h;
      }
      str += h;
    }
    return str;
  }
};

const UINT32_MAX$1 = Math.pow(2, 32) - 1;
const push = [].push;

// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const RemuxerTrackIdConfig = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function bin2str(data) {
  return String.fromCharCode.apply(null, data);
}
function readUint16(buffer, offset) {
  const val = buffer[offset] << 8 | buffer[offset + 1];
  return val < 0 ? 65536 + val : val;
}
function readUint32(buffer, offset) {
  const val = readSint32(buffer, offset);
  return val < 0 ? 4294967296 + val : val;
}
function readUint64(buffer, offset) {
  let result = readUint32(buffer, offset);
  result *= Math.pow(2, 32);
  result += readUint32(buffer, offset + 4);
  return result;
}
function readSint32(buffer, offset) {
  return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function writeUint32(buffer, offset, value) {
  buffer[offset] = value >> 24;
  buffer[offset + 1] = value >> 16 & 0xff;
  buffer[offset + 2] = value >> 8 & 0xff;
  buffer[offset + 3] = value & 0xff;
}

// Find "moof" box
function hasMoofData(data) {
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) {
      return true;
    }
    i = size > 1 ? i + size : end;
  }
  return false;
}

// Find the data for a box specified by its path
function findBox(data, path) {
  const results = [];
  if (!path.length) {
    // short-circuit the search for empty paths
    return results;
  }
  const end = data.byteLength;
  for (let i = 0; i < end;) {
    const size = readUint32(data, i);
    const type = bin2str(data.subarray(i + 4, i + 8));
    const endbox = size > 1 ? i + size : end;
    if (type === path[0]) {
      if (path.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data.subarray(i + 8, endbox));
      } else {
        // recursively search for the next box along the path
        const subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
        if (subresults.length) {
          push.apply(results, subresults);
        }
      }
    }
    i = endbox;
  }

  // we've finished searching all of data
  return results;
}
function parseSegmentIndex(sidx) {
  const references = [];
  const version = sidx[0];

  // set initial offset, we skip the reference ID (not needed)
  let index = 8;
  const timescale = readUint32(sidx, index);
  index += 4;
  let earliestPresentationTime = 0;
  let firstOffset = 0;
  if (version === 0) {
    earliestPresentationTime = readUint32(sidx, index);
    firstOffset = readUint32(sidx, index + 4);
    index += 8;
  } else {
    earliestPresentationTime = readUint64(sidx, index);
    firstOffset = readUint64(sidx, index + 8);
    index += 16;
  }

  // skip reserved
  index += 2;
  let startByte = sidx.length + firstOffset;
  const referencesCount = readUint16(sidx, index);
  index += 2;
  for (let i = 0; i < referencesCount; i++) {
    let referenceIndex = index;
    const referenceInfo = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    const referenceSize = referenceInfo & 0x7fffffff;
    const referenceType = (referenceInfo & 0x80000000) >>> 31;
    if (referenceType === 1) {
      logger.warn('SIDX has hierarchical references (not supported)');
      return null;
    }
    const subsegmentDuration = readUint32(sidx, referenceIndex);
    referenceIndex += 4;
    references.push({
      referenceSize,
      subsegmentDuration,
      // unscaled
      info: {
        duration: subsegmentDuration / timescale,
        start: startByte,
        end: startByte + referenceSize - 1
      }
    });
    startByte += referenceSize;

    // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
    // for |sapDelta|.
    referenceIndex += 4;

    // skip to next ref
    index = referenceIndex;
  }
  return {
    earliestPresentationTime,
    timescale,
    version,
    referencesCount,
    references
  };
}

/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */

function parseInitSegment(initSegment) {
  const result = [];
  const traks = findBox(initSegment, ['moov', 'trak']);
  for (let i = 0; i < traks.length; i++) {
    const trak = traks[i];
    const tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      let version = tkhd[0];
      const trackId = readUint32(tkhd, version === 0 ? 12 : 20);
      const mdhd = findBox(trak, ['mdia', 'mdhd'])[0];
      if (mdhd) {
        version = mdhd[0];
        const timescale = readUint32(mdhd, version === 0 ? 12 : 20);
        const hdlr = findBox(trak, ['mdia', 'hdlr'])[0];
        if (hdlr) {
          const hdlrType = bin2str(hdlr.subarray(8, 12));
          const type = {
            soun: ElementaryStreamTypes.AUDIO,
            vide: ElementaryStreamTypes.VIDEO
          }[hdlrType];
          if (type) {
            // Parse codec details
            const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];
            const stsdData = parseStsd(stsd);
            result[trackId] = {
              timescale,
              type
            };
            result[type] = _objectSpread2({
              timescale,
              id: trackId
            }, stsdData);
          }
        }
      }
    }
  }
  const trex = findBox(initSegment, ['moov', 'mvex', 'trex']);
  trex.forEach(trex => {
    const trackId = readUint32(trex, 4);
    const track = result[trackId];
    if (track) {
      track.default = {
        duration: readUint32(trex, 12),
        flags: readUint32(trex, 20)
      };
    }
  });
  return result;
}
function parseStsd(stsd) {
  const sampleEntries = stsd.subarray(8);
  const sampleEntriesEnd = sampleEntries.subarray(8 + 78);
  const fourCC = bin2str(sampleEntries.subarray(4, 8));
  let codec = fourCC;
  const encrypted = fourCC === 'enca' || fourCC === 'encv';
  if (encrypted) {
    const encBox = findBox(sampleEntries, [fourCC])[0];
    const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
    const sinfs = findBox(encBoxChildren, ['sinf']);
    sinfs.forEach(sinf => {
      const schm = findBox(sinf, ['schm'])[0];
      if (schm) {
        const scheme = bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') {
          const frma = findBox(sinf, ['frma'])[0];
          if (frma) {
            // for encrypted content codec fourCC will be in frma
            codec = bin2str(frma);
          }
        }
      }
    });
  }
  switch (codec) {
    case 'avc1':
    case 'avc2':
    case 'avc3':
    case 'avc4':
      {
        // extract profile + compatibility + level out of avcC box
        const avcCBox = findBox(sampleEntriesEnd, ['avcC'])[0];
        codec += '.' + toHex(avcCBox[1]) + toHex(avcCBox[2]) + toHex(avcCBox[3]);
        break;
      }
    case 'mp4a':
      {
        const codecBox = findBox(sampleEntries, [fourCC])[0];
        const esdsBox = findBox(codecBox.subarray(28), ['esds'])[0];
        if (esdsBox && esdsBox.length > 12) {
          let i = 4;
          // ES Descriptor tag
          if (esdsBox[i++] !== 0x03) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          i += 2; // skip es_id;
          const flags = esdsBox[i++];
          if (flags & 0x80) {
            i += 2; // skip dependency es_id
          }
          if (flags & 0x40) {
            i += esdsBox[i++]; // skip URL
          }
          // Decoder config descriptor
          if (esdsBox[i++] !== 0x04) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const objectType = esdsBox[i++];
          if (objectType === 0x40) {
            codec += '.' + toHex(objectType);
          } else {
            break;
          }
          i += 12;
          // Decoder specific info
          if (esdsBox[i++] !== 0x05) {
            break;
          }
          i = skipBERInteger(esdsBox, i);
          const firstByte = esdsBox[i++];
          let audioObjectType = (firstByte & 0xf8) >> 3;
          if (audioObjectType === 31) {
            audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
          }
          codec += '.' + audioObjectType;
        }
        break;
      }
    case 'hvc1':
    case 'hev1':
      {
        const hvcCBox = findBox(sampleEntriesEnd, ['hvcC'])[0];
        const profileByte = hvcCBox[1];
        const profileSpace = ['', 'A', 'B', 'C'][profileByte >> 6];
        const generalProfileIdc = profileByte & 0x1f;
        const profileCompat = readUint32(hvcCBox, 2);
        const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
        const levelIDC = hvcCBox[12];
        const constraintIndicator = hvcCBox.subarray(6, 12);
        codec += '.' + profileSpace + generalProfileIdc;
        codec += '.' + profileCompat.toString(16).toUpperCase();
        codec += '.' + tierFlag + levelIDC;
        let constraintString = '';
        for (let i = constraintIndicator.length; i--;) {
          const byte = constraintIndicator[i];
          if (byte || constraintString) {
            const encodedByte = byte.toString(16).toUpperCase();
            constraintString = '.' + encodedByte + constraintString;
          }
        }
        codec += constraintString;
        break;
      }
    case 'dvh1':
    case 'dvhe':
      {
        const dvcCBox = findBox(sampleEntriesEnd, ['dvcC'])[0];
        const profile = dvcCBox[2] >> 1 & 0x7f;
        const level = dvcCBox[2] << 5 & 0x20 | dvcCBox[3] >> 3 & 0x1f;
        codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level);
        break;
      }
    case 'vp09':
      {
        const vpcCBox = findBox(sampleEntriesEnd, ['vpcC'])[0];
        const profile = vpcCBox[4];
        const level = vpcCBox[5];
        const bitDepth = vpcCBox[6] >> 4 & 0x0f;
        codec += '.' + addLeadingZero(profile) + '.' + addLeadingZero(level) + '.' + addLeadingZero(bitDepth);
        break;
      }
    case 'av01':
      {
        const av1CBox = findBox(sampleEntriesEnd, ['av1C'])[0];
        const profile = av1CBox[1] >>> 5;
        const level = av1CBox[1] & 0x1f;
        const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
        const highBitDepth = (av1CBox[2] & 0x40) >> 6;
        const twelveBit = (av1CBox[2] & 0x20) >> 5;
        const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
        const monochrome = (av1CBox[2] & 0x10) >> 4;
        const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
        const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
        const chromaSamplePosition = av1CBox[2] & 0x03;
        // TODO: parse color_description_present_flag
        // default it to BT.709/limited range for now
        // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
        const colorPrimaries = 1;
        const transferCharacteristics = 1;
        const matrixCoefficients = 1;
        const videoFullRangeFlag = 0;
        codec += '.' + profile + '.' + addLeadingZero(level) + tierFlag + '.' + addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + addLeadingZero(colorPrimaries) + '.' + addLeadingZero(transferCharacteristics) + '.' + addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
        break;
      }
  }
  return {
    codec,
    encrypted
  };
}
function skipBERInteger(bytes, i) {
  const limit = i + 5;
  while (bytes[i++] & 0x80 && i < limit) {}
  return i;
}
function toHex(x) {
  return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function addLeadingZero(num) {
  return (num < 10 ? '0' : '') + num;
}
function patchEncyptionData(initSegment, decryptdata) {
  if (!initSegment || !decryptdata) {
    return initSegment;
  }
  const keyId = decryptdata.keyId;
  if (keyId && decryptdata.isCommonEncryption) {
    const traks = findBox(initSegment, ['moov', 'trak']);
    traks.forEach(trak => {
      const stsd = findBox(trak, ['mdia', 'minf', 'stbl', 'stsd'])[0];

      // skip the sample entry count
      const sampleEntries = stsd.subarray(8);
      let encBoxes = findBox(sampleEntries, ['enca']);
      const isAudio = encBoxes.length > 0;
      if (!isAudio) {
        encBoxes = findBox(sampleEntries, ['encv']);
      }
      encBoxes.forEach(enc => {
        const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
        const sinfBoxes = findBox(encBoxChildren, ['sinf']);
        sinfBoxes.forEach(sinf => {
          const tenc = parseSinf(sinf);
          if (tenc) {
            // Look for default key id (keyID offset is always 8 within the tenc box):
            const tencKeyId = tenc.subarray(8, 24);
            if (!tencKeyId.some(b => b !== 0)) {
              logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${Hex.hexDump(tencKeyId)} -> ${Hex.hexDump(keyId)}`);
              tenc.set(keyId, 8);
            }
          }
        });
      });
    });
  }
  return initSegment;
}
function parseSinf(sinf) {
  const schm = findBox(sinf, ['schm'])[0];
  if (schm) {
    const scheme = bin2str(schm.subarray(4, 8));
    if (scheme === 'cbcs' || scheme === 'cenc') {
      return findBox(sinf, ['schi', 'tenc'])[0];
    }
  }
  logger.error(`[eme] missing 'schm' box`);
  return null;
}

/**
 * Determine the base media decode start time, in seconds, for an MP4
 * fragment. If multiple fragments are specified, the earliest time is
 * returned.
 *
 * The base media decode time can be parsed from track fragment
 * metadata:
 * ```
 * moof > traf > tfdt.baseMediaDecodeTime
 * ```
 * It requires the timescale value from the mdhd to interpret.
 *
 * @param initData - a hash of track type to timescale values
 * @param fmp4 - the bytes of the mp4 fragment
 * @returns the earliest base media decode start time for the
 * fragment, in seconds
 */
function getStartDTS(initData, fmp4) {
  // we need info from two children of each track fragment box
  return findBox(fmp4, ['moof', 'traf']).reduce((result, traf) => {
    const tfdt = findBox(traf, ['tfdt'])[0];
    const version = tfdt[0];
    const start = findBox(traf, ['tfhd']).reduce((result, tfhd) => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (track) {
        let baseTime = readUint32(tfdt, 4);
        if (version === 1) {
          // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
          // This prevents large values from being used for initPTS, which can cause playlist sync issues.
          // https://github.com/video-dev/hls.js/issues/5303
          if (baseTime === UINT32_MAX$1) {
            logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
            return result;
          }
          baseTime *= UINT32_MAX$1 + 1;
          baseTime += readUint32(tfdt, 8);
        }
        // assume a 90kHz clock if no timescale was specified
        const scale = track.timescale || 90e3;
        // convert base time to seconds
        const startTime = baseTime / scale;
        if (isFiniteNumber(startTime) && (result === null || startTime < result)) {
          return startTime;
        }
      }
      return result;
    }, null);
    if (start !== null && isFiniteNumber(start) && (result === null || start < result)) {
      return start;
    }
    return result;
  }, null);
}

/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */
function getDuration(data, initData) {
  let rawDuration = 0;
  let videoDuration = 0;
  let audioDuration = 0;
  const trafs = findBox(data, ['moof', 'traf']);
  for (let i = 0; i < trafs.length; i++) {
    const traf = trafs[i];
    // There is only one tfhd & trun per traf
    // This is true for CMAF style content, and we should perhaps check the ftyp
    // and only look for a single trun then, but for ISOBMFF we should check
    // for multiple track runs.
    const tfhd = findBox(traf, ['tfhd'])[0];
    // get the track id from the tfhd
    const id = readUint32(tfhd, 4);
    const track = initData[id];
    if (!track) {
      continue;
    }
    const trackDefault = track.default;
    const tfhdFlags = readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
    let sampleDuration = trackDefault == null ? void 0 : trackDefault.duration;
    if (tfhdFlags & 0x000008) {
      // 0x000008 indicates the presence of the default_sample_duration field
      if (tfhdFlags & 0x000002) {
        // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
        // If present, the default_sample_duration exists at byte offset 12
        sampleDuration = readUint32(tfhd, 12);
      } else {
        // Otherwise, the duration is at byte offset 8
        sampleDuration = readUint32(tfhd, 8);
      }
    }
    // assume a 90kHz clock if no timescale was specified
    const timescale = track.timescale || 90e3;
    const truns = findBox(traf, ['trun']);
    for (let j = 0; j < truns.length; j++) {
      rawDuration = computeRawDurationFromSamples(truns[j]);
      if (!rawDuration && sampleDuration) {
        const sampleCount = readUint32(truns[j], 4);
        rawDuration = sampleDuration * sampleCount;
      }
      if (track.type === ElementaryStreamTypes.VIDEO) {
        videoDuration += rawDuration / timescale;
      } else if (track.type === ElementaryStreamTypes.AUDIO) {
        audioDuration += rawDuration / timescale;
      }
    }
  }
  if (videoDuration === 0 && audioDuration === 0) {
    // If duration samples are not available in the traf use sidx subsegment_duration
    let sidxMinStart = Infinity;
    let sidxMaxEnd = 0;
    let sidxDuration = 0;
    const sidxs = findBox(data, ['sidx']);
    for (let i = 0; i < sidxs.length; i++) {
      const sidx = parseSegmentIndex(sidxs[i]);
      if (sidx != null && sidx.references) {
        sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
        const subSegmentDuration = sidx.references.reduce((dur, ref) => dur + ref.info.duration || 0, 0);
        sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
        sidxDuration = sidxMaxEnd - sidxMinStart;
      }
    }
    if (sidxDuration && isFiniteNumber(sidxDuration)) {
      return sidxDuration;
    }
  }
  if (videoDuration) {
    return videoDuration;
  }
  return audioDuration;
}

/*
  For Reference:
  aligned(8) class TrackRunBox
           extends FullBox(‘trun’, version, tr_flags) {
     unsigned int(32)  sample_count;
     // the following are optional fields
     signed int(32) data_offset;
     unsigned int(32)  first_sample_flags;
     // all fields in the following array are optional
     {
        unsigned int(32)  sample_duration;
        unsigned int(32)  sample_size;
        unsigned int(32)  sample_flags
        if (version == 0)
           { unsigned int(32)
        else
           { signed int(32)
     }[ sample_count ]
  }
 */
function computeRawDurationFromSamples(trun) {
  const flags = readUint32(trun, 0);
  // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
  // Each field is an int32, which is 4 bytes
  let offset = 8;
  // data-offset-present flag
  if (flags & 0x000001) {
    offset += 4;
  }
  // first-sample-flags-present flag
  if (flags & 0x000004) {
    offset += 4;
  }
  let duration = 0;
  const sampleCount = readUint32(trun, 4);
  for (let i = 0; i < sampleCount; i++) {
    // sample-duration-present flag
    if (flags & 0x000100) {
      const sampleDuration = readUint32(trun, offset);
      duration += sampleDuration;
      offset += 4;
    }
    // sample-size-present flag
    if (flags & 0x000200) {
      offset += 4;
    }
    // sample-flags-present flag
    if (flags & 0x000400) {
      offset += 4;
    }
    // sample-composition-time-offsets-present flag
    if (flags & 0x000800) {
      offset += 4;
    }
  }
  return duration;
}
function offsetStartDTS(initData, fmp4, timeOffset) {
  findBox(fmp4, ['moof', 'traf']).forEach(traf => {
    findBox(traf, ['tfhd']).forEach(tfhd => {
      // get the track id from the tfhd
      const id = readUint32(tfhd, 4);
      const track = initData[id];
      if (!track) {
        return;
      }
      // assume a 90kHz clock if no timescale was specified
      const timescale = track.timescale || 90e3;
      // get the base media decode time from the tfdt
      findBox(traf, ['tfdt']).forEach(tfdt => {
        const version = tfdt[0];
        const offset = timeOffset * timescale;
        if (offset) {
          let baseMediaDecodeTime = readUint32(tfdt, 4);
          if (version === 0) {
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            writeUint32(tfdt, 4, baseMediaDecodeTime);
          } else {
            baseMediaDecodeTime *= Math.pow(2, 32);
            baseMediaDecodeTime += readUint32(tfdt, 8);
            baseMediaDecodeTime -= offset;
            baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
            const upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX$1 + 1));
            const lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX$1 + 1));
            writeUint32(tfdt, 4, upper);
            writeUint32(tfdt, 8, lower);
          }
        }
      });
    });
  });
}

// TODO: Check if the last moof+mdat pair is part of the valid range
function segmentValidRange(data) {
  const segmentedRange = {
    valid: null,
    remainder: null
  };
  const moofs = findBox(data, ['moof']);
  if (moofs.length < 2) {
    segmentedRange.remainder = data;
    return segmentedRange;
  }
  const last = moofs[moofs.length - 1];
  // Offset by 8 bytes; findBox offsets the start by as much
  segmentedRange.valid = sliceUint8(data, 0, last.byteOffset - 8);
  segmentedRange.remainder = sliceUint8(data, last.byteOffset - 8);
  return segmentedRange;
}
function appendUint8Array(data1, data2) {
  const temp = new Uint8Array(data1.length + data2.length);
  temp.set(data1);
  temp.set(data2, data1.length);
  return temp;
}
function parseSamples(timeOffset, track) {
  const seiSamples = [];
  const videoData = track.samples;
  const timescale = track.timescale;
  const trackId = track.id;
  let isHEVCFlavor = false;
  const moofs = findBox(videoData, ['moof']);
  moofs.map(moof => {
    const moofOffset = moof.byteOffset - 8;
    const trafs = findBox(moof, ['traf']);
    trafs.map(traf => {
      // get the base media decode time from the tfdt
      const baseTime = findBox(traf, ['tfdt']).map(tfdt => {
        const version = tfdt[0];
        let result = readUint32(tfdt, 4);
        if (version === 1) {
          result *= Math.pow(2, 32);
          result += readUint32(tfdt, 8);
        }
        return result / timescale;
      })[0];
      if (baseTime !== undefined) {
        timeOffset = baseTime;
      }
      return findBox(traf, ['tfhd']).map(tfhd => {
        const id = readUint32(tfhd, 4);
        const tfhdFlags = readUint32(tfhd, 0) & 0xffffff;
        const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
        const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
        const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
        let defaultSampleDuration = 0;
        const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
        let defaultSampleSize = 0;
        const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
        let tfhdOffset = 8;
        if (id === trackId) {
          if (baseDataOffsetPresent) {
            tfhdOffset += 8;
          }
          if (sampleDescriptionIndexPresent) {
            tfhdOffset += 4;
          }
          if (defaultSampleDurationPresent) {
            defaultSampleDuration = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleSizePresent) {
            defaultSampleSize = readUint32(tfhd, tfhdOffset);
            tfhdOffset += 4;
          }
          if (defaultSampleFlagsPresent) {
            tfhdOffset += 4;
          }
          if (track.type === 'video') {
            isHEVCFlavor = isHEVC(track.codec);
          }
          findBox(traf, ['trun']).map(trun => {
            const version = trun[0];
            const flags = readUint32(trun, 0) & 0xffffff;
            const dataOffsetPresent = (flags & 0x000001) !== 0;
            let dataOffset = 0;
            const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
            const sampleDurationPresent = (flags & 0x000100) !== 0;
            let sampleDuration = 0;
            const sampleSizePresent = (flags & 0x000200) !== 0;
            let sampleSize = 0;
            const sampleFlagsPresent = (flags & 0x000400) !== 0;
            const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
            let compositionOffset = 0;
            const sampleCount = readUint32(trun, 4);
            let trunOffset = 8; // past version, flags, and sample count

            if (dataOffsetPresent) {
              dataOffset = readUint32(trun, trunOffset);
              trunOffset += 4;
            }
            if (firstSampleFlagsPresent) {
              trunOffset += 4;
            }
            let sampleOffset = dataOffset + moofOffset;
            for (let ix = 0; ix < sampleCount; ix++) {
              if (sampleDurationPresent) {
                sampleDuration = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleDuration = defaultSampleDuration;
              }
              if (sampleSizePresent) {
                sampleSize = readUint32(trun, trunOffset);
                trunOffset += 4;
              } else {
                sampleSize = defaultSampleSize;
              }
              if (sampleFlagsPresent) {
                trunOffset += 4;
              }
              if (sampleCompositionOffsetsPresent) {
                if (version === 0) {
                  compositionOffset = readUint32(trun, trunOffset);
                } else {
                  compositionOffset = readSint32(trun, trunOffset);
                }
                trunOffset += 4;
              }
              if (track.type === ElementaryStreamTypes.VIDEO) {
                let naluTotalSize = 0;
                while (naluTotalSize < sampleSize) {
                  const naluSize = readUint32(videoData, sampleOffset);
                  sampleOffset += 4;
                  if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                    const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                    parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                  }
                  sampleOffset += naluSize;
                  naluTotalSize += naluSize + 4;
                }
              }
              timeOffset += sampleDuration / timescale;
            }
          });
        }
      });
    });
  });
  return seiSamples;
}
function isHEVC(codec) {
  if (!codec) {
    return false;
  }
  const delimit = codec.indexOf('.');
  const baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
  return baseCodec === 'hvc1' || baseCodec === 'hev1' ||
  // Dolby Vision
  baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function isSEIMessage(isHEVCFlavor, naluHeader) {
  if (isHEVCFlavor) {
    const naluType = naluHeader >> 1 & 0x3f;
    return naluType === 39 || naluType === 40;
  } else {
    const naluType = naluHeader & 0x1f;
    return naluType === 6;
  }
}
function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
  const data = discardEPB(unescapedData);
  let seiPtr = 0;
  // skip nal header
  seiPtr += headerSize;
  let payloadType = 0;
  let payloadSize = 0;
  let b = 0;
  while (seiPtr < data.length) {
    payloadType = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadType += b;
    } while (b === 0xff);

    // Parse payload size.
    payloadSize = 0;
    do {
      if (seiPtr >= data.length) {
        break;
      }
      b = data[seiPtr++];
      payloadSize += b;
    } while (b === 0xff);
    const leftOver = data.length - seiPtr;
    // Create a variable to process the payload
    let payPtr = seiPtr;

    // Increment the seiPtr to the end of the payload
    if (payloadSize < leftOver) {
      seiPtr += payloadSize;
    } else if (payloadSize > leftOver) {
      // Some type of corruption has happened?
      logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
      // We might be able to parse some data, but let's be safe and ignore it.
      break;
    }
    if (payloadType === 4) {
      const countryCode = data[payPtr++];
      if (countryCode === 181) {
        const providerCode = readUint16(data, payPtr);
        payPtr += 2;
        if (providerCode === 49) {
          const userStructure = readUint32(data, payPtr);
          payPtr += 4;
          if (userStructure === 0x47413934) {
            const userDataType = data[payPtr++];

            // Raw CEA-608 bytes wrapped in CEA-708 packet
            if (userDataType === 3) {
              const firstByte = data[payPtr++];
              const totalCCs = 0x1f & firstByte;
              const enabled = 0x40 & firstByte;
              const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
              const byteArray = new Uint8Array(totalBytes);
              if (enabled) {
                byteArray[0] = firstByte;
                for (let i = 1; i < totalBytes; i++) {
                  byteArray[i] = data[payPtr++];
                }
              }
              samples.push({
                type: userDataType,
                payloadType,
                pts,
                bytes: byteArray
              });
            }
          }
        }
      }
    } else if (payloadType === 5) {
      if (payloadSize > 16) {
        const uuidStrArray = [];
        for (let i = 0; i < 16; i++) {
          const _b = data[payPtr++].toString(16);
          uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
          if (i === 3 || i === 5 || i === 7 || i === 9) {
            uuidStrArray.push('-');
          }
        }
        const length = payloadSize - 16;
        const userDataBytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
          userDataBytes[i] = data[payPtr++];
        }
        samples.push({
          payloadType,
          pts,
          uuid: uuidStrArray.join(''),
          userData: utf8ArrayToStr(userDataBytes),
          userDataBytes
        });
      }
    }
  }
}

/**
 * remove Emulation Prevention bytes from a RBSP
 */
function discardEPB(data) {
  const length = data.byteLength;
  const EPBPositions = [];
  let i = 1;

  // Find all `Emulation Prevention Bytes`
  while (i < length - 2) {
    if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
      EPBPositions.push(i + 2);
      i += 2;
    } else {
      i++;
    }
  }

  // If no Emulation Prevention Bytes were found just return the original
  // array
  if (EPBPositions.length === 0) {
    return data;
  }

  // Create a new array to hold the NAL unit data
  const newLength = length - EPBPositions.length;
  const newData = new Uint8Array(newLength);
  let sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === EPBPositions[0]) {
      // Skip this byte
      sourceIndex++;
      // Remove this position index
      EPBPositions.shift();
    }
    newData[i] = data[sourceIndex];
  }
  return newData;
}
function parseEmsg(data) {
  const version = data[0];
  let schemeIdUri = '';
  let value = '';
  let timeScale = 0;
  let presentationTimeDelta = 0;
  let presentationTime = 0;
  let eventDuration = 0;
  let id = 0;
  let offset = 0;
  if (version === 0) {
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    timeScale = readUint32(data, 12);
    presentationTimeDelta = readUint32(data, 16);
    eventDuration = readUint32(data, 20);
    id = readUint32(data, 24);
    offset = 28;
  } else if (version === 1) {
    offset += 4;
    timeScale = readUint32(data, offset);
    offset += 4;
    const leftPresentationTime = readUint32(data, offset);
    offset += 4;
    const rightPresentationTime = readUint32(data, offset);
    offset += 4;
    presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
    if (!isSafeInteger(presentationTime)) {
      presentationTime = Number.MAX_SAFE_INTEGER;
      logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
    }
    eventDuration = readUint32(data, offset);
    offset += 4;
    id = readUint32(data, offset);
    offset += 4;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      schemeIdUri += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
    while (bin2str(data.subarray(offset, offset + 1)) !== '\0') {
      value += bin2str(data.subarray(offset, offset + 1));
      offset += 1;
    }
    value += bin2str(data.subarray(offset, offset + 1));
    offset += 1;
  }
  const payload = data.subarray(offset, data.byteLength);
  return {
    schemeIdUri,
    value,
    timeScale,
    presentationTime,
    presentationTimeDelta,
    eventDuration,
    id,
    payload
  };
}
function mp4Box(type, ...payload) {
  const len = payload.length;
  let size = 8;
  let i = len;
  while (i--) {
    size += payload[i].byteLength;
  }
  const result = new Uint8Array(size);
  result[0] = size >> 24 & 0xff;
  result[1] = size >> 16 & 0xff;
  result[2] = size >> 8 & 0xff;
  result[3] = size & 0xff;
  result.set(type, 4);
  for (i = 0, size = 8; i < len; i++) {
    result.set(payload[i], size);
    size += payload[i].byteLength;
  }
  return result;
}
function mp4pssh(systemId, keyids, data) {
  if (systemId.byteLength !== 16) {
    throw new RangeError('Invalid system id');
  }
  let version;
  let kids;
  if (keyids) {
    version = 1;
    kids = new Uint8Array(keyids.length * 16);
    for (let ix = 0; ix < keyids.length; ix++) {
      const k = keyids[ix]; // uint8array
      if (k.byteLength !== 16) {
        throw new RangeError('Invalid key');
      }
      kids.set(k, ix * 16);
    }
  } else {
    version = 0;
    kids = new Uint8Array();
  }
  let kidCount;
  if (version > 0) {
    kidCount = new Uint8Array(4);
    if (keyids.length > 0) {
      new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    }
  } else {
    kidCount = new Uint8Array();
  }
  const dataSize = new Uint8Array(4);
  if (data && data.byteLength > 0) {
    new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
  }
  return mp4Box([112, 115, 115, 104], new Uint8Array([version, 0x00, 0x00, 0x00 // Flags
  ]), systemId,
  // 16 bytes
  kidCount, kids, dataSize, data || new Uint8Array());
}
function parsePssh(initData) {
  if (!(initData instanceof ArrayBuffer) || initData.byteLength < 32) {
    return null;
  }
  const result = {
    version: 0,
    systemId: '',
    kids: null,
    data: null
  };
  const view = new DataView(initData);
  const boxSize = view.getUint32(0);
  if (initData.byteLength !== boxSize && boxSize > 44) {
    return null;
  }
  const type = view.getUint32(4);
  if (type !== 0x70737368) {
    return null;
  }
  result.version = view.getUint32(8) >>> 24;
  if (result.version > 1) {
    return null;
  }
  result.systemId = Hex.hexDump(new Uint8Array(initData, 12, 16));
  const dataSizeOrKidCount = view.getUint32(28);
  if (result.version === 0) {
    if (boxSize - 32 < dataSizeOrKidCount) {
      return null;
    }
    result.data = new Uint8Array(initData, 32, dataSizeOrKidCount);
  } else if (result.version === 1) {
    result.kids = [];
    for (let i = 0; i < dataSizeOrKidCount; i++) {
      result.kids.push(new Uint8Array(initData, 32 + i * 16, 16));
    }
  }
  return result;
}

let keyUriToKeyIdMap = {};
class LevelKey {
  static clearKeyUriToKeyIdMap() {
    keyUriToKeyIdMap = {};
  }
  constructor(method, uri, format, formatversions = [1], iv = null) {
    this.uri = void 0;
    this.method = void 0;
    this.keyFormat = void 0;
    this.keyFormatVersions = void 0;
    this.encrypted = void 0;
    this.isCommonEncryption = void 0;
    this.iv = null;
    this.key = null;
    this.keyId = null;
    this.pssh = null;
    this.method = method;
    this.uri = uri;
    this.keyFormat = format;
    this.keyFormatVersions = formatversions;
    this.iv = iv;
    this.encrypted = method ? method !== 'NONE' : false;
    this.isCommonEncryption = this.encrypted && method !== 'AES-128';
  }
  isSupported() {
    // If it's Segment encryption or No encryption, just select that key system
    if (this.method) {
      if (this.method === 'AES-128' || this.method === 'NONE') {
        return true;
      }
      if (this.keyFormat === 'identity') {
        // Maintain support for clear SAMPLE-AES with MPEG-3 TS
        return this.method === 'SAMPLE-AES';
      } else {
        switch (this.keyFormat) {
          case KeySystemFormats.FAIRPLAY:
          case KeySystemFormats.WIDEVINE:
          case KeySystemFormats.PLAYREADY:
          case KeySystemFormats.CLEARKEY:
            return ['ISO-23001-7', 'SAMPLE-AES', 'SAMPLE-AES-CENC', 'SAMPLE-AES-CTR'].indexOf(this.method) !== -1;
        }
      }
    }
    return false;
  }
  getDecryptData(sn) {
    if (!this.encrypted || !this.uri) {
      return null;
    }
    if (this.method === 'AES-128' && this.uri && !this.iv) {
      if (typeof sn !== 'number') {
        // We are fetching decryption data for a initialization segment
        // If the segment was encrypted with AES-128
        // It must have an IV defined. We cannot substitute the Segment Number in.
        if (this.method === 'AES-128' && !this.iv) {
          logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
        }
        // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
        sn = 0;
      }
      const iv = createInitializationVector(sn);
      const decryptdata = new LevelKey(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
      return decryptdata;
    }

    // Initialize keyId if possible
    const keyBytes = convertDataUriToArrayBytes(this.uri);
    if (keyBytes) {
      switch (this.keyFormat) {
        case KeySystemFormats.WIDEVINE:
          this.pssh = keyBytes;
          // In case of widevine keyID is embedded in PSSH box. Read Key ID.
          if (keyBytes.length >= 22) {
            this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
          }
          break;
        case KeySystemFormats.PLAYREADY:
          {
            const PlayReadyKeySystemUUID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);
            this.pssh = mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
            const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
            const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));

            // Parse Playready WRMHeader XML
            const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
            const keyData = xmlDoc.getElementsByTagName('KID')[0];
            if (keyData) {
              const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
              if (keyId) {
                const keyIdArray = base64Decode(keyId).subarray(0, 16);
                // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
                // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
                changeEndianness(keyIdArray);
                this.keyId = keyIdArray;
              }
            }
            break;
          }
        default:
          {
            let keydata = keyBytes.subarray(0, 16);
            if (keydata.length !== 16) {
              const padded = new Uint8Array(16);
              padded.set(keydata, 16 - keydata.length);
              keydata = padded;
            }
            this.keyId = keydata;
            break;
          }
      }
    }

    // Default behavior: assign a new keyId for each uri
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let keyId = keyUriToKeyIdMap[this.uri];
      if (!keyId) {
        const val = Object.keys(keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        keyId = new Uint8Array(16);
        const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
        dv.setUint32(0, val);
        keyUriToKeyIdMap[this.uri] = keyId;
      }
      this.keyId = keyId;
    }
    return this;
  }
}
function createInitializationVector(segmentNumber) {
  const uint8View = new Uint8Array(16);
  for (let i = 12; i < 16; i++) {
    uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
  }
  return uint8View;
}

const VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function hasVariableReferences(str) {
  return VARIABLE_REPLACEMENT_REGEX.test(str);
}
function substituteVariablesInAttributes(parsed, attr, attributeNames) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    for (let i = attributeNames.length; i--;) {
      const name = attributeNames[i];
      const value = attr[name];
      if (value) {
        attr[name] = substituteVariables(parsed, value);
      }
    }
  }
}
function substituteVariables(parsed, value) {
  if (parsed.variableList !== null || parsed.hasVariableRefs) {
    const variableList = parsed.variableList;
    return value.replace(VARIABLE_REPLACEMENT_REGEX, variableReference => {
      const variableName = variableReference.substring(2, variableReference.length - 1);
      const variableValue = variableList == null ? void 0 : variableList[variableName];
      if (variableValue === undefined) {
        parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
        return variableReference;
      }
      return variableValue;
    });
  }
  return value;
}
function addVariableDefinition(parsed, attr, parentUrl) {
  let variableList = parsed.variableList;
  if (!variableList) {
    parsed.variableList = variableList = {};
  }
  let NAME;
  let VALUE;
  if ('QUERYPARAM' in attr) {
    NAME = attr.QUERYPARAM;
    try {
      const searchParams = new self.URL(parentUrl).searchParams;
      if (searchParams.has(NAME)) {
        VALUE = searchParams.get(NAME);
      } else {
        throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
      }
    } catch (error) {
      parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
    }
  } else {
    NAME = attr.NAME;
    VALUE = attr.VALUE;
  }
  if (NAME in variableList) {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
  } else {
    variableList[NAME] = VALUE || '';
  }
}
function importVariableDefinition(parsed, attr, sourceVariableList) {
  const IMPORT = attr.IMPORT;
  if (sourceVariableList && IMPORT in sourceVariableList) {
    let variableList = parsed.variableList;
    if (!variableList) {
      parsed.variableList = variableList = {};
    }
    variableList[IMPORT] = sourceVariableList[IMPORT];
  } else {
    parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
  }
}

/**
 * MediaSource helper
 */

function getMediaSource(preferManagedMediaSource = true) {
  if (typeof self === 'undefined') return undefined;
  const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
  return mms || self.MediaSource || self.WebKitMediaSource;
}
function isManagedMediaSource(source) {
  return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}

// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const sampleEntryCodesISO = {
  audio: {
    a3ds: 1,
    'ac-3': 0.95,
    'ac-4': 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    'dts+': 1,
    'dts-': 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    'ec-3': 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    'raw ': 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    'vc-1': 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function isCodecType(codec, type) {
  const typeCodes = sampleEntryCodesISO[type];
  return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
  return !codecs.split(',').some(codec => !isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
  var _MediaSource$isTypeSu;
  const MediaSource = getMediaSource(preferManagedMediaSource);
  return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported(mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function mimeTypeForCodec(codec, type) {
  return `${type}/mp4;codecs="${codec}"`;
}
function videoCodecPreferenceValue(videoCodec) {
  if (videoCodec) {
    const fourCC = videoCodec.substring(0, 4);
    return sampleEntryCodesISO.video[fourCC];
  }
  return 2;
}
function codecsSetSelectionPreferenceValue(codecSet) {
  return codecSet.split(',').reduce((num, fourCC) => {
    const preferenceValue = sampleEntryCodesISO.video[fourCC];
    if (preferenceValue) {
      return (preferenceValue * 2 + num) / (num ? 3 : 2);
    }
    return (sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
  }, 0);
}
const CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
  if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) {
    return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
  }

  // Idealy fLaC and Opus would be first (spec-compliant) but
  // some browsers will report that fLaC is supported then fail.
  // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
  const codecsToCheck = {
    flac: ['flac', 'fLaC', 'FLAC'],
    opus: ['opus', 'Opus']
  }[lowerCaseCodec];
  for (let i = 0; i < codecsToCheck.length; i++) {
    if (isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
      CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
      return codecsToCheck[i];
    }
  }
  return lowerCaseCodec;
}
const AUDIO_CODEC_REGEXP = /flac|opus/i;
function getCodecCompatibleName(codec, preferManagedMediaSource = true) {
  return codec.replace(AUDIO_CODEC_REGEXP, m => getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function pickMostCompleteCodecName(parsedCodec, levelCodec) {
  // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
  // so use level codec is parsed codec is unavailable or incomplete
  if (parsedCodec && parsedCodec !== 'mp4a') {
    return parsedCodec;
  }
  return levelCodec ? levelCodec.split(',')[0] : levelCodec;
}
function convertAVC1ToAVCOTI(codec) {
  // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
  // Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
  const codecs = codec.split(',');
  for (let i = 0; i < codecs.length; i++) {
    const avcdata = codecs[i].split('.');
    if (avcdata.length > 2) {
      let result = avcdata.shift() + '.';
      result += parseInt(avcdata.shift()).toString(16);
      result += ('000' + parseInt(avcdata.shift()).toString(16)).slice(-4);
      codecs[i] = result;
    }
  }
  return codecs.join(',');
}

const MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)

const LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
// duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/(?!#) *(\S[^\r\n]*)/.source,
// segment URI, group 3 => the URI (note newline is not eaten)
/#EXT-X-BYTERANGE:*(.+)/.source,
// next segment's byterange, group 4 => range spec (x@y)
/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
// next segment's program date/time group 5 => the datetime spec
/#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join('|'));
class M3U8Parser {
  static findGroup(groups, mediaGroupId) {
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (group.id === mediaGroupId) {
        return group;
      }
    }
  }
  static resolve(url, baseUrl) {
    return urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
      alwaysNormalize: true
    });
  }
  static isMediaPlaylist(str) {
    return IS_MEDIA_PLAYLIST.test(str);
  }
  static parseMasterPlaylist(string, baseurl) {
    const hasVariableRefs = hasVariableReferences(string) ;
    const parsed = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs
    };
    const levelsWithKnownCodecs = [];
    MASTER_PLAYLIST_REGEX.lastIndex = 0;
    let result;
    while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
      if (result[1]) {
        var _level$unknownCodecs;
        // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
        const attrs = new AttrList(result[1]);
        {
          substituteVariablesInAttributes(parsed, attrs, ['CODECS', 'SUPPLEMENTAL-CODECS', 'ALLOWED-CPC', 'PATHWAY-ID', 'STABLE-VARIANT-ID', 'AUDIO', 'VIDEO', 'SUBTITLES', 'CLOSED-CAPTIONS', 'NAME']);
        }
        const uri = substituteVariables(parsed, result[2]) ;
        const level = {
          attrs,
          bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
          name: attrs.NAME,
          url: M3U8Parser.resolve(uri, baseurl)
        };
        const resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        setCodecs(attrs.CODECS, level);
        if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) {
          levelsWithKnownCodecs.push(level);
        }
        parsed.levels.push(level);
      } else if (result[3]) {
        const tag = result[3];
        const attributes = result[4];
        switch (tag) {
          case 'SESSION-DATA':
            {
              // #EXT-X-SESSION-DATA
              const sessionAttrs = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, sessionAttrs, ['DATA-ID', 'LANGUAGE', 'VALUE', 'URI']);
              }
              const dataId = sessionAttrs['DATA-ID'];
              if (dataId) {
                if (parsed.sessionData === null) {
                  parsed.sessionData = {};
                }
                parsed.sessionData[dataId] = sessionAttrs;
              }
              break;
            }
          case 'SESSION-KEY':
            {
              // #EXT-X-SESSION-KEY
              const sessionKey = parseKey(attributes, baseurl, parsed);
              if (sessionKey.encrypted && sessionKey.isSupported()) {
                if (parsed.sessionKeys === null) {
                  parsed.sessionKeys = [];
                }
                parsed.sessionKeys.push(sessionKey);
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
              }
              break;
            }
          case 'DEFINE':
            {
              // #EXT-X-DEFINE
              {
                const variableAttributes = new AttrList(attributes);
                substituteVariablesInAttributes(parsed, variableAttributes, ['NAME', 'VALUE', 'QUERYPARAM']);
                addVariableDefinition(parsed, variableAttributes, baseurl);
              }
              break;
            }
          case 'CONTENT-STEERING':
            {
              // #EXT-X-CONTENT-STEERING
              const contentSteeringAttributes = new AttrList(attributes);
              {
                substituteVariablesInAttributes(parsed, contentSteeringAttributes, ['SERVER-URI', 'PATHWAY-ID']);
              }
              parsed.contentSteering = {
                uri: M3U8Parser.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
              };
              break;
            }
          case 'START':
            {
              // #EXT-X-START
              parsed.startTimeOffset = parseStartTimeOffset(attributes);
              break;
            }
        }
      }
    }
    // Filter out levels with unknown codecs if it does not remove all levels
    const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
    parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
    if (parsed.levels.length === 0) {
      parsed.playlistParsingError = new Error('no levels found in manifest');
    }
    return parsed;
  }
  static parseMasterPlaylistMedia(string, baseurl, parsed) {
    let result;
    const results = {};
    const levels = parsed.levels;
    const groupsByType = {
      AUDIO: levels.map(level => ({
        id: level.attrs.AUDIO,
        audioCodec: level.audioCodec
      })),
      SUBTITLES: levels.map(level => ({
        id: level.attrs.SUBTITLES,
        textCodec: level.textCodec
      })),
      'CLOSED-CAPTIONS': []
    };
    let id = 0;
    MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
    while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
      const attrs = new AttrList(result[1]);
      const type = attrs.TYPE;
      if (type) {
        const groups = groupsByType[type];
        const medias = results[type] || [];
        results[type] = medias;
        {
          substituteVariablesInAttributes(parsed, attrs, ['URI', 'GROUP-ID', 'LANGUAGE', 'ASSOC-LANGUAGE', 'STABLE-RENDITION-ID', 'NAME', 'INSTREAM-ID', 'CHARACTERISTICS', 'CHANNELS']);
        }
        const lang = attrs.LANGUAGE;
        const assocLang = attrs['ASSOC-LANGUAGE'];
        const channels = attrs.CHANNELS;
        const characteristics = attrs.CHARACTERISTICS;
        const instreamId = attrs['INSTREAM-ID'];
        const media = {
          attrs,
          bitrate: 0,
          id: id++,
          groupId: attrs['GROUP-ID'] || '',
          name: attrs.NAME || lang || '',
          type,
          default: attrs.bool('DEFAULT'),
          autoselect: attrs.bool('AUTOSELECT'),
          forced: attrs.bool('FORCED'),
          lang,
          url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ''
        };
        if (assocLang) {
          media.assocLang = assocLang;
        }
        if (channels) {
          media.channels = channels;
        }
        if (characteristics) {
          media.characteristics = characteristics;
        }
        if (instreamId) {
          media.instreamId = instreamId;
        }
        if (groups != null && groups.length) {
          // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
          // If we don't find the track signalled, lets use the first audio groups codec we have
          // Acting as a best guess
          const groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
          assignCodec(media, groupCodec, 'audioCodec');
          assignCodec(media, groupCodec, 'textCodec');
        }
        medias.push(media);
      }
    }
    return results;
  }
  static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
    const level = new LevelDetails(baseurl);
    const fragments = level.fragments;
    // The most recent init segment seen (applies to all subsequent segments)
    let currentInitSegment = null;
    let currentSN = 0;
    let currentPart = 0;
    let totalduration = 0;
    let discontinuityCounter = 0;
    let prevFrag = null;
    let frag = new Fragment(type, baseurl);
    let result;
    let i;
    let levelkeys;
    let firstPdtIndex = -1;
    let createNextFrag = false;
    let nextByteRange = null;
    LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
    level.m3u8 = string;
    level.hasVariableRefs = hasVariableReferences(string) ;
    while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
      if (createNextFrag) {
        createNextFrag = false;
        frag = new Fragment(type, baseurl);
        // setup the next fragment for part loading
        frag.start = totalduration;
        frag.sn = currentSN;
        frag.cc = discontinuityCounter;
        frag.level = id;
        if (currentInitSegment) {
          frag.initSegment = currentInitSegment;
          frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
          currentInitSegment.rawProgramDateTime = null;
          if (nextByteRange) {
            frag.setByteRange(nextByteRange);
            nextByteRange = null;
          }
        }
      }
      const duration = result[1];
      if (duration) {
        // INF
        frag.duration = parseFloat(duration);
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const title = (' ' + result[2]).slice(1);
        frag.title = title || null;
        frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
      } else if (result[3]) {
        // url
        if (isFiniteNumber(frag.duration)) {
          frag.start = totalduration;
          if (levelkeys) {
            setFragLevelKeys(frag, levelkeys, level);
          }
          frag.sn = currentSN;
          frag.level = id;
          frag.cc = discontinuityCounter;
          fragments.push(frag);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          const uri = (' ' + result[3]).slice(1);
          frag.relurl = substituteVariables(level, uri) ;
          assignProgramDateTime(frag, prevFrag);
          prevFrag = frag;
          totalduration += frag.duration;
          currentSN++;
          currentPart = 0;
          createNextFrag = true;
        }
      } else if (result[4]) {
        // X-BYTERANGE
        const data = (' ' + result[4]).slice(1);
        if (prevFrag) {
          frag.setByteRange(data, prevFrag);
        } else {
          frag.setByteRange(data);
        }
      } else if (result[5]) {
        // PROGRAM-DATE-TIME
        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        frag.rawProgramDateTime = (' ' + result[5]).slice(1);
        frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
        if (firstPdtIndex === -1) {
          firstPdtIndex = fragments.length;
        }
      } else {
        result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
        if (!result) {
          logger.warn('No matches on slow regex match for level playlist!');
          continue;
        }
        for (i = 1; i < result.length; i++) {
          if (typeof result[i] !== 'undefined') {
            break;
          }
        }

        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
        const tag = (' ' + result[i]).slice(1);
        const value1 = (' ' + result[i + 1]).slice(1);
        const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : '';
        switch (tag) {
          case 'PLAYLIST-TYPE':
            level.type = value1.toUpperCase();
            break;
          case 'MEDIA-SEQUENCE':
            currentSN = level.startSN = parseInt(value1);
            break;
          case 'SKIP':
            {
              const skipAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, skipAttrs, ['RECENTLY-REMOVED-DATERANGES']);
              }
              const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
              if (isFiniteNumber(skippedSegments)) {
                level.skippedSegments = skippedSegments;
                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                for (let _i = skippedSegments; _i--;) {
                  fragments.unshift(null);
                }
                currentSN += skippedSegments;
              }
              const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
              if (recentlyRemovedDateranges) {
                level.recentlyRemovedDateranges = recentlyRemovedDateranges.split('\t');
              }
              break;
            }
          case 'TARGETDURATION':
            level.targetduration = Math.max(parseInt(value1), 1);
            break;
          case 'VERSION':
            level.version = parseInt(value1);
            break;
          case 'INDEPENDENT-SEGMENTS':
          case 'EXTM3U':
            break;
          case 'ENDLIST':
            level.live = false;
            break;
          case '#':
            if (value1 || value2) {
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
            }
            break;
          case 'DISCONTINUITY':
            discontinuityCounter++;
            frag.tagList.push(['DIS']);
            break;
          case 'GAP':
            frag.gap = true;
            frag.tagList.push([tag]);
            break;
          case 'BITRATE':
            frag.tagList.push([tag, value1]);
            break;
          case 'DATERANGE':
            {
              const dateRangeAttr = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, dateRangeAttr, ['ID', 'CLASS', 'START-DATE', 'END-DATE', 'SCTE35-CMD', 'SCTE35-OUT', 'SCTE35-IN']);
                substituteVariablesInAttributes(level, dateRangeAttr, dateRangeAttr.clientAttrs);
              }
              const dateRange = new DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
              if (dateRange.isValid || level.skippedSegments) {
                level.dateRanges[dateRange.id] = dateRange;
              } else {
                logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
              }
              // Add to fragment tag list for backwards compatibility (< v1.2.0)
              frag.tagList.push(['EXT-X-DATERANGE', value1]);
              break;
            }
          case 'DEFINE':
            {
              {
                const variableAttributes = new AttrList(value1);
                substituteVariablesInAttributes(level, variableAttributes, ['NAME', 'VALUE', 'IMPORT', 'QUERYPARAM']);
                if ('IMPORT' in variableAttributes) {
                  importVariableDefinition(level, variableAttributes, multivariantVariableList);
                } else {
                  addVariableDefinition(level, variableAttributes, baseurl);
                }
              }
              break;
            }
          case 'DISCONTINUITY-SEQUENCE':
            discontinuityCounter = parseInt(value1);
            break;
          case 'KEY':
            {
              const levelKey = parseKey(value1, baseurl, level);
              if (levelKey.isSupported()) {
                if (levelKey.method === 'NONE') {
                  levelkeys = undefined;
                  break;
                }
                if (!levelkeys) {
                  levelkeys = {};
                }
                if (levelkeys[levelKey.keyFormat]) {
                  levelkeys = _extends({}, levelkeys);
                }
                levelkeys[levelKey.keyFormat] = levelKey;
              } else {
                logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
              }
              break;
            }
          case 'START':
            level.startTimeOffset = parseStartTimeOffset(value1);
            break;
          case 'MAP':
            {
              const mapAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, mapAttrs, ['BYTERANGE', 'URI']);
              }
              if (frag.duration) {
                // Initial segment tag is after segment duration tag.
                //   #EXTINF: 6.0
                //   #EXT-X-MAP:URI="init.mp4
                const init = new Fragment(type, baseurl);
                setInitSegment(init, mapAttrs, id, levelkeys);
                currentInitSegment = init;
                frag.initSegment = currentInitSegment;
                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) {
                  frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                }
              } else {
                // Initial segment tag is before segment duration tag
                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                const end = frag.byteRangeEndOffset;
                if (end) {
                  const start = frag.byteRangeStartOffset;
                  nextByteRange = `${end - start}@${start}`;
                } else {
                  nextByteRange = null;
                }
                setInitSegment(frag, mapAttrs, id, levelkeys);
                currentInitSegment = frag;
                createNextFrag = true;
              }
              break;
            }
          case 'SERVER-CONTROL':
            {
              const serverControlAttrs = new AttrList(value1);
              level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
              level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
              level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
              level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
              level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
              break;
            }
          case 'PART-INF':
            {
              const partInfAttrs = new AttrList(value1);
              level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
              break;
            }
          case 'PART':
            {
              let partList = level.partList;
              if (!partList) {
                partList = level.partList = [];
              }
              const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
              const index = currentPart++;
              const partAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, partAttrs, ['BYTERANGE', 'URI']);
              }
              const part = new Part(partAttrs, frag, baseurl, index, previousFragmentPart);
              partList.push(part);
              frag.duration += part.duration;
              break;
            }
          case 'PRELOAD-HINT':
            {
              const preloadHintAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, preloadHintAttrs, ['URI']);
              }
              level.preloadHint = preloadHintAttrs;
              break;
            }
          case 'RENDITION-REPORT':
            {
              const renditionReportAttrs = new AttrList(value1);
              {
                substituteVariablesInAttributes(level, renditionReportAttrs, ['URI']);
              }
              level.renditionReports = level.renditionReports || [];
              level.renditionReports.push(renditionReportAttrs);
              break;
            }
          default:
            logger.warn(`line parsed but not handled: ${result}`);
            break;
        }
      }
    }
    if (prevFrag && !prevFrag.relurl) {
      fragments.pop();
      totalduration -= prevFrag.duration;
      if (level.partList) {
        level.fragmentHint = prevFrag;
      }
    } else if (level.partList) {
      assignProgramDateTime(frag, prevFrag);
      frag.cc = discontinuityCounter;
      level.fragmentHint = frag;
      if (levelkeys) {
        setFragLevelKeys(frag, levelkeys, level);
      }
    }
    const fragmentLength = fragments.length;
    const firstFragment = fragments[0];
    const lastFragment = fragments[fragmentLength - 1];
    totalduration += level.skippedSegments * level.targetduration;
    if (totalduration > 0 && fragmentLength && lastFragment) {
      level.averagetargetduration = totalduration / fragmentLength;
      const lastSn = lastFragment.sn;
      level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
      if (!level.live) {
        lastFragment.endList = true;
      }
      if (firstFragment) {
        level.startCC = firstFragment.cc;
      }
    } else {
      level.endSN = 0;
      level.startCC = 0;
    }
    if (level.fragmentHint) {
      totalduration += level.fragmentHint.duration;
    }
    level.totalduration = totalduration;
    level.endCC = discontinuityCounter;

    /**
     * Backfill any missing PDT values
     * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
     * one or more Media Segment URIs, the client SHOULD extrapolate
     * backward from that tag (using EXTINF durations and/or media
     * timestamps) to associate dates with those segments."
     * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
     * computed.
     */
    if (firstPdtIndex > 0) {
      backfillProgramDateTimes(fragments, firstPdtIndex);
    }
    return level;
  }
}
function parseKey(keyTagAttributes, baseurl, parsed) {
  var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
  // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
  const keyAttrs = new AttrList(keyTagAttributes);
  {
    substituteVariablesInAttributes(parsed, keyAttrs, ['KEYFORMAT', 'KEYFORMATVERSIONS', 'URI', 'IV', 'URI']);
  }
  const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
  const decrypturi = keyAttrs.URI;
  const decryptiv = keyAttrs.hexadecimalInteger('IV');
  const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
  // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
  const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
  if (decrypturi && keyAttrs.IV && !decryptiv) {
    logger.error(`Invalid IV: ${keyAttrs.IV}`);
  }
  // If decrypturi is a URI with a scheme, then baseurl will be ignored
  // No uri is allowed when METHOD is NONE
  const resolvedUri = decrypturi ? M3U8Parser.resolve(decrypturi, baseurl) : '';
  const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
  return new LevelKey(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function parseStartTimeOffset(startAttributes) {
  const startAttrs = new AttrList(startAttributes);
  const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
  if (isFiniteNumber(startTimeOffset)) {
    return startTimeOffset;
  }
  return null;
}
function setCodecs(codecsAttributeValue, level) {
  let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter(c => c);
  ['video', 'audio', 'text'].forEach(type => {
    const filtered = codecs.filter(codec => isCodecType(codec, type));
    if (filtered.length) {
      // Comma separated list of all codecs for type
      level[`${type}Codec`] = filtered.join(',');
      // Remove known codecs so that only unknownCodecs are left after iterating through each type
      codecs = codecs.filter(codec => filtered.indexOf(codec) === -1);
    }
  });
  level.unknownCodecs = codecs;
}
function assignCodec(media, groupItem, codecProperty) {
  const codecValue = groupItem[codecProperty];
  if (codecValue) {
    media[codecProperty] = codecValue;
  }
}
function backfillProgramDateTimes(fragments, firstPdtIndex) {
  let fragPrev = fragments[firstPdtIndex];
  for (let i = firstPdtIndex; i--;) {
    const frag = fragments[i];
    // Exit on delta-playlist skipped segments
    if (!frag) {
      return;
    }
    frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
    fragPrev = frag;
  }
}
function assignProgramDateTime(frag, prevFrag) {
  if (frag.rawProgramDateTime) {
    frag.programDateTime = Date.parse(frag.rawProgramDateTime);
  } else if (prevFrag != null && prevFrag.programDateTime) {
    frag.programDateTime = prevFrag.endProgramDateTime;
  }
  if (!isFiniteNumber(frag.programDateTime)) {
    frag.programDateTime = null;
    frag.rawProgramDateTime = null;
  }
}
function setInitSegment(frag, mapAttrs, id, levelkeys) {
  frag.relurl = mapAttrs.URI;
  if (mapAttrs.BYTERANGE) {
    frag.setByteRange(mapAttrs.BYTERANGE);
  }
  frag.level = id;
  frag.sn = 'initSegment';
  if (levelkeys) {
    frag.levelkeys = levelkeys;
  }
  frag.initSegment = null;
}
function setFragLevelKeys(frag, levelkeys, level) {
  frag.levelkeys = levelkeys;
  const {
    encryptedFragments
  } = level;
  if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some(format => levelkeys[format].isCommonEncryption)) {
    encryptedFragments.push(frag);
  }
}

var PlaylistContextType = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
};
var PlaylistLevelType = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};

function mapContextToLevelType(context) {
  const {
    type
  } = context;
  switch (type) {
    case PlaylistContextType.AUDIO_TRACK:
      return PlaylistLevelType.AUDIO;
    case PlaylistContextType.SUBTITLE_TRACK:
      return PlaylistLevelType.SUBTITLE;
    default:
      return PlaylistLevelType.MAIN;
  }
}
function getResponseUrl(response, context) {
  let url = response.url;
  // responseURL not supported on some browsers (it is used to detect URL redirection)
  // data-uri mode also not supported (but no need to detect redirection)
  if (url === undefined || url.indexOf('data:') === 0) {
    // fallback to initial URL
    url = context.url;
  }
  return url;
}
class PlaylistLoader {
  constructor(hls) {
    this.hls = void 0;
    this.loaders = Object.create(null);
    this.variableList = null;
    this.hls = hls;
    this.registerListeners();
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.on(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
    hls.off(Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }

  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(context) {
    const config = this.hls.config;
    const PLoader = config.pLoader;
    const Loader = config.loader;
    const InternalLoader = PLoader || Loader;
    const loader = new InternalLoader(config);
    this.loaders[context.type] = loader;
    return loader;
  }
  getInternalLoader(context) {
    return this.loaders[context.type];
  }
  resetInternalLoader(contextType) {
    if (this.loaders[contextType]) {
      delete this.loaders[contextType];
    }
  }

  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const contextType in this.loaders) {
      const loader = this.loaders[contextType];
      if (loader) {
        loader.destroy();
      }
      this.resetInternalLoader(contextType);
    }
  }
  destroy() {
    this.variableList = null;
    this.unregisterListeners();
    this.destroyInternalLoaders();
  }
  onManifestLoading(event, data) {
    const {
      url
    } = data;
    this.variableList = null;
    this.load({
      id: null,
      level: 0,
      responseType: 'text',
      type: PlaylistContextType.MANIFEST,
      url,
      deliveryDirectives: null
    });
  }
  onLevelLoading(event, data) {
    const {
      id,
      level,
      pathwayId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      level,
      pathwayId,
      responseType: 'text',
      type: PlaylistContextType.LEVEL,
      url,
      deliveryDirectives
    });
  }
  onAudioTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.AUDIO_TRACK,
      url,
      deliveryDirectives
    });
  }
  onSubtitleTrackLoading(event, data) {
    const {
      id,
      groupId,
      url,
      deliveryDirectives
    } = data;
    this.load({
      id,
      groupId,
      level: null,
      responseType: 'text',
      type: PlaylistContextType.SUBTITLE_TRACK,
      url,
      deliveryDirectives
    });
  }
  load(context) {
    var _context$deliveryDire;
    const config = this.hls.config;

    // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);

    // Check if a loader for this context already exists
    let loader = this.getInternalLoader(context);
    if (loader) {
      const loaderContext = loader.context;
      if (loaderContext && loaderContext.url === context.url && loaderContext.level === context.level) {
        // same URL can't overlap
        logger.trace('[playlist-loader]: playlist request ongoing');
        return;
      }
      logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
      loader.abort();
    }

    // apply different configs for retries depending on
    // context (manifest, level, audio/subs playlist)
    let loadPolicy;
    if (context.type === PlaylistContextType.MANIFEST) {
      loadPolicy = config.manifestLoadPolicy.default;
    } else {
      loadPolicy = _extends({}, config.playlistLoadPolicy.default, {
        timeoutRetry: null,
        errorRetry: null
      });
    }
    loader = this.createInternalLoader(context);

    // Override level/track timeout for LL-HLS requests
    // (the default of 10000ms is counter productive to blocking playlist reload requests)
    if (isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
      let levelDetails;
      if (context.type === PlaylistContextType.LEVEL && context.level !== null) {
        levelDetails = this.hls.levels[context.level].details;
      } else if (context.type === PlaylistContextType.AUDIO_TRACK && context.id !== null) {
        levelDetails = this.hls.audioTracks[context.id].details;
      } else if (context.type === PlaylistContextType.SUBTITLE_TRACK && context.id !== null) {
        levelDetails = this.hls.subtitleTracks[context.id].details;
      }
      if (levelDetails) {
        const partTarget = levelDetails.partTarget;
        const targetDuration = levelDetails.targetduration;
        if (partTarget && targetDuration) {
          const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
          loadPolicy = _extends({}, loadPolicy, {
            maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const loaderCallbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        const loader = this.getInternalLoader(context);
        this.resetInternalLoader(context.type);
        const string = response.data;

        // Validate if it is an M3U8 at all
        if (string.indexOf('#EXTM3U') !== 0) {
          this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
          return;
        }
        stats.parsing.start = performance.now();
        if (M3U8Parser.isMediaPlaylist(string)) {
          this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
        } else {
          this.handleMasterPlaylist(response, stats, context, networkDetails);
        }
      },
      onError: (response, context, networkDetails, stats) => {
        this.handleNetworkError(context, networkDetails, false, response, stats);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.handleNetworkError(context, networkDetails, true, undefined, stats);
      }
    };

    // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);

    loader.load(context, loaderConfig, loaderCallbacks);
  }
  handleMasterPlaylist(response, stats, context, networkDetails) {
    const hls = this.hls;
    const string = response.data;
    const url = getResponseUrl(response, context);
    const parsedResult = M3U8Parser.parseMasterPlaylist(string, url);
    if (parsedResult.playlistParsingError) {
      this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
      return;
    }
    const {
      contentSteering,
      levels,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    } = parsedResult;
    this.variableList = variableList;
    const {
      AUDIO: audioTracks = [],
      SUBTITLES: subtitles,
      'CLOSED-CAPTIONS': captions
    } = M3U8Parser.parseMasterPlaylistMedia(string, url, parsedResult);
    if (audioTracks.length) {
      // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
      const embeddedAudioFound = audioTracks.some(audioTrack => !audioTrack.url);

      // if no embedded audio track defined, but audio codec signaled in quality level,
      // we need to signal this main audio track this could happen with playlists with
      // alt audio rendition in which quality levels (main)
      // contains both audio+video. but with mixed audio track not signaled
      if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
        logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
        audioTracks.unshift({
          type: 'main',
          name: 'main',
          groupId: 'main',
          default: false,
          autoselect: false,
          forced: false,
          id: -1,
          attrs: new AttrList({}),
          bitrate: 0,
          url: ''
        });
      }
    }
    hls.trigger(Events.MANIFEST_LOADED, {
      levels,
      audioTracks,
      subtitles,
      captions,
      contentSteering,
      url,
      stats,
      networkDetails,
      sessionData,
      sessionKeys,
      startTimeOffset,
      variableList
    });
  }
  handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      id,
      level,
      type
    } = context;
    const url = getResponseUrl(response, context);
    const levelUrlId = 0;
    const levelId = isFiniteNumber(level) ? level : isFiniteNumber(id) ? id : 0;
    const levelType = mapContextToLevelType(context);
    const levelDetails = M3U8Parser.parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId, this.variableList);

    // We have done our first request (Manifest-type) and receive
    // not a master playlist but a chunk-list (track/level)
    // We fire the manifest-loaded event anyway with the parsed level-details
    // by creating a single-level structure for it.
    if (type === PlaylistContextType.MANIFEST) {
      const singleLevel = {
        attrs: new AttrList({}),
        bitrate: 0,
        details: levelDetails,
        name: '',
        url
      };
      hls.trigger(Events.MANIFEST_LOADED, {
        levels: [singleLevel],
        audioTracks: [],
        url,
        stats,
        networkDetails,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }

    // save parsing time
    stats.parsing.end = performance.now();

    // extend the context with the new levelDetails property
    context.levelDetails = levelDetails;
    this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
  }
  handleManifestParsingError(response, context, error, networkDetails, stats) {
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.NETWORK_ERROR,
      details: ErrorDetails.MANIFEST_PARSING_ERROR,
      fatal: context.type === PlaylistContextType.MANIFEST,
      url: response.url,
      err: error,
      error,
      reason: error.message,
      response,
      context,
      networkDetails,
      stats
    });
  }
  handleNetworkError(context, networkDetails, timeout = false, response, stats) {
    let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
    if (context.type === PlaylistContextType.LEVEL) {
      message += `: ${context.level} id: ${context.id}`;
    } else if (context.type === PlaylistContextType.AUDIO_TRACK || context.type === PlaylistContextType.SUBTITLE_TRACK) {
      message += ` id: ${context.id} group-id: "${context.groupId}"`;
    }
    const error = new Error(message);
    logger.warn(`[playlist-loader]: ${message}`);
    let details = ErrorDetails.UNKNOWN;
    let fatal = false;
    const loader = this.getInternalLoader(context);
    switch (context.type) {
      case PlaylistContextType.MANIFEST:
        details = timeout ? ErrorDetails.MANIFEST_LOAD_TIMEOUT : ErrorDetails.MANIFEST_LOAD_ERROR;
        fatal = true;
        break;
      case PlaylistContextType.LEVEL:
        details = timeout ? ErrorDetails.LEVEL_LOAD_TIMEOUT : ErrorDetails.LEVEL_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.AUDIO_TRACK:
        details = timeout ? ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
        fatal = false;
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        details = timeout ? ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : ErrorDetails.SUBTITLE_LOAD_ERROR;
        fatal = false;
        break;
    }
    if (loader) {
      this.resetInternalLoader(context.type);
    }
    const errorData = {
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal,
      url: context.url,
      loader,
      context,
      error,
      networkDetails,
      stats
    };
    if (response) {
      const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
      errorData.response = _objectSpread2({
        url,
        data: undefined
      }, response);
    }
    this.hls.trigger(Events.ERROR, errorData);
  }
  handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
    const hls = this.hls;
    const {
      type,
      level,
      id,
      groupId,
      deliveryDirectives
    } = context;
    const url = getResponseUrl(response, context);
    const parent = mapContextToLevelType(context);
    const levelIndex = typeof context.level === 'number' && parent === PlaylistLevelType.MAIN ? level : undefined;
    if (!levelDetails.fragments.length) {
      const _error = new Error('No Segments found in Playlist');
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_EMPTY_ERROR,
        fatal: false,
        url,
        error: _error,
        reason: _error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (!levelDetails.targetduration) {
      levelDetails.playlistParsingError = new Error('Missing Target Duration');
    }
    const error = levelDetails.playlistParsingError;
    if (error) {
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.LEVEL_PARSING_ERROR,
        fatal: false,
        url,
        error,
        reason: error.message,
        response,
        context,
        level: levelIndex,
        parent,
        networkDetails,
        stats
      });
      return;
    }
    if (levelDetails.live && loader) {
      if (loader.getCacheAge) {
        levelDetails.ageHeader = loader.getCacheAge() || 0;
      }
      if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) {
        levelDetails.ageHeader = 0;
      }
    }
    switch (type) {
      case PlaylistContextType.MANIFEST:
      case PlaylistContextType.LEVEL:
        hls.trigger(Events.LEVEL_LOADED, {
          details: levelDetails,
          level: levelIndex || 0,
          id: id || 0,
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.AUDIO_TRACK:
        hls.trigger(Events.AUDIO_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
      case PlaylistContextType.SUBTITLE_TRACK:
        hls.trigger(Events.SUBTITLE_TRACK_LOADED, {
          details: levelDetails,
          id: id || 0,
          groupId: groupId || '',
          stats,
          networkDetails,
          deliveryDirectives
        });
        break;
    }
  }
}

function sendAddTrackEvent(track, videoEl) {
  let event;
  try {
    event = new Event('addtrack');
  } catch (err) {
    // for IE11
    event = document.createEvent('Event');
    event.initEvent('addtrack', false, false);
  }
  event.track = track;
  videoEl.dispatchEvent(event);
}
function addCueToTrack(track, cue) {
  // Sometimes there are cue overlaps on segmented vtts so the same
  // cue can appear more than once in different vtt files.
  // This avoid showing duplicated cues with same timecode and text.
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && !track.cues.getCueById(cue.id)) {
    try {
      track.addCue(cue);
      if (!track.cues.getCueById(cue.id)) {
        throw new Error(`addCue is failed for: ${cue}`);
      }
    } catch (err) {
      logger.debug(`[texttrack-utils]: ${err}`);
      try {
        const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
        textTrackCue.id = cue.id;
        track.addCue(textTrackCue);
      } catch (err2) {
        logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function clearCurrentCues(track) {
  // When track.mode is disabled, track.cues will be null.
  // To guarantee the removal of cues, we need to temporarily
  // change the mode to hidden
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues) {
    for (let i = track.cues.length; i--;) {
      track.removeCue(track.cues[i]);
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}
function removeCuesInRange(track, start, end, predicate) {
  const mode = track.mode;
  if (mode === 'disabled') {
    track.mode = 'hidden';
  }
  if (track.cues && track.cues.length > 0) {
    const cues = getCuesInRange(track.cues, start, end);
    for (let i = 0; i < cues.length; i++) {
      if (!predicate || predicate(cues[i])) {
        track.removeCue(cues[i]);
      }
    }
  }
  if (mode === 'disabled') {
    track.mode = mode;
  }
}

// Find first cue starting after given time.
// Modified version of binary search O(log(n)).
function getFirstCueIndexAfterTime(cues, time) {
  // If first cue starts after time, start there
  if (time < cues[0].startTime) {
    return 0;
  }
  // If the last cue ends before time there is no overlap
  const len = cues.length - 1;
  if (time > cues[len].endTime) {
    return -1;
  }
  let left = 0;
  let right = len;
  while (left <= right) {
    const mid = Math.floor((right + left) / 2);
    if (time < cues[mid].startTime) {
      right = mid - 1;
    } else if (time > cues[mid].startTime && left < len) {
      left = mid + 1;
    } else {
      // If it's not lower or higher, it must be equal.
      return mid;
    }
  }
  // At this point, left and right have swapped.
  // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
  return cues[left].startTime - time < time - cues[right].startTime ? left : right;
}
function getCuesInRange(cues, start, end) {
  const cuesFound = [];
  const firstCueInRange = getFirstCueIndexAfterTime(cues, start);
  if (firstCueInRange > -1) {
    for (let i = firstCueInRange, len = cues.length; i < len; i++) {
      const cue = cues[i];
      if (cue.startTime >= start && cue.endTime <= end) {
        cuesFound.push(cue);
      } else if (cue.startTime > end) {
        return cuesFound;
      }
    }
  }
  return cuesFound;
}
function filterSubtitleTracks(textTrackList) {
  const tracks = [];
  for (let i = 0; i < textTrackList.length; i++) {
    const track = textTrackList[i];
    // Edge adds a track without a label; we don't want to use it
    if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

var MetadataSchema = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};

const MIN_CUE_DURATION = 0.25;
function getCueClass() {
  if (typeof self === 'undefined') return undefined;
  return self.VTTCue || self.TextTrackCue;
}
function createCueWithDataFields(Cue, startTime, endTime, data, type) {
  let cue = new Cue(startTime, endTime, '');
  try {
    cue.value = data;
    if (type) {
      cue.type = type;
    }
  } catch (e) {
    cue = new Cue(startTime, endTime, JSON.stringify(type ? _objectSpread2({
      type
    }, data) : data));
  }
  return cue;
}

// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const MAX_CUE_ENDTIME = (() => {
  const Cue = getCueClass();
  try {
    Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
  } catch (e) {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function dateRangeDateToTimelineSeconds(date, offset) {
  return date.getTime() / 1000 - offset;
}
function hexToArrayBuffer(str) {
  return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class ID3TrackController {
  constructor(hls) {
    this.hls = void 0;
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    this.hls = hls;
    this._registerListeners();
  }
  destroy() {
    this._unregisterListeners();
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
    // @ts-ignore
    this.hls = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }

  // Add ID3 metatadata text track.
  onMediaAttached(event, data) {
    this.media = data.media;
  }
  onMediaDetaching() {
    if (!this.id3Track) {
      return;
    }
    clearCurrentCues(this.id3Track);
    this.id3Track = null;
    this.media = null;
    this.dateRangeCuesAppended = {};
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(media) {
    const track = this.getID3Track(media.textTracks);
    track.mode = 'hidden';
    return track;
  }
  getID3Track(textTracks) {
    if (!this.media) {
      return;
    }
    for (let i = 0; i < textTracks.length; i++) {
      const textTrack = textTracks[i];
      if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
        // send 'addtrack' when reusing the textTrack for metadata,
        // same as what we do for captions
        sendAddTrackEvent(textTrack, this.media);
        return textTrack;
      }
    }
    return this.media.addTextTrack('metadata', 'id3');
  }
  onFragParsingMetadata(event, data) {
    if (!this.media) {
      return;
    }
    const {
      hls: {
        config: {
          enableEmsgMetadataCues,
          enableID3MetadataCues
        }
      }
    } = this;
    if (!enableEmsgMetadataCues && !enableID3MetadataCues) {
      return;
    }
    const {
      samples
    } = data;

    // create track dynamically
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const Cue = getCueClass();
    if (!Cue) {
      return;
    }
    for (let i = 0; i < samples.length; i++) {
      const type = samples[i].type;
      if (type === MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) {
        continue;
      }
      const frames = getID3Frames(samples[i].data);
      if (frames) {
        const startTime = samples[i].pts;
        let endTime = startTime + samples[i].duration;
        if (endTime > MAX_CUE_ENDTIME) {
          endTime = MAX_CUE_ENDTIME;
        }
        const timeDiff = endTime - startTime;
        if (timeDiff <= 0) {
          endTime = startTime + MIN_CUE_DURATION;
        }
        for (let j = 0; j < frames.length; j++) {
          const frame = frames[j];
          // Safari doesn't put the timestamp frame in the TextTrack
          if (!isTimeStampFrame(frame)) {
            // add a bounds to any unbounded cues
            this.updateId3CueEnds(startTime, type);
            const cue = createCueWithDataFields(Cue, startTime, endTime, frame, type);
            if (cue) {
              this.id3Track.addCue(cue);
            }
          }
        }
      }
    }
  }
  updateId3CueEnds(startTime, type) {
    var _this$id3Track;
    const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
    if (cues) {
      for (let i = cues.length; i--;) {
        const cue = cues[i];
        if (cue.type === type && cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) {
          cue.endTime = startTime;
        }
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    type
  }) {
    const {
      id3Track,
      hls
    } = this;
    if (!hls) {
      return;
    }
    const {
      config: {
        enableEmsgMetadataCues,
        enableID3MetadataCues
      }
    } = hls;
    if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
      let predicate;
      if (type === 'audio') {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues;
      } else if (type === 'video') {
        predicate = cue => cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      } else {
        predicate = cue => cue.type === MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === MetadataSchema.emsg && enableEmsgMetadataCues;
      }
      removeCuesInRange(id3Track, startOffset, endOffset, predicate);
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) {
      return;
    }
    const {
      dateRangeCuesAppended,
      id3Track
    } = this;
    const {
      dateRanges
    } = details;
    const ids = Object.keys(dateRanges);
    // Remove cues from track not found in details.dateRanges
    if (id3Track) {
      const idsToRemove = Object.keys(dateRangeCuesAppended).filter(id => !ids.includes(id));
      for (let i = idsToRemove.length; i--;) {
        const id = idsToRemove[i];
        Object.keys(dateRangeCuesAppended[id].cues).forEach(key => {
          id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
        });
        delete dateRangeCuesAppended[id];
      }
    }
    // Exit if the playlist does not have Date Ranges or does not have Program Date Time
    const lastFragment = details.fragments[details.fragments.length - 1];
    if (ids.length === 0 || !isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) {
      return;
    }
    if (!this.id3Track) {
      this.id3Track = this.createTrack(this.media);
    }
    const dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
    const Cue = getCueClass();
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const dateRange = dateRanges[id];
      const startTime = dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);

      // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
      const appendedDateRangeCues = dateRangeCuesAppended[id];
      const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
      let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
      let endTime = MAX_CUE_ENDTIME;
      const endDate = dateRange.endDate;
      if (endDate) {
        endTime = dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
        durationKnown = true;
      } else if (dateRange.endOnNext && !durationKnown) {
        const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id) => {
          if (id !== dateRange.id) {
            const otherDateRange = dateRanges[id];
            if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) {
              return otherDateRange;
            }
          }
          return candidateDateRange;
        }, null);
        if (nextDateRangeWithSameClass) {
          endTime = dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
          durationKnown = true;
        }
      }

      // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
      // This is to emulate Safari HLS playback handling of DateRange tags
      const attributes = Object.keys(dateRange.attr);
      for (let j = 0; j < attributes.length; j++) {
        const key = attributes[j];
        if (!isDateRangeCueAttribute(key)) {
          continue;
        }
        const cue = cues[key];
        if (cue) {
          if (durationKnown && !appendedDateRangeCues.durationKnown) {
            cue.endTime = endTime;
          }
        } else if (Cue) {
          let data = dateRange.attr[key];
          if (isSCTE35Attribute(key)) {
            data = hexToArrayBuffer(data);
          }
          const _cue = createCueWithDataFields(Cue, startTime, endTime, {
            key,
            data
          }, MetadataSchema.dateRange);
          if (_cue) {
            _cue.id = id;
            this.id3Track.addCue(_cue);
            cues[key] = _cue;
          }
        }
      }

      // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
      dateRangeCuesAppended[id] = {
        cues,
        dateRange,
        durationKnown
      };
    }
  }
}

class LatencyController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.levelDetails = null;
    this.currentTime = 0;
    this.stallCount = 0;
    this._latency = null;
    this.timeupdateHandler = () => this.timeupdate();
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config,
      levelDetails
    } = this;
    if (config.liveMaxLatencyDuration !== undefined) {
      return config.liveMaxLatencyDuration;
    }
    return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    const {
      holdBack,
      partHoldBack,
      targetduration
    } = levelDetails;
    const {
      liveSyncDuration,
      liveSyncDurationCount,
      lowLatencyMode
    } = this.config;
    const userConfig = this.hls.userConfig;
    let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
    if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) {
      targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
    }
    const maxLiveSyncOnStallIncrease = targetduration;
    const liveSyncOnStallIncrease = 1.0;
    return targetLatency + Math.min(this.stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
  }
  get liveSyncPosition() {
    const liveEdge = this.estimateLiveEdge();
    const targetLatency = this.targetLatency;
    const levelDetails = this.levelDetails;
    if (liveEdge === null || targetLatency === null || levelDetails === null) {
      return null;
    }
    const edge = levelDetails.edge;
    const syncPosition = liveEdge - targetLatency - this.edgeStalled;
    const min = edge - levelDetails.totalduration;
    const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
    return Math.min(Math.max(min, syncPosition), max);
  }
  get drift() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 1;
    }
    return levelDetails.drift;
  }
  get edgeStalled() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return 0;
    }
    const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
    return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
  }
  get forwardBufferLength() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return 0;
    }
    const bufferedRanges = media.buffered.length;
    return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetaching();
    this.levelDetails = null;
    // @ts-ignore
    this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    this.hls.off(Events.ERROR, this.onError, this);
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('timeupdate', this.timeupdateHandler);
  }
  onMediaDetaching() {
    if (this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
      this.media = null;
    }
  }
  onManifestLoading() {
    this.levelDetails = null;
    this._latency = null;
    this.stallCount = 0;
  }
  onLevelUpdated(event, {
    details
  }) {
    this.levelDetails = details;
    if (details.advanced) {
      this.timeupdate();
    }
    if (!details.live && this.media) {
      this.media.removeEventListener('timeupdate', this.timeupdateHandler);
    }
  }
  onError(event, data) {
    var _this$levelDetails;
    if (data.details !== ErrorDetails.BUFFER_STALLED_ERROR) {
      return;
    }
    this.stallCount++;
    if ((_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) {
      logger.warn('[playback-rate-controller]: Stall detected, adjusting target latency');
    }
  }
  timeupdate() {
    const {
      media,
      levelDetails
    } = this;
    if (!media || !levelDetails) {
      return;
    }
    this.currentTime = media.currentTime;
    const latency = this.computeLatency();
    if (latency === null) {
      return;
    }
    this._latency = latency;

    // Adapt playbackRate to meet target latency in low-latency mode
    const {
      lowLatencyMode,
      maxLiveSyncPlaybackRate
    } = this.config;
    if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) {
      return;
    }
    const targetLatency = this.targetLatency;
    if (targetLatency === null) {
      return;
    }
    const distanceFromTarget = latency - targetLatency;
    // Only adjust playbackRate when within one target duration of targetLatency
    // and more than one second from under-buffering.
    // Playback further than one target duration from target can be considered DVR playback.
    const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
    const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
    if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
      const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
      const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
      media.playbackRate = Math.min(max, Math.max(1, rate));
    } else if (media.playbackRate !== 1 && media.playbackRate !== 0) {
      media.playbackRate = 1;
    }
  }
  estimateLiveEdge() {
    const {
      levelDetails
    } = this;
    if (levelDetails === null) {
      return null;
    }
    return levelDetails.edge + levelDetails.age;
  }
  computeLatency() {
    const liveEdge = this.estimateLiveEdge();
    if (liveEdge === null) {
      return null;
    }
    return liveEdge - this.currentTime;
  }
}

const HdcpLevels = ['NONE', 'TYPE-0', 'TYPE-1', null];
function isHdcpLevel(value) {
  return HdcpLevels.indexOf(value) > -1;
}
const VideoRangeValues = ['SDR', 'PQ', 'HLG'];
function isVideoRange(value) {
  return !!value && VideoRangeValues.indexOf(value) > -1;
}
var HlsSkip = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function getSkipValue(details) {
  const {
    canSkipUntil,
    canSkipDateRanges,
    age
  } = details;
  // A Client SHOULD NOT request a Playlist Delta Update unless it already
  // has a version of the Playlist that is no older than one-half of the Skip Boundary.
  // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
  const playlistRecentEnough = age < canSkipUntil / 2;
  if (canSkipUntil && playlistRecentEnough) {
    if (canSkipDateRanges) {
      return HlsSkip.v2;
    }
    return HlsSkip.Yes;
  }
  return HlsSkip.No;
}
class HlsUrlParameters {
  constructor(msn, part, skip) {
    this.msn = void 0;
    this.part = void 0;
    this.skip = void 0;
    this.msn = msn;
    this.part = part;
    this.skip = skip;
  }
  addDirectives(uri) {
    const url = new self.URL(uri);
    if (this.msn !== undefined) {
      url.searchParams.set('_HLS_msn', this.msn.toString());
    }
    if (this.part !== undefined) {
      url.searchParams.set('_HLS_part', this.part.toString());
    }
    if (this.skip) {
      url.searchParams.set('_HLS_skip', this.skip);
    }
    return url.href;
  }
}
class Level {
  constructor(data) {
    this._attrs = void 0;
    this.audioCodec = void 0;
    this.bitrate = void 0;
    this.codecSet = void 0;
    this.url = void 0;
    this.frameRate = void 0;
    this.height = void 0;
    this.id = void 0;
    this.name = void 0;
    this.videoCodec = void 0;
    this.width = void 0;
    this.details = void 0;
    this.fragmentError = 0;
    this.loadError = 0;
    this.loaded = void 0;
    this.realBitrate = 0;
    this.supportedPromise = void 0;
    this.supportedResult = void 0;
    this._avgBitrate = 0;
    this._audioGroups = void 0;
    this._subtitleGroups = void 0;
    // Deprecated (retained for backwards compatibility)
    this._urlId = 0;
    this.url = [data.url];
    this._attrs = [data.attrs];
    this.bitrate = data.bitrate;
    if (data.details) {
      this.details = data.details;
    }
    this.id = data.id || 0;
    this.name = data.name;
    this.width = data.width || 0;
    this.height = data.height || 0;
    this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
    this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
    this.audioCodec = data.audioCodec;
    this.videoCodec = data.videoCodec;
    this.codecSet = [data.videoCodec, data.audioCodec].filter(c => !!c).map(s => s.substring(0, 4)).join(',');
    this.addGroupId('audio', data.attrs.AUDIO);
    this.addGroupId('text', data.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || '';
  }
  get pathwayId() {
    return this.attrs['PATHWAY-ID'] || '.';
  }
  get videoRange() {
    return this.attrs['VIDEO-RANGE'] || 'SDR';
  }
  get score() {
    return this.attrs.optionalFloat('SCORE', 0);
  }
  get uri() {
    return this.url[0] || '';
  }
  hasAudioGroup(groupId) {
    return hasGroup(this._audioGroups, groupId);
  }
  hasSubtitleGroup(groupId) {
    return hasGroup(this._subtitleGroups, groupId);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(type, groupId) {
    if (!groupId) {
      return;
    }
    if (type === 'audio') {
      let audioGroups = this._audioGroups;
      if (!audioGroups) {
        audioGroups = this._audioGroups = [];
      }
      if (audioGroups.indexOf(groupId) === -1) {
        audioGroups.push(groupId);
      }
    } else if (type === 'text') {
      let subtitleGroups = this._subtitleGroups;
      if (!subtitleGroups) {
        subtitleGroups = this._subtitleGroups = [];
      }
      if (subtitleGroups.indexOf(groupId) === -1) {
        subtitleGroups.push(groupId);
      }
    }
  }

  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(value) {}
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : undefined;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : undefined;
  }
  get audioGroupId() {
    var _this$audioGroups;
    return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
  }
  get textGroupId() {
    var _this$subtitleGroups;
    return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
  }
  addFallback() {}
}
function hasGroup(groups, groupId) {
  if (!groupId || !groups) {
    return false;
  }
  return groups.indexOf(groupId) !== -1;
}

function updateFromToPTS(fragFrom, fragTo) {
  const fragToPTS = fragTo.startPTS;
  // if we know startPTS[toIdx]
  if (isFiniteNumber(fragToPTS)) {
    // update fragment duration.
    // it helps to fix drifts between playlist reported duration and fragment real duration
    let duration = 0;
    let frag;
    if (fragTo.sn > fragFrom.sn) {
      duration = fragToPTS - fragFrom.start;
      frag = fragFrom;
    } else {
      duration = fragFrom.start - fragToPTS;
      frag = fragTo;
    }
    if (frag.duration !== duration) {
      frag.duration = duration;
    }
    // we dont know startPTS[toIdx]
  } else if (fragTo.sn > fragFrom.sn) {
    const contiguous = fragFrom.cc === fragTo.cc;
    // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
    if (contiguous && fragFrom.minEndPTS) {
      fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
    } else {
      fragTo.start = fragFrom.start + fragFrom.duration;
    }
  } else {
    fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
  }
}
function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
  const parsedMediaDuration = endPTS - startPTS;
  if (parsedMediaDuration <= 0) {
    logger.warn('Fragment should have a positive duration', frag);
    endPTS = startPTS + frag.duration;
    endDTS = startDTS + frag.duration;
  }
  let maxStartPTS = startPTS;
  let minEndPTS = endPTS;
  const fragStartPts = frag.startPTS;
  const fragEndPts = frag.endPTS;
  if (isFiniteNumber(fragStartPts)) {
    // delta PTS between audio and video
    const deltaPTS = Math.abs(fragStartPts - startPTS);
    if (!isFiniteNumber(frag.deltaPTS)) {
      frag.deltaPTS = deltaPTS;
    } else {
      frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
    }
    maxStartPTS = Math.max(startPTS, fragStartPts);
    startPTS = Math.min(startPTS, fragStartPts);
    startDTS = Math.min(startDTS, frag.startDTS);
    minEndPTS = Math.min(endPTS, fragEndPts);
    endPTS = Math.max(endPTS, fragEndPts);
    endDTS = Math.max(endDTS, frag.endDTS);
  }
  const drift = startPTS - frag.start;
  if (frag.start !== 0) {
    frag.start = startPTS;
  }
  frag.duration = endPTS - frag.start;
  frag.startPTS = startPTS;
  frag.maxStartPTS = maxStartPTS;
  frag.startDTS = startDTS;
  frag.endPTS = endPTS;
  frag.minEndPTS = minEndPTS;
  frag.endDTS = endDTS;
  const sn = frag.sn; // 'initSegment'
  // exit if sn out of range
  if (!details || sn < details.startSN || sn > details.endSN) {
    return 0;
  }
  let i;
  const fragIdx = sn - details.startSN;
  const fragments = details.fragments;
  // update frag reference in fragments array
  // rationale is that fragments array might not contain this frag object.
  // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
  // if we don't update frag, we won't be able to propagate PTS info on the playlist
  // resulting in invalid sliding computation
  fragments[fragIdx] = frag;
  // adjust fragment PTS/duration from seqnum-1 to frag 0
  for (i = fragIdx; i > 0; i--) {
    updateFromToPTS(fragments[i], fragments[i - 1]);
  }

  // adjust fragment PTS/duration from seqnum to last frag
  for (i = fragIdx; i < fragments.length - 1; i++) {
    updateFromToPTS(fragments[i], fragments[i + 1]);
  }
  if (details.fragmentHint) {
    updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
  }
  details.PTSKnown = details.alignedSliding = true;
  return drift;
}
function mergeDetails(oldDetails, newDetails) {
  // Track the last initSegment processed. Initialize it to the last one on the timeline.
  let currentInitSegment = null;
  const oldFragments = oldDetails.fragments;
  for (let i = oldFragments.length - 1; i >= 0; i--) {
    const oldInit = oldFragments[i].initSegment;
    if (oldInit) {
      currentInitSegment = oldInit;
      break;
    }
  }
  if (oldDetails.fragmentHint) {
    // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
  }
  // check if old/new playlists have fragments in common
  // loop through overlapping SN and update startPTS , cc, and duration if any found
  let ccOffset = 0;
  let PTSFrag;
  mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag) => {
    if (oldFrag.relurl) {
      // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
      // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
      // of the playlist.
      ccOffset = oldFrag.cc - newFrag.cc;
    }
    if (isFiniteNumber(oldFrag.startPTS) && isFiniteNumber(oldFrag.endPTS)) {
      newFrag.start = newFrag.startPTS = oldFrag.startPTS;
      newFrag.startDTS = oldFrag.startDTS;
      newFrag.maxStartPTS = oldFrag.maxStartPTS;
      newFrag.endPTS = oldFrag.endPTS;
      newFrag.endDTS = oldFrag.endDTS;
      newFrag.minEndPTS = oldFrag.minEndPTS;
      newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
      if (newFrag.duration) {
        PTSFrag = newFrag;
      }

      // PTS is known when any segment has startPTS and endPTS
      newDetails.PTSKnown = newDetails.alignedSliding = true;
    }
    newFrag.elementaryStreams = oldFrag.elementaryStreams;
    newFrag.loader = oldFrag.loader;
    newFrag.stats = oldFrag.stats;
    if (oldFrag.initSegment) {
      newFrag.initSegment = oldFrag.initSegment;
      currentInitSegment = oldFrag.initSegment;
    }
  });
  if (currentInitSegment) {
    const fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    fragmentsToCheck.forEach(frag => {
      var _currentInitSegment;
      if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) {
        frag.initSegment = currentInitSegment;
      }
    });
  }
  if (newDetails.skippedSegments) {
    newDetails.deltaUpdateFailed = newDetails.fragments.some(frag => !frag);
    if (newDetails.deltaUpdateFailed) {
      logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
      for (let i = newDetails.skippedSegments; i--;) {
        newDetails.fragments.shift();
      }
      newDetails.startSN = newDetails.fragments[0].sn;
      newDetails.startCC = newDetails.fragments[0].cc;
    } else if (newDetails.canSkipDateRanges) {
      newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
    }
  }
  const newFragments = newDetails.fragments;
  if (ccOffset) {
    logger.warn('discontinuity sliding from playlist, take drift into account');
    for (let i = 0; i < newFragments.length; i++) {
      newFragments[i].cc += ccOffset;
    }
  }
  if (newDetails.skippedSegments) {
    newDetails.startCC = newDetails.fragments[0].cc;
  }

  // Merge parts
  mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart) => {
    newPart.elementaryStreams = oldPart.elementaryStreams;
    newPart.stats = oldPart.stats;
  });

  // if at least one fragment contains PTS info, recompute PTS information for all fragments
  if (PTSFrag) {
    updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
  } else {
    // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    adjustSliding(oldDetails, newDetails);
  }
  if (newFragments.length) {
    newDetails.totalduration = newDetails.edge - newFragments[0].start;
  }
  newDetails.driftStartTime = oldDetails.driftStartTime;
  newDetails.driftStart = oldDetails.driftStart;
  const advancedDateTime = newDetails.advancedDateTime;
  if (newDetails.advanced && advancedDateTime) {
    const edge = newDetails.edge;
    if (!newDetails.driftStart) {
      newDetails.driftStartTime = advancedDateTime;
      newDetails.driftStart = edge;
    }
    newDetails.driftEndTime = advancedDateTime;
    newDetails.driftEnd = edge;
  } else {
    newDetails.driftEndTime = oldDetails.driftEndTime;
    newDetails.driftEnd = oldDetails.driftEnd;
    newDetails.advancedDateTime = oldDetails.advancedDateTime;
  }
}
function mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
  const dateRanges = _extends({}, oldDateRanges);
  if (recentlyRemovedDateranges) {
    recentlyRemovedDateranges.forEach(id => {
      delete dateRanges[id];
    });
  }
  Object.keys(deltaDateRanges).forEach(id => {
    const dateRange = new DateRange(deltaDateRanges[id].attr, dateRanges[id]);
    if (dateRange.isValid) {
      dateRanges[id] = dateRange;
    } else {
      logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(deltaDateRanges[id].attr)}"`);
    }
  });
  return dateRanges;
}
function mapPartIntersection(oldParts, newParts, intersectionFn) {
  if (oldParts && newParts) {
    let delta = 0;
    for (let i = 0, len = oldParts.length; i <= len; i++) {
      const oldPart = oldParts[i];
      const newPart = newParts[i + delta];
      if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) {
        intersectionFn(oldPart, newPart);
      } else {
        delta--;
      }
    }
  }
}
function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
  const skippedSegments = newDetails.skippedSegments;
  const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
  const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
  const delta = newDetails.startSN - oldDetails.startSN;
  const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
  const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
  for (let i = start; i <= end; i++) {
    const oldFrag = oldFrags[delta + i];
    let newFrag = newFrags[i];
    if (skippedSegments && !newFrag && i < skippedSegments) {
      // Fill in skipped segments in delta playlist
      newFrag = newDetails.fragments[i] = oldFrag;
    }
    if (oldFrag && newFrag) {
      intersectionFn(oldFrag, newFrag);
    }
  }
}
function adjustSliding(oldDetails, newDetails) {
  const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
  const oldFragments = oldDetails.fragments;
  if (delta < 0 || delta >= oldFragments.length) {
    return;
  }
  addSliding(newDetails, oldFragments[delta].start);
}
function addSliding(details, start) {
  if (start) {
    const fragments = details.fragments;
    for (let i = details.skippedSegments; i < fragments.length; i++) {
      fragments[i].start += start;
    }
    if (details.fragmentHint) {
      details.fragmentHint.start += start;
    }
  }
}
function computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
  let reloadInterval = 1000 * newDetails.targetduration;
  if (newDetails.updated) {
    // Use last segment duration when shorter than target duration and near live edge
    const fragments = newDetails.fragments;
    const liveEdgeMaxTargetDurations = 4;
    if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
      const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
      if (lastSegmentDuration < reloadInterval) {
        reloadInterval = lastSegmentDuration;
      }
    }
  } else {
    // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
  }
  return Math.round(reloadInterval);
}
function getFragmentWithSN(level, sn, fragCurrent) {
  if (!(level != null && level.details)) {
    return null;
  }
  const levelDetails = level.details;
  let fragment = levelDetails.fragments[sn - levelDetails.startSN];
  if (fragment) {
    return fragment;
  }
  fragment = levelDetails.fragmentHint;
  if (fragment && fragment.sn === sn) {
    return fragment;
  }
  if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) {
    return fragCurrent;
  }
  return null;
}
function getPartWith(level, sn, partIndex) {
  var _level$details;
  if (!(level != null && level.details)) {
    return null;
  }
  return findPart((_level$details = level.details) == null ? void 0 : _level$details.partList, sn, partIndex);
}
function findPart(partList, sn, partIndex) {
  if (partList) {
    for (let i = partList.length; i--;) {
      const part = partList[i];
      if (part.index === partIndex && part.fragment.sn === sn) {
        return part;
      }
    }
  }
  return null;
}
function reassignFragmentLevelIndexes(levels) {
  levels.forEach((level, index) => {
    const {
      details
    } = level;
    if (details != null && details.fragments) {
      details.fragments.forEach(fragment => {
        fragment.level = index;
      });
    }
  });
}

function isTimeoutError(error) {
  switch (error.details) {
    case ErrorDetails.FRAG_LOAD_TIMEOUT:
    case ErrorDetails.KEY_LOAD_TIMEOUT:
    case ErrorDetails.LEVEL_LOAD_TIMEOUT:
    case ErrorDetails.MANIFEST_LOAD_TIMEOUT:
      return true;
  }
  return false;
}
function getRetryConfig(loadPolicy, error) {
  const isTimeout = isTimeoutError(error);
  return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function getRetryDelay(retryConfig, retryCount) {
  // exponential backoff capped to max retry delay
  const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
  return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function getLoaderConfigWithoutReties(loderConfig) {
  return _objectSpread2(_objectSpread2({}, loderConfig), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
  if (!retryConfig) {
    return false;
  }
  const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
  const retry = retryCount < retryConfig.maxNumRetry && (retryForHttpStatus(httpStatus) || !!isTimeout);
  return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function retryForHttpStatus(httpStatus) {
  // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
  return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}

const BinarySearch = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function (list, comparisonFn) {
    let minIndex = 0;
    let maxIndex = list.length - 1;
    let currentIndex = null;
    let currentElement = null;
    while (minIndex <= maxIndex) {
      currentIndex = (minIndex + maxIndex) / 2 | 0;
      currentElement = list[currentIndex];
      const comparisonResult = comparisonFn(currentElement);
      if (comparisonResult > 0) {
        minIndex = currentIndex + 1;
      } else if (comparisonResult < 0) {
        maxIndex = currentIndex - 1;
      } else {
        return currentElement;
      }
    }
    return null;
  }
};

/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */
function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
  if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !isFiniteNumber(PDTValue)) {
    return null;
  }

  // if less than start
  const startPDT = fragments[0].programDateTime;
  if (PDTValue < (startPDT || 0)) {
    return null;
  }
  const endPDT = fragments[fragments.length - 1].endProgramDateTime;
  if (PDTValue >= (endPDT || 0)) {
    return null;
  }
  maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
  for (let seg = 0; seg < fragments.length; ++seg) {
    const frag = fragments[seg];
    if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
      return frag;
    }
  }
  return null;
}

/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */
function findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = 0.005) {
  let fragNext = null;
  if (fragPrevious) {
    fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
    // check for buffer-end rounding error
    const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
    if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) {
      bufferEnd += 0.0000015;
    }
  } else if (bufferEnd === 0 && fragments[0].start === 0) {
    fragNext = fragments[0];
  }
  // Prefer the next fragment if it's within tolerance
  if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) {
    return fragNext;
  }
  // We might be seeking past the tolerance so find the best match
  const foundFragment = BinarySearch.search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
  if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) {
    return foundFragment;
  }
  // If no match was found return the next fragment after fragPrevious, or null
  return fragNext;
}
function fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
  if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
    const firstDuration = fragPrevious.tagList.reduce((duration, tag) => {
      if (tag[0] === 'INF') {
        duration += parseFloat(tag[1]);
      }
      return duration;
    }, nextFragLookupTolerance);
    return fragNext.start <= firstDuration;
  }
  return false;
}

/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */
function fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
  // eagerly accept an accurate match (no tolerance)
  if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) {
    return 0;
  }
  // offset should be within fragment boundary - config.maxFragLookUpTolerance
  // this is to cope with situations like
  // bufferEnd = 9.991
  // frag[Ø] : [0,10]
  // frag[1] : [10,20]
  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
  //              frag start               frag start+duration
  //                  |-----------------------------|
  //              <--->                         <--->
  //  ...--------><-----------------------------><---------....
  // previous frag         matching fragment         next frag
  //  return -1             return 0                 return 1
  // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
    return 1;
  } else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
    // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
  }
  return 0;
}

/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */
function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
  const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;

  // endProgramDateTime can be null, default to zero
  const endProgramDateTime = candidate.endProgramDateTime || 0;
  return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function findFragWithCC(fragments, cc) {
  return BinarySearch.search(fragments, candidate => {
    if (candidate.cc < cc) {
      return 1;
    } else if (candidate.cc > cc) {
      return -1;
    } else {
      return 0;
    }
  });
}

var NetworkErrorAction = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
};
var ErrorActionFlags = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
}; // Reserved for future use
class ErrorController {
  constructor(hls) {
    this.hls = void 0;
    this.playlistError = 0;
    this.penalizedRenditions = {};
    this.log = void 0;
    this.warn = void 0;
    this.error = void 0;
    this.hls = hls;
    this.log = logger.log.bind(logger, `[info]:`);
    this.warn = logger.warn.bind(logger, `[warning]:`);
    this.error = logger.error.bind(logger, `[error]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.ERROR, this.onErrorOut, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  destroy() {
    this.unregisterListeners();
    // @ts-ignore
    this.hls = null;
    this.penalizedRenditions = {};
  }
  startLoad(startPosition) {}
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(frag) {
    return (frag == null ? void 0 : frag.type) === PlaylistLevelType.MAIN ? frag.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0;
    this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(event, data) {
    var _data$frag, _data$level;
    if (data.fatal) {
      return;
    }
    const hls = this.hls;
    const context = data.context;
    switch (data.details) {
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        data.errorAction = this.getFragRetryOrSwitchAction(data);
        return;
      case ErrorDetails.FRAG_PARSING_ERROR:
        // ignore empty segment errors marked as gap
        if ((_data$frag = data.frag) != null && _data$frag.gap) {
          data.errorAction = {
            action: NetworkErrorAction.DoNothing,
            flags: ErrorActionFlags.None
          };
          return;
        }
      // falls through
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
        {
          // Switch level if possible, otherwise allow retry count to reach max error retries
          data.errorAction = this.getFragRetryOrSwitchAction(data);
          data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
          return;
        }
      case ErrorDetails.LEVEL_EMPTY_ERROR:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        {
          var _data$context, _data$context$levelDe;
          // Only retry when empty and live
          const levelIndex = data.parent === PlaylistLevelType.MAIN ? data.level : hls.loadLevel;
          if (data.details === ErrorDetails.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) {
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
          } else {
            // Escalate to fatal if not retrying or switching
            data.levelRetry = false;
            data.errorAction = this.getLevelSwitchAction(data, levelIndex);
          }
        }
        return;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
        if (typeof (context == null ? void 0 : context.level) === 'number') {
          data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
        }
        return;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.SUBTITLE_LOAD_ERROR:
      case ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (context) {
          const level = hls.levels[hls.loadLevel];
          if (level && (context.type === PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
            // Perform Pathway switch or Redundant failover if possible for fastest recovery
            // otherwise allow playlist retry count to reach max error retries
            data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
            data.errorAction.action = NetworkErrorAction.SendAlternateToPenaltyBox;
            data.errorAction.flags = ErrorActionFlags.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const level = hls.levels[hls.loadLevel];
          const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
          if (restrictedHdcpLevel) {
            data.errorAction = {
              action: NetworkErrorAction.SendAlternateToPenaltyBox,
              flags: ErrorActionFlags.MoveAllAlternatesMatchingHDCP,
              hdcpLevel: restrictedHdcpLevel
            };
          } else {
            this.keySystemError(data);
          }
        }
        return;
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.REMUX_ALLOC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
        return;
      case ErrorDetails.INTERNAL_EXCEPTION:
      case ErrorDetails.BUFFER_APPENDING_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
      case ErrorDetails.LEVEL_SWITCH_ERROR:
      case ErrorDetails.BUFFER_STALLED_ERROR:
      case ErrorDetails.BUFFER_SEEK_OVER_HOLE:
      case ErrorDetails.BUFFER_NUDGE_ON_STALL:
        data.errorAction = {
          action: NetworkErrorAction.DoNothing,
          flags: ErrorActionFlags.None
        };
        return;
    }
    if (data.type === ErrorTypes.KEY_SYSTEM_ERROR) {
      this.keySystemError(data);
    }
  }
  keySystemError(data) {
    const levelIndex = this.getVariantLevelIndex(data.frag);
    // Do not retry level. Escalate to fatal if switching levels fails.
    data.levelRetry = false;
    data.errorAction = this.getLevelSwitchAction(data, levelIndex);
  }
  getPlaylistRetryOrSwitchAction(data, levelIndex) {
    const hls = this.hls;
    const retryConfig = getRetryConfig(hls.config.playlistLoadPolicy, data);
    const retryCount = this.playlistError++;
    const retry = shouldRetry(retryConfig, retryCount, isTimeoutError(data), data.response);
    if (retry) {
      return {
        action: NetworkErrorAction.RetryRequest,
        flags: ErrorActionFlags.None,
        retryConfig,
        retryCount
      };
    }
    const errorAction = this.getLevelSwitchAction(data, levelIndex);
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = retryCount;
    }
    return errorAction;
  }
  getFragRetryOrSwitchAction(data) {
    const hls = this.hls;
    // Share fragment error count accross media options (main, audio, subs)
    // This allows for level based rendition switching when media option assets fail
    const variantLevelIndex = this.getVariantLevelIndex(data.frag);
    const level = hls.levels[variantLevelIndex];
    const {
      fragLoadPolicy,
      keyLoadPolicy
    } = hls.config;
    const retryConfig = getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
    const fragmentErrors = hls.levels.reduce((acc, level) => acc + level.fragmentError, 0);
    // Switch levels when out of retried or level index out of bounds
    if (level) {
      if (data.details !== ErrorDetails.FRAG_GAP) {
        level.fragmentError++;
      }
      const retry = shouldRetry(retryConfig, fragmentErrors, isTimeoutError(data), data.response);
      if (retry) {
        return {
          action: NetworkErrorAction.RetryRequest,
          flags: ErrorActionFlags.None,
          retryConfig,
          retryCount: fragmentErrors
        };
      }
    }
    // Reach max retry count, or Missing level reference
    // Switch to valid index
    const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
    // Add retry details to allow skipping of FRAG_PARSING_ERROR
    if (retryConfig) {
      errorAction.retryConfig = retryConfig;
      errorAction.retryCount = fragmentErrors;
    }
    return errorAction;
  }
  getLevelSwitchAction(data, levelIndex) {
    const hls = this.hls;
    if (levelIndex === null || levelIndex === undefined) {
      levelIndex = hls.loadLevel;
    }
    const level = this.hls.levels[levelIndex];
    if (level) {
      var _data$frag2, _data$context2;
      const errorDetails = data.details;
      level.loadError++;
      if (errorDetails === ErrorDetails.BUFFER_APPEND_ERROR) {
        level.fragmentError++;
      }
      // Search for next level to retry
      let nextLevel = -1;
      const {
        levels,
        loadLevel,
        minAutoLevel,
        maxAutoLevel
      } = hls;
      if (!hls.autoLevelEnabled) {
        hls.loadLevel = -1;
      }
      const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
      // Find alternate audio codec if available on audio codec error
      const isAudioCodecError = fragErrorType === PlaylistLevelType.AUDIO && errorDetails === ErrorDetails.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findAudioCodecAlternate = isAudioCodecError && levels.some(({
        audioCodec
      }) => level.audioCodec !== audioCodec);
      // Find alternate video codec if available on video codec error
      const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === ErrorDetails.BUFFER_ADD_CODEC_ERROR || errorDetails === ErrorDetails.BUFFER_APPEND_ERROR);
      const findVideoCodecAlternate = isVideoCodecError && levels.some(({
        codecSet,
        audioCodec
      }) => level.codecSet !== codecSet && level.audioCodec === audioCodec);
      const {
        type: playlistErrorType,
        groupId: playlistErrorGroupId
      } = (_data$context2 = data.context) != null ? _data$context2 : {};
      for (let i = levels.length; i--;) {
        const candidate = (i + loadLevel) % levels.length;
        if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
          var _level$audioGroups, _level$subtitleGroups;
          const levelCandidate = levels[candidate];
          // Skip level switch if GAP tag is found in next level at same position
          if (errorDetails === ErrorDetails.FRAG_GAP && fragErrorType === PlaylistLevelType.MAIN && data.frag) {
            const levelDetails = levels[candidate].details;
            if (levelDetails) {
              const fragCandidate = findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
              if (fragCandidate != null && fragCandidate.gap) {
                continue;
              }
            }
          } else if (playlistErrorType === PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) {
            // For audio/subs playlist errors find another group ID or fallthrough to redundant fail-over
            continue;
          } else if (fragErrorType === PlaylistLevelType.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some(groupId => levelCandidate.hasAudioGroup(groupId)) || fragErrorType === PlaylistLevelType.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some(groupId => levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || !findAudioCodecAlternate && level.audioCodec !== levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet) {
            // For video/audio/subs frag errors find another group ID or fallthrough to redundant fail-over
            continue;
          }
          nextLevel = candidate;
          break;
        }
      }
      if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
        data.levelRetry = true;
        this.playlistError = 0;
        return {
          action: NetworkErrorAction.SendAlternateToPenaltyBox,
          flags: ErrorActionFlags.None,
          nextAutoLevel: nextLevel
        };
      }
    }
    // No levels to switch / Manual level selection / Level not found
    // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
    return {
      action: NetworkErrorAction.SendAlternateToPenaltyBox,
      flags: ErrorActionFlags.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(event, data) {
    var _data$errorAction;
    switch ((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action) {
      case NetworkErrorAction.DoNothing:
        break;
      case NetworkErrorAction.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(data);
        if (!data.errorAction.resolved && data.details !== ErrorDetails.FRAG_GAP) {
          data.fatal = true;
        } else if (/MediaSource readyState: ended/.test(data.error.message)) {
          this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
          this.hls.recoverMediaError();
        }
        break;
    }
    if (data.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(data) {
    const hls = this.hls;
    const errorAction = data.errorAction;
    if (!errorAction) {
      return;
    }
    const {
      flags,
      hdcpLevel,
      nextAutoLevel
    } = errorAction;
    switch (flags) {
      case ErrorActionFlags.None:
        this.switchLevel(data, nextAutoLevel);
        break;
      case ErrorActionFlags.MoveAllAlternatesMatchingHDCP:
        if (hdcpLevel) {
          hls.maxHdcpLevel = HdcpLevels[HdcpLevels.indexOf(hdcpLevel) - 1];
          errorAction.resolved = true;
        }
        this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
        break;
    }
    // If not resolved by previous actions try to switch to next level
    if (!errorAction.resolved) {
      this.switchLevel(data, nextAutoLevel);
    }
  }
  switchLevel(data, levelIndex) {
    if (levelIndex !== undefined && data.errorAction) {
      this.warn(`switching to level ${levelIndex} after ${data.details}`);
      this.hls.nextAutoLevel = levelIndex;
      data.errorAction.resolved = true;
      // Stream controller is responsible for this but won't switch on false start
      this.hls.nextLoadLevel = this.hls.nextAutoLevel;
    }
  }
}

class BasePlaylistController {
  constructor(hls, logPrefix) {
    this.hls = void 0;
    this.timer = -1;
    this.requestScheduled = -1;
    this.canLoad = false;
    this.log = void 0;
    this.warn = void 0;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
  }
  destroy() {
    this.clearTimer();
    // @ts-ignore
    this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    if (this.timer !== -1) {
      self.clearTimeout(this.timer);
      this.timer = -1;
    }
  }
  startLoad() {
    this.canLoad = true;
    this.requestScheduled = -1;
    this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = false;
    this.clearTimer();
  }
  switchParams(playlistUri, previous, current) {
    const renditionReports = previous == null ? void 0 : previous.renditionReports;
    if (renditionReports) {
      let foundIndex = -1;
      for (let i = 0; i < renditionReports.length; i++) {
        const attr = renditionReports[i];
        let uri;
        try {
          uri = new self.URL(attr.URI, previous.url).href;
        } catch (error) {
          logger.warn(`Could not construct new URL for Rendition Report: ${error}`);
          uri = attr.URI || '';
        }
        // Use exact match. Otherwise, the last partial match, if any, will be used
        // (Playlist URI includes a query string that the Rendition Report does not)
        if (uri === playlistUri) {
          foundIndex = i;
          break;
        } else if (uri === playlistUri.substring(0, uri.length)) {
          foundIndex = i;
        }
      }
      if (foundIndex !== -1) {
        const attr = renditionReports[foundIndex];
        const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
        let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
          if (part >= 0 && currentGoal > previous.partTarget) {
            part += 1;
          }
        }
        const skip = current && getSkipValue(current);
        return new HlsUrlParameters(msn, part >= 0 ? part : undefined, skip);
      }
    }
  }
  loadPlaylist(hlsUrlParameters) {
    if (this.requestScheduled === -1) {
      this.requestScheduled = self.performance.now();
    }
    // Loading is handled by the subclasses
  }
  shouldLoadPlaylist(playlist) {
    return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
  }
  shouldReloadPlaylist(playlist) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(playlist);
  }
  playlistLoaded(index, data, previousDetails) {
    const {
      details,
      stats
    } = data;

    // Set last updated date-time
    const now = self.performance.now();
    const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
    details.advancedDateTime = Date.now() - elapsed;

    // if current playlist is a live playlist, arm a timer to reload it
    if (details.live || previousDetails != null && previousDetails.live) {
      details.reloaded(previousDetails);
      if (previousDetails) {
        this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
      }
      // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
      if (previousDetails && details.fragments.length > 0) {
        mergeDetails(previousDetails, details);
      }
      if (!this.canLoad || !details.live) {
        return;
      }
      let deliveryDirectives;
      let msn = undefined;
      let part = undefined;
      if (details.canBlockReload && details.endSN && details.advanced) {
        // Load level with LL-HLS delivery directives
        const lowLatencyMode = this.hls.config.lowLatencyMode;
        const lastPartSn = details.lastPartSn;
        const endSn = details.endSN;
        const lastPartIndex = details.lastPartIndex;
        const hasParts = lastPartIndex !== -1;
        const lastPart = lastPartSn === endSn;
        // When low latency mode is disabled, we'll skip part requests once the last part index is found
        const nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
        if (hasParts) {
          msn = lastPart ? endSn + 1 : lastPartSn;
          part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
        } else {
          msn = endSn + 1;
        }
        // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
        // Update directives to obtain the Playlist that has the estimated additional duration of media
        const lastAdvanced = details.age;
        const cdnAge = lastAdvanced + details.ageHeader;
        let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
        if (currentGoal > 0) {
          if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
            // If we attempted to get the next or latest playlist update, but currentGoal increased,
            // then we either can't catchup, or the "age" header cannot be trusted.
            this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
            currentGoal = 0;
          } else {
            const segments = Math.floor(currentGoal / details.targetduration);
            msn += segments;
            if (part !== undefined) {
              const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
              part += parts;
            }
            this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
          }
          details.tuneInGoal = currentGoal;
        }
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
        if (lowLatencyMode || !lastPart) {
          this.loadPlaylist(deliveryDirectives);
          return;
        }
      } else if (details.canBlockReload || details.canSkipUntil) {
        deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
      }
      const bufferInfo = this.hls.mainForwardBufferInfo;
      const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
      const distanceToLiveEdgeMs = (details.edge - position) * 1000;
      const reloadInterval = computeReloadInterval(details, distanceToLiveEdgeMs);
      if (details.updated && now > this.requestScheduled + reloadInterval) {
        this.requestScheduled = stats.loading.start;
      }
      if (msn !== undefined && details.canBlockReload) {
        this.requestScheduled = stats.loading.first + reloadInterval - (details.partTarget * 1000 || 1000);
      } else if (this.requestScheduled === -1 || this.requestScheduled + reloadInterval < now) {
        this.requestScheduled = now;
      } else if (this.requestScheduled - now <= 0) {
        this.requestScheduled += reloadInterval;
      }
      let estimatedTimeUntilUpdate = this.requestScheduled - now;
      estimatedTimeUntilUpdate = Math.max(0, estimatedTimeUntilUpdate);
      this.log(`reload live playlist ${index} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
      // this.log(
      //   `live reload ${details.updated ? 'REFRESHED' : 'MISSED'}
      // reload in ${estimatedTimeUntilUpdate / 1000}
      // round trip ${(stats.loading.end - stats.loading.start) / 1000}
      // diff ${
      //   (reloadInterval -
      //     (estimatedTimeUntilUpdate +
      //       stats.loading.end -
      //       stats.loading.start)) /
      //   1000
      // }
      // reload interval ${reloadInterval / 1000}
      // target duration ${details.targetduration}
      // distance to edge ${distanceToLiveEdgeMs / 1000}`
      // );

      this.timer = self.setTimeout(() => this.loadPlaylist(deliveryDirectives), estimatedTimeUntilUpdate);
    } else {
      this.clearTimer();
    }
  }
  getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
    let skip = getSkipValue(details);
    if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
      msn = previousDeliveryDirectives.msn;
      part = previousDeliveryDirectives.part;
      skip = HlsSkip.No;
    }
    return new HlsUrlParameters(msn, part, skip);
  }
  checkRetry(errorEvent) {
    const errorDetails = errorEvent.details;
    const isTimeout = isTimeoutError(errorEvent);
    const errorAction = errorEvent.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    const retry = !!errorAction && !!retryConfig && (action === NetworkErrorAction.RetryRequest || !errorAction.resolved && action === NetworkErrorAction.SendAlternateToPenaltyBox);
    if (retry) {
      var _errorEvent$context;
      this.requestScheduled = -1;
      if (retryCount >= retryConfig.maxNumRetry) {
        return false;
      }
      if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
        // The LL-HLS request already timed out so retry immediately
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
        this.loadPlaylist();
      } else {
        const delay = getRetryDelay(retryConfig, retryCount);
        // Schedule level/track reload
        this.timer = self.setTimeout(() => this.loadPlaylist(), delay);
        this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
      }
      // `levelRetry = true` used to inform other controllers that a retry is happening
      errorEvent.levelRetry = true;
      errorAction.resolved = true;
    }
    return retry;
  }
}

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

class EWMA {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(halfLife, estimate = 0, weight = 0) {
    this.halfLife = void 0;
    this.alpha_ = void 0;
    this.estimate_ = void 0;
    this.totalWeight_ = void 0;
    this.halfLife = halfLife;
    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = estimate;
    this.totalWeight_ = weight;
  }
  sample(weight, value) {
    const adjAlpha = Math.pow(this.alpha_, weight);
    this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
    this.totalWeight_ += weight;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (zeroFactor) {
        return this.estimate_ / zeroFactor;
      }
    }
    return this.estimate_;
  }
}

/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */

class EwmaBandWidthEstimator {
  constructor(slow, fast, defaultEstimate, defaultTTFB = 100) {
    this.defaultEstimate_ = void 0;
    this.minWeight_ = void 0;
    this.minDelayMs_ = void 0;
    this.slow_ = void 0;
    this.fast_ = void 0;
    this.defaultTTFB_ = void 0;
    this.ttfb_ = void 0;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new EWMA(slow);
    this.fast_ = new EWMA(fast);
    this.defaultTTFB_ = defaultTTFB;
    this.ttfb_ = new EWMA(slow);
  }
  update(slow, fast) {
    const {
      slow_,
      fast_,
      ttfb_
    } = this;
    if (slow_.halfLife !== slow) {
      this.slow_ = new EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
    }
    if (fast_.halfLife !== fast) {
      this.fast_ = new EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
    }
    if (ttfb_.halfLife !== slow) {
      this.ttfb_ = new EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
  }
  sample(durationMs, numBytes) {
    durationMs = Math.max(durationMs, this.minDelayMs_);
    const numBits = 8 * numBytes;
    // weight is duration in seconds
    const durationS = durationMs / 1000;
    // value is bandwidth in bits/s
    const bandwidthInBps = numBits / durationS;
    this.fast_.sample(durationS, bandwidthInBps);
    this.slow_.sample(durationS, bandwidthInBps);
  }
  sampleTTFB(ttfb) {
    // weight is frequency curve applied to TTFB in seconds
    // (longer times have less weight with expected input under 1 second)
    const seconds = ttfb / 1000;
    const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
    this.ttfb_.sample(weight, Math.max(ttfb, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    if (this.canEstimate()) {
      // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
      // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
      // Take the minimum of these two estimates.  This should have the effect of
      // adapting down quickly, but up more slowly.
      return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
    } else {
      return this.defaultEstimate_;
    }
  }
  getEstimateTTFB() {
    if (this.ttfb_.getTotalWeight() >= this.minWeight_) {
      return this.ttfb_.getEstimate();
    } else {
      return this.defaultTTFB_;
    }
  }
  destroy() {}
}

const SUPPORTED_INFO_DEFAULT = {
  supported: true,
  configurations: [],
  decodingInfoResults: [{
    supported: true,
    powerEfficient: true,
    smooth: true
  }]
};
const SUPPORTED_INFO_CACHE = {};
function requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
  // Only test support when configuration is exceeds minimum options
  const audioGroups = level.audioCodec ? level.audioGroups : null;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
  let audioChannels = null;
  if (audioGroups != null && audioGroups.length) {
    try {
      if (audioGroups.length === 1 && audioGroups[0]) {
        audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
      } else {
        audioChannels = audioGroups.reduce((acc, groupId) => {
          if (groupId) {
            const audioTrackGroup = audioTracksByGroup.groups[groupId];
            if (!audioTrackGroup) {
              throw new Error(`Audio track group ${groupId} not found`);
            }
            // Sum all channel key values
            Object.keys(audioTrackGroup.channels).forEach(key => {
              acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
            });
          }
          return acc;
        }, {
          2: 0
        });
      }
    } catch (error) {
      return true;
    }
  }
  return level.videoCodec !== undefined && (level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && isFiniteNumber(maxChannels) && Object.keys(audioChannels).some(channels => parseInt(channels) > maxChannels);
}
function getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities) {
  const videoCodecs = level.videoCodec;
  const audioCodecs = level.audioCodec;
  if (!videoCodecs || !audioCodecs || !mediaCapabilities) {
    return Promise.resolve(SUPPORTED_INFO_DEFAULT);
  }
  const baseVideoConfiguration = {
    width: level.width,
    height: level.height,
    bitrate: Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: level.frameRate || 30
  };
  const videoRange = level.videoRange;
  if (videoRange !== 'SDR') {
    baseVideoConfiguration.transferFunction = videoRange.toLowerCase();
  }
  const configurations = videoCodecs.split(',').map(videoCodec => ({
    type: 'media-source',
    video: _objectSpread2(_objectSpread2({}, baseVideoConfiguration), {}, {
      contentType: mimeTypeForCodec(videoCodec, 'video')
    })
  }));
  if (audioCodecs && level.audioGroups) {
    level.audioGroups.forEach(audioGroupId => {
      var _audioTracksByGroup$g;
      if (!audioGroupId) {
        return;
      }
      (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null ? void 0 : _audioTracksByGroup$g.tracks.forEach(audioTrack => {
        if (audioTrack.groupId === audioGroupId) {
          const channels = audioTrack.channels || '';
          const channelsNumber = parseFloat(channels);
          if (isFiniteNumber(channelsNumber) && channelsNumber > 2) {
            configurations.push.apply(configurations, audioCodecs.split(',').map(audioCodec => ({
              type: 'media-source',
              audio: {
                contentType: mimeTypeForCodec(audioCodec, 'audio'),
                channels: '' + channelsNumber
                // spatialRendering:
                //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
              }
            })));
          }
        }
      });
    });
  }
  return Promise.all(configurations.map(configuration => {
    // Cache MediaCapabilities promises
    const decodingInfoKey = getMediaDecodingInfoKey(configuration);
    return SUPPORTED_INFO_CACHE[decodingInfoKey] || (SUPPORTED_INFO_CACHE[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
  })).then(decodingInfoResults => ({
    supported: !decodingInfoResults.some(info => !info.supported),
    configurations,
    decodingInfoResults
  })).catch(error => ({
    supported: false,
    configurations,
    decodingInfoResults: [],
    error
  }));
}
function getMediaDecodingInfoKey(config) {
  const {
    audio,
    video
  } = config;
  const mediaConfig = video || audio;
  if (mediaConfig) {
    const codec = mediaConfig.contentType.split('"')[1];
    if (video) {
      return `r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${codec}_${Math.ceil(video.bitrate / 1e5)}`;
    }
    if (audio) {
      return `c${audio.channels}${audio.spatialRendering ? 's' : 'n'}_${codec}`;
    }
  }
  return '';
}

/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */
function isHdrSupported() {
  if (typeof matchMedia === 'function') {
    const mediaQueryList = matchMedia('(dynamic-range: high)');
    const badQuery = matchMedia('bad query');
    if (mediaQueryList.media !== badQuery.media) {
      return mediaQueryList.matches === true;
    }
  }
  return false;
}

/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */
function getVideoSelectionOptions(currentVideoRange, videoPreference) {
  let preferHDR = false;
  let allowedVideoRanges = [];
  if (currentVideoRange) {
    preferHDR = currentVideoRange !== 'SDR';
    allowedVideoRanges = [currentVideoRange];
  }
  if (videoPreference) {
    allowedVideoRanges = videoPreference.allowedVideoRanges || VideoRangeValues.slice(0);
    preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : isHdrSupported();
    if (preferHDR) {
      allowedVideoRanges = allowedVideoRanges.filter(range => range !== 'SDR');
    } else {
      allowedVideoRanges = ['SDR'];
    }
  }
  return {
    preferHDR,
    allowedVideoRanges
  };
}

function getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
  const codecSets = Object.keys(codecTiers);
  const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
  const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
  const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
  // Use first level set to determine stereo, and minimum resolution and framerate
  let hasStereo = true;
  let hasCurrentVideoRange = false;
  let minHeight = Infinity;
  let minFramerate = Infinity;
  let minBitrate = Infinity;
  let selectedScore = 0;
  let videoRanges = [];
  const {
    preferHDR,
    allowedVideoRanges
  } = getVideoSelectionOptions(currentVideoRange, videoPreference);
  for (let i = codecSets.length; i--;) {
    const tier = codecTiers[codecSets[i]];
    hasStereo = tier.channels[2] > 0;
    minHeight = Math.min(minHeight, tier.minHeight);
    minFramerate = Math.min(minFramerate, tier.minFramerate);
    minBitrate = Math.min(minBitrate, tier.minBitrate);
    const matchingVideoRanges = allowedVideoRanges.filter(range => tier.videoRanges[range] > 0);
    if (matchingVideoRanges.length > 0) {
      hasCurrentVideoRange = true;
      videoRanges = matchingVideoRanges;
    }
  }
  minHeight = isFiniteNumber(minHeight) ? minHeight : 0;
  minFramerate = isFiniteNumber(minFramerate) ? minFramerate : 0;
  const maxHeight = Math.max(1080, minHeight);
  const maxFramerate = Math.max(30, minFramerate);
  minBitrate = isFiniteNumber(minBitrate) ? minBitrate : currentBw;
  currentBw = Math.max(minBitrate, currentBw);
  // If there are no variants with matching preference, set currentVideoRange to undefined
  if (!hasCurrentVideoRange) {
    currentVideoRange = undefined;
    videoRanges = [];
  }
  const codecSet = codecSets.reduce((selected, candidate) => {
    // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
    const candidateTier = codecTiers[candidate];
    if (candidate === selected) {
      return selected;
    }
    if (candidateTier.minBitrate > currentBw) {
      logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
      return selected;
    }
    if (!candidateTier.hasDefaultAudio) {
      logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
      return selected;
    }
    if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
      logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
      return selected;
    }
    if (channelsPreference && !preferStereo) {
      if (!candidateTier.channels[channelsPreference]) {
        logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
        return selected;
      }
    } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
      logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
      return selected;
    }
    if (candidateTier.minHeight > maxHeight) {
      logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
      return selected;
    }
    if (candidateTier.minFramerate > maxFramerate) {
      logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
      return selected;
    }
    if (!videoRanges.some(range => candidateTier.videoRanges[range] > 0)) {
      logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${JSON.stringify(videoRanges)} found`);
      return selected;
    }
    if (candidateTier.maxScore < selectedScore) {
      logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
      return selected;
    }
    // Remove candiates with less preferred codecs or more errors
    if (selected && (codecsSetSelectionPreferenceValue(candidate) >= codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) {
      return selected;
    }
    selectedScore = candidateTier.maxScore;
    return candidate;
  }, undefined);
  return {
    codecSet,
    videoRanges,
    preferHDR,
    minFramerate,
    minBitrate
  };
}
function logStartCodecCandidateIgnored(codeSet, reason) {
  logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function getAudioTracksByGroup(allAudioTracks) {
  return allAudioTracks.reduce((audioTracksByGroup, track) => {
    let trackGroup = audioTracksByGroup.groups[track.groupId];
    if (!trackGroup) {
      trackGroup = audioTracksByGroup.groups[track.groupId] = {
        tracks: [],
        channels: {
          2: 0
        },
        hasDefault: false,
        hasAutoSelect: false
      };
    }
    trackGroup.tracks.push(track);
    const channelsKey = track.channels || '2';
    trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
    trackGroup.hasDefault = trackGroup.hasDefault || track.default;
    trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
    if (trackGroup.hasDefault) {
      audioTracksByGroup.hasDefaultAudio = true;
    }
    if (trackGroup.hasAutoSelect) {
      audioTracksByGroup.hasAutoSelectAudio = true;
    }
    return audioTracksByGroup;
  }, {
    hasDefaultAudio: false,
    hasAutoSelectAudio: false,
    groups: {}
  });
}
function getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
  return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level) => {
    if (!level.codecSet) {
      return tiers;
    }
    const audioGroups = level.audioGroups;
    let tier = tiers[level.codecSet];
    if (!tier) {
      tiers[level.codecSet] = tier = {
        minBitrate: Infinity,
        minHeight: Infinity,
        minFramerate: Infinity,
        maxScore: 0,
        videoRanges: {
          SDR: 0
        },
        channels: {
          '2': 0
        },
        hasDefaultAudio: !audioGroups,
        fragmentError: 0
      };
    }
    tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
    const lesserWidthOrHeight = Math.min(level.height, level.width);
    tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
    tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
    tier.maxScore = Math.max(tier.maxScore, level.score);
    tier.fragmentError += level.fragmentError;
    tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
    if (audioGroups) {
      audioGroups.forEach(audioGroupId => {
        if (!audioGroupId) {
          return;
        }
        const audioGroup = audioTracksByGroup.groups[audioGroupId];
        if (!audioGroup) {
          return;
        }
        // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
        tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
        Object.keys(audioGroup.channels).forEach(channels => {
          tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
        });
      });
    }
    return tiers;
  }, {});
}
function findMatchingOption(option, tracks, matchPredicate) {
  if ('attrs' in option) {
    const index = tracks.indexOf(option);
    if (index !== -1) {
      return index;
    }
  }
  for (let i = 0; i < tracks.length; i++) {
    const track = tracks[i];
    if (matchesOption(option, track, matchPredicate)) {
      return i;
    }
  }
  return -1;
}
function matchesOption(option, track, matchPredicate) {
  const {
    groupId,
    name,
    lang,
    assocLang,
    characteristics,
    default: isDefault
  } = option;
  const forced = option.forced;
  return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || track.lang === lang) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (characteristics === undefined || characteristicsMatch(characteristics, track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function characteristicsMatch(characteristicsA, characteristicsB = '') {
  const arrA = characteristicsA.split(',');
  const arrB = characteristicsB.split(',');
  // Expects each item to be unique:
  return arrA.length === arrB.length && !arrA.some(el => arrB.indexOf(el) === -1);
}
function audioMatchPredicate(option, track) {
  const {
    audioCodec,
    channels
  } = option;
  return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
  const currentLevel = levels[searchIndex];
  // Are there variants with same URI as current level?
  // If so, find a match that does not require any level URI change
  const variants = levels.reduce((variantMap, level, index) => {
    const uri = level.uri;
    const renditions = variantMap[uri] || (variantMap[uri] = []);
    renditions.push(index);
    return variantMap;
  }, {});
  const renditions = variants[currentLevel.uri];
  if (renditions.length > 1) {
    searchIndex = Math.max.apply(Math, renditions);
  }
  // Find best match
  const currentVideoRange = currentLevel.videoRange;
  const currentFrameRate = currentLevel.frameRate;
  const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
  const matchingVideo = searchDownAndUpList(levels, searchIndex, level => {
    if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) {
      return false;
    }
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
  if (matchingVideo > -1) {
    return matchingVideo;
  }
  return searchDownAndUpList(levels, searchIndex, level => {
    const audioGroups = level.audioGroups;
    const tracks = allAudioTracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
    return findMatchingOption(option, tracks, matchPredicate) > -1;
  });
}
function searchDownAndUpList(arr, searchIndex, predicate) {
  for (let i = searchIndex; i; i--) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  for (let i = searchIndex + 1; i < arr.length; i++) {
    if (predicate(arr[i])) {
      return i;
    }
  }
  return -1;
}

class AbrController {
  constructor(_hls) {
    this.hls = void 0;
    this.lastLevelLoadSec = 0;
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this._nextAutoLevel = -1;
    this.nextAutoLevelKey = '';
    this.audioTracksByGroup = null;
    this.codecTiers = null;
    this.timer = -1;
    this.fragCurrent = null;
    this.partCurrent = null;
    this.bitrateTestDelay = 0;
    this.bwEstimator = void 0;
    /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */
    this._abandonRulesCheck = () => {
      const {
        fragCurrent: frag,
        partCurrent: part,
        hls
      } = this;
      const {
        autoLevelEnabled,
        media
      } = hls;
      if (!frag || !media) {
        return;
      }
      const now = performance.now();
      const stats = part ? part.stats : frag.stats;
      const duration = part ? part.duration : frag.duration;
      const timeLoading = now - stats.loading.start;
      const minAutoLevel = hls.minAutoLevel;
      // If frag loading is aborted, complete, or from lowest level, stop timer and return
      if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level <= minAutoLevel) {
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;
        return;
      }

      // This check only runs if we're in ABR mode and actually playing
      if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) {
        return;
      }
      const bufferInfo = hls.mainForwardBufferInfo;
      if (bufferInfo === null) {
        return;
      }
      const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
      const playbackRate = Math.abs(media.playbackRate);
      // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
      if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) {
        return;
      }

      // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
      const bufferStarvationDelay = bufferInfo.len / playbackRate;
      const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
      const loadedFirstByte = stats.loaded && ttfb > -1;
      const bwEstimate = this.getBwEstimate();
      const levels = hls.levels;
      const level = levels[frag.level];
      const expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.averageBitrate / 8));
      let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
      if (timeStreaming < 1 && loadedFirstByte) {
        timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
      }
      const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
      // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
      const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbEstimate / 1000;
      // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
      if (fragLoadedDelay <= bufferStarvationDelay) {
        return;
      }
      const bwe = loadRate ? loadRate * 8 : bwEstimate;
      let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
      let nextLoadLevel;
      // Iterate through lower level and try to find the largest one that avoids rebuffering
      for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
        // compute time to load next fragment at lower level
        // 8 = bits per byte (bps/Bps)
        const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
        fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbEstimate / 1000, bwe, duration * levelNextBitrate, !levels[nextLoadLevel].details);
        if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
          break;
        }
      }
      // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
      // to load the current one
      if (fragLevelNextLoadedDelay >= fragLoadedDelay) {
        return;
      }

      // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
      if (fragLevelNextLoadedDelay > duration * 10) {
        return;
      }
      hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
      if (loadedFirstByte) {
        // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
        this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
      } else {
        // If there has been no loading progress, sample TTFB
        this.bwEstimator.sampleTTFB(timeLoading);
      }
      const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
      if (this.getBwEstimate() * this.hls.config.abrBandWidthUpFactor > nextLoadLevelBitrate) {
        this.resetEstimator(nextLoadLevelBitrate);
      }
      this.clearTimer();
      logger.warn(`[abr] Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} is loading too slowly;
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
      hls.trigger(Events.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag,
        part,
        stats
      });
    };
    this.hls = _hls;
    this.bwEstimator = this.initEstimator();
    this.registerListeners();
  }
  resetEstimator(abrEwmaDefaultEstimate) {
    if (abrEwmaDefaultEstimate) {
      logger.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
      this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
    }
    this.firstSelection = -1;
    this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const config = this.hls.config;
    return new EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.clearTimer();
    // @ts-ignore
    this.hls = this._abandonRulesCheck = null;
    this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(event, data) {
    this.lastLoadedFragLevel = -1;
    this.firstSelection = -1;
    this.lastLevelLoadSec = 0;
    this.fragCurrent = this.partCurrent = null;
    this.onLevelsUpdated();
    this.clearTimer();
  }
  onLevelsUpdated() {
    if (this.lastLoadedFragLevel > -1 && this.fragCurrent) {
      this.lastLoadedFragLevel = this.fragCurrent.level;
    }
    this._nextAutoLevel = -1;
    this.onMaxAutoLevelUpdated();
    this.codecTiers = null;
    this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1;
    this.nextAutoLevelKey = '';
  }
  onFragLoading(event, data) {
    const frag = data.frag;
    if (this.ignoreFragment(frag)) {
      return;
    }
    if (!frag.bitrateTest) {
      var _data$part;
      this.fragCurrent = frag;
      this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
    }
    this.clearTimer();
    this.timer = self.setInterval(this._abandonRulesCheck, 100);
  }
  onLevelSwitching(event, data) {
    this.clearTimer();
  }
  onError(event, data) {
    if (data.fatal) {
      return;
    }
    switch (data.details) {
      case ErrorDetails.BUFFER_ADD_CODEC_ERROR:
      case ErrorDetails.BUFFER_APPEND_ERROR:
        // Reset last loaded level so that a new selection can be made after calling recoverMediaError
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        break;
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
        {
          const frag = data.frag;
          const {
            fragCurrent,
            partCurrent: part
          } = this;
          if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const timeLoading = now - stats.loading.start;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            if (loadedFirstByte) {
              const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            } else {
              this.bwEstimator.sampleTTFB(timeLoading);
            }
          }
          break;
        }
    }
  }
  getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
    const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
    const playlistLoadSec = isSwitch ? this.lastLevelLoadSec : 0;
    return fragLoadSec + playlistLoadSec;
  }
  onLevelLoaded(event, data) {
    const config = this.hls.config;
    const {
      loading
    } = data.stats;
    const timeLoadingMs = loading.end - loading.start;
    if (isFiniteNumber(timeLoadingMs)) {
      this.lastLevelLoadSec = timeLoadingMs / 1000;
    }
    if (data.details.live) {
      this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
    } else {
      this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
    }
  }
  onFragLoaded(event, {
    frag,
    part
  }) {
    const stats = part ? part.stats : frag.stats;
    if (frag.type === PlaylistLevelType.MAIN) {
      this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // stop monitoring bw once frag loaded
    this.clearTimer();
    // reset forced auto level value so that next level will be selected
    if (frag.level === this._nextAutoLevel) {
      this._nextAutoLevel = -1;
    }
    this.firstSelection = -1;

    // compute level average bitrate
    if (this.hls.config.abrMaxWithRealBitrate) {
      const duration = part ? part.duration : frag.duration;
      const level = this.hls.levels[frag.level];
      const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
      const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
      level.loaded = {
        bytes: loadedBytes,
        duration: loadedDuration
      };
      level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
    }
    if (frag.bitrateTest) {
      const fragBufferedData = {
        stats,
        frag,
        part,
        id: frag.type
      };
      this.onFragBuffered(Events.FRAG_BUFFERED, fragBufferedData);
      frag.bitrateTest = false;
    } else {
      // store level id after successful fragment load for playback
      this.lastLoadedFragLevel = frag.level;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
    if (stats.aborted) {
      return;
    }
    if (this.ignoreFragment(frag)) {
      return;
    }
    // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
    // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
    // is used. If we used buffering in that case, our BW estimate sample will be very large.
    const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(processingMs, stats.loaded);
    stats.bwEstimate = this.getBwEstimate();
    if (frag.bitrateTest) {
      this.bitrateTestDelay = processingMs / 1000;
    } else {
      this.bitrateTestDelay = 0;
    }
  }
  ignoreFragment(frag) {
    // Only count non-alt-audio frags which were actually buffered in our BW calculations
    return frag.type !== PlaylistLevelType.MAIN || frag.sn === 'initSegment';
  }
  clearTimer() {
    if (this.timer > -1) {
      self.clearInterval(this.timer);
      this.timer = -1;
    }
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    const bwEstimate = this.getBwEstimate();
    const maxStartDelay = this.hls.config.maxStarvationDelay;
    const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
    if (abrAutoLevel > -1) {
      return abrAutoLevel;
    }
    const firstLevel = this.hls.firstLevel;
    const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
    logger.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
    return clamped;
  }
  get forcedAutoLevel() {
    if (this.nextAutoLevelKey) {
      return -1;
    }
    return this._nextAutoLevel;
  }

  // return next auto level
  get nextAutoLevel() {
    const forcedAutoLevel = this.forcedAutoLevel;
    const bwEstimator = this.bwEstimator;
    const useEstimate = bwEstimator.canEstimate();
    const loadedFirstFrag = this.lastLoadedFragLevel > -1;
    // in case next auto level has been forced, and bw not available or not reliable, return forced value
    if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) {
      return forcedAutoLevel;
    }

    // compute next level using ABR logic
    const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;

    // use forced auto level while it hasn't errored more than ABR selection
    if (forcedAutoLevel !== -1) {
      const levels = this.hls.levels;
      if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) {
        return forcedAutoLevel;
      }
    }

    // save result until state has changed
    this._nextAutoLevel = nextABRAutoLevel;
    this.nextAutoLevelKey = this.getAutoLevelKey();
    return nextABRAutoLevel;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent,
      partCurrent,
      hls
    } = this;
    const {
      maxAutoLevel,
      config,
      minAutoLevel
    } = hls;
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const avgbw = this.getBwEstimate();
    // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
    const bufferStarvationDelay = this.getStarvationDelay();
    let bwFactor = config.abrBandWidthFactor;
    let bwUpFactor = config.abrBandWidthUpFactor;

    // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
    if (bufferStarvationDelay) {
      const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
      if (_bestLevel >= 0) {
        return _bestLevel;
      }
    }
    // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
    let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
    if (!bufferStarvationDelay) {
      // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
      const bitrateTestDelay = this.bitrateTestDelay;
      if (bitrateTestDelay) {
        // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
        // max video loading delay used in  automatic start level selection :
        // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
        // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
        // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
        const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
        maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
        logger.info(`[abr] bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
        // don't use conservative factor on bitrate test
        bwFactor = bwUpFactor = 1;
      }
    }
    const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
    logger.info(`[abr] ${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
    if (bestLevel > -1) {
      return bestLevel;
    }
    // If no matching level found, see if min auto level would be a better option
    const minLevel = hls.levels[minAutoLevel];
    const autoLevel = hls.levels[hls.loadLevel];
    if ((minLevel == null ? void 0 : minLevel.bitrate) < (autoLevel == null ? void 0 : autoLevel.bitrate)) {
      return minAutoLevel;
    }
    // or if bitrate is not lower, continue to use loadLevel
    return hls.loadLevel;
  }
  getStarvationDelay() {
    const hls = this.hls;
    const media = hls.media;
    if (!media) {
      return Infinity;
    }
    // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
    // if we're playing back at the normal rate.
    const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
    const bufferInfo = hls.mainForwardBufferInfo;
    return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
    var _level$details;
    const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
    const lastLoadedFragLevel = this.lastLoadedFragLevel;
    const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
    const {
      fragCurrent,
      partCurrent
    } = this;
    const {
      levels,
      allAudioTracks,
      loadLevel,
      config
    } = this.hls;
    if (levels.length === 1) {
      return 0;
    }
    const level = levels[selectionBaseLevel];
    const live = !!(level != null && (_level$details = level.details) != null && _level$details.live);
    const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
    let currentCodecSet;
    let currentVideoRange = 'SDR';
    let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
    const {
      audioPreference,
      videoPreference
    } = config;
    const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = getAudioTracksByGroup(allAudioTracks));
    if (firstSelection) {
      if (this.firstSelection !== -1) {
        return this.firstSelection;
      }
      const codecTiers = this.codecTiers || (this.codecTiers = getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
      const startTier = getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
      const {
        codecSet,
        videoRanges,
        minFramerate,
        minBitrate,
        preferHDR
      } = startTier;
      currentCodecSet = codecSet;
      currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
      currentFrameRate = minFramerate;
      currentBw = Math.max(currentBw, minBitrate);
      logger.log(`[abr] picked start tier ${JSON.stringify(startTier)}`);
    } else {
      currentCodecSet = level == null ? void 0 : level.codecSet;
      currentVideoRange = level == null ? void 0 : level.videoRange;
    }
    const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
    const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
    const levelsSkipped = [];
    for (let i = maxAutoLevel; i >= minAutoLevel; i--) {
      var _levelInfo$supportedR;
      const levelInfo = levels[i];
      const upSwitch = i > selectionBaseLevel;
      if (!levelInfo) {
        continue;
      }
      if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
        const mediaCapabilities = navigator.mediaCapabilities;
        if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference)) {
          levelInfo.supportedPromise = getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities);
          levelInfo.supportedPromise.then(decodingInfo => {
            if (!this.hls) {
              return;
            }
            levelInfo.supportedResult = decodingInfo;
            const levels = this.hls.levels;
            const index = levels.indexOf(levelInfo);
            if (decodingInfo.error) {
              logger.warn(`[abr] MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${JSON.stringify(decodingInfo)}`);
            } else if (!decodingInfo.supported) {
              logger.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${index} ${JSON.stringify(decodingInfo)}`);
              if (index > -1 && levels.length > 1) {
                logger.log(`[abr] Removing unsupported level ${index}`);
                this.hls.removeLevel(index);
              }
            }
          });
        } else {
          levelInfo.supportedResult = SUPPORTED_INFO_DEFAULT;
        }
      }

      // skip candidates which change codec-family or video-range,
      // and which decrease or increase frame-rate for up and down-switch respectfully
      if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || levelInfo.supportedResult && !((_levelInfo$supportedR = levelInfo.supportedResult.decodingInfoResults) != null && _levelInfo$supportedR[0].smooth)) {
        levelsSkipped.push(i);
        continue;
      }
      const levelDetails = levelInfo.details;
      const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
      let adjustedbw;
      // follow algorithm captured from stagefright :
      // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
      // Pick the highest bandwidth stream below or equal to estimated bandwidth.
      // consider only 80% of the available bandwidth, but if we are switching up,
      // be even more conservative (70%) to avoid overestimating and immediately
      // switching back.
      if (!upSwitch) {
        adjustedbw = bwFactor * currentBw;
      } else {
        adjustedbw = bwUpFactor * currentBw;
      }

      // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
      const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levels[i].averageBitrate : levels[i].maxBitrate;
      const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
      const canSwitchWithinTolerance =
      // if adjusted bw is greater than level bitrate AND
      adjustedbw >= bitrate && (
      // no level change, or new level has no error history
      i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && (
      // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
      fetchDuration <= ttfbEstimateSec || !isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
      if (canSwitchWithinTolerance) {
        const forcedAutoLevel = this.forcedAutoLevel;
        if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
          if (levelsSkipped.length) {
            logger.trace(`[abr] Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${level.codecs}" ${currentVideoRange}`);
          }
          logger.info(`[abr] switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${currentCodecSet} videoRange:${currentVideoRange} hls.loadLevel:${loadLevel}`);
        }
        if (firstSelection) {
          this.firstSelection = i;
        }
        // as we are looping from highest to lowest, this will return the best achievable quality level
        return i;
      }
    }
    // not enough time budget even with quality level 0 ... rebuffering might happen
    return -1;
  }
  set nextAutoLevel(nextLevel) {
    const {
      maxAutoLevel,
      minAutoLevel
    } = this.hls;
    const value = Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
    if (this._nextAutoLevel !== value) {
      this.nextAutoLevelKey = '';
      this._nextAutoLevel = value;
    }
  }
}

/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */
class TaskLoop {
  constructor() {
    this._boundTick = void 0;
    this._tickTimer = null;
    this._tickInterval = null;
    this._tickCallCount = 0;
    this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying();
    this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    // clear all timers before unregistering from event bus
    this.clearNextTick();
    this.clearInterval();
  }
  onHandlerDestroyed() {}
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }

  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(millis) {
    if (!this._tickInterval) {
      this._tickCallCount = 0;
      this._tickInterval = self.setInterval(this._boundTick, millis);
      return true;
    }
    return false;
  }

  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    if (this._tickInterval) {
      self.clearInterval(this._tickInterval);
      this._tickInterval = null;
      return true;
    }
    return false;
  }

  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    if (this._tickTimer) {
      self.clearTimeout(this._tickTimer);
      this._tickTimer = null;
      return true;
    }
    return false;
  }

  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++;
    if (this._tickCallCount === 1) {
      this.doTick();
      // re-entrant call to tick from previous doTick call stack
      // -> schedule a call on the next main loop iteration to process this task processing request
      if (this._tickCallCount > 1) {
        // make sure only one timer exists at any time at max
        this.tickImmediate();
      }
      this._tickCallCount = 0;
    }
  }
  tickImmediate() {
    this.clearNextTick();
    this._tickTimer = self.setTimeout(this._boundTick, 0);
  }

  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {}
}

var FragmentState = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class FragmentTracker {
  constructor(hls) {
    this.activePartLists = Object.create(null);
    this.endListFragments = Object.create(null);
    this.fragments = Object.create(null);
    this.timeRanges = Object.create(null);
    this.bufferPadding = 0.2;
    this.hls = void 0;
    this.hasGaps = false;
    this.hls = hls;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.BUFFER_APPENDED, this.onBufferAppended, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners();
    // @ts-ignore
    this.fragments =
    // @ts-ignore
    this.activePartLists =
    // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }

  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(position, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (activeParts) {
      for (let i = activeParts.length; i--;) {
        const activePart = activeParts[i];
        if (!activePart) {
          break;
        }
        const appendedPTS = activePart.end;
        if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) {
          return activePart;
        }
      }
    }
    return this.getBufferedFrag(position, levelType);
  }

  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(position, levelType) {
    const {
      fragments
    } = this;
    const keys = Object.keys(fragments);
    for (let i = keys.length; i--;) {
      const fragmentEntity = fragments[keys[i]];
      if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
        const frag = fragmentEntity.body;
        if (frag.start <= position && position <= frag.end) {
          return frag;
        }
      }
    }
    return null;
  }

  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart) {
    if (this.timeRanges) {
      this.timeRanges[elementaryStream] = timeRange;
    }
    // Check if any flagged fragments have been unloaded
    // excluding anything newer than appendedPartSn
    const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (appendedPartSn >= fragmentEntity.body.sn) {
        return;
      }
      if (!fragmentEntity.buffered && !fragmentEntity.loaded) {
        if (fragmentEntity.body.type === playlistType) {
          this.removeFragment(fragmentEntity.body);
        }
        return;
      }
      const esData = fragmentEntity.range[elementaryStream];
      if (!esData) {
        return;
      }
      esData.time.some(time => {
        const isNotBuffered = !this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
        if (isNotBuffered) {
          // Unregister partial fragment as it needs to load again to be reused
          this.removeFragment(fragmentEntity.body);
        }
        return isNotBuffered;
      });
    });
  }

  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(data) {
    const timeRanges = this.timeRanges;
    const {
      frag,
      part
    } = data;
    if (!timeRanges || frag.sn === 'initSegment') {
      return;
    }
    const fragKey = getFragmentKey(frag);
    const fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity || fragmentEntity.buffered && frag.gap) {
      return;
    }
    const isFragHint = !frag.relurl;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const streamInfo = frag.elementaryStreams[elementaryStream];
      if (!streamInfo) {
        return;
      }
      const timeRange = timeRanges[elementaryStream];
      const partial = isFragHint || streamInfo.partial === true;
      fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, part, partial, timeRange);
    });
    fragmentEntity.loaded = null;
    if (Object.keys(fragmentEntity.range).length) {
      fragmentEntity.buffered = true;
      const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
      if (endList) {
        this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
      }
      if (!isPartial(fragmentEntity)) {
        // Remove older fragment parts from lookup after frag is tracked as buffered
        this.removeParts(frag.sn - 1, frag.type);
      }
    } else {
      // remove fragment if nothing was appended
      this.removeFragment(fragmentEntity.body);
    }
  }
  removeParts(snToKeep, levelType) {
    const activeParts = this.activePartLists[levelType];
    if (!activeParts) {
      return;
    }
    this.activePartLists[levelType] = activeParts.filter(part => part.fragment.sn >= snToKeep);
  }
  fragBuffered(frag, force) {
    const fragKey = getFragmentKey(frag);
    let fragmentEntity = this.fragments[fragKey];
    if (!fragmentEntity && force) {
      fragmentEntity = this.fragments[fragKey] = {
        body: frag,
        appendedPTS: null,
        loaded: null,
        buffered: false,
        range: Object.create(null)
      };
      if (frag.gap) {
        this.hasGaps = true;
      }
    }
    if (fragmentEntity) {
      fragmentEntity.loaded = null;
      fragmentEntity.buffered = true;
    }
  }
  getBufferedTimes(fragment, part, partial, timeRange) {
    const buffered = {
      time: [],
      partial
    };
    const startPTS = fragment.start;
    const endPTS = fragment.end;
    const minEndPTS = fragment.minEndPTS || endPTS;
    const maxStartPTS = fragment.maxStartPTS || startPTS;
    for (let i = 0; i < timeRange.length; i++) {
      const startTime = timeRange.start(i) - this.bufferPadding;
      const endTime = timeRange.end(i) + this.bufferPadding;
      if (maxStartPTS >= startTime && minEndPTS <= endTime) {
        // Fragment is entirely contained in buffer
        // No need to check the other timeRange times since it's completely playable
        buffered.time.push({
          startPTS: Math.max(startPTS, timeRange.start(i)),
          endPTS: Math.min(endPTS, timeRange.end(i))
        });
        break;
      } else if (startPTS < endTime && endPTS > startTime) {
        const start = Math.max(startPTS, timeRange.start(i));
        const end = Math.min(endPTS, timeRange.end(i));
        if (end > start) {
          buffered.partial = true;
          // Check for intersection with buffer
          // Get playable sections of the fragment
          buffered.time.push({
            startPTS: start,
            endPTS: end
          });
        }
      } else if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        break;
      }
    }
    return buffered;
  }

  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(time) {
    let bestFragment = null;
    let timePadding;
    let startTime;
    let endTime;
    let bestOverlap = 0;
    const {
      bufferPadding,
      fragments
    } = this;
    Object.keys(fragments).forEach(key => {
      const fragmentEntity = fragments[key];
      if (!fragmentEntity) {
        return;
      }
      if (isPartial(fragmentEntity)) {
        startTime = fragmentEntity.body.start - bufferPadding;
        endTime = fragmentEntity.body.end + bufferPadding;
        if (time >= startTime && time <= endTime) {
          // Use the fragment that has the most padding from start and end time
          timePadding = Math.min(time - startTime, endTime - time);
          if (bestOverlap <= timePadding) {
            bestFragment = fragmentEntity.body;
            bestOverlap = timePadding;
          }
        }
      }
    });
    return bestFragment;
  }
  isEndListAppended(type) {
    const lastFragmentEntity = this.endListFragments[type];
    return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || isPartial(lastFragmentEntity));
  }
  getState(fragment) {
    const fragKey = getFragmentKey(fragment);
    const fragmentEntity = this.fragments[fragKey];
    if (fragmentEntity) {
      if (!fragmentEntity.buffered) {
        return FragmentState.APPENDING;
      } else if (isPartial(fragmentEntity)) {
        return FragmentState.PARTIAL;
      } else {
        return FragmentState.OK;
      }
    }
    return FragmentState.NOT_LOADED;
  }
  isTimeBuffered(startPTS, endPTS, timeRange) {
    let startTime;
    let endTime;
    for (let i = 0; i < timeRange.length; i++) {
      startTime = timeRange.start(i) - this.bufferPadding;
      endTime = timeRange.end(i) + this.bufferPadding;
      if (startPTS >= startTime && endPTS <= endTime) {
        return true;
      }
      if (endPTS <= startTime) {
        // No need to check the rest of the timeRange as it is in order
        return false;
      }
    }
    return false;
  }
  onFragLoaded(event, data) {
    const {
      frag,
      part
    } = data;
    // don't track initsegment (for which sn is not a number)
    // don't track frags used for bitrateTest, they're irrelevant.
    if (frag.sn === 'initSegment' || frag.bitrateTest) {
      return;
    }

    // Fragment entity `loaded` FragLoadedData is null when loading parts
    const loaded = part ? null : data;
    const fragKey = getFragmentKey(frag);
    this.fragments[fragKey] = {
      body: frag,
      appendedPTS: null,
      loaded,
      buffered: false,
      range: Object.create(null)
    };
  }
  onBufferAppended(event, data) {
    const {
      frag,
      part,
      timeRanges
    } = data;
    if (frag.sn === 'initSegment') {
      return;
    }
    const playlistType = frag.type;
    if (part) {
      let activeParts = this.activePartLists[playlistType];
      if (!activeParts) {
        this.activePartLists[playlistType] = activeParts = [];
      }
      activeParts.push(part);
    }
    // Store the latest timeRanges loaded in the buffer
    this.timeRanges = timeRanges;
    Object.keys(timeRanges).forEach(elementaryStream => {
      const timeRange = timeRanges[elementaryStream];
      this.detectEvictedFragments(elementaryStream, timeRange, playlistType, part);
    });
  }
  onFragBuffered(event, data) {
    this.detectPartialFragments(data);
  }
  hasFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    return !!this.fragments[fragKey];
  }
  hasParts(type) {
    var _this$activePartLists;
    return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
  }
  removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
    if (withGapOnly && !this.hasGaps) {
      return;
    }
    Object.keys(this.fragments).forEach(key => {
      const fragmentEntity = this.fragments[key];
      if (!fragmentEntity) {
        return;
      }
      const frag = fragmentEntity.body;
      if (frag.type !== playlistType || withGapOnly && !frag.gap) {
        return;
      }
      if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) {
        this.removeFragment(frag);
      }
    });
  }
  removeFragment(fragment) {
    const fragKey = getFragmentKey(fragment);
    fragment.stats.loaded = 0;
    fragment.clearElementaryStreamInfo();
    const activeParts = this.activePartLists[fragment.type];
    if (activeParts) {
      const snToRemove = fragment.sn;
      this.activePartLists[fragment.type] = activeParts.filter(part => part.fragment.sn !== snToRemove);
    }
    delete this.fragments[fragKey];
    if (fragment.endList) {
      delete this.endListFragments[fragment.type];
    }
  }
  removeAllFragments() {
    this.fragments = Object.create(null);
    this.endListFragments = Object.create(null);
    this.activePartLists = Object.create(null);
    this.hasGaps = false;
  }
}
function isPartial(fragmentEntity) {
  var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
  return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function getFragmentKey(fragment) {
  return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}

/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */

const noopBuffered = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class BufferHelper {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(media, position) {
    try {
      if (media) {
        const buffered = BufferHelper.getBuffered(media);
        for (let i = 0; i < buffered.length; i++) {
          if (position >= buffered.start(i) && position <= buffered.end(i)) {
            return true;
          }
        }
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return false;
  }
  static bufferInfo(media, pos, maxHoleDuration) {
    try {
      if (media) {
        const vbuffered = BufferHelper.getBuffered(media);
        const buffered = [];
        let i;
        for (i = 0; i < vbuffered.length; i++) {
          buffered.push({
            start: vbuffered.start(i),
            end: vbuffered.end(i)
          });
        }
        return this.bufferedInfo(buffered, pos, maxHoleDuration);
      }
    } catch (error) {
      // this is to catch
      // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
      // This SourceBuffer has been removed from the parent media source
    }
    return {
      len: 0,
      start: pos,
      end: pos,
      nextStart: undefined
    };
  }
  static bufferedInfo(buffered, pos, maxHoleDuration) {
    pos = Math.max(0, pos);
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    buffered.sort(function (a, b) {
      const diff = a.start - b.start;
      if (diff) {
        return diff;
      } else {
        return b.end - a.end;
      }
    });
    let buffered2 = [];
    if (maxHoleDuration) {
      // there might be some small holes between buffer time range
      // consider that holes smaller than maxHoleDuration are irrelevant and build another
      // buffer time range representations that discards those holes
      for (let i = 0; i < buffered.length; i++) {
        const buf2len = buffered2.length;
        if (buf2len) {
          const buf2end = buffered2[buf2len - 1].end;
          // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
          if (buffered[i].start - buf2end < maxHoleDuration) {
            // merge overlapping time ranges
            // update lastRange.end only if smaller than item.end
            // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
            // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
            if (buffered[i].end > buf2end) {
              buffered2[buf2len - 1].end = buffered[i].end;
            }
          } else {
            // big hole
            buffered2.push(buffered[i]);
          }
        } else {
          // first value
          buffered2.push(buffered[i]);
        }
      }
    } else {
      buffered2 = buffered;
    }
    let bufferLen = 0;

    // bufferStartNext can possibly be undefined based on the conditional logic below
    let bufferStartNext;

    // bufferStart and bufferEnd are buffer boundaries around current video position
    let bufferStart = pos;
    let bufferEnd = pos;
    for (let i = 0; i < buffered2.length; i++) {
      const start = buffered2[i].start;
      const end = buffered2[i].end;
      // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        bufferStartNext = start;
        break;
      }
    }
    return {
      len: bufferLen,
      start: bufferStart || 0,
      end: bufferEnd || 0,
      nextStart: bufferStartNext
    };
  }

  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(media) {
    try {
      return media.buffered;
    } catch (e) {
      logger.log('failed to get media.buffered', e);
      return noopBuffered;
    }
  }
}

class ChunkMetadata {
  constructor(level, sn, id, size = 0, part = -1, partial = false) {
    this.level = void 0;
    this.sn = void 0;
    this.part = void 0;
    this.id = void 0;
    this.size = void 0;
    this.partial = void 0;
    this.transmuxing = getNewPerformanceTiming();
    this.buffering = {
      audio: getNewPerformanceTiming(),
      video: getNewPerformanceTiming(),
      audiovideo: getNewPerformanceTiming()
    };
    this.level = level;
    this.sn = sn;
    this.id = id;
    this.size = size;
    this.part = part;
    this.partial = partial;
  }
}
function getNewPerformanceTiming() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}

function findFirstFragWithCC(fragments, cc) {
  for (let i = 0, len = fragments.length; i < len; i++) {
    var _fragments$i;
    if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) {
      return fragments[i];
    }
  }
  return null;
}
function shouldAlignOnDiscontinuities(lastFrag, switchDetails, details) {
  if (switchDetails) {
    if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) {
      return true;
    }
  }
  return false;
}

// Find the first frag in the previous level which matches the CC of the first frag of the new level
function findDiscontinuousReferenceFrag(prevDetails, curDetails) {
  const prevFrags = prevDetails.fragments;
  const curFrags = curDetails.fragments;
  if (!curFrags.length || !prevFrags.length) {
    logger.log('No fragments to align');
    return;
  }
  const prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
  if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
    logger.log('No frag in previous level to align on');
    return;
  }
  return prevStartFrag;
}
function adjustFragmentStart(frag, sliding) {
  if (frag) {
    const start = frag.start + sliding;
    frag.start = frag.startPTS = start;
    frag.endPTS = start + frag.duration;
  }
}
function adjustSlidingStart(sliding, details) {
  // Update segments
  const fragments = details.fragments;
  for (let i = 0, len = fragments.length; i < len; i++) {
    adjustFragmentStart(fragments[i], sliding);
  }
  // Update LL-HLS parts at the end of the playlist
  if (details.fragmentHint) {
    adjustFragmentStart(details.fragmentHint, sliding);
  }
  details.alignedSliding = true;
}

/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastFrag
 * @param lastLevel
 * @param details
 */
function alignStream(lastFrag, switchDetails, details) {
  if (!switchDetails) {
    return;
  }
  alignDiscontinuities(lastFrag, details, switchDetails);
  if (!details.alignedSliding && switchDetails) {
    // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    alignMediaPlaylistByPDT(details, switchDetails);
  }
  if (!details.alignedSliding && switchDetails && !details.skippedSegments) {
    // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    adjustSliding(switchDetails, details);
  }
}

/**
 * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
 * discontinuity sequence.
 * @param lastFrag - The last Fragment which shares the same discontinuity sequence
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */
function alignDiscontinuities(lastFrag, details, switchDetails) {
  if (shouldAlignOnDiscontinuities(lastFrag, switchDetails, details)) {
    const referenceFrag = findDiscontinuousReferenceFrag(switchDetails, details);
    if (referenceFrag && isFiniteNumber(referenceFrag.start)) {
      logger.log(`Adjusting PTS using last level due to CC increase within current level ${details.url}`);
      adjustSlidingStart(referenceFrag.start, details);
    }
  }
}

/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */
function alignMediaPlaylistByPDT(details, refDetails) {
  if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) {
    return;
  }
  const fragments = details.fragments;
  const refFragments = refDetails.fragments;
  if (!fragments.length || !refFragments.length) {
    return;
  }

  // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
  // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
  // If a fragment of the same discontinuity was not found use the middle fragment of both.
  let refFrag;
  let frag;
  const targetCC = Math.min(refDetails.endCC, details.endCC);
  if (refDetails.startCC < targetCC && details.startCC < targetCC) {
    refFrag = findFirstFragWithCC(refFragments, targetCC);
    frag = findFirstFragWithCC(fragments, targetCC);
  }
  if (!refFrag || !frag) {
    refFrag = refFragments[Math.floor(refFragments.length / 2)];
    frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
  }
  const refPDT = refFrag.programDateTime;
  const targetPDT = frag.programDateTime;
  if (!refPDT || !targetPDT) {
    return;
  }
  const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
  adjustSlidingStart(delta, details);
}

const MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb

class FragmentLoader {
  constructor(config) {
    this.config = void 0;
    this.loader = null;
    this.partLoadTimeout = -1;
    this.config = config;
  }
  destroy() {
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
  }
  abort() {
    if (this.loader) {
      // Abort the loader for current fragment. Only one may load at any given time
      this.loader.abort();
    }
  }
  load(frag, onProgress) {
    const url = frag.url;
    if (!url) {
      return Promise.reject(new LoadError({
        type: ErrorTypes.NETWORK_ERROR,
        details: ErrorDetails.FRAG_LOAD_ERROR,
        fatal: false,
        frag,
        error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
        networkDetails: null
      }));
    }
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap) {
        if (frag.tagList.some(tags => tags[0] === 'GAP')) {
          reject(createGapLoadError(frag));
          return;
        } else {
          // Reset temporary treatment as GAP tag
          frag.gap = false;
        }
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag);
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: frag.sn === 'initSegment' ? Infinity : MIN_CHUNK_SIZE
      };
      // Assign frag stats to the loader's stats reference
      frag.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          let payload = response.data;
          if (context.resetIV && frag.decryptdata) {
            frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
            payload = payload.slice(16);
          }
          resolve({
            frag,
            part: null,
            payload,
            networkDetails
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            response: _objectSpread2({
              url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        },
        onProgress: (stats, context, data, networkDetails) => {
          if (onProgress) {
            onProgress({
              frag,
              part: null,
              payload: data,
              networkDetails
            });
          }
        }
      });
    });
  }
  loadPart(frag, part, onProgress) {
    this.abort();
    const config = this.config;
    const FragmentILoader = config.fLoader;
    const DefaultILoader = config.loader;
    return new Promise((resolve, reject) => {
      if (this.loader) {
        this.loader.destroy();
      }
      if (frag.gap || part.gap) {
        reject(createGapLoadError(frag, part));
        return;
      }
      const loader = this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
      const loaderContext = createLoaderContext(frag, part);
      // Should we define another load policy for parts?
      const loadPolicy = getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: MIN_CHUNK_SIZE
      };
      // Assign part stats to the loader's stats reference
      part.stats = loader.stats;
      loader.load(loaderContext, loaderConfig, {
        onSuccess: (response, stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          this.updateStatsFromPart(frag, part);
          const partLoadedData = {
            frag,
            part,
            payload: response.data,
            networkDetails
          };
          onProgress(partLoadedData);
          resolve(partLoadedData);
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_ERROR,
            fatal: false,
            frag,
            part,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response),
            error: new Error(`HTTP Error ${response.code} ${response.text}`),
            networkDetails,
            stats
          }));
        },
        onAbort: (stats, context, networkDetails) => {
          frag.stats.aborted = part.stats.aborted;
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.INTERNAL_ABORTED,
            fatal: false,
            frag,
            part,
            error: new Error('Aborted'),
            networkDetails,
            stats
          }));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(frag, loader);
          reject(new LoadError({
            type: ErrorTypes.NETWORK_ERROR,
            details: ErrorDetails.FRAG_LOAD_TIMEOUT,
            fatal: false,
            frag,
            part,
            error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
            networkDetails,
            stats
          }));
        }
      });
    });
  }
  updateStatsFromPart(frag, part) {
    const fragStats = frag.stats;
    const partStats = part.stats;
    const partTotal = partStats.total;
    fragStats.loaded += partStats.loaded;
    if (partTotal) {
      const estTotalParts = Math.round(frag.duration / part.duration);
      const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
      const estRemainingParts = estTotalParts - estLoadedParts;
      const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
      fragStats.total = fragStats.loaded + estRemainingBytes;
    } else {
      fragStats.total = Math.max(fragStats.loaded, fragStats.total);
    }
    const fragLoading = fragStats.loading;
    const partLoading = partStats.loading;
    if (fragLoading.start) {
      // add to fragment loader latency
      fragLoading.first += partLoading.first - partLoading.start;
    } else {
      fragLoading.start = partLoading.start;
      fragLoading.first = partLoading.first;
    }
    fragLoading.end = partLoading.end;
  }
  resetLoader(frag, loader) {
    frag.loader = null;
    if (this.loader === loader) {
      self.clearTimeout(this.partLoadTimeout);
      this.loader = null;
    }
    loader.destroy();
  }
}
function createLoaderContext(frag, part = null) {
  const segment = part || frag;
  const loaderContext = {
    frag,
    part,
    responseType: 'arraybuffer',
    url: segment.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  };
  const start = segment.byteRangeStartOffset;
  const end = segment.byteRangeEndOffset;
  if (isFiniteNumber(start) && isFiniteNumber(end)) {
    var _frag$decryptdata;
    let byteRangeStart = start;
    let byteRangeEnd = end;
    if (frag.sn === 'initSegment' && ((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method) === 'AES-128') {
      // MAP segment encrypted with method 'AES-128', when served with HTTP Range,
      // has the unencrypted size specified in the range.
      // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
      const fragmentLen = end - start;
      if (fragmentLen % 16) {
        byteRangeEnd = end + (16 - fragmentLen % 16);
      }
      if (start !== 0) {
        loaderContext.resetIV = true;
        byteRangeStart = start - 16;
      }
    }
    loaderContext.rangeStart = byteRangeStart;
    loaderContext.rangeEnd = byteRangeEnd;
  }
  return loaderContext;
}
function createGapLoadError(frag, part) {
  const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
  const errorData = {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_GAP,
    fatal: false,
    frag,
    error,
    networkDetails: null
  };
  if (part) {
    errorData.part = part;
  }
  (part ? part : frag).stats.aborted = true;
  return new LoadError(errorData);
}
class LoadError extends Error {
  constructor(data) {
    super(data.error.message);
    this.data = void 0;
    this.data = data;
  }
}

class AESCrypto {
  constructor(subtle, iv) {
    this.subtle = void 0;
    this.aesIV = void 0;
    this.subtle = subtle;
    this.aesIV = iv;
  }
  decrypt(data, key) {
    return this.subtle.decrypt({
      name: 'AES-CBC',
      iv: this.aesIV
    }, key, data);
  }
}

class FastAESKey {
  constructor(subtle, key) {
    this.subtle = void 0;
    this.key = void 0;
    this.subtle = subtle;
    this.key = key;
  }
  expandKey() {
    return this.subtle.importKey('raw', this.key, {
      name: 'AES-CBC'
    }, false, ['encrypt', 'decrypt']);
  }
}

// PKCS7
function removePadding(array) {
  const outputBytes = array.byteLength;
  const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
  if (paddingBytes) {
    return sliceUint8(array, 0, outputBytes - paddingBytes);
  }
  return array;
}
class AESDecryptor {
  constructor() {
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);
    this.key = new Uint32Array(0);
    this.ksRows = 0;
    this.keySize = 0;
    this.keySchedule = void 0;
    this.invKeySchedule = void 0;
    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(arrayBuffer) {
    const view = new DataView(arrayBuffer);
    const newArray = new Uint32Array(4);
    for (let i = 0; i < 4; i++) {
      newArray[i] = view.getUint32(i * 4);
    }
    return newArray;
  }
  initTable() {
    const sBox = this.sBox;
    const invSBox = this.invSBox;
    const subMix = this.subMix;
    const subMix0 = subMix[0];
    const subMix1 = subMix[1];
    const subMix2 = subMix[2];
    const subMix3 = subMix[3];
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const d = new Uint32Array(256);
    let x = 0;
    let xi = 0;
    let i = 0;
    for (i = 0; i < 256; i++) {
      if (i < 128) {
        d[i] = i << 1;
      } else {
        d[i] = i << 1 ^ 0x11b;
      }
    }
    for (i = 0; i < 256; i++) {
      let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
      sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
      sBox[x] = sx;
      invSBox[sx] = x;

      // Compute multiplication
      const x2 = d[x];
      const x4 = d[x2];
      const x8 = d[x4];

      // Compute sub/invSub bytes, mix columns tables
      let t = d[sx] * 0x101 ^ sx * 0x1010100;
      subMix0[x] = t << 24 | t >>> 8;
      subMix1[x] = t << 16 | t >>> 16;
      subMix2[x] = t << 8 | t >>> 24;
      subMix3[x] = t;

      // Compute inv sub bytes, inv mix columns tables
      t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
      invSubMix0[sx] = t << 24 | t >>> 8;
      invSubMix1[sx] = t << 16 | t >>> 16;
      invSubMix2[sx] = t << 8 | t >>> 24;
      invSubMix3[sx] = t;

      // Compute next counter
      if (!x) {
        x = xi = 1;
      } else {
        x = x2 ^ d[d[d[x8 ^ x2]]];
        xi ^= d[d[xi]];
      }
    }
  }
  expandKey(keyBuffer) {
    // convert keyBuffer to Uint32Array
    const key = this.uint8ArrayToUint32Array_(keyBuffer);
    let sameKey = true;
    let offset = 0;
    while (offset < key.length && sameKey) {
      sameKey = key[offset] === this.key[offset];
      offset++;
    }
    if (sameKey) {
      return;
    }
    this.key = key;
    const keySize = this.keySize = key.length;
    if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
      throw new Error('Invalid aes key size=' + keySize);
    }
    const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
    let ksRow;
    let invKsRow;
    const keySchedule = this.keySchedule = new Uint32Array(ksRows);
    const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
    const sbox = this.sBox;
    const rcon = this.rcon;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    let prev;
    let t;
    for (ksRow = 0; ksRow < ksRows; ksRow++) {
      if (ksRow < keySize) {
        prev = keySchedule[ksRow] = key[ksRow];
        continue;
      }
      t = prev;
      if (ksRow % keySize === 0) {
        // Rot word
        t = t << 8 | t >>> 24;

        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

        // Mix Rcon
        t ^= rcon[ksRow / keySize | 0] << 24;
      } else if (keySize > 6 && ksRow % keySize === 4) {
        // Sub word
        t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
      }
      keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
    }
    for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
      ksRow = ksRows - invKsRow;
      if (invKsRow & 3) {
        t = keySchedule[ksRow];
      } else {
        t = keySchedule[ksRow - 4];
      }
      if (invKsRow < 4 || ksRow <= 4) {
        invKeySchedule[invKsRow] = t;
      } else {
        invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
      }
      invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
    }
  }

  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(word) {
    return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
  }
  decrypt(inputArrayBuffer, offset, aesIV) {
    const nRounds = this.keySize + 6;
    const invKeySchedule = this.invKeySchedule;
    const invSBOX = this.invSBox;
    const invSubMix = this.invSubMix;
    const invSubMix0 = invSubMix[0];
    const invSubMix1 = invSubMix[1];
    const invSubMix2 = invSubMix[2];
    const invSubMix3 = invSubMix[3];
    const initVector = this.uint8ArrayToUint32Array_(aesIV);
    let initVector0 = initVector[0];
    let initVector1 = initVector[1];
    let initVector2 = initVector[2];
    let initVector3 = initVector[3];
    const inputInt32 = new Int32Array(inputArrayBuffer);
    const outputInt32 = new Int32Array(inputInt32.length);
    let t0, t1, t2, t3;
    let s0, s1, s2, s3;
    let inputWords0, inputWords1, inputWords2, inputWords3;
    let ksRow, i;
    const swapWord = this.networkToHostOrderSwap;
    while (offset < inputInt32.length) {
      inputWords0 = swapWord(inputInt32[offset]);
      inputWords1 = swapWord(inputInt32[offset + 1]);
      inputWords2 = swapWord(inputInt32[offset + 2]);
      inputWords3 = swapWord(inputInt32[offset + 3]);
      s0 = inputWords0 ^ invKeySchedule[0];
      s1 = inputWords3 ^ invKeySchedule[1];
      s2 = inputWords2 ^ invKeySchedule[2];
      s3 = inputWords1 ^ invKeySchedule[3];
      ksRow = 4;

      // Iterate through the rounds of decryption
      for (i = 1; i < nRounds; i++) {
        t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        // Update state
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
        ksRow = ksRow + 4;
      }

      // Shift rows, sub bytes, add round key
      t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
      t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
      t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
      t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];

      // Write
      outputInt32[offset] = swapWord(t0 ^ initVector0);
      outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
      outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
      outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

      // reset initVector to last 4 unsigned int
      initVector0 = inputWords0;
      initVector1 = inputWords1;
      initVector2 = inputWords2;
      initVector3 = inputWords3;
      offset = offset + 4;
    }
    return outputInt32.buffer;
  }
}

const CHUNK_SIZE = 16; // 16 bytes, 128 bits

class Decrypter {
  constructor(config, {
    removePKCS7Padding = true
  } = {}) {
    this.logEnabled = true;
    this.removePKCS7Padding = void 0;
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
    this.useSoftware = void 0;
    this.useSoftware = config.enableSoftwareAES;
    this.removePKCS7Padding = removePKCS7Padding;
    // built in decryptor expects PKCS7 padding
    if (removePKCS7Padding) {
      try {
        const browserCrypto = self.crypto;
        if (browserCrypto) {
          this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        }
      } catch (e) {
        /* no-op */
      }
    }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null;
    this.softwareDecrypter = null;
    this.key = null;
    this.fastAesKey = null;
    this.remainderData = null;
    this.currentIV = null;
    this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult,
      remainderData
    } = this;
    if (!currentResult || remainderData) {
      this.reset();
      return null;
    }
    const data = new Uint8Array(currentResult);
    this.reset();
    if (this.removePKCS7Padding) {
      return removePadding(data);
    }
    return data;
  }
  reset() {
    this.currentResult = null;
    this.currentIV = null;
    this.remainderData = null;
    if (this.softwareDecrypter) {
      this.softwareDecrypter = null;
    }
  }
  decrypt(data, key, iv) {
    if (this.useSoftware) {
      return new Promise((resolve, reject) => {
        this.softwareDecrypt(new Uint8Array(data), key, iv);
        const decryptResult = this.flush();
        if (decryptResult) {
          resolve(decryptResult.buffer);
        } else {
          reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        }
      });
    }
    return this.webCryptoDecrypt(new Uint8Array(data), key, iv);
  }

  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(data, key, iv) {
    const {
      currentIV,
      currentResult,
      remainderData
    } = this;
    this.logOnce('JS AES decrypt');
    // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
    // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
    // the end on flush(), but by that time we have already received all bytes for the segment.
    // Progressive decryption does not work with WebCrypto

    if (remainderData) {
      data = appendUint8Array(remainderData, data);
      this.remainderData = null;
    }

    // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
    const currentChunk = this.getValidChunk(data);
    if (!currentChunk.length) {
      return null;
    }
    if (currentIV) {
      iv = currentIV;
    }
    let softwareDecrypter = this.softwareDecrypter;
    if (!softwareDecrypter) {
      softwareDecrypter = this.softwareDecrypter = new AESDecryptor();
    }
    softwareDecrypter.expandKey(key);
    const result = currentResult;
    this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
    this.currentIV = sliceUint8(currentChunk, -16).buffer;
    if (!result) {
      return null;
    }
    return result;
  }
  webCryptoDecrypt(data, key, iv) {
    if (this.key !== key || !this.fastAesKey) {
      if (!this.subtle) {
        return Promise.resolve(this.onWebCryptoError(data, key, iv));
      }
      this.key = key;
      this.fastAesKey = new FastAESKey(this.subtle, key);
    }
    return this.fastAesKey.expandKey().then(aesKey => {
      // decrypt using web crypto
      if (!this.subtle) {
        return Promise.reject(new Error('web crypto not initialized'));
      }
      this.logOnce('WebCrypto AES decrypt');
      const crypto = new AESCrypto(this.subtle, new Uint8Array(iv));
      return crypto.decrypt(data.buffer, aesKey);
    }).catch(err => {
      logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
      return this.onWebCryptoError(data, key, iv);
    });
  }
  onWebCryptoError(data, key, iv) {
    this.useSoftware = true;
    this.logEnabled = true;
    this.softwareDecrypt(data, key, iv);
    const decryptResult = this.flush();
    if (decryptResult) {
      return decryptResult.buffer;
    }
    throw new Error('WebCrypto and softwareDecrypt: failed to decrypt data');
  }
  getValidChunk(data) {
    let currentChunk = data;
    const splitPoint = data.length - data.length % CHUNK_SIZE;
    if (splitPoint !== data.length) {
      currentChunk = sliceUint8(data, 0, splitPoint);
      this.remainderData = sliceUint8(data, splitPoint);
    }
    return currentChunk;
  }
  logOnce(msg) {
    if (!this.logEnabled) {
      return;
    }
    logger.log(`[decrypter]: ${msg}`);
    this.logEnabled = false;
  }
}

/**
 *  TimeRanges to string helper
 */

const TimeRanges = {
  toString: function (r) {
    let log = '';
    const len = r.length;
    for (let i = 0; i < len; i++) {
      log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
    }
    return log;
  }
};

const State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS',
  WAITING_LEVEL: 'WAITING_LEVEL'
};
class BaseStreamController extends TaskLoop {
  constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType) {
    super();
    this.hls = void 0;
    this.fragPrevious = null;
    this.fragCurrent = null;
    this.fragmentTracker = void 0;
    this.transmuxer = null;
    this._state = State.STOPPED;
    this.playlistType = void 0;
    this.media = null;
    this.mediaBuffer = null;
    this.config = void 0;
    this.bitrateTest = false;
    this.lastCurrentTime = 0;
    this.nextLoadPosition = 0;
    this.startPosition = 0;
    this.startTimeOffset = null;
    this.loadedmetadata = false;
    this.retryDate = 0;
    this.levels = null;
    this.fragmentLoader = void 0;
    this.keyLoader = void 0;
    this.levelLastLoaded = null;
    this.startFragRequested = false;
    this.decrypter = void 0;
    this.initPTS = [];
    this.onvseeking = null;
    this.onvended = null;
    this.logPrefix = '';
    this.log = void 0;
    this.warn = void 0;
    this.playlistType = playlistType;
    this.logPrefix = logPrefix;
    this.log = logger.log.bind(logger, `${logPrefix}:`);
    this.warn = logger.warn.bind(logger, `${logPrefix}:`);
    this.hls = hls;
    this.fragmentLoader = new FragmentLoader(hls.config);
    this.keyLoader = keyLoader;
    this.fragmentTracker = fragmentTracker;
    this.config = hls.config;
    this.decrypter = new Decrypter(hls.config);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(startPosition) {}
  stopLoad() {
    this.fragmentLoader.abort();
    this.keyLoader.abort(this.playlistType);
    const frag = this.fragCurrent;
    if (frag != null && frag.loader) {
      frag.abortRequests();
      this.fragmentTracker.removeFragment(frag);
    }
    this.resetTransmuxer();
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.clearInterval();
    this.clearNextTick();
    this.state = State.STOPPED;
  }
  _streamEnded(bufferInfo, levelDetails) {
    // If playlist is live, there is another buffered range after the current range, nothing buffered, media is detached,
    // of nothing loading/loaded return false
    if (levelDetails.live || bufferInfo.nextStart || !bufferInfo.end || !this.media) {
      return false;
    }
    const partList = levelDetails.partList;
    // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
    // check instead if the last part is buffered.
    if (partList != null && partList.length) {
      const lastPart = partList[partList.length - 1];

      // Checking the midpoint of the part for potential margin of error and related issues.
      // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
      // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
      // part mismatches for independent audio and video playlists/segments.
      const lastPartBuffered = BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
      return lastPartBuffered;
    }
    const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(playlistType);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var _this$levelLastLoaded;
      return (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details;
    }
  }
  onMediaAttached(event, data) {
    const media = this.media = this.mediaBuffer = data.media;
    this.onvseeking = this.onMediaSeeking.bind(this);
    this.onvended = this.onMediaEnded.bind(this);
    media.addEventListener('seeking', this.onvseeking);
    media.addEventListener('ended', this.onvended);
    const config = this.config;
    if (this.levels && config.autoStartLoad && this.state === State.STOPPED) {
      this.startLoad(config.startPosition);
    }
  }
  onMediaDetaching() {
    const media = this.media;
    if (media != null && media.ended) {
      this.log('MSE detaching and video ended, reset startPosition');
      this.startPosition = this.lastCurrentTime = 0;
    }

    // remove video listeners
    if (media && this.onvseeking && this.onvended) {
      media.removeEventListener('seeking', this.onvseeking);
      media.removeEventListener('ended', this.onvended);
      this.onvseeking = this.onvended = null;
    }
    if (this.keyLoader) {
      this.keyLoader.detach();
    }
    this.media = this.mediaBuffer = null;
    this.loadedmetadata = false;
    this.fragmentTracker.removeAllFragments();
    this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config,
      fragCurrent,
      media,
      mediaBuffer,
      state
    } = this;
    const currentTime = media ? media.currentTime : 0;
    const bufferInfo = BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
    this.log(`media seeking to ${isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    } else if (fragCurrent) {
      // Seeking while frag load is in progress
      const tolerance = config.maxFragLookUpTolerance;
      const fragStartOffset = fragCurrent.start - tolerance;
      const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
      // if seeking out of buffered range or into new one
      if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
        const pastFragment = currentTime > fragEndOffset;
        // if the seek position is outside the current fragment range
        if (currentTime < fragStartOffset || pastFragment) {
          if (pastFragment && fragCurrent.loader) {
            this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
            fragCurrent.abortRequests();
            this.resetLoadingState();
          }
          this.fragPrevious = null;
        }
      }
    }
    if (media) {
      // Remove gap fragments
      this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
      this.lastCurrentTime = currentTime;
    }

    // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
    if (!this.loadedmetadata && !bufferInfo.len) {
      this.nextLoadPosition = this.startPosition = currentTime;
    }

    // Async tick to speed up processing
    this.tickImmediate();
  }
  onMediaEnded() {
    // reset startPosition and lastCurrentTime to restart playback @ stream beginning
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(event, data) {
    this.startTimeOffset = data.startTimeOffset;
    this.initPTS = [];
  }
  onHandlerDestroying() {
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    this.stopLoad();
    super.onHandlerDestroying();
    // @ts-ignore
    this.hls = null;
  }
  onHandlerDestroyed() {
    this.state = State.STOPPED;
    if (this.fragmentLoader) {
      this.fragmentLoader.destroy();
    }
    if (this.keyLoader) {
      this.keyLoader.destroy();
    }
    if (this.decrypter) {
      this.decrypter.destroy();
    }
    this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
    super.onHandlerDestroyed();
  }
  loadFragment(frag, level, targetBufferTime) {
    this._loadFragForPlayback(frag, level, targetBufferTime);
  }
  _loadFragForPlayback(frag, level, targetBufferTime) {
    const progressCallback = data => {
      if (this.fragContextChanged(frag)) {
        this.warn(`Fragment ${frag.sn}${data.part ? ' p: ' + data.part.index : ''} of level ${frag.level} was dropped during download.`);
        this.fragmentTracker.removeFragment(frag);
        return;
      }
      frag.stats.chunkCount++;
      this._handleFragmentLoadProgress(data);
    };
    this._doFragLoad(frag, level, targetBufferTime, progressCallback).then(data => {
      if (!data) {
        // if we're here we probably needed to backtrack or are waiting for more parts
        return;
      }
      const state = this.state;
      if (this.fragContextChanged(frag)) {
        if (state === State.FRAG_LOADING || !this.fragCurrent && state === State.PARSING) {
          this.fragmentTracker.removeFragment(frag);
          this.state = State.IDLE;
        }
        return;
      }
      if ('payload' in data) {
        this.log(`Loaded fragment ${frag.sn} of level ${frag.level}`);
        this.hls.trigger(Events.FRAG_LOADED, data);
      }

      // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
      this._handleFragmentLoadComplete(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
      this.resetFragmentLoading(frag);
    });
  }
  clearTrackerIfNeeded(frag) {
    var _this$mediaBuffer;
    const {
      fragmentTracker
    } = this;
    const fragState = fragmentTracker.getState(frag);
    if (fragState === FragmentState.APPENDING) {
      // Lower the max buffer length and try again
      const playlistType = frag.type;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
      // If backtracking, always remove from the tracker without reducing max buffer length
      const backtrackFragment = this.backtrackFragment;
      const backtracked = backtrackFragment ? frag.sn - backtrackFragment.sn : 0;
      if (backtracked === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) {
        fragmentTracker.removeFragment(frag);
      }
    } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) {
      // Stop gap for bad tracker / buffer flush behavior
      fragmentTracker.removeAllFragments();
    } else if (fragmentTracker.hasParts(frag.type)) {
      // In low latency mode, remove fragments for which only some parts were buffered
      fragmentTracker.detectPartialFragments({
        frag,
        part: null,
        stats: frag.stats,
        id: frag.type
      });
      if (fragmentTracker.getState(frag) === FragmentState.PARTIAL) {
        fragmentTracker.removeFragment(frag);
      }
    }
  }
  checkLiveUpdate(details) {
    if (details.updated && !details.live) {
      // Live stream ended, update fragment tracker
      const lastFragment = details.fragments[details.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: lastFragment,
        part: null,
        stats: lastFragment.stats,
        id: lastFragment.type
      });
    }
    if (!details.fragments[0]) {
      details.deltaUpdateFailed = true;
    }
  }
  flushMainBuffer(startOffset, endOffset, type = null) {
    if (!(startOffset - endOffset)) {
      return;
    }
    // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
    // passing a null type flushes both buffers
    const flushScope = {
      startOffset,
      endOffset,
      type
    };
    this.hls.trigger(Events.BUFFER_FLUSHING, flushScope);
  }
  _loadInitSegment(frag, level) {
    this._doFragLoad(frag, level).then(data => {
      if (!data || this.fragContextChanged(frag) || !this.levels) {
        throw new Error('init load aborted');
      }
      return data;
    }).then(data => {
      const {
        hls
      } = this;
      const {
        payload
      } = data;
      const decryptData = frag.decryptdata;

      // check to see if the payload needs to be decrypted
      if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
        const startTime = self.performance.now();
        // decrypt init segment data
        return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.FRAG_DECRYPT_ERROR,
            fatal: false,
            error: err,
            reason: err.message,
            frag
          });
          throw err;
        }).then(decryptedData => {
          const endTime = self.performance.now();
          hls.trigger(Events.FRAG_DECRYPTED, {
            frag,
            payload: decryptedData,
            stats: {
              tstart: startTime,
              tdecrypt: endTime
            }
          });
          data.payload = decryptedData;
          return this.completeInitSegmentLoad(data);
        });
      }
      return this.completeInitSegmentLoad(data);
    }).catch(reason => {
      if (this.state === State.STOPPED || this.state === State.ERROR) {
        return;
      }
      this.warn(reason);
      this.resetFragmentLoading(frag);
    });
  }
  completeInitSegmentLoad(data) {
    const {
      levels
    } = this;
    if (!levels) {
      throw new Error('init load aborted, missing levels');
    }
    const stats = data.frag.stats;
    this.state = State.IDLE;
    data.frag.data = new Uint8Array(data.payload);
    stats.parsing.start = stats.buffering.start = self.performance.now();
    stats.parsing.end = stats.buffering.end = self.performance.now();
    this.tick();
  }
  fragContextChanged(frag) {
    const {
      fragCurrent
    } = this;
    return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
  }
  fragBufferedComplete(frag, part) {
    var _frag$startPTS, _frag$endPTS, _this$fragCurrent, _this$fragPrevious;
    const media = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.playlistType === PlaylistLevelType.MAIN ? 'level' : 'track'} ${frag.level} (frag:[${((_frag$startPTS = frag.startPTS) != null ? _frag$startPTS : NaN).toFixed(3)}-${((_frag$endPTS = frag.endPTS) != null ? _frag$endPTS : NaN).toFixed(3)}] > buffer:${media ? TimeRanges.toString(BufferHelper.getBuffered(media)) : '(detached)'})`);
    if (frag.sn !== 'initSegment') {
      var _this$levels;
      if (frag.type !== PlaylistLevelType.SUBTITLE) {
        const el = frag.elementaryStreams;
        if (!Object.keys(el).some(type => !!el[type])) {
          // empty segment
          this.state = State.IDLE;
          return;
        }
      }
      const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
      if (level != null && level.fragmentError) {
        this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
        level.fragmentError = 0;
      }
    }
    this.state = State.IDLE;
    if (!media) {
      return;
    }
    if (!this.loadedmetadata && frag.type == PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = this.fragPrevious) == null ? void 0 : _this$fragPrevious.sn)) {
      this.loadedmetadata = true;
      this.seekToStartPos();
    }
    this.tick();
  }
  seekToStartPos() {}
  _handleFragmentLoadComplete(fragLoadedEndData) {
    const {
      transmuxer
    } = this;
    if (!transmuxer) {
      return;
    }
    const {
      frag,
      part,
      partsLoaded
    } = fragLoadedEndData;
    // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
    const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some(fragLoaded => !fragLoaded);
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
    transmuxer.flush(chunkMeta);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(frag) {}
  _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
    var _frag$decryptdata;
    const details = level == null ? void 0 : level.details;
    if (!this.levels || !details) {
      throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
    }
    let keyLoadingPromise = null;
    if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
      this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'} ${frag.level}`);
      this.state = State.KEY_LOADING;
      this.fragCurrent = frag;
      keyLoadingPromise = this.keyLoader.load(frag).then(keyLoadedData => {
        if (!this.fragContextChanged(keyLoadedData.frag)) {
          this.hls.trigger(Events.KEY_LOADED, keyLoadedData);
          if (this.state === State.KEY_LOADING) {
            this.state = State.IDLE;
          }
          return keyLoadedData;
        }
      });
      this.hls.trigger(Events.KEY_LOADING, {
        frag
      });
      if (this.fragCurrent === null) {
        keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
      }
    } else if (!frag.encrypted && details.encryptedFragments.length) {
      this.keyLoader.loadClear(frag, details.encryptedFragments);
    }
    targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
    if (this.config.lowLatencyMode && frag.sn !== 'initSegment') {
      const partList = details.partList;
      if (partList && progressCallback) {
        if (targetBufferTime > frag.end && details.fragmentHint) {
          frag = details.fragmentHint;
        }
        const partIndex = this.getNextPart(partList, frag, targetBufferTime);
        if (partIndex > -1) {
          const part = partList[partIndex];
          this.log(`Loading part sn: ${frag.sn} p: ${part.index} cc: ${frag.cc} of playlist [${details.startSN}-${details.endSN}] parts [0-${partIndex}-${partList.length - 1}] ${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
          this.nextLoadPosition = part.start + part.duration;
          this.state = State.FRAG_LOADING;
          let _result;
          if (keyLoadingPromise) {
            _result = keyLoadingPromise.then(keyLoadedData => {
              if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) {
                return null;
              }
              return this.doFragPartsLoad(frag, part, level, progressCallback);
            }).catch(error => this.handleFragLoadError(error));
          } else {
            _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch(error => this.handleFragLoadError(error));
          }
          this.hls.trigger(Events.FRAG_LOADING, {
            frag,
            part,
            targetBufferTime
          });
          if (this.fragCurrent === null) {
            return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
          }
          return _result;
        } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) {
          // Fragment hint has no parts
          return Promise.resolve(null);
        }
      }
    }
    this.log(`Loading fragment ${frag.sn} cc: ${frag.cc} ${details ? 'of [' + details.startSN + '-' + details.endSN + '] ' : ''}${this.logPrefix === '[stream-controller]' ? 'level' : 'track'}: ${frag.level}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
    // Don't update nextLoadPosition for fragments which are not buffered
    if (isFiniteNumber(frag.sn) && !this.bitrateTest) {
      this.nextLoadPosition = frag.start + frag.duration;
    }
    this.state = State.FRAG_LOADING;

    // Load key before streaming fragment data
    const dataOnProgress = this.config.progressive;
    let result;
    if (dataOnProgress && keyLoadingPromise) {
      result = keyLoadingPromise.then(keyLoadedData => {
        if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) {
          return null;
        }
        return this.fragmentLoader.load(frag, progressCallback);
      }).catch(error => this.handleFragLoadError(error));
    } else {
      // load unencrypted fragment data with progress event,
      // or handle fragment result after key and fragment are finished loading
      result = Promise.all([this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined), keyLoadingPromise]).then(([fragLoadedData]) => {
        if (!dataOnProgress && fragLoadedData && progressCallback) {
          progressCallback(fragLoadedData);
        }
        return fragLoadedData;
      }).catch(error => this.handleFragLoadError(error));
    }
    this.hls.trigger(Events.FRAG_LOADING, {
      frag,
      targetBufferTime
    });
    if (this.fragCurrent === null) {
      return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
    }
    return result;
  }
  doFragPartsLoad(frag, fromPart, level, progressCallback) {
    return new Promise((resolve, reject) => {
      var _level$details;
      const partsLoaded = [];
      const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
      const loadPart = part => {
        this.fragmentLoader.loadPart(frag, part, progressCallback).then(partLoadedData => {
          partsLoaded[part.index] = partLoadedData;
          const loadedPart = partLoadedData.part;
          this.hls.trigger(Events.FRAG_LOADED, partLoadedData);
          const nextPart = getPartWith(level, frag.sn, part.index + 1) || findPart(initialPartList, frag.sn, part.index + 1);
          if (nextPart) {
            loadPart(nextPart);
          } else {
            return resolve({
              frag,
              part: loadedPart,
              partsLoaded
            });
          }
        }).catch(reject);
      };
      loadPart(fromPart);
    });
  }
  handleFragLoadError(error) {
    if ('data' in error) {
      const data = error.data;
      if (error.data && data.details === ErrorDetails.INTERNAL_ABORTED) {
        this.handleFragLoadAborted(data.frag, data.part);
      } else {
        this.hls.trigger(Events.ERROR, data);
      }
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.INTERNAL_EXCEPTION,
        err: error,
        error,
        fatal: true
      });
    }
    return null;
  }
  _handleTransmuxerFlush(chunkMeta) {
    const context = this.getCurrentContext(chunkMeta);
    if (!context || this.state !== State.PARSING) {
      if (!this.fragCurrent && this.state !== State.STOPPED && this.state !== State.ERROR) {
        this.state = State.IDLE;
      }
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const now = self.performance.now();
    frag.stats.parsing.end = now;
    if (part) {
      part.stats.parsing.end = now;
    }
    this.updateLevelTiming(frag, part, level, chunkMeta.partial);
  }
  getCurrentContext(chunkMeta) {
    const {
      levels,
      fragCurrent
    } = this;
    const {
      level: levelIndex,
      sn,
      part: partIndex
    } = chunkMeta;
    if (!(levels != null && levels[levelIndex])) {
      this.warn(`Levels object was unset while buffering fragment ${sn} of level ${levelIndex}. The current chunk will not be buffered.`);
      return null;
    }
    const level = levels[levelIndex];
    const part = partIndex > -1 ? getPartWith(level, sn, partIndex) : null;
    const frag = part ? part.fragment : getFragmentWithSN(level, sn, fragCurrent);
    if (!frag) {
      return null;
    }
    if (fragCurrent && fragCurrent !== frag) {
      frag.stats = fragCurrent.stats;
    }
    return {
      frag,
      part,
      level
    };
  }
  bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
    var _buffer;
    if (!data || this.state !== State.PARSING) {
      return;
    }
    const {
      data1,
      data2
    } = data;
    let buffer = data1;
    if (data1 && data2) {
      // Combine the moof + mdat so that we buffer with a single append
      buffer = appendUint8Array(data1, data2);
    }
    if (!((_buffer = buffer) != null && _buffer.length)) {
      return;
    }
    const segment = {
      type: data.type,
      frag,
      part,
      chunkMeta,
      parent: frag.type,
      data: buffer
    };
    this.hls.trigger(Events.BUFFER_APPENDING, segment);
    if (data.dropped && data.independent && !part) {
      if (noBacktracking) {
        return;
      }
      // Clear buffer so that we reload previous segments sequentially if required
      this.flushBufferGap(frag);
    }
  }
  flushBufferGap(frag) {
    const media = this.media;
    if (!media) {
      return;
    }
    // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
    if (!BufferHelper.isBuffered(media, media.currentTime)) {
      this.flushMainBuffer(0, frag.start);
      return;
    }
    // Remove back-buffer without interrupting playback to allow back tracking
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const fragDuration = frag.duration;
    const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
    const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
    if (frag.start - start > segmentFraction) {
      this.flushMainBuffer(start, frag.start);
    }
  }
  getFwdBufferInfo(bufferable, type) {
    const pos = this.getLoadPosition();
    if (!isFiniteNumber(pos)) {
      return null;
    }
    return this.getFwdBufferInfoAtPos(bufferable, pos, type);
  }
  getFwdBufferInfoAtPos(bufferable, pos, type) {
    const {
      config: {
        maxBufferHole
      }
    } = this;
    const bufferInfo = BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
    // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
    if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
      const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
      if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) {
        return BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, maxBufferHole));
      }
    }
    return bufferInfo;
  }
  getMaxBufferLength(levelBitrate) {
    const {
      config
    } = this;
    let maxBufLen;
    if (levelBitrate) {
      maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
    } else {
      maxBufLen = config.maxBufferLength;
    }
    return Math.min(maxBufLen, config.maxMaxBufferLength);
  }
  reduceMaxBufferLength(threshold, fragDuration) {
    const config = this.config;
    const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
    const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
    if (reducedLength >= minLength) {
      // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
      config.maxMaxBufferLength = reducedLength;
      this.warn(`Reduce max buffer length to ${reducedLength}s`);
      return true;
    }
    return false;
  }
  getAppendedFrag(position, playlistType = PlaylistLevelType.MAIN) {
    const fragOrPart = this.fragmentTracker.getAppendedFrag(position, PlaylistLevelType.MAIN);
    if (fragOrPart && 'fragment' in fragOrPart) {
      return fragOrPart.fragment;
    }
    return fragOrPart;
  }
  getNextFragment(pos, levelDetails) {
    const fragments = levelDetails.fragments;
    const fragLen = fragments.length;
    if (!fragLen) {
      return null;
    }

    // find fragment index, contiguous with end of buffer position
    const {
      config
    } = this;
    const start = fragments[0].start;
    let frag;
    if (levelDetails.live) {
      const initialLiveManifestSize = config.initialLiveManifestSize;
      if (fragLen < initialLiveManifestSize) {
        this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
        return null;
      }
      // The real fragment start times for a live stream are only known after the PTS range for that level is known.
      // In order to discover the range, we load the best matching fragment for that level and demux it.
      // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
      // we get the fragment matching that start time
      if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
        frag = this.getInitialLiveFragment(levelDetails, fragments);
        this.startPosition = this.nextLoadPosition = frag ? this.hls.liveSyncPosition || frag.start : pos;
      }
    } else if (pos <= start) {
      // VoD playlist: if loadPosition before start of playlist, load first fragment
      frag = fragments[0];
    }

    // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
    if (!frag) {
      const end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
      frag = this.getFragmentAtPosition(pos, end, levelDetails);
    }
    return this.mapToInitFragWhenRequired(frag);
  }
  isLoopLoading(frag, targetBufferTime) {
    const trackerState = this.fragmentTracker.getState(frag);
    return (trackerState === FragmentState.OK || trackerState === FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
  }
  getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
    const gapStart = frag.gap;
    const nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
    if (nextFragment === null) {
      return nextFragment;
    }
    frag = nextFragment;
    if (gapStart && frag && !frag.gap && bufferInfo.nextStart) {
      // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
      const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType);
      if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
        // Returning here might result in not finding an audio and video candiate to skip to
        this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${frag.sn}`);
        return null;
      }
    }
    return frag;
  }
  mapToInitFragWhenRequired(frag) {
    // If an initSegment is present, it must be buffered first
    if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) {
      return frag.initSegment;
    }
    return frag;
  }
  getNextPart(partList, frag, targetBufferTime) {
    let nextPart = -1;
    let contiguous = false;
    let independentAttrOmitted = true;
    for (let i = 0, len = partList.length; i < len; i++) {
      const part = partList[i];
      independentAttrOmitted = independentAttrOmitted && !part.independent;
      if (nextPart > -1 && targetBufferTime < part.start) {
        break;
      }
      const loaded = part.loaded;
      if (loaded) {
        nextPart = -1;
      } else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) {
        nextPart = i;
      }
      contiguous = loaded;
    }
    return nextPart;
  }
  loadedEndOfParts(partList, targetBufferTime) {
    const lastPart = partList[partList.length - 1];
    return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
  }

  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(levelDetails, fragments) {
    const fragPrevious = this.fragPrevious;
    let frag = null;
    if (fragPrevious) {
      if (levelDetails.hasProgramDateTime) {
        // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
        this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
        frag = findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
      }
      if (!frag) {
        // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
        const targetSN = fragPrevious.sn + 1;
        if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
          const fragNext = fragments[targetSN - levelDetails.startSN];
          // Ensure that we're staying within the continuity range, since PTS resets upon a new range
          if (fragPrevious.cc === fragNext.cc) {
            frag = fragNext;
            this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
          }
        }
        // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
        // will have the wrong start times
        if (!frag) {
          frag = findFragWithCC(fragments, fragPrevious.cc);
          if (frag) {
            this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
          }
        }
      }
    } else {
      // Find a new start fragment when fragPrevious is null
      const liveStart = this.hls.liveSyncPosition;
      if (liveStart !== null) {
        frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
      }
    }
    return frag;
  }

  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(bufferEnd, end, levelDetails) {
    const {
      config
    } = this;
    let {
      fragPrevious
    } = this;
    let {
      fragments,
      endSN
    } = levelDetails;
    const {
      fragmentHint
    } = levelDetails;
    const {
      maxFragLookUpTolerance
    } = config;
    const partList = levelDetails.partList;
    const loadingParts = !!(config.lowLatencyMode && partList != null && partList.length && fragmentHint);
    if (loadingParts && fragmentHint && !this.bitrateTest) {
      // Include incomplete fragment with parts at end
      fragments = fragments.concat(fragmentHint);
      endSN = fragmentHint.sn;
    }
    let frag;
    if (bufferEnd < end) {
      const lookupTolerance = bufferEnd > end - maxFragLookUpTolerance ? 0 : maxFragLookUpTolerance;
      // Remove the tolerance if it would put the bufferEnd past the actual end of stream
      // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
      frag = findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
    } else {
      // reach end of playlist
      frag = fragments[fragments.length - 1];
    }
    if (frag) {
      const curSNIdx = frag.sn - levelDetails.startSN;
      // Move fragPrevious forward to support forcing the next fragment to load
      // when the buffer catches up to a previously buffered range.
      const fragState = this.fragmentTracker.getState(frag);
      if (fragState === FragmentState.OK || fragState === FragmentState.PARTIAL && frag.gap) {
        fragPrevious = frag;
      }
      if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn)) {
        // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
        // non-uniform fragment durations
        const sameLevel = fragPrevious && frag.level === fragPrevious.level;
        if (sameLevel) {
          const nextFrag = fragments[curSNIdx + 1];
          if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== FragmentState.OK) {
            frag = nextFrag;
          } else {
            frag = null;
          }
        }
      }
    }
    return frag;
  }
  synchronizeToLiveEdge(levelDetails) {
    const {
      config,
      media
    } = this;
    if (!media) {
      return;
    }
    const liveSyncPosition = this.hls.liveSyncPosition;
    const currentTime = media.currentTime;
    const start = levelDetails.fragments[0].start;
    const end = levelDetails.edge;
    const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
    // Continue if we can seek forward to sync position or if current time is outside of sliding window
    if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
      // Continue if buffer is starving or if current time is behind max latency
      const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
      if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
        if (!this.loadedmetadata) {
          this.nextLoadPosition = liveSyncPosition;
        }
        // Only seek if ready and there is not a significant forward buffer available for playback
        if (media.readyState) {
          this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
          media.currentTime = liveSyncPosition;
        }
      }
    }
  }
  alignPlaylists(details, previousDetails, switchDetails) {
    // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
    //  this could all go in level-helper mergeDetails()
    const length = details.fragments.length;
    if (!length) {
      this.warn(`No fragments in live playlist`);
      return 0;
    }
    const slidingStart = details.fragments[0].start;
    const firstLevelLoad = !previousDetails;
    const aligned = details.alignedSliding && isFiniteNumber(slidingStart);
    if (firstLevelLoad || !aligned && !slidingStart) {
      const {
        fragPrevious
      } = this;
      alignStream(fragPrevious, switchDetails, details);
      const alignedSlidingStart = details.fragments[0].start;
      this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} prev-sn: ${fragPrevious ? fragPrevious.sn : 'na'} fragments: ${length}`);
      return alignedSlidingStart;
    }
    return slidingStart;
  }
  waitForCdnTuneIn(details) {
    // Wait for Low-Latency CDN Tune-in to get an updated playlist
    const advancePartLimit = 3;
    return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
  }
  setStartPosition(details, sliding) {
    // compute start position if set to -1. use it straight away if value is defined
    let startPosition = this.startPosition;
    if (startPosition < sliding) {
      startPosition = -1;
    }
    if (startPosition === -1 || this.lastCurrentTime === -1) {
      // Use Playlist EXT-X-START:TIME-OFFSET when set
      // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
      const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
      const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
      if (startTimeOffset !== null && isFiniteNumber(startTimeOffset)) {
        startPosition = sliding + startTimeOffset;
        if (startTimeOffset < 0) {
          startPosition += details.totalduration;
        }
        startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
        this.log(`Start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist, adjust startPosition to ${startPosition}`);
        this.startPosition = startPosition;
      } else if (details.live) {
        // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
        // not been specified via the config or an as an argument to startLoad (#3736).
        startPosition = this.hls.liveSyncPosition || sliding;
      } else {
        this.startPosition = startPosition = 0;
      }
      this.lastCurrentTime = startPosition;
    }
    this.nextLoadPosition = startPosition;
  }
  getLoadPosition() {
    const {
      media
    } = this;
    // if we have not yet loaded any fragment, start loading from start position
    let pos = 0;
    if (this.loadedmetadata && media) {
      pos = media.currentTime;
    } else if (this.nextLoadPosition) {
      pos = this.nextLoadPosition;
    }
    return pos;
  }
  handleFragLoadAborted(frag, part) {
    if (this.transmuxer && frag.sn !== 'initSegment' && frag.stats.aborted) {
      this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${frag.level} was aborted`);
      this.resetFragmentLoading(frag);
    }
  }
  resetFragmentLoading(frag) {
    if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== State.FRAG_LOADING_WAITING_RETRY) {
      this.state = State.IDLE;
    }
  }
  onFragmentOrKeyLoadError(filterType, data) {
    if (data.chunkMeta && !data.frag) {
      const context = this.getCurrentContext(data.chunkMeta);
      if (context) {
        data.frag = context.frag;
      }
    }
    const frag = data.frag;
    // Handle frag error related to caller's filterType
    if (!frag || frag.type !== filterType || !this.levels) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      var _this$fragCurrent2;
      this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent2 = this.fragCurrent) == null ? void 0 : _this$fragCurrent2.url}`);
      return;
    }
    const gapTagEncountered = data.details === ErrorDetails.FRAG_GAP;
    if (gapTagEncountered) {
      this.fragmentTracker.fragBuffered(frag, true);
    }
    // keep retrying until the limit will be reached
    const errorAction = data.errorAction;
    const {
      action,
      retryCount = 0,
      retryConfig
    } = errorAction || {};
    if (errorAction && action === NetworkErrorAction.RetryRequest && retryConfig) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const delay = getRetryDelay(retryConfig, retryCount);
      this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
      errorAction.resolved = true;
      this.retryDate = self.performance.now() + delay;
      this.state = State.FRAG_LOADING_WAITING_RETRY;
    } else if (retryConfig && errorAction) {
      this.resetFragmentErrors(filterType);
      if (retryCount < retryConfig.maxNumRetry) {
        // Network retry is skipped when level switch is preferred
        if (!gapTagEncountered && action !== NetworkErrorAction.RemoveAlternatePermanently) {
          errorAction.resolved = true;
        }
      } else {
        logger.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
        return;
      }
    } else if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox) {
      this.state = State.WAITING_LEVEL;
    } else {
      this.state = State.ERROR;
    }
    // Perform next async tick sooner to speed up error action resolution
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(data) {
    // if in appending state
    if (this.state === State.PARSING || this.state === State.PARSED) {
      const frag = data.frag;
      const playlistType = data.parent;
      const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      // reduce max buf len if current position is buffered
      const buffered = bufferedInfo && bufferedInfo.len > 0.5;
      if (buffered) {
        this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
      }
      const flushBuffer = !buffered;
      if (flushBuffer) {
        // current position is not buffered, but browser is still complaining about buffer full error
        // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
        // in that case flush the whole audio buffer to recover
        this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
      }
      if (frag) {
        this.fragmentTracker.removeFragment(frag);
        this.nextLoadPosition = frag.start;
      }
      this.resetLoadingState();
      return flushBuffer;
    }
    return false;
  }
  resetFragmentErrors(filterType) {
    if (filterType === PlaylistLevelType.AUDIO) {
      // Reset current fragment since audio track audio is essential and may not have a fail-over track
      this.fragCurrent = null;
    }
    // Fragment errors that result in a level switch or redundant fail-over
    // should reset the stream controller state to idle
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
    }
    if (this.state !== State.STOPPED) {
      this.state = State.IDLE;
    }
  }
  afterBufferFlushed(media, bufferType, playlistType) {
    if (!media) {
      return;
    }
    // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
    // (so that we will check against video.buffered ranges in case of alt audio track)
    const bufferedTimeRanges = BufferHelper.getBuffered(media);
    this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
    if (this.state === State.ENDED) {
      this.resetLoadingState();
    }
  }
  resetLoadingState() {
    this.log('Reset loading state');
    this.fragCurrent = null;
    this.fragPrevious = null;
    this.state = State.IDLE;
  }
  resetStartWhenNotLoaded(level) {
    // if loadedmetadata is not set, it means that first frag request failed
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      const details = level ? level.details : null;
      if (details != null && details.live) {
        // Update the start position and return to IDLE to recover live start
        this.startPosition = -1;
        this.setStartPosition(details, 0);
        this.resetLoadingState();
      } else {
        this.nextLoadPosition = this.startPosition;
      }
    }
  }
  resetWhenMissingContext(chunkMeta) {
    this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of level ${chunkMeta.level}. This chunk will not be buffered.`);
    this.removeUnbufferedFrags();
    this.resetStartWhenNotLoaded(this.levelLastLoaded);
    this.resetLoadingState();
  }
  removeUnbufferedFrags(start = 0) {
    this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
  }
  updateLevelTiming(frag, part, level, partial) {
    var _this$transmuxer;
    const details = level.details;
    if (!details) {
      this.warn('level.details undefined');
      return;
    }
    const parsed = Object.keys(frag.elementaryStreams).reduce((result, type) => {
      const info = frag.elementaryStreams[type];
      if (info) {
        const parsedDuration = info.endPTS - info.startPTS;
        if (parsedDuration <= 0) {
          // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
          // The new transmuxer will be configured with a time offset matching the next fragment start,
          // preventing the timeline from shifting.
          this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
          return result || false;
        }
        const drift = partial ? 0 : updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
        this.hls.trigger(Events.LEVEL_PTS_UPDATED, {
          details,
          level,
          drift,
          type,
          frag,
          start: info.startPTS,
          end: info.endPTS
        });
        return true;
      }
      return result;
    }, false);
    if (!parsed && ((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
      const error = new Error(`Found no media in fragment ${frag.sn} of level ${frag.level} resetting transmuxer to fallback to playlist timing`);
      if (level.fragmentError === 0) {
        // Mark and track the odd empty segment as a gap to avoid reloading
        level.fragmentError++;
        frag.gap = true;
        this.fragmentTracker.removeFragment(frag);
        this.fragmentTracker.fragBuffered(frag, true);
      }
      this.warn(error.message);
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.FRAG_PARSING_ERROR,
        fatal: false,
        error,
        frag,
        reason: `Found no media in msn ${frag.sn} of level "${level.url}"`
      });
      if (!this.hls) {
        return;
      }
      this.resetTransmuxer();
      // For this error fallthrough. Marking parsed will allow advancing to next fragment.
    }
    this.state = State.PARSED;
    this.hls.trigger(Events.FRAG_PARSED, {
      frag,
      part
    });
  }
  resetTransmuxer() {
    if (this.transmuxer) {
      this.transmuxer.destroy();
      this.transmuxer = null;
    }
  }
  recoverWorkerError(data) {
    if (data.event === 'demuxerWorker') {
      this.fragmentTracker.removeAllFragments();
      this.resetTransmuxer();
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      this.resetLoadingState();
    }
  }
  set state(nextState) {
    const previousState = this._state;
    if (previousState !== nextState) {
      this._state = nextState;
      this.log(`${previousState}->${nextState}`);
    }
  }
  get state() {
    return this._state;
  }
}

class ChunkCache {
  constructor() {
    this.chunks = [];
    this.dataLength = 0;
  }
  push(chunk) {
    this.chunks.push(chunk);
    this.dataLength += chunk.length;
  }
  flush() {
    const {
      chunks,
      dataLength
    } = this;
    let result;
    if (!chunks.length) {
      return new Uint8Array(0);
    } else if (chunks.length === 1) {
      result = chunks[0];
    } else {
      result = concatUint8Arrays(chunks, dataLength);
    }
    this.reset();
    return result;
  }
  reset() {
    this.chunks.length = 0;
    this.dataLength = 0;
  }
}
function concatUint8Arrays(chunks, dataLength) {
  const result = new Uint8Array(dataLength);
  let offset = 0;
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    result.set(chunk, offset);
    offset += chunk.length;
  }
  return result;
}

// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
function hasUMDWorker() {
  return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function injectWorker() {
  const blob = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: 'text/javascript'
  });
  const objectURL = self.URL.createObjectURL(blob);
  const worker = new self.Worker(objectURL);
  return {
    worker,
    objectURL
  };
}
function loadWorker(path) {
  const scriptURL = new self.URL(path, self.location.href).href;
  const worker = new self.Worker(scriptURL);
  return {
    worker,
    scriptURL
  };
}

function dummyTrack(type = '', inputTimeScale = 90000) {
  return {
    type,
    id: -1,
    pid: -1,
    inputTimeScale,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}

class BaseAudioDemuxer {
  constructor() {
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this.frameIndex = 0;
    this.cachedData = null;
    this.basePTS = null;
    this.initPTS = null;
    this.lastPTS = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this._id3Track = {
      type: 'id3',
      id: 3,
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(deaultTimestamp) {
    this.initPTS = deaultTimestamp;
    this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null;
    this.lastPTS = null;
    this.frameIndex = 0;
  }
  canParse(data, offset) {
    return false;
  }
  appendFrame(track, data, offset) {}

  // feed incoming data to the front of the parsing pipeline
  demux(data, timeOffset) {
    if (this.cachedData) {
      data = appendUint8Array(this.cachedData, data);
      this.cachedData = null;
    }
    let id3Data = getID3Data(data, 0);
    let offset = id3Data ? id3Data.length : 0;
    let lastDataIndex;
    const track = this._audioTrack;
    const id3Track = this._id3Track;
    const timestamp = id3Data ? getTimeStamp(id3Data) : undefined;
    const length = data.length;
    if (this.basePTS === null || this.frameIndex === 0 && isFiniteNumber(timestamp)) {
      this.basePTS = initPTSFn(timestamp, timeOffset, this.initPTS);
      this.lastPTS = this.basePTS;
    }
    if (this.lastPTS === null) {
      this.lastPTS = this.basePTS;
    }

    // more expressive than alternative: id3Data?.length
    if (id3Data && id3Data.length > 0) {
      id3Track.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: id3Data,
        type: MetadataSchema.audioId3,
        duration: Number.POSITIVE_INFINITY
      });
    }
    while (offset < length) {
      if (this.canParse(data, offset)) {
        const frame = this.appendFrame(track, data, offset);
        if (frame) {
          this.frameIndex++;
          this.lastPTS = frame.sample.pts;
          offset += frame.length;
          lastDataIndex = offset;
        } else {
          offset = length;
        }
      } else if (canParse$2(data, offset)) {
        // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
        id3Data = getID3Data(data, offset);
        id3Track.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: id3Data,
          type: MetadataSchema.audioId3,
          duration: Number.POSITIVE_INFINITY
        });
        offset += id3Data.length;
        lastDataIndex = offset;
      } else {
        offset++;
      }
      if (offset === length && lastDataIndex !== length) {
        const partialData = sliceUint8(data, lastDataIndex);
        if (this.cachedData) {
          this.cachedData = appendUint8Array(this.cachedData, partialData);
        } else {
          this.cachedData = partialData;
        }
      }
    }
    return {
      audioTrack: track,
      videoTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(timeOffset) {
    // Parse cache in case of remaining frames.
    const cachedData = this.cachedData;
    if (cachedData) {
      this.cachedData = null;
      this.demux(cachedData, 0);
    }
    return {
      audioTrack: this._audioTrack,
      videoTrack: dummyTrack(),
      id3Track: this._id3Track,
      textTrack: dummyTrack()
    };
  }
  destroy() {}
}

/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */
const initPTSFn = (timestamp, timeOffset, initPTS) => {
  if (isFiniteNumber(timestamp)) {
    return timestamp * 90;
  }
  const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
  return timeOffset * 90000 + init90kHz;
};

/**
 * ADTS parser helper
 * @link https://wiki.multimedia.cx/index.php?title=ADTS
 */
function getAudioConfig(observer, data, offset, audioCodec) {
  let adtsObjectType;
  let adtsExtensionSamplingIndex;
  let adtsChannelConfig;
  let config;
  const userAgent = navigator.userAgent.toLowerCase();
  const manifestCodec = audioCodec;
  const adtsSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
  // byte 2
  adtsObjectType = ((data[offset + 2] & 0xc0) >>> 6) + 1;
  const adtsSamplingIndex = (data[offset + 2] & 0x3c) >>> 2;
  if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
    const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
    observer.emit(Events.ERROR, Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      fatal: true,
      error,
      reason: error.message
    });
    return;
  }
  adtsChannelConfig = (data[offset + 2] & 0x01) << 2;
  // byte 3
  adtsChannelConfig |= (data[offset + 3] & 0xc0) >>> 6;
  logger.log(`manifest codec:${audioCodec}, ADTS type:${adtsObjectType}, samplingIndex:${adtsSamplingIndex}`);
  // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
  if (/firefox/i.test(userAgent)) {
    if (adtsSamplingIndex >= 6) {
      adtsObjectType = 5;
      config = new Array(4);
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
    // Android : always use AAC
  } else if (userAgent.indexOf('android') !== -1) {
    adtsObjectType = 2;
    config = new Array(2);
    adtsExtensionSamplingIndex = adtsSamplingIndex;
  } else {
    /*  for other browsers (Chrome/Vivaldi/Opera ...)
        always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
    */
    adtsObjectType = 5;
    config = new Array(4);
    // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
    if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSamplingIndex >= 6) {
      // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
      // there is a factor 2 between frame sample rate and output sample rate
      // multiply frequency by 2 (see table below, equivalent to substract 3)
      adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
    } else {
      // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
      // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
      if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
        adtsObjectType = 2;
        config = new Array(2);
      }
      adtsExtensionSamplingIndex = adtsSamplingIndex;
    }
  }
  /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */
  // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
  config[0] = adtsObjectType << 3;
  // samplingFrequencyIndex
  config[0] |= (adtsSamplingIndex & 0x0e) >> 1;
  config[1] |= (adtsSamplingIndex & 0x01) << 7;
  // channelConfiguration
  config[1] |= adtsChannelConfig << 3;
  if (adtsObjectType === 5) {
    // adtsExtensionSamplingIndex
    config[1] |= (adtsExtensionSamplingIndex & 0x0e) >> 1;
    config[2] = (adtsExtensionSamplingIndex & 0x01) << 7;
    // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
    //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
    config[2] |= 2 << 2;
    config[3] = 0;
  }
  return {
    config,
    samplerate: adtsSamplingRates[adtsSamplingIndex],
    channelCount: adtsChannelConfig,
    codec: 'mp4a.40.' + adtsObjectType,
    manifestCodec
  };
}
function isHeaderPattern$1(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function getHeaderLength(data, offset) {
  return data[offset + 1] & 0x01 ? 7 : 9;
}
function getFullFrameLength(data, offset) {
  return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function canGetFrameLength(data, offset) {
  return offset + 5 < data.length;
}
function isHeader$1(data, offset) {
  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
  // More info https://wiki.multimedia.cx/index.php?title=ADTS
  return offset + 1 < data.length && isHeaderPattern$1(data, offset);
}
function canParse$1(data, offset) {
  return canGetFrameLength(data, offset) && isHeaderPattern$1(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
}
function probe$1(data, offset) {
  // same as isHeader but we also check that ADTS frame follows last ADTS frame
  // or end of data is reached
  if (isHeader$1(data, offset)) {
    // ADTS header Length
    const headerLength = getHeaderLength(data, offset);
    if (offset + headerLength >= data.length) {
      return false;
    }
    // ADTS frame Length
    const frameLength = getFullFrameLength(data, offset);
    if (frameLength <= headerLength) {
      return false;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader$1(data, newOffset);
  }
  return false;
}
function initTrackConfig(track, observer, data, offset, audioCodec) {
  if (!track.samplerate) {
    const config = getAudioConfig(observer, data, offset, audioCodec);
    if (!config) {
      return;
    }
    track.config = config.config;
    track.samplerate = config.samplerate;
    track.channelCount = config.channelCount;
    track.codec = config.codec;
    track.manifestCodec = config.manifestCodec;
    logger.log(`parsed codec:${track.codec}, rate:${config.samplerate}, channels:${config.channelCount}`);
  }
}
function getFrameDuration(samplerate) {
  return 1024 * 90000 / samplerate;
}
function parseFrameHeader(data, offset) {
  // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
  const headerLength = getHeaderLength(data, offset);
  if (offset + headerLength <= data.length) {
    // retrieve frame size
    const frameLength = getFullFrameLength(data, offset) - headerLength;
    if (frameLength > 0) {
      // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
      return {
        headerLength,
        frameLength
      };
    }
  }
}
function appendFrame$2(track, data, offset, pts, frameIndex) {
  const frameDuration = getFrameDuration(track.samplerate);
  const stamp = pts + frameIndex * frameDuration;
  const header = parseFrameHeader(data, offset);
  let unit;
  if (header) {
    const {
      frameLength,
      headerLength
    } = header;
    const _length = headerLength + frameLength;
    const missing = Math.max(0, offset + _length - data.length);
    // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
    if (missing) {
      unit = new Uint8Array(_length - headerLength);
      unit.set(data.subarray(offset + headerLength, data.length), 0);
    } else {
      unit = data.subarray(offset + headerLength, offset + _length);
    }
    const _sample = {
      unit,
      pts: stamp
    };
    if (!missing) {
      track.samples.push(_sample);
    }
    return {
      sample: _sample,
      length: _length,
      missing
    };
  }
  // overflow incomplete header
  const length = data.length - offset;
  unit = new Uint8Array(length);
  unit.set(data.subarray(offset, data.length), 0);
  const sample = {
    unit,
    pts: stamp
  };
  return {
    sample,
    length,
    missing: -1
  };
}

/**
 *  MPEG parser helper
 */

let chromeVersion$1 = null;
const BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
const SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];
const SamplesCoefficients = [
// MPEG 2.5
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// Reserved
[0,
// Reserved
0,
// Layer3
0,
// Layer2
0 // Layer1
],
// MPEG 2
[0,
// Reserved
72,
// Layer3
144,
// Layer2
12 // Layer1
],
// MPEG 1
[0,
// Reserved
144,
// Layer3
144,
// Layer2
12 // Layer1
]];
const BytesInSlot = [0,
// Reserved
1,
// Layer3
1,
// Layer2
4 // Layer1
];
function appendFrame$1(track, data, offset, pts, frameIndex) {
  // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
  if (offset + 24 > data.length) {
    return;
  }
  const header = parseHeader(data, offset);
  if (header && offset + header.frameLength <= data.length) {
    const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
    const stamp = pts + frameIndex * frameDuration;
    const sample = {
      unit: data.subarray(offset, offset + header.frameLength),
      pts: stamp,
      dts: stamp
    };
    track.config = [];
    track.channelCount = header.channelCount;
    track.samplerate = header.sampleRate;
    track.samples.push(sample);
    return {
      sample,
      length: header.frameLength,
      missing: 0
    };
  }
}
function parseHeader(data, offset) {
  const mpegVersion = data[offset + 1] >> 3 & 3;
  const mpegLayer = data[offset + 1] >> 1 & 3;
  const bitRateIndex = data[offset + 2] >> 4 & 15;
  const sampleRateIndex = data[offset + 2] >> 2 & 3;
  if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
    const paddingBit = data[offset + 2] >> 1 & 1;
    const channelMode = data[offset + 3] >> 6;
    const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
    const bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
    const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
    const sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
    const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
    const sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
    const bytesInSlot = BytesInSlot[mpegLayer];
    const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
    const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
    if (chromeVersion$1 === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion$1 = result ? parseInt(result[1]) : 0;
    }
    const needChromeFix = !!chromeVersion$1 && chromeVersion$1 <= 87;
    if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) {
      // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
      data[offset + 3] = data[offset + 3] | 0x80;
    }
    return {
      sampleRate,
      channelCount,
      frameLength,
      samplesPerFrame
    };
  }
}
function isHeaderPattern(data, offset) {
  return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function isHeader(data, offset) {
  // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
  // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
  // More info http://www.mp3-tech.org/programmer/frame_header.html
  return offset + 1 < data.length && isHeaderPattern(data, offset);
}
function canParse(data, offset) {
  const headerSize = 4;
  return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function probe(data, offset) {
  // same as isHeader but we also check that MPEG frame follows last MPEG frame
  // or end of data is reached
  if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
    // MPEG header Length
    const headerLength = 4;
    // MPEG frame Length
    const header = parseHeader(data, offset);
    let frameLength = headerLength;
    if (header != null && header.frameLength) {
      frameLength = header.frameLength;
    }
    const newOffset = offset + frameLength;
    return newOffset === data.length || isHeader(data, newOffset);
  }
  return false;
}

/**
 * AAC demuxer
 */
class AACDemuxer extends BaseAudioDemuxer {
  constructor(observer, config) {
    super();
    this.observer = void 0;
    this.config = void 0;
    this.observer = observer;
    this.config = config;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/adts',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'aac',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }

  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(data) {
    if (!data) {
      return false;
    }

    // Check for the ADTS sync word
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    const id3Data = getID3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
    if (probe(data, offset)) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe$1(data, offset)) {
        logger.log('ADTS sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse$1(data, offset);
  }
  appendFrame(track, data, offset) {
    initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
    const frame = appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
    if (frame && frame.missing === 0) {
      return frame;
    }
  }
}

const emsgSchemePattern = /\/emsg[-/]ID3/i;
class MP4Demuxer {
  constructor(observer, config) {
    this.remainderData = null;
    this.timeOffset = 0;
    this.config = void 0;
    this.videoTrack = void 0;
    this.audioTrack = void 0;
    this.id3Track = void 0;
    this.txtTrack = void 0;
    this.config = config;
  }
  resetTimeStamp() {}
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    const videoTrack = this.videoTrack = dummyTrack('video', 1);
    const audioTrack = this.audioTrack = dummyTrack('audio', 1);
    const captionTrack = this.txtTrack = dummyTrack('text', 1);
    this.id3Track = dummyTrack('id3', 1);
    this.timeOffset = 0;
    if (!(initSegment != null && initSegment.byteLength)) {
      return;
    }
    const initData = parseInitSegment(initSegment);
    if (initData.video) {
      const {
        id,
        timescale,
        codec
      } = initData.video;
      videoTrack.id = id;
      videoTrack.timescale = captionTrack.timescale = timescale;
      videoTrack.codec = codec;
    }
    if (initData.audio) {
      const {
        id,
        timescale,
        codec
      } = initData.audio;
      audioTrack.id = id;
      audioTrack.timescale = timescale;
      audioTrack.codec = codec;
    }
    captionTrack.id = RemuxerTrackIdConfig.text;
    videoTrack.sampleDuration = 0;
    videoTrack.duration = audioTrack.duration = trackDuration;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(data) {
    return hasMoofData(data);
  }
  demux(data, timeOffset) {
    this.timeOffset = timeOffset;
    // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
    let videoSamples = data;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    if (this.config.progressive) {
      // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
      // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
      // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
      if (this.remainderData) {
        videoSamples = appendUint8Array(this.remainderData, data);
      }
      const segmentedData = segmentValidRange(videoSamples);
      this.remainderData = segmentedData.remainder;
      videoTrack.samples = segmentedData.valid || new Uint8Array();
    } else {
      videoTrack.samples = videoSamples;
    }
    const id3Track = this.extractID3Track(videoTrack, timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: this.audioTrack,
      id3Track,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const timeOffset = this.timeOffset;
    const videoTrack = this.videoTrack;
    const textTrack = this.txtTrack;
    videoTrack.samples = this.remainderData || new Uint8Array();
    this.remainderData = null;
    const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
    textTrack.samples = parseSamples(timeOffset, videoTrack);
    return {
      videoTrack,
      audioTrack: dummyTrack(),
      id3Track,
      textTrack: dummyTrack()
    };
  }
  extractID3Track(videoTrack, timeOffset) {
    const id3Track = this.id3Track;
    if (videoTrack.samples.length) {
      const emsgs = findBox(videoTrack.samples, ['emsg']);
      if (emsgs) {
        emsgs.forEach(data => {
          const emsgInfo = parseEmsg(data);
          if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
            const pts = isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
            let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
            // Safari takes anything <= 0.001 seconds and maps it to Infinity
            if (duration <= 0.001) {
              duration = Number.POSITIVE_INFINITY;
            }
            const payload = emsgInfo.payload;
            id3Track.samples.push({
              data: payload,
              len: payload.byteLength,
              dts: pts,
              pts: pts,
              type: MetadataSchema.emsg,
              duration: duration
            });
          }
        });
      }
    }
    return id3Track;
  }
  demuxSampleAes(data, keyData, timeOffset) {
    return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
  }
  destroy() {}
}

const getAudioBSID = (data, offset) => {
  // check the bsid to confirm ac-3 | ec-3
  let bsid = 0;
  let numBits = 5;
  offset += numBits;
  const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
  const mask = new Uint32Array(1); // unsigned 32 bit mask value
  const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
  while (numBits > 0) {
    byte[0] = data[offset];
    // read remaining bits, upto 8 bits at a time
    const bits = Math.min(numBits, 8);
    const shift = 8 - bits;
    mask[0] = 0xff000000 >>> 24 + shift << shift;
    temp[0] = (byte[0] & mask[0]) >> shift;
    bsid = !bsid ? temp[0] : bsid << bits | temp[0];
    offset += 1;
    numBits -= bits;
  }
  return bsid;
};

class AC3Demuxer extends BaseAudioDemuxer {
  constructor(observer) {
    super();
    this.observer = void 0;
    this.observer = observer;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/ac-3',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'ac3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  canParse(data, offset) {
    return offset + 64 < data.length;
  }
  appendFrame(track, data, offset) {
    const frameLength = appendFrame(track, data, offset, this.basePTS, this.frameIndex);
    if (frameLength !== -1) {
      const sample = track.samples[track.samples.length - 1];
      return {
        sample,
        length: frameLength,
        missing: 0
      };
    }
  }
  static probe(data) {
    if (!data) {
      return false;
    }
    const id3Data = getID3Data(data, 0);
    if (!id3Data) {
      return false;
    }

    // look for the ac-3 sync bytes
    const offset = id3Data.length;
    if (data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3
    getAudioBSID(data, offset) < 16) {
      return true;
    }
    return false;
  }
}
function appendFrame(track, data, start, pts, frameIndex) {
  if (start + 8 > data.length) {
    return -1; // not enough bytes left
  }
  if (data[start] !== 0x0b || data[start + 1] !== 0x77) {
    return -1; // invalid magic
  }

  // get sample rate
  const samplingRateCode = data[start + 4] >> 6;
  if (samplingRateCode >= 3) {
    return -1; // invalid sampling rate
  }
  const samplingRateMap = [48000, 44100, 32000];
  const sampleRate = samplingRateMap[samplingRateCode];

  // get frame size
  const frameSizeCode = data[start + 4] & 0x3f;
  const frameSizeMap = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920];
  const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
  if (start + frameLength > data.length) {
    return -1;
  }

  // get channel count
  const channelMode = data[start + 6] >> 5;
  let skipCount = 0;
  if (channelMode === 2) {
    skipCount += 2;
  } else {
    if (channelMode & 1 && channelMode !== 1) {
      skipCount += 2;
    }
    if (channelMode & 4) {
      skipCount += 2;
    }
  }
  const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
  const channelsMap = [2, 1, 2, 3, 3, 4, 4, 5];
  const channelCount = channelsMap[channelMode] + lfeon;

  // build dac3 box
  const bsid = data[start + 5] >> 3;
  const bsmod = data[start + 5] & 7;
  const config = new Uint8Array([samplingRateCode << 6 | bsid << 1 | bsmod >> 2, (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4, frameSizeCode << 4 & 0xe0]);
  const frameDuration = 1536 / sampleRate * 90000;
  const stamp = pts + frameIndex * frameDuration;
  const unit = data.subarray(start, start + frameLength);
  track.config = config;
  track.channelCount = channelCount;
  track.samplerate = sampleRate;
  track.samples.push({
    unit,
    pts: stamp
  });
  return frameLength;
}

class BaseVideoParser {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(key, pts, dts, debug) {
    return {
      key,
      frame: false,
      pts,
      dts,
      units: [],
      debug,
      length: 0
    };
  }
  getLastNalUnit(samples) {
    var _VideoSample;
    let VideoSample = this.VideoSample;
    let lastUnit;
    // try to fallback to previous sample if current one is empty
    if (!VideoSample || VideoSample.units.length === 0) {
      VideoSample = samples[samples.length - 1];
    }
    if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
      const units = VideoSample.units;
      lastUnit = units[units.length - 1];
    }
    return lastUnit;
  }
  pushAccessUnit(VideoSample, videoTrack) {
    if (VideoSample.units.length && VideoSample.frame) {
      // if sample does not have PTS/DTS, patch with last sample PTS/DTS
      if (VideoSample.pts === undefined) {
        const samples = videoTrack.samples;
        const nbSamples = samples.length;
        if (nbSamples) {
          const lastSample = samples[nbSamples - 1];
          VideoSample.pts = lastSample.pts;
          VideoSample.dts = lastSample.dts;
        } else {
          // dropping samples, no timestamp found
          videoTrack.dropped++;
          return;
        }
      }
      videoTrack.samples.push(VideoSample);
    }
    if (VideoSample.debug.length) {
      logger.log(VideoSample.pts + '/' + VideoSample.dts + ':' + VideoSample.debug);
    }
  }
}

/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */

class ExpGolomb {
  constructor(data) {
    this.data = void 0;
    this.bytesAvailable = void 0;
    this.word = void 0;
    this.bitsAvailable = void 0;
    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void
  loadWord() {
    const data = this.data;
    const bytesAvailable = this.bytesAvailable;
    const position = data.byteLength - bytesAvailable;
    const workingBytes = new Uint8Array(4);
    const availableBytes = Math.min(4, bytesAvailable);
    if (availableBytes === 0) {
      throw new Error('no bytes available');
    }
    workingBytes.set(data.subarray(position, position + availableBytes));
    this.word = new DataView(workingBytes.buffer).getUint32(0);
    // track the amount of this.data that has been processed
    this.bitsAvailable = availableBytes * 8;
    this.bytesAvailable -= availableBytes;
  }

  // (count:int):void
  skipBits(count) {
    let skipBytes; // :int
    count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
    if (this.bitsAvailable > count) {
      this.word <<= count;
      this.bitsAvailable -= count;
    } else {
      count -= this.bitsAvailable;
      skipBytes = count >> 3;
      count -= skipBytes << 3;
      this.bytesAvailable -= skipBytes;
      this.loadWord();
      this.word <<= count;
      this.bitsAvailable -= count;
    }
  }

  // (size:int):uint
  readBits(size) {
    let bits = Math.min(this.bitsAvailable, size); // :uint
    const valu = this.word >>> 32 - bits; // :uint
    if (size > 32) {
      logger.error('Cannot read more than 32 bits at a time');
    }
    this.bitsAvailable -= bits;
    if (this.bitsAvailable > 0) {
      this.word <<= bits;
    } else if (this.bytesAvailable > 0) {
      this.loadWord();
    } else {
      throw new Error('no bits available');
    }
    bits = size - bits;
    if (bits > 0 && this.bitsAvailable) {
      return valu << bits | this.readBits(bits);
    } else {
      return valu;
    }
  }

  // ():uint
  skipLZ() {
    let leadingZeroCount; // :uint
    for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
      if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
        // the first bit of working word is 1
        this.word <<= leadingZeroCount;
        this.bitsAvailable -= leadingZeroCount;
        return leadingZeroCount;
      }
    }
    // we exhausted word and still have not found a 1
    this.loadWord();
    return leadingZeroCount + this.skipLZ();
  }

  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }

  // ():uint
  readUEG() {
    const clz = this.skipLZ(); // :uint
    return this.readBits(clz + 1) - 1;
  }

  // ():int
  readEG() {
    const valu = this.readUEG(); // :int
    if (0x01 & valu) {
      // the number is odd if the low order bit is set
      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
    } else {
      return -1 * (valu >>> 1); // divide by two then make it negative
    }
  }

  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }

  // ():int
  readUByte() {
    return this.readBits(8);
  }

  // ():int
  readUShort() {
    return this.readBits(16);
  }

  // ():int
  readUInt() {
    return this.readBits(32);
  }

  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(count) {
    let lastScale = 8;
    let nextScale = 8;
    let deltaScale;
    for (let j = 0; j < count; j++) {
      if (nextScale !== 0) {
        deltaScale = this.readEG();
        nextScale = (lastScale + deltaScale + 256) % 256;
      }
      lastScale = nextScale === 0 ? lastScale : nextScale;
    }
  }

  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let frameCropLeftOffset = 0;
    let frameCropRightOffset = 0;
    let frameCropTopOffset = 0;
    let frameCropBottomOffset = 0;
    let numRefFramesInPicOrderCntCycle;
    let scalingListCount;
    let i;
    const readUByte = this.readUByte.bind(this);
    const readBits = this.readBits.bind(this);
    const readUEG = this.readUEG.bind(this);
    const readBoolean = this.readBoolean.bind(this);
    const skipBits = this.skipBits.bind(this);
    const skipEG = this.skipEG.bind(this);
    const skipUEG = this.skipUEG.bind(this);
    const skipScalingList = this.skipScalingList.bind(this);
    readUByte();
    const profileIdc = readUByte(); // profile_idc
    readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
    skipBits(3); // reserved_zero_3bits u(3),
    readUByte(); // level_idc u(8)
    skipUEG(); // seq_parameter_set_id
    // some profiles have more optional data we don't need
    if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
      const chromaFormatIdc = readUEG();
      if (chromaFormatIdc === 3) {
        skipBits(1);
      } // separate_colour_plane_flag

      skipUEG(); // bit_depth_luma_minus8
      skipUEG(); // bit_depth_chroma_minus8
      skipBits(1); // qpprime_y_zero_transform_bypass_flag
      if (readBoolean()) {
        // seq_scaling_matrix_present_flag
        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
        for (i = 0; i < scalingListCount; i++) {
          if (readBoolean()) {
            // seq_scaling_list_present_flag[ i ]
            if (i < 6) {
              skipScalingList(16);
            } else {
              skipScalingList(64);
            }
          }
        }
      }
    }
    skipUEG(); // log2_max_frame_num_minus4
    const picOrderCntType = readUEG();
    if (picOrderCntType === 0) {
      readUEG(); // log2_max_pic_order_cnt_lsb_minus4
    } else if (picOrderCntType === 1) {
      skipBits(1); // delta_pic_order_always_zero_flag
      skipEG(); // offset_for_non_ref_pic
      skipEG(); // offset_for_top_to_bottom_field
      numRefFramesInPicOrderCntCycle = readUEG();
      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
        skipEG();
      } // offset_for_ref_frame[ i ]
    }
    skipUEG(); // max_num_ref_frames
    skipBits(1); // gaps_in_frame_num_value_allowed_flag
    const picWidthInMbsMinus1 = readUEG();
    const picHeightInMapUnitsMinus1 = readUEG();
    const frameMbsOnlyFlag = readBits(1);
    if (frameMbsOnlyFlag === 0) {
      skipBits(1);
    } // mb_adaptive_frame_field_flag

    skipBits(1); // direct_8x8_inference_flag
    if (readBoolean()) {
      // frame_cropping_flag
      frameCropLeftOffset = readUEG();
      frameCropRightOffset = readUEG();
      frameCropTopOffset = readUEG();
      frameCropBottomOffset = readUEG();
    }
    let pixelRatio = [1, 1];
    if (readBoolean()) {
      // vui_parameters_present_flag
      if (readBoolean()) {
        // aspect_ratio_info_present_flag
        const aspectRatioIdc = readUByte();
        switch (aspectRatioIdc) {
          case 1:
            pixelRatio = [1, 1];
            break;
          case 2:
            pixelRatio = [12, 11];
            break;
          case 3:
            pixelRatio = [10, 11];
            break;
          case 4:
            pixelRatio = [16, 11];
            break;
          case 5:
            pixelRatio = [40, 33];
            break;
          case 6:
            pixelRatio = [24, 11];
            break;
          case 7:
            pixelRatio = [20, 11];
            break;
          case 8:
            pixelRatio = [32, 11];
            break;
          case 9:
            pixelRatio = [80, 33];
            break;
          case 10:
            pixelRatio = [18, 11];
            break;
          case 11:
            pixelRatio = [15, 11];
            break;
          case 12:
            pixelRatio = [64, 33];
            break;
          case 13:
            pixelRatio = [160, 99];
            break;
          case 14:
            pixelRatio = [4, 3];
            break;
          case 15:
            pixelRatio = [3, 2];
            break;
          case 16:
            pixelRatio = [2, 1];
            break;
          case 255:
            {
              pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
              break;
            }
        }
      }
    }
    return {
      width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
      pixelRatio: pixelRatio
    };
  }
  readSliceType() {
    // skip NALu type
    this.readUByte();
    // discard first_mb_in_slice
    this.readUEG();
    // return slice_type
    return this.readUEG();
  }
}

class AvcVideoParser extends BaseVideoParser {
  parseAVCPES(track, textTrack, pes, last, duration) {
    const units = this.parseAVCNALu(track, pes.data);
    let VideoSample = this.VideoSample;
    let push;
    let spsfound = false;
    // free pes.data to save up some memory
    pes.data = null;

    // if new NAL units found and last sample still there, let's push ...
    // this helps parsing streams with missing AUD (only do this if AUD never found)
    if (VideoSample && units.length && !track.audFound) {
      this.pushAccessUnit(VideoSample, track);
      VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
    }
    units.forEach(unit => {
      var _VideoSample2;
      switch (unit.type) {
        // NDR
        case 1:
          {
            let iskey = false;
            push = true;
            const data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              const sliceType = new ExpGolomb(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              // if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                iskey = true;
              }
            }
            if (iskey) {
              var _VideoSample;
              // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
              if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                this.pushAccessUnit(VideoSample, track);
                VideoSample = this.VideoSample = null;
              }
            }
            if (!VideoSample) {
              VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
            }
            VideoSample.frame = true;
            VideoSample.key = iskey;
            break;
            // IDR
          }
        case 5:
          push = true;
          // handle PES not starting with AUD
          // if we have frame data already, that cannot belong to the same frame, so force a push
          if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = null;
          }
          if (!VideoSample) {
            VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts, '');
          }
          VideoSample.key = true;
          VideoSample.frame = true;
          break;
        // SEI
        case 6:
          {
            push = true;
            parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
            break;
            // SPS
          }
        case 7:
          {
            var _track$pixelRatio, _track$pixelRatio2;
            push = true;
            spsfound = true;
            const sps = unit.data;
            const expGolombDecoder = new ExpGolomb(sps);
            const config = expGolombDecoder.readSPS();
            if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [sps];
              track.duration = duration;
              const codecarray = sps.subarray(1, 4);
              let codecstring = 'avc1.';
              for (let i = 0; i < 3; i++) {
                let h = codecarray[i].toString(16);
                if (h.length < 2) {
                  h = '0' + h;
                }
                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          }
        // PPS
        case 8:
          push = true;
          track.pps = [unit.data];
          break;
        // AUD
        case 9:
          push = true;
          track.audFound = true;
          if (VideoSample) {
            this.pushAccessUnit(VideoSample, track);
          }
          VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts, '');
          break;
        // Filler Data
        case 12:
          push = true;
          break;
        default:
          push = false;
          if (VideoSample) {
            VideoSample.debug += 'unknown NAL ' + unit.type + ' ';
          }
          break;
      }
      if (VideoSample && push) {
        const units = VideoSample.units;
        units.push(unit);
      }
    });
    // if last PES packet, push samples
    if (last && VideoSample) {
      this.pushAccessUnit(VideoSample, track);
      this.VideoSample = null;
    }
  }
  parseAVCNALu(track, array) {
    const len = array.byteLength;
    let state = track.naluState || 0;
    const lastState = state;
    const units = [];
    let i = 0;
    let value;
    let overflow;
    let unitType;
    let lastUnitStart = -1;
    let lastUnitType = 0;
    // logger.log('PES:' + Hex.hexDump(array));

    if (state === -1) {
      // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
      lastUnitStart = 0;
      // NALu type is value read from offset 0
      lastUnitType = array[0] & 0x1f;
      state = 0;
      i = 1;
    }
    while (i < len) {
      value = array[i++];
      // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
      if (!state) {
        state = value ? 0 : 1;
        continue;
      }
      if (state === 1) {
        state = value ? 0 : 2;
        continue;
      }
      // here we have state either equal to 2 or 3
      if (!value) {
        state = 3;
      } else if (value === 1) {
        overflow = i - state - 1;
        if (lastUnitStart >= 0) {
          const unit = {
            data: array.subarray(lastUnitStart, overflow),
            type: lastUnitType
          };
          // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
          units.push(unit);
        } else {
          // lastUnitStart is undefined => this is the first start code found in this PES packet
          // first check if start code delimiter is overlapping between 2 PES packets,
          // ie it started in last packet (lastState not zero)
          // and ended at the beginning of this PES packet (i <= 4 - lastState)
          const lastUnit = this.getLastNalUnit(track.samples);
          if (lastUnit) {
            if (lastState && i <= 4 - lastState) {
              // start delimiter overlapping between PES packets
              // strip start delimiter bytes from the end of last NAL unit
              // check if lastUnit had a state different from zero
              if (lastUnit.state) {
                // strip last bytes
                lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
              }
            }
            // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.

            if (overflow > 0) {
              // logger.log('first NALU found with overflow:' + overflow);
              lastUnit.data = appendUint8Array(lastUnit.data, array.subarray(0, overflow));
              lastUnit.state = 0;
            }
          }
        }
        // check if we can read unit type
        if (i < len) {
          unitType = array[i] & 0x1f;
          // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
          lastUnitStart = i;
          lastUnitType = unitType;
          state = 0;
        } else {
          // not enough byte to read unit type. let's read it on next PES parsing
          state = -1;
        }
      } else {
        state = 0;
      }
    }
    if (lastUnitStart >= 0 && state >= 0) {
      const unit = {
        data: array.subarray(lastUnitStart, len),
        type: lastUnitType,
        state: state
      };
      units.push(unit);
      // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
    }
    // no NALu found
    if (units.length === 0) {
      // append pes.data to previous NAL unit
      const lastUnit = this.getLastNalUnit(track.samples);
      if (lastUnit) {
        lastUnit.data = appendUint8Array(lastUnit.data, array);
      }
    }
    track.naluState = state;
    return units;
  }
}

/**
 * SAMPLE-AES decrypter
 */

class SampleAesDecrypter {
  constructor(observer, config, keyData) {
    this.keyData = void 0;
    this.decrypter = void 0;
    this.keyData = keyData;
    this.decrypter = new Decrypter(config, {
      removePKCS7Padding: false
    });
  }
  decryptBuffer(encryptedData) {
    return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer);
  }

  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(samples, sampleIndex, callback) {
    const curUnit = samples[sampleIndex].unit;
    if (curUnit.length <= 16) {
      // No encrypted portion in this sample (first 16 bytes is not
      // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
      return;
    }
    const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
    const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
    this.decryptBuffer(encryptedBuffer).then(decryptedBuffer => {
      const decryptedData = new Uint8Array(decryptedBuffer);
      curUnit.set(decryptedData, 16);
      if (!this.decrypter.isSync()) {
        this.decryptAacSamples(samples, sampleIndex + 1, callback);
      }
    });
  }
  decryptAacSamples(samples, sampleIndex, callback) {
    for (;; sampleIndex++) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      if (samples[sampleIndex].unit.length < 32) {
        continue;
      }
      this.decryptAacSample(samples, sampleIndex, callback);
      if (!this.decrypter.isSync()) {
        return;
      }
    }
  }

  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(decodedData) {
    const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
    const encryptedData = new Int8Array(encryptedDataLen);
    let outputPos = 0;
    for (let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) {
      encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return encryptedData;
  }
  getAvcDecryptedUnit(decodedData, decryptedData) {
    const uint8DecryptedData = new Uint8Array(decryptedData);
    let inputPos = 0;
    for (let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) {
      decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
    }
    return decodedData;
  }
  decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
    const decodedData = discardEPB(curUnit.data);
    const encryptedData = this.getAvcEncryptedData(decodedData);
    this.decryptBuffer(encryptedData.buffer).then(decryptedBuffer => {
      curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
      if (!this.decrypter.isSync()) {
        this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
      }
    });
  }
  decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
    if (samples instanceof Uint8Array) {
      throw new Error('Cannot decrypt samples of type Uint8Array');
    }
    for (;; sampleIndex++, unitIndex = 0) {
      if (sampleIndex >= samples.length) {
        callback();
        return;
      }
      const curUnits = samples[sampleIndex].units;
      for (;; unitIndex++) {
        if (unitIndex >= curUnits.length) {
          break;
        }
        const curUnit = curUnits[unitIndex];
        if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
          continue;
        }
        this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
        if (!this.decrypter.isSync()) {
          return;
        }
      }
    }
  }
}

const PACKET_LENGTH = 188;
class TSDemuxer {
  constructor(observer, config, typeSupported) {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.sampleAes = null;
    this.pmtParsed = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this._duration = 0;
    this._pmtId = -1;
    this._videoTrack = void 0;
    this._audioTrack = void 0;
    this._id3Track = void 0;
    this._txtTrack = void 0;
    this.aacOverFlow = null;
    this.remainderData = null;
    this.videoParser = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.videoParser = new AvcVideoParser();
  }
  static probe(data) {
    const syncOffset = TSDemuxer.syncOffset(data);
    if (syncOffset > 0) {
      logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
    }
    return syncOffset !== -1;
  }
  static syncOffset(data) {
    const length = data.length;
    let scanwindow = Math.min(PACKET_LENGTH * 5, length - PACKET_LENGTH) + 1;
    let i = 0;
    while (i < scanwindow) {
      // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
      let foundPat = false;
      let packetStart = -1;
      let tsPackets = 0;
      for (let j = i; j < length; j += PACKET_LENGTH) {
        if (data[j] === 0x47 && (length - j === PACKET_LENGTH || data[j + PACKET_LENGTH] === 0x47)) {
          tsPackets++;
          if (packetStart === -1) {
            packetStart = j;
            // First sync word found at offset, increase scan length (#5251)
            if (packetStart !== 0) {
              scanwindow = Math.min(packetStart + PACKET_LENGTH * 99, data.length - PACKET_LENGTH) + 1;
            }
          }
          if (!foundPat) {
            foundPat = parsePID(data, j) === 0;
          }
          // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
          if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + PACKET_LENGTH > scanwindow)) {
            return packetStart;
          }
        } else if (tsPackets) {
          // Exit if sync word found, but does not contain contiguous packets
          return -1;
        } else {
          break;
        }
      }
      i++;
    }
    return -1;
  }

  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(type, duration) {
    return {
      container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
      type,
      id: RemuxerTrackIdConfig[type],
      pid: -1,
      inputTimeScale: 90000,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: type === 'audio' ? duration : undefined
    };
  }

  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    this.pmtParsed = false;
    this._pmtId = -1;
    this._videoTrack = TSDemuxer.createTrack('video');
    this._audioTrack = TSDemuxer.createTrack('audio', trackDuration);
    this._id3Track = TSDemuxer.createTrack('id3');
    this._txtTrack = TSDemuxer.createTrack('text');
    this._audioTrack.segmentCodec = 'aac';

    // flush any partial content
    this.aacOverFlow = null;
    this.remainderData = null;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this._duration = trackDuration;
  }
  resetTimeStamp() {}
  resetContiguity() {
    const {
      _audioTrack,
      _videoTrack,
      _id3Track
    } = this;
    if (_audioTrack) {
      _audioTrack.pesData = null;
    }
    if (_videoTrack) {
      _videoTrack.pesData = null;
    }
    if (_id3Track) {
      _id3Track.pesData = null;
    }
    this.aacOverFlow = null;
    this.remainderData = null;
  }
  demux(data, timeOffset, isSampleAes = false, flush = false) {
    if (!isSampleAes) {
      this.sampleAes = null;
    }
    let pes;
    const videoTrack = this._videoTrack;
    const audioTrack = this._audioTrack;
    const id3Track = this._id3Track;
    const textTrack = this._txtTrack;
    let videoPid = videoTrack.pid;
    let videoData = videoTrack.pesData;
    let audioPid = audioTrack.pid;
    let id3Pid = id3Track.pid;
    let audioData = audioTrack.pesData;
    let id3Data = id3Track.pesData;
    let unknownPID = null;
    let pmtParsed = this.pmtParsed;
    let pmtId = this._pmtId;
    let len = data.length;
    if (this.remainderData) {
      data = appendUint8Array(this.remainderData, data);
      len = data.length;
      this.remainderData = null;
    }
    if (len < PACKET_LENGTH && !flush) {
      this.remainderData = data;
      return {
        audioTrack,
        videoTrack,
        id3Track,
        textTrack
      };
    }
    const syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
    len -= (len - syncOffset) % PACKET_LENGTH;
    if (len < data.byteLength && !flush) {
      this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
    }

    // loop through TS packets
    let tsPacketErrors = 0;
    for (let start = syncOffset; start < len; start += PACKET_LENGTH) {
      if (data[start] === 0x47) {
        const stt = !!(data[start + 1] & 0x40);
        const pid = parsePID(data, start);
        const atf = (data[start + 3] & 0x30) >> 4;

        // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
        let offset;
        if (atf > 1) {
          offset = start + 5 + data[start + 4];
          // continue if there is only adaptation field
          if (offset === start + PACKET_LENGTH) {
            continue;
          }
        } else {
          offset = start + 4;
        }
        switch (pid) {
          case videoPid:
            if (stt) {
              if (videoData && (pes = parsePES(videoData))) {
                this.videoParser.parseAVCPES(videoTrack, textTrack, pes, false, this._duration);
              }
              videoData = {
                data: [],
                size: 0
              };
            }
            if (videoData) {
              videoData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              videoData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case audioPid:
            if (stt) {
              if (audioData && (pes = parsePES(audioData))) {
                switch (audioTrack.segmentCodec) {
                  case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                  case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                  case 'ac3':
                    {
                      this.parseAC3PES(audioTrack, pes);
                    }
                    break;
                }
              }
              audioData = {
                data: [],
                size: 0
              };
            }
            if (audioData) {
              audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
              audioData.size += start + PACKET_LENGTH - offset;
            }
            break;
          case id3Pid:
            if (stt) {
              if (id3Data && (pes = parsePES(id3Data))) {
                this.parseID3PES(id3Track, pes);
              }
              id3Data = {
                data: [],
                size: 0
              };
            }
            if (id3Data) {
              id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
              id3Data.size += start + PACKET_LENGTH - offset;
            }
            break;
          case 0:
            if (stt) {
              offset += data[offset] + 1;
            }
            pmtId = this._pmtId = parsePAT(data, offset);
            // logger.log('PMT PID:'  + this._pmtId);
            break;
          case pmtId:
            {
              if (stt) {
                offset += data[offset] + 1;
              }
              const parsedPIDs = parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              // NOTE this is only the PID of the track as found in TS,
              // but we are not using this for MP4 track IDs.
              videoPid = parsedPIDs.videoPid;
              if (videoPid > 0) {
                videoTrack.pid = videoPid;
                videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
              }
              audioPid = parsedPIDs.audioPid;
              if (audioPid > 0) {
                audioTrack.pid = audioPid;
                audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
              }
              id3Pid = parsedPIDs.id3Pid;
              if (id3Pid > 0) {
                id3Track.pid = id3Pid;
              }
              if (unknownPID !== null && !pmtParsed) {
                logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                unknownPID = null;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = syncOffset - 188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            }
          case 0x11:
          case 0x1fff:
            break;
          default:
            unknownPID = pid;
            break;
        }
      } else {
        tsPacketErrors++;
      }
    }
    if (tsPacketErrors > 0) {
      emitParsingError(this.observer, new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`));
    }
    videoTrack.pesData = videoData;
    audioTrack.pesData = audioData;
    id3Track.pesData = id3Data;
    const demuxResult = {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    };
    if (flush) {
      this.extractRemainingSamples(demuxResult);
    }
    return demuxResult;
  }
  flush() {
    const {
      remainderData
    } = this;
    this.remainderData = null;
    let result;
    if (remainderData) {
      result = this.demux(remainderData, -1, false, true);
    } else {
      result = {
        videoTrack: this._videoTrack,
        audioTrack: this._audioTrack,
        id3Track: this._id3Track,
        textTrack: this._txtTrack
      };
    }
    this.extractRemainingSamples(result);
    if (this.sampleAes) {
      return this.decrypt(result, this.sampleAes);
    }
    return result;
  }
  extractRemainingSamples(demuxResult) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const videoData = videoTrack.pesData;
    const audioData = audioTrack.pesData;
    const id3Data = id3Track.pesData;
    // try to parse last PES packets
    let pes;
    if (videoData && (pes = parsePES(videoData))) {
      this.videoParser.parseAVCPES(videoTrack, textTrack, pes, true, this._duration);
      videoTrack.pesData = null;
    } else {
      // either avcData null or PES truncated, keep it for next frag parsing
      videoTrack.pesData = videoData;
    }
    if (audioData && (pes = parsePES(audioData))) {
      switch (audioTrack.segmentCodec) {
        case 'aac':
          this.parseAACPES(audioTrack, pes);
          break;
        case 'mp3':
          this.parseMPEGPES(audioTrack, pes);
          break;
        case 'ac3':
          {
            this.parseAC3PES(audioTrack, pes);
          }
          break;
      }
      audioTrack.pesData = null;
    } else {
      if (audioData != null && audioData.size) {
        logger.log('last AAC PES packet truncated,might overlap between fragments');
      }

      // either audioData null or PES truncated, keep it for next frag parsing
      audioTrack.pesData = audioData;
    }
    if (id3Data && (pes = parsePES(id3Data))) {
      this.parseID3PES(id3Track, pes);
      id3Track.pesData = null;
    } else {
      // either id3Data null or PES truncated, keep it for next frag parsing
      id3Track.pesData = id3Data;
    }
  }
  demuxSampleAes(data, keyData, timeOffset) {
    const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
    const sampleAes = this.sampleAes = new SampleAesDecrypter(this.observer, this.config, keyData);
    return this.decrypt(demuxResult, sampleAes);
  }
  decrypt(demuxResult, sampleAes) {
    return new Promise(resolve => {
      const {
        audioTrack,
        videoTrack
      } = demuxResult;
      if (audioTrack.samples && audioTrack.segmentCodec === 'aac') {
        sampleAes.decryptAacSamples(audioTrack.samples, 0, () => {
          if (videoTrack.samples) {
            sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
              resolve(demuxResult);
            });
          } else {
            resolve(demuxResult);
          }
        });
      } else if (videoTrack.samples) {
        sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, () => {
          resolve(demuxResult);
        });
      }
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(track, pes) {
    let startOffset = 0;
    const aacOverFlow = this.aacOverFlow;
    let data = pes.data;
    if (aacOverFlow) {
      this.aacOverFlow = null;
      const frameMissingBytes = aacOverFlow.missing;
      const sampleLength = aacOverFlow.sample.unit.byteLength;
      // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
      if (frameMissingBytes === -1) {
        data = appendUint8Array(aacOverFlow.sample.unit, data);
      } else {
        const frameOverflowBytes = sampleLength - frameMissingBytes;
        aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
        track.samples.push(aacOverFlow.sample);
        startOffset = aacOverFlow.missing;
      }
    }
    // look for ADTS header (0xFFFx)
    let offset;
    let len;
    for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
      if (isHeader$1(data, offset)) {
        break;
      }
    }
    // if ADTS header does not start straight from the beginning of the PES payload, raise an error
    if (offset !== startOffset) {
      let reason;
      const recoverable = offset < len - 1;
      if (recoverable) {
        reason = `AAC PES did not start with ADTS header,offset:${offset}`;
      } else {
        reason = 'No ADTS header found in AAC PES';
      }
      emitParsingError(this.observer, new Error(reason), recoverable);
      if (!recoverable) {
        return;
      }
    }
    initTrackConfig(track, this.observer, data, offset, this.audioCodec);
    let pts;
    if (pes.pts !== undefined) {
      pts = pes.pts;
    } else if (aacOverFlow) {
      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      const frameDuration = getFrameDuration(track.samplerate);
      pts = aacOverFlow.sample.pts + frameDuration;
    } else {
      logger.warn('[tsdemuxer]: AAC PES unknown PTS');
      return;
    }

    // scan for aac samples
    let frameIndex = 0;
    let frame;
    while (offset < len) {
      frame = appendFrame$2(track, data, offset, pts, frameIndex);
      offset += frame.length;
      if (!frame.missing) {
        frameIndex++;
        for (; offset < len - 1; offset++) {
          if (isHeader$1(data, offset)) {
            break;
          }
        }
      } else {
        this.aacOverFlow = frame;
        break;
      }
    }
  }
  parseMPEGPES(track, pes) {
    const data = pes.data;
    const length = data.length;
    let frameIndex = 0;
    let offset = 0;
    const pts = pes.pts;
    if (pts === undefined) {
      logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
      return;
    }
    while (offset < length) {
      if (isHeader(data, offset)) {
        const frame = appendFrame$1(track, data, offset, pts, frameIndex);
        if (frame) {
          offset += frame.length;
          frameIndex++;
        } else {
          // logger.log('Unable to parse Mpeg audio frame');
          break;
        }
      } else {
        // nothing found, keep looking
        offset++;
      }
    }
  }
  parseAC3PES(track, pes) {
    {
      const data = pes.data;
      const pts = pes.pts;
      if (pts === undefined) {
        logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
        return;
      }
      const length = data.length;
      let frameIndex = 0;
      let offset = 0;
      let parsed;
      while (offset < length && (parsed = appendFrame(track, data, offset, pts, frameIndex++)) > 0) {
        offset += parsed;
      }
    }
  }
  parseID3PES(id3Track, pes) {
    if (pes.pts === undefined) {
      logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
      return;
    }
    const id3Sample = _extends({}, pes, {
      type: this._videoTrack ? MetadataSchema.emsg : MetadataSchema.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    id3Track.samples.push(id3Sample);
  }
}
function parsePID(data, offset) {
  // pid is a 13-bit field starting at the last bit of TS[1]
  return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function parsePAT(data, offset) {
  // skip the PSI header and parse the first PMT entry
  return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function parsePMT(data, offset, typeSupported, isSampleAes, observer) {
  const result = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: 'avc',
    segmentAudioCodec: 'aac'
  };
  const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
  const tableEnd = offset + 3 + sectionLength - 4;
  // to determine where the table is, we have to figure out how
  // long the program info descriptors are
  const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
  // advance the offset to the first entry in the mapping table
  offset += 12 + programInfoLength;
  while (offset < tableEnd) {
    const pid = parsePID(data, offset);
    const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
    switch (data[offset]) {
      case 0xcf:
        // SAMPLE-AES AAC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC');
          break;
        }
      /* falls through */
      case 0x0f:
        // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
        // logger.log('AAC PID:'  + pid);
        if (result.audioPid === -1) {
          result.audioPid = pid;
        }
        break;

      // Packetized metadata (ID3)
      case 0x15:
        // logger.log('ID3 PID:'  + pid);
        if (result.id3Pid === -1) {
          result.id3Pid = pid;
        }
        break;
      case 0xdb:
        // SAMPLE-AES AVC
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('H.264');
          break;
        }
      /* falls through */
      case 0x1b:
        // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
        // logger.log('AVC PID:'  + pid);
        if (result.videoPid === -1) {
          result.videoPid = pid;
          result.segmentVideoCodec = 'avc';
        }
        break;

      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 0x03:
      case 0x04:
        // logger.log('MPEG PID:'  + pid);
        if (!typeSupported.mpeg && !typeSupported.mp3) {
          logger.log('MPEG audio found, not supported in this browser');
        } else if (result.audioPid === -1) {
          result.audioPid = pid;
          result.segmentAudioCodec = 'mp3';
        }
        break;
      case 0xc1:
        // SAMPLE-AES AC3
        if (!isSampleAes) {
          logEncryptedSamplesFoundInUnencryptedStream('AC-3');
          break;
        }
      /* falls through */
      case 0x81:
        {
          if (!typeSupported.ac3) {
            logger.log('AC-3 audio found, not supported in this browser');
          } else if (result.audioPid === -1) {
            result.audioPid = pid;
            result.segmentAudioCodec = 'ac3';
          }
        }
        break;
      case 0x06:
        // stream_type 6 can mean a lot of different things in case of DVB.
        // We need to look at the descriptors. Right now, we're only interested
        // in AC-3 audio, so we do the descriptor parsing only when we don't have
        // an audio PID yet.
        if (result.audioPid === -1 && esInfoLength > 0) {
          let parsePos = offset + 5;
          let remaining = esInfoLength;
          while (remaining > 2) {
            const descriptorId = data[parsePos];
            switch (descriptorId) {
              case 0x6a:
                // DVB Descriptor for AC-3
                {
                  if (typeSupported.ac3 !== true) {
                    logger.log('AC-3 audio found, not supported in this browser for now');
                  } else {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                  }
                }
                break;
            }
            const descriptorLen = data[parsePos + 1] + 2;
            parsePos += descriptorLen;
            remaining -= descriptorLen;
          }
        }
        break;
      case 0xc2: // SAMPLE-AES EC3
      /* falls through */
      case 0x87:
        emitParsingError(observer, new Error('Unsupported EC-3 in M2TS found'));
        return result;
      case 0x24:
        emitParsingError(observer, new Error('Unsupported HEVC in M2TS found'));
        return result;
    }
    // move to the next table entry
    // skip past the elementary stream descriptors, if present
    offset += esInfoLength + 5;
  }
  return result;
}
function emitParsingError(observer, error, levelRetry) {
  logger.warn(`parsing error: ${error.message}`);
  observer.emit(Events.ERROR, Events.ERROR, {
    type: ErrorTypes.MEDIA_ERROR,
    details: ErrorDetails.FRAG_PARSING_ERROR,
    fatal: false,
    levelRetry,
    error,
    reason: error.message
  });
}
function logEncryptedSamplesFoundInUnencryptedStream(type) {
  logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function parsePES(stream) {
  let i = 0;
  let frag;
  let pesLen;
  let pesHdrLen;
  let pesPts;
  let pesDts;
  const data = stream.data;
  // safety check
  if (!stream || stream.size === 0) {
    return null;
  }

  // we might need up to 19 bytes to read PES header
  // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
  // usually only one merge is needed (and this is rare ...)
  while (data[0].length < 19 && data.length > 1) {
    data[0] = appendUint8Array(data[0], data[1]);
    data.splice(1, 1);
  }
  // retrieve PTS/DTS from first fragment
  frag = data[0];
  const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
  if (pesPrefix === 1) {
    pesLen = (frag[4] << 8) + frag[5];
    // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
    // minus 6 : PES header size
    if (pesLen && pesLen > stream.size - 6) {
      return null;
    }
    const pesFlags = frag[7];
    if (pesFlags & 0xc0) {
      /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */
      pesPts = (frag[9] & 0x0e) * 536870912 +
      // 1 << 29
      (frag[10] & 0xff) * 4194304 +
      // 1 << 22
      (frag[11] & 0xfe) * 16384 +
      // 1 << 14
      (frag[12] & 0xff) * 128 +
      // 1 << 7
      (frag[13] & 0xfe) / 2;
      if (pesFlags & 0x40) {
        pesDts = (frag[14] & 0x0e) * 536870912 +
        // 1 << 29
        (frag[15] & 0xff) * 4194304 +
        // 1 << 22
        (frag[16] & 0xfe) * 16384 +
        // 1 << 14
        (frag[17] & 0xff) * 128 +
        // 1 << 7
        (frag[18] & 0xfe) / 2;
        if (pesPts - pesDts > 60 * 90000) {
          logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
          pesPts = pesDts;
        }
      } else {
        pesDts = pesPts;
      }
    }
    pesHdrLen = frag[8];
    // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
    let payloadStartOffset = pesHdrLen + 9;
    if (stream.size <= payloadStartOffset) {
      return null;
    }
    stream.size -= payloadStartOffset;
    // reassemble PES packet
    const pesData = new Uint8Array(stream.size);
    for (let j = 0, dataLen = data.length; j < dataLen; j++) {
      frag = data[j];
      let len = frag.byteLength;
      if (payloadStartOffset) {
        if (payloadStartOffset > len) {
          // trim full frag if PES header bigger than frag
          payloadStartOffset -= len;
          continue;
        } else {
          // trim partial frag if PES header smaller than frag
          frag = frag.subarray(payloadStartOffset);
          len -= payloadStartOffset;
          payloadStartOffset = 0;
        }
      }
      pesData.set(frag, i);
      i += len;
    }
    if (pesLen) {
      // payload size : remove PES header + PES extension
      pesLen -= pesHdrLen + 3;
    }
    return {
      data: pesData,
      pts: pesPts,
      dts: pesDts,
      len: pesLen
    };
  }
  return null;
}

/**
 * MP3 demuxer
 */
class MP3Demuxer extends BaseAudioDemuxer {
  resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
    super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
    this._audioTrack = {
      container: 'audio/mpeg',
      type: 'audio',
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: 'mp3',
      samples: [],
      manifestCodec: audioCodec,
      duration: trackDuration,
      inputTimeScale: 90000,
      dropped: 0
    };
  }
  static probe(data) {
    if (!data) {
      return false;
    }

    // check if data contains ID3 timestamp and MPEG sync word
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    const id3Data = getID3Data(data, 0);
    let offset = (id3Data == null ? void 0 : id3Data.length) || 0;

    // Check for ac-3|ec-3 sync bytes and return false if present
    if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && getTimeStamp(id3Data) !== undefined &&
    // check the bsid to confirm ac-3 or ec-3 (not mp3)
    getAudioBSID(data, offset) <= 16) {
      return false;
    }
    for (let length = data.length; offset < length; offset++) {
      if (probe(data, offset)) {
        logger.log('MPEG Audio sync word found !');
        return true;
      }
    }
    return false;
  }
  canParse(data, offset) {
    return canParse(data, offset);
  }
  appendFrame(track, data, offset) {
    if (this.basePTS === null) {
      return;
    }
    return appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
  }
}

/**
 *  AAC helper
 */

class AAC {
  static getSilentFrame(codec, channelCount) {
    switch (codec) {
      case 'mp4a.40.2':
        if (channelCount === 1) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
        } else if (channelCount === 2) {
          return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
        } else if (channelCount === 3) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
        } else if (channelCount === 4) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
        } else if (channelCount === 5) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
        } else if (channelCount === 6) {
          return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
        }
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (channelCount === 1) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 2) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        } else if (channelCount === 3) {
          // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
          return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
        }
        break;
    }
    return undefined;
  }
}

/**
 * Generate MP4 Box
 */

const UINT32_MAX = Math.pow(2, 32) - 1;
class MP4 {
  static init() {
    MP4.types = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      '.mp3': [],
      dac3: [],
      'ac-3': [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let i;
    for (i in MP4.types) {
      if (MP4.types.hasOwnProperty(i)) {
        MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
      }
    }
    const videoHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x76, 0x69, 0x64, 0x65,
    // handler_type: 'vide'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
    ]);
    const audioHdlr = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0x73, 0x6f, 0x75, 0x6e,
    // handler_type: 'soun'
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
    ]);
    MP4.HDLR_TYPES = {
      video: videoHdlr,
      audio: audioHdlr
    };
    const dref = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01,
    // entry_count
    0x00, 0x00, 0x00, 0x0c,
    // entry_size
    0x75, 0x72, 0x6c, 0x20,
    // 'url' type
    0x00,
    // version 0
    0x00, 0x00, 0x01 // entry_flags
    ]);
    const stco = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00 // entry_count
    ]);
    MP4.STTS = MP4.STSC = MP4.STCO = stco;
    MP4.STSZ = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00,
    // sample_size
    0x00, 0x00, 0x00, 0x00 // sample_count
    ]);
    MP4.VMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x01,
    // flags
    0x00, 0x00,
    // graphicsmode
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
    ]);
    MP4.SMHD = new Uint8Array([0x00,
    // version
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00,
    // balance
    0x00, 0x00 // reserved
    ]);
    MP4.STSD = new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x01]); // entry_count

    const majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
    const avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
    const minorVersion = new Uint8Array([0, 0, 0, 1]);
    MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
    MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
  }
  static box(type, ...payload) {
    let size = 8;
    let i = payload.length;
    const len = i;
    // calculate the total size we need to allocate
    while (i--) {
      size += payload[i].byteLength;
    }
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    // copy the payload into the result
    for (i = 0, size = 8; i < len; i++) {
      // copy payload[i] array @ offset size
      result.set(payload[i], size);
      size += payload[i].byteLength;
    }
    return result;
  }
  static hdlr(type) {
    return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
  }
  static mdat(data) {
    return MP4.box(MP4.types.mdat, data);
  }
  static mdhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.mdhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x55, 0xc4,
    // 'und' language (undetermined)
    0x00, 0x00]));
  }
  static mdia(track) {
    return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
  }
  static mfhd(sequenceNumber) {
    return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00,
    // flags
    sequenceNumber >> 24, sequenceNumber >> 16 & 0xff, sequenceNumber >> 8 & 0xff, sequenceNumber & 0xff // sequence_number
    ]));
  }
  static minf(track) {
    if (track.type === 'audio') {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
    } else {
      return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
    }
  }
  static moof(sn, baseMediaDecodeTime, track) {
    return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
  }
  static moov(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trak(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
  }
  static mvex(tracks) {
    let i = tracks.length;
    const boxes = [];
    while (i--) {
      boxes[i] = MP4.trex(tracks[i]);
    }
    return MP4.box.apply(null, [MP4.types.mvex, ...boxes]);
  }
  static mvhd(timescale, duration) {
    duration *= timescale;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    const bytes = new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    timescale >> 24 & 0xff, timescale >> 16 & 0xff, timescale >> 8 & 0xff, timescale & 0xff,
    // timescale
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x01, 0x00, 0x00,
    // 1.0 rate
    0x01, 0x00,
    // 1.0 volume
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    0xff, 0xff, 0xff, 0xff // next_track_ID
    ]);
    return MP4.box(MP4.types.mvhd, bytes);
  }
  static sdtp(track) {
    const samples = track.samples || [];
    const bytes = new Uint8Array(4 + samples.length);
    let i;
    let flags;
    // leave the full box header (4 bytes) all zero
    // write the sample table
    for (i = 0; i < samples.length; i++) {
      flags = samples[i].flags;
      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
    }
    return MP4.box(MP4.types.sdtp, bytes);
  }
  static stbl(track) {
    return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
  }
  static avc1(track) {
    let sps = [];
    let pps = [];
    let i;
    let data;
    let len;
    // assemble the SPSs

    for (i = 0; i < track.sps.length; i++) {
      data = track.sps[i];
      len = data.byteLength;
      sps.push(len >>> 8 & 0xff);
      sps.push(len & 0xff);

      // SPS
      sps = sps.concat(Array.prototype.slice.call(data));
    }

    // assemble the PPSs
    for (i = 0; i < track.pps.length; i++) {
      data = track.pps[i];
      len = data.byteLength;
      pps.push(len >>> 8 & 0xff);
      pps.push(len & 0xff);
      pps = pps.concat(Array.prototype.slice.call(data));
    }
    const avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01,
    // version
    sps[3],
    // profile
    sps[4],
    // profile compat
    sps[5],
    // level
    0xfc | 3,
    // lengthSizeMinusOne, hard-coded to 4 bytes
    0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
    ]).concat(pps))); // "PPS"
    const width = track.width;
    const height = track.height;
    const hSpacing = track.pixelRatio[0];
    const vSpacing = track.pixelRatio[1];
    return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00,
    // pre_defined
    0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // pre_defined
    width >> 8 & 0xff, width & 0xff,
    // width
    height >> 8 & 0xff, height & 0xff,
    // height
    0x00, 0x48, 0x00, 0x00,
    // horizresolution
    0x00, 0x48, 0x00, 0x00,
    // vertresolution
    0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // frame_count
    0x12, 0x64, 0x61, 0x69, 0x6c,
    // dailymotion/hls.js
    0x79, 0x6d, 0x6f, 0x74, 0x69, 0x6f, 0x6e, 0x2f, 0x68, 0x6c, 0x73, 0x2e, 0x6a, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // compressorname
    0x00, 0x18,
    // depth = 24
    0x11, 0x11]),
    // pre_defined = -1
    avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80,
    // bufferSizeDB
    0x00, 0x2d, 0xc6, 0xc0,
    // maxBitrate
    0x00, 0x2d, 0xc6, 0xc0])),
    // avgBitrate
    MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
    // hSpacing
    hSpacing >> 16 & 0xff, hSpacing >> 8 & 0xff, hSpacing & 0xff, vSpacing >> 24,
    // vSpacing
    vSpacing >> 16 & 0xff, vSpacing >> 8 & 0xff, vSpacing & 0xff])));
  }
  static esds(track) {
    const configlen = track.config.length;
    return new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags

    0x03,
    // descriptor_type
    0x17 + configlen,
    // length
    0x00, 0x01,
    // es_id
    0x00,
    // stream_priority

    0x04,
    // descriptor_type
    0x0f + configlen,
    // length
    0x40,
    // codec : mpeg4_audio
    0x15,
    // stream_type
    0x00, 0x00, 0x00,
    // buffer_size
    0x00, 0x00, 0x00, 0x00,
    // maxBitrate
    0x00, 0x00, 0x00, 0x00,
    // avgBitrate

    0x05 // descriptor_type
    ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
  }
  static audioStsd(track) {
    const samplerate = track.samplerate;
    return new Uint8Array([0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00, 0x00,
    // reserved
    0x00, 0x01,
    // data_reference_index
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, track.channelCount,
    // channelcount
    0x00, 0x10,
    // sampleSize:16bits
    0x00, 0x00, 0x00, 0x00,
    // reserved2
    samplerate >> 8 & 0xff, samplerate & 0xff,
    //
    0x00, 0x00]);
  }
  static mp4a(track) {
    return MP4.box(MP4.types.mp4a, MP4.audioStsd(track), MP4.box(MP4.types.esds, MP4.esds(track)));
  }
  static mp3(track) {
    return MP4.box(MP4.types['.mp3'], MP4.audioStsd(track));
  }
  static ac3(track) {
    return MP4.box(MP4.types['ac-3'], MP4.audioStsd(track), MP4.box(MP4.types.dac3, track.config));
  }
  static stsd(track) {
    if (track.type === 'audio') {
      if (track.segmentCodec === 'mp3' && track.codec === 'mp3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
      }
      if (track.segmentCodec === 'ac3') {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.ac3(track));
      }
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
    } else {
      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
    }
  }
  static tkhd(track) {
    const id = track.id;
    const duration = track.duration * track.timescale;
    const width = track.width;
    const height = track.height;
    const upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
    const lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
    return MP4.box(MP4.types.tkhd, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x07,
    // flags
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02,
    // creation_time
    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03,
    // modification_time
    id >> 24 & 0xff, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x00,
    // reserved
    upperWordDuration >> 24, upperWordDuration >> 16 & 0xff, upperWordDuration >> 8 & 0xff, upperWordDuration & 0xff, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xff, lowerWordDuration >> 8 & 0xff, lowerWordDuration & 0xff, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    // reserved
    0x00, 0x00,
    // layer
    0x00, 0x00,
    // alternate_group
    0x00, 0x00,
    // non-audio track volume
    0x00, 0x00,
    // reserved
    0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00,
    // transformation: unity matrix
    width >> 8 & 0xff, width & 0xff, 0x00, 0x00,
    // width
    height >> 8 & 0xff, height & 0xff, 0x00, 0x00 // height
    ]));
  }
  static traf(track, baseMediaDecodeTime) {
    const sampleDependencyTable = MP4.sdtp(track);
    const id = track.id;
    const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
    const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
    return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff // track_ID
    ])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01,
    // version 1
    0x00, 0x00, 0x00,
    // flags
    upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0xff, upperWordBaseMediaDecodeTime >> 8 & 0xff, upperWordBaseMediaDecodeTime & 0xff, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0xff, lowerWordBaseMediaDecodeTime >> 8 & 0xff, lowerWordBaseMediaDecodeTime & 0xff])), MP4.trun(track, sampleDependencyTable.length + 16 +
    // tfhd
    20 +
    // tfdt
    8 +
    // traf header
    16 +
    // mfhd
    8 +
    // moof header
    8),
    // mdat header
    sampleDependencyTable);
  }

  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(track) {
    track.duration = track.duration || 0xffffffff;
    return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
  }
  static trex(track) {
    const id = track.id;
    return MP4.box(MP4.types.trex, new Uint8Array([0x00,
    // version 0
    0x00, 0x00, 0x00,
    // flags
    id >> 24, id >> 16 & 0xff, id >> 8 & 0xff, id & 0xff,
    // track_ID
    0x00, 0x00, 0x00, 0x01,
    // default_sample_description_index
    0x00, 0x00, 0x00, 0x00,
    // default_sample_duration
    0x00, 0x00, 0x00, 0x00,
    // default_sample_size
    0x00, 0x01, 0x00, 0x01 // default_sample_flags
    ]));
  }
  static trun(track, offset) {
    const samples = track.samples || [];
    const len = samples.length;
    const arraylen = 12 + 16 * len;
    const array = new Uint8Array(arraylen);
    let i;
    let sample;
    let duration;
    let size;
    let flags;
    let cts;
    offset += 8 + arraylen;
    array.set([track.type === 'video' ? 0x01 : 0x00,
    // version 1 for video with signed-int sample_composition_time_offset
    0x00, 0x0f, 0x01,
    // flags
    len >>> 24 & 0xff, len >>> 16 & 0xff, len >>> 8 & 0xff, len & 0xff,
    // sample_count
    offset >>> 24 & 0xff, offset >>> 16 & 0xff, offset >>> 8 & 0xff, offset & 0xff // data_offset
    ], 0);
    for (i = 0; i < len; i++) {
      sample = samples[i];
      duration = sample.duration;
      size = sample.size;
      flags = sample.flags;
      cts = sample.cts;
      array.set([duration >>> 24 & 0xff, duration >>> 16 & 0xff, duration >>> 8 & 0xff, duration & 0xff,
      // sample_duration
      size >>> 24 & 0xff, size >>> 16 & 0xff, size >>> 8 & 0xff, size & 0xff,
      // sample_size
      flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xf0 << 8, flags.degradPrio & 0x0f,
      // sample_flags
      cts >>> 24 & 0xff, cts >>> 16 & 0xff, cts >>> 8 & 0xff, cts & 0xff // sample_composition_time_offset
      ], 12 + 16 * i);
    }
    return MP4.box(MP4.types.trun, array);
  }
  static initSegment(tracks) {
    if (!MP4.types) {
      MP4.init();
    }
    const movie = MP4.moov(tracks);
    const result = appendUint8Array(MP4.FTYP, movie);
    return result;
  }
}
MP4.types = void 0;
MP4.HDLR_TYPES = void 0;
MP4.STTS = void 0;
MP4.STSC = void 0;
MP4.STCO = void 0;
MP4.STSZ = void 0;
MP4.VMHD = void 0;
MP4.SMHD = void 0;
MP4.STSD = void 0;
MP4.FTYP = void 0;
MP4.DINF = void 0;

const MPEG_TS_CLOCK_FREQ_HZ = 90000;
function toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
  const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
  return round ? Math.round(result) : result;
}
function toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
  return toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function toMsFromMpegTsClock(baseTime, round = false) {
  return toTimescaleFromBase(baseTime, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
}
function toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
  return toTimescaleFromBase(baseTime, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}

const MAX_SILENT_FRAME_DURATION = 10 * 1000; // 10 seconds
const AAC_SAMPLES_PER_FRAME = 1024;
const MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const AC3_SAMPLES_PER_FRAME = 1536;
let chromeVersion = null;
let safariWebkitVersion = null;
class MP4Remuxer {
  constructor(observer, config, typeSupported, vendor = '') {
    this.observer = void 0;
    this.config = void 0;
    this.typeSupported = void 0;
    this.ISGenerated = false;
    this._initPTS = null;
    this._initDTS = null;
    this.nextAvcDts = null;
    this.nextAudioPts = null;
    this.videoSampleDuration = null;
    this.isAudioContiguous = false;
    this.isVideoContiguous = false;
    this.videoTrackConfig = void 0;
    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.ISGenerated = false;
    if (chromeVersion === null) {
      const userAgent = navigator.userAgent || '';
      const result = userAgent.match(/Chrome\/(\d+)/i);
      chromeVersion = result ? parseInt(result[1]) : 0;
    }
    if (safariWebkitVersion === null) {
      const result = navigator.userAgent.match(/Safari\/(\d+)/i);
      safariWebkitVersion = result ? parseInt(result[1]) : 0;
    }
  }
  destroy() {
    // @ts-ignore
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(defaultTimeStamp) {
    logger.log('[mp4-remuxer]: initPTS & initDTS reset');
    this._initPTS = this._initDTS = defaultTimeStamp;
  }
  resetNextTimestamp() {
    logger.log('[mp4-remuxer]: reset next timestamp');
    this.isVideoContiguous = false;
    this.isAudioContiguous = false;
  }
  resetInitSegment() {
    logger.log('[mp4-remuxer]: ISGenerated flag reset');
    this.ISGenerated = false;
    this.videoTrackConfig = undefined;
  }
  getVideoStartPts(videoSamples) {
    let rolloverDetected = false;
    const startPTS = videoSamples.reduce((minPTS, sample) => {
      const delta = sample.pts - minPTS;
      if (delta < -4294967296) {
        // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
        rolloverDetected = true;
        return normalizePts(minPTS, sample.pts);
      } else if (delta > 0) {
        return minPTS;
      } else {
        return sample.pts;
      }
    }, videoSamples[0].pts);
    if (rolloverDetected) {
      logger.debug('PTS rollover detected');
    }
    return startPTS;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
    let video;
    let audio;
    let initSegment;
    let text;
    let id3;
    let independent;
    let audioTimeOffset = timeOffset;
    let videoTimeOffset = timeOffset;

    // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
    // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
    // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
    // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
    // then we can remux one track without waiting for the other.
    const hasAudio = audioTrack.pid > -1;
    const hasVideo = videoTrack.pid > -1;
    const length = videoTrack.samples.length;
    const enoughAudioSamples = audioTrack.samples.length > 0;
    const enoughVideoSamples = flush && length > 0 || length > 1;
    const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
    if (canRemuxAvc) {
      if (this.ISGenerated) {
        var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
        const config = this.videoTrackConfig;
        if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1]))) {
          this.resetInitSegment();
        }
      } else {
        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
      }
      const isVideoContiguous = this.isVideoContiguous;
      let firstKeyFrameIndex = -1;
      let firstKeyFramePTS;
      if (enoughVideoSamples) {
        firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
        if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
          independent = true;
          if (firstKeyFrameIndex > 0) {
            logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
            const startPTS = this.getVideoStartPts(videoTrack.samples);
            videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
            videoTrack.dropped += firstKeyFrameIndex;
            videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
            firstKeyFramePTS = videoTimeOffset;
          } else if (firstKeyFrameIndex === -1) {
            logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
            independent = false;
          }
        }
      }
      if (this.ISGenerated) {
        if (enoughAudioSamples && enoughVideoSamples) {
          // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
          // if first audio DTS is not aligned with first video DTS then we need to take that into account
          // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
          // drift between audio and video streams
          const startPTS = this.getVideoStartPts(videoTrack.samples);
          const tsDelta = normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
          const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
          audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
          videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
        }

        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
        if (enoughAudioSamples) {
          // if initSegment was generated without audio samples, regenerate it again
          if (!audioTrack.samplerate) {
            logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
          }
          audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
          if (enoughVideoSamples) {
            const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.inputTimeScale) {
              logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
              initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            }
            video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
          }
        } else if (enoughVideoSamples) {
          video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
        }
        if (video) {
          video.firstKeyFrame = firstKeyFrameIndex;
          video.independent = firstKeyFrameIndex !== -1;
          video.firstKeyFramePTS = firstKeyFramePTS;
        }
      }
    }

    // Allow ID3 and text to remux, even if more audio/video samples are required
    if (this.ISGenerated && this._initPTS && this._initDTS) {
      if (id3Track.samples.length) {
        id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
      }
      if (textTrack.samples.length) {
        text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
      }
    }
    return {
      audio,
      video,
      initSegment,
      independent,
      text,
      id3
    };
  }
  generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
    const audioSamples = audioTrack.samples;
    const videoSamples = videoTrack.samples;
    const typeSupported = this.typeSupported;
    const tracks = {};
    const _initPTS = this._initPTS;
    let computePTSDTS = !_initPTS || accurateTimeOffset;
    let container = 'audio/mp4';
    let initPTS;
    let initDTS;
    let timescale;
    if (computePTSDTS) {
      initPTS = initDTS = Infinity;
    }
    if (audioTrack.config && audioSamples.length) {
      // let's use audio sampling rate as MP4 time scale.
      // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
      // using audio sampling rate here helps having an integer MP4 frame duration
      // this avoids potential rounding issue and AV sync issue
      audioTrack.timescale = audioTrack.samplerate;
      switch (audioTrack.segmentCodec) {
        case 'mp3':
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
          break;
        case 'ac3':
          audioTrack.codec = 'ac-3';
          break;
      }
      tracks.audio = {
        id: 'audio',
        container: container,
        codec: audioTrack.codec,
        initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : MP4.initSegment([audioTrack]),
        metadata: {
          channelCount: audioTrack.channelCount
        }
      };
      if (computePTSDTS) {
        timescale = audioTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
        } else {
          computePTSDTS = false;
        }
      }
    }
    if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
      // let's use input time scale as MP4 video timescale
      // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
      videoTrack.timescale = videoTrack.inputTimeScale;
      tracks.video = {
        id: 'main',
        container: 'video/mp4',
        codec: videoTrack.codec,
        initSegment: MP4.initSegment([videoTrack]),
        metadata: {
          width: videoTrack.width,
          height: videoTrack.height
        }
      };
      if (computePTSDTS) {
        timescale = videoTrack.inputTimeScale;
        if (!_initPTS || timescale !== _initPTS.timescale) {
          const startPTS = this.getVideoStartPts(videoSamples);
          const startOffset = Math.round(timescale * timeOffset);
          initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
          initPTS = Math.min(initPTS, startPTS - startOffset);
        } else {
          computePTSDTS = false;
        }
      }
      this.videoTrackConfig = {
        width: videoTrack.width,
        height: videoTrack.height,
        pixelRatio: videoTrack.pixelRatio
      };
    }
    if (Object.keys(tracks).length) {
      this.ISGenerated = true;
      if (computePTSDTS) {
        this._initPTS = {
          baseTime: initPTS,
          timescale: timescale
        };
        this._initDTS = {
          baseTime: initDTS,
          timescale: timescale
        };
      } else {
        initPTS = timescale = undefined;
      }
      return {
        tracks,
        initPTS,
        timescale
      };
    }
  }
  remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
    const timeScale = track.inputTimeScale;
    const inputSamples = track.samples;
    const outputSamples = [];
    const nbSamples = inputSamples.length;
    const initPTS = this._initPTS;
    let nextAvcDts = this.nextAvcDts;
    let offset = 8;
    let mp4SampleDuration = this.videoSampleDuration;
    let firstDTS;
    let lastDTS;
    let minPTS = Number.POSITIVE_INFINITY;
    let maxPTS = Number.NEGATIVE_INFINITY;
    let sortSamples = false;

    // if parsed fragment is contiguous with last one, let's use last DTS value as reference
    if (!contiguous || nextAvcDts === null) {
      const pts = timeOffset * timeScale;
      const cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
      if (chromeVersion && nextAvcDts !== null && Math.abs(pts - cts - nextAvcDts) < 15000) {
        // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
        contiguous = true;
      } else {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = pts - cts;
      }
    }

    // PTS is coded on 33bits, and can loop from -2^32 to 2^32
    // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
    const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
    for (let i = 0; i < nbSamples; i++) {
      const sample = inputSamples[i];
      sample.pts = normalizePts(sample.pts - initTime, nextAvcDts);
      sample.dts = normalizePts(sample.dts - initTime, nextAvcDts);
      if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) {
        sortSamples = true;
      }
    }

    // sort video samples by DTS then PTS then demux id order
    if (sortSamples) {
      inputSamples.sort(function (a, b) {
        const deltadts = a.dts - b.dts;
        const deltapts = a.pts - b.pts;
        return deltadts || deltapts;
      });
    }

    // Get first/last DTS
    firstDTS = inputSamples[0].dts;
    lastDTS = inputSamples[inputSamples.length - 1].dts;

    // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
    // set this constant duration as being the avg delta between consecutive DTS.
    const inputDuration = lastDTS - firstDTS;
    const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;

    // if fragment are contiguous, detect hole/overlapping between fragments
    if (contiguous) {
      // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
      const delta = firstDTS - nextAvcDts;
      const foundHole = delta > averageSampleDuration;
      const foundOverlap = delta < -1;
      if (foundHole || foundOverlap) {
        if (foundHole) {
          logger.warn(`AVC: ${toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
        } else {
          logger.warn(`AVC: ${toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
        }
        if (!foundOverlap || nextAvcDts >= inputSamples[0].pts || chromeVersion) {
          firstDTS = nextAvcDts;
          const firstPTS = inputSamples[0].pts - delta;
          if (foundHole) {
            inputSamples[0].dts = firstDTS;
            inputSamples[0].pts = firstPTS;
          } else {
            for (let i = 0; i < inputSamples.length; i++) {
              if (inputSamples[i].dts > firstPTS) {
                break;
              }
              inputSamples[i].dts -= delta;
              inputSamples[i].pts -= delta;
            }
          }
          logger.log(`Video: Initial PTS/DTS adjusted: ${toMsFromMpegTsClock(firstPTS, true)}/${toMsFromMpegTsClock(firstDTS, true)}, delta: ${toMsFromMpegTsClock(delta, true)} ms`);
        }
      }
    }
    firstDTS = Math.max(0, firstDTS);
    let nbNalu = 0;
    let naluLen = 0;
    let dtsStep = firstDTS;
    for (let i = 0; i < nbSamples; i++) {
      // compute total/avc sample length and nb of NAL units
      const sample = inputSamples[i];
      const units = sample.units;
      const nbUnits = units.length;
      let sampleLen = 0;
      for (let j = 0; j < nbUnits; j++) {
        sampleLen += units[j].data.length;
      }
      naluLen += sampleLen;
      nbNalu += nbUnits;
      sample.length = sampleLen;

      // ensure sample monotonic DTS
      if (sample.dts < dtsStep) {
        sample.dts = dtsStep;
        dtsStep += averageSampleDuration / 4 | 0 || 1;
      } else {
        dtsStep = sample.dts;
      }
      minPTS = Math.min(sample.pts, minPTS);
      maxPTS = Math.max(sample.pts, maxPTS);
    }
    lastDTS = inputSamples[nbSamples - 1].dts;

    /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */
    const mdatSize = naluLen + 4 * nbNalu + 8;
    let mdat;
    try {
      mdat = new Uint8Array(mdatSize);
    } catch (err) {
      this.observer.emit(Events.ERROR, Events.ERROR, {
        type: ErrorTypes.MUX_ERROR,
        details: ErrorDetails.REMUX_ALLOC_ERROR,
        fatal: false,
        error: err,
        bytes: mdatSize,
        reason: `fail allocating video mdat ${mdatSize}`
      });
      return;
    }
    const view = new DataView(mdat.buffer);
    view.setUint32(0, mdatSize);
    mdat.set(MP4.types.mdat, 4);
    let stretchedLastFrame = false;
    let minDtsDelta = Number.POSITIVE_INFINITY;
    let minPtsDelta = Number.POSITIVE_INFINITY;
    let maxDtsDelta = Number.NEGATIVE_INFINITY;
    let maxPtsDelta = Number.NEGATIVE_INFINITY;
    for (let i = 0; i < nbSamples; i++) {
      const VideoSample = inputSamples[i];
      const VideoSampleUnits = VideoSample.units;
      let mp4SampleLength = 0;
      // convert NALU bitstream to MP4 format (prepend NALU with size field)
      for (let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++) {
        const unit = VideoSampleUnits[j];
        const unitData = unit.data;
        const unitDataLen = unit.data.byteLength;
        view.setUint32(offset, unitDataLen);
        offset += 4;
        mdat.set(unitData, offset);
        offset += unitDataLen;
        mp4SampleLength += 4 + unitDataLen;
      }

      // expected sample duration is the Decoding Timestamp diff of consecutive samples
      let ptsDelta;
      if (i < nbSamples - 1) {
        mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
        ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
      } else {
        const config = this.config;
        const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
        ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
        if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
          // In some cases, a segment's audio track duration may exceed the video track duration.
          // Since we've already remuxed audio, and we know how long the audio track is, we look to
          // see if the delta to the next segment is longer than maxBufferHole.
          // If so, playback would potentially get stuck, so we artificially inflate
          // the duration of the last frame to minimize any potential gap between segments.
          const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
          const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - VideoSample.pts;
          if (deltaToFrameEnd > gapTolerance) {
            // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
            // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
            mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
            if (mp4SampleDuration < 0) {
              mp4SampleDuration = lastFrameDuration;
            } else {
              stretchedLastFrame = true;
            }
            logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
          } else {
            mp4SampleDuration = lastFrameDuration;
          }
        } else {
          mp4SampleDuration = lastFrameDuration;
        }
      }
      const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
      minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
      maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
      minPtsDelta = Math.min(minPtsDelta, ptsDelta);
      maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
      outputSamples.push(new Mp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
    }
    if (outputSamples.length) {
      if (chromeVersion) {
        if (chromeVersion < 70) {
          // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
          // https://code.google.com/p/chromium/issues/detail?id=229412
          const flags = outputSamples[0].flags;
          flags.dependsOn = 2;
          flags.isNonSync = 0;
        }
      } else if (safariWebkitVersion) {
        // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
        // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
        if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
          logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
          let dts = firstDTS;
          for (let i = 0, len = outputSamples.length; i < len; i++) {
            const nextDts = dts + outputSamples[i].duration;
            const pts = dts + outputSamples[i].cts;
            if (i < len - 1) {
              const nextPts = nextDts + outputSamples[i + 1].cts;
              outputSamples[i].duration = nextPts - pts;
            } else {
              outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
            }
            outputSamples[i].cts = 0;
            dts = nextDts;
          }
        }
      }
    }
    // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
    mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
    this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
    this.videoSampleDuration = mp4SampleDuration;
    this.isVideoContiguous = true;
    const moof = MP4.moof(track.sequenceNumber++, firstDTS, _extends({}, track, {
      samples: outputSamples
    }));
    const type = 'video';
    const data = {
      data1: moof,
      data2: mdat,
      startPTS: minPTS / timeScale,
      endPTS: (maxPTS + mp4SampleDuration) / timeScale,
      startDTS: firstDTS / timeScale,
      endDTS: nextAvcDts / timeScale,
      type,
      hasAudio: false,
      hasVideo: true,
      nb: outputSamples.length,
      dropped: track.dropped
    };
    track.samples = [];
    track.dropped = 0;
    return data;
  }
  getSamplesPerFrame(track) {
    switch (track.segmentCodec) {
      case 'mp3':
        return MPEG_AUDIO_SAMPLE_PER_FRAME;
      case 'ac3':
        return AC3_SAMPLES_PER_FRAME;
      default:
        return AAC_SAMPLES_PER_FRAME;
    }
  }
  remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const mp4SampleDuration = this.getSamplesPerFrame(track);
    const inputSampleDuration = mp4SampleDuration * scaleFactor;
    const initPTS = this._initPTS;
    const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
    const outputSamples = [];
    const alignedWithVideo = videoTimeOffset !== undefined;
    let inputSamples = track.samples;
    let offset = rawMPEG ? 0 : 8;
    let nextAudioPts = this.nextAudioPts || -1;

    // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);

    // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
    // for sake of clarity:
    // consecutive fragments are frags with
    //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
    //  - less than 20 audio frames distance
    // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
    // this helps ensuring audio continuity
    // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
    const timeOffsetMpegTS = timeOffset * inputTimeScale;
    const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
    this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);

    // compute normalized PTS
    inputSamples.forEach(function (sample) {
      sample.pts = normalizePts(sample.pts - initTime, timeOffsetMpegTS);
    });
    if (!contiguous || nextAudioPts < 0) {
      // filter out sample with negative PTS that are not playable anyway
      // if we don't remove these negative samples, they will shift all audio samples forward.
      // leading to audio overlap between current / next fragment
      inputSamples = inputSamples.filter(sample => sample.pts >= 0);

      // in case all samples have negative PTS, and have been filtered out, return now
      if (!inputSamples.length) {
        return;
      }
      if (videoTimeOffset === 0) {
        // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
        nextAudioPts = 0;
      } else if (accurateTimeOffset && !alignedWithVideo) {
        // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
        nextAudioPts = Math.max(0, timeOffsetMpegTS);
      } else {
        // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
        nextAudioPts = inputSamples[0].pts;
      }
    }

    // If the audio track is missing samples, the frames seem to get "left-shifted" within the
    // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
    // In an effort to prevent this from happening, we inject frames here where there are gaps.
    // When possible, we inject a silent frame; when that's not possible, we duplicate the last
    // frame.

    if (track.segmentCodec === 'aac') {
      const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
      for (let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++) {
        // First, let's see how far off this frame is from where we expect it to be
        const sample = inputSamples[i];
        const pts = sample.pts;
        const delta = pts - nextPts;
        const duration = Math.abs(1000 * delta / inputTimeScale);

        // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
        if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
          if (i === 0) {
            logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
            this.nextAudioPts = nextAudioPts = nextPts = pts;
          }
        } // eslint-disable-line brace-style

        // Insert missing frames if:
        // 1: We're more than maxAudioFramesDrift frame away
        // 2: Not more than MAX_SILENT_FRAME_DURATION away
        // 3: currentTime (aka nextPtsNorm) is not 0
        // 4: remuxing with video (videoTimeOffset !== undefined)
        else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
          let missing = Math.round(delta / inputSampleDuration);
          // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
          // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
          nextPts = pts - missing * inputSampleDuration;
          if (nextPts < 0) {
            missing--;
            nextPts += inputSampleDuration;
          }
          if (i === 0) {
            this.nextAudioPts = nextAudioPts = nextPts;
          }
          logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
          for (let j = 0; j < missing; j++) {
            const newStamp = Math.max(nextPts, 0);
            let fillFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
              fillFrame = sample.unit.subarray();
            }
            inputSamples.splice(i, 0, {
              unit: fillFrame,
              pts: newStamp
            });
            nextPts += inputSampleDuration;
            i++;
          }
        }
        sample.pts = nextPts;
        nextPts += inputSampleDuration;
      }
    }
    let firstPTS = null;
    let lastPTS = null;
    let mdat;
    let mdatSize = 0;
    let sampleLength = inputSamples.length;
    while (sampleLength--) {
      mdatSize += inputSamples[sampleLength].unit.byteLength;
    }
    for (let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++) {
      const audioSample = inputSamples[j];
      const unit = audioSample.unit;
      let pts = audioSample.pts;
      if (lastPTS !== null) {
        // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
        // the previous sample
        const prevSample = outputSamples[j - 1];
        prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
      } else {
        if (contiguous && track.segmentCodec === 'aac') {
          // set PTS/DTS to expected PTS/DTS
          pts = nextAudioPts;
        }
        // remember first PTS of our audioSamples
        firstPTS = pts;
        if (mdatSize > 0) {
          /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */
          mdatSize += offset;
          try {
            mdat = new Uint8Array(mdatSize);
          } catch (err) {
            this.observer.emit(Events.ERROR, Events.ERROR, {
              type: ErrorTypes.MUX_ERROR,
              details: ErrorDetails.REMUX_ALLOC_ERROR,
              fatal: false,
              error: err,
              bytes: mdatSize,
              reason: `fail allocating audio mdat ${mdatSize}`
            });
            return;
          }
          if (!rawMPEG) {
            const view = new DataView(mdat.buffer);
            view.setUint32(0, mdatSize);
            mdat.set(MP4.types.mdat, 4);
          }
        } else {
          // no audio samples
          return;
        }
      }
      mdat.set(unit, offset);
      const unitLen = unit.byteLength;
      offset += unitLen;
      // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
      // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
      // becomes the PTS diff with the previous sample
      outputSamples.push(new Mp4Sample(true, mp4SampleDuration, unitLen, 0));
      lastPTS = pts;
    }

    // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
    const nbSamples = outputSamples.length;
    if (!nbSamples) {
      return;
    }

    // The next audio sample PTS should be equal to last sample PTS + duration
    const lastSample = outputSamples[outputSamples.length - 1];
    this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;

    // Set the track samples from inputSamples to outputSamples before remuxing
    const moof = rawMPEG ? new Uint8Array(0) : MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
      samples: outputSamples
    }));

    // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
    track.samples = [];
    const start = firstPTS / inputTimeScale;
    const end = nextAudioPts / inputTimeScale;
    const type = 'audio';
    const audioData = {
      data1: moof,
      data2: mdat,
      startPTS: start,
      endPTS: end,
      startDTS: start,
      endDTS: end,
      type,
      hasAudio: true,
      hasVideo: false,
      nb: nbSamples
    };
    this.isAudioContiguous = true;
    return audioData;
  }
  remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
    const inputTimeScale = track.inputTimeScale;
    const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
    const scaleFactor = inputTimeScale / mp4timeScale;
    const nextAudioPts = this.nextAudioPts;
    // sync with video's timestamp
    const initDTS = this._initDTS;
    const init90kHz = initDTS.baseTime * 90000 / initDTS.timescale;
    const startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + init90kHz;
    const endDTS = videoData.endDTS * inputTimeScale + init90kHz;
    // one sample's duration value
    const frameDuration = scaleFactor * AAC_SAMPLES_PER_FRAME;
    // samples count of this segment's duration
    const nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
    // silent frame
    const silentFrame = AAC.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
    logger.warn('[mp4-remuxer]: remux empty Audio');
    // Can't remux if we can't generate a silent frame...
    if (!silentFrame) {
      logger.trace('[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec');
      return;
    }
    const samples = [];
    for (let i = 0; i < nbSamples; i++) {
      const stamp = startDTS + i * frameDuration;
      samples.push({
        unit: silentFrame,
        pts: stamp,
        dts: stamp
      });
    }
    track.samples = samples;
    return this.remuxAudio(track, timeOffset, contiguous, false);
  }
}
function normalizePts(value, reference) {
  let offset;
  if (reference === null) {
    return value;
  }
  if (reference < value) {
    // - 2^33
    offset = -8589934592;
  } else {
    // + 2^33
    offset = 8589934592;
  }
  /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */
  while (Math.abs(value - reference) > 4294967296) {
    value += offset;
  }
  return value;
}
function findKeyframeIndex(samples) {
  for (let i = 0; i < samples.length; i++) {
    if (samples[i].key) {
      return i;
    }
  }
  return -1;
}
function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting id3 pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    sample.dts = normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
  const length = track.samples.length;
  if (!length) {
    return;
  }
  const inputTimeScale = track.inputTimeScale;
  for (let index = 0; index < length; index++) {
    const sample = track.samples[index];
    // setting text pts, dts to relative time
    // using this._initPTS and this._initDTS to calculate relative time
    sample.pts = normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
  }
  track.samples.sort((a, b) => a.pts - b.pts);
  const samples = track.samples;
  track.samples = [];
  return {
    samples
  };
}
class Mp4Sample {
  constructor(isKeyframe, duration, size, cts) {
    this.size = void 0;
    this.duration = void 0;
    this.cts = void 0;
    this.flags = void 0;
    this.duration = duration;
    this.size = size;
    this.cts = cts;
    this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: isKeyframe ? 2 : 1,
      isNonSync: isKeyframe ? 0 : 1
    };
  }
}

class PassThroughRemuxer {
  constructor() {
    this.emitInitSegment = false;
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initData = void 0;
    this.initPTS = null;
    this.initTracks = void 0;
    this.lastEndTime = null;
  }
  destroy() {}
  resetTimeStamp(defaultInitPTS) {
    this.initPTS = defaultInitPTS;
    this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.generateInitSegment(patchEncyptionData(initSegment, decryptdata));
    this.emitInitSegment = true;
  }
  generateInitSegment(initSegment) {
    let {
      audioCodec,
      videoCodec
    } = this;
    if (!(initSegment != null && initSegment.byteLength)) {
      this.initTracks = undefined;
      this.initData = undefined;
      return;
    }
    const initData = this.initData = parseInitSegment(initSegment);

    // Get codec from initSegment or fallback to default
    if (initData.audio) {
      audioCodec = getParsedTrackCodec(initData.audio, ElementaryStreamTypes.AUDIO);
    }
    if (initData.video) {
      videoCodec = getParsedTrackCodec(initData.video, ElementaryStreamTypes.VIDEO);
    }
    const tracks = {};
    if (initData.audio && initData.video) {
      tracks.audiovideo = {
        container: 'video/mp4',
        codec: audioCodec + ',' + videoCodec,
        initSegment,
        id: 'main'
      };
    } else if (initData.audio) {
      tracks.audio = {
        container: 'audio/mp4',
        codec: audioCodec,
        initSegment,
        id: 'audio'
      };
    } else if (initData.video) {
      tracks.video = {
        container: 'video/mp4',
        codec: videoCodec,
        initSegment,
        id: 'main'
      };
    } else {
      logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
    }
    this.initTracks = tracks;
  }
  remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
    var _initData, _initData2;
    let {
      initPTS,
      lastEndTime
    } = this;
    const result = {
      audio: undefined,
      video: undefined,
      text: textTrack,
      id3: id3Track,
      initSegment: undefined
    };

    // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
    // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
    // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
    if (!isFiniteNumber(lastEndTime)) {
      lastEndTime = this.lastEndTime = timeOffset || 0;
    }

    // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
    // audio or video (or both); adding it to video was an arbitrary choice.
    const data = videoTrack.samples;
    if (!(data != null && data.length)) {
      return result;
    }
    const initSegment = {
      initPTS: undefined,
      timescale: 1
    };
    let initData = this.initData;
    if (!((_initData = initData) != null && _initData.length)) {
      this.generateInitSegment(data);
      initData = this.initData;
    }
    if (!((_initData2 = initData) != null && _initData2.length)) {
      // We can't remux if the initSegment could not be generated
      logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
      return result;
    }
    if (this.emitInitSegment) {
      initSegment.tracks = this.initTracks;
      this.emitInitSegment = false;
    }
    const duration = getDuration(data, initData);
    const startDTS = getStartDTS(initData, data);
    const decodeTime = startDTS === null ? timeOffset : startDTS;
    if (isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale && accurateTimeOffset) {
      initSegment.initPTS = decodeTime - timeOffset;
      if (initPTS && initPTS.timescale === 1) {
        logger.warn(`Adjusting initPTS by ${initSegment.initPTS - initPTS.baseTime}`);
      }
      this.initPTS = initPTS = {
        baseTime: initSegment.initPTS,
        timescale: 1
      };
    }
    const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
    const endTime = startTime + duration;
    offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
    if (duration > 0) {
      this.lastEndTime = endTime;
    } else {
      logger.warn('Duration parsed from mp4 should be greater than zero');
      this.resetNextTimestamp();
    }
    const hasAudio = !!initData.audio;
    const hasVideo = !!initData.video;
    let type = '';
    if (hasAudio) {
      type += 'audio';
    }
    if (hasVideo) {
      type += 'video';
    }
    const track = {
      data1: data,
      startPTS: startTime,
      startDTS: startTime,
      endPTS: endTime,
      endDTS: endTime,
      type,
      hasAudio,
      hasVideo,
      nb: 1,
      dropped: 0
    };
    result.audio = track.type === 'audio' ? track : undefined;
    result.video = track.type !== 'audio' ? track : undefined;
    result.initSegment = initSegment;
    result.id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
    if (textTrack.samples.length) {
      result.text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
    }
    return result;
  }
}
function isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
  if (initPTS === null) {
    return true;
  }
  // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
  const minDuration = Math.max(duration, 1);
  const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
  return Math.abs(startTime - timeOffset) > minDuration;
}
function getParsedTrackCodec(track, type) {
  const parsedCodec = track == null ? void 0 : track.codec;
  if (parsedCodec && parsedCodec.length > 4) {
    return parsedCodec;
  }
  if (type === ElementaryStreamTypes.AUDIO) {
    if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') {
      return parsedCodec;
    }
    if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
      // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
      const preferManagedMediaSource = false;
      return getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
    }
    const result = 'mp4a.40.5';
    logger.info(`Parsed audio codec "${parsedCodec}" or audio object type not handled. Using "${result}"`);
    return result;
  }
  // Provide defaults based on codec type
  // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
  logger.warn(`Unhandled video codec "${parsedCodec}"`);
  if (parsedCodec === 'hvc1' || parsedCodec === 'hev1') {
    return 'hvc1.1.6.L120.90';
  }
  if (parsedCodec === 'av01') {
    return 'av01.0.04M.08';
  }
  return 'avc1.42e01e';
}

let now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
  now = self.performance.now.bind(self.performance);
} catch (err) {
  logger.debug('Unable to use Performance API on this environment');
  now = optionalSelf == null ? void 0 : optionalSelf.Date.now;
}
const muxConfig = [{
  demux: MP4Demuxer,
  remux: PassThroughRemuxer
}, {
  demux: TSDemuxer,
  remux: MP4Remuxer
}, {
  demux: AACDemuxer,
  remux: MP4Remuxer
}, {
  demux: MP3Demuxer,
  remux: MP4Remuxer
}];
{
  muxConfig.splice(2, 0, {
    demux: AC3Demuxer,
    remux: MP4Remuxer
  });
}
class Transmuxer {
  constructor(observer, typeSupported, config, vendor, id) {
    this.async = false;
    this.observer = void 0;
    this.typeSupported = void 0;
    this.config = void 0;
    this.vendor = void 0;
    this.id = void 0;
    this.demuxer = void 0;
    this.remuxer = void 0;
    this.decrypter = void 0;
    this.probe = void 0;
    this.decryptionPromise = null;
    this.transmuxConfig = void 0;
    this.currentTransmuxState = void 0;
    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.vendor = vendor;
    this.id = id;
  }
  configure(transmuxConfig) {
    this.transmuxConfig = transmuxConfig;
    if (this.decrypter) {
      this.decrypter.reset();
    }
  }
  push(data, decryptdata, chunkMeta, state) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    let uintData = new Uint8Array(data);
    const {
      currentTransmuxState,
      transmuxConfig
    } = this;
    if (state) {
      this.currentTransmuxState = state;
    }
    const {
      contiguous,
      discontinuity,
      trackSwitch,
      accurateTimeOffset,
      timeOffset,
      initSegmentChange
    } = state || currentTransmuxState;
    const {
      audioCodec,
      videoCodec,
      defaultInitPts,
      duration,
      initSegmentData
    } = transmuxConfig;
    const keyData = getEncryptionType(uintData, decryptdata);
    if (keyData && keyData.method === 'AES-128') {
      const decrypter = this.getDecrypter();
      // Software decryption is synchronous; webCrypto is not
      if (decrypter.isSync()) {
        // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
        // data is handled in the flush() call
        let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
        // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
        const loadingParts = chunkMeta.part > -1;
        if (loadingParts) {
          decryptedData = decrypter.flush();
        }
        if (!decryptedData) {
          stats.executeEnd = now();
          return emptyResult(chunkMeta);
        }
        uintData = new Uint8Array(decryptedData);
      } else {
        this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then(decryptedData => {
          // Calling push here is important; if flush() is called while this is still resolving, this ensures that
          // the decrypted data has been transmuxed
          const result = this.push(decryptedData, null, chunkMeta);
          this.decryptionPromise = null;
          return result;
        });
        return this.decryptionPromise;
      }
    }
    const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
    if (resetMuxers) {
      const error = this.configureTransmuxer(uintData);
      if (error) {
        logger.warn(`[transmuxer] ${error.message}`);
        this.observer.emit(Events.ERROR, Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_PARSING_ERROR,
          fatal: false,
          error,
          reason: error.message
        });
        stats.executeEnd = now();
        return emptyResult(chunkMeta);
      }
    }
    if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) {
      this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
    }
    if (discontinuity || initSegmentChange || resetMuxers) {
      this.resetInitialTimestamp(defaultInitPts);
    }
    if (!contiguous) {
      this.resetContiguity();
    }
    const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    const currentState = this.currentTransmuxState;
    currentState.contiguous = true;
    currentState.discontinuity = false;
    currentState.trackSwitch = false;
    stats.executeEnd = now();
    return result;
  }

  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(chunkMeta) {
    const stats = chunkMeta.transmuxing;
    stats.executeStart = now();
    const {
      decrypter,
      currentTransmuxState,
      decryptionPromise
    } = this;
    if (decryptionPromise) {
      // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
      // only flushing is required for async decryption
      return decryptionPromise.then(() => {
        return this.flush(chunkMeta);
      });
    }
    const transmuxResults = [];
    const {
      timeOffset
    } = currentTransmuxState;
    if (decrypter) {
      // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
      // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
      // or for progressive downloads with small segments)
      const decryptedData = decrypter.flush();
      if (decryptedData) {
        // Push always returns a TransmuxerResult if decryptdata is null
        transmuxResults.push(this.push(decryptedData, null, chunkMeta));
      }
    }
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      // If probing failed, then Hls.js has been given content its not able to handle
      stats.executeEnd = now();
      return [emptyResult(chunkMeta)];
    }
    const demuxResultOrPromise = demuxer.flush(timeOffset);
    if (isPromise(demuxResultOrPromise)) {
      // Decrypt final SAMPLE-AES samples
      return demuxResultOrPromise.then(demuxResult => {
        this.flushRemux(transmuxResults, demuxResult, chunkMeta);
        return transmuxResults;
      });
    }
    this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
    return transmuxResults;
  }
  flushRemux(transmuxResults, demuxResult, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = demuxResult;
    const {
      accurateTimeOffset,
      timeOffset
    } = this.currentTransmuxState;
    logger.log(`[transmuxer.ts]: Flushed fragment ${chunkMeta.sn}${chunkMeta.part > -1 ? ' p: ' + chunkMeta.part : ''} of level ${chunkMeta.level}`);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
    transmuxResults.push({
      remuxResult,
      chunkMeta
    });
    chunkMeta.transmuxing.executeEnd = now();
  }
  resetInitialTimestamp(defaultInitPts) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetTimeStamp(defaultInitPts);
    remuxer.resetTimeStamp(defaultInitPts);
  }
  resetContiguity() {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetContiguity();
    remuxer.resetNextTimestamp();
  }
  resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
    const {
      demuxer,
      remuxer
    } = this;
    if (!demuxer || !remuxer) {
      return;
    }
    demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
    remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
  }
  destroy() {
    if (this.demuxer) {
      this.demuxer.destroy();
      this.demuxer = undefined;
    }
    if (this.remuxer) {
      this.remuxer.destroy();
      this.remuxer = undefined;
    }
  }
  transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
    let result;
    if (keyData && keyData.method === 'SAMPLE-AES') {
      result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
    } else {
      result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
    }
    return result;
  }
  transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
    const {
      audioTrack,
      videoTrack,
      id3Track,
      textTrack
    } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
    const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
    return {
      remuxResult,
      chunkMeta
    };
  }
  transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
    return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then(demuxResult => {
      const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
      return {
        remuxResult,
        chunkMeta
      };
    });
  }
  configureTransmuxer(data) {
    const {
      config,
      observer,
      typeSupported,
      vendor
    } = this;
    // probe for content type
    let mux;
    for (let i = 0, len = muxConfig.length; i < len; i++) {
      var _muxConfig$i$demux;
      if ((_muxConfig$i$demux = muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data)) {
        mux = muxConfig[i];
        break;
      }
    }
    if (!mux) {
      return new Error('Failed to find demuxer by probing fragment data');
    }
    // so let's check that current remuxer and demuxer are still valid
    const demuxer = this.demuxer;
    const remuxer = this.remuxer;
    const Remuxer = mux.remux;
    const Demuxer = mux.demux;
    if (!remuxer || !(remuxer instanceof Remuxer)) {
      this.remuxer = new Remuxer(observer, config, typeSupported, vendor);
    }
    if (!demuxer || !(demuxer instanceof Demuxer)) {
      this.demuxer = new Demuxer(observer, config, typeSupported);
      this.probe = Demuxer.probe;
    }
  }
  needsProbing(discontinuity, trackSwitch) {
    // in case of continuity change, or track switch
    // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
    return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
  }
  getDecrypter() {
    let decrypter = this.decrypter;
    if (!decrypter) {
      decrypter = this.decrypter = new Decrypter(this.config);
    }
    return decrypter;
  }
}
function getEncryptionType(data, decryptData) {
  let encryptionType = null;
  if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) {
    encryptionType = decryptData;
  }
  return encryptionType;
}
const emptyResult = chunkMeta => ({
  remuxResult: {},
  chunkMeta
});
function isPromise(p) {
  return 'then' in p && p.then instanceof Function;
}
class TransmuxConfig {
  constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
    this.audioCodec = void 0;
    this.videoCodec = void 0;
    this.initSegmentData = void 0;
    this.duration = void 0;
    this.defaultInitPts = void 0;
    this.audioCodec = audioCodec;
    this.videoCodec = videoCodec;
    this.initSegmentData = initSegmentData;
    this.duration = duration;
    this.defaultInitPts = defaultInitPts || null;
  }
}
class TransmuxState {
  constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
    this.discontinuity = void 0;
    this.contiguous = void 0;
    this.accurateTimeOffset = void 0;
    this.trackSwitch = void 0;
    this.timeOffset = void 0;
    this.initSegmentChange = void 0;
    this.discontinuity = discontinuity;
    this.contiguous = contiguous;
    this.accurateTimeOffset = accurateTimeOffset;
    this.trackSwitch = trackSwitch;
    this.timeOffset = timeOffset;
    this.initSegmentChange = initSegmentChange;
  }
}

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	} 
} (eventemitter3));

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

class TransmuxerInterface {
  constructor(hls, id, onTransmuxComplete, onFlush) {
    this.error = null;
    this.hls = void 0;
    this.id = void 0;
    this.observer = void 0;
    this.frag = null;
    this.part = null;
    this.useWorker = void 0;
    this.workerContext = null;
    this.onwmsg = void 0;
    this.transmuxer = null;
    this.onTransmuxComplete = void 0;
    this.onFlush = void 0;
    const config = hls.config;
    this.hls = hls;
    this.id = id;
    this.useWorker = !!config.enableWorker;
    this.onTransmuxComplete = onTransmuxComplete;
    this.onFlush = onFlush;
    const forwardMessage = (ev, data) => {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      if (ev === Events.ERROR) {
        this.error = data.error;
      }
      this.hls.trigger(ev, data);
    };

    // forward events to main thread
    this.observer = new EventEmitter();
    this.observer.on(Events.FRAG_DECRYPTED, forwardMessage);
    this.observer.on(Events.ERROR, forwardMessage);
    const MediaSource = getMediaSource(config.preferManagedMediaSource) || {
      isTypeSupported: () => false
    };
    const m2tsTypeSupported = {
      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"') 
    };
    if (this.useWorker && typeof Worker !== 'undefined') {
      const canCreateWorker = config.workerPath || hasUMDWorker();
      if (canCreateWorker) {
        try {
          if (config.workerPath) {
            logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
            this.workerContext = loadWorker(config.workerPath);
          } else {
            logger.log(`injecting Web Worker for "${id}"`);
            this.workerContext = injectWorker();
          }
          this.onwmsg = event => this.onWorkerMessage(event);
          const {
            worker
          } = this.workerContext;
          worker.addEventListener('message', this.onwmsg);
          worker.onerror = event => {
            const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
            config.enableWorker = false;
            logger.warn(`Error in "${id}" Web Worker, fallback to inline`);
            this.hls.trigger(Events.ERROR, {
              type: ErrorTypes.OTHER_ERROR,
              details: ErrorDetails.INTERNAL_EXCEPTION,
              fatal: false,
              event: 'demuxerWorker',
              error
            });
          };
          worker.postMessage({
            cmd: 'init',
            typeSupported: m2tsTypeSupported,
            vendor: '',
            id: id,
            config: JSON.stringify(config)
          });
        } catch (err) {
          logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
          this.resetWorker();
          this.error = null;
          this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id);
        }
        return;
      }
    }
    this.transmuxer = new Transmuxer(this.observer, m2tsTypeSupported, config, '', id);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker,
        objectURL
      } = this.workerContext;
      if (objectURL) {
        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
        self.URL.revokeObjectURL(objectURL);
      }
      worker.removeEventListener('message', this.onwmsg);
      worker.onerror = null;
      worker.terminate();
      this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext) {
      this.resetWorker();
      this.onwmsg = undefined;
    } else {
      const transmuxer = this.transmuxer;
      if (transmuxer) {
        transmuxer.destroy();
        this.transmuxer = null;
      }
    }
    const observer = this.observer;
    if (observer) {
      observer.removeAllListeners();
    }
    this.frag = null;
    // @ts-ignore
    this.observer = null;
    // @ts-ignore
    this.hls = null;
  }
  push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
    var _frag$initSegment, _lastFrag$initSegment;
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    const timeOffset = part ? part.start : frag.start;
    // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
    const decryptdata = frag.decryptdata;
    const lastFrag = this.frag;
    const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
    const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
    const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
    const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
    const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
    const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
    const now = self.performance.now();
    if (trackSwitch || snDiff || frag.stats.parsing.start === 0) {
      frag.stats.parsing.start = now;
    }
    if (part && (partDiff || !contiguous)) {
      part.stats.parsing.start = now;
    }
    const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
    const state = new TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
    if (!contiguous || discontinuity || initSegmentChange) {
      logger.log(`[transmuxer-interface, ${frag.type}]: Starting new transmux session for sn: ${chunkMeta.sn} p: ${chunkMeta.part} level: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
      const config = new TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
      this.configureTransmuxer(config);
    }
    this.frag = frag;
    this.part = part;

    // Frags with sn of 'initSegment' are not transmuxed
    if (this.workerContext) {
      // post fragment payload as transferable objects for ArrayBuffer (no copy)
      this.workerContext.worker.postMessage({
        cmd: 'demux',
        data,
        decryptdata,
        chunkMeta,
        state
      }, data instanceof ArrayBuffer ? [data] : []);
    } else if (transmuxer) {
      const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
      if (isPromise(transmuxResult)) {
        transmuxer.async = true;
        transmuxResult.then(data => {
          this.handleTransmuxComplete(data);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
        });
      } else {
        transmuxer.async = false;
        this.handleTransmuxComplete(transmuxResult);
      }
    }
  }
  flush(chunkMeta) {
    chunkMeta.transmuxing.start = self.performance.now();
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'flush',
        chunkMeta
      });
    } else if (transmuxer) {
      let transmuxResult = transmuxer.flush(chunkMeta);
      const asyncFlush = isPromise(transmuxResult);
      if (asyncFlush || transmuxer.async) {
        if (!isPromise(transmuxResult)) {
          transmuxResult = Promise.resolve(transmuxResult);
        }
        transmuxResult.then(data => {
          this.handleFlushResult(data, chunkMeta);
        }).catch(error => {
          this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
        });
      } else {
        this.handleFlushResult(transmuxResult, chunkMeta);
      }
    }
  }
  transmuxerError(error, chunkMeta, reason) {
    if (!this.hls) {
      return;
    }
    this.error = error;
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.FRAG_PARSING_ERROR,
      chunkMeta,
      frag: this.frag || undefined,
      fatal: false,
      error,
      err: error,
      reason
    });
  }
  handleFlushResult(results, chunkMeta) {
    results.forEach(result => {
      this.handleTransmuxComplete(result);
    });
    this.onFlush(chunkMeta);
  }
  onWorkerMessage(event) {
    const data = event.data;
    if (!(data != null && data.event)) {
      logger.warn(`worker message received with no ${data ? 'event name' : 'data'}`);
      return;
    }
    const hls = this.hls;
    if (!this.hls) {
      return;
    }
    switch (data.event) {
      case 'init':
        {
          var _this$workerContext;
          const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
          if (objectURL) {
            // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
          }
          break;
        }
      case 'transmuxComplete':
        {
          this.handleTransmuxComplete(data.data);
          break;
        }
      case 'flush':
        {
          this.onFlush(data.data);
          break;
        }

      // pass logs from the worker thread to the main logger
      case 'workerLog':
        if (logger[data.data.logType]) {
          logger[data.data.logType](data.data.message);
        }
        break;
      default:
        {
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
        }
    }
  }
  configureTransmuxer(config) {
    const {
      transmuxer
    } = this;
    if (this.workerContext) {
      this.workerContext.worker.postMessage({
        cmd: 'configure',
        config
      });
    } else if (transmuxer) {
      transmuxer.configure(config);
    }
  }
  handleTransmuxComplete(result) {
    result.chunkMeta.transmuxing.end = self.performance.now();
    this.onTransmuxComplete(result);
  }
}

function subtitleOptionsIdentical(trackList1, trackList2) {
  if (trackList1.length !== trackList2.length) {
    return false;
  }
  for (let i = 0; i < trackList1.length; i++) {
    if (!mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) {
      return false;
    }
  }
  return true;
}
function mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
  // Media options with the same rendition ID must be bit identical
  const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
  if (stableRenditionId && !customAttributes) {
    return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
  }
  // When rendition ID is not present, compare attributes
  return !(customAttributes || ['LANGUAGE', 'NAME', 'CHARACTERISTICS', 'AUTOSELECT', 'DEFAULT', 'FORCED', 'ASSOC-LANGUAGE']).some(subtitleAttribute => attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
  return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}

const TICK_INTERVAL$2 = 100; // how often to tick in ms

class AudioStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[audio-stream-controller]', PlaylistLevelType.AUDIO);
    this.videoBuffer = null;
    this.videoTrackCC = -1;
    this.waitingVideoCC = -1;
    this.bufferedTrack = null;
    this.switchingTrack = null;
    this.trackId = -1;
    this.waitingData = null;
    this.mainDetails = null;
    this.flushing = false;
    this.bufferFlushed = false;
    this.cachedTrackLoadedData = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
    this.mainDetails = null;
    this.bufferedTrack = null;
    this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }

  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    // Always update the new INIT PTS
    // Can change due level switch
    if (id === 'main') {
      const cc = frag.cc;
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
      this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}`);
      this.videoTrackCC = cc;
      // If we are waiting, tick immediately to unblock audio fragment transmuxing
      if (this.state === State.WAITING_INIT_PTS) {
        this.tick();
      }
    }
  }
  startLoad(startPosition) {
    if (!this.levels) {
      this.startPosition = startPosition;
      this.state = State.STOPPED;
      return;
    }
    const lastCurrentTime = this.lastCurrentTime;
    this.stopLoad();
    this.setInterval(TICK_INTERVAL$2);
    if (lastCurrentTime > 0 && startPosition === -1) {
      this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
      startPosition = lastCurrentTime;
      this.state = State.IDLE;
    } else {
      this.loadedmetadata = false;
      this.state = State.WAITING_TRACK;
    }
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  doTick() {
    switch (this.state) {
      case State.IDLE:
        this.doTickIdle();
        break;
      case State.WAITING_TRACK:
        {
          var _levels$trackId;
          const {
            levels,
            trackId
          } = this;
          const details = levels == null ? void 0 : (_levels$trackId = levels[trackId]) == null ? void 0 : _levels$trackId.details;
          if (details) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.WAITING_INIT_PTS;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              trackId
            } = this;
            this.log('RetryDate reached, switch back to IDLE state');
            this.resetStartWhenNotLoaded((levels == null ? void 0 : levels[trackId]) || null);
            this.state = State.IDLE;
          }
          break;
        }
      case State.WAITING_INIT_PTS:
        {
          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          const waitingData = this.waitingData;
          if (waitingData) {
            const {
              frag,
              part,
              cache,
              complete
            } = waitingData;
            if (this.initPTS[frag.cc] !== undefined) {
              this.waitingData = null;
              this.waitingVideoCC = -1;
              this.state = State.FRAG_LOADING;
              const payload = cache.flush();
              const data = {
                frag,
                part,
                payload,
                networkDetails: null
              };
              this._handleFragmentLoadProgress(data);
              if (complete) {
                super._handleFragmentLoadComplete(data);
              }
            } else if (this.videoTrackCC !== this.waitingVideoCC) {
              // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
              this.log(`Waiting fragment cc (${frag.cc}) cancelled because video is at cc ${this.videoTrackCC}`);
              this.clearWaitingFragment();
            } else {
              // Drop waiting fragment if an earlier fragment is needed
              const pos = this.getLoadPosition();
              const bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer, pos, this.config.maxBufferHole);
              const waitingFragmentAtPosition = fragmentWithinToleranceTest(bufferInfo.end, this.config.maxFragLookUpTolerance, frag);
              if (waitingFragmentAtPosition < 0) {
                this.log(`Waiting fragment cc (${frag.cc}) @ ${frag.start} cancelled because another fragment at ${bufferInfo.end} is needed`);
                this.clearWaitingFragment();
              }
            }
          } else {
            this.state = State.IDLE;
          }
        }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const waitingData = this.waitingData;
    if (waitingData) {
      this.fragmentTracker.removeFragment(waitingData.frag);
      this.waitingData = null;
      this.waitingVideoCC = -1;
      this.state = State.IDLE;
    }
  }
  resetLoadingState() {
    this.clearWaitingFragment();
    super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media
    } = this;
    if (!(media != null && media.readyState)) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    this.lastCurrentTime = media.currentTime;
  }
  doTickIdle() {
    const {
      hls,
      levels,
      media,
      trackId
    } = this;
    const config = hls.config;

    // 1. if video not attached AND
    //    start fragment already requested OR start frag prefetch not enabled
    // 2. if tracks or track not loaded and selected
    // then exit loop
    // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
    if (!media && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) {
      return;
    }
    const levelInfo = levels[trackId];
    const trackDetails = levelInfo.details;
    if (!trackDetails || trackDetails.live && this.levelLastLoaded !== levelInfo || this.waitForCdnTuneIn(trackDetails)) {
      this.state = State.WAITING_TRACK;
      return;
    }
    const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.bufferFlushed && bufferable) {
      this.bufferFlushed = false;
      this.afterBufferFlushed(bufferable, ElementaryStreamTypes.AUDIO, PlaylistLevelType.AUDIO);
    }
    const bufferInfo = this.getFwdBufferInfo(bufferable, PlaylistLevelType.AUDIO);
    if (bufferInfo === null) {
      return;
    }
    const {
      bufferedTrack,
      switchingTrack
    } = this;
    if (!switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
      hls.trigger(Events.BUFFER_EOS, {
        type: 'audio'
      });
      this.state = State.ENDED;
      return;
    }
    const mainBufferInfo = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, PlaylistLevelType.MAIN);
    const bufferLen = bufferInfo.len;
    const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len);
    const fragments = trackDetails.fragments;
    const start = fragments[0].start;
    let targetBufferTime = this.flushing ? this.getLoadPosition() : bufferInfo.end;
    if (switchingTrack && media) {
      const pos = this.getLoadPosition();
      // STABLE
      if (bufferedTrack && !mediaAttributesIdentical(switchingTrack.attrs, bufferedTrack.attrs)) {
        targetBufferTime = pos;
      }
      // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
      if (trackDetails.PTSKnown && pos < start) {
        // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
        if (bufferInfo.end > start || bufferInfo.nextStart) {
          this.log('Alt audio track ahead of main track, seek to start of alt audio track');
          media.currentTime = start + 0.05;
        }
      }
    }

    // if buffer length is less than maxBufLen, or near the end, find a fragment to load
    if (bufferLen >= maxBufLen && !switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) {
      return;
    }
    let frag = this.getNextFragment(targetBufferTime, trackDetails);
    let atGap = false;
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      atGap = !!frag.gap;
      frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      this.bufferFlushed = true;
      return;
    }

    // Buffer audio up to one target duration ahead of main buffer
    const atBufferSyncLimit = mainBufferInfo && frag.start > mainBufferInfo.end + trackDetails.targetduration;
    if (atBufferSyncLimit ||
    // Or wait for main buffer after buffing some audio
    !(mainBufferInfo != null && mainBufferInfo.len) && bufferInfo.len) {
      // Check fragment-tracker for main fragments since GAP segments do not show up in bufferInfo
      const mainFrag = this.getAppendedFrag(frag.start, PlaylistLevelType.MAIN);
      if (mainFrag === null) {
        return;
      }
      // Bridge gaps in main buffer
      atGap || (atGap = !!mainFrag.gap || !!atBufferSyncLimit && mainBufferInfo.len === 0);
      if (atBufferSyncLimit && !atGap || atGap && bufferInfo.nextStart && bufferInfo.nextStart < mainFrag.end) {
        return;
      }
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.min(Math.max(maxConfigBuffer, mainBufferLength), this.config.maxMaxBufferLength);
  }
  onMediaDetaching() {
    this.videoBuffer = null;
    this.bufferFlushed = this.flushing = false;
    super.onMediaDetaching();
  }
  onAudioTracksUpdated(event, {
    audioTracks
  }) {
    // Reset tranxmuxer is essential for large context switches (Content Steering)
    this.resetTransmuxer();
    this.levels = audioTracks.map(mediaPlaylist => new Level(mediaPlaylist));
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const altAudio = !!data.url;
    this.trackId = data.id;
    const {
      fragCurrent
    } = this;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.removeUnbufferedFrags(fragCurrent.start);
    }
    this.resetLoadingState();
    // destroy useless transmuxer when switching audio to main
    if (!altAudio) {
      this.resetTransmuxer();
    } else {
      // switching to audio track, start timer if not already started
      this.setInterval(TICK_INTERVAL$2);
    }

    // should we switch tracks ?
    if (altAudio) {
      this.switchingTrack = data;
      // main audio track are handled by stream-controller, just do something if switching to alt audio track
      this.state = State.IDLE;
      this.flushAudioIfNeeded(data);
    } else {
      this.switchingTrack = null;
      this.bufferedTrack = data;
      this.state = State.STOPPED;
    }
    this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments();
    this.startPosition = this.lastCurrentTime = 0;
    this.bufferFlushed = this.flushing = false;
    this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null;
    this.startFragRequested = false;
    this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
    if (this.cachedTrackLoadedData !== null) {
      this.hls.trigger(Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData);
      this.cachedTrackLoadedData = null;
    }
  }
  onAudioTrackLoaded(event, data) {
    var _track$details;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = data;
      return;
    }
    const {
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Audio tracks were reset while loading level ${trackId}`);
      return;
    }
    this.log(`Audio track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    const track = levels[trackId];
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      this.checkLiveUpdate(newDetails);
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
        // Make sure our audio rendition is aligned with the "main" rendition, using
        // pdt as our reference times.
        alignMediaPlaylistByPDT(newDetails, mainDetails);
        sliding = newDetails.fragments[0].start;
      } else {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = track;

    // compute start position if we are aligned with the main playlist
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(this.mainDetails || newDetails, sliding);
    }
    // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
    if (this.state === State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) {
      this.state = State.IDLE;
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      config,
      trackId,
      levels
    } = this;
    if (!levels) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const track = levels[trackId];
    if (!track) {
      this.warn('Audio track is undefined on fragment load progress');
      return;
    }
    const details = track.details;
    if (!details) {
      this.warn('Audio track details undefined on fragment load progress');
      this.removeUnbufferedFrags(frag.start);
      return;
    }
    const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
    let transmuxer = this.transmuxer;
    if (!transmuxer) {
      transmuxer = this.transmuxer = new TransmuxerInterface(this.hls, PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    }

    // Check if we have video initPTS
    // If not we need to wait for it
    const initPTS = this.initPTS[frag.cc];
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    if (initPTS !== undefined) {
      // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
      const accurateTimeOffset = false; // details.PTSKnown || !details.live;
      const partIndex = part ? part.index : -1;
      const partial = partIndex !== -1;
      const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
      transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    } else {
      this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
      const {
        cache
      } = this.waitingData = this.waitingData || {
        frag,
        part,
        cache: new ChunkCache(),
        complete: false
      };
      cache.push(new Uint8Array(payload));
      this.waitingVideoCC = this.videoTrackCC;
      this.state = State.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    if (this.waitingData) {
      this.waitingData.complete = true;
      return;
    }
    super._handleFragmentLoadComplete(fragLoadedData);
  }
  onBufferReset( /* event: Events.BUFFER_RESET */
  ) {
    // reset reference to sourcebuffers
    this.mediaBuffer = this.videoBuffer = null;
    this.loadedmetadata = false;
  }
  onBufferCreated(event, data) {
    const audioTrack = data.tracks.audio;
    if (audioTrack) {
      this.mediaBuffer = audioTrack.buffer || null;
    }
    if (data.tracks.video) {
      this.videoBuffer = data.tracks.video.buffer || null;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag.type !== PlaylistLevelType.AUDIO) {
      if (!this.loadedmetadata && frag.type === PlaylistLevelType.MAIN) {
        const bufferable = this.videoBuffer || this.media;
        if (bufferable) {
          const bufferedTimeRanges = BufferHelper.getBuffered(bufferable);
          if (bufferedTimeRanges.length) {
            this.loadedmetadata = true;
          }
        }
      }
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
      return;
    }
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
      const track = this.switchingTrack;
      if (track) {
        this.bufferedTrack = track;
        this.switchingTrack = null;
        this.hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, track));
      }
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.AUDIO, data);
        break;
      case ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
      case ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.AUDIO_TRACK) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'audio') {
          return;
        }
        if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.bufferedTrack = null;
          super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }
  onBufferFlushing(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = true;
    }
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.VIDEO) {
      this.flushing = false;
      this.bufferFlushed = true;
      if (this.state === State.ENDED) {
        this.state = State.IDLE;
      }
      const mediaBuffer = this.mediaBuffer || this.media;
      if (mediaBuffer) {
        this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.AUDIO);
        this.tick();
      }
    }
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'audio';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      details
    } = level;
    const {
      audio,
      text,
      id3,
      initSegment
    } = remuxResult;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag) || !details) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (this.switchingTrack && audio) {
      this.completeAudioSwitch(this.switchingTrack);
    }
    if (initSegment != null && initSegment.tracks) {
      const mapFragment = frag.initSegment || frag;
      this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
      hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
        frag: mapFragment,
        id,
        tracks: initSegment.tracks
      });
      // Only flush audio from old audio tracks when PTS is known on new audio track
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = _extends({
        id,
        frag,
        details
      }, id3);
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (text) {
      const emittedText = _extends({
        id,
        frag,
        details
      }, text);
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    // delete any video track found on audio transmuxer
    if (tracks.video) {
      delete tracks.video;
    }

    // include levelCodec in audio and video tracks
    const track = tracks.audio;
    if (!track) {
      return;
    }
    track.id = 'audio';
    const variantAudioCodecs = currentLevel.audioCodec;
    this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
    // SourceBuffer will use track.levelCodec if defined
    if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) {
      track.levelCodec = variantAudioCodecs;
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    const initSegment = track.initSegment;
    if (initSegment != null && initSegment.byteLength) {
      const segment = {
        type: 'audio',
        frag,
        part: null,
        chunkMeta,
        parent: frag.type,
        data: initSegment
      };
      this.hls.trigger(Events.BUFFER_APPENDING, segment);
    }
    // trigger handler right now
    this.tickImmediate();
  }
  loadFragment(frag, track, targetBufferTime) {
    // only load if fragment is not loaded or if in audio switch
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;

    // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
    if (this.switchingTrack || fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      var _track$details2;
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, track);
      } else if ((_track$details2 = track.details) != null && _track$details2.live && !this.initPTS[frag.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
        this.state = State.WAITING_INIT_PTS;
        const mainDetails = this.mainDetails;
        if (mainDetails && mainDetails.fragments[0].start !== track.details.fragments[0].start) {
          alignMediaPlaylistByPDT(track.details, mainDetails);
        }
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, track, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  flushAudioIfNeeded(switchingTrack) {
    const {
      media,
      bufferedTrack
    } = this;
    const bufferedAttributes = bufferedTrack == null ? void 0 : bufferedTrack.attrs;
    const switchAttributes = switchingTrack.attrs;
    if (media && bufferedAttributes && (bufferedAttributes.CHANNELS !== switchAttributes.CHANNELS || bufferedTrack.name !== switchingTrack.name || bufferedTrack.lang !== switchingTrack.lang)) {
      this.log('Switching audio track : flushing all audio');
      super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
      this.bufferedTrack = null;
    }
  }
  completeAudioSwitch(switchingTrack) {
    const {
      hls
    } = this;
    this.flushAudioIfNeeded(switchingTrack);
    this.bufferedTrack = switchingTrack;
    this.switchingTrack = null;
    hls.trigger(Events.AUDIO_TRACK_SWITCHED, _objectSpread2({}, switchingTrack));
  }
}

class AudioTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[audio-track-controller]');
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.registerListeners();
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    super.destroy();
  }
  onManifestLoading() {
    this.tracks = [];
    this.tracksInGroup = [];
    this.groupIds = null;
    this.currentTrack = null;
    this.trackId = -1;
    this.selectDefaultTrack = true;
  }
  onManifestParsed(event, data) {
    this.tracks = data.audioTracks || [];
  }
  onAudioTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const audioGroups = levelInfo.audioGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = audioGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const audioTracks = this.tracks.filter(track => !audioGroups || audioGroups.indexOf(track.groupId) !== -1);
      if (audioTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !audioTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        audioTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = audioTracks;

      // Find preferred track
      const audioPreference = this.hls.config.audioPreference;
      if (!currentTrack && audioPreference) {
        const groupIndex = findMatchingOption(audioPreference, audioTracks, audioMatchPredicate);
        if (groupIndex > -1) {
          currentTrack = audioTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(audioPreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const audioTracksUpdated = {
        audioTracks
      };
      this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
      this.hls.trigger(Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
      const selectedTrackId = this.trackId;
      if (trackId !== -1 && selectedTrackId === -1) {
        this.setAudioTrack(trackId);
      } else if (audioTracks.length && selectedTrackId === -1) {
        var _this$groupIds;
        const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
        this.warn(error.message);
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
          fatal: true,
          error
        });
      }
    } else if (this.shouldReloadPlaylist(currentTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setAudioTrack(this.trackId);
    }
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.requestScheduled = -1;
      this.checkRetry(data);
    }
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(newId) {
    // If audio track is selected from API then don't choose from the manifest default track
    this.selectDefaultTrack = false;
    this.setAudioTrack(newId);
  }
  setAudioOption(audioOption) {
    const hls = this.hls;
    hls.config.audioPreference = audioOption;
    if (audioOption) {
      const allAudioTracks = this.allAudioTracks;
      this.selectDefaultTrack = false;
      if (allAudioTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(audioOption, currentTrack, audioMatchPredicate)) {
          return currentTrack;
        }
        // Find option in available tracks (tracksInGroup)
        const groupIndex = findMatchingOption(audioOption, this.tracksInGroup, audioMatchPredicate);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setAudioTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // Find option in nearest level audio group
          let searchIndex = hls.loadLevel;
          if (searchIndex === -1) {
            searchIndex = hls.firstAutoLevel;
          }
          const switchIndex = findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, audioMatchPredicate);
          if (switchIndex === -1) {
            // could not find matching variant
            return null;
          }
          // and switch level to acheive the audio group switch
          hls.nextLoadLevel = switchIndex;
        }
        if (audioOption.channels || audioOption.audioCodec) {
          // Could not find a match with codec / channels predicate
          // Find a match without channels or codec
          const withoutCodecAndChannelsMatch = findMatchingOption(audioOption, allAudioTracks);
          if (withoutCodecAndChannelsMatch > -1) {
            return allAudioTracks[withoutCodecAndChannelsMatch];
          }
        }
      }
    }
    return null;
  }
  setAudioTrack(newId) {
    const tracks = this.tracksInGroup;

    // check if level idx is valid
    if (newId < 0 || newId >= tracks.length) {
      this.warn(`Invalid audio track id: ${newId}`);
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId];
    const trackLoaded = track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
    this.trackId = newId;
    this.currentTrack = track;
    this.hls.trigger(Events.AUDIO_TRACK_SWITCHING, _objectSpread2({}, track));
    // Do not reload track unless live
    if (trackLoaded) {
      return;
    }
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
  findTrackId(currentTrack) {
    const audioTracks = this.tracksInGroup;
    for (let i = 0; i < audioTracks.length; i++) {
      const track = audioTracks[i];
      if (this.selectDefaultTrack && !track.default) {
        continue;
      }
      if (!currentTrack || matchesOption(currentTrack, track, audioMatchPredicate)) {
        return i;
      }
    }
    if (currentTrack) {
      const {
        name,
        lang,
        assocLang,
        characteristics,
        audioCodec,
        channels
      } = currentTrack;
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (matchesOption({
          name,
          lang,
          assocLang,
          characteristics,
          audioCodec,
          channels
        }, track, audioMatchPredicate)) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < audioTracks.length; i++) {
        const track = audioTracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  loadPlaylist(hlsUrlParameters) {
    const audioTrack = this.currentTrack;
    if (this.shouldLoadPlaylist(audioTrack) && audioTrack) {
      super.loadPlaylist();
      const id = audioTrack.id;
      const groupId = audioTrack.groupId;
      let url = audioTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      // track not retrieved yet, or live playlist we need to (re)load it
      this.log(`loading audio-track playlist ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}`);
      this.clearTimer();
      this.hls.trigger(Events.AUDIO_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
}

const TICK_INTERVAL$1 = 500; // how often to tick in ms

class SubtitleStreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[subtitle-stream-controller]', PlaylistLevelType.SUBTITLE);
    this.currentTrackId = -1;
    this.tracksBuffered = [];
    this.mainDetails = null;
    this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
    this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(startPosition) {
    this.stopLoad();
    this.state = State.IDLE;
    this.setInterval(TICK_INTERVAL$1);
    this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
    this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null;
    this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [];
    super.onMediaDetaching();
  }
  onLevelLoaded(event, data) {
    this.mainDetails = data.details;
  }
  onSubtitleFragProcessed(event, data) {
    const {
      frag,
      success
    } = data;
    this.fragPrevious = frag;
    this.state = State.IDLE;
    if (!success) {
      return;
    }
    const buffered = this.tracksBuffered[this.currentTrackId];
    if (!buffered) {
      return;
    }

    // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
    // so we can re-use the logic used to detect how much has been buffered
    let timeRange;
    const fragStart = frag.start;
    for (let i = 0; i < buffered.length; i++) {
      if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
        timeRange = buffered[i];
        break;
      }
    }
    const fragEnd = frag.start + frag.duration;
    if (timeRange) {
      timeRange.end = fragEnd;
    } else {
      timeRange = {
        start: fragStart,
        end: fragEnd
      };
      buffered.push(timeRange);
    }
    this.fragmentTracker.fragBuffered(frag);
    this.fragBufferedComplete(frag, null);
  }
  onBufferFlushing(event, data) {
    const {
      startOffset,
      endOffset
    } = data;
    if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
      const endOffsetSubtitles = endOffset - 1;
      if (endOffsetSubtitles <= 0) {
        return;
      }
      data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
      this.tracksBuffered.forEach(buffered => {
        for (let i = 0; i < buffered.length;) {
          if (buffered[i].end <= endOffsetSubtitles) {
            buffered.shift();
            continue;
          } else if (buffered[i].start < endOffsetSubtitles) {
            buffered[i].start = endOffsetSubtitles;
          } else {
            break;
          }
          i++;
        }
      });
      this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, PlaylistLevelType.SUBTITLE);
    }
  }
  onFragBuffered(event, data) {
    if (!this.loadedmetadata && data.frag.type === PlaylistLevelType.MAIN) {
      var _this$media;
      if ((_this$media = this.media) != null && _this$media.buffered.length) {
        this.loadedmetadata = true;
      }
    }
  }

  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(event, data) {
    const frag = data.frag;
    if ((frag == null ? void 0 : frag.type) === PlaylistLevelType.SUBTITLE) {
      if (data.details === ErrorDetails.FRAG_GAP) {
        this.fragmentTracker.fragBuffered(frag, true);
      }
      if (this.fragCurrent) {
        this.fragCurrent.abortRequests();
      }
      if (this.state !== State.STOPPED) {
        this.state = State.IDLE;
      }
    }
  }

  // Got all new subtitle levels.
  onSubtitleTracksUpdated(event, {
    subtitleTracks
  }) {
    if (this.levels && subtitleOptionsIdentical(this.levels, subtitleTracks)) {
      this.levels = subtitleTracks.map(mediaPlaylist => new Level(mediaPlaylist));
      return;
    }
    this.tracksBuffered = [];
    this.levels = subtitleTracks.map(mediaPlaylist => {
      const level = new Level(mediaPlaylist);
      this.tracksBuffered[level.id] = [];
      return level;
    });
    this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, PlaylistLevelType.SUBTITLE);
    this.fragPrevious = null;
    this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(event, data) {
    var _this$levels;
    this.currentTrackId = data.id;
    if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }

    // Check if track has the necessary details to load fragments
    const currentTrack = this.levels[this.currentTrackId];
    if (currentTrack != null && currentTrack.details) {
      this.mediaBuffer = this.mediaBufferTimeRanges;
    } else {
      this.mediaBuffer = null;
    }
    if (currentTrack) {
      this.setInterval(TICK_INTERVAL$1);
    }
  }

  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(event, data) {
    var _track$details;
    const {
      currentTrackId,
      levels
    } = this;
    const {
      details: newDetails,
      id: trackId
    } = data;
    if (!levels) {
      this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
      return;
    }
    const track = levels[trackId];
    if (trackId >= levels.length || !track) {
      return;
    }
    this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let sliding = 0;
    if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
      const mainDetails = this.mainDetails;
      if (newDetails.deltaUpdateFailed || !mainDetails) {
        return;
      }
      const mainSlidingStartFragment = mainDetails.fragments[0];
      if (!track.details) {
        if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
          alignMediaPlaylistByPDT(newDetails, mainDetails);
          sliding = newDetails.fragments[0].start;
        } else if (mainSlidingStartFragment) {
          // line up live playlist with main so that fragments in range are loaded
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      } else {
        var _this$levelLastLoaded;
        sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        if (sliding === 0 && mainSlidingStartFragment) {
          // realign with main when there is no overlap with last refresh
          sliding = mainSlidingStartFragment.start;
          addSliding(newDetails, sliding);
        }
      }
    }
    track.details = newDetails;
    this.levelLastLoaded = track;
    if (trackId !== currentTrackId) {
      return;
    }
    if (!this.startFragRequested && (this.mainDetails || !newDetails.live)) {
      this.setStartPosition(this.mainDetails || newDetails, sliding);
    }

    // trigger handler right now
    this.tick();

    // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
    if (newDetails.live && !this.fragCurrent && this.media && this.state === State.IDLE) {
      const foundFrag = findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
      if (!foundFrag) {
        this.warn('Subtitle playlist not aligned with playback');
        track.details = undefined;
      }
    }
  }
  _handleFragmentLoadComplete(fragLoadedData) {
    const {
      frag,
      payload
    } = fragLoadedData;
    const decryptData = frag.decryptdata;
    const hls = this.hls;
    if (this.fragContextChanged(frag)) {
      return;
    }
    // check to see if the payload needs to be decrypted
    if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && decryptData.method === 'AES-128') {
      const startTime = performance.now();
      // decrypt the subtitles
      this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).catch(err => {
        hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.FRAG_DECRYPT_ERROR,
          fatal: false,
          error: err,
          reason: err.message,
          frag
        });
        throw err;
      }).then(decryptedData => {
        const endTime = performance.now();
        hls.trigger(Events.FRAG_DECRYPTED, {
          frag,
          payload: decryptedData,
          stats: {
            tstart: startTime,
            tdecrypt: endTime
          }
        });
      }).catch(err => {
        this.warn(`${err.name}: ${err.message}`);
        this.state = State.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = State.IDLE;
      return;
    }
    if (this.state === State.IDLE) {
      const {
        currentTrackId,
        levels
      } = this;
      const track = levels == null ? void 0 : levels[currentTrackId];
      if (!track || !levels.length || !track.details) {
        return;
      }
      const {
        config
      } = this;
      const currentTime = this.getLoadPosition();
      const bufferedInfo = BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
      const {
        end: targetBufferTime,
        len: bufferLen
      } = bufferedInfo;
      const mainBufferInfo = this.getFwdBufferInfo(this.media, PlaylistLevelType.MAIN);
      const trackDetails = track.details;
      const maxBufLen = this.getMaxBufferLength(mainBufferInfo == null ? void 0 : mainBufferInfo.len) + trackDetails.levelTargetDuration;
      if (bufferLen > maxBufLen) {
        return;
      }
      const fragments = trackDetails.fragments;
      const fragLen = fragments.length;
      const end = trackDetails.edge;
      let foundFrag = null;
      const fragPrevious = this.fragPrevious;
      if (targetBufferTime < end) {
        const tolerance = config.maxFragLookUpTolerance;
        const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
        foundFrag = findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
        if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) {
          foundFrag = fragments[0];
        }
      } else {
        foundFrag = fragments[fragLen - 1];
      }
      if (!foundFrag) {
        return;
      }
      foundFrag = this.mapToInitFragWhenRequired(foundFrag);
      if (foundFrag.sn !== 'initSegment') {
        // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
        const curSNIdx = foundFrag.sn - trackDetails.startSN;
        const prevFrag = fragments[curSNIdx - 1];
        if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === FragmentState.NOT_LOADED) {
          foundFrag = prevFrag;
        }
      }
      if (this.fragmentTracker.getState(foundFrag) === FragmentState.NOT_LOADED) {
        // only load if fragment is not loaded
        this.loadFragment(foundFrag, track, targetBufferTime);
      }
    }
  }
  getMaxBufferLength(mainBufferLength) {
    const maxConfigBuffer = super.getMaxBufferLength();
    if (!mainBufferLength) {
      return maxConfigBuffer;
    }
    return Math.max(maxConfigBuffer, mainBufferLength);
  }
  loadFragment(frag, level, targetBufferTime) {
    this.fragCurrent = frag;
    if (frag.sn === 'initSegment') {
      this._loadInitSegment(frag, level);
    } else {
      this.startFragRequested = true;
      super.loadFragment(frag, level, targetBufferTime);
    }
  }
  get mediaBufferTimeRanges() {
    return new BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class BufferableInstance {
  constructor(timeranges) {
    this.buffered = void 0;
    const getRange = (name, index, length) => {
      index = index >>> 0;
      if (index > length - 1) {
        throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
      }
      return timeranges[index][name];
    };
    this.buffered = {
      get length() {
        return timeranges.length;
      },
      end(index) {
        return getRange('end', index, timeranges.length);
      },
      start(index) {
        return getRange('start', index, timeranges.length);
      }
    };
  }
}

class SubtitleTrackController extends BasePlaylistController {
  constructor(hls) {
    super(hls, '[subtitle-track-controller]');
    this.media = null;
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
    this.queuedDefaultTrack = -1;
    this.asyncPollTrackChange = () => this.pollTrackChange(0);
    this.useTextTrackPolling = false;
    this.subtitlePollingInterval = -1;
    this._subtitleDisplay = true;
    this.onTextTracksChanged = () => {
      if (!this.useTextTrackPolling) {
        self.clearInterval(this.subtitlePollingInterval);
      }
      // Media is undefined when switching streams via loadSource()
      if (!this.media || !this.hls.config.renderTextTracksNatively) {
        return;
      }
      let textTrack = null;
      const tracks = filterSubtitleTracks(this.media.textTracks);
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].mode === 'hidden') {
          // Do not break in case there is a following track with showing.
          textTrack = tracks[i];
        } else if (tracks[i].mode === 'showing') {
          textTrack = tracks[i];
          break;
        }
      }

      // Find internal track index for TextTrack
      const trackId = this.findTrackForTextTrack(textTrack);
      if (this.subtitleTrack !== trackId) {
        this.setSubtitleTrack(trackId);
      }
    };
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.tracks.length = 0;
    this.tracksInGroup.length = 0;
    this.currentTrack = null;
    this.onTextTracksChanged = this.asyncPollTrackChange = null;
    super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(value) {
    this._subtitleDisplay = value;
    if (this.trackId > -1) {
      this.toggleTrackModes();
    }
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.on(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.off(Events.LEVEL_SWITCHING, this.onLevelSwitching, this);
    hls.off(Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
    hls.off(Events.ERROR, this.onError, this);
  }

  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(event, data) {
    this.media = data.media;
    if (!this.media) {
      return;
    }
    if (this.queuedDefaultTrack > -1) {
      this.subtitleTrack = this.queuedDefaultTrack;
      this.queuedDefaultTrack = -1;
    }
    this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
    if (this.useTextTrackPolling) {
      this.pollTrackChange(500);
    } else {
      this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
  }
  pollTrackChange(timeout) {
    self.clearInterval(this.subtitlePollingInterval);
    this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
  }
  onMediaDetaching() {
    if (!this.media) {
      return;
    }
    self.clearInterval(this.subtitlePollingInterval);
    if (!this.useTextTrackPolling) {
      this.media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
    }
    if (this.trackId > -1) {
      this.queuedDefaultTrack = this.trackId;
    }
    const textTracks = filterSubtitleTracks(this.media.textTracks);
    // Clear loaded cues on media detachment from tracks
    textTracks.forEach(track => {
      clearCurrentCues(track);
    });
    // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
    this.subtitleTrack = -1;
    this.media = null;
  }
  onManifestLoading() {
    this.tracks = [];
    this.groupIds = null;
    this.tracksInGroup = [];
    this.trackId = -1;
    this.currentTrack = null;
    this.selectDefaultTrack = true;
  }

  // Fired whenever a new manifest is loaded.
  onManifestParsed(event, data) {
    this.tracks = data.subtitleTracks;
  }
  onSubtitleTrackLoaded(event, data) {
    const {
      id,
      groupId,
      details
    } = data;
    const trackInActiveGroup = this.tracksInGroup[id];
    if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
      this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
      return;
    }
    const curDetails = trackInActiveGroup.details;
    trackInActiveGroup.details = data.details;
    this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
    if (id === this.trackId) {
      this.playlistLoaded(id, data, curDetails);
    }
  }
  onLevelLoading(event, data) {
    this.switchLevel(data.level);
  }
  onLevelSwitching(event, data) {
    this.switchLevel(data.level);
  }
  switchLevel(levelIndex) {
    const levelInfo = this.hls.levels[levelIndex];
    if (!levelInfo) {
      return;
    }
    const subtitleGroups = levelInfo.subtitleGroups || null;
    const currentGroups = this.groupIds;
    let currentTrack = this.currentTrack;
    if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some(groupId => (currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
      this.groupIds = subtitleGroups;
      this.trackId = -1;
      this.currentTrack = null;
      const subtitleTracks = this.tracks.filter(track => !subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
      if (subtitleTracks.length) {
        // Disable selectDefaultTrack if there are no default tracks
        if (this.selectDefaultTrack && !subtitleTracks.some(track => track.default)) {
          this.selectDefaultTrack = false;
        }
        // track.id should match hls.audioTracks index
        subtitleTracks.forEach((track, i) => {
          track.id = i;
        });
      } else if (!currentTrack && !this.tracksInGroup.length) {
        // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
        return;
      }
      this.tracksInGroup = subtitleTracks;

      // Find preferred track
      const subtitlePreference = this.hls.config.subtitlePreference;
      if (!currentTrack && subtitlePreference) {
        this.selectDefaultTrack = false;
        const groupIndex = findMatchingOption(subtitlePreference, subtitleTracks);
        if (groupIndex > -1) {
          currentTrack = subtitleTracks[groupIndex];
        } else {
          const allIndex = findMatchingOption(subtitlePreference, this.tracks);
          currentTrack = this.tracks[allIndex];
        }
      }

      // Select initial track
      let trackId = this.findTrackId(currentTrack);
      if (trackId === -1 && currentTrack) {
        trackId = this.findTrackId(null);
      }

      // Dispatch events and load track if needed
      const subtitleTracksUpdated = {
        subtitleTracks
      };
      this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
      this.hls.trigger(Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
      if (trackId !== -1 && this.trackId === -1) {
        this.setSubtitleTrack(trackId);
      }
    } else if (this.shouldReloadPlaylist(currentTrack)) {
      // Retry playlist loading if no playlist is or has been loaded yet
      this.setSubtitleTrack(this.trackId);
    }
  }
  findTrackId(currentTrack) {
    const tracks = this.tracksInGroup;
    const selectDefault = this.selectDefaultTrack;
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      if (selectDefault && !track.default || !selectDefault && !currentTrack) {
        continue;
      }
      if (!currentTrack || matchesOption(track, currentTrack)) {
        return i;
      }
    }
    if (currentTrack) {
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE', 'ASSOC-LANGUAGE', 'CHARACTERISTICS'])) {
          return i;
        }
      }
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (mediaAttributesIdentical(currentTrack.attrs, track.attrs, ['LANGUAGE'])) {
          return i;
        }
      }
    }
    return -1;
  }
  findTrackForTextTrack(textTrack) {
    if (textTrack) {
      const tracks = this.tracksInGroup;
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        if (subtitleTrackMatchesTextTrack(track, textTrack)) {
          return i;
        }
      }
    }
    return -1;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) {
      this.checkRetry(data);
    }
  }
  get allSubtitleTracks() {
    return this.tracks;
  }

  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }

  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(newId) {
    this.selectDefaultTrack = false;
    this.setSubtitleTrack(newId);
  }
  setSubtitleOption(subtitleOption) {
    this.hls.config.subtitlePreference = subtitleOption;
    if (subtitleOption) {
      const allSubtitleTracks = this.allSubtitleTracks;
      this.selectDefaultTrack = false;
      if (allSubtitleTracks.length) {
        // First see if current option matches (no switch op)
        const currentTrack = this.currentTrack;
        if (currentTrack && matchesOption(subtitleOption, currentTrack)) {
          return currentTrack;
        }
        // Find option in current group
        const groupIndex = findMatchingOption(subtitleOption, this.tracksInGroup);
        if (groupIndex > -1) {
          const track = this.tracksInGroup[groupIndex];
          this.setSubtitleTrack(groupIndex);
          return track;
        } else if (currentTrack) {
          // If this is not the initial selection return null
          // option should have matched one in active group
          return null;
        } else {
          // Find the option in all tracks for initial selection
          const allIndex = findMatchingOption(subtitleOption, allSubtitleTracks);
          if (allIndex > -1) {
            return allSubtitleTracks[allIndex];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentTrack = this.currentTrack;
    if (this.shouldLoadPlaylist(currentTrack) && currentTrack) {
      const id = currentTrack.id;
      const groupId = currentTrack.groupId;
      let url = currentTrack.url;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      this.log(`Loading subtitle playlist for id ${id}`);
      this.hls.trigger(Events.SUBTITLE_TRACK_LOADING, {
        url,
        id,
        groupId,
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }

  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = filterSubtitleTracks(media.textTracks);
    const currentTrack = this.currentTrack;
    let nextTrack;
    if (currentTrack) {
      nextTrack = textTracks.filter(textTrack => subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
      if (!nextTrack) {
        this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
      }
    }
    [].slice.call(textTracks).forEach(track => {
      if (track.mode !== 'disabled' && track !== nextTrack) {
        track.mode = 'disabled';
      }
    });
    if (nextTrack) {
      const mode = this.subtitleDisplay ? 'showing' : 'hidden';
      if (nextTrack.mode !== mode) {
        nextTrack.mode = mode;
      }
    }
  }

  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(newId) {
    const tracks = this.tracksInGroup;

    // setting this.subtitleTrack will trigger internal logic
    // if media has not been attached yet, it will fail
    // we keep a reference to the default track id
    // and we'll set subtitleTrack when onMediaAttached is triggered
    if (!this.media) {
      this.queuedDefaultTrack = newId;
      return;
    }

    // exit if track id as already set or invalid
    if (newId < -1 || newId >= tracks.length || !isFiniteNumber(newId)) {
      this.warn(`Invalid subtitle track id: ${newId}`);
      return;
    }

    // stopping live reloading timer if any
    this.clearTimer();
    this.selectDefaultTrack = false;
    const lastTrack = this.currentTrack;
    const track = tracks[newId] || null;
    this.trackId = newId;
    this.currentTrack = track;
    this.toggleTrackModes();
    if (!track) {
      // switch to -1
      this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
        id: newId
      });
      return;
    }
    const trackLoaded = !!track.details && !track.details.live;
    if (newId === this.trackId && track === lastTrack && trackLoaded) {
      return;
    }
    this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
    const {
      id,
      groupId = '',
      name,
      type,
      url
    } = track;
    this.hls.trigger(Events.SUBTITLE_TRACK_SWITCH, {
      id,
      groupId,
      name,
      type,
      url
    });
    const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
    this.loadPlaylist(hlsUrlParameters);
  }
}

class BufferOperationQueue {
  constructor(sourceBufferReference) {
    this.buffers = void 0;
    this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    };
    this.buffers = sourceBufferReference;
  }
  append(operation, type, pending) {
    const queue = this.queues[type];
    queue.push(operation);
    if (queue.length === 1 && !pending) {
      this.executeNext(type);
    }
  }
  insertAbort(operation, type) {
    const queue = this.queues[type];
    queue.unshift(operation);
    this.executeNext(type);
  }
  appendBlocker(type) {
    let execute;
    const promise = new Promise(resolve => {
      execute = resolve;
    });
    const operation = {
      execute,
      onStart: () => {},
      onComplete: () => {},
      onError: () => {}
    };
    this.append(operation, type);
    return promise;
  }
  executeNext(type) {
    const queue = this.queues[type];
    if (queue.length) {
      const operation = queue[0];
      try {
        // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
        // which do not end with this event must call _onSBUpdateEnd manually
        operation.execute();
      } catch (error) {
        logger.warn(`[buffer-operation-queue]: Exception executing "${type}" SourceBuffer operation: ${error}`);
        operation.onError(error);

        // Only shift the current operation off, otherwise the updateend handler will do this for us
        const sb = this.buffers[type];
        if (!(sb != null && sb.updating)) {
          this.shiftAndExecuteNext(type);
        }
      }
    }
  }
  shiftAndExecuteNext(type) {
    this.queues[type].shift();
    this.executeNext(type);
  }
  current(type) {
    return this.queues[type][0];
  }
}

const VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class BufferController {
  constructor(hls) {
    // The level details used to determine duration, target-duration and live
    this.details = null;
    // cache the self generated object url to detect hijack of video tag
    this._objectUrl = null;
    // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
    this.operationQueue = void 0;
    // References to event listeners for each SourceBuffer, so that they can be referenced for event removal
    this.listeners = void 0;
    this.hls = void 0;
    // The number of BUFFER_CODEC events received before any sourceBuffers are created
    this.bufferCodecEventsExpected = 0;
    // The total number of BUFFER_CODEC events received
    this._bufferCodecEventsTotal = 0;
    // A reference to the attached media element
    this.media = null;
    // A reference to the active media source
    this.mediaSource = null;
    // Last MP3 audio chunk appended
    this.lastMpegAudioChunk = null;
    this.appendSource = void 0;
    // counters
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
    this.tracks = {};
    this.pendingTracks = {};
    this.sourceBuffer = void 0;
    this.log = void 0;
    this.warn = void 0;
    this.error = void 0;
    this._onEndStreaming = event => {
      if (!this.hls) {
        return;
      }
      this.hls.pauseBuffering();
    };
    this._onStartStreaming = event => {
      if (!this.hls) {
        return;
      }
      this.hls.resumeBuffering();
    };
    // Keep as arrow functions so that we can directly reference these functions directly as event listeners
    this._onMediaSourceOpen = () => {
      const {
        media,
        mediaSource
      } = this;
      this.log('Media source opened');
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        this.updateMediaElementDuration();
        this.hls.trigger(Events.MEDIA_ATTACHED, {
          media,
          mediaSource: mediaSource
        });
      }
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      }
      this.checkPendingTracks();
    };
    this._onMediaSourceClose = () => {
      this.log('Media source closed');
    };
    this._onMediaSourceEnded = () => {
      this.log('Media source ended');
    };
    this._onMediaEmptied = () => {
      const {
        mediaSrc,
        _objectUrl
      } = this;
      if (mediaSrc !== _objectUrl) {
        logger.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
      }
    };
    this.hls = hls;
    const logPrefix = '[buffer-controller]';
    this.appendSource = isManagedMediaSource(getMediaSource(hls.config.preferManagedMediaSource));
    this.log = logger.log.bind(logger, logPrefix);
    this.warn = logger.warn.bind(logger, logPrefix);
    this.error = logger.error.bind(logger, logPrefix);
    this._initSourceBuffer();
    this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners();
    this.details = null;
    this.lastMpegAudioChunk = null;
    // @ts-ignore
    this.hls = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.on(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.on(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.on(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.on(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.BUFFER_RESET, this.onBufferReset, this);
    hls.off(Events.BUFFER_APPENDING, this.onBufferAppending, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.BUFFER_EOS, this.onBufferEos, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    hls.off(Events.LEVEL_UPDATED, this.onLevelUpdated, this);
    hls.off(Events.FRAG_PARSED, this.onFragParsed, this);
    hls.off(Events.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {};
    this.operationQueue = new BufferOperationQueue(this.sourceBuffer);
    this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    };
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
    this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0;
    this.details = null;
  }
  onManifestParsed(event, data) {
    // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
    // sourcebuffers will be created all at once when the expected nb of tracks will be reached
    // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
    // it will contain the expected nb of source buffers, no need to compute it
    let codecEvents = 2;
    if (data.audio && !data.video || !data.altAudio || !true) {
      codecEvents = 1;
    }
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = codecEvents;
    this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(event, data) {
    const media = this.media = data.media;
    const MediaSource = getMediaSource(this.appendSource);
    if (media && MediaSource) {
      var _ms$constructor;
      const ms = this.mediaSource = new MediaSource();
      this.log(`created media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
      // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
      ms.addEventListener('sourceopen', this._onMediaSourceOpen);
      ms.addEventListener('sourceended', this._onMediaSourceEnded);
      ms.addEventListener('sourceclose', this._onMediaSourceClose);
      if (this.appendSource) {
        ms.addEventListener('startstreaming', this._onStartStreaming);
        ms.addEventListener('endstreaming', this._onEndStreaming);
      }

      // cache the locally generated object url
      const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
      // link video and media Source
      if (this.appendSource) {
        try {
          media.removeAttribute('src');
          // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
          const MMS = self.ManagedMediaSource;
          media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
          removeSourceChildren(media);
          addSource(media, objectUrl);
          media.load();
        } catch (error) {
          media.src = objectUrl;
        }
      } else {
        media.src = objectUrl;
      }
      media.addEventListener('emptied', this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media,
      mediaSource,
      _objectUrl
    } = this;
    if (mediaSource) {
      this.log('media source detaching');
      if (mediaSource.readyState === 'open') {
        try {
          // endOfStream could trigger exception if any sourcebuffer is in updating state
          // we don't really care about checking sourcebuffer state here,
          // as we are anyway detaching the MediaSource
          // let's just avoid this exception to propagate
          mediaSource.endOfStream();
        } catch (err) {
          this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
        }
      }
      // Clean up the SourceBuffers by invoking onBufferReset
      this.onBufferReset();
      mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
      mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
      mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
      if (this.appendSource) {
        mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
        mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
      }

      // Detach properly the MediaSource from the HTMLMediaElement as
      // suggested in https://github.com/w3c/media-source/issues/53.
      if (media) {
        media.removeEventListener('emptied', this._onMediaEmptied);
        if (_objectUrl) {
          self.URL.revokeObjectURL(_objectUrl);
        }

        // clean up video tag src only if it's our own url. some external libraries might
        // hijack the video tag and change its 'src' without destroying the Hls instance first
        if (this.mediaSrc === _objectUrl) {
          media.removeAttribute('src');
          if (this.appendSource) {
            removeSourceChildren(media);
          }
          media.load();
        } else {
          this.warn('media|source.src was changed by a third party - skip cleanup');
        }
      }
      this.mediaSource = null;
      this.media = null;
      this._objectUrl = null;
      this.bufferCodecEventsExpected = this._bufferCodecEventsTotal;
      this.pendingTracks = {};
      this.tracks = {};
    }
    this.hls.trigger(Events.MEDIA_DETACHED, undefined);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach(type => {
      this.resetBuffer(type);
    });
    this._initSourceBuffer();
  }
  resetBuffer(type) {
    const sb = this.sourceBuffer[type];
    try {
      if (sb) {
        var _this$mediaSource;
        this.removeBufferListeners(type);
        // Synchronously remove the SB from the map before the next call in order to prevent an async function from
        // accessing it
        this.sourceBuffer[type] = undefined;
        if ((_this$mediaSource = this.mediaSource) != null && _this$mediaSource.sourceBuffers.length) {
          this.mediaSource.removeSourceBuffer(sb);
        }
      }
    } catch (err) {
      this.warn(`onBufferReset ${type}`, err);
    }
  }
  onBufferCodecs(event, data) {
    const sourceBufferCount = this.getSourceBufferTypes().length;
    const trackNames = Object.keys(data);
    trackNames.forEach(trackName => {
      if (sourceBufferCount) {
        // check if SourceBuffer codec needs to change
        const track = this.tracks[trackName];
        if (track && typeof track.buffer.changeType === 'function') {
          var _trackCodec;
          const {
            id,
            codec,
            levelCodec,
            container,
            metadata
          } = data[trackName];
          const currentCodecFull = pickMostCompleteCodecName(track.codec, track.levelCodec);
          const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
          let trackCodec = pickMostCompleteCodecName(codec, levelCodec);
          const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace(VIDEO_CODEC_PROFILE_REPLACE, '$1');
          if (trackCodec && currentCodec !== nextCodec) {
            if (trackName.slice(0, 5) === 'audio') {
              trackCodec = getCodecCompatibleName(trackCodec, this.appendSource);
            }
            const mimeType = `${container};codecs=${trackCodec}`;
            this.appendChangeType(trackName, mimeType);
            this.log(`switching codec ${currentCodecFull} to ${trackCodec}`);
            this.tracks[trackName] = {
              buffer: track.buffer,
              codec,
              container,
              levelCodec,
              metadata,
              id
            };
          }
        }
      } else {
        // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
        this.pendingTracks[trackName] = data[trackName];
      }
    });

    // if sourcebuffers already created, do nothing ...
    if (sourceBufferCount) {
      return;
    }
    const bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0);
    if (this.bufferCodecEventsExpected !== bufferCodecEventsExpected) {
      this.log(`${bufferCodecEventsExpected} bufferCodec event(s) expected ${trackNames.join(',')}`);
      this.bufferCodecEventsExpected = bufferCodecEventsExpected;
    }
    if (this.mediaSource && this.mediaSource.readyState === 'open') {
      this.checkPendingTracks();
    }
  }
  appendChangeType(type, mimeType) {
    const {
      operationQueue
    } = this;
    const operation = {
      execute: () => {
        const sb = this.sourceBuffer[type];
        if (sb) {
          this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
          sb.changeType(mimeType);
        }
        operationQueue.shiftAndExecuteNext(type);
      },
      onStart: () => {},
      onComplete: () => {},
      onError: error => {
        this.warn(`Failed to change ${type} SourceBuffer type`, error);
      }
    };
    operationQueue.append(operation, type, !!this.pendingTracks[type]);
  }
  onBufferAppending(event, eventData) {
    const {
      hls,
      operationQueue,
      tracks
    } = this;
    const {
      data,
      type,
      frag,
      part,
      chunkMeta
    } = eventData;
    const chunkStats = chunkMeta.buffering[type];
    const bufferAppendingStart = self.performance.now();
    chunkStats.start = bufferAppendingStart;
    const fragBuffering = frag.stats.buffering;
    const partBuffering = part ? part.stats.buffering : null;
    if (fragBuffering.start === 0) {
      fragBuffering.start = bufferAppendingStart;
    }
    if (partBuffering && partBuffering.start === 0) {
      partBuffering.start = bufferAppendingStart;
    }

    // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
    // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
    // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
    // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
    // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
    const audioTrack = tracks.audio;
    let checkTimestampOffset = false;
    if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
      checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
      this.lastMpegAudioChunk = chunkMeta;
    }
    const fragStart = frag.start;
    const operation = {
      execute: () => {
        chunkStats.executeStart = self.performance.now();
        if (checkTimestampOffset) {
          const sb = this.sourceBuffer[type];
          if (sb) {
            const delta = fragStart - sb.timestampOffset;
            if (Math.abs(delta) >= 0.1) {
              this.log(`Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${frag.sn})`);
              sb.timestampOffset = fragStart;
            }
          }
        }
        this.appendExecutor(data, type);
      },
      onStart: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
        const end = self.performance.now();
        chunkStats.executeEnd = chunkStats.end = end;
        if (fragBuffering.first === 0) {
          fragBuffering.first = end;
        }
        if (partBuffering && partBuffering.first === 0) {
          partBuffering.first = end;
        }
        const {
          sourceBuffer
        } = this;
        const timeRanges = {};
        for (const type in sourceBuffer) {
          timeRanges[type] = BufferHelper.getBuffered(sourceBuffer[type]);
        }
        this.appendErrors[type] = 0;
        if (type === 'audio' || type === 'video') {
          this.appendErrors.audiovideo = 0;
        } else {
          this.appendErrors.audio = 0;
          this.appendErrors.video = 0;
        }
        this.hls.trigger(Events.BUFFER_APPENDED, {
          type,
          frag,
          part,
          chunkMeta,
          parent: frag.type,
          timeRanges
        });
      },
      onError: error => {
        // in case any error occured while appending, put back segment in segments table
        const event = {
          type: ErrorTypes.MEDIA_ERROR,
          parent: frag.type,
          details: ErrorDetails.BUFFER_APPEND_ERROR,
          sourceBufferName: type,
          frag,
          part,
          chunkMeta,
          error,
          err: error,
          fatal: false
        };
        if (error.code === DOMException.QUOTA_EXCEEDED_ERR) {
          // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
          // let's stop appending any segments, and report BUFFER_FULL_ERROR error
          event.details = ErrorDetails.BUFFER_FULL_ERROR;
        } else {
          const appendErrorCount = ++this.appendErrors[type];
          event.details = ErrorDetails.BUFFER_APPEND_ERROR;
          /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */
          this.warn(`Failed ${appendErrorCount}/${hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer`);
          if (appendErrorCount >= hls.config.appendErrorMaxRetry) {
            event.fatal = true;
          }
        }
        hls.trigger(Events.ERROR, event);
      }
    };
    operationQueue.append(operation, type, !!this.pendingTracks[type]);
  }
  onBufferFlushing(event, data) {
    const {
      operationQueue
    } = this;
    const flushOperation = type => ({
      execute: this.removeExecutor.bind(this, type, data.startOffset, data.endOffset),
      onStart: () => {
        // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
      },
      onComplete: () => {
        // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
        this.hls.trigger(Events.BUFFER_FLUSHED, {
          type
        });
      },
      onError: error => {
        this.warn(`Failed to remove from ${type} SourceBuffer`, error);
      }
    });
    if (data.type) {
      operationQueue.append(flushOperation(data.type), data.type);
    } else {
      this.getSourceBufferTypes().forEach(type => {
        operationQueue.append(flushOperation(type), type);
      });
    }
  }
  onFragParsed(event, data) {
    const {
      frag,
      part
    } = data;
    const buffersAppendedTo = [];
    const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
    if (elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO]) {
      buffersAppendedTo.push('audiovideo');
    } else {
      if (elementaryStreams[ElementaryStreamTypes.AUDIO]) {
        buffersAppendedTo.push('audio');
      }
      if (elementaryStreams[ElementaryStreamTypes.VIDEO]) {
        buffersAppendedTo.push('video');
      }
    }
    const onUnblocked = () => {
      const now = self.performance.now();
      frag.stats.buffering.end = now;
      if (part) {
        part.stats.buffering.end = now;
      }
      const stats = part ? part.stats : frag.stats;
      this.hls.trigger(Events.FRAG_BUFFERED, {
        frag,
        part,
        stats,
        id: frag.type
      });
    };
    if (buffersAppendedTo.length === 0) {
      this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
    }
    this.blockBuffers(onUnblocked, buffersAppendedTo);
  }
  onFragChanged(event, data) {
    this.trimBuffers();
  }

  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(event, data) {
    const ended = this.getSourceBufferTypes().reduce((acc, type) => {
      const sb = this.sourceBuffer[type];
      if (sb && (!data.type || data.type === type)) {
        sb.ending = true;
        if (!sb.ended) {
          sb.ended = true;
          this.log(`${type} sourceBuffer now EOS`);
        }
      }
      return acc && !!(!sb || sb.ended);
    }, true);
    if (ended) {
      this.log(`Queueing mediaSource.endOfStream()`);
      this.blockBuffers(() => {
        this.getSourceBufferTypes().forEach(type => {
          const sb = this.sourceBuffer[type];
          if (sb) {
            sb.ending = false;
          }
        });
        const {
          mediaSource
        } = this;
        if (!mediaSource || mediaSource.readyState !== 'open') {
          if (mediaSource) {
            this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
          }
          return;
        }
        this.log(`Calling mediaSource.endOfStream()`);
        // Allow this to throw and be caught by the enqueueing function
        mediaSource.endOfStream();
      });
    }
  }
  onLevelUpdated(event, {
    details
  }) {
    if (!details.fragments.length) {
      return;
    }
    this.details = details;
    if (this.getSourceBufferTypes().length) {
      this.blockBuffers(this.updateMediaElementDuration.bind(this));
    } else {
      this.updateMediaElementDuration();
    }
  }
  trimBuffers() {
    const {
      hls,
      details,
      media
    } = this;
    if (!media || details === null) {
      return;
    }
    const sourceBufferTypes = this.getSourceBufferTypes();
    if (!sourceBufferTypes.length) {
      return;
    }
    const config = hls.config;
    const currentTime = media.currentTime;
    const targetDuration = details.levelTargetDuration;

    // Support for deprecated liveBackBufferLength
    const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
    if (isFiniteNumber(backBufferLength) && backBufferLength > 0) {
      const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
      const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
      this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
    }
    if (isFiniteNumber(config.frontBufferFlushThreshold) && config.frontBufferFlushThreshold > 0) {
      const frontBufferLength = Math.max(config.maxBufferLength, config.frontBufferFlushThreshold);
      const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
      const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
      this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
    }
  }
  flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
    const {
      details,
      sourceBuffer
    } = this;
    const sourceBufferTypes = this.getSourceBufferTypes();
    sourceBufferTypes.forEach(type => {
      const sb = sourceBuffer[type];
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        // when target buffer start exceeds actual buffer start
        if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
          this.hls.trigger(Events.BACK_BUFFER_REACHED, {
            bufferEnd: targetBackBufferPosition
          });

          // Support for deprecated event:
          if (details != null && details.live) {
            this.hls.trigger(Events.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: targetBackBufferPosition
            });
          } else if (sb.ended && buffered.end(buffered.length - 1) - currentTime < targetDuration * 2) {
            this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(Events.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: targetBackBufferPosition,
            type
          });
        }
      }
    });
  }
  flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
    const {
      sourceBuffer
    } = this;
    const sourceBufferTypes = this.getSourceBufferTypes();
    sourceBufferTypes.forEach(type => {
      const sb = sourceBuffer[type];
      if (sb) {
        const buffered = BufferHelper.getBuffered(sb);
        const numBufferedRanges = buffered.length;
        // The buffer is either empty or contiguous
        if (numBufferedRanges < 2) {
          return;
        }
        const bufferStart = buffered.start(numBufferedRanges - 1);
        const bufferEnd = buffered.end(numBufferedRanges - 1);
        // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
        if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) {
          return;
        } else if (sb.ended && currentTime - bufferEnd < 2 * targetDuration) {
          this.log(`Cannot flush ${type} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: bufferStart,
          endOffset: Infinity,
          type
        });
      }
    });
  }

  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== 'open') {
      return;
    }
    const {
      details,
      hls,
      media,
      mediaSource
    } = this;
    const levelDuration = details.fragments[0].start + details.totalduration;
    const mediaDuration = media.duration;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
    if (details.live && hls.config.liveDurationInfinity) {
      // Override duration to Infinity
      mediaSource.duration = Infinity;
      this.updateSeekableRange(details);
    } else if (levelDuration > msDuration && levelDuration > mediaDuration || !isFiniteNumber(mediaDuration)) {
      // levelDuration was the last value we set.
      // not using mediaSource.duration as the browser may tweak this value
      // only update Media Source duration if its value increase, this is to avoid
      // flushing already buffered portion when switching between quality level
      this.log(`Updating Media Source duration to ${levelDuration.toFixed(3)}`);
      mediaSource.duration = levelDuration;
    }
  }
  updateSeekableRange(levelDetails) {
    const mediaSource = this.mediaSource;
    const fragments = levelDetails.fragments;
    const len = fragments.length;
    if (len && levelDetails.live && mediaSource != null && mediaSource.setLiveSeekableRange) {
      const start = Math.max(0, fragments[0].start);
      const end = Math.max(start, start + levelDetails.totalduration);
      this.log(`Media Source duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
      mediaSource.setLiveSeekableRange(start, end);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected,
      operationQueue,
      pendingTracks
    } = this;

    // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
    // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
    // data has been appended to existing ones.
    // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
    const pendingTracksCount = Object.keys(pendingTracks).length;
    if (pendingTracksCount && (!bufferCodecEventsExpected || pendingTracksCount === 2 || 'audiovideo' in pendingTracks)) {
      // ok, let's create them now !
      this.createSourceBuffers(pendingTracks);
      this.pendingTracks = {};
      // append any pending segments now !
      const buffers = this.getSourceBufferTypes();
      if (buffers.length) {
        this.hls.trigger(Events.BUFFER_CREATED, {
          tracks: this.tracks
        });
        buffers.forEach(type => {
          operationQueue.executeNext(type);
        });
      } else {
        const error = new Error('could not create source buffer for media codec(s)');
        this.hls.trigger(Events.ERROR, {
          type: ErrorTypes.MEDIA_ERROR,
          details: ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: true,
          error,
          reason: error.message
        });
      }
    }
  }
  createSourceBuffers(tracks) {
    const {
      sourceBuffer,
      mediaSource
    } = this;
    if (!mediaSource) {
      throw Error('createSourceBuffers called when mediaSource was null');
    }
    for (const trackName in tracks) {
      if (!sourceBuffer[trackName]) {
        var _track$levelCodec;
        const track = tracks[trackName];
        if (!track) {
          throw Error(`source buffer exists for track ${trackName}, however track does not`);
        }
        // use levelCodec as first priority unless it contains multiple comma-separated codec values
        let codec = ((_track$levelCodec = track.levelCodec) == null ? void 0 : _track$levelCodec.indexOf(',')) === -1 ? track.levelCodec : track.codec;
        if (codec) {
          if (trackName.slice(0, 5) === 'audio') {
            codec = getCodecCompatibleName(codec, this.appendSource);
          }
        }
        const mimeType = `${track.container};codecs=${codec}`;
        this.log(`creating sourceBuffer(${mimeType})`);
        try {
          const sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
          const sbName = trackName;
          this.addBufferListener(sbName, 'updatestart', this._onSBUpdateStart);
          this.addBufferListener(sbName, 'updateend', this._onSBUpdateEnd);
          this.addBufferListener(sbName, 'error', this._onSBUpdateError);
          // ManagedSourceBuffer bufferedchange event
          if (this.appendSource) {
            this.addBufferListener(sbName, 'bufferedchange', (type, event) => {
              // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
              const removedRanges = event.removedRanges;
              if (removedRanges != null && removedRanges.length) {
                this.hls.trigger(Events.BUFFER_FLUSHED, {
                  type: trackName
                });
              }
            });
          }
          this.tracks[trackName] = {
            buffer: sb,
            codec: codec,
            container: track.container,
            levelCodec: track.levelCodec,
            metadata: track.metadata,
            id: track.id
          };
        } catch (err) {
          this.error(`error while trying to add sourceBuffer: ${err.message}`);
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_ADD_CODEC_ERROR,
            fatal: false,
            error: err,
            sourceBufferName: trackName,
            mimeType: mimeType
          });
        }
      }
    }
  }
  get mediaSrc() {
    var _this$media, _this$media$querySele;
    const media = ((_this$media = this.media) == null ? void 0 : (_this$media$querySele = _this$media.querySelector) == null ? void 0 : _this$media$querySele.call(_this$media, 'source')) || this.media;
    return media == null ? void 0 : media.src;
  }
  _onSBUpdateStart(type) {
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onStart();
  }
  _onSBUpdateEnd(type) {
    var _this$mediaSource2;
    if (((_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState) === 'closed') {
      this.resetBuffer(type);
      return;
    }
    const {
      operationQueue
    } = this;
    const operation = operationQueue.current(type);
    operation.onComplete();
    operationQueue.shiftAndExecuteNext(type);
  }
  _onSBUpdateError(type, event) {
    var _this$mediaSource3;
    const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource3 = this.mediaSource) == null ? void 0 : _this$mediaSource3.readyState}`);
    this.error(`${error}`, event);
    // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
    // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
    this.hls.trigger(Events.ERROR, {
      type: ErrorTypes.MEDIA_ERROR,
      details: ErrorDetails.BUFFER_APPENDING_ERROR,
      sourceBufferName: type,
      error,
      fatal: false
    });
    // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
    const operation = this.operationQueue.current(type);
    if (operation) {
      operation.onError(error);
    }
  }

  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(type, startOffset, endOffset) {
    const {
      media,
      mediaSource,
      operationQueue,
      sourceBuffer
    } = this;
    const sb = sourceBuffer[type];
    if (!media || !mediaSource || !sb) {
      this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
      operationQueue.shiftAndExecuteNext(type);
      return;
    }
    const mediaDuration = isFiniteNumber(media.duration) ? media.duration : Infinity;
    const msDuration = isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
    const removeStart = Math.max(0, startOffset);
    const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
    if (removeEnd > removeStart && (!sb.ending || sb.ended)) {
      sb.ended = false;
      this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
      sb.remove(removeStart, removeEnd);
    } else {
      // Cycle the queue
      operationQueue.shiftAndExecuteNext(type);
    }
  }

  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(data, type) {
    const sb = this.sourceBuffer[type];
    if (!sb) {
      if (!this.pendingTracks[type]) {
        throw new Error(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
      }
      return;
    }
    sb.ended = false;
    sb.appendBuffer(data);
  }

  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(onUnblocked, buffers = this.getSourceBufferTypes()) {
    if (!buffers.length) {
      this.log('Blocking operation requested, but no SourceBuffers exist');
      Promise.resolve().then(onUnblocked);
      return;
    }
    const {
      operationQueue
    } = this;

    // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
    const blockingOperations = buffers.map(type => operationQueue.appendBlocker(type));
    Promise.all(blockingOperations).then(() => {
      // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
      onUnblocked();
      buffers.forEach(type => {
        const sb = this.sourceBuffer[type];
        // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
        // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
        // While this is a workaround, it's probably useful to have around
        if (!(sb != null && sb.updating)) {
          operationQueue.shiftAndExecuteNext(type);
        }
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(type, event, fn) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    const listener = fn.bind(this, type);
    this.listeners[type].push({
      event,
      listener
    });
    buffer.addEventListener(event, listener);
  }
  removeBufferListeners(type) {
    const buffer = this.sourceBuffer[type];
    if (!buffer) {
      return;
    }
    this.listeners[type].forEach(l => {
      buffer.removeEventListener(l.event, l.listener);
    });
  }
}
function removeSourceChildren(node) {
  const sourceChildren = node.querySelectorAll('source');
  [].slice.call(sourceChildren).forEach(source => {
    node.removeChild(source);
  });
}
function addSource(media, url) {
  const source = self.document.createElement('source');
  source.type = 'video/mp4';
  source.src = url;
  media.appendChild(source);
}

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

const specialCea608CharsCodes = {
  0x2a: 0xe1,
  // lowercase a, acute accent
  0x5c: 0xe9,
  // lowercase e, acute accent
  0x5e: 0xed,
  // lowercase i, acute accent
  0x5f: 0xf3,
  // lowercase o, acute accent
  0x60: 0xfa,
  // lowercase u, acute accent
  0x7b: 0xe7,
  // lowercase c with cedilla
  0x7c: 0xf7,
  // division symbol
  0x7d: 0xd1,
  // uppercase N tilde
  0x7e: 0xf1,
  // lowercase n tilde
  0x7f: 0x2588,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  0x80: 0xae,
  // Registered symbol (R)
  0x81: 0xb0,
  // degree sign
  0x82: 0xbd,
  // 1/2 symbol
  0x83: 0xbf,
  // Inverted (open) question mark
  0x84: 0x2122,
  // Trademark symbol (TM)
  0x85: 0xa2,
  // Cents symbol
  0x86: 0xa3,
  // Pounds sterling
  0x87: 0x266a,
  // Music 8'th note
  0x88: 0xe0,
  // lowercase a, grave accent
  0x89: 0x20,
  // transparent space (regular)
  0x8a: 0xe8,
  // lowercase e, grave accent
  0x8b: 0xe2,
  // lowercase a, circumflex accent
  0x8c: 0xea,
  // lowercase e, circumflex accent
  0x8d: 0xee,
  // lowercase i, circumflex accent
  0x8e: 0xf4,
  // lowercase o, circumflex accent
  0x8f: 0xfb,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  0x90: 0xc1,
  // capital letter A with acute
  0x91: 0xc9,
  // capital letter E with acute
  0x92: 0xd3,
  // capital letter O with acute
  0x93: 0xda,
  // capital letter U with acute
  0x94: 0xdc,
  // capital letter U with diaresis
  0x95: 0xfc,
  // lowercase letter U with diaeresis
  0x96: 0x2018,
  // opening single quote
  0x97: 0xa1,
  // inverted exclamation mark
  0x98: 0x2a,
  // asterisk
  0x99: 0x2019,
  // closing single quote
  0x9a: 0x2501,
  // box drawings heavy horizontal
  0x9b: 0xa9,
  // copyright sign
  0x9c: 0x2120,
  // Service mark
  0x9d: 0x2022,
  // (round) bullet
  0x9e: 0x201c,
  // Left double quotation mark
  0x9f: 0x201d,
  // Right double quotation mark
  0xa0: 0xc0,
  // uppercase A, grave accent
  0xa1: 0xc2,
  // uppercase A, circumflex
  0xa2: 0xc7,
  // uppercase C with cedilla
  0xa3: 0xc8,
  // uppercase E, grave accent
  0xa4: 0xca,
  // uppercase E, circumflex
  0xa5: 0xcb,
  // capital letter E with diaresis
  0xa6: 0xeb,
  // lowercase letter e with diaresis
  0xa7: 0xce,
  // uppercase I, circumflex
  0xa8: 0xcf,
  // uppercase I, with diaresis
  0xa9: 0xef,
  // lowercase i, with diaresis
  0xaa: 0xd4,
  // uppercase O, circumflex
  0xab: 0xd9,
  // uppercase U, grave accent
  0xac: 0xf9,
  // lowercase u, grave accent
  0xad: 0xdb,
  // uppercase U, circumflex
  0xae: 0xab,
  // left-pointing double angle quotation mark
  0xaf: 0xbb,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  0xb0: 0xc3,
  // Uppercase A, tilde
  0xb1: 0xe3,
  // Lowercase a, tilde
  0xb2: 0xcd,
  // Uppercase I, acute accent
  0xb3: 0xcc,
  // Uppercase I, grave accent
  0xb4: 0xec,
  // Lowercase i, grave accent
  0xb5: 0xd2,
  // Uppercase O, grave accent
  0xb6: 0xf2,
  // Lowercase o, grave accent
  0xb7: 0xd5,
  // Uppercase O, tilde
  0xb8: 0xf5,
  // Lowercase o, tilde
  0xb9: 0x7b,
  // Open curly brace
  0xba: 0x7d,
  // Closing curly brace
  0xbb: 0x5c,
  // Backslash
  0xbc: 0x5e,
  // Caret
  0xbd: 0x5f,
  // Underscore
  0xbe: 0x7c,
  // Pipe (vertical line)
  0xbf: 0x223c,
  // Tilde operator
  0xc0: 0xc4,
  // Uppercase A, umlaut
  0xc1: 0xe4,
  // Lowercase A, umlaut
  0xc2: 0xd6,
  // Uppercase O, umlaut
  0xc3: 0xf6,
  // Lowercase o, umlaut
  0xc4: 0xdf,
  // Esszett (sharp S)
  0xc5: 0xa5,
  // Yen symbol
  0xc6: 0xa4,
  // Generic currency sign
  0xc7: 0x2503,
  // Box drawings heavy vertical
  0xc8: 0xc5,
  // Uppercase A, ring
  0xc9: 0xe5,
  // Lowercase A, ring
  0xca: 0xd8,
  // Uppercase O, stroke
  0xcb: 0xf8,
  // Lowercase o, strok
  0xcc: 0x250f,
  // Box drawings heavy down and right
  0xcd: 0x2513,
  // Box drawings heavy down and left
  0xce: 0x2517,
  // Box drawings heavy up and right
  0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
const getCharForByte = byte => String.fromCharCode(specialCea608CharsCodes[byte] || byte);
const NR_ROWS = 15;
const NR_COLS = 100;
// Tables to look up row from PAC data
const rowsLowCh1 = {
  0x11: 1,
  0x12: 3,
  0x15: 5,
  0x16: 7,
  0x17: 9,
  0x10: 11,
  0x13: 12,
  0x14: 14
};
const rowsHighCh1 = {
  0x11: 2,
  0x12: 4,
  0x15: 6,
  0x16: 8,
  0x17: 10,
  0x13: 13,
  0x14: 15
};
const rowsLowCh2 = {
  0x19: 1,
  0x1a: 3,
  0x1d: 5,
  0x1e: 7,
  0x1f: 9,
  0x18: 11,
  0x1b: 12,
  0x1c: 14
};
const rowsHighCh2 = {
  0x19: 2,
  0x1a: 4,
  0x1d: 6,
  0x1e: 8,
  0x1f: 10,
  0x1b: 13,
  0x1c: 15
};
const backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
class CaptionsLogger {
  constructor() {
    this.time = null;
    this.verboseLevel = 0;
  }
  log(severity, msg) {
    if (this.verboseLevel >= severity) {
      const m = typeof msg === 'function' ? msg() : msg;
      logger.log(`${this.time} [${severity}] ${m}`);
    }
  }
}
const numArrayToHexArray = function numArrayToHexArray(numArray) {
  const hexArray = [];
  for (let j = 0; j < numArray.length; j++) {
    hexArray.push(numArray[j].toString(16));
  }
  return hexArray;
};
class PenState {
  constructor() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  reset() {
    this.foreground = 'white';
    this.underline = false;
    this.italics = false;
    this.background = 'black';
    this.flash = false;
  }
  setStyles(styles) {
    const attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
    for (let i = 0; i < attribs.length; i++) {
      const style = attribs[i];
      if (styles.hasOwnProperty(style)) {
        this[style] = styles[style];
      }
    }
  }
  isDefault() {
    return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
  }
  equals(other) {
    return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
  }
  copy(newPenState) {
    this.foreground = newPenState.foreground;
    this.underline = newPenState.underline;
    this.italics = newPenState.italics;
    this.background = newPenState.background;
    this.flash = newPenState.flash;
  }
  toString() {
    return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
  }
}

/**
 * Unicode character with styling and background.
 * @constructor
 */
class StyledUnicodeChar {
  constructor() {
    this.uchar = ' ';
    this.penState = new PenState();
  }
  reset() {
    this.uchar = ' ';
    this.penState.reset();
  }
  setChar(uchar, newPenState) {
    this.uchar = uchar;
    this.penState.copy(newPenState);
  }
  setPenState(newPenState) {
    this.penState.copy(newPenState);
  }
  equals(other) {
    return this.uchar === other.uchar && this.penState.equals(other.penState);
  }
  copy(newChar) {
    this.uchar = newChar.uchar;
    this.penState.copy(newChar.penState);
  }
  isEmpty() {
    return this.uchar === ' ' && this.penState.isDefault();
  }
}

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */
class Row {
  constructor(logger) {
    this.chars = [];
    this.pos = 0;
    this.currPenState = new PenState();
    this.cueStartTime = null;
    this.logger = void 0;
    for (let i = 0; i < NR_COLS; i++) {
      this.chars.push(new StyledUnicodeChar());
    }
    this.logger = logger;
  }
  equals(other) {
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].equals(other.chars[i])) {
        return false;
      }
    }
    return true;
  }
  copy(other) {
    for (let i = 0; i < NR_COLS; i++) {
      this.chars[i].copy(other.chars[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      if (!this.chars[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }

  /**
   *  Set the cursor to a valid column.
   */
  setCursor(absPos) {
    if (this.pos !== absPos) {
      this.pos = absPos;
    }
    if (this.pos < 0) {
      this.logger.log(3, 'Negative cursor position ' + this.pos);
      this.pos = 0;
    } else if (this.pos > NR_COLS) {
      this.logger.log(3, 'Too large cursor position ' + this.pos);
      this.pos = NR_COLS;
    }
  }

  /**
   * Move the cursor relative to current position.
   */
  moveCursor(relPos) {
    const newPos = this.pos + relPos;
    if (relPos > 1) {
      for (let i = this.pos + 1; i < newPos + 1; i++) {
        this.chars[i].setPenState(this.currPenState);
      }
    }
    this.setCursor(newPos);
  }

  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1);
    this.chars[this.pos].setChar(' ', this.currPenState);
  }
  insertChar(byte) {
    if (byte >= 0x90) {
      // Extended char
      this.backSpace();
    }
    const char = getCharForByte(byte);
    if (this.pos >= NR_COLS) {
      this.logger.log(0, () => 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
      return;
    }
    this.chars[this.pos].setChar(char, this.currPenState);
    this.moveCursor(1);
  }
  clearFromPos(startPos) {
    let i;
    for (i = startPos; i < NR_COLS; i++) {
      this.chars[i].reset();
    }
  }
  clear() {
    this.clearFromPos(0);
    this.pos = 0;
    this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const chars = [];
    let empty = true;
    for (let i = 0; i < NR_COLS; i++) {
      const char = this.chars[i].uchar;
      if (char !== ' ') {
        empty = false;
      }
      chars.push(char);
    }
    if (empty) {
      return '';
    } else {
      return chars.join('');
    }
  }
  setPenStyles(styles) {
    this.currPenState.setStyles(styles);
    const currChar = this.chars[this.pos];
    currChar.setPenState(this.currPenState);
  }
}

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */
class CaptionScreen {
  constructor(logger) {
    this.rows = [];
    this.currRow = NR_ROWS - 1;
    this.nrRollUpRows = null;
    this.lastOutputScreen = null;
    this.logger = void 0;
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows.push(new Row(logger));
    }
    this.logger = logger;
  }
  reset() {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].clear();
    }
    this.currRow = NR_ROWS - 1;
  }
  equals(other) {
    let equal = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].equals(other.rows[i])) {
        equal = false;
        break;
      }
    }
    return equal;
  }
  copy(other) {
    for (let i = 0; i < NR_ROWS; i++) {
      this.rows[i].copy(other.rows[i]);
    }
  }
  isEmpty() {
    let empty = true;
    for (let i = 0; i < NR_ROWS; i++) {
      if (!this.rows[i].isEmpty()) {
        empty = false;
        break;
      }
    }
    return empty;
  }
  backSpace() {
    const row = this.rows[this.currRow];
    row.backSpace();
  }
  clearToEndOfRow() {
    const row = this.rows[this.currRow];
    row.clearToEndOfRow();
  }

  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(char) {
    const row = this.rows[this.currRow];
    row.insertChar(char);
  }
  setPen(styles) {
    const row = this.rows[this.currRow];
    row.setPenStyles(styles);
  }
  moveCursor(relPos) {
    const row = this.rows[this.currRow];
    row.moveCursor(relPos);
  }
  setCursor(absPos) {
    this.logger.log(2, 'setCursor: ' + absPos);
    const row = this.rows[this.currRow];
    row.setCursor(absPos);
  }
  setPAC(pacData) {
    this.logger.log(2, () => 'pacData = ' + JSON.stringify(pacData));
    let newRow = pacData.row - 1;
    if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
      newRow = this.nrRollUpRows - 1;
    }

    // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
    if (this.nrRollUpRows && this.currRow !== newRow) {
      // clear all rows first
      for (let i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }

      // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
      // topRowIndex - the start of rows to copy (inclusive index)
      const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      // We only copy if the last position was already shown.
      // We use the cueStartTime value to check this.
      const lastOutputScreen = this.lastOutputScreen;
      if (lastOutputScreen) {
        const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
        const time = this.logger.time;
        if (prevLineTime !== null && time !== null && prevLineTime < time) {
          for (let i = 0; i < this.nrRollUpRows; i++) {
            this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
          }
        }
      }
    }
    this.currRow = newRow;
    const row = this.rows[this.currRow];
    if (pacData.indent !== null) {
      const indent = pacData.indent;
      const prevPos = Math.max(indent - 1, 0);
      row.setCursor(pacData.indent);
      pacData.color = row.chars[prevPos].penState.foreground;
    }
    const styles = {
      foreground: pacData.color,
      underline: pacData.underline,
      italics: pacData.italics,
      background: 'black',
      flash: false
    };
    this.setPen(styles);
  }

  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(bkgData) {
    this.logger.log(2, () => 'bkgData = ' + JSON.stringify(bkgData));
    this.backSpace();
    this.setPen(bkgData);
    this.insertChar(0x20); // Space
  }
  setRollUpRows(nrRows) {
    this.nrRollUpRows = nrRows;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
      return; // Not properly setup
    }
    this.logger.log(1, () => this.getDisplayText());
    const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
    const topRow = this.rows.splice(topRowIndex, 1)[0];
    topRow.clear();
    this.rows.splice(this.currRow, 0, topRow);
    this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
  }

  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(asOneRow) {
    asOneRow = asOneRow || false;
    const displayText = [];
    let text = '';
    let rowNr = -1;
    for (let i = 0; i < NR_ROWS; i++) {
      const rowText = this.rows[i].getTextString();
      if (rowText) {
        rowNr = i + 1;
        if (asOneRow) {
          displayText.push('Row ' + rowNr + ": '" + rowText + "'");
        } else {
          displayText.push(rowText.trim());
        }
      }
    }
    if (displayText.length > 0) {
      if (asOneRow) {
        text = '[' + displayText.join(' | ') + ']';
      } else {
        text = displayText.join('\n');
      }
    }
    return text;
  }
  getTextAndFormat() {
    return this.rows;
  }
}

// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

class Cea608Channel {
  constructor(channelNumber, outputFilter, logger) {
    this.chNr = void 0;
    this.outputFilter = void 0;
    this.mode = void 0;
    this.verbose = void 0;
    this.displayedMemory = void 0;
    this.nonDisplayedMemory = void 0;
    this.lastOutputScreen = void 0;
    this.currRollUpRow = void 0;
    this.writeScreen = void 0;
    this.cueStartTime = void 0;
    this.logger = void 0;
    this.chNr = channelNumber;
    this.outputFilter = outputFilter;
    this.mode = null;
    this.verbose = 0;
    this.displayedMemory = new CaptionScreen(logger);
    this.nonDisplayedMemory = new CaptionScreen(logger);
    this.lastOutputScreen = new CaptionScreen(logger);
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null; // Keeps track of where a cue started.
    this.logger = logger;
  }
  reset() {
    this.mode = null;
    this.displayedMemory.reset();
    this.nonDisplayedMemory.reset();
    this.lastOutputScreen.reset();
    this.outputFilter.reset();
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(newHandler) {
    this.outputFilter = newHandler;
  }
  setPAC(pacData) {
    this.writeScreen.setPAC(pacData);
  }
  setBkgData(bkgData) {
    this.writeScreen.setBkgData(bkgData);
  }
  setMode(newMode) {
    if (newMode === this.mode) {
      return;
    }
    this.mode = newMode;
    this.logger.log(2, () => 'MODE=' + newMode);
    if (this.mode === 'MODE_POP-ON') {
      this.writeScreen = this.nonDisplayedMemory;
    } else {
      this.writeScreen = this.displayedMemory;
      this.writeScreen.reset();
    }
    if (this.mode !== 'MODE_ROLL-UP') {
      this.displayedMemory.nrRollUpRows = null;
      this.nonDisplayedMemory.nrRollUpRows = null;
    }
    this.mode = newMode;
  }
  insertChars(chars) {
    for (let i = 0; i < chars.length; i++) {
      this.writeScreen.insertChar(chars[i]);
    }
    const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
    this.logger.log(2, () => screen + ': ' + this.writeScreen.getDisplayText(true));
    if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
      this.logger.log(1, () => 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
      this.outputDataUpdate();
    }
  }
  ccRCL() {
    // Resume Caption Loading (switch mode to Pop On)
    this.logger.log(2, 'RCL - Resume Caption Loading');
    this.setMode('MODE_POP-ON');
  }
  ccBS() {
    // BackSpace
    this.logger.log(2, 'BS - BackSpace');
    if (this.mode === 'MODE_TEXT') {
      return;
    }
    this.writeScreen.backSpace();
    if (this.writeScreen === this.displayedMemory) {
      this.outputDataUpdate();
    }
  }
  ccAOF() {
    // Reserved (formerly Alarm Off)
  }
  ccAON() {
    // Reserved (formerly Alarm On)
  }
  ccDER() {
    // Delete to End of Row
    this.logger.log(2, 'DER- Delete to End of Row');
    this.writeScreen.clearToEndOfRow();
    this.outputDataUpdate();
  }
  ccRU(nrRows) {
    // Roll-Up Captions-2,3,or 4 Rows
    this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
    this.writeScreen = this.displayedMemory;
    this.setMode('MODE_ROLL-UP');
    this.writeScreen.setRollUpRows(nrRows);
  }
  ccFON() {
    // Flash On
    this.logger.log(2, 'FON - Flash On');
    this.writeScreen.setPen({
      flash: true
    });
  }
  ccRDC() {
    // Resume Direct Captioning (switch mode to PaintOn)
    this.logger.log(2, 'RDC - Resume Direct Captioning');
    this.setMode('MODE_PAINT-ON');
  }
  ccTR() {
    // Text Restart in text mode (not supported, however)
    this.logger.log(2, 'TR');
    this.setMode('MODE_TEXT');
  }
  ccRTD() {
    // Resume Text Display in Text mode (not supported, however)
    this.logger.log(2, 'RTD');
    this.setMode('MODE_TEXT');
  }
  ccEDM() {
    // Erase Displayed Memory
    this.logger.log(2, 'EDM - Erase Displayed Memory');
    this.displayedMemory.reset();
    this.outputDataUpdate(true);
  }
  ccCR() {
    // Carriage Return
    this.logger.log(2, 'CR - Carriage Return');
    this.writeScreen.rollUp();
    this.outputDataUpdate(true);
  }
  ccENM() {
    // Erase Non-Displayed Memory
    this.logger.log(2, 'ENM - Erase Non-displayed Memory');
    this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    // End of Caption (Flip Memories)
    this.logger.log(2, 'EOC - End Of Caption');
    if (this.mode === 'MODE_POP-ON') {
      const tmp = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory;
      this.nonDisplayedMemory = tmp;
      this.writeScreen = this.nonDisplayedMemory;
      this.logger.log(1, () => 'DISP: ' + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(true);
  }
  ccTO(nrCols) {
    // Tab Offset 1,2, or 3 columns
    this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
    this.writeScreen.moveCursor(nrCols);
  }
  ccMIDROW(secondByte) {
    // Parse MIDROW command
    const styles = {
      flash: false
    };
    styles.underline = secondByte % 2 === 1;
    styles.italics = secondByte >= 0x2e;
    if (!styles.italics) {
      const colorIndex = Math.floor(secondByte / 2) - 0x10;
      const colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
      styles.foreground = colors[colorIndex];
    } else {
      styles.foreground = 'white';
    }
    this.logger.log(2, 'MIDROW: ' + JSON.stringify(styles));
    this.writeScreen.setPen(styles);
  }
  outputDataUpdate(dispatch = false) {
    const time = this.logger.time;
    if (time === null) {
      return;
    }
    if (this.outputFilter) {
      if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
        // Start of a new cue
        this.cueStartTime = time;
      } else {
        if (!this.displayedMemory.equals(this.lastOutputScreen)) {
          this.outputFilter.newCue(this.cueStartTime, time, this.lastOutputScreen);
          if (dispatch && this.outputFilter.dispatchCue) {
            this.outputFilter.dispatchCue();
          }
          this.cueStartTime = this.displayedMemory.isEmpty() ? null : time;
        }
      }
      this.lastOutputScreen.copy(this.displayedMemory);
    }
  }
  cueSplitAtTime(t) {
    if (this.outputFilter) {
      if (!this.displayedMemory.isEmpty()) {
        if (this.outputFilter.newCue) {
          this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
        }
        this.cueStartTime = t;
      }
    }
  }
}

// Will be 1 or 2 when parsing captions

class Cea608Parser {
  constructor(field, out1, out2) {
    this.channels = void 0;
    this.currentChannel = 0;
    this.cmdHistory = createCmdHistory();
    this.logger = void 0;
    const logger = this.logger = new CaptionsLogger();
    this.channels = [null, new Cea608Channel(field, out1, logger), new Cea608Channel(field + 1, out2, logger)];
  }
  getHandler(channel) {
    return this.channels[channel].getHandler();
  }
  setHandler(channel, newHandler) {
    this.channels[channel].setHandler(newHandler);
  }

  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(time, byteList) {
    this.logger.time = time;
    for (let i = 0; i < byteList.length; i += 2) {
      const a = byteList[i] & 0x7f;
      const b = byteList[i + 1] & 0x7f;
      let cmdFound = false;
      let charsFound = null;
      if (a === 0 && b === 0) {
        continue;
      } else {
        this.logger.log(3, () => '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
      }
      const cmdHistory = this.cmdHistory;
      const isControlCode = a >= 0x10 && a <= 0x1f;
      if (isControlCode) {
        // Skip redundant control codes
        if (hasCmdRepeated(a, b, cmdHistory)) {
          setLastCmd(null, null, cmdHistory);
          this.logger.log(3, () => 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
          continue;
        }
        setLastCmd(a, b, this.cmdHistory);
        cmdFound = this.parseCmd(a, b);
        if (!cmdFound) {
          cmdFound = this.parseMidrow(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parsePAC(a, b);
        }
        if (!cmdFound) {
          cmdFound = this.parseBackgroundAttributes(a, b);
        }
      } else {
        setLastCmd(null, null, cmdHistory);
      }
      if (!cmdFound) {
        charsFound = this.parseChars(a, b);
        if (charsFound) {
          const currChNr = this.currentChannel;
          if (currChNr && currChNr > 0) {
            const channel = this.channels[currChNr];
            channel.insertChars(charsFound);
          } else {
            this.logger.log(2, 'No channel found yet. TEXT-MODE?');
          }
        }
      }
      if (!cmdFound && !charsFound) {
        this.logger.log(2, () => "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
      }
    }
  }

  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(a, b) {
    const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
    const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
    if (!(cond1 || cond2)) {
      return false;
    }
    const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
      if (b === 0x20) {
        channel.ccRCL();
      } else if (b === 0x21) {
        channel.ccBS();
      } else if (b === 0x22) {
        channel.ccAOF();
      } else if (b === 0x23) {
        channel.ccAON();
      } else if (b === 0x24) {
        channel.ccDER();
      } else if (b === 0x25) {
        channel.ccRU(2);
      } else if (b === 0x26) {
        channel.ccRU(3);
      } else if (b === 0x27) {
        channel.ccRU(4);
      } else if (b === 0x28) {
        channel.ccFON();
      } else if (b === 0x29) {
        channel.ccRDC();
      } else if (b === 0x2a) {
        channel.ccTR();
      } else if (b === 0x2b) {
        channel.ccRTD();
      } else if (b === 0x2c) {
        channel.ccEDM();
      } else if (b === 0x2d) {
        channel.ccCR();
      } else if (b === 0x2e) {
        channel.ccENM();
      } else if (b === 0x2f) {
        channel.ccEOC();
      }
    } else {
      // a == 0x17 || a == 0x1F
      channel.ccTO(b - 0x20);
    }
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Parse midrow styling command
   */
  parseMidrow(a, b) {
    let chNr = 0;
    if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
      if (a === 0x11) {
        chNr = 1;
      } else {
        chNr = 2;
      }
      if (chNr !== this.currentChannel) {
        this.logger.log(0, 'Mismatch channel in midrow parsing');
        return false;
      }
      const channel = this.channels[chNr];
      if (!channel) {
        return false;
      }
      channel.ccMIDROW(b);
      this.logger.log(3, () => 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
      return true;
    }
    return false;
  }

  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(a, b) {
    let row;
    const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
    const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
    if (!(case1 || case2)) {
      return false;
    }
    const chNr = a <= 0x17 ? 1 : 2;
    if (b >= 0x40 && b <= 0x5f) {
      row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
    } else {
      // 0x60 <= b <= 0x7F
      row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
    }
    const channel = this.channels[chNr];
    if (!channel) {
      return false;
    }
    channel.setPAC(this.interpretPAC(row, b));
    this.currentChannel = chNr;
    return true;
  }

  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(row, byte) {
    let pacIndex;
    const pacData = {
      color: null,
      italics: false,
      indent: null,
      underline: false,
      row: row
    };
    if (byte > 0x5f) {
      pacIndex = byte - 0x60;
    } else {
      pacIndex = byte - 0x40;
    }
    pacData.underline = (pacIndex & 1) === 1;
    if (pacIndex <= 0xd) {
      pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
    } else if (pacIndex <= 0xf) {
      pacData.italics = true;
      pacData.color = 'white';
    } else {
      pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
    }
    return pacData; // Note that row has zero offset. The spec uses 1.
  }

  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(a, b) {
    let channelNr;
    let charCodes = null;
    let charCode1 = null;
    if (a >= 0x19) {
      channelNr = 2;
      charCode1 = a - 8;
    } else {
      channelNr = 1;
      charCode1 = a;
    }
    if (charCode1 >= 0x11 && charCode1 <= 0x13) {
      // Special character
      let oneCode;
      if (charCode1 === 0x11) {
        oneCode = b + 0x50;
      } else if (charCode1 === 0x12) {
        oneCode = b + 0x70;
      } else {
        oneCode = b + 0x90;
      }
      this.logger.log(2, () => "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
      charCodes = [oneCode];
    } else if (a >= 0x20 && a <= 0x7f) {
      charCodes = b === 0 ? [a] : [a, b];
    }
    if (charCodes) {
      this.logger.log(3, () => 'Char codes =  ' + numArrayToHexArray(charCodes).join(','));
    }
    return charCodes;
  }

  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(a, b) {
    const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
    const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
    if (!(case1 || case2)) {
      return false;
    }
    let index;
    const bkgData = {};
    if (a === 0x10 || a === 0x18) {
      index = Math.floor((b - 0x20) / 2);
      bkgData.background = backgroundColors[index];
      if (b % 2 === 1) {
        bkgData.background = bkgData.background + '_semi';
      }
    } else if (b === 0x2d) {
      bkgData.background = 'transparent';
    } else {
      bkgData.foreground = 'black';
      if (b === 0x2f) {
        bkgData.underline = true;
      }
    }
    const chNr = a <= 0x17 ? 1 : 2;
    const channel = this.channels[chNr];
    channel.setBkgData(bkgData);
    return true;
  }

  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let i = 0; i < Object.keys(this.channels).length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.reset();
      }
    }
    setLastCmd(null, null, this.cmdHistory);
  }

  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(t) {
    for (let i = 0; i < this.channels.length; i++) {
      const channel = this.channels[i];
      if (channel) {
        channel.cueSplitAtTime(t);
      }
    }
  }
}
function setLastCmd(a, b, cmdHistory) {
  cmdHistory.a = a;
  cmdHistory.b = b;
}
function hasCmdRepeated(a, b, cmdHistory) {
  return cmdHistory.a === a && cmdHistory.b === b;
}
function createCmdHistory() {
  return {
    a: null,
    b: null
  };
}

class OutputFilter {
  constructor(timelineController, trackName) {
    this.timelineController = void 0;
    this.cueRanges = [];
    this.trackName = void 0;
    this.startTime = null;
    this.endTime = null;
    this.screen = null;
    this.timelineController = timelineController;
    this.trackName = trackName;
  }
  dispatchCue() {
    if (this.startTime === null) {
      return;
    }
    this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
    this.startTime = null;
  }
  newCue(startTime, endTime, screen) {
    if (this.startTime === null || this.startTime > startTime) {
      this.startTime = startTime;
    }
    this.endTime = endTime;
    this.screen = screen;
    this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [];
    this.startTime = null;
  }
}

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var VTTCue = (function () {
  if (optionalSelf != null && optionalSelf.VTTCue) {
    return self.VTTCue;
  }
  const AllowedDirections = ['', 'lr', 'rl'];
  const AllowedAlignments = ['start', 'middle', 'end', 'left', 'right'];
  function isAllowedValue(allowed, value) {
    if (typeof value !== 'string') {
      return false;
    }
    // necessary for assuring the generic conforms to the Array interface
    if (!Array.isArray(allowed)) {
      return false;
    }
    // reset the type so that the next narrowing works well
    const lcValue = value.toLowerCase();
    // use the allow list to narrow the type to a specific subset of strings
    if (~allowed.indexOf(lcValue)) {
      return lcValue;
    }
    return false;
  }
  function findDirectionSetting(value) {
    return isAllowedValue(AllowedDirections, value);
  }
  function findAlignSetting(value) {
    return isAllowedValue(AllowedAlignments, value);
  }
  function extend(obj, ...rest) {
    let i = 1;
    for (; i < arguments.length; i++) {
      const cobj = arguments[i];
      for (const p in cobj) {
        obj[p] = cobj[p];
      }
    }
    return obj;
  }
  function VTTCue(startTime, endTime, text) {
    const cue = this;
    const baseObj = {
      enumerable: true
    };
    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    let _id = '';
    let _pauseOnExit = false;
    let _startTime = startTime;
    let _endTime = endTime;
    let _text = text;
    let _region = null;
    let _vertical = '';
    let _snapToLines = true;
    let _line = 'auto';
    let _lineAlign = 'start';
    let _position = 50;
    let _positionAlign = 'middle';
    let _size = 50;
    let _align = 'middle';
    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function () {
        return _id;
      },
      set: function (value) {
        _id = '' + value;
      }
    }));
    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function () {
        return _pauseOnExit;
      },
      set: function (value) {
        _pauseOnExit = !!value;
      }
    }));
    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function () {
        return _startTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function () {
        return _endTime;
      },
      set: function (value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function () {
        return _text;
      },
      set: function (value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    // todo: implement VTTRegion polyfill?
    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function () {
        return _region;
      },
      set: function (value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function () {
        return _vertical;
      },
      set: function (value) {
        const setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function () {
        return _snapToLines;
      },
      set: function (value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function () {
        return _line;
      },
      set: function (value) {
        if (typeof value !== 'number' && value !== 'auto') {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function () {
        return _lineAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function () {
        return _position;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function () {
        return _positionAlign;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function () {
        return _size;
      },
      set: function (value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));
    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function () {
        return _align;
      },
      set: function (value) {
        const setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    const WebVTT = self.WebVTT;
    return WebVTT.convertCueToDOMTree(self, this.text);
  };
  // this is a polyfill hack
  return VTTCue;
})();

/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */

class StringDecoder {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(data, options) {
    if (!data) {
      return '';
    }
    if (typeof data !== 'string') {
      throw new Error('Error - expected string data.');
    }
    return decodeURIComponent(encodeURIComponent(data));
  }
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
  }
  const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  if (!m) {
    return null;
  }
  if (parseFloat(m[2]) > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
  }
  // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
  return computeSeconds(m[1], m[2], m[3], m[4]);
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class Settings {
  constructor() {
    this.values = Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  }
  // Check whether we have a value for a key.
  has(k) {
    return k in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(k, v, a) {
    for (let n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  }
  // Accept a setting if its a valid percentage.
  percent(k, v) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
      const percent = parseFloat(v);
      if (percent >= 0 && percent <= 100) {
        this.set(k, percent);
        return true;
      }
    }
    return false;
  }
}

// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  const groups = groupDelim ? input.split(groupDelim) : [input];
  for (const i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    const kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    const k = kv[0];
    const v = kv[1];
    callback(k, v);
  }
}
const defaults = new VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const center = defaults.align === 'middle' ? 'middle' : 'center';
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  const oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    const ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }

    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    const settings = new Settings();
    parseOptions(input, function (k, v) {
      let vals;
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (let i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          vals = v.split(',');
          settings.integer(k, vals[0]);
          if (settings.percent(k, vals[0])) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals[0], ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    let line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    let position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.slice(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.slice(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}
function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}
class VTTParser {
  constructor() {
    this.state = 'INITIAL';
    this.buffer = '';
    this.decoder = new StringDecoder();
    this.regionList = [];
    this.cue = null;
    this.oncue = void 0;
    this.onparsingerror = void 0;
    this.onflush = void 0;
  }
  parse(data) {
    const _this = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      _this.buffer += _this.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      let buffer = _this.buffer;
      let pos = 0;
      buffer = fixLineBreaks(buffer);
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      const line = buffer.slice(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      _this.buffer = buffer.slice(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        // switch (k) {
        // case 'region':
        // 3.3 WebVTT region metadata header syntax
        // console.log('parse region', v);
        // parseRegion(v);
        // break;
        // }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      let line = '';
      if (_this.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        line = collectNextLine();
        // strip of UTF-8 BOM if any
        // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
        const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(m != null && m[0])) {
          throw new Error('Malformed WebVTT signature.');
        }
        _this.state = 'HEADER';
      }
      let alreadyCollectedLine = false;
      while (_this.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(_this.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (_this.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              _this.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              _this.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              _this.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            _this.cue = new VTTCue(0, 0, '');
            _this.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              _this.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case 'CUE':
            // 40 - Collect cue timings and settings.
            if (!_this.cue) {
              _this.state = 'BADCUE';
              continue;
            }
            try {
              parseCue(line, _this.cue, _this.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              _this.cue = null;
              _this.state = 'BADCUE';
              continue;
            }
            _this.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            {
              const hasSubstring = line.indexOf('-->') !== -1;
              // 34 - If we have an empty line then report the cue.
              // 35 - If we have the special substring '-->' then report the cue,
              // but do not collect the line as we need to process the current
              // one as a new cue.
              if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                // We are done parsing self cue.
                if (_this.oncue && _this.cue) {
                  _this.oncue(_this.cue);
                }
                _this.cue = null;
                _this.state = 'ID';
                continue;
              }
              if (_this.cue === null) {
                continue;
              }
              if (_this.cue.text) {
                _this.cue.text += '\n';
              }
              _this.cue.text += line;
            }
            continue;
          case 'BADCUE':
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              _this.state = 'ID';
            }
        }
      }
    } catch (e) {
      // If we are currently parsing a cue, report what we have.
      if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) {
        _this.oncue(_this.cue);
      }
      _this.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  }
  flush() {
    const _this = this;
    try {
      // Finish decoding the stream.
      // _this.buffer += _this.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (_this.cue || _this.state === 'HEADER') {
        _this.buffer += '\n\n';
        _this.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      if (_this.onparsingerror) {
        _this.onparsingerror(e);
      }
    }
    if (_this.onflush) {
      _this.onflush();
    }
    return this;
  }
}

const LINEBREAKS = /\r\n|\n\r|\n|\r/g;

// String.prototype.startsWith is not supported in IE11
const startsWith = function startsWith(inputString, searchString, position = 0) {
  return inputString.slice(position, position + searchString.length) === searchString;
};
const cueString2millis = function cueString2millis(timeString) {
  let ts = parseInt(timeString.slice(-3));
  const secs = parseInt(timeString.slice(-6, -4));
  const mins = parseInt(timeString.slice(-9, -7));
  const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
  if (!isFiniteNumber(ts) || !isFiniteNumber(secs) || !isFiniteNumber(mins) || !isFiniteNumber(hours)) {
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
  }
  ts += 1000 * secs;
  ts += 60 * 1000 * mins;
  ts += 60 * 60 * 1000 * hours;
  return ts;
};

// From https://github.com/darkskyapp/string-hash
const hash = function hash(text) {
  let _hash = 5381;
  let i = text.length;
  while (i) {
    _hash = _hash * 33 ^ text.charCodeAt(--i);
  }
  return (_hash >>> 0).toString();
};

// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function generateCueId(startTime, endTime, text) {
  return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
}
const calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
  let currCC = vttCCs[cc];
  let prevCC = vttCCs[currCC.prevCC];

  // This is the first discontinuity or cues have been processed since the last discontinuity
  // Offset = current discontinuity time
  if (!prevCC || !prevCC.new && currCC.new) {
    vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
    currCC.new = false;
    return;
  }

  // There have been discontinuities since cues were last parsed.
  // Offset = time elapsed
  while ((_prevCC = prevCC) != null && _prevCC.new) {
    var _prevCC;
    vttCCs.ccOffset += currCC.start - prevCC.start;
    currCC.new = false;
    currCC = prevCC;
    prevCC = vttCCs[currCC.prevCC];
  }
  vttCCs.presentationOffset = presentationTime;
};
function parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
  const parser = new VTTParser();
  // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
  // Uint8Array.prototype.reduce is not implemented in IE11
  const vttLines = utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, '\n').split('\n');
  const cues = [];
  const init90kHz = initPTS ? toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
  let cueTime = '00:00.000';
  let timestampMapMPEGTS = 0;
  let timestampMapLOCAL = 0;
  let parsingError;
  let inHeader = true;
  parser.oncue = function (cue) {
    // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
    const currCC = vttCCs[cc];
    let cueOffset = vttCCs.ccOffset;

    // Calculate subtitle PTS offset
    const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;

    // Update offsets for new discontinuities
    if (currCC != null && currCC.new) {
      if (timestampMapLOCAL !== undefined) {
        // When local time is provided, offset = discontinuity start time - local time
        cueOffset = vttCCs.ccOffset = currCC.start;
      } else {
        calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
      }
    }
    if (webVttMpegTsMapOffset) {
      if (!initPTS) {
        parsingError = new Error('Missing initPTS for VTT MPEGTS');
        return;
      }
      // If we have MPEGTS, offset = presentation time + discontinuity offset
      cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
    }
    const duration = cue.endTime - cue.startTime;
    const startTime = normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
    cue.startTime = Math.max(startTime, 0);
    cue.endTime = Math.max(startTime + duration, 0);

    //trim trailing webvtt block whitespaces
    const text = cue.text.trim();

    // Fix encoding of special characters
    cue.text = decodeURIComponent(encodeURIComponent(text));

    // If the cue was not assigned an id from the VTT file (line above the content), create one.
    if (!cue.id) {
      cue.id = generateCueId(cue.startTime, cue.endTime, text);
    }
    if (cue.endTime > 0) {
      cues.push(cue);
    }
  };
  parser.onparsingerror = function (error) {
    parsingError = error;
  };
  parser.onflush = function () {
    if (parsingError) {
      errorCallBack(parsingError);
      return;
    }
    callBack(cues);
  };

  // Go through contents line by line.
  vttLines.forEach(line => {
    if (inHeader) {
      // Look for X-TIMESTAMP-MAP in header.
      if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
        // Once found, no more are allowed anyway, so stop searching.
        inHeader = false;
        // Extract LOCAL and MPEGTS.
        line.slice(16).split(',').forEach(timestamp => {
          if (startsWith(timestamp, 'LOCAL:')) {
            cueTime = timestamp.slice(6);
          } else if (startsWith(timestamp, 'MPEGTS:')) {
            timestampMapMPEGTS = parseInt(timestamp.slice(7));
          }
        });
        try {
          // Convert cue time to seconds
          timestampMapLOCAL = cueString2millis(cueTime) / 1000;
        } catch (error) {
          parsingError = error;
        }
        // Return without parsing X-TIMESTAMP-MAP line.
        return;
      } else if (line === '') {
        inHeader = false;
      }
    }
    // Parse line by default.
    parser.parse(line + '\n');
  });
  parser.flush();
}

const IMSC1_CODEC = 'stpp.ttml.im1t';

// Time format: h:m:s:frames(.subframes)
const HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;

// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const textAlignToLineAlign = {
  left: 'start',
  center: 'center',
  right: 'end',
  start: 'start',
  end: 'end'
};
function parseIMSC1(payload, initPTS, callBack, errorCallBack) {
  const results = findBox(new Uint8Array(payload), ['mdat']);
  if (results.length === 0) {
    errorCallBack(new Error('Could not parse IMSC1 mdat'));
    return;
  }
  const ttmlList = results.map(mdat => utf8ArrayToStr(mdat));
  const syncTime = toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
  try {
    ttmlList.forEach(ttml => callBack(parseTTML(ttml, syncTime)));
  } catch (error) {
    errorCallBack(error);
  }
}
function parseTTML(ttml, syncTime) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(ttml, 'text/xml');
  const tt = xmlDoc.getElementsByTagName('tt')[0];
  if (!tt) {
    throw new Error('Invalid ttml');
  }
  const defaultRateInfo = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  };
  const rateInfo = Object.keys(defaultRateInfo).reduce((result, key) => {
    result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
    return result;
  }, {});
  const trim = tt.getAttribute('xml:space') !== 'preserve';
  const styleElements = collectionToDictionary(getElementCollection(tt, 'styling', 'style'));
  const regionElements = collectionToDictionary(getElementCollection(tt, 'layout', 'region'));
  const cueElements = getElementCollection(tt, 'body', '[begin]');
  return [].map.call(cueElements, cueElement => {
    const cueText = getTextContent(cueElement, trim);
    if (!cueText || !cueElement.hasAttribute('begin')) {
      return null;
    }
    const startTime = parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
    const duration = parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
    let endTime = parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
    if (startTime === null) {
      throw timestampParsingError(cueElement);
    }
    if (endTime === null) {
      if (duration === null) {
        throw timestampParsingError(cueElement);
      }
      endTime = startTime + duration;
    }
    const cue = new VTTCue(startTime - syncTime, endTime - syncTime, cueText);
    cue.id = generateCueId(cue.startTime, cue.endTime, cue.text);
    const region = regionElements[cueElement.getAttribute('region')];
    const style = styleElements[cueElement.getAttribute('style')];

    // Apply styles to cue
    const styles = getTtmlStyles(region, style, styleElements);
    const {
      textAlign
    } = styles;
    if (textAlign) {
      // cue.positionAlign not settable in FF~2016
      const lineAlign = textAlignToLineAlign[textAlign];
      if (lineAlign) {
        cue.lineAlign = lineAlign;
      }
      cue.align = textAlign;
    }
    _extends(cue, styles);
    return cue;
  }).filter(cue => cue !== null);
}
function getElementCollection(fromElement, parentName, childName) {
  const parent = fromElement.getElementsByTagName(parentName)[0];
  if (parent) {
    return [].slice.call(parent.querySelectorAll(childName));
  }
  return [];
}
function collectionToDictionary(elementsWithId) {
  return elementsWithId.reduce((dict, element) => {
    const id = element.getAttribute('xml:id');
    if (id) {
      dict[id] = element;
    }
    return dict;
  }, {});
}
function getTextContent(element, trim) {
  return [].slice.call(element.childNodes).reduce((str, node, i) => {
    var _node$childNodes;
    if (node.nodeName === 'br' && i) {
      return str + '\n';
    }
    if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) {
      return getTextContent(node, trim);
    } else if (trim) {
      return str + node.textContent.trim().replace(/\s+/g, ' ');
    }
    return str + node.textContent;
  }, '');
}
function getTtmlStyles(region, style, styleElements) {
  const ttsNs = 'http://www.w3.org/ns/ttml#styling';
  let regionStyle = null;
  const styleAttributes = ['displayAlign', 'textAlign', 'color', 'backgroundColor', 'fontSize', 'fontFamily'
  // 'fontWeight',
  // 'lineHeight',
  // 'wrapOption',
  // 'fontStyle',
  // 'direction',
  // 'writingMode'
  ];
  const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
  if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) {
    regionStyle = styleElements[regionStyleName];
  }
  return styleAttributes.reduce((styles, name) => {
    const value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
    if (value) {
      styles[name] = value;
    }
    return styles;
  }, {});
}
function getAttributeNS(element, ns, name) {
  if (!element) {
    return null;
  }
  return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function timestampParsingError(node) {
  return new Error(`Could not parse ttml timestamp ${node}`);
}
function parseTtmlTime(timeAttributeValue, rateInfo) {
  if (!timeAttributeValue) {
    return null;
  }
  let seconds = parseTimeStamp(timeAttributeValue);
  if (seconds === null) {
    if (HMSF_REGEX.test(timeAttributeValue)) {
      seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
    } else if (TIME_UNIT_REGEX.test(timeAttributeValue)) {
      seconds = parseTimeUnits(timeAttributeValue, rateInfo);
    }
  }
  return seconds;
}
function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
  const m = HMSF_REGEX.exec(timeAttributeValue);
  const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
  return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function parseTimeUnits(timeAttributeValue, rateInfo) {
  const m = TIME_UNIT_REGEX.exec(timeAttributeValue);
  const value = Number(m[1]);
  const unit = m[2];
  switch (unit) {
    case 'h':
      return value * 3600;
    case 'm':
      return value * 60;
    case 'ms':
      return value * 1000;
    case 'f':
      return value / rateInfo.frameRate;
    case 't':
      return value / rateInfo.tickRate;
  }
  return value;
}

class TimelineController {
  constructor(hls) {
    this.hls = void 0;
    this.media = null;
    this.config = void 0;
    this.enabled = true;
    this.Cues = void 0;
    this.textTracks = [];
    this.tracks = [];
    this.initPTS = [];
    this.unparsedVttFrags = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.cea608Parser1 = void 0;
    this.cea608Parser2 = void 0;
    this.lastCc = -1;
    // Last video (CEA-608) fragment CC
    this.lastSn = -1;
    // Last video (CEA-608) fragment MSN
    this.lastPartIndex = -1;
    // Last video (CEA-608) fragment Part Index
    this.prevCC = -1;
    // Last subtitle fragment CC
    this.vttCCs = newVTTCCs();
    this.captionsProperties = void 0;
    this.hls = hls;
    this.config = hls.config;
    this.Cues = hls.config.cueHandler;
    this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    };
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.on(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.on(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.on(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.on(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.on(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.on(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.on(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
    hls.off(Events.FRAG_LOADING, this.onFragLoading, this);
    hls.off(Events.FRAG_LOADED, this.onFragLoaded, this);
    hls.off(Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
    hls.off(Events.FRAG_DECRYPTED, this.onFragDecrypted, this);
    hls.off(Events.INIT_PTS_FOUND, this.onInitPtsFound, this);
    hls.off(Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
    hls.off(Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
    // @ts-ignore
    this.hls = this.config = null;
    this.cea608Parser1 = this.cea608Parser2 = undefined;
  }
  initCea608Parsers() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const channel1 = new OutputFilter(this, 'textTrack1');
      const channel2 = new OutputFilter(this, 'textTrack2');
      const channel3 = new OutputFilter(this, 'textTrack3');
      const channel4 = new OutputFilter(this, 'textTrack4');
      this.cea608Parser1 = new Cea608Parser(1, channel1, channel2);
      this.cea608Parser2 = new Cea608Parser(3, channel3, channel4);
    }
  }
  addCues(trackName, startTime, endTime, screen, cueRanges) {
    // skip cues which overlap more than 50% with previously parsed time ranges
    let merged = false;
    for (let i = cueRanges.length; i--;) {
      const cueRange = cueRanges[i];
      const overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
      if (overlap >= 0) {
        cueRange[0] = Math.min(cueRange[0], startTime);
        cueRange[1] = Math.max(cueRange[1], endTime);
        merged = true;
        if (overlap / (endTime - startTime) > 0.5) {
          return;
        }
      }
    }
    if (!merged) {
      cueRanges.push([startTime, endTime]);
    }
    if (this.config.renderTextTracksNatively) {
      const track = this.captionsTracks[trackName];
      this.Cues.newCue(track, startTime, endTime, screen);
    } else {
      const cues = this.Cues.newCue(null, startTime, endTime, screen);
      this.hls.trigger(Events.CUES_PARSED, {
        type: 'captions',
        cues,
        track: trackName
      });
    }
  }

  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(event, {
    frag,
    id,
    initPTS,
    timescale
  }) {
    const {
      unparsedVttFrags
    } = this;
    if (id === 'main') {
      this.initPTS[frag.cc] = {
        baseTime: initPTS,
        timescale
      };
    }

    // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
    // Parse any unparsed fragments upon receiving the initial PTS.
    if (unparsedVttFrags.length) {
      this.unparsedVttFrags = [];
      unparsedVttFrags.forEach(frag => {
        this.onFragLoaded(Events.FRAG_LOADED, frag);
      });
    }
  }
  getExistingTrack(label, language) {
    const {
      media
    } = this;
    if (media) {
      for (let i = 0; i < media.textTracks.length; i++) {
        const textTrack = media.textTracks[i];
        if (canReuseVttTextTrack(textTrack, {
          name: label,
          lang: language,
          attrs: {}
        })) {
          return textTrack;
        }
      }
    }
    return null;
  }
  createCaptionsTrack(trackName) {
    if (this.config.renderTextTracksNatively) {
      this.createNativeTrack(trackName);
    } else {
      this.createNonNativeTrack(trackName);
    }
  }
  createNativeTrack(trackName) {
    if (this.captionsTracks[trackName]) {
      return;
    }
    const {
      captionsProperties,
      captionsTracks,
      media
    } = this;
    const {
      label,
      languageCode
    } = captionsProperties[trackName];
    // Enable reuse of existing text track.
    const existingTrack = this.getExistingTrack(label, languageCode);
    if (!existingTrack) {
      const textTrack = this.createTextTrack('captions', label, languageCode);
      if (textTrack) {
        // Set a special property on the track so we know it's managed by Hls.js
        textTrack[trackName] = true;
        captionsTracks[trackName] = textTrack;
      }
    } else {
      captionsTracks[trackName] = existingTrack;
      clearCurrentCues(captionsTracks[trackName]);
      sendAddTrackEvent(captionsTracks[trackName], media);
    }
  }
  createNonNativeTrack(trackName) {
    if (this.nonNativeCaptionsTracks[trackName]) {
      return;
    }
    // Create a list of a single track for the provider to consume
    const trackProperties = this.captionsProperties[trackName];
    if (!trackProperties) {
      return;
    }
    const label = trackProperties.label;
    const track = {
      _id: trackName,
      label,
      kind: 'captions',
      default: trackProperties.media ? !!trackProperties.media.default : false,
      closedCaptions: trackProperties.media
    };
    this.nonNativeCaptionsTracks[trackName] = track;
    this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [track]
    });
  }
  createTextTrack(kind, label, lang) {
    const media = this.media;
    if (!media) {
      return;
    }
    return media.addTextTrack(kind, label, lang);
  }
  onMediaAttaching(event, data) {
    this.media = data.media;
    this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks
    } = this;
    Object.keys(captionsTracks).forEach(trackName => {
      clearCurrentCues(captionsTracks[trackName]);
      delete captionsTracks[trackName];
    });
    this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    // Detect discontinuity in video fragment (CEA-608) parsing
    this.lastCc = -1;
    this.lastSn = -1;
    this.lastPartIndex = -1;
    // Detect discontinuity in subtitle manifests
    this.prevCC = -1;
    this.vttCCs = newVTTCCs();
    // Reset tracks
    this._cleanTracks();
    this.tracks = [];
    this.captionsTracks = {};
    this.nonNativeCaptionsTracks = {};
    this.textTracks = [];
    this.unparsedVttFrags = [];
    this.initPTS = [];
    if (this.cea608Parser1 && this.cea608Parser2) {
      this.cea608Parser1.reset();
      this.cea608Parser2.reset();
    }
  }
  _cleanTracks() {
    // clear outdated subtitles
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const textTracks = media.textTracks;
    if (textTracks) {
      for (let i = 0; i < textTracks.length; i++) {
        clearCurrentCues(textTracks[i]);
      }
    }
  }
  onSubtitleTracksUpdated(event, data) {
    const tracks = data.subtitleTracks || [];
    const hasIMSC1 = tracks.some(track => track.textCodec === IMSC1_CODEC);
    if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
      const listIsIdentical = subtitleOptionsIdentical(this.tracks, tracks);
      if (listIsIdentical) {
        this.tracks = tracks;
        return;
      }
      this.textTracks = [];
      this.tracks = tracks;
      if (this.config.renderTextTracksNatively) {
        const media = this.media;
        const inUseTracks = media ? filterSubtitleTracks(media.textTracks) : null;
        this.tracks.forEach((track, index) => {
          // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
          let textTrack;
          if (inUseTracks) {
            let inUseTrack = null;
            for (let i = 0; i < inUseTracks.length; i++) {
              if (inUseTracks[i] && canReuseVttTextTrack(inUseTracks[i], track)) {
                inUseTrack = inUseTracks[i];
                inUseTracks[i] = null;
                break;
              }
            }
            if (inUseTrack) {
              textTrack = inUseTrack;
            }
          }
          if (textTrack) {
            clearCurrentCues(textTrack);
          } else {
            const textTrackKind = captionsOrSubtitlesFromCharacteristics(track);
            textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
            if (textTrack) {
              textTrack.mode = 'disabled';
            }
          }
          if (textTrack) {
            this.textTracks.push(textTrack);
          }
        });
        // Warn when video element has captions or subtitle TextTracks carried over from another source
        if (inUseTracks != null && inUseTracks.length) {
          const unusedTextTracks = inUseTracks.filter(t => t !== null).map(t => t.label);
          if (unusedTextTracks.length) {
            logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
          }
        }
      } else if (this.tracks.length) {
        // Create a list of tracks for the provider to consume
        const tracksList = this.tracks.map(track => {
          return {
            label: track.name,
            kind: track.type.toLowerCase(),
            default: track.default,
            subtitleTrack: track
          };
        });
        this.hls.trigger(Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: tracksList
        });
      }
    }
  }
  onManifestLoaded(event, data) {
    if (this.config.enableCEA708Captions && data.captions) {
      data.captions.forEach(captionsTrack => {
        const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
        if (!instreamIdMatch) {
          return;
        }
        const trackName = `textTrack${instreamIdMatch[1]}`;
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) {
          return;
        }
        trackProperties.label = captionsTrack.name;
        if (captionsTrack.lang) {
          // optional attribute
          trackProperties.languageCode = captionsTrack.lang;
        }
        trackProperties.media = captionsTrack;
      });
    }
  }
  closedCaptionsForLevel(frag) {
    const level = this.hls.levels[frag.level];
    return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
  }
  onFragLoading(event, data) {
    // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
    if (this.enabled && data.frag.type === PlaylistLevelType.MAIN) {
      var _data$part$index, _data$part;
      const {
        cea608Parser1,
        cea608Parser2,
        lastSn
      } = this;
      const {
        cc,
        sn
      } = data.frag;
      const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
      if (cea608Parser1 && cea608Parser2) {
        if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
          cea608Parser1.reset();
          cea608Parser2.reset();
        }
      }
      this.lastCc = cc;
      this.lastSn = sn;
      this.lastPartIndex = partIndex;
    }
  }
  onFragLoaded(event, data) {
    const {
      frag,
      payload
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      // If fragment is subtitle type, parse as WebVTT.
      if (payload.byteLength) {
        const decryptData = frag.decryptdata;
        // fragment after decryption has a stats object
        const decrypted = ('stats' in data);
        // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
        if (decryptData == null || !decryptData.encrypted || decrypted) {
          const trackPlaylistMedia = this.tracks[frag.level];
          const vttCCs = this.vttCCs;
          if (!vttCCs[frag.cc]) {
            vttCCs[frag.cc] = {
              start: frag.start,
              prevCC: this.prevCC,
              new: true
            };
            this.prevCC = frag.cc;
          }
          if (trackPlaylistMedia && trackPlaylistMedia.textCodec === IMSC1_CODEC) {
            this._parseIMSC1(frag, payload);
          } else {
            this._parseVTTs(data);
          }
        }
      } else {
        // In case there is no payload, finish unsuccessfully.
        this.hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
          success: false,
          frag,
          error: new Error('Empty subtitle payload')
        });
      }
    }
  }
  _parseIMSC1(frag, payload) {
    const hls = this.hls;
    parseIMSC1(payload, this.initPTS[frag.cc], cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      logger.log(`Failed to parse IMSC1: ${error}`);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _parseVTTs(data) {
    var _frag$initSegment;
    const {
      frag,
      payload
    } = data;
    // We need an initial synchronisation PTS. Store fragments as long as none has arrived
    const {
      initPTS,
      unparsedVttFrags
    } = this;
    const maxAvCC = initPTS.length - 1;
    if (!initPTS[frag.cc] && maxAvCC === -1) {
      unparsedVttFrags.push(data);
      return;
    }
    const hls = this.hls;
    // Parse the WebVTT file contents.
    const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? appendUint8Array(frag.initSegment.data, new Uint8Array(payload)) : payload;
    parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, cues => {
      this._appendCues(cues, frag.level);
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: true,
        frag: frag
      });
    }, error => {
      const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
      if (missingInitPTS) {
        unparsedVttFrags.push(data);
      } else {
        this._fallbackToIMSC1(frag, payload);
      }
      // Something went wrong while parsing. Trigger event with success false.
      logger.log(`Failed to parse VTT cue: ${error}`);
      if (missingInitPTS && maxAvCC > frag.cc) {
        return;
      }
      hls.trigger(Events.SUBTITLE_FRAG_PROCESSED, {
        success: false,
        frag: frag,
        error
      });
    });
  }
  _fallbackToIMSC1(frag, payload) {
    // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
    const trackPlaylistMedia = this.tracks[frag.level];
    if (!trackPlaylistMedia.textCodec) {
      parseIMSC1(payload, this.initPTS[frag.cc], () => {
        trackPlaylistMedia.textCodec = IMSC1_CODEC;
        this._parseIMSC1(frag, payload);
      }, () => {
        trackPlaylistMedia.textCodec = 'wvtt';
      });
    }
  }
  _appendCues(cues, fragLevel) {
    const hls = this.hls;
    if (this.config.renderTextTracksNatively) {
      const textTrack = this.textTracks[fragLevel];
      // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
      // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
      // and trying to access getCueById method of cues will throw an exception
      // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
      if (!textTrack || textTrack.mode === 'disabled') {
        return;
      }
      cues.forEach(cue => addCueToTrack(textTrack, cue));
    } else {
      const currentTrack = this.tracks[fragLevel];
      if (!currentTrack) {
        return;
      }
      const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
      hls.trigger(Events.CUES_PARSED, {
        type: 'subtitles',
        cues,
        track
      });
    }
  }
  onFragDecrypted(event, data) {
    const {
      frag
    } = data;
    if (frag.type === PlaylistLevelType.SUBTITLE) {
      this.onFragLoaded(Events.FRAG_LOADED, data);
    }
  }
  onSubtitleTracksCleared() {
    this.tracks = [];
    this.captionsTracks = {};
  }
  onFragParsingUserdata(event, data) {
    this.initCea608Parsers();
    const {
      cea608Parser1,
      cea608Parser2
    } = this;
    if (!this.enabled || !cea608Parser1 || !cea608Parser2) {
      return;
    }
    const {
      frag,
      samples
    } = data;
    if (frag.type === PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') {
      return;
    }
    // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
    // It will create the proper timestamps based on the PTS value
    for (let i = 0; i < samples.length; i++) {
      const ccBytes = samples[i].bytes;
      if (ccBytes) {
        const ccdatas = this.extractCea608Data(ccBytes);
        cea608Parser1.addData(samples[i].pts, ccdatas[0]);
        cea608Parser2.addData(samples[i].pts, ccdatas[1]);
      }
    }
  }
  onBufferFlushing(event, {
    startOffset,
    endOffset,
    endOffsetSubtitles,
    type
  }) {
    const {
      media
    } = this;
    if (!media || media.currentTime < endOffset) {
      return;
    }
    // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
    // Forward cues are never removed because we can loose streamed 608 content from recent fragments
    if (!type || type === 'video') {
      const {
        captionsTracks
      } = this;
      Object.keys(captionsTracks).forEach(trackName => removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
    }
    if (this.config.renderTextTracksNatively) {
      // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
      if (startOffset === 0 && endOffsetSubtitles !== undefined) {
        const {
          textTracks
        } = this;
        Object.keys(textTracks).forEach(trackName => removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
      }
    }
  }
  extractCea608Data(byteArray) {
    const actualCCBytes = [[], []];
    const count = byteArray[0] & 0x1f;
    let position = 2;
    for (let j = 0; j < count; j++) {
      const tmpByte = byteArray[position++];
      const ccbyte1 = 0x7f & byteArray[position++];
      const ccbyte2 = 0x7f & byteArray[position++];
      if (ccbyte1 === 0 && ccbyte2 === 0) {
        continue;
      }
      const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
      if (ccValid) {
        const ccType = 0x03 & tmpByte;
        if (0x00 /* CEA608 field1*/ === ccType || 0x01 /* CEA608 field2*/ === ccType) {
          // Exclude CEA708 CC data.
          actualCCBytes[ccType].push(ccbyte1);
          actualCCBytes[ccType].push(ccbyte2);
        }
      }
    }
    return actualCCBytes;
  }
}
function captionsOrSubtitlesFromCharacteristics(track) {
  if (track.characteristics) {
    if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) {
      return 'captions';
    }
  }
  return 'subtitles';
}
function canReuseVttTextTrack(inUseTrack, manifestTrack) {
  return !!inUseTrack && inUseTrack.kind === captionsOrSubtitlesFromCharacteristics(manifestTrack) && subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}
function newVTTCCs() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: true
    }
  };
}

class CapLevelController {
  constructor(hls) {
    this.hls = void 0;
    this.autoLevelCapping = void 0;
    this.firstLevel = void 0;
    this.media = void 0;
    this.restrictedLevels = void 0;
    this.timer = void 0;
    this.clientRect = void 0;
    this.streamController = void 0;
    this.hls = hls;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    this.firstLevel = -1;
    this.media = null;
    this.restrictedLevels = [];
    this.timer = undefined;
    this.clientRect = null;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  destroy() {
    if (this.hls) {
      this.unregisterListener();
    }
    if (this.timer) {
      this.stopCapping();
    }
    this.media = null;
    this.clientRect = null;
    // @ts-ignore
    this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls
    } = this;
    hls.off(Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
    hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.BUFFER_CODECS, this.onBufferCodecs, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(event, data) {
    // Don't add a restricted level more than once
    const level = this.hls.levels[data.droppedLevel];
    if (this.isLevelAllowed(level)) {
      this.restrictedLevels.push({
        bitrate: level.bitrate,
        height: level.height,
        width: level.width
      });
    }
  }
  onMediaAttaching(event, data) {
    this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    this.clientRect = null;
    if (this.timer && this.hls.levels.length) {
      this.detectPlayerSize();
    }
  }
  onManifestParsed(event, data) {
    const hls = this.hls;
    this.restrictedLevels = [];
    this.firstLevel = data.firstLevel;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // Start capping immediately if the manifest has signaled video codecs
      this.startCapping();
    }
  }
  onLevelsUpdated(event, data) {
    if (this.timer && isFiniteNumber(this.autoLevelCapping)) {
      this.detectPlayerSize();
    }
  }

  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(event, data) {
    const hls = this.hls;
    if (hls.config.capLevelToPlayerSize && data.video) {
      // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
      this.startCapping();
    }
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const levels = this.hls.levels;
      if (levels.length) {
        const hls = this.hls;
        const maxLevel = this.getMaxLevel(levels.length - 1);
        if (maxLevel !== this.autoLevelCapping) {
          logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
        }
        hls.autoLevelCapping = maxLevel;
        if (hls.autoLevelCapping > this.autoLevelCapping && this.streamController) {
          // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
          // usually happen when the user go to the fullscreen mode.
          this.streamController.nextLevelSwitch();
        }
        this.autoLevelCapping = hls.autoLevelCapping;
      }
    }
  }

  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(capLevelIndex) {
    const levels = this.hls.levels;
    if (!levels.length) {
      return -1;
    }
    const validLevels = levels.filter((level, index) => this.isLevelAllowed(level) && index <= capLevelIndex);
    this.clientRect = null;
    return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    if (this.timer) {
      // Don't reset capping if started twice; this can happen if the manifest signals a video codec
      return;
    }
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    self.clearInterval(this.timer);
    this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
    this.detectPlayerSize();
  }
  stopCapping() {
    this.restrictedLevels = [];
    this.firstLevel = -1;
    this.autoLevelCapping = Number.POSITIVE_INFINITY;
    if (this.timer) {
      self.clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  getDimensions() {
    if (this.clientRect) {
      return this.clientRect;
    }
    const media = this.media;
    const boundsRect = {
      width: 0,
      height: 0
    };
    if (media) {
      const clientRect = media.getBoundingClientRect();
      boundsRect.width = clientRect.width;
      boundsRect.height = clientRect.height;
      if (!boundsRect.width && !boundsRect.height) {
        // When the media element has no width or height (equivalent to not being in the DOM),
        // then use its width and height attributes (media.width, media.height)
        boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
        boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
      }
    }
    this.clientRect = boundsRect;
    return boundsRect;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let pixelRatio = 1;
    if (!this.hls.config.ignoreDevicePixelRatio) {
      try {
        pixelRatio = self.devicePixelRatio;
      } catch (e) {
        /* no-op */
      }
    }
    return pixelRatio;
  }
  isLevelAllowed(level) {
    const restrictedLevels = this.restrictedLevels;
    return !restrictedLevels.some(restrictedLevel => {
      return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
    });
  }
  static getMaxLevelByMediaSize(levels, width, height) {
    if (!(levels != null && levels.length)) {
      return -1;
    }

    // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
    // to determine whether we've chosen the greatest bandwidth for the media's dimensions
    const atGreatestBandwidth = (curLevel, nextLevel) => {
      if (!nextLevel) {
        return true;
      }
      return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
    };

    // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
    // the max level
    let maxLevelIndex = levels.length - 1;
    // Prevent changes in aspect-ratio from causing capping to toggle back and forth
    const squareSize = Math.max(width, height);
    for (let i = 0; i < levels.length; i += 1) {
      const level = levels[i];
      if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
        maxLevelIndex = i;
        break;
      }
    }
    return maxLevelIndex;
  }
}

class FPSController {
  constructor(hls) {
    this.hls = void 0;
    this.isVideoPlaybackQualityAvailable = false;
    this.timer = void 0;
    this.media = null;
    this.lastTime = void 0;
    this.lastDroppedFrames = 0;
    this.lastDecodedFrames = 0;
    // stream controller must be provided as a dependency!
    this.streamController = void 0;
    this.hls = hls;
    this.registerListeners();
  }
  setStreamController(streamController) {
    this.streamController = streamController;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.unregisterListeners();
    this.isVideoPlaybackQualityAvailable = false;
    this.media = null;
  }
  onMediaAttaching(event, data) {
    const config = this.hls.config;
    if (config.capLevelOnFPSDrop) {
      const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
      this.media = media;
      if (media && typeof media.getVideoPlaybackQuality === 'function') {
        this.isVideoPlaybackQualityAvailable = true;
      }
      self.clearInterval(this.timer);
      this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(video, decodedFrames, droppedFrames) {
    const currentTime = performance.now();
    if (decodedFrames) {
      if (this.lastTime) {
        const currentPeriod = currentTime - this.lastTime;
        const currentDropped = droppedFrames - this.lastDroppedFrames;
        const currentDecoded = decodedFrames - this.lastDecodedFrames;
        const droppedFPS = 1000 * currentDropped / currentPeriod;
        const hls = this.hls;
        hls.trigger(Events.FPS_DROP, {
          currentDropped: currentDropped,
          currentDecoded: currentDecoded,
          totalDroppedFrames: droppedFrames
        });
        if (droppedFPS > 0) {
          // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
          if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
            let currentLevel = hls.currentLevel;
            logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
            if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
              currentLevel = currentLevel - 1;
              hls.trigger(Events.FPS_DROP_LEVEL_CAPPING, {
                level: currentLevel,
                droppedLevel: hls.currentLevel
              });
              hls.autoLevelCapping = currentLevel;
              this.streamController.nextLevelSwitch();
            }
          }
        }
      }
      this.lastTime = currentTime;
      this.lastDroppedFrames = droppedFrames;
      this.lastDecodedFrames = decodedFrames;
    }
  }
  checkFPSInterval() {
    const video = this.media;
    if (video) {
      if (this.isVideoPlaybackQualityAvailable) {
        const videoPlaybackQuality = video.getVideoPlaybackQuality();
        this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
      } else {
        // HTMLVideoElement doesn't include the webkit types
        this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
      }
    }
  }
}

const LOGGER_PREFIX = '[eme]';
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */
class EMEController {
  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = null;
    this.keyFormatPromise = null;
    this.keySystemAccessPromises = {};
    this._requestLicenseFailureCount = 0;
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    this.setMediaKeysQueue = EMEController.CDMCleanupPromise ? [EMEController.CDMCleanupPromise] : [];
    this.onMediaEncrypted = this._onMediaEncrypted.bind(this);
    this.onWaitingForKey = this._onWaitingForKey.bind(this);
    this.debug = logger.debug.bind(logger, LOGGER_PREFIX);
    this.log = logger.log.bind(logger, LOGGER_PREFIX);
    this.warn = logger.warn.bind(logger, LOGGER_PREFIX);
    this.error = logger.error.bind(logger, LOGGER_PREFIX);
    this.hls = hls;
    this.config = hls.config;
    this.registerListeners();
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.requestMediaKeySystemAccessFunc = null;
    config.licenseXhrSetup = config.licenseResponseCallback = undefined;
    config.drmSystems = config.drmSystemOptions = {};
    // @ts-ignore
    this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
    // @ts-ignore
    this.config = null;
  }
  registerListeners() {
    this.hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    this.hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    this.hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    this.hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(keySystem) {
    const {
      drmSystems,
      widevineLicenseUrl
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.licenseUrl;
    }

    // For backward compatibility
    if (keySystem === KeySystems.WIDEVINE && widevineLicenseUrl) {
      return widevineLicenseUrl;
    }
    throw new Error(`no license server URL configured for key-system "${keySystem}"`);
  }
  getServerCertificateUrl(keySystem) {
    const {
      drmSystems
    } = this.config;
    const keySystemConfiguration = drmSystems[keySystem];
    if (keySystemConfiguration) {
      return keySystemConfiguration.serverCertificateUrl;
    } else {
      this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
  }
  attemptKeySystemAccess(keySystemsToAttempt) {
    const levels = this.hls.levels;
    const uniqueCodec = (value, i, a) => !!value && a.indexOf(value) === i;
    const audioCodecs = levels.map(level => level.audioCodec).filter(uniqueCodec);
    const videoCodecs = levels.map(level => level.videoCodec).filter(uniqueCodec);
    if (audioCodecs.length + videoCodecs.length === 0) {
      videoCodecs.push('avc1.42e01e');
    }
    return new Promise((resolve, reject) => {
      const attempt = keySystems => {
        const keySystem = keySystems.shift();
        this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then(mediaKeys => resolve({
          keySystem,
          mediaKeys
        })).catch(error => {
          if (keySystems.length) {
            attempt(keySystems);
          } else if (error instanceof EMEKeyError) {
            reject(error);
          } else {
            reject(new EMEKeyError({
              type: ErrorTypes.KEY_SYSTEM_ERROR,
              details: ErrorDetails.KEY_SYSTEM_NO_ACCESS,
              error,
              fatal: true
            }, error.message));
          }
        });
      };
      attempt(keySystemsToAttempt);
    });
  }
  requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
    const {
      requestMediaKeySystemAccessFunc
    } = this.config;
    if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
      let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
      if (requestMediaKeySystemAccess === null && self.location.protocol === 'http:') {
        errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
      }
      return Promise.reject(new Error(errMessage));
    }
    return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
  }
  getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
    // This can throw, but is caught in event handler callpath
    const mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
    const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
    let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
    if (!keySystemAccess) {
      this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${JSON.stringify(mediaKeySystemConfigs)}`);
      keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
      const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
        keySystemAccess
      };
      keySystemAccess.catch(error => {
        this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
      });
      return keySystemAccess.then(mediaKeySystemAccess => {
        this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
        const certificateRequest = this.fetchServerCertificate(keySystem);
        this.log(`Create media-keys for "${keySystem}"`);
        _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then(mediaKeys => {
          this.log(`Media-keys created for "${keySystem}"`);
          return certificateRequest.then(certificate => {
            if (certificate) {
              return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
            }
            return mediaKeys;
          });
        });
        _keySystemAccessPromises.mediaKeys.catch(error => {
          this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
        });
        return _keySystemAccessPromises.mediaKeys;
      });
    }
    return keySystemAccess.then(() => keySystemAccessPromises.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata,
    keySystem,
    mediaKeys
  }) {
    this.log(`Creating key-system session "${keySystem}" keyId: ${Hex.hexDump(decryptdata.keyId || [])}`);
    const mediaKeysSession = mediaKeys.createSession();
    const mediaKeySessionContext = {
      decryptdata,
      keySystem,
      mediaKeys,
      mediaKeysSession,
      keyStatus: 'status-pending'
    };
    this.mediaKeySessions.push(mediaKeySessionContext);
    return mediaKeySessionContext;
  }
  renewKeySession(mediaKeySessionContext) {
    const decryptdata = mediaKeySessionContext.decryptdata;
    if (decryptdata.pssh) {
      const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
      const keyId = this.getKeyIdString(decryptdata);
      const scheme = 'cenc';
      this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'expired');
    } else {
      this.warn(`Could not renew expired session. Missing pssh initData.`);
    }
    this.removeSession(mediaKeySessionContext);
  }
  getKeyIdString(decryptdata) {
    if (!decryptdata) {
      throw new Error('Could not read keyId of undefined decryptdata');
    }
    if (decryptdata.keyId === null) {
      throw new Error('keyId is null');
    }
    return Hex.hexDump(decryptdata.keyId);
  }
  updateKeySession(mediaKeySessionContext, data) {
    var _mediaKeySessionConte;
    const keySession = mediaKeySessionContext.mediaKeysSession;
    this.log(`Updating key-session "${keySession.sessionId}" for keyID ${Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
    return keySession.update(data);
  }
  selectKeySystemFormat(frag) {
    const keyFormats = Object.keys(frag.levelkeys || {});
    if (!this.keyFormatPromise) {
      this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
    return this.keyFormatPromise;
  }
  getKeyFormatPromise(keyFormats) {
    return new Promise((resolve, reject) => {
      const keySystemsInConfig = getKeySystemsForConfig(this.config);
      const keySystemsToAttempt = keyFormats.map(keySystemFormatToKeySystemDomain).filter(value => !!value && keySystemsInConfig.indexOf(value) !== -1);
      return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({
        keySystem
      }) => {
        const keySystemFormat = keySystemDomainToKeySystemFormat(keySystem);
        if (keySystemFormat) {
          resolve(keySystemFormat);
        } else {
          reject(new Error(`Unable to find format for key-system "${keySystem}"`));
        }
      }).catch(reject);
    });
  }
  loadKey(data) {
    const decryptdata = data.keyInfo.decryptdata;
    const keyId = this.getKeyIdString(decryptdata);
    const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
    this.log(`Starting session for key ${keyDetails}`);
    let keySessionContextPromise = this.keyIdToKeySessionPromise[keyId];
    if (!keySessionContextPromise) {
      keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = this.getKeySystemForKeyPromise(decryptdata).then(({
        keySystem,
        mediaKeys
      }) => {
        this.throwIfDestroyed();
        this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            keySystem,
            mediaKeys,
            decryptdata
          });
          const scheme = 'cenc';
          return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh, 'playlist-key');
        });
      });
      keySessionContextPromise.catch(error => this.handleError(error));
    }
    return keySessionContextPromise;
  }
  throwIfDestroyed(message = 'Invalid state') {
    if (!this.hls) {
      throw new Error('invalid state');
    }
  }
  handleError(error) {
    if (!this.hls) {
      return;
    }
    this.error(error.message);
    if (error instanceof EMEKeyError) {
      this.hls.trigger(Events.ERROR, error.data);
    } else {
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_KEYS,
        error,
        fatal: true
      });
    }
  }
  getKeySystemForKeyPromise(decryptdata) {
    const keyId = this.getKeyIdString(decryptdata);
    const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
    if (!mediaKeySessionContext) {
      const keySystem = keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
      const keySystemsToAttempt = keySystem ? [keySystem] : getKeySystemsForConfig(this.config);
      return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    return mediaKeySessionContext;
  }
  getKeySystemSelectionPromise(keySystemsToAttempt) {
    if (!keySystemsToAttempt.length) {
      keySystemsToAttempt = getKeySystemsForConfig(this.config);
    }
    if (keySystemsToAttempt.length === 0) {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: true
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    }
    return this.attemptKeySystemAccess(keySystemsToAttempt);
  }
  _onMediaEncrypted(event) {
    const {
      initDataType,
      initData
    } = event;
    this.debug(`"${event.type}" event: init data type: "${initDataType}"`);

    // Ignore event when initData is null
    if (initData === null) {
      return;
    }
    let keyId;
    let keySystemDomain;
    if (initDataType === 'sinf' && this.config.drmSystems[KeySystems.FAIRPLAY]) {
      // Match sinf keyId to playlist skd://keyId=
      const json = bin2str(new Uint8Array(initData));
      try {
        const sinf = base64Decode(JSON.parse(json).sinf);
        const tenc = parseSinf(new Uint8Array(sinf));
        if (!tenc) {
          return;
        }
        keyId = tenc.subarray(8, 24);
        keySystemDomain = KeySystems.FAIRPLAY;
      } catch (error) {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      // Support clear-lead key-session creation (otherwise depend on playlist keys)
      const psshInfo = parsePssh(initData);
      if (psshInfo === null) {
        return;
      }
      if (psshInfo.version === 0 && psshInfo.systemId === KeySystemIds.WIDEVINE && psshInfo.data) {
        keyId = psshInfo.data.subarray(8, 24);
      }
      keySystemDomain = keySystemIdToKeySystemDomain(psshInfo.systemId);
    }
    if (!keySystemDomain || !keyId) {
      return;
    }
    const keyIdHex = Hex.hexDump(keyId);
    const {
      keyIdToKeySessionPromise,
      mediaKeySessions
    } = this;
    let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
    for (let i = 0; i < mediaKeySessions.length; i++) {
      // Match playlist key
      const keyContext = mediaKeySessions[i];
      const decryptdata = keyContext.decryptdata;
      if (decryptdata.pssh || !decryptdata.keyId) {
        continue;
      }
      const oldKeyIdHex = Hex.hexDump(decryptdata.keyId);
      if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
        keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
        delete keyIdToKeySessionPromise[oldKeyIdHex];
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(() => {
          return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
        });
        break;
      }
    }
    if (!keySessionContextPromise) {
      // Clear-lead key (not encountered in playlist)
      keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([keySystemDomain]).then(({
        keySystem,
        mediaKeys
      }) => {
        var _keySystemToKeySystem;
        this.throwIfDestroyed();
        const decryptdata = new LevelKey('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
        decryptdata.pssh = new Uint8Array(initData);
        decryptdata.keyId = keyId;
        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(() => {
          this.throwIfDestroyed();
          const keySessionContext = this.createMediaKeySessionContext({
            decryptdata,
            keySystem,
            mediaKeys
          });
          return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
        });
      });
    }
    keySessionContextPromise.catch(error => this.handleError(error));
  }
  _onWaitingForKey(event) {
    this.log(`"${event.type}" event`);
  }
  attemptSetMediaKeys(keySystem, mediaKeys) {
    const queue = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${keySystem}"`);
    // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
    // can be queued for execution for multiple key sessions.
    const setMediaKeysPromise = Promise.all(queue).then(() => {
      if (!this.media) {
        throw new Error('Attempted to set mediaKeys without media element attached');
      }
      return this.media.setMediaKeys(mediaKeys);
    });
    this.setMediaKeysQueue.push(setMediaKeysPromise);
    return setMediaKeysPromise.then(() => {
      this.log(`Media-keys set for "${keySystem}"`);
      queue.push(setMediaKeysPromise);
      this.setMediaKeysQueue = this.setMediaKeysQueue.filter(p => queue.indexOf(p) === -1);
    });
  }
  generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
    var _this$config$drmSyste, _this$config$drmSyste2;
    const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
    if (generateRequestFilter) {
      try {
        const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
        if (!mappedInitData) {
          throw new Error('Invalid response from configured generateRequest filter');
        }
        initDataType = mappedInitData.initDataType;
        initData = context.decryptdata.pssh = mappedInitData.initData ? new Uint8Array(mappedInitData.initData) : null;
      } catch (error) {
        var _this$hls;
        this.warn(error.message);
        if ((_this$hls = this.hls) != null && _this$hls.config.debug) {
          throw error;
        }
      }
    }
    if (initData === null) {
      this.log(`Skipping key-session request for "${reason}" (no initData)`);
      return Promise.resolve(context);
    }
    const keyId = this.getKeyIdString(context.decryptdata);
    this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
    const licenseStatus = new EventEmitter();
    const onmessage = context._onmessage = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      const {
        messageType,
        message
      } = event;
      this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
      if (messageType === 'license-request' || messageType === 'license-renewal') {
        this.renewLicense(context, message).catch(error => {
          this.handleError(error);
          licenseStatus.emit('error', error);
        });
      } else if (messageType === 'license-release') {
        if (context.keySystem === KeySystems.FAIRPLAY) {
          this.updateKeySession(context, strToUtf8array('acknowledged'));
          this.removeSession(context);
        }
      } else {
        this.warn(`unhandled media key message type "${messageType}"`);
      }
    };
    const onkeystatuseschange = context._onkeystatuseschange = event => {
      const keySession = context.mediaKeysSession;
      if (!keySession) {
        licenseStatus.emit('error', new Error('invalid state'));
        return;
      }
      this.onKeyStatusChange(context);
      const keyStatus = context.keyStatus;
      licenseStatus.emit('keyStatus', keyStatus);
      if (keyStatus === 'expired') {
        this.warn(`${context.keySystem} expired for key ${keyId}`);
        this.renewKeySession(context);
      }
    };
    context.mediaKeysSession.addEventListener('message', onmessage);
    context.mediaKeysSession.addEventListener('keystatuseschange', onkeystatuseschange);
    const keyUsablePromise = new Promise((resolve, reject) => {
      licenseStatus.on('error', reject);
      licenseStatus.on('keyStatus', keyStatus => {
        if (keyStatus.startsWith('usable')) {
          resolve();
        } else if (keyStatus === 'output-restricted') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
            fatal: false
          }, 'HDCP level output restricted'));
        } else if (keyStatus === 'internal-error') {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
            fatal: true
          }, `key status changed to "${keyStatus}"`));
        } else if (keyStatus === 'expired') {
          reject(new Error('key expired while generating request'));
        } else {
          this.warn(`unhandled key status change "${keyStatus}"`);
        }
      });
    });
    return context.mediaKeysSession.generateRequest(initDataType, initData).then(() => {
      var _context$mediaKeysSes;
      this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
    }).catch(error => {
      throw new EMEKeyError({
        type: ErrorTypes.KEY_SYSTEM_ERROR,
        details: ErrorDetails.KEY_SYSTEM_NO_SESSION,
        error,
        fatal: false
      }, `Error generating key-session request: ${error}`);
    }).then(() => keyUsablePromise).catch(error => {
      licenseStatus.removeAllListeners();
      this.removeSession(context);
      throw error;
    }).then(() => {
      licenseStatus.removeAllListeners();
      return context;
    });
  }
  onKeyStatusChange(mediaKeySessionContext) {
    mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status, keyId) => {
      this.log(`key status change "${status}" for keyStatuses keyId: ${Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
      mediaKeySessionContext.keyStatus = status;
    });
  }
  fetchServerCertificate(keySystem) {
    const config = this.config;
    const Loader = config.loader;
    const certLoader = new Loader(config);
    const url = this.getServerCertificateUrl(keySystem);
    if (!url) {
      return Promise.resolve();
    }
    this.log(`Fetching server certificate for "${keySystem}"`);
    return new Promise((resolve, reject) => {
      const loaderContext = {
        responseType: 'arraybuffer',
        url
      };
      const loadPolicy = config.certLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          resolve(response.data);
        },
        onError: (response, contex, networkDetails, stats) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: _objectSpread2({
              url: loaderContext.url,
              data: undefined
            }, response)
          }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
        },
        onTimeout: (stats, context, networkDetails) => {
          reject(new EMEKeyError({
            type: ErrorTypes.KEY_SYSTEM_ERROR,
            details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: true,
            networkDetails,
            response: {
              url: loaderContext.url,
              data: undefined
            }
          }, `"${keySystem}" certificate request timed out (${url})`));
        },
        onAbort: (stats, context, networkDetails) => {
          reject(new Error('aborted'));
        }
      };
      certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
    return new Promise((resolve, reject) => {
      mediaKeys.setServerCertificate(cert).then(success => {
        this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
        resolve(mediaKeys);
      }).catch(error => {
        reject(new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message));
      });
    });
  }
  renewLicense(context, keyMessage) {
    return this.requestLicense(context, new Uint8Array(keyMessage)).then(data => {
      return this.updateKeySession(context, new Uint8Array(data)).catch(error => {
        throw new EMEKeyError({
          type: ErrorTypes.KEY_SYSTEM_ERROR,
          details: ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
          error,
          fatal: true
        }, error.message);
      });
    });
  }
  unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
    // On Edge, the raw license message is UTF-16-encoded XML.  We need
    // to unpack the Challenge element (base64-encoded string containing the
    // actual license request) and any HttpHeader elements (sent as request
    // headers).
    // For PlayReady CDMs, we need to dig the Challenge out of the XML.
    const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
    if (!xmlString.includes('PlayReadyKeyMessage')) {
      // This does not appear to be a wrapped message as on Edge.  Some
      // clients do not need this unwrapping, so we will assume this is one of
      // them.  Note that "xml" at this point probably looks like random
      // garbage, since we interpreted UTF-8 as UTF-16.
      xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
      return licenseChallenge;
    }
    const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
    // Set request headers.
    const headers = keyMessageXml.querySelectorAll('HttpHeader');
    if (headers.length > 0) {
      let header;
      for (let i = 0, len = headers.length; i < len; i++) {
        var _header$querySelector, _header$querySelector2;
        header = headers[i];
        const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
        const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
        if (name && value) {
          xhr.setRequestHeader(name, value);
        }
      }
    }
    const challengeElement = keyMessageXml.querySelector('Challenge');
    const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
    if (!challengeText) {
      throw new Error(`Cannot find <Challenge> in key message`);
    }
    return strToUtf8array(atob(challengeText));
  }
  setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
    const licenseXhrSetup = this.config.licenseXhrSetup;
    if (!licenseXhrSetup) {
      xhr.open('POST', url, true);
      return Promise.resolve({
        xhr,
        licenseChallenge
      });
    }
    return Promise.resolve().then(() => {
      if (!keysListItem.decryptdata) {
        throw new Error('Key removed');
      }
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).catch(error => {
      if (!keysListItem.decryptdata) {
        // Key session removed. Cancel license request.
        throw error;
      }
      // let's try to open before running setup
      xhr.open('POST', url, true);
      return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
    }).then(licenseXhrSetupResult => {
      // if licenseXhrSetup did not yet call open, let's do it now
      if (!xhr.readyState) {
        xhr.open('POST', url, true);
      }
      const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
      return {
        xhr,
        licenseChallenge: finalLicenseChallenge
      };
    });
  }
  requestLicense(keySessionContext, licenseChallenge) {
    const keyLoadPolicy = this.config.keyLoadPolicy.default;
    return new Promise((resolve, reject) => {
      const url = this.getLicenseServerUrl(keySessionContext.keySystem);
      this.log(`Sending license request to URL: ${url}`);
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.onreadystatechange = () => {
        if (!this.hls || !keySessionContext.mediaKeysSession) {
          return reject(new Error('invalid state'));
        }
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this._requestLicenseFailureCount = 0;
            let data = xhr.response;
            this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
            const licenseResponseCallback = this.config.licenseResponseCallback;
            if (licenseResponseCallback) {
              try {
                data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
              } catch (error) {
                this.error(error);
              }
            }
            resolve(data);
          } else {
            const retryConfig = keyLoadPolicy.errorRetry;
            const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
            this._requestLicenseFailureCount++;
            if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) {
              reject(new EMEKeyError({
                type: ErrorTypes.KEY_SYSTEM_ERROR,
                details: ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: true,
                networkDetails: xhr,
                response: {
                  url,
                  data: undefined,
                  code: xhr.status,
                  text: xhr.statusText
                }
              }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
            } else {
              const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
              this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
            }
          }
        }
      };
      if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) {
        keySessionContext.licenseXhr.abort();
      }
      keySessionContext.licenseXhr = xhr;
      this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({
        xhr,
        licenseChallenge
      }) => {
        if (keySessionContext.keySystem == KeySystems.PLAYREADY) {
          licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
        }
        xhr.send(licenseChallenge);
      });
    });
  }
  onMediaAttached(event, data) {
    if (!this.config.emeEnabled) {
      return;
    }
    const media = data.media;

    // keep reference of media
    this.media = media;
    media.addEventListener('encrypted', this.onMediaEncrypted);
    media.addEventListener('waitingforkey', this.onWaitingForKey);
  }
  onMediaDetached() {
    const media = this.media;
    const mediaKeysList = this.mediaKeySessions;
    if (media) {
      media.removeEventListener('encrypted', this.onMediaEncrypted);
      media.removeEventListener('waitingforkey', this.onWaitingForKey);
      this.media = null;
    }
    this._requestLicenseFailureCount = 0;
    this.setMediaKeysQueue = [];
    this.mediaKeySessions = [];
    this.keyIdToKeySessionPromise = {};
    LevelKey.clearKeyUriToKeyIdMap();

    // Close all sessions and remove media keys from the video element.
    const keySessionCount = mediaKeysList.length;
    EMEController.CDMCleanupPromise = Promise.all(mediaKeysList.map(mediaKeySessionContext => this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : media.setMediaKeys(null).catch(error => {
      this.log(`Could not clear media keys: ${error}`);
    }))).then(() => {
      if (keySessionCount) {
        this.log('finished closing key sessions and clearing media keys');
        mediaKeysList.length = 0;
      }
    }).catch(error => {
      this.log(`Could not close sessions and clear media keys: ${error}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(event, {
    sessionKeys
  }) {
    if (!sessionKeys || !this.config.emeEnabled) {
      return;
    }
    if (!this.keyFormatPromise) {
      const keyFormats = sessionKeys.reduce((formats, sessionKey) => {
        if (formats.indexOf(sessionKey.keyFormat) === -1) {
          formats.push(sessionKey.keyFormat);
        }
        return formats;
      }, []);
      this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
      this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
    }
  }
  removeSession(mediaKeySessionContext) {
    const {
      mediaKeysSession,
      licenseXhr
    } = mediaKeySessionContext;
    if (mediaKeysSession) {
      this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
      if (mediaKeySessionContext._onmessage) {
        mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
        mediaKeySessionContext._onmessage = undefined;
      }
      if (mediaKeySessionContext._onkeystatuseschange) {
        mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
        mediaKeySessionContext._onkeystatuseschange = undefined;
      }
      if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) {
        licenseXhr.abort();
      }
      mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
      const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
      if (index > -1) {
        this.mediaKeySessions.splice(index, 1);
      }
      return mediaKeysSession.remove().catch(error => {
        this.log(`Could not remove session: ${error}`);
      }).then(() => {
        return mediaKeysSession.close();
      }).catch(error => {
        this.log(`Could not close session: ${error}`);
      });
    }
  }
}
EMEController.CDMCleanupPromise = void 0;
class EMEKeyError extends Error {
  constructor(data, message) {
    super(message);
    this.data = void 0;
    data.error || (data.error = new Error(message));
    this.data = data;
    data.err = data.error;
  }
}

/**
 * Common Media Object Type
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
var CmObjectType;
(function (CmObjectType) {
  /**
   * text file, such as a manifest or playlist
   */
  CmObjectType["MANIFEST"] = "m";
  /**
   * audio only
   */
  CmObjectType["AUDIO"] = "a";
  /**
   * video only
   */
  CmObjectType["VIDEO"] = "v";
  /**
   * muxed audio and video
   */
  CmObjectType["MUXED"] = "av";
  /**
   * init segment
   */
  CmObjectType["INIT"] = "i";
  /**
   * caption or subtitle
   */
  CmObjectType["CAPTION"] = "c";
  /**
   * ISOBMFF timed text track
   */
  CmObjectType["TIMED_TEXT"] = "tt";
  /**
   * cryptographic key, license or certificate.
   */
  CmObjectType["KEY"] = "k";
  /**
   * other
   */
  CmObjectType["OTHER"] = "o";
})(CmObjectType || (CmObjectType = {}));

/**
 * Common Media Streaming Format
 *
 * @group CMCD
 * @group CMSD
 *
 * @beta
 */
var CmStreamingFormat;
(function (CmStreamingFormat) {
  /**
   * MPEG DASH
   */
  CmStreamingFormat["DASH"] = "d";
  /**
   * HTTP Live Streaming (HLS)
   */
  CmStreamingFormat["HLS"] = "h";
  /**
   * Smooth Streaming
   */
  CmStreamingFormat["SMOOTH"] = "s";
  /**
   * Other
   */
  CmStreamingFormat["OTHER"] = "o";
})(CmStreamingFormat || (CmStreamingFormat = {}));

/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @beta
 */
var CmcdHeaderField;
(function (CmcdHeaderField) {
  /**
   * keys whose values vary with the object being requested.
   */
  CmcdHeaderField["OBJECT"] = "CMCD-Object";
  /**
   * keys whose values vary with each request.
   */
  CmcdHeaderField["REQUEST"] = "CMCD-Request";
  /**
   * keys whose values are expected to be invariant over the life of the session.
   */
  CmcdHeaderField["SESSION"] = "CMCD-Session";
  /**
   * keys whose values do not vary with every request or object.
   */
  CmcdHeaderField["STATUS"] = "CMCD-Status";
})(CmcdHeaderField || (CmcdHeaderField = {}));

/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */
const CmcdHeaderMap = {
  [CmcdHeaderField.OBJECT]: ['br', 'd', 'ot', 'tb'],
  [CmcdHeaderField.REQUEST]: ['bl', 'dl', 'mtp', 'nor', 'nrr', 'su'],
  [CmcdHeaderField.SESSION]: ['cid', 'pr', 'sf', 'sid', 'st', 'v'],
  [CmcdHeaderField.STATUS]: ['bs', 'rtp']
};

/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */
class SfItem {
  constructor(value, params) {
    this.value = void 0;
    this.params = void 0;
    if (Array.isArray(value)) {
      value = value.map(v => v instanceof SfItem ? v : new SfItem(v));
    }
    this.value = value;
    this.params = params;
  }
}

/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */
class SfToken {
  constructor(description) {
    this.description = void 0;
    this.description = description;
  }
}

const DICT = 'Dict';

function format(value) {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  if (value instanceof Map) {
    return 'Map{}';
  }
  if (value instanceof Set) {
    return 'Set{}';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}
function throwError(action, src, type, cause) {
  return new Error(`failed to ${action} "${format(src)}" as ${type}`, {
    cause
  });
}

const BARE_ITEM = 'Bare Item';

const BOOLEAN = 'Boolean';

const BYTES = 'Byte Sequence';

const DECIMAL = 'Decimal';

const INTEGER = 'Integer';

function isInvalidInt(value) {
  return value < -999999999999999 || 999999999999999 < value;
}

const STRING_REGEX = /[\x00-\x1f\x7f]+/; // eslint-disable-line no-control-regex

const TOKEN = 'Token';

const KEY = 'Key';

function serializeError(src, type, cause) {
  return throwError('serialize', src, type, cause);
}

// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function serializeBoolean(value) {
  if (typeof value !== 'boolean') {
    throw serializeError(value, BOOLEAN);
  }
  return value ? '?1' : '?0';
}

/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */
function base64encode(binary) {
  return btoa(String.fromCharCode(...binary));
}

// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function serializeByteSequence(value) {
  if (ArrayBuffer.isView(value) === false) {
    throw serializeError(value, BYTES);
  }
  return `:${base64encode(value)}:`;
}

// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function serializeInteger(value) {
  if (isInvalidInt(value)) {
    throw serializeError(value, INTEGER);
  }
  return value.toString();
}

// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function serializeDate(value) {
  return `@${serializeInteger(value.getTime() / 1000)}`;
}

/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */
function roundToEven(value, precision) {
  if (value < 0) {
    return -roundToEven(-value, precision);
  }
  const decimalShift = Math.pow(10, precision);
  const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
  if (isEquidistant) {
    // If the tail of the decimal place is 'equidistant' we round to the nearest even value
    const flooredValue = Math.floor(value * decimalShift);
    return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
  } else {
    // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
  }
}

// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function serializeDecimal(value) {
  const roundedValue = roundToEven(value, 3); // round to 3 decimal places
  if (Math.floor(Math.abs(roundedValue)).toString().length > 12) {
    throw serializeError(value, DECIMAL);
  }
  const stringValue = roundedValue.toString();
  return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}

const STRING = 'String';

// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function serializeString(value) {
  if (STRING_REGEX.test(value)) {
    throw serializeError(value, STRING);
  }
  return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}

function symbolToStr(symbol) {
  return symbol.description || symbol.toString().slice(7, -1);
}

function serializeToken(token) {
  const value = symbolToStr(token);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) {
    throw serializeError(value, TOKEN);
  }
  return value;
}

// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function serializeBareItem(value) {
  switch (typeof value) {
    case 'number':
      if (!isFiniteNumber(value)) {
        throw serializeError(value, BARE_ITEM);
      }
      if (Number.isInteger(value)) {
        return serializeInteger(value);
      }
      return serializeDecimal(value);
    case 'string':
      return serializeString(value);
    case 'symbol':
      return serializeToken(value);
    case 'boolean':
      return serializeBoolean(value);
    case 'object':
      if (value instanceof Date) {
        return serializeDate(value);
      }
      if (value instanceof Uint8Array) {
        return serializeByteSequence(value);
      }
      if (value instanceof SfToken) {
        return serializeToken(value);
      }
    default:
      // fail
      throw serializeError(value, BARE_ITEM);
  }
}

// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function serializeKey(value) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) {
    throw serializeError(value, KEY);
  }
  return value;
}

// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function serializeParams(params) {
  if (params == null) {
    return '';
  }
  return Object.entries(params).map(([key, value]) => {
    if (value === true) {
      return `;${serializeKey(key)}`; // omit true
    }
    return `;${serializeKey(key)}=${serializeBareItem(value)}`;
  }).join('');
}

// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function serializeItem(value) {
  if (value instanceof SfItem) {
    return `${serializeBareItem(value.value)}${serializeParams(value.params)}`;
  } else {
    return serializeBareItem(value);
  }
}

// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function serializeInnerList(value) {
  return `(${value.value.map(serializeItem).join(' ')})${serializeParams(value.params)}`;
}

// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function serializeDict(dict, options = {
  whitespace: true
}) {
  if (typeof dict !== 'object') {
    throw serializeError(dict, DICT);
  }
  const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
  const optionalWhiteSpace = options != null && options.whitespace ? ' ' : '';
  return Array.from(entries).map(([key, item]) => {
    if (item instanceof SfItem === false) {
      item = new SfItem(item);
    }
    let output = serializeKey(key);
    if (item.value === true) {
      output += serializeParams(item.params);
    } else {
      output += '=';
      if (Array.isArray(item.value)) {
        output += serializeInnerList(item);
      } else {
        output += serializeItem(item);
      }
    }
    return output;
  }).join(`,${optionalWhiteSpace}`);
}

/**
 * Encode an object into a structured field dictionary
 *
 * @param input - The structured field dictionary to encode
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */
function encodeSfDict(value, options) {
  return serializeDict(value, options);
}

/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 *
 * @group CMCD
 */
const isTokenField = key => key === 'ot' || key === 'sf' || key === 'st';

const isValid = value => {
  if (typeof value === 'number') {
    return isFiniteNumber(value);
  }
  return value != null && value !== '' && value !== false;
};

/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */
function urlToRelativePath(url, base) {
  const to = new URL(url);
  const from = new URL(base);
  if (to.origin !== from.origin) {
    return url;
  }
  const toPath = to.pathname.split('/').slice(1);
  const fromPath = from.pathname.split('/').slice(1, -1);
  // remove common parents
  while (toPath[0] === fromPath[0]) {
    toPath.shift();
    fromPath.shift();
  }
  // add back paths
  while (fromPath.length) {
    fromPath.shift();
    toPath.unshift('..');
  }
  return toPath.join('/');
}

/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */
function uuid() {
  try {
    return crypto.randomUUID();
  } catch (error) {
    try {
      const url = URL.createObjectURL(new Blob());
      const uuid = url.toString();
      URL.revokeObjectURL(url);
      return uuid.slice(uuid.lastIndexOf('/') + 1);
    } catch (error) {
      let dt = new Date().getTime();
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
  }
}

const toRounded = value => Math.round(value);
const toUrlSafe = (value, options) => {
  if (options != null && options.baseUrl) {
    value = urlToRelativePath(value, options.baseUrl);
  }
  return encodeURIComponent(value);
};
const toHundred = value => toRounded(value / 100) * 100;
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */
const CmcdFormatters = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: toRounded,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: toRounded,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: toHundred,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: toHundred,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: toHundred,
  /**
   * Next Object Request URL encoded
   */
  nor: toUrlSafe,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: toHundred,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: toRounded
};

/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */
function processCmcd(obj, options) {
  const results = {};
  if (obj == null || typeof obj !== 'object') {
    return results;
  }
  const keys = Object.keys(obj).sort();
  const formatters = _extends({}, CmcdFormatters, options == null ? void 0 : options.formatters);
  const filter = options == null ? void 0 : options.filter;
  keys.forEach(key => {
    if (filter != null && filter(key)) {
      return;
    }
    let value = obj[key];
    const formatter = formatters[key];
    if (formatter) {
      value = formatter(value, options);
    }
    // Version should only be reported if not equal to 1.
    if (key === 'v' && value === 1) {
      return;
    }
    // Playback rate should only be sent if not equal to 1.
    if (key == 'pr' && value === 1) {
      return;
    }
    // ignore invalid values
    if (!isValid(value)) {
      return;
    }
    if (isTokenField(key) && typeof value === 'string') {
      value = new SfToken(value);
    }
    results[key] = value;
  });
  return results;
}

/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */
function encodeCmcd(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  return encodeSfDict(processCmcd(cmcd, options), _extends({
    whitespace: false
  }, options));
}

/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdHeaders(cmcd, options = {}) {
  if (!cmcd) {
    return {};
  }
  const entries = Object.entries(cmcd);
  const headerMap = Object.entries(CmcdHeaderMap).concat(Object.entries((options == null ? void 0 : options.customHeaderMap) || {}));
  const shards = entries.reduce((acc, entry) => {
    var _headerMap$find, _acc$field;
    const [key, value] = entry;
    const field = ((_headerMap$find = headerMap.find(entry => entry[1].includes(key))) == null ? void 0 : _headerMap$find[0]) || CmcdHeaderField.REQUEST;
    (_acc$field = acc[field]) != null ? _acc$field : acc[field] = {};
    acc[field][key] = value;
    return acc;
  }, {});
  return Object.entries(shards).reduce((acc, [field, value]) => {
    acc[field] = encodeCmcd(value, options);
    return acc;
  }, {});
}

/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param customHeaderMap - A map of custom CMCD keys to header fields.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdHeaders(headers, cmcd, options) {
  return _extends(headers, toCmcdHeaders(cmcd, options));
}

/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */
const CMCD_PARAM = 'CMCD';

/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */
function toCmcdQuery(cmcd, options = {}) {
  if (!cmcd) {
    return '';
  }
  const params = encodeCmcd(cmcd, options);
  return `${CMCD_PARAM}=${encodeURIComponent(params)}`;
}

const REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */
function appendCmcdQuery(url, cmcd, options) {
  // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
  // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  const query = toCmcdQuery(cmcd, options);
  if (!query) {
    return url;
  }
  if (REGEX.test(url)) {
    return url.replace(REGEX, query);
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${query}`;
}

/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */
class CMCDController {
  // eslint-disable-line no-restricted-globals

  constructor(hls) {
    this.hls = void 0;
    this.config = void 0;
    this.media = void 0;
    this.sid = void 0;
    this.cid = void 0;
    this.useHeaders = false;
    this.includeKeys = void 0;
    this.initialized = false;
    this.starved = false;
    this.buffering = true;
    this.audioBuffer = void 0;
    // eslint-disable-line no-restricted-globals
    this.videoBuffer = void 0;
    this.onWaiting = () => {
      if (this.initialized) {
        this.starved = true;
      }
      this.buffering = true;
    };
    this.onPlaying = () => {
      if (!this.initialized) {
        this.initialized = true;
      }
      this.buffering = false;
    };
    /**
     * Apply CMCD data to a manifest request.
     */
    this.applyPlaylistData = context => {
      try {
        this.apply(context, {
          ot: CmObjectType.MANIFEST,
          su: !this.initialized
        });
      } catch (error) {
        logger.warn('Could not generate manifest CMCD data.', error);
      }
    };
    /**
     * Apply CMCD data to a segment request
     */
    this.applyFragmentData = context => {
      try {
        const fragment = context.frag;
        const level = this.hls.levels[fragment.level];
        const ot = this.getObjectType(fragment);
        const data = {
          d: fragment.duration * 1000,
          ot
        };
        if (ot === CmObjectType.VIDEO || ot === CmObjectType.AUDIO || ot == CmObjectType.MUXED) {
          data.br = level.bitrate / 1000;
          data.tb = this.getTopBandwidth(ot) / 1000;
          data.bl = this.getBufferLength(ot);
        }
        this.apply(context, data);
      } catch (error) {
        logger.warn('Could not generate segment CMCD data.', error);
      }
    };
    this.hls = hls;
    const config = this.config = hls.config;
    const {
      cmcd
    } = config;
    if (cmcd != null) {
      config.pLoader = this.createPlaylistLoader();
      config.fLoader = this.createFragmentLoader();
      this.sid = cmcd.sessionId || uuid();
      this.cid = cmcd.contentId;
      this.useHeaders = cmcd.useHeaders === true;
      this.includeKeys = cmcd.includeKeys;
      this.registerListeners();
    }
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHED, this.onMediaDetached, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners();
    this.onMediaDetached();

    // @ts-ignore
    this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
    // @ts-ignore
    this.onWaiting = this.onPlaying = null;
  }
  onMediaAttached(event, data) {
    this.media = data.media;
    this.media.addEventListener('waiting', this.onWaiting);
    this.media.addEventListener('playing', this.onPlaying);
  }
  onMediaDetached() {
    if (!this.media) {
      return;
    }
    this.media.removeEventListener('waiting', this.onWaiting);
    this.media.removeEventListener('playing', this.onPlaying);

    // @ts-ignore
    this.media = null;
  }
  onBufferCreated(event, data) {
    var _data$tracks$audio, _data$tracks$video;
    this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
    this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var _this$media;
    return {
      v: 1,
      sf: CmStreamingFormat.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1000
    };
  }

  /**
   * Apply CMCD data to a request.
   */
  apply(context, data = {}) {
    // apply baseline data
    _extends(data, this.createData());
    const isVideo = data.ot === CmObjectType.INIT || data.ot === CmObjectType.VIDEO || data.ot === CmObjectType.MUXED;
    if (this.starved && isVideo) {
      data.bs = true;
      data.su = true;
      this.starved = false;
    }
    if (data.su == null) {
      data.su = this.buffering;
    }

    // TODO: Implement rtp, nrr, nor, dl

    const {
      includeKeys
    } = this;
    if (includeKeys) {
      data = Object.keys(data).reduce((acc, key) => {
        includeKeys.includes(key) && (acc[key] = data[key]);
        return acc;
      }, {});
    }
    if (this.useHeaders) {
      if (!context.headers) {
        context.headers = {};
      }
      appendCmcdHeaders(context.headers, data);
    } else {
      context.url = appendCmcdQuery(context.url, data);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(fragment) {
    const {
      type
    } = fragment;
    if (type === 'subtitle') {
      return CmObjectType.TIMED_TEXT;
    }
    if (fragment.sn === 'initSegment') {
      return CmObjectType.INIT;
    }
    if (type === 'audio') {
      return CmObjectType.AUDIO;
    }
    if (type === 'main') {
      if (!this.hls.audioTracks.length) {
        return CmObjectType.MUXED;
      }
      return CmObjectType.VIDEO;
    }
    return undefined;
  }

  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(type) {
    let bitrate = 0;
    let levels;
    const hls = this.hls;
    if (type === CmObjectType.AUDIO) {
      levels = hls.audioTracks;
    } else {
      const max = hls.maxAutoLevel;
      const len = max > -1 ? max + 1 : hls.levels.length;
      levels = hls.levels.slice(0, len);
    }
    for (const level of levels) {
      if (level.bitrate > bitrate) {
        bitrate = level.bitrate;
      }
    }
    return bitrate > 0 ? bitrate : NaN;
  }

  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(type) {
    const media = this.hls.media;
    const buffer = type === CmObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
    if (!buffer || !media) {
      return NaN;
    }
    const info = BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
    return info.len * 1000;
  }

  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader
    } = this.config;
    const apply = this.applyPlaylistData;
    const Ctor = pLoader || this.config.loader;
    return class CmcdPlaylistLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }

  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader
    } = this.config;
    const apply = this.applyFragmentData;
    const Ctor = fLoader || this.config.loader;
    return class CmcdFragmentLoader {
      constructor(config) {
        this.loader = void 0;
        this.loader = new Ctor(config);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(context, config, callbacks) {
        apply(context);
        this.loader.load(context, config, callbacks);
      }
    };
  }
}

const PATHWAY_PENALTY_DURATION_MS = 300000;
class ContentSteeringController {
  constructor(hls) {
    this.hls = void 0;
    this.log = void 0;
    this.loader = null;
    this.uri = null;
    this.pathwayId = '.';
    this.pathwayPriority = null;
    this.timeToLoad = 300;
    this.reloadTimer = -1;
    this.updated = 0;
    this.started = false;
    this.enabled = true;
    this.levels = null;
    this.audioTracks = null;
    this.subtitleTracks = null;
    this.penalizedPathways = {};
    this.hls = hls;
    this.log = logger.log.bind(logger, `[content-steering]:`);
    this.registerListeners();
  }
  registerListeners() {
    const hls = this.hls;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const hls = this.hls;
    if (!hls) {
      return;
    }
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  startLoad() {
    this.started = true;
    this.clearTimeout();
    if (this.enabled && this.uri) {
      if (this.updated) {
        const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
        if (ttl > 0) {
          this.scheduleRefresh(this.uri, ttl);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = false;
    if (this.loader) {
      this.loader.destroy();
      this.loader = null;
    }
    this.clearTimeout();
  }
  clearTimeout() {
    if (this.reloadTimer !== -1) {
      self.clearTimeout(this.reloadTimer);
      this.reloadTimer = -1;
    }
  }
  destroy() {
    this.unregisterListeners();
    this.stopLoad();
    // @ts-ignore
    this.hls = null;
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(levelToRemove) {
    const levels = this.levels;
    if (levels) {
      this.levels = levels.filter(level => level !== levelToRemove);
    }
  }
  onManifestLoading() {
    this.stopLoad();
    this.enabled = true;
    this.timeToLoad = 300;
    this.updated = 0;
    this.uri = null;
    this.pathwayId = '.';
    this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(event, data) {
    const {
      contentSteering
    } = data;
    if (contentSteering === null) {
      return;
    }
    this.pathwayId = contentSteering.pathwayId;
    this.uri = contentSteering.uri;
    if (this.started) {
      this.startLoad();
    }
  }
  onManifestParsed(event, data) {
    this.audioTracks = data.audioTracks;
    this.subtitleTracks = data.subtitleTracks;
  }
  onError(event, data) {
    const {
      errorAction
    } = data;
    if ((errorAction == null ? void 0 : errorAction.action) === NetworkErrorAction.SendAlternateToPenaltyBox && errorAction.flags === ErrorActionFlags.MoveAllAlternatesMatchingHost) {
      const levels = this.levels;
      let pathwayPriority = this.pathwayPriority;
      let errorPathway = this.pathwayId;
      if (data.context) {
        const {
          groupId,
          pathwayId,
          type
        } = data.context;
        if (groupId && levels) {
          errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
        } else if (pathwayId) {
          errorPathway = pathwayId;
        }
      }
      if (!(errorPathway in this.penalizedPathways)) {
        this.penalizedPathways[errorPathway] = performance.now();
      }
      if (!pathwayPriority && levels) {
        // If PATHWAY-PRIORITY was not provided, list pathways for error handling
        pathwayPriority = levels.reduce((pathways, level) => {
          if (pathways.indexOf(level.pathwayId) === -1) {
            pathways.push(level.pathwayId);
          }
          return pathways;
        }, []);
      }
      if (pathwayPriority && pathwayPriority.length > 1) {
        this.updatePathwayPriority(pathwayPriority);
        errorAction.resolved = this.pathwayId !== errorPathway;
      }
      if (!errorAction.resolved) {
        logger.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${JSON.stringify(pathwayPriority)} penalized: ${JSON.stringify(this.penalizedPathways)}`);
      }
    }
  }
  filterParsedLevels(levels) {
    // Filter levels to only include those that are in the initial pathway
    this.levels = levels;
    let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
    if (pathwayLevels.length === 0) {
      const pathwayId = levels[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
      pathwayLevels = this.getLevelsForPathway(pathwayId);
      this.pathwayId = pathwayId;
    }
    if (pathwayLevels.length !== levels.length) {
      this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
      return pathwayLevels;
    }
    return levels;
  }
  getLevelsForPathway(pathwayId) {
    if (this.levels === null) {
      return [];
    }
    return this.levels.filter(level => pathwayId === level.pathwayId);
  }
  updatePathwayPriority(pathwayPriority) {
    this.pathwayPriority = pathwayPriority;
    let levels;

    // Evaluate if we should remove the pathway from the penalized list
    const penalizedPathways = this.penalizedPathways;
    const now = performance.now();
    Object.keys(penalizedPathways).forEach(pathwayId => {
      if (now - penalizedPathways[pathwayId] > PATHWAY_PENALTY_DURATION_MS) {
        delete penalizedPathways[pathwayId];
      }
    });
    for (let i = 0; i < pathwayPriority.length; i++) {
      const pathwayId = pathwayPriority[i];
      if (pathwayId in penalizedPathways) {
        continue;
      }
      if (pathwayId === this.pathwayId) {
        return;
      }
      const selectedIndex = this.hls.nextLoadLevel;
      const selectedLevel = this.hls.levels[selectedIndex];
      levels = this.getLevelsForPathway(pathwayId);
      if (levels.length > 0) {
        this.log(`Setting Pathway to "${pathwayId}"`);
        this.pathwayId = pathwayId;
        reassignFragmentLevelIndexes(levels);
        this.hls.trigger(Events.LEVELS_UPDATED, {
          levels
        });
        // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
        const levelAfterChange = this.hls.levels[selectedIndex];
        if (selectedLevel && levelAfterChange && this.levels) {
          if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) {
            this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
          }
          this.hls.nextLoadLevel = selectedIndex;
        }
        break;
      }
    }
  }
  getPathwayForGroupId(groupId, type, defaultPathway) {
    const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
    for (let i = 0; i < levels.length; i++) {
      if (type === PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) {
        return levels[i].pathwayId;
      }
    }
    return defaultPathway;
  }
  clonePathways(pathwayClones) {
    const levels = this.levels;
    if (!levels) {
      return;
    }
    const audioGroupCloneMap = {};
    const subtitleGroupCloneMap = {};
    pathwayClones.forEach(pathwayClone => {
      const {
        ID: cloneId,
        'BASE-ID': baseId,
        'URI-REPLACEMENT': uriReplacement
      } = pathwayClone;
      if (levels.some(level => level.pathwayId === cloneId)) {
        return;
      }
      const clonedVariants = this.getLevelsForPathway(baseId).map(baseLevel => {
        const attributes = new AttrList(baseLevel.attrs);
        attributes['PATHWAY-ID'] = cloneId;
        const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
        const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
        if (clonedAudioGroupId) {
          audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
          attributes.AUDIO = clonedAudioGroupId;
        }
        if (clonedSubtitleGroupId) {
          subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
          attributes.SUBTITLES = clonedSubtitleGroupId;
        }
        const url = performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
        const clonedLevel = new Level({
          attrs: attributes,
          audioCodec: baseLevel.audioCodec,
          bitrate: baseLevel.bitrate,
          height: baseLevel.height,
          name: baseLevel.name,
          url,
          videoCodec: baseLevel.videoCodec,
          width: baseLevel.width
        });
        if (baseLevel.audioGroups) {
          for (let i = 1; i < baseLevel.audioGroups.length; i++) {
            clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
          }
        }
        if (baseLevel.subtitleGroups) {
          for (let i = 1; i < baseLevel.subtitleGroups.length; i++) {
            clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
          }
        }
        return clonedLevel;
      });
      levels.push(...clonedVariants);
      cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
      cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
    });
  }
  loadSteeringManifest(uri) {
    const config = this.hls.config;
    const Loader = config.loader;
    if (this.loader) {
      this.loader.destroy();
    }
    this.loader = new Loader(config);
    let url;
    try {
      url = new self.URL(uri);
    } catch (error) {
      this.enabled = false;
      this.log(`Failed to parse Steering Manifest URI: ${uri}`);
      return;
    }
    if (url.protocol !== 'data:') {
      const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
      url.searchParams.set('_HLS_pathway', this.pathwayId);
      url.searchParams.set('_HLS_throughput', '' + throughput);
    }
    const context = {
      responseType: 'json',
      url: url.href
    };
    const loadPolicy = config.steeringManifestLoadPolicy.default;
    const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
    const loaderConfig = {
      loadPolicy,
      timeout: loadPolicy.maxLoadTimeMs,
      maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
      retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
      maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
    };
    const callbacks = {
      onSuccess: (response, stats, context, networkDetails) => {
        this.log(`Loaded steering manifest: "${url}"`);
        const steeringData = response.data;
        if (steeringData.VERSION !== 1) {
          this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now();
        this.timeToLoad = steeringData.TTL;
        const {
          'RELOAD-URI': reloadUri,
          'PATHWAY-CLONES': pathwayClones,
          'PATHWAY-PRIORITY': pathwayPriority
        } = steeringData;
        if (reloadUri) {
          try {
            this.uri = new self.URL(reloadUri, url).href;
          } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
            return;
          }
        }
        this.scheduleRefresh(this.uri || context.url);
        if (pathwayClones) {
          this.clonePathways(pathwayClones);
        }
        const loadedSteeringData = {
          steeringManifest: steeringData,
          url: url.toString()
        };
        this.hls.trigger(Events.STEERING_MANIFEST_LOADED, loadedSteeringData);
        if (pathwayPriority) {
          this.updatePathwayPriority(pathwayPriority);
        }
      },
      onError: (error, context, networkDetails, stats) => {
        this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
        this.stopLoad();
        if (error.code === 410) {
          this.enabled = false;
          this.log(`Steering manifest ${context.url} no longer available`);
          return;
        }
        let ttl = this.timeToLoad * 1000;
        if (error.code === 429) {
          const loader = this.loader;
          if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
            const retryAfter = loader.getResponseHeader('Retry-After');
            if (retryAfter) {
              ttl = parseFloat(retryAfter) * 1000;
            }
          }
          this.log(`Steering manifest ${context.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || context.url, ttl);
      },
      onTimeout: (stats, context, networkDetails) => {
        this.log(`Timeout loading steering manifest (${context.url})`);
        this.scheduleRefresh(this.uri || context.url);
      }
    };
    this.log(`Requesting steering manifest: ${url}`);
    this.loader.load(context, loaderConfig, callbacks);
  }
  scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
    this.clearTimeout();
    this.reloadTimer = self.setTimeout(() => {
      var _this$hls;
      const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
      if (media && !media.ended) {
        this.loadSteeringManifest(uri);
        return;
      }
      this.scheduleRefresh(uri, this.timeToLoad * 1000);
    }, ttlMs);
  }
}
function cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
  if (!tracks) {
    return;
  }
  Object.keys(groupCloneMap).forEach(audioGroupId => {
    const clonedTracks = tracks.filter(track => track.groupId === audioGroupId).map(track => {
      const clonedTrack = _extends({}, track);
      clonedTrack.details = undefined;
      clonedTrack.attrs = new AttrList(clonedTrack.attrs);
      clonedTrack.url = clonedTrack.attrs.URI = performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
      clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
      clonedTrack.attrs['PATHWAY-ID'] = cloneId;
      return clonedTrack;
    });
    tracks.push(...clonedTracks);
  });
}
function performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
  const {
    HOST: host,
    PARAMS: params,
    [perOptionKey]: perOptionUris
  } = uriReplacement;
  let perVariantUri;
  if (stableId) {
    perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
    if (perVariantUri) {
      uri = perVariantUri;
    }
  }
  const url = new self.URL(uri);
  if (host && !perVariantUri) {
    url.host = host;
  }
  if (params) {
    Object.keys(params).sort().forEach(key => {
      if (key) {
        url.searchParams.set(key, params[key]);
      }
    });
  }
  return url.href;
}

const AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class XhrLoader {
  constructor(config) {
    this.xhrSetup = void 0;
    this.requestTimeout = void 0;
    this.retryTimeout = void 0;
    this.retryDelay = void 0;
    this.config = null;
    this.callbacks = null;
    this.context = null;
    this.loader = null;
    this.stats = void 0;
    this.xhrSetup = config ? config.xhrSetup || null : null;
    this.stats = new LoadStats();
    this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null;
    this.abortInternal();
    this.loader = null;
    this.config = null;
    this.context = null;
    this.xhrSetup = null;
  }
  abortInternal() {
    const loader = this.loader;
    self.clearTimeout(this.requestTimeout);
    self.clearTimeout(this.retryTimeout);
    if (loader) {
      loader.onreadystatechange = null;
      loader.onprogress = null;
      if (loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
  }
  load(context, config, callbacks) {
    if (this.stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    this.stats.loading.start = self.performance.now();
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.loadInternal();
  }
  loadInternal() {
    const {
      config,
      context
    } = this;
    if (!config || !context) {
      return;
    }
    const xhr = this.loader = new self.XMLHttpRequest();
    const stats = this.stats;
    stats.loading.first = 0;
    stats.loaded = 0;
    stats.aborted = false;
    const xhrSetup = this.xhrSetup;
    if (xhrSetup) {
      Promise.resolve().then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        return xhrSetup(xhr, context.url);
      }).catch(error => {
        if (this.loader !== xhr || this.stats.aborted) return;
        xhr.open('GET', context.url, true);
        return xhrSetup(xhr, context.url);
      }).then(() => {
        if (this.loader !== xhr || this.stats.aborted) return;
        this.openAndSendXhr(xhr, context, config);
      }).catch(error => {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({
          code: xhr.status,
          text: error.message
        }, context, xhr, stats);
        return;
      });
    } else {
      this.openAndSendXhr(xhr, context, config);
    }
  }
  openAndSendXhr(xhr, context, config) {
    if (!xhr.readyState) {
      xhr.open('GET', context.url, true);
    }
    const headers = context.headers;
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    if (headers) {
      for (const header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
    }
    if (context.rangeEnd) {
      xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
    }
    xhr.onreadystatechange = this.readystatechange.bind(this);
    xhr.onprogress = this.loadprogress.bind(this);
    xhr.responseType = context.responseType;
    // setup timeout before we perform request
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
    xhr.send();
  }
  readystatechange() {
    const {
      context,
      loader: xhr,
      stats
    } = this;
    if (!context || !xhr) {
      return;
    }
    const readyState = xhr.readyState;
    const config = this.config;

    // don't proceed if xhr has been aborted
    if (stats.aborted) {
      return;
    }

    // >= HEADERS_RECEIVED
    if (readyState >= 2) {
      if (stats.loading.first === 0) {
        stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
        // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
        if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
          self.clearTimeout(this.requestTimeout);
          config.timeout = config.loadPolicy.maxLoadTimeMs;
          this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
        }
      }
      if (readyState === 4) {
        self.clearTimeout(this.requestTimeout);
        xhr.onreadystatechange = null;
        xhr.onprogress = null;
        const status = xhr.status;
        // http status between 200 to 299 are all successful
        const useResponse = xhr.responseType !== 'text';
        if (status >= 200 && status < 300 && (useResponse && xhr.response || xhr.responseText !== null)) {
          stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
          const data = useResponse ? xhr.response : xhr.responseText;
          const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
          stats.loaded = stats.total = len;
          stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
          if (!this.callbacks) {
            return;
          }
          const onProgress = this.callbacks.onProgress;
          if (onProgress) {
            onProgress(stats, context, data, xhr);
          }
          if (!this.callbacks) {
            return;
          }
          const response = {
            url: xhr.responseURL,
            data: data,
            code: status
          };
          this.callbacks.onSuccess(response, stats, context, xhr);
        } else {
          const retryConfig = config.loadPolicy.errorRetry;
          const retryCount = stats.retry;
          // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
          const response = {
            url: context.url,
            data: undefined,
            code: status
          };
          if (shouldRetry(retryConfig, retryCount, false, response)) {
            this.retry(retryConfig);
          } else {
            logger.error(`${status} while loading ${context.url}`);
            this.callbacks.onError({
              code: status,
              text: xhr.statusText
            }, context, xhr, stats);
          }
        }
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const retryConfig = this.config.loadPolicy.timeoutRetry;
    const retryCount = this.stats.retry;
    if (shouldRetry(retryConfig, retryCount, true)) {
      this.retry(retryConfig);
    } else {
      var _this$context;
      logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
      const callbacks = this.callbacks;
      if (callbacks) {
        this.abortInternal();
        callbacks.onTimeout(this.stats, this.context, this.loader);
      }
    }
  }
  retry(retryConfig) {
    const {
      context,
      stats
    } = this;
    this.retryDelay = getRetryDelay(retryConfig, stats.retry);
    stats.retry++;
    logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
    // abort and reset internal state
    this.abortInternal();
    this.loader = null;
    // schedule retry
    self.clearTimeout(this.retryTimeout);
    this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(event) {
    const stats = this.stats;
    stats.loaded = event.loaded;
    if (event.lengthComputable) {
      stats.total = event.total;
    }
  }
  getCacheAge() {
    let result = null;
    if (this.loader && AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
      const ageHeader = this.loader.getResponseHeader('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) {
      return this.loader.getResponseHeader(name);
    }
    return null;
  }
}

function fetchSupported() {
  if (
  // @ts-ignore
  self.fetch && self.AbortController && self.ReadableStream && self.Request) {
    try {
      new self.ReadableStream({}); // eslint-disable-line no-new
      return true;
    } catch (e) {
      /* noop */
    }
  }
  return false;
}
const BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class FetchLoader {
  constructor(config /* HlsConfig */) {
    this.fetchSetup = void 0;
    this.requestTimeout = void 0;
    this.request = null;
    this.response = null;
    this.controller = void 0;
    this.context = null;
    this.config = null;
    this.callbacks = null;
    this.stats = void 0;
    this.loader = null;
    this.fetchSetup = config.fetchSetup || getRequest;
    this.controller = new self.AbortController();
    this.stats = new LoadStats();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null;
    this.abortInternal();
    this.response = null;
    // @ts-ignore
    this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    if (this.controller && !this.stats.loading.end) {
      this.stats.aborted = true;
      this.controller.abort();
    }
  }
  abort() {
    var _this$callbacks;
    this.abortInternal();
    if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) {
      this.callbacks.onAbort(this.stats, this.context, this.response);
    }
  }
  load(context, config, callbacks) {
    const stats = this.stats;
    if (stats.loading.start) {
      throw new Error('Loader can only be used once.');
    }
    stats.loading.start = self.performance.now();
    const initParams = getRequestParameters(context, this.controller.signal);
    const onProgress = callbacks.onProgress;
    const isArrayBuffer = context.responseType === 'arraybuffer';
    const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
    const {
      maxTimeToFirstByteMs,
      maxLoadTimeMs
    } = config.loadPolicy;
    this.context = context;
    this.config = config;
    this.callbacks = callbacks;
    this.request = this.fetchSetup(context, initParams);
    self.clearTimeout(this.requestTimeout);
    config.timeout = maxTimeToFirstByteMs && isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
    this.requestTimeout = self.setTimeout(() => {
      this.abortInternal();
      callbacks.onTimeout(stats, context, this.response);
    }, config.timeout);
    self.fetch(this.request).then(response => {
      this.response = this.loader = response;
      const first = Math.max(self.performance.now(), stats.loading.start);
      self.clearTimeout(this.requestTimeout);
      config.timeout = maxLoadTimeMs;
      this.requestTimeout = self.setTimeout(() => {
        this.abortInternal();
        callbacks.onTimeout(stats, context, this.response);
      }, maxLoadTimeMs - (first - stats.loading.start));
      if (!response.ok) {
        const {
          status,
          statusText
        } = response;
        throw new FetchError(statusText || 'fetch, bad network response', status, response);
      }
      stats.loading.first = first;
      stats.total = getContentLength(response.headers) || stats.total;
      if (onProgress && isFiniteNumber(config.highWaterMark)) {
        return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
      }
      if (isArrayBuffer) {
        return response.arrayBuffer();
      }
      if (context.responseType === 'json') {
        return response.json();
      }
      return response.text();
    }).then(responseData => {
      const response = this.response;
      if (!response) {
        throw new Error('loader destroyed');
      }
      self.clearTimeout(this.requestTimeout);
      stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
      const total = responseData[LENGTH];
      if (total) {
        stats.loaded = stats.total = total;
      }
      const loaderResponse = {
        url: response.url,
        data: responseData,
        code: response.status
      };
      if (onProgress && !isFiniteNumber(config.highWaterMark)) {
        onProgress(stats, context, responseData, response);
      }
      callbacks.onSuccess(loaderResponse, stats, context, response);
    }).catch(error => {
      self.clearTimeout(this.requestTimeout);
      if (stats.aborted) {
        return;
      }
      // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
      // when destroying, 'error' itself can be undefined
      const code = !error ? 0 : error.code || 0;
      const text = !error ? null : error.message;
      callbacks.onError({
        code,
        text
      }, context, error ? error.details : null, stats);
    });
  }
  getCacheAge() {
    let result = null;
    if (this.response) {
      const ageHeader = this.response.headers.get('age');
      result = ageHeader ? parseFloat(ageHeader) : null;
    }
    return result;
  }
  getResponseHeader(name) {
    return this.response ? this.response.headers.get(name) : null;
  }
  loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
    const chunkCache = new ChunkCache();
    const reader = response.body.getReader();
    const pump = () => {
      return reader.read().then(data => {
        if (data.done) {
          if (chunkCache.dataLength) {
            onProgress(stats, context, chunkCache.flush(), response);
          }
          return Promise.resolve(new ArrayBuffer(0));
        }
        const chunk = data.value;
        const len = chunk.length;
        stats.loaded += len;
        if (len < highWaterMark || chunkCache.dataLength) {
          // The current chunk is too small to to be emitted or the cache already has data
          // Push it to the cache
          chunkCache.push(chunk);
          if (chunkCache.dataLength >= highWaterMark) {
            // flush in order to join the typed arrays
            onProgress(stats, context, chunkCache.flush(), response);
          }
        } else {
          // If there's nothing cached already, and the chache is large enough
          // just emit the progress event
          onProgress(stats, context, chunk, response);
        }
        return pump();
      }).catch(() => {
        /* aborted */
        return Promise.reject();
      });
    };
    return pump();
  }
}
function getRequestParameters(context, signal) {
  const initParams = {
    method: 'GET',
    mode: 'cors',
    credentials: 'same-origin',
    signal,
    headers: new self.Headers(_extends({}, context.headers))
  };
  if (context.rangeEnd) {
    initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
  }
  return initParams;
}
function getByteRangeLength(byteRangeHeader) {
  const result = BYTERANGE.exec(byteRangeHeader);
  if (result) {
    return parseInt(result[2]) - parseInt(result[1]) + 1;
  }
}
function getContentLength(headers) {
  const contentRange = headers.get('Content-Range');
  if (contentRange) {
    const byteRangeLength = getByteRangeLength(contentRange);
    if (isFiniteNumber(byteRangeLength)) {
      return byteRangeLength;
    }
  }
  const contentLength = headers.get('Content-Length');
  if (contentLength) {
    return parseInt(contentLength);
  }
}
function getRequest(context, initParams) {
  return new self.Request(context.url, initParams);
}
class FetchError extends Error {
  constructor(message, code, details) {
    super(message);
    this.code = void 0;
    this.details = void 0;
    this.code = code;
    this.details = details;
  }
}

const WHITESPACE_CHAR = /\s/;
const Cues = {
  newCue(track, startTime, endTime, captionScreen) {
    const result = [];
    let row;
    // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
    let cue;
    let indenting;
    let indent;
    let text;
    const Cue = self.VTTCue || self.TextTrackCue;
    for (let r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';
      if (!row.isEmpty()) {
        var _track$cues;
        for (let c = 0; c < row.chars.length; c++) {
          if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        // To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }
        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }
        const cueText = fixLineBreaks(text.trim());
        const id = generateCueId(startTime, endTime, cueText);

        // If this cue already exists in the track do not push it
        if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
          cue = new Cue(startTime, endTime, cueText);
          cue.id = id;
          cue.line = r + 1;
          cue.align = 'left';
          // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
          // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
          // Firefox throws an exception and captions break with out of bounds 0-100 values
          cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
          result.push(cue);
        }
      }
    }
    if (track && result.length) {
      // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
      result.sort((cueA, cueB) => {
        if (cueA.line === 'auto' || cueB.line === 'auto') {
          return 0;
        }
        if (cueA.line > 8 && cueB.line > 8) {
          return cueB.line - cueA.line;
        }
        return cueA.line - cueB.line;
      });
      result.forEach(cue => addCueToTrack(track, cue));
    }
    return result;
  }
};

/**
 * @deprecated use fragLoadPolicy.default
 */

/**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */

const defaultLoadPolicy = {
  maxTimeToFirstByteMs: 8000,
  maxLoadTimeMs: 20000,
  timeoutRetry: null,
  errorRetry: null
};

/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */
const hlsDefaultConfig = _objectSpread2(_objectSpread2({
  autoStartLoad: true,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: undefined,
  // used by stream-controller
  debug: false,
  // used by logger
  capLevelOnFPSDrop: false,
  // used by fps-controller
  capLevelToPlayerSize: false,
  // used by cap-level-controller
  ignoreDevicePixelRatio: false,
  // used by cap-level-controller
  preferManagedMediaSource: true,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: Infinity,
  // used by buffer-controller
  frontBufferFlushThreshold: Infinity,
  maxBufferSize: 60 * 1000 * 1000,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: Infinity,
  // used by latency-controller
  liveSyncDuration: undefined,
  // used by latency-controller
  liveMaxLatencyDuration: undefined,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: false,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: true,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: true,
  // used by decrypter
  startLevel: undefined,
  // used by level-controller
  startFragPrefetch: false,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5000,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: XhrLoader,
  // loader: FetchLoader,
  fLoader: undefined,
  // used by fragment-loader
  pLoader: undefined,
  // used by playlist-loader
  xhrSetup: undefined,
  // used by xhr-loader
  licenseXhrSetup: undefined,
  // used by eme-controller
  licenseResponseCallback: undefined,
  // used by eme-controller
  abrController: AbrController,
  bufferController: BufferController,
  capLevelController: CapLevelController,
  errorController: ErrorController,
  fpsController: FPSController,
  stretchShortVideoTrack: false,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: true,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: false,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: false,
  // used by eme-controller
  widevineLicenseUrl: undefined,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: requestMediaKeySystemAccess ,
  // used by eme-controller
  testBandwidth: true,
  progressive: false,
  lowLatencyMode: true,
  cmcd: undefined,
  enableDateRangeMetadataCues: true,
  enableEmsgMetadataCues: true,
  enableID3MetadataCues: true,
  useMediaCapabilities: true,
  certLoadPolicy: {
    default: defaultLoadPolicy
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1000,
        maxRetryDelayMs: 20000,
        backoff: 'linear'
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: Infinity,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 120000,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 10000,
      maxLoadTimeMs: 20000,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1000,
        maxRetryDelayMs: 8000
      }
    } 
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 10000,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1000,
  manifestLoadingMaxRetryTimeout: 64000,
  levelLoadingTimeOut: 10000,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1000,
  levelLoadingMaxRetryTimeout: 64000,
  fragLoadingTimeOut: 20000,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1000,
  fragLoadingMaxRetryTimeout: 64000
}, timelineConfig()), {}, {
  subtitleStreamController: SubtitleStreamController ,
  subtitleTrackController: SubtitleTrackController ,
  timelineController: TimelineController ,
  audioStreamController: AudioStreamController ,
  audioTrackController: AudioTrackController ,
  emeController: EMEController ,
  cmcdController: CMCDController ,
  contentSteeringController: ContentSteeringController 
});
function timelineConfig() {
  return {
    cueHandler: Cues,
    // used by timeline-controller
    enableWebVTT: true,
    // used by timeline-controller
    enableIMSC1: true,
    // used by timeline-controller
    enableCEA708Captions: true,
    // used by timeline-controller
    captionsTextTrack1Label: 'English',
    // used by timeline-controller
    captionsTextTrack1LanguageCode: 'en',
    // used by timeline-controller
    captionsTextTrack2Label: 'Spanish',
    // used by timeline-controller
    captionsTextTrack2LanguageCode: 'es',
    // used by timeline-controller
    captionsTextTrack3Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack3LanguageCode: '',
    // used by timeline-controller
    captionsTextTrack4Label: 'Unknown CC',
    // used by timeline-controller
    captionsTextTrack4LanguageCode: '',
    // used by timeline-controller
    renderTextTracksNatively: true
  };
}

/**
 * @ignore
 */
function mergeConfig(defaultConfig, userConfig) {
  if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) {
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  }
  if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  }
  if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) {
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  }
  const defaultsCopy = deepCpy(defaultConfig);

  // Backwards compatibility with deprecated config values
  const deprecatedSettingTypes = ['manifest', 'level', 'frag'];
  const deprecatedSettings = ['TimeOut', 'MaxRetry', 'RetryDelay', 'MaxRetryTimeout'];
  deprecatedSettingTypes.forEach(type => {
    const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
    const policyNotSet = userConfig[policyName] === undefined;
    const report = [];
    deprecatedSettings.forEach(setting => {
      const deprecatedSetting = `${type}Loading${setting}`;
      const value = userConfig[deprecatedSetting];
      if (value !== undefined && policyNotSet) {
        report.push(deprecatedSetting);
        const settings = defaultsCopy[policyName].default;
        userConfig[policyName] = {
          default: settings
        };
        switch (setting) {
          case 'TimeOut':
            settings.maxLoadTimeMs = value;
            settings.maxTimeToFirstByteMs = value;
            break;
          case 'MaxRetry':
            settings.errorRetry.maxNumRetry = value;
            settings.timeoutRetry.maxNumRetry = value;
            break;
          case 'RetryDelay':
            settings.errorRetry.retryDelayMs = value;
            settings.timeoutRetry.retryDelayMs = value;
            break;
          case 'MaxRetryTimeout':
            settings.errorRetry.maxRetryDelayMs = value;
            settings.timeoutRetry.maxRetryDelayMs = value;
            break;
        }
      }
    });
    if (report.length) {
      logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${JSON.stringify(userConfig[policyName])}`);
    }
  });
  return _objectSpread2(_objectSpread2({}, defaultsCopy), userConfig);
}
function deepCpy(obj) {
  if (obj && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(deepCpy);
    }
    return Object.keys(obj).reduce((result, key) => {
      result[key] = deepCpy(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

/**
 * @ignore
 */
function enableStreamingMode(config) {
  const currentLoader = config.loader;
  if (currentLoader !== FetchLoader && currentLoader !== XhrLoader) {
    // If a developer has configured their own loader, respect that choice
    logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
    config.progressive = false;
  } else {
    const canStreamProgressively = fetchSupported();
    if (canStreamProgressively) {
      config.loader = FetchLoader;
      config.progressive = true;
      config.enableSoftwareAES = true;
      logger.log('[config]: Progressive streaming enabled, using FetchLoader');
    }
  }
}

let chromeOrFirefox;
class LevelController extends BasePlaylistController {
  constructor(hls, contentSteeringController) {
    super(hls, '[level-controller]');
    this._levels = [];
    this._firstLevel = -1;
    this._maxAutoLevel = -1;
    this._startLevel = void 0;
    this.currentLevel = null;
    this.currentLevelIndex = -1;
    this.manualLevelIndex = -1;
    this.steering = void 0;
    this.onParsedComplete = void 0;
    this.steering = contentSteeringController;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.on(Events.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_LOADED, this.onManifestLoaded, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
    hls.off(Events.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners();
    this.steering = null;
    this.resetLevels();
    super.destroy();
  }
  stopLoad() {
    const levels = this._levels;

    // clean up live level details to force reload them, and reset load errors
    levels.forEach(level => {
      level.loadError = 0;
      level.fragmentError = 0;
    });
    super.stopLoad();
  }
  resetLevels() {
    this._startLevel = undefined;
    this.manualLevelIndex = -1;
    this.currentLevelIndex = -1;
    this.currentLevel = null;
    this._levels = [];
    this._maxAutoLevel = -1;
  }
  onManifestLoading(event, data) {
    this.resetLevels();
  }
  onManifestLoaded(event, data) {
    const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
    const levels = [];
    const redundantSet = {};
    const generatePathwaySet = {};
    let resolutionFound = false;
    let videoCodecFound = false;
    let audioCodecFound = false;
    data.levels.forEach(levelParsed => {
      var _audioCodec, _videoCodec;
      const attributes = levelParsed.attrs;

      // erase audio codec info if browser does not support mp4a.40.34.
      // demuxer will autodetect codec and fallback to mpeg/audio
      let {
        audioCodec,
        videoCodec
      } = levelParsed;
      if (((_audioCodec = audioCodec) == null ? void 0 : _audioCodec.indexOf('mp4a.40.34')) !== -1) {
        chromeOrFirefox || (chromeOrFirefox = /chrome|firefox/i.test(navigator.userAgent));
        if (chromeOrFirefox) {
          levelParsed.audioCodec = audioCodec = undefined;
        }
      }
      if (audioCodec) {
        levelParsed.audioCodec = audioCodec = getCodecCompatibleName(audioCodec, preferManagedMediaSource);
      }
      if (((_videoCodec = videoCodec) == null ? void 0 : _videoCodec.indexOf('avc1')) === 0) {
        videoCodec = levelParsed.videoCodec = convertAVC1ToAVCOTI(videoCodec);
      }

      // only keep levels with supported audio/video codecs
      const {
        width,
        height,
        unknownCodecs
      } = levelParsed;
      resolutionFound || (resolutionFound = !!(width && height));
      videoCodecFound || (videoCodecFound = !!videoCodec);
      audioCodecFound || (audioCodecFound = !!audioCodec);
      if (unknownCodecs != null && unknownCodecs.length || audioCodec && !areCodecsMediaSourceSupported(audioCodec, 'audio', preferManagedMediaSource) || videoCodec && !areCodecsMediaSourceSupported(videoCodec, 'video', preferManagedMediaSource)) {
        return;
      }
      const {
        CODECS,
        'FRAME-RATE': FRAMERATE,
        'HDCP-LEVEL': HDCP,
        'PATHWAY-ID': PATHWAY,
        RESOLUTION,
        'VIDEO-RANGE': VIDEO_RANGE
      } = attributes;
      const contentSteeringPrefix = `${PATHWAY || '.'}-`;
      const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
      if (!redundantSet[levelKey]) {
        const level = new Level(levelParsed);
        redundantSet[levelKey] = level;
        generatePathwaySet[levelKey] = 1;
        levels.push(level);
      } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
        // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
        // Content Steering controller to handles Pathway fallback on error
        const pathwayCount = generatePathwaySet[levelKey] += 1;
        levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
        const level = new Level(levelParsed);
        redundantSet[levelKey] = level;
        levels.push(level);
      } else {
        redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
        redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
      }
    });
    this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
  }
  filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
    let audioTracks = [];
    let subtitleTracks = [];
    let levels = filteredLevels;

    // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
    if ((resolutionFound || videoCodecFound) && audioCodecFound) {
      levels = levels.filter(({
        videoCodec,
        videoRange,
        width,
        height
      }) => (!!videoCodec || !!(width && height)) && isVideoRange(videoRange));
    }
    if (levels.length === 0) {
      // Dispatch error after MANIFEST_LOADED is done propagating
      Promise.resolve().then(() => {
        if (this.hls) {
          if (data.levels.length) {
            this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(data.levels[0].attrs)}`);
          }
          const error = new Error('no level with compatible codecs found in manifest');
          this.hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: true,
            url: data.url,
            error,
            reason: error.message
          });
        }
      });
      return;
    }
    if (data.audioTracks) {
      const {
        preferManagedMediaSource
      } = this.hls.config;
      audioTracks = data.audioTracks.filter(track => !track.audioCodec || areCodecsMediaSourceSupported(track.audioCodec, 'audio', preferManagedMediaSource));
      // Assign ids after filtering as array indices by group-id
      assignTrackIdsByGroup(audioTracks);
    }
    if (data.subtitles) {
      subtitleTracks = data.subtitles;
      assignTrackIdsByGroup(subtitleTracks);
    }
    // start bitrate is the first bitrate of the manifest
    const unsortedLevels = levels.slice(0);
    // sort levels from lowest to highest
    levels.sort((a, b) => {
      if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) {
        return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
      }
      // sort on height before bitrate for cap-level-controller
      if (resolutionFound && a.height !== b.height) {
        return a.height - b.height;
      }
      if (a.frameRate !== b.frameRate) {
        return a.frameRate - b.frameRate;
      }
      if (a.videoRange !== b.videoRange) {
        return VideoRangeValues.indexOf(a.videoRange) - VideoRangeValues.indexOf(b.videoRange);
      }
      if (a.videoCodec !== b.videoCodec) {
        const valueA = videoCodecPreferenceValue(a.videoCodec);
        const valueB = videoCodecPreferenceValue(b.videoCodec);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.uri === b.uri && a.codecSet !== b.codecSet) {
        const valueA = codecsSetSelectionPreferenceValue(a.codecSet);
        const valueB = codecsSetSelectionPreferenceValue(b.codecSet);
        if (valueA !== valueB) {
          return valueB - valueA;
        }
      }
      if (a.averageBitrate !== b.averageBitrate) {
        return a.averageBitrate - b.averageBitrate;
      }
      return 0;
    });
    let firstLevelInPlaylist = unsortedLevels[0];
    if (this.steering) {
      levels = this.steering.filterParsedLevels(levels);
      if (levels.length !== unsortedLevels.length) {
        for (let i = 0; i < unsortedLevels.length; i++) {
          if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
            firstLevelInPlaylist = unsortedLevels[i];
            break;
          }
        }
      }
    }
    this._levels = levels;

    // find index of first level in sorted levels
    for (let i = 0; i < levels.length; i++) {
      if (levels[i] === firstLevelInPlaylist) {
        var _this$hls$userConfig;
        this._firstLevel = i;
        const firstLevelBitrate = firstLevelInPlaylist.bitrate;
        const bandwidthEstimate = this.hls.bandwidthEstimate;
        this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
        // Update default bwe to first variant bitrate as long it has not been configured or set
        if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
          const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
          if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === hlsDefaultConfig.abrEwmaDefaultEstimate) {
            this.hls.bandwidthEstimate = startingBwEstimate;
          }
        }
        break;
      }
    }

    // Audio is only alternate if manifest include a URI along with the audio group tag,
    // and this is not an audio-only stream where levels contain audio-only
    const audioOnly = audioCodecFound && !videoCodecFound;
    const edata = {
      levels,
      audioTracks,
      subtitleTracks,
      sessionData: data.sessionData,
      sessionKeys: data.sessionKeys,
      firstLevel: this._firstLevel,
      stats: data.stats,
      audio: audioCodecFound,
      video: videoCodecFound,
      altAudio: !audioOnly && audioTracks.some(t => !!t.url)
    };
    this.hls.trigger(Events.MANIFEST_PARSED, edata);

    // Initiate loading after all controllers have received MANIFEST_PARSED
    if (this.hls.config.autoStartLoad || this.hls.forceStartLoad) {
      this.hls.startLoad(this.hls.config.startPosition);
    }
  }
  get levels() {
    if (this._levels.length === 0) {
      return null;
    }
    return this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(newLevel) {
    const levels = this._levels;
    if (levels.length === 0) {
      return;
    }
    // check if level idx is valid
    if (newLevel < 0 || newLevel >= levels.length) {
      // invalid level id given, trigger error
      const error = new Error('invalid level idx');
      const fatal = newLevel < 0;
      this.hls.trigger(Events.ERROR, {
        type: ErrorTypes.OTHER_ERROR,
        details: ErrorDetails.LEVEL_SWITCH_ERROR,
        level: newLevel,
        fatal,
        error,
        reason: error.message
      });
      if (fatal) {
        return;
      }
      newLevel = Math.min(newLevel, levels.length - 1);
    }
    const lastLevelIndex = this.currentLevelIndex;
    const lastLevel = this.currentLevel;
    const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
    const level = levels[newLevel];
    const pathwayId = level.attrs['PATHWAY-ID'];
    this.currentLevelIndex = newLevel;
    this.currentLevel = level;
    if (lastLevelIndex === newLevel && level.details && lastLevel && lastPathwayId === pathwayId) {
      return;
    }
    this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
    const levelSwitchingData = {
      level: newLevel,
      attrs: level.attrs,
      details: level.details,
      bitrate: level.bitrate,
      averageBitrate: level.averageBitrate,
      maxBitrate: level.maxBitrate,
      realBitrate: level.realBitrate,
      width: level.width,
      height: level.height,
      codecSet: level.codecSet,
      audioCodec: level.audioCodec,
      videoCodec: level.videoCodec,
      audioGroups: level.audioGroups,
      subtitleGroups: level.subtitleGroups,
      loaded: level.loaded,
      loadError: level.loadError,
      fragmentError: level.fragmentError,
      name: level.name,
      id: level.id,
      uri: level.uri,
      url: level.url,
      urlId: 0,
      audioGroupIds: level.audioGroupIds,
      textGroupIds: level.textGroupIds
    };
    this.hls.trigger(Events.LEVEL_SWITCHING, levelSwitchingData);
    // check if we need to load playlist for this level
    const levelDetails = level.details;
    if (!levelDetails || levelDetails.live) {
      // level not retrieved yet, or live playlist we need to (re)load it
      const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
      this.loadPlaylist(hlsUrlParameters);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(newLevel) {
    this.manualLevelIndex = newLevel;
    if (this._startLevel === undefined) {
      this._startLevel = newLevel;
    }
    if (newLevel !== -1) {
      this.level = newLevel;
    }
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(newLevel) {
    this._firstLevel = newLevel;
  }
  get startLevel() {
    // Setting hls.startLevel (this._startLevel) overrides config.startLevel
    if (this._startLevel === undefined) {
      const configStartLevel = this.hls.config.startLevel;
      if (configStartLevel !== undefined) {
        return configStartLevel;
      }
      return this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(newLevel) {
    this._startLevel = newLevel;
  }
  onError(event, data) {
    if (data.fatal || !data.context) {
      return;
    }
    if (data.context.type === PlaylistContextType.LEVEL && data.context.level === this.level) {
      this.checkRetry(data);
    }
  }

  // reset errors on the successful load of a fragment
  onFragBuffered(event, {
    frag
  }) {
    if (frag !== undefined && frag.type === PlaylistLevelType.MAIN) {
      const el = frag.elementaryStreams;
      if (!Object.keys(el).some(type => !!el[type])) {
        return;
      }
      const level = this._levels[frag.level];
      if (level != null && level.loadError) {
        this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
        level.loadError = 0;
      }
    }
  }
  onLevelLoaded(event, data) {
    var _data$deliveryDirecti2;
    const {
      level,
      details
    } = data;
    const curLevel = this._levels[level];
    if (!curLevel) {
      var _data$deliveryDirecti;
      this.warn(`Invalid level index ${level}`);
      if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) {
        details.deltaUpdateFailed = true;
      }
      return;
    }

    // only process level loaded events matching with expected level
    if (level === this.currentLevelIndex) {
      // reset level load error counter on successful level loaded only if there is no issues with fragments
      if (curLevel.fragmentError === 0) {
        curLevel.loadError = 0;
      }
      this.playlistLoaded(level, data, curLevel.details);
    } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) {
      // received a delta playlist update that cannot be merged
      details.deltaUpdateFailed = true;
    }
  }
  loadPlaylist(hlsUrlParameters) {
    super.loadPlaylist();
    const currentLevelIndex = this.currentLevelIndex;
    const currentLevel = this.currentLevel;
    if (currentLevel && this.shouldLoadPlaylist(currentLevel)) {
      let url = currentLevel.uri;
      if (hlsUrlParameters) {
        try {
          url = hlsUrlParameters.addDirectives(url);
        } catch (error) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
      }
      const pathwayId = currentLevel.attrs['PATHWAY-ID'];
      this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''} with${pathwayId ? ' Pathway ' + pathwayId : ''} ${url}`);

      // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
      // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
      this.clearTimer();
      this.hls.trigger(Events.LEVEL_LOADING, {
        url,
        level: currentLevelIndex,
        pathwayId: currentLevel.attrs['PATHWAY-ID'],
        id: 0,
        // Deprecated Level urlId
        deliveryDirectives: hlsUrlParameters || null
      });
    }
  }
  get nextLoadLevel() {
    if (this.manualLevelIndex !== -1) {
      return this.manualLevelIndex;
    } else {
      return this.hls.nextAutoLevel;
    }
  }
  set nextLoadLevel(nextLevel) {
    this.level = nextLevel;
    if (this.manualLevelIndex === -1) {
      this.hls.nextAutoLevel = nextLevel;
    }
  }
  removeLevel(levelIndex) {
    var _this$currentLevel;
    const levels = this._levels.filter((level, index) => {
      if (index !== levelIndex) {
        return true;
      }
      if (this.steering) {
        this.steering.removeLevel(level);
      }
      if (level === this.currentLevel) {
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        if (level.details) {
          level.details.fragments.forEach(f => f.level = -1);
        }
      }
      return false;
    });
    reassignFragmentLevelIndexes(levels);
    this._levels = levels;
    if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) {
      this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
    }
    this.hls.trigger(Events.LEVELS_UPDATED, {
      levels
    });
  }
  onLevelsUpdated(event, {
    levels
  }) {
    this._levels = levels;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping,
      maxAutoLevel,
      maxHdcpLevel
    } = this.hls;
    if (this._maxAutoLevel !== maxAutoLevel) {
      this._maxAutoLevel = maxAutoLevel;
      this.hls.trigger(Events.MAX_AUTO_LEVEL_UPDATED, {
        autoLevelCapping,
        levels: this.levels,
        maxAutoLevel,
        minAutoLevel: this.hls.minAutoLevel,
        maxHdcpLevel
      });
    }
  }
}
function assignTrackIdsByGroup(tracks) {
  const groups = {};
  tracks.forEach(track => {
    const groupId = track.groupId || '';
    track.id = groups[groupId] = groups[groupId] || 0;
    groups[groupId]++;
  });
}

class KeyLoader {
  constructor(config) {
    this.config = void 0;
    this.keyUriToKeyInfo = {};
    this.emeController = null;
    this.config = config;
  }
  abort(type) {
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        var _loader$context;
        if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) {
          return;
        }
        loader.abort();
      }
    }
  }
  detach() {
    for (const uri in this.keyUriToKeyInfo) {
      const keyInfo = this.keyUriToKeyInfo[uri];
      // Remove cached EME keys on detach
      if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) {
        delete this.keyUriToKeyInfo[uri];
      }
    }
  }
  destroy() {
    this.detach();
    for (const uri in this.keyUriToKeyInfo) {
      const loader = this.keyUriToKeyInfo[uri].loader;
      if (loader) {
        loader.destroy();
      }
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(frag, details = ErrorDetails.KEY_LOAD_ERROR, error, networkDetails, response) {
    return new LoadError({
      type: ErrorTypes.NETWORK_ERROR,
      details,
      fatal: false,
      frag,
      response,
      error,
      networkDetails
    });
  }
  loadClear(loadingFrag, encryptedFragments) {
    if (this.emeController && this.config.emeEnabled) {
      // access key-system with nearest key on start (loaidng frag is unencrypted)
      const {
        sn,
        cc
      } = loadingFrag;
      for (let i = 0; i < encryptedFragments.length; i++) {
        const frag = encryptedFragments[i];
        if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) {
          this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
            frag.setKeyFormat(keySystemFormat);
          });
          break;
        }
      }
    }
  }
  load(frag) {
    if (!frag.decryptdata && frag.encrypted && this.emeController) {
      // Multiple keys, but none selected, resolve in eme-controller
      return this.emeController.selectKeySystemFormat(frag).then(keySystemFormat => {
        return this.loadInternal(frag, keySystemFormat);
      });
    }
    return this.loadInternal(frag);
  }
  loadInternal(frag, keySystemFormat) {
    var _keyInfo, _keyInfo2;
    if (keySystemFormat) {
      frag.setKeyFormat(keySystemFormat);
    }
    const decryptdata = frag.decryptdata;
    if (!decryptdata) {
      const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, error));
    }
    const uri = decryptdata.uri;
    if (!uri) {
      return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
    }
    let keyInfo = this.keyUriToKeyInfo[uri];
    if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
      decryptdata.key = keyInfo.decryptdata.key;
      return Promise.resolve({
        frag,
        keyInfo
      });
    }
    // Return key load promise as long as it does not have a mediakey session with an unusable key status
    if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
      var _keyInfo$mediaKeySess;
      switch ((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus) {
        case undefined:
        case 'status-pending':
        case 'usable':
        case 'usable-in-future':
          return keyInfo.keyLoadPromise.then(keyLoadedData => {
            // Return the correct fragment with updated decryptdata key and loaded keyInfo
            decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
            return {
              frag,
              keyInfo
            };
          });
      }
      // If we have a key session and status and it is not pending or usable, continue
      // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
    }

    // Load the key or return the loading promise
    keyInfo = this.keyUriToKeyInfo[uri] = {
      decryptdata,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    };
    switch (decryptdata.method) {
      case 'ISO-23001-7':
      case 'SAMPLE-AES':
      case 'SAMPLE-AES-CENC':
      case 'SAMPLE-AES-CTR':
        if (decryptdata.keyFormat === 'identity') {
          // loadKeyHTTP handles http(s) and data URLs
          return this.loadKeyHTTP(keyInfo, frag);
        }
        return this.loadKeyEME(keyInfo, frag);
      case 'AES-128':
        return this.loadKeyHTTP(keyInfo, frag);
      default:
        return Promise.reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
    }
  }
  loadKeyEME(keyInfo, frag) {
    const keyLoadedData = {
      frag,
      keyInfo
    };
    if (this.emeController && this.config.emeEnabled) {
      const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
      if (keySessionContextPromise) {
        return (keyInfo.keyLoadPromise = keySessionContextPromise.then(keySessionContext => {
          keyInfo.mediaKeySessionContext = keySessionContext;
          return keyLoadedData;
        })).catch(error => {
          // Remove promise for license renewal or retry
          keyInfo.keyLoadPromise = null;
          throw error;
        });
      }
    }
    return Promise.resolve(keyLoadedData);
  }
  loadKeyHTTP(keyInfo, frag) {
    const config = this.config;
    const Loader = config.loader;
    const keyLoader = new Loader(config);
    frag.keyLoader = keyInfo.loader = keyLoader;
    return keyInfo.keyLoadPromise = new Promise((resolve, reject) => {
      const loaderContext = {
        keyInfo,
        frag,
        responseType: 'arraybuffer',
        url: keyInfo.decryptdata.uri
      };

      // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
      // key-loader will trigger an error and rely on stream-controller to handle retry logic.
      // this will also align retry logic with fragment-loader
      const loadPolicy = config.keyLoadPolicy.default;
      const loaderConfig = {
        loadPolicy,
        timeout: loadPolicy.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      };
      const loaderCallbacks = {
        onSuccess: (response, stats, context, networkDetails) => {
          const {
            frag,
            keyInfo,
            url: uri
          } = context;
          if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) {
            return reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
          }
          keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);

          // detach fragment key loader on load success
          frag.keyLoader = null;
          keyInfo.loader = null;
          resolve({
            frag,
            keyInfo
          });
        },
        onError: (response, context, networkDetails, stats) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, _objectSpread2({
            url: loaderContext.url,
            data: undefined
          }, response)));
        },
        onTimeout: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
        },
        onAbort: (stats, context, networkDetails) => {
          this.resetLoader(context);
          reject(this.createKeyLoadError(frag, ErrorDetails.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
        }
      };
      keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
    });
  }
  resetLoader(context) {
    const {
      frag,
      keyInfo,
      url: uri
    } = context;
    const loader = keyInfo.loader;
    if (frag.keyLoader === loader) {
      frag.keyLoader = null;
      keyInfo.loader = null;
    }
    delete this.keyUriToKeyInfo[uri];
    if (loader) {
      loader.destroy();
    }
  }
}

function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isMSESupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }

  // if SourceBuffer is exposed ensure its API is valid
  // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  const sourceBuffer = getSourceBuffer();
  return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function isSupported() {
  if (!isMSESupported()) {
    return false;
  }
  const mediaSource = getMediaSource();
  return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && (['avc1.42E01E,mp4a.40.2', 'av01.0.01M.08', 'vp09.00.50.08'].some(codecsForVideoContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecsForVideoContainer, 'video'))) || ['mp4a.40.2', 'fLaC'].some(codecForAudioContainer => mediaSource.isTypeSupported(mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function changeTypeSupported() {
  var _sourceBuffer$prototy;
  const sourceBuffer = getSourceBuffer();
  return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}

const STALL_MINIMUM_DURATION_MS = 250;
const MAX_START_GAP_JUMP = 2.0;
const SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const SKIP_BUFFER_RANGE_START = 0.05;
class GapController {
  constructor(config, media, fragmentTracker, hls) {
    this.config = void 0;
    this.media = null;
    this.fragmentTracker = void 0;
    this.hls = void 0;
    this.nudgeRetry = 0;
    this.stallReported = false;
    this.stalled = null;
    this.moved = false;
    this.seeking = false;
    this.config = config;
    this.media = media;
    this.fragmentTracker = fragmentTracker;
    this.hls = hls;
  }
  destroy() {
    this.media = null;
    // @ts-ignore
    this.hls = this.fragmentTracker = null;
  }

  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(lastCurrentTime, activeFrag) {
    const {
      config,
      media,
      stalled
    } = this;
    if (media === null) {
      return;
    }
    const {
      currentTime,
      seeking
    } = media;
    const seeked = this.seeking && !seeking;
    const beginSeek = !this.seeking && seeking;
    this.seeking = seeking;

    // The playhead is moving, no-op
    if (currentTime !== lastCurrentTime) {
      this.moved = true;
      if (!seeking) {
        this.nudgeRetry = 0;
      }
      if (stalled !== null) {
        // The playhead is now moving, but was previously stalled
        if (this.stallReported) {
          const _stalledDuration = self.performance.now() - stalled;
          logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(_stalledDuration)}ms`);
          this.stallReported = false;
        }
        this.stalled = null;
      }
      return;
    }

    // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
    if (beginSeek || seeked) {
      this.stalled = null;
      return;
    }

    // The playhead should not be moving
    if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !BufferHelper.getBuffered(media).length) {
      this.nudgeRetry = 0;
      return;
    }
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const nextStart = bufferInfo.nextStart || 0;
    if (seeking) {
      // Waiting for seeking in a buffered range to complete
      const hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
      // Next buffered range is too far ahead to jump to while still seeking
      const noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > MAX_START_GAP_JUMP && !this.fragmentTracker.getPartialFragment(currentTime);
      if (hasEnoughBuffer || noBufferGap) {
        return;
      }
      // Reset moved state when seeking to a point in or before a gap
      this.moved = false;
    }

    // Skip start gaps if we haven't played, but the last poll detected the start of a stall
    // The addition poll gives the browser a chance to jump the gap for us
    if (!this.moved && this.stalled !== null) {
      var _level$details;
      // There is no playable buffer (seeked, waiting for buffer)
      const isBuffered = bufferInfo.len > 0;
      if (!isBuffered && !nextStart) {
        return;
      }
      // Jump start gaps within jump threshold
      const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;

      // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
      // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
      // that begins over 1 target duration after the video start position.
      const level = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null;
      const isLive = level == null ? void 0 : (_level$details = level.details) == null ? void 0 : _level$details.live;
      const maxStartGapJump = isLive ? level.details.targetduration * 2 : MAX_START_GAP_JUMP;
      const partialOrGap = this.fragmentTracker.getPartialFragment(currentTime);
      if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
        if (!media.paused) {
          this._trySkipBufferHole(partialOrGap);
        }
        return;
      }
    }

    // Start tracking stall time
    const tnow = self.performance.now();
    if (stalled === null) {
      this.stalled = tnow;
      return;
    }
    const stalledDuration = tnow - stalled;
    if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) {
      // Report stalling after trying to fix
      this._reportStall(bufferInfo);
      if (!this.media) {
        return;
      }
    }
    const bufferedWithHoles = BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
    this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
  }

  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(bufferInfo, stalledDurationMs) {
    const {
      config,
      fragmentTracker,
      media
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    const partial = fragmentTracker.getPartialFragment(currentTime);
    if (partial) {
      // Try to skip over the buffer hole caused by a partial fragment
      // This method isn't limited by the size of the gap between buffered ranges
      const targetTime = this._trySkipBufferHole(partial);
      // we return here in this case, meaning
      // the branch below only executes when we haven't seeked to a new position
      if (targetTime || !this.media) {
        return;
      }
    }

    // if we haven't had to skip over a buffer hole of a partial fragment
    // we may just have to "nudge" the playlist as the browser decoding/rendering engine
    // needs to cross some sort of threshold covering all source-buffers content
    // to start playing properly.
    if ((bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && bufferInfo.nextStart - currentTime < config.maxBufferHole) && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
      logger.warn('Trying to nudge playhead over buffer-hole');
      // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
      // We only try to jump the hole if it's under the configured size
      // Reset stalled so to rearm watchdog timer
      this.stalled = null;
      this._tryNudgeBuffer();
    }
  }

  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(bufferInfo) {
    const {
      hls,
      media,
      stallReported
    } = this;
    if (!stallReported && media) {
      // Report stalled error once
      this.stallReported = true;
      const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${JSON.stringify(bufferInfo)})`);
      logger.warn(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        fatal: false,
        error,
        buffer: bufferInfo.len
      });
    }
  }

  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(partial) {
    const {
      config,
      hls,
      media
    } = this;
    if (media === null) {
      return 0;
    }

    // Check if currentTime is between unbuffered regions of partial fragments
    const currentTime = media.currentTime;
    const bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
    const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
    if (startTime) {
      const bufferStarved = bufferInfo.len <= config.maxBufferHole;
      const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
      const gapLength = startTime - currentTime;
      if (gapLength > 0 && (bufferStarved || waiting)) {
        // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
        if (gapLength > config.maxBufferHole) {
          const {
            fragmentTracker
          } = this;
          let startGap = false;
          if (currentTime === 0) {
            const startFrag = fragmentTracker.getAppendedFrag(0, PlaylistLevelType.MAIN);
            if (startFrag && startTime < startFrag.end) {
              startGap = true;
            }
          }
          if (!startGap) {
            const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, PlaylistLevelType.MAIN);
            if (startProvisioned) {
              let moreToLoad = false;
              let pos = startProvisioned.end;
              while (pos < startTime) {
                const provisioned = fragmentTracker.getPartialFragment(pos);
                if (provisioned) {
                  pos += provisioned.duration;
                } else {
                  moreToLoad = true;
                  break;
                }
              }
              if (moreToLoad) {
                return 0;
              }
            }
          }
        }
        const targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
        logger.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
        this.moved = true;
        this.stalled = null;
        media.currentTime = targetTime;
        if (partial && !partial.gap) {
          const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
          hls.trigger(Events.ERROR, {
            type: ErrorTypes.MEDIA_ERROR,
            details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
            fatal: false,
            error,
            reason: error.message,
            frag: partial
          });
        }
        return targetTime;
      }
    }
    return 0;
  }

  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config,
      hls,
      media,
      nudgeRetry
    } = this;
    if (media === null) {
      return;
    }
    const currentTime = media.currentTime;
    this.nudgeRetry++;
    if (nudgeRetry < config.nudgeMaxRetry) {
      const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
      // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
      const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
      logger.warn(error.message);
      media.currentTime = targetTime;
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
        error,
        fatal: false
      });
    } else {
      const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
      logger.error(error.message);
      hls.trigger(Events.ERROR, {
        type: ErrorTypes.MEDIA_ERROR,
        details: ErrorDetails.BUFFER_STALLED_ERROR,
        error,
        fatal: true
      });
    }
  }
}

const TICK_INTERVAL = 100; // how often to tick in ms

class StreamController extends BaseStreamController {
  constructor(hls, fragmentTracker, keyLoader) {
    super(hls, fragmentTracker, keyLoader, '[stream-controller]', PlaylistLevelType.MAIN);
    this.audioCodecSwap = false;
    this.gapController = null;
    this.level = -1;
    this._forceStartLoad = false;
    this.altAudio = false;
    this.audioOnly = false;
    this.fragPlaying = null;
    this.onvplaying = null;
    this.onvseeked = null;
    this.fragLastKbps = 0;
    this.couldBacktrack = false;
    this.backtrackFragment = null;
    this.audioCodecSwitch = false;
    this.videoBuffer = null;
    this._registerListeners();
  }
  _registerListeners() {
    const {
      hls
    } = this;
    hls.on(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.on(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.on(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.on(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.on(Events.LEVEL_LOADING, this.onLevelLoading, this);
    hls.on(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.on(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.on(Events.ERROR, this.onError, this);
    hls.on(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.on(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.on(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.on(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.on(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.on(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls
    } = this;
    hls.off(Events.MEDIA_ATTACHED, this.onMediaAttached, this);
    hls.off(Events.MEDIA_DETACHING, this.onMediaDetaching, this);
    hls.off(Events.MANIFEST_LOADING, this.onManifestLoading, this);
    hls.off(Events.MANIFEST_PARSED, this.onManifestParsed, this);
    hls.off(Events.LEVEL_LOADED, this.onLevelLoaded, this);
    hls.off(Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
    hls.off(Events.ERROR, this.onError, this);
    hls.off(Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
    hls.off(Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
    hls.off(Events.BUFFER_CREATED, this.onBufferCreated, this);
    hls.off(Events.BUFFER_FLUSHED, this.onBufferFlushed, this);
    hls.off(Events.LEVELS_UPDATED, this.onLevelsUpdated, this);
    hls.off(Events.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners();
    super.onHandlerDestroying();
  }
  startLoad(startPosition) {
    if (this.levels) {
      const {
        lastCurrentTime,
        hls
      } = this;
      this.stopLoad();
      this.setInterval(TICK_INTERVAL);
      this.level = -1;
      if (!this.startFragRequested) {
        // determine load level
        let startLevel = hls.startLevel;
        if (startLevel === -1) {
          if (hls.config.testBandwidth && this.levels.length > 1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          } else {
            startLevel = hls.firstAutoLevel;
          }
        }
        // set new level to playlist loader : this will trigger start level load
        // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
        hls.nextLoadLevel = startLevel;
        this.level = hls.loadLevel;
        this.loadedmetadata = false;
      }
      // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
      if (lastCurrentTime > 0 && startPosition === -1) {
        this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
        startPosition = lastCurrentTime;
      }
      this.state = State.IDLE;
      this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
      this.tick();
    } else {
      this._forceStartLoad = true;
      this.state = State.STOPPED;
    }
  }
  stopLoad() {
    this._forceStartLoad = false;
    super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case State.WAITING_LEVEL:
        {
          const {
            levels,
            level
          } = this;
          const currentLevel = levels == null ? void 0 : levels[level];
          const details = currentLevel == null ? void 0 : currentLevel.details;
          if (details && (!details.live || this.levelLastLoaded === currentLevel)) {
            if (this.waitForCdnTuneIn(details)) {
              break;
            }
            this.state = State.IDLE;
            break;
          } else if (this.hls.nextLoadLevel !== this.level) {
            this.state = State.IDLE;
            break;
          }
          break;
        }
      case State.FRAG_LOADING_WAITING_RETRY:
        {
          var _this$media;
          const now = self.performance.now();
          const retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
            const {
              levels,
              level
            } = this;
            const currentLevel = levels == null ? void 0 : levels[level];
            this.resetStartWhenNotLoaded(currentLevel || null);
            this.state = State.IDLE;
          }
        }
        break;
    }
    if (this.state === State.IDLE) {
      this.doTickIdle();
    }
    this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd();
    this.checkBuffer();
    this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls,
      levelLastLoaded,
      levels,
      media
    } = this;

    // if start level not parsed yet OR
    // if video not attached AND start fragment already requested OR start frag prefetch not enabled
    // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
    if (levelLastLoaded === null || !media && (this.startFragRequested || !hls.config.startFragPrefetch)) {
      return;
    }

    // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
    if (this.altAudio && this.audioOnly) {
      return;
    }
    const level = hls.nextLoadLevel;
    if (!(levels != null && levels[level])) {
      return;
    }
    const levelInfo = levels[level];

    // if buffer length is less than maxBufLen try to load a new fragment

    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null) {
      return;
    }
    const lastDetails = this.getLevelDetails();
    if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
      const data = {};
      if (this.altAudio) {
        data.type = 'video';
      }
      this.hls.trigger(Events.BUFFER_EOS, data);
      this.state = State.ENDED;
      return;
    }

    // set next load level : this will trigger a playlist load if needed
    if (hls.loadLevel !== level && hls.manualLevel === -1) {
      this.log(`Adapting to level ${level} from level ${this.level}`);
    }
    this.level = hls.nextLoadLevel = level;
    const levelDetails = levelInfo.details;
    // if level info not retrieved yet, switch state and wait for level retrieval
    // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
    // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
    if (!levelDetails || this.state === State.WAITING_LEVEL || levelDetails.live && this.levelLastLoaded !== levelInfo) {
      this.level = level;
      this.state = State.WAITING_LEVEL;
      return;
    }
    const bufferLen = bufferInfo.len;

    // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
    const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);

    // Stay idle if we are still with buffer margins
    if (bufferLen >= maxBufLen) {
      return;
    }
    if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) {
      this.backtrackFragment = null;
    }
    const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
    let frag = this.getNextFragment(targetBufferTime, levelDetails);
    // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
    if (this.couldBacktrack && !this.fragPrevious && frag && frag.sn !== 'initSegment' && this.fragmentTracker.getState(frag) !== FragmentState.OK) {
      var _this$backtrackFragme;
      const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
      const fragIdx = backtrackSn - levelDetails.startSN;
      const backtrackFrag = levelDetails.fragments[fragIdx - 1];
      if (backtrackFrag && frag.cc === backtrackFrag.cc) {
        frag = backtrackFrag;
        this.fragmentTracker.removeFragment(backtrackFrag);
      }
    } else if (this.backtrackFragment && bufferInfo.len) {
      this.backtrackFragment = null;
    }
    // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
    if (frag && this.isLoopLoading(frag, targetBufferTime)) {
      const gapStart = frag.gap;
      if (!gapStart) {
        // Cleanup the fragment tracker before trying to find the next unbuffered fragment
        const type = this.audioOnly && !this.altAudio ? ElementaryStreamTypes.AUDIO : ElementaryStreamTypes.VIDEO;
        const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        if (mediaBuffer) {
          this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
        }
      }
      frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, PlaylistLevelType.MAIN, maxBufLen);
    }
    if (!frag) {
      return;
    }
    if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) {
      frag = frag.initSegment;
    }
    this.loadFragment(frag, levelInfo, targetBufferTime);
  }
  loadFragment(frag, level, targetBufferTime) {
    // Check if fragment is not loaded
    const fragState = this.fragmentTracker.getState(frag);
    this.fragCurrent = frag;
    if (fragState === FragmentState.NOT_LOADED || fragState === FragmentState.PARTIAL) {
      if (frag.sn === 'initSegment') {
        this._loadInitSegment(frag, level);
      } else if (this.bitrateTest) {
        this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
        this._loadBitrateTestFrag(frag, level);
      } else {
        this.startFragRequested = true;
        super.loadFragment(frag, level, targetBufferTime);
      }
    } else {
      this.clearTrackerIfNeeded(frag);
    }
  }
  getBufferedFrag(position) {
    return this.fragmentTracker.getBufferedFrag(position, PlaylistLevelType.MAIN);
  }
  followingBufferedFrag(frag) {
    if (frag) {
      // try to get range of next fragment (500ms after this range)
      return this.getBufferedFrag(frag.end + 0.5);
    }
    return null;
  }

  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag();
    this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }

  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels,
      media
    } = this;
    // ensure that media is defined and that metadata are available (to retrieve currentTime)
    if (media != null && media.readyState) {
      let fetchdelay;
      const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
      if (fragPlayingCurrent && fragPlayingCurrent.start > 1) {
        // flush buffer preceding current fragment (flush until current fragment start offset)
        // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
        this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
      }
      const levelDetails = this.getLevelDetails();
      if (levelDetails != null && levelDetails.live) {
        const bufferInfo = this.getMainFwdBufferInfo();
        // Do not flush in live stream with low buffer
        if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) {
          return;
        }
      }
      if (!media.paused && levels) {
        // add a safety delay of 1s
        const nextLevelId = this.hls.nextLoadLevel;
        const nextLevel = levels[nextLevelId];
        const fragLastKbps = this.fragLastKbps;
        if (fragLastKbps && this.fragCurrent) {
          fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
        } else {
          fetchdelay = 0;
        }
      } else {
        fetchdelay = 0;
      }
      // this.log('fetchdelay:'+fetchdelay);
      // find buffer range that will be reached once new fragment will be fetched
      const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
      if (bufferedFrag) {
        // we can flush buffer range following this one without stalling playback
        const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
        if (nextBufferedFrag) {
          // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
          this.abortCurrentFrag();
          // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
          const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
          const fragDuration = nextBufferedFrag.duration;
          const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const fragCurrent = this.fragCurrent;
    this.fragCurrent = null;
    this.backtrackFragment = null;
    if (fragCurrent) {
      fragCurrent.abortRequests();
      this.fragmentTracker.removeFragment(fragCurrent);
    }
    switch (this.state) {
      case State.KEY_LOADING:
      case State.FRAG_LOADING:
      case State.FRAG_LOADING_WAITING_RETRY:
      case State.PARSING:
      case State.PARSED:
        this.state = State.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(startOffset, endOffset) {
    super.flushMainBuffer(startOffset, endOffset, this.altAudio ? 'video' : null);
  }
  onMediaAttached(event, data) {
    super.onMediaAttached(event, data);
    const media = data.media;
    this.onvplaying = this.onMediaPlaying.bind(this);
    this.onvseeked = this.onMediaSeeked.bind(this);
    media.addEventListener('playing', this.onvplaying);
    media.addEventListener('seeked', this.onvseeked);
    this.gapController = new GapController(this.config, media, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media
    } = this;
    if (media && this.onvplaying && this.onvseeked) {
      media.removeEventListener('playing', this.onvplaying);
      media.removeEventListener('seeked', this.onvseeked);
      this.onvplaying = this.onvseeked = null;
      this.videoBuffer = null;
    }
    this.fragPlaying = null;
    if (this.gapController) {
      this.gapController.destroy();
      this.gapController = null;
    }
    super.onMediaDetaching();
  }
  onMediaPlaying() {
    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onMediaSeeked() {
    const media = this.media;
    const currentTime = media ? media.currentTime : null;
    if (isFiniteNumber(currentTime)) {
      this.log(`Media seeked to ${currentTime.toFixed(3)}`);
    }

    // If seeked was issued before buffer was appended do not tick immediately
    const bufferInfo = this.getMainFwdBufferInfo();
    if (bufferInfo === null || bufferInfo.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
      return;
    }

    // tick to speed up FRAG_CHANGED triggering
    this.tick();
  }
  onManifestLoading() {
    // reset buffer on manifest loading
    this.log('Trigger BUFFER_RESET');
    this.hls.trigger(Events.BUFFER_RESET, undefined);
    this.fragmentTracker.removeAllFragments();
    this.couldBacktrack = false;
    this.startPosition = this.lastCurrentTime = this.fragLastKbps = 0;
    this.levels = this.fragPlaying = this.backtrackFragment = this.levelLastLoaded = null;
    this.altAudio = this.audioOnly = this.startFragRequested = false;
  }
  onManifestParsed(event, data) {
    // detect if we have different kind of audio codecs used amongst playlists
    let aac = false;
    let heaac = false;
    data.levels.forEach(level => {
      const codec = level.audioCodec;
      if (codec) {
        aac = aac || codec.indexOf('mp4a.40.2') !== -1;
        heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
      }
    });
    this.audioCodecSwitch = aac && heaac && !changeTypeSupported();
    if (this.audioCodecSwitch) {
      this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
    }
    this.levels = data.levels;
    this.startFragRequested = false;
  }
  onLevelLoading(event, data) {
    const {
      levels
    } = this;
    if (!levels || this.state !== State.IDLE) {
      return;
    }
    const level = levels[data.level];
    if (!level.details || level.details.live && this.levelLastLoaded !== level || this.waitForCdnTuneIn(level.details)) {
      this.state = State.WAITING_LEVEL;
    }
  }
  onLevelLoaded(event, data) {
    var _curLevel$details;
    const {
      levels
    } = this;
    const newLevelId = data.level;
    const newDetails = data.details;
    const duration = newDetails.totalduration;
    if (!levels) {
      this.warn(`Levels were reset while loading level ${newLevelId}`);
      return;
    }
    this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
    const curLevel = levels[newLevelId];
    const fragCurrent = this.fragCurrent;
    if (fragCurrent && (this.state === State.FRAG_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY)) {
      if (fragCurrent.level !== data.level && fragCurrent.loader) {
        this.abortCurrentFrag();
      }
    }
    let sliding = 0;
    if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
      var _this$levelLastLoaded;
      this.checkLiveUpdate(newDetails);
      if (newDetails.deltaUpdateFailed) {
        return;
      }
      sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
    }
    // override level info
    curLevel.details = newDetails;
    this.levelLastLoaded = curLevel;
    this.hls.trigger(Events.LEVEL_UPDATED, {
      details: newDetails,
      level: newLevelId
    });

    // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
    if (this.state === State.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(newDetails)) {
        // Wait for Low-Latency CDN Tune-in
        return;
      }
      this.state = State.IDLE;
    }
    if (!this.startFragRequested) {
      this.setStartPosition(newDetails, sliding);
    } else if (newDetails.live) {
      this.synchronizeToLiveEdge(newDetails);
    }

    // trigger handler right now
    this.tick();
  }
  _handleFragmentLoadProgress(data) {
    var _frag$initSegment;
    const {
      frag,
      part,
      payload
    } = data;
    const {
      levels
    } = this;
    if (!levels) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
      return;
    }
    const currentLevel = levels[frag.level];
    const details = currentLevel.details;
    if (!details) {
      this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    const videoCodec = currentLevel.videoCodec;

    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
    const accurateTimeOffset = details.PTSKnown || !details.live;
    const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
    const audioCodec = this._getAudioCodec(currentLevel);

    // transmux the MPEG-TS data to ISO-BMFF segments
    // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
    const transmuxer = this.transmuxer = this.transmuxer || new TransmuxerInterface(this.hls, PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
    const partIndex = part ? part.index : -1;
    const partial = partIndex !== -1;
    const chunkMeta = new ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
    const initPTS = this.initPTS[frag.cc];
    transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
  }
  onAudioTrackSwitching(event, data) {
    // if any URL found on new audio track, it is an alternate audio track
    const fromAltAudio = this.altAudio;
    const altAudio = !!data.url;
    // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
    // don't do anything if we switch to alt audio: audio stream controller is handling it.
    // we will just have to change buffer scheduling on audioTrackSwitched
    if (!altAudio) {
      if (this.mediaBuffer !== this.media) {
        this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
        this.mediaBuffer = this.media;
        const fragCurrent = this.fragCurrent;
        // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
        if (fragCurrent) {
          this.log('Switching to main audio track, cancel main fragment load');
          fragCurrent.abortRequests();
          this.fragmentTracker.removeFragment(fragCurrent);
        }
        // destroy transmuxer to force init segment generation (following audio switch)
        this.resetTransmuxer();
        // switch to IDLE state to load new fragment
        this.resetLoadingState();
      } else if (this.audioOnly) {
        // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
        this.resetTransmuxer();
      }
      const hls = this.hls;
      // If switching from alt to main audio, flush all audio and trigger track switched
      if (fromAltAudio) {
        hls.trigger(Events.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        this.fragmentTracker.removeAllFragments();
      }
      hls.trigger(Events.AUDIO_TRACK_SWITCHED, data);
    }
  }
  onAudioTrackSwitched(event, data) {
    const trackId = data.id;
    const altAudio = !!this.hls.audioTracks[trackId].url;
    if (altAudio) {
      const videoBuffer = this.videoBuffer;
      // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
      if (videoBuffer && this.mediaBuffer !== videoBuffer) {
        this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
        this.mediaBuffer = videoBuffer;
      }
    }
    this.altAudio = altAudio;
    this.tick();
  }
  onBufferCreated(event, data) {
    const tracks = data.tracks;
    let mediaTrack;
    let name;
    let alternate = false;
    for (const type in tracks) {
      const track = tracks[type];
      if (track.id === 'main') {
        name = type;
        mediaTrack = track;
        // keep video source buffer reference
        if (type === 'video') {
          const videoTrack = tracks[type];
          if (videoTrack) {
            this.videoBuffer = videoTrack.buffer;
          }
        }
      } else {
        alternate = true;
      }
    }
    if (alternate && mediaTrack) {
      this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
      this.mediaBuffer = mediaTrack.buffer;
    } else {
      this.mediaBuffer = this.media;
    }
  }
  onFragBuffered(event, data) {
    const {
      frag,
      part
    } = data;
    if (frag && frag.type !== PlaylistLevelType.MAIN) {
      return;
    }
    if (this.fragContextChanged(frag)) {
      // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
      // Avoid setting state back to IDLE, since that will interfere with a level switch
      this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
      if (this.state === State.PARSED) {
        this.state = State.IDLE;
      }
      return;
    }
    const stats = part ? part.stats : frag.stats;
    this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
    if (frag.sn !== 'initSegment') {
      this.fragPrevious = frag;
    }
    this.fragBufferedComplete(frag, part);
  }
  onError(event, data) {
    var _data$context;
    if (data.fatal) {
      this.state = State.ERROR;
      return;
    }
    switch (data.details) {
      case ErrorDetails.FRAG_GAP:
      case ErrorDetails.FRAG_PARSING_ERROR:
      case ErrorDetails.FRAG_DECRYPT_ERROR:
      case ErrorDetails.FRAG_LOAD_ERROR:
      case ErrorDetails.FRAG_LOAD_TIMEOUT:
      case ErrorDetails.KEY_LOAD_ERROR:
      case ErrorDetails.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(PlaylistLevelType.MAIN, data);
        break;
      case ErrorDetails.LEVEL_LOAD_ERROR:
      case ErrorDetails.LEVEL_LOAD_TIMEOUT:
      case ErrorDetails.LEVEL_PARSING_ERROR:
        // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
        if (!data.levelRetry && this.state === State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === PlaylistContextType.LEVEL) {
          this.state = State.IDLE;
        }
        break;
      case ErrorDetails.BUFFER_APPEND_ERROR:
      case ErrorDetails.BUFFER_FULL_ERROR:
        if (!data.parent || data.parent !== 'main') {
          return;
        }
        if (data.details === ErrorDetails.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        if (this.reduceLengthAndFlushBuffer(data)) {
          this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        }
        break;
      case ErrorDetails.INTERNAL_EXCEPTION:
        this.recoverWorkerError(data);
        break;
    }
  }

  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media,
      gapController
    } = this;
    if (!media || !gapController || !media.readyState) {
      // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
      return;
    }
    if (this.loadedmetadata || !BufferHelper.getBuffered(media).length) {
      // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
      const activeFrag = this.state !== State.IDLE ? this.fragCurrent : null;
      gapController.poll(this.lastCurrentTime, activeFrag);
    }
    this.lastCurrentTime = media.currentTime;
  }
  onFragLoadEmergencyAborted() {
    this.state = State.IDLE;
    // if loadedmetadata is not set, it means that we are emergency switch down on first frag
    // in that case, reset startFragRequested flag
    if (!this.loadedmetadata) {
      this.startFragRequested = false;
      this.nextLoadPosition = this.startPosition;
    }
    this.tickImmediate();
  }
  onBufferFlushed(event, {
    type
  }) {
    if (type !== ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
      const mediaBuffer = (type === ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(mediaBuffer, type, PlaylistLevelType.MAIN);
      this.tick();
    }
  }
  onLevelsUpdated(event, data) {
    if (this.level > -1 && this.fragCurrent) {
      this.level = this.fragCurrent.level;
    }
    this.levels = data.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }

  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media
    } = this;
    if (!media) {
      return;
    }
    const currentTime = media.currentTime;
    let startPosition = this.startPosition;
    // only adjust currentTime if different from startPosition or if startPosition not buffered
    // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
    if (startPosition >= 0 && currentTime < startPosition) {
      if (media.seeking) {
        this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
        return;
      }
      const buffered = BufferHelper.getBuffered(media);
      const bufferStart = buffered.length ? buffered.start(0) : 0;
      const delta = bufferStart - startPosition;
      if (delta > 0 && (delta < this.config.maxBufferHole || delta < this.config.maxFragLookUpTolerance)) {
        this.log(`adjusting start position by ${delta} to match buffer start`);
        startPosition += delta;
        this.startPosition = startPosition;
      }
      this.log(`seek to target start position ${startPosition} from current time ${currentTime}`);
      media.currentTime = startPosition;
    }
  }
  _getAudioCodec(currentLevel) {
    let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
    if (this.audioCodecSwap && audioCodec) {
      this.log('Swapping audio codec');
      if (audioCodec.indexOf('mp4a.40.5') !== -1) {
        audioCodec = 'mp4a.40.2';
      } else {
        audioCodec = 'mp4a.40.5';
      }
    }
    return audioCodec;
  }
  _loadBitrateTestFrag(frag, level) {
    frag.bitrateTest = true;
    this._doFragLoad(frag, level).then(data => {
      const {
        hls
      } = this;
      if (!data || this.fragContextChanged(frag)) {
        return;
      }
      level.fragmentError = 0;
      this.state = State.IDLE;
      this.startFragRequested = false;
      this.bitrateTest = false;
      const stats = frag.stats;
      // Bitrate tests fragments are neither parsed nor buffered
      stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
      hls.trigger(Events.FRAG_LOADED, data);
      frag.bitrateTest = false;
    });
  }
  _handleTransmuxComplete(transmuxResult) {
    var _id3$samples;
    const id = 'main';
    const {
      hls
    } = this;
    const {
      remuxResult,
      chunkMeta
    } = transmuxResult;
    const context = this.getCurrentContext(chunkMeta);
    if (!context) {
      this.resetWhenMissingContext(chunkMeta);
      return;
    }
    const {
      frag,
      part,
      level
    } = context;
    const {
      video,
      text,
      id3,
      initSegment
    } = remuxResult;
    const {
      details
    } = level;
    // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
    const audio = this.altAudio ? undefined : remuxResult.audio;

    // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
    // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
    if (this.fragContextChanged(frag)) {
      this.fragmentTracker.removeFragment(frag);
      return;
    }
    this.state = State.PARSING;
    if (initSegment) {
      if (initSegment != null && initSegment.tracks) {
        const mapFragment = frag.initSegment || frag;
        this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
        hls.trigger(Events.FRAG_PARSING_INIT_SEGMENT, {
          frag: mapFragment,
          id,
          tracks: initSegment.tracks
        });
      }

      // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
      const initPTS = initSegment.initPTS;
      const timescale = initSegment.timescale;
      if (isFiniteNumber(initPTS)) {
        this.initPTS[frag.cc] = {
          baseTime: initPTS,
          timescale
        };
        hls.trigger(Events.INIT_PTS_FOUND, {
          frag,
          id,
          initPTS,
          timescale
        });
      }
    }

    // Avoid buffering if backtracking this fragment
    if (video && details && frag.sn !== 'initSegment') {
      const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
      const isFirstFragment = frag.sn === details.startSN;
      const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
      if (remuxResult.independent !== false) {
        const {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        } = video;
        if (part) {
          part.elementaryStreams[video.type] = {
            startPTS,
            endPTS,
            startDTS,
            endDTS
          };
        } else {
          if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) {
            this.couldBacktrack = true;
          }
          if (video.dropped && video.independent) {
            // Backtrack if dropped frames create a gap after currentTime

            const bufferInfo = this.getMainFwdBufferInfo();
            const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
            const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
            if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
              this.backtrack(frag);
              return;
            } else if (isFirstInDiscontinuity) {
              // Mark segment with a gap to avoid loop loading
              frag.gap = true;
            }
            // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
            frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
          } else if (isFirstFragment && startPTS > MAX_START_GAP_JUMP) {
            // Mark segment with a gap to skip large start gap
            frag.gap = true;
          }
        }
        frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
        if (this.backtrackFragment) {
          this.backtrackFragment = frag;
        }
        this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
      } else if (isFirstFragment || isFirstInDiscontinuity) {
        // Mark segment with a gap to avoid loop loading
        frag.gap = true;
      } else {
        this.backtrack(frag);
        return;
      }
    }
    if (audio) {
      const {
        startPTS,
        endPTS,
        startDTS,
        endDTS
      } = audio;
      if (part) {
        part.elementaryStreams[ElementaryStreamTypes.AUDIO] = {
          startPTS,
          endPTS,
          startDTS,
          endDTS
        };
      }
      frag.setElementaryStreamInfo(ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
      this.bufferFragmentData(audio, frag, part, chunkMeta);
    }
    if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
      const emittedID3 = {
        id,
        frag,
        details,
        samples: id3.samples
      };
      hls.trigger(Events.FRAG_PARSING_METADATA, emittedID3);
    }
    if (details && text) {
      const emittedText = {
        id,
        frag,
        details,
        samples: text.samples
      };
      hls.trigger(Events.FRAG_PARSING_USERDATA, emittedText);
    }
  }
  _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
    if (this.state !== State.PARSING) {
      return;
    }
    this.audioOnly = !!tracks.audio && !tracks.video;

    // if audio track is expected to come from audio stream controller, discard any coming from main
    if (this.altAudio && !this.audioOnly) {
      delete tracks.audio;
    }
    // include levelCodec in audio and video tracks
    const {
      audio,
      video,
      audiovideo
    } = tracks;
    if (audio) {
      let audioCodec = currentLevel.audioCodec;
      const ua = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        if (audioCodec) {
          if (audioCodec.indexOf('mp4a.40.5') !== -1) {
            audioCodec = 'mp4a.40.2';
          } else {
            audioCodec = 'mp4a.40.5';
          }
        }
        // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
        // force HE-AAC, as it seems that most browsers prefers it.
        // don't force HE-AAC if mono stream, or in Firefox
        const audioMetadata = audio.metadata;
        if (audioMetadata && 'channelCount' in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf('firefox') === -1) {
          audioCodec = 'mp4a.40.5';
        }
      }
      // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
      if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
        // Exclude mpeg audio
        audioCodec = 'mp4a.40.2';
        this.log(`Android: force audio codec to ${audioCodec}`);
      }
      if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) {
        this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
      }
      audio.levelCodec = audioCodec;
      audio.id = 'main';
      this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
    }
    if (video) {
      video.levelCodec = currentLevel.videoCodec;
      video.id = 'main';
      this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${video.codec}]`);
    }
    if (audiovideo) {
      this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
    }
    this.hls.trigger(Events.BUFFER_CODECS, tracks);
    // loop through tracks that are going to be provided to bufferController
    Object.keys(tracks).forEach(trackName => {
      const track = tracks[trackName];
      const initSegment = track.initSegment;
      if (initSegment != null && initSegment.byteLength) {
        this.hls.trigger(Events.BUFFER_APPENDING, {
          type: trackName,
          data: initSegment,
          frag,
          part: null,
          chunkMeta,
          parent: frag.type
        });
      }
    });
    // trigger handler right now
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, PlaylistLevelType.MAIN);
  }
  backtrack(frag) {
    this.couldBacktrack = true;
    // Causes findFragments to backtrack through fragments to find the keyframe
    this.backtrackFragment = frag;
    this.resetTransmuxer();
    this.flushBufferGap(frag);
    this.fragmentTracker.removeFragment(frag);
    this.fragPrevious = null;
    this.nextLoadPosition = frag.start;
    this.state = State.IDLE;
  }
  checkFragmentChanged() {
    const video = this.media;
    let fragPlayingCurrent = null;
    if (video && video.readyState > 1 && video.seeking === false) {
      const currentTime = video.currentTime;
      /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */

      if (BufferHelper.isBuffered(video, currentTime)) {
        fragPlayingCurrent = this.getAppendedFrag(currentTime);
      } else if (BufferHelper.isBuffered(video, currentTime + 0.1)) {
        /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */
        fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
      }
      if (fragPlayingCurrent) {
        this.backtrackFragment = null;
        const fragPlaying = this.fragPlaying;
        const fragCurrentLevel = fragPlayingCurrent.level;
        if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
          this.fragPlaying = fragPlayingCurrent;
          this.hls.trigger(Events.FRAG_CHANGED, {
            frag: fragPlayingCurrent
          });
          if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) {
            this.hls.trigger(Events.LEVEL_SWITCHED, {
              level: fragCurrentLevel
            });
          }
        }
      }
    }
  }
  get nextLevel() {
    const frag = this.nextBufferedFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get currentFrag() {
    const media = this.media;
    if (media) {
      return this.fragPlaying || this.getAppendedFrag(media.currentTime);
    }
    return null;
  }
  get currentProgramDateTime() {
    const media = this.media;
    if (media) {
      const currentTime = media.currentTime;
      const frag = this.currentFrag;
      if (frag && isFiniteNumber(currentTime) && isFiniteNumber(frag.programDateTime)) {
        const epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
        return new Date(epocMs);
      }
    }
    return null;
  }
  get currentLevel() {
    const frag = this.currentFrag;
    if (frag) {
      return frag.level;
    }
    return -1;
  }
  get nextBufferedFrag() {
    const frag = this.currentFrag;
    if (frag) {
      return this.followingBufferedFrag(frag);
    }
    return null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}

/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */
class Hls {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return "1.5.14";
  }

  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return isMSESupported();
  }

  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return isSupported();
  }

  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return getMediaSource();
  }
  static get Events() {
    return Events;
  }
  static get ErrorTypes() {
    return ErrorTypes;
  }
  static get ErrorDetails() {
    return ErrorDetails;
  }

  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    if (!Hls.defaultConfig) {
      return hlsDefaultConfig;
    }
    return Hls.defaultConfig;
  }

  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(defaultConfig) {
    Hls.defaultConfig = defaultConfig;
  }

  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(userConfig = {}) {
    /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */
    this.config = void 0;
    /**
     * The configuration object provided on player instantiation.
     */
    this.userConfig = void 0;
    this.coreComponents = void 0;
    this.networkControllers = void 0;
    this.started = false;
    this._emitter = new EventEmitter();
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    this.abrController = void 0;
    this.bufferController = void 0;
    this.capLevelController = void 0;
    this.latencyController = void 0;
    this.levelController = void 0;
    this.streamController = void 0;
    this.audioTrackController = void 0;
    this.subtitleTrackController = void 0;
    this.emeController = void 0;
    this.cmcdController = void 0;
    this._media = null;
    this.url = null;
    this.triggeringException = void 0;
    enableLogs(userConfig.debug || false, 'Hls instance');
    const config = this.config = mergeConfig(Hls.DefaultConfig, userConfig);
    this.userConfig = userConfig;
    if (config.progressive) {
      enableStreamingMode(config);
    }

    // core controllers and network loaders
    const {
      abrController: ConfigAbrController,
      bufferController: ConfigBufferController,
      capLevelController: ConfigCapLevelController,
      errorController: ConfigErrorController,
      fpsController: ConfigFpsController
    } = config;
    const errorController = new ConfigErrorController(this);
    const abrController = this.abrController = new ConfigAbrController(this);
    const bufferController = this.bufferController = new ConfigBufferController(this);
    const capLevelController = this.capLevelController = new ConfigCapLevelController(this);
    const fpsController = new ConfigFpsController(this);
    const playListLoader = new PlaylistLoader(this);
    const id3TrackController = new ID3TrackController(this);
    const ConfigContentSteeringController = config.contentSteeringController;
    // ConentSteeringController is defined before LevelController to receive Multivariant Playlist events first
    const contentSteering = ConfigContentSteeringController ? new ConfigContentSteeringController(this) : null;
    const levelController = this.levelController = new LevelController(this, contentSteering);
    // FragmentTracker must be defined before StreamController because the order of event handling is important
    const fragmentTracker = new FragmentTracker(this);
    const keyLoader = new KeyLoader(this.config);
    const streamController = this.streamController = new StreamController(this, fragmentTracker, keyLoader);

    // Cap level controller uses streamController to flush the buffer
    capLevelController.setStreamController(streamController);
    // fpsController uses streamController to switch when frames are being dropped
    fpsController.setStreamController(streamController);
    const networkControllers = [playListLoader, levelController, streamController];
    if (contentSteering) {
      networkControllers.splice(1, 0, contentSteering);
    }
    this.networkControllers = networkControllers;
    const coreComponents = [abrController, bufferController, capLevelController, fpsController, id3TrackController, fragmentTracker];
    this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
    const AudioStreamControllerClass = config.audioStreamController;
    if (AudioStreamControllerClass) {
      networkControllers.push(new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    // subtitleTrackController must be defined before subtitleStreamController because the order of event handling is important
    this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
    const SubtitleStreamControllerClass = config.subtitleStreamController;
    if (SubtitleStreamControllerClass) {
      networkControllers.push(new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
    }
    this.createController(config.timelineController, coreComponents);
    keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
    this.cmcdController = this.createController(config.cmcdController, coreComponents);
    this.latencyController = this.createController(LatencyController, coreComponents);
    this.coreComponents = coreComponents;

    // Error controller handles errors before and after all other controllers
    // This listener will be invoked after all other controllers error listeners
    networkControllers.push(errorController);
    const onErrorOut = errorController.onErrorOut;
    if (typeof onErrorOut === 'function') {
      this.on(Events.ERROR, onErrorOut, errorController);
    }
  }
  createController(ControllerClass, components) {
    if (ControllerClass) {
      const controllerInstance = new ControllerClass(this);
      if (components) {
        components.push(controllerInstance);
      }
      return controllerInstance;
    }
    return null;
  }

  // Delegate the EventEmitter through the public API of Hls.js
  on(event, listener, context = this) {
    this._emitter.on(event, listener, context);
  }
  once(event, listener, context = this) {
    this._emitter.once(event, listener, context);
  }
  removeAllListeners(event) {
    this._emitter.removeAllListeners(event);
  }
  off(event, listener, context = this, once) {
    this._emitter.off(event, listener, context, once);
  }
  listeners(event) {
    return this._emitter.listeners(event);
  }
  emit(event, name, eventObject) {
    return this._emitter.emit(event, name, eventObject);
  }
  trigger(event, eventObject) {
    if (this.config.debug) {
      return this.emit(event, event, eventObject);
    } else {
      try {
        return this.emit(event, event, eventObject);
      } catch (error) {
        logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
        // Prevent recursion in error event handlers that throw #5497
        if (!this.triggeringException) {
          this.triggeringException = true;
          const fatal = event === Events.ERROR;
          this.trigger(Events.ERROR, {
            type: ErrorTypes.OTHER_ERROR,
            details: ErrorDetails.INTERNAL_EXCEPTION,
            fatal,
            event,
            error
          });
          this.triggeringException = false;
        }
      }
    }
    return false;
  }
  listenerCount(event) {
    return this._emitter.listenerCount(event);
  }

  /**
   * Dispose of the instance
   */
  destroy() {
    logger.log('destroy');
    this.trigger(Events.DESTROYING, undefined);
    this.detachMedia();
    this.removeAllListeners();
    this._autoLevelCapping = -1;
    this.url = null;
    this.networkControllers.forEach(component => component.destroy());
    this.networkControllers.length = 0;
    this.coreComponents.forEach(component => component.destroy());
    this.coreComponents.length = 0;
    // Remove any references that could be held in config options or callbacks
    const config = this.config;
    config.xhrSetup = config.fetchSetup = undefined;
    // @ts-ignore
    this.userConfig = null;
  }

  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(media) {
    logger.log('attachMedia');
    this._media = media;
    this.trigger(Events.MEDIA_ATTACHING, {
      media: media
    });
  }

  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    logger.log('detachMedia');
    this.trigger(Events.MEDIA_DETACHING, undefined);
    this._media = null;
  }

  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(url) {
    this.stopLoad();
    const media = this.media;
    const loadedSource = this.url;
    const loadingSource = this.url = urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
      alwaysNormalize: true
    });
    this._autoLevelCapping = -1;
    this._maxHdcpLevel = null;
    logger.log(`loadSource:${loadingSource}`);
    if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
      this.detachMedia();
      this.attachMedia(media);
    }
    // when attaching to a source URL, trigger a playlist load
    this.trigger(Events.MANIFEST_LOADING, {
      url: url
    });
  }

  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(startPosition = -1) {
    logger.log(`startLoad(${startPosition})`);
    this.started = true;
    this.networkControllers.forEach(controller => {
      controller.startLoad(startPosition);
    });
  }

  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    logger.log('stopLoad');
    this.started = false;
    this.networkControllers.forEach(controller => {
      controller.stopLoad();
    });
  }

  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    if (this.started) {
      this.networkControllers.forEach(controller => {
        if ('fragmentLoader' in controller) {
          controller.startLoad(-1);
        }
      });
    }
  }

  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach(controller => {
      if ('fragmentLoader' in controller) {
        controller.stopLoad();
      }
    });
  }

  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    logger.log('swapAudioCodec');
    this.streamController.swapAudioCodec();
  }

  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    logger.log('recoverMediaError');
    const media = this._media;
    this.detachMedia();
    if (media) {
      this.attachMedia(media);
    }
  }
  removeLevel(levelIndex) {
    this.levelController.removeLevel(levelIndex);
  }

  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const levels = this.levelController.levels;
    return levels ? levels : [];
  }

  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }

  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(newLevel) {
    logger.log(`set currentLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.immediateLevelSwitch();
  }

  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }

  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(newLevel) {
    logger.log(`set nextLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
    this.streamController.nextLevelSwitch();
  }

  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }

  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(newLevel) {
    logger.log(`set loadLevel:${newLevel}`);
    this.levelController.manualLevel = newLevel;
  }

  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }

  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(level) {
    this.levelController.nextLoadLevel = level;
  }

  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }

  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(newLevel) {
    logger.log(`set firstLevel:${newLevel}`);
    this.levelController.firstLevel = newLevel;
  }

  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const startLevel = this.levelController.startLevel;
    if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) {
      return this.abrController.forcedAutoLevel;
    }
    return startLevel;
  }

  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(newLevel) {
    logger.log(`set startLevel:${newLevel}`);
    // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
    if (newLevel !== -1) {
      newLevel = Math.max(newLevel, this.minAutoLevel);
    }
    this.levelController.startLevel = newLevel;
  }

  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }

  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(shouldStartCapping) {
    const newCapLevelToPlayerSize = !!shouldStartCapping;
    if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
      if (newCapLevelToPlayerSize) {
        this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
      } else {
        this.capLevelController.stopCapping();
        this.autoLevelCapping = -1;
        this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
      }
      this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
    }
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }

  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimate();
  }
  set bandwidthEstimate(abrEwmaDefaultEstimate) {
    this.abrController.resetEstimator(abrEwmaDefaultEstimate);
  }

  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator
    } = this.abrController;
    if (!bwEstimator) {
      return NaN;
    }
    return bwEstimator.getEstimateTTFB();
  }

  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(newLevel) {
    if (this._autoLevelCapping !== newLevel) {
      logger.log(`set autoLevelCapping:${newLevel}`);
      this._autoLevelCapping = newLevel;
      this.levelController.checkMaxAutoUpdated();
    }
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(value) {
    if (isHdcpLevel(value) && this._maxHdcpLevel !== value) {
      this._maxHdcpLevel = value;
      this.levelController.checkMaxAutoUpdated();
    }
  }

  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }

  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }

  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels,
      config: {
        minAutoBitrate
      }
    } = this;
    if (!levels) return 0;
    const len = levels.length;
    for (let i = 0; i < len; i++) {
      if (levels[i].maxBitrate >= minAutoBitrate) {
        return i;
      }
    }
    return 0;
  }

  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels,
      autoLevelCapping,
      maxHdcpLevel
    } = this;
    let maxAutoLevel;
    if (autoLevelCapping === -1 && levels != null && levels.length) {
      maxAutoLevel = levels.length - 1;
    } else {
      maxAutoLevel = autoLevelCapping;
    }
    if (maxHdcpLevel) {
      for (let i = maxAutoLevel; i--;) {
        const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
        if (hdcpLevel && hdcpLevel <= maxHdcpLevel) {
          return i;
        }
      }
    }
    return maxAutoLevel;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }

  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }

  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(nextLevel) {
    this.abrController.nextAutoLevel = nextLevel;
  }

  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }

  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(audioOption) {
    var _this$audioTrackContr;
    return (_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption);
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(subtitleOption) {
    var _this$subtitleTrackCo;
    (_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption);
    return null;
  }

  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.allAudioTracks : [];
  }

  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTracks : [];
  }

  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const audioTrackController = this.audioTrackController;
    return audioTrackController ? audioTrackController.audioTrack : -1;
  }

  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(audioTrackId) {
    const audioTrackController = this.audioTrackController;
    if (audioTrackController) {
      audioTrackController.audioTrack = audioTrackId;
    }
  }

  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
  }

  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
  }

  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }

  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(subtitleTrackId) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
  }

  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const subtitleTrackController = this.subtitleTrackController;
    return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
  }

  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(value) {
    const subtitleTrackController = this.subtitleTrackController;
    if (subtitleTrackController) {
      subtitleTrackController.subtitleDisplay = value;
    }
  }

  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }

  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(mode) {
    this.config.lowLatencyMode = mode;
  }

  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }

  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }

  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }

  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }

  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }

  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
Hls.defaultConfig = void 0;

var hls = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbrController: AbrController,
  AttrList: AttrList,
  AudioStreamController: AudioStreamController,
  AudioTrackController: AudioTrackController,
  BasePlaylistController: BasePlaylistController,
  BaseSegment: BaseSegment,
  BaseStreamController: BaseStreamController,
  BufferController: BufferController,
  CMCDController: CMCDController,
  CapLevelController: CapLevelController,
  ChunkMetadata: ChunkMetadata,
  ContentSteeringController: ContentSteeringController,
  DateRange: DateRange,
  EMEController: EMEController,
  ErrorActionFlags: ErrorActionFlags,
  ErrorController: ErrorController,
  ErrorDetails: ErrorDetails,
  ErrorTypes: ErrorTypes,
  Events: Events,
  FPSController: FPSController,
  Fragment: Fragment,
  Hls: Hls,
  HlsSkip: HlsSkip,
  HlsUrlParameters: HlsUrlParameters,
  KeySystemFormats: KeySystemFormats,
  KeySystems: KeySystems,
  Level: Level,
  LevelDetails: LevelDetails,
  LevelKey: LevelKey,
  LoadStats: LoadStats,
  MetadataSchema: MetadataSchema,
  NetworkErrorAction: NetworkErrorAction,
  Part: Part,
  PlaylistLevelType: PlaylistLevelType,
  SubtitleStreamController: SubtitleStreamController,
  SubtitleTrackController: SubtitleTrackController,
  TimelineController: TimelineController,
  default: Hls,
  getMediaSource: getMediaSource,
  isMSESupported: isMSESupported,
  isSupported: isSupported
});

export { API_AUTOCOMPLETE_HOST, AppDownloadPopupWithQR, BadgeList, Badges, BlockedPage, COUPON_PUBLISH_DONE_MESSAGE, CUSTOM_COUPON_PUBLISH_MESSAGE, CardFeedItem, CardFeedItemPlaceholder, CardPlaceholder, ChangeLanguageButton, ChipListModule, CommerceProductCard, Container$n as Container, ContentFeedItem, ContentFeedItemPlaceholder, DEEP_LINK_HOST, DEFAULT_OG_IMAGE, DELIVERY_PAYMENT, DELIVERY_SERVICE_CODE, DELIVERY_TARGET_TYPE, DELIVERY_TARGET_TYPE_NAME, DELIVERY_TRACKING_STATUS, DOMAINS, DeliveryBadge, DeliveryOrderInfo, DeliveryStartAt, DeliverySummary, DeliveryTimeLine, DeliveryTrackingLoadFail, DeliveryTrackingTemplate, FEED_ITEM_DESKTOP_ASPECT_RATIO, FEED_ITEM_MOBILE_ASPECT_RATIO, FeedItem, FeedItemPlaceholder, FeedItemThumbnail, FeedPlaceholder, FilterKey, Follow, GLOBAL_API_GATEWAY, GLOBAL_DEEP_LINK_HOST, GLOBAL_DEFAULT_LOCALE, GLOBAL_DEFAULT_METADATA, GLOBAL_DOMAINS, GLOBAL_INFO, GNB, GlobalBanner, GlobalFooter, HTTPError, IconWithTextBadge, ImpressionTracker, Info$1 as Info, InfoPlaceholder, InfoTip, KAKAO_TEMPLATE_ID, LOCALE_ITEMS, LogLink, LogoIcon$1 as LogoIcon, Price, PricePlaceholder, ProductCard, ProductCardScrap, QUERY_BLACKLIST, RangeSliderInput, RouteFilter, SHIPMENT_TYPE, SHORTCUT_TYPE, STORE_ITEM_TYPE, Scrap, ScrapBookSelectModal, SharePopper, SoldOutBanner, Stats, StatsPlaceholder, Thumbnail$1 as Thumbnail, ThumbnailBadge, ThumbnailPlaceholder, Timer, TrendingKeywordsDropdown, TrendingKeywordsEntry, TrendingKeywordsList, TrendingKeywordsRolling, USERABLE_TYPE, UTM_TAGS, addRange, bucketClickLog, bucketImpressionLog, checkAllowedLocale, convertDealToProduct, convertGoodsSummaryToProduct, convertGoodsToProduct, convertLandingUrlByHost, convertStoreItemToProduct, convertThumbnailBadgeToBadge, countries, createColorSchema, createColorTagDeserializer, createColorTagSerializer, createCookieDomain, createDeserialize, createGlobalDefaultUrl, createGroupSchema, createListSchema, createListTagDeserializer, createListTagSerializer, createProductScrapData, createRangeSchema, createRangeTagDeserializer, createRangeTagSerializer, createSearchHistoryStorage, createSerialize, escapeBracesInQuery, fetchDelete, fetchGet, fetchPatch, fetchPost, fetchPut, fetchSugar, findNextOption, findPreviousOption, formatPhoneNumber, formatPriceByCurrency, formatRange, getAmplitude, getBestCardPromotion, getCardPromotionBadges, getCardPromotionTitle, getClientIp, getCookieDomain, getCouponBadge, getCouponBadgeTitle, getCouponsPublishMessage, getDeepLink, getDeliveryTackingNoticeFormat, getDiscountPrice, getExhibitionKakaoTemplate, getFacebookPixelScript, getLocaleFromUrl, getLoginURL, getMaxDiscountCouponMold, getMinBaseAmountCouponMold, getPublishCartCouponStatus, getPublishProductCouponStatus, getRange, getSearchTargetURL, getSearchType, getSearchURL, getServiceType, getShortenPrice, getURL, getUrlWithExchangeLocale, getUtmData, getUtmDataFromUrl, globalCountries, globalLocales, globalMiddleware, initAirbridge, initBraze, initBucketLog, initCriteo, initDatadogRum, initKakaoPixel, initNaverAnalycis, initWiderPlanet, isInclude, isNextJsPageRequest, isRootPathnameWithLocale, isSearchRobot, isUrlWithLocale, joinLinkQuery, locales, logAirbridge, logAmplitude$1 as logAmplitude, logAppBraze, logBraze, logFacebookPixel, sendImpressionLog, serializePathToString, setUtmData, shouldShowDeliveryBadge, signoutAirbridge, useImpressionLog, useIntersectionObserver, useKakaoAPI, useMergeRef, useProductCardLogData, useToggle$1 as useToggle, useUspBadgeExperimentType, useWebviewEventDispatcher, useWebviewEventListener };
//# sourceMappingURL=index.es.js.map
